webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACbSURBVHgBtZbbCcAgEASvBEu0c0tICRtFEUnwce7dQn6UnUlUMCItAIIY5cfKAwk1UcgURn6ewuy2NgBW0uBjwmwiijJbBiM57t5I1B1N4fqrT4pg920FoOErkBl8IbGDbyRRrOIqcF0i102G5zE9AVxLNEW15Oatjjsg1nXbBfiTMWWgXpkUfCIp13C/MlMbiEJmkKTvhMtvywsxgPf/RmBemAAAAABJRU5ErkJggg=="

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1087)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(981),
  /* scopeId */
  "data-v-4ac67fc6",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/JwPlayer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] JwPlayer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4ac67fc6", Component.options)
  } else {
    hotAPI.reload("data-v-4ac67fc6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interest__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plans__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__unauthpage__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__charities__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__authpage__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__experts__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__videoplayer__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__search__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__contactus__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__events__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__gifts__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__configuration__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__dynamiccontents__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_dateHelpers_js__ = __webpack_require__(15);






















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */]);
__webpack_require__(760).polyfill();

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = 'https://api1.dev-tonenetworks.com/v1/';

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.validateStatus = function (status) {
    return status < 500;
};

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
    var userId = 0;
    var token = '';
    var loggedUser = localStorage.getItem('loggedUser');
    var loggedUserTemp = sessionStorage.getItem('loggedUserTemp');
    if (loggedUserTemp) {
        loggedUserTemp = JSON.parse(loggedUserTemp);
        userId = loggedUserTemp.userId;
        token = '' + localStorage.getItem('token');
    }
    if (loggedUser) {
        loggedUser = JSON.parse(loggedUser);
        userId = loggedUser.userId;
        token = '' + localStorage.getItem('token');
    }
    if (token === undefined || token === '') {
        token = null;
    }
    var serverDate = __WEBPACK_IMPORTED_MODULE_18__helpers_dateHelpers_js__["a" /* dateHelpers */].returnFormattedUTCDateTime();

    config.headers.common['Authorization'] = token;
    config.headers.common['RequestDateTime'] = serverDate;
    config.headers.common['UserID'] = userId;
    return config;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */].Store({
    state: {
        scrolled: false
    },
    getters: {
        isScrolled: function isScrolled(state) {
            return state.scrolled;
        }
    },
    mutations: {
        setStickyNavigation: function setStickyNavigation(state, obj) {
            state.scrolled = obj.value;
        }
    },
    modules: {
        usersStore: __WEBPACK_IMPORTED_MODULE_4__users__["a" /* default */],
        interest: __WEBPACK_IMPORTED_MODULE_5__interest__["a" /* default */],
        plans: __WEBPACK_IMPORTED_MODULE_6__plans__["a" /* default */],
        unauthpage: __WEBPACK_IMPORTED_MODULE_7__unauthpage__["a" /* default */],
        charities: __WEBPACK_IMPORTED_MODULE_8__charities__["a" /* default */],
        authpage: __WEBPACK_IMPORTED_MODULE_9__authpage__["a" /* default */],
        experts: __WEBPACK_IMPORTED_MODULE_10__experts__["a" /* default */],
        videoPlayer: __WEBPACK_IMPORTED_MODULE_11__videoplayer__["a" /* default */],
        search: __WEBPACK_IMPORTED_MODULE_12__search__["a" /* default */],
        contactus: __WEBPACK_IMPORTED_MODULE_13__contactus__["a" /* default */],
        events: __WEBPACK_IMPORTED_MODULE_14__events__["a" /* default */],
        gifts: __WEBPACK_IMPORTED_MODULE_15__gifts__["a" /* default */],
        configration: __WEBPACK_IMPORTED_MODULE_16__configuration__["a" /* default */],
        dynamiccontents: __WEBPACK_IMPORTED_MODULE_17__dynamiccontents__["a" /* default */]
    }
}));

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateHelpers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_platform__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_platform__);




var dateHelpers = {
    deprecated: function deprecated() {
        return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a;
    },
    userPlatForm: function userPlatForm() {
        return __WEBPACK_IMPORTED_MODULE_2_platform___default.a;
    },

    dstEnabled: function dstEnabled(date) {
        var timeZone = 'America/New_York';
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).tz(timeZone).isDST();
    },
    getUserTimeZone: function getUserTimeZone() {
        var tz = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.tz.guess();
        return tz;
    },

    returnEasternTime: function returnEasternTime(date, timezone) {
        var timeZone = timezone || 'America/New_York';
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).tz(timeZone).toString();
    },
    returnFormattedEasternDateTime: function returnFormattedEasternDateTime() {
        var timeZone = 'America/New_York';
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).tz(timeZone).format('MM/DD/YYYY HH:mm:SS').toString();
    },
    returnFormattedUTCDateTime: function returnFormattedUTCDateTime() {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(new Date()).format('MM/DD/YYYY HH:mm:SS').toString();
    },

    getDatesDifference: function getDatesDifference(firstDate, secondDate, type) {
        var timeZone = 'America/New_York';
        var first = __WEBPACK_IMPORTED_MODULE_0_moment___default()(firstDate).tz(timeZone);
        first.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        var second = __WEBPACK_IMPORTED_MODULE_0_moment___default()(secondDate).tz(timeZone);
        second.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        switch (type) {
            case 'minutes':
                {
                    return first.diff(second, 'minutes');
                }
            case 'hours':
                {
                    return first.diff(second, 'hours');
                }
            case 'days':
                {
                    return first.diff(second, 'days') + 1;
                }
            case 'weeks':
                {
                    return first.diff(second, 'weeks');
                }
            default:
                return first.diff(second, 'days');
        }
    }
};

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1048)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(955),
  /* scopeId */
  "data-v-1ad9f1ae",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/JwPlayList.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] JwPlayList.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1ad9f1ae", Component.options)
  } else {
    hotAPI.reload("data-v-1ad9f1ae", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.83a4067.svg";

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1032)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(944),
  /* scopeId */
  "data-v-07f96927",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/RulesComp.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RulesComp.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07f96927", Component.options)
  } else {
    hotAPI.reload("data-v-07f96927", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIsAAAA3CAIAAACzcy6mAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzJDNUVERDFGN0Q0MTFFODg5NTJDQjAwNDE3OEU3NjAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MzJDNUVERDJGN0Q0MTFFODg5NTJDQjAwNDE3OEU3NjAiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozMkM1RURDRkY3RDQxMUU4ODk1MkNCMDA0MTc4RTc2MCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDozMkM1RUREMEY3RDQxMUU4ODk1MkNCMDA0MTc4RTc2MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PvgjDFgAABAqSURBVHja7FwJeFTV2b7n3tmTyZ4Q1iQSAmGRAAE1YEFrcWHx/61LBas+1i5Yu1pasYu4gLbWiq11+aXVuvy1KFqpUpawBGRJwpoFQhKSQBbIRkgmk9nuuaffyUwy997M3HsnmWD6PHOeefJkJnfOPed7v+/9tnODCCFMoMHvWsGmLWUzVzCR8aUONuCnQsVG0nyQwc6IgL70oRv4EXE042PP0t9MKREBXZlBbLWkpYhBLDKnMMZElDCdtJ9AiTmBbQjvub/PwLiI7K7MQPoY0lnF8HaC3fjY08Bewpm/BbYhvH8VuXymDyF9RHZXaJgSUXIuik5D1gmkYQcufxWNuiaAH8KlG4T6f/uB5Uz/1bv2FJfj8xf+a5br6mBc7aSrBiVMYxwXUYoPIdQfywmnXscnnpf4qKX5KCYz2IRC2Z/AyNip3wuZc1sKheZDTMcpcHiMwDOGGGTNQHFZQLte5g0DNkVl7q37AR7Dormm+5cFWMPFL4Doib2RIZgxxCLrVShpNoqbHHaxC435pKkA3AwjeJAxgbGmobgpIH1kGS2/1NnKsAaGCOCN6FtDrITl8MnfC+WvyBmv8HFkjGdk4ThCBGK8rlpib+DmPhsCMJdKhKr3hLOb+vCPQgYr0C7TUU4AMO/cUePQ+FvYtGUoceZg/K3dwR895S44gmsbfRPGRksFxguVbwvVfyddZwM4g+RcNvNeNuPr4TCIS/j0m8Kp1/qm1jGEJyJ2YsctZietRKkLRESXHNhFgQ3hgz8S6j4NnTqT9XcUa7rS2YqPrRfqPqH3G/tVbvKD1IRBX/ol21VNzm/F5X9msMtHvum3c7nPgHlp0tOL7bimni+r5k+eIQ6X+E/GO75qXLqwz24O4sM/JT0XVZx26nzdorfEywvZbuo+xYd+AtbATljCTl0FgVnv7XnSXipUvyfUbPbnOpkruHnrVdbj+deNARVKdXCznmCzv6O+XPB7hx5jPDbGGK+74V3fcoMQMT7ypHBuS78G6Ob/EY26Tnl++/qNuPp8sL8aly423kH1VKh8HR/p5XBjPIqdBIRDBA/jaCGdlf1q4RdK7CTdzVsYnXkQYqG+vHQD5Ygb3wewAwlkJ4RjAJgPpLE3cQs3KiK09yHqDBBH6av1KOO+7P9b0iwGqFNedCCU6WLSuVm/8jGmAjwVf6WxI6Wvsbpbt/Zzq9IOS16kHq5fD/JeYtP/V8nlFJaSThuymInN7t5bLLR2iDYnGP/nTuOyHFK1ji/aiJJngUazQCxi0TvbhcZdwqlXia1OIpfEmbqbQ+YVWDmsXwEenwQ7TvPbllIX6AVpwhJuwZ+DIiSu+vC77wMXKooUdqGYiYM39oq/4GPP9E5k1i/fz5iStKrhiechbPGDNG+9xuITcbm7V/+BdPf0vTVZfrKEsx4VStewORvAxwT/JoYkXTjzlqTcMuVhbvavQthv1Xu4mF7PZj3A5T6lFi4V8fl3iwhpDZv9XQ1VH8Etc3eDT5Kb9vrggdtf+3vt8NDrcx5HSXP8gBU9IdYbJUIwGnRXZ4kAi8L71pPaVVzeJiV4el03N+dJNut+eenL3qR1v5crvPBAfMvN/rX6UlPmsRO/4d/j8eeAckOoy/XdVhhstNvNFzzsW0rMRLDikItR178mfst7qVhLnTExTkwQiCXc/GI0ZqEmzch9GoJJCUiVb2u1+33f7qcshtVpWur0RyUzHF8fOkKDHbjwF35POOVbg5nCnMKOv1Vs3LJcLejQ+ytVbFQnmvYoY71a+23Z2b+UqOj5rZr47ewm0l3fFwou0FrpgdRC5ESEun8GJK3wIwT2Lpz/vH8Z7PhbBjcPO/MxGecE4wF5HOO3RA9xhlZapGoBwZE/wWqQRRDBHKd/hnGLQ+GKKMk8p98McEn4s+hTb/jVJC5LvOHQiokxmZB+A97+DVS+w838WQgQCaB/fMiakbrAH/HTuKsMWdMVPe5uke4jqp0Gq/oa3ZdJ82FyqVRqsp8xOT+HSYYTIUjaG3aIpTyUycD+sAghAptXR2ioA8VnMyKEmO4GtbrObklQWLRm8PQDVAnJmbQcGmaESNsxhreL3cmQhJU8VzK5rZbYGyG1Gl6IpBUz4mxTY/Uz/jeGWJSc2/spUdwYQhDGQOQMWTNkRRCRwU/OzI69keGMw8tyMrNlhlYdp+oMqXRfZtc7f9mwI6SXlvI8NsUN8+KKDEqYoVv4l/AuJ8yRAulpCu64Qx/GBHkN2NE87CwndQNUzRX262iTBGADCkgjDiHIhCRvecdQJ5TxJHYMN0JEplXKSaGY0ntLiyMeIdl+nO1h5hx05RvzSHN0DxTSyPA9IxshaYBP7PVDFY/Mc2qovV7RId0vcAY9bjCSEUJmSRuKdFYr87i6TUqNMkBr8ksdyJQkUxpxAjcibSjmKhlNk45TQ5pQ6slQXPbIsiFWj6InSBBqzB/RCLHJ8wYkdENbseOiKPieypgSmRE2ZFm50LAzDN53GG3IlEj7fmKdqvloCJGhjdj8/VM2bRkz8sbALjA+vm7YEJJnwmgwM066TxreXCAX9g8+/yX+wpq4oRKeQExj+K28X9pbkdxGqP04jN6IDWeC6Z0x4+uyEyDeRvgghpgh2awHGGP8ICKNIduIGs3oowa2B3HBQ8ODkD5GKR3THoLmbZBGdFWyBrPG1Mp/dIszcrO0VSSR1Go8/FAlNKBQFuCSnMdlQBJ7E7/r3tBu5O7EB39EH2hQQAhZ02S3GaTajbmRnXi3RKeOPkW6qkOaBJe+3F+hoMUurSW+ofJaSFWfviwthnb6ZQrWfIjfeRfj0aTlEF94Ps2jZ+IG1JpZBacn7iOErHnX/E4WMvD594aQGzlbhbKXfVPlrtXeuCR2SUpPnO7QaUVyUo44WrVx+x0Dj0KS1mJ+62JyYZ+iry3B+79Hm+geO5f30sB+jQQhWv0WlVXIhQIaOwYGnccnX8DFv1Tiupv+gRJmiIXOb1+uqU/q7uR33OmDhx7weDCE9KlUktLzR0POxoiU20nrEXG0oqSU172IxiwaoDGN/J77+d0r6UFX+nRDDy3VYxex1Qq1mwEYfttyoX4b/fqCVwKeO0OyZ/CEqndxseSoCpt+O0pbhmKzkD6agM121wlNe4SKvzKKZ4j8ZHVkreQ8hj6ay1nDTloZ3N534AM/gD2g6DTumt+iUddqF67zvc/duwvlgksbbVq5hMucoA3hHvAfpP2kREZJc7h56zWe6saHVws1Hwbnw1ikM9Oz0KKKOEq9npv3LOw3MOsOfEoSEAKcAlmyzn/gxpigy3sZjb5ek1Ze2IdLXhRvG2wZaAGlzkfR42lpS3CT7gbSfECofId00wSInfwQDQ20PR5DHC739gPu7QeJKyinIYOeTR/DjkrUzZikz50WaJH7cekG0nZUSbjx2bBybvoPlTuT9ODcieflZf6Aw5zCXf0YO/EeJb8Y8DlWoWazcPr1gEVAUCg26z7lc6DBnCGp+ZA+9aDQE9NHA6dB8BpSmw7XNtqfeQMZDeyEVPjJ6HSIYxkW+UI7Qk86Cm0dQttlxu3RZV9lWR2ANunx2JO/ReZUxjKKHoTnDPThHFBKkI/gIc420lXjPZCru20bipuisibXJXzmbXJuS7CDKPQUf9pyGk+pRUCIBM8YgILBj9Gj6NhJH1WwZqCUufBzSKGSx0YulRNbDQ0UnS0M72Q4PWNKpmepk2YPcnLYAsYAjAY1ERh2CGUU6pBY9QxJ/I2246SjnD4GA+4NcbTSCmJMmEHJQ2NsSUgYstTIGL7BRkQQQSgyIghFEIqMCEKREbw0I0qnedf2g4avzEHWqP5MkC+r0s+czBiUMkfhYpvnUAktiBEa+LLJ8YZblcpork/3kC47zIksRtLZzQiEm5Khnxf06Un33mLdlKvYVF931Z1/mEsf018j8BwuQbHRkOWo5ExV590FxaTHiTgOUlfjkq9oSg2Ky3BNA+PmGb3OsDCXHa3yFBQ+Ww+3gKTYt9MteyFH1l8zQ6XItf0Af+YciE6XlWb42rWytMFvQ8TlcW3Oh9TP/4nN7vpoJ3GqnNJz5xe6dxeimGgUEwUvxqLy+CeKMsNlQnO765PdoA30WyaD4gYOuj7xNYpgMc7/3+r6eFefSLBj48eMQ22F//6i59UP2IQ4/XUzuemZuKLW/vTrNIVSG64PtsE66aY8vP25jfwJlb4cqAvcy/t7z0vvuvcUswkqh5Oc73/u3l2knztNlzOZrzov2HqC2hDp7gG0+fKzznc/M31zaW9Ji2OT4lVTPOLxwM6NyxdpNFvDTbTUJjS2OAkx3n6D6vXG2653bTvgE0HBUVgSslrAvpHZ6DleQQs5s7MVKw4Nzg93RD//YzbF9xQGWEP36hd7XttkeVSlhYOS4kx3LWZHJ3uzXecH26JzlKoJyGLyGnf3b+hzqdaXVqvuzr2rMHrdD73WCQtT9EM8hlfUU4+49xT5KsSQgWvotiCTkXR1E5fb+6LzaCkCXepk3JqaETogQCJ4HyGGhVHtMZs8RWX07bHT3DiVw/uuLQX6udP74fEOy88exKdriV31BCvy3hds11NSqZuq8lQvUALsy/mPbdzo5Oinv69ld9yE0Y43P1JYiQghlq6GjY8xP3IPWCj9IM4KTkI92EiK48/UOV7b5HjlA8ef/g6WHl5XSQtuifG4ss5LvMDyrDUK19CzkkJTq272VBUT7+wGvyVf86hEFBet/j9lWOT6bJ/9yVd7Xvib/uosH7UoLDU+hj9S7t5xyLzqbo27s/z0m+Dk7Ove7Hn5fVzfrBbLcSwYgT53mm7WlJ4X3oZv0pdaWUjo6OIyxplW3AYbgBfwadjjGS5zPNyFOm0LrTPqpmeCpZJOG5g4MLiaDXLC5QG1WreHON2qTgL2brxlvj4vR2hqMT2wXN5iHyiKC22GW+aDEGyPrNPYgAf/HbXmYfN37gRFt6/7v/7/phIs2kYMpmc8LT9Ygc81Od76JztulPpNYKtxVqAR+gLdjLaEHSFQGgj/XJ/v001Op4BNTodww/HGR+z4VFU3qc+b6SmUm7Vzcz7iWFitGkIMirMabs5DyfEQoagvFGOI5QyL5nLZGV3fX6f9HAtYuWnlEv2MSa7PCoIiRHiBamXfiHri2579xzwFR0AWKrvgedzUAvxLX+2dpKNLy8qI2yN0dWvcADs2hS+v5o9XGG7wn5jkK2rBwagHJovmsqlJQCNCu++febh3HoKX+bt3qS+y0+b9luWRb0CUj6vOqVzvdAstl7wqrpuc0bXqWTB9ZRt1vvMvT28jGK7kq+v1s+RRD7d27dp+wxda2iEuQjrO6/SA9ISmNsPiPLVwhIdsA1ee40uq+JJKXH1eP2uKKiEw9h5i66FXahuQddE+3OLr/ABfaDXd9TUt3QTDgtkYAC4qo//753AJrNay6h4tXVdc1wRWyybGATFA9Ah71M9RcntCWwcyGnXZGV7bhWAE11+kCWVwafCna8AMQGieL06AizXeJk8lI92HSNUnMoY2/iPAAAZBPigs3z/iAAAAAElFTkSuQmCC"

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SignUp__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SignUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SignUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Plans__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Plans___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Plans__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Topic__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Topic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Topic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Validate__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Join__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_InterestList__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_InterestList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_InterestList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ResetPassword__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_ResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_UnAuth__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_UnAuth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_UnAuth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Experts__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Experts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Experts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ManagePage__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ManagePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_ManagePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_EmailRules__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_EmailRules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_EmailRules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Expert__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Expert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Expert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_VideoPlayer__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_VideoPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_VideoPlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Charities__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Charities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Charities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Search__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Giving__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Giving___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Giving__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Profile__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Community__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Community___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Community__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_LiveEvent__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_LiveEvent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_LiveEvent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_NewCareer__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_NewCareer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_NewCareer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Inspiration__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Inspiration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Inspiration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Mindbody__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Mindbody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Mindbody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_ContactUs__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_ContactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_ContactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_AboutUs__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_AboutUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_AboutUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Feedback__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Feedback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_Feedback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Terms__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Terms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Terms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_PrivacyPolicy__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_PrivacyPolicy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_PrivacyPolicy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Work__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Work__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Money__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_Money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Life__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Life___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Life__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_RecentlyWatched__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_RecentlyWatched___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_RecentlyWatched__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_RelatedVideo__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_RelatedVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_RelatedVideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Rules__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_Rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Talk__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Talk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_Talk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Rating__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_Rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_LiveStreamTest__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_LiveStreamTest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_LiveStreamTest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Gift__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Gift___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_Gift__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Redeem__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Redeem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_Redeem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Gifts__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Gifts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_Gifts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_PodcastTone__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_PodcastTone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_PodcastTone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_FAQ__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_FAQ___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_FAQ__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Event__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Event___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_Event__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_CorporateGift__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_CorporateGift___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_CorporateGift__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_TrialExpiry__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_TrialExpiry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_TrialExpiry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_TrialExpiry_Novo__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_TrialExpiry_Novo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_TrialExpiry_Novo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_AccentureCharlot__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_AccentureCharlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_AccentureCharlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_CorporationGifting__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_CorporationGifting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_CorporationGifting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_CorporationGiftingComcast__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_CorporationGiftingComcast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_CorporationGiftingComcast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_UnauthVideoPlayer__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_UnauthVideoPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_UnauthVideoPlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_NewEvents__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_NewEvents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_NewEvents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_CorporationReferral__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_CorporationReferral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_CorporationReferral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_PlaylistVideoPlayer__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_PlaylistVideoPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_PlaylistVideoPlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_CorpPlaylistVideoPlayer__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_CorpPlaylistVideoPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_CorpPlaylistVideoPlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_TrendingPlaylist__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_TrendingPlaylist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_TrendingPlaylist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_PressRelease__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_PressRelease___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_PressRelease__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_CorporateSale__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_CorporateSale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_CorporateSale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_WorkContents__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_WorkContents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_WorkContents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_LifeContents__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_LifeContents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_LifeContents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_MindbodyContents__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_MindbodyContents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_MindbodyContents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_MoneyContents__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_MoneyContents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_MoneyContents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_B2B__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_B2B___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_B2B__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_ArchivePlaylistPlayer__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_ArchivePlaylistPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_ArchivePlaylistPlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_SharePlaylistPlayer__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_SharePlaylistPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_SharePlaylistPlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_DrRamani__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_DrRamani___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_DrRamani__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_JoinNowMobile__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_JoinNowMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_JoinNowMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_Logout__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_TakeawayMobile__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_TakeawayMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_TakeawayMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_TeaserMobile__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_TeaserMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_TeaserMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_CorporateLiveEvent__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_CorporateLiveEvent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_CorporateLiveEvent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_SetTone__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_SetTone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_SetTone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_Resources__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_Resources___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_Resources__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_Maintainance__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_Maintainance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_Maintainance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_CorporateCommunity__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_CorporateCommunity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__components_CorporateCommunity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_DemoEvent__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_DemoEvent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__components_DemoEvent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_CommunityDemo__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_CommunityDemo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_CommunityDemo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_LiveEventDemo__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_LiveEventDemo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__components_LiveEventDemo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_BecomeExpert__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_BecomeExpert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__components_BecomeExpert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_GiftRedirect__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_GiftRedirect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__components_GiftRedirect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__helpers_dateHelpers_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_vue_meta__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_vue_meta__);























































































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_83_vue_meta___default.a, {
    keyName: 'metaInfo',
    attribute: 'data-vue-meta',
    ssrAttribute: 'data-vue-meta-server-rendered',
    tagIDKeyName: 'vmid' });
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/mytone',
        name: 'Hello',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a,
        meta: { title: 'Tone - Home' }
    }, {
        path: '/g/:giftCode',
        name: 'GiftRedirect',
        component: __WEBPACK_IMPORTED_MODULE_81__components_GiftRedirect___default.a,
        meta: { title: 'Tone - Welcome!' }
    }, {
        path: '/',
        name: 'UnAuth',
        component: __WEBPACK_IMPORTED_MODULE_64__components_B2B___default.a,
        meta: { title: 'Tone - Welcome!' }
    }, {
        path: '/preferences?params=:params',
        name: 'EmailRules',
        component: __WEBPACK_IMPORTED_MODULE_13__components_EmailRules___default.a,
        meta: { title: 'Tone | Email Preferences' }
    }, {
        path: '/preferences',
        name: 'EmailRules',
        component: __WEBPACK_IMPORTED_MODULE_13__components_EmailRules___default.a,
        meta: { title: 'Tone | Email Preferences' }
    }, {
        path: '/plan/:planId',
        name: 'UnAuth',
        component: __WEBPACK_IMPORTED_MODULE_10__components_UnAuth___default.a,
        meta: { title: 'Tone - Welcome!' }
    }, {
        path: '/corporation/:corporateId/:giftCode',
        name: 'UnAuth',
        component: __WEBPACK_IMPORTED_MODULE_10__components_UnAuth___default.a,
        meta: { title: 'Tone - Welcome!' }
    }, {
        path: '/corporation/referral/:corporateId/:giftCode',
        name: 'ReferralUnAuth',
        component: __WEBPACK_IMPORTED_MODULE_10__components_UnAuth___default.a,
        meta: { title: 'Tone - Welcome!' }
    }, {
        path: '/signup',
        name: 'SignUp',
        component: __WEBPACK_IMPORTED_MODULE_3__components_SignUp___default.a,
        meta: {
            title: 'Tone - Signup',
            hideNav: false
        }
    }, {
        path: '/signup/:planId',
        name: 'SignUp',
        component: __WEBPACK_IMPORTED_MODULE_3__components_SignUp___default.a,
        meta: {
            title: 'Tone - Signup to your favorite plan',
            hideNav: false
        }
    }, {
        path: '/plans',
        name: 'Plans',
        component: __WEBPACK_IMPORTED_MODULE_4__components_Plans___default.a,
        meta: { title: 'Tone - Plans' }
    }, {
        path: '/topic',
        name: 'Topic',
        component: __WEBPACK_IMPORTED_MODULE_5__components_Topic___default.a
    }, {
        path: '/validate',
        name: 'Validate',
        component: __WEBPACK_IMPORTED_MODULE_6__components_Validate___default.a,
        meta: {
            title: 'Tone - Validate Account',
            hideNav: false
        }
    }, {
        path: '/validate?params=:params',
        name: 'Validate',
        component: __WEBPACK_IMPORTED_MODULE_6__components_Validate___default.a,
        meta: {
            title: 'Tone - Validate Account via Link',
            hideNav: false
        }
    }, {
        path: '/join',
        name: 'Join',
        component: __WEBPACK_IMPORTED_MODULE_7__components_Join___default.a
    }, {
        path: '/interests',
        name: 'InterestList',
        component: __WEBPACK_IMPORTED_MODULE_8__components_InterestList___default.a,
        meta: { title: 'Tone - Interests', hideNav: true }
    }, {
        path: '/resetpassword',
        name: 'ResetPassword',
        component: __WEBPACK_IMPORTED_MODULE_9__components_ResetPassword___default.a,
        meta: {
            title: 'Tone - Reset Password',
            hideNav: false
        }
    }, {
        path: '/resetpassword?params=:params',
        name: 'ResetPassword',
        component: __WEBPACK_IMPORTED_MODULE_9__components_ResetPassword___default.a,
        meta: {
            title: 'Tone - Reset Password',
            hideNav: false
        }
    }, {
        path: '/career',
        name: 'Career',
        component: __WEBPACK_IMPORTED_MODULE_22__components_NewCareer___default.a,
        meta: { title: 'Tone - Career' }
    }, {
        path: '/expert/:expertId',
        name: 'Expert',
        component: __WEBPACK_IMPORTED_MODULE_14__components_Expert___default.a,
        meta: { title: 'Tone - Expert' }
    }, {
        path: '/expert/:expertId/:expertName',
        name: 'Expert',
        component: __WEBPACK_IMPORTED_MODULE_14__components_Expert___default.a,
        meta: { title: 'Tone - Expert' }
    }, {
        path: '/watch/:videoCode',
        name: 'Player',
        component: __WEBPACK_IMPORTED_MODULE_15__components_VideoPlayer___default.a,
        meta: { title: 'Tone - Video Player' }
    }, {
        path: '/watch/:videoCode/:videoTitle',
        name: 'Player',
        component: __WEBPACK_IMPORTED_MODULE_15__components_VideoPlayer___default.a,
        meta: { title: 'Tone - Video Player' }
    }, {
        path: '/watch/:videoCode/:refBy',
        name: 'Player',
        component: __WEBPACK_IMPORTED_MODULE_15__components_VideoPlayer___default.a,
        meta: { title: 'Tone - Video Player' }
    }, {
        path: '/watch/:videoCode/:refBy/:videoTitle',
        name: 'Player',
        component: __WEBPACK_IMPORTED_MODULE_15__components_VideoPlayer___default.a,
        meta: { title: 'Tone - Video Player' }
    }, {
        path: '/search',
        name: 'Search',
        component: __WEBPACK_IMPORTED_MODULE_17__components_Search___default.a,
        meta: { title: 'Tone - Search' }
    }, {
        path: '/search/:qryString',
        name: 'Search',
        component: __WEBPACK_IMPORTED_MODULE_17__components_Search___default.a,
        meta: { title: 'Tone - Search Results' }
    }, {
        path: '/giving',
        name: 'Giving',
        component: __WEBPACK_IMPORTED_MODULE_18__components_Giving___default.a,
        meta: { title: 'Tone - Giving' }
    }, {
        path: '/profile',
        name: 'Profile',
        component: __WEBPACK_IMPORTED_MODULE_19__components_Profile___default.a,
        meta: { title: 'Tone - Profile' }
    }, {
        path: '/profile/:feature',
        name: 'Profile',
        component: __WEBPACK_IMPORTED_MODULE_19__components_Profile___default.a,
        meta: { title: 'Tone - Profile' }
    }, {
        path: '/events',
        name: 'Events',
        component: __WEBPACK_IMPORTED_MODULE_20__components_Community___default.a,
        meta: { title: 'Tone - Events' }
    }, {
        path: '/events/section/:section',
        name: 'Events',
        component: __WEBPACK_IMPORTED_MODULE_20__components_Community___default.a,
        meta: { title: 'Tone - Events' }
    }, {
        path: '/liveevent/:eventId',
        name: 'LiveEvent',
        component: __WEBPACK_IMPORTED_MODULE_21__components_LiveEvent___default.a,
        meta: { title: 'Tone - Live Events' }
    }, {
        path: '/charity/:charityId',
        name: 'Charities',
        component: __WEBPACK_IMPORTED_MODULE_16__components_Charities___default.a,
        meta: { title: 'Tone - View Charity' }
    }, {
        path: '/inspiration',
        name: 'Inspiration',
        component: __WEBPACK_IMPORTED_MODULE_23__components_Inspiration___default.a,
        meta: { title: 'Tone - Inspiration Videos' }
    }, {
        path: '/mindbody',
        name: 'Mindbody',
        component: __WEBPACK_IMPORTED_MODULE_24__components_Mindbody___default.a,
        meta: { title: 'Tone - Mindbody Videos' }
    }, {
        path: '/work',
        name: 'Work',
        component: __WEBPACK_IMPORTED_MODULE_30__components_Work___default.a,
        meta: { title: 'Tone - Work Videos' }
    }, {
        path: '/life',
        name: 'Life',
        component: __WEBPACK_IMPORTED_MODULE_32__components_Life___default.a,
        meta: { title: 'Tone - Life Videos' }
    }, {
        path: '/money',
        name: 'Money',
        component: __WEBPACK_IMPORTED_MODULE_31__components_Money___default.a,
        meta: { title: 'Tone - Money Videos' }
    }, {
        path: '/contactus',
        name: 'ContactUs',
        component: __WEBPACK_IMPORTED_MODULE_25__components_ContactUs___default.a,
        meta: { title: 'Tone - Contact Us' }
    }, {
        path: '/business',
        name: 'B2b',
        component: __WEBPACK_IMPORTED_MODULE_64__components_B2B___default.a,
        meta: { title: 'Tone - TONE for Businesses' }
    }, {
        path: '/b2b',
        name: 'B2b',
        component: __WEBPACK_IMPORTED_MODULE_64__components_B2B___default.a,
        meta: { title: 'Tone - TONE for Businesses' }
    }, {
        path: '/aboutus',
        name: 'AboutUs',
        component: __WEBPACK_IMPORTED_MODULE_26__components_AboutUs___default.a,
        meta: { title: 'Tone - About Us' }
    }, {
        path: '/pressrelease',
        name: 'PressRelease',
        component: __WEBPACK_IMPORTED_MODULE_58__components_PressRelease___default.a,
        meta: { title: 'Tone - Press Releases' }
    }, {
        path: '/feedback',
        name: 'Feedback',
        component: __WEBPACK_IMPORTED_MODULE_27__components_Feedback___default.a,
        meta: { title: 'Tone - Feedback' }
    }, {
        path: '/terms',
        name: 'Terms',
        component: __WEBPACK_IMPORTED_MODULE_28__components_Terms___default.a,
        meta: { title: 'Tone - Terms' }
    }, {
        path: '/faq',
        name: 'FAQ',
        component: __WEBPACK_IMPORTED_MODULE_44__components_FAQ___default.a,
        meta: { title: 'Tone - FAQ' }
    }, {
        path: '/privacypolicy',
        name: 'PrivacyPolicy',
        component: __WEBPACK_IMPORTED_MODULE_29__components_PrivacyPolicy___default.a,
        meta: { title: 'Tone - Privacy Policy' }
    }, {
        path: '/recenltywatchedvideos',
        name: 'RecentlyWatched',
        component: __WEBPACK_IMPORTED_MODULE_33__components_RecentlyWatched___default.a,
        meta: { title: 'Tone - Recently Watched Videos' }
    }, {
        path: '/relatedvideos',
        name: 'RelatedVideos',
        component: __WEBPACK_IMPORTED_MODULE_34__components_RelatedVideo___default.a,
        meta: { title: 'Tone - Related Videos' }
    }, {
        path: '/rules/:eventId',
        name: 'Rules',
        component: __WEBPACK_IMPORTED_MODULE_35__components_Rules___default.a,
        meta: { title: 'Tone - Rules' }
    }, {
        path: '/talk/:eventId',
        name: 'Talk',
        component: __WEBPACK_IMPORTED_MODULE_36__components_Talk___default.a,
        meta: { title: 'Tone - Talk' }
    }, {
        path: '/rating',
        name: 'Rating',
        component: __WEBPACK_IMPORTED_MODULE_37__components_Rating___default.a,
        meta: { title: 'Tone - Rating' }
    }, {
        path: '/experts',
        name: 'Experts',
        component: __WEBPACK_IMPORTED_MODULE_11__components_Experts___default.a,
        meta: {
            title: 'Tone - Experts',
            hideNav: false
        }
    }, {
        path: '/lstest',
        name: 'LiveStreamTest',
        component: __WEBPACK_IMPORTED_MODULE_39__components_LiveStreamTest___default.a,
        meta: {
            title: 'Tone - LS Test',
            hideNav: false
        }
    }, {
        path: '/sendgift',
        name: 'Gift',
        component: __WEBPACK_IMPORTED_MODULE_40__components_Gift___default.a,
        meta: {
            title: 'Tone - Send Gifts',
            hideNav: false
        }
    }, {
        path: '/gifts',
        name: 'Gifts',
        component: __WEBPACK_IMPORTED_MODULE_42__components_Gifts___default.a,
        meta: {
            title: 'Tone - Gifts',
            hideNav: false
        }
    }, {
        path: '/redeem',
        name: 'Redeem,',
        component: __WEBPACK_IMPORTED_MODULE_41__components_Redeem___default.a,
        meta: {
            title: 'Tone - Redeem Your Gift',
            hideNav: false
        }
    }, {
        path: '/event',
        name: 'Event',
        component: __WEBPACK_IMPORTED_MODULE_45__components_Event___default.a,
        meta: {
            title: 'Tone - Event Details',
            hideNav: false
        }
    }, {
        path: '/corporation/sale',
        name: 'CorporateSale',
        component: __WEBPACK_IMPORTED_MODULE_59__components_CorporateSale___default.a,
        meta: {
            title: 'Tone - Corporate Sale',
            hideNav: false
        }
    }, {
        path: '/event/:eventId',
        name: 'Event',
        component: __WEBPACK_IMPORTED_MODULE_45__components_Event___default.a,
        meta: {
            title: 'Tone - Event Details',
            hideNav: false
        }
    }, {
        path: '/corporategifts',
        name: 'CorporateGift',
        component: __WEBPACK_IMPORTED_MODULE_46__components_CorporateGift___default.a,
        meta: {
            title: 'Tone - Corporate Gifting',
            hideNav: false
        }
    }, {
        path: '/becomemember',
        name: 'TrialExpiry',
        component: __WEBPACK_IMPORTED_MODULE_47__components_TrialExpiry___default.a,
        meta: {
            title: 'Tone - Become a Member',
            hideNav: false
        }
    }, {
        path: '/become-member-novo',
        name: 'TrialExpiryNovo',
        component: __WEBPACK_IMPORTED_MODULE_48__components_TrialExpiry_Novo___default.a,
        meta: {
            title: 'Tone - Become a Member',
            hideNav: false
        }
    }, {
        path: '/accenturecharlotte',
        name: 'AccentureCharlotte',
        component: __WEBPACK_IMPORTED_MODULE_49__components_AccentureCharlot___default.a,
        meta: {
            title: 'Tone - Accenture & Partners',
            hideNav: true
        }
    }, {
        path: '/corporationgifting/:corporateId/:giftCode',
        name: 'CorporationGifting',
        component: __WEBPACK_IMPORTED_MODULE_50__components_CorporationGifting___default.a,
        meta: {
            title: 'Tone - Redeem Corporation Gifts',
            hideNav: false
        }
    }, {
        path: '/corporationgifting/:corporateId/:giftCode/:regions',
        name: 'CorporationGiftingComcox',
        component: __WEBPACK_IMPORTED_MODULE_50__components_CorporationGifting___default.a,
        meta: {
            title: 'Tone - Redeem Corporation Gifts',
            hideNav: false
        }
    }, {
        path: '/corporationgiftingcustom/:corporateId/:giftCode',
        name: 'CorporationGiftingComcast',
        component: __WEBPACK_IMPORTED_MODULE_51__components_CorporationGiftingComcast___default.a,
        meta: {
            title: 'Tone - Redeem Corporation Gifts',
            hideNav: false
        }
    }, {
        path: '/corporation/referral/buy/:corporateId/:giftCode',
        name: 'CorporationReferral',
        component: __WEBPACK_IMPORTED_MODULE_54__components_CorporationReferral___default.a,
        meta: {
            title: 'Tone - TONE Corporation Referral',
            hideNav: false
        }
    }, {
        path: '/contentvideos/play/:videoCode',
        name: 'UnauthPlayer',
        component: __WEBPACK_IMPORTED_MODULE_52__components_UnauthVideoPlayer___default.a,
        meta: {
            title: 'Tone - Watch Video',
            hideNav: false
        }
    }, {
        path: '/contentvideos/play/:videoCode/:videoTitle',
        name: 'UnauthPlayer',
        component: __WEBPACK_IMPORTED_MODULE_52__components_UnauthVideoPlayer___default.a,
        meta: {
            title: 'Tone - Watch Video',
            hideNav: false
        }
    }, {
        path: '/contentvideos/play/:videoCode/:refBy',
        name: 'UnauthPlayer',
        component: __WEBPACK_IMPORTED_MODULE_52__components_UnauthVideoPlayer___default.a,
        meta: {
            title: 'Tone - Watch Video',
            hideNav: false
        }
    }, {
        path: '/contentvideos/play/:videoCode/:refBy/:videoTitle',
        name: 'UnauthPlayer',
        component: __WEBPACK_IMPORTED_MODULE_52__components_UnauthVideoPlayer___default.a,
        meta: {
            title: 'Tone - Watch Video',
            hideNav: false
        }
    }, {
        path: '/newevents/:eventId',
        name: 'NewEvents',
        component: __WEBPACK_IMPORTED_MODULE_53__components_NewEvents___default.a,
        meta: {
            title: 'Tone - New Events',
            hideNav: false
        }
    }, {
        path: '/newevents',
        name: 'NewEvents',
        component: __WEBPACK_IMPORTED_MODULE_53__components_NewEvents___default.a,
        meta: {
            title: 'Tone - New Events',
            hideNav: false
        }
    }, {
        path: '/playlist/:playlistId/play/:videoCode',
        name: 'PlaylistVideoPlayer',
        component: __WEBPACK_IMPORTED_MODULE_55__components_PlaylistVideoPlayer___default.a,
        meta: {
            title: 'Tone - Playlist',
            hideNav: false
        }
    }, {
        path: '/playlist/trending/:playlistId/play/:videoCode',
        name: 'TrendingPlaylistVideoPlayer',
        component: __WEBPACK_IMPORTED_MODULE_57__components_TrendingPlaylist___default.a,
        meta: {
            title: 'Tone - Trending Playlist',
            hideNav: false
        }
    }, {
        path: '/playlist/trending/:playlistId/play/:videoCode/:videoTitle',
        name: 'TrendingPlaylistVideoPlayer',
        component: __WEBPACK_IMPORTED_MODULE_57__components_TrendingPlaylist___default.a,
        meta: {
            title: 'Tone - Trending Playlist',
            hideNav: false
        }
    }, {
        path: '/playlist/:playlistId/play/:videoCode/:corporationId',
        name: 'CorpPlaylistVideoPlayer',
        component: __WEBPACK_IMPORTED_MODULE_56__components_CorpPlaylistVideoPlayer___default.a,
        meta: {
            title: 'Tone - Playlist',
            hideNav: false
        }
    }, {
        path: '/playlist/:playlistId/play/:videoCode/:corporationId/:videoTitle',
        name: 'CorpPlaylistVideoPlayer',
        component: __WEBPACK_IMPORTED_MODULE_56__components_CorpPlaylistVideoPlayer___default.a,
        meta: {
            title: 'Tone - Playlist',
            hideNav: false
        }
    }, {
        path: '/tonearchive/:eventId/play/:sequence',
        name: 'ArchivePlayer',
        component: __WEBPACK_IMPORTED_MODULE_65__components_ArchivePlaylistPlayer___default.a,
        meta: {
            title: 'Tone - Event Archive',
            hideNav: false
        }
    }, {
        path: '/tonearchive/:eventId/play/:sequence/:eventTitle',
        name: 'ArchivePlayer',
        component: __WEBPACK_IMPORTED_MODULE_65__components_ArchivePlaylistPlayer___default.a,
        meta: {
            title: 'Tone - Event Archive',
            hideNav: false
        }
    }, {
        path: '/playlistshare/:playlistId/play/:videoCode',
        name: 'SharePlayer',
        component: __WEBPACK_IMPORTED_MODULE_66__components_SharePlaylistPlayer___default.a,
        meta: {
            title: 'Tone - Playlist Share',
            hideNav: false
        }
    }, {
        path: '/playlistshare/:playlistId/play/:videoCode/:playlistTitle',
        name: 'SharePlayer',
        component: __WEBPACK_IMPORTED_MODULE_66__components_SharePlaylistPlayer___default.a,
        meta: {
            title: 'Tone - Playlist Share',
            hideNav: false
        }
    }, {
        path: '/content/work',
        name: 'WorkContents',
        component: __WEBPACK_IMPORTED_MODULE_60__components_WorkContents___default.a,
        meta: {
            title: 'Tone - Work Contents',
            hideNav: false
        }
    }, {
        path: '/content/life',
        name: 'LifeContents',
        component: __WEBPACK_IMPORTED_MODULE_61__components_LifeContents___default.a,
        meta: {
            title: 'Tone - Life Contents',
            hideNav: false
        }
    }, {
        path: '/content/mindbody',
        name: 'MindbodyContents',
        component: __WEBPACK_IMPORTED_MODULE_62__components_MindbodyContents___default.a,
        meta: {
            title: 'Tone - Mind-Body Contents',
            hideNav: false
        }
    }, {
        path: '/content/money',
        name: 'MoneyContents',
        component: __WEBPACK_IMPORTED_MODULE_63__components_MoneyContents___default.a,
        meta: {
            title: 'Tone - Money Contents',
            hideNav: false
        }
    }, {
        path: '/joinnative',
        name: 'JoinNowMobile',
        component: __WEBPACK_IMPORTED_MODULE_68__components_JoinNowMobile___default.a,
        meta: {
            title: 'Tone - Login',
            hideNav: false
        }
    }, {
        path: '/takeaway',
        name: 'Takeaway',
        component: __WEBPACK_IMPORTED_MODULE_70__components_TakeawayMobile___default.a,
        meta: {
            title: 'Tone | Takeaway',
            hideNav: false
        }
    }, {
        path: '/teaser',
        name: 'Teaser',
        component: __WEBPACK_IMPORTED_MODULE_71__components_TeaserMobile___default.a,
        meta: {
            title: 'Tone | Teaser',
            hideNav: false
        }
    }, {
        path: '/resources',
        name: 'ToneResources',
        component: __WEBPACK_IMPORTED_MODULE_74__components_Resources___default.a,
        meta: {
            title: 'Tone | Resources',
            hideNav: false
        }
    }, {
        path: '/resources/feature/:feature',
        name: 'ToneResources',
        component: __WEBPACK_IMPORTED_MODULE_74__components_Resources___default.a,
        meta: {
            title: 'Tone | Resources',
            hideNav: false
        }
    }, {
        path: '/setthetone/article/:articleId/',
        name: 'SetTONE',
        component: __WEBPACK_IMPORTED_MODULE_73__components_SetTone___default.a,
        meta: {
            title: 'TONE Articles',
            hideNav: false
        }
    }, {
        path: '/setthetone/article/:articleId/:articleTitle',
        name: 'SetTONE',
        component: __WEBPACK_IMPORTED_MODULE_73__components_SetTone___default.a,
        meta: {
            title: 'TONE Articles',
            hideNav: false
        }
    }, {
        path: '/corporations/event/live',
        name: 'AMCEvent',
        component: __WEBPACK_IMPORTED_MODULE_72__components_CorporateLiveEvent___default.a,
        meta: {
            title: 'Tone | Welcome to Event',
            hideNav: false
        }
    }, {
        path: '/logout',
        name: 'Logout',
        component: __WEBPACK_IMPORTED_MODULE_69__components_Logout___default.a,
        meta: {
            title: 'Tone - Logout',
            hideNav: false
        }
    }, {
        path: '/corporation/mycommunity',
        name: 'CorporateCommunity',
        component: __WEBPACK_IMPORTED_MODULE_76__components_CorporateCommunity___default.a,
        meta: {
            title: 'TONE - Community',
            hideNav: false
        }
    }, {
        path: '/corporation/manage-page',
        name: 'ManagePage',
        component: __WEBPACK_IMPORTED_MODULE_12__components_ManagePage___default.a,
        meta: {
            title: 'TONE - Manage Community Page',
            hideNav: false
        }
    }, {
        path: '/corporation/mycommunity/feature/:tab',
        name: 'CorporateCommunity',
        component: __WEBPACK_IMPORTED_MODULE_76__components_CorporateCommunity___default.a,
        meta: {
            title: 'TONE - Community',
            hideNav: false
        }
    }, {
        path: '/corporation/mycommunity/feature/:tab/section/:section',
        name: 'CorporateCommunity',
        component: __WEBPACK_IMPORTED_MODULE_76__components_CorporateCommunity___default.a,
        meta: {
            title: 'TONE - Community',
            hideNav: false
        }
    }, {
        path: '/sitemaintenance',
        name: 'Maintainance',
        component: __WEBPACK_IMPORTED_MODULE_75__components_Maintainance___default.a,
        meta: {
            title: 'Tone - Site Maintenance',
            hideNav: true
        }
    }, {
        path: '/become-expert',
        name: 'BecomeExpert',
        component: __WEBPACK_IMPORTED_MODULE_80__components_BecomeExpert___default.a,
        meta: {
            title: 'Tone | Become Expert Request',
            hideNav: false
        }
    }, {
        path: '/tone/demo/event',
        name: 'DemoEvent',
        component: __WEBPACK_IMPORTED_MODULE_77__components_DemoEvent___default.a,
        meta: {
            title: 'Tone | Event Demo',
            hideNav: false
        }
    }, {
        path: '/tone/demo/corporate-demo',
        name: 'DemoEventCorp',
        component: __WEBPACK_IMPORTED_MODULE_78__components_CommunityDemo___default.a,
        meta: {
            title: 'Tone | Corporation Demo',
            hideNav: false
        }
    }, {
        path: '/tone/demo/live-event-demo/:eventId',
        name: 'LiveEventDemo',
        component: __WEBPACK_IMPORTED_MODULE_79__components_LiveEventDemo___default.a,
        meta: {
            title: 'Tone | Welcome to TONE Event!',
            hideNav: false
        }
    }, {
        path: '/showpodcast',
        name: 'PodPage',
        component: __WEBPACK_IMPORTED_MODULE_43__components_PodcastTone___default.a,
        meta: {
            title: 'PodPage - Anchor',
            hideNav: false
        }
    }, {
        path: '/drramani',
        name: 'drRamani',
        component: __WEBPACK_IMPORTED_MODULE_67__components_DrRamani___default.a,
        meta: {
            title: 'Tone - Dr. Ramani Event',
            hideNav: false,
            metaTags: [{
                name: 'description',
                content: 'Give the gift of knowledge and inspiration to the women you care about'
            }, {
                property: 'og:description',
                content: 'Give the gift of knowledge and inspiration to the women you care about'
            }, {
                property: 'og:image',
                content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/experts/Ramani.jpg'
            }, {
                property: 'og:site_name',
                content: 'The about page of our example app.'
            }, {
                property: 'og:title',
                content: 'Dr. Ramani Event on Narcissism'
            }, {
                property: 'twitter:title',
                content: 'Give the gift of knowledge and inspiration to the women you care about'
            }, {
                property: 'twitter:card',
                content: 'Dr. Ramani Event on Narcissism'
            }, {
                property: 'twitter:image',
                content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/experts/Ramani.jpg'
            }]
        }
    }, {
        path: '*',
        redirect: '/'
    }]
});
router.beforeEach(function (to, from, next) {
    if (window.location.hash.length > 0) {
        window.location = window.location.hash.substring(1);
    }
    var loggedUser = localStorage.getItem('loggedUser');
    var loggedUserTemp = sessionStorage.getItem('loggedUserTemp');
    if (loggedUserTemp) {
        loggedUserTemp = JSON.parse(loggedUserTemp);
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setUser', { user: loggedUserTemp });
    }
    if (loggedUser) {
        loggedUser = JSON.parse(loggedUser);
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setUser', { user: loggedUser });
    }
    var token = localStorage.getItem('token');

    if (token === undefined || !token || token.length < 15 || loggedUser && !loggedUser.hasOwnProperty('ccExpiryDate') || loggedUserTemp && !loggedUserTemp.hasOwnProperty('ccExpiryDate') || loggedUser && !loggedUser.hasOwnProperty('ccExpAlarmFlag') || loggedUserTemp && !loggedUserTemp.hasOwnProperty('ccExpAlarmFlag')) {
        localStorage.removeItem('loggedUser');
        sessionStorage.removeItem('loggedUserTemp');
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        token = null;
        loggedUser = null;
        loggedUserTemp = null;
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setUser', { user: null });
    }
    if (to.name === 'Expert') {
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setExpert', { expert: null });
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setExpertVideos', { expertVideos: null });
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setComingVideoFlag', false);
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setExpertPlaylist', { playList: null });
    }
    if (to.name === 'PlaylistVideoPlayer' || to.name === 'CorpPlaylistVideoPlayer' || to.name === 'TrendingPlaylistVideoPlayer') {
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setUserNewPlaylistObject', { playlist: null });
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setTrendingNewPlaylistObject', { playlist: null });
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setCorpNewPlaylistObject', { playlist: null });
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setExpert', { expert: null });
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setItemChangeInPlaylist', { item: null });
    }
    if (to.name === 'ArchivePlayer') {
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setArchivePlaylistObject', { eList: null });
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setLiveEventsArchive', { liveArchive: null });
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setArchivePlaylist', { arplaylist: null });
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setItemChangeInPlaylist', { item: null });
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setExpert', { expert: null });
    }
    if (to.name === 'Profile') {
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setUserPlaylistsProfile', { playlists: null });
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setUserProgressProfile', { playlists: null });
        __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setUpcomingEvent', { event: null });
    }
    if (to.name === 'SignUp') {
        if (from.name === 'SharePlayer') {
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', from.fullPath);
            } else {
                sessionStorage.setItem('redirectPath', from.fullPath);
            }
        }
    }
    console.log('inside src/router/index.js : loggedUserTemp = ', loggedUserTemp);
    console.log('inside src/router/index.js : loggedUser = ', loggedUser);
    if (loggedUserTemp) {
        if (loggedUserTemp.trialEndDate) {
            var endingDate = new Date(loggedUserTemp.trialEndDate.substr(0, 10));
            var currentDate = new Date();
            var remainingDays = __WEBPACK_IMPORTED_MODULE_82__helpers_dateHelpers_js__["a" /* dateHelpers */].getDatesDifference(endingDate, currentDate, 'days');
            if (remainingDays >= 0) {
                __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setHeaderAlertStatus', true);
                __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setTrialDays', remainingDays);
            }
        }
        if (to.name === 'SignUp' || to.name === 'JoinNowMobile' || to.name === 'ResetPassword' || to.name === 'Redeem' || to.name === 'AccentureCharlotte' || to.name === 'CorporationGifting' || to.name === 'CorporationGiftingComcast' || to.name === 'CorporationReferral') {
            next(false);
        } else if (to.name === 'Player' || to.name === 'UnauthPlayer' || to.name === 'NewEvents' || to.name === 'PlaylistVideoPlayer' || to.name === 'CorpPlaylistVideoPlayer') {
            var isDelegated = false;
            for (var matched = to.matched || [], i = matched.length; i--;) {
                var route = matched[i];
                if (route.meta.beforeEach) {
                    isDelegated = true;
                    route.meta.beforeEach(to, from, next);
                }
            }
            !isDelegated && next();
            window.scrollTo(0, 0);
            next();
        } else if (to.name === '/' || to.name === 'UnAuth') {
            console.log('R1 - 4', to.name);
            window.scrollTo(0, 0);
            next({ path: '/mytone' });
        } else {
            console.log('R1 - 5');
            window.scrollTo(0, 0);
            document.title = to.meta.title;
            next();
        }
    } else {
        if (token && token !== undefined) {
            if (loggedUser.trialEndDate) {
                var _endingDate = new Date(loggedUser.trialEndDate.substr(0, 10));
                var _currentDate = new Date();
                var _remainingDays = __WEBPACK_IMPORTED_MODULE_82__helpers_dateHelpers_js__["a" /* dateHelpers */].getDatesDifference(_endingDate, _currentDate, 'days');
                __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setHeaderAlertStatus', true);
                __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setTrialDays', _remainingDays);
            }
            if (loggedUser.ccExpiryDate && loggedUser.ccExpAlarmFlag === 2) {
                var expiryDate = new Date(loggedUser.ccExpiryDate.substr(0, 10));
                var _currentDate2 = new Date();
                var _remainingDays2 = __WEBPACK_IMPORTED_MODULE_82__helpers_dateHelpers_js__["a" /* dateHelpers */].getDatesDifference(expiryDate, _currentDate2, 'days');
                __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setCardExpiryDays', _remainingDays2);
            }
            if (loggedUser && sessionStorage.getItem('switchClientObject')) {
                var switchedCorp = sessionStorage.getItem('switchClientObject');
                switchedCorp = JSON.parse(switchedCorp);

                loggedUser.corporation = switchedCorp;
                __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setUser', { user: loggedUser });
                console.log('current user before switch', loggedUser);
            }
            if (loggedUser.corporation) {
                var headerColor = '#44bda8';
                var footerColor = '#44bda8';
                var buttonColor = '#44bda8';
                var headingColor = '#44bda8';
                if (loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.headerColor) {
                    headerColor = loggedUser.corporation.groupDefinitions.headerColor;
                }
                if (loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.footerColor) {
                    footerColor = loggedUser.corporation.groupDefinitions.footerColor;
                }
                if (loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.buttonColor) {
                    buttonColor = loggedUser.corporation.groupDefinitions.buttonColor;
                }
                if (loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.headingColor) {
                    headingColor = loggedUser.corporation.groupDefinitions.headingColor;
                }
                __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setCorpHeaderColor', headerColor);
                __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setCorpFooterColor', footerColor);
                __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setCorpButtonColor', buttonColor);
                __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setCorpHeadingColor', headingColor);
            }
            if (to.name === 'SignUp' || to.name === 'JoinNowMobile' || to.name === 'ResetPassword' || to.name === 'Redeem' || to.name === 'AccentureCharlotte' || to.name === 'CorporationGifting' || to.name === 'CorporationGiftingComcast' || to.name === 'CorporationReferral' || to.name === 'GiftRedirect') {
                next({ path: '/mytone' });
            } else if (to.name === 'Player') {
                var _isDelegated = false;
                for (var _matched = to.matched || [], _i = _matched.length; _i--;) {
                    var _route = _matched[_i];
                    if (_route.meta.beforeEach) {
                        _isDelegated = true;
                        _route.meta.beforeEach(to, from, next);
                    }
                }
                !_isDelegated && next();
                window.scrollTo(0, 0);
                next();
            } else if (to.name === '/' || to.name === 'UnAuth') {
                window.scrollTo(0, 0);
                next({ path: '/mytone' });
            } else {
                window.scrollTo(0, 0);
                document.title = to.meta.title;
                next();
            }
        } else {
            if (localStorage.getItem('corporateClientObject')) {
                var unauthCorp = localStorage.getItem('corporateClientObject');
                unauthCorp = JSON.parse(unauthCorp);
                if (unauthCorp) {
                    var _headerColor = '#44bda8';
                    var _footerColor = '#44bda8';
                    var _buttonColor = '#44bda8';
                    var _headingColor = '#44bda8';
                    if (unauthCorp.groupDefinitions && unauthCorp.groupDefinitions.headerColor) {
                        _headerColor = unauthCorp.groupDefinitions.headerColor;
                    }
                    if (unauthCorp.groupDefinitions && unauthCorp.groupDefinitions.footerColor) {
                        _footerColor = unauthCorp.groupDefinitions.footerColor;
                    }
                    if (unauthCorp.groupDefinitions && unauthCorp.groupDefinitions.buttonColor) {
                        _buttonColor = unauthCorp.groupDefinitions.buttonColor;
                    }
                    if (unauthCorp.groupDefinitions && unauthCorp.groupDefinitions.headingColor) {
                        _headingColor = unauthCorp.groupDefinitions.headingColor;
                    }
                    __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setCorpHeaderColor', _headerColor);
                    __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setCorpFooterColor', _footerColor);
                    __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setCorpButtonColor', _buttonColor);
                    __WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */].commit('setCorpHeadingColor', _headingColor);
                }
            }
            if (to.name === '/mytone' || to.name === 'Hello' || to.name === 'Player' || to.name === 'Career' || to.name === 'Work' || to.name === 'Life' || to.name === 'Money' || to.name === 'Profile' || to.name === 'Inspiration' || to.name === 'Mindbody' || to.name === 'Rules' || to.name === 'Talk' || to.name === 'LiveEvent' || to.name === 'Giving' || to.name === 'RecentlyWatched' || to.name === 'RelatedVideos' || to.name === 'Events' || to.name === 'CorporateGift' || to.name === 'PlaylistVideoPlayer' || to.name === 'CorpPlaylistVideoPlayer' || to.name === 'CorporateSale' || to.name === 'ArchivePlayer' || to.name === 'Teaser' || to.name === 'Takeaway' || to.name === 'CorporateCommunity' || to.name === 'TrialExpiry' || to.name === 'ManagePage' || to.name === 'TrendingPlaylistVideoPlayer') {
                if (to.fullPath.indexOf('watch') > 0) {
                    if (to.params.refBy && (to.params.refBy.toLowerCase() === 'toneteaser' || to.params.refBy.toLowerCase() === 'tonetakeaway')) {
                        if (to.params.videoTitle) {
                            next({ path: '/contentvideos/play/' + to.params.videoCode + '/' + to.params.refBy.toLowerCase() + '/' + to.params.videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase() });
                        } else {
                            next({ path: '/contentvideos/play/' + to.params.videoCode + '/' + to.params.refBy.toLowerCase() });
                        }
                    } else {
                        if (to.params.videoTitle) {
                            next({ path: '/contentvideos/play/' + to.params.videoCode + '/' + to.params.videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase() });
                        } else {
                            next({ path: '/contentvideos/play/' + to.params.videoCode });
                        }
                    }
                } else if (to.fullPath.indexOf('liveevent') > 0 || to.fullPath.indexOf('talk') > 0 || to.fullPath.indexOf('takeaway') > 0 || to.fullPath.indexOf('teaser') > 0 || to.name === 'CorpPlaylistVideoPlayer' || to.name === 'CorporateCommunity' || to.fullPath.indexOf('becomemember') > 0 || to.fullPath.indexOf('tonearchive') > 0 || to.name === 'Events' || to.name === 'PlaylistVideoPlayer' || to.fullPath.indexOf('trending') > 0) {
                    if (sessionStorage.getItem('redirectPath')) {
                        sessionStorage.removeItem('redirectPath');
                        sessionStorage.setItem('redirectPath', to.fullPath);
                    } else {
                        sessionStorage.setItem('redirectPath', to.fullPath);
                    }
                    window.scrollTo(0, 0);
                    console.log('inside src/router/index.js :  ====> to.fullPath = ', to.fullPath);
                    console.log('inside src/router/index.js :  ====> to.name = ', to.name);
                    next({ path: '/' });
                } else {
                    window.scrollTo(0, 0);
                    console.log('inside src/router/index.js : (else) ====> to.fullPath = ', to.fullPath);
                    console.log('inside src/router/index.js : (else) ====> to.name = ', to.name);
                    next({ path: '/' });
                }
            } else {
                window.scrollTo(0, 0);
                document.title = to.meta.title;
                next();
            }
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mothersday-image-desktop.9ab6d2b.jpg";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1060)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(963),
  /* scopeId */
  "data-v-2f3b14a2",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/JwPlayListTemp.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] JwPlayListTemp.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2f3b14a2", Component.options)
  } else {
    hotAPI.reload("data-v-2f3b14a2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCustomErrorMessage; });
var getCustomErrorMessage = function getCustomErrorMessage(originalMessage) {
    var errorMessageMapping = [{ 'original': 'aws.cognito.UserNotFound', 'custom': 'Login Failed, User not found' }, { 'original': 'aws.cognito.UserNotAuthorized', 'custom': 'Authentication Failed, Invalid Password' }, { 'original': 'aws.cognito.UserNotConfirmed', 'custom': 'Please check your inbox for your Validation Email - TONE Networks' }, { 'original': 'aws.cognito.PasswordReset', 'custom': 'Login Failed, Password Reset is required' }, { 'original': 'User.Requested.Not.Found', 'custom': 'User not found' }, { 'original': 'User.Exists', 'custom': 'User Already Exists' }];

    var exists = errorMessageMapping.filter(function (mapping) {
        return mapping.original.toLowerCase() === originalMessage.toLowerCase();
    });
    if (exists && exists.length > 0) {
        return exists[0].custom;
    } else {
        return originalMessage;
    }
};

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Gift-Ribbon-PNG-Photos.bd5d504.png";

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyNnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyNiAyMiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjYgMjIiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8dGl0bGU+TWluZCBCb2R5PC90aXRsZT4KPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CjxnIGlkPSJTeW1ib2xzIj4KCTxnIGlkPSJNYWluLU5hdiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUyMS4wMDAwMDAsIC0yNS4wMDAwMDApIj4KCQk8Zz4KCQkJPHJlY3QgaWQ9IlJlY3QiIGZpbGw9IiNGRkZGRkYiIGZpbGwtb3BhY2l0eT0iMCIgd2lkdGg9IjEyMDAiIGhlaWdodD0iODYiLz4KCQkJPGcgaWQ9Ik5hdiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQ2LjAwMDAwMCwgMjQuMDAwMDAwKSI+CgkJCQk8cGF0aCBpZD0iTWluZC1Cb2R5IiBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMC41IiBkPSJNMjk4LjkxNywxOS41MDlsLTAuMDYyLDAuMDUzCgkJCQkJYy0yLjAyOSwxLjc3OC00LjQyOCwyLjU0OS02LjU4OSwyLjEyNmMtMS45NDgtMC4zODctMy4zNDQtMS42NzQtNC42ODktMi45MThjLTEuNDU5LTEuMzQ4LTIuODM1LTIuNjItNC44NjQtMi44MzgKCQkJCQljLTIuMDI5LTAuMjE5LTQuMjQ0LDAuNzE3LTUuOTk0LDIuNTljMC42OCwwLjk0NiwzLjkxNyw0LjgzOCw5LjE5NCwxLjYyNGMwLjE0MS0wLjA1OSwwLjMwNC0wLjAwMywwLjM4MSwwLjEyOAoJCQkJCWMwLjA3OCwwLjEzMywwLjA0NSwwLjMwMi0wLjA3NCwwLjM5NmMtMS41ODgsMC45NjUtMy4wMTYsMS4zMy00LjI2MywxLjMzYy0zLjc1NCwwLTUuODgyLTMuMjk5LTUuOTEtMy4zNDQKCQkJCQljLTAuMDczLTAuMTE2LTAuMDYtMC4yNjYsMC4wMzEtMC4zNjdjMS45MS0yLjE0Niw0LjM0NC0zLjIyMyw2LjY3OC0yLjk3MWMyLjIzMSwwLjI0LDMuNzQ4LDEuNjQzLDUuMjEsMi45OTgKCQkJCQljMS4zNDIsMS4yMjYsMi42MTEsMi40MTQsNC4zOTEsMi43NThjMS45NzUsMC4zOTMsNC4xODQtMC4zMyw2LjA2My0xLjk4NmwwLjA3My0wLjA2MWgwLjAwMQoJCQkJCWMwLjIzOC0wLjE5MSwwLjQ2Ny0wLjM5NiwwLjY4NC0wLjYxM2MtMC45Mi0yLjE2OS0zLjQyNC0yLjY3Mi0zLjkyMy0yLjc1OGMtMC45MTEsMC41NTgtMS44OTYsMC45ODQtMi45MjcsMS4yNjYKCQkJCQljLTAuMDI4LDAuMDA0LTAuMDU2LDAuMDA0LTAuMDgzLDBjLTAuMDgxLDAuMDEtMC4xNjQtMC4wMTItMC4yMjktMC4wNjJjLTAuMDY1LTAuMDQ5LTAuMTA4LTAuMTIzLTAuMTE5LTAuMjA0CgkJCQkJYy0wLjAyMi0wLjE3LDAuMDk2LTAuMzI1LDAuMjY2LTAuMzQ4YzMuMTIzLTAuODg5LDUuMDU3LTIuNTg0LDUuNzU2LTUuMDMzaC0wLjAwMWMwLjI5MS0xLjA0NywwLjM0Ny0yLjE0NiwwLjE2My0zLjIxOAoJCQkJCWMtNC4yMzgtMC40MzYtNi4wMjUsMi4xLTYuMjg5LDIuNTEzYy0wLjIzNiwxLjY1NC0wLjk4NiwzLjMwNS0yLjI0NCw0LjkyOHYwLjAwMWMtMC4xMDUsMC4xMjItMC4yODksMC4xNC0wLjQxOCwwLjA0MQoJCQkJCWMtMC4xMjctMC4xLTAuMTU2LTAuMjgtMC4wNjQtMC40MTVjMS4yMjUtMS41MTYsMS45MzktMy4wODUsMi4xNS00LjY2MWMwLjA4OS0wLjY1NiwwLjA4OS0xLjMyMSwwLTEuOTc3CgkJCQkJYy0wLjQwNC0zLjA2NS0yLjY1LTUuMjEtMy4zMjgtNS43OTZjLTMuNTQ0LDMuMjc5LTIuOTA5LDYuODIyLTIuMTU5LDguNzIzYzAuMjc4LDAuNDYzLDAuNTIzLDAuOTQ2LDAuNzM2LDEuNDQzCgkJCQkJYzAuMDgzLDAuMTQ2LDAuMDMzLDAuMzM1LTAuMTE0LDAuNDJjLTAuMTQ3LDAuMDg1LTAuMzM1LDAuMDMzLTAuNDItMC4xMTNjLTAuMjcxLTAuNDMyLTAuNTAzLTAuODg5LTAuNjg5LTEuMzY0CgkJCQkJYy0xLjEwNC0xLjg3LTIuNTk2LTMuMDM0LTQuNDUtMy40NjZjLTAuOTQ5LTAuMjItMS45MzUtMC4yMzUtMi44OS0wLjA0Yy0wLjg4NiwyLjY4MiwwLjk2OSw1LjEsMC45ODcsNS4xMjQKCQkJCQljMC4xMDQsMC4xMzUsMC4wOCwwLjMyNy0wLjA1MywwLjQzMmMtMC4xMzQsMC4xMDMtMC4zMjcsMC4wNzgtMC40MzEtMC4wNTVjLTAuMDg4LTAuMTEzLTIuMTQ2LTIuODAxLTEuMDI3LTUuODY4VjcuOTI2CgkJCQkJYzAuMDM1LTAuMDkxLDAuMTA5LTAuMTU5LDAuMjAzLTAuMTg3YzEuMjg2LTAuMjk2LDIuNjI4LTAuMjM4LDMuODg1LDAuMTY2YzEuMjU2LDAuNDA1LDIuMzc5LDEuMTQzLDMuMjUsMi4xMzIKCQkJCQljLTAuNDIzLTIuMTg4LTAuMTY2LTUuMjEsMi45NjQtNy45NjhoLTAuMDAxYzAuMTE0LTAuMDkyLDAuMjc2LTAuMDkyLDAuMzksMGMwLjEzOCwwLjA4MywzLjI0MiwyLjQ4OSwzLjc2Myw2LjM0NAoJCQkJCWMwLjA0OSwwLjM3NiwwLjA3MiwwLjc1MywwLjA2OCwxLjEzMWMwLjk0MS0wLjk5LDIuOTY3LTIuNDUyLDYuNTAxLTIuMDJoLTAuMDAxYzAuMTI0LDAuMDE1LDAuMjI3LDAuMTA1LDAuMjU3LDAuMjI2CgkJCQkJYzAsMC4wNTUsMS4xMDEsNC41MjctMi42NzgsNy40NDhjMS4wNzksMC4yNzUsMy4wNjQsMS4wNTcsMy44NTQsMy4xNUMyOTkuOTMxLDE4LjU5MiwyOTkuNzc1LDE4Ljc4OCwyOTguOTE3LDE5LjUwOQoJCQkJCUwyOTguOTE3LDE5LjUwOXoiLz4KCQkJPC9nPgoJCTwvZz4KCTwvZz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAYCAYAAAB9ejRwAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjIzOEVERjk3Qjg3MTFFODk0MUZFN0MzMEQ2RkNCRkEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjIzOEVERkE3Qjg3MTFFODk0MUZFN0MzMEQ2RkNCRkEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGMjM4RURGNzdCODcxMUU4OTQxRkU3QzMwRDZGQ0JGQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGMjM4RURGODdCODcxMUU4OTQxRkU3QzMwRDZGQ0JGQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlYSSIIAAABSSURBVHjaYvyQWPufgfaAkRTFTAyDEAxKR7GQGrQjNqRGHTXkE/poOUVsSNEb/CcUiqPl1KijhlpC/0+OmmFfeDKOpikqh95o4TnqKLoDgAADABVkCRDHsnk3AAAAAElFTkSuQmCC"

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXcAAAF3AQAAAAB2uzZTAAACP0lEQVR4nO2bTW7CQAyFxw0S3aU3CDcJNyPcrLlJuUGzI1LDdMb2/KSsKDRM1OcNJHxCXoys52fPi8njYO3FVNbHh2n5037NiBdzW4AHvyxPNsT79c/k/28biRLzBw9+zk/kY5dejvRmGnt0L/XFwES3UD7gwT+KJ3nhD/Be5Mdz8wEP/i6eWDDXrJ+7cLyfmA948DfyoQH0YSfaOMH86b72TmBofa6Z6BbKBzz43/OWQuzdM1V2pFenN1puD7k+j5EoMX/w4DPe5qEFeaSGy/XR94NVDlyKyx88+Jx3VXfD305agY1hvXHK+8FBq3eB+YMHn/Ou6IqeaFUhu4I8sF9nRYls2L7zchp6A3zxvNbn2vbsMOsA5UQ77gcNsZxOdkdx+YMH/4P3CtkbGq3U5ykeYCvj77OyB8wHwa+CH3k+2JO1xkaB4cOV64lqd9obnYaXmT948IH3A5StLiCRLHP4guz7QfU3Bj3eR4K/Ab58fmLDWQRzLMg6T5lYXQd/A/oZ/Br4UQ0NPsBbrs/ymPWDrEYKzR88+MRXKjBIDA2/vyELdezYSX2WcSH0BvjCeZ6YpA1nNZwbNeh0Ozq5H8XlDx58zlMeXarPbVjv9+o6BPQz+NL5q/spwX+O+xvnGf/X+YAHfx+f30/RfjBeSJGZt8y7u4XyAQ/+YXzY58+uEwZ3ukM/CH59fPCf+bp3Gq/IdscK8gf/z/n8fkpcHzXhkWbbdyXmDx584uf3U7g9PPO40IRHHz32n8GvgP8GfBxT2pv9MucAAAAASUVORK5CYII="

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/whiteribbon.2ae75a1.png";

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.f4769f9.eot";

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1094)
__webpack_require__(1095)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(986),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5930af97", Component.options)
  } else {
    hotAPI.reload("data-v-5930af97", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isUserAuthorized; });
var isUserAuthorized = function isUserAuthorized(email) {
    var authorizedList = 'adam@tonenetworks.com,gemma@tonenetworks.com,pippa@tonenetworks.com,pippa.schwarzkopf@gmail.com,abdul.rehman@pk.ewsystemsinc.com';
    if (authorizedList.indexOf(email.toLowerCase()) >= 0) {
        console.info('authorized');
        return true;
    } else {
        console.info('user not authorized');
        return false;
    }
};

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_pagination_2__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_pagination_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_pagination_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_social_sharing__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_social_sharing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_sweetalert__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_meta__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_multiselect__);
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_social_sharing___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_sweetalert___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('multiselect', __WEBPACK_IMPORTED_MODULE_11_vue_multiselect___default.a);

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    jquery: __WEBPACK_IMPORTED_MODULE_5_jquery___default.a,
    bootstrap: __WEBPACK_IMPORTED_MODULE_4_bootstrap___default.a,
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_6_vue_pagination_2__["Pagination"],
    PaginationEvent: __WEBPACK_IMPORTED_MODULE_6_vue_pagination_2__["PaginationEvent"],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

__WEBPACK_IMPORTED_MODULE_8_vue_analytics___default.a.onScriptLoaded().then(function () {
    app.$mount('#app');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_analytics___default.a, {
    onReady: function onReady() {},

    id: 'UA-104790802-1',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    autoTracking: {
        pageviewTemplate: function pageviewTemplate(route) {
            return {
                page: route.path,
                title: document.title,
                location: window.location.href
            };
        }
    }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    GETAUTHVIDEOS: function GETAUTHVIDEOS(_ref, videoType) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/playlists/getJWPlaylistByTitle/' + videoType[0] + '/' + videoType[1]).then(function (response) {
            var data = response.data.data;

            var videoData = void 0;
            if (data && data.length > 0) {
                videoData = data;
            } else {
                videoData = null;
            }
            if (videoType[0] === 'CAREER') {
                commit('setAuthCareerVideo', { videoObject: videoData });
            } else if (videoType[0] === 'MINDBODY') {
                commit('setAuthMindbodyVideo', { videoObject: videoData });
            } else if (videoType[0] === 'INSPIRATION') {
                commit('setAuthInspirationVideo', { videoObject: videoData });
            } else if (videoType[0] === 'WORK') {
                commit('setAuthWorkVideo', { videoObject: videoData });
            } else if (videoType[0] === 'LIFE') {
                commit('setAuthLifeVideo', { videoObject: videoData });
            } else if (videoType[0] === 'MONEY') {
                commit('setAuthMoneyVideo', { videoObject: videoData });
            } else {}
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETAUTHRECOMMENDEDVIDEOS: function GETAUTHRECOMMENDEDVIDEOS(_ref2, userId) {
        var commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('recommendations/getPlaylistByUserId/' + userId).then(function (response) {
            var data = response.data.data;

            var failedVideos = data.filter(function (x) {
                return !x && !x.image || x.image === null || x.image === '';
            });
            if (failedVideos && failedVideos.length > 0) {
                console.log('failed videos', failedVideos);
            }
            commit('setAuthRecommendedVideos', { videoObject: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETAUTHRECENTLYWATCHEDVIDEOS: function GETAUTHRECENTLYWATCHEDVIDEOS(_ref3, userId) {
        var commit = _ref3.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('playlists/getRecentVideoByuserId/' + userId + '/5').then(function (response) {
            var data = response.data.data;

            var recentVideos = [];
            if (data && data.length > 0) {
                data.forEach(function (videoItem) {
                    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/playlists/getJWVideoByCode/' + videoItem.videoCode).then(function (response) {
                        var data = response.data.data;

                        if (data[0] && data[0].image) {
                            recentVideos.push(data[0]);
                        } else {
                            console.log('video issue', videoItem.videoCode);
                        }
                    }, function (err) {
                        console.log('err ', err);
                    });
                });
                commit('setAuthRecentlyWatchedVideos', { videoObject: recentVideos });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setAuthRecentlyWatchedVideos', { videoObject: null });
        });
    },
    GETUSERFAVORITEVIDEOS: function GETUSERFAVORITEVIDEOS(_ref4, userId) {
        var commit = _ref4.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('playlists/getUserVideosById/' + userId).then(function (response) {
            var data = response.data.data;

            var favVideos = [];
            if (data && data.length > 0) {
                data.forEach(function (videoItem) {
                    if (videoItem.liked === '1') {
                        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/playlists/getJWVideoByCode/' + videoItem.videoCode).then(function (response) {
                            var data = response.data.data;

                            favVideos.push(data[0]);
                        }, function (err) {
                            console.log('err ', err);
                        });
                    }
                });
            }
            commit('setAuthUserFavVideos', { favVideos: favVideos });
        }, function (err) {
            console.log('err ', err);
            commit('setAuthUserFavVideos', { favVideos: null });
        });
    },
    GETAUTHQUESTIONS: function GETAUTHQUESTIONS(_ref5) {
        var commit = _ref5.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('questions').then(function (response) {
            var data = response.data.data;

            commit('setAuthQuestions', { questions: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    SETANSWER: function SETANSWER(_ref6, questionReponse) {
        var commit = _ref6.commit;

        var userId = questionReponse.userId;
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/questions/addUpdateUserAnswers', questionReponse).then(function (response) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/playlists/reloadPlaylistByUserQuestionAnswers/' + userId).then(function (response) {
                var data = response.data.data;

                commit('setAuthRecommendedVideos', { videoObject: data.slice(0, 3) });
            }, function (err) {
                console.log('err ', err);
            });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETAUTHUSERVIDEOS: function GETAUTHUSERVIDEOS(_ref7, userId) {
        var commit = _ref7.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('playlists/getUserVideosById/' + userId).then(function (response) {
            var data = response.data.data;

            commit('setAuthUserVideos', { userVideos: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETTONETEASER: function GETTONETEASER(_ref8, userId) {
        var commit = _ref8.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('useremails/getUserToneTeaser/' + userId).then(function (response) {
            var data = response.data.data;

            if (data) {
                commit('setToneTeasers', { obj: data });
            } else {
                commit('setToneTeasers', { obj: null });
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETTONETAKEAWAY: function GETTONETAKEAWAY(_ref9, userId) {
        var commit = _ref9.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('tonetakeaways/getUserToneTakeaways/' + userId).then(function (response) {
            var data = response.data.data;

            console.log('data', data);
            if (data) {
                commit('setToneTakeaways', { obj: data });
            } else {
                commit('setToneTakeaways', { obj: null });
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETAUTHQUOTES: function GETAUTHQUOTES(_ref10, corporationId) {
        var commit = _ref10.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/user/getQuotesAtRandom/' + corporationId).then(function (response) {
            var data = response.data.data;

            commit('setNewQuote', { quoteObj: data.payload });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETAUTHGREETNGS: function GETAUTHGREETNGS(_ref11, corporationId) {
        var commit = _ref11.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/user/getGreetingsAtRandom/any/' + corporationId).then(function (response) {
            var data = response.data.data;

            commit('setAuthGreeting', { greetingObj: data.payload });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETAUTHFUNNIES: function GETAUTHFUNNIES(_ref12, corporationId) {
        var commit = _ref12.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/user/getFunniesAtRandom/' + corporationId).then(function (response) {
            var data = response.data.data;

            commit('setAuthFunnies', { funniesObj: data.payload });
        }, function (err) {
            console.log('err ', err);
        });
    }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getAuthCareerVideos: function getAuthCareerVideos(state) {
        return state.authCareerVideos;
    },
    getAuthInspirationVideos: function getAuthInspirationVideos(state) {
        return state.authInspirationVideos;
    },
    getAuthWorkVideos: function getAuthWorkVideos(state) {
        return state.authWorkVideos;
    },
    getAuthLifeVideos: function getAuthLifeVideos(state) {
        return state.authLifeVideos;
    },
    getAuthMoneyVideos: function getAuthMoneyVideos(state) {
        return state.authMoneyVideos;
    },
    getAuthMindbodyVideos: function getAuthMindbodyVideos(state) {
        return state.authMindbodyVideos;
    },
    getAuthRecommendedVideos: function getAuthRecommendedVideos(state) {
        return state.authRecommendedVideos;
    },
    getAuthRecentlyWatchedVideos: function getAuthRecentlyWatchedVideos(state) {
        return state.authRecentlyWatchedVideos;
    },
    getAuthQuestions: function getAuthQuestions(state) {
        return state.authQuestions;
    },
    getAuthUserVideos: function getAuthUserVideos(state) {
        return state.authUserVideos;
    },
    getAuthUserFavVideos: function getAuthUserFavVideos(state) {
        return state.authUserFavVideos;
    },
    getQuote: function getQuote(state) {
        return state.authQuote;
    },
    getAuthGreeting: function getAuthGreeting(state) {
        return state.authGreeting;
    },
    getAuthFunnies: function getAuthFunnies(state) {
        return state.authFunnies;
    },
    getToneTakeaways: function getToneTakeaways(state) {
        return state.toneTakeaways;
    },
    getToneTeasers: function getToneTeasers(state) {
        return state.toneTeasers;
    }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(352);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    setAuthCareerVideo: function setAuthCareerVideo(state, _ref) {
        var videoObject = _ref.videoObject;

        state.authCareerVideos = videoObject;
    },
    setAuthInspirationVideo: function setAuthInspirationVideo(state, _ref2) {
        var videoObject = _ref2.videoObject;

        state.authInspirationVideos = videoObject;
    },
    setAuthMindbodyVideo: function setAuthMindbodyVideo(state, _ref3) {
        var videoObject = _ref3.videoObject;

        state.authMindbodyVideos = videoObject;
    },
    setAuthMoodForSomethingElse: function setAuthMoodForSomethingElse(state, _ref4) {
        var mood = _ref4.mood;

        state.mainVideo = mood;
    },
    setAuthWorkVideo: function setAuthWorkVideo(state, _ref5) {
        var videoObject = _ref5.videoObject;

        state.authWorkVideos = videoObject;
    },
    setAuthMoneyVideo: function setAuthMoneyVideo(state, _ref6) {
        var videoObject = _ref6.videoObject;

        state.authMoneyVideos = videoObject;
    },
    setAuthLifeVideo: function setAuthLifeVideo(state, _ref7) {
        var videoObject = _ref7.videoObject;

        state.authLifeVideos = videoObject;
    },
    setAuthRecommendedVideos: function setAuthRecommendedVideos(state, _ref8) {
        var videoObject = _ref8.videoObject;

        state.authRecommendedVideos = videoObject;
    },
    setAuthRecentlyWatchedVideos: function setAuthRecentlyWatchedVideos(state, _ref9) {
        var videoObject = _ref9.videoObject;

        state.authRecentlyWatchedVideos = videoObject;
    },
    setAuthQuestions: function setAuthQuestions(state, _ref10) {
        var questions = _ref10.questions;

        state.authQuestions = questions;
    },
    setAuthUserVideos: function setAuthUserVideos(state, _ref11) {
        var userVideos = _ref11.userVideos;

        state.authUserVideos = userVideos;
    },
    setAuthUserFavVideos: function setAuthUserFavVideos(state, _ref12) {
        var favVideos = _ref12.favVideos;

        state.authUserFavVideos = favVideos;
    },
    setAuthRelatedVideos: function setAuthRelatedVideos(state, _ref13) {
        var relVideos = _ref13.relVideos;

        state.authRelatedVideos = relVideos;
    },
    setNewQuote: function setNewQuote(state, _ref14) {
        var quoteObj = _ref14.quoteObj;

        state.authQuote = quoteObj;
    },
    setAuthGreeting: function setAuthGreeting(state, _ref15) {
        var greetingObj = _ref15.greetingObj;

        state.authGreeting = greetingObj;
    },
    setToneTakeaways: function setToneTakeaways(state, _ref16) {
        var obj = _ref16.obj;

        state.toneTakeaways = obj;
    },
    setToneTeasers: function setToneTeasers(state, _ref17) {
        var obj = _ref17.obj;

        state.toneTeasers = obj;
    },
    setAuthFunnies: function setAuthFunnies(state, _ref18) {
        var funniesObj = _ref18.funniesObj;

        state.authFunnies = funniesObj;
    }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    authRecommendedVideos: null,
    authMoodForSomethingElse: null,
    authRecentlyWatchedVideos: null,
    authCareerVideos: null,
    authMindbodyVideos: null,
    authInspirationVideos: null,
    authWorkVideos: null,
    authMoneyVideos: null,
    authLifeVideos: null,
    authQuestions: null,
    authUserVideos: null,
    authUserFavVideos: null,
    authRelatedVideos: null,
    authQuote: null,
    authGreeting: null,
    authFunnies: null,
    toneTeasers: null,
    toneTakeaways: null
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    GETALLCHARITIES: function GETALLCHARITIES(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/charities').then(function (response) {
            var data = response.data.data;

            commit('setCharities', { charities: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETCHARITY: function GETCHARITY(_ref2, charityId) {
        var commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/charities/' + charityId).then(function (response) {
            var data = response.data.data;

            commit('setCharity', { charity: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    SETSELECTEDCHARITY: function SETSELECTEDCHARITY(_ref3, info) {
        var commit = _ref3.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/charities/updateByUserId/' + info[0] + '/' + info[1]).then(function (response) {
            var data = response.data.data;

            commit('setSelectedCharity', { charity: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETSELECTEDCHARITY: function GETSELECTEDCHARITY(_ref4, userId) {
        var commit = _ref4.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/charities/getByUserId/' + userId).then(function (response) {
            var data = response.data.data;

            commit('setSelectedCharity', { charity: data });
        }, function (err) {
            console.log('err ', err);
        });
    }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getAllCharities: function getAllCharities(state) {
        return state.charities;
    },
    getCharity: function getCharity(state) {
        return state.charity;
    },
    getSelectedCharity: function getSelectedCharity(state) {
        return state.selectedCharity;
    }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(357);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    setCharities: function setCharities(state, _ref) {
        var charities = _ref.charities;

        state.charities = charities;
    },
    setCharity: function setCharity(state, _ref2) {
        var charity = _ref2.charity;

        state.charity = charity;
    },
    setSelectedCharity: function setSelectedCharity(state, _ref3) {
        var charity = _ref3.charity;

        state.selectedCharity = charity;
    }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    charity: null,
    charities: null,
    selectedCharity: null
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    GETAPPCONFIGRATION: function GETAPPCONFIGRATION(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/freepreview/getAllAppConfiguration').then(function (response) {
            var data = response.data.data;

            commit('setAllConfgirations', { config: data });

            var giftingTitle = data.filter(function (conf) {
                return conf.key === 'Gift_Link_Text';
            });
            if (giftingTitle && giftingTitle.length >= 0) {
                if (giftingTitle[0].value) {
                    commit('setGiftingText', giftingTitle[0].value);
                } else {
                    commit('setGiftingText', 'Give the gift of TONE');
                }
            } else {
                commit('setGiftingText', 'Give the gift of TONE');
            }

            var customBanner = data.filter(function (conf) {
                return conf.key === 'ShowCustomUnauthBanner';
            });
            if (customBanner && customBanner.length >= 0) {
                if (customBanner[0].value === '1') {
                    commit('setShowCustomUnauthBanner', true);
                } else {
                    commit('setShowCustomUnauthBanner', false);
                }
            } else {
                commit('setShowCustomUnauthBanner', false);
            }

            var customBannerText = data.filter(function (conf) {
                return conf.key === 'CustomUnauthBannerText';
            });
            if (customBannerText && customBannerText.length >= 0) {
                if (customBannerText[0].value) {
                    commit('setUnauthBannerText', customBannerText[0].value);
                } else {
                    commit('setUnauthBannerText', '');
                }
            } else {
                commit('setUnauthBannerText', '');
            }

            var customBannerLink = data.filter(function (conf) {
                return conf.key === 'CustomUnauthBannerLink';
            });
            if (customBannerLink && customBannerLink.length >= 0) {
                if (customBannerLink[0].value) {
                    commit('setUnauthBannerLink', customBannerLink[0].value);
                } else {
                    commit('setUnauthBannerLink', '');
                }
            } else {
                commit('setUnauthBannerLink', '');
            }

            var siteStatus = data.filter(function (conf) {
                return conf.key === 'EnableMaintenancePage';
            });
            if (siteStatus && siteStatus.length >= 0) {
                if (siteStatus[0].value === '1') {
                    commit('setMaintenanceStatus', true);
                } else {
                    commit('setMaintenanceStatus', false);
                }
            } else {
                commit('setMaintenanceStatus', false);
            }

            var corpLiveStreamStatus = data.filter(function (conf) {
                return conf.key === 'EnableCorporateLiveStreaming';
            });
            if (corpLiveStreamStatus && corpLiveStreamStatus.length >= 0) {
                if (corpLiveStreamStatus[0].value === '1') {
                    commit('SetCorporateLiveStreamFlag', 1);
                } else {
                    commit('SetCorporateLiveStreamFlag', 0);
                }
            } else {
                commit('SetCorporateLiveStreamFlag', 0);
            }

            var freePreviewStatus = data.filter(function (conf) {
                return conf.key === 'FreePreviewService';
            });
            if (freePreviewStatus && freePreviewStatus.length >= 0) {
                if (freePreviewStatus[0].value === '1') {
                    commit('SetDefaultPreviewStatus', 1);
                } else {
                    commit('SetDefaultPreviewStatus', 0);
                }
            } else {
                commit('SetDefaultPreviewStatus', 0);
            }

            var swithTime = data.filter(function (conf) {
                return conf.key === 'DefaultEventJoiningSwitch';
            });
            if (swithTime && swithTime.length >= 0) {
                commit('setEventJoinSwitch', swithTime[0].value);
            } else {
                commit('setEventJoinSwitch', 0);
            }

            var totalTrialDys = data.filter(function (conf) {
                return conf.key === 'TrialDays';
            });
            if (totalTrialDys && totalTrialDys.length >= 0) {
                commit('setTotalTrialDays', totalTrialDys[0].value);
            } else {
                commit('setTotalTrialDays', 0);
            }

            var paidMemberService = data.filter(function (conf) {
                return conf.key === 'PaidMembershipService';
            });
            if (paidMemberService && paidMemberService.length >= 0) {
                if (paidMemberService[0].value === '1') {
                    commit('setPaidMembershipFlag', 1);
                } else {
                    commit('setPaidMembershipFlag', 0);
                }
            } else {
                commit('setPaidMembershipFlag', 0);
            }

            var charitySection = data.filter(function (conf) {
                return conf.key === 'ShowProfileCharitySection';
            });
            if (charitySection && charitySection.length >= 0) {
                if (charitySection[0].value === '1') {
                    commit('setProfileCharitySectionFlag', 1);
                } else {
                    commit('setProfileCharitySectionFlag', 0);
                }
            } else {
                commit('setProfileCharitySectionFlag', 0);
            }

            var authBannerMessage = data.filter(function (conf) {
                return conf.key === 'RegularAuthLeftTopBannerMessage';
            });
            if (authBannerMessage && authBannerMessage.length >= 0) {
                commit('setAuthLeftTopBannerMessage', authBannerMessage[0].value);
            } else {
                commit('setAuthLeftTopBannerMessage', null);
            }

            var authBannerUrl = data.filter(function (conf) {
                return conf.key === 'RegularAuthLeftTopBannerUrl';
            });
            if (authBannerUrl && authBannerUrl.length >= 0) {
                commit('setAuthLeftTopBannerUrl', authBannerUrl[0].value);
            } else {
                commit('setAuthLeftTopBannerUrl', null);
            }

            var findoutMoreUrl = data.filter(function (conf) {
                return conf.key === 'UnauthFindMoreLinkUrl';
            });
            if (findoutMoreUrl && findoutMoreUrl.length >= 0) {
                commit('setUnauthFindMoreUrl', findoutMoreUrl[0].value);
            } else {
                commit('setUnauthFindMoreUrl', null);
            }

            var showParticipantCount = data.filter(function (conf) {
                return conf.key === 'ShowEventParticipantCount';
            });
            if (showParticipantCount && showParticipantCount.length >= 0) {
                if (showParticipantCount[0].value === '1') {
                    commit('setShowParticipantFlag', 1);
                } else {
                    commit('setShowParticipantFlag', 0);
                }
            } else {
                commit('setShowParticipantFlag', 0);
            }

            var giftingLinksStatus = data.filter(function (conf) {
                return conf.key === 'HideGiftingLinksAcrossSite';
            });
            if (giftingLinksStatus && giftingLinksStatus.length >= 0) {
                if (giftingLinksStatus[0].value === '1') {
                    commit('setGiftingLinksStatus', 1);
                } else {
                    commit('setGiftingLinksStatus', 0);
                }
            } else {
                commit('setGiftingLinksStatus', 0);
            }

            var totalDuration = data.filter(function (conf) {
                return conf.key === 'BannerMessageDuration';
            });
            if (totalDuration && totalDuration.length >= 0) {
                commit('setMessageDuration', parseInt(totalDuration[0].value));
            } else {
                commit('setMessageDuration', 0);
            }

            var amcStreamingURL = data.filter(function (conf) {
                return conf.key === 'CorpLiveStreamingURL';
            });
            if (amcStreamingURL && amcStreamingURL.length > 0) {
                commit('setCorpStreamingURL', amcStreamingURL[0].value);
            } else {
                commit('setCorpStreamingURL', null);
            }
            var liveStreamingStatus = data.filter(function (conf) {
                return conf.key === 'EnableLiveStreaming';
            });
            var liveStreamingURL = data.filter(function (conf) {
                return conf.key === 'LiveStreamingURL';
            });
            if (liveStreamingStatus && liveStreamingStatus.length > 0 && liveStreamingURL && liveStreamingURL.length > 0) {
                if (liveStreamingStatus[0].value === '1' && liveStreamingURL[0].value.length > 0) {
                    commit('setLiveStreamingStatus', 1);
                    commit('setLiveStreamingURL', liveStreamingURL[0].value);
                } else {
                    commit('setLiveStreamingStatus', 0);
                    commit('setLiveStreamingURL', null);
                }
            } else {
                commit('setLiveStreamingStatus', 0);
                commit('setLiveStreamingURL', null);
            }
        }, function (err) {
            commit('setLiveStreamingStatus', 0);
            commit('setLiveStreamingURL', null);
            console.log('err ', err);
        });
    },
    GETPRESSRELEASES: function GETPRESSRELEASES(_ref2) {
        var commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('feedback/getPressPageContents').then(function (response) {
            var data = response.data.data;

            commit('setPressReleaseData', { pressReleases: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    CACHEPAGE: function CACHEPAGE(_ref3, urlToCache) {
        var commit = _ref3.commit;

        var payload = {
            prerenderToken: 'Du2s8J9rXbxwE0wa5yKN',
            url: urlToCache
        };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://api.prerender.io/recache', payload).then(function (response) {
            console.log(urlToCache + ' successfully cached!');
        }, function (err) {
            console.log('err ', err + ' : Page coudn\'t be cached');
        });
    },
    GETMESSAGEBOARD: function GETMESSAGEBOARD(_ref4, corpId) {
        var commit = _ref4.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('home/getAllBanners/' + corpId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setMessageBoard', { messages: data.payload });
            } else {
                commit('setMessageBoard', { messages: null });
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETALLARTICLES: function GETALLARTICLES(_ref5) {
        var commit = _ref5.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('user/findAllToneArticles').then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setAllArticles', { articles: data.payload });
            } else {
                commit('setAllArticles', { articles: null });
            }
        }, function (err) {
            commit('setAllArticles', { articles: null });
            console.log('err ', err);
        });
    },
    GETSELECTEDARTICLE: function GETSELECTEDARTICLE(_ref6, articleId) {
        var commit = _ref6.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('user/findToneArticleById/' + articleId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setSelectedArticle', { article: data.payload });
            } else {
                commit('setSelectedArticle', { article: null });
            }
        }, function (err) {
            commit('setSelectedArticle', { article: null });
            console.log('err ', err);
        });
    },
    GETFAQS: function GETFAQS(_ref7) {
        var commit = _ref7.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('common/getAllFaqs').then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setFaqs', { faqs: data.payload });
            } else {
                commit('setFaqs', { faqs: null });
            }
        }, function (err) {
            commit('setFaqs', { faqs: null });
            console.log('err ', err);
        });
    },
    GETSTAFFMEMBERS: function GETSTAFFMEMBERS(_ref8) {
        var commit = _ref8.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('common/getAllStaff').then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setMembers', { members: data.payload });
            } else {
                commit('setMembers', { members: null });
            }
        }, function (err) {
            commit('setMembers', { members: null });
            console.log('err ', err);
        });
    },
    GET_ADVISORY_BOARD: function GET_ADVISORY_BOARD(_ref9, groupName) {
        var commit = _ref9.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/common/getAdvisoryBoard/' + groupName).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setAdvisoryBoard', { adBoard: data.payload });
                console.log('GET_PODCAST_FOR_SERVICE - DATA FOUND  >>>>>>>>>>>>>>>>>>> data.payload ', data.payload);
            } else {
                commit('setAdvisoryBoard', { adBoard: null });
                console.log('GET_PODCAST_FOR_SERVICE -- NO DATA FOUND >>>>>>>>>>>>>>>>>>> data.payload ', data.payload);
            }
        }, function (err) {
            console.log('err ', err);
            commit('setAdvisoryBoard', { adBoard: null });
        });
    }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getAllConfigrations: function getAllConfigrations(state) {
        return state.allConfigurations;
    },
    getFreePreviewStatus: function getFreePreviewStatus(state) {
        return state.isFreePreviewEnabled;
    },
    getLiveStreamingStatus: function getLiveStreamingStatus(state) {
        return state.enableLiveStreaming;
    },
    getMessageDuration: function getMessageDuration(state) {
        return state.messageDuration;
    },
    getLiveStreamingURL: function getLiveStreamingURL(state) {
        return state.liveStreamingURL;
    },
    getCorpStreamingURL: function getCorpStreamingURL(state) {
        return state.CorpLiveStreamingURL;
    },
    getAlertMsgStatus: function getAlertMsgStatus(state) {
        return state.showHeaderAlert;
    },
    getTrialDays: function getTrialDays(state) {
        return state.daysLeft;
    },
    getCardExpiryDays: function getCardExpiryDays(state) {
        return state.cardExpiryDays;
    },
    getTotalTrialDays: function getTotalTrialDays(state) {
        return state.totalTrialDays;
    },
    getPressReleaseData: function getPressReleaseData(state) {
        return state.pressReleaseData;
    },
    getMessageBoard: function getMessageBoard(state) {
        return state.messageBoard;
    },
    getAllArticles: function getAllArticles(state) {
        return state.allArticles;
    },
    getSelectedArticle: function getSelectedArticle(state) {
        return state.selectedArticle;
    },
    getEventSwitchTime: function getEventSwitchTime(state) {
        return state.defEventSwitch;
    },
    getCorporateLiveStreamFlag: function getCorporateLiveStreamFlag(state) {
        return state.enableCorporateLiveStreaming;
    },
    getFAQs: function getFAQs(state) {
        return state.faqs;
    },
    getMembers: function getMembers(state) {
        return state.members;
    },
    getSiteStatus: function getSiteStatus(state) {
        return state.isMaintenance;
    },
    getGiftingText: function getGiftingText(state) {
        return state.giftingText;
    },
    getCustomUnauthBannerStatus: function getCustomUnauthBannerStatus(state) {
        return state.showCustomUnauthBanner;
    },
    getCustomUnauthBannerText: function getCustomUnauthBannerText(state) {
        return state.unauthBannerText;
    },
    getCustomUnauthBannerLink: function getCustomUnauthBannerLink(state) {
        return state.unauthBannerLink;
    },
    getGiftingLinksFlag: function getGiftingLinksFlag(state) {
        return state.turnOffGifting;
    },
    getPaidMembershipFlag: function getPaidMembershipFlag(state) {
        return state.paidMembershipService;
    },
    getProfileCharitySection: function getProfileCharitySection(state) {
        return state.profileCharitySection;
    },
    getAuthLeftTopBannerMessage: function getAuthLeftTopBannerMessage(state) {
        return state.authLeftTopBannerMessage;
    },
    getAuthLeftTopBannerUrl: function getAuthLeftTopBannerUrl(state) {
        return state.authLeftTopBannerUrl;
    },
    getFindOutMoreUrl: function getFindOutMoreUrl(state) {
        return state.unauthFindMoreUrl;
    },
    getShowCountFlag: function getShowCountFlag(state) {
        return state.showEventParticipantCount;
    },
    getAdvisoryBoard: function getAdvisoryBoard(state) {
        return state.advisoryBoard;
    }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(362);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    setAllConfgirations: function setAllConfgirations(state, _ref) {
        var config = _ref.config;

        state.allConfigurations = config;
    },
    SetDefaultPreviewStatus: function SetDefaultPreviewStatus(state, previewStatus) {
        state.isFreePreviewEnabled = previewStatus;
    },
    SetCorporateLiveStreamFlag: function SetCorporateLiveStreamFlag(state, flag) {
        state.enableCorporateLiveStreaming = flag;
    },
    setLiveStreamingStatus: function setLiveStreamingStatus(state, status) {
        state.enableLiveStreaming = status;
    },
    setCorpStreamingURL: function setCorpStreamingURL(state, status) {
        state.CorpLiveStreamingURL = status;
    },
    setMessageDuration: function setMessageDuration(state, status) {
        state.messageDuration = status;
    },
    setLiveStreamingURL: function setLiveStreamingURL(state, url) {
        state.liveStreamingURL = url;
    },
    setHeaderAlertStatus: function setHeaderAlertStatus(state, alertStatus) {
        state.showHeaderAlert = alertStatus;
    },
    setTrialDays: function setTrialDays(state, days) {
        state.daysLeft = days;
    },
    setCardExpiryDays: function setCardExpiryDays(state, days) {
        state.cardExpiryDays = days;
    },
    setTotalTrialDays: function setTotalTrialDays(state, days) {
        state.totalTrialDays = days;
    },
    setMaintenanceStatus: function setMaintenanceStatus(state, flag) {
        state.isMaintenance = flag;
    },
    setEventJoinSwitch: function setEventJoinSwitch(state, mins) {
        state.defEventSwitch = mins;
    },
    setPressReleaseData: function setPressReleaseData(state, _ref2) {
        var pressReleases = _ref2.pressReleases;

        state.pressReleaseData = pressReleases;
    },
    setMessageBoard: function setMessageBoard(state, _ref3) {
        var messages = _ref3.messages;

        state.messageBoard = messages;
    },
    setAllArticles: function setAllArticles(state, _ref4) {
        var articles = _ref4.articles;

        state.allArticles = articles;
    },
    setSelectedArticle: function setSelectedArticle(state, _ref5) {
        var article = _ref5.article;

        state.selectedArticle = article;
    },
    setFaqs: function setFaqs(state, _ref6) {
        var faqs = _ref6.faqs;

        state.faqs = faqs;
    },
    setMembers: function setMembers(state, _ref7) {
        var members = _ref7.members;

        state.members = members;
    },
    setGiftingText: function setGiftingText(state, giftingTitle) {
        state.giftingText = giftingTitle;
    },
    setShowCustomUnauthBanner: function setShowCustomUnauthBanner(state, flag) {
        state.showCustomUnauthBanner = flag;
    },
    setUnauthBannerText: function setUnauthBannerText(state, bannerText) {
        state.unauthBannerText = bannerText;
    },
    setUnauthBannerLink: function setUnauthBannerLink(state, bannerLink) {
        state.unauthBannerLink = bannerLink;
    },
    setGiftingLinksStatus: function setGiftingLinksStatus(state, status) {
        state.turnOffGifting = status;
    },
    setPaidMembershipFlag: function setPaidMembershipFlag(state, status) {
        state.paidMembershipService = status;
    },
    setProfileCharitySectionFlag: function setProfileCharitySectionFlag(state, status) {
        state.profileCharitySection = status;
    },
    setAuthLeftTopBannerMessage: function setAuthLeftTopBannerMessage(state, msg) {
        state.authLeftTopBannerMessage = msg;
    },
    setAuthLeftTopBannerUrl: function setAuthLeftTopBannerUrl(state, url) {
        state.authLeftTopBannerUrl = url;
    },
    setUnauthFindMoreUrl: function setUnauthFindMoreUrl(state, url) {
        state.unauthFindMoreUrl = url;
    },
    setShowParticipantFlag: function setShowParticipantFlag(state, url) {
        state.showEventParticipantCount = url;
    },
    setAdvisoryBoard: function setAdvisoryBoard(state, _ref8) {
        var adBoard = _ref8.adBoard;

        state.advisoryBoard = adBoard;
    }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    allConfigurations: null,
    isFreePreviewEnabled: 0,
    showHeaderAlert: false,
    daysLeft: 0,
    enableLiveStreaming: false,
    liveStreamingURL: '',
    totalTrialDays: 0,
    cardExpiryDays: 50,
    pressReleaseData: null,
    messageDuration: 0,
    messageBoard: null,
    CorpLiveStreamingURL: '',
    allArticles: null,
    selectedArticle: null,
    defEventSwitch: 0,
    enableCorporateLiveStreaming: false,
    faqs: null,
    members: null,
    isMaintenance: false,
    giftingText: 'Give the gift of TONE',
    showCustomUnauthBanner: false,
    unauthBannerText: '',
    unauthBannerLink: '',
    turnOffGifting: false,
    paidMembershipService: false,
    profileCharitySection: true,
    authLeftTopBannerMessage: '',
    authLeftTopBannerUrl: '',
    unauthFindMoreUrl: '',
    showEventParticipantCount: false,
    advisoryBoard: null
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    SENDCONTACTUSFORM: function SENDCONTACTUSFORM(_ref, contactForm) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/contact', contactForm).then(function (response) {}, function (err) {
            commit('setError', { error: { show: true, message: 'Message could not be sent' } });
            console.log('err ', err);
        });
    },
    BECOME_EXPERT_REQUEST: function BECOME_EXPERT_REQUEST(_ref2, contactForm) {
        var commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/experts/insertBecomeAnExpert', contactForm).then(function (response) {}, function (err) {
            commit('setError', { error: { show: true, message: 'Request could not be sent' } });
            console.log('err ', err);
        });
    },
    SENDFEEDBACKFORM: function SENDFEEDBACKFORM(_ref3, feedback) {
        var commit = _ref3.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/feedback', feedback).then(function (response) {}, function (err) {
            commit('setError', { error: { show: true, message: 'Message could not be sent' } });
            console.log('err ', err);
        });
    }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(367);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    setContactUsStatus: function setContactUsStatus(state, _ref) {
        var status = _ref.status;

        state.contactUsStatus = !status;
    },
    setError: function setError(state, _ref2) {
        var error = _ref2.error;

        state.error = error;
    }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    contactUsStatus: false,
    error: {
        show: false,
        message: ''
    }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
    GETDYNAMICCONTENTS: function GETDYNAMICCONTENTS(_ref, pageId) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/registration/getPageContents/' + pageId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setAllContents', { coll: data.payload.lstDynamicPageContents });
            } else {
                commit('setAllContents', { coll: null });
            }
        }, function (err) {
            commit('setAllContents', { coll: null });
            console.log('err ', err);
        });
    },
    GET_NEWS_RESOURCES: function GET_NEWS_RESOURCES(_ref2) {
        var commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/home/getAllNewsResource').then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setAllNewsResources', { coll: data.payload });

                var featuredArticles = data.payload.filter(function (x) {
                    return x.resourceType === 1;
                });
                if (featuredArticles && featuredArticles.length > 0) {
                    commit('setFAResources', { coll: featuredArticles });
                } else {
                    commit('setFAResources', { coll: null });
                }

                var setToneArticles = data.payload.filter(function (x) {
                    return x.resourceType === 2;
                });
                if (setToneArticles && setToneArticles.length > 0) {
                    commit('setSTResources', { coll: setToneArticles });
                } else {
                    commit('setSTResources', { coll: null });
                }

                var setAdvertisement = data.payload.filter(function (x) {
                    return x.resourceType === 3;
                });
                if (setAdvertisement && setAdvertisement.length > 0) {
                    commit('setABResources', { coll: setAdvertisement });
                } else {
                    commit('setABResources', { coll: null });
                }
            } else {
                commit('setAllNewsResources', { coll: null });
            }
        }, function (err) {
            commit('setAllContents', { coll: null });
            console.log('err ', err);
        });
    }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getAllSiteContents: function getAllSiteContents(state) {
        return state.allContents;
    },
    getUnauthContents: function getUnauthContents(state) {
        return state.unauthPageContents;
    },
    getAllNewsResources: function getAllNewsResources(state) {
        return state.newsResources;
    },
    getAllFeaturedArticles: function getAllFeaturedArticles(state) {
        return state.faResources;
    },
    getAllSetToneResources: function getAllSetToneResources(state) {
        return state.stResources;
    },
    getAllAdvertisementResources: function getAllAdvertisementResources(state) {
        return state.abResources;
    }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(372);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    setUnauthPageContents: function setUnauthPageContents(state, _ref) {
        var coll = _ref.coll;

        state.unauthPageContents = coll;
    },
    setAllContents: function setAllContents(state, _ref2) {
        var coll = _ref2.coll;

        state.allContents = coll;
    },
    setAllNewsResources: function setAllNewsResources(state, _ref3) {
        var coll = _ref3.coll;

        state.newsResources = coll;
    },
    setFAResources: function setFAResources(state, _ref4) {
        var coll = _ref4.coll;

        state.faResources = coll;
    },
    setSTResources: function setSTResources(state, _ref5) {
        var coll = _ref5.coll;

        state.stResources = coll;
    },
    setABResources: function setABResources(state, _ref6) {
        var coll = _ref6.coll;

        state.abResources = coll;
    }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    allContents: null,
    unauthPageContents: null,
    newsResources: null,
    faResources: null,
    stResources: null,
    abResources: null
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
    GETEVENTLIST: function GETEVENTLIST(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/events').then(function (response) {
            var data = response.data.data;

            commit('setEventList', { eventList: data });

            commit('setMainEvent', { mainEvent: data[0] });

            var allEvents = data.filter(function (event) {
                return event.eventId !== data[0].eventId;
            });

            var talkEvents = allEvents.filter(function (event) {
                return event.type === '2';
            });
            commit('setTalkEvents', { talkEvent: talkEvents });

            var liveEvents = allEvents.filter(function (event) {
                return event.type === '1';
            });
            commit('setLiveEvents', { liveEvent: liveEvents });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETADMINEVENTS: function GETADMINEVENTS(_ref2) {
        var commit = _ref2.commit;

        console.info('called for admin');
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/corporations/getToneAndCorpPrivNonPhysicalEvents').then(function (response) {
            var data = response.data.data;

            commit('setEventList', { eventList: data });
        }, function (err) {
            commit('setEventList', { eventList: null });
            console.log('err ', err);
        });
    },
    GET_UPCOMING_EVENT: function GET_UPCOMING_EVENT(_ref3) {
        var commit = _ref3.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/events').then(function (response) {
            var data = response.data.data;

            if (data && data.length > 0) {
                commit('setUpcomingEvent', { event: data[0] });
            } else {
                commit('setUpcomingEvent', { event: null });
            }
        }, function (err) {
            commit('setUpcomingEvent', { event: null });
            console.log('err ', err);
        });
    },
    GETBANNEREVENT: function GETBANNEREVENT(_ref4, userId) {
        var commit = _ref4.commit;
    },
    GETMONTHEVETNSLIST: function GETMONTHEVETNSLIST(_ref5) {
        var commit = _ref5.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/events/getCurrMonthEvents').then(function (response) {
            var data = response.data.data;

            commit('setMonthEvents', { monEvents: data });
        }, function (err) {
            commit('setMonthEvents', { monEvents: null });
            console.log('err ', err);
        });
    },
    GETDEMOEVENTS: function GETDEMOEVENTS(_ref6) {
        var commit = _ref6.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/events/loadPrivateEventDemo').then(function (response) {
            var data = response.data.data;

            commit('setDemoEvent', { event: data.payload });
        }, function (err) {
            commit('setDemoEvent', { event: null });
            console.log('err ', err);
        });
    },
    GETUSEREVENTS: function GETUSEREVENTS(_ref7, userId) {
        var commit = _ref7.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/events/getByUserId/' + userId).then(function (response) {
            var data = response.data.data;

            commit('setUserEvents', { events: data });
        }, function (err) {
            console.log('ERROR in GETUSEREVENTS ====> err = ', err);
        });
    },
    SEATRESERVATION: function SEATRESERVATION(_ref8, event) {
        var commit = _ref8.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/events/addUserEvents', event).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {}
        }, function (err) {
            console.log('err ', err);
        });
    },
    UPDATERESERVATION: function UPDATERESERVATION(_ref9, event) {
        var commit = _ref9.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/events/updateUserEvents', event).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {}
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETSELECTEDEVENT: function GETSELECTEDEVENT(_ref10, eventId) {
        var commit = _ref10.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/events/getByEventId/' + eventId).then(function (response) {
            var data = response.data.data;

            commit('setSelectedEvent', { event: data });
            console.log('inside action.js -> GETSELECTEDEVENT ===> data ', data);
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETEVENTUSERS: function GETEVENTUSERS(_ref11, eventId) {
        var commit = _ref11.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/events/getAudienceByEventId/' + eventId).then(function (response) {
            var data = response.data.data;

            commit('setEventUsers', { users: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GENERATESIGNATURE: function GENERATESIGNATURE(_ref12, userId) {
        var commit = _ref12.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/events/getChatRollSig/' + userId).then(function (response) {
            var data = response.data.data;

            commit('setUserStatus', { isAnyony: '0' });
            commit('setUserSig', { sig: data });
        }, function (err) {
            console.log('ERROR in GENERATESIGNATURE ====> err ', err);
        });
    },
    GENERATE_UNAUTH_SIGNATURE: function GENERATE_UNAUTH_SIGNATURE(_ref13, status) {
        var commit = _ref13.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/events/getChatRollSigUnauth/' + parseInt(status)).then(function (response) {
            var data = response.data.data;

            if (status === '1') {
                commit('setDemoUserStatus', 1);
            } else {
                commit('setDemoUserStatus', 0);
            }
            commit('setUnAuthUserSig', { sig: data });
        }, function (err) {
            commit('setUnAuthUserSig', { sig: null });
            commit('setDemoUserStatus', null);
            console.log('err ', err);
        });
    },
    LEAVEEVENT: function LEAVEEVENT(_ref14) {
        var commit = _ref14.commit;

        commit('setUserSig', { sig: null });
    },
    SETBANNEREVENT: function SETBANNEREVENT(_ref15, eventId) {
        var commit = _ref15.commit;

        commit('setBannerEvent', eventId);
    },
    GENERATESIGNATUREWITHEVENT: function GENERATESIGNATUREWITHEVENT(_ref16, event) {
        var commit = _ref16.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/events/getChatRollSig', event).then(function (response) {
            var data = response.data.data;

            commit('setUserStatus', { isAnyony: '1' });
            commit('setUserSig', { sig: data });
        }, function (err) {
            console.log('ERROR in GENERATESIGNATUREWITHEVENT ==== > err ', err);
        });
    },
    GETEVENTSARCHIVE: function GETEVENTSARCHIVE(_ref17) {
        var commit = _ref17.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/events/getToneLiveEvents').then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setLiveEventsArchive', { liveArchive: data.payload });
            } else {
                commit('setLiveEventsArchive', { liveArchive: null });
            }
        }, function (err) {
            commit('setLiveEventsArchive', { liveArchive: null });
            console.log('err ', err);
        });
    },
    GETCORPEVENTSARCHIVE: function GETCORPEVENTSARCHIVE(_ref18, coprId) {
        var commit = _ref18.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/events/getCorporationArchiveEvents/' + coprId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                console.log('data returned', data);
                commit('setCorpArchiveEvents', { aEvents: data.payload });
            } else {
                commit('setCorpArchiveEvents', { aEvents: null });
            }
        }, function (err) {
            commit('setCorpArchiveEvents', { aEvents: null });
            console.log('err ', err);
        });
    },
    GETCORPPRIVATEVIDEOS: function GETCORPPRIVATEVIDEOS(_ref19, coprId) {
        var commit = _ref19.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/playlists/getCorpShowHideVideoDetail/' + coprId + '/1').then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCorpPrivateVideos', { videos: data.payload });
            } else {
                commit('setCorpPrivateVideos', { videos: null });
            }
        }, function (err) {
            commit('setCorpPrivateVideos', { videos: null });
            console.log('err ', err);
        });
    },
    GETCORPPLAYLISTS: function GETCORPPLAYLISTS(_ref20, coprId) {
        var commit = _ref20.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/corporations/getCorporationPlaylists/' + coprId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCorpPlaylists', { playlist: data.payload });
            } else {
                commit('setCorpPlaylists', { playlist: null });
            }
        }, function (err) {
            commit('setCorpPlaylists', { playlist: null });
            console.log('err ', err);
        });
    },
    GETEVENTSARCHIVEPLAYLIST: function GETEVENTSARCHIVEPLAYLIST(_ref21) {
        var commit = _ref21.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/playlists/getJWPlaylistByTitle/ARCHIVETESTPLAYLIST/0').then(function (response) {
            var data = response.data.data;

            commit('setArchivePlaylist', { arplaylist: data });
        }, function (err) {
            commit('setArchivePlaylist', { arplaylist: null });
            console.log('err ', err);
        });
    },
    GETEVENTSARCHIVEPLAYLIST_EVENTID: function GETEVENTSARCHIVEPLAYLIST_EVENTID(_ref22, eventId) {
        var commit = _ref22.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/playlists/loadArchiveEventPlaylist/' + eventId).then(function (response) {
            var data = response.data.data;

            commit('setArchivePlaylist', { arplaylist: data });
        }, function (err) {
            commit('setArchivePlaylist', { arplaylist: null });
            console.log('err ', err);
        });
    },
    GET_ARCHIVE_EVENT_PLAYLIST_BY_EVENTID: function GET_ARCHIVE_EVENT_PLAYLIST_BY_EVENTID(_ref23, eventId) {
        var commit = _ref23.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('playlists/loadArchivePlaylistForNewPlayer/' + eventId).then(function (response) {
            var data = response.data.data;

            if (data) {
                commit('setArchivePlaylistObject', { eList: data });
            } else {
                commit('setArchivePlaylistObject', { eList: null });
            }
        }, function (err) {
            commit('setArchivePlaylistObject', { eList: null });
            console.log('err ', err);
        });
    },
    GETCORPEVENTS: function GETCORPEVENTS(_ref24, corporationId) {
        var commit = _ref24.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/corporations/getCorporationEvents/' + corporationId).then(function (response) {
            var data = response.data.data;

            if (data && data.length > 0) {
                commit('setCorpAllEvents', { pEvents: data });

                var privateEvents = data.filter(function (x) {
                    return x.corporationId === corporationId;
                });
                if (privateEvents && privateEvents.length > 0) {
                    var mainEvent = privateEvents[0];
                    commit('setCorpMainEvent', { pEvents: mainEvent });
                    var otherPrivateEvents = privateEvents.filter(function (x) {
                        return x.eventId !== mainEvent.eventId;
                    });
                    if (otherPrivateEvents && otherPrivateEvents.length > 0) {
                        commit('setCorpPrivateEvents', { pEvents: otherPrivateEvents });
                    } else {
                        commit('setCorpPrivateEvents', { pEvents: null });
                    }
                    var allPublicEvents = data.filter(function (x) {
                        return x.corporationId === 0;
                    });
                    if (allPublicEvents && allPublicEvents.length > 0) {
                        commit('setCorpPublicEvents', { pEvents: allPublicEvents });
                    } else {
                        commit('setCorpPublicEvents', { pEvents: null });
                    }
                } else {
                    console.info('inside public section');
                    commit('setCorpPrivateEvents', { pEvents: null });
                    var _mainEvent = data[0];
                    commit('setCorpMainEvent', { pEvents: _mainEvent });
                    var _allPublicEvents = data.filter(function (x) {
                        return x.eventId !== _mainEvent.eventId;
                    });
                    if (_allPublicEvents && _allPublicEvents.length > 0) {
                        commit('setCorpPublicEvents', { pEvents: _allPublicEvents });
                    } else {
                        commit('setCorpPublicEvents', { pEvents: null });
                    }
                }
            }
        }, function (err) {
            console.log('err ', err);
        });
    }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getEventList: function getEventList(state) {
        return state.eventList;
    },
    getMainEvent: function getMainEvent(state) {
        return state.mainEvent;
    },
    getTalkEvents: function getTalkEvents(state) {
        return state.talkEvents;
    },
    getLiveEvents: function getLiveEvents(state) {
        return state.liveEvents;
    },
    getLiveExperts: function getLiveExperts(state) {
        return state.expertsLive;
    },
    getTalkExperts: function getTalkExperts(state) {
        return state.expertsTalk;
    },
    getUserEvents: function getUserEvents(state) {
        return state.userEvents;
    },
    getSelectedEvent: function getSelectedEvent(state) {
        return state.selectedEvent;
    },
    getEventUsers: function getEventUsers(state) {
        return state.eventUsers;
    },
    getUserSignature: function getUserSignature(state) {
        return state.userSig;
    },
    getUnauthUserSignature: function getUnauthUserSignature(state) {
        return state.unAuthUserSig;
    },
    getDemoUserStatus: function getDemoUserStatus(state) {
        return state.demoUserStatus;
    },
    getUserStatus: function getUserStatus(state) {
        return state.isUserAnonymous;
    },
    getBannerEvent: function getBannerEvent(state) {
        return state.bannerEvent;
    },
    getLiveEventsArchive: function getLiveEventsArchive(state) {
        return state.liveEventsArchive;
    },
    getArchivePlaylist: function getArchivePlaylist(state) {
        return state.archivePlaylist;
    },
    getMonthEvents: function getMonthEvents(state) {
        return state.monthEvents;
    },
    getCorpPrivateEvents: function getCorpPrivateEvents(state) {
        return state.corpPrivateEvents;
    },
    getCorpPublicEvents: function getCorpPublicEvents(state) {
        return state.corpPublicEvents;
    },
    getCorpAllEvents: function getCorpAllEvents(state) {
        return state.corpAllEvents;
    },
    getCorpMainEvent: function getCorpMainEvent(state) {
        return state.corpMainEvent;
    },
    getCorpArchiveEvents: function getCorpArchiveEvents(state) {
        return state.corpArchiveEvents;
    },
    getCorpPlaylists: function getCorpPlaylists(state) {
        return state.corpPlaylists;
    },
    getDemoEvent: function getDemoEvent(state) {
        return state.demoEvent;
    },
    getCorpPrivateVideos: function getCorpPrivateVideos(state) {
        return state.corpPrivateVideos;
    },
    getUpcomingEvent: function getUpcomingEvent(state) {
        return state.upcomingEvent;
    }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(377);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    setEventList: function setEventList(state, _ref) {
        var eventList = _ref.eventList;

        state.eventList = eventList;
    },
    setMainEvent: function setMainEvent(state, _ref2) {
        var mainEvent = _ref2.mainEvent;

        state.mainEvent = mainEvent;
    },
    setTalkEvents: function setTalkEvents(state, _ref3) {
        var talkEvent = _ref3.talkEvent;

        state.talkEvents = talkEvent;
    },
    setLiveEvents: function setLiveEvents(state, _ref4) {
        var liveEvent = _ref4.liveEvent;

        state.liveEvents = liveEvent;
    },
    setTalkExperts: function setTalkExperts(state, _ref5) {
        var exp = _ref5.exp;

        state.expertsTalk = exp;
    },
    setLiveExperts: function setLiveExperts(state, _ref6) {
        var exp = _ref6.exp;

        state.expertsLive = exp;
    },
    setUserEvents: function setUserEvents(state, _ref7) {
        var events = _ref7.events;

        state.userEvents = events;
    },
    setSelectedEvent: function setSelectedEvent(state, _ref8) {
        var event = _ref8.event;

        state.selectedEvent = event;
    },
    setCorpPrivateVideos: function setCorpPrivateVideos(state, _ref9) {
        var videos = _ref9.videos;

        state.corpPrivateVideos = videos;
    },
    setEventUsers: function setEventUsers(state, _ref10) {
        var users = _ref10.users;

        state.eventUsers = users;
    },
    setUserSig: function setUserSig(state, _ref11) {
        var sig = _ref11.sig;

        state.userSig = sig;
    },
    setUnAuthUserSig: function setUnAuthUserSig(state, _ref12) {
        var sig = _ref12.sig;

        state.unAuthUserSig = sig;
    },
    setUserStatus: function setUserStatus(state, _ref13) {
        var isAnyony = _ref13.isAnyony;

        state.isUserAnonymous = isAnyony;
    },
    setDemoUserStatus: function setDemoUserStatus(state, isAnyony) {
        state.demoUserStatus = isAnyony;
    },
    setLiveEventsArchive: function setLiveEventsArchive(state, _ref14) {
        var liveArchive = _ref14.liveArchive;

        state.liveEventsArchive = liveArchive;
    },
    setCorpArchiveEvents: function setCorpArchiveEvents(state, _ref15) {
        var aEvents = _ref15.aEvents;

        state.corpArchiveEvents = aEvents;
    },
    setBannerEvent: function setBannerEvent(state, eventId) {
        state.bannerEvent = eventId;
    },
    setArchivePlaylist: function setArchivePlaylist(state, _ref16) {
        var arplaylist = _ref16.arplaylist;

        state.archivePlaylist = arplaylist;
    },
    setMonthEvents: function setMonthEvents(state, _ref17) {
        var monEvents = _ref17.monEvents;

        state.monthEvents = monEvents;
    },
    setCorpMainEvent: function setCorpMainEvent(state, _ref18) {
        var pEvents = _ref18.pEvents;

        state.corpMainEvent = pEvents;
    },
    setCorpAllEvents: function setCorpAllEvents(state, _ref19) {
        var pEvents = _ref19.pEvents;

        state.corpAllEvents = pEvents;
    },
    setCorpPrivateEvents: function setCorpPrivateEvents(state, _ref20) {
        var pEvents = _ref20.pEvents;

        state.corpPrivateEvents = pEvents;
    },
    setCorpPublicEvents: function setCorpPublicEvents(state, _ref21) {
        var pEvents = _ref21.pEvents;

        state.corpPublicEvents = pEvents;
    },
    setCorpPlaylists: function setCorpPlaylists(state, _ref22) {
        var playlist = _ref22.playlist;

        state.corpPlaylists = playlist;
    },
    setDemoEvent: function setDemoEvent(state, _ref23) {
        var event = _ref23.event;

        state.demoEvent = event;
    },
    setUpcomingEvent: function setUpcomingEvent(state, _ref24) {
        var event = _ref24.event;

        state.upcomingEvent = event;
    }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    mainEvent: null,
    eventList: null,
    liveEvents: null,
    talkEvents: null,
    expertsLive: null,
    expertsTalk: null,
    userEvents: null,
    selectedEvent: null,
    eventUsers: null,
    userSig: null,
    unAuthUserSig: null,
    isUserAnonymous: 0,
    bannerEvent: 0,
    liveEventsArchive: null,
    archivePlaylist: null,
    monthEvents: null,
    corpAllEvents: null,
    corpPrivateEvents: null,
    corpPublicEvents: null,
    corpMainEvent: null,
    corpArchiveEvents: null,
    corpPlaylists: null,
    demoEvent: null,
    corpPrivateVideos: null,
    demoUserStatus: null,
    upcomingEvent: null
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    GETALLEXPERTS: function GETALLEXPERTS(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/experts').then(function (response) {
            var data = response.data.data;

            commit('setAllExperts', { experts: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETALLEXPERTS_CORPORATION: function GETALLEXPERTS_CORPORATION(_ref2, corporationId) {
        var commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/experts/getAllExperts/' + corporationId).then(function (response) {
            var data = response.data.data;

            commit('setAllExperts', { experts: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETEXPERT: function GETEXPERT(_ref3, expertId) {
        var commit = _ref3.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/experts/' + expertId).then(function (response) {
            var data = response.data.data;

            commit('setExpert', { expert: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GET_EXPERT_BY_BY_ID: function GET_EXPERT_BY_BY_ID(_ref4, expertId) {
        var commit = _ref4.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/experts/getExpertById/' + expertId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setExpert', { expert: data.payload });
            } else {
                commit('setExpert', { expert: null });
            }
        }, function (err) {
            commit('setExpert', { expert: null });
            console.log('err ', err);
        });
    },
    GET_EXPERT_NEXT_EVENT: function GET_EXPERT_NEXT_EVENT(_ref5, expertId) {
        var commit = _ref5.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/events/getExpertNearestEvent/' + expertId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setExpertNextEvent', { event: data.payload });
            } else {
                commit('setExpertNextEvent', { event: null });
            }
        }, function (err) {
            commit('setExpertNextEvent', { event: null });
            console.log('err ', err);
        });
    },
    GETEXPERTVIDEOS: function GETEXPERTVIDEOS(_ref6, expertId) {
        var commit = _ref6.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/playlists/getExpertVideosById/' + expertId[0] + '/' + expertId[1] + '/10').then(function (response) {
            var data = response.data.data;

            if (data && data.length > 0) {
                commit('setExpertVideos', { expertVideos: data });
                commit('setComingVideoFlag', false);
            } else {
                commit('setComingVideoFlag', true);
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETEXPERTPLAYLIST: function GETEXPERTPLAYLIST(_ref7, expertId) {
        var commit = _ref7.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/playlists/getExpertContentVideosById/' + expertId[0] + '/' + expertId[1]).then(function (response) {
            var data = response.data.data;

            if (data && data.length > 0) {
                commit('setExpertPlaylist', { playList: data });
            } else {}
        }, function (err) {
            console.log('err ', err);
        });
    },
    GET_EXPERT_EVENT_CLIPS: function GET_EXPERT_EVENT_CLIPS(_ref8, expertId) {
        var commit = _ref8.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/events/getToneLiveEventsForExperts/' + expertId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setExpertArchiveClips', { clips: data.payload });
            } else {
                commit('setExpertArchiveClips', { clips: null });
            }
        }, function (err) {
            commit('setExpertArchiveClips', { clips: null });
            console.log('err ', err);
        });
    }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getAllExperts: function getAllExperts(state) {
        return state.experts;
    },
    getExpert: function getExpert(state) {
        return state.expert;
    },
    getExpertVideos: function getExpertVideos(state) {
        return state.expertVideos;
    },
    getVideosFlag: function getVideosFlag(state) {
        return state.videosComingSoonFlag;
    },
    getExpertPlaylist: function getExpertPlaylist(state) {
        return state.expertPlaylist;
    },
    getExpertArchiveClips: function getExpertArchiveClips(state) {
        return state.expertArchiveClips;
    },
    getExpertNextEvent: function getExpertNextEvent(state) {
        return state.expertNextEvent;
    }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(382);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    setAllExperts: function setAllExperts(state, _ref) {
        var experts = _ref.experts;

        state.experts = experts;
    },
    setExpert: function setExpert(state, _ref2) {
        var expert = _ref2.expert;

        state.expert = expert;
    },
    setExpertVideos: function setExpertVideos(state, _ref3) {
        var expertVideos = _ref3.expertVideos;

        state.expertVideos = expertVideos;
    },
    setComingVideoFlag: function setComingVideoFlag(state, videosFlag) {
        state.videosComingSoonFlag = videosFlag;
    },
    setExpertPlaylist: function setExpertPlaylist(state, _ref4) {
        var playList = _ref4.playList;

        state.expertPlaylist = playList;
    },
    setExpertArchiveClips: function setExpertArchiveClips(state, _ref5) {
        var clips = _ref5.clips;

        state.expertArchiveClips = clips;
    },
    setExpertNextEvent: function setExpertNextEvent(state, _ref6) {
        var event = _ref6.event;

        state.expertNextEvent = event;
    }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    experts: null,
    expert: null,
    expertVideos: null,
    videosComingSoonFlag: false,
    expertPlaylist: null,
    expertArchiveClips: null,
    expertNextEvent: null
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errorMessageMapping__ = __webpack_require__(120);





/* harmony default export */ __webpack_exports__["a"] = ({
    ADDGIFTS: function ADDGIFTS(_ref, _ref2) {
        var commit = _ref.commit;
        var gift = _ref2.gift;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('registration/addGifter', gift).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                window.logEvents('Send-Gift Page', 'Gift Sent', 'Gift sent to ' + gift.userGifts.length.toString() + ' email(s)');
            } else {
                commit('setError', { error: { show: true, message: data.message } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    ADDCORPORATEGIFTS: function ADDCORPORATEGIFTS(_ref3, _ref4) {
        var commit = _ref3.commit;
        var gift = _ref4.gift;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('messagereader/addGifteesInQueue', gift).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {} else {
                commit('setError', { error: { show: true, message: data.message } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GETGIFTEE: function GETGIFTEE(_ref5, giftCode) {
        var commit = _ref5.commit;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('registration/getByGifteeId/' + giftCode).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setGiftee', { payload: data.payload });
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: data.message } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GETACCENTUREGIFTEE: function GETACCENTUREGIFTEE(_ref6, giftCode) {
        var commit = _ref6.commit;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('registration/getGifteeByCorpId/' + giftCode + '/1').then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setGiftee', { payload: data.payload });
                commit('setGiftingError', { error: { show: false, message: '' } });
            } else {
                commit('setGiftingError', { error: { show: true, message: 'You have reached the maximum number of accounts registered for this trial offer.' } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GETCORPORATIONGIFTEE: function GETCORPORATIONGIFTEE(_ref7, giftDetails) {
        var commit = _ref7.commit;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('registration/getGifteeByCorpId/' + giftDetails[0] + '/' + giftDetails[1]).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setGiftee', { payload: data.payload });
                commit('setGiftingError', { error: { show: false, message: '' } });
            } else {
                commit('setGiftingError', { error: { show: true, message: 'You have reached the maximum number of accounts registered for this trial offer.' } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GETCORPORATIONPLAN: function GETCORPORATIONPLAN(_ref8, giftDetails) {
        var commit = _ref8.commit;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('registration/getGifteeByCorpId/' + giftDetails[0] + '/' + giftDetails[1]).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCorporateClientPlanId', data.payload.packageId);
                commit('setGiftingError', { error: { show: false, message: '' } });
            } else {}
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    SETGIFTID: function SETGIFTID(_ref9, packageId) {
        var commit = _ref9.commit;

        commit('setSelectedGiftId', { giftId: packageId });
        __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push('/sendgift');
        window.scrollTo(0, 0);
    },
    SAVEGIFTEE: function SAVEGIFTEE(_ref10, _ref11) {
        var commit = _ref10.commit;
        var giftee = _ref11.giftee;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('registration/addGiftee', giftee).then(function (response) {
            var data = response.data.data;

            var userToken = response.headers.authorization;
            if (data && !data.error && data.completed) {
                commit('setUser', { user: data.payload });
                sessionStorage.setItem('loggedUserTemp', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.payload));
                localStorage.setItem('token', userToken);
                commit('setError', { error: { show: false, message: '' } });
                var skptInterests = false;
                var defaultLandingPage = '/mytone';
                if (data.payload.corporation && data.payload.corporation.skipInterestPage.toString() === '1') {
                    skptInterests = true;
                }
                if (data.payload.corporation && data.payload.corporation.landingPage && data.payload.corporation.landingPage.length > 2 && data.payload.corporation.landingPage.indexOf('/') > -1) {
                    defaultLandingPage = data.payload.corporation.landingPage;
                }

                if (skptInterests) {
                    __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push(defaultLandingPage);
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push('/interests');
                }
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_3__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GETCORPORATECLIENTS: function GETCORPORATECLIENTS(_ref12) {
        var commit = _ref12.commit;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/corporations').then(function (response) {
            var data = response.data.data;

            commit('setCorporateClients', { clients: data });
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GETCORPORATECLIENT: function GETCORPORATECLIENT(_ref13, corporationId) {
        var commit = _ref13.commit;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/corporations/findByCorporationId/' + corporationId).then(function (response) {
            var data = response.data.data;

            commit('setCorporateClient', { client: data });
            if (localStorage.getItem('corporateClientObject')) {
                localStorage.removeItem('corporateClientObject');
                localStorage.setItem('corporateClientObject', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
            } else {
                localStorage.setItem('corporateClientObject', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
            }

            var headerColor = '#44bda8';
            var footerColor = '#44bda8';
            var buttonColor = '#44bda8';
            var headingColor = '#44bda8';

            if (data && data.groupDefinitions && data.groupDefinitions.headerColor) {
                headerColor = data.groupDefinitions.headerColor;
            }

            if (data && data.groupDefinitions && data.groupDefinitions.footerColor) {
                footerColor = data.groupDefinitions.footerColor;
            }

            if (data && data.groupDefinitions && data.groupDefinitions.buttonColor) {
                buttonColor = data.groupDefinitions.buttonColor;
            }

            if (data && data.groupDefinitions && data.groupDefinitions.headingColor) {
                headingColor = data.groupDefinitions.headingColor;
            }
            console.log('updated header color', headerColor);
            commit('setCorpHeaderColor', headerColor);
            commit('setCorpFooterColor', footerColor);
            commit('setCorpButtonColor', buttonColor);
            commit('setCorpHeadingColor', headingColor);
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    SWITCH_CORPORATION: function SWITCH_CORPORATION(_ref14, corporationId) {
        var commit = _ref14.commit;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/corporations/findByCorporationId/' + corporationId).then(function (response) {
            var data = response.data.data;

            commit('setSwitchCorporateClient', { client: data });
            if (sessionStorage.getItem('switchClientObject')) {
                sessionStorage.removeItem('switchClientObject');
                sessionStorage.setItem('switchClientObject', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
            } else {
                sessionStorage.setItem('switchClientObject', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
            }

            var headerColor = '#44bda8';
            var footerColor = '#44bda8';
            var buttonColor = '#44bda8';
            var headingColor = '#44bda8';

            if (data && data.groupDefinitions && data.groupDefinitions.headerColor) {
                headerColor = data.groupDefinitions.headerColor;
            }

            if (data && data.groupDefinitions && data.groupDefinitions.footerColor) {
                footerColor = data.groupDefinitions.footerColor;
            }

            if (data && data.groupDefinitions && data.groupDefinitions.buttonColor) {
                buttonColor = data.groupDefinitions.buttonColor;
            }

            if (data && data.groupDefinitions && data.groupDefinitions.headingColor) {
                headingColor = data.groupDefinitions.headingColor;
            }
            commit('setCorpHeaderColor', headerColor);
            commit('setCorpFooterColor', footerColor);
            commit('setCorpButtonColor', buttonColor);
            commit('setCorpHeadingColor', headingColor);
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GETCORPORATECLIENTFORDEMO: function GETCORPORATECLIENTFORDEMO(_ref15, corporationId) {
        var commit = _ref15.commit;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/corporations/findByCorporationId/' + corporationId).then(function (response) {
            var data = response.data.data;

            if (data) {
                commit('setCorporateClientForDemo', { client: data });
            } else {
                commit('setCorporateClientForDemo', { client: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GET_PARENT_CORPORATION: function GET_PARENT_CORPORATION(_ref16, corporationId) {
        var commit = _ref16.commit;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('corporations/findCorporationSiblings/' + corporationId).then(function (response) {
            var data = response.data.data;

            commit('setParentCorporation', { parentCorp: data });
        }, function (err) {
            commit('setParentCorporation', { parentCorp: null });
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GET_CORP_RESTRICTED_REGIONS: function GET_CORP_RESTRICTED_REGIONS(_ref17, corporationId) {
        var commit = _ref17.commit;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('corporations/getCorpRestrictedRegions/' + corporationId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCorpRestrictedRegions', { payload: data.payload });
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setCorpRestrictedRegions', { payload: null });
            }
        }, function (err) {
            commit('setCorpRestrictedRegions', { payload: null });
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GET_CORPORATION_REGIONS: function GET_CORPORATION_REGIONS(_ref18, corporationId) {
        var commit = _ref18.commit;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('corporations/getCorporationRegions/' + corporationId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCorporationRegions', { payload: data.payload });
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setCorporationRegions', { payload: null });
            }
        }, function (err) {
            commit('setCorporationRegions', { payload: null });
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    LOG_SIGNUP_ATTEMPT: function LOG_SIGNUP_ATTEMPT(_ref19, errorPayload) {
        var commit = _ref19.commit;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/logging/writeActivityToQueue', errorPayload).then(function (response) {
            console.log('LOG_SIGNUP_ATTEMPT : error successfully logged: ', errorPayload);
        }, function (err) {
            console.log('LOG_SIGNUP_ATTEMPT : err ', err);
        });
    },
    GETCORPORATECLIENT_GIFT_DETAILS: function GETCORPORATECLIENT_GIFT_DETAILS(_ref20, giftInfo) {
        var commit = _ref20.commit;

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/registration/getGifteeByCorpId/' + giftInfo.giftCode + '/' + giftInfo.corporationId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCorporateGiftInfo', { gift: data.payload });
            } else {
                commit('setCorporateGiftInfo', { gift: null });
            }
        }, function (err) {
            commit('setCorporateGiftInfo', { gift: null });
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getGiftee: function getGiftee(state) {
        return state.giftee;
    },
    getSelectedGiftId: function getSelectedGiftId(state) {
        return state.selectedGiftId;
    },
    getCorporateClients: function getCorporateClients(state) {
        return state.corporateClients;
    },
    getCorporateClientPlanId: function getCorporateClientPlanId(state) {
        return state.corporateClientPlanId;
    },
    getCorporateClientForDemo: function getCorporateClientForDemo(state) {
        return state.corporateClientForDemo;
    },
    getCorporateClient: function getCorporateClient(state) {
        if (state.corporateClient) {
            return state.corporateClient;
        } else if (localStorage.getItem('corporateClientObject')) {
            state.corporateClient = JSON.parse(localStorage.getItem('corporateClientObject'));
            return state.corporateClient;
        } else {
            return null;
        }
    },
    getGiftingError: function getGiftingError(state) {
        return state.giftingError;
    },
    getCorpHeaderColor: function getCorpHeaderColor(state) {
        return state.corpHeaderColor;
    },
    getCorpFooterColor: function getCorpFooterColor(state) {
        return state.corpFooterColor;
    },
    getCorpButtonColor: function getCorpButtonColor(state) {
        return state.corpButtonColor;
    },
    getCorpHeadingColor: function getCorpHeadingColor(state) {
        return state.corpHeadingColor;
    },
    getParentCorporation: function getParentCorporation(state) {
        return state.parentCorporation;
    },
    getCorpRestrictedRegions: function getCorpRestrictedRegions(state) {
        return state.corpRestrictedRegions;
    },
    getCorporationRegions: function getCorporationRegions(state) {
        return state.corporationRegions;
    },
    getSwitchCorporateClient: function getSwitchCorporateClient(state) {
        return state.SwitchCorporateClient;
    },
    getCorporateGiftInfo: function getCorporateGiftInfo(state) {
        if (state.corporateGiftInfo) {
            return state.corporateGiftInfo;
        } else if (localStorage.getItem('corporateGiftInfoObject')) {
            state.corporateGiftInfo = JSON.parse(localStorage.getItem('corporateGiftInfoObject'));
            return state.corporateGiftInfo;
        } else {
            return null;
        }
    }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(387);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
    setGiftee: function setGiftee(state, _ref) {
        var payload = _ref.payload;

        state.giftee = payload;
    },
    setSelectedGiftId: function setSelectedGiftId(state, giftId) {
        state.selectedGiftId = giftId;
    },
    setCorporateClientPlanId: function setCorporateClientPlanId(state, planId) {
        state.corporateClientPlanId = planId;
    },
    setCorporateClients: function setCorporateClients(state, _ref2) {
        var clients = _ref2.clients;

        state.corporateClients = clients;
    },
    setCorporateClient: function setCorporateClient(state, _ref3) {
        var client = _ref3.client;

        state.corporateClient = client;
    },
    setSwitchCorporateClient: function setSwitchCorporateClient(state, _ref4) {
        var client = _ref4.client;

        state.SwitchCorporateClient = client;
    },
    setCorporateClientForDemo: function setCorporateClientForDemo(state, _ref5) {
        var client = _ref5.client;

        state.corporateClientForDemo = client;
    },
    setGiftingError: function setGiftingError(state, _ref6) {
        var error = _ref6.error;

        state.giftingError = error;
    },
    setCorpHeaderColor: function setCorpHeaderColor(state, color) {
        state.corpHeaderColor = color;
    },
    setCorpFooterColor: function setCorpFooterColor(state, color) {
        state.corpFooterColor = color;
    },
    setCorpButtonColor: function setCorpButtonColor(state, color) {
        state.corpButtonColor = color;
    },
    setCorpHeadingColor: function setCorpHeadingColor(state, color) {
        state.corpHeadingColor = color;
    },
    setParentCorporation: function setParentCorporation(state, _ref7) {
        var parentCorp = _ref7.parentCorp;

        state.parentCorporation = parentCorp;
    },
    setCorpRestrictedRegions: function setCorpRestrictedRegions(state, _ref8) {
        var payload = _ref8.payload;

        state.corpRestrictedRegions = payload;
    },
    setCorporationRegions: function setCorporationRegions(state, _ref9) {
        var payload = _ref9.payload;

        state.corporationRegions = payload;
    },
    setCorporateGiftInfo: function setCorporateGiftInfo(state, _ref10) {
        var gift = _ref10.gift;

        if (gift) {
            state.corporateGiftInfo = gift;
            if (localStorage.getItem('corporateGiftInfoObject')) {
                localStorage.removeItem('corporateGiftInfoObject');
                localStorage.setItem('corporateGiftInfoObject', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(gift));
            } else {
                localStorage.setItem('corporateGiftInfoObject', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(gift));
            }
        } else {
            if (localStorage.getItem('corporateGiftInfoObject')) {
                localStorage.removeItem('corporateGiftInfoObject');
            } else {
                localStorage.setItem('corporateGiftInfoObject', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(gift));
            }
            state.corporateGiftInfo = null;
        }
    }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    giftee: '',
    selectedGiftId: 0,
    corporateClients: '',
    corporateClient: '',
    SwitchCorporateClient: null,
    corporateClientForDemo: null,
    corporateClientPlanId: 0,
    corporateGiftInfo: null,
    giftingError: {
        show: false,
        message: '',
        originalMessage: ''
    },
    corpHeaderColor: '#44bda8',
    corpFooterColor: '#44bda8',
    corpButtonColor: '#44bda8',
    corpHeadingColor: '#44bda8',
    parentCorporation: null,
    corpRestrictedRegions: null,
    corporationRegions: null
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    INTEREST: function INTEREST(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('interests').then(function (response) {
            var data = response.data.data;

            if (data.length && !data.error) {
                commit('setInterest', { interests: data });
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETALLINTERESTS: function GETALLINTERESTS(_ref2, corporationId) {
        var commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/interests/' + corporationId).then(function (response) {
            var data = response.data.data;

            commit('interestList', { interests: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETALLEMAILDAYS: function GETALLEMAILDAYS(_ref3, userId) {
        var commit = _ref3.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('user/email-delivery-days/users/' + userId).then(function (response) {
            return response.data.data.payload;
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETUSERINTERESTS: function GETUSERINTERESTS(_ref4, userId) {
        var commit = _ref4.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/interests/getByUserId/' + userId).then(function (response) {
            console.log('response', response);
            var data = response.data.data;

            commit('SetUserInterests', { userInterests: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    UPDATEINTERESTS: function UPDATEINTERESTS(_ref5, _ref6) {
        var commit = _ref5.commit;
        var loggedUser = _ref6.loggedUser;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/profile/updateUserInterests', loggedUser).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {} else {
                commit('setError', { error: { show: true, message: data.message } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    interests: function interests(state) {
        return state.interests;
    },
    getAllInterests: function getAllInterests(state) {
        return state.interestList;
    },
    getUserInterests: function getUserInterests(state) {
        return state.userInterests;
    }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(392);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    setInterest: function setInterest(state, _ref) {
        var interests = _ref.interests;

        state.interests = interests;
    },
    interestList: function interestList(state, _ref2) {
        var interests = _ref2.interests;

        state.interestList = interests;
    },
    SetUserInterests: function SetUserInterests(state, _ref3) {
        var userInterests = _ref3.userInterests;

        state.userInterests = userInterests;
    }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    interests: null,
    interestList: null,
    userInterests: null,
    error: {
        show: false,
        message: ''
    }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    GETPLANS: function GETPLANS(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/plans').then(function (response) {
            var data = response.data.data;

            commit('planList', { plans: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETPLAN: function GETPLAN(_ref2, reqPlan) {
        var commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/plans/getDefaultPlan/' + reqPlan).then(function (response) {
            var data = response.data.data;

            commit('SetDefaultPlan', { defaultPlan: data });
        }, function (err) {
            console.log('err ', err);
        });
    }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getAllPlans: function getAllPlans(state) {
        return state.plans;
    },
    getDefaultPlan: function getDefaultPlan(state) {
        return state.defaultPlan;
    }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(397);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    planList: function planList(state, _ref) {
        var plans = _ref.plans;

        state.plans = plans;
    },
    SetDefaultPlan: function SetDefaultPlan(state, _ref2) {
        var defaultPlan = _ref2.defaultPlan;

        state.defaultPlan = defaultPlan;
    }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    plans: null,
    defaultPlan: null,
    error: {
        show: false,
        message: ''
    }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    GETSEARCHRESULTS: function GETSEARCHRESULTS(_ref, query) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/search/searchVideoContent/' + query[0] + '/null/200/' + query[1]).then(function (response) {
            var data = response.data.data;

            commit('setSearchResults', { results: data.videos });
            commit('setSearchExpertResults', { results: data.events });
            commit('setSearchPlaylistResults', { results: data.playlists });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETSEARCHRESULTS_POST: function GETSEARCHRESULTS_POST(_ref2, query) {
        var commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/search/searchVideoContent', query).then(function (response) {
            var data = response.data.data;

            commit('setSearchResults', { results: data.videos });
            commit('setSearchExpertResults', { results: data.events });
            commit('setSearchPlaylistResults', { results: data.playlists });
        }, function (err) {
            console.log('err ', err);
        });
    },
    SORTDATA: function SORTDATA(_ref3, query) {
        var commit = _ref3.commit;

        console.log(query);
        var searchObject = query;
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/search/searchVideoContent', searchObject).then(function (response) {
            console.log(response);
            var data = response.data.data;

            commit('setSearchExpertResults', { results: data.events });
            commit('setSearchPlaylistResults', { results: data.playlists });
            commit('setSearchResults', { results: data.videos });
        });
    }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getSearchResults: function getSearchResults(state) {
        console.log('====================================================================================================');
        console.log('getSearchResults', state);
        console.log('====================================================================================================');
        return state.searchResults;
    },
    getSearchExpertResults: function getSearchExpertResults(state) {
        console.log('====================================================================================================');
        console.log('getSearchExpertResults', state);
        console.log('====================================================================================================');
        return state.searchResults1;
    },
    getSearchPlaylistResults: function getSearchPlaylistResults(state) {
        console.log('====================================================================================================');
        console.log('getSearchPlaylistResults', state);
        console.log('====================================================================================================');
        return state.searchResults2;
    }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(402);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    setSearchExpertResults: function setSearchExpertResults(state, _ref) {
        var results = _ref.results;

        console.log('------------------------Entered setSearchExpertResults------------------------');
        console.log('setSearchExpertResults', state, results);
        state.searchResults1 = results;
        console.log(state);
    },
    setSearchResults: function setSearchResults(state, _ref2) {
        var results = _ref2.results;

        console.log('-------------------Entered setSearchResults------------------------');
        console.log('setSearchReults', state, results);
        state.searchResults = results;
        console.log(state);
    },
    setSearchPlaylistResults: function setSearchPlaylistResults(state, _ref3) {
        var results = _ref3.results;

        console.log('------------------------setSearchPlaylistResults------------------------', state, results);
        state.searchResults2 = results;
        console.log(state);
    }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    searchResults: null,
    searchResults1: null,
    searchResults2: null
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    GETUNAUTHVIDEOS: function GETUNAUTHVIDEOS(_ref, csvTags) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/playlists/listJWPVideosForGivenTags/' + csvTags).then(function (response) {
            var data = response.data.data;

            commit('setAllUnauthVideos', { videos: data });

            var workVideo = 'work';
            workVideo = data.filter(function (workVideo) {
                return workVideo.tags.indexOf('work-promo') > -1;
            });
            commit('setWorkVideo', { videoObject: workVideo.slice(0, 24) });

            var mindbodyVideo = 'mindbody';
            mindbodyVideo = data.filter(function (mindbodyVideo) {
                return mindbodyVideo.tags.indexOf('mindbody-promo') > -1;
            });
            commit('setMindbodyVideo', { videoObject: mindbodyVideo.slice(0, 24) });

            var communityVideo = 'community';
            communityVideo = data.filter(function (communityVideo) {
                return communityVideo.tags === 'community';
            });
            commit('setCommunityVideo', { videoObject: communityVideo.slice(0, 3) });

            var lifeVideo = 'life';
            lifeVideo = data.filter(function (lifeVideo) {
                return lifeVideo.tags.indexOf('life-promo') > -1;
            });
            commit('setLifeVideo', { videoObject: lifeVideo.slice(0, 24) });

            var moneyVideo = 'money';
            moneyVideo = data.filter(function (moneyVideo) {
                return moneyVideo.tags.indexOf('money-promo') > -1;
            });
            commit('setMoneyVideo', { videoObject: moneyVideo.slice(0, 24) });

            var mainVideo = 'main';
            mainVideo = data.filter(function (mainVideo) {
                return mainVideo.tags === 'main';
            });
            commit('setMainVideo', { videoObject: mainVideo[0] });

            var aboutusVideo = 'aboutus';
            aboutusVideo = data.filter(function (aboutvid) {
                return aboutvid.tags === 'aboutus';
            });
            commit('setAboutUsVideo', { videoObject: aboutusVideo[0] });

            var liveEventVideo = data.filter(function (eventVideo) {
                return eventVideo.tags === 'live-event';
            });
            commit('setLiveEventVideo', { videoObject: liveEventVideo[0] });

            var learnWork = 'learn-work';
            learnWork = data.filter(function (learnWork) {
                return learnWork.tags === 'learn-work';
            });
            commit('setWorkLearnMoreVideo', { videoObject: learnWork[0] });

            var learnLife = 'learn-life';
            learnLife = data.filter(function (learnLife) {
                return learnLife.tags === 'learn-life';
            });
            commit('setLifeLearnMoreVideo', { videoObject: learnLife[0] });

            var learnMindbody = 'learn-mindbody';
            learnMindbody = data.filter(function (learnMindbody) {
                return learnMindbody.tags === 'learn-mindbody';
            });
            commit('setMindbodyLearnMoreVideo', { videoObject: learnMindbody[0] });

            var learnMoney = 'learn-money';
            learnMoney = data.filter(function (learnMoney) {
                return learnMoney.tags === 'learn-money';
            });
            commit('setMoneyLearnMoreVideo', { videoObject: learnMoney[0] });

            var learnCommunity = 'learn-community';
            learnCommunity = data.filter(function (learnCommunity) {
                return learnCommunity.tags === 'learn-community';
            });
            commit('setCommunityLearnMoreVideo', { videoObject: learnCommunity[0] });
        }, function (err) {
            console.log('err ', err);
        });
    },
    TRIGGERLOGINPOPUP: function TRIGGERLOGINPOPUP(_ref2, loginStatus) {
        var commit = _ref2.commit;

        commit('setTriggerLogin', { loginStatus: loginStatus });
    },
    GETTESTIMONIALS: function GETTESTIMONIALS(_ref3, page) {
        var commit = _ref3.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/user/getTestimonialsData/' + page).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setAllTestimonials', { testimonials: data.payload });
            } else {
                commit('setAllTestimonials', { testimonials: null });
            }
        });
    },
    GETCOMPANYLOGOS: function GETCOMPANYLOGOS(_ref4, page) {
        var commit = _ref4.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/common/getAllHomePageLogo/' + page).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCompanyLogos', { logos: data.payload });
            } else {
                commit('setCompanyLogos', { logos: null });
            }
        });
    },
    GET_CORP_BY_GIFTCODE: function GET_CORP_BY_GIFTCODE(_ref5, giftCode) {
        var commit = _ref5.commit;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/corporations/findByGiftCode/' + giftCode).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCorpReference', { corp: data.payload });
            } else {
                commit('setCorpReference', { corp: null });
            }
        });
    }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getWorkVideo: function getWorkVideo(state) {
        return state.workVideo;
    },
    getLifeVideos: function getLifeVideos(state) {
        return state.lifeVideo;
    },
    getMindbodyVideo: function getMindbodyVideo(state) {
        return state.mindbodyVideo;
    },
    getCommunityVideo: function getCommunityVideo(state) {
        return state.communityVideo;
    },
    getMoneyVideo: function getMoneyVideo(state) {
        return state.moneyVideo;
    },
    getMainVideo: function getMainVideo(state) {
        return state.mainVideo;
    },
    getAboutUsVideo: function getAboutUsVideo(state) {
        return state.aboutusVideo;
    },
    getWorkLearnMoreVideo: function getWorkLearnMoreVideo(state) {
        return state.workLearnMore;
    },
    getLifeLearnMoreVideo: function getLifeLearnMoreVideo(state) {
        return state.lifeLearnMore;
    },
    getMoneyLearnMoreVideo: function getMoneyLearnMoreVideo(state) {
        return state.moneyLearnMore;
    },
    getMindbodyLearnMoreVideo: function getMindbodyLearnMoreVideo(state) {
        return state.mindbodyLearnMore;
    },
    getCommunityLearnMoreVideo: function getCommunityLearnMoreVideo(state) {
        return state.communityLearnMore;
    },
    getAllUnauthVideos: function getAllUnauthVideos(state) {
        return state.allUnauthVideos;
    },
    getCorpReference: function getCorpReference(state) {
        return state.corpReference;
    },
    getLiveEventVideo: function getLiveEventVideo(state) {
        return state.liveEventVideo;
    },
    getAllTestimonials: function getAllTestimonials(state) {
        return state.allTestimonials;
    },
    getMarketingPlan: function getMarketingPlan(state) {
        if (sessionStorage.getItem('marketingPlan')) {
            state.marketingPlanId = sessionStorage.getItem('marketingPlan');
            return state.marketingPlanId;
        } else {
            return null;
        }
    },
    getCorporateGiftingCode: function getCorporateGiftingCode(state) {
        if (state.corporateGiftingCode) {
            return state.corporateGiftingCode;
        } else {
            if (localStorage.getItem('corporateGiftingCode')) {
                state.corporateGiftingCode = localStorage.getItem('corporateGiftingCode');
                return state.corporateGiftingCode;
            } else {
                return null;
            }
        }
    },
    getCorporateClientId: function getCorporateClientId(state) {
        if (state.corporateClientId) {
            return state.corporateClientId;
        } else {
            if (localStorage.getItem('corporateClientId')) {
                state.corporateClientId = localStorage.getItem('corporateClientId');
                return state.corporateClientId;
            } else {
                return null;
            }
        }
    },
    getLoginTriggerStatus: function getLoginTriggerStatus(state) {
        return state.triggerLogin;
    },
    getCompanyLogos: function getCompanyLogos(state) {
        return state.companyLogos;
    }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(407);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    setWorkVideo: function setWorkVideo(state, _ref) {
        var videoObject = _ref.videoObject;

        state.workVideo = videoObject;
    },
    setLifeVideo: function setLifeVideo(state, _ref2) {
        var videoObject = _ref2.videoObject;

        state.lifeVideo = videoObject;
    },
    setMoneyVideo: function setMoneyVideo(state, _ref3) {
        var videoObject = _ref3.videoObject;

        state.moneyVideo = videoObject;
    },
    setMindbodyVideo: function setMindbodyVideo(state, _ref4) {
        var videoObject = _ref4.videoObject;

        state.mindbodyVideo = videoObject;
    },
    setCommunityVideo: function setCommunityVideo(state, _ref5) {
        var videoObject = _ref5.videoObject;

        state.communityVideo = videoObject;
    },
    setWorkLearnMoreVideo: function setWorkLearnMoreVideo(state, _ref6) {
        var videoObject = _ref6.videoObject;

        state.workLearnMore = videoObject;
    },
    setLifeLearnMoreVideo: function setLifeLearnMoreVideo(state, _ref7) {
        var videoObject = _ref7.videoObject;

        state.lifeLearnMore = videoObject;
    },
    setMindbodyLearnMoreVideo: function setMindbodyLearnMoreVideo(state, _ref8) {
        var videoObject = _ref8.videoObject;

        state.mindbodyLearnMore = videoObject;
    },
    setMoneyLearnMoreVideo: function setMoneyLearnMoreVideo(state, _ref9) {
        var videoObject = _ref9.videoObject;

        state.moneyLearnMore = videoObject;
    },
    setCommunityLearnMoreVideo: function setCommunityLearnMoreVideo(state, _ref10) {
        var videoObject = _ref10.videoObject;

        state.communityLearnMore = videoObject;
    },
    setMainVideo: function setMainVideo(state, _ref11) {
        var videoObject = _ref11.videoObject;

        state.mainVideo = videoObject;
    },
    setAboutUsVideo: function setAboutUsVideo(state, _ref12) {
        var videoObject = _ref12.videoObject;

        state.aboutusVideo = videoObject;
    },
    setLiveEventVideo: function setLiveEventVideo(state, _ref13) {
        var videoObject = _ref13.videoObject;

        state.liveEventVideo = videoObject;
    },
    setTriggerLogin: function setTriggerLogin(state, loginStatus) {
        state.triggerLogin = loginStatus;
    },
    setAllUnauthVideos: function setAllUnauthVideos(state, _ref14) {
        var videos = _ref14.videos;

        state.allUnauthVideos = videos;
    },
    setAllTestimonials: function setAllTestimonials(state, _ref15) {
        var testimonials = _ref15.testimonials;

        state.allTestimonials = testimonials;
    },
    setCorpReference: function setCorpReference(state, _ref16) {
        var corp = _ref16.corp;

        state.corpReference = corp;
    },
    setMarketingPlan: function setMarketingPlan(state, _ref17) {
        var planId = _ref17.planId;

        if (planId) {
            state.marketingPlanId = planId;
            sessionStorage.setItem('marketingPlan', planId);
        } else {
            state.marketingPlanId = null;
        }
    },
    setCorporateGiftingCode: function setCorporateGiftingCode(state, _ref18) {
        var giftCode = _ref18.giftCode;

        if (giftCode) {
            state.corporateGiftingCode = giftCode;
            localStorage.setItem('corporateGiftingCode', giftCode);
        } else {
            state.corporateGiftingCode = null;
            if (localStorage.getItem('corporateGiftingCode')) {
                localStorage.removeItem('corporateGiftingCode');
            }
        }
    },
    setCorporateClientId: function setCorporateClientId(state, _ref19) {
        var corporateClientId = _ref19.corporateClientId;

        if (corporateClientId) {
            state.corporateClientId = corporateClientId;
            localStorage.setItem('corporateClientId', corporateClientId);
        } else {
            state.corporateClientId = null;
            if (localStorage.getItem('corporateClientId')) {
                localStorage.removeItem('corporateClientId');
            }
        }
    },
    setCompanyLogos: function setCompanyLogos(state, _ref20) {
        var logos = _ref20.logos;

        state.companyLogos = logos;
    }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    workVideo: null,
    moneyVideo: null,
    lifeVideo: null,
    mindbodyVideo: null,
    inspirationVideo: null,
    communityVideo: null,
    mainVideo: null,
    aboutusVideo: null,
    marketingPlanId: null,
    workLearnMore: null,
    moneyLearnMore: null,
    lifeLearnMore: null,
    communityLearnMore: null,
    mindbodyLearnMore: null,
    liveEventVideo: null,
    triggerLogin: false,
    corporateGiftingCode: '',
    corporateClientId: 0,
    allUnauthVideos: null,
    allTestimonials: null,
    companyLogos: null,
    corpReference: null
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__ = __webpack_require__(15);








/* harmony default export */ __webpack_exports__["a"] = ({
    LOGIN: function LOGIN(_ref, _ref2) {
        var commit = _ref.commit;
        var user = _ref2.user;

        user.email = user.email.toLowerCase();
        commit('setError', { error: { show: false, message: '' } });
        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('login/authenticate', user).then(function (response) {
            var data = response.data.data;

            var userToken = response.headers.authorization;
            if (data && !data.error && data.completed) {
                localStorage.setItem('token', userToken);
                localStorage.setItem('loggedUser', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.payload));
                commit('setUser', { user: data.payload });

                var userPayloadSignIn = {};
                userPayloadSignIn.userId = data.payload.userId;
                userPayloadSignIn.action = 'LOGIN';
                userPayloadSignIn.activityCode = null;
                userPayloadSignIn.activityMessage = 'AUTHORIZED';
                userPayloadSignIn.severityLevel = 'INFORMATION';
                userPayloadSignIn.status = null;
                userPayloadSignIn.timeZone = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].getUserTimeZone();
                userPayloadSignIn.pageName = null;
                userPayloadSignIn.os = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.family;
                userPayloadSignIn.osVersion = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.version;
                userPayloadSignIn.browserName = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().name;
                userPayloadSignIn.browserVersion = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().version;
                userPayloadSignIn.device = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().product;
                userPayloadSignIn.deviceType = null;

                userPayloadSignIn.userAgent = navigator.userAgent;
                if (navigator.userAgent.indexOf('gonative') > -1) {
                    userPayloadSignIn.deviceType = 'IOS APP';
                }if (navigator.userAgent.indexOf('gonativeand') > -1) {
                    userPayloadSignIn.deviceType = 'ANDROID APP';
                }
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/logging/writeActivityToQueue', userPayloadSignIn).then(function (response) {
                    console.log('successfully logged-IE: ', response);
                    if (sessionStorage.getItem('redirectPath')) {
                        setTimeout(function () {
                            var redirection = sessionStorage.getItem('redirectPath');
                            if (redirection.toString().toLowerCase().indexOf('playlistshare') > -1) {
                                __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push(sessionStorage.getItem('redirectPath'));
                                sessionStorage.removeItem('redirectPath');
                                window.location.reload();
                            } else {
                                __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push(sessionStorage.getItem('redirectPath'));
                                sessionStorage.removeItem('redirectPath');
                                window.location.reload();
                            }
                        }, 200);
                    } else {
                        commit('setError', { error: { show: false, message: '' } });
                        if (data.payload && data.payload.corporation && data.payload.corporation.landingPage && data.payload.corporation.landingPage.length > 2 && data.payload.corporation.landingPage.indexOf('/') > -1) {
                            __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push(data.payload.corporation.landingPage);
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('/mytone');
                        }
                        window.location.reload();
                    }
                }, function (err) {
                    console.log('err in logging ', err);
                    if (sessionStorage.getItem('redirectPath')) {
                        setTimeout(function () {
                            var redirection = sessionStorage.getItem('redirectPath');
                            if (redirection.toString().toLowerCase().indexOf('playlistshare') > -1) {
                                __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push(sessionStorage.getItem('redirectPath'));
                                sessionStorage.removeItem('redirectPath');
                                window.location.reload();
                            } else {
                                __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push(sessionStorage.getItem('redirectPath'));
                                sessionStorage.removeItem('redirectPath');
                                window.location.reload();
                            }
                        }, 200);
                    } else {
                        commit('setError', { error: { show: false, message: '' } });
                        if (data.payload && data.payload.corporation && data.payload.corporation.landingPage && data.payload.corporation.landingPage.length > 2 && data.payload.corporation.landingPage.indexOf('/') > -1) {
                            __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push(data.payload.corporation.landingPage);
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('/mytone');
                        }
                    }
                });
            } else {
                console.log('error returned', data);
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message), originalMessage: data.message } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    VERIFYUSEREXISTS: function VERIFYUSEREXISTS(_ref3, _ref4) {
        var commit = _ref3.commit;
        var email = _ref4.email;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/registration/getExistingUser/' + email).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    UPDATEUSERPAYLOAD: function UPDATEUSERPAYLOAD(_ref5, userId) {
        var commit = _ref5.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/profile/getUserPaymentInfo/' + userId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                localStorage.setItem('loggedUser', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.payload));
                if (sessionStorage.getItem('loggedUserTemp')) {
                    sessionStorage.removeItem('loggedUserTemp');
                }
                if (data.payload.corporation && sessionStorage.getItem('switchClientObject')) {
                    var switchedCorp = sessionStorage.getItem('switchClientObject');
                    switchedCorp = JSON.parse(switchedCorp);
                    data.payload.corporation = switchedCorp;
                    var headerColor = '#44bda8';
                    var footerColor = '#44bda8';
                    var buttonColor = '#44bda8';
                    var headingColor = '#44bda8';
                    if (data.payload.corporation.groupDefinitions && data.payload.corporation.groupDefinitions.headerColor) {
                        headerColor = data.payload.corporation.groupDefinitions.headerColor;
                    }
                    if (data.payload.corporation.groupDefinitions && data.payload.corporation.groupDefinitions.footerColor) {
                        footerColor = data.payload.corporation.groupDefinitions.footerColor;
                    }
                    if (data.payload.corporation.groupDefinitions && data.payload.corporation.groupDefinitions.buttonColor) {
                        buttonColor = data.payload.corporation.groupDefinitions.buttonColor;
                    }
                    if (data.payload.corporation.groupDefinitions && data.payload.corporation.groupDefinitions.headingColor) {
                        headingColor = data.payload.corporation.groupDefinitions.headingColor;
                    }
                    commit('setCorpHeaderColor', headerColor);
                    commit('setCorpFooterColor', footerColor);
                    commit('setCorpButtonColor', buttonColor);
                    commit('setCorpHeadingColor', headingColor);
                    commit('setUser', { user: data.payload });
                } else {
                    commit('setUser', { user: data.payload });
                }
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    VERIFYUSERSTATUS: function VERIFYUSERSTATUS(_ref6, email) {
        var commit = _ref6.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put('/registration/validateUserEmailStatus/' + email).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setValidationStatusError', true);
            } else {
                commit('setValidationStatusError', false);
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    VALIDATE: function VALIDATE(_ref7, _ref8) {
        var commit = _ref7.commit;
        var user = _ref8.user;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put('/registration/validateUserEmail/' + user.email + '/' + user.validationCode).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    FORGOTPASSWORD: function FORGOTPASSWORD(_ref9, _ref10) {
        var commit = _ref9.commit;
        var user = _ref10.user;

        commit('setError', { error: { show: false, message: '' } });
        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/login/forget-password/' + user.email.toLowerCase()).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    CONFIRMPASSWORD: function CONFIRMPASSWORD(_ref11, _ref12) {
        var commit = _ref11.commit;
        var user = _ref12.user;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/login/confirm-forget-password', user).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });
                __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('/');
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    UPDATE_USER_PREFERENCES: function UPDATE_USER_PREFERENCES(_ref13, _ref14) {
        var commit = _ref13.commit;
        var user = _ref14.user;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/registration/updateTeaserTakeAwayOptOutFlag', user).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    UPDATEPROFILEPASSWORD: function UPDATEPROFILEPASSWORD(_ref15, _ref16) {
        var commit = _ref15.commit;
        var passwords = _ref16.passwords;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/login/reset-password', passwords).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    EMAILSHAREPLAYLIST: function EMAILSHAREPLAYLIST(_ref17, _ref18) {
        var commit = _ref17.commit;
        var payload = _ref18.payload;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/playlists/sharePlaylist', payload).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    EMAILSHAREVIDEO: function EMAILSHAREVIDEO(_ref19, _ref20) {
        var commit = _ref19.commit;
        var payload = _ref20.payload;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/playlists/shareVideoByUser', payload).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    ARCHIVE_PLAYLIST_SHARE: function ARCHIVE_PLAYLIST_SHARE(_ref21, _ref22) {
        var commit = _ref21.commit;
        var payload = _ref22.payload;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/playlists/shareArchivePlaylist', payload).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    VIDEOCORPORATESHARE: function VIDEOCORPORATESHARE(_ref23, _ref24) {
        var commit = _ref23.commit;
        var payload = _ref24.payload;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/corporations/sendVideoSharingLetter', payload).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    PLAYLISTCORPORATESHARE: function PLAYLISTCORPORATESHARE(_ref25, _ref26) {
        var commit = _ref25.commit;
        var payload = _ref26.payload;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/playlists/sharePlaylistForCorp', payload).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    CORP_EVENT_SHARE: function CORP_EVENT_SHARE(_ref27, _ref28) {
        var commit = _ref27.commit;
        var payload = _ref28.payload;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/playlists/shareEvent', payload).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    UPDATEPROFILEEMAIL: function UPDATEPROFILEEMAIL(_ref29, _ref30) {
        var commit = _ref29.commit;
        var payload = _ref30.payload;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/registration/changeUserEmail', payload).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    USERINFO: function USERINFO(_ref31, _ref32) {
        var commit = _ref31.commit;
        var userInfo = _ref32.userInfo;

        commit('setUser', { user: userInfo });
        __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('/topic');
    },
    SIGNUP: function SIGNUP(_ref33, _ref34) {
        var commit = _ref33.commit;
        var user = _ref34.user;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('registration/add-user', user).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed && data.message !== 'tone.user.AlreadyExists') {
                commit('setUser', { user: data.payload });
                sessionStorage.setItem('loggedUserTemp', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.payload));
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    SIGNUPWITHPAYMENTPLAN: function SIGNUPWITHPAYMENTPLAN(_ref35, _ref36) {
        var commit = _ref35.commit;
        var user = _ref36.user;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('registration/addNewUser', user, { headers: { 'tone-user': user.email } }).then(function (response) {
            var data = response.data.data;

            var userToken = response.headers.authorization;
            if (data && !data.error && data.completed) {
                commit('setUser', { user: data.payload });
                sessionStorage.setItem('loggedUserTemp', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.payload));
                localStorage.setItem('token', userToken);
                commit('setError', { error: { show: false, message: '' } });
                __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('/interests');
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    CHANGEFREEPREVIEWTOREGULAR: function CHANGEFREEPREVIEWTOREGULAR(_ref37, _ref38) {
        var commit = _ref37.commit;
        var user = _ref38.user;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('registration/changeFreePrevToRegular', user, { headers: { 'tone-user': user.email } }).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setUser', { user: data.payload });
                var loggedUser = localStorage.getItem('loggedUser');
                var loggedUserTemp = sessionStorage.getItem('loggedUserTemp');
                if (loggedUser) {
                    localStorage.setItem('loggedUser', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.payload));
                }
                if (loggedUserTemp) {
                    sessionStorage.setItem('loggedUserTemp', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.payload));
                }
                commit('setHeaderAlertStatus', false);
                commit('setTrialDays', 10000000);
                commit('setError', { error: { show: false, message: '' } });
                __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('/mytone');
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    CHANGE_FREEP_REVIEW_TO_REGULAR_NOVO: function CHANGE_FREEP_REVIEW_TO_REGULAR_NOVO(_ref39, _ref40) {
        var commit = _ref39.commit;
        var user = _ref40.user;

        console.log('user to update', user);
        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('corporations/oneTimeNordiskCharge', user, { headers: { 'tone-user': user.email } }).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                console.log('returned profile after update', data.payload);
                commit('setUser', { user: data.payload });
                var loggedUser = localStorage.getItem('loggedUser');
                var loggedUserTemp = sessionStorage.getItem('loggedUserTemp');
                if (loggedUser) {
                    localStorage.setItem('loggedUser', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.payload));
                }
                if (loggedUserTemp) {
                    sessionStorage.setItem('loggedUserTemp', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.payload));
                }
                commit('setHeaderAlertStatus', false);
                commit('setTrialDays', 10000000);
                commit('setError', { error: { show: false, message: '' } });
                __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('/mytone');
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    PROCESSCORPORATEPAYMENT: function PROCESSCORPORATEPAYMENT(_ref41, _ref42) {
        var commit = _ref41.commit;
        var user = _ref42.user;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('corporations/processCorporationSales', user).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {} else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    SAVEUSERWITHFREETIRAL: function SAVEUSERWITHFREETIRAL(_ref43, _ref44) {
        var commit = _ref43.commit;
        var newUser = _ref44.newUser;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('freepreview/addNewUserFreePreview', newUser, { headers: { 'tone-user': newUser.email } }).then(function (response) {
            var data = response.data.data;

            var userToken = response.headers.authorization;
            if (data && !data.error && data.completed) {
                commit('setUser', { user: data.payload });
                sessionStorage.setItem('loggedUserTemp', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.payload));
                localStorage.setItem('token', userToken);
                commit('setError', { error: { show: false, message: '' } });
                __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('/interests');
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    UPDATECREDITCARD: function UPDATECREDITCARD(_ref45, user) {
        var commit = _ref45.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/profile/addCard', user).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setUser', { user: data.payload });
                localStorage.setItem('loggedUser', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.payload));
                commit('setCardExpiryDays', 100);
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    SUBSCRIBE: function SUBSCRIBE(_ref46, _ref47) {
        var commit = _ref46.commit;
        var userPaymentInfo = _ref47.userPaymentInfo;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/registration/add-plan', userPaymentInfo[0], { headers: { 'tone-user': userPaymentInfo[0].email } }).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/registration/add-payment/' + userPaymentInfo[0].userPayments[0].token + '/' + userPaymentInfo[0].userPayments[0].stripeCardId + '/' + userPaymentInfo[1], userPaymentInfo[0], { headers: { 'tone-user': userPaymentInfo[0].email } }).then(function (response) {
                    var data = response.data.data;

                    if (data && !data.error && data.completed) {
                        commit('setError', { error: { show: false, message: '' } });
                        __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('/interests');
                    } else {
                        commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
                    }
                });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    SETINTERESTS: function SETINTERESTS(_ref48, _ref49) {
        var commit = _ref48.commit;
        var interests = _ref49.interests;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/interests', interests).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                if (sessionStorage.getItem('redirectPath')) {
                    __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push(sessionStorage.getItem('redirectPath'));
                    sessionStorage.removeItem('redirectPath');
                } else {
                    var loggedUser = localStorage.getItem('loggedUser');
                    var loggedUserTemp = sessionStorage.getItem('loggedUserTemp');
                    var defaultLandingPage = '/mytone';
                    if (loggedUserTemp) {
                        if (loggedUserTemp.corporation && loggedUserTemp.corporation.landingPage.length > 2 && loggedUserTemp.corporation.landingPage.indexOf('/') > -1) {
                            defaultLandingPage = loggedUserTemp.corporation.landingPage;
                            __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push(defaultLandingPage);
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push(defaultLandingPage);
                        }
                    }
                    if (loggedUser) {
                        if (loggedUser.corporation && loggedUser.corporation.landingPage.length > 2 && loggedUser.corporation.landingPage.indexOf('/') > -1) {
                            defaultLandingPage = loggedUser.corporation.landingPage;
                            __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push(defaultLandingPage);
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push(defaultLandingPage);
                        }
                    }
                }
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    SETDAYS: function SETDAYS(_ref50, _ref51) {
        var commit = _ref50.commit;
        var data = _ref51.data;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('user/email-delivery-days/users/' + data.userId, data.days).then(function (response) {
            console.log(response);
        });
    },
    UPDATEUSERPROFILE: function UPDATEUSERPROFILE(_ref52, userProfile) {
        var commit = _ref52.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put('/profile', userProfile).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                var loggedUserTemp = sessionStorage.getItem('loggedUserTemp');
                if (loggedUserTemp) {
                    sessionStorage.removeItem('loggedUserTemp');
                    sessionStorage.setItem('loggedUserTemp', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(userProfile));
                    commit('setUser', { user: data.payload });
                } else {
                    localStorage.removeItem('loggedUser');
                    localStorage.setItem('loggedUser', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(userProfile));
                    commit('setUser', { user: data.payload });
                }
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    UPDATEUSERSTATE: function UPDATEUSERSTATE(_ref53) {
        var commit = _ref53.commit;

        var loggedUser = localStorage.getItem('loggedUser');
        if (loggedUser) {
            this.$store.commit('setUser', { user: loggedUser });
        }
    },
    LOGUSERACTIVITY: function LOGUSERACTIVITY(_ref54, userRef) {
        var commit = _ref54.commit;

        var userId = userRef[0] ? userRef[0] : 0;
        var userPayload = {};
        userPayload.userId = userId;
        userPayload.action = 'USER_NAVIGATION';
        userPayload.activityCode = null;
        userPayload.activityMessage = userId > 0 ? 'AUTHORIZED' : 'UNAUTHORIZED';
        userPayload.severityLevel = 'INFORMATION';
        userPayload.status = null;
        userPayload.timeZone = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].getUserTimeZone();
        userPayload.pageName = userRef[1];
        userPayload.os = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.family;
        userPayload.osVersion = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.version;
        userPayload.browserName = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().name;
        userPayload.browserVersion = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().version;
        userPayload.device = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().product;
        userPayload.deviceType = null;

        userPayload.userAgent = navigator.userAgent;
        if (navigator.userAgent.indexOf('gonative') > -1) {
            userPayload.deviceType = 'IOS APP';
        }if (navigator.userAgent.indexOf('gonativeand') > -1) {
            userPayload.deviceType = 'ANDROID APP';
        }
        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/logging/writeActivityToQueue', userPayload).then(function (response) {}, function (err) {
            console.log('activity log err ', err);
        });
    },
    LOG_USER_WITHIN_PAGE_CLICK: function LOG_USER_WITHIN_PAGE_CLICK(_ref55, userRef) {
        var commit = _ref55.commit;

        var userId = userRef[0] ? userRef[0] : 0;
        var userPayload = {};
        userPayload.userId = userId;
        userPayload.action = userRef[2];
        userPayload.activityCode = userRef[3];
        userPayload.activityMessage = userId > 0 ? 'AUTHORIZED' : 'UNAUTHORIZED';
        userPayload.severityLevel = 'INFORMATION';
        userPayload.status = null;
        userPayload.timeZone = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].getUserTimeZone();
        userPayload.pageName = userRef[1];
        userPayload.os = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.family;
        userPayload.osVersion = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.version;
        userPayload.browserName = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().name;
        userPayload.browserVersion = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().version;
        userPayload.device = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().product;
        userPayload.deviceType = null;

        userPayload.userAgent = navigator.userAgent;
        if (navigator.userAgent.indexOf('gonative') > -1) {
            userPayload.deviceType = 'IOS APP';
        }if (navigator.userAgent.indexOf('gonativeand') > -1) {
            userPayload.deviceType = 'ANDROID APP';
        }
        console.log('banner click payload', userPayload);
        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/logging/writeActivityToQueue', userPayload).then(function (response) {}, function (err) {
            console.log('activity log err ', err);
        });
    },
    LOGOUT: function LOGOUT(_ref56, userRef) {
        var commit = _ref56.commit;

        var userId = userRef ? userRef.userId : 0;
        var userPayload = {};
        userPayload.userId = userId;
        userPayload.action = 'LOGOUT';
        userPayload.activityCode = null;
        userPayload.activityMessage = 'AUTHORIZED';
        userPayload.severityLevel = 'INFORMATION';
        userPayload.status = null;
        userPayload.timeZone = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].getUserTimeZone();
        userPayload.pageName = null;
        userPayload.os = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.family;
        userPayload.osVersion = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.version;
        userPayload.browserName = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().name;
        userPayload.browserVersion = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().version;
        userPayload.device = __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().product;
        userPayload.deviceType = null;

        userPayload.userAgent = navigator.userAgent;
        if (navigator.userAgent.indexOf('gonative') > -1) {
            userPayload.deviceType = 'IOS APP';
        }if (navigator.userAgent.indexOf('gonativeand') > -1) {
            userPayload.deviceType = 'ANDROID APP';
        }
        if (sessionStorage.getItem('corporateGiftingCode')) {
            sessionStorage.removeItem('corporateGiftingCode');
        }
        if (localStorage.getItem('corporateGiftingCode')) {
            localStorage.removeItem('corporateGiftingCode');
        }
        if (sessionStorage.getItem('corporateClientObject')) {
            sessionStorage.removeItem('corporateClientObject');
        }
        if (localStorage.getItem('corporateClientObject')) {
            localStorage.removeItem('corporateClientObject');
        }
        if (sessionStorage.getItem('corporateGiftInfoObject')) {
            sessionStorage.removeItem('corporateGiftInfoObject');
        }
        if (localStorage.getItem('corporateGiftInfoObject')) {
            localStorage.removeItem('corporateGiftInfoObject');
        }
        if (sessionStorage.getItem('corporateClientId')) {
            sessionStorage.removeItem('corporateClientId');
        }
        if (localStorage.getItem('corporateClientId')) {
            localStorage.removeItem('corporateClientId');
        }
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        localStorage.removeItem('loggedUser');

        sessionStorage.removeItem('switchClientObject');
        sessionStorage.removeItem('redirectPath');
        var loggedUserTemp = sessionStorage.getItem('loggedUserTemp');
        if (loggedUserTemp) {
            sessionStorage.removeItem('loggedUserTemp');
        }

        commit('setUser', { user: null });
        commit('setHeaderAlertStatus', false);
        commit('setCorpHeaderColor', '#44bda8');
        commit('setCorpFooterColor', '#44bda8');
        commit('setCorpButtonColor', '#44bda8');
        commit('setCorpHeadingColor', '#44bda8');

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/logging/writeActivityToQueue', userPayload).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('/');
        }, function (err) {
            __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('/');
            console.log('err ', err);
        });
    },
    ME: function ME(_ref57) {
        var commit = _ref57.commit;

        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/users/me').then(function (response) {
            commit('setUser', { user: response.data });
        }, function (err) {
            console.log(err);
        });
    },
    GETBILLINGHISTORY: function GETBILLINGHISTORY(_ref58, _ref59) {
        var commit = _ref58.commit;
        var userId = _ref59.userId;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/profile/getBillingHistoryById/' + userId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setBillingHistory', { billHistory: data.payload });
            } else {
                commit('setBillingHistory', { billHistory: null });
            }
        }, function (err) {
            commit('setBillingHistory', { billHistory: null });
            console.log('err ', err);
        });
    },
    DEFAULTIMAGESLIST: function DEFAULTIMAGESLIST(_ref60) {
        var commit = _ref60.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/profilepictures').then(function (response) {
            var data = response.data.data;

            if (data) {
                commit('setDefaultImages', { imagesList: data });
            } else {
                commit('setDefaultImages', { imagesList: null });
            }
        }, function (err) {
            commit('setDefaultImages', { billHistory: null });
            console.log('err ', err);
        });
    },
    RESENDVALIDATIONCODE: function RESENDVALIDATIONCODE(_ref61, email) {
        var commit = _ref61.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/registration/resendConfirmationCode/' + email).then(function (response) {
            var data = response.data.data;

            if (data && !data.error) {
                commit('setError', { error: { show: false, message: '' } });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETPAYPALTOKEN: function GETPAYPALTOKEN(_ref62) {
        var commit = _ref62.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/braintree').then(function (response) {
            var data = response.data.data;

            if (data) {
                commit('setPaypalToken', { token: data });
            } else {
                commit('setPaypalToken', { token: '' });
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETCREDITCARDINFO: function GETCREDITCARDINFO(_ref63, userId) {
        var commit = _ref63.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('profile/getCardLastDigits/' + userId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCreditCardInfo', { ccInfo: data.payload });
            } else {
                commit('setCreditCardInfo', { ccInfo: '' });
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    CANCELSUBSCRIPTION: function CANCELSUBSCRIPTION(_ref64, userId) {
        var commit = _ref64.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('registration/cancelSubscriptionById/' + userId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } });

                var logUser = localStorage.getItem('loggedUser');
                if (logUser) {
                    logUser = JSON.parse(localStorage.getItem('loggedUser'));
                    logUser.status = 'CANCELLED';
                    localStorage.setItem('loggedUser', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(logUser));
                }
                var logUserTemp = sessionStorage.getItem('loggedUserTemp');
                if (logUserTemp) {
                    logUserTemp = JSON.parse(sessionStorage.getItem('loggedUserTemp'));
                    logUserTemp.status = 'CANCELLED';
                    sessionStorage.setItem('loggedUserTemp', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(logUserTemp));
                }
            } else {
                commit('setError', { error: { show: true, message: '' } });
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    CREATEPLAYLIST: function CREATEPLAYLIST(_ref65, _ref66) {
        var commit = _ref65.commit;
        var playlist = _ref66.playlist;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('playlists/insertUserPlaylist', playlist).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('playlists/getAllUserPlaylists/' + playlist.userId).then(function (response) {
                    var data = response.data.data;

                    if (data && !data.error && data.completed) {
                        commit('setUserPlaylists', { playlist: data.payload });
                    } else {
                        commit('setUserPlaylists', { playlist: null });
                    }
                }, function (err) {
                    console.log('err ', err);
                    commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
                });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    ADDVIDEOINPLAYLIST: function ADDVIDEOINPLAYLIST(_ref67, _ref68) {
        var commit = _ref67.commit;
        var playlist = _ref68.playlist;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('playlists/addVideoToUserPlaylist', playlist).then(function (response) {
            var data = response.data.data;

            if (data) {
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('playlists/getAllUserPlaylists/' + playlist.userId).then(function (response) {
                    var data = response.data.data;

                    if (data && !data.error && data.completed) {
                        commit('setUserPlaylists', { playlist: data.payload });
                    } else {
                        commit('setUserPlaylists', { playlist: null });
                    }
                }, function (err) {
                    console.log('err ', err);
                    commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
                });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    REMOVEVIDEOFROMPLAYLIST: function REMOVEVIDEOFROMPLAYLIST(_ref69, _ref70) {
        var commit = _ref69.commit;
        var playlist = _ref70.playlist;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('playlists/deleteUserPlaylistVideo', playlist).then(function (response) {
            var data = response.data.data;

            if (data) {
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('playlists/getAllUserPlaylists/' + playlist.userId).then(function (response) {
                    var data = response.data.data;

                    if (data && !data.error && data.completed) {
                        commit('setUserPlaylists', { playlist: data.payload });
                    } else {
                        commit('setUserPlaylists', { playlist: null });
                    }
                }, function (err) {
                    console.log('err ', err);
                    commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
                });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    REMOVEPLAYLIST: function REMOVEPLAYLIST(_ref71, _ref72) {
        var commit = _ref71.commit;
        var playlist = _ref72.playlist;

        console.log('payload', playlist);
        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('playlists/inactivateUserPlaylist/' + playlist.playlistId).then(function (response) {
            var data = response.data.data;

            if (data) {
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('playlists/getAllUserPlaylists/' + playlist.userId).then(function (response) {
                    var data = response.data.data;

                    if (data && !data.error && data.completed) {
                        commit('setUserPlaylists', { playlist: data.payload });
                    } else {
                        commit('setUserPlaylists', { playlist: null });
                    }
                }, function (err) {
                    console.log('err ', err);
                    commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
                });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    SORTPLAYLISTVIDEOS: function SORTPLAYLISTVIDEOS(_ref73, _ref74) {
        var commit = _ref73.commit;
        var playlist = _ref74.playlist;

        console.log('payload', playlist);
        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('playlists/updUserVideoDispOrder/', playlist).then(function (response) {
            console.log('sorting response', response.data);
            var data = response.data.data;

            if (data) {
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('playlists/getAllUserPlaylists/' + playlist.userId).then(function (response) {
                    var data = response.data.data;

                    if (data && !data.error && data.completed) {
                        commit('setUserPlaylists', { playlist: data.payload });
                    } else {
                        commit('setUserPlaylists', { playlist: null });
                    }
                }, function (err) {
                    console.log('err ', err);
                    commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
                });
            } else {
                commit('setError', { error: { show: true, message: __WEBPACK_IMPORTED_MODULE_4__errorMessageMapping__["a" /* getCustomErrorMessage */](data.message) } });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GETUSERPLAYLISTS: function GETUSERPLAYLISTS(_ref75, userId) {
        var commit = _ref75.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('playlists/getAllUserPlaylists/' + userId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setUserPlaylists', { playlist: data.payload });
            } else {
                commit('setUserPlaylists', { playlist: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GET_TRENDING_PLAYLISTS: function GET_TRENDING_PLAYLISTS(_ref76) {
        var commit = _ref76.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/playlists/getCuratedPlaylist').then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setUserPlaylists', { playlist: data.payload });
            } else {
                commit('setUserPlaylists', { playlist: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GETCORPPLAYLISTS: function GETCORPPLAYLISTS(_ref77, corpId) {
        var commit = _ref77.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('corporations/getCorporationPlaylists/' + corpId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setUserPlaylists', { playlist: data.payload });
            } else {
                commit('setUserPlaylists', { playlist: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GETCORPSHAREDVIDEOS: function GETCORPSHAREDVIDEOS(_ref78, userId) {
        var commit = _ref78.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('corporations/getCorpUserSharedVideos/' + userId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCropUserSharedVideos', { vids: data.payload });
            } else {
                commit('setCropUserSharedVideos', { vids: null });
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    GET_USER_PLAYLISTS_PROFILE: function GET_USER_PLAYLISTS_PROFILE(_ref79, payload) {
        var commit = _ref79.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('playlists/getUserIntegratedPlaylists/' + payload[0] + '/' + payload[1]).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                console.log('playlists payload', data.payload);
                commit('setUserPlaylistsProfile', { playlists: data.payload });
            } else {
                commit('setUserPlaylistsProfile', { playlists: null });
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    GET_USER_PROGRESS_PROFILE: function GET_USER_PROGRESS_PROFILE(_ref80, userId) {
        var commit = _ref80.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('profile/getProfileProgressTab/' + userId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setUserProgressProfile', { playlists: data.payload });
            } else {
                commit('setUserProgressProfile', { playlists: null });
            }
        }, function (err) {
            commit('setUserProgressProfile', { playlists: null });
            console.log('err ', err);
        });
    },
    GETSHAREDPLAYLISTS: function GETSHAREDPLAYLISTS(_ref81, playlistId) {
        var commit = _ref81.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('playlists/getUserSharedPlaylist/' + playlistId[0] + '/' + playlistId[1]).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setUserSharedPlaylists', { playlist: data.payload });
            } else {
                commit('setUserSharedPlaylists', { playlist: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GET_USER_EMAIL_PREFRENCES: function GET_USER_EMAIL_PREFRENCES(_ref82, userId) {
        var commit = _ref82.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/registration/getUserOptOuts/' + userId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setEmailPreferences', { pref: data.payload });
            } else {
                commit('setEmailPreferences', { pref: null });
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETUSERPLAYLISTSWITHVIDEOS: function GETUSERPLAYLISTSWITHVIDEOS(_ref83, userId) {
        var commit = _ref83.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('playlists/getAllUserPlaylistsWithVideos/' + userId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setUserPlaylistsWithVideos', { playlist: data });
            } else {
                commit('setUserPlaylistsWithVideos', { playlist: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } });
        });
    },
    GETCORPORATIONPINNEDMSGS: function GETCORPORATIONPINNEDMSGS(_ref84, corpId) {
        var commit = _ref84.commit;

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('corporations/findCorporationAllAdminMessages/' + corpId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCorporationPinnedMsgs', { msgs: data.payload });
            } else {
                commit('setCorporationPinnedMsgs', { msgs: null });
            }
        }, function (err) {
            commit('setCorporationPinnedMsgs', { msgs: null });
            console.log('err ', err);
        });
    },
    UPLOAD_CORP_CSV_METADATA: function UPLOAD_CORP_CSV_METADATA(_ref85, payload) {
        var commit = _ref85.commit;

        console.log('payload of  file', payload.csv_file);
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            console.log('payload of  file', payload.csv_file);
            var formData = new FormData();
            formData.append('csv_file', payload.csv_file);
            formData.append('corporationId', payload.corporationId);
            formData.append('userId', payload.userId);
            console.log('form data', formData);
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/corporations/uploadCorpMembersDetail2S3', formData).then(function (response) {
                var data = response.data.data;

                resolve(data);
            }, function (error) {
                console.log('CREATE_EXPERT error ', error);
                reject(error);
            });
        });
    }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    user: function user(state) {
        return state.user;
    },
    error: function error(state) {
        return state.error;
    },
    isUserLoggedIn: function isUserLoggedIn(state) {
        return state.user;
    },
    getBillingHistory: function getBillingHistory(state) {
        return state.billingHistory;
    },
    getDefaultImages: function getDefaultImages(state) {
        return state.defaultImagesList;
    },
    getPaypalToken: function getPaypalToken(state) {
        return state.paypalToken;
    },
    getCreditCardInfo: function getCreditCardInfo(state) {
        return state.creditCardInfo;
    },
    getUserPlaylists: function getUserPlaylists(state) {
        return state.userPlaylists;
    },
    getUserSharedPlaylists: function getUserSharedPlaylists(state) {
        return state.userSharedPlaylists;
    },
    getUserPlaylistsWithVideos: function getUserPlaylistsWithVideos(state) {
        return state.userPlaylistsWithVideos;
    },
    getValidationStatusError: function getValidationStatusError(state) {
        return state.validationStatusError;
    },
    getCorporationPinnedMsgs: function getCorporationPinnedMsgs(state) {
        return state.corporationPinnedMsgs;
    },
    getCropUserSharedVideos: function getCropUserSharedVideos(state) {
        return state.corpUserSharedVideos;
    },
    getUserPlaylistsProfile: function getUserPlaylistsProfile(state) {
        return state.userPlaylistsProfile;
    },
    getUserProgressProfile: function getUserProgressProfile(state) {
        return state.userProgressProfile;
    },
    getUserEmailPreferences: function getUserEmailPreferences(state) {
        return state.userEmailPreferences;
    }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(412);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    setUser: function setUser(state, _ref) {
        var user = _ref.user;

        state.user = user;
    },
    setError: function setError(state, _ref2) {
        var error = _ref2.error;

        state.error = error;
    },
    setBillingHistory: function setBillingHistory(state, _ref3) {
        var billHistory = _ref3.billHistory;

        state.billingHistory = billHistory;
    },
    setDefaultImages: function setDefaultImages(state, _ref4) {
        var imagesList = _ref4.imagesList;

        state.defaultImagesList = imagesList;
    },
    setPaypalToken: function setPaypalToken(state, _ref5) {
        var token = _ref5.token;

        state.paypalToken = token;
    },
    setCreditCardInfo: function setCreditCardInfo(state, _ref6) {
        var ccInfo = _ref6.ccInfo;

        state.creditCardInfo = ccInfo;
    },
    setUserPlaylists: function setUserPlaylists(state, _ref7) {
        var playlist = _ref7.playlist;

        state.userPlaylists = playlist;
    },
    setUserSharedPlaylists: function setUserSharedPlaylists(state, _ref8) {
        var playlist = _ref8.playlist;

        state.userSharedPlaylists = playlist;
    },
    setValidationStatusError: function setValidationStatusError(state, flag) {
        state.validationStatusError = flag;
    },
    setCorporationPinnedMsgs: function setCorporationPinnedMsgs(state, _ref9) {
        var msgs = _ref9.msgs;

        state.corporationPinnedMsgs = msgs;
    },
    setCropUserSharedVideos: function setCropUserSharedVideos(state, _ref10) {
        var vids = _ref10.vids;

        state.corpUserSharedVideos = vids;
    },
    setUserPlaylistsProfile: function setUserPlaylistsProfile(state, _ref11) {
        var playlists = _ref11.playlists;

        state.userPlaylistsProfile = playlists;
    },
    setUserProgressProfile: function setUserProgressProfile(state, _ref12) {
        var playlists = _ref12.playlists;

        state.userProgressProfile = playlists;
    },
    setEmailPreferences: function setEmailPreferences(state, _ref13) {
        var pref = _ref13.pref;

        state.userEmailPreferences = pref;
    }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    user: null,
    billingHistory: null,
    defaultImagesList: null,
    paypalToken: null,
    creditCardInfo: null,
    userPlaylists: null,
    userPlaylistsWithVideos: null,
    userSharedPlaylists: null,
    error: {
        show: false,
        message: '',
        originalMessage: ''
    },
    validationStatusError: false,
    corporationPinnedMsgs: null,
    corpUserSharedVideos: null,
    userPlaylistsProfile: null,
    userProgressProfile: null,
    userEmailPreferences: null
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
    LOAD_NEW_PLAYER_USER_PLAYLISTS: function LOAD_NEW_PLAYER_USER_PLAYLISTS(_ref, playlistId) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('playlists/loadGeneralPlaylistForNewPlayer/' + playlistId + '/1').then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setUserNewPlaylistObject', { playlist: data.payload });
            } else {
                commit('setUserNewPlaylistObject', { playlist: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request : LOAD_NEW_PLAYER_USER_PLAYLISTS' } });
        });
    },
    LOAD_NEW_PLAYER_TRENDING_PLAYLISTS: function LOAD_NEW_PLAYER_TRENDING_PLAYLISTS(_ref2, playlistId) {
        var commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('playlists/loadGeneralPlaylistForNewPlayer/' + playlistId + '/2').then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setTrendingNewPlaylistObject', { playlist: data.payload });
            } else {
                commit('setTrendingNewPlaylistObject', { playlist: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request : LOAD_NEW_PLAYER_TRENDING_PLAYLISTS' } });
        });
    },
    LOAD_NEW_PLAYER_CORP_PLAYLISTS: function LOAD_NEW_PLAYER_CORP_PLAYLISTS(_ref3, playlistId) {
        var commit = _ref3.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('playlists/loadGeneralPlaylistForNewPlayer/' + playlistId + '/3').then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCorpNewPlaylistObject', { playlist: data.payload });
            } else {
                commit('setCorpNewPlaylistObject', { playlist: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request : LOAD_NEW_PLAYER_CORP_PLAYLISTS' } });
        });
    },
    GETCURRENTVIDEO: function GETCURRENTVIDEO(_ref4, mediaId) {
        var commit = _ref4.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/playlists/getJWVideoByCode/' + mediaId).then(function (response) {
            var data = response.data.data;

            console.log('data found', data);
            if (data && data.length) {
                commit('setCurrentVideoObject', { videoObject: data });
            } else {
                commit('setCurrentVideoObject', { videoObject: null });
            }
        }, function (err) {
            console.log('err ', err);
        });
    },
    GET_CURRENT_VIDEO_DATA_SYNC: function GET_CURRENT_VIDEO_DATA_SYNC(_ref5, mediaId) {
        var commit = _ref5.commit;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/playlists/getJWVideoByCode/' + mediaId).then(function (response) {
                var data = response.data.data;

                console.log('video sync', data);
                resolve(data);
            }).catch(function (error) {
                console.log('action fetch error : ', error);
                reject(null);
            });
        });
    },
    GETVIDEOSUBCATEGORIES: function GETVIDEOSUBCATEGORIES(_ref6, category) {
        var commit = _ref6.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/interests/getSubCategoriesByTitle/' + category[0] + '/' + category[1]).then(function (response) {
            var data = response.data.data;

            if (data) {
                commit('setVideoSubcategory', { subCategories: data });
            } else {
                commit('setVideoSubcategory', { subCategories: null });
            }
        }, function (err) {
            commit('setVideoSubcategory', { subCategories: null });
            console.log('err ', err);
        });
    },
    GETFILTEREDWORKVIDEOS: function GETFILTEREDWORKVIDEOS(_ref7, _ref8) {
        var commit = _ref7.commit;
        var payload = _ref8.payload;

        commit('setAuthWorkVideo', { videoObject: null });
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/playlists/getJWPlaylistByMultipleTitle/WORK/' + payload.corpId, { lstInterestSubCategoryName: payload.lstInterestSubCategoryName }).then(function (response) {
            var data = response.data.data;

            if (data) {
                commit('setAuthWorkVideo', { videoObject: data });
            } else {
                commit('setAuthWorkVideo', { videoObject: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setAuthWorkVideo', { videoObject: null });
        });
    },
    GETFILTEREDLIFEVIDEOS: function GETFILTEREDLIFEVIDEOS(_ref9, _ref10) {
        var commit = _ref9.commit;
        var payload = _ref10.payload;

        commit('setAuthLifeVideo', { videoObject: null });
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/playlists/getJWPlaylistByMultipleTitle/LIFE/' + payload.corpId, { lstInterestSubCategoryName: payload.lstInterestSubCategoryName }).then(function (response) {
            var data = response.data.data;

            if (data) {
                commit('setAuthLifeVideo', { videoObject: data });
            } else {
                commit('setAuthLifeVideo', { videoObject: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setAuthLifeVideo', { videoObject: null });
        });
    },
    GETFILTEREDMONEYVIDEOS: function GETFILTEREDMONEYVIDEOS(_ref11, _ref12) {
        var commit = _ref11.commit;
        var payload = _ref12.payload;

        commit('setAuthMoneyVideo', { videoObject: null });
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/playlists/getJWPlaylistByMultipleTitle/MONEY/' + payload.corpId, { lstInterestSubCategoryName: payload.lstInterestSubCategoryName }).then(function (response) {
            var data = response.data.data;

            if (data) {
                commit('setAuthMoneyVideo', { videoObject: data });
            } else {
                commit('setAuthMoneyVideo', { videoObject: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setAuthMoneyVideo', { videoObject: null });
        });
    },
    GETFILTEREDMINDBODYVIDEOS: function GETFILTEREDMINDBODYVIDEOS(_ref13, _ref14) {
        var commit = _ref13.commit;
        var payload = _ref14.payload;

        commit('setAuthMindbodyVideo', { videoObject: null });
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/playlists/getJWPlaylistByMultipleTitle/MINDBODY/' + payload.corpId, { lstInterestSubCategoryName: payload.lstInterestSubCategoryName }).then(function (response) {
            var data = response.data.data;

            if (data) {
                commit('setAuthMindbodyVideo', { videoObject: data });
            } else {
                commit('setAuthMindbodyVideo', { videoObject: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setAuthMindbodyVideo', { videoObject: null });
        });
    },
    GET_B2B_VIDEOS_METADATA: function GET_B2B_VIDEOS_METADATA(_ref15, videoList) {
        var commit = _ref15.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/playlists/getVideosData', { csvVideoCodes: videoList }).then(function (response) {
            var data = response.data.data;

            if (data) {
                console.log('returned videos', data.payload);
                commit('setB2BVideos', { bVideos: data.payload });
            } else {
                commit('setB2BVideos', { bVideos: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setB2BVideos', { bVideos: null });
        });
    },
    GET_B2B_VIDEOS_METADATA_TOPVIDEO: function GET_B2B_VIDEOS_METADATA_TOPVIDEO(_ref16, videoList) {
        var commit = _ref16.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/playlists/getVideosData', { csvVideoCodes: videoList }).then(function (response) {
            var data = response.data.data;

            if (data) {
                commit('setB2BTopVideo', { bVideos: data.payload });
            } else {
                commit('setB2BTopVideo', { bVideos: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setB2BTopVideo', { bVideos: null });
        });
    },
    GETPROMOVIDEOFORCODE: function GETPROMOVIDEOFORCODE(_ref17, mediaId) {
        var commit = _ref17.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/playlists/getJWVideoByCode/' + mediaId).then(function (response) {
            var data = response.data.data;

            commit('setCurrentPromoVideoObject', { videoObject: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    GETVIDEOTRANSCRIPT: function GETVIDEOTRANSCRIPT(_ref18, mediaId) {
        var commit = _ref18.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/playlists/getTranscriptByVideoCode/' + mediaId).then(function (response) {
            var data = response.data.data;

            commit('setCurrentVideoTranscript', { transcript: data });
        }, function (err) {
            console.log('err ', err);
        });
    },
    SETVIDEOSTATUS: function SETVIDEOSTATUS(_ref19, statusObject) {
        var commit = _ref19.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/playlists/addUpdateUserVideos/', statusObject).then(function (response) {
            commit('setCurrentVideoStatus', { videoStatus: statusObject });
        }, function (err) {
            console.log('err ', err);
            commit('setCurrentVideoStatus', { videoStatus: statusObject });
        });
    },
    SET_PLAYLIST_VIDEOSTATUS: function SET_PLAYLIST_VIDEOSTATUS(_ref20, statusObject) {
        var commit = _ref20.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/playlists/addUpdateWatchedPlaylistVideo', statusObject).then(function (response) {
            console.log('playlist load entry logged');
        }, function (err) {
            console.log('err ', err);
        });
    },
    COPYPLAYLIST: function COPYPLAYLIST(_ref21, _ref22) {
        var commit = _ref21.commit;
        var copyPlaylistObject = _ref22.copyPlaylistObject;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('playlists/copySharedUserPlaylist/', copyPlaylistObject).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCopiedPlaylistObject', { newPlaylist: data.payload });
            } else {
                commit('setCopiedPlaylistObject', { newPlaylist: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setCopiedPlaylistObject', { newPlaylist: null });
        });
    },
    LOGVIDEOERROR: function LOGVIDEOERROR(_ref23, errorPayload) {
        var commit = _ref23.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/logging/writeActivityToQueue', errorPayload).then(function (response) {
            console.log('error successfully logged: ', errorPayload);
        }, function (err) {
            console.log('err ', err);
        });
    },
    SETORIGINALVIDEOCODE: function SETORIGINALVIDEOCODE(_ref24, videoCode) {
        var commit = _ref24.commit;

        if (videoCode) {
            commit('setOriginalVideoCode', videoCode);
        } else {
            commit('setOriginalVideoCode', null);
        }
    },
    SETORIGINALVIDEOTITLE: function SETORIGINALVIDEOTITLE(_ref25, videoTitle) {
        var commit = _ref25.commit;

        if (videoTitle) {
            commit('setOriginalVideoTitle', videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
        } else {
            commit('setOriginalVideoTitle', null);
        }
    },
    GETCORPPAYLOAD: function GETCORPPAYLOAD(_ref26, userId) {
        var commit = _ref26.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/corporations/getUserCorporation/' + userId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCorporatePayload', { corp: data.payload });
            } else {
                commit('setCorporatePayload', { corp: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setCorporatePayload', { corp: null });
        });
    },
    GETCORPPAYLOAD_PRIVATE_EVENT_SHARING: function GETCORPPAYLOAD_PRIVATE_EVENT_SHARING(_ref27, userId) {
        var commit = _ref27.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/corporations/getUserCorporationMemberList/' + userId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setCorporatePayload', { corp: data.payload });
            } else {
                commit('setCorporatePayload', { corp: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setCorporatePayload', { corp: null });
        });
    },
    GET_TAGGED_EMAIL_LIST: function GET_TAGGED_EMAIL_LIST(_ref28, userId) {
        var commit = _ref28.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('playlists/getUserSharedEmailRecipient/' + userId).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setTaggedEmailList', { eList: data.payload });
            } else {
                commit('setTaggedEmailList', { eList: null });
            }
        }, function (err) {
            console.log('err ', err);
            commit('setTaggedEmailList', { eList: null });
        });
    },
    GET_PODCAST_FOR_SERVICE: function GET_PODCAST_FOR_SERVICE(_ref29, podcastServiceName) {
        var commit = _ref29.commit;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/common/getPodcastForService/' + podcastServiceName).then(function (response) {
            var data = response.data.data;

            if (data && !data.error && data.completed) {
                commit('setServicePodcast', { anyThing: data.payload });
                console.log('GET_PODCAST_FOR_SERVICE - DATA FOUND  >>>>>>>>>>>>>>>>>>> data.payload ', data.payload);
            } else {
                commit('setServicePodcast', { anyThing: null });
                console.log('GET_PODCAST_FOR_SERVICE -- NO DATA FOUND >>>>>>>>>>>>>>>>>>> data.payload ', data.payload);
                console.log('GET_PODCAST_FOR_SERVICE -- NO DATA FOUND >>>>>>>>>>>>>>>>>>> podcastServiceName ', podcastServiceName);
            }
        }, function (err) {
            console.log('err ', err);
            commit('setServicePodcast', { anyThing: null });
        });
    }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getCurrentVideo: function getCurrentVideo(state) {
        return state.currentVideoObject;
    },
    getPromoVideo: function getPromoVideo(state) {
        return state.currentPromoVideoObject;
    },
    getCurrentStatus: function getCurrentStatus(state) {
        return state.currentVideoStatus;
    },
    getCurrentVideoTranscript: function getCurrentVideoTranscript(state) {
        return state.currentVideoTranscript;
    },
    getCurrentVideoDurationWatched: function getCurrentVideoDurationWatched(state) {
        return state.currentVideoDurationWatched;
    },
    getVideEndMessage: function getVideEndMessage(state) {
        return state.videoEndMessage;
    },
    getVideEndGif: function getVideEndGif(state) {
        return state.videoEndGif;
    },
    getCopiedPlaylistObject: function getCopiedPlaylistObject(state) {
        return state.copiedPlaylistObject;
    },
    getOriginalVideoCode: function getOriginalVideoCode(state) {
        return state.originalVideoCode;
    },
    getOriginalVideoTitle: function getOriginalVideoTitle(state) {
        return state.originalVideoTitle;
    },
    getVideoSubcategories: function getVideoSubcategories(state) {
        return state.videoSubCategories;
    },
    getCorporatePayload: function getCorporatePayload(state) {
        return state.corporatePayload;
    },
    getB2BVideos: function getB2BVideos(state) {
        return state.B2BVideos;
    },
    getB2BTopVideo: function getB2BTopVideo(state) {
        return state.b2BTopVideo;
    },
    getTaggedEmailList: function getTaggedEmailList(state) {
        return state.taggedEmailList;
    },
    getArchivePlaylistObject: function getArchivePlaylistObject(state) {
        return state.archivePlaylistObject;
    },
    getItemChangeInPlaylist: function getItemChangeInPlaylist(state) {
        return state.itemChangeInPlaylist;
    },
    getServicePodcast: function getServicePodcast(state) {
        return state.servicePodcast;
    },
    getUserNewPlaylistObject: function getUserNewPlaylistObject(state) {
        return state.userNewPlaylistObject;
    },
    getTrendingNewPlaylistObject: function getTrendingNewPlaylistObject(state) {
        return state.trendingNewPlaylistObject;
    },
    getCorpNewPlaylistObject: function getCorpNewPlaylistObject(state) {
        return state.corpNewPlaylistObject;
    }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(417);





/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    setCurrentVideoObject: function setCurrentVideoObject(state, _ref) {
        var videoObject = _ref.videoObject;

        state.currentVideoObject = videoObject;
    },
    setCurrentPromoVideoObject: function setCurrentPromoVideoObject(state, _ref2) {
        var videoObject = _ref2.videoObject;

        state.currentPromoVideoObject = videoObject;
    },
    setCurrentVideoStatus: function setCurrentVideoStatus(state, _ref3) {
        var videoStatus = _ref3.videoStatus;

        state.currentVideoStatus = videoStatus;
    },
    setCurrentVideoTranscript: function setCurrentVideoTranscript(state, _ref4) {
        var transcript = _ref4.transcript;

        state.currentVideoTranscript = transcript;
    },
    setCopiedPlaylistObject: function setCopiedPlaylistObject(state, _ref5) {
        var newPlaylist = _ref5.newPlaylist;

        state.copiedPlaylistObject = newPlaylist;
    },
    setCurrentVideoDurationWatched: function setCurrentVideoDurationWatched(state, duration) {
        state.currentVideoDurationWatched = duration;
    },
    setOriginalVideoCode: function setOriginalVideoCode(state, videoCode) {
        state.originalVideoCode = videoCode;
    },
    setOriginalVideoTitle: function setOriginalVideoTitle(state, videoTitle) {
        state.originalVideoTitle = videoTitle;
    },
    setVideoSubcategory: function setVideoSubcategory(state, _ref6) {
        var subCategories = _ref6.subCategories;

        state.videoSubCategories = subCategories;
    },
    setCorporatePayload: function setCorporatePayload(state, _ref7) {
        var corp = _ref7.corp;

        state.corporatePayload = corp;
    },
    setB2BVideos: function setB2BVideos(state, _ref8) {
        var bVideos = _ref8.bVideos;

        state.B2BVideos = bVideos;
    },
    setB2BTopVideo: function setB2BTopVideo(state, _ref9) {
        var bVideos = _ref9.bVideos;

        state.b2BTopVideo = bVideos;
    },
    setTaggedEmailList: function setTaggedEmailList(state, _ref10) {
        var eList = _ref10.eList;

        state.taggedEmailList = eList;
    },
    setArchivePlaylistObject: function setArchivePlaylistObject(state, _ref11) {
        var eList = _ref11.eList;

        state.archivePlaylistObject = eList;
    },
    setItemChangeInPlaylist: function setItemChangeInPlaylist(state, _ref12) {
        var item = _ref12.item;

        state.itemChangeInPlaylist = item;
    },
    setServicePodcast: function setServicePodcast(state, _ref13) {
        var anyThing = _ref13.anyThing;

        state.servicePodcast = anyThing;
    },
    setUserNewPlaylistObject: function setUserNewPlaylistObject(state, _ref14) {
        var playlist = _ref14.playlist;

        state.userNewPlaylistObject = playlist;
    },
    setTrendingNewPlaylistObject: function setTrendingNewPlaylistObject(state, _ref15) {
        var playlist = _ref15.playlist;

        state.trendingNewPlaylistObject = playlist;
    },
    setCorpNewPlaylistObject: function setCorpNewPlaylistObject(state, _ref16) {
        var playlist = _ref16.playlist;

        state.corpNewPlaylistObject = playlist;
    }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    currentVideoObject: null,
    currentVideoStatus: null,
    currentVideoTranscript: null,
    currentVideoDurationWatched: null,
    currentPromoVideoObject: null,
    copiedPlaylistObject: null,
    originalVideoCode: null,
    originalVideoTitle: null,
    videoEndMessage: ['Good for you! Hope you got the insight you were looking for!', 'Yay you! There is more coming your way!', 'And that is just for starters! Click for more.', 'Do not miss out! Invest in yourself and watch more Tone videos here.', 'Yay you! Now take the advice and run with it!', 'Congrats! You just did something great for you.', 'No time like the present. Keep on clicking for more great advice!', 'Woo hoo! You did it!', 'Congratulations! Today is your day.', 'Well done. Thanks for stopping by!', 'We are proud of you. Very, very proud of you!', 'Congrats! We are so happy you stopped by.', 'Thanks for taking time for you!', 'Congratulations! You did it!', 'Congrats! Now have a fantastic rest of your day!', 'Well done, my friend. Keep up the good work!', 'Way to take time out for you!', 'Yippee skippee! Today just got a little bit sweeter.', 'Congratulations! What an achievement.', 'Woo hoo! Have a Tone-tastic day!', 'Congrats! This is only the beginning.', 'You did it! Sending a virtual high five your way!'],
    videoEndGif: ['../assets/baloonssmall.png', '../assets/fireworkssmall.png', '../assets/confettismall.png', '../assets/sparkelssmall.gif'],
    videoSubCategories: null,
    corporatePayload: null,
    B2BVideos: null,
    b2BTopVideo: null,
    taggedEmailList: null,
    archivePlaylistObject: null,
    userNewPlaylistObject: null,
    trendingNewPlaylistObject: null,
    corpNewPlaylistObject: null,
    itemChangeInPlaylist: null,
    servicePodcast: null
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Header__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Footer__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        'ToneHeader': __WEBPACK_IMPORTED_MODULE_1__components_layout_Header___default.a,
        'ToneFooter': __WEBPACK_IMPORTED_MODULE_2__components_layout_Footer___default.a
    },
    data: function data() {
        return {
            headerColor: '#f0617d',
            scrollPosition: 155,
            gTagCorporationId: 0,
            hideNav: this.$route.meta.hideNav,
            html: {
                background: 'yellow !important'
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-8056SCPWK0';

        document.head.appendChild(script);

        console.log('in App.vue : user = ', this.user);
        if (this.user && this.user.corporation) {
            this.gTagCorporationId = this.user.corporation.corporationId;
        }
        console.log('in App.vue : this.gTagCorporationId = ', this.gTagCorporationId);
        script.onload = function () {
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                window.dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', 'G-8056SCPWK0');
            gtag('gTagCorporationId', _this.gTagCorporationId);
            gtag('event', 'CORPORATION', {
                'corporation_id': _this.gTagCorporationId
            });
        };
    },
    watch: {
        '$route': function $route(to, from) {
            this.hideNav = to.meta.hideNav ? to.meta.hideNav : false;
        }
    },
    created: function created() {
        window.addEventListener('scroll', this.stickyNavigation);
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.stickyNavigation);
    },

    methods: {
        setHeaderColor: function setHeaderColor() {
            var self = this;
            var loggedUser = null;
            if (localStorage.getItem('loggedUser')) {
                loggedUser = JSON.parse(localStorage.getItem('loggedUser'));
            }
            if (loggedUser) {
                if (loggedUser && loggedUser.corporation && loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.headerColor) {
                    self.headerColor = loggedUser.corporation.groupDefinitions.headerColor;
                }
            } else {
                if (!loggedUser) {
                    if (localStorage.getItem('corporateClientObject')) {
                        var corpObject = JSON.parse(localStorage.getItem('corporateClientObject'));
                        if (corpObject && corpObject.groupDefinitions && corpObject.groupDefinitions.headerColor) {
                            self.headerColor = corpObject.groupDefinitions.headerColor;
                        }
                    }
                }
            }
            console.log('updated color in app', this.headerColor);
        },
        stickyNavigation: function stickyNavigation(e) {}
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['user', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor']))
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);








/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"]
    },
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | About US',
            meta: [{ property: 'og:image', content: 'https://assets.tonenetworks.com/images/tone_social_logo.jpg' }, { property: 'og:title', content: 'About US | TONE Networks' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'Here at TONE we believe that being your personal and professional best is possible – and that when women help themselves and each other, we are truly unstoppable.'
            }, { property: 'twitter:title', content: 'About US | TONE Networks' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://assets.tonenetworks.com/images/tone_social_logo.jpg' }, {
                property: 'twitter:description',
                content: 'Here at TONE we believe that being your personal and professional best is possible – and that when women help themselves and each other, we are truly unstoppable.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    name: 'login',
    data: function data() {
        return {
            success: false,
            successMsg: '',
            contactForm: {
                emailAddress: '',
                phoneNumber: '',
                reason: '',
                comments: ''
            },
            spinner: false,
            staffMembers: null,
            showMembers: false,
            beginSectionHeading: '',
            beginSectionImage: '',
            beginSectionPara1: '',
            beginSectionPara2: '',
            beginSectionPara3: '',
            beginSectionPara4: '',
            createdSectionHeading: '',
            createdSectionPara1: '',
            createdSectionPara2: '',
            createdSectionPara3: '',
            bottomMessage1: '',
            bottomMessage2: '',
            bottomMessage3: ''
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'user', 'getMembers', 'getAllSiteContents', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'])),
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this = this;

            if (this.contactForm.emailAddress && this.contactForm.phoneNumber) {
                this.spinnerToggle();
                this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(function () {
                    _this.success = true;
                    _this.successMsg = 'Your message has been sent, we will get back to you shortly!';
                    _this.spinnerToggle();
                });
            }
        },
        setCarousal: function setCarousal() {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$el).find('.responsive-slick-imagelist');
            $slick.each(function () {
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        }
    },
    watch: {},
    mounted: function mounted() {
        var _this2 = this;

        var self = this;

        self.$store.dispatch('GETSTAFFMEMBERS').then(function () {
            if (self.getMembers) {
                self.staffMembers = self.getMembers;
                setTimeout(function () {
                    self.showMembers = true;
                    self.setCarousal();
                }, 2000);
            }
        });
        self.$store.dispatch('GETDYNAMICCONTENTS', 12).then(function () {
            if (self.getAllSiteContents) {
                self.beginSectionHeading = _this2.setDynamicSection(_this2.getAllSiteContents, 'HOW_WE_BEGAN_SECTION_HEADING');
                self.beginSectionImage = _this2.setDynamicSection(_this2.getAllSiteContents, 'HOW_WE_BEGAN_SECTION_IMG_01');
                self.beginSectionPara1 = _this2.setDynamicSection(_this2.getAllSiteContents, 'HOW_WE_BEGAN_SECTION_PARA_01');
                self.beginSectionPara2 = _this2.setDynamicSection(_this2.getAllSiteContents, 'HOW_WE_BEGAN_SECTION_PARA_02');
                self.beginSectionPara3 = _this2.setDynamicSection(_this2.getAllSiteContents, 'HOW_WE_BEGAN_SECTION_PARA_03');
                self.beginSectionPara4 = _this2.setDynamicSection(_this2.getAllSiteContents, 'HOW_WE_BEGAN_SECTION_PARA_04');

                self.createdSectionHeading = _this2.setDynamicSection(_this2.getAllSiteContents, 'WE_CREATED_TONE_HEADING');
                self.createdSectionPara1 = _this2.setDynamicSection(_this2.getAllSiteContents, 'WE_CREATED_TONE_PARA_01');
                self.createdSectionPara2 = _this2.setDynamicSection(_this2.getAllSiteContents, 'WE_CREATED_TONE_PARA_02');
                self.createdSectionPara3 = _this2.setDynamicSection(_this2.getAllSiteContents, 'WE_CREATED_TONE_PARA_03');
                self.createdSectionPara4 = _this2.setDynamicSection(_this2.getAllSiteContents, 'WE_CREATED_TONE_PARA_04');

                self.bottomMessage1 = _this2.setDynamicSection(_this2.getAllSiteContents, 'BOTTOM_MESSAGE_01');
                self.bottomMessage2 = _this2.setDynamicSection(_this2.getAllSiteContents, 'BOTTOM_MESSAGE_02');
                self.bottomMessage3 = _this2.setDynamicSection(_this2.getAllSiteContents, 'BOTTOM_MESSAGE_03');
            }
        });
        self.$store.dispatch('CACHEPAGE', window.location.href);
    }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password__);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["accordion"],
        'panel': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["panel"],
        alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
        dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["dropdown"],
        radio: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["radio"],
        VuePassword: __WEBPACK_IMPORTED_MODULE_3_vue_password___default.a,
        checkbox: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        tabs: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tabs"],
        tab: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tab"],
        buttonGroup: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"]
    },
    name: 'signUp',
    data: function data() {
        return {
            user: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                packageId: 0,
                comments: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg'
            },
            spinner: false,
            alert: false,
            passwordError: '',
            paymentSection: false,
            isToggle: false,
            isChecked: false,
            defaultPlan: '',
            hidePasswordMeter: true,
            accentureGiftCode: 'Accenture'
        };
    },
    mounted: function mounted() {
        this.$router.push('/corporation/1/Accenture');
    },

    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        verifyPaymentSubmit: function verifyPaymentSubmit() {
            if (this.user.packageId > 0) {
                return false;
            }
            return true;
        },
        verifyPassword: function verifyPassword() {
            if (this.user.password.length >= 6) {
                var re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/;
                if (!re.test(this.user.password)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (this.user.password.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        verifyEmail: function verifyEmail() {
            if (this.user.email.length > 0) {
                var re = /^[\w\d.+-]+@[\w\d-]+\.[a-z]+$/i;
                if (!re.test(this.user.email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyFirstName: function verifyFirstName() {
            if (this.user.firstName.length > 0) {
                var re = /^[A-Za-z '-]+$/;
                if (!re.test(this.user.firstName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyLastName: function verifyLastName() {
            if (this.user.lastName.length > 0) {
                var re = /^[A-Za-z '-]+$/;
                if (!re.test(this.user.lastName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyCardHolderName: function verifyCardHolderName() {
            if (this.user.cardHolderName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.cardHolderName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onGifteeSubmit: function onGifteeSubmit() {
            var _this = this;

            this.$store.dispatch('GETACCENTUREGIFTEE', this.accentureGiftCode).then(function () {
                if (_this.getGiftee && !_this.getGiftingError.show) {
                    if (_this.verifyPassword() && _this.verifyEmail() && _this.verifyFirstName() && _this.verifyLastName()) {
                        _this.spinnerToggle();
                        _this.user.email = _this.user.email.toLowerCase();
                        _this.$store.dispatch('SAVEGIFTEE', { giftee: _this.user }).then(function () {
                            if (!_this.error.show) {
                                _this.spinnerToggle();
                                _this.$swal({
                                    title: 'Registration Success!',
                                    text: 'Welcome To TONE! For your security, please check your inbox for a Validation Email - TONE Networks within the next 12 hours.  (Don’t see it…check your spam folder.)',
                                    type: 'success',
                                    timer: 4000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(function () {}, function (dismiss) {
                                    if (dismiss === 'timer') {}
                                });
                            } else {
                                _this.spinnerToggle();
                            }
                        });
                    }
                } else {
                    _this.user.packageId = -1;
                    _this.$swal({
                        title: 'You have reached the maximum number of accounts registered for this trial offer.',
                        text: '',
                        type: 'error',
                        timer: 4000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                }
            });
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['error', 'isUserLoggedIn', 'getAllPlans', 'getGiftee', 'getGiftingError']))
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_strap__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'player',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default.a,
        'tabs': __WEBPACK_IMPORTED_MODULE_6_vue_strap__["tabs"],
        'bs-input': __WEBPACK_IMPORTED_MODULE_6_vue_strap__["input"],
        spinner: __WEBPACK_IMPORTED_MODULE_6_vue_strap__["spinner"],
        'tab': __WEBPACK_IMPORTED_MODULE_6_vue_strap__["tab"],
        modal: __WEBPACK_IMPORTED_MODULE_6_vue_strap__["modal"]
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: 'TONE Archive Playlist | ' + self.currentVideo.title,
            meta: [{ property: 'og:image', content: self.currentVideo.img }, { property: 'og:title', content: self.currentVideo.title + ' | TONE Networks' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: self.currentVideo.Description
            }, { property: 'twitter:title', content: self.currentVideo.title + ' | TONE Networks' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.currentVideo.img }, {
                property: 'twitter:description',
                content: self.currentVideo.Description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            eventExpertColl: null,
            corporateShareMessage: '',
            selectedPlaylist: null,
            corpShareModalImage: '',
            showCorporateShare: false,
            corpShareModalTitle: '',
            corpShareModalDesc: '',
            selectedCorps: [],
            allCorps: [],
            shareOption: 'Corporate',
            showShareCommunity: false,
            showShareIndividual: false,
            showShareFriends: false,
            sharePlaylistType: '',
            archiveEventId: 0,
            archiveEventTitle: '',
            spinner: false,
            taggedEmails: [],
            emailList: [],
            previewMsg: 'Message Preview: \n',
            showSharedModal: false,
            shareInProcess: false,
            toggleSpinner: false,
            activeTab: 0,
            currentVideo: '',
            currentStatus: '',
            currentVideoCode: '',
            recommendationList: '',
            videoCompleted: false,
            videoSqueeze: false,
            hideLeftVideoIcons: false,
            addRightHoverWidthClass: false,
            addIconHoverWidthClass: false,
            showRateHoverBox: false,
            showShareHoverBox: false,
            showEnjoyHoverBox: false,
            addRightHoverEnjoyClass: false,
            addEnjoyHoverClass: false,
            captionTrack: '',
            viewTranscript: false,
            ratingOne: false,
            ratingTwo: false,
            ratingThree: false,
            ratingFour: false,
            hideAll: false,
            videoMessage: '',
            videoMessageIndex: Math.floor(Math.random() * 7),
            videoGif: '',
            videoGifIndex: Math.floor(Math.random() * 4),
            videoURL: window.location.href,
            playlistVideos: null,
            videoIndex: 0,
            showPlaylist: false,
            eventRef: null,
            titleURL: '',
            sharePayload: {
                tmpVideCode: '',
                sharedEmailList: '',
                sharedEmailMessage: '',
                sharedPlaylistPreview: ''
            },
            shareVideoPayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                recipientFriendEmails: null,
                playlistId: '',
                messageText: '',
                playlistType: 4
            }
        };
    },
    methods: {
        videoChangedInPlaylist: function videoChangedInPlaylist() {},
        shareCorporateVideo: function shareCorporateVideo() {
            var self = this;
            self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0;
            self.shareVideoPayload.senderUserId = self.user.userId;
            self.shareVideoPayload.recipientsUserIds = [];
            self.shareVideoPayload.recipientFriendEmails = null;
            self.shareVideoPayload.messageText = self.corporateShareMessage;
            if (self.shareOption === 'Corporate') {
                self.shareVideoPayload.recipientsUserIds = [];
                self.shareVideoPayload.recipientFriendEmails = null;
            } else if (self.shareOption === 'Individual') {
                self.shareVideoPayload.recipientFriendEmails = null;
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    self.shareVideoPayload.recipientsUserIds = self.selectedCorps.map(function (x) {
                        return x.userId;
                    });
                }
            } else if (self.shareOption === 'Friends') {
                self.shareVideoPayload.recipientsUserIds = [];
                var emailArray = self.taggedEmails.map(function (x) {
                    return x.name;
                });
                self.shareVideoPayload.recipientFriendEmails = emailArray.join(',');
            } else {}
            self.shareVideoPayload.playlistId = self.archiveEventId;

            if (!self.shareInProcess) {
                self.$store.dispatch('PLAYLISTCORPORATESHARE', { payload: self.shareVideoPayload }).then(function () {
                    if (!self.error.show) {
                        self.spinnerToggle();
                        self.$swal({
                            title: 'Playlist has been shared!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });

                        self.cancelCorporateModal();
                    } else {
                        self.cancelCorporateModal();
                    }
                });
            }
            self.shareInProcess = true;
        },
        maskEmailAddress: function maskEmailAddress(userEmail) {
            var avg = void 0,
                splitted = void 0,
                part1 = void 0,
                part2 = void 0;
            splitted = userEmail.split('@');
            part1 = splitted[0];
            var regex = /[^0-9.]/g;
            var maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1);
            console.log('maked', maskid);
            avg = part1.length / 2;
            part1 = part1.substring(0, part1.length - avg);
            part2 = splitted[1];
            var maskDomain = part2.split('.');
            return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1];
        },
        customLabel: function customLabel(option) {
            var findDuplicate = this.allCorps.find(function (x) {
                return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId;
            });

            if (findDuplicate) {
                var maskedEmail = this.maskEmailAddress(option.email);
                return option.firstName + ' ' + option.lastName + ' <' + maskedEmail + '>';
            } else {
                return option.firstName + ' ' + option.lastName;
            }
        },
        openCorporateShareModal: function openCorporateShareModal(playlistObj) {
            var self = this;
            self.shareInProcess = false;
            self.corpShareModalImage = playlistObj.img_url;
            self.corpShareModalDesc = playlistObj.description;
            self.corpShareModalTitle = playlistObj.title;
            self.selectedPlaylist = playlistObj;
            self.archiveEventId = playlistObj.eventId;
            self.showCorporateShare = true;

            if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareArchivePlistPermission >= 1) {
                var rights = self.user.corporation.corpSharingPermissions.shareArchivePlistPermission;
                console.log('rights', rights);
                if (rights === 1) {
                    self.showShareCommunity = true;
                    self.showShareIndividual = true;
                    self.showShareFriends = true;
                } else if (rights === 2) {
                    self.showShareCommunity = true;
                    self.showShareIndividual = false;
                    self.showShareFriends = false;
                    self.shareOption = 'Corporate';
                } else if (rights === 3) {
                    self.showShareCommunity = false;
                    self.showShareFriends = false;
                    self.showShareIndividual = true;
                    self.shareOption = 'Individual';
                } else if (rights === 5) {
                    self.showShareCommunity = false;
                    self.showShareIndividual = false;
                    self.showShareFriends = true;
                    self.shareOption = 'Friends';
                } else {
                    self.showShareCommunity = false;
                    self.showShareIndividual = false;
                    self.showShareFriends = false;
                }
            }
        },
        showSharingModal: function showSharingModal(playlistObj) {
            console.log('playlist obj', playlistObj);
            var self = this;
            if (self.user && self.user.corporation === null) {
                self.openModalShare(playlistObj.eventId, playlistObj.title);
            } else {
                self.openCorporateShareModal(playlistObj);
            }
        },
        verifyEmailShare: function verifyEmailShare(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        addTag: function addTag(newTag) {
            var self = this;
            console.log('newTAg', newTag);
            var tag = {
                name: newTag
            };
            if (self.verifyEmailShare(newTag)) {
                self.emailList.push(tag);
                this.taggedEmails.push(tag);
                console.log('tagged emails', this.taggedEmails);
            } else {
                console.log('invalid email address, calling swal');
            }
        },
        cancelCorporateModal: function cancelCorporateModal() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateShare = false;
                self.shareInProcess = false;
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        cancelEmailShareModal: function cancelEmailShareModal() {
            var self = this;
            var $ = __webpack_provided_window_dot_jQuery;
            self.sharePayload.tmpVideCode = '';
            self.sharePayload.sharedEmailList = '';
            self.sharePayload.sharedEmailMessage = '';
            setTimeout(function () {
                self.showSharedModal = false;
                self.archiveEventId = 0;
                self.archiveEventTitle = '';
                self.sharePayload.sharedPlaylistPreview = '';

                $('.modal-open').removeClass('modal-open');
            }, 500);
        },
        verifyEmail: function verifyEmail(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onSharePlaylist: function onSharePlaylist() {
            var self = this;
            self.spinnerToggle();
            var emailArray = self.taggedEmails.map(function (x) {
                return x.name;
            });
            self.sharePayload.sharedPlaylistPreview = self.user.firstName + ' shared a coaching tips playlist with you on Tone Networks: \n' + self.archiveEventTitle + '\n' + self.sharePayload.sharedEmailMessage;
            var sharePayload = {
                csvEmailRecepients: emailArray.join(','),
                userId: self.user.userId,
                playlistId: self.archiveEventId,
                customizedMessage: self.sharePayload.sharedPlaylistPreview
            };
            self.$store.dispatch('ARCHIVE_PLAYLIST_SHARE', { payload: sharePayload }).then(function () {
                if (!self.error.show) {
                    self.spinnerToggle();
                    self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(function () {
                        if (self.getTaggedEmailList) {
                            self.emailList = [];
                            self.emailList = self.getTaggedEmailList;
                            self.taggedEmails = [];
                            self.sharePayload.sharedPlaylistPreview = '';
                        }
                    });
                    self.$swal({
                        title: 'Email Sent!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    self.cancelEmailShareModal();
                } else {
                    self.spinnerToggle();
                    self.cancelEmailShareModal();
                }
            });
        },
        openModalShare: function openModalShare(eventId, eventTitle) {
            console.log('called');
            this.archiveEventId = eventId;
            this.archiveEventTitle = eventTitle;
            this.showSharedModal = true;
        },
        sortPlaylist: function sortPlaylist(a, b) {
            if (parseInt(a.eventVideoId) < parseInt(b.eventVideoId)) {
                return -1;
            }
            if (parseInt(a.eventVideoId) > parseInt(b.eventVideoId)) {
                return 1;
            }
            return 0;
        },
        getVideoIndex: function getVideoIndex(videoArray, videoCode) {
            var index;
            for (var i = 0; i < videoArray.length; ++i) {
                if (videoArray[i].videoCode === videoCode) {
                    index = i;
                    break;
                }
            }
            return index;
        },
        toggleViewTranscript: function toggleViewTranscript() {
            this.viewTranscript = !this.viewTranscript;
        },
        redirectToRelatedVideos: function redirectToRelatedVideos() {
            this.$router.push('/relatedvideos');
        },
        getNextVideo: function getNextVideo(index) {
            if (index >= 0 && index < this.playlistVideos.length) {
                return parseInt(index) + 1;
            } else {
                return null;
            }
        },
        playVideo: function playVideo(videoSequence) {
            this.$router.push('/tonearchive/' + this.$route.params.eventId + '/play/' + videoSequence + '/' + this.titleURL.toLowerCase());
            location.reload();
        },
        playVideoInPlylist: function playVideoInPlylist(videoObjectToPlay) {
            var self = this;
            var videoIndex = self.getArchivePlaylistObject.indexOf(videoObjectToPlay);
            console.log('actual video index', videoIndex);
            if (videoIndex > -1) {
                self.videoIndex = videoIndex + 1;
                console.log('video index of next video', videoIndex + 1);
                self.currentVideo = videoObjectToPlay;
                window.jwplayer().playlistItem(videoIndex);
            }
        },
        onVideoComplete: function onVideoComplete() {
            var nextVideoReference = this.getNextVideo(this.videoIndex);
            if (nextVideoReference) {
                this.$router.push('/tonearchive/' + this.$route.params.eventId + '/play/' + nextVideoReference + '/' + this.titleURL.toLowerCase());
                location.reload();
            }
        },
        setUserLike: function setUserLike() {
            var _this = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / this.getCurrentVideo[0].duration * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            if (this.currentStatus.liked === '1') {
                this.currentStatus.liked = '0';
            } else {
                this.currentStatus.liked = '1';
            }
            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this.currentStatus = _this.getCurrentStatus;
            });
        },
        setOpinion: function setOpinion(desc) {
            var _this2 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            var opinion = '0';
            if (desc === 'travel') {
                opinion = '1';
            } else if (desc === 'dating') {
                opinion = '2';
            } else if (desc === 'news') {
                opinion = '3';
            } else if (desc === 'recipes') {
                opinion = '4';
            } else {
                opinion = '0';
            }

            if (this.currentStatus.opinion === opinion) {
                this.currentStatus.opinion = '0';
            } else {
                this.currentStatus.opinion = opinion;
            }
            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this2.currentStatus = _this2.getCurrentStatus;
            });
        },
        setRating: function setRating(rating) {
            var _this3 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            if (this.currentStatus.rating === rating) {
                this.currentStatus.rating = '0';
            } else {
                this.currentStatus.rating = rating;
            }

            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this3.currentStatus = _this3.getCurrentStatus;
            });
        },
        logVideoEntry: function logVideoEntry() {
            var logWatchedEntry = {
                videoCode: this.$route.params.videoCode,
                userId: this.user.userId,
                playlistId: null,
                playlistCode: null,
                watched: 'N',
                rating: null,
                liked: '0',
                durationWatched: 0,
                thumbnailURL: null,
                opinion: null
            };
            this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {});
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/watch/' + videoCode);
            location.reload();
        },
        applyRatingClass: function applyRatingClass(rating) {
            if (rating === this.currentStatus.rating) {
                return true;
            } else {
                return false;
            }
        },
        setCarousal: function setCarousal() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.each(function () {
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        toggleVideoCompleted: function toggleVideoCompleted() {
            var self = this;
            self.videoCompleted = true;
            setTimeout(function () {
                self.videoSqueeze = true;
            }, 200);
        },
        replayVideo: function replayVideo() {
            var videoCode = this.$route.params.videoCode;
            this.videoCompleted = false;
            this.videoSqueeze = false;
            this.$router.push('/watch/' + videoCode);
            this.setVideoPlayerObject(videoCode);
        },
        changeHeight: function changeHeight() {
            this.hideLeftVideoIcons = true;
            this.showRateHoverBox = true;
            this.addRightHoverWidthClass = true;
            this.addIconHoverWidthClass = true;
            this.showShareHoverBox = false;
            this.showEnjoyHoverBox = false;
        },
        showSharing: function showSharing() {
            this.hideLeftVideoIcons = true;
            this.showShareHoverBox = true;
            this.addRightHoverWidthClass = true;
            this.addIconHoverWidthClass = true;
            this.showRateHoverBox = false;
            this.showEnjoyHoverBox = false;
        },
        redirectToHome: function redirectToHome() {
            this.$router.push('/');
        },
        showEnjoy: function showEnjoy() {
            this.showEnjoyHoverBox = true;
            this.hideLeftVideoIcons = true;
            this.addRightHoverEnjoyClass = true;
            this.addIconHoverWidthClass = true;
            this.addEnjoyHoverClass = true;
            this.showRateHoverBox = false;
            this.showShareHoverBox = false;
        },
        resetClass: function resetClass(bool) {
            if (bool) {
                this.hideLeftVideoIcons = false;
                this.addRightHoverWidthClass = false;
                this.addRightHoverEnjoyClass = false;
                this.addIconHoverWidthClass = false;
                this.showRateHoverBox = false;
                this.showShareHoverBox = false;
                this.showEnjoyHoverBox = false;
                this.addEnjoyHoverClass = false;
            } else {}
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    },
    watch: {
        'sharePayload.sharedEmailMessage': function sharePayloadSharedEmailMessage(to, from) {
            var self = this;
            var oriiginalMessage = self.user.firstName + ' shared a coaching tips playlist with you on Tone Networks: \n' + self.archiveEventTitle + ' \n';
            if (self.showSharedModal && self.sharePayload.sharedEmailMessage && self.sharePayload.sharedEmailMessage.length > 0) {
                self.sharePayload.sharedPlaylistPreview = '' + self.previewMsg + oriiginalMessage + self.sharePayload.sharedEmailMessage;
            } else {
                self.sharePayload.sharedPlaylistPreview = self.previewMsg + ' ' + self.user.firstName + ' shared a coaching tips playlist with you on Tone Networks: \n' + self.archiveEventTitle + ' \n';
            }
        },
        'shareOption': function shareOption(to, from) {
            var self = this;
            self.selectedCorps = null;
            self.corporateShareMessage = '';
            self.taggedEmails = [];
        },
        'getItemChangeInPlaylist': function getItemChangeInPlaylist(to, from) {
            var self = this;
            if (self.getItemChangeInPlaylist) {
                self.videoIndex = self.getItemChangeInPlaylist.index + 1;
                self.currentVideo = self.getItemChangeInPlaylist.item;
            }

            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);
            userPayload.push('/tonearchive/' + this.$route.params.eventId + '/play/' + self.videoIndex + '/' + this.titleURL.toLowerCase());
            console.log('user activity', userPayload);
            this.$store.dispatch('LOGUSERACTIVITY', userPayload);
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        var self = this;
        var getEventId = this.$route.params.eventId;
        self.$store.dispatch('GETEVENTSARCHIVE').then(function () {
            if (self.getLiveEventsArchive) {
                var eventRefr = self.getLiveEventsArchive.filter(function (x) {
                    return x.eventId.toString() === getEventId.toString();
                });
                if (eventRefr && eventRefr.length > 0) {
                    self.eventRef = eventRefr[0];
                    self.titleURL = self.eventRef.title.replace(/[^a-zA-Z0-9]/g, '-');
                    self.eventExpertColl = self.eventRef.lstExperts;
                }
            }
        });
        if (this.$route.params.eventId && this.$route.params.sequence) {
            self.$store.dispatch('GETEVENTSARCHIVEPLAYLIST_EVENTID', this.$route.params.eventId).then(function () {
                if (self.getArchivePlaylist) {
                    console.log('1', self.getArchivePlaylist);

                    var findPlaylist = self.getArchivePlaylist.filter(function (x) {
                        return x.eventId === self.$route.params.eventId;
                    });
                    console.log('2', findPlaylist);
                    self.playlistVideos = findPlaylist.sort(function (a, b) {
                        return parseInt(a.eventVideoId) - parseInt(b.eventVideoId);
                    });
                    if (findPlaylist && findPlaylist.length > 0) {
                        console.info('2a');
                        if (self.user) {
                            var findVideo = findPlaylist.filter(function (x) {
                                return x.eventVideoId.toString() === self.$route.params.sequence.toString();
                            });
                            if (findVideo && findVideo.length > 0) {
                                self.videoIndex = _this4.$route.params.sequence;

                                self.$store.dispatch('GET_ARCHIVE_EVENT_PLAYLIST_BY_EVENTID', _this4.$route.params.eventId).then(function () {
                                    if (self.getArchivePlaylistObject) {
                                        console.log('playlist object found ', self.getArchivePlaylistObject);
                                        self.currentVideo = self.getArchivePlaylistObject[0];
                                    }
                                });

                                self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(function () {
                                    if (self.getTaggedEmailList) {
                                        self.emailList = [];
                                        self.emailList = self.getTaggedEmailList;
                                        console.log('email list', self.getTaggedEmailList);
                                    }
                                });

                                _this4.$store.dispatch('GETCORPPAYLOAD', _this4.user.userId).then(function () {
                                    _this4.allCorps = [];
                                    if (_this4.getCorporatePayload) {
                                        _this4.corporateInfo = _this4.getCorporatePayload;
                                        _this4.allCorps = _this4.corporateInfo.lstCorporationUsers;
                                    }
                                });
                            } else {
                                self.$router.push('/events');
                            }
                        } else {
                            self.$router.push('/events');
                        }
                    } else {
                        self.$router.push('/events');
                    }
                } else {
                    self.$router.push('/events');
                }
            });
        } else {
            self.$router.push('/events');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'getCorporatePayload', 'user', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert', 'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getUserPlaylists', 'getArchivePlaylist', 'getLiveEventsArchive', 'getTaggedEmailList', 'error', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getArchivePlaylistObject', 'getItemChangeInPlaylist']))
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_masked_input__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_slick_carousel__);











/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["alert"],
        'masked-input': __WEBPACK_IMPORTED_MODULE_5_vue_masked_input__["a" /* default */],
        modal: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["modal"],
        jwplayer: __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    name: 'login',
    data: function data() {
        return {
            success: false,
            successMsg: '',
            uName: '',
            companyName: '',
            companyDescription: '',
            rawPhoneNumber: '',
            b2bComments: '',
            companySize: '',
            contactForm: {
                emailAddress: '',
                phoneNumber: '',
                reason: '',
                comments: ''
            },
            showB2BVideoModal: false,
            currentVideoPlayer: null,
            spinner: false,
            topImageUrl: '',
            topHeading: '',
            topParaLine1: '',
            topParaLine2: '',
            topParaBullet1: '',
            topParaBullet2: '',
            topParaBullet3: '',
            vidSectionImage: '',
            vidSectionHeading: '',
            vidSectionText: '',
            contSectionImage: '',
            contSectionHeading: '',
            contSectionText: '',
            evtSectionImage: '',
            evtSectionHeading: '',
            evtSectionText: '',
            collSectionImage: '',
            collSectionHeading: '',
            collSectionText: '',
            topVideo: '',
            topVideoObj: null,
            bottomPara: '',
            videoList: '',
            formLine1: '',
            formLine2: '',
            panelsHeading: '',
            videosHeading: '',
            logosHeading: '',
            testimonialHeading: '',
            formHeading: '',
            metaTag_pageTitle: 'TONE Networks for Businesses',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: '',
            testimonials: [],
            corpLogos: [],
            b2bVideos: [],
            showLinkedInCode: false,
            topVideoUrl: ''
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['error', 'user', 'getAllSiteContents', 'getAllTestimonials', 'getCompanyLogos', 'getB2BVideos', 'getB2BTopVideo', 'getCorpButtonColor'])),
    watch: {
        'topVideo': function topVideo(to, from) {
            var _this = this;

            this.$store.dispatch('GET_B2B_VIDEOS_METADATA_TOPVIDEO', this.topVideo.replace(/\s/g, '').split(',')).then(function () {
                if (_this.getB2BTopVideo) {
                    var topVideo = _this.getB2BTopVideo[0];
                    _this.topVideoUrl = topVideo.sources[topVideo.sources.length - 1].file;
                    console.log('top video object', _this.topVideoUrl);
                }
            });
        },
        'videoList': function videoList(to, from) {
            var self = this;
            if (self.videoList) {
                var videos = self.videoList.replace(/\s/g, '');
                if (videos) {
                    var videosArray = videos.split(',');
                    if (videosArray && videosArray.length > 0) {
                        self.$store.dispatch('GET_B2B_VIDEOS_METADATA', videosArray).then(function () {
                            if (self.getB2BVideos) {
                                self.b2bVideos = self.getB2BVideos;
                                setTimeout(function () {
                                    self.createVideos();
                                }, 500);
                            }
                        });
                    }
                }
            }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        var script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/v2.js';
        document.body.appendChild(script);
        script.addEventListener('load', function () {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    region: 'na1',
                    portalId: '9459028',
                    formId: 'a7b8f6c6-799e-46a9-b3eb-76528a228ec6',
                    target: '#hubspotForm'
                });
            }
        });
        var self = this;
        if (navigator.userAgent.indexOf('gonative') > -1) {
            this.isNativeApp = true;
            this.isNativeAppNavigation = true;

            __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.getJSON(self.appNavigationURL + '/sidebar_unauth.json', function (data) {
                console.log('side navigation (unuath) returned', data);
                var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
                window.location.href = 'gonative://sidebar/setItems?items=' + encodeURIComponent(json);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown);
            });

            if (navigator.userAgent.indexOf('gonativeand') <= -1) {
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.getJSON(self.appNavigationURL + '/bottomNav_unauth.json', function (data) {
                        console.log('bottom navigation (unauth) returned', data);
                        var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
                        window.location.href = 'gonative://tabs/setTabs?tabs=' + encodeURIComponent(json);
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown);
                    });
                }, 500);
            }
        }
        self.$store.dispatch('GETDYNAMICCONTENTS', 14).then(function () {
            if (self.getAllSiteContents) {
                _this2.metaTag_pageTitle = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this2.metaTag_description = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this2.metaTag_keywords = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this2.metaTag_fb_title = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this2.metaTag_fb_image = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this2.metaTag_fb_description = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this2.metaTag_fb_sitename = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this2.metaTag_tw_title = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this2.metaTag_tw_image = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this2.metaTag_tw_description = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');

                self.topImageUrl = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_IMAGE');
                self.topVideo = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_VIDEO_CODE');
                self.topHeading = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_HEADING');
                self.videoList = _this2.setDynamicSection(_this2.getAllSiteContents, 'CSV_VIDEO_CODE');
                self.topParaLine1 = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_PARA_LINE_01');
                self.topParaLine2 = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_PARA_LINE_02');
                self.topParaBullet1 = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_PARA_BULLET_01');
                self.topParaBullet2 = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_PARA_BULLET_02');
                self.topParaBullet3 = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_PARA_BULLET_03');
                self.panelsHeading = _this2.setDynamicSection(_this2.getAllSiteContents, 'PANELS_HEADING');
                self.videosHeading = _this2.setDynamicSection(_this2.getAllSiteContents, 'VIDEOS_HEADING');
                self.testimonialsHeading = _this2.setDynamicSection(_this2.getAllSiteContents, 'TESTIMONIAL_HEADING');
                self.logosHeading = _this2.setDynamicSection(_this2.getAllSiteContents, 'LOGOS_HEADING');
                self.formHeading = _this2.setDynamicSection(_this2.getAllSiteContents, 'FORM_HEADING');

                self.vidSectionImage = _this2.setDynamicSection(_this2.getAllSiteContents, 'COL_VIDEO_IMG_URL');
                self.vidSectionHeading = _this2.setDynamicSection(_this2.getAllSiteContents, 'COL_VIDEO_HEADING');
                self.vidSectionText = _this2.setDynamicSection(_this2.getAllSiteContents, 'COL_VIDEO_TEXT');

                self.contSectionImage = _this2.setDynamicSection(_this2.getAllSiteContents, 'COL_CONTENT_IMG_URL');
                self.contSectionHeading = _this2.setDynamicSection(_this2.getAllSiteContents, 'COL_CONTENT_HEADING');
                self.contSectionText = _this2.setDynamicSection(_this2.getAllSiteContents, 'COL_CONTENT_TEXT');

                self.evtSectionImage = _this2.setDynamicSection(_this2.getAllSiteContents, 'COL_EVENT_IMG_URL');
                self.evtSectionHeading = _this2.setDynamicSection(_this2.getAllSiteContents, 'COL_EVENT_HEADING');
                self.evtSectionText = _this2.setDynamicSection(_this2.getAllSiteContents, 'COL_EVENT_TEXT');

                self.collSectionImage = _this2.setDynamicSection(_this2.getAllSiteContents, 'COL_COLLECT_IMG_URL');
                self.collSectionHeading = _this2.setDynamicSection(_this2.getAllSiteContents, 'COL_COLLECT_HEADING');
                self.collSectionText = _this2.setDynamicSection(_this2.getAllSiteContents, 'COL_COLLECT_TEXT');

                self.bottomPara = _this2.setDynamicSection(_this2.getAllSiteContents, 'BOTTOM_PARA');

                self.formLine1 = _this2.setDynamicSection(_this2.getAllSiteContents, 'FORM_DESCRIPTION');
            }
        });
        this.$store.dispatch('GETTESTIMONIALS', 'B2B').then(function () {
            if (_this2.getAllTestimonials) {
                _this2.testimonials = _this2.getAllTestimonials;
                setTimeout(function () {
                    _this2.createTestimonail();
                }, 500);
            }
        });
        this.$store.dispatch('GETCOMPANYLOGOS', 'B2B').then(function () {
            if (_this2.getCompanyLogos) {
                _this2.corpLogos = _this2.getCompanyLogos;
                setTimeout(function () {
                    _this2.createLogos();
                }, 500);
            }
        });
        setTimeout(function () {
            self.$store.dispatch('CACHEPAGE', window.location.href);
        }, 2000);
    },
    methods: {
        openVideoModal: function openVideoModal(mainVideoObj, player) {
            var _this3 = this;

            if (player !== 'Top') {
                this.currentVideoPlayer = { video: mainVideoObj.sources[mainVideoObj.sources.length - 1].file, title: mainVideoObj.title, img: mainVideoObj.image, playerID: new Date(), tracks: mainVideoObj.tracks, videoDescription: mainVideoObj.longdescription };
                if (this.currentVideoPlayer) {
                    this.showB2BVideoModal = true;
                }
            } else {
                this.$store.dispatch('GET_B2B_VIDEOS_METADATA', this.topVideo.replace(/\s/g, '').split(',')).then(function () {
                    if (_this3.getB2BVideos) {
                        _this3.topVideoObj = _this3.getB2BVideos[0];
                        _this3.currentVideoPlayer = { video: _this3.topVideoObj.sources[_this3.topVideoObj.sources.length - 1].file, title: _this3.topVideoObj.title, img: _this3.topVideoObj.image, playerID: new Date(), tracks: _this3.topVideoObj.tracks, videoDescription: _this3.topVideoObj.longdescription };
                        if (_this3.currentVideoPlayer) {
                            _this3.showB2BVideoModal = true;
                        }
                    }
                });
            }
        },
        cancelModal: function cancelModal() {
            var self = this;
            var $ = __webpack_provided_window_dot_jQuery;
            setTimeout(function () {
                $('.modal-open').removeClass('modal-open');
                this.currentVideoPlayer = null;
                self.showB2BVideoModal = false;
            }, 500);
        },
        scrollToFormSection: function scrollToFormSection() {
            this.$router.push('/signup');
        },
        playVideoInPopup: function playVideoInPopup(mediaId) {
            console.log('media id', mediaId);
        },
        createTestimonail: function createTestimonail() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_7_slick_carousel___default.a;
            var $charitySlick = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el).find('.responsive-slick-display-testimonials');
            $charitySlick.slick({
                dots: false,
                infinite: true,
                speed: 1000,
                arrows: false,
                fade: true,
                cssEase: 'linear',
                autoplay: true,
                autoplaySpeed: 4000,
                useTransform: false,
                adaptiveHeight: true,
                pauseOnFocus: true,
                pauseOnHover: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        },
        createLogos: function createLogos() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_7_slick_carousel___default.a;
            var $logoSlick = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el).find('.responsive-slick-display-logos');
            $logoSlick.slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 5,
                slidesToScroll: 1,
                cssEase: 'linear',
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        },
        createVideos: function createVideos() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_7_slick_carousel___default.a;
            var $logoSlick = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el).find('.responsive-slick-display-videos');
            $logoSlick.slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        verifyEmail: function verifyEmail(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this4 = this;

            this.showLinkedInCode = false;
            if (this.verifyEmail(this.contactForm.emailAddress)) {
                this.b2bComments = 'Sent from B2B Page! ';
                var cDescription = this.companyDescription ? this.companyDescription : 'Not provided';

                this.b2bComments = this.b2bComments + (' User/Sender Name: ' + this.uName + ', Company Name: ' + this.companyName + ', Company Description: ' + cDescription);
                this.contactForm.comments = this.b2bComments;
                this.spinnerToggle();
                this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(function () {
                    _this4.spinnerToggle();
                    _this4.showLinkedInCode = true;
                    window.fbq('track', 'Lead');
                    window.logEvents('B2B Page', 'Request a Demo Form', 'submit');
                    _this4.$swal({
                        title: 'Sent!',
                        text: 'Thank you! We will get back to you shortly',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                });
            }
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_masked_input__ = __webpack_require__(30);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"],
        'masked-input': __WEBPACK_IMPORTED_MODULE_3_vue_masked_input__["a" /* default */]
    },
    name: 'login',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Contact Us',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Become an Expert' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Become an Expert' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            success: false,
            successMsg: '',
            becomeExpert: {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                reachMethod: '',
                websiteUrl: '',
                smFacebook: '',
                smInstagram: '',
                smTwitter: '',
                smLinked_in: '',
                smPinterest: '',
                smOther: '',
                howHearTone: '',
                toneMember: false,
                bioProfExp: '',
                otherPersonalInfo: '',
                joinReason: '',
                videoTopic: null,
                contentWork: false,
                contentLife: false,
                contentMind: false,
                contentMoney: false
            },
            spinner: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'user', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'])),
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this = this;

            if (this.becomeExpert.email) {
                this.spinnerToggle();
                this.$store.dispatch('BECOME_EXPERT_REQUEST', this.becomeExpert).then(function () {
                    _this.spinnerToggle();
                    _this.$swal({
                        title: 'Request Sent!',
                        text: 'We will get back to your shortly',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                });
            }
        }
    }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'viewcharity',
    data: function data() {
        return {
            selectedCharity: ''
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['error', 'getCharity'])),
    mounted: function mounted() {
        var _this = this;

        this.$store.dispatch('GETCHARITY', this.$route.params.charityId).then(function () {
            _this.selectedCharity = _this.getCharity;
        });
    }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RulesComp_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RulesComp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__RulesComp_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'community',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        'bs-input': __WEBPACK_IMPORTED_MODULE_6_vue_strap__["input"],
        modal: __WEBPACK_IMPORTED_MODULE_6_vue_strap__["modal"],
        spinner: __WEBPACK_IMPORTED_MODULE_6_vue_strap__["spinner"],
        rulescomp: __WEBPACK_IMPORTED_MODULE_7__RulesComp_vue___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            shareImagePayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                recipientFriendEmails: null,
                eventId: '',
                customizedMessage: '',
                playlistType: 6
            },
            shareEventSelected: null,
            showCorporateImageShare: false,
            corporateShareMessage: '',
            selectedPlaylist: null,
            corpShareModalImage: '',
            showCorporateShare: false,
            corpShareModalTitle: '',
            corpShareModalDesc: '',
            selectedCorps: [],
            allCorps: [],
            shareOption: 'Corporate',
            showShareCommunity: false,
            showShareIndividual: false,
            showShareFriends: false,
            sharePlaylistType: '',
            archiveEventId: 0,
            archiveEventTitle: '',
            spinner: false,
            taggedEmails: [],
            emailList: [],
            previewMsg: 'Message Preview: \n',
            showSharedModal: false,
            shareInProcess: false,
            toggleSpinner: false,
            showRulesComp: true,
            sharingImage: '',
            sharingTitle: '',
            sharingDescription: '',
            reservationMsg: '',
            liveEventVideo: '',
            currentVideo: null,
            videoRef: '',
            eventURL: 'https://www1.dev-tonenetworks.com',
            seatReservation: {
                userEventId: 0,
                eventId: 0,
                userId: 0,
                status: 0,
                isAnonymous: 0
            },
            sharePayload: {
                tmpVideCode: '',
                sharedEmailList: '',
                sharedEmailMessage: '',
                sharedPlaylistPreview: ''
            },
            shareVideoPayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                recipientFriendEmails: null,
                playlistId: '',
                messageText: '',
                playlistType: 4
            },
            pageTitle: 'TONE Talks',
            pageDesc: 'Join Our Monthly Live Stream Events And Learn From Our Experts, Executive Coaches And Each Other. These Interactive Coaching Sessions And Panels are Designed With Your Professional And Personal Growth In Mind, So Get Your Questions Ready!',
            talkHeading: 'TONE TALKS',
            talkDesc: 'oin us in our moderated discussions and tap into the wisdom of women helping women.  At TONE, we believe all women have something to share.',
            liveHeading: 'UPCOMING TONE TALKS',
            liveDesc: '',
            archiveHeading: 'IN CASE YOU MISSED IT',
            archiveDesc: 'Check out our playlists of highlights from past TONE Live events',
            metaTag_pageTitle: '',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: ''
        };
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        setTimeout(function () {
            window.addeventatc.refresh();
        }, 2000);
        this.$store.dispatch('GETEVENTLIST').then(function () {
            if (self.getMainEvent) {
                console.log('hjkshdkjhsdhsdjk', self.getMainEvent);
                self.calculateTimeToStartEvent(self.getMainEvent.start_date, self.getMainEvent.end_date, self.getMainEvent.eventSwitchTime, self.getEventSwitchTime);
                _this.$store.dispatch('GETEXPERT', _this.getMainEvent.expertId).then(function () {
                    if (self.getMainEvent.type === '1') {
                        self.sharingTitle = 'TONE Live: ' + self.getMainEvent.title + ' with ' + self.getExpert[0].name;
                        self.sharingImage = self.getMainEvent.img_url;
                        self.sharingDescription = self.getMainEvent.longDescription;
                    } else {
                        self.sharingTitle = 'TONE Talk: ' + self.getMainEvent.title + ' with ' + self.getExpert[0].name;
                        self.sharingImage = self.getMainEvent.img_url;
                        self.sharingDescription = self.getMainEvent.longDescription;
                    }
                    self.$store.dispatch('CACHEPAGE', window.location.href);
                    if (self.getMainEvent.jw_stream_title && self.getMainEvent.jw_stream_title.length > 2) {
                        self.$store.dispatch('GETCURRENTVIDEO', self.getMainEvent.jw_stream_title).then(function () {
                            if (self.getCurrentVideo) {
                                var videoObj = self.getCurrentVideo[0];
                                self.currentVideo = {
                                    video: videoObj.sources[videoObj.sources.length - 1].file,
                                    title: videoObj.title,
                                    img: videoObj.image,
                                    playerID: new Date(),
                                    tracks: videoObj.tracks,
                                    Description: videoObj.description,
                                    mediaId: videoObj.mediaid,
                                    isMute: true
                                };
                                self.videoRef = window['currentVideoId'];
                            }
                        });
                    }
                });
            }
            setTimeout(function () {
                _this.createCarousal();
            }, 2000);
        });

        this.$store.dispatch('GETALLEXPERTS').then(function () {});
        this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(function () {});
        this.$store.dispatch('GETEVENTSARCHIVE').then(function () {});

        this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(function () {
            _this.allCorps = [];
            if (_this.getCorporatePayload) {
                _this.corporateInfo = _this.getCorporatePayload;
                _this.allCorps = _this.corporateInfo.lstCorporationUsers;
            }
        });

        self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(function () {
            if (self.getTaggedEmailList) {
                self.emailList = [];
                self.emailList = self.getTaggedEmailList;
            }
        });
        this.$store.dispatch('GETUNAUTHVIDEOS', 'DEFAULT').then(function () {
            if (_this.getLiveEventVideo) {
                _this.liveEventVideo = { video: _this.getLiveEventVideo.sources[_this.getLiveEventVideo.sources.length - 2].file, title: _this.getLiveEventVideo.title, img: _this.getLiveEventVideo.image, playerID: new Date(), tracks: _this.getLiveEventVideo.tracks, isMute: false, showCaptions: true, autoStart: false };
            }
        });
        self.$store.dispatch('GETDYNAMICCONTENTS', 17).then(function () {
            if (self.getAllSiteContents) {
                self.pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'PAGE_HEADING');
                self.pageDesc = _this.setDynamicSection(_this.getAllSiteContents, 'PAGE_DESCRIPTION');
                self.liveHeading = _this.setDynamicSection(_this.getAllSiteContents, 'UPCOMING LIVE EVENTS');
                self.talkHeading = _this.setDynamicSection(_this.getAllSiteContents, 'TALK_HEADING');
                self.talkDesc = _this.setDynamicSection(_this.getAllSiteContents, 'TALK_DESCRIPTION');
                self.archiveHeading = _this.setDynamicSection(_this.getAllSiteContents, 'ARCHIVE_HEADING');
                self.archiveDesc = _this.setDynamicSection(_this.getAllSiteContents, 'ARCHIVE_DESCRIPTION');

                _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
            }
            setTimeout(function () {
                if (self.$route.params.section && self.$route.params.section === 'in-case-you-missed-it') {
                    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html,body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#missed').offset().top }, 900);
                }
            }, 3500);
        });
    },
    watch: {
        'sharePayload.sharedEmailMessage': function sharePayloadSharedEmailMessage(to, from) {
            var self = this;
            var oriiginalMessage = self.user.firstName + ' shared a coaching tips playlist with you on Tone Networks: \n' + self.archiveEventTitle + ' \n';
            if (self.showSharedModal && self.sharePayload.sharedEmailMessage && self.sharePayload.sharedEmailMessage.length > 0) {
                self.sharePayload.sharedPlaylistPreview = '' + self.previewMsg + oriiginalMessage + self.sharePayload.sharedEmailMessage;
            } else {
                self.sharePayload.sharedPlaylistPreview = self.previewMsg + ' ' + self.user.firstName + ' shared a coaching tips playlist with you on Tone Networks: \n' + self.archiveEventTitle + ' \n';
            }
        },
        'shareOption': function shareOption(to, from) {
            var self = this;
            self.selectedCorps = null;
            self.corporateShareMessage = '';
            self.taggedEmails = [];
        }
    },
    methods: {
        replaceLastExpert: function replaceLastExpert(strArray, chr, newChr) {
            var a = strArray.split('');
            a[strArray.lastIndexOf(chr)] = newChr;
            return a.join('').replace('/,/g', ', ');
        },
        shareCorporateImage: function shareCorporateImage() {
            var self = this;
            self.shareImagePayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0;
            self.shareImagePayload.senderUserId = self.user.userId;
            self.shareImagePayload.recipientsUserIds = [];
            self.shareImagePayload.recipientFriendEmails = null;
            self.shareImagePayload.customizedMessage = self.corporateShareMessage;
            if (self.shareOption === 'Corporate') {
                self.shareImagePayload.recipientsUserIds = [];
                self.shareImagePayload.recipientFriendEmails = null;
            } else if (self.shareOption === 'Individual') {
                self.shareImagePayload.recipientFriendEmails = null;
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    self.shareImagePayload.recipientsUserIds = self.selectedCorps.map(function (x) {
                        return x.userId;
                    });
                }
            } else if (self.shareOption === 'Friends') {
                self.shareImagePayload.recipientsUserIds = [];
                var emailArray = self.taggedEmails.map(function (x) {
                    return x.name;
                });
                self.shareImagePayload.recipientFriendEmails = emailArray.join(',');
            } else {}
            self.shareImagePayload.eventId = self.shareEventSelected.eventId;
            self.shareInProcess = true;

            self.$store.dispatch('CORP_EVENT_SHARE', { payload: self.shareImagePayload }).then(function () {
                if (!self.error.show) {
                    self.spinnerToggle();
                    self.$swal({
                        title: 'Event has been shared!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });

                    self.cancelCorporateImageModal();
                } else {
                    self.cancelCorporateImageModal();
                }
            });
        },
        openCorporateImageShareModal: function openCorporateImageShareModal(tEvent) {
            console.log('event for share', tEvent);
            var self = this;
            self.shareInProcess = false;
            self.shareEventSelected = tEvent;
            self.corpShareModalImage = tEvent.img_url;
            self.corpShareModalDesc = tEvent.description;
            self.corpShareModalTitle = tEvent.title;
            self.showCorporateImageShare = true;
        },
        cancelCorporateImageModal: function cancelCorporateImageModal() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateImageShare = false;
                self.shareInProcess = false;
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        shareCorporateVideo: function shareCorporateVideo() {
            var self = this;
            self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0;
            self.shareVideoPayload.senderUserId = self.user.userId;
            self.shareVideoPayload.recipientsUserIds = [];
            self.shareVideoPayload.recipientFriendEmails = null;
            self.shareVideoPayload.messageText = self.corporateShareMessage;
            if (self.shareOption === 'Corporate') {
                self.shareVideoPayload.recipientsUserIds = [];
                self.shareVideoPayload.recipientFriendEmails = null;
            } else if (self.shareOption === 'Individual') {
                self.shareVideoPayload.recipientFriendEmails = null;
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    self.shareVideoPayload.recipientsUserIds = self.selectedCorps.map(function (x) {
                        return x.userId;
                    });
                }
            } else if (self.shareOption === 'Friends') {
                self.shareVideoPayload.recipientsUserIds = [];
                var emailArray = self.taggedEmails.map(function (x) {
                    return x.name;
                });
                self.shareVideoPayload.recipientFriendEmails = emailArray.join(',');
            } else {}
            self.shareVideoPayload.playlistId = self.archiveEventId;

            if (!self.shareInProcess) {
                self.$store.dispatch('PLAYLISTCORPORATESHARE', { payload: self.shareVideoPayload }).then(function () {
                    if (!self.error.show) {
                        self.spinnerToggle();
                        self.$swal({
                            title: 'Playlist has been shared!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });

                        self.cancelCorporateModal();
                    } else {
                        self.cancelCorporateModal();
                    }
                });
            }
            self.shareInProcess = true;
        },
        maskEmailAddress: function maskEmailAddress(userEmail) {
            var avg = void 0,
                splitted = void 0,
                part1 = void 0,
                part2 = void 0;
            splitted = userEmail.split('@');
            part1 = splitted[0];
            var regex = /[^0-9.]/g;
            var maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1);
            console.log('maked', maskid);
            avg = part1.length / 2;
            part1 = part1.substring(0, part1.length - avg);
            part2 = splitted[1];
            var maskDomain = part2.split('.');
            return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1];
        },
        customLabel: function customLabel(option) {
            var findDuplicate = this.allCorps.find(function (x) {
                return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId;
            });

            if (findDuplicate) {
                var maskedEmail = this.maskEmailAddress(option.email);
                return option.firstName + ' ' + option.lastName + ' <' + maskedEmail + '>';
            } else {
                return option.firstName + ' ' + option.lastName;
            }
        },
        openCorporateShareModal: function openCorporateShareModal(playlistObj) {
            var self = this;
            self.shareInProcess = false;
            self.corpShareModalImage = playlistObj.img_url;
            self.corpShareModalDesc = playlistObj.description;
            self.corpShareModalTitle = playlistObj.title;
            self.selectedPlaylist = playlistObj;
            this.archiveEventId = playlistObj.eventId;
            self.showCorporateShare = true;

            if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareEventCoachingTipPermission >= 1) {
                var rights = self.user.corporation.corpSharingPermissions.shareEventCoachingTipPermission;
                console.log('rights', rights);
                if (rights === 1) {
                    self.showShareCommunity = true;
                    self.showShareIndividual = true;
                    self.showShareFriends = true;
                } else if (rights === 2) {
                    self.showShareCommunity = true;
                    self.showShareIndividual = false;
                    self.showShareFriends = false;
                    self.shareOption = 'Corporate';
                } else if (rights === 3) {
                    self.showShareCommunity = false;
                    self.showShareFriends = false;
                    self.showShareIndividual = true;
                    self.shareOption = 'Individual';
                } else if (rights === 5) {
                    self.showShareCommunity = false;
                    self.showShareIndividual = false;
                    self.showShareFriends = true;
                    self.shareOption = 'Friends';
                } else {
                    self.showShareCommunity = false;
                    self.showShareIndividual = false;
                    self.showShareFriends = false;
                }
            }
        },
        showSharingModal: function showSharingModal(playlistObj) {
            console.log('playlist obj', playlistObj);
            var self = this;
            if (self.user && self.user.corporation === null) {
                self.openModalShare(playlistObj.eventId, playlistObj.title);
            } else {
                self.openCorporateShareModal(playlistObj);
            }
        },
        verifyEmailShare: function verifyEmailShare(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        addTag: function addTag(newTag) {
            var self = this;
            console.log('newTAg', newTag);
            var tag = {
                name: newTag
            };
            if (self.verifyEmailShare(newTag)) {
                self.emailList.push(tag);
                this.taggedEmails.push(tag);
                console.log('tagged emails', this.taggedEmails);
            } else {
                console.log('invalid email address, calling swal');
            }
        },
        cancelCorporateModal: function cancelCorporateModal() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateShare = false;
                self.shareInProcess = false;
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        cancelEmailShareModal: function cancelEmailShareModal() {
            var self = this;
            var $ = __webpack_provided_window_dot_jQuery;
            self.sharePayload.tmpVideCode = '';
            self.sharePayload.sharedEmailList = '';
            self.sharePayload.sharedEmailMessage = '';
            self.sharePayload.sharedPlaylistPreview = self.user.firstName + ' ' + self.user.lastName + ' shared an event archive playlist with you on TONE Networks: \n' + self.archiveEventTitle + ' \n';
            setTimeout(function () {
                self.showSharedModal = false;
                self.archiveEventId = 0;
                self.archiveEventTitle = '';
                self.sharePayload.sharedPlaylistPreview = '';

                $('.modal-open').removeClass('modal-open');
            }, 500);
        },
        verifyEmail: function verifyEmail(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onSharePlaylist: function onSharePlaylist() {
            var self = this;
            self.spinnerToggle();
            var emailArray = self.taggedEmails.map(function (x) {
                return x.name;
            });
            self.sharePayload.sharedPlaylistPreview = self.user.firstName + ' shared a coaching tips playlist with you on Tone Networks: \n' + self.archiveEventTitle + '\n' + self.sharePayload.sharedEmailMessage;
            var sharePayload = {
                csvEmailRecepients: emailArray.join(','),
                userId: self.user.userId,
                playlistId: self.archiveEventId,
                customizedMessage: self.sharePayload.sharedPlaylistPreview
            };
            self.$store.dispatch('ARCHIVE_PLAYLIST_SHARE', { payload: sharePayload }).then(function () {
                if (!self.error.show) {
                    self.spinnerToggle();
                    self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(function () {
                        if (self.getTaggedEmailList) {
                            self.emailList = [];
                            self.emailList = self.getTaggedEmailList;
                            self.taggedEmails = [];
                            self.sharePayload.sharedPlaylistPreview = '';
                        }
                    });
                    self.$swal({
                        title: 'Email Sent!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    self.cancelEmailShareModal();
                } else {
                    self.spinnerToggle();
                    self.cancelEmailShareModal();
                }
            });
        },
        openModalShare: function openModalShare(eventId, eventTitle) {
            this.archiveEventId = eventId;
            this.archiveEventTitle = eventTitle;
            this.showSharedModal = true;
        },
        calendarLogging: function calendarLogging(event, title) {
            var self = this;
            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);
            userPayload.push(self.$route.fullPath);
            userPayload.push('ADD_TO_CALENDAR');
            userPayload.push(title);
            self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload);
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        calculateTimeToStartEvent: function calculateTimeToStartEvent(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var self = this;
            var eventDate = new Date(evtDate);

            var currentDate = this.returnEasternTime();
            var switchTime = parseInt(defaultSwitchTime);
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime) {} else {
                    var timeToStart = this.getMinutesBetweenDates(currentDate, eventDate) - switchTime;
                    if (timeToStart > 0 && timeToStart <= 90) {
                        var timeToTrigger = parseInt(timeToStart * 60 * 1000);
                        setTimeout(function () {
                            self.toggleSpinner = true;
                            self.showRulesComp = false;
                            setTimeout(function () {
                                self.showRulesComp = true;
                                self.toggleSpinner = false;
                            }, 1500);
                        }, timeToTrigger + 60);
                    }
                }
            }
        },
        playVideoArchive: function playVideoArchive(eventId, eventTitle) {
            this.$router.push('/tonearchive/' + eventId + '/play/1/' + eventTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
        },
        createCarousal: function createCarousal() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_2_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var pHours = this.getPacificTime(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET' + ' / ' + pHours + ' PT';
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET' + ' / ' + pHours + ' PT';
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET' + ' / ' + pHours + ' PT';
            }
        },
        getExpertInfo: function getExpertInfo(expertId, info) {
            var reqInfo = void 0;
            if (this.getAllExperts) {
                var expert = this.getAllExperts.filter(function (exp) {
                    return exp.expertId === expertId;
                });
                if (info === 'name') {
                    reqInfo = expert[0].name;
                } else if (info === 'img') {
                    reqInfo = expert[0].small_image;
                } else if (info === 'biography') {
                    reqInfo = expert[0].biography;
                } else if (info === 'experties') {
                    reqInfo = expert[0].experties;
                }
            }
            return reqInfo;
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'p.m.' : 'a.m.';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = minutes > 0 ? hours + ':' + minutes + ' ' + ampm : hours + ' ' + ampm;
            return strTime;
        },
        getPacificTime: function getPacificTime(time) {
            var hours = time.getHours() - 3;
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'p.m.' : 'a.m.';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = minutes > 0 ? hours + ':' + minutes + ' ' + ampm : hours + ' ' + ampm;
            return strTime;
        },
        isUserEntrolled: function isUserEntrolled(eventId) {
            if (this.getUserEvents) {
                var filter = this.getUserEvents.filter(function (ev) {
                    return ev.eventId === eventId;
                });
                if (filter && filter.length > 0) {
                    return true;
                }
            }
            return false;
        },
        getMinutesBetweenDates: function getMinutesBetweenDates(startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime();
            return diff / 60000;
        },
        isEventToday: function isEventToday(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var eventDate = new Date(evtDate);
            var eventEndDate = new Date(endDate);
            var currentDate = this.returnEasternTime();
            var switchTime = parseInt(defaultSwitchTime);
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        timeLeftInEvent: function timeLeftInEvent(evtDate) {
            var eventDate = new Date(evtDate);
            var currentDate = this.returnEasternTime();
            return this.getMinutesBetweenDates(currentDate, eventDate);
        },
        showJoin: function showJoin(eventId) {
            var event = this.getEventList.filter(function (evn) {
                return evn.eventId === eventId;
            });
            if (this.isEventToday(event[0].start_date, event[0].end_date, event[0].eventSwitchTime, this.getEventSwitchTime)) {
                return true;
            }
            return false;
        },
        joinEvent: function joinEvent(event) {
            this.$router.push('/event/' + event.eventId);
        },
        enrollUser: function enrollUser(event) {
            var _this2 = this;

            if (event.eventId === 1) {
                window.logEvents('Events Page', 'Tone Live Seat Reserved', 'Event Title: ' + event.title);
            } else {
                window.logEvents('Events Page', 'Tone Talk Seat Reserved', 'Event Title: ' + event.title);
            }
            this.seatReservation.eventId = event.eventId;
            this.seatReservation.userId = this.user.userId;
            this.seatReservation.status = '1';
            this.seatReservation.isAnonymous = '0';
            this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(function () {
                _this2.$store.dispatch('GETALLEXPERTS').then(function () {});
                _this2.$store.dispatch('GETUSEREVENTS', _this2.user.userId).then(function () {});
            });
        },
        returnEasternTime: function returnEasternTime() {
            var offset = -5;
            if (__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelpers_js__["a" /* dateHelpers */].dstEnabled(new Date())) {
                offset = -4.0;
            }
            var clientDate = new Date();
            var utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
            var serverDate = new Date(utc + 3600000 * offset);
            return serverDate;
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['error', 'user', 'getCorporatePayload', 'getExpert', 'getEventList', 'getMainEvent', 'getTalkEvents', 'getLiveEvents', 'getLiveExperts', 'getTalkExperts', 'getAllExperts', 'getUserEvents', 'getLiveEventVideo', 'getLiveEventsArchive', 'getEventSwitchTime', 'getCurrentVideo', 'getAllSiteContents', 'getTaggedEmailList', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor']))

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_dateHelpers_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RulesComp_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RulesComp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RulesComp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_slick_carousel__);










/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        spinner: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
        rulescomp: __WEBPACK_IMPORTED_MODULE_5__RulesComp_vue___default.a,
        modal: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["modal"]
    },
    name: 'corporatecommunity',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Community',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Community' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Community' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            toggleSpinner: false,
            contentToSearch: '',
            privateEventURL: window.location.href,
            pageLimit: 6,
            pageStart: 1,
            pageEnd: 6,
            enteredValue: '',
            spinner: false,
            isBlankField: false,
            isEmptyResponse: false,
            currentPlan: '',
            signUpPath: '',
            tabs: {
                community: false,
                events: false,
                playlists: false,
                videos: false
            },
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            isNativeApp: false,
            showCorporateShare: false,
            selectedCorps: null,
            corporateShareMessage: '',
            selectedTab: '',
            shareOption: 'Corporate',
            topImage: 'https://s3.amazonaws.com/tone-assets/images/resources/GettyImages-863497498-min.jpg',
            smallImage: 'https://s3.amazonaws.com/tone-assets/images/resources/4th-of-july-blur-bokeh-450301.jpg',
            spotlightImage: 'https://s3.amazonaws.com/tone-assets-prod/images/team/Pippa-Schwarzkopf-Editor.png',
            eventURL: 'https://www1.dev-tonenetworks.com',
            corpShareModalImage: '',
            corpShareModalDesc: '',
            corpShareModalTitle: '',
            corporateInfo: null,
            selectedPlaylist: null,
            associatedCorporation: null,
            shareVideoPayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                playlistId: '',
                messageText: ''
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        console.info('inside page');
        var self = this;
        self.$store.dispatch('GETDEMOEVENTS').then(function () {
            if (self.getDemoEvent && self.getDemoEvent.demoCorporationId > 1) {
                console.log('demo event', self.getDemoEvent);
                self.$store.dispatch('GETCORPORATECLIENTFORDEMO', self.getDemoEvent.demoCorporationId).then(function () {
                    console.log('corporation reference', self.getCorporateClientForDemo);
                    if (self.getCorporateClientForDemo && self.getCorporateClientForDemo.corporationId > 0) {
                        console.log('de');
                        self.associatedCorporation = self.getCorporateClientForDemo;
                        console.info('corporation reference', self.getCorporateClientForDemo);
                        _this.$store.dispatch('GETALLEXPERTS').then(function () {});
                        _this.$store.dispatch('GETCORPEVENTS', self.associatedCorporation.corporationId).then(function () {
                            if (_this.getCorpAllEvents) {
                                _this.calculateTimeToStartEvent(_this.getCorpMainEvent.start_date, _this.getCorpMainEvent.end_date, _this.getCorpMainEvent.eventSwitchTime, _this.getEventSwitchTime);
                            }
                        });
                        _this.$store.dispatch('GETCORPEVENTSARCHIVE', self.associatedCorporation.corporationId).then(function () {
                            if (_this.getCorpArchiveEvents) {}
                        });
                        _this.$store.dispatch('GETCORPPRIVATEVIDEOS', self.associatedCorporation.corporationId).then(function () {
                            if (_this.getCorpPrivateVideos) {}
                        });
                        _this.$store.dispatch('GETCORPORATIONPINNEDMSGS', self.associatedCorporation.corporationId).then(function () {
                            if (_this.getCorporationPinnedMsgs) {}
                        });
                        _this.$store.dispatch('GETCORPPLAYLISTS', self.associatedCorporation.corporationId).then(function () {
                            if (_this.getCorpPlaylists) {}
                        });
                        _this.$store.dispatch('GETCORPSHAREDVIDEOS', _this.user.userId).then(function () {
                            if (_this.getCropUserSharedVideos) {}
                        });

                        _this.$store.dispatch('GETCORPPAYLOAD', _this.user.userId).then(function () {
                            _this.allCorps = [];
                            if (_this.getCorporatePayload) {
                                _this.corporateInfo = _this.getCorporatePayload;
                                _this.allCorps = _this.corporateInfo.lstCorporationUsers;
                            }
                        });
                        self.selectedTab = 'events';
                    } else {
                        console.info(2);
                        self.$router.push('/');
                    }
                });
            } else {
                console.info(1);
                self.$router.push('/');
            }
        });
        self.selectedTab = 'events';
    },

    watch: {
        'showCorporateShare': function showCorporateShare(to, from) {
            var self = this;
            if (self.showCorporateShare) {
                self.selectedCorps = null;
                self.corporateShareMessage = '';
                self.shareOption = 'Corporate';
            }
        },
        'selectedTab': function selectedTab(to, from) {
            var _this2 = this;

            if (this.selectedTab === 'events') {
                setTimeout(function () {
                    _this2.createCarousal();
                }, 2000);
                setTimeout(function () {
                    window.addeventatc.refresh();
                }, 2500);
            }
        },
        'shareOption': function shareOption(to, from) {
            var self = this;
            self.selectedCorps = null;
            self.corporateShareMessage = '';
        }
    },
    methods: {
        generateUnAuthTokenAndRedirect: function generateUnAuthTokenAndRedirect(status) {
            var _this3 = this;

            this.$store.dispatch('GENERATE_UNAUTH_SIGNATURE', status).then(function () {
                if (_this3.getUnauthUserSignature) {
                    _this3.$router.push('/tone/demo/live-event-demo/' + _this3.getCorpMainEvent.eventId);
                }
            });
        },
        maskEmailAddress: function maskEmailAddress(userEmail) {
            var avg = void 0,
                splitted = void 0,
                part1 = void 0,
                part2 = void 0;
            splitted = userEmail.split('@');
            part1 = splitted[0];
            var regex = /[^0-9.]/g;
            var maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1);
            console.log('maked', maskid);
            avg = part1.length / 2;
            part1 = part1.substring(0, part1.length - avg);
            part2 = splitted[1];
            var maskDomain = part2.split('.');
            return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1];
        },
        openCorporateShareModal: function openCorporateShareModal(playlistObj) {
            console.info('called');
            var self = this;
            self.corpShareModalImage = playlistObj.userPlaylistVideos[0].thumbnailURL;
            self.corpShareModalDesc = playlistObj.description;
            self.corpShareModalTitle = playlistObj.title;
            self.selectedPlaylist = playlistObj;
            self.showCorporateShare = true;
        },
        shareCorporateVideo: function shareCorporateVideo() {
            var self = this;
            self.spinnerToggle();
            self.cancelCorporateModal();
            self.$swal({
                title: 'Playlist has been shared!',
                text: '',
                type: 'success',
                timer: 3000,
                showCancelButton: false,
                showConfirmButton: false
            }).then(function () {}, function (dismiss) {
                if (dismiss === 'timer') {
                    self.spinnerToggle();
                }
            });
        },
        customLabel: function customLabel(option) {
            var findDuplicate = this.allCorps.find(function (x) {
                return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId;
            });

            if (findDuplicate) {
                var maskedEmail = this.maskEmailAddress(option.email);
                return option.firstName + ' ' + option.lastName + ' <' + maskedEmail + '>';
            } else {
                return option.firstName + ' ' + option.lastName;
            }
        },
        cancelCorporateModal: function cancelCorporateModal() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateShare = false;
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        getMinutesBetweenDates: function getMinutesBetweenDates(startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime();
            return diff / 60000;
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/watch/' + videoCode);
        },
        playPlaylist: function playPlaylist(playlistId, videoCode, playlistTitle) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/playlist/' + playlistId + '/play/' + videoCode + '/' + this.associatedCorporation.corporationId + '/' + playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
            }
        },
        playVideoArchive: function playVideoArchive(eventId, eventTitle) {
            this.$router.push('/tonearchive/' + eventId + '/play/1/' + eventTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
            location.reload();
        },
        createCarousal: function createCarousal() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_6_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        },
        getExpertInfo: function getExpertInfo(expertId, info) {
            var reqInfo = void 0;
            if (this.getAllExperts) {
                var expert = this.getAllExperts.filter(function (exp) {
                    return exp.expertId === expertId;
                });
                if (info === 'name') {
                    reqInfo = expert[0].name;
                } else if (info === 'img') {
                    reqInfo = expert[0].small_image;
                } else if (info === 'biography') {
                    reqInfo = expert[0].biography;
                } else if (info === 'experties') {
                    reqInfo = expert[0].experties;
                }
            }
            return reqInfo;
        },
        isEventToday: function isEventToday(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var eventDate = new Date(evtDate);
            var eventEndDate = new Date(endDate);
            var currentDate = this.returnEasternTime();
            var switchTime = parseInt(defaultSwitchTime);

            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET';
            }
        },
        returnEasternTime: function returnEasternTime() {
            var offset = -5;
            if (__WEBPACK_IMPORTED_MODULE_4__helpers_dateHelpers_js__["a" /* dateHelpers */].dstEnabled(new Date())) {
                offset = -4.0;
            }
            var clientDate = new Date();
            var utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
            var serverDate = new Date(utc + 3600000 * offset);
            return serverDate;
        },
        showJoin: function showJoin(eventId) {
            var event = this.getCorpAllEvents.filter(function (evn) {
                return evn.eventId === eventId;
            });
            if (this.isEventToday(event[0].start_date, event[0].end_date, event[0].eventSwitchTime, this.getEventSwitchTime)) {
                return true;
            }
            return false;
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        },

        switchTab: function switchTab(id) {
            this.selectedTab = id;
            for (var tab in this.tabs) {
                this.tabs[tab] = id === tab;
            }
        },
        redirectToSignUp: function redirectToSignUp() {
            if (this.getMarketingPlan) {
                this.$router.push('/signup/' + this.getMarketingPlan);
            } else {
                this.$router.push('/signup');
            }
        },
        initiateSearch: function initiateSearch() {
            var _this4 = this;

            this.pageStart = 1;
            this.pageEnd = 6;
            if (this.contentToSearch.length !== 0) {
                this.enteredValue = this.contentToSearch;
                this.isBlankField = false;
                this.isEmptyResponse = false;
                this.spinnerToggle();
                this.$store.dispatch('GETSEARCHRESULTS', this.contentToSearch).then(function () {
                    window.logEvents('Search Page', 'click', 'Title Searched: ' + _this4.contentToSearch);
                    if (_this4.getSearchResults['length'] !== 0) {} else {
                        _this4.isEmptyResponse = true;
                    }
                    _this4.spinnerToggle();
                });
            } else {
                this.$swal({
                    title: 'Please type something, the input field seems to be blank.',
                    text: '',
                    type: 'question',
                    timer: 3000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(function () {}, function (dismiss) {
                    if (dismiss === 'timer') {}
                });
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        limitTo: function limitTo(arr) {
            return arr.slice(this.pageStart - 1, this.pageEnd);
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoStatus: function setVideoStatus(videoObject) {
            var _this5 = this;

            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0';
                    } else {
                        exists[0].liked = '1';
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(function () {
                        _this5.$store.dispatch('GETAUTHUSERVIDEOS', _this5.user.userId);
                    });
                } else {
                    var logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    };
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {
                        _this5.$store.dispatch('GETAUTHUSERVIDEOS', _this5.user.userId);
                    });
                }
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this6 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this6.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        calculateTimeToStartEvent: function calculateTimeToStartEvent(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var _this7 = this;

            var eventDate = new Date(evtDate);
            var currentDate = this.returnEasternTime();
            var switchTime = parseInt(defaultSwitchTime);
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }
            console.log('time left in event', this.getMinutesBetweenDates(currentDate, eventDate));
            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime) {
                    console.log('event joining enabled');
                } else {
                    var timeToStart = this.getMinutesBetweenDates(currentDate, eventDate) - switchTime;
                    if (timeToStart > 0 && timeToStart <= 90) {
                        console.log('view needs to be freshed after: ', timeToStart);
                        var timeToTrigger = parseInt(timeToStart * 60 * 1000);

                        setTimeout(function () {
                            if (_this7.$route.name === 'CorporateCommunity') {
                                window.location.reload();
                            }
                        }, timeToTrigger + 60);
                    }
                }
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['error', 'user', 'getDefaultPlan', 'getAuthUserVideos', 'getUserPlaylists', 'getTrialDays', 'getCorpPrivateEvents', 'getCorpAllEvents', 'getCorpPublicEvents', 'getCorpMainEvent', 'getAllExperts', 'getCorpArchiveEvents', 'getCorpPlaylists', 'getCorporationPinnedMsgs', 'getCropUserSharedVideos', 'getCorporatePayload', 'getEventSwitchTime', 'getCorpPrivateVideos', 'getDemoEvent', 'getCorporateClientForDemo', 'getUnauthUserSignature']))
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        var script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/v2.js';
        document.body.appendChild(script);
        script.addEventListener('load', function () {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    region: 'na1',
                    portalId: '9459028',
                    formId: 'a7b8f6c6-799e-46a9-b3eb-76528a228ec6',
                    target: '#hubspotForm'
                });
            }
        });
    },
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this = this;

            if (this.contactForm.emailAddress && this.contactForm.comments) {
                this.spinnerToggle();
                this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(function () {
                    _this.spinnerToggle();
                    _this.$swal({
                        title: 'Sent!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                });
            }
        }
    }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayListTemp_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayListTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayListTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuedraggable__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'player',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        draggable: __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayListTemp_vue___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: 'TONE Playlist | ' + self.currentVideo.title,
            meta: [{ property: 'og:image', content: self.currentVideo.img }, { property: 'og:title', content: self.currentVideo.title + ' | TONE Networks' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: self.currentVideo.Description
            }, { property: 'twitter:title', content: self.currentVideo.title + ' | TONE Networks' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.currentVideo.img }, {
                property: 'twitter:description',
                content: self.currentVideo.Description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            hoverState: false,
            hoverStateTranscript: false,
            activeTab: 0,
            currentVideo: '',
            currentStatus: '',
            currentVideoCode: this.$route.params.videoCode,
            recommendationList: '',
            videoCompleted: false,
            videoSqueeze: false,
            hideLeftVideoIcons: false,
            addRightHoverWidthClass: false,
            addIconHoverWidthClass: false,
            showRateHoverBox: false,
            showShareHoverBox: false,
            showEnjoyHoverBox: false,
            addRightHoverEnjoyClass: false,
            addEnjoyHoverClass: false,
            captionTrack: '',
            viewTranscript: false,
            ratingOne: false,
            ratingTwo: false,
            ratingThree: false,
            ratingFour: false,
            hideAll: false,
            videoMessage: '',
            videoMessageIndex: Math.floor(Math.random() * 7),
            videoGif: '',
            videoGifIndex: Math.floor(Math.random() * 4),
            videoURL: window.location.href,
            playlistVideos: null,
            videoIndex: 0,
            showPlaylist: false,
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            isMobileOrDesktop: false,
            showMenuOptions: false,
            dragFlagDisabled: true,
            playlistVideoCode: '',
            playlistId: 0,
            videoLogged: false
        };
    },
    beforeDestroy: function beforeDestroy() {
        var self = this;
        if (!self.videoLogged) {
            var watchedDuration = self.getCurrentVideoDurationWatched.duration;
            if (watchedDuration >= self.getCurrentVideo[0].duration) {
                self.updateUserPlaylistVideoView(true);
            } else {
                self.updateUserPlaylistVideoView(false);
            }
        }
    },

    methods: {
        videoChangedInPlaylist: function videoChangedInPlaylist() {
            console.log('1. -------------------------> videoChangedInPlaylist():');
        },
        playlistCompleted: function playlistCompleted() {
            console.log('2. -------------------------> playlistCompleted():');
        },
        updateHoverState: function updateHoverState(isHover) {
            this.hoverState = isHover;
        },
        updateHoverStateTranscript: function updateHoverStateTranscript(isHover) {
            this.hoverStateTranscript = isHover;
        },
        updateUserPlaylistVideoView: function updateUserPlaylistVideoView(isFull) {
            var self = this;
            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (isFull) {
                self.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, self.getCurrentVideo[0].duration, 'F');
            } else {
                if (self.getCurrentVideoDurationWatched) {
                    watchedDuration = self.getCurrentVideoDurationWatched.duration;
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(self.getCurrentVideo[0].duration) * 100);
                if (watchedPercentage >= 5) {
                    self.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, watchedDuration, 'P');
                } else {
                    self.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, watchedDuration, 'N');
                }
            }
        },
        logPlaylistVideoStatus: function logPlaylistVideoStatus(playlistId, videoCode, duration, watched) {
            console.log('video code in logging', videoCode);
            var self = this;
            var payload = {
                videoCode: videoCode,
                userId: self.user.userId,
                playlistId: playlistId,
                playlistType: 3,
                playlistCode: null,
                watched: watched,
                rating: null,
                liked: null,
                durationWatched: duration && duration > 0 ? duration : 0,
                thumbnailURL: null,
                opinion: null
            };
            self.$store.dispatch('SET_PLAYLIST_VIDEOSTATUS', payload).then(function () {});
        },
        filterPlaylistOptions: function filterPlaylistOptions(playlistId) {
            console.log('playlsit id', playlistId);
            var self = this;
            if (self.getUserPlaylists) {
                var filterPlaylist = self.getUserPlaylists.filter(function (x) {
                    return x.playlistId.toString() !== playlistId.toString();
                });
                console.log('playlists', filterPlaylist);
                if (filterPlaylist && filterPlaylist.length > 0) {
                    console.info('yes');
                    return true;
                } else {
                    console.info('no');
                    return false;
                }
            } else {
                return false;
            }
        },
        callDelete: function callDelete(video) {
            var _this = this;

            var self = this;
            self.selectedVideo = video.videoCode;
            self.selectedPlaylist = self.$route.params.playlistId.toString();
            if (video.videoCode === self.$route.params.videoCode) {
                var payload = {};
                payload.videoCode = video.videoCode;
                payload.userPlaylistId = self.$route.params.playlistId.toString();
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + video.videoCode + ' + ul').toggleClass('hide');
                    if (self.getUserPlaylists) {
                        var findPlaylist = self.getUserPlaylists.filter(function (x) {
                            return x.playlistId.toString() === self.$route.params.playlistId.toString();
                        });
                        if (findPlaylist && findPlaylist.length > 0) {
                            if (findPlaylist[0].userPlaylistVideos) {
                                self.playlistVideos = findPlaylist[0];
                                if (findPlaylist[0].userPlaylistVideos) {
                                    var userPlaylistVideos = findPlaylist[0].userPlaylistVideos;
                                    var findNextVideo = userPlaylistVideos.filter(function (x) {
                                        return x.videoCode !== self.$route.params.videoCode;
                                    });
                                    if (findNextVideo && findNextVideo.length > 0) {
                                        self.playVideo(self.$route.params.playlistId.toString(), findNextVideo[0].videoCode);
                                    } else {
                                        self.$router.push('/');
                                    }
                                } else {
                                    self.$router.push('/');
                                }
                            } else {
                                self.$router.push('/');
                            }
                        } else {
                            self.$router.push('/');
                        }
                    } else {
                        self.$router.push('/');
                    }
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.videoCode;
                _payload.userPlaylistId = self.$route.params.playlistId.toString();
                _payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: _payload }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + video.videoCode + ' + ul').toggleClass('hide');
                    if (self.getUserPlaylists) {
                        var findPlaylist = self.getUserPlaylists.filter(function (x) {
                            return x.playlistId.toString() === self.$route.params.playlistId.toString();
                        });
                        if (findPlaylist && findPlaylist.length > 0) {
                            if (findPlaylist[0].userPlaylistVideos) {
                                var findVideo = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                                    return x.videoCode.toString() === self.$route.params.videoCode.toString();
                                });
                                if (findVideo && findVideo.length > 0) {
                                    self.playlistVideos = findPlaylist[0];
                                    self.videoIndex = _this.getVideoIndex(findPlaylist[0].userPlaylistVideos, self.$route.params.videoCode);
                                }
                            } else {
                                self.$router.push('/');
                            }
                        } else {
                            self.$router.push('/');
                        }
                    } else {
                        self.$router.push('/');
                    }
                });
            }
        },
        listUpdated: function listUpdated(event) {},
        getVideoIndex: function getVideoIndex(videoArray, videoCode) {
            var index;
            for (var i = 0; i < videoArray.length; ++i) {
                if (videoArray[i].videoCode === videoCode) {
                    index = i;
                    break;
                }
            }
            return index + 1;
        },
        toggleViewTranscript: function toggleViewTranscript() {
            this.viewTranscript = !this.viewTranscript;
        },
        redirectToRelatedVideos: function redirectToRelatedVideos() {
            this.$router.push('/relatedvideos');
        },
        getNextVideo: function getNextVideo(index) {
            if (index >= 0 && index < this.playlistVideos.userPlaylistVideos.length - 1) {
                return this.playlistVideos.userPlaylistVideos[index + 1];
            } else {
                return null;
            }
        },
        playVideo: function playVideo(playlistId, videoCode, playlistTitle) {
            this.updateUserPlaylistVideoView(false);
            this.$router.push('/playlist/' + playlistId + '/play/' + videoCode + '/' + this.$route.params.corporationId + '/' + playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
            setTimeout(function () {
                location.reload();
            }, 500);
        },
        onVideoComplete: function onVideoComplete() {
            var self = this;
            self.updateUserPlaylistVideoView(true);
            self.videoLogged = true;
            var nextVideoReference = this.getNextVideo(this.videoIndex - 1);
            if (nextVideoReference) {
                this.$router.push('/playlist/' + this.$route.params.playlistId + '/play/' + nextVideoReference.videoCode + '/' + this.$route.params.corporationId + '/' + this.playlistVideos.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
                setTimeout(function () {
                    location.reload();
                }, 500);
            } else {
                this.$router.push('/profile/myprogress');
            }
        },
        setUserLike: function setUserLike() {
            var _this2 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / this.getCurrentVideo[0].duration * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            if (this.currentStatus.liked === '1') {
                this.currentStatus.liked = '0';
            } else {
                this.currentStatus.liked = '1';
            }
            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this2.currentStatus = _this2.getCurrentStatus;
            });
        },
        setOpinion: function setOpinion(desc) {
            var _this3 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            var opinion = '0';
            if (desc === 'travel') {
                opinion = '1';
            } else if (desc === 'dating') {
                opinion = '2';
            } else if (desc === 'news') {
                opinion = '3';
            } else if (desc === 'recipes') {
                opinion = '4';
            } else {
                opinion = '0';
            }

            if (this.currentStatus.opinion === opinion) {
                this.currentStatus.opinion = '0';
            } else {
                this.currentStatus.opinion = opinion;
            }
            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this3.currentStatus = _this3.getCurrentStatus;
            });
        },
        setRating: function setRating(rating) {
            var _this4 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            if (this.currentStatus.rating === rating) {
                this.currentStatus.rating = '0';
            } else {
                this.currentStatus.rating = rating;
            }

            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this4.currentStatus = _this4.getCurrentStatus;
            });
        },
        logVideoEntry: function logVideoEntry() {
            var logWatchedEntry = {
                videoCode: this.$route.params.videoCode,
                userId: this.user.userId,
                playlistId: null,
                playlistCode: null,
                watched: 'N',
                rating: null,
                liked: '0',
                durationWatched: 0,
                thumbnailURL: null,
                opinion: null
            };
            this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {});
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode, videoTitle) {
            this.$router.push('/watch/' + videoCode + '/' + videoTitle.replace(/\\s/g, '-').toLowerCase());
            location.reload();
        },
        applyRatingClass: function applyRatingClass(rating) {
            if (rating === this.currentStatus.rating) {
                return true;
            } else {
                return false;
            }
        },
        setCarousal: function setCarousal() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.each(function () {
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        toggleVideoCompleted: function toggleVideoCompleted() {
            var self = this;
            self.videoCompleted = true;
            setTimeout(function () {
                self.videoSqueeze = true;
            }, 200);
        },
        replayVideo: function replayVideo() {
            var videoCode = this.$route.params.videoCode;
            this.videoCompleted = false;
            this.videoSqueeze = false;
            this.$router.push('/watch/' + videoCode);
            this.setVideoPlayerObject(videoCode);
        },
        changeHeight: function changeHeight() {
            this.hideLeftVideoIcons = true;
            this.showRateHoverBox = true;
            this.addRightHoverWidthClass = true;
            this.addIconHoverWidthClass = true;
            this.showShareHoverBox = false;
            this.showEnjoyHoverBox = false;
        },
        showSharing: function showSharing() {
            this.hideLeftVideoIcons = true;
            this.showShareHoverBox = true;
            this.addRightHoverWidthClass = true;
            this.addIconHoverWidthClass = true;
            this.showRateHoverBox = false;
            this.showEnjoyHoverBox = false;
        },
        redirectToHome: function redirectToHome() {
            this.$router.push('/');
        },
        showEnjoy: function showEnjoy() {
            this.showEnjoyHoverBox = true;
            this.hideLeftVideoIcons = true;
            this.addRightHoverEnjoyClass = true;
            this.addIconHoverWidthClass = true;
            this.addEnjoyHoverClass = true;
            this.showRateHoverBox = false;
            this.showShareHoverBox = false;
        },
        resetClass: function resetClass(bool) {
            if (bool) {
                this.hideLeftVideoIcons = false;
                this.addRightHoverWidthClass = false;
                this.addRightHoverEnjoyClass = false;
                this.addIconHoverWidthClass = false;
                this.showRateHoverBox = false;
                this.showShareHoverBox = false;
                this.showEnjoyHoverBox = false;
                this.addEnjoyHoverClass = false;
            } else {}
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.videoCode;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.videoCode;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload2 = {};
                _payload2.videoCode = video.videoCode;
                _payload2.userId = this.user.userId;
                _payload2.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload2 }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.videoCode;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this5 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this5.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        playVideoInPlylist: function playVideoInPlylist(videoObjectToPlay) {
            var self = this;
            var videoIndex = self.getCorpNewPlaylistObject.indexOf(videoObjectToPlay);
            console.log('playVideoInPlylist : actual video index', videoIndex);
            if (videoIndex > -1) {
                self.videoIndex = videoIndex + 1;
                console.log('playVideoInPlylist : video index of next video', videoIndex + 1);
                self.currentVideo = videoObjectToPlay;
                window.jwplayer().playlistItem(videoIndex);
            }
        }
    },
    watch: {
        'getItemChangeInPlaylist': function getItemChangeInPlaylist(to, from) {
            var self = this;
            if (self.getItemChangeInPlaylist) {
                self.videoIndex = self.getItemChangeInPlaylist.index + 1;
                self.currentVideo = self.getItemChangeInPlaylist.item;
            }

            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);

            console.log('getItemChangeInPlaylist : user activity', userPayload);
            this.$store.dispatch('LOGUSERACTIVITY', userPayload);

            console.log('getItemChangeInPlaylist : self.playlistId = ', self.playlistId);
            console.log('getItemChangeInPlaylist : self.currentVideo.videoCode = ', self.currentVideo.videoCode);
            console.log('getItemChangeInPlaylist : self.currentVideo.title = ', self.currentVideo.title);
            console.log('getItemChangeInPlaylist : self.currentVideo = ', self.currentVideo);

            self.$store.dispatch('GETEXPERT', self.currentVideo.expertid).then(function () {});
        }
    },
    mounted: function mounted() {
        var _this6 = this;

        var self = this;
        console.log('user id', self.user.corporationId);
        console.log('paramId', this.$route.params.corporationId);
        if (self.user && (self.user.corporation && self.user.corporation.corporationId.toString() === this.$route.params.corporationId.toString() || self.user && self.user.isSuperUser)) {
            if (self.getTrialDays < 0) {
                self.$router.push('/becomemember');
            }

            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);
            userPayload.push(self.$route.fullPath);
            console.log('user activity', userPayload);
            this.$store.dispatch('LOGUSERACTIVITY', userPayload);
            if (__WEBPACK_IMPORTED_MODULE_5_jquery___default()(window).width() > 739) {
                self.showPlaylist = true;
            } else {
                self.showPlaylist = false;
            }
            self.playlistVideoCode = this.$route.params.videoCode;
            self.playlistId = this.$route.params.playlistId;
            this.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, 0, 'N');
            if (this.$route.params.playlistId && this.$route.params.videoCode && this.$route.params.corporationId) {
                self.$store.dispatch('GETCORPPLAYLISTS', this.$route.params.corporationId).then(function () {
                    if (self.getUserPlaylists) {
                        var findPlaylist = self.getUserPlaylists.filter(function (x) {
                            return x.playlistId.toString() === self.$route.params.playlistId.toString();
                        });
                        if (findPlaylist && findPlaylist.length > 0) {
                            if (findPlaylist[0].userPlaylistVideos) {
                                var findVideo = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                                    return x.videoCode.toString() === self.$route.params.videoCode.toString();
                                });
                                if (findVideo && findVideo.length > 0) {
                                    self.playlistVideos = findPlaylist[0];
                                    self.videoIndex = _this6.getVideoIndex(findPlaylist[0].userPlaylistVideos, self.$route.params.videoCode);

                                    self.$store.dispatch('GETCURRENTVIDEO', self.$route.params.videoCode).then(function () {
                                        var video = _this6.getCurrentVideo;
                                        self.currentVideo = {
                                            video: video[0].sources[video[0].sources.length - 1].file,
                                            title: video[0].title,
                                            img: video[0].image,
                                            playerID: new Date(),
                                            tracks: video[0].tracks,
                                            Description: video[0].description,
                                            mediaId: video[0].mediaid
                                        };
                                        self.$store.dispatch('GETEXPERT', video[0].expertid).then(function () {});
                                    });

                                    self.$store.dispatch('GETVIDEOTRANSCRIPT', self.$route.params.videoCode).then(function () {});

                                    self.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', self.user.userId).then(function () {
                                        var filteredList = _this6.getAuthRecommendedVideos.filter(function (code) {
                                            return code.mediaid !== _this6.currentVideoCode;
                                        });
                                        _this6.recommendationList = filteredList;
                                        setTimeout(function () {
                                            _this6.setCarousal();
                                        }, 2000);
                                    });
                                    self.$store.dispatch('LOAD_NEW_PLAYER_CORP_PLAYLISTS', self.$route.params.playlistId).then(function () {
                                        if (self.getCorpNewPlaylistObject) {
                                            console.log('playlist object found : getCorpNewPlaylistObject = ', self.getCorpNewPlaylistObject);
                                            self.currentVideo = self.getCorpNewPlaylistObject[0];
                                        }
                                    });
                                } else {
                                    console.info('1');
                                    self.$router.push('/');
                                }
                            } else {
                                console.info('2');
                                self.$router.push('/');
                            }
                        } else {
                            console.info('3');
                            self.$router.push('/');
                        }
                    } else {
                        console.info('4');
                        self.$router.push('/');
                    }
                });
            } else {
                console.info('5');
                self.$router.push('/');
            }
        } else {
            console.info('6');
            self.$router.push('/mytone');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert', 'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getUserPlaylists', 'getTrialDays', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getCorpNewPlaylistObject', 'getItemChangeInPlaylist']), {
        styleObject: function styleObject() {
            if (this.hoverState) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor,
                    borderColor: this.getCorpButtonColor
                };
            } else {
                return {
                    color: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            }
        },
        styleObjectTranscript: function styleObjectTranscript() {
            if (this.hoverStateTranscript && this.viewTranscript) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor + ' !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                };
            } else {
                return {
                    border: '2px solid' + this.getCorpButtonColor + ' !important',
                    color: this.getCorpButtonColor
                };
            }
        }
    })
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_dateHelpers_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RulesComp_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RulesComp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RulesComp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slick_carousel__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_slick_carousel_dist_vue_slick_carousel_css__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_slick_carousel_dist_vue_slick_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_slick_carousel_dist_vue_slick_carousel_css__);












/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        spinner: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
        rulescomp: __WEBPACK_IMPORTED_MODULE_5__RulesComp_vue___default.a,
        modal: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["modal"],
        VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_7_vue_slick_carousel___default.a
    },
    name: 'corporatecommunity',
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            archiveEventId: 0,
            metaTag_pageTitle: '',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: '',
            carouselSettings: {
                'dots': false,
                'infinite': true,
                'speed': 500,
                'slidesToShow': 3,
                'slidesToScroll': 1,
                'initialSlide': 0,
                'responsive': [{
                    'breakpoint': 1024,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'infinite': true,
                        'dots': true
                    }
                }, {
                    'breakpoint': 600,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'initialSlide': 2
                    }
                }, {
                    'breakpoint': 480,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1
                    }
                }]
            },
            shareImagePayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                recipientFriendEmails: null,
                eventId: '',
                customizedMessage: '',
                playlistType: 6
            },
            shareEventSelected: null,
            showCorporateImageShare: false,
            selectedCorpId: 0,
            siblingCorps: null,
            taggedEmails: [],
            emailList: [],
            showShareCommunity: false,
            showShareIndividual: false,
            showShareFriends: false,
            toggleSpinner: false,
            contentToSearch: '',
            privateEventURL: window.location.href,
            pageLimit: 6,
            pageStart: 1,
            pageEnd: 6,
            enteredValue: '',
            spinner: false,
            isBlankField: false,
            isEmptyResponse: false,
            showCorporateSwitch: false,
            currentPlan: '',
            signUpPath: '',
            tabs: {
                community: false,
                events: false,
                playlists: false,
                videos: false
            },
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            isNativeApp: false,
            showCorporateShare: false,
            selectedCorps: null,
            corporateShareMessage: '',
            selectedTab: '',
            shareOption: 'Corporate',
            topImage: 'https://s3.amazonaws.com/tone-assets/images/resources/GettyImages-863497498-min.jpg',
            smallImage: 'https://s3.amazonaws.com/tone-assets/images/resources/4th-of-july-blur-bokeh-450301.jpg',
            spotlightImage: 'https://s3.amazonaws.com/tone-assets-prod/images/team/Pippa-Schwarzkopf-Editor.png',
            eventURL: 'https://www1.dev-tonenetworks.com',
            corpShareModalImage: '',
            corpShareModalDesc: '',
            corpShareModalTitle: '',
            corporateInfo: null,
            selectedPlaylist: null,
            shareInProcess: false,
            shareVideoPayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                recipientFriendEmails: null,
                playlistId: '',
                messageText: '',
                playlistType: 3
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        if (this.user && this.user.corporation && this.user.corporation.enableCorporatePage === 1) {
            this.selectedCorpId = this.user.corporation.corporationId;
            this.topImage = this.user.corporation.largeImage ? this.user.corporation.largeImage : 'https://s3.amazonaws.com/tone-assets/images/corporate/Image1.png';
            this.smallImage = this.user.corporation.smallImage ? this.user.corporation.smallImage : 'https://s3.amazonaws.com/tone-assets/images/resources/4th-of-july-blur-bokeh-450301.jpg';
        } else {
            this.$router.push('/mytone');
        }
        console.log('1 -> CororateCommunity.vue -> mounted () -> ');
        self.$store.dispatch('GETDYNAMICCONTENTS', 30).then(function () {
            if (self.getAllSiteContents) {
                _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
            }
        });
        this.$store.dispatch('GETALLEXPERTS').then(function () {});
        this.$store.dispatch('GETCORPEVENTS', this.user.corporation.corporationId).then(function () {
            if (_this.getCorpAllEvents) {
                _this.calculateTimeToStartEvent(_this.getCorpMainEvent.start_date, _this.getCorpMainEvent.end_date, _this.getCorpMainEvent.eventSwitchTime, _this.getEventSwitchTime);
            }
        });
        this.$store.dispatch('GETCORPEVENTSARCHIVE', this.user.corporation.corporationId).then(function () {
            if (_this.getCorpArchiveEvents) {}
        });
        this.$store.dispatch('GET_PARENT_CORPORATION', this.user.corporation.corporationId).then(function () {
            if (_this.getParentCorporation) {
                if (_this.getParentCorporation.lstCorporation && _this.getParentCorporation.lstCorporation.length >= 1) {
                    _this.siblingCorps = _this.getParentCorporation.lstCorporation;
                }
            }
        });
        this.$store.dispatch('GETCORPPRIVATEVIDEOS', this.user.corporation.corporationId).then(function () {
            if (_this.getCorpPrivateVideos) {}
        });
        this.$store.dispatch('GETCORPORATIONPINNEDMSGS', this.user.corporation.corporationId).then(function () {
            if (_this.getCorporationPinnedMsgs) {}
        });
        this.$store.dispatch('GETCORPPLAYLISTS', this.user.corporation.corporationId).then(function () {
            if (_this.getCorpPlaylists) {}
        });
        this.$store.dispatch('GETCORPSHAREDVIDEOS', this.user.userId).then(function () {
            if (_this.getCropUserSharedVideos) {}
        });

        this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(function () {
            _this.allCorps = [];
            if (_this.getCorporatePayload) {
                _this.corporateInfo = _this.getCorporatePayload;
                _this.allCorps = _this.corporateInfo.lstCorporationUsers;
            }
        });

        this.$store.dispatch('GET_TAGGED_EMAIL_LIST', this.user.userId).then(function () {
            if (_this.getTaggedEmailList) {
                _this.emailList = [];
                _this.emailList = _this.getTaggedEmailList;
                console.log('email list', self.getTaggedEmailList);
            }
        });
        this.selectedTab = 'events';
        if (this.$route.params.tab) {
            console.log('default tab', this.user.corporation);
            setTimeout(function () {
                var tab = _this.$route.params.tab;
                if (tab === 'career' || tab === 'coaching') {
                    _this.selectedTab = 'events';
                } else if (tab === 'playlists') {
                    console.info('inside playlists');
                    if (_this.getCorpPlaylists) {
                        _this.selectedTab = 'playlists';
                        console.log('playlist set');
                    } else {
                        _this.selectedTab = 'events';
                    }
                } else if (tab === 'videos') {
                    if (_this.getCorpPrivateVideos) {
                        _this.selectedTab = 'videos';
                    } else {
                        _this.selectedTab = 'events';
                    }
                } else if (tab === 'community') {
                    if (_this.user.corporation.showSpotlightSection || _this.user.corporation.showPinnedMessages) {
                        _this.selectedTab = 'community';
                    } else {
                        _this.selectedTab = 'events';
                    }
                } else {
                    _this.selectedTab = 'events';
                }
            }, 800);
        } else {
            console.log('selected tab', this.user.corporation.defaultCorpTab);
            setTimeout(function () {
                var tab = _this.user.corporation.defaultCorpTab;
                if (tab === 1) {
                    _this.selectedTab = 'events';
                } else if (tab === 3) {
                    if (_this.getCorpPlaylists) {
                        _this.selectedTab = 'playlists';
                    } else {
                        _this.selectedTab = 'events';
                    }
                } else if (tab === 4) {
                    if (_this.getCorpPrivateVideos) {
                        _this.selectedTab = 'videos';
                    } else {
                        _this.selectedTab = 'events';
                    }
                } else if (tab === 2) {
                    if (_this.user.corporation.showSpotlightSection || _this.user.corporation.showPinnedMessages) {
                        _this.selectedTab = 'community';
                    } else {
                        _this.selectedTab = 'events';
                    }
                } else {
                    _this.selectedTab = 'events';
                }
            }, 800);
        }
        setTimeout(function () {
            if ((_this.selectedTab === 'events' || _this.selectedTab === 'career') && _this.$route.params.section === 'in-case-you-missed-it' && _this.getCorpArchiveEvents) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html,body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#missed').offset().top }, 800);
            }
        }, 1000);
    },

    watch: {
        'showCorporateShare': function showCorporateShare(to, from) {
            var self = this;
            if (self.showCorporateShare) {
                self.selectedCorps = null;
                self.corporateShareMessage = '';
                self.taggedEmails = [];
            }
        },
        'selectedTab': function selectedTab(to, from) {
            if (this.selectedTab === 'events') {
                setTimeout(function () {
                    window.addeventatc.refresh();
                }, 2500);
            }
        },
        'shareOption': function shareOption(to, from) {
            var self = this;
            self.selectedCorps = null;
            self.corporateShareMessage = '';
        }
    },
    methods: {
        replaceLastExpert: function replaceLastExpert(strArray, chr, newChr) {
            var a = strArray.split('');
            a[strArray.lastIndexOf(chr)] = newChr;
            return a.join('').replace('/,/g', ', ');
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        playPlaylistForShared: function playPlaylistForShared(playlistObj) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                if (playlistObj.playlistType === 1) {
                    this.$router.push('/playlist/' + playlistObj.playlistId + '/play/' + playlistObj.videoCode);
                } else if (playlistObj.playlistType === 2) {
                    this.$router.push('/playlist/trending/' + playlistObj.playlistId + '/play/' + playlistObj.videoCode + '/' + playlistObj.videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
                } else if (playlistObj.playlistType === 3) {
                    this.$router.push('/playlist/' + playlistObj.playlistId + '/play/' + playlistObj.videoCode + '/' + this.user.corporation.corporationId + '/' + playlistObj.playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
                } else if (playlistObj.playlistType === 4) {} else {}
            }
        },
        get_regular_tagged_colleagues: function get_regular_tagged_colleagues() {
            var self = this;

            self.$store.dispatch('GETCORPPAYLOAD', self.user.userId).then(function () {
                self.allCorps = [];
                if (self.getCorporatePayload) {
                    self.corporateInfo = self.getCorporatePayload;
                    self.allCorps = self.corporateInfo.lstCorporationUsers;
                }
            });
        },
        get_private_tagged_colleagues: function get_private_tagged_colleagues() {
            var self = this;

            self.$store.dispatch('GETCORPPAYLOAD_PRIVATE_EVENT_SHARING', self.user.userId).then(function () {
                self.allCorps = [];
                if (self.getCorporatePayload) {
                    self.corporateInfo = self.getCorporatePayload;
                    self.allCorps = self.corporateInfo.lstCorporationUsers;
                }
            });
        },
        shareCorporateImage: function shareCorporateImage() {
            var self = this;
            self.shareImagePayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0;
            self.shareImagePayload.senderUserId = self.user.userId;
            self.shareImagePayload.recipientsUserIds = [];
            self.shareImagePayload.recipientFriendEmails = null;
            self.shareImagePayload.customizedMessage = self.corporateShareMessage;
            if (self.shareOption === 'Corporate') {
                self.shareImagePayload.recipientsUserIds = [];
                self.shareImagePayload.recipientFriendEmails = null;
            } else if (self.shareOption === 'Individual') {
                self.shareImagePayload.recipientFriendEmails = null;
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    self.shareImagePayload.recipientsUserIds = self.selectedCorps.map(function (x) {
                        return x.userId;
                    });
                }
            } else if (self.shareOption === 'Friends') {
                self.shareImagePayload.recipientsUserIds = [];
                var emailArray = self.taggedEmails.map(function (x) {
                    return x.name;
                });
                self.shareImagePayload.recipientFriendEmails = emailArray.join(',');
            } else {}
            self.shareImagePayload.eventId = self.shareEventSelected.eventId;
            self.shareInProcess = true;

            self.$store.dispatch('CORP_EVENT_SHARE', { payload: self.shareImagePayload }).then(function () {
                if (!self.error.show) {
                    self.spinnerToggle();
                    self.$swal({
                        title: 'Event has been shared!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });

                    self.cancelCorporateImageModal();
                } else {
                    self.cancelCorporateImageModal();
                }
            });
        },
        openCorporateImageShareModal: function openCorporateImageShareModal(tEvent) {
            console.log('event for share', tEvent);
            var self = this;
            if (tEvent.isPrivate.toString() === '1') {
                self.get_private_tagged_colleagues();
            } else {
                self.get_regular_tagged_colleagues();
            }
            self.shareInProcess = false;
            self.shareEventSelected = tEvent;
            self.corpShareModalImage = tEvent.img_url;
            self.corpShareModalDesc = tEvent.description;
            self.corpShareModalTitle = tEvent.title;
            self.showCorporateImageShare = true;
        },
        cancelCorporateImageModal: function cancelCorporateImageModal() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateImageShare = false;
                self.archiveEventId = 0;
                self.shareInProcess = false;
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        addTag: function addTag(newTag) {
            var self = this;
            console.log('newTAg', newTag);
            var tag = {
                name: newTag
            };
            if (self.verifyEmailShare(newTag)) {
                self.emailList.push(tag);
                self.taggedEmails.push(tag);
                console.log('tagged emails', this.taggedEmails);
            } else {
                console.log('invalid email address, calling swal');
            }
        },
        verifyEmailShare: function verifyEmailShare(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        switchCorporation: function switchCorporation() {
            var self = this;
            self.shareInProcess = true;
            self.$store.dispatch('SWITCH_CORPORATION', self.selectedCorpId).then(function () {
                if (self.getSwitchCorporateClient) {
                    self.shareInProcess = false;
                    self.$swal({
                        title: 'Corporation Successfully switched to : ' + self.getSwitchCorporateClient.name,
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {
                            window.location.reload();
                        }
                    });
                    self.$router.push('/mytone');
                } else {
                    self.shareInProcess = false;
                }
            });
        },
        openSwitchModal: function openSwitchModal() {
            console.log('user definition', this.user.corporation.corporationId);
            this.selectedCorpId = this.user.corporation.corporationId;
            this.showCorporateSwitch = true;
        },
        handleCorporateShareModal: function handleCorporateShareModal() {
            var self = this;
            self.showCorporateShare = true;

            if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareCompanyPlaylistPermission >= 1) {
                var rights = self.user.corporation.corpSharingPermissions.shareCompanyPlaylistPermission;
                console.log('rights', rights);
                if (rights === 1) {
                    self.showShareCommunity = true;
                    self.showShareIndividual = true;
                } else if (rights === 2) {
                    self.showShareCommunity = true;
                    self.showShareIndividual = false;
                    self.shareOption = 'Corporate';
                    self.showCorporateShare = true;
                } else if (rights === 3) {
                    self.showShareCommunity = false;
                    self.showShareIndividual = true;
                    self.shareOption = 'Individual';
                } else {
                    self.showShareCommunity = false;
                    self.showShareIndividual = false;
                }
            }
        },
        calendarLogging: function calendarLogging(event, title) {
            var self = this;
            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);
            userPayload.push(self.$route.fullPath);
            userPayload.push('ADD_TO_CALENDAR');
            userPayload.push(title);
            self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload);
        },
        maskEmailAddress: function maskEmailAddress(userEmail) {
            var avg = void 0,
                splitted = void 0,
                part1 = void 0,
                part2 = void 0;
            splitted = userEmail.split('@');
            part1 = splitted[0];
            var regex = /[^0-9.]/g;
            var maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1);
            console.log('maked', maskid);
            avg = part1.length / 2;
            part1 = part1.substring(0, part1.length - avg);
            part2 = splitted[1];
            var maskDomain = part2.split('.');
            return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1];
        },
        openCorporateShareModal: function openCorporateShareModal(type, playlistObj) {
            var self = this;
            self.get_regular_tagged_colleagues();
            self.shareInProcess = false;
            if (type === 'playlist') {
                self.corpShareModalImage = playlistObj.userPlaylistVideos[0].thumbnailURL;
                self.corpShareModalDesc = playlistObj.description;
                self.corpShareModalTitle = playlistObj.title;
                self.selectedPlaylist = playlistObj;
                self.archiveEventId = 0;
                if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareCompanyPlaylistPermission >= 1) {
                    var rights = self.user.corporation.corpSharingPermissions.shareCompanyPlaylistPermission;
                    if (rights === 1) {
                        self.showShareCommunity = true;
                        self.showShareIndividual = true;
                        self.showShareFriends = true;
                    } else if (rights === 2) {
                        self.showShareCommunity = true;
                        self.showShareIndividual = false;
                        self.showShareFriends = false;
                        self.shareOption = 'Corporate';
                    } else if (rights === 3) {
                        self.showShareCommunity = false;
                        self.showShareFriends = false;
                        self.showShareIndividual = true;
                        self.shareOption = 'Individual';
                    } else if (rights === 5) {
                        self.showShareCommunity = false;
                        self.showShareIndividual = false;
                        self.showShareFriends = true;
                        self.shareOption = 'Friends';
                    } else {
                        self.showShareCommunity = false;
                        self.showShareIndividual = false;
                        self.showShareFriends = false;
                    }
                }
            } else {
                self.corpShareModalImage = playlistObj.img_url;
                self.corpShareModalDesc = playlistObj.description;
                self.corpShareModalTitle = playlistObj.title;
                self.selectedPlaylist = playlistObj;
                self.archiveEventId = playlistObj.eventId;
                if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.corpArchiveEventOptnPermission >= 1) {
                    self.showShareCommunity = true;
                    self.showShareIndividual = true;
                    self.showShareFriends = false;
                }
            }
            self.showCorporateShare = true;
        },
        shareCorporateVideo: function shareCorporateVideo() {
            var self = this;
            self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0;
            self.shareVideoPayload.senderUserId = self.user.userId;
            self.shareVideoPayload.recipientsUserIds = [];
            self.shareVideoPayload.recipientFriendEmails = null;
            self.shareVideoPayload.messageText = self.corporateShareMessage;
            if (self.shareOption === 'Corporate') {
                self.shareVideoPayload.recipientsUserIds = [];
                self.shareVideoPayload.recipientFriendEmails = null;
            } else if (self.shareOption === 'Individual') {
                self.shareVideoPayload.recipientFriendEmails = null;
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    self.shareVideoPayload.recipientsUserIds = self.selectedCorps.map(function (x) {
                        return x.userId;
                    });
                }
            } else if (self.shareOption === 'Friends') {
                self.shareVideoPayload.recipientsUserIds = [];
                var emailArray = self.taggedEmails.map(function (x) {
                    return x.name;
                });
                self.shareVideoPayload.recipientFriendEmails = emailArray.join(',');
            } else {}
            var sharingMsg = 'Playlist has been shared!';
            if (self.archiveEventId > 0) {
                self.shareVideoPayload.playlistId = self.selectedPlaylist.eventId;
                self.shareVideoPayload.playlistType = 7;
                sharingMsg = 'Archive Playlist has been shared!';
            } else {
                self.shareVideoPayload.playlistId = self.selectedPlaylist.playlistId;

                self.shareVideoPayload.playlistType = 6;
                sharingMsg = 'Playlist has been shared!';
            }

            console.log('updated sharing payload', self.shareVideoPayload);
            if (!self.shareInProcess) {
                self.$store.dispatch('PLAYLISTCORPORATESHARE', { payload: self.shareVideoPayload }).then(function () {
                    if (!self.error.show) {
                        self.spinnerToggle();
                        self.$swal({
                            title: sharingMsg,
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });

                        self.cancelCorporateModal();
                    } else {
                        self.cancelCorporateModal();
                    }
                });
            }
            self.shareInProcess = true;
        },
        customLabel: function customLabel(option) {
            var findDuplicate = this.allCorps.find(function (x) {
                return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId;
            });

            if (findDuplicate) {
                var maskedEmail = this.maskEmailAddress(option.email);
                return option.firstName + ' ' + option.lastName + ' <' + maskedEmail + '>';
            } else {
                return option.firstName + ' ' + option.lastName;
            }
        },
        cancelCorporateModal: function cancelCorporateModal() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateShare = false;
                self.shareInProcess = false;
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        cancelCorporateSwitchModal: function cancelCorporateSwitchModal() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateSwitch = false;
                self.shareInProcess = false;
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        getMinutesBetweenDates: function getMinutesBetweenDates(startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime();
            return diff / 60000;
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode, videoTitle) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/watch/' + videoCode + '/' + videoTitle.replace(/\\s/g, '-').toLowerCase());
            }
        },
        playPlaylist: function playPlaylist(playlistId, videoCode, playlistTitle) {
            var self = this;
            if (self.getTrialDays < 0) {
                self.$router.push('/becomemember');
            } else {
                var userPayload = [];
                var uId = 0;
                if (self.user) {
                    uId = self.user.userId;
                }
                userPayload.push(uId);
                userPayload.push(self.$route.fullPath);
                userPayload.push('CORP_PLAYLIST_CLICK');
                userPayload.push(playlistTitle);
                self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload);
                this.$router.push('/playlist/' + playlistId + '/play/' + videoCode + '/' + this.user.corporation.corporationId + '/' + playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
            }
        },
        playVideoArchive: function playVideoArchive(eventId, eventTitle) {
            var self = this;
            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);
            userPayload.push(self.$route.fullPath);
            userPayload.push('CORP_ARHIVE_CLICK');
            userPayload.push(eventTitle);
            self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload);
            this.$router.push('/tonearchive/' + eventId + '/play/1/' + eventTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
        },
        createCarousal: function createCarousal() {
            if (this.selectedTab === 'events') {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_6_slick_carousel___default.a;
                var $slick = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).find('.responsive-slick-slider');
                $slick.slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            }
        },
        getExpertInfo: function getExpertInfo(expertId, info) {
            var reqInfo = void 0;
            if (this.getAllExperts) {
                var expert = this.getAllExperts.filter(function (exp) {
                    return exp.expertId === expertId;
                });
                if (info === 'name') {
                    reqInfo = expert[0].name;
                } else if (info === 'img') {
                    reqInfo = expert[0].small_image;
                } else if (info === 'biography') {
                    reqInfo = expert[0].biography;
                } else if (info === 'experties') {
                    reqInfo = expert[0].experties;
                }
            }
            return reqInfo;
        },
        isEventToday: function isEventToday(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var eventDate = new Date(evtDate);
            var eventEndDate = new Date(endDate);
            var currentDate = this.returnEasternTime();
            var switchTime = parseInt(defaultSwitchTime);

            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var pHours = this.getPacificTime(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET' + ' / ' + pHours + ' PT';
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET' + ' / ' + pHours + ' PT';
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET' + ' / ' + pHours + ' PT';
            }
        },
        returnEasternTime: function returnEasternTime() {
            var offset = -5;
            if (__WEBPACK_IMPORTED_MODULE_4__helpers_dateHelpers_js__["a" /* dateHelpers */].dstEnabled(new Date())) {
                offset = -4.0;
            }
            var clientDate = new Date();
            var utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
            var serverDate = new Date(utc + 3600000 * offset);
            return serverDate;
        },
        showJoin: function showJoin(eventId) {
            var event = this.getCorpAllEvents.filter(function (evn) {
                return evn.eventId === eventId;
            });
            if (this.isEventToday(event[0].start_date, event[0].end_date, event[0].eventSwitchTime, this.getEventSwitchTime)) {
                return true;
            }
            return false;
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = minutes > 0 ? hours + ':' + minutes + ' ' + ampm : hours + ' ' + ampm;
            return strTime;
        },
        getPacificTime: function getPacificTime(time) {
            var hours = time.getHours() - 3;
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'p.m.' : 'a.m.';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = minutes > 0 ? hours + ':' + minutes + ' ' + ampm : hours + ' ' + ampm;
            return strTime;
        },

        switchTab: function switchTab(id) {
            var self = this;
            var tabName = id;
            if (id === 'events') {
                tabName = 'coaching events';
            }
            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);
            userPayload.push(self.$route.fullPath);
            userPayload.push('MY_COMMUNITY_TAB_CHANGED');
            userPayload.push(tabName);
            self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload);
            self.selectedTab = id;
            for (var tab in self.tabs) {
                this.tabs[tab] = id === tab;
            }
        },
        redirectToSignUp: function redirectToSignUp() {
            if (this.getMarketingPlan) {
                this.$router.push('/signup/' + this.getMarketingPlan);
            } else {
                this.$router.push('/signup');
            }
        },
        initiateSearch: function initiateSearch() {
            var _this2 = this;

            this.pageStart = 1;
            this.pageEnd = 6;
            if (this.contentToSearch.length !== 0) {
                this.enteredValue = this.contentToSearch;
                this.isBlankField = false;
                this.isEmptyResponse = false;
                this.spinnerToggle();
                this.$store.dispatch('GETSEARCHRESULTS', this.contentToSearch).then(function () {
                    window.logEvents('Search Page', 'click', 'Title Searched: ' + _this2.contentToSearch);
                    if (_this2.getSearchResults['length'] !== 0) {} else {
                        _this2.isEmptyResponse = true;
                    }
                    _this2.spinnerToggle();
                });
            } else {
                this.$swal({
                    title: 'Please type something, the input field seems to be blank.',
                    text: '',
                    type: 'question',
                    timer: 3000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(function () {}, function (dismiss) {
                    if (dismiss === 'timer') {}
                });
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        limitTo: function limitTo(arr) {
            return arr.slice(this.pageStart - 1, this.pageEnd);
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoStatus: function setVideoStatus(videoObject) {
            var _this3 = this;

            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0';
                    } else {
                        exists[0].liked = '1';
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(function () {
                        _this3.$store.dispatch('GETAUTHUSERVIDEOS', _this3.user.userId);
                    });
                } else {
                    var logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    };
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {
                        _this3.$store.dispatch('GETAUTHUSERVIDEOS', _this3.user.userId);
                    });
                }
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this4 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this4.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        calculateTimeToStartEvent: function calculateTimeToStartEvent(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var _this5 = this;

            var eventDate = new Date(evtDate);
            var currentDate = this.returnEasternTime();
            var switchTime = parseInt(defaultSwitchTime);
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime) {} else {
                    var timeToStart = this.getMinutesBetweenDates(currentDate, eventDate) - switchTime;
                    if (timeToStart > 0 && timeToStart <= 90) {
                        var timeToTrigger = parseInt(timeToStart * 60 * 1000);

                        setTimeout(function () {
                            if (_this5.$route.name === 'CorporateCommunity') {
                                window.location.reload();
                            }
                        }, timeToTrigger + 60);
                    }
                }
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['error', 'user', 'getDefaultPlan', 'getAuthUserVideos', 'getUserPlaylists', 'getTrialDays', 'getCorpPrivateEvents', 'getCorpAllEvents', 'getCorpPublicEvents', 'getCorpMainEvent', 'getAllExperts', 'getCorpArchiveEvents', 'getCorpPlaylists', 'getCorporationPinnedMsgs', 'getCropUserSharedVideos', 'getCorporatePayload', 'getEventSwitchTime', 'getCorpPrivateVideos', 'getTaggedEmailList', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getParentCorporation', 'getSwitchCorporateClient', 'getAllSiteContents']))
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authorizedUsersList__ = __webpack_require__(350);








/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["accordion"],
        'panel': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["panel"],
        alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
        dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["dropdown"],
        radio: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["radio"],
        VuePassword: __WEBPACK_IMPORTED_MODULE_3_vue_password___default.a,
        checkbox: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        tabs: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tabs"],
        tab: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tab"],
        buttonGroup: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"],
        datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["datepicker"]
    },
    name: 'signUp',
    data: function data() {
        return {
            gifter: {
                userId: 0,
                email: '',
                firstName: '',
                lastName: '',
                cardHolderName: '',
                stripeCustomerId: '',
                packageId: '',
                userPayments: [],
                totalGiftedAmount: 0,
                userGifts: '',
                corporationId: 0
            },
            giftee: {
                gifteeFirstName: '',
                gifteeLastName: '',
                gifteeEmail: '',
                deliveryDate: '',
                deliveryMessage: '',
                redeemDate: null,
                packageId: null
            },
            userPayments: {
                token: '',
                stripeCardId: '',
                paymentType: 'CC',
                paymentDate: new Date(),
                paypalPayerId: '',
                paypalPaymentId: '',
                paymentMethodNonce: ''
            },
            gifteeValidated: true,
            spinner: false,
            alert: false,
            passwordError: '',
            confirmPassword: '',
            stripe: '',
            card: '',
            panelStatus: false,
            createSection: true,
            paymentSection: false,
            isToggle: false,
            defaultPlan: '',
            isChecked: false,

            stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo',
            daysToCancel: 0,
            isStripe: true,
            gateway: 'CC',
            packageId: 0,
            gifteeCol: [],
            giftPlans: '',
            totalAmount: 0.00,
            minimumDate: new Date(),
            addMessage: 'Buy Gift',
            dateErrorMessage: 'Delivery date must be ' + this.returnMinimumDate() + ' or later',
            dateFormat: 'mm/dd/yyyy',
            stripeErrorMessage: '',
            csvFile: '',
            clientId: 0
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (!__WEBPACK_IMPORTED_MODULE_4__authorizedUsersList__["a" /* isUserAuthorized */](this.user.email)) {
            this.$router.push('/');
        }
        this.$store.dispatch('GETPLANS').then(function () {
            _this.packageId = _this.getAllPlans[0].packageId;
            _this.giftPlans = _this.getAllPlans.filter(function (pln) {
                return pln.type.toLowerCase() === 'gift';
            });
            if (_this.getSelectedGiftId) {
                _this.packageId = _this.getSelectedGiftId.giftId;
            } else {
                _this.packageId = _this.giftPlans[0].packageId;
            }
        });
        if (this.user !== null) {
            if (this.user.firstName.length > 0) {
                this.gifter.firstName = this.user.firstName;
                this.gifter.lastName = this.user.lastName;
                this.gifter.email = this.user.email;
                this.gifter.cardHolderName = this.user.firstName + ' ' + this.user.lastName;
            }
        }

        this.$store.dispatch('GETCORPORATECLIENTS').then(function () {
            if (_this.getCorporateClients) {
                _this.clientId = _this.getCorporateClients[0].corporationId;
            }
        });
    },

    methods: {
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.readCSVFile(files[0]);
            }
        },
        readCSVFile: function readCSVFile(file) {
            var self = this;
            var reader = new FileReader();
            reader.readAsText(file);
            reader.onload = function (e) {
                var contents = e.target.result;
                self.processCSVFile(contents);
            };
        },
        processCSVFile: function processCSVFile(csv) {
            var allTextLines = csv.split(/\r\n|\n/);
            var lines = [];
            for (var i = 1; i < allTextLines.length; i++) {
                var data = allTextLines[i].split(',');
                var tarr = [];
                for (var j = 0; j < data.length; j++) {
                    tarr.push(data[j]);
                }
                lines.push(tarr);
            }
            console.log(lines);
            if (lines && lines.length > 0) {
                for (var k = 0; k < lines.length; k++) {
                    var newGiftee = {};
                    newGiftee.packageId = this.packageId;
                    newGiftee.gifteeFirstName = lines[k][0];
                    newGiftee.gifteeLastName = lines[k][1];
                    newGiftee.gifteeEmail = lines[k][2].toLowerCase();
                    newGiftee.deliveryMessage = lines[k][3];
                    newGiftee.deliveryDate = this.returnFormatedDate(lines[k][4], 'M');
                    newGiftee.redeemDate = null;
                    this.gifteeCol.push(newGiftee);
                }
            }
        },
        togglePaymentMethods: function togglePaymentMethods() {
            var _this2 = this;

            if (this.gateway === 'paypal') {
                this.isStripe = false;
                setTimeout(function () {
                    _this2.mountbraintree();
                }, 1000);
            } else {
                this.isStripe = true;
                this.mountStripeElement();
            }
        },
        mountbraintree: function mountbraintree() {
            var self = this;
            if (self.getPaypalToken) {
                window.braintree.client.create({
                    authorization: 'production_6r7mxqgh_htw3nq9wp32w8h2x'
                }, function (clientErr, clientInstance) {
                    if (clientErr) {
                        console.error('Error creating client:', clientErr);
                        return;
                    }

                    window.braintree.paypalCheckout.create({
                        client: clientInstance
                    }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                        if (paypalCheckoutErr) {
                            console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
                            return;
                        }

                        window.paypal.Button.render({
                            env: 'production',
                            payment: function payment() {
                                return paypalCheckoutInstance.createPayment({
                                    flow: 'vault',
                                    amount: self.totalAmount || 19,
                                    currency: 'USD',
                                    intent: 'sale'
                                });
                            },
                            onAuthorize: function onAuthorize(data, actions) {
                                return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
                                    self.userPayments.paymentMethodNonce = payload.nonce;
                                });
                            },
                            onCancel: function onCancel(data) {},
                            onError: function onError(err) {
                                console.error('checkout.js error', err);
                            }
                        }, '#paypal-button').then(function () {});
                    });
                });
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        resetForm: function resetForm() {
            var _this3 = this;

            setTimeout(function () {
                _this3.gifteeValidated = !_this3.gifteeValidated;
            }, 100);
        },
        mountStripeElement: function mountStripeElement() {
            var _this4 = this;

            setTimeout(function () {
                _this4.stripe = window.Stripe(_this4.stripeKey);
                var elements = _this4.stripe.elements();
                _this4.card = elements.create('card');
                _this4.card.mount('#card-element');
            }, 1000);
        },
        addGiftee: function addGiftee() {
            if (this.verifyNameField(this.giftee.gifteeFirstName) && this.verifyNameField(this.giftee.gifteeLastName) && this.verifyEmailField(this.giftee.gifteeEmail)) {
                var isDateValid = false;
                if (!this.doesEmailExists(this.giftee.gifteeEmail)) {
                    try {
                        var currentDate = new Date(this.returnMinimumDate());
                        currentDate.setHours(0);
                        currentDate.setMinutes(0);

                        var delDate = new Date(this.giftee.deliveryDate.split('-').join('/'));

                        delDate.setHours(0);
                        delDate.setMinutes(0);

                        if (delDate >= currentDate) {
                            isDateValid = true;
                        } else {
                            isDateValid = false;
                            this.$swal({
                                title: 'Invalid Delivery Date',
                                text: '',
                                type: 'error',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {}
                            });
                        }
                    } catch (err) {
                        isDateValid = false;
                        this.$swal({
                            title: '',
                            text: 'Invalid delivery date',
                            type: 'failure',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                    }
                    if (isDateValid) {
                        var newGiftee = {};
                        newGiftee.packageId = this.packageId;
                        newGiftee.gifteeFirstName = this.giftee.gifteeFirstName;
                        newGiftee.gifteeLastName = this.giftee.gifteeLastName;
                        newGiftee.gifteeEmail = this.giftee.gifteeEmail.toLowerCase();
                        newGiftee.deliveryDate = this.returnFormatedDate(this.giftee.deliveryDate, 'M');
                        newGiftee.deliveryMessage = this.giftee.deliveryMessage;
                        newGiftee.redeemDate = null;
                        this.gifteeCol.push(newGiftee);
                        this.giftee.packageId = this.packageId;
                        this.giftee.gifteeFirstName = '';
                        this.giftee.gifteeLastName = '';
                        this.giftee.gifteeEmail = '';
                        this.giftee.deliveryDate = this.returnMinimumDate();
                        this.giftee.deliveryMessage = '';
                        this.giftee.redeemDate = null;
                        this.gifteeValidated = false;

                        this.resetForm();
                    }
                } else {
                    this.$swal({
                        title: 'Recipient with this email already exists',
                        text: '',
                        type: 'error',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                }
            }
        },
        removeGiftee: function removeGiftee(element) {
            var index = this.gifteeCol.indexOf(element);
            this.gifteeCol.splice(index, 1);
        },
        calculateTotalAmount: function calculateTotalAmount() {
            this.totalAmount = 0;
            if (this.gifteeCol && this.gifteeCol.length > 0) {
                this.addMessage = 'Buy Another Gift';
                for (var i = 0; i < this.gifteeCol.length; i++) {
                    var packageInfo = this.getPackageInfo(this.gifteeCol[i].packageId)[0];
                    this.totalAmount = parseFloat(this.totalAmount) + parseFloat(packageInfo.amount);
                    this.totalAmount = parseFloat(this.totalAmount).toFixed(2);
                }
            } else {
                this.addMessage = 'Buy Gift';
            }
        },
        getPackageInfo: function getPackageInfo(packageId) {
            if (this.getAllPlans) {
                var pkg = this.getAllPlans.filter(function (plan) {
                    return plan.packageId === packageId;
                });
                return pkg;
            }
            return null;
        },
        verifyPaymentSubmit: function verifyPaymentSubmit() {
            if (this.user.packageId > 0) {
                return false;
            }
            return true;
        },
        verifyPasswordField: function verifyPasswordField(field) {
            if (field.length >= 8) {
                var re = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,}).{8,}$/;
                if (!re.test(field)) {
                    this.passwordError = 'Min 8 Chars, One Upper Case, One Lower Case, One Digit!';
                    return false;
                } else {
                    return true;
                }
            } else {
                if (field.length > 0) {
                    this.passwordError = 'Password must be of 8 charecters at least';
                    return false;
                } else {
                    return true;
                }
            }
        },
        verifyEmailField: function verifyEmailField(field) {
            if (field.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(field)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyNameField: function verifyNameField(field) {
            if (field.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(field)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        doesEmailExists: function doesEmailExists(newEmail) {
            if (this.gifteeCol && this.gifteeCol.length > 0) {
                var exists = this.gifteeCol.filter(function (giftee) {
                    return giftee.gifteeEmail.toLowerCase() === newEmail.toLowerCase();
                });
                if (exists && exists.length > 0) {
                    return true;
                }
            }
            return false;
        },
        returnMinimumDate: function returnMinimumDate() {
            var today = new Date();

            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            today = mm + '/' + dd + '/' + yyyy;
            return today;
        },
        returnFormatedDate: function returnFormatedDate(delDate, format) {
            var ddate = new Date(delDate.split('-').join('/'));

            var dd = ddate.getDate();
            var mm = ddate.getMonth() + 1;
            var yyyy = ddate.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            if (format === 'M') {
                return yyyy + '-' + mm + '-' + dd;
            } else {
                return mm + '/' + dd + '/' + yyyy;
            }
        },
        onPaymentSubmit: function onPaymentSubmit() {
            var _this5 = this;

            this.gifter.email = this.gifter.email.toLowerCase();
            this.gifter.corporationId = this.clientId;
            if (this.gifteeCol.length > 0) {
                this.gifter.userGifts = this.gifteeCol;
                this.spinnerToggle();
                this.$store.dispatch('ADDCORPORATEGIFTS', { gift: this.gifter }).then(function () {
                    if (!_this5.error.show) {
                        _this5.spinnerToggle();
                        _this5.$router.push('/');
                        _this5.$swal({
                            title: 'Gifts Sent!',
                            text: '',
                            type: 'success',
                            timer: 4000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                    } else {
                        _this5.spinnerToggle();
                    }
                });
            } else {
                this.$swal({
                    title: 'There is no Gift Recipient Added',
                    text: 'Upload csv file',
                    type: 'error',
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(function () {}, function (dismiss) {
                    if (dismiss === 'timer') {}
                });
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['error', 'isUserLoggedIn', 'getDefaultPlan', 'getAllPlans', 'user', 'getSelectedGiftId', 'getPaypalToken', 'getCorporateClients'])),
    watch: {
        'gifter.firstName': function gifterFirstName(to, from) {
            this.gifter.cardHolderName = this.gifter.firstName + ' ' + this.gifter.lastName;
        },
        'gifter.lastName': function gifterLastName(to, from) {
            this.gifter.cardHolderName = this.gifter.firstName + ' ' + this.gifter.lastName;
        },
        'gifteeCol': function gifteeCol(to, from) {
            this.calculateTotalAmount();
        },
        'gateway': function gateway(to, from) {
            var _this6 = this;

            if (this.gateway === 'paypal') {
                this.card.unmount('#card-element');
                this.stripeErrorMessage = '';
                this.isStripe = false;
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';
                this.userPayments.paymentType = 'PayPal';

                this.userPayments.paymentMethodNonce = '';
                setTimeout(function () {
                    _this6.mountbraintree();
                }, 1000);
            } else {
                this.stripeErrorMessage = '';
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';

                this.userPayments.paymentType = 'CC';
                this.userPayments.paymentMethodNonce = '';
                this.isStripe = true;
                setTimeout(function () {
                    _this6.mountStripeElement();
                }, 1000);
            }
        }
    }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"]
    },
    name: 'amcliveevent',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Welcome to Private Live stream!',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Welcome to Private Live stream' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Welcome to Private Live stream' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            success: false,
            successMsg: '',
            contactForm: {
                emailAddress: '',
                phoneNumber: '',
                reason: '',
                comments: ''
            },
            spinner: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['user', 'error', 'getCorpStreamingURL'])),
    methods: {}
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["accordion"],
        'panel': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["panel"],
        alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
        dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["dropdown"],
        radio: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["radio"],
        VuePassword: __WEBPACK_IMPORTED_MODULE_3_vue_password___default.a,
        checkbox: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        tabs: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tabs"],
        tab: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tab"],
        buttonGroup: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"]
    },
    name: 'signUp',
    data: function data() {
        return {
            GifteeUser: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                packageId: 0,
                comments: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg'
            },
            userObject: {
                userId: 0,
                corporationId: 0,
                name: '',
                subscriptionCount: 1,
                email: '',
                cardHolderName: '',
                packageId: '',
                userPayments: [],
                isPaypalCustomer: '',
                paypalSubscriptionId: '',
                billingStreet: '',
                billingCity: '',
                billingState: '',
                billingZip: ''
            },

            userPayments: {
                token: '',
                stripeCardId: '',
                paymentType: 'CC',
                paymentDate: new Date(),
                paypalPayerId: '',
                paypalPaymentId: '',
                paymentMethodNonce: ''
            },
            spinner: false,
            alert: false,
            passwordError: '',
            confirmPassword: '',
            stripe: '',
            card: '',
            panelStatus: false,
            createSection: true,
            paymentSection: false,
            isToggle: false,
            defaultPlan: '',
            isChecked: false,
            reqPlanCode: this.$route.params.planId ? this.$route.params.planId : '7DaysFree',
            daysToCancel: 0,
            isStripe: true,
            packageId: 0,

            stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo',
            gateway: 'CC',
            corpSel: 'E',
            paypalPayerID: '',
            paypalPaymentId: '',
            paypalToken: '',

            paypalResponse: '',
            giftCode: '',
            codeRedeemed: false,
            stripeErrorMessage: '',
            hidePasswordMeter: true,
            isMonthlySubscription: true,
            isAnnualSubscription: false,
            annualPlan: '',
            planAmount: 0,
            twoYearPlan: null,
            corporateClientId: 0
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (this.user) {
            this.$store.dispatch('GETPLANS').then(function () {
                var regularPlan = _this.getAllPlans.filter(function (x) {
                    return x.packageId === 15;
                });
                if (regularPlan && regularPlan.length > 0) {
                    var regPlan = regularPlan[0];
                    _this.defaultPlan = regPlan;
                    _this.userObject.packageId = regPlan.packageId;
                    _this.packageId = regPlan.packageId;
                }

                var annualPlan = _this.getAllPlans.filter(function (x) {
                    return x.packageId === 12;
                });
                if (annualPlan && annualPlan.length > 0) {
                    _this.annualPlan = annualPlan[0];
                    _this.userObject.packageId = _this.annualPlan.packageId;
                    _this.packageId = _this.annualPlan.packageId;
                    _this.planAmount = _this.annualPlan.amount;
                }

                var twoYearPln = _this.getAllPlans.filter(function (x) {
                    return x.packageId === 11;
                });
                if (twoYearPln && twoYearPln.length > 0) {
                    _this.twoYearPlan = twoYearPln[0];
                }
            });
            this.$store.dispatch('GETCORPORATECLIENTS').then(function () {
                if (_this.getCorporateClients) {
                    _this.corporateClientId = _this.getCorporateClients[0].corporationId;
                }
            });
            this.$store.dispatch('GETPAYPALTOKEN');
            this.mountStripeElement();
        } else {
            this.$router.push('/');
        }
    },

    methods: {
        mountbraintree: function mountbraintree() {
            var self = this;
            if (self.getPaypalToken) {
                window.braintree.client.create({
                    authorization: 'production_6r7mxqgh_htw3nq9wp32w8h2x'
                }, function (clientErr, clientInstance) {
                    if (clientErr) {
                        console.error('Error creating client:', clientErr);
                        return;
                    }

                    window.braintree.paypalCheckout.create({
                        client: clientInstance
                    }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                        if (paypalCheckoutErr) {
                            console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
                            return;
                        }

                        window.paypal.Button.render({
                            env: 'production',
                            payment: function payment() {
                                return paypalCheckoutInstance.createPayment({
                                    flow: 'vault',
                                    amount: self.planAmount,
                                    currency: 'USD',
                                    intent: 'sale'
                                });
                            },
                            onAuthorize: function onAuthorize(data, actions) {
                                return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
                                    self.userPayments.paymentMethodNonce = payload.nonce;
                                });
                            },
                            onCancel: function onCancel(data) {},
                            onError: function onError(err) {
                                console.error('checkout.js error', err);
                            }
                        }, '#paypal-button').then(function () {});
                    });
                });
            }
        },
        redeemCode: function redeemCode() {
            var _this2 = this;

            if (this.giftCode && this.giftCode.length > 0) {
                this.spinnerToggle();
                this.$store.dispatch('GETGIFTEE', this.giftCode).then(function () {
                    _this2.spinnerToggle();
                    if (_this2.getGiftee) {
                        _this2.user.firstName = _this2.getGiftee.gifteeFirstName;
                        _this2.user.lastName = _this2.getGiftee.gifteeLastName;
                        _this2.user.email = _this2.getGiftee.gifteeEmail;
                        _this2.user.packageId = _this2.getGiftee.packageId;
                        _this2.user.comments = _this2.getGiftee.gifteeUuid;
                        _this2.codeRedeemed = true;
                        _this2.$store.dispatch('GETPLANS').then(function () {
                            var plan = _this2.getAllPlans.filter(function (pln) {
                                return pln.packageId === _this2.getGiftee.packageId;
                            });
                            _this2.defaultPlan = plan[0];
                        });
                    }
                });
            }
        },
        togglePaymentMethods: function togglePaymentMethods() {
            var _this3 = this;

            if (this.gateway === 'paypal') {
                this.isStripe = false;
                setTimeout(function () {
                    _this3.mountbraintree();
                }, 1000);
            } else {
                this.isStripe = true;
                this.mountStripeElement();
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this4 = this;

            if (this.user && this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                this.isToggle = false;
                this.spinnerToggle();
                this.$store.dispatch('VERIFYUSEREXISTS', { email: this.user.email }).then(function () {
                    _this4.spinnerToggle();
                    if (!_this4.error.show) {
                        _this4.isToggle = true;
                        _this4.createSection = false;
                        _this4.paymentSection = true;
                        _this4.user.cardHolderName = _this4.user.firstName + ' ' + _this4.user.lastName;

                        _this4.isStripe = true;
                        _this4.gateway = 'CC';
                        _this4.mountStripeElement();
                    }
                });
            }
        },
        mountStripeElement: function mountStripeElement() {
            var _this5 = this;

            setTimeout(function () {
                _this5.stripe = window.Stripe(_this5.stripeKey);
                var elements = _this5.stripe.elements();
                _this5.card = elements.create('card');
                _this5.card.mount('#card-element');
            }, 1000);
        },
        disablePaymentPanel: function disablePaymentPanel() {
            this.panelStatus = false;
        },
        verifyPaymentSubmit: function verifyPaymentSubmit() {
            if (this.user.packageId > 0) {
                return false;
            }
            return true;
        },
        verifyPassword: function verifyPassword() {
            if (this.user.password.length >= 6) {
                var re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/;
                if (!re.test(this.user.password)) {
                    this.passwordError = 'Min 8 Chars, One Upper Case, One Lower Case, One Digit!';
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyEmail: function verifyEmail() {
            if (this.userObject.email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(this.userObject.email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyFirstName: function verifyFirstName() {
            if (this.user.firstName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.firstName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyLastName: function verifyLastName() {
            if (this.user.lastName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.lastName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyCardHolderName: function verifyCardHolderName() {
            if (this.userObject.cardHolderName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.userObject.cardHolderName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onPaymentSubmit: function onPaymentSubmit() {
            var _this6 = this;

            var self = this;
            if (this.codeRedeemed) {
                if (this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                    this.GifteeUser.firstName = this.user.firstName;
                    this.GifteeUser.lastName = this.user.lastName;
                    this.GifteeUser.email = this.user.email.toLowerCase();
                    this.GifteeUser.password = this.user.password;
                    this.GifteeUser.packageId = this.getGiftee.packageId;
                    this.GifteeUser.comments = this.getGiftee.gifteeUuid;
                    this.spinnerToggle();
                    this.$store.dispatch('SAVEGIFTEE', { giftee: this.GifteeUser }).then(function () {
                        if (!_this6.error.show) {
                            _this6.spinnerToggle();
                            _this6.$swal({
                                title: 'Registration Success!',
                                text: 'Welcome To TONE! For your security, please check your inbox for a Validation Email - TONE Networks within the next 12 hours.  (Don’t see it…check your spam folder.)',
                                type: 'success',
                                timer: 4000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {}
                            });
                        } else {
                            _this6.spinnerToggle();
                        }
                    });
                }
            } else {
                self = this;
                if (this.gateway !== 'CC') {
                    this.userObject.cardHolderName = ' ';
                }
                if (this.userObject && this.verifyCardHolderName() && this.userObject.subscriptionCount > 0) {
                    if (this.corpSel === 'N' && !this.verifyEmail()) {
                        return;
                    }
                    this.userObject.userId = this.user.userId;
                    if (this.corpSel === 'N') {
                        this.userObject.corporationId = 0;
                    } else {
                        self.userObject.corporationId = self.corporateClientId;
                        this.userObject.name = '';
                        this.userObject.email = '';
                    }

                    this.spinnerToggle();
                    this.userObject.userId = this.user.userId;
                    if (this.gateway === 'CC') {
                        this.stripe.createToken(this.card).then(function (result) {
                            if (result.error) {
                                _this6.spinnerToggle();

                                self.stripeErrorMessage = result.error.message;
                            } else {
                                var stripeToken = result.token.id;
                                var cardId = result.token.card.id;

                                _this6.userPayments.token = stripeToken;
                                _this6.userPayments.stripeCardId = cardId;
                                if (_this6.userObject.userPayments.length > 0) {
                                    _this6.userObject.userPayments.pop();
                                }
                                _this6.userObject.userPayments.push(_this6.userPayments);
                                if (stripeToken) {
                                    _this6.$store.dispatch('PROCESSCORPORATEPAYMENT', { user: _this6.userObject }).then(function () {
                                        if (!_this6.error.show) {
                                            _this6.spinnerToggle();
                                            _this6.$swal({
                                                title: 'Transaction Processed!',
                                                text: 'Welcome To TONE!',
                                                type: 'success',
                                                timer: 4000,
                                                showCancelButton: false,
                                                showConfirmButton: false
                                            }).then(function () {}, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        } else {
                                            _this6.spinnerToggle();
                                        }
                                    });
                                }
                            }
                        });
                    } else if (this.userPayments.paymentMethodNonce) {
                        if (this.userObject.userPayments.length > 0) {
                            this.userObject.userPayments.pop();
                        }
                        this.userObject.userPayments.push(this.userPayments);
                        if (this.userPayments.paymentMethodNonce) {
                            this.$store.dispatch('PROCESSCORPORATEPAYMENT', { user: this.userObject }).then(function () {
                                if (!_this6.error.show) {
                                    _this6.spinnerToggle();
                                    _this6.$swal({
                                        title: 'Transaction Processed!',
                                        text: 'Welcome To TONE!',
                                        type: 'success',
                                        timer: 4000,
                                        showCancelButton: false,
                                        showConfirmButton: false
                                    }).then(function () {}, function (dismiss) {
                                        if (dismiss === 'timer') {}
                                    });
                                } else {
                                    _this6.spinnerToggle();
                                }
                            });
                        }
                    } else {
                        this.spinnerToggle();
                    }
                }
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['error', 'isUserLoggedIn', 'getDefaultPlan', 'getGiftee', 'getAllPlans', 'getPaypalToken', 'getTrialDays', 'user', 'getCorporateClients'])),
    watch: {
        'corpSel': function corpSel(to, from) {
            if (this.corpSel === 'N') {
                this.corporateClientId === this.getCorporateClients[0].corporationId;
            } else {
                this.userObject.name = '';
                this.userObject.email = '';
            }
        },
        'user.firstName': function userFirstName(to, from) {
            this.user.cardHolderName = this.user.firstName + ' ' + this.user.lastName;
        },
        'user.lastName': function userLastName(to, from) {
            this.user.cardHolderName = this.user.firstName + ' ' + this.user.lastName;
        },
        'packageId': function packageId(to, from) {
            this.user.packageId = this.packageId;
            if (this.packageId === 12) {
                this.planAmount = this.annualPlan.amount;
            } else if (this.packageId === 11) {
                this.planAmount = this.twoYearPlan.amount;
            } else {
                this.planAmount = this.defaultPlan.amount;
            }
        },
        'gateway': function gateway(to, from) {
            var _this7 = this;

            if (this.gateway === 'paypal') {
                this.card.unmount('#card-element');
                this.stripeErrorMessage = '';
                this.isStripe = false;
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';
                this.userPayments.paymentType = 'PayPal';
                this.userObject.isPaypalCustomer = '1';
                this.userPayments.paymentMethodNonce = '';
                setTimeout(function () {
                    _this7.mountbraintree();
                }, 1000);
            } else {
                this.stripeErrorMessage = '';
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';
                this.userObject.isPaypalCustomer = '0';
                this.userPayments.paymentType = 'CC';
                this.userPayments.paymentMethodNonce = '';
                this.isStripe = true;
                setTimeout(function () {
                    _this7.mountStripeElement();
                }, 1000);
            }
        }
    }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_masked_input__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);










/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["accordion"],
        'panel': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["panel"],
        'masked-input': __WEBPACK_IMPORTED_MODULE_5_vue_masked_input__["a" /* default */],
        alert: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["alert"],
        dropdown: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["dropdown"],
        radio: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["radio"],
        VuePassword: __WEBPACK_IMPORTED_MODULE_4_vue_password___default.a,
        checkbox: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["checkbox"],
        tabs: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["tabs"],
        tab: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["tab"],
        buttonGroup: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["buttonGroup"],
        modal: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["modal"]
    },
    name: 'signUp',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Redeem Your Gift',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Redeem Your Gift' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Redeem Your Gift' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            user: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                packageId: 0,
                comments: '',
                phoneNumber: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/Sneakers.png',
                userRegion: 0
            },
            emailPattern: "^[a-zA-Z0-9._%+'\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}(\\.[a-zA-Z]{2,})?$",
            showMobileFlag: true,
            phoneNumber: '',
            rawPhoneNumber: '',
            spinner: false,
            alert: false,
            passwordError: '',
            paymentSection: false,
            isToggle: false,
            isChecked: false,
            defaultPlan: '',
            hidePasswordMeter: true,
            corpGiftCode: this.$route.params.giftCode,
            corpId: this.$route.params.corporateId,
            corpRegion: this.$route.params.regions,
            dynamic_bullet_1: '',
            dynamic_bullet_2: '',
            dynamic_bullet_3: '',
            dynamic_bullet_4: '',
            dynamic_bullet_5: '',
            dynamic_bullet_6: '',
            giftDescription: '',
            showResetModal: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        console.log('inside CorporationGifting.vue -> mounted () ----------------------> this.corpId', this.corpId);
        console.log('inside CorporationGifting.vue -> mounted () ----------------------> this.$route.params.corporateId', this.$route.params.corporateId);
        console.log('inside CorporationGifting.vue -> mounted () ----------------------> typeof this.corpId', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.corpId));
        console.log('inside CorporationGifting.vue -> mounted () ----------------------> typeof this.$route.params.corporateId', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.$route.params.corporateId));
        if (this.corpId === '112' || this.$route.params.corporateId === '112') {
            this.$router.push('/corporationgiftingcustom/112/COMCAST');
        }
        if (this.corpId === '197' || this.$route.params.corporateId === '197') {
            this.$router.push('/corporationgiftingcustom/197/ADECCO');
        }

        if (this.isUserLoggedIn && this.isUserLoggedIn.userId > 0) {
            console.log('user is logged in');
            this.$router.push('/mytone');
        } else {
            this.$store.dispatch('GETDYNAMICCONTENTS', 4).then(function () {
                if (_this.getAllSiteContents) {
                    _this.dynamic_bullet_1 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_1');
                    _this.dynamic_bullet_2 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_2');
                    _this.dynamic_bullet_3 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_3');
                    _this.dynamic_bullet_4 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_4');
                    _this.dynamic_bullet_5 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_5');
                    _this.dynamic_bullet_6 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_6');
                }
            });
            var giftPayload = [];
            giftPayload.push(this.corpGiftCode);
            giftPayload.push(this.corpId);
            if (this.$route.params.giftCode && this.$route.params.corporateId) {
                this.$store.commit('setCorporateGiftingCode', { giftCode: this.$route.params.giftCode });
                this.$store.commit('setCorporateClientId', { corporateClientId: this.$route.params.corporateId });
            } else {
                this.$router.push('/');
            }
            this.$store.dispatch('GETCORPORATECLIENT', this.$route.params.corporateId).then(function () {
                if (_this.getCorporateClient) {
                    if (_this.getCorporateClient.phoneFlag === 2 || _this.getCorporateClient.phoneFlag === 4) {
                        _this.showMobileFlag = false;
                    }
                }
            });
            this.$store.dispatch('GETCORPORATIONGIFTEE', giftPayload).then(function () {
                if (_this.getGiftee) {
                    console.log('giftee info', _this.getGiftee);
                    _this.$store.commit('setCorporateGiftInfo', { gift: _this.getGiftee });
                    _this.user.firstName = _this.getGiftee.gifteeFirstName;
                    _this.user.lastName = _this.getGiftee.gifteeLastName;
                    _this.user.email = _this.getGiftee.gifteeEmail;
                    _this.user.packageId = _this.getGiftee.packageId;
                    _this.user.comments = _this.getGiftee.gifteeUuid;
                    _this.giftDescription = _this.getGiftee.signupGiftDesc;
                } else {
                    if (_this.getGiftingError.show) {
                        _this.user.packageId = -1;
                        _this.$swal({
                            title: 'You have reached the maximum number of accounts registered for this trial offer.',
                            text: '',
                            type: 'error',
                            timer: 4000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                    }
                }
                _this.$store.dispatch('GETPLANS').then(function () {
                    var plan = _this.getAllPlans.filter(function (pln) {
                        return pln.packageId === _this.getGiftee.packageId;
                    });
                    _this.defaultPlan = plan[0];
                });
            });
        }
    },

    methods: {
        SetupLogin: function SetupLogin() {
            this.showResetModal = false;
            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        cancelResetModal: function cancelResetModal() {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showResetModal = false;
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        onSubmitForgetRequest: function onSubmitForgetRequest() {
            var self = this;
            console.log('email', self.user.email);

            this.$store.dispatch('FORGOTPASSWORD', { user: self.user }).then(function () {
                if (self.error.show) {
                    self.$swal({
                        title: self.error.message,
                        text: '',
                        type: 'error',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {
                        self.showResetModal = false;
                    }, function (dismiss) {
                        if (dismiss === 'timer') {
                            self.cancelResetModal();
                        }
                    });
                } else {
                    self.$swal({
                        title: 'Forgot Password Request Sent! Check your email and follow the reset link',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {
                            self.cancelResetModal();
                        }
                    });
                }
            });
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        verifyPaymentSubmit: function verifyPaymentSubmit() {
            if (this.user.packageId > 0) {
                return false;
            }
            return true;
        },
        verifyPassword: function verifyPassword() {
            if (this.user.password.length >= 6) {
                var re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/;
                if (!re.test(this.user.password)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (this.user.password.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        verifyEmail: function verifyEmail() {
            if (this.user.email.length > 0) {
                var re = /^[\w\d.+'-]+@[\w\d-]+(\.[\w\d-]+)*\.[a-z]+$/i;
                if (!re.test(this.user.email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyFirstName: function verifyFirstName() {
            if (this.user.firstName.length > 0) {
                var re = /^[A-Za-z '-]+$/;
                if (!re.test(this.user.firstName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyLastName: function verifyLastName() {
            if (this.user.lastName.length > 0) {
                var re = /^[A-Za-z '-]+$/;
                if (!re.test(this.user.lastName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyCardHolderName: function verifyCardHolderName() {
            if (this.user.cardHolderName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.cardHolderName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onGifteeSubmit: function onGifteeSubmit() {
            var _this2 = this;

            var url = window.location.href;
            var region = url.split('/').pop();
            console.log('CorporationGifting.vue : region : ', region);
            console.log('CorporationGifting.vue : this.corpId : ', this.corpId);
            if (this.corpId === '93') {
                if (region === 'Leaders') {
                    this.user.userRegion = 15;
                } else {
                    if (region === 'Mentors') {
                        this.user.userRegion = 16;
                    } else {
                        this.user.userRegion = null;
                    }
                }
            }
            if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                this.user.phoneNumber = this.phoneNumber;
            } else {
                this.phoneNumber = '';
                this.user.phoneNumber = '';
            }
            var giftPayload = [];
            giftPayload.push(this.corpGiftCode);
            giftPayload.push(this.corpId);
            console.log('CorporationGifting.vue : this.corpGiftCode : ', this.corpGiftCode);
            console.log('CorporationGifting.vue : this.corpId : ', this.corpId);
            var displayMsg = 'Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)';
            if (this.corpGiftCode.toLowerCase() === 'GIANTALLACCESS'.toLowerCase()) {
                displayMsg = 'Welcome To TONE! Now you have access to TONE\'s short-form videos and live coaching events till midnight on March 10th 2021.';
            }
            this.$store.dispatch('GETCORPORATIONGIFTEE', giftPayload).then(function () {
                var self = _this2;
                if (_this2.getGiftee && !_this2.getGiftingError.show) {
                    if (_this2.verifyPassword() && _this2.verifyEmail() && _this2.verifyFirstName() && _this2.verifyLastName()) {
                        _this2.spinnerToggle();
                        _this2.user.email = _this2.user.email.toLowerCase();
                        _this2.$store.dispatch('SAVEGIFTEE', { giftee: _this2.user }).then(function () {
                            if (!_this2.error.show) {
                                _this2.$store.commit('setCorporateGiftingCode', { giftCode: null });
                                _this2.$store.commit('setCorporateClientId', { corporateClientId: null });
                                _this2.$store.commit('setCorporateGiftingCode', { giftCode: null });
                                _this2.$store.commit('setCorporateGiftInfo', { gift: null });
                                _this2.spinnerToggle();
                                _this2.$swal({
                                    title: 'Registration Success!',
                                    text: displayMsg,
                                    type: 'success',
                                    timer: 4000,
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'sweetalert-lg-signup'
                                }).then(function () {}, function (dismiss) {
                                    if (dismiss === 'timer') {}
                                });
                            } else {
                                _this2.spinnerToggle();
                                if (_this2.error.show) {
                                    if (_this2.error.message.toString().toLowerCase().indexOf('already exist') > -1) {
                                        self.showResetModal = true;
                                    } else {
                                        _this2.$swal({
                                            title: 'An Error occurred while processing the request',
                                            text: _this2.error.message,
                                            type: 'error',
                                            timer: 3000,
                                            showCancelButton: false,
                                            showConfirmButton: false
                                        }).then(function () {}, function (dismiss) {
                                            if (dismiss === 'timer') {}
                                        });
                                    }
                                }
                            }
                        });
                    }
                } else {
                    _this2.user.packageId = -1;
                    _this2.$swal({
                        title: 'You have reached the maximum number of accounts registered for this trial offer.',
                        text: '',
                        type: 'error',
                        timer: 4000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                }
            });
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'isUserLoggedIn', 'getAllPlans', 'getGiftee', 'getGiftingError', 'getCorporateGiftingCode', 'getCorporateClientId', 'getCorporateClient', 'getAllSiteContents', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getCorporateGiftInfo']))
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_masked_input__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers__ = __webpack_require__(15);











/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["accordion"],
        'panel': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["panel"],
        'masked-input': __WEBPACK_IMPORTED_MODULE_5_vue_masked_input__["a" /* default */],
        alert: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["alert"],
        dropdown: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["dropdown"],
        radio: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["radio"],
        VuePassword: __WEBPACK_IMPORTED_MODULE_4_vue_password___default.a,
        checkbox: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["checkbox"],
        tabs: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["tabs"],
        tab: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["tab"],
        buttonGroup: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["buttonGroup"],
        modal: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["modal"]
    },
    name: 'signUp',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Redeem Your Gift',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Redeem Your Gift' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Redeem Your Gift' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            user: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                packageId: 0,
                comments: '',
                phoneNumber: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/Sneakers.png',
                userRegion: 0
            },
            emailPattern: "^[a-zA-Z0-9._%+'\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}(\\.[a-zA-Z]{2,})?$",
            showMobileFlag: true,
            phoneNumber: '',
            rawPhoneNumber: '',
            spinner: false,
            alert: false,
            passwordError: '',
            paymentSection: false,
            isToggle: false,
            isChecked: false,
            defaultPlan: '',
            hidePasswordMeter: true,
            corpGiftCode: this.$route.params.giftCode,
            corpId: this.$route.params.corporateId,
            dynamic_bullet_1: '',
            dynamic_bullet_2: '',
            dynamic_bullet_3: '',
            dynamic_bullet_4: '',
            dynamic_bullet_5: '',
            dynamic_bullet_6: '',
            giftDescription: '',
            showResetModal: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (this.isUserLoggedIn && this.isUserLoggedIn.userId > 0) {
            console.log('user is logged in');
            this.$router.push('/mytone');
        } else {
            this.$store.dispatch('GETDYNAMICCONTENTS', 4).then(function () {
                if (_this.getAllSiteContents) {
                    _this.dynamic_bullet_1 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_1');
                    _this.dynamic_bullet_2 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_2');
                    _this.dynamic_bullet_3 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_3');
                    _this.dynamic_bullet_4 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_4');
                    _this.dynamic_bullet_5 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_5');
                    _this.dynamic_bullet_6 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_6');
                }
            });
            var giftPayload = [];
            giftPayload.push(this.corpGiftCode);
            giftPayload.push(this.corpId);
            if (this.$route.params.giftCode && this.$route.params.corporateId) {
                this.$store.commit('setCorporateGiftingCode', { giftCode: this.$route.params.giftCode });
                this.$store.commit('setCorporateClientId', { corporateClientId: this.$route.params.corporateId });
            } else {
                this.$router.push('/');
            }
            this.$store.dispatch('GETCORPORATECLIENT', this.$route.params.corporateId).then(function () {
                if (_this.getCorporateClient) {}
            });
            this.$store.dispatch('GET_CORP_RESTRICTED_REGIONS', this.$route.params.corporateId).then(function () {
                if (_this.getCorpRestrictedRegions) {}
            });
            this.$store.dispatch('GET_CORPORATION_REGIONS', this.$route.params.corporateId).then(function () {
                if (_this.getCorporationRegions) {}
            });

            this.$store.dispatch('GETCORPORATIONGIFTEE', giftPayload).then(function () {
                if (_this.getGiftee) {
                    console.log('giftee info', _this.getGiftee);
                    _this.$store.commit('setCorporateGiftInfo', { gift: _this.getGiftee });
                    _this.user.firstName = _this.getGiftee.gifteeFirstName;
                    _this.user.lastName = _this.getGiftee.gifteeLastName;
                    _this.user.email = _this.getGiftee.gifteeEmail;
                    _this.user.packageId = _this.getGiftee.packageId;
                    _this.user.comments = _this.getGiftee.gifteeUuid;
                    _this.giftDescription = _this.getGiftee.signupGiftDesc;
                } else {
                    if (_this.getGiftingError.show) {
                        _this.user.packageId = -1;
                        _this.$swal({
                            title: 'You have reached the maximum number of accounts registered for this trial offer.',
                            text: '',
                            type: 'error',
                            timer: 4000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                    }
                }
                _this.$store.dispatch('GETPLANS').then(function () {
                    var plan = _this.getAllPlans.filter(function (pln) {
                        return pln.packageId === _this.getGiftee.packageId;
                    });
                    _this.defaultPlan = plan[0];
                });
            });
        }
    },

    methods: {
        SetupLogin: function SetupLogin() {
            this.showResetModal = false;
            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        cancelResetModal: function cancelResetModal() {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showResetModal = false;
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        onSubmitForgetRequest: function onSubmitForgetRequest() {
            var self = this;
            console.log('email', self.user.email);

            this.$store.dispatch('FORGOTPASSWORD', { user: self.user }).then(function () {
                if (self.error.show) {
                    self.$swal({
                        title: self.error.message,
                        text: '',
                        type: 'error',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {
                        self.showResetModal = false;
                    }, function (dismiss) {
                        if (dismiss === 'timer') {
                            self.cancelResetModal();
                        }
                    });
                } else {
                    self.$swal({
                        title: 'Forgot Password Request Sent! Check your email and follow the reset link',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {
                            self.cancelResetModal();
                        }
                    });
                }
            });
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        verifyPaymentSubmit: function verifyPaymentSubmit() {
            if (this.user.packageId > 0) {
                return false;
            }
            return true;
        },
        verifyPassword: function verifyPassword() {
            if (this.user.password.length >= 6) {
                var re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/;
                if (!re.test(this.user.password)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (this.user.password.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        verifyEmail: function verifyEmail() {
            if (this.user.email.length > 0) {
                var re = /^[\w\d.+'-]+@[\w\d-]+(\.[\w\d-]+)*\.[a-z]+$/i;
                if (!re.test(this.user.email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyFirstName: function verifyFirstName() {
            if (this.user.firstName.length > 0) {
                var re = /^[A-Za-z '-]+$/;
                if (!re.test(this.user.firstName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyLastName: function verifyLastName() {
            if (this.user.lastName.length > 0) {
                var re = /^[A-Za-z '-]+$/;
                if (!re.test(this.user.lastName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyCardHolderName: function verifyCardHolderName() {
            if (this.user.cardHolderName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.cardHolderName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onGifteeSubmit: function onGifteeSubmit() {
            var _this2 = this;

            if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                this.user.phoneNumber = this.phoneNumber;
            } else {
                this.phoneNumber = '';
                this.user.phoneNumber = '';
            }
            var giftPayload = [];
            giftPayload.push(this.corpGiftCode);
            giftPayload.push(this.corpId);
            var displayMsg = 'Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)';
            if (this.corpGiftCode.toLowerCase() === 'GIANTALLACCESS'.toLowerCase()) {
                displayMsg = 'Welcome To TONE! Now you have access to TONE\'s short-form videos and live coaching events till midnight on March 10th 2021.';
            }

            var userRegionId = parseInt(this.user.userRegion, 10);


            console.log('inside onGifteeSubmit () ----------------------> userRegionId = ', userRegionId);
            console.log('inside onGifteeSubmit () ----------------------> typeof userRegionId', typeof userRegionId === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(userRegionId));

            var quotaExceeded = false;
            for (var i = 0; i < this.getCorpRestrictedRegions.length; i++) {
                var vUserRegionId = this.getCorpRestrictedRegions[i].corpRegionId;

                console.log('inside onGifteeSubmit () ----------------------> vUserRegionId = ', vUserRegionId);
                console.log('inside onGifteeSubmit () ----------------------> typeof vUserRegionId = ', typeof vUserRegionId === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(vUserRegionId));
                if (userRegionId === vUserRegionId) {
                    console.log('inside onGifteeSubmit () ----------------------> USER BELONGS TO RESTRICTED REGION.');
                    quotaExceeded = true;
                    break;
                }
            }
            console.log('inside onGifteeSubmit () ----------------------> quotaExceeded = ', quotaExceeded);
            console.log('inside onGifteeSubmit () ----------------------> typeof quotaExceeded = ', typeof quotaExceeded === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(quotaExceeded));
            console.log('inside onGifteeSubmit () ----------------------> this.getCorpRestrictedRegions', this.getCorpRestrictedRegions);

            if (quotaExceeded === true) {
                var exceedLimitMsg = 'Thank you for your interest in Tone Networks! Unfortunately, at this time your organization has reached capacity. We will follow up when additional spaces become available.';
                self.showResetModal = true;
                this.$swal({
                    text: exceedLimitMsg,
                    type: 'info',
                    timer: 4000,
                    showCancelButton: false,
                    showConfirmButton: false,
                    customClass: 'sweetalert-lg-signup'
                }).then(function () {}, function (dismiss) {
                    if (dismiss === 'timer') {}
                });
                var errorPayload = {};
                errorPayload.userId = self.user ? self.user.userId : 0;
                errorPayload.action = 'COMCAST_REGION_LIMIT_EXCEEDED';
                errorPayload.activityCode = this.user.userRegion;
                errorPayload.activityMessage = this.user.email;
                errorPayload.severityLevel = null;
                errorPayload.status = null;
                errorPayload.timeZone = __WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers__["a" /* dateHelpers */].getUserTimeZone();
                errorPayload.pageName = 'CorporationGiftingComcast.vue';
                errorPayload.os = __WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers__["a" /* dateHelpers */].userPlatForm().os.family;
                errorPayload.osVersion = __WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers__["a" /* dateHelpers */].userPlatForm().os.version;
                errorPayload.browserName = __WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers__["a" /* dateHelpers */].userPlatForm().name;
                errorPayload.browserVersion = __WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers__["a" /* dateHelpers */].userPlatForm().version;
                errorPayload.device = __WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers__["a" /* dateHelpers */].userPlatForm().product;
                errorPayload.deviceType = null;

                errorPayload.userAgent = navigator.userAgent;
                errorPayload.deviceType = null;

                if (this.$route.params.corporateId === '197') {
                    errorPayload.action = 'ADECCO_REGION_LIMIT_EXCEEDED';
                    console.log('log Adecco signup activity completed...');
                } else {
                    console.log('log Comcast signup activity completed...');
                }
                this.$store.dispatch('LOG_SIGNUP_ATTEMPT', errorPayload);
            } else {
                this.$store.dispatch('GETCORPORATIONGIFTEE', giftPayload).then(function () {
                    var self = _this2;
                    if (_this2.getGiftee && !_this2.getGiftingError.show) {
                        if (_this2.verifyPassword() && _this2.verifyEmail() && _this2.verifyFirstName() && _this2.verifyLastName()) {
                            _this2.spinnerToggle();
                            _this2.user.email = _this2.user.email.toLowerCase();
                            _this2.$store.dispatch('SAVEGIFTEE', { giftee: _this2.user }).then(function () {
                                if (!_this2.error.show) {
                                    _this2.$store.commit('setCorporateGiftingCode', { giftCode: null });
                                    _this2.$store.commit('setCorporateClientId', { corporateClientId: null });
                                    _this2.$store.commit('setCorporateGiftingCode', { giftCode: null });
                                    _this2.$store.commit('setCorporateGiftInfo', { gift: null });
                                    _this2.spinnerToggle();
                                    _this2.$swal({
                                        title: 'Registration Success!',
                                        text: displayMsg,
                                        type: 'success',
                                        timer: 4000,
                                        showCancelButton: false,
                                        showConfirmButton: false,
                                        customClass: 'sweetalert-lg-signup'
                                    }).then(function () {}, function (dismiss) {
                                        if (dismiss === 'timer') {}
                                    });
                                } else {
                                    _this2.spinnerToggle();
                                    if (_this2.error.show) {
                                        if (_this2.error.message.toString().toLowerCase().indexOf('already exist') > -1) {
                                            self.showResetModal = true;
                                        } else {
                                            _this2.$swal({
                                                title: 'An Error occurred while processing the request',
                                                text: _this2.error.message,
                                                type: 'error',
                                                timer: 3000,
                                                showCancelButton: false,
                                                showConfirmButton: false
                                            }).then(function () {}, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        }
                                    }
                                }
                            });
                        }
                    } else {
                        _this2.user.packageId = -1;
                        _this2.$swal({
                            title: 'You have reached the maximum number of accounts registered for this trial offer.',
                            text: '',
                            type: 'error',
                            timer: 4000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                    }
                });
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'isUserLoggedIn', 'getAllPlans', 'getGiftee', 'getGiftingError', 'getCorporateGiftingCode', 'getCorporateClientId', 'getCorporateClient', 'getAllSiteContents', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getCorporateGiftInfo', 'getCorpRestrictedRegions', 'getCorporationRegions']))
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_masked_input__ = __webpack_require__(30);








/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["accordion"],
        'panel': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["panel"],
        'masked-input': __WEBPACK_IMPORTED_MODULE_4_vue_masked_input__["a" /* default */],
        alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
        dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["dropdown"],
        radio: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["radio"],
        VuePassword: __WEBPACK_IMPORTED_MODULE_3_vue_password___default.a,
        checkbox: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        tabs: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tabs"],
        tab: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tab"],
        buttonGroup: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"]
    },
    name: 'signUp',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Redeem Your Gift',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Redeem Your Gift' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Redeem Your Gift' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            GifteeUser: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                packageId: 0,
                comments: '',
                phoneNumber: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg'
            },
            userObject: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                cardHolderName: '',
                phoneNumber: '',
                packageId: '',
                userPayments: [],
                isPaypalCustomer: '',
                paypalSubscriptionId: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg',
                comments: ''
            },

            userPayments: {
                token: '',
                stripeCardId: '',
                paymentType: 'CC',
                paymentDate: new Date(),
                paypalPayerId: '',
                paypalPaymentId: '',
                paymentMethodNonce: ''
            },
            rawPhoneNumber: '',
            phoneNumber: '',
            spinner: false,
            alert: false,
            passwordError: '',
            confirmPassword: '',
            stripe: '',
            card: '',
            panelStatus: false,
            createSection: true,
            paymentSection: false,
            isToggle: false,
            defaultPlan: '',
            isChecked: false,
            reqPlanCode: this.$route.params.planId ? this.$route.params.planId : '7DaysFree',
            daysToCancel: 0,
            isStripe: true,
            packageId: 0,

            stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo',
            gateway: 'CC',
            paypalPayerID: '',
            paypalPaymentId: '',
            paypalToken: '',

            paypalResponse: '',
            giftCode: '',
            codeRedeemed: false,
            stripeErrorMessage: '',
            hidePasswordMeter: true,
            isMonthlySubscription: true,
            isAnnualSubscription: false,
            annualPlan: '',
            planAmount: 0,
            dynamic_bullet_1: '',
            dynamic_bullet_2: '',
            dynamic_bullet_3: '',
            dynamic_bullet_4: '',
            dynamic_bullet_5: '',
            dynamic_bullet_6: ''
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$store.dispatch('GETDYNAMICCONTENTS', 4).then(function () {
            if (_this.getAllSiteContents) {
                _this.dynamic_bullet_1 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_1');
                _this.dynamic_bullet_2 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_2');
                _this.dynamic_bullet_3 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_3');
                _this.dynamic_bullet_4 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_4');
                _this.dynamic_bullet_5 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_5');
                _this.dynamic_bullet_6 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_6');
            }
        });
        var self = this;
        if (this.$route.params.giftCode && this.$route.params.corporateId) {
            this.$store.commit('setCorporateGiftingCode', { giftCode: this.$route.params.giftCode });
            this.$store.commit('setCorporateClientId', { corporateClientId: this.$route.params.corporateId });
            this.$store.dispatch('GETCORPORATECLIENT', this.$route.params.corporateId).then(function () {});

            var giftPayload = [];
            giftPayload.push(self.$route.params.giftCode);
            giftPayload.push(self.$route.params.corporateId);
            this.$store.dispatch('GETCORPORATIONPLAN', giftPayload).then(function () {
                self.$store.dispatch('GETPLANS').then(function () {
                    if (self.getCorporateClientPlanId) {
                        var regularPlan = self.getAllPlans.filter(function (x) {
                            return x.packageId === self.getCorporateClientPlanId;
                        });
                        if (regularPlan && regularPlan.length > 0) {
                            var regPlan = regularPlan[0];
                            self.defaultPlan = regPlan;
                            self.userObject.packageId = regPlan.packageId;
                            self.packageId = regPlan.packageId;
                        }
                    }
                });
            });
            this.$store.dispatch('GETPAYPALTOKEN');
            this.mountStripeElement();
        } else {
            this.$router.push('/');
        }
    },

    methods: {
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        mountbraintree: function mountbraintree() {
            var self = this;
            if (self.getPaypalToken) {
                window.braintree.client.create({
                    authorization: 'production_6r7mxqgh_htw3nq9wp32w8h2x'
                }, function (clientErr, clientInstance) {
                    if (clientErr) {
                        console.error('Error creating client:', clientErr);
                        return;
                    }

                    window.braintree.paypalCheckout.create({
                        client: clientInstance
                    }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                        if (paypalCheckoutErr) {
                            console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
                            return;
                        }

                        window.paypal.Button.render({
                            env: 'production',
                            payment: function payment() {
                                return paypalCheckoutInstance.createPayment({
                                    flow: 'vault',
                                    amount: self.planAmount,
                                    currency: 'USD',
                                    intent: 'sale'
                                });
                            },
                            onAuthorize: function onAuthorize(data, actions) {
                                return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
                                    self.userPayments.paymentMethodNonce = payload.nonce;
                                });
                            },
                            onCancel: function onCancel(data) {},
                            onError: function onError(err) {
                                console.error('checkout.js error', err);
                            }
                        }, '#paypal-button').then(function () {});
                    });
                });
            }
        },
        redeemCode: function redeemCode() {
            var _this2 = this;

            if (this.giftCode && this.giftCode.length > 0) {
                this.spinnerToggle();
                this.$store.dispatch('GETGIFTEE', this.giftCode).then(function () {
                    _this2.spinnerToggle();
                    if (_this2.getGiftee) {
                        _this2.user.firstName = _this2.getGiftee.gifteeFirstName;
                        _this2.user.lastName = _this2.getGiftee.gifteeLastName;
                        _this2.user.email = _this2.getGiftee.gifteeEmail;
                        _this2.user.packageId = _this2.getGiftee.packageId;
                        _this2.user.comments = _this2.getGiftee.gifteeUuid;
                        _this2.codeRedeemed = true;
                        _this2.$store.dispatch('GETPLANS').then(function () {
                            var plan = _this2.getAllPlans.filter(function (pln) {
                                return pln.packageId === _this2.getGiftee.packageId;
                            });
                            _this2.defaultPlan = plan[0];
                        });
                    }
                });
            }
        },
        togglePaymentMethods: function togglePaymentMethods() {
            var _this3 = this;

            if (this.gateway === 'paypal') {
                this.isStripe = false;
                setTimeout(function () {
                    _this3.mountbraintree();
                }, 1000);
            } else {
                this.isStripe = true;
                this.mountStripeElement();
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this4 = this;

            if (this.user && this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                this.isToggle = false;
                this.spinnerToggle();
                this.$store.dispatch('VERIFYUSEREXISTS', { email: this.user.email }).then(function () {
                    _this4.spinnerToggle();
                    if (!_this4.error.show) {
                        _this4.isToggle = true;
                        _this4.createSection = false;
                        _this4.paymentSection = true;
                        _this4.user.cardHolderName = _this4.user.firstName + ' ' + _this4.user.lastName;

                        _this4.isStripe = true;
                        _this4.gateway = 'CC';
                        _this4.mountStripeElement();
                    }
                });
            }
        },
        mountStripeElement: function mountStripeElement() {
            var _this5 = this;

            setTimeout(function () {
                _this5.stripe = window.Stripe(_this5.stripeKey);
                var elements = _this5.stripe.elements();
                _this5.card = elements.create('card');
                _this5.card.mount('#card-element');
            }, 1000);
        },
        disablePaymentPanel: function disablePaymentPanel() {
            this.panelStatus = false;
        },
        verifyPaymentSubmit: function verifyPaymentSubmit() {
            if (this.userObject.packageId > 0) {
                return false;
            }
            return true;
        },
        verifyPassword: function verifyPassword() {
            if (this.userObject.password.length >= 6) {
                var re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/;
                if (!re.test(this.userObject.password)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (this.userObject.password.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        verifyEmail: function verifyEmail() {
            if (this.user.email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(this.user.email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyFirstName: function verifyFirstName() {
            if (this.user.firstName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.firstName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyLastName: function verifyLastName() {
            if (this.user.lastName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.lastName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyCardHolderName: function verifyCardHolderName() {
            if (this.userObject.cardHolderName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.userObject.cardHolderName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onPaymentSubmit: function onPaymentSubmit() {
            var _this6 = this;

            var self = this;
            if (this.codeRedeemed) {
                if (this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                    this.GifteeUser.firstName = this.user.firstName;
                    this.GifteeUser.lastName = this.user.lastName;
                    this.GifteeUser.email = this.user.email.toLowerCase();
                    this.GifteeUser.password = this.user.password;
                    this.GifteeUser.packageId = this.getGiftee.packageId;
                    this.GifteeUser.comments = this.getGiftee.gifteeUuid;
                    this.spinnerToggle();
                    this.$store.dispatch('SAVEGIFTEE', { giftee: this.GifteeUser }).then(function () {
                        if (!_this6.error.show) {
                            _this6.spinnerToggle();
                            _this6.$swal({
                                title: 'Registration Success!',
                                text: 'Welcome To TONE! For your security, please check your inbox for a Validation Email - TONE Networks within the next 12 hours.  (Don’t see it…check your spam folder.)',
                                type: 'success',
                                timer: 4000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {}
                            });
                        } else {
                            _this6.spinnerToggle();
                        }
                    });
                }
            } else {
                if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                    self.userObject.phoneNumber = this.phoneNumber;
                } else {
                    this.phoneNumber = '';
                    self.userObject.phoneNumber = '';
                }
                if (self.gateway !== 'CC') {
                    self.userObject.cardHolderName = ' ';
                }
                if (self.userObject && self.verifyCardHolderName()) {
                    self.spinnerToggle();
                    self.$store.dispatch('VERIFYUSEREXISTS', { email: self.userObject.email }).then(function () {
                        if (!self.error.show) {
                            self.userObject.email = self.userObject.email.toLowerCase();
                            self.userObject.comments = self.getCorporateGiftingCode;

                            if (self.gateway === 'CC') {
                                self.stripe.createToken(self.card).then(function (result) {
                                    if (result.error) {
                                        self.spinnerToggle();

                                        self.stripeErrorMessage = result.error.message;
                                    } else {
                                        var stripeToken = result.token.id;
                                        var cardId = result.token.card.id;

                                        self.userPayments.token = stripeToken;
                                        self.userPayments.stripeCardId = cardId;
                                        if (self.userObject.userPayments.length > 0) {
                                            self.userObject.userPayments.pop();
                                        }
                                        self.userObject.userPayments.push(self.userPayments);
                                        if (stripeToken) {
                                            self.$store.dispatch('SIGNUPWITHPAYMENTPLAN', { user: self.userObject }).then(function () {
                                                if (!self.error.show) {
                                                    self.spinnerToggle();
                                                    self.$swal({
                                                        title: 'Registration Success!',
                                                        text: 'Welcome To TONE!',
                                                        type: 'success',
                                                        timer: 4000,
                                                        showCancelButton: false,
                                                        showConfirmButton: false
                                                    }).then(function () {}, function (dismiss) {
                                                        if (dismiss === 'timer') {}
                                                    });
                                                } else {
                                                    self.spinnerToggle();
                                                }
                                            });
                                        }
                                    }
                                });
                            } else if (self.userPayments.paymentMethodNonce) {
                                if (self.userObject.userPayments.length > 0) {
                                    self.userObject.userPayments.pop();
                                }
                                self.userObject.userPayments.push(self.userPayments);
                                if (self.userPayments.paymentMethodNonce) {
                                    self.$store.dispatch('SIGNUPWITHPAYMENTPLAN', { user: self.userObject }).then(function () {
                                        if (!self.error.show) {
                                            self.spinnerToggle();
                                            self.$swal({
                                                title: 'Registration Success!',
                                                text: 'Welcome To TONE!',
                                                type: 'success',
                                                timer: 4000,
                                                showCancelButton: false,
                                                showConfirmButton: false
                                            }).then(function () {}, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        } else {
                                            self.spinnerToggle();
                                        }
                                    });
                                }
                            } else {
                                self.spinnerToggle();
                            }
                        } else {
                            self.spinnerToggle();
                        }
                    });
                }
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['error', 'isUserLoggedIn', 'getDefaultPlan', 'getGiftee', 'getAllPlans', 'getPaypalToken', 'getTrialDays', 'user', 'getCorporateClient', 'getCorporateClientPlanId', 'getCorporateGiftingCode', 'getAllSiteContents'])),
    watch: {
        'user.firstName': function userFirstName(to, from) {
            this.user.cardHolderName = this.user.firstName + ' ' + this.user.lastName;
        },
        'user.lastName': function userLastName(to, from) {
            this.user.cardHolderName = this.user.firstName + ' ' + this.user.lastName;
        },
        'packageId': function packageId(to, from) {
            this.userObject.packageId = this.packageId;
            if (this.packageId === 4) {
                this.planAmount = this.annualPlan.amount;
            } else {
                this.planAmount = this.defaultPlan.amount;
            }
        },
        'gateway': function gateway(to, from) {
            var _this7 = this;

            if (this.gateway === 'paypal') {
                this.card.unmount('#card-element');
                this.stripeErrorMessage = '';
                this.isStripe = false;
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';
                this.userPayments.paymentType = 'PayPal';
                this.userObject.isPaypalCustomer = '1';
                this.userPayments.paymentMethodNonce = '';
                setTimeout(function () {
                    _this7.mountbraintree();
                }, 1000);
            } else {
                this.stripeErrorMessage = '';
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';
                this.userObject.isPaypalCustomer = '0';
                this.userPayments.paymentType = 'CC';
                this.userPayments.paymentMethodNonce = '';
                this.isStripe = true;
                setTimeout(function () {
                    _this7.mountStripeElement();
                }, 1000);
            }
        }
    }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_strap__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'demoTalk',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_4__JwPlayer_vue___default.a,
        spinner: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["spinner"]
    },
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | TONE Event',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Event' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Event' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            chatRollURL: '',
            eventUsersArray: [],
            eventUserArray: [],
            chatrllRef: '',
            intervalId: '',
            jwEventRef: '',
            userSignature: 'b443b3462870037c9ac0aecf05bc5ca8',
            userAuthenticated: false,
            userType: 0,
            toggleSpinner: false,
            currentVideo: null,
            participantCount: 0,
            userRef: 0,
            seatReservation: {
                userEventId: 0,
                eventId: 0,
                userId: 0,
                status: 0,
                isAnonymous: 0
            }
        };
    },
    watch: {
        'userAuthenticated': function userAuthenticated(to, from) {
            var _this = this;

            if (this.userAuthenticated) {
                this.toggleSpinner = true;
                setTimeout(function () {
                    _this.toggleSpinner = false;
                }, 2500);
            }
        }
    },
    methods: {
        switchEventView: function switchEventView() {
            var self = this;

            self.userSignature = self.getDemoEvent.userSignagure;
            self.userRef = self.getDemoEvent.userRef;
            console.log('user ref', self.userRef);
            self.chatRollURL = self.getDemoEvent.chatrollEventUrl + '&uid=' + self.userRef + '&uname=Shoe-cognito&sig=' + self.userSignature + '&ismod=0&upic=https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg';
            console.log('chatrol ref', self.chatRollURL);
            self.userAuthenticated = true;
            window.scrollTo(0, 0);
        },
        joinEvent: function joinEvent(isAnonymous) {
            var _this2 = this;

            this.updateUserStatus(isAnonymous);
            if (this.getSelectedEvent) {
                if (this.getSelectedEvent[0].type === '1') {
                    if (isAnonymous === '1') {
                        setTimeout(function () {
                            _this2.$store.dispatch('GETUSEREVENTS', _this2.user.userId).then(function () {
                                if (_this2.getUserEvents) {
                                    var uEvent = _this2.getUserEvents.filter(function (ev) {
                                        return ev.eventId === _this2.getSelectedEvent[0].eventId;
                                    });
                                    uEvent[0].isAnonymous = '1';
                                    uEvent[0].firstName = 'Shoe-cognito';
                                    _this2.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(function () {
                                        if (_this2.getUserSignature) {
                                            _this2.$router.push('/liveevent/' + _this2.getSelectedEvent[0].eventId);
                                        }
                                    });
                                }
                            });
                        }, 500);
                    } else {
                        this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(function () {
                            if (_this2.getUserSignature) {
                                _this2.$router.push('/liveevent/' + _this2.getSelectedEvent[0].eventId);
                            }
                        });
                    }
                } else {
                    if (isAnonymous === '1') {
                        setTimeout(function () {
                            _this2.$store.dispatch('GETUSEREVENTS', _this2.user.userId).then(function () {
                                if (_this2.getUserEvents) {
                                    var uEvent = _this2.getUserEvents.filter(function (ev) {
                                        return ev.eventId === _this2.getSelectedEvent[0].eventId;
                                    });
                                    uEvent[0].isAnonymous = '1';
                                    uEvent[0].firstName = 'Shoe-cognito';
                                    _this2.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(function () {
                                        if (_this2.getUserSignature) {
                                            _this2.$router.push('/talk/' + _this2.getSelectedEvent[0].eventId);
                                        }
                                    });
                                }
                            });
                        }, 500);
                    } else {
                        this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(function () {
                            if (_this2.getUserSignature) {
                                _this2.$router.push('/talk/' + _this2.getSelectedEvent[0].eventId);
                            }
                        });
                    }
                }
            }
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET';
            }
        },
        setCarousal: function setCarousal() {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('.responsive-slick-eventusers');
            $slick.each(function () {
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        leaveEvent: function leaveEvent() {
            this.userAuthenticated = false;
            window.scrollTo(0, 0);
        },
        refreshAttendees: function refreshAttendees() {
            var _this3 = this;

            if (this.getSelectedEvent) {
                this.$store.dispatch('GETEVENTUSERS', this.getSelectedEvent[0].eventId).then(function () {
                    if (_this3.getEventUsers) {
                        if (!_this3.getSelectedEvent[0].jw_rtmp_url) {
                            console.log('refreshing regular chat');
                            _this3.participantCount = _this3.getEventUsers.length;
                            _this3.eventUsersArray.splice(0, _this3.eventUsersArray.length);
                            __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this3.$el).find('.responsive-slick-eventusers').slick('unslick');

                            _this3.eventUserArray = _this3.getEventUsers;
                            while (_this3.eventUserArray.length > 0) {
                                _this3.eventUsersArray.push(_this3.eventUserArray.splice(0, 9));
                            }
                            setTimeout(function () {
                                _this3.setCarousal();
                            }, 1000);
                        } else {
                            console.log('refreshing Live chat', _this3.getEventUsers.length);
                            _this3.participantCount = _this3.getEventUsers.length;
                        }
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        var self = this;
        self.$store.dispatch('GETDEMOEVENTS').then(function () {
            if (self.getDemoEvent) {
                console.log('demo event details', self.getDemoEvent);
                self.chatrllRef = self.getDemoEvent.chatrollEventUrl;
                self.$store.dispatch('GETEXPERT', self.getDemoEvent.expertId).then(function () {});
                if (self.getDemoEvent.videoCode && self.getDemoEvent.videoCode.length > 2) {
                    self.$store.dispatch('GETCURRENTVIDEO', self.getDemoEvent.videoCode).then(function () {
                        console.log('current video', self.getCurrentVideo);
                        if (self.getCurrentVideo) {
                            var videoObj = self.getCurrentVideo[0];
                            self.currentVideo = {
                                video: videoObj.sources[videoObj.sources.length - 1].file,
                                title: videoObj.title,
                                img: videoObj.image,
                                playerID: new Date(),
                                tracks: videoObj.tracks,
                                Description: videoObj.description,
                                mediaId: videoObj.mediaid,
                                isMute: true
                            };
                        }
                    });
                }
            }
        });
        setTimeout(function () {
            window.addeventatc.refresh();
        }, 2000);
    },
    beforeDestroy: function beforeDestroy() {},

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['user', 'getExpert', 'getSelectedEvent', 'getUserEvents', 'getEventUsers', 'getUserSignature', 'getUserStatus', 'getDemoEvent', 'getCurrentVideo']))
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers_js__ = __webpack_require__(15);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'expert',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default.a,
        'tabs': __WEBPACK_IMPORTED_MODULE_4_vue_strap__["tabs"],
        'tab': __WEBPACK_IMPORTED_MODULE_4_vue_strap__["tab"],
        modal: __WEBPACK_IMPORTED_MODULE_4_vue_strap__["modal"]
    },
    data: function data() {
        return {
            activeTab: 0,
            expertEvent: '',
            expertMainVideo: '',
            showWatchVideoModal: false,
            currentPlayerID: '',
            currentVideoRef: '',
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            topVideos: [],
            seatReservation: {
                userEventId: 0,
                eventId: 0,
                userId: 0,
                status: 0,
                isAnonymous: 0
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$store.dispatch('GETEXPERT', this.$route.params.expertId).then(function () {
            if (_this.getExpert) {
                _this.$store.dispatch('GETEVENTLIST').then(function () {
                    if (_this.getEventList) {
                        var expEvent = _this.getEventList.filter(function (ev) {
                            return ev.expertId === _this.getExpert[0].expertId;
                        });
                        if (expEvent && expEvent.length > 0) {
                            _this.expertEvent = expEvent[0];
                        }
                    }
                });

                if (_this.user) {
                    _this.$store.dispatch('GETUSEREVENTS', _this.user.userId).then(function () {});
                }
            }
        });

        this.$store.dispatch('GETEXPERTVIDEOS', this.$route.params.expertId).then(function () {
            if (_this.getExpertVideos) {
                _this.topVideos = _this.getExpertVideos.slice(0, 7);
                console.log('top videos retreived', _this.topVideos);
                console.log('after status', _this.getExpertVideos);
                var mainVideo = _this.getExpertVideos[0];
                if (!_this.expertEvent) {
                    _this.expertMainVideo = {
                        video: mainVideo.sources[mainVideo.sources.length - 1].file,
                        title: mainVideo.title,
                        img: mainVideo.image,
                        playerID: new Date(),
                        tracks: mainVideo.tracks,
                        isMute: true,
                        showCaptions: true,
                        mediaId: mainVideo.mediaid
                    };
                }
            }
        });
        this.$store.dispatch('GETEXPERTPLAYLIST', this.$route.params.expertId).then(function () {});

        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(function () {});

        this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(function () {});
        window.scrollTo(0, 0);
    },
    methods: {
        setVideoPlayerObject: function setVideoPlayerObject(videoObject) {
            if (videoObject.marketing) {
                this.openModal(videoObject);
            } else {
                if (this.user) {
                    this.$router.push('/watch/' + videoObject.videoCode);
                } else {
                    if (sessionStorage.getItem('redirectPath')) {
                        sessionStorage.removeItem('redirectPath');
                        sessionStorage.setItem('redirectPath', '/watch/' + videoObject.videoCode);
                    } else {
                        sessionStorage.setItem('redirectPath', '/watch/' + videoObject.videoCode);
                    }
                    __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
                }
            }
        },
        cancelModal: function cancelModal() {
            var self = this;
            var $ = __webpack_provided_window_dot_jQuery;
            setTimeout(function () {
                self.showModal = false;
                self.showWatchVideoModal = false;

                $('.modal-open').removeClass('modal-open');
            }, 500);
        },
        openModal: function openModal(mainVideoObj) {
            var self = this;
            if (!this.expertEvent) {
                if (self.currentVideoRef) {
                    window.jwplayer(self.currentVideoRef).pause(true);
                } else {
                    self.currentVideoRef = window['currentVideoId'];
                    window.jwplayer(self.currentVideoRef).pause(true);
                }
            }
            this.currentPlayerID = { video: mainVideoObj.sources[mainVideoObj.sources.length - 1].file, title: mainVideoObj.title, img: mainVideoObj.image, playerID: new Date(), tracks: mainVideoObj.tracks, videoDescription: mainVideoObj.longdescription };
            this.showWatchVideoModal = true;
            this.currentVideoDesc = mainVideoObj.description;
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET';
            }
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        },
        isUserEntrolled: function isUserEntrolled(eventId) {
            if (this.getUserEvents) {
                var filter = this.getUserEvents.filter(function (ev) {
                    return ev.eventId === eventId;
                });
                if (filter && filter.length > 0) {
                    return true;
                }
            }
            return false;
        },
        getMinutesBetweenDates: function getMinutesBetweenDates(startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime();
            return diff / 60000;
        },
        returnEasternTime: function returnEasternTime() {
            var offset = -5;
            if (__WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers_js__["a" /* dateHelpers */].dstEnabled(new Date())) {
                offset = -4.0;
            }
            var clientDate = new Date();
            var utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
            var serverDate = new Date(utc + 3600000 * offset);
            return serverDate;
        },
        isEventToday: function isEventToday(evtDate, endDate) {
            var eventDate = new Date(evtDate);
            var eventEndDate = new Date(endDate);
            var currentDate = this.returnEasternTime();

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= 15 && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        enrollUser: function enrollUser(event) {
            var _this2 = this;

            this.seatReservation.eventId = event.eventId;
            this.seatReservation.userId = this.user.userId;
            this.seatReservation.status = '1';
            this.seatReservation.isAnonymous = '0';
            this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(function () {
                _this2.$store.dispatch('GETALLEXPERTS').then(function () {});
                _this2.$store.dispatch('GETUSEREVENTS', _this2.user.userId).then(function () {});
            });
        },
        addNewPlayList: function addNewPlayList() {
            var _this3 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this3.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoStatus: function setVideoStatus(videoObject) {
            var _this4 = this;

            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0';
                    } else {
                        exists[0].liked = '1';
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(function () {
                        _this4.$store.dispatch('GETAUTHUSERVIDEOS', _this4.user.userId);
                    });
                } else {
                    var logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    };
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {
                        _this4.$store.dispatch('GETAUTHUSERVIDEOS', _this4.user.userId);
                    });
                }
            }
        },
        verifyVideoStatus: function verifyVideoStatus(videoCode) {
            if (this.getExpertVideos) {
                var getStatus = this.topVideos.filter(function (x) {
                    return x.mediaid === videoCode;
                });
                if (getStatus && getStatus.length > 0) {
                    console.log('video found - ', getStatus[0].title + ' - ' + getStatus[0].mediaid);
                    return true;
                } else {
                    console.log('video not found - ', videoCode);
                    return false;
                }
            }
        },
        createSlickCarousal: function createSlickCarousal() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'isScrolled', 'getExpert', 'getExpertVideos', 'getEventList', 'getUserEvents', 'getVideosFlag', 'getExpertPlaylist', 'getUserPlaylists', 'getAuthUserVideos']))
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        alert: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"],
        spinner: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        checkbox: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["checkbox"],
        carousel: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["carousel"],
        slider: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["slider"]
    },
    name: 'emailRules',
    data: function data() {
        return {
            userObj: {
                userId: 0,
                isOptOutTeaser: false,
                isOptOutTakeaways: false,
                isOptOutContentEmail: false
            },
            spinner: false,
            paramEmail: '',
            paramValidationCode: '',
            validationSuccess: false,
            teaserRule: false,
            takeawayRule: false,
            userId: ''
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'user', 'getValidationStatusError', 'getUserEmailPreferences'])),
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        updatePrefrences: function updatePrefrences() {
            var _this = this;

            var self = this;
            self.spinnerToggle();
            var finalObj = {
                userId: self.userObj.userId,
                isOptOutTeaser: self.userObj.isOptOutTeaser ? 1 : 0,
                isOptOutTakeaways: self.userObj.isOptOutTakeaways ? 1 : 0,
                isOptOutContentEmail: self.userObj.isOptOutContentEmail ? 1 : 0
            };
            this.$store.dispatch('UPDATE_USER_PREFERENCES', { user: finalObj }).then(function () {
                if (!_this.error.show) {
                    _this.spinnerToggle();
                    self.$swal({
                        title: 'Thank you!',
                        text: 'Your email preferences have been updated',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    self.$router.push('/');
                } else {
                    _this.spinnerToggle();
                }
            });
        },

        onSubmit: function onSubmit() {
            var _this2 = this;

            if (this.user) {
                this.$store.dispatch('VALIDATE', { user: this.user }).then(function () {
                    if (!_this2.error.show) {
                        _this2.validationSuccess = true;
                        setTimeout(function () {
                            _this2.validationSuccess = false;
                            _this2.$router.push('/');
                        }, 4000);
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        var self = this;
        self.userId = self.$route.query.params;
        if (self.$route.query.params) {
            self.userObj.userId = self.userId;
            self.$store.dispatch('GET_USER_EMAIL_PREFRENCES', self.userId).then(function () {
                if (self.getUserEmailPreferences) {
                    if (self.getUserEmailPreferences.isOptOutTeaser === 1) {
                        self.userObj.isOptOutTeaser = true;
                    }
                    if (self.getUserEmailPreferences.isOptOutTakeaways === 1) {
                        self.userObj.isOptOutTakeaways = true;
                    }
                    if (self.getUserEmailPreferences.isOptOutContentEmail === 1) {
                        self.userObj.isOptOutContentEmail = true;
                    }
                } else {
                    self.$swal({
                        title: 'User Reference not found',
                        text: '',
                        type: 'error',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    self.$router.push('/');
                }
            });
        } else {
            self.$router.push('/');
        }
    }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dateHelpers_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RulesComp_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RulesComp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RulesComp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'community',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_4__JwPlayer_vue___default.a,
        rulescomp: __WEBPACK_IMPORTED_MODULE_5__RulesComp_vue___default.a,
        spinner: __WEBPACK_IMPORTED_MODULE_6_vue_strap__["spinner"],
        modal: __WEBPACK_IMPORTED_MODULE_6_vue_strap__["modal"]
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: 'TONE Upcoming Events |' + self.sTitle,
            meta: [{ property: 'og:image', content: self.sImage }, { property: 'og:title', content: self.sTitle }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: self.sDescription
            }, { property: 'twitter:title', content: self.sTitle }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.sImage }, {
                property: 'twitter:description',
                content: self.sDescription
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            shareImagePayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                recipientFriendEmails: null,
                eventId: '',
                customizedMessage: '',
                playlistType: 6
            },
            shareEventSelected: null,
            showCorporateImageShare: false,
            corporateShareMessage: '',
            selectedPlaylist: null,
            corpShareModalImage: '',
            showCorporateShare: false,
            corpShareModalTitle: '',
            corpShareModalDesc: '',
            selectedCorps: [],
            allCorps: [],
            shareOption: 'Corporate',
            spinner: false,
            taggedEmails: [],
            emailList: [],
            previewMsg: 'Message Preview: \n',
            showSharedModal: false,
            shareInProcess: false,
            toggleSpinner: false,
            showRulesComp: false,
            videoRef: '',
            currentVideo: null,
            reservationMsg: '',
            bannerEvent: null,
            eventURL: 'https://www1.dev-tonenetworks.com',
            sImage: '',
            sTitle: '',
            sDescription: '',
            timeTostartEvent: 0,
            seatReservation: {
                userEventId: 0,
                eventId: 0,
                userId: 0,
                status: 0,
                isAnonymous: 0
            }
        };
    },
    watch: {
        'bannerEvent': function bannerEvent(to, from) {
            var self = this;
            if (self.bannerEvent && self.bannerEvent.eventId > 0) {
                self.sTitle = self.bannerEvent.type === '1' ? 'TONE Live: ' + self.bannerEvent.title : 'TONE Talk: ' + self.bannerEvent.title;
                self.sImage = self.bannerEvent.img_url;
                self.sDescription = self.bannerEvent.longDescription;
                self.showRulesComp = true;
                self.$store.dispatch('CACHEPAGE', window.location.href);
                self.calculateTimeToStartEvent(self.bannerEvent.start_date, self.bannerEvent.end_date, self.bannerEvent.eventSwitchTime, self.getEventSwitchTime);
                if (self.bannerEvent.jw_stream_title && self.bannerEvent.jw_stream_title.length > 2) {
                    self.$store.dispatch('GETCURRENTVIDEO', self.bannerEvent.jw_stream_title).then(function () {
                        if (self.getCurrentVideo) {
                            var videoObj = self.getCurrentVideo[0];
                            self.currentVideo = {
                                video: videoObj.sources[videoObj.sources.length - 1].file,
                                title: videoObj.title,
                                img: videoObj.image,
                                playerID: new Date(),
                                tracks: videoObj.tracks,
                                Description: videoObj.description,
                                mediaId: videoObj.mediaid,
                                isMute: true
                            };
                            self.videoRef = window['currentVideoId'];
                        }
                    });
                }
            } else {}
        },
        'shareOption': function shareOption(to, from) {
            var self = this;
            self.selectedCorps = null;
            self.corporateShareMessage = '';
            self.taggedEmails = [];
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            window.addeventatc.refresh();
        }, 2000);
        var eventIdParam = this.$route.params.eventId;

        var self = this;
        var apiName = 'GETEVENTLIST';
        if (self.user && self.user.adminAccessLevel === 1) {
            apiName = 'GETADMINEVENTS';
        }
        console.info(3);
        if (eventIdParam) {
            this.$store.dispatch('' + apiName).then(function () {
                if (_this.getEventList) {
                    console.info(4);
                    var getEvt = _this.getEventList.filter(function (ev) {
                        return ev.eventId.toString() === eventIdParam.toString();
                    });
                    console.log('found event', getEvt);
                    if (getEvt && getEvt.length > 0) {
                        self.eventId = getEvt[0].eventId;
                        _this.$store.dispatch('SETBANNEREVENT', getEvt[0].eventId).then(function () {});
                        _this.bannerEvent = getEvt[0];
                        _this.$store.dispatch('GETEXPERT', getEvt[0].expertId).then(function () {
                            if (self.bannerEvent.type === '1') {
                                self.sTitle = 'TONE Live: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                self.sImage = self.bannerEvent.img_url;
                                self.sDescription = self.bannerEvent.longDescription;
                            } else {
                                self.sTitle = 'TONE Talk: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                self.sImage = self.bannerEvent.img_url;
                                self.Description = self.bannerEvent.longDescription;
                            }
                        });
                    } else {
                        var currentDate = _this.returnEasternTime();
                        var eMonth = currentDate.getMonth() + 1;
                        eMonth = eMonth >= 10 ? eMonth : '0' + eMonth;
                        var eDate = currentDate.getDate() >= 10 ? currentDate.getDate() : '0' + currentDate.getDate();
                        var formattedDate = eMonth + '/' + eDate + '/' + currentDate.getFullYear();

                        var eventsOnDate = _this.getEventList.filter(function (ev) {
                            return ev.start_date.substr(0, 10) === formattedDate;
                        });

                        var eventsNotOnDate = _this.getEventList.filter(function (ev) {
                            return new Date(ev.start_date.substr(0, 10)) > new Date(formattedDate);
                        });
                        if (eventsOnDate && eventsOnDate.length > 0) {
                            if (_this.isEventToday(eventsOnDate[0].end_date)) {
                                self.eventId = eventsOnDate[0].eventId;
                                _this.$store.dispatch('SETBANNEREVENT', eventsOnDate[0].eventId).then(function () {});
                                if (self.eventId > 0) {
                                    if (self.getEventList) {
                                        var ev = _this.getEventList.filter(function (ev) {
                                            return ev.eventId === self.eventId;
                                        });
                                        if (ev && ev.length > 0) {
                                            _this.bannerEvent = ev[0];
                                            _this.$store.dispatch('GETEXPERT', ev[0].expertId).then(function () {
                                                if (self.bannerEvent.type === '1') {
                                                    self.sTitle = 'TONE Live: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                                    self.sImage = self.bannerEvent.img_url;
                                                    self.sDescription = self.bannerEvent.longDescription;
                                                } else {
                                                    self.sTitle = 'TONE Talk: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                                    self.sImage = self.bannerEvent.img_url;
                                                    self.Description = self.bannerEvent.longDescription;
                                                }
                                            });
                                        }
                                    }
                                } else {
                                    console.info('1');
                                    _this.$router.push('/');
                                }
                            } else {
                                if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                    self.eventId = eventsNotOnDate[0].eventId;
                                    _this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(function () {});
                                    if (self.eventId > 0) {
                                        if (self.getEventList) {
                                            var _ev = _this.getEventList.filter(function (ev) {
                                                return ev.eventId === self.eventId;
                                            });
                                            if (_ev && _ev.length > 0) {
                                                _this.bannerEvent = _ev[0];
                                                _this.$store.dispatch('GETEXPERT', _ev[0].expertId).then(function () {
                                                    if (self.bannerEvent.type === '1') {
                                                        self.sTitle = 'TONE Live: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                                        self.sImage = self.bannerEvent.img_url;
                                                        self.sDescription = self.bannerEvent.longDescription;
                                                    } else {
                                                        self.sTitle = 'TONE Talk: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                                        self.sImage = self.bannerEvent.img_url;
                                                        self.Description = self.bannerEvent.longDescription;
                                                    }
                                                });
                                            }
                                        }
                                    } else {
                                        console.info('2');
                                        _this.$router.push('/');
                                    }
                                }
                            }
                        } else {
                            if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                self.eventId = eventsNotOnDate[0].eventId;
                                _this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(function () {});
                                if (self.eventId > 0) {
                                    if (self.getEventList) {
                                        var _ev2 = _this.getEventList.filter(function (ev) {
                                            return ev.eventId === self.eventId;
                                        });
                                        if (_ev2 && _ev2.length > 0) {
                                            _this.bannerEvent = _ev2[0];
                                            _this.$store.dispatch('GETEXPERT', _ev2[0].expertId).then(function () {
                                                if (self.bannerEvent.type === '1') {
                                                    self.sTitle = 'TONE Live: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                                    self.sImage = self.bannerEvent.img_url;
                                                    self.sDescription = self.bannerEvent.longDescription;
                                                } else {
                                                    self.sTitle = 'TONE Talk: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                                    self.sImage = self.bannerEvent.img_url;
                                                    self.Description = self.bannerEvent.longDescription;
                                                }
                                            });
                                        }
                                    }
                                } else {
                                    console.info('3');
                                    _this.$router.push('/');
                                }
                            }
                        }
                    }
                }
            });
        } else {
            this.$store.dispatch('GETEVENTLIST').then(function () {
                if (_this.getEventList) {
                    var currentDate = _this.returnEasternTime();
                    var eMonth = currentDate.getMonth() + 1;
                    eMonth = eMonth >= 10 ? eMonth : '0' + eMonth;
                    var eDate = currentDate.getDate() >= 10 ? currentDate.getDate() : '0' + currentDate.getDate();
                    var formattedDate = eMonth + '/' + eDate + '/' + currentDate.getFullYear();

                    var eventsOnDate = _this.getEventList.filter(function (ev) {
                        return ev.start_date.substr(0, 10) === formattedDate;
                    });

                    var eventsNotOnDate = _this.getEventList.filter(function (ev) {
                        return new Date(ev.start_date.substr(0, 10)) > new Date(formattedDate);
                    });
                    if (eventsOnDate && eventsOnDate.length > 0) {
                        if (_this.isEventToday(eventsOnDate[0].end_date)) {
                            self.eventId = eventsOnDate[0].eventId;
                            _this.$store.dispatch('SETBANNEREVENT', eventsOnDate[0].eventId).then(function () {});
                            if (self.eventId > 0) {
                                if (self.getEventList) {
                                    var ev = _this.getEventList.filter(function (ev) {
                                        return ev.eventId === self.eventId;
                                    });
                                    if (ev && ev.length > 0) {
                                        _this.bannerEvent = ev[0];
                                        _this.$store.dispatch('GETEXPERT', ev[0].expertId).then(function () {
                                            if (self.bannerEvent.type === '1') {
                                                self.sTitle = 'TONE Live: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                                self.sImage = self.bannerEvent.img_url;
                                                self.sDescription = self.bannerEvent.longDescription;
                                            } else {
                                                self.sTitle = 'TONE Talk: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                                self.sImage = self.bannerEvent.img_url;
                                                self.Description = self.bannerEvent.longDescription;
                                            }
                                        });
                                    }
                                }
                            } else {
                                console.info('4');
                                _this.$router.push('/');
                            }
                        } else {
                            if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                self.eventId = eventsNotOnDate[0].eventId;
                                _this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(function () {});
                                if (self.eventId > 0) {
                                    if (self.getEventList) {
                                        var _ev3 = _this.getEventList.filter(function (ev) {
                                            return ev.eventId === self.eventId;
                                        });
                                        if (_ev3 && _ev3.length > 0) {
                                            _this.bannerEvent = _ev3[0];
                                            _this.$store.dispatch('GETEXPERT', _ev3[0].expertId).then(function () {
                                                if (self.bannerEvent.type === '1') {
                                                    self.sTitle = 'TONE Live: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                                    self.sImage = self.bannerEvent.img_url;
                                                    self.sDescription = self.bannerEvent.longDescription;
                                                } else {
                                                    self.sTitle = 'TONE Talk: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                                    self.sImage = self.bannerEvent.img_url;
                                                    self.Description = self.bannerEvent.longDescription;
                                                }
                                            });
                                        }
                                    }
                                } else {
                                    console.info('5');
                                    _this.$router.push('/');
                                }
                            }
                        }
                    } else {
                        if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                            self.eventId = eventsNotOnDate[0].eventId;
                            _this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(function () {});
                            if (self.eventId > 0) {
                                if (self.getEventList) {
                                    var _ev4 = _this.getEventList.filter(function (ev) {
                                        return ev.eventId === self.eventId;
                                    });
                                    if (_ev4 && _ev4.length > 0) {
                                        _this.bannerEvent = _ev4[0];
                                        _this.$store.dispatch('GETEXPERT', _ev4[0].expertId).then(function () {
                                            if (self.bannerEvent.type === '1') {
                                                self.sTitle = 'TONE Live: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                                self.sImage = self.bannerEvent.img_url;
                                                self.sDescription = self.bannerEvent.longDescription;
                                            } else {
                                                self.sTitle = 'TONE Talk: ' + self.bannerEvent.title + ' with ' + self.getExpert[0].name;
                                                self.sImage = self.bannerEvent.img_url;
                                                self.Description = self.bannerEvent.longDescription;
                                            }
                                        });
                                    }
                                }
                            } else {
                                console.info('6');
                                _this.$router.push('/');
                            }
                        }
                    }
                }
            });
        }
        if (self.user) {
            self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(function () {
                if (self.getTaggedEmailList) {
                    self.emailList = [];
                    self.emailList = self.getTaggedEmailList;
                    console.log('email list', self.getTaggedEmailList);
                }
            });

            this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(function () {
                _this.allCorps = [];
                if (_this.getCorporatePayload) {
                    _this.corporateInfo = _this.getCorporatePayload;
                    _this.allCorps = _this.corporateInfo.lstCorporationUsers;
                }
            });
        }
    },
    methods: {
        replaceLastExpert: function replaceLastExpert(strArray, chr, newChr) {
            var a = strArray.split('');
            a[strArray.lastIndexOf(chr)] = newChr;
            return a.join('').replace('/,/g', ', ');
        },
        shareCorporateImage: function shareCorporateImage() {
            var self = this;
            self.shareImagePayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0;
            self.shareImagePayload.senderUserId = self.user.userId;
            self.shareImagePayload.recipientsUserIds = [];
            self.shareImagePayload.recipientFriendEmails = null;
            self.shareImagePayload.customizedMessage = self.corporateShareMessage;
            if (self.shareOption === 'Corporate') {
                self.shareImagePayload.recipientsUserIds = [];
                self.shareImagePayload.recipientFriendEmails = null;
            } else if (self.shareOption === 'Individual') {
                self.shareImagePayload.recipientFriendEmails = null;
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    self.shareImagePayload.recipientsUserIds = self.selectedCorps.map(function (x) {
                        return x.userId;
                    });
                }
            } else if (self.shareOption === 'Friends') {
                self.shareImagePayload.recipientsUserIds = [];
                var emailArray = self.taggedEmails.map(function (x) {
                    return x.name;
                });
                self.shareImagePayload.recipientFriendEmails = emailArray.join(',');
            } else {}
            self.shareImagePayload.eventId = self.shareEventSelected.eventId;
            self.shareInProcess = true;

            self.$store.dispatch('CORP_EVENT_SHARE', { payload: self.shareImagePayload }).then(function () {
                if (!self.error.show) {
                    self.spinnerToggle();
                    self.$swal({
                        title: 'Event has been shared!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });

                    self.cancelCorporateImageModal();
                } else {
                    self.cancelCorporateImageModal();
                }
            });
        },
        maskEmailAddress: function maskEmailAddress(userEmail) {
            var avg = void 0,
                splitted = void 0,
                part1 = void 0,
                part2 = void 0;
            splitted = userEmail.split('@');
            part1 = splitted[0];
            var regex = /[^0-9.]/g;
            var maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1);
            console.log('maked', maskid);
            avg = part1.length / 2;
            part1 = part1.substring(0, part1.length - avg);
            part2 = splitted[1];
            var maskDomain = part2.split('.');
            return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1];
        },
        customLabel: function customLabel(option) {
            var findDuplicate = this.allCorps.find(function (x) {
                return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId;
            });

            if (findDuplicate) {
                var maskedEmail = this.maskEmailAddress(option.email);
                return option.firstName + ' ' + option.lastName + ' <' + maskedEmail + '>';
            } else {
                return option.firstName + ' ' + option.lastName;
            }
        },
        openCorporateImageShareModal: function openCorporateImageShareModal(tEvent) {
            console.log('event for share', tEvent);
            var self = this;
            self.shareInProcess = false;
            self.shareEventSelected = tEvent;
            self.corpShareModalImage = tEvent.img_url;
            self.corpShareModalDesc = tEvent.description;
            self.corpShareModalTitle = tEvent.title;
            self.showCorporateImageShare = true;
        },
        verifyEmailShare: function verifyEmailShare(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        addTag: function addTag(newTag) {
            var self = this;
            console.log('newTAg', newTag);
            var tag = {
                name: newTag
            };
            if (self.verifyEmailShare(newTag)) {
                self.emailList.push(tag);
                this.taggedEmails.push(tag);
                console.log('tagged emails', this.taggedEmails);
            } else {
                console.log('invalid email address, calling swal');
            }
        },
        cancelCorporateImageModal: function cancelCorporateImageModal() {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateImageShare = false;
                self.shareInProcess = false;
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET';
            }
        },
        getExpertInfo: function getExpertInfo(expertId, info) {
            var reqInfo = void 0;
            if (this.getAllExperts) {
                var expert = this.getAllExperts.filter(function (exp) {
                    return exp.expertId === expertId;
                });
                if (info === 'name') {
                    reqInfo = expert[0].name;
                } else if (info === 'img') {
                    reqInfo = expert[0].small_image;
                } else if (info === 'biography') {
                    reqInfo = expert[0].biography;
                } else if (info === 'experties') {
                    reqInfo = expert[0].experties;
                }
            }
            return reqInfo;
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        },
        isUserEntrolled: function isUserEntrolled(eventId) {
            if (this.getUserEvents) {
                var filter = this.getUserEvents.filter(function (ev) {
                    return ev.eventId === eventId;
                });
                if (filter && filter.length > 0) {
                    return true;
                }
            }
            return false;
        },
        getMinutesBetweenDates: function getMinutesBetweenDates(startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime();
            return diff / 60000;
        },
        isEventToday: function isEventToday(evtDate) {
            var eventDate = new Date(evtDate);
            var currentDate = this.returnEasternTime();

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        isEventToday2: function isEventToday2(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var eventDate = new Date(evtDate);
            var eventEndDate = new Date(endDate);
            var currentDate = this.returnEasternTime();
            var switchTime = parseInt(defaultSwitchTime);
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        timeLeftInEvent: function timeLeftInEvent(evtDate) {
            var eventDate = new Date(evtDate);
            var currentDate = this.returnEasternTime();
            return this.getMinutesBetweenDates(currentDate, eventDate);
        },
        joinEventUnAuth: function joinEventUnAuth(event) {
            var joinString = '/event/' + event.eventId;
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', joinString);
            } else {
                sessionStorage.setItem('redirectPath', joinString);
            }
            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        enrollUser: function enrollUser(event) {
            var _this2 = this;

            if (event.eventId === 1) {
                window.logEvents('Events Page', 'Tone Live Seat Reserved', 'Event Title: ' + event.title);
            } else {
                window.logEvents('Events Page', 'Tone Talk Seat Reserved', 'Event Title: ' + event.title);
            }
            this.seatReservation.eventId = event.eventId;
            this.seatReservation.userId = this.user.userId;
            this.seatReservation.status = '1';
            this.seatReservation.isAnonymous = '0';
            this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(function () {
                _this2.$store.dispatch('GETALLEXPERTS').then(function () {});
                _this2.$store.dispatch('GETUSEREVENTS', _this2.user.userId).then(function () {});
            });
        },
        returnEasternTime: function returnEasternTime() {
            var offset = -5;
            if (__WEBPACK_IMPORTED_MODULE_2__helpers_dateHelpers_js__["a" /* dateHelpers */].dstEnabled(new Date())) {
                offset = -4.0;
            }
            var clientDate = new Date();
            var utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
            var serverDate = new Date(utc + 3600000 * offset);
            return serverDate;
        },
        triggerLogin: function triggerLogin() {
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', '/events');
            } else {
                sessionStorage.setItem('redirectPath', '/events');
            }
            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        showJoin: function showJoin(bEvent) {
            if (this.isEventToday2(bEvent.start_date, bEvent.end_date, bEvent.eventSwitchTime, this.getEventSwitchTime)) {
                return true;
            }
            return false;
        },
        calculateTimeToStartEvent: function calculateTimeToStartEvent(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var self = this;
            var eventDate = new Date(evtDate);

            var currentDate = this.returnEasternTime();
            var switchTime = parseInt(defaultSwitchTime);
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }

            console.log('time left in event', this.getMinutesBetweenDates(currentDate, eventDate));
            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime) {
                    console.log('event joining enabled');
                } else {
                    console.log('difference', self.getMinutesBetweenDates(currentDate, eventDate));
                    console.log('switch time', switchTime);
                    console.log('time left', self.getMinutesBetweenDates(currentDate, eventDate) - switchTime);
                    var timeToStart = this.getMinutesBetweenDates(currentDate, eventDate) - switchTime;
                    if (timeToStart > 0 && timeToStart <= 90) {
                        console.log('view needs to be freshed after: ', timeToStart);
                        var timeToTrigger = parseInt(timeToStart * 60 * 1000);
                        console.log('trigger in seconds', timeToTrigger);
                        setTimeout(function () {
                            console.info('refreshing view');
                            self.toggleSpinner = true;
                            self.showRulesComp = false;
                            setTimeout(function () {
                                self.showRulesComp = true;
                                self.toggleSpinner = false;
                            }, 1500);
                        }, timeToTrigger + 60);
                    }
                }
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['user', 'error', 'getExpert', 'getEventList', 'getMainEvent', 'getTalkEvents', 'getLiveEvents', 'getLiveExperts', 'getTalkExperts', 'getBannerEvent', 'getEventSwitchTime', 'getCurrentVideo', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getTaggedEmailList', 'getCorporatePayload']))

});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RulesComp_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RulesComp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__RulesComp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers_js__ = __webpack_require__(15);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'expert',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default.a,
        'tabs': __WEBPACK_IMPORTED_MODULE_4_vue_strap__["tabs"],
        'bs-input': __WEBPACK_IMPORTED_MODULE_4_vue_strap__["input"],
        spinner: __WEBPACK_IMPORTED_MODULE_4_vue_strap__["spinner"],
        'tab': __WEBPACK_IMPORTED_MODULE_4_vue_strap__["tab"],
        modal: __WEBPACK_IMPORTED_MODULE_4_vue_strap__["modal"],
        rulescomp: __WEBPACK_IMPORTED_MODULE_7__RulesComp_vue___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.expertTitle,
            meta: [{ property: 'og:image', content: self.expertImage }, { property: 'og:title', content: self.expertTitle }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: self.expertBio
            }, { property: 'twitter:title', content: self.expertTitle }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.expertImage }, {
                property: 'twitter:description',
                content: self.expertBio
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            shareImagePayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                recipientFriendEmails: null,
                eventId: '',
                customizedMessage: '',
                playlistType: 6
            },
            shareEventSelected: null,
            showCorporateImageShare: false,
            corporateShareMessage: '',
            selectedPlaylist: null,
            corpShareModalImage: '',
            showCorporateShare: false,
            corpShareModalTitle: '',
            corpShareModalDesc: '',
            selectedCorps: [],
            allCorps: [],
            shareOption: 'Corporate',
            showShareCommunity: false,
            showShareIndividual: false,
            showShareFriends: false,
            sharePlaylistType: '',
            archiveEventId: 0,
            archiveEventTitle: '',
            spinner: false,
            taggedEmails: [],
            emailList: [],
            previewMsg: 'Message Preview: \n',
            showSharedModal: false,
            shareInProcess: false,
            toggleSpinner: false,
            expertInfo: null,
            activeTab: 0,
            expertEvent: '',
            expertMainVideo: '',
            showWatchVideoModal: false,
            currentPlayerID: '',
            currentVideoRef: '',
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            topVideos: [],
            expertTitle: '',
            expertImage: '',
            expertBio: '',
            eventURL: 'https://www1.dev-tonenetworks.com',
            seatReservation: {
                userEventId: 0,
                eventId: 0,
                userId: 0,
                status: 0,
                isAnonymous: 0
            },
            sharePayload: {
                tmpVideCode: '',
                sharedEmailList: '',
                sharedEmailMessage: '',
                sharedPlaylistPreview: ''
            },
            shareVideoPayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                recipientFriendEmails: null,
                playlistId: '',
                messageText: '',
                playlistType: 4
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            window.addeventatc.refresh();
        }, 2000);

        var self = this;
        if (self.user) {
            self.$store.dispatch('GET_EXPERT_EVENT_CLIPS', self.$route.params.expertId).then(function () {
                if (self.getExpertArchiveClips) {
                    console.log('archive clips', self.getExpertArchiveClips);
                }
            });
        }
        self.$store.dispatch('GET_EXPERT_BY_BY_ID', self.$route.params.expertId).then(function () {
            if (self.getExpert) {
                self.expertInfo = self.getExpert[0];
                if (self.expertInfo.experties) {
                    _this.expertTitle = 'TONE Expert | ' + self.expertInfo.name + ', ' + self.expertInfo.experties;
                } else {
                    _this.expertTitle = 'TONE Expert | ' + self.expertInfo.name;
                }
                _this.expertImage = self.expertInfo.large_image;
                _this.expertBio = self.expertInfo.areasofexpertise;

                _this.$store.dispatch('GET_EXPERT_NEXT_EVENT', self.$route.params.expertId).then(function () {
                    if (self.getExpertNextEvent) {
                        console.log('expert next event', self.getExpertNextEvent);
                        self.expertEvent = self.getExpertNextEvent;
                    } else {
                        self.expertEvent = null;
                    }
                });
                self.$store.dispatch('CACHEPAGE', window.location.href);

                if (self.user) {
                    self.$store.dispatch('GETUSEREVENTS', self.user.userId).then(function () {});
                }
            } else {
                self.$swal({
                    title: 'Expert not found!',
                    text: '',
                    type: 'error',
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(function () {}, function (dismiss) {
                    if (dismiss === 'timer') {
                        self.$router.push('/experts');
                    }
                });
            }
        });

        if (self.user) {
            self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(function () {
                if (self.getTaggedEmailList) {
                    self.emailList = [];
                    self.emailList = self.getTaggedEmailList;
                    console.log('email list', self.getTaggedEmailList);
                }
            });

            this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(function () {
                _this.allCorps = [];
                if (_this.getCorporatePayload) {
                    _this.corporateInfo = _this.getCorporatePayload;
                    _this.allCorps = _this.corporateInfo.lstCorporationUsers;
                }
            });
        }

        var corpId = 0;
        if (self.user && this.user.corporation && self.user.corporation.corporationId > 0) {
            corpId = self.user.corporation.corporationId;
        }
        var params = [self.$route.params.expertId, corpId];
        this.$store.dispatch('GETEXPERTVIDEOS', params).then(function () {
            if (self.getExpertVideos) {
                self.topVideos = self.getExpertVideos.slice(0, 7);
                console.log('top videos retreived', self.topVideos);
                console.log('after status', self.getExpertVideos);
                var mainVideo = _this.getExpertVideos[0];
                if (!_this.expertEvent) {
                    _this.expertMainVideo = {
                        video: mainVideo.sources[mainVideo.sources.length - 1].file,
                        title: mainVideo.title,
                        img: mainVideo.image,
                        playerID: new Date(),
                        tracks: mainVideo.tracks,
                        isMute: true,
                        showCaptions: true,
                        mediaId: mainVideo.mediaid
                    };
                }
            }
        });
        self.$store.dispatch('GETEXPERTPLAYLIST', params).then(function () {});

        if (self.user) {
            this.$store.dispatch('GETAUTHUSERVIDEOS', self.user.userId).then(function () {});
        }

        if (self.user) {
            this.$store.dispatch('GETUSERPLAYLISTS', self.user.userId).then(function () {});
        }
        window.scrollTo(0, 0);
    },
    watch: {
        'sharePayload.sharedEmailMessage': function sharePayloadSharedEmailMessage(to, from) {
            var self = this;
            var oriiginalMessage = self.user.firstName + ' shared a coaching tips playlist with you on Tone Networks: \n' + self.archiveEventTitle + ' \n';
            if (self.showSharedModal && self.sharePayload.sharedEmailMessage && self.sharePayload.sharedEmailMessage.length > 0) {
                self.sharePayload.sharedPlaylistPreview = '' + self.previewMsg + oriiginalMessage + self.sharePayload.sharedEmailMessage;
            } else {
                self.sharePayload.sharedPlaylistPreview = self.previewMsg + ' ' + self.user.firstName + ' shared a coaching tips playlist with you on Tone Networks: \n' + self.archiveEventTitle + ' \n';
            }
        },
        'shareOption': function shareOption(to, from) {
            var self = this;
            self.selectedCorps = null;
            self.corporateShareMessage = '';
            self.taggedEmails = [];
        }
    },
    methods: {
        replaceLastExpert: function replaceLastExpert(strArray, chr, newChr) {
            var a = strArray.split('');
            a[strArray.lastIndexOf(chr)] = newChr;
            return a.join('').replace('/,/g', ', ');
        },
        shareCorporateImage: function shareCorporateImage() {
            var self = this;
            self.shareImagePayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0;
            self.shareImagePayload.senderUserId = self.user.userId;
            self.shareImagePayload.recipientsUserIds = [];
            self.shareImagePayload.recipientFriendEmails = null;
            self.shareImagePayload.customizedMessage = self.corporateShareMessage;
            if (self.shareOption === 'Corporate') {
                self.shareImagePayload.recipientsUserIds = [];
                self.shareImagePayload.recipientFriendEmails = null;
            } else if (self.shareOption === 'Individual') {
                self.shareImagePayload.recipientFriendEmails = null;
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    self.shareImagePayload.recipientsUserIds = self.selectedCorps.map(function (x) {
                        return x.userId;
                    });
                }
            } else if (self.shareOption === 'Friends') {
                self.shareImagePayload.recipientsUserIds = [];
                var emailArray = self.taggedEmails.map(function (x) {
                    return x.name;
                });
                self.shareImagePayload.recipientFriendEmails = emailArray.join(',');
            } else {}
            self.shareImagePayload.eventId = self.shareEventSelected.eventId;
            self.shareInProcess = true;

            self.$store.dispatch('CORP_EVENT_SHARE', { payload: self.shareImagePayload }).then(function () {
                if (!self.error.show) {
                    self.spinnerToggle();
                    self.$swal({
                        title: 'Event has been shared!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });

                    self.cancelCorporateImageModal();
                } else {
                    self.cancelCorporateImageModal();
                }
            });
        },
        openCorporateImageShareModal: function openCorporateImageShareModal(tEvent) {
            console.log('event for share', tEvent);
            var self = this;
            self.shareInProcess = false;
            self.shareEventSelected = tEvent;
            self.corpShareModalImage = tEvent.img_url;
            self.corpShareModalDesc = tEvent.description;
            self.corpShareModalTitle = tEvent.title;
            self.showCorporateImageShare = true;
        },
        cancelCorporateImageModal: function cancelCorporateImageModal() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateImageShare = false;
                self.shareInProcess = false;
                __WEBPACK_IMPORTED_MODULE_6_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        shareCorporateVideo: function shareCorporateVideo() {
            var self = this;
            self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0;
            self.shareVideoPayload.senderUserId = self.user.userId;
            self.shareVideoPayload.recipientsUserIds = [];
            self.shareVideoPayload.recipientFriendEmails = null;
            self.shareVideoPayload.messageText = self.corporateShareMessage;
            if (self.shareOption === 'Corporate') {
                self.shareVideoPayload.recipientsUserIds = [];
                self.shareVideoPayload.recipientFriendEmails = null;
            } else if (self.shareOption === 'Individual') {
                self.shareVideoPayload.recipientFriendEmails = null;
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    self.shareVideoPayload.recipientsUserIds = self.selectedCorps.map(function (x) {
                        return x.userId;
                    });
                }
            } else if (self.shareOption === 'Friends') {
                self.shareVideoPayload.recipientsUserIds = [];
                var emailArray = self.taggedEmails.map(function (x) {
                    return x.name;
                });
                self.shareVideoPayload.recipientFriendEmails = emailArray.join(',');
            } else {}
            self.shareVideoPayload.playlistId = self.archiveEventId;

            if (!self.shareInProcess) {
                self.$store.dispatch('PLAYLISTCORPORATESHARE', { payload: self.shareVideoPayload }).then(function () {
                    if (!self.error.show) {
                        self.spinnerToggle();
                        self.$swal({
                            title: 'Playlist has been shared!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });

                        self.cancelCorporateModal();
                    } else {
                        self.cancelCorporateModal();
                    }
                });
            }
            self.shareInProcess = true;
        },
        maskEmailAddress: function maskEmailAddress(userEmail) {
            var avg = void 0,
                splitted = void 0,
                part1 = void 0,
                part2 = void 0;
            splitted = userEmail.split('@');
            part1 = splitted[0];
            var regex = /[^0-9.]/g;
            var maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1);
            console.log('maked', maskid);
            avg = part1.length / 2;
            part1 = part1.substring(0, part1.length - avg);
            part2 = splitted[1];
            var maskDomain = part2.split('.');
            return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1];
        },
        customLabel: function customLabel(option) {
            var findDuplicate = this.allCorps.find(function (x) {
                return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId;
            });

            if (findDuplicate) {
                var maskedEmail = this.maskEmailAddress(option.email);
                return option.firstName + ' ' + option.lastName + ' <' + maskedEmail + '>';
            } else {
                return option.firstName + ' ' + option.lastName;
            }
        },
        openCorporateShareModal: function openCorporateShareModal(playlistObj) {
            var self = this;
            self.shareInProcess = false;
            self.corpShareModalImage = playlistObj.img_url;
            self.corpShareModalDesc = playlistObj.description;
            self.corpShareModalTitle = playlistObj.title;
            self.selectedPlaylist = playlistObj;
            self.archiveEventId = playlistObj.eventId;
            self.showCorporateShare = true;

            if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareExpertCoachingTipPermission >= 1) {
                var rights = self.user.corporation.corpSharingPermissions.shareExpertCoachingTipPermission;
                console.log('rights', rights);
                if (rights === 1) {
                    self.showShareCommunity = true;
                    self.showShareIndividual = true;
                    self.showShareFriends = true;
                } else if (rights === 2) {
                    self.showShareCommunity = true;
                    self.showShareIndividual = false;
                    self.showShareFriends = false;
                    self.shareOption = 'Corporate';
                } else if (rights === 3) {
                    self.showShareCommunity = false;
                    self.showShareFriends = false;
                    self.showShareIndividual = true;
                    self.shareOption = 'Individual';
                } else if (rights === 5) {
                    self.showShareCommunity = false;
                    self.showShareIndividual = false;
                    self.showShareFriends = true;
                    self.shareOption = 'Friends';
                } else {
                    self.showShareCommunity = false;
                    self.showShareIndividual = false;
                    self.showShareFriends = false;
                }
            }
        },
        showSharingModal: function showSharingModal(playlistObj) {
            console.log('playlist obj', playlistObj);
            var self = this;
            if (self.user && self.user.corporation === null) {
                self.openModalShare(playlistObj.eventId, playlistObj.title);
            } else {
                self.openCorporateShareModal(playlistObj);
            }
        },
        verifyEmailShare: function verifyEmailShare(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        addTag: function addTag(newTag) {
            var self = this;
            console.log('newTAg', newTag);
            var tag = {
                name: newTag
            };
            if (self.verifyEmailShare(newTag)) {
                self.emailList.push(tag);
                this.taggedEmails.push(tag);
                console.log('tagged emails', this.taggedEmails);
            } else {
                console.log('invalid email address, calling swal');
            }
        },
        cancelCorporateModal: function cancelCorporateModal() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateShare = false;
                self.shareInProcess = false;
                __WEBPACK_IMPORTED_MODULE_6_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        cancelEmailShareModal: function cancelEmailShareModal() {
            var self = this;
            var $ = __webpack_provided_window_dot_jQuery;
            self.sharePayload.tmpVideCode = '';
            self.sharePayload.sharedEmailList = '';
            self.sharePayload.sharedEmailMessage = '';
            setTimeout(function () {
                self.showSharedModal = false;
                self.archiveEventId = 0;
                self.archiveEventTitle = '';
                self.sharePayload.sharedPlaylistPreview = '';

                $('.modal-open').removeClass('modal-open');
            }, 500);
        },
        verifyEmail: function verifyEmail(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onSharePlaylist: function onSharePlaylist() {
            var self = this;
            self.spinnerToggle();
            var emailArray = self.taggedEmails.map(function (x) {
                return x.name;
            });
            self.sharePayload.sharedPlaylistPreview = self.user.firstName + ' shared a coaching tips playlist with you on Tone Networks: \n' + self.archiveEventTitle + '\n' + self.sharePayload.sharedEmailMessage;
            var sharePayload = {
                csvEmailRecepients: emailArray.join(','),
                userId: self.user.userId,
                playlistId: self.archiveEventId,
                customizedMessage: self.sharePayload.sharedPlaylistPreview
            };
            self.$store.dispatch('ARCHIVE_PLAYLIST_SHARE', { payload: sharePayload }).then(function () {
                if (!self.error.show) {
                    self.spinnerToggle();
                    self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(function () {
                        if (self.getTaggedEmailList) {
                            self.emailList = [];
                            self.emailList = self.getTaggedEmailList;
                            self.taggedEmails = [];
                            self.sharePayload.sharedPlaylistPreview = '';
                        }
                    });
                    self.$swal({
                        title: 'Email Sent!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    self.cancelEmailShareModal();
                } else {
                    self.spinnerToggle();
                    self.cancelEmailShareModal();
                }
            });
        },
        openModalShare: function openModalShare(eventId, eventTitle) {
            console.log('called');
            this.archiveEventId = eventId;
            this.archiveEventTitle = eventTitle;
            this.showSharedModal = true;
        },
        playVideoArchive: function playVideoArchive(eventId, eventTitle) {
            this.$router.push('/tonearchive/' + eventId + '/play/1/' + eventTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoObject) {
            if (videoObject.marketing) {
                this.openModal(videoObject);
            } else {
                if (this.user && this.getTrialDays < 0) {
                    if (sessionStorage.getItem('redirectPath')) {
                        sessionStorage.removeItem('redirectPath');
                        sessionStorage.setItem('redirectPath', '/watch/' + videoObject.videoCode);
                    } else {
                        sessionStorage.setItem('redirectPath', '/watch/' + videoObject.videoCode);
                    }
                    this.$router.push('/becomemember');
                } else if (this.user) {
                    this.$router.push('/watch/' + videoObject.videoCode);
                } else {
                    this.$router.push('/watch/' + videoObject.videoCode);
                }
            }
        },
        cancelModal: function cancelModal() {
            var self = this;
            var $ = __webpack_provided_window_dot_jQuery;
            setTimeout(function () {
                self.showModal = false;
                self.showWatchVideoModal = false;

                $('.modal-open').removeClass('modal-open');
            }, 500);
        },
        openModal: function openModal(mainVideoObj) {
            var self = this;
            if (!this.expertEvent) {
                if (self.currentVideoRef) {
                    window.jwplayer(self.currentVideoRef).pause(true);
                } else {
                    self.currentVideoRef = window['currentVideoId'];
                    window.jwplayer(self.currentVideoRef).pause(true);
                }
            }
            this.currentPlayerID = { video: mainVideoObj.sources[mainVideoObj.sources.length - 1].file, title: mainVideoObj.title, img: mainVideoObj.image, playerID: new Date(), tracks: mainVideoObj.tracks, videoDescription: mainVideoObj.longdescription };
            this.showWatchVideoModal = true;
            this.currentVideoDesc = mainVideoObj.description;
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET';
            }
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        },
        isUserEntrolled: function isUserEntrolled(eventId) {
            if (this.getUserEvents) {
                var filter = this.getUserEvents.filter(function (ev) {
                    return ev.eventId === eventId;
                });
                if (filter && filter.length > 0) {
                    return true;
                }
            }
            return false;
        },
        getMinutesBetweenDates: function getMinutesBetweenDates(startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime();
            return diff / 60000;
        },
        returnEasternTime: function returnEasternTime() {
            var offset = -5;
            if (__WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers_js__["a" /* dateHelpers */].dstEnabled(new Date())) {
                offset = -4.0;
            }
            var clientDate = new Date();
            var utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
            var serverDate = new Date(utc + 3600000 * offset);
            return serverDate;
        },
        isEventToday2: function isEventToday2(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var eventDate = new Date(evtDate);
            var eventEndDate = new Date(endDate);
            var currentDate = this.returnEasternTime();
            var switchTime = parseInt(defaultSwitchTime);
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        showJoin: function showJoin(bEvent) {
            if (bEvent) {
                if (this.isEventToday2(bEvent.start_date, bEvent.end_date, bEvent.eventSwitchTime, this.getEventSwitchTime)) {
                    return true;
                }
            }
            return false;
        },
        isEventToday: function isEventToday(evtDate, endDate) {
            var eventDate = new Date(evtDate);
            var eventEndDate = new Date(endDate);
            var currentDate = this.returnEasternTime();

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= 15 && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        enrollUser: function enrollUser(event) {
            var _this2 = this;

            this.seatReservation.eventId = event.eventId;
            this.seatReservation.userId = this.user.userId;
            this.seatReservation.status = '1';
            this.seatReservation.isAnonymous = '0';
            this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(function () {
                _this2.$store.dispatch('GETALLEXPERTS').then(function () {});
                _this2.$store.dispatch('GETUSEREVENTS', _this2.user.userId).then(function () {});
            });
        },
        addNewPlayList: function addNewPlayList() {
            var _this3 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this3.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoStatus: function setVideoStatus(videoObject) {
            var _this4 = this;

            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0';
                    } else {
                        exists[0].liked = '1';
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(function () {
                        _this4.$store.dispatch('GETAUTHUSERVIDEOS', _this4.user.userId);
                    });
                } else {
                    var logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    };
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {
                        _this4.$store.dispatch('GETAUTHUSERVIDEOS', _this4.user.userId);
                    });
                }
            }
        },
        verifyVideoStatus: function verifyVideoStatus(videoCode) {
            if (this.getExpertVideos) {
                var getStatus = this.topVideos.filter(function (x) {
                    return x.mediaid === videoCode;
                });
                if (getStatus && getStatus.length > 0) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        createSlickCarousal: function createSlickCarousal() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'getCorporatePayload', 'user', 'isScrolled', 'getExpert', 'getExpertVideos', 'getEventList', 'getUserEvents', 'getVideosFlag', 'getExpertPlaylist', 'getUserPlaylists', 'getAuthUserVideos', 'getTrialDays', 'getEventSwitchTime', 'getExpertArchiveClips', 'getTaggedEmailList', 'error', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getExpertNextEvent']))
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);









/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        modal: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["modal"],
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default.a,
        'spinner': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["spinner"]
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    name: 'giving',
    data: function data() {
        return {
            timerRef: null,
            elementRef: '',
            isHover: false,
            activeClass: false,
            spinner: false,
            showModal_player: false,
            metaTag_pageTitle: 'TONE | Our Experts',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: ''
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['getAllExperts', 'user', 'getAllSiteContents', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'])),
    mounted: function mounted() {
        var _this = this;

        this.$store.dispatch('GETDYNAMICCONTENTS', 20).then(function () {
            if (_this.getAllSiteContents) {
                _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
            }
        });
        console.log('user', this.user);
        if (this.user && this.user.corporation) {
            this.$store.dispatch('GETALLEXPERTS_CORPORATION', this.user.corporation.corporationId).then(function () {
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.expert_entry_holder').on('click', function () {
                    var clickedDiv = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this)[0].id;
                    console.log('selected div', clickedDiv);
                    var oldDiv = '';
                    var activeRef = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.expert_entry_holder').find('.active');

                    if (activeRef[0] === undefined) {} else {
                        oldDiv = activeRef[0].id;
                    }
                    __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.expert_entry_holder').removeClass('active');
                    if (clickedDiv !== oldDiv) {
                        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).addClass('active');
                    }
                });
            });
        } else {
            var corpId = 0;

            if (localStorage.getItem('corporateClientObject')) {
                var corpObject = JSON.parse(localStorage.getItem('corporateClientObject'));
                corpId = corpObject.corporationId;
            }
            this.$store.dispatch('GETALLEXPERTS_CORPORATION', corpId).then(function () {
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.expert_entry_holder').on('click', function () {
                    var clickedDiv = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this)[0].id;
                    console.log('selected div', clickedDiv);
                    var oldDiv = '';
                    var activeRef = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.expert_entry_holder').find('.active');

                    if (activeRef[0] === undefined) {} else {
                        oldDiv = activeRef[0].id;
                    }
                    __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.expert_entry_holder').removeClass('active');
                    if (clickedDiv !== oldDiv) {
                        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).addClass('active');
                    }
                });
            });
        }

        this.$store.dispatch('CACHEPAGE', window.location.href);
    },
    methods: {
        triggerPopup: function triggerPopup(identifier) {
            var self = this;
            self.elementRef = identifier;
            console.log('identifier', self.elementRef);
            setTimeout(function () {
                if (self.elementRef === identifier) {
                    __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + self.elementRef).addClass('hoveringeffect');
                }
            }, 400);
        },
        clear: function clear(elementRef) {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + self.elementRef).removeClass('hoveringeffect');
            this.elementRef = '';
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        setPlayer: function setPlayer(playerObject) {
            this.currentPlayerID = { video: playerObject.sources[1].file, title: playerObject.title, img: playerObject.image, playerID: new Date() };
            this.showModal_player = true;
        },
        active: function active() {
            this.activeClass = true;
        },

        switchTab: function switchTab(id) {
            for (var tab in this.tabs) {
                this.tabs[tab] = id === tab;
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        openModal: function openModal(charity) {
            this.currentCharity = charity;
            this.showModal = true;
        },
        cancelModal: function cancelModal() {
            this.showModal = false;
            var self = this;
            setTimeout(function () {
                self.showModal = false;

                __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        changeCharity: function changeCharity(charity) {
            var _this2 = this;

            this.currentCharity = charity;
            var info = [this.currentCharity.charityId, this.user.userId];

            this.$store.dispatch('SETSELECTEDCHARITY', info).then(function () {
                _this2.$store.dispatch('GETSELECTEDCHARITY', _this2.user.userId).then(function () {
                    _this2.currentCharity.selectedCharity = !_this2.currentCharity.selectedCharity;
                });
            });
        },
        checkCharity: function checkCharity(charity) {
            return this.getSelectedCharity.charityId === charity.charityId;
        },
        redirectToExpert: function redirectToExpert(expert) {
            this.$router.push('/expert/' + expert.expertId);
        },
        cancelModal_player: function cancelModal_player() {
            var self = this;
            var $ = __webpack_provided_window_dot_jQuery;
            setTimeout(function () {
                self.showModal_player = false;

                $('.modal-open').removeClass('modal-open');
            }, 500);
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"]
    },
    name: 'login',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | FAQ',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | FAQ' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | FAQ' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            success: false,
            successMsg: '',
            allFAQ: null,
            contactForm: {
                emailAddress: '',
                phoneNumber: '',
                reason: '',
                comments: ''
            },
            spinner: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'user', 'getFAQs', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'])),
    mounted: function mounted() {
        var self = this;
        self.$store.dispatch('GETFAQS').then(function () {
            if (self.getFAQs) {
                console.log('faqs', self.getFAQs);
                self.allFAQ = self.getFAQs;
            }
        });
    },
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this = this;

            if (this.contactForm.emailAddress && this.contactForm.phoneNumber) {
                this.spinnerToggle();
                this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(function () {
                    _this.success = true;
                    _this.successMsg = 'Your message has been sent, we will get back to you shortly!';
                    _this.spinnerToggle();
                });
            }
        }
    }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"],
        checkbox: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["checkbox"]
    },
    name: 'login',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Feedback',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Feedback' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Feedback' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            success: false,
            successMsg: '',
            feedbackForm: {
                userId: null,
                email: '',
                name: '',
                comments: '',
                rating: 0,
                newsLetterEmail: '0',
                promotionalEmail: '0',
                representativeCall: '0'
            },
            spinner: false,
            newsLetterEmailBool: '',
            promotionalEmailBool: '',
            representativeCallBool: ''
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'user', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'])),
    methods: {
        setRating: function setRating(rating) {
            this.feedbackForm.rating = rating;
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this = this;

            if (this.user) {
                this.feedbackForm.email = this.user.email;
                this.feedbackForm.name = this.user.firstName + ' ' + this.user.lastName;
                this.feedbackForm.userId = this.user.userId;
            } else {
                this.userId = null;
            }
            if (this.feedbackForm.email && this.feedbackForm.name) {
                this.spinnerToggle();
                this.$store.dispatch('SENDFEEDBACKFORM', this.feedbackForm).then(function () {
                    window.logEvents('Feedback Page', 'Feedback Sent', 'Feedback Email: ' + _this.feedbackForm.email + ', Feedback: ' + _this.feedbackForm.comments);

                    _this.spinnerToggle();
                    _this.$swal({
                        title: 'Thank you for your feedback!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                });
            }
        }
    }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["accordion"],
        'panel': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["panel"],
        alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
        dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["dropdown"],
        radio: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["radio"],
        VuePassword: __WEBPACK_IMPORTED_MODULE_3_vue_password___default.a,
        checkbox: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        tabs: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tabs"],
        tab: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tab"],
        buttonGroup: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"],
        datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["datepicker"]
    },
    name: 'signUp',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Send Gifts',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/tone-assets/images/TONEGiftingHolidays.jpg' }, { property: 'og:title', content: 'Give the Gift of Knowledge and Empowerment | TONE Networks' }, { property: 'og:site_name', content: 'The Perfect Holiday Gift for all the Women in Your Life' }, {
                property: 'og:description',
                content: 'Give the women in your life a subscription to TONE Networks, an empowering female community built around expert advice and support.'
            }, { property: 'twitter:title', content: 'Give the Gift of Knowledge and Empowerment | TONE Networks' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/tone-assets/images/TONEGiftingHolidays.jpg' }, {
                property: 'twitter:description',
                content: 'Give the women in your life a subscription to TONE Networks, an empowering female community built around expert advice and support.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            gifter: {
                userId: 0,
                email: '',
                firstName: '',
                lastName: '',
                cardHolderName: '',
                stripeCustomerId: '',
                packageId: '',
                userPayments: [],
                totalGiftedAmount: 0,
                userGifts: ''
            },
            giftee: {
                gifteeFirstName: '',
                gifteeLastName: '',
                gifteeEmail: '',
                deliveryDate: '',
                deliveryMessage: '',
                redeemDate: null,
                packageId: null
            },
            userPayments: {
                token: '',
                stripeCardId: '',
                paymentType: 'CC',
                paymentDate: new Date(),
                paypalPayerId: '',
                paypalPaymentId: '',
                paymentMethodNonce: ''
            },
            gifteeValidated: true,
            spinner: false,
            alert: false,
            passwordError: '',
            confirmPassword: '',
            stripe: '',
            card: '',
            panelStatus: false,
            createSection: true,
            paymentSection: false,
            isToggle: false,
            defaultPlan: '',
            isChecked: false,

            stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo',
            daysToCancel: 0,
            isStripe: true,
            gateway: 'CC',
            packageId: 0,
            gifteeCol: [],
            giftPlans: '',
            totalAmount: 0.00,
            minimumDate: new Date(),
            addMessage: 'Add Gift to Cart',
            dateErrorMessage: 'Delivery date must be ' + this.returnMinimumDate() + ' or later',
            dateFormat: 'mm/dd/yyyy',
            stripeErrorMessage: ''
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$store.dispatch('GETPLANS').then(function () {
            _this.packageId = _this.getAllPlans[0].packageId;
            _this.giftPlans = _this.getAllPlans.filter(function (pln) {
                return pln.type.toLowerCase().indexOf('gift') >= 0 && pln.packageId > 8;
            });
            if (_this.getSelectedGiftId) {
                _this.packageId = _this.getSelectedGiftId.giftId;
            } else {
                _this.packageId = _this.giftPlans[0].packageId;
            }
        });
        if (this.user !== null) {
            if (this.user.firstName.length > 0) {
                this.gifter.firstName = this.user.firstName;
                this.gifter.lastName = this.user.lastName;
                this.gifter.email = this.user.email;
                this.gifter.cardHolderName = this.user.firstName + ' ' + this.user.lastName;
            }
        }
        this.$store.dispatch('GETPAYPALTOKEN');
        this.mountStripeElement();
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(':input').blur(function () {
            if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val().length > 0) {
                window.logEvents('Send-Gift Page', 'Send-Gift Page: Field.' + __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).attr('name'), 'Send-Gift Page: Field.' + __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).attr('name') + ', val: ' + __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val());
            } else {
                window.logEvents('Send-Gift Page', 'Send-Gift Page: Field.' + __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).attr('name'), 'Send-Gift Page: Field.' + __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).attr('name') + ', val: ' + 'skipped');
            }
        });
        if (this.user) {
            window.juapp('arb', '[userId]', '[auth]');
        } else {
            window.juapp('arb', '[userId]', '[unauth]');
        }
    },

    methods: {
        togglePaymentMethods: function togglePaymentMethods() {
            var _this2 = this;

            if (this.gateway === 'paypal') {
                this.isStripe = false;
                setTimeout(function () {
                    _this2.mountbraintree();
                }, 1000);
            } else {
                this.isStripe = true;
                this.mountStripeElement();
            }
        },
        mountbraintree: function mountbraintree() {
            var self = this;
            if (self.getPaypalToken) {
                window.braintree.client.create({
                    authorization: 'production_6r7mxqgh_htw3nq9wp32w8h2x'
                }, function (clientErr, clientInstance) {
                    if (clientErr) {
                        console.error('Error creating client:', clientErr);
                        return;
                    }

                    window.braintree.paypalCheckout.create({
                        client: clientInstance
                    }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                        if (paypalCheckoutErr) {
                            console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
                            return;
                        }

                        window.paypal.Button.render({
                            env: 'production',
                            payment: function payment() {
                                return paypalCheckoutInstance.createPayment({
                                    flow: 'vault',
                                    amount: self.totalAmount || 19,
                                    currency: 'USD',
                                    intent: 'sale'
                                });
                            },
                            onAuthorize: function onAuthorize(data, actions) {
                                return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
                                    self.userPayments.paymentMethodNonce = payload.nonce;
                                });
                            },
                            onCancel: function onCancel(data) {},
                            onError: function onError(err) {
                                console.error('checkout.js error', err);
                            }
                        }, '#paypal-button').then(function () {});
                    });
                });
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        resetForm: function resetForm() {
            var _this3 = this;

            setTimeout(function () {
                _this3.gifteeValidated = !_this3.gifteeValidated;
            }, 100);
        },
        mountStripeElement: function mountStripeElement() {
            var _this4 = this;

            setTimeout(function () {
                _this4.stripe = window.Stripe(_this4.stripeKey);
                var elements = _this4.stripe.elements();
                _this4.card = elements.create('card');
                _this4.card.mount('#card-element');
            }, 1000);
        },
        addGiftee: function addGiftee() {
            if (this.verifyNameField(this.giftee.gifteeFirstName) && this.verifyNameField(this.giftee.gifteeLastName) && this.verifyEmailField(this.giftee.gifteeEmail)) {
                var isDateValid = false;
                if (!this.doesEmailExists(this.giftee.gifteeEmail)) {
                    try {
                        var currentDate = new Date(this.returnMinimumDate());
                        currentDate.setHours(0);
                        currentDate.setMinutes(0);

                        var delDate = new Date(this.giftee.deliveryDate.split('-').join('/'));

                        delDate.setHours(0);
                        delDate.setMinutes(0);

                        if (delDate >= currentDate) {
                            isDateValid = true;
                        } else {
                            isDateValid = false;
                            this.$swal({
                                title: 'Invalid Delivery Date',
                                text: '',
                                type: 'error',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {}
                            });
                        }
                    } catch (err) {
                        isDateValid = false;
                        this.$swal({
                            title: '',
                            text: 'Invalid delivery date',
                            type: 'failure',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                    }
                    if (isDateValid) {
                        var newGiftee = {};
                        newGiftee.packageId = this.packageId;
                        newGiftee.gifteeFirstName = this.giftee.gifteeFirstName;
                        newGiftee.gifteeLastName = this.giftee.gifteeLastName;
                        newGiftee.gifteeEmail = this.giftee.gifteeEmail.toLowerCase();
                        newGiftee.deliveryDate = this.returnFormatedDate(this.giftee.deliveryDate, 'M');
                        newGiftee.deliveryMessage = this.giftee.deliveryMessage;
                        newGiftee.redeemDate = null;
                        this.gifteeCol.push(newGiftee);
                        this.giftee.packageId = this.packageId;
                        this.giftee.gifteeFirstName = '';
                        this.giftee.gifteeLastName = '';
                        this.giftee.gifteeEmail = '';
                        this.giftee.deliveryDate = this.returnMinimumDate();
                        this.giftee.deliveryMessage = '';
                        this.giftee.redeemDate = null;
                        this.gifteeValidated = false;

                        this.resetForm();
                    }
                } else {
                    this.$swal({
                        title: 'Recipient with this email already exists',
                        text: '',
                        type: 'error',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                }
            }
        },
        removeGiftee: function removeGiftee(element) {
            var index = this.gifteeCol.indexOf(element);
            this.gifteeCol.splice(index, 1);
        },
        calculateTotalAmount: function calculateTotalAmount() {
            this.totalAmount = 0;
            if (this.gifteeCol && this.gifteeCol.length > 0) {
                this.addMessage = 'Add Another Gift to Cart';
                for (var i = 0; i < this.gifteeCol.length; i++) {
                    var packageInfo = this.getPackageInfo(this.gifteeCol[i].packageId)[0];
                    this.totalAmount = parseFloat(this.totalAmount) + parseFloat(packageInfo.amount);
                    this.totalAmount = parseFloat(this.totalAmount).toFixed(2);
                }
            } else {
                this.addMessage = 'Add Gift to Cart';
            }
        },
        getPackageInfo: function getPackageInfo(packageId) {
            if (this.getAllPlans) {
                var pkg = this.getAllPlans.filter(function (plan) {
                    return plan.packageId === packageId;
                });
                return pkg;
            }
            return null;
        },
        verifyPaymentSubmit: function verifyPaymentSubmit() {
            if (this.user.packageId > 0) {
                return false;
            }
            return true;
        },
        verifyPasswordField: function verifyPasswordField(field) {
            if (field.length >= 8) {
                var re = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,}).{8,}$/;
                if (!re.test(field)) {
                    this.passwordError = 'Min 8 Chars, One Upper Case, One Lower Case, One Digit!';
                    return false;
                } else {
                    return true;
                }
            } else {
                if (field.length > 0) {
                    this.passwordError = 'Password must be of 8 charecters at least';
                    return false;
                } else {
                    return true;
                }
            }
        },
        verifyEmailField: function verifyEmailField(field) {
            if (field.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(field)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyNameField: function verifyNameField(field) {
            if (field.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(field)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        doesEmailExists: function doesEmailExists(newEmail) {
            if (this.gifteeCol && this.gifteeCol.length > 0) {
                var exists = this.gifteeCol.filter(function (giftee) {
                    return giftee.gifteeEmail.toLowerCase() === newEmail.toLowerCase();
                });
                if (exists && exists.length > 0) {
                    return true;
                }
            }
            return false;
        },
        returnMinimumDate: function returnMinimumDate() {
            var today = new Date();

            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            today = mm + '/' + dd + '/' + yyyy;
            return today;
        },
        returnFormatedDate: function returnFormatedDate(delDate, format) {
            var ddate = new Date(delDate.split('-').join('/'));

            var dd = ddate.getDate();
            var mm = ddate.getMonth() + 1;
            var yyyy = ddate.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            if (format === 'M') {
                return yyyy + '-' + mm + '-' + dd;
            } else {
                return mm + '/' + dd + '/' + yyyy;
            }
        },
        onPaymentSubmit: function onPaymentSubmit() {
            var _this5 = this;

            var self = this;
            if (this.verifyEmailField(this.gifter.email) && this.verifyNameField(this.gifter.firstName) && this.verifyNameField(this.gifter.lastName)) {
                this.gifter.email = this.gifter.email.toLowerCase();
                if (this.gifteeCol.length > 0) {
                    this.spinnerToggle();
                    if (this.gateway === 'CC') {
                        this.stripe.createToken(this.card).then(function (result) {
                            if (result.error) {
                                _this5.spinnerToggle();

                                self.stripeErrorMessage = result.error.message;
                            } else {
                                var stripeToken = result.token.id;
                                var cardId = result.token.card.id;
                                _this5.userPayments.token = stripeToken;
                                _this5.userPayments.stripeCardId = cardId;
                                if (_this5.gifter.userPayments.length > 0) {
                                    _this5.gifter.userPayments.pop();
                                }
                                _this5.gifter.userPayments.push(_this5.userPayments);
                                _this5.gifter.userGifts = _this5.gifteeCol;
                                _this5.gifter.totalGiftedAmount = _this5.totalAmount;
                                if (stripeToken) {
                                    _this5.$store.dispatch('ADDGIFTS', { gift: _this5.gifter }).then(function () {
                                        if (!_this5.error.show) {
                                            console.log('total amount', _this5.gifter.totalGiftedAmount);
                                            window.fbq('track', 'Purchase', { 'value': _this5.gifter.totalGiftedAmount, 'currency': 'USD' });
                                            window.logEvents('form', 'submit', 'send-gift', _this5.gifter.totalGiftedAmount);

                                            _this5.spinnerToggle();
                                            _this5.$router.push('/');
                                            _this5.$swal({
                                                title: 'Gifts Sent!' + '<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=565489&conversionId=1609346&fmt=gif" />',
                                                text: '',
                                                type: 'success',
                                                timer: 4000,
                                                showCancelButton: false,
                                                showConfirmButton: false
                                            }).then(function () {}, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        } else {
                                            _this5.spinnerToggle();
                                        }
                                    });
                                }
                            }
                        });
                    } else if (this.userPayments.paymentMethodNonce) {
                        if (this.gifter.userPayments.length > 0) {
                            this.gifter.userPayments.pop();
                        }
                        this.gifter.userPayments.push(this.userPayments);
                        this.gifter.userGifts = this.gifteeCol;
                        this.gifter.totalGiftedAmount = this.totalAmount;
                        this.$store.dispatch('ADDGIFTS', { gift: this.gifter }).then(function () {
                            if (!_this5.error.show) {
                                _this5.spinnerToggle();
                                window.fbq('track', 'Purchase', { value: _this5.gifter.totalGiftedAmount, currency: 'USD' });
                                window.logEvents('form', 'submit', 'send-gift', _this5.gifter.totalGiftedAmount);
                                _this5.$router.push('/');
                                _this5.$swal({
                                    title: 'Gifts Sent!' + '<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=565489&conversionId=1609346&fmt=gif" />',
                                    text: '',
                                    type: 'success',
                                    timer: 4000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(function () {}, function (dismiss) {
                                    if (dismiss === 'timer') {}
                                });
                            } else {
                                _this5.spinnerToggle();
                            }
                        });
                    } else {
                        this.spinnerToggle();
                    }
                } else {
                    this.$swal({
                        title: 'Add Gift to Cart',
                        text: '',
                        type: 'error',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                }
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['error', 'user', 'isUserLoggedIn', 'getDefaultPlan', 'getAllPlans', 'user', 'getSelectedGiftId', 'getPaypalToken'])),
    watch: {
        'gifter.firstName': function gifterFirstName(to, from) {
            this.gifter.cardHolderName = this.gifter.firstName + ' ' + this.gifter.lastName;
        },
        'gifter.lastName': function gifterLastName(to, from) {
            this.gifter.cardHolderName = this.gifter.firstName + ' ' + this.gifter.lastName;
        },
        'gifteeCol': function gifteeCol(to, from) {
            this.calculateTotalAmount();
        },
        'gateway': function gateway(to, from) {
            var _this6 = this;

            if (this.gateway === 'paypal') {
                this.card.unmount('#card-element');
                this.stripeErrorMessage = '';
                this.isStripe = false;
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';
                this.userPayments.paymentType = 'PayPal';

                this.userPayments.paymentMethodNonce = '';
                setTimeout(function () {
                    _this6.mountbraintree();
                }, 1000);
            } else {
                this.stripeErrorMessage = '';
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';

                this.userPayments.paymentType = 'CC';
                this.userPayments.paymentMethodNonce = '';
                this.isStripe = true;
                setTimeout(function () {
                    _this6.mountStripeElement();
                }, 1000);
            }
        }
    }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        alert: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"],
        spinner: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"]
    },
    name: 'validate',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Redeem Your Gift',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Redeem Your Gift' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Redeem Your Gift' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            userObj: {
                email: '',
                code: '',
                validationCode: ''
            },
            spinner: false,
            paramEmail: '',
            paramValidationCode: '',
            validationSuccess: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'user', 'getValidationStatusError', 'getCorpReference'])),
    methods: {},
    mounted: function mounted() {
        var self = this;
        self.$store.dispatch('CACHEPAGE', window.location.href);
        if (self.user) {
            self.$router.push('/mytone');
        } else {
            self.$store.dispatch('GET_CORP_BY_GIFTCODE', self.$route.params.giftCode).then(function () {
                if (self.getCorpReference) {
                    var giftingUrl = '';
                    if (self.getCorpReference.invitationCode === '1') {
                        giftingUrl = '/corporationgifting/' + self.getCorpReference.corporationId + '/' + self.getCorpReference.userComments;
                    } else {
                        giftingUrl = '/corporation/referral/buy/' + self.getCorpReference.corporationId + '/' + self.getCorpReference.userComments;
                    }
                    console.log('gift found url: ', giftingUrl);
                    self.$router.push('' + giftingUrl);
                } else {
                    console.log('gift not found');
                    self.$router.push('/');
                    self.$swal({
                        title: 'Invalid Gift Code',
                        text: '',
                        type: 'error',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                }
            });
        }
    }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__JwPlayer_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"],
        'jwplayer': __WEBPACK_IMPORTED_MODULE_3__JwPlayer_vue___default.a
    },
    name: 'login',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE Gifts',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mothersday-image-mobile.jpg' }, { property: 'og:title', content: 'Give the Gift of Knowledge and Empowerment | TONE Networks' }, { property: 'og:site_name', content: 'The Perfect Holiday Gift for all the Women in Your Life' }, {
                property: 'og:description',
                content: 'Give the women in your life a subscription to TONE Networks, an empowering female community built around expert advice and support.'
            }, { property: 'twitter:title', content: 'Give the Gift of Knowledge and Empowerment | TONE Networks' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mothersday-image-mobile.jpg' }, {
                property: 'twitter:description',
                content: 'Give the women in your life a subscription to TONE Networks, an empowering female community built around expert advice and support.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            success: false,
            successMsg: '',
            giftPlans: '',
            spinner: false,
            videoURL: window.location.href,
            currentPlayerID: '',
            currentPlayerID2: '',
            sharingTitle: 'TONE Networks, Set the Tone of Your Life',
            sharingDescription: 'Give the gift of knowledge and inspiration to the women you care about',
            dynamic_para_1: '',
            dynamic_para_2: '',
            dynamic_para_3: '',
            dynamic_para_4: '',
            dynamic_para_5: '',
            dynamic_para_6: '',
            dynamic_para_7: '',
            dynamic_bullet_1: '',
            dynamic_bullet_2: '',
            dynamic_bullet_3: '',
            dynamic_button_1: '',
            dynamic_promotion_img: ''
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'getAllPlans', 'getMainVideo', 'user', 'getAllSiteContents'])),
    methods: {
        setPackage: function setPackage(plan) {
            window.logEvents('Gifting Page', 'Gifting Page: Plan Selected', 'Gifting Page Selected Plan: (' + plan.description + ') - $' + plan.amount);
            this.$store.dispatch('SETGIFTID', plan.packageId).then(function () {
                window.scrollTo(0, 0);
            });
        },
        redirect: function redirect() {
            window.logEvents('Gifting Page', 'click', 'Gifting Page: Give the Gift of Tone (Hero)');
            this.$router.push('/sendgift');
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$store.dispatch('GETDYNAMICCONTENTS', 2).then(function () {
            if (_this.getAllSiteContents) {
                _this.dynamic_para_1 = _this.setDynamicSection(_this.getAllSiteContents, 'PARA_1');
                _this.dynamic_para_2 = _this.setDynamicSection(_this.getAllSiteContents, 'PARA_2');
                _this.dynamic_para_3 = _this.setDynamicSection(_this.getAllSiteContents, 'PARA_3');
                _this.dynamic_para_4 = _this.setDynamicSection(_this.getAllSiteContents, 'PARA_4');
                _this.dynamic_para_5 = _this.setDynamicSection(_this.getAllSiteContents, 'PARA_5');
                _this.dynamic_para_6 = _this.setDynamicSection(_this.getAllSiteContents, 'PARA_6');
                _this.dynamic_para_7 = _this.setDynamicSection(_this.getAllSiteContents, 'PARA_7');
                _this.dynamic_bullet_1 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_1');
                _this.dynamic_bullet_2 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_2');
                _this.dynamic_bullet_3 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_3');
                _this.dynamic_button_1 = _this.setDynamicSection(_this.getAllSiteContents, 'BUTTON_1');
                _this.dynamic_promotion_img = _this.setDynamicSection(_this.getAllSiteContents, 'IMAGE_1');
            }
        });
        this.$store.dispatch('GETPLANS').then(function () {
            _this.giftPlans = _this.getAllPlans.filter(function (pln) {
                return pln.type.toLowerCase().indexOf('gift') >= 0 && pln.packageId > 8;
            });
        });
        this.$store.dispatch('GETUNAUTHVIDEOS', 'DEFAULT').then(function () {
            if (_this.getMainVideo) {
                _this.currentPlayerID = { video: _this.getMainVideo.sources[_this.getMainVideo.sources.length - 1].file, title: _this.getMainVideo.title, img: _this.getMainVideo.image, playerID: new Date(), tracks: _this.getMainVideo.tracks, isMute: true, showCaptions: true, mediaId: _this.getMainVideo.mediaid };
                _this.currentPlayerID2 = { video: _this.getMainVideo.sources[_this.getMainVideo.sources.length - 1].file, title: _this.getMainVideo.title, img: _this.getMainVideo.image, playerID: new Date().getHours() + new Date().getMinutes() + new Date().getSeconds() * Math.floor(Math.random() * 50), tracks: _this.getMainVideo.tracks, isMute: true, showCaptions: true, mediaId: _this.getMainVideo.mediaid };
            }
        });
        this.$store.dispatch('CACHEPAGE', window.location.href);
        this.$root.$on('social_shares_open', function (network, url) {
            window.logEvents('Gifting Page', 'social share', 'Gifting page shared on: ' + network);
        });
        if (this.user) {
            window.juapp('arb', '[userId]', '[auth]');
        } else {
            window.juapp('arb', '[userId]', '[unauth]');
        }
    }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);









/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        modal: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["modal"],
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default.a,
        'spinner': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["spinner"]
    },
    name: 'giving',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Giving',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Giving' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Giving' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            activeClass: false,
            showModal: false,
            currentCharity: null,
            mindbodyVideos: '',
            spinner: false,
            showModal_player: false,
            tabs: {
                videos: true,
                chat: false,
                discussion: false
            }
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['getAllCharities', 'getSelectedCharity', 'user', 'getMindbodyVideo'])),
    mounted: function mounted() {
        var _this = this;

        var self = this;

        self.$store.dispatch('GETSELECTEDCHARITY', this.user.userId).then(function () {
            self.$store.dispatch('GETALLCHARITIES').then(function () {
                self.getAllCharities.map(function (obj, key) {
                    if (obj.charityId === self.getSelectedCharity.charityId) {
                        obj.selectedCharity = true;
                    }
                });
            });

            _this.$store.dispatch('GETUNAUTHVIDEOS', 'DEFAULT').then(function () {
                _this.mindbodyVideos = _this.getMindbodyVideo;
                setTimeout(function () {}, 1000);
            });
        });
    },
    methods: {
        setPlayer: function setPlayer(playerObject) {
            this.currentPlayerID = { video: playerObject.sources[1].file, title: playerObject.title, img: playerObject.image, playerID: new Date() };
            this.showModal_player = true;
        },
        active: function active() {
            this.activeClass = true;
        },

        switchTab: function switchTab(id) {
            for (var tab in this.tabs) {
                this.tabs[tab] = id === tab;
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        openModal: function openModal(charity) {
            this.currentCharity = charity;
            this.showModal = true;
        },
        cancelModal: function cancelModal() {
            this.showModal = false;
            var self = this;
            setTimeout(function () {
                self.showModal = false;

                __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        changeCharity: function changeCharity(charity) {
            var self = this;
            self.currentCharity = charity;
            window.logEvents('Giving Page', 'click', 'Selected Charity: ' + charity.name);
            var info = [self.currentCharity.charityId, self.user.userId];

            self.$store.dispatch('SETSELECTEDCHARITY', info).then(function () {
                self.$store.dispatch('GETSELECTEDCHARITY', self.user.userId).then(function () {
                    self.currentCharity.selectedCharity = !self.currentCharity.selectedCharity;
                    self.$swal({
                        title: 'Charity has been updated!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    var redirect = sessionStorage.getItem('updatRedirect');
                    if (redirect) {
                        self.$router.push('/profile');
                        sessionStorage.removeItem('updatRedirect');
                    }
                });
            });
        },
        checkCharity: function checkCharity(charity) {
            return this.getSelectedCharity.charityId === charity.charityId;
        },
        cancelModal_player: function cancelModal_player() {
            var self = this;
            var $ = __webpack_provided_window_dot_jQuery;
            setTimeout(function () {
                self.showModal_player = false;

                $('.modal-open').removeClass('modal-open');
            }, 500);
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers_js__ = __webpack_require__(15);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'hello',

    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_3__JwPlayList_vue___default.a,
        'tabs': __WEBPACK_IMPORTED_MODULE_5_vue_strap__["tabs"],
        'tab': __WEBPACK_IMPORTED_MODULE_5_vue_strap__["tab"],
        modal: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["modal"],
        spinner: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["spinner"]
    },
    data: function data() {
        return {
            shareImagePayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                recipientFriendEmails: null,
                eventId: '',
                customizedMessage: '',
                playlistType: 6
            },
            shareEventSelected: null,
            showCorporateImageShare: false,
            corporateShareMessage: '',
            selectedPlaylist: null,
            corpShareModalImage: '',
            showCorporateShare: false,
            corpShareModalTitle: '',
            corpShareModalDesc: '',
            selectedCorps: [],
            allCorps: [],
            shareOption: 'Corporate',
            spinner: false,
            taggedEmails: [],
            emailList: [],
            previewMsg: 'Message Preview: \n',
            showSharedModal: false,
            shareInProcess: false,
            hoverState: false,
            showModal: false,
            currentVideo: null,
            currentPlayerID: null,
            currentVideoDesc: '',
            showQuestionsBox: false,
            activeTab: 0,
            expertsToShow: '',
            selectedQuestionId: 0,
            selectedQuestionStatus: false,
            selectedQuestionAnswer: 0,
            recommendedVideoCount: '',
            welcomeMessage: '',
            workTag: 1,
            mindbodyTag: 3,
            lifeTag: 2,
            moneyTag: 4,
            sectionToHide: Math.floor(Math.random() * 3) + 1,
            quoteReference: '',
            newContentLoaded: false,
            videoURL: window.location.href,
            firstTalkEvent: '',
            firstLiveEvent: null,
            liveEventExpert: '',
            eventURL: 'https://www1.dev-tonenetworks.com',
            seatReservation: {
                userEventId: 0,
                eventId: 0,
                userId: 0,
                status: 0,
                isAnonymous: 0
            },
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            appNavigationURL: 'https://s3.amazonaws.com/tone-assets/app/navigation',
            videoRef: null,
            giftingTitle: 'Give the gift of TONE',
            whatIsItImage: 'https://cdn.jwplayer.com/thumbs/maViy4Eq-720.jpg',
            whatIsItHeading: 'What is it?',
            whatIsItText: 'lease join our Community of women helping women as we explore the topics that interest you in our scheduled events. TONE Talks, our open chat groups, and TONE Live, our interactive expert live streaming events, are a great way to get the answers you need to help make it through your busy day!',
            desktopThemes: ['purple', 'orange', 'teal', 'pink'],
            selectedTheme: '',
            metaTag_pageTitle: '',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: ''
        };
    },
    methods: {
        formattedDuration: function formattedDuration(duration) {
            var hours = Math.floor(duration / 3600);
            var minutes = Math.floor(duration % 3600 / 60);
            var seconds = duration % 60;
            var formattedHours = hours > 0 ? hours + ':' : '';
            var formattedMinutes = minutes > 0 ? minutes + ':' : '0:';
            var formattedSeconds = '' + seconds;
            return '' + formattedHours + formattedMinutes + formattedSeconds;
        },
        shareCorporateImage: function shareCorporateImage() {
            var self = this;
            self.shareImagePayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0;
            self.shareImagePayload.senderUserId = self.user.userId;
            self.shareImagePayload.recipientsUserIds = [];
            self.shareImagePayload.recipientFriendEmails = null;
            self.shareImagePayload.customizedMessage = self.corporateShareMessage;
            if (self.shareOption === 'Corporate') {
                self.shareImagePayload.recipientsUserIds = [];
                self.shareImagePayload.recipientFriendEmails = null;
            } else if (self.shareOption === 'Individual') {
                self.shareImagePayload.recipientFriendEmails = null;
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    self.shareImagePayload.recipientsUserIds = self.selectedCorps.map(function (x) {
                        return x.userId;
                    });
                }
            } else if (self.shareOption === 'Friends') {
                self.shareImagePayload.recipientsUserIds = [];
                var emailArray = self.taggedEmails.map(function (x) {
                    return x.name;
                });
                self.shareImagePayload.recipientFriendEmails = emailArray.join(',');
            } else {}
            self.shareImagePayload.eventId = self.shareEventSelected.eventId;
            self.shareInProcess = true;

            self.$store.dispatch('CORP_EVENT_SHARE', { payload: self.shareImagePayload }).then(function () {
                if (!self.error.show) {
                    self.spinnerToggle();
                    self.$swal({
                        title: 'Event has been shared!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });

                    self.cancelCorporateImageModal();
                } else {
                    self.cancelCorporateImageModal();
                }
            });
        },
        maskEmailAddress: function maskEmailAddress(userEmail) {
            var avg = void 0,
                splitted = void 0,
                part1 = void 0,
                part2 = void 0;
            splitted = userEmail.split('@');
            part1 = splitted[0];
            var regex = /[^0-9.]/g;
            var maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1);
            console.log('maked', maskid);
            avg = part1.length / 2;
            part1 = part1.substring(0, part1.length - avg);
            part2 = splitted[1];
            var maskDomain = part2.split('.');
            return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1];
        },
        customLabel: function customLabel(option) {
            var findDuplicate = this.allCorps.find(function (x) {
                return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId;
            });

            if (findDuplicate) {
                var maskedEmail = this.maskEmailAddress(option.email);
                return option.firstName + ' ' + option.lastName + ' <' + maskedEmail + '>';
            } else {
                return option.firstName + ' ' + option.lastName;
            }
        },
        openCorporateImageShareModal: function openCorporateImageShareModal(tEvent) {
            console.log('event for share', tEvent);
            var self = this;
            self.shareInProcess = false;
            self.shareEventSelected = tEvent;
            self.showCorporateImageShare = true;
        },
        verifyEmailShare: function verifyEmailShare(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        addTag: function addTag(newTag) {
            var self = this;
            console.log('newTAg', newTag);
            var tag = {
                name: newTag
            };
            if (self.verifyEmailShare(newTag)) {
                self.emailList.push(tag);
                this.taggedEmails.push(tag);
                console.log('tagged emails', this.taggedEmails);
            } else {
                console.log('invalid email address, calling swal');
            }
        },
        cancelCorporateImageModal: function cancelCorporateImageModal() {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateImageShare = false;
                self.shareInProcess = false;
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        updateHoverState: function updateHoverState(isHover) {
            this.hoverState = isHover;
        },
        calendarLogging: function calendarLogging(event, title) {
            var self = this;
            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);
            userPayload.push(self.$route.fullPath);
            userPayload.push('ADD_TO_CALENDAR');
            userPayload.push(title);
            self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload);
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        socialClick: function socialClick() {},
        openModal: function openModal(videoObj) {
            this.currentPlayerID = { video: videoObj.sources[videoObj.sources.length - 1].file, title: videoObj.title, img: videoObj.image, playerID: new Date(), tracks: videoObj.tracks };
            this.showModal = true;
            this.currentVideoDesc = videoObj.description;
        },
        cancelModal: function cancelModal() {
            var self = this;
            var $ = __webpack_provided_window_dot_jQuery;
            setTimeout(function () {
                self.showModal = false;

                $('.modal-open').removeClass('modal-open');
            }, 500);
        },
        showQuestions: function showQuestions() {
            if (!this.showQuestionsBox) {
                window.logEvents('Home Page', 'click', 'In the mood for something else clicked');
            }
            this.showQuestionsBox = !this.showQuestionsBox;
        },
        create: function create() {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_4_slick_carousel___default.a;
            var $charitySlick = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$el).find('.responsive-slick-charity-slider');
            var $slick = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$el).find('.responsive-slick-slider');
            $charitySlick.slick({
                dots: false,
                infinite: true,
                useTransform: false,
                adaptiveHeight: true,
                speed: 300,
                pauseOnFocus: true,
                pauseOnHover: true,

                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
            $slick.slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        },
        destroy: function destroy() {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$el).find('.responsive-slick-slider').slick('unslick');
        },
        reSlick: function reSlick() {
            this.destroy();
            this.create();
        },
        redirectToExpert: function redirectToExpert(expertId) {
            this.$router.push('/expert/' + expertId);
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode, videoTitle) {
            this.$router.push('/watch/' + videoCode + '/' + videoTitle.replace(/\\s/g, '-').toLowerCase());
        },
        setRecentlyWatchedVideos: function setRecentlyWatchedVideos() {
            this.$router.push('/recenltywatchedvideos');
        },
        redirectToGiving: function redirectToGiving() {
            this.$router.push('/giving');
        },
        getTimeOfDay: function getTimeOfDay() {
            var today = new Date();
            var curHr = today.getHours();

            if (curHr < 12) {
                return 'morning';
            } else if (curHr < 18) {
                return 'afternoon';
            } else {
                return 'evening';
            }
        },
        setAnswer: function setAnswer(questionId) {
            var _this = this;

            if (this.selectedQuestionId !== questionId) {
                this.spinnerToggle();
                this.selectedQuestionId = questionId;
                this.selectedQuestionStatus = true;
                var questionResponse = {
                    questionId: questionId,
                    userId: this.user.userId,
                    answer: '1',
                    answerDate: new Date(),
                    answerDescription: null
                };
                this.$store.dispatch('SETANSWER', questionResponse).then(function () {
                    _this.showQuestionsBox = false;
                    _this.spinnerToggle();
                    _this.newContentLoaded = true;
                    window.scrollTo(0, 0);
                    setTimeout(function () {
                        _this.newContentLoaded = false;
                    }, 3000);
                });
            }
        },
        toggleBottonSection: function toggleBottonSection(sectionId) {
            if (sectionId === this.sectionToHide) {
                return true;
            }
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay.toString() + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr.toString() + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr.toString() + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr.toString() + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else if (type === 'str') {
                return day + ', ' + monStr.toString() + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else {
                return day + ', ' + monStr.toString() + ' ' + dayStr + ' @' + eHours + ' ET';
            }
        },
        isUserEntrolled: function isUserEntrolled(eventId) {
            if (this.getUserEvents) {
                var filter = this.getUserEvents.filter(function (ev) {
                    return ev.eventId === eventId;
                });
                if (filter && filter.length > 0) {
                    return true;
                }
            }
            return false;
        },
        isEventToday: function isEventToday(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var eventDate = new Date(evtDate);
            var currentDate = this.returnEasternTime();
            var eventEndDate = new Date(endDate);
            var switchTime = parseInt(defaultSwitchTime);
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        getMinutesBetweenDates: function getMinutesBetweenDates(startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime();
            return diff / 60000;
        },
        showJoin: function showJoin(eventId) {
            var event = this.getEventList.filter(function (evn) {
                return evn.eventId === eventId;
            });
            if (this.isEventToday(event[0].start_date, event[0].end_date, event[0].eventSwitchTime, this.getEventSwitchTime)) {
                return true;
            }
            return false;
        },
        joinEvent: function joinEvent(event) {
            this.$router.push('/event');
        },
        enrollUser: function enrollUser(event) {
            var _this2 = this;

            if (this.activeTab === 1) {
                window.logEvents('Home Page', 'Tone Talks Seat Reserved', 'Event Title: ' + event.title);
            } else if (this.activeTab === 2) {
                window.logEvents('Home Page', 'Tone Live Seat Reserved', 'Event Title: ' + event.title);
            }
            this.seatReservation.eventId = event.eventId;
            this.seatReservation.userId = this.user.userId;
            this.seatReservation.status = '1';
            this.seatReservation.isAnonymous = '0';
            this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(function () {
                _this2.$store.dispatch('GETALLEXPERTS').then(function () {});
                _this2.$store.dispatch('GETUSEREVENTS', _this2.user.userId).then(function () {});
            });
        },
        returnEasternTime: function returnEasternTime() {
            var offset = -5;
            if (__WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers_js__["a" /* dateHelpers */].dstEnabled(new Date())) {
                offset = -4.0;
            }
            var clientDate = new Date();
            var utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
            var serverDate = new Date(utc + 3600000 * offset);
            return serverDate;
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        },
        setVideoStatus: function setVideoStatus(videoObject) {
            var _this3 = this;

            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0';
                    } else {
                        exists[0].liked = '1';
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(function () {
                        _this3.$store.dispatch('GETAUTHUSERVIDEOS', _this3.user.userId);
                    });
                } else {
                    var logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    };
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {
                        _this3.$store.dispatch('GETAUTHUSERVIDEOS', _this3.user.userId);
                    });
                }
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this4 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this4.newPlaylistName = '';
                });
            }
        },
        getRandomTheme: function getRandomTheme() {
            var randomIndex = Math.floor(Math.random() * this.desktopThemes.length);
            return this.desktopThemes[randomIndex];
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        }
    },
    mounted: function mounted() {
        var _this5 = this;

        var self = this;
        self.$store.dispatch('GETDYNAMICCONTENTS', 16).then(function () {
            if (self.getAllSiteContents) {
                _this5.metaTag_pageTitle = _this5.setDynamicSection(_this5.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this5.metaTag_description = _this5.setDynamicSection(_this5.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this5.metaTag_keywords = _this5.setDynamicSection(_this5.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this5.metaTag_fb_title = _this5.setDynamicSection(_this5.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this5.metaTag_fb_image = _this5.setDynamicSection(_this5.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this5.metaTag_fb_description = _this5.setDynamicSection(_this5.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this5.metaTag_fb_sitename = _this5.setDynamicSection(_this5.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this5.metaTag_tw_title = _this5.setDynamicSection(_this5.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this5.metaTag_tw_image = _this5.setDynamicSection(_this5.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this5.metaTag_tw_description = _this5.setDynamicSection(_this5.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
            }
        });
        if (navigator.userAgent.indexOf('gonative') > -1) {
            var info = { userId: self.user.userId };
            var jsonFile = '';
            if (self.user.corporation && self.user.corporation.enableCorporatePage === 1) {
                jsonFile = 'sidebar_auth_corp.json';
            } else {
                jsonFile = 'sidebar_auth.json';
            }
            var json = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(info);
            window.location.href = 'gonative://registration/send?customData=' + encodeURIComponent(json);

            __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.getJSON(self.appNavigationURL + '/' + jsonFile, function (data) {
                console.log('side navigation (uath) returned', data);
                var json = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
                window.location.href = 'gonative://sidebar/setItems?items=' + encodeURIComponent(json);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown);
            });

            if (navigator.userAgent.indexOf('gonativeand') <= -1) {
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.getJSON(self.appNavigationURL + '/bottomNav_auth.json', function (data) {
                        console.log('bottom navigation (auth) returned', data);
                        var json = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
                        window.location.href = 'gonative://tabs/setTabs?tabs=' + encodeURIComponent(json);
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown);
                    });
                }, 500);
            }
        }
        if (self.user && self.user.trialEndDate) {
            var endingDate = new Date(self.user.trialEndDate.substr(0, 10));
            var currentDate = new Date();
            var remainingDays = __WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers_js__["a" /* dateHelpers */].getDatesDifference(endingDate, currentDate, 'days');
            if (remainingDays < 0) {
                self.$router.push('/becomemember');
            }
        }

        this.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', this.user.userId).then(function () {
            if (_this5.getAuthRecommendedVideos) {
                if (_this5.getAuthRecommendedVideos.length >= 3) {
                    _this5.recommendedVideoCount = 'three';
                } else if (_this5.getAuthRecommendedVideos.length === 2) {
                    _this5.recommendedVideoCount = 'two';
                } else if (_this5.getAuthRecommendedVideos.length === 1) {
                    _this5.recommendedVideoCount = 'one';
                } else {
                    _this5.recommendedVideoCount = 'none';
                }
            }
        });

        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(function () {});

        this.$store.dispatch('GETAUTHRECENTLYWATCHEDVIDEOS', this.user.userId).then(function () {
            setTimeout(function () {
                _this5.create();
            }, 3000);
            _this5.recentlyWatchedVideos = _this5.getAuthRecentlyWatchedVideos;
        });

        this.$store.dispatch('GETALLCHARITIES').then(function () {});
        this.$store.dispatch('GETDYNAMICCONTENTS', 16).then(function () {
            if (_this5.getAllSiteContents) {
                _this5.whatIsItImage = _this5.setDynamicSection(_this5.getAllSiteContents, 'WHAT_IMG_URL');
                _this5.whatIsItHeading = _this5.setDynamicSection(_this5.getAllSiteContents, 'WHAT_HEADING');
                _this5.whatIsItText = _this5.setDynamicSection(_this5.getAllSiteContents, 'WHAT_TEXT');
            }
        });

        var corpId = 0;
        if (self.user.corporation && this.user.corporation.corporationId > 0) {
            corpId = this.user.corporation.corporationId;
        }
        var params = ['WORK', corpId];
        this.$store.dispatch('GETAUTHVIDEOS', params).then(function () {});
        params = [];
        params = ['MINDBODY', corpId];

        this.$store.dispatch('GETAUTHVIDEOS', params).then(function () {});

        params = [];
        params = ['LIFE', corpId];
        this.$store.dispatch('GETAUTHVIDEOS', params).then(function () {});
        params = [];
        params = ['MONEY', corpId];
        this.$store.dispatch('GETAUTHVIDEOS', params).then(function () {});

        this.$store.dispatch('GETAUTHQUESTIONS').then(function () {});

        this.$store.dispatch('GETAUTHFUNNIES', corpId).then(function () {});

        this.$store.dispatch('GETAUTHGREETNGS', corpId).then(function () {});

        this.$store.dispatch('GETAUTHQUOTES', corpId).then(function () {
            _this5.quoteReference = _this5.getQuote.quote + '  (' + _this5.getQuote.author + ')';
        });

        this.$store.dispatch('GETALLEXPERTS').then(function () {
            _this5.expertsToShow = _this5.getAllExperts.slice(0, 3);
        });

        this.$store.dispatch('GETEVENTLIST').then(function () {
            if (_this5.getEventList) {
                var liveEvent = _this5.getEventList.filter(function (ev) {
                    return ev.type === '1';
                });
                _this5.firstLiveEvent = liveEvent[0];
                if (_this5.getAllExperts && _this5.firstLiveEvent && _this5.firstLiveEvent.expertId > 0) {
                    var expert = _this5.getAllExperts.filter(function (exp) {
                        return exp.expertId === _this5.firstLiveEvent.expertId;
                    });
                    _this5.liveEventExpert = expert[0];
                }
                var talkEvent = _this5.getEventList.filter(function (ev) {
                    return ev.type === '2';
                });
                _this5.firstTalkEvent = talkEvent[0];
                setTimeout(function () {
                    window.addeventatc.refresh();
                }, 2000);
            }
        });
        setTimeout(function () {
            var randomIndex = Math.floor(Math.random() * _this5.desktopThemes.length);
            _this5.selectedTheme = _this5.desktopThemes[randomIndex];
        }, 500);

        this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(function () {});

        this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(function () {});
        if (this.user) {
            self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(function () {
                if (self.getTaggedEmailList) {
                    self.emailList = [];
                    self.emailList = self.getTaggedEmailList;
                    console.log('email list', self.getTaggedEmailList);
                }
            });

            this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(function () {
                _this5.allCorps = [];
                if (_this5.getCorporatePayload) {
                    _this5.corporateInfo = _this5.getCorporatePayload;
                    _this5.allCorps = _this5.corporateInfo.lstCorporationUsers;
                }
            });
        }
        this.$root.$on('social_shares_open', function (network, url) {
            window.logEvents('Home Page', 'social share', 'Quote shared on: ' + network);
        });
    },
    watch: {
        'activeTab': function activeTab(to, from) {
            if (to === 1) {
                window.logEvents('Home Page', 'click', 'Tone Talks tab Clicked');
            } else if (to === 2) {
                window.logEvents('Home Page', 'click', 'Tone Live tab Clicked');
            } else {}
        },
        'firstLiveEvent': function firstLiveEvent(to, from) {
            var _this6 = this;

            var self = this;
            if (self.firstLiveEvent && self.firstLiveEvent.eventId > 0) {
                if (self.firstLiveEvent.jw_stream_title && self.firstLiveEvent.jw_stream_title.length > 2) {
                    self.$store.dispatch('GETCURRENTVIDEO', self.firstLiveEvent.jw_stream_title).then(function () {
                        if (self.getCurrentVideo) {
                            var videoObj = self.getCurrentVideo[0];
                            self.currentVideo = {
                                video: videoObj.sources[videoObj.sources.length - 1].file,
                                title: videoObj.title,
                                img: videoObj.image,
                                playerID: new Date(),
                                tracks: videoObj.tracks,
                                Description: videoObj.description,
                                mediaId: videoObj.mediaid,
                                isMute: true,
                                autoStart: false
                            };

                            setTimeout(function () {
                                _this6.videoRef = window['currentVideoId'];
                                window.jwplayer(_this6.videoRef).seek(1);
                                window.jwplayer(_this6.videoRef).pause(true);
                            }, 500);
                        }
                    });
                }
            } else {}
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'error', 'isScrolled', 'getAuthRecommendedVideos', 'getAuthRecentlyWatchedVideos', 'getAllCharities', 'getAuthWorkVideos', 'getAuthMindbodyVideos', 'getAuthLifeVideos', 'getAuthQuestions', 'getAllExperts', 'getAuthUserVideos', 'getQuote', 'getAuthMoneyVideos', 'getAuthGreeting', 'getAuthFunnies', 'getEventList', 'getUserEvents', 'getUserPlaylists', 'getEventSwitchTime', 'getCurrentVideo', 'getAllSiteContents', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getTaggedEmailList', 'getCorporatePayload', 'getAllSiteContents']), {
        styleObject: function styleObject() {
            if (this.hoverState) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor,
                    borderColor: this.getCorpButtonColor
                };
            } else {
                return {
                    color: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            }
        }
    })
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);





/* harmony default export */ __webpack_exports__["default"] = ({
    spinner: false,
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'checkbox': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        'button-group': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        alert: alert
    },
    name: 'profile',
    data: function data() {
        return {
            interestIndexes: [],
            userInterests: [],
            spinner: false,
            tabs: {
                videos: true,
                chat: false,
                discussion: false
            }
        };
    },
    methods: {
        switchTab: function switchTab(id) {
            for (var tab in this.tabs) {
                this.tabs[tab] = id === tab;
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        getInterestStatus: function getInterestStatus(interest) {
            if (this.getUserInterests) {
                var selectedInterestId = void 0;
                console.log(selectedInterestId);
                var exists = this.getUserInterests.filter(function (selectedInterestId) {
                    return selectedInterestId.interestId === interest.interestId;
                });
                if (exists && exists.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/watch/' + videoCode);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getAuthInspirationVideos', 'user', 'error'])),
    mounted: function mounted() {
        this.$store.dispatch('GETAUTHVIDEOS', 'INSPIRATION').then(function () {});
    }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'interestlist',
    spinner: false,
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'checkbox': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["checkbox"],
        'button-group': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["buttonGroup"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        alert: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"]
    },
    mounted: function mounted() {
        var _this = this;

        this.$store.dispatch('GETALLEMAILDAYS', this.user.userId).then(function () {});
        if (this.user && (this.user.status === 'REGISTER' || this.user.status === 'Registered')) {
            var corpId = 0;
            if (this.user.corporation && this.user.corporation.corporationId > 0) {
                corpId = this.user.corporation.corporationId;
            }
            this.$store.dispatch('GETALLINTERESTS', corpId).then(function () {
                console.log(_this.user.userId);
            });
            this.$store.dispatch('GETALLEMAILDAYS', this.user.userId).then(function () {});
            this.shareSaleSrc = 'https://shareasale.com/sale.cfm?amount=' + this.getDefaultPlan.amount + '&tracking=' + this.user.userId + '&transtype=SALE&merchantID=76371';
        } else {
            this.$router.push('/');
        }
    },

    data: function data() {
        return {
            interestIndexes: [],
            daysOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            userInterests: [],
            selectedDays: [1, 3, 4],
            spinner: false,
            toggleStatus: false,
            shareSaleSrc: ''
        };
    },
    watch: {
        'toggleStatus': function toggleStatus(to, from) {
            var self = this;
            if (self.toggleStatus) {
                self.checkAllInterests();
            } else {
                self.interestIndexes = [];
            }
        }
    },
    methods: {
        styleInterestObject: function styleInterestObject(interestId) {
            var isSelected = this.interestIndexes.filter(function (x) {
                return x.toString() === interestId.toString();
            });
            if (isSelected && isSelected.length > 0) {
                return {
                    color: '#FFFFFF !important',
                    backgroundColor: this.getCorpButtonColor,
                    borderWidth: '1px !important',
                    borderStyle: 'solid !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                };
            } else {
                return {
                    color: this.getCorpButtonColor + ' !important',
                    borderWidth: '1px !important',
                    borderStyle: 'solid !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                };
            }
        },
        styleDays: function styleDays(interestId) {
            var isSelected = this.selectedDays.filter(function (x) {
                return x.toString() === interestId.toString();
            });
            if (isSelected && isSelected.length > 0) {
                return {
                    color: '#FFFFFF !important',
                    backgroundColor: this.getCorpButtonColor,
                    borderWidth: '1px !important',
                    borderStyle: 'solid !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                };
            } else {
                return {
                    color: this.getCorpButtonColor + ' !important',
                    borderWidth: '1px !important',
                    borderStyle: 'solid !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                };
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        checkAllInterests: function checkAllInterests() {
            this.interestIndexes = [];
            for (var i = 0, l = this.getAllInterests.length; i < l; i++) {
                this.interestIndexes.push(i);
            }
        },

        onSubmit: function onSubmit() {
            var _this2 = this;

            this.spinnerToggle();
            var days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
            var daysSelected = [];
            this.selectedDays.forEach(function (index) {
                daysSelected.push(days[index]);
            });
            var setDaysData = { userId: this.user.userId, days: daysSelected };
            for (var i = 0, l = this.interestIndexes.length; i < l; i++) {
                var newUserInterest = {};
                var selectedInterest = this.getAllInterests[this.interestIndexes[i]];
                newUserInterest.userId = this.user.userId;
                newUserInterest.interestId = selectedInterest.interestId;
                newUserInterest.count = 5;
                this.userInterests.push(newUserInterest);
            }
            this.$store.dispatch('SETDAYS', { data: setDaysData }).then(function () {});
            this.$store.dispatch('SETINTERESTS', { interests: this.userInterests }).then(function () {
                _this2.spinnerToggle();
            });
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        atLeastOneDaySelected: function atLeastOneDaySelected() {
            return this.selectedDays.length > 0;
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getAllInterests', 'isUserLoggedIn', 'error', 'user', 'getDefaultPlan', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor']))
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_password__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_0_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_0_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_0_vue_strap__["accordion"],
        'panel': __WEBPACK_IMPORTED_MODULE_0_vue_strap__["panel"],
        alert: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["alert"],
        dropdown: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["dropdown"],
        radio: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["radio"],
        VuePassword: __WEBPACK_IMPORTED_MODULE_1_vue_password___default.a,
        checkbox: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["checkbox"],
        tabs: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["tabs"],
        tab: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["tab"],
        buttonGroup: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["buttonGroup"],
        datepicker: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["datepicker"]
    },
    name: 'join',
    data: function data() {
        return {
            dateVal: '',
            dateFormat: 'MM/dd/yyyy',
            isClear: true,
            title: 'Enter Delivery Date'
        };
    }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_masked_input__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"],
        'masked-input': __WEBPACK_IMPORTED_MODULE_3_vue_masked_input__["a" /* default */]
    },
    name: 'login',
    data: function data() {
        return {
            success: false,
            successMsg: '',
            info: {
                email: '',
                password: ''
            },
            forgetPassword: {
                email: ''
            },
            isForget: false,
            spinner: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'user', 'getOriginalVideoCode'])),
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this = this;

            var self = this;
            if (self.info.email && self.info.password) {
                self.spinnerToggle();
                self.$store.dispatch('LOGIN', { user: self.info }).then(function () {
                    self.spinnerToggle();
                    if (!self.error.show) {
                        if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).width() > 739) {} else {
                            var _self = _this;
                            var eventDesc;
                            _this.$store.dispatch('GETEVENTLIST').then(function () {
                                if (_this.getEventList) {
                                    var currentDate = _this.returnEasternTime();
                                    var eMonth = currentDate.getMonth() + 1;
                                    eMonth = eMonth >= 10 ? eMonth : '0' + eMonth;
                                    var eDate = currentDate.getDate() >= 10 ? currentDate.getDate() : '0' + currentDate.getDate();
                                    var formattedDate = eMonth + '/' + eDate + '/' + currentDate.getFullYear();

                                    var eventsOnDate = _this.getEventList.filter(function (ev) {
                                        return ev.start_date.substr(0, 10) === formattedDate;
                                    });

                                    var eventsNotOnDate = _this.getEventList.filter(function (ev) {
                                        return new Date(ev.start_date.substr(0, 10)) > new Date(formattedDate);
                                    });
                                    if (eventsOnDate && eventsOnDate.length > 0) {
                                        if (_this.isEventToday(eventsOnDate[0].end_date)) {
                                            var eventTime = new Date(eventsOnDate[0].start_date);
                                            var eventHrs = _this.getHoursFormatted(eventTime);
                                            _this.$store.dispatch('SETBANNEREVENT', eventsOnDate[0].eventId).then(function () {});
                                            if (eventsOnDate[0].type === '1') {
                                                eventDesc = 'Join us for TONE Live at ' + eventHrs + ' ET';
                                                _this.eventDescription = eventsOnDate[0].unAuthBannerText;
                                            } else {
                                                eventDesc = 'Join us for TONE Talks at ' + eventHrs + ' ET';
                                                _this.eventDescription = eventsOnDate[0].unAuthBannerText;
                                            }
                                            if (_self.currentRoute.name === 'Hello') {
                                                _self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText: 'Find out more'
                                                }).then(function () {
                                                    _self.JoinEventOrRedirect();
                                                }, function (dismiss) {
                                                    if (dismiss === 'timer') {}
                                                });
                                            } else {}
                                        } else {
                                            if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                                _this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(function () {});
                                                if (eventsNotOnDate[0].type === '1') {
                                                    _this.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                                    _this.authEventDescription = eventsNotOnDate[0].authBannerText;
                                                } else {
                                                    _this.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                                    _this.authEventDescription = eventsNotOnDate[0].authBannerText;
                                                }
                                                eventDesc = _this.eventDescription;
                                                if (_self.currentRoute.name === 'Hello') {
                                                    _self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText: 'Find out more'
                                                    }).then(function () {
                                                        _self.JoinEventOrRedirect();
                                                    }, function (dismiss) {
                                                        if (dismiss === 'timer') {}
                                                    });
                                                } else {}
                                            }
                                        }
                                    } else {
                                        if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                            _this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(function () {});
                                            if (eventsNotOnDate[0].type === '1') {
                                                _this.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                                _this.authEventDescription = eventsNotOnDate[0].authBannerText;
                                            } else {
                                                _this.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                                _this.authEventDescription = eventsNotOnDate[0].authBannerText;
                                            }
                                            eventDesc = _this.eventDescription;
                                            if (_self.currentRoute.name === 'Hello') {
                                                _self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText: 'Find out more'
                                                }).then(function () {
                                                    _self.JoinEventOrRedirect();
                                                }, function (dismiss) {
                                                    if (dismiss === 'timer') {}
                                                });
                                            } else {}
                                        }
                                    }
                                }
                            });
                        }
                    }
                    if (self.error.show && self.error.originalMessage !== 'aws.cognito.UserNotConfirmed') {
                        self.$swal({
                            title: self.error.message,
                            text: '',
                            type: 'error',
                            timer: 2000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                    } else if (self.error.show && self.error.originalMessage === 'aws.cognito.UserNotConfirmed') {
                        self.$swal({
                            title: 'Validate Your Email Address',
                            text: 'We have already sent you a validation email. Do you want us to resend it?',
                            type: 'error',
                            showCancelButton: true,
                            confirmButtonText: 'Yes, Please',
                            cancelButtonText: 'Cancel',
                            confirmButtonClass: 'btn btn-success',
                            cancelButtonClass: 'btn btn-danger',
                            buttonsStyling: false
                        }).then(function (result) {
                            self.$store.dispatch('RESENDVALIDATIONCODE', self.info.email).then(function () {
                                self.$swal({
                                    title: 'Check your mailbox for new validation email',
                                    text: '',
                                    type: 'success',
                                    timer: 3000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(function () {}, function (dismiss) {
                                    if (dismiss === 'timer') {}
                                });
                                self.cancelModal();
                            });
                        }, function (dismiss) {});
                    } else {
                        self.cancelModal();
                    }
                });
            }
        },

        onSubmitForgetRequest: function onSubmitForgetRequest() {
            var _this2 = this;

            var self = this;
            this.spinnerToggle();
            this.$store.dispatch('FORGOTPASSWORD', { user: this.forgetPassword }).then(function () {
                _this2.spinnerToggle();
                if (self.error.show) {
                    self.$swal({
                        title: self.error.message,
                        text: '',
                        type: 'error',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                } else {
                    self.$swal({
                        title: 'Forgot Password Request Sent! Check your email and follow the reset link',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    self.cancelModal();
                }
            });
        }
    },
    mounted: function mounted() {
        var originalVideoCode = this.getOriginalVideoCode;
        if (originalVideoCode) {
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', '/watch/' + originalVideoCode);
            } else {
                sessionStorage.setItem('redirectPath', '/watch/' + originalVideoCode);
            }
        }
    }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data', 'onComplete', 'onPlaylistItem', 'onPlaylistComplete'],
    name: 'jwplayerplaylistplayer',
    data: function data() {
        return {
            playerID: Math.floor(Math.random() * 1000000),
            isMute: false,
            autoStartVideo: true,
            duration: 0,
            directedFromAuthenticatedPage: false,
            repeat: false,
            showButtonFlag: false,
            showNativeFlag: false,
            becomeMemberFlag: false,
            tonePlaylistJSON: null
        };
    },
    methods: {
        redirectUserToJoin: function redirectUserToJoin() {
            if (navigator.userAgent.indexOf('gonative') > -1) {
                this.$router.push('/joinnative');
            } else {
                this.$router.push('/signup');
            }
        },
        redirectUserToCompleteSignup: function redirectUserToCompleteSignup() {
            this.$router.push('/becomemember');
        }
    },
    mounted: function mounted() {
        var self = this;
        self.tonePlaylistJSON = [{
            'image': 'https://cdn.jwplayer.com/v2/media/GECNkWxo/poster.jpg?width=720',
            'videoCode': 'GECNkWxo',
            'file': 'https://videos-cloudflare.jwpsrv.com/content/conversions/61TBRJjF/videos/ebDDpPxT-29796916.mp4?token=610418b9_67bb6dd291b57d65b3e906dbdab410080c9a8ee6',
            'description': 'As women, we approach money from one of three perspectives: happiness, fear, or commitment. Find out which one is your money mind and what it all means with this financially savvy video.',
            'title': 'Whats Your Money Mind?'
        }, {
            'image': 'https://cdn.jwplayer.com/v2/media/gtZ2dSz0/poster.jpg?width=720',
            'videoCode': 'gtZ2dSz0',
            'file': 'https://videos-cloudflare.jwpsrv.com/content/conversions/61TBRJjF/videos/ebDDpPxT-29796916.mp4?token=610418b9_67bb6dd291b57d65b3e906dbdab410080c9a8ee6',
            'description': 'Earn your seat at the table by putting forth the best version of yourself. Make your voice heard with the tips in this video.',
            'title': 'Getting a Seat at the Table'
        }, {
            'image': 'https://cdn.jwplayer.com/v2/media/XZjZQx5o/poster.jpg?width=720',
            'videoCode': 'XZjZQx5o',
            'file': 'https://videos-cloudflare.jwpsrv.com/content/conversions/61TBRJjF/videos/ebDDpPxT-29796916.mp4?token=610418b9_67bb6dd291b57d65b3e906dbdab410080c9a8ee6',
            'description': 'Its important to let your kids know you are proud of them. But did you know that its possible to go overboard on the praise? Let Dr. Tracy Alloway teach you the best ways to praise your kids to encourage real growth and effort in this video.',
            'title': 'Praising Your Kids'
        }, {
            'image': 'https://cdn.jwplayer.com/v2/media/4Q8FbuHP/poster.jpg?width=720',
            'videoCode': '4Q8FbuHP',
            'file': 'https://videos-cloudflare.jwpsrv.com/content/conversions/61TBRJjF/videos/ebDDpPxT-29796916.mp4?token=610418b9_67bb6dd291b57d65b3e906dbdab410080c9a8ee6',
            'description': 'Are you always hungry, no matter what you eat? It may be time to examine your diet and talk to a doctor to find out if you have insulin resistance. Traci Fields has the advice you need on managing insulin resistance so you can fight hunger the healthy way.',
            'title': 'Always Hungry?'
        }];
        var player = window.jwplayer('player').setup({
            playlist: self.data,
            autostart: true,
            stretching: 'uniform',

            width: '100%',
            events: {
                onReady: function onReady(state) {},
                onPlaylistItem: function onPlaylistItem(item) {
                    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setItemChangeInPlaylist', { item: item });
                },
                onComplete: function onComplete(state) {
                    console.log('user watched full video', state);
                },
                onPlaylistComplete: function onPlaylistComplete() {
                    console.log('whole playlist has completed');
                }
            }
        });
        console.log('player object', player);
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['user', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor']), {
        currentRoute: function currentRoute() {
            return this.$route;
        }
    })
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data', 'onComplete', 'onPlaylistItem', 'onPlaylistComplete'],
    name: 'jwplayerplaylistplayer',
    data: function data() {
        return {
            playerID: Math.floor(Math.random() * 1000000),
            isMute: false,
            autoStartVideo: true,
            duration: 0,
            directedFromAuthenticatedPage: false,
            repeat: false,
            showButtonFlag: false,
            showNativeFlag: false,
            becomeMemberFlag: false,
            tonePlaylistJSON: null
        };
    },
    methods: {
        redirectUserToJoin: function redirectUserToJoin() {
            if (navigator.userAgent.indexOf('gonative') > -1) {
                this.$router.push('/joinnative');
            } else {
                this.$router.push('/signup');
            }
        },
        redirectUserToCompleteSignup: function redirectUserToCompleteSignup() {
            this.$router.push('/becomemember');
        }
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        self.tonePlaylistJSON = [{
            'image': 'https://cdn.jwplayer.com/v2/media/GECNkWxo/poster.jpg?width=720',
            'videoCode': 'GECNkWxo',
            'file': 'https://videos-cloudflare.jwpsrv.com/content/conversions/61TBRJjF/videos/ebDDpPxT-29796916.mp4?token=610418b9_67bb6dd291b57d65b3e906dbdab410080c9a8ee6',
            'description': 'As women, we approach money from one of three perspectives: happiness, fear, or commitment. Find out which one is your money mind and what it all means with this financially savvy video.',
            'title': 'Whats Your Money Mind?'
        }, {
            'image': 'https://cdn.jwplayer.com/v2/media/gtZ2dSz0/poster.jpg?width=720',
            'videoCode': 'gtZ2dSz0',
            'file': 'https://videos-cloudflare.jwpsrv.com/content/conversions/61TBRJjF/videos/ebDDpPxT-29796916.mp4?token=610418b9_67bb6dd291b57d65b3e906dbdab410080c9a8ee6',
            'description': 'Earn your seat at the table by putting forth the best version of yourself. Make your voice heard with the tips in this video.',
            'title': 'Getting a Seat at the Table'
        }, {
            'image': 'https://cdn.jwplayer.com/v2/media/XZjZQx5o/poster.jpg?width=720',
            'videoCode': 'XZjZQx5o',
            'file': 'https://videos-cloudflare.jwpsrv.com/content/conversions/61TBRJjF/videos/ebDDpPxT-29796916.mp4?token=610418b9_67bb6dd291b57d65b3e906dbdab410080c9a8ee6',
            'description': 'Its important to let your kids know you are proud of them. But did you know that its possible to go overboard on the praise? Let Dr. Tracy Alloway teach you the best ways to praise your kids to encourage real growth and effort in this video.',
            'title': 'Praising Your Kids'
        }, {
            'image': 'https://cdn.jwplayer.com/v2/media/4Q8FbuHP/poster.jpg?width=720',
            'videoCode': '4Q8FbuHP',
            'file': 'https://videos-cloudflare.jwpsrv.com/content/conversions/61TBRJjF/videos/ebDDpPxT-29796916.mp4?token=610418b9_67bb6dd291b57d65b3e906dbdab410080c9a8ee6',
            'description': 'Are you always hungry, no matter what you eat? It may be time to examine your diet and talk to a doctor to find out if you have insulin resistance. Traci Fields has the advice you need on managing insulin resistance so you can fight hunger the healthy way.',
            'title': 'Always Hungry?'
        }];
        var player = window.jwplayer('player').setup({
            playlist: self.data,
            autostart: true,
            stretching: 'uniform',

            width: '100%',
            events: {
                onReady: function onReady(state) {},
                onPlaylistItem: function onPlaylistItem(item) {
                    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setItemChangeInPlaylist', { item: item });
                },
                onComplete: function onComplete(state) {
                    console.log('user watched full video', state);
                },
                onPlaylistComplete: function onPlaylistComplete() {
                    console.log('whole playlist has completed');
                    _this.$router.push('/profile/playlist');
                }
            }
        });
        console.log('player object', player);
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['user', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor']), {
        currentRoute: function currentRoute() {
            return this.$route;
        }
    })
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__ = __webpack_require__(15);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data', 'onComplete'],
    name: 'jwplayer',
    data: function data() {
        return {
            playerID: Math.floor(Math.random() * 1000000),
            isMute: false,
            autoStartVideo: true,
            duration: 0,
            directedFromAuthenticatedPage: false,
            repeat: false,
            showButtonFlag: false,
            showNativeFlag: false,
            becomeMemberFlag: false
        };
    },
    methods: {
        redirectUserToJoin: function redirectUserToJoin() {
            if (navigator.userAgent.indexOf('gonative') > -1) {
                this.$router.push('/joinnative');
            } else {
                this.$router.push('/signup');
            }
        },
        redirectUserToCompleteSignup: function redirectUserToCompleteSignup() {
            this.$router.push('/becomemember');
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        var self = this;
        var userTimeZone = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].getUserTimeZone();
        var completeVideoReference = userTimeZone + ' | ' + self.currentRoute.name + ' | ' + self.data.mediaId;
        console.log('video refernce', completeVideoReference);
        if (this.data.repeat) {
            this.repeat = true;
        }
        if (this.data.isMute) {
            this.isMute = true;
        } else {
            this.isMute = false;
        }

        if (self.currentRoute.name === 'ArchivePlayer' || self.currentRoute.name === 'TrendingPlaylistVideoPlayer' || self.currentRoute.name === 'CorpPlaylistVideoPlayer' || self.currentRoute.name === 'PlaylistVideoPlayer') {
            if (localStorage.getItem('jwplayer.mute')) {
                var currentSetting = localStorage.getItem('jwplayer.mute');
                currentSetting = JSON.parse(currentSetting);
                console.log('local storage setting', currentSetting);
                self.isMute = currentSetting;
            }
        }
        if (this.data.autoStart === undefined || this.data.autoStart) {
            this.autoStartVideo = true;
        } else if (!this.data.autoStart) {
            this.autoStartVideo = false;
        } else {
            this.autoStartVideo = true;
        }
        var lastPosition = 0;
        window.jwplayer(this.$refs[this.playerID]).setup({
            file: this.data.video,

            image: this.data.img,
            title: this.data.title,
            tracks: this.data.tracks,
            mediaid: this.data.mediaid,
            mute: this.isMute,
            repeat: this.repeat,
            stretching: 'uniform',

            width: '100%',
            events: {
                onSetupError: function onSetupError(state) {
                    console.log('setup error', state);
                    var errorPayload = {};
                    errorPayload.userId = self.user ? self.user.userId : 0;
                    errorPayload.action = 'JW_SETUP_ERROR';
                    errorPayload.activityCode = state.code;
                    errorPayload.activityMessage = state.message;
                    errorPayload.severityLevel = null;
                    errorPayload.status = self.data.mediaId;
                    errorPayload.timeZone = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].getUserTimeZone();
                    errorPayload.pageName = self.currentRoute.fullPath;
                    errorPayload.os = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.family;
                    errorPayload.osVersion = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.version;
                    errorPayload.browserName = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().name;
                    errorPayload.browserVersion = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().version;
                    errorPayload.device = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().product;
                    errorPayload.deviceType = null;

                    errorPayload.userAgent = navigator.userAgent;
                    if (navigator.userAgent.indexOf('gonative') > -1) {
                        errorPayload.deviceType = 'IOS APP';
                    }if (navigator.userAgent.indexOf('gonativeand') > -1) {
                        errorPayload.deviceType = 'ANDROID APP';
                    }
                    console.log('log video error activty');
                    self.$store.dispatch('LOGVIDEOERROR', errorPayload);
                },
                onError: function onError(state) {
                    console.log('regular error', state);
                    var errorPayload = {};
                    errorPayload.userId = self.user ? self.user.userId : 0;
                    errorPayload.action = 'JW_ERROR';
                    errorPayload.activityCode = state.code;
                    errorPayload.activityMessage = state.message;
                    errorPayload.severityLevel = null;
                    errorPayload.status = self.data.mediaId;
                    errorPayload.timeZone = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].getUserTimeZone();
                    errorPayload.pageName = self.currentRoute.fullPath;
                    errorPayload.os = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.family;
                    errorPayload.osVersion = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.version;
                    errorPayload.browserName = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().name;
                    errorPayload.browserVersion = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().version;
                    errorPayload.device = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().product;
                    errorPayload.deviceType = null;

                    errorPayload.userAgent = navigator.userAgent;
                    if (navigator.userAgent.indexOf('gonative') > -1) {
                        errorPayload.deviceType = 'IOS APP';
                    }if (navigator.userAgent.indexOf('gonativeand') > -1) {
                        errorPayload.deviceType = 'ANDROID APP';
                    }
                    self.$store.dispatch('LOGVIDEOERROR', errorPayload);
                },
                onReady: function onReady(state) {
                    var _this = this;

                    if (state.type === 'ready') {
                        window['videoPlaying'] = true;

                        if (self.autoStartVideo) {
                            setTimeout(function () {
                                if (_this.$refs && _this.$refs[_this.playerID]) {
                                    _this.$refs[_this.playerID].seek(1);
                                    _this.$refs[_this.playerID].play(true);
                                    if (!self.isMute) {
                                        _this.setVolume(30);
                                    }
                                }
                            }, 200);
                        }

                        var errorPayload = {};
                        errorPayload.userId = self.user ? self.user.userId : 0;
                        errorPayload.action = 'JW_VIDEO_LOADED';
                        errorPayload.activityCode = self.data.mediaId;
                        errorPayload.activityMessage = self.data.mediaId;
                        errorPayload.severityLevel = null;
                        errorPayload.status = self.data.mediaId;
                        errorPayload.timeZone = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].getUserTimeZone();
                        errorPayload.pageName = self.currentRoute.fullPath;
                        errorPayload.os = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.family;
                        errorPayload.osVersion = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().os.version;
                        errorPayload.browserName = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().name;
                        errorPayload.browserVersion = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().version;
                        errorPayload.device = __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelpers_js__["a" /* dateHelpers */].userPlatForm().product;
                        errorPayload.deviceType = null;

                        errorPayload.userAgent = window.navigator.userAgent;
                        if (window.navigator.userAgent.indexOf('gonative') > -1) {
                            errorPayload.deviceType = 'IOS APP';
                        }if (window.navigator.userAgent.indexOf('gonativeand') > -1) {
                            errorPayload.deviceType = 'ANDROID APP';
                        }
                        self.$store.dispatch('LOGVIDEOERROR', errorPayload);
                    }
                },
                onTime: function onTime(state) {
                    var currentPosition = Math.floor(this.getPosition());
                    var totalDuration = Math.floor(this.getDuration());

                    if (totalDuration - currentPosition <= 5 && self.user && self.currentRoute.name === 'Player' && self.user.trialEndDate !== null && (self.$route.params.refBy.toLowerCase() === 'toneteaser' || self.$route.params.refBy.toLowerCase() === 'tonetakeaway')) {
                        this.setFullscreen(false);
                        self.becomeMemberFlag = true;
                    } else {
                        self.becomeMemberFlag = false;
                    }
                    if (totalDuration - currentPosition <= 3 && !self.user && self.currentRoute.name !== 'UnAuth' && self.currentRoute.name !== 'B2b') {
                        this.setFullscreen(false);
                        self.showButtonFlag = true;
                    } else {
                        self.showButtonFlag = false;
                    }
                    if (currentPosition <= totalDuration && lastPosition !== currentPosition) {
                        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setCurrentVideoDurationWatched', { duration: currentPosition });
                    }
                    lastPosition = currentPosition;
                },
                onComplete: function onComplete(state) {
                    _this2.onComplete();
                    window['videoPlaying'] = false;
                }
            }
        });
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['user', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor']), {
        currentRoute: function currentRoute() {
            return this.$route;
        }
    })
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
    spinner: false,
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'checkbox': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        'button-group': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        alert: alert
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    name: 'profile',
    data: function data() {
        return {
            metaTag_pageTitle: '',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: '',
            interestIndexes: [],
            toggleSpinner: false,
            spinnerText: 'fetching videos',
            spinner: false,
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            firstVideoObject: '',
            showAllVideosFlag: false,
            isMobile: false,
            tabs: {
                videos: true,
                chat: false,
                discussion: false
            }
        };
    },
    watch: {
        'interestIndexes': function interestIndexes(to, from) {
            var self = this;
            self.spinnerText = 'fetching videos';
            self.toggleSpinner = true;
            self.showAllVideosFlag = false;
            var corpId = 0;
            if (self.user.corporation && this.user.corporation.corporationId > 0) {
                corpId = this.user.corporation.corporationId;
            }
            if (self.interestIndexes && self.interestIndexes.length > 0) {
                var tmpInterest = self.interestIndexes[self.interestIndexes.length - 1];
                console.log('category selected : tmpInterest = ', tmpInterest);
                self.interestIndexes.length = 0;
                self.interestIndexes[0] = tmpInterest;
                console.log('category selected', self.interestIndexes);
                var payload = {
                    corpId: corpId,
                    lstInterestSubCategoryName: self.interestIndexes
                };
                self.$store.dispatch('GETFILTEREDLIFEVIDEOS', { payload: payload }).then(function () {
                    console.log('Results', self.getAuthLifeVideos.length);
                    self.toggleSpinner = false;
                });
            } else {
                var _corpId = 0;
                if (self.user.corporation && this.user.corporation.corporationId > 0) {
                    _corpId = this.user.corporation.corporationId;
                }
                var params = ['LIFE', _corpId];
                self.$store.dispatch('GETAUTHVIDEOS', params).then(function () {
                    if (self.getAuthLifeVideos) {
                        self.toggleSpinner = false;
                    }
                });
            }
        }
    },
    methods: {
        formattedDuration: function formattedDuration(duration) {
            var hours = Math.floor(duration / 3600);
            var minutes = Math.floor(duration % 3600 / 60);
            var seconds = duration % 60;
            var formattedHours = hours > 0 ? hours + ':' : '';
            var formattedMinutes = minutes > 0 ? minutes + ':' : '0:';
            var formattedSeconds = seconds < 10 ? '0' + seconds : '' + seconds;
            return '' + formattedHours + formattedMinutes + formattedSeconds;
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        styleInterestObject: function styleInterestObject(interestId) {
            var isSelected = this.interestIndexes.filter(function (x) {
                return x.toString() === interestId.toString();
            });
            if (isSelected && isSelected.length > 0) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            } else {
                return {
                    color: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            }
        },
        showAllVideos: function showAllVideos(ref) {
            var _this = this;

            if (ref === 'top') {
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html,body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#btmLink').offset().top }, 800);
                    _this.toggleSpinner = true;
                    _this.showAllVideosFlag = true;
                    setTimeout(function () {
                        _this.toggleSpinner = false;
                    }, 700);
                }, 800);
            } else {
                this.toggleSpinner = true;
                this.showAllVideosFlag = true;
                setTimeout(function () {
                    _this.toggleSpinner = false;
                }, 700);
            }
        },
        hideCompleteList: function hideCompleteList() {
            var self = this;
            if (self.getAuthLifeVideos && self.getAuthLifeVideos.length <= 99 && !self.showAllVideosFlag) {
                return true;
            } else if (self.getAuthLifeVideos && self.getAuthLifeVideos.length > 99 && self.showAllVideosFlag) {
                return false;
            }
            return true;
        },

        switchTab: function switchTab(id) {
            for (var tab in this.tabs) {
                this.tabs[tab] = id === tab;
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/watch/' + videoCode);
            }
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoStatus: function setVideoStatus(videoObject) {
            var _this2 = this;

            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0';
                    } else {
                        exists[0].liked = '1';
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(function () {
                        _this2.$store.dispatch('GETAUTHUSERVIDEOS', _this2.user.userId);
                    });
                } else {
                    var logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    };
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {
                        _this2.$store.dispatch('GETAUTHUSERVIDEOS', _this2.user.userId);
                    });
                }
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this3 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this3.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getAuthLifeVideos', 'user', 'error', 'getAuthUserVideos', 'getUserPlaylists', 'getTrialDays', 'getVideoSubcategories', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getAllSiteContents'])),
    mounted: function mounted() {
        var _this4 = this;

        var self = this;
        self.$store.dispatch('GETDYNAMICCONTENTS', 28).then(function () {
            if (self.getAllSiteContents) {
                _this4.metaTag_pageTitle = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this4.metaTag_description = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this4.metaTag_keywords = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this4.metaTag_fb_title = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this4.metaTag_fb_image = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this4.metaTag_fb_description = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this4.metaTag_fb_sitename = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this4.metaTag_tw_title = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this4.metaTag_tw_image = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this4.metaTag_tw_description = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
            }
        });
        var checkMobile = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width();
        if (checkMobile < 767) {
            self.isMobile = true;
        } else {
            self.isMobile = false;
        }
        self.toggleSpinner = true;
        var corpId = 0;
        if (self.user.corporation && this.user.corporation.corporationId > 0) {
            corpId = this.user.corporation.corporationId;
        }
        var params = ['LIFE', corpId];
        self.$store.dispatch('GETAUTHVIDEOS', params).then(function () {
            if (self.getAuthLifeVideos) {
                self.firstVideoObject = self.getAuthLifeVideos[0];
                self.$store.dispatch('CACHEPAGE', window.location.href);
                self.toggleSpinner = false;
            }
        });
        self.$store.dispatch('GETVIDEOSUBCATEGORIES', params).then(function () {});

        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(function () {});

        this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(function () {});
    }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'contentlifeplayer',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            activeTab: 0,
            currentVideo: '',
            currentStatus: '',
            currentVideoCode: this.$route.params.videoCode,
            recommendationList: '',
            videoCompleted: false,
            videoSqueeze: false,
            hideLeftVideoIcons: false,
            addRightHoverWidthClass: false,
            addIconHoverWidthClass: false,
            showRateHoverBox: false,
            showShareHoverBox: false,
            showEnjoyHoverBox: false,
            addRightHoverEnjoyClass: false,
            addEnjoyHoverClass: false,
            captionTrack: '',
            viewTranscript: false,
            ratingOne: false,
            ratingTwo: false,
            ratingThree: false,
            ratingFour: false,
            hideAll: false,
            videoMessage: '',
            videoMessageIndex: Math.floor(Math.random() * 7),
            videoGif: '',
            videoGifIndex: Math.floor(Math.random() * 4),
            videoURL: window.location.href,
            videoNotFoundFlag: false,
            videoTag: '',
            videoList: '',
            categoryVideoList: null,
            videoExpert: '',
            categoryVideoList24: null,
            metaTag_pageTitle: '',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: '',
            showComponent: false
        };
    },
    methods: {
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        redeemCode: function redeemCode() {
            var self = this;
            if (self.getCorporateClient.invitationCode === '2') {
                self.$router.push('/corporation/referral/buy/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
            } else {
                self.$router.push('/corporationgifting/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/contentvideos/play/' + videoCode);
            location.reload();
        },
        redirectToHome: function redirectToHome() {
            this.$router.push('/');
        },
        triggerLogin: function triggerLogin(videoCode) {
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', '/watch/' + videoCode);
            } else {
                sessionStorage.setItem('redirectPath', '/watch/' + videoCode);
            }
            __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        create: function create() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.each(function () {
                __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this).slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        }
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        var videoCode = null;
        var contentCategory = 'life-promo';
        localStorage.setItem('fromUnauthPage', 'life-promo');
        self.$store.dispatch('GETDYNAMICCONTENTS', 23).then(function () {
            if (self.getAllSiteContents) {
                _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
            }
        });

        if (!self.user) {
            self.$store.dispatch('GETUNAUTHVIDEOS', 'life-promo').then(function () {
                if (_this.getAllUnauthVideos) {
                    if (videoCode) {} else {
                        var video = _this.getAllUnauthVideos.filter(function (x) {
                            return x.tags.indexOf('life-promo') > -1;
                        });
                        if (video && video.length > 0) {
                            var vTag = contentCategory;
                            var expertId = video[0].expertid;
                            self.videoNotFoundFlag = false;
                            if (vTag.indexOf('life-promo') >= 0) {
                                self.videoTag = 'LIFE';
                                self.videoList = self.getLifeVideos.filter(function (x) {
                                    return x.mediaid !== video[0].mediaid;
                                });
                                setTimeout(function () {
                                    _this.create();
                                }, 1500);
                                var params = ['LIFE', 0];
                                self.$store.dispatch('GETAUTHVIDEOS', params).then(function () {
                                    if (self.getAuthLifeVideos) {
                                        self.categoryVideoList = self.getAuthLifeVideos.slice(0, 15);
                                    }
                                });
                            } else {
                                self.categoryVideoList = '';
                                self.videoTag = null;
                                self.videoList = null;
                            }
                            self.currentVideo = {
                                video: video[0].sources[video[0].sources.length - 1].file,
                                title: video[0].title,
                                img: video[0].image,
                                playerID: new Date(),
                                tracks: video[0].tracks,
                                Description: video[0].description,
                                mediaId: video[0].mediaid
                            };
                            self.$store.dispatch('CACHEPAGE', self.videoURL);
                            if (expertId && expertId > 0) {
                                self.$store.dispatch('GETEXPERT', expertId).then(function () {
                                    if (self.getExpert) {
                                        self.videoExpert = self.getExpert;
                                    }
                                });
                            } else {
                                self.videoExpert = null;
                            }
                        } else {
                            self.$swal({
                                title: 'Video not found or not available for unauthenticated users!',
                                text: '',
                                type: 'error',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {
                                    self.$router.push('/');
                                }
                            });
                        }
                    }
                }
            });
        } else {
            self.$router.push('/');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'getWorkVideo', 'getLifeVideos', 'getMoneyVideo', 'getMindbodyVideo', 'getCommunityVideo', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert', 'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getAllUnauthVideos', 'getCorporateGiftingCode', 'getAuthWorkVideos', 'getAuthLifeVideos', 'getAuthMindbodyVideos', 'getAuthMoneyVideos', 'getCorporateClient', 'getCorporateClientId', 'getAllSiteContents', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor', 'getCorporateGiftInfo'])),
    updated: function updated() {
        this.showComponent = true;
    }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'LiveEvent',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Live Event',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Live Event' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Live Event' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            chatRollURL: '',
            eventUsersArray: [],
            eventUserArray: [],
            chatrllRef: '',
            jwEventRef: '',
            intervalId: '',
            seatReservation: {
                userEventId: 0,
                eventId: 0,
                userId: 0,
                status: 0,
                isAnonymous: 0
            }
        };
    },
    methods: {
        create: function create() {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('.responsive-slick-slider-live');
            $slick.slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        },
        leaveEvent: function leaveEvent() {
            var _this = this;

            console.log('LiveEvent.vue -> inside leaveEvent () -> ');
            this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(function (res) {
                if (_this.getUserEvents) {
                    var uEvent = _this.getUserEvents.filter(function (ev) {
                        return ev.eventId === _this.getSelectedEvent[0].eventId;
                    });
                    if (uEvent && uEvent.length > 0) {
                        _this.seatReservation.eventId = _this.getSelectedEvent[0].eventId;
                        _this.seatReservation.userId = _this.user.userId;
                        _this.seatReservation.status = '1';
                        _this.seatReservation.isAnonymous = '0';
                        _this.seatReservation.userEventId = uEvent[0].userEventId;
                        _this.$store.dispatch('UPDATERESERVATION', _this.seatReservation).then(function (res) {
                            _this.$store.dispatch('LEAVEEVENT').then(function () {});
                        }).catch(function (err) {
                            console.log('ERROR in UPDATERESERVATION ====> err = ', err);
                        });
                    }
                }
            }, 300).catch(function (err) {
                console.log('inside leaveEvent () : ERROR in -> GETUSEREVENTS  ====> err = ', err);
            });
        },
        refreshAttendees: function refreshAttendees() {
            var self = this;
            if (self.getSelectedEvent) {
                self.$store.dispatch('GETEVENTUSERS', self.getSelectedEvent[0].eventId).then(function (res) {
                    if (self.getEventUsers) {
                        self.eventUsersArray.splice(0, self.eventUsersArray.length);
                        __WEBPACK_IMPORTED_MODULE_2_jquery___default()(self.$el).find('.responsive-slick-slider-live').slick('unslick');

                        self.eventUserArray = self.getEventUsers.lstUserEvents;
                        while (self.eventUserArray.length > 0) {
                            self.eventUsersArray.push(self.eventUserArray.splice(0, 15));
                        }
                        setTimeout(function () {
                            self.create();
                        }, 1000);
                        if (self.getEventUsers.upcomingEvent) {
                            self.$swal({
                                background: '#44bda8',
                                title: self.getEventUsers.scheduleUpcomingEventMsg,
                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.getEventUsers.upcomingEvent.description + ' </span>',
                                text: '',
                                type: null,
                                timer: 5000,
                                showConfirmButton: true,
                                showCloseButton: true,
                                showCancelButton: false,
                                confirmButtonColor: '#f0617d',
                                confirmButtonText: 'Find out more'
                            }).then(function () {
                                self.$router.push('/event');
                            }, function (dismiss) {
                                if (dismiss === 'timer') {
                                    self.$router.push('/event');
                                }
                            });
                        }
                    }
                }).catch(function (err) {
                    console.log('inside refreshAttendees () : ERROR in -> GETEVENTUSERS ====> err = ', err);
                });
            }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        console.log('1 -> LiveEvent.vue -> mounted () -> this.getUserSignature = ', this.getUserSignature);
        if (this.getUserSignature) {
            console.log('1A -> LiveEvent.vue -> mounted () -> this.$route.params.eventId = ', this.$route.params.eventId);
            if (this.$route.params.eventId > 0) {
                console.log('1B -> LiveEvent.vue -> mounted () -> this.getUserSignature = ', this.getUserSignature);
                this.$store.dispatch('GETSELECTEDEVENT', this.$route.params.eventId).then(function (res) {
                    console.log('2 -> LiveEvent.vue -> mounted () -> ');
                    if (_this2.getSelectedEvent) {
                        _this2.chatrllRef = _this2.getSelectedEvent.chatroll_event_name;

                        console.log('3 -> LiveEvent.vue -> mounted () -> ', _this2.getSelectedEvent[0].eventId);
                        console.log('3A -> LiveEvent.vue -> mounted () -> this.$route.params.eventId = ', _this2.$route.params.eventId);

                        _this2.$store.dispatch('GETEVENTUSERS', _this2.$route.params.eventId).then(function (res) {
                            if (_this2.getEventUsers) {
                                _this2.eventUserArray = _this2.getEventUsers;
                                console.log('4 -> LiveEvent.vue -> mounted () -> ');
                                while (_this2.eventUserArray.length > 0) {
                                    _this2.eventUsersArray.push(_this2.eventUserArray.splice(0, 15));
                                }
                                setTimeout(function () {
                                    _this2.create();
                                    window['intervalLive'] = setInterval(function () {
                                        _this2.refreshAttendees();
                                    }, 30000);
                                }, 1000);
                            }
                        }).catch(function (err) {
                            console.log('4A : ERROR in -> GETEVENTUSERS ====> err = ', err);
                        });
                    } else {
                        if (_this2.user && _this2.user.corporation && _this2.user.corporation.enableCorporatePage === 1) {
                            console.log('5 -> LiveEvent.vue -> mounted () -> ');
                            _this2.$router.push('/corporation/mycommunity');
                        } else {
                            if (_this2.user && _this2.user.adminAccessLevel === 1) {
                                console.log('6 -> LiveEvent.vue -> mounted () -> ');
                                _this2.$router.push('/event/' + _this2.$route.params.eventId);
                            } else {
                                console.log('7 -> LiveEvent.vue -> mounted () -> ');
                                _this2.$router.push('/events');
                            }
                        }
                    }
                }).catch(function (err) {
                    console.log('7A ERROR in -> GETSELECTEDEVENT  ====> err = ', err);
                });
            } else {
                if (this.user && this.user.corporation && this.user.corporation.enableCorporatePage === 1) {
                    console.log('8 -> LiveEvent.vue -> mounted () -> ');
                    this.$router.push('/corporation/mycommunity');
                } else {
                    if (this.user && this.user.adminAccessLevel === 1) {
                        console.log('9 -> LiveEvent.vue -> mounted () -> ');
                        this.$router.push('/event/' + this.$route.params.eventId);
                    } else {
                        console.log('10 -> LiveEvent.vue -> mounted () -> ');
                        this.$router.push('/events');
                    }
                }
            }
        } else {
            if (this.user && this.user.corporation && this.user.corporation.enableCorporatePage === 1) {
                console.log('11 -> LiveEvent.vue -> mounted () -> ');

                this.$router.push('/corporation/mycommunity');
            } else {
                if (this.user && this.user.adminAccessLevel === 1) {
                    console.log('12 -> LiveEvent.vue -> mounted () -> ');
                    this.$router.push('/event/' + this.$route.params.eventId);
                } else {
                    console.log('13 -> LiveEvent.vue -> mounted () -> ');
                    this.$router.push('/events');
                }
            }
        }
        if (this.getSelectedEvent) {
            var userPic = void 0;
            if (this.user && this.user.corporation && this.user.corporation.showShoeMotif === 2) {
                userPic = 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png';
            } else {
                userPic = this.user.picture;
            }
            if (this.getUserStatus === '0') {
                this.chatRollURL = this.getSelectedEvent[0].chatroll_event_name + '&uid=' + this.user.userId + '&uname=' + this.user.firstName + '&sig=' + this.getUserSignature + '&ismod=0&upic=' + userPic;
            } else {
                var uName = 'Shoe-cognito';
                if (this.user && this.user.corporation && this.user.corporation.showShoeMotif === 2) {
                    uName = 'Incognito';
                }
                this.chatRollURL = this.getSelectedEvent[0].chatroll_event_name + '&uid=' + this.user.userId + '&uname=' + uName + '&sig=' + this.getUserSignature + '&ismod=0&upic=' + userPic;
            }
            console.log('14 -> LiveEvent.vue -> mounted () -> ');
            this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(function () {}).catch(function (err) {
                console.log('14A ERROR in GETUSEREVENTS ====> err = ', err);
            });
            console.log('15 -> LiveEvent.vue -> mounted () -> ');
        }
        this.jwEventRef = this.getSelectedEvent[0].jw_rtmp_url;
    },
    beforeDestroy: function beforeDestroy() {
        this.leaveEvent();
        clearInterval(window['intervalLive']);
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['user', 'getExpert', 'getSelectedEvent', 'getUserEvents', 'getEventUsers', 'getUserSignature', 'getUserStatus', 'getShowCountFlag', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor']))
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'LiveEvent',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Live Event',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Live Event' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Live Event' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            chatRollURL: '',
            eventUsersArray: [],
            eventUserArray: [],
            chatrllRef: '',
            jwEventRef: '',
            intervalId: '',
            seatReservation: {
                userEventId: 0,
                eventId: 0,
                userId: 0,
                status: 0,
                isAnonymous: 0
            }
        };
    },
    methods: {
        create: function create() {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('.responsive-slick-slider-live');
            $slick.slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        },
        leaveEvent: function leaveEvent() {
            var _this = this;

            this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(function () {
                if (_this.getUserEvents) {
                    var uEvent = _this.getUserEvents.filter(function (ev) {
                        return ev.eventId === _this.getSelectedEvent[0].eventId;
                    });
                    if (uEvent && uEvent.length > 0) {
                        _this.seatReservation.eventId = _this.getSelectedEvent[0].eventId;
                        _this.seatReservation.userId = _this.user.userId;
                        _this.seatReservation.status = '1';
                        _this.seatReservation.isAnonymous = '0';
                        _this.seatReservation.userEventId = uEvent[0].userEventId;
                        _this.$store.dispatch('UPDATERESERVATION', _this.seatReservation).then(function () {
                            _this.$store.dispatch('LEAVEEVENT').then(function () {});
                        });
                    }
                }
            }, 300);
        },
        refreshAttendees: function refreshAttendees() {
            var _this2 = this;

            if (this.getSelectedEvent) {
                this.$store.dispatch('GETEVENTUSERS', this.getSelectedEvent[0].eventId).then(function () {
                    if (_this2.getEventUsers) {
                        _this2.eventUsersArray.splice(0, _this2.eventUsersArray.length);
                        __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this2.$el).find('.responsive-slick-slider-live').slick('unslick');

                        _this2.eventUserArray = _this2.getEventUsers;
                        while (_this2.eventUserArray.length > 0) {
                            _this2.eventUsersArray.push(_this2.eventUserArray.splice(0, 15));
                        }
                        setTimeout(function () {
                            _this2.create();
                        }, 1000);
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        var self = this;
        if (self.getUnauthUserSignature) {
            if (this.$route.params.eventId > 0) {
                this.$store.dispatch('GETSELECTEDEVENT', this.$route.params.eventId).then(function () {
                    if (_this3.getSelectedEvent) {
                        self.chatrllRef = _this3.getSelectedEvent[0].chatroll_event_name;
                        console.log('user Status', self.getDemoUserStatus);
                        if (self.getDemoUserStatus === 1) {
                            console.info('cognito');
                            self.chatRollURL = self.getSelectedEvent[0].chatroll_event_name + '?uid=1053&uname=Shoe-cognito&sig=' + self.getUnauthUserSignature + '&ismod=0&upic=https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg';
                        } else {
                            console.info('jane');
                            self.chatRollURL = self.getSelectedEvent[0].chatroll_event_name + '?&uid=1053&uname=jane&sig=' + self.getUnauthUserSignature + '&ismod=0&upic=https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg';
                        }
                        console.log('chat roll user', self.chatRollURL);
                        _this3.jwEventRef = self.getSelectedEvent[0].jw_rtmp_url;
                        _this3.$store.dispatch('GETEXPERT', _this3.getSelectedEvent[0].expertId).then(function () {});
                        _this3.$store.dispatch('GETEVENTUSERS', _this3.getSelectedEvent[0].eventId).then(function () {
                            if (_this3.getEventUsers) {
                                _this3.eventUserArray = _this3.getEventUsers;
                                while (_this3.eventUserArray.length > 0) {
                                    _this3.eventUsersArray.push(_this3.eventUserArray.splice(0, 15));
                                }
                                setTimeout(function () {
                                    _this3.create();
                                    window['intervalLive'] = setInterval(function () {
                                        _this3.refreshAttendees();
                                    }, 30000);
                                }, 1000);
                            }
                        });
                    } else {
                        self.$router.push('/tone/demo/corporate-demo');
                    }
                });
            } else {
                self.$router.push('/tone/demo/corporate-demo');
            }
        } else {
            self.$router.push('/tone/demo/corporate-demo');
        }
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(window['intervalLive']);
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['user', 'getExpert', 'getSelectedEvent', 'getUserEvents', 'getEventUsers', 'getUnauthUserSignature', 'getDemoUserStatus']))
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"]
    },
    name: 'login',
    data: function data() {
        return {
            success: false,
            successMsg: '',
            contactForm: {
                emailAddress: '',
                phoneNumber: '',
                reason: '',
                comments: ''
            },
            spinner: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error'])),
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this = this;

            if (this.contactForm.emailAddress && this.contactForm.phoneNumber) {
                this.spinnerToggle();
                this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(function () {
                    _this.success = true;
                    _this.successMsg = 'Your message has been sent, we will get back to you shortly!';
                    _this.spinnerToggle();
                });
            }
        }
    }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        alert: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"],
        spinner: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"]
    },
    name: 'validate',
    data: function data() {
        return {
            logoutSuccess: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'user'])),
    methods: {},
    mounted: function mounted() {
        var self = this;
        if (self.user && navigator.userAgent.indexOf('gonative') > -1) {
            self.$store.dispatch('LOGOUT', this.user).then(function () {});
        } else {
            this.$router.push('/');
        }
    }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);








/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"]
    },
    name: 'login',
    data: function data() {
        return {
            success: false,
            successMsg: '',
            contactForm: {
                emailAddress: '',
                phoneNumber: '',
                reason: '',
                comments: ''
            },
            spinner: false,
            staffMembers: null,
            showMembers: false,
            messageHeader: '',
            messageText: '',
            messageImageUrl: ''
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'user', 'getMembers', 'getAllSiteContents', 'getSiteStatus'])),
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this = this;

            if (this.contactForm.emailAddress && this.contactForm.phoneNumber) {
                this.spinnerToggle();
                this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(function () {
                    _this.success = true;
                    _this.successMsg = 'Your message has been sent, we will get back to you shortly!';
                    _this.spinnerToggle();
                });
            }
        },
        setCarousal: function setCarousal() {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$el).find('.responsive-slick-imagelist');
            $slick.each(function () {
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        }
    },
    watch: {},
    mounted: function mounted() {
        var _this2 = this;

        var self = this;
        this.$store.dispatch('GETAPPCONFIGRATION').then(function () {
            if (!self.getSiteStatus) {
                self.$router.push('/');
            }
        });
        self.$store.dispatch('GETDYNAMICCONTENTS', 13).then(function () {
            if (self.getAllSiteContents) {
                self.messageHeader = _this2.setDynamicSection(_this2.getAllSiteContents, 'LINE_01');
                self.messageText = _this2.setDynamicSection(_this2.getAllSiteContents, 'LINE_02');
                self.messageImageUrl = _this2.setDynamicSection(_this2.getAllSiteContents, 'IMAGE_URL_01');
            }
        });
        self.$store.dispatch('CACHEPAGE', window.location.href);
    }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_masked_input__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);








/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["accordion"],
        'panel': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["panel"],
        'masked-input': __WEBPACK_IMPORTED_MODULE_4_vue_masked_input__["a" /* default */],
        alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
        dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["dropdown"],
        radio: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["radio"],
        VuePassword: __WEBPACK_IMPORTED_MODULE_3_vue_password___default.a,
        checkbox: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        tabs: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tabs"],
        tab: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tab"],
        buttonGroup: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"]
    },
    name: 'signUp',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Redeem Your Gift',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Redeem Your Gift' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Redeem Your Gift' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            csv_file: [],
            userObject: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                packageId: 0,
                comments: '',
                phoneNumber: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg'
            },
            spinner: false,
            alert: false,
            passwordError: '',
            paymentSection: false,
            isToggle: false,
            isChecked: false,
            defaultPlan: '',
            hidePasswordMeter: true,
            rawPhoneNumber: '',
            phoneNumber: '',
            dynamic_bullet_1: '',
            dynamic_bullet_2: '',
            dynamic_bullet_3: '',
            dynamic_bullet_4: '',
            dynamic_bullet_5: '',
            dynamic_bullet_6: '',
            downloadUrl: window.location.href
        };
    },
    mounted: function mounted() {
        if (this.user && this.user.corporation && this.user.corporation.pageAdmin) {} else {
            this.$router.push('/mytone');
        }
    },

    methods: {
        uploadImage: function uploadImage() {
            var _this = this;

            console.log('csv file data', this.csv_file);
            this.$store.dispatch('UPLOAD_CORP_CSV_METADATA', {
                csv_file: this.csv_file,
                corporationId: this.user.corporation.corporationId,
                userId: this.user.userId
            }).then(function (res) {
                if (res && res.completed && !res.error) {
                    _this.showPopup('Success!', 'File is uploaded successfully', 'success');
                    _this.$refs.myFileInput.value = '';
                    _this.csv_file = [];
                } else {
                    _this.showPopup('Error!', 'Unable to process.', 'error');
                }
            }).catch(function (err) {
                console.log('error', err);
                _this.showPopup('Error!', 'File could not be uploaded', 'error');
            });
        },
        showPopup: function showPopup(title, msg, popupType, cb) {
            this.$swal(title, msg, popupType).then(function (res) {
                cb && cb();
                return res;
            });
        },
        onFileChange: function onFileChange(event) {
            var files = event.target.files;
            if (files.length) this.csv_file = files[0];
        },
        readCSVFile: function readCSVFile(file) {
            var self = this;
            var reader = new FileReader();
            reader.readAsText(file);
            reader.onload = function (e) {
                var contents = e.target.result;
                self.processCSVFile(contents);
            };
        },
        returnFormatedDate: function returnFormatedDate(delDate, format) {
            var ddate = new Date(delDate.split('-').join('/'));

            var dd = ddate.getDate();
            var mm = ddate.getMonth() + 1;
            var yyyy = ddate.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            if (format === 'M') {
                return yyyy + '-' + mm + '-' + dd;
            } else {
                return mm + '/' + dd + '/' + yyyy;
            }
        },
        processCSVFile: function processCSVFile(csv) {
            var allTextLines = csv.split(/\r\n|\n/);
            var lines = [];
            for (var i = 1; i < allTextLines.length; i++) {
                var data = allTextLines[i].split(',');
                var tarr = [];
                for (var j = 0; j < data.length; j++) {
                    tarr.push(data[j]);
                }
                lines.push(tarr);
            }
            console.log(lines);
            if (lines && lines.length > 0) {
                for (var k = 0; k < lines.length; k++) {
                    var newGiftee = {};
                    newGiftee.packageId = this.packageId;
                    newGiftee.gifteeFirstName = lines[k][0];
                    newGiftee.gifteeLastName = lines[k][1];
                    newGiftee.gifteeEmail = lines[k][2].toLowerCase();
                    newGiftee.deliveryMessage = lines[k][3];
                    newGiftee.deliveryDate = this.returnFormatedDate(lines[k][4], 'M');
                    newGiftee.redeemDate = null;
                    this.gifteeCol.push(newGiftee);
                }
            }
        },
        downloadWithAxios: function downloadWithAxios() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_5_axios___default()({
                method: 'get',
                url: this.returnDonwloadUrl(),
                responseType: 'arraybuffer'
            }).then(function (response) {
                console.log('response from axios', response);
                _this2.forceFileDownload(response);
            }).catch(function () {
                return console.log('error occured');
            });
        },
        forceFileDownload: function forceFileDownload(response) {
            var url = window.URL.createObjectURL(new Blob([response.data]));
            var link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'user-list.csv');
            document.body.appendChild(link);
            link.click();
        },
        downloadWithVueResource: function downloadWithVueResource() {
            var _this3 = this;

            this.$http({
                method: 'get',
                url: this.url,
                responseType: 'arraybuffer'
            }).then(function (response) {
                _this3.forceFileDownload(response);
            }).catch(function () {
                return console.log('error occured');
            });
        },
        returnDonwloadUrl: function returnDonwloadUrl() {
            var href = window.location.href;
            var origin = '';
            if (href.indexOf('localhost') > -1 || href.indexOf('dev') > -1) {
                origin = 'https://api1.dev-tonenetworks.com/v1/corporations/downloadCorporationUsersCSV/' + this.user.corporation.corporationId + '/null/null';
            } else {
                origin = 'https://api1.tonenetworks.com/v1/corporations/downloadCorporationUsersCSV/' + this.user.corporation.corporationId + '/null/null';
            }

            return origin;
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        verifyPaymentSubmit: function verifyPaymentSubmit() {
            if (this.user.packageId > 0) {
                return false;
            }
            return true;
        },
        verifyPassword: function verifyPassword() {
            if (this.user.password.length >= 6) {
                var re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/;
                if (!re.test(this.user.password)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (this.user.password.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        verifyEmail: function verifyEmail() {
            if (this.user.email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(this.user.email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyFirstName: function verifyFirstName() {
            if (this.user.firstName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.firstName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyLastName: function verifyLastName() {
            if (this.user.lastName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.lastName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyCardHolderName: function verifyCardHolderName() {
            if (this.user.cardHolderName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.cardHolderName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onGifteeSubmit: function onGifteeSubmit() {
            var _this4 = this;

            if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                this.user.phoneNumber = this.phoneNumber;
            } else {
                this.phoneNumber = '';
                this.user.phoneNumber = '';
            }
            if (this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                this.spinnerToggle();
                this.user.email = this.user.email.toLowerCase();
                this.$store.dispatch('SAVEGIFTEE', { giftee: this.user }).then(function () {
                    if (!_this4.error.show) {
                        _this4.spinnerToggle();
                        _this4.$swal({
                            title: 'Registration Success!',
                            text: 'Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)',
                            type: 'success',
                            timer: 4000,
                            showCancelButton: false,
                            showConfirmButton: false,
                            customClass: 'sweetalert-lg-signup'
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                    } else {
                        _this4.spinnerToggle();
                    }
                });
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['user', 'error', 'isUserLoggedIn', 'getAllPlans', 'getGiftee', 'getCorporateGiftingCode', 'getAllSiteContents']))
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
    spinner: false,
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'checkbox': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        'button-group': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        alert: alert
    },
    name: 'profile',
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            metaTag_pageTitle: '',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: '',
            spinnerText: 'fetching videos',
            interestIndexes: [],
            toggleSpinner: false,
            userInterests: [],
            spinner: false,
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            firstVideoObject: '',
            showAllVideosFlag: false,
            isMobile: false,
            tabs: {
                videos: true,
                chat: false,
                discussion: false
            }
        };
    },
    watch: {
        'interestIndexes': function interestIndexes(to, from) {
            var self = this;
            self.spinnerText = 'fetching videos';
            self.toggleSpinner = true;
            self.showAllVideosFlag = false;
            var corpId = 0;
            if (self.user.corporation && this.user.corporation.corporationId > 0) {
                corpId = this.user.corporation.corporationId;
            }
            if (self.interestIndexes && self.interestIndexes.length > 0) {
                var tmpInterest = self.interestIndexes[self.interestIndexes.length - 1];
                console.log('category selected : tmpInterest = ', tmpInterest);
                self.interestIndexes.length = 0;
                self.interestIndexes[0] = tmpInterest;
                console.log('category selected', self.interestIndexes);
                var payload = {
                    corpId: corpId,
                    lstInterestSubCategoryName: self.interestIndexes
                };
                self.$store.dispatch('GETFILTEREDMINDBODYVIDEOS', { payload: payload }).then(function () {
                    console.log('Results', self.getAuthMindbodyVideos.length);
                    self.toggleSpinner = false;
                });
            } else {
                var _corpId = 0;
                if (self.user.corporation && this.user.corporation.corporationId > 0) {
                    _corpId = this.user.corporation.corporationId;
                }
                var params = ['MINDBODY', _corpId];
                self.$store.dispatch('GETAUTHVIDEOS', params).then(function () {
                    if (self.getAuthMindbodyVideos) {
                        self.toggleSpinner = false;
                    }
                });
            }
        }
    },
    methods: {
        formattedDuration: function formattedDuration(duration) {
            var hours = Math.floor(duration / 3600);
            var minutes = Math.floor(duration % 3600 / 60);
            var seconds = duration % 60;
            var formattedHours = hours > 0 ? hours + ':' : '';
            var formattedMinutes = minutes > 0 ? minutes + ':' : '0:';
            var formattedSeconds = seconds < 10 ? '0' + seconds : '' + seconds;
            return '' + formattedHours + formattedMinutes + formattedSeconds;
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        styleInterestObject: function styleInterestObject(interestId) {
            var isSelected = this.interestIndexes.filter(function (x) {
                return x.toString() === interestId.toString();
            });
            if (isSelected && isSelected.length > 0) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            } else {
                return {
                    color: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            }
        },
        showAllVideos: function showAllVideos(ref) {
            var _this = this;

            if (ref === 'top') {
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html,body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#btmLink').offset().top }, 800);
                    _this.toggleSpinner = true;
                    _this.showAllVideosFlag = true;
                    setTimeout(function () {
                        _this.toggleSpinner = false;
                    }, 700);
                }, 800);
            } else {
                this.toggleSpinner = true;
                this.showAllVideosFlag = true;
                setTimeout(function () {
                    _this.toggleSpinner = false;
                }, 700);
            }
        },
        hideCompleteList: function hideCompleteList() {
            var self = this;
            if (self.getAuthMindbodyVideos && self.getAuthMindbodyVideos.length <= 99 && !self.showAllVideosFlag) {
                return true;
            } else if (self.getAuthMindbodyVideos && self.getAuthMindbodyVideos.length > 99 && self.showAllVideosFlag) {
                return false;
            }
            return true;
        },

        switchTab: function switchTab(id) {
            for (var tab in this.tabs) {
                this.tabs[tab] = id === tab;
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        getInterestStatus: function getInterestStatus(interest) {
            if (this.getUserInterests) {
                var exists = this.getUserInterests.filter(function (selectedInterestId) {
                    return selectedInterestId.interestId === interest.interestId;
                });
                if (exists && exists.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/watch/' + videoCode);
            }
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoStatus: function setVideoStatus(videoObject) {
            var _this2 = this;

            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0';
                    } else {
                        exists[0].liked = '1';
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(function () {
                        _this2.$store.dispatch('GETAUTHUSERVIDEOS', _this2.user.userId);
                    });
                } else {
                    var logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    };
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {
                        _this2.$store.dispatch('GETAUTHUSERVIDEOS', _this2.user.userId);
                    });
                }
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this3 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this3.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getAuthMindbodyVideos', 'user', 'error', 'getAuthUserVideos', 'getUserPlaylists', 'getTrialDays', 'getVideoSubcategories', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getAllSiteContents'])),
    mounted: function mounted() {
        var _this4 = this;

        var self = this;
        self.$store.dispatch('GETDYNAMICCONTENTS', 29).then(function () {
            if (self.getAllSiteContents) {
                _this4.metaTag_pageTitle = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this4.metaTag_description = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this4.metaTag_keywords = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this4.metaTag_fb_title = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this4.metaTag_fb_image = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this4.metaTag_fb_description = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this4.metaTag_fb_sitename = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this4.metaTag_tw_title = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this4.metaTag_tw_image = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this4.metaTag_tw_description = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
            }
        });
        var checkMobile = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width();
        if (checkMobile < 767) {
            self.isMobile = true;
        } else {
            self.isMobile = false;
        }
        self.toggleSpinner = true;
        var corpId = 0;
        if (self.user.corporation && this.user.corporation.corporationId > 0) {
            corpId = this.user.corporation.corporationId;
        }
        var params = ['MINDBODY', corpId];
        self.$store.dispatch('GETAUTHVIDEOS', params).then(function () {
            if (self.getAuthMindbodyVideos) {
                self.firstVideoObject = self.getAuthMindbodyVideos[0];
                self.$store.dispatch('CACHEPAGE', window.location.href);
                self.toggleSpinner = false;
            }
        });
        self.$store.dispatch('GETVIDEOSUBCATEGORIES', params).then(function () {});

        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(function () {});

        this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(function () {});
    }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'contentmindbodyplayer',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            activeTab: 0,
            currentVideo: '',
            currentStatus: '',
            currentVideoCode: this.$route.params.videoCode,
            recommendationList: '',
            videoCompleted: false,
            videoSqueeze: false,
            hideLeftVideoIcons: false,
            addRightHoverWidthClass: false,
            addIconHoverWidthClass: false,
            showRateHoverBox: false,
            showShareHoverBox: false,
            showEnjoyHoverBox: false,
            addRightHoverEnjoyClass: false,
            addEnjoyHoverClass: false,
            captionTrack: '',
            viewTranscript: false,
            ratingOne: false,
            ratingTwo: false,
            ratingThree: false,
            ratingFour: false,
            hideAll: false,
            videoMessage: '',
            videoMessageIndex: Math.floor(Math.random() * 7),
            videoGif: '',
            videoGifIndex: Math.floor(Math.random() * 4),
            videoURL: window.location.href,
            videoNotFoundFlag: false,
            videoTag: '',
            videoList: '',
            categoryVideoList: null,
            videoExpert: '',
            categoryVideoList24: null,
            metaTag_pageTitle: '',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: '',
            showComponent: false
        };
    },
    methods: {
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        redeemCode: function redeemCode() {
            var self = this;
            if (self.getCorporateClient.invitationCode === '2') {
                self.$router.push('/corporation/referral/buy/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
            } else {
                self.$router.push('/corporationgifting/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/contentvideos/play/' + videoCode);
            location.reload();
        },
        redirectToHome: function redirectToHome() {
            this.$router.push('/');
        },
        triggerLogin: function triggerLogin(videoCode) {
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', '/watch/' + videoCode);
            } else {
                sessionStorage.setItem('redirectPath', '/watch/' + videoCode);
            }
            __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        create: function create() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.each(function () {
                __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this).slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        }
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        var videoCode = null;
        var contentCategory = 'mindbody-promo';
        localStorage.setItem('fromUnauthPage', 'mindbody-promo');
        self.$store.dispatch('GETDYNAMICCONTENTS', 21).then(function () {
            if (self.getAllSiteContents) {
                _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
            }
        });

        if (!self.user) {
            self.$store.dispatch('GETUNAUTHVIDEOS', 'mindbody-promo').then(function () {
                if (_this.getAllUnauthVideos) {
                    if (videoCode) {} else {
                        var video = _this.getAllUnauthVideos.filter(function (x) {
                            return x.tags.indexOf('mindbody-promo') > -1;
                        });
                        if (video && video.length > 0) {
                            var vTag = contentCategory;
                            var expertId = video[0].expertid;
                            self.videoNotFoundFlag = false;
                            if (vTag.indexOf('mindbody-promo') >= 0) {
                                self.videoTag = 'MINDBODY';
                                self.videoList = self.getMindbodyVideo.filter(function (x) {
                                    return x.mediaid !== video[0].mediaid;
                                });
                                setTimeout(function () {
                                    _this.create();
                                }, 1500);
                                var params = ['MINDBODY', 0];
                                _this.$store.dispatch('GETAUTHVIDEOS', params).then(function () {
                                    if (self.getAuthMindbodyVideos) {
                                        self.categoryVideoList = self.getAuthMindbodyVideos.slice(0, 15);
                                    }
                                });
                            } else {
                                self.categoryVideoList = '';
                                self.videoTag = null;
                                self.videoList = null;
                            }
                            self.currentVideo = {
                                video: video[0].sources[video[0].sources.length - 1].file,
                                title: video[0].title,
                                img: video[0].image,
                                playerID: new Date(),
                                tracks: video[0].tracks,
                                Description: video[0].description,
                                mediaId: video[0].mediaid
                            };
                            self.$store.dispatch('CACHEPAGE', self.videoURL);
                            if (expertId && expertId > 0) {
                                self.$store.dispatch('GETEXPERT', expertId).then(function () {
                                    if (self.getExpert) {
                                        self.videoExpert = self.getExpert;
                                    }
                                });
                            } else {
                                self.videoExpert = null;
                            }
                        } else {
                            self.$swal({
                                title: 'Video not found or not available for unauthenticated users!',
                                text: '',
                                type: 'error',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {
                                    self.$router.push('/');
                                }
                            });
                        }
                    }
                }
            });
        } else {
            self.$router.push('/');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'getWorkVideo', 'getLifeVideos', 'getMoneyVideo', 'getMindbodyVideo', 'getCommunityVideo', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert', 'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getAllUnauthVideos', 'getCorporateGiftingCode', 'getAuthWorkVideos', 'getAuthLifeVideos', 'getAuthMindbodyVideos', 'getAuthMoneyVideos', 'getCorporateClient', 'getCorporateClientId', 'getAllSiteContents', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor', 'getCorporateGiftInfo'])),
    updated: function updated() {
        this.showComponent = true;
    }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
    spinner: false,
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'checkbox': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        'button-group': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        alert: alert
    },
    name: 'profile',
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: 'TONE | Money Videos',
            meta: [{ property: 'og:image', content: self.firstVideoObject.image }, { property: 'og:title', content: self.firstVideoObject.title + ' | TONE Networks' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: self.firstVideoObject.description
            }, { property: 'twitter:title', content: self.firstVideoObject.title + ' | TONE Networks' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.firstVideoObject.image }, {
                property: 'twitter:description',
                content: self.firstVideoObject.description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            spinnerText: 'fetching videos',
            interestIndexes: [],
            toggleSpinner: false,
            spinner: false,
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            firstVideoObject: '',
            showAllVideosFlag: false,
            isMobile: false,
            tabs: {
                videos: true,
                chat: false,
                discussion: false
            }
        };
    },
    watch: {
        'interestIndexes': function interestIndexes(to, from) {
            var self = this;
            self.spinnerText = 'fetching videos';
            self.toggleSpinner = true;
            self.showAllVideosFlag = false;
            var corpId = 0;
            if (self.user.corporation && this.user.corporation.corporationId > 0) {
                corpId = this.user.corporation.corporationId;
            }
            if (self.interestIndexes && self.interestIndexes.length > 0) {
                var tmpInterest = self.interestIndexes[self.interestIndexes.length - 1];
                console.log('category selected : tmpInterest = ', tmpInterest);
                self.interestIndexes.length = 0;
                self.interestIndexes[0] = tmpInterest;
                console.log('category selected', self.interestIndexes);
                var payload = {
                    corpId: corpId,
                    lstInterestSubCategoryName: self.interestIndexes
                };
                self.$store.dispatch('GETFILTEREDMONEYVIDEOS', { payload: payload }).then(function () {
                    console.log('Results', self.getAuthMoneyVideos.length);
                    self.toggleSpinner = false;
                });
            } else {
                var _corpId = 0;
                if (self.user.corporation && this.user.corporation.corporationId > 0) {
                    _corpId = this.user.corporation.corporationId;
                }
                var params = ['MONEY', _corpId];
                self.$store.dispatch('GETAUTHVIDEOS', params).then(function () {
                    if (self.getAuthMoneyVideos) {
                        self.toggleSpinner = false;
                    }
                });
            }
        }
    },
    methods: {
        formattedDuration: function formattedDuration(duration) {
            var hours = Math.floor(duration / 3600);
            var minutes = Math.floor(duration % 3600 / 60);
            var seconds = duration % 60;
            var formattedHours = hours > 0 ? hours + ':' : '';
            var formattedMinutes = minutes > 0 ? minutes + ':' : '0:';
            var formattedSeconds = seconds < 10 ? '0' + seconds : '' + seconds;
            return '' + formattedHours + formattedMinutes + formattedSeconds;
        },
        styleInterestObject: function styleInterestObject(interestId) {
            var isSelected = this.interestIndexes.filter(function (x) {
                return x.toString() === interestId.toString();
            });
            if (isSelected && isSelected.length > 0) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            } else {
                return {
                    color: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            }
        },
        showAllVideos: function showAllVideos(ref) {
            var _this = this;

            if (ref === 'top') {
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html,body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#btmLink').offset().top }, 800);
                    _this.toggleSpinner = true;
                    _this.showAllVideosFlag = true;
                    setTimeout(function () {
                        _this.toggleSpinner = false;
                    }, 700);
                }, 800);
            } else {
                this.toggleSpinner = true;
                this.showAllVideosFlag = true;
                setTimeout(function () {
                    _this.toggleSpinner = false;
                }, 700);
            }
        },
        hideCompleteList: function hideCompleteList() {
            var self = this;
            if (self.getAuthMoneyVideos && self.getAuthMoneyVideos.length <= 99 && !self.showAllVideosFlag) {
                return true;
            } else if (self.getAuthMoneyVideos && self.getAuthMoneyVideos.length > 99 && self.showAllVideosFlag) {
                return false;
            }
            return true;
        },

        switchTab: function switchTab(id) {
            for (var tab in this.tabs) {
                this.tabs[tab] = id === tab;
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/watch/' + videoCode);
            }
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoStatus: function setVideoStatus(videoObject) {
            var _this2 = this;

            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0';
                    } else {
                        exists[0].liked = '1';
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(function () {
                        _this2.$store.dispatch('GETAUTHUSERVIDEOS', _this2.user.userId);
                    });
                } else {
                    var logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    };
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {
                        _this2.$store.dispatch('GETAUTHUSERVIDEOS', _this2.user.userId);
                    });
                }
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this3 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this3.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getAuthMoneyVideos', 'user', 'error', 'getAuthUserVideos', 'getUserPlaylists', 'getTrialDays', 'getVideoSubcategories', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'])),
    mounted: function mounted() {
        var self = this;
        var checkMobile = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width();
        if (checkMobile < 767) {
            self.isMobile = true;
        } else {
            self.isMobile = false;
        }
        self.toggleSpinner = true;
        var corpId = 0;
        if (self.user.corporation && this.user.corporation.corporationId > 0) {
            corpId = this.user.corporation.corporationId;
        }
        var params = ['MONEY', corpId];
        this.$store.dispatch('GETAUTHVIDEOS', params).then(function () {
            if (self.getAuthMoneyVideos) {
                self.firstVideoObject = self.getAuthMoneyVideos[0];
                self.$store.dispatch('CACHEPAGE', window.location.href);
                self.toggleSpinner = false;
            }
        });
        self.$store.dispatch('GETVIDEOSUBCATEGORIES', params).then(function () {});

        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(function () {});

        this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(function () {});
    }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'contentmoneyplayer',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            activeTab: 0,
            currentVideo: '',
            currentStatus: '',
            currentVideoCode: this.$route.params.videoCode,
            recommendationList: '',
            videoCompleted: false,
            videoSqueeze: false,
            hideLeftVideoIcons: false,
            addRightHoverWidthClass: false,
            addIconHoverWidthClass: false,
            showRateHoverBox: false,
            showShareHoverBox: false,
            showEnjoyHoverBox: false,
            addRightHoverEnjoyClass: false,
            addEnjoyHoverClass: false,
            captionTrack: '',
            viewTranscript: false,
            ratingOne: false,
            ratingTwo: false,
            ratingThree: false,
            ratingFour: false,
            hideAll: false,
            videoMessage: '',
            videoMessageIndex: Math.floor(Math.random() * 7),
            videoGif: '',
            videoGifIndex: Math.floor(Math.random() * 4),
            videoURL: window.location.href,
            videoNotFoundFlag: false,
            videoTag: '',
            videoList: '',
            categoryVideoList: null,
            videoExpert: '',
            categoryVideoList24: null,
            metaTag_pageTitle: '',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: '',
            showComponent: false
        };
    },
    methods: {
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        redeemCode: function redeemCode() {
            var self = this;
            if (self.getCorporateClient.invitationCode === '2') {
                self.$router.push('/corporation/referral/buy/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
            } else {
                self.$router.push('/corporationgifting/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/contentvideos/play/' + videoCode);
            location.reload();
        },
        redirectToHome: function redirectToHome() {
            this.$router.push('/');
        },
        triggerLogin: function triggerLogin(videoCode) {
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', '/watch/' + videoCode);
            } else {
                sessionStorage.setItem('redirectPath', '/watch/' + videoCode);
            }
            __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        create: function create() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.each(function () {
                __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this).slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        }
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        var videoCode = null;
        var contentCategory = 'money-promo';
        localStorage.setItem('fromUnauthPage', 'money-promo');
        self.$store.dispatch('GETDYNAMICCONTENTS', 22).then(function () {
            if (self.getAllSiteContents) {
                _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
            }
        });

        if (!self.user) {
            self.$store.dispatch('GETUNAUTHVIDEOS', 'money-promo').then(function () {
                if (_this.getAllUnauthVideos) {
                    if (videoCode) {} else {
                        var video = _this.getAllUnauthVideos.filter(function (x) {
                            return x.tags.indexOf('money-promo') > -1;
                        });
                        if (video && video.length > 0) {
                            var vTag = contentCategory;
                            var expertId = video[0].expertid;
                            self.videoNotFoundFlag = false;
                            if (vTag.indexOf('money-promo') >= 0) {
                                self.videoTag = 'MONEY';
                                self.videoList = self.getMoneyVideo.filter(function (x) {
                                    return x.mediaid !== video[0].mediaid;
                                });
                                setTimeout(function () {
                                    _this.create();
                                }, 1500);
                                var params = ['MONEY', 0];
                                self.$store.dispatch('GETAUTHVIDEOS', params).then(function () {
                                    if (self.getAuthMoneyVideos) {
                                        self.categoryVideoList = self.getAuthMoneyVideos.slice(0, 15);
                                    }
                                });
                            } else {
                                self.categoryVideoList = '';
                                self.videoTag = null;
                                self.videoList = null;
                            }

                            self.currentVideo = {
                                video: video[0].sources[video[0].sources.length - 1].file,
                                title: video[0].title,
                                img: video[0].image,
                                playerID: new Date(),
                                tracks: video[0].tracks,
                                Description: video[0].description,
                                mediaId: video[0].mediaid
                            };
                            self.$store.dispatch('CACHEPAGE', self.videoURL);
                            if (expertId && expertId > 0) {
                                self.$store.dispatch('GETEXPERT', expertId).then(function () {
                                    if (self.getExpert) {
                                        self.videoExpert = self.getExpert;
                                    }
                                });
                            } else {
                                self.videoExpert = null;
                            }
                        } else {
                            self.$swal({
                                title: 'Video not found or not available for unauthenticated users!',
                                text: '',
                                type: 'error',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {
                                    self.$router.push('/');
                                }
                            });
                        }
                    }
                }
            });
        } else {
            self.$router.push('/');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'getWorkVideo', 'getLifeVideos', 'getMoneyVideo', 'getMindbodyVideo', 'getCommunityVideo', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert', 'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getAllUnauthVideos', 'getCorporateGiftingCode', 'getAuthWorkVideos', 'getAuthLifeVideos', 'getAuthMindbodyVideos', 'getAuthMoneyVideos', 'getCorporateClient', 'getCorporateClientId', 'getAllSiteContents', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor', 'getCorporateGiftInfo'])),
    updated: function updated() {
        this.showComponent = true;
    }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);





/* harmony default export */ __webpack_exports__["default"] = ({
    spinner: false,
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'checkbox': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        'button-group': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        alert: alert
    },
    name: 'profile',
    data: function data() {
        return {
            interestIndexes: [],
            userInterests: [],
            spinner: false,
            tabs: {
                videos: true,
                chat: false,
                discussion: false
            }
        };
    },
    methods: {
        switchTab: function switchTab(id) {
            for (var tab in this.tabs) {
                this.tabs[tab] = id === tab;
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        getInterestStatus: function getInterestStatus(interest) {
            if (this.getUserInterests) {
                var selectedInterestId = void 0;
                console.log(selectedInterestId);
                var exists = this.getUserInterests.filter(function (selectedInterestId) {
                    return selectedInterestId.interestId === interest.interestId;
                });
                if (exists && exists.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/watch/' + videoCode);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getAuthCareerVideos', 'user', 'error'])),
    mounted: function mounted() {
        this.$store.dispatch('GETAUTHVIDEOS', 'CAREER').then(function () {});
    }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RulesComp_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RulesComp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__RulesComp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers_js__ = __webpack_require__(15);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'player',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_3__JwPlayList_vue___default.a,
        rulescomp: __WEBPACK_IMPORTED_MODULE_1__RulesComp_vue___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            toggleSpinner: false,
            showRulesComp: true,
            activeTab: 0,
            currentVideo: '',
            currentStatus: '',
            currentVideoCode: '',
            recommendationList: '',
            videoCompleted: false,
            videoSqueeze: false,
            hideLeftVideoIcons: false,
            addRightHoverWidthClass: false,
            addIconHoverWidthClass: false,
            showRateHoverBox: false,
            showShareHoverBox: false,
            showEnjoyHoverBox: false,
            addRightHoverEnjoyClass: false,
            addEnjoyHoverClass: false,
            captionTrack: '',
            viewTranscript: false,
            ratingOne: false,
            ratingTwo: false,
            ratingThree: false,
            ratingFour: false,
            hideAll: false,
            videoMessage: '',
            videoMessageIndex: Math.floor(Math.random() * 7),
            videoGif: '',
            videoGifIndex: Math.floor(Math.random() * 4),
            videoURL: window.location.href,
            videoNotFoundFlag: false,
            videoTag: '',
            videoList: '',
            categoryVideoList: '',
            videoExpert: '',
            mainLiveEvent: null,
            allLiveEvents: null,
            allTalkEvents: null,
            eventURL: 'https://www1.dev-tonenetworks.com',
            sharingImage: '',
            sharingTitle: '',
            sharingDescription: '',
            toneLiveHeading: 'COMING UP AT TONE',
            toneTalkHeading: 'TONE TALKS',
            toneTalkDesc: 'Join us for our twice monthly livestream coaching events to learn from our experts, executive coaches and one another.',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_sitename: '',
            metaTag_pageTitle: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: ''
        };
    },
    methods: {
        calendarLogging: function calendarLogging(event, title) {
            var self = this;
            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);
            userPayload.push(self.$route.fullPath);
            userPayload.push('ADD_TO_CALENDAR');
            userPayload.push(title);
            self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload);
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        redeemCode: function redeemCode() {
            var self = this;
            if (self.getCorporateClient.invitationCode === '2') {
                self.$router.push('/corporation/referral/buy/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
            } else {
                self.$router.push('/corporationgifting/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
            }
        },
        createCarousal: function createCarousal() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_4_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        },
        getPacificTime: function getPacificTime(time) {
            var hours = time.getHours() - 3;
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'p.m.' : 'a.m.';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = minutes > 0 ? hours + ':' + minutes + ' ' + ampm : hours + ' ' + ampm;
            return strTime;
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var pHours = this.getPacificTime(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET' + ' / ' + pHours + ' PT';
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET' + ' / ' + pHours + ' PT';
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET' + ' / ' + pHours + ' PT';
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(eventId) {
            this.$router.push('/newevents/' + eventId);
            location.reload();
        },
        redirectToHome: function redirectToHome() {
            this.$router.push('/');
        },
        getMinutesBetweenDates: function getMinutesBetweenDates(startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime();
            return diff / 60000;
        },
        isEventToday: function isEventToday(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var eventDate = new Date(evtDate);
            var eventEndDate = new Date(endDate);
            var currentDate = this.returnEasternTime();
            var switchTime = parseInt(defaultSwitchTime);
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }
            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        returnEasternTime: function returnEasternTime() {
            var offset = -5;
            if (__WEBPACK_IMPORTED_MODULE_8__helpers_dateHelpers_js__["a" /* dateHelpers */].dstEnabled(new Date())) {
                offset = -4.0;
            }
            var clientDate = new Date();
            var utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
            var serverDate = new Date(utc + 3600000 * offset);
            return serverDate;
        },
        timeLeftInEvent: function timeLeftInEvent(evtDate) {
            var eventDate = new Date(evtDate);
            var currentDate = this.returnEasternTime();
            return this.getMinutesBetweenDates(currentDate, eventDate);
        },
        showJoin: function showJoin(bEvent) {
            if (this.isEventToday(bEvent.start_date, bEvent.end_date, bEvent.eventSwitchTime, this.getEventSwitchTime)) {
                return true;
            }
            return false;
        },
        joinEvent: function joinEvent(event) {
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', '/event/' + event.eventId);
            } else {
                sessionStorage.setItem('redirectPath', '/event/' + event.eventId);
            }
            __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        triggerLogin: function triggerLogin() {
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', '/events');
            } else {
                sessionStorage.setItem('redirectPath', '/events');
            }
            __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        calculateTimeToStartEvent: function calculateTimeToStartEvent(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var self = this;
            var eventDate = new Date(evtDate);

            var currentDate = this.returnEasternTime();
            var switchTime = parseInt(defaultSwitchTime);
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime) {} else {
                    var timeToStart = this.getMinutesBetweenDates(currentDate, eventDate) - switchTime;
                    if (timeToStart > 0 && timeToStart <= 90) {
                        var timeToTrigger = parseInt(timeToStart * 60 * 1000);
                        setTimeout(function () {
                            self.toggleSpinner = true;
                            self.showRulesComp = false;
                            setTimeout(function () {
                                self.showRulesComp = true;
                                self.toggleSpinner = false;
                            }, 1500);
                        }, timeToTrigger + 60);
                    }
                }
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            window.addeventatc.refresh();
        }, 1500);
        this.$store.dispatch('GETDYNAMICCONTENTS', 19).then(function () {
            if (_this.getAllSiteContents) {
                _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');
                _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');
                _this.toneLiveHeading = _this.setDynamicSection(_this.getAllSiteContents, 'COMING_UP_TONE_HEADING');
                _this.toneTalkHeading = _this.setDynamicSection(_this.getAllSiteContents, 'TONE_TALKS_HEADING');
                _this.toneTalkDesc = _this.setDynamicSection(_this.getAllSiteContents, 'TONE_TALK_DESC');

                _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
            }
        });
        var eventIdParam = this.$route.params.eventId;
        var self = this;
        if (!self.user) {
            self.$store.dispatch('GETEVENTLIST').then(function () {
                if (_this.getEventList) {
                    var liveEvents = _this.getEventList.filter(function (x) {
                        return x.type === '1';
                    });
                    var talkEvents = _this.getEventList.filter(function (x) {
                        return x.type === '2';
                    });
                    if (liveEvents && liveEvents.length > 0) {
                        liveEvents = liveEvents.slice(0, 3);
                        if (eventIdParam) {
                            var mainEvent = liveEvents.filter(function (x) {
                                return x.eventId.toString() === eventIdParam.toString();
                            });
                            if (mainEvent && mainEvent.length > 0) {
                                self.mainLiveEvent = mainEvent[0];
                                self.calculateTimeToStartEvent(self.mainLiveEvent.start_date, self.mainLiveEvent.end_date, self.mainLiveEvent.eventSwitchTime, self.getEventSwitchTime);
                                self.allLiveEvents = liveEvents.filter(function (x) {
                                    return x.eventId !== self.mainLiveEvent.eventId;
                                });
                            } else {
                                self.mainLiveEvent = liveEvents[0];
                                self.allLiveEvents = liveEvents.slice(1, 3);
                            }
                        } else {
                            self.mainLiveEvent = liveEvents[0];
                            self.calculateTimeToStartEvent(self.mainLiveEvent.start_date, self.mainLiveEvent.end_date, self.mainLiveEvent.eventSwitchTime, self.getEventSwitchTime);
                            self.allLiveEvents = liveEvents.slice(1, 3);
                        }
                    } else {
                        self.mainLiveEvent = null;
                        self.allLiveEvents = null;
                    }

                    self.allTalkEvents = talkEvents;
                    setTimeout(function () {
                        self.createCarousal();
                    }, 2000);

                    console.log('main event object', self.mainLiveEvent);
                }
            });
        } else {
            self.$router.push('/events');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'getEventList', 'user', 'getWorkVideo', 'getLifeVideos', 'getTalkEvents', 'getLiveEvents', 'getMoneyVideo', 'getMindbodyVideo', 'getCommunityVideo', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert', 'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getAllUnauthVideos', 'getAuthWorkVideos', 'getAuthLifeVideos', 'getAuthMindbodyVideos', 'getAuthMoneyVideos', 'getTalkEvents', 'getCorporateGiftingCode', 'getCorporateClient', 'getCorporateClientId', 'getEventSwitchTime', 'getAllSiteContents', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor', 'getCorporateGiftInfo']))
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'plans'
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayListTemp_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayListTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayListTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuedraggable__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'player',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        draggable: __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayListTemp_vue___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: 'TONE Playlist | ' + self.currentVideo.title,
            meta: [{ property: 'og:image', content: self.currentVideo.img }, { property: 'og:title', content: self.currentVideo.title + ' | TONE Networks' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: self.currentVideo.Description
            }, { property: 'twitter:title', content: self.currentVideo.title + ' | TONE Networks' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.currentVideo.img }, {
                property: 'twitter:description',
                content: self.currentVideo.Description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            hoverState: false,
            hoverStateTranscript: false,
            activeTab: 0,
            currentVideo: '',
            currentStatus: '',
            currentVideoCode: this.$route.params.videoCode,
            recommendationList: '',
            videoCompleted: false,
            videoSqueeze: false,
            hideLeftVideoIcons: false,
            addRightHoverWidthClass: false,
            addIconHoverWidthClass: false,
            showRateHoverBox: false,
            showShareHoverBox: false,
            showEnjoyHoverBox: false,
            addRightHoverEnjoyClass: false,
            addEnjoyHoverClass: false,
            captionTrack: '',
            viewTranscript: false,
            ratingOne: false,
            ratingTwo: false,
            ratingThree: false,
            ratingFour: false,
            hideAll: false,
            videoMessage: '',
            videoMessageIndex: Math.floor(Math.random() * 7),
            videoGif: '',
            videoGifIndex: Math.floor(Math.random() * 4),
            videoURL: window.location.href,
            playlistVideos: null,
            videoIndex: 0,
            showPlaylist: false,
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            isMobileOrDesktop: false,
            showMenuOptions: false,
            playlistId: 0,
            playlistVideoCode: '',
            videoLogged: false
        };
    },
    beforeDestroy: function beforeDestroy() {
        var self = this;
        if (!self.videoLogged) {
            var watchedDuration = self.getCurrentVideoDurationWatched.duration;
            if (watchedDuration >= self.getCurrentVideo[0].duration) {
                self.updateUserPlaylistVideoView(true);
            } else {
                self.updateUserPlaylistVideoView(false);
            }
        }
    },

    methods: {
        videoChangedInPlaylist: function videoChangedInPlaylist() {
            console.log('1. -------------------------> videoChangedInPlaylist():');
        },
        updateHoverState: function updateHoverState(isHover) {
            this.hoverState = isHover;
        },
        updateHoverStateTranscript: function updateHoverStateTranscript(isHover) {
            this.hoverStateTranscript = isHover;
        },
        updateUserPlaylistVideoView: function updateUserPlaylistVideoView(isFull) {
            var self = this;
            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (isFull) {
                self.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, self.getCurrentVideo[0].duration, 'F');
            } else {
                if (self.getCurrentVideoDurationWatched) {
                    watchedDuration = self.getCurrentVideoDurationWatched.duration;
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(self.getCurrentVideo[0].duration) * 100);
                if (watchedPercentage >= 5) {
                    self.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, watchedDuration, 'P');
                } else {
                    self.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, watchedDuration, 'N');
                }
            }
        },
        logPlaylistVideoStatus: function logPlaylistVideoStatus(playlistId, videoCode, duration, watched) {
            console.log('video code in logging', videoCode);
            var self = this;
            var payload = {
                videoCode: videoCode,
                userId: self.user.userId,
                playlistId: playlistId,
                playlistType: 1,
                playlistCode: null,
                watched: watched,
                rating: null,
                liked: null,
                durationWatched: duration && duration > 0 ? duration : 0,
                thumbnailURL: null,
                opinion: null
            };
            self.$store.dispatch('SET_PLAYLIST_VIDEOSTATUS', payload).then(function () {});
        },
        filterPlaylistOptions: function filterPlaylistOptions(playlistId) {
            var self = this;
            if (self.getUserPlaylists) {
                var filterPlaylist = self.getUserPlaylists.filter(function (x) {
                    return x.playlistId.toString() !== playlistId.toString();
                });
                if (filterPlaylist && filterPlaylist.length > 0) {
                    console.info('yes');
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        callDelete: function callDelete(video) {
            var _this = this;

            var self = this;
            self.selectedVideo = video.videoCode;
            self.selectedPlaylist = self.$route.params.playlistId.toString();
            if (video.videoCode === self.$route.params.videoCode) {
                var payload = {};
                payload.videoCode = video.videoCode;
                payload.userPlaylistId = self.$route.params.playlistId.toString();
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + video.videoCode + ' + ul').toggleClass('hide');
                    if (self.getUserPlaylists) {
                        var findPlaylist = self.getUserPlaylists.filter(function (x) {
                            return x.playlistId.toString() === self.$route.params.playlistId.toString();
                        });
                        if (findPlaylist && findPlaylist.length > 0) {
                            if (findPlaylist[0].userPlaylistVideos) {
                                self.playlistVideos = findPlaylist[0];
                                if (findPlaylist[0].userPlaylistVideos) {
                                    var userPlaylistVideos = findPlaylist[0].userPlaylistVideos;
                                    var findNextVideo = userPlaylistVideos.filter(function (x) {
                                        return x.videoCode !== self.$route.params.videoCode;
                                    });
                                    if (findNextVideo && findNextVideo.length > 0) {
                                        self.playVideo(self.$route.params.playlistId.toString(), findNextVideo[0].videoCode);
                                    } else {
                                        self.$router.push('/');
                                    }
                                } else {
                                    self.$router.push('/');
                                }
                            } else {
                                self.$router.push('/');
                            }
                        } else {
                            self.$router.push('/');
                        }
                    } else {
                        self.$router.push('/');
                    }
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.videoCode;
                _payload.userPlaylistId = self.$route.params.playlistId.toString();
                _payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: _payload }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + video.videoCode + ' + ul').toggleClass('hide');
                    if (self.getUserPlaylists) {
                        var findPlaylist = self.getUserPlaylists.filter(function (x) {
                            return x.playlistId.toString() === self.$route.params.playlistId.toString();
                        });
                        if (findPlaylist && findPlaylist.length > 0) {
                            if (findPlaylist[0].userPlaylistVideos) {
                                var findVideo = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                                    return x.videoCode.toString() === self.$route.params.videoCode.toString();
                                });
                                if (findVideo && findVideo.length > 0) {
                                    self.playlistVideos = findPlaylist[0];
                                    self.videoIndex = _this.getVideoIndex(findPlaylist[0].userPlaylistVideos, self.$route.params.videoCode);
                                }
                            } else {
                                self.$router.push('/');
                            }
                        } else {
                            self.$router.push('/');
                        }
                    } else {
                        self.$router.push('/');
                    }
                });
            }
        },
        listUpdated: function listUpdated(event) {
            var self = this;
            var newIndex = this.getVideoIndex(this.playlistVideos.userPlaylistVideos, self.$route.params.videoCode);
            self.videoIndex = newIndex;
            var data = self.playlistVideos.userPlaylistVideos;
            var videoCodeList = data.map(function (obj) {
                return obj.videoCode;
            });
            var playlistLoad = {};
            playlistLoad.userPlaylistId = self.$route.params.playlistId.toString();
            playlistLoad.dispOrderVideoCodes = videoCodeList;
            playlistLoad.userId = self.user.userId;
            self.$store.dispatch('SORTPLAYLISTVIDEOS', { playlist: playlistLoad }).then(function () {});
        },
        getVideoIndex: function getVideoIndex(videoArray, videoCode) {
            var index;
            for (var i = 0; i < videoArray.length; ++i) {
                if (videoArray[i].videoCode === videoCode) {
                    index = i;
                    break;
                }
            }
            return index + 1;
        },
        toggleViewTranscript: function toggleViewTranscript() {
            this.viewTranscript = !this.viewTranscript;
        },
        redirectToRelatedVideos: function redirectToRelatedVideos() {
            this.$router.push('/relatedvideos');
        },
        getNextVideo: function getNextVideo(index) {
            if (index >= 0 && index < this.playlistVideos.userPlaylistVideos.length - 1) {
                return this.playlistVideos.userPlaylistVideos[index + 1];
            } else {
                return null;
            }
        },
        playVideo: function playVideo(playlistId, videoCode) {
            this.updateUserPlaylistVideoView(false);
            this.$router.push('/playlist/' + playlistId + '/play/' + videoCode);
            setTimeout(function () {
                location.reload();
            }, 500);
        },
        onVideoComplete: function onVideoComplete() {
            var self = this;
            self.updateUserPlaylistVideoView(true);
            self.videoLogged = true;
            var nextVideoReference = self.getNextVideo(this.videoIndex - 1);
            if (nextVideoReference) {
                self.$router.push('/playlist/' + this.$route.params.playlistId + '/play/' + nextVideoReference.videoCode);
                setTimeout(function () {
                    location.reload();
                }, 500);
            } else {
                this.$router.push('/profile/myprogress');
            }
        },
        setUserLike: function setUserLike() {
            var _this2 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / this.getCurrentVideo[0].duration * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            if (this.currentStatus.liked === '1') {
                this.currentStatus.liked = '0';
            } else {
                this.currentStatus.liked = '1';
            }
            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this2.currentStatus = _this2.getCurrentStatus;
            });
        },
        setOpinion: function setOpinion(desc) {
            var _this3 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            var opinion = '0';
            if (desc === 'travel') {
                opinion = '1';
            } else if (desc === 'dating') {
                opinion = '2';
            } else if (desc === 'news') {
                opinion = '3';
            } else if (desc === 'recipes') {
                opinion = '4';
            } else {
                opinion = '0';
            }

            if (this.currentStatus.opinion === opinion) {
                this.currentStatus.opinion = '0';
            } else {
                this.currentStatus.opinion = opinion;
            }
            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this3.currentStatus = _this3.getCurrentStatus;
            });
        },
        setRating: function setRating(rating) {
            var _this4 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            if (this.currentStatus.rating === rating) {
                this.currentStatus.rating = '0';
            } else {
                this.currentStatus.rating = rating;
            }

            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this4.currentStatus = _this4.getCurrentStatus;
            });
        },
        logVideoEntry: function logVideoEntry() {
            var logWatchedEntry = {
                videoCode: this.$route.params.videoCode,
                userId: this.user.userId,
                playlistId: null,
                playlistCode: null,
                watched: 'N',
                rating: null,
                liked: '0',
                durationWatched: 0,
                thumbnailURL: null,
                opinion: null
            };
            this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {});
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/watch/' + videoCode);
            location.reload();
        },
        applyRatingClass: function applyRatingClass(rating) {
            if (rating === this.currentStatus.rating) {
                return true;
            } else {
                return false;
            }
        },
        setCarousal: function setCarousal() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.each(function () {
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        toggleVideoCompleted: function toggleVideoCompleted() {
            var self = this;
            self.videoCompleted = true;
            setTimeout(function () {
                self.videoSqueeze = true;
            }, 200);
        },
        replayVideo: function replayVideo() {
            var videoCode = this.$route.params.videoCode;
            this.videoCompleted = false;
            this.videoSqueeze = false;
            this.$router.push('/watch/' + videoCode);
            this.setVideoPlayerObject(videoCode);
        },
        changeHeight: function changeHeight() {
            this.hideLeftVideoIcons = true;
            this.showRateHoverBox = true;
            this.addRightHoverWidthClass = true;
            this.addIconHoverWidthClass = true;
            this.showShareHoverBox = false;
            this.showEnjoyHoverBox = false;
        },
        showSharing: function showSharing() {
            this.hideLeftVideoIcons = true;
            this.showShareHoverBox = true;
            this.addRightHoverWidthClass = true;
            this.addIconHoverWidthClass = true;
            this.showRateHoverBox = false;
            this.showEnjoyHoverBox = false;
        },
        redirectToHome: function redirectToHome() {
            this.$router.push('/');
        },
        showEnjoy: function showEnjoy() {
            this.showEnjoyHoverBox = true;
            this.hideLeftVideoIcons = true;
            this.addRightHoverEnjoyClass = true;
            this.addIconHoverWidthClass = true;
            this.addEnjoyHoverClass = true;
            this.showRateHoverBox = false;
            this.showShareHoverBox = false;
        },
        resetClass: function resetClass(bool) {
            if (bool) {
                this.hideLeftVideoIcons = false;
                this.addRightHoverWidthClass = false;
                this.addRightHoverEnjoyClass = false;
                this.addIconHoverWidthClass = false;
                this.showRateHoverBox = false;
                this.showShareHoverBox = false;
                this.showEnjoyHoverBox = false;
                this.addEnjoyHoverClass = false;
            } else {}
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.videoCode;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.videoCode;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload2 = {};
                _payload2.videoCode = video.videoCode;
                _payload2.userId = this.user.userId;
                _payload2.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload2 }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.videoCode;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this5 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this5.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            console.log(videoCode);
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            console.log(videoCode);
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        playVideoInPlylist: function playVideoInPlylist(videoObjectToPlay) {
            var self = this;
            var videoIndex = self.getUserNewPlaylistObject.indexOf(videoObjectToPlay);
            console.log('playVideoInPlylist : actual video index', videoIndex);
            if (videoIndex > -1) {
                self.videoIndex = videoIndex + 1;
                console.log('playVideoInPlylist : video index of next video', videoIndex + 1);
                self.currentVideo = videoObjectToPlay;
                window.jwplayer().playlistItem(videoIndex);
            }
        }
    },
    watch: {
        'getItemChangeInPlaylist': function getItemChangeInPlaylist(to, from) {
            var self = this;
            if (self.getItemChangeInPlaylist) {
                self.videoIndex = self.getItemChangeInPlaylist.index + 1;
                self.currentVideo = self.getItemChangeInPlaylist.item;
            }

            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);

            console.log('getItemChangeInPlaylist : user activity', userPayload);
            this.$store.dispatch('LOGUSERACTIVITY', userPayload);

            console.log('getItemChangeInPlaylist : self.playlistId = ', self.playlistId);
            console.log('getItemChangeInPlaylist : self.currentVideo.videoCode = ', self.currentVideo.videoCode);
            console.log('getItemChangeInPlaylist : self.currentVideo.title = ', self.currentVideo.title);
            console.log('getItemChangeInPlaylist : self.currentVideo = ', self.currentVideo);

            self.$store.dispatch('GETEXPERT', self.currentVideo.expertid).then(function () {});
        }
    },
    mounted: function mounted() {
        var _this6 = this;

        var self = this;
        if (self.getTrialDays < 0) {
            self.$router.push('/becomemember');
        }

        var userPayload = [];
        var uId = 0;
        if (self.user) {
            uId = self.user.userId;
        }
        userPayload.push(uId);
        userPayload.push(self.$route.fullPath);
        this.$store.dispatch('LOGUSERACTIVITY', userPayload);
        if (__WEBPACK_IMPORTED_MODULE_5_jquery___default()(window).width() > 739) {
            self.showPlaylist = true;
        } else {
            self.showPlaylist = false;
        }
        self.playlistVideoCode = this.$route.params.videoCode;
        self.playlistId = this.$route.params.playlistId;
        this.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, 0, 'N');
        if (this.$route.params.playlistId && this.$route.params.videoCode) {
            self.$store.dispatch('GETUSERPLAYLISTS', self.user.userId).then(function () {
                if (self.getUserPlaylists) {
                    var findPlaylist = self.getUserPlaylists.filter(function (x) {
                        return x.playlistId.toString() === self.$route.params.playlistId.toString();
                    });
                    if (findPlaylist && findPlaylist.length > 0) {
                        if (findPlaylist[0].userPlaylistVideos) {
                            var findVideo = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                                return x.videoCode.toString() === self.$route.params.videoCode.toString();
                            });
                            if (findVideo && findVideo.length > 0) {
                                self.playlistVideos = findPlaylist[0];
                                self.videoIndex = _this6.getVideoIndex(findPlaylist[0].userPlaylistVideos, self.$route.params.videoCode);

                                self.$store.dispatch('GETCURRENTVIDEO', self.$route.params.videoCode).then(function () {
                                    var video = _this6.getCurrentVideo;
                                    self.currentVideo = {
                                        video: video[0].sources[video[0].sources.length - 1].file,
                                        title: video[0].title,
                                        img: video[0].image,
                                        playerID: new Date(),
                                        tracks: video[0].tracks,
                                        Description: video[0].description,
                                        mediaId: video[0].mediaid
                                    };
                                    self.$store.dispatch('GETEXPERT', video[0].expertid).then(function () {});
                                });

                                self.$store.dispatch('GETVIDEOTRANSCRIPT', self.$route.params.videoCode).then(function () {});

                                self.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', self.user.userId).then(function () {
                                    var filteredList = _this6.getAuthRecommendedVideos.filter(function (code) {
                                        return code.mediaid !== _this6.currentVideoCode;
                                    });
                                    _this6.recommendationList = filteredList;
                                    setTimeout(function () {
                                        _this6.setCarousal();
                                    }, 2000);
                                });
                                self.$store.dispatch('LOAD_NEW_PLAYER_USER_PLAYLISTS', self.$route.params.playlistId).then(function () {
                                    if (self.getUserNewPlaylistObject) {
                                        self.currentVideoCode = self.getUserNewPlaylistObject[0];
                                    }
                                });
                            } else {
                                self.$router.push('/');
                            }
                        } else {
                            self.$router.push('/');
                        }
                    } else {
                        self.$router.push('/');
                    }
                } else {
                    self.$router.push('/');
                }
            });
        } else {
            self.$router.push('/');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert', 'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getUserPlaylists', 'getTrialDays', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getUserNewPlaylistObject', 'getItemChangeInPlaylist']), {
        styleObject: function styleObject() {
            if (this.hoverState) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor,
                    borderColor: this.getCorpButtonColor
                };
            } else {
                return {
                    color: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            }
        },
        styleObjectTranscript: function styleObjectTranscript() {
            if (this.hoverStateTranscript && this.viewTranscript) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor + ' !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                };
            } else {
                return {
                    border: '2px solid' + this.getCorpButtonColor + ' !important',
                    color: this.getCorpButtonColor
                };
            }
        }
    })
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_0_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_0_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_0_vue_strap__["alert"],
        'jwplayer': __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a
    },
    name: 'login',
    metaInfo: function metaInfo() {
        return {
            title: 'Podcast'
        };
    },

    data: function data() {
        return {
            success: false,
            successMsg: '',
            giftPlans: '',
            spinner: false,
            videoURL: window.location.href,
            currentPlayerID: '',
            currentPlayerID2: '',
            sharingTitle: 'TONE Networks, Set the Tone of Your Life',
            sharingDescription: '',
            dynamic_para_1: '',
            dynamic_para_2: '',
            dynamic_para_3: '',
            dynamic_para_4: '',
            dynamic_para_5: '',
            dynamic_para_6: '',
            dynamic_para_7: '',
            dynamic_bullet_1: '',
            dynamic_bullet_2: '',
            dynamic_bullet_3: '',
            dynamic_button_1: '',
            dynamic_promotion_img: ''
        };
    }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);








/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"]
    },
    name: 'login',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Press Releases',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Press Releases' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Press Releases' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            success: false,
            successMsg: '',
            pressSection: null,
            newsSection: null,
            subscriptionForm: {
                userId: null,
                email: '',
                name: '',
                comments: 'Newsletter Subscription (PRESS)',
                rating: 0,
                newsLetterEmail: '1',
                promotionalEmail: '0',
                representativeCall: '0'
            },
            spinner: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'getPressReleaseData', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'])),
    methods: {
        onSubmitEmail: function onSubmitEmail() {
            var _this = this;

            var self = this;
            this.subscriptionForm.comments = 'Newsletter Subscription';
            this.subscriptionForm.newsLetterEmail = '1';
            var displayMsg = 'Successfully subscribed to newsletter';
            this.subscriptionForm.email = this.subscriptionForm.email.toLowerCase();
            if (self.verifyEmail(this.subscriptionForm.email)) {
                this.$store.dispatch('SENDFEEDBACKFORM', this.subscriptionForm).then(function () {
                    window.logEvents('Newsletter Subscription (Press)', 'Subscribed', 'Press Subscription Email: ' + _this.subscriptionForm.email);

                    self.$swal({
                        title: displayMsg,
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    setTimeout(function () {
                        _this.success = false;
                        _this.subscriptionForm.email = '';
                        _this.subscriptionForm.promotionalEmail = '0';
                        _this.subscriptionForm.userId = null;
                        _this.subscriptionForm.email = '';
                        _this.subscriptionForm.name = '';
                        _this.subscriptionForm.comments = 'Newsletter Subscription (PRESS)';
                        _this.subscriptionForm.rating = 0;
                        _this.subscriptionForm.newsLetterEmail = '1';
                        _this.subscriptionForm.promotionalEmail = '0';
                        _this.subscriptionForm.representativeCall = '0';
                    }, 2000);
                });
            }
        },
        verifyEmail: function verifyEmail(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this2 = this;

            if (this.contactForm.emailAddress && this.contactForm.phoneNumber) {
                this.spinnerToggle();
                this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(function () {
                    _this2.success = true;
                    _this2.successMsg = 'Your message has been sent, we will get back to you shortly!';
                    _this2.spinnerToggle();
                });
            }
        },
        setCarousal: function setCarousal() {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$el).find('.responsive-slick-imagelist');
            $slick.each(function () {
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        var self = this;
        self.$store.dispatch('GETPRESSRELEASES').then(function () {
            if (self.getPressReleaseData) {
                var pressReleases = _this3.getPressReleaseData.filter(function (x) {
                    return x.contentOrder === 2;
                });
                self.pressSection = pressReleases;
                var newsReleases = _this3.getPressReleaseData.filter(function (x) {
                    return x.contentOrder === 3;
                });
                self.newsSection = newsReleases;
            }
        });
        this.setCarousal();
    }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"]
    },
    name: 'login',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Privacy Policy',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Privacy Policy' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Privacy Policy' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            success: false,
            successMsg: '',
            contactForm: {
                emailAddress: '',
                phoneNumber: '',
                reason: '',
                comments: ''
            },
            spinner: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'user', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'])),
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this = this;

            if (this.contactForm.emailAddress && this.contactForm.phoneNumber) {
                this.spinnerToggle();
                this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(function () {
                    _this.success = true;
                    _this.successMsg = 'Your message has been sent, we will get back to you shortly!';
                    _this.spinnerToggle();
                });
            }
        }
    }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_masked_input__ = __webpack_require__(30);










/* harmony default export */ __webpack_exports__["default"] = ({
    spinner: false,
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["input"],
        'checkbox': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["checkbox"],
        'button-group': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["buttonGroup"],
        'spinner': __WEBPACK_IMPORTED_MODULE_3_vue_strap__["spinner"],
        'masked-input': __WEBPACK_IMPORTED_MODULE_7_vue_masked_input__["a" /* default */],
        alert: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["alert"],
        datepicker: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["datepicker"],
        modal: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["modal"]
    },
    name: 'profile',
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle ? self.metaTag_pageTitle : 'TONE | Profile',
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            daysOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            selectedDays: [],
            hoverState: false,
            interestSelected: false,
            corpShareModalTitle: '',
            corpShareModalDesc: '',
            selectedCorps: [],
            allCorps: [],
            shareInProcess: false,
            shareOption: 'Corporate',
            showShareCommunity: false,
            showShareIndividual: false,
            showShareFriends: false,
            sharePlaylistType: '',
            taggedEmails: [],
            emailList: [],
            eventURL: 'https://www1.dev-tonenetworks.com',
            isPlaylistWatched: false,
            isSectionWatched: true,
            upcomingProfileEvent: null,
            expandPlaylistPanel: false,
            expandTakeawayPanel: false,
            expandEventsAttendedPanel: false,
            expandVideosWatchedPanel: false,
            sharedPlaylistId: 0,
            sharedPlaylistTitle: '',
            sharedEmailList: '',
            sharedEmailMessage: '',
            sharedPlaylistPreview: '',
            showSharedModal: false,
            isStripe: true,
            toggleStatus: false,
            isCharityUpdate: false,
            passwordError: '',
            updatedFirstName: '',
            updatedLastName: '',
            showUpdateNameBox: false,
            showUpdateMobileBox: false,
            phoneNumber: '',
            rawPhoneNumber: '',
            updatedDOB: '',
            showUpdateDOBBox: false,
            oldPassword: '',
            oldPasswordForEmail: '',
            newEmail: '',
            updatedPassword: '',
            confirmPassword: '',
            showUpdatePasswordBox: false,
            showUpdateEmailBox: false,
            showPaymentBox: false,
            showPaymentHistoryBox: false,
            interestIndexes: [],
            userInterests: [],
            spinner: false,
            success: false,
            sucessMsg: '',
            alert: false,
            stripe: '',
            clearButton: true,
            newPlaylistName: '',
            playlistHasVideo: false,
            card: '',
            isMobileSubscribe: false,
            isPushNotificationSubscribe: false,
            tabs: {
                videos: false,
                playlist: false,
                chat: false,
                coolFeatures: false,
                discussion: true
            },
            userPaymentsCol: [],
            userPayments: {
                token: '',
                stripeCardId: '',
                paymentType: 'CC',
                paymentDate: new Date(),
                paypalPayerId: '',
                paypalPaymentId: '',
                paymentMethodNonce: ''
            },
            sharePayload: {
                sharedPlaylistId: 0,
                sharedPlaylistTitle: '',
                sharedEmailList: '',
                sharedEmailMessage: '',
                sharedPlaylistPreview: ''
            },
            shareVideoPayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                recipientFriendEmails: null,
                playlistId: '',
                messageText: '',
                playlistType: 0
            },
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            failedEmail: '',
            showCorporateShare: false,
            previewMsg: 'Message Preview: \n',
            expiredTrialMessage: '',
            imageText: 'So many shoes to fill and only two feet! Step into our community by selecting your first pair of shoes. By the way, you can change your style as often as you like!',

            userPersonalPlaylists: null,
            userCuratedPlaylists: null,
            userCorpSharedPlaylists: null,
            userProgressPlaylists: null,
            userProgressEventsAttended: null,
            userProgressVideosWatched: null,
            userProgressTakeaways: null,
            personalPlaylistTitle: 'Your Playlists',
            trendingPlaylistTitle: 'Trending Playlists',
            corpPlaylistTitle: 'Women\'s LINC Playlists',
            progressHeading1: 'Look What YOU\'VE accomplished!',
            progressHeading2: 'Good for you!"',
            progressHeading3: 'Keep Investing in Yourself',
            progressEmptyTakeawayHdng1: '',
            progressEmptyTakeawayHdng2: '',
            progressEmptyTakeawayHdng3: '',
            progressEmptyTakeawayHdng4: '',
            metaTag_pageTitle: '',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: ''
        };
    },
    watch: {
        'sharePayload.sharedEmailMessage': function sharePayloadSharedEmailMessage(to, from) {
            var self = this;

            var oriiginalMessage = self.user.firstName + ' ' + self.user.lastName + ' shared a playlist with you on TONE Networks: \n' + self.sharePayload.sharedPlaylistTitle + ' \n';
            if (self.showSharedModal && self.sharePayload.sharedEmailMessage && self.sharePayload.sharedEmailMessage.length > 0) {
                self.sharePayload.sharedPlaylistPreview = '' + self.previewMsg + oriiginalMessage + self.sharePayload.sharedEmailMessage;
            } else {
                self.sharePayload.sharedPlaylistPreview = '' + self.previewMsg + self.user.firstName + ' ' + self.user.lastName + ' shared a playlist with you on TONE Networks: \n' + self.sharePayload.sharedPlaylistTitle + ' \n';
            }
        },
        '$route.params.feature': function $routeParamsFeature(to, from) {
            var _this = this;

            var self = this;
            if (this.$route.params.feature && this.$route.params.feature.toString().toLowerCase() === 'playlist') {
                this.switchTab('playlist');
                self.$store.dispatch('GETDYNAMICCONTENTS', 31).then(function () {
                    if (self.getAllSiteContents) {
                        _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                        _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                        _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                        _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                        _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                        _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                        _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                        _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                        _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                        _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
                    }
                });
            } else if (this.$route.params.feature && this.$route.params.feature.toString().toLowerCase() === 'myprogress') {
                this.switchTab('coolFeatures');
                self.$store.dispatch('GETDYNAMICCONTENTS', 32).then(function () {
                    if (self.getAllSiteContents) {
                        _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                        _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                        _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                        _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                        _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                        _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                        _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                        _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                        _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                        _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
                    }
                });
            } else if (this.$route.params.feature && this.$route.params.feature.toString().toLowerCase() === 'personalize') {
                this.switchTab('chat');
                self.$store.dispatch('GETDYNAMICCONTENTS', 33).then(function () {
                    if (self.getAllSiteContents) {
                        _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                        _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                        _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                        _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                        _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                        _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                        _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                        _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                        _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                        _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
                    }
                });
            } else if (this.$route.params.feature && this.$route.params.feature.toString().toLowerCase() === 'myfav') {
                this.switchTab('videos');
                self.$store.dispatch('GETDYNAMICCONTENTS', 33).then(function () {
                    if (self.getAllSiteContents) {
                        _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                        _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                        _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                        _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                        _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                        _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                        _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                        _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                        _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                        _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
                    }
                });
            } else {
                this.switchTab('discussion');
                self.$store.dispatch('GETDYNAMICCONTENTS', 15).then(function () {
                    if (self.getAllSiteContents) {
                        _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                        _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                        _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                        _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                        _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                        _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                        _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                        _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                        _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                        _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
                    }
                });
                this.$store.dispatch('DEFAULTIMAGESLIST').then(function () {
                    if (_this.getDefaultImages) {
                        setTimeout(function () {
                            _this.setCarousal();
                        }, 2000);
                    }
                });
            }
        },
        'toggleStatus': function toggleStatus(to, from) {
            var self = this;
            if (self.toggleStatus) {
                self.checkAllInterests();
            } else {
                self.interestIndexes = [];
            }
        },
        'isMobileSubscribe': function isMobileSubscribe(to, from) {
            var self = this;
            self.spinnerToggle();
            if (self.isMobileSubscribe) {
                self.user.isOptOutSMS = '1';
            } else {
                self.user.isOptOutSMS = '0';
            }
            this.$store.dispatch('UPDATEUSERPROFILE', self.user).then(function () {
                self.spinnerToggle();
            });
        },
        'showCorporateShare': function showCorporateShare(to, from) {
            var self = this;
            if (self.showCorporateShare) {
                self.selectedCorps = null;
                self.corporateShareMessage = '';
                self.taggedEmails = [];
            }
        },
        'shareOption': function shareOption(to, from) {
            var self = this;
            self.selectedCorps = null;
            self.corporateShareMessage = '';
            self.taggedEmails = [];
        },
        'isPushNotificationSubscribe': function isPushNotificationSubscribe(to, from) {
            var self = this;
            self.spinnerToggle();
            if (self.isPushNotificationSubscribe) {
                self.user.isOptOutPn = '1';
            } else {
                self.user.isOptOutPn = '0';
            }
            this.$store.dispatch('UPDATEUSERPROFILE', self.user).then(function () {
                self.spinnerToggle();
            });
        }
    },
    methods: {
        styleDays: function styleDays(interestId) {
            var isSelected = this.selectedDays.filter(function (x) {
                return x.toString() === interestId.toString();
            });
            if (isSelected && isSelected.length > 0) {
                return {
                    color: '#FFFFFF !important',
                    backgroundColor: this.getCorpButtonColor,
                    borderWidth: '1px !important',
                    borderStyle: 'solid !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                };
            } else {
                return {
                    color: this.getCorpButtonColor + ' !important',
                    borderWidth: '1px !important',
                    borderStyle: 'solid !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                };
            }
        },
        updateHoverState: function updateHoverState(isHover) {
            this.hoverState = isHover;
            console.log('final hover state', this.hoverState);
        },
        styleInterestObject: function styleInterestObject(interestId) {
            var isSelected = this.interestIndexes.filter(function (x) {
                return x.toString() === interestId.toString();
            });
            if (isSelected && isSelected.length > 0) {
                return {
                    color: '#FFFFFF !important',
                    backgroundColor: this.getCorpButtonColor,
                    borderWidth: '1px !important',
                    borderStyle: 'solid !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                };
            } else {
                return {
                    color: this.getCorpButtonColor + ' !important',
                    borderWidth: '1px !important',
                    borderStyle: 'solid !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                };
            }
        },
        shareCorporateVideo: function shareCorporateVideo() {
            var self = this;
            self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0;
            self.shareVideoPayload.senderUserId = self.user.userId;
            self.shareVideoPayload.recipientsUserIds = [];
            self.shareVideoPayload.recipientFriendEmails = [];
            self.shareVideoPayload.messageText = self.corporateShareMessage;
            if (self.shareOption === 'Corporate') {
                self.shareVideoPayload.recipientsUserIds = [];
                self.shareVideoPayload.recipientFriendEmails = null;
            } else if (self.shareOption === 'Individual') {
                self.shareVideoPayload.recipientFriendEmails = null;
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    var userIdArray = self.selectedCorps.map(function (x) {
                        return x.userId;
                    });
                    self.shareVideoPayload.recipientsUserIds = userIdArray;
                }
            } else if (self.shareOption === 'Friends') {
                self.shareVideoPayload.recipientsUserIds = [];
                var emailArray = self.taggedEmails.map(function (x) {
                    return x.name;
                });
                self.shareVideoPayload.recipientFriendEmails = emailArray.join(',');
            } else {}
            self.shareVideoPayload.playlistId = self.selectedPlaylist.playlistId;
            if (self.sharePlaylistType === 'personal') {
                self.shareVideoPayload.playlistType = 1;
            } else if (self.sharePlaylistType === 'corporate') {
                self.shareVideoPayload.playlistType = 3;
            } else if (self.sharePlaylistType === 'trending') {
                self.shareVideoPayload.playlistType = 2;
            }

            if (!self.shareInProcess) {
                self.$store.dispatch('PLAYLISTCORPORATESHARE', { payload: self.shareVideoPayload }).then(function () {
                    if (!self.error.show) {
                        self.spinnerToggle();
                        self.$swal({
                            title: 'Playlist has been shared!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });

                        self.cancelCorporateModal();
                    } else {
                        self.cancelCorporateModal();
                    }
                });
            }
            self.shareInProcess = true;
        },
        showSharingModal: function showSharingModal(playlist, type) {
            var self = this;
            if (self.user && self.user.corporation === null) {
                self.openModalShare(playlist.playlistId, playlist.title);
            } else {
                self.openCorporateShareModal(playlist, type);
            }
        },
        verifyEmailShare: function verifyEmailShare(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        addTag: function addTag(newTag) {
            var self = this;
            console.log('newTAg', newTag);
            var tag = {
                name: newTag
            };
            if (self.verifyEmailShare(newTag)) {
                self.emailList.push(tag);
                this.taggedEmails.push(tag);
                console.log('tagged emails', this.taggedEmails);
            } else {
                console.log('invalid email address, calling swal');
            }
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET';
            }
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        },
        playWatchedVideo: function playWatchedVideo(videoCode, videoTitle) {
            this.$router.push('/watch/' + videoCode + '/' + videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
        },
        returnProgressStyle: function returnProgressStyle(progress) {
            return 'width: ' + progress + '%;';
        },
        showPrivateVideoShareMsg: function showPrivateVideoShareMsg() {
            this.$swal({
                title: 'Cannot Share',
                text: 'This playlist contains videos which are private and cannot be shared',
                type: 'info',
                timer: 3000,
                showCancelButton: false,
                showConfirmButton: false
            }).then(function () {}, function (dismiss) {
                if (dismiss === 'timer') {}
            });
        },
        showDOBFlag: function showDOBFlag() {
            if (this.user) {
                if (this.user && this.user.corporation) {
                    if (this.user.corporation.dobFlag === 1) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        showMobFlag: function showMobFlag() {
            if (this.user) {
                if (this.user && this.user.corporation) {
                    if (this.user.corporation.phoneFlag === 1 || this.user.corporation.phoneFlag === 2) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        openModalShare: function openModalShare(playlistId, playlistTitle) {
            var self = this;
            if (self.getTrialDays < 0) {
                self.$router.push('/becomemember');
            } else {
                self.sharePayload.sharedPlaylistId = playlistId;
                self.sharePayload.sharedPlaylistTitle = playlistTitle;
                self.sharePayload.sharedPlaylistPreview = '' + self.previewMsg + self.user.firstName + ' ' + self.user.lastName + ' shared a playlist with you on TONE Networks: \n' + self.sharePayload.sharedPlaylistTitle + ' \n';
                self.showSharedModal = true;
            }
        },
        verifyEmailList: function verifyEmailList(emailList) {
            var removeWhiteSpace = emailList.filter(function (x) {
                return x.trim();
            });
            var updatedList = removeWhiteSpace.filter(function (x) {
                return x !== '' && x !== ' ' && x !== '  ';
            });
            var self = this;
            var re = /\S+@\S+\.\S+/;
            for (var i = 0; i < updatedList.length; i++) {
                if (updatedList[i] && updatedList[i] !== ' ' && !re.test(updatedList[i])) {
                    self.failedEmail = updatedList[i];
                    return false;
                }
            }
            self.failedEmail = '';
            self.sharePayload.sharedEmailList = updatedList.join(',');
            return true;
        },
        returnPermissionBasedOnType: function returnPermissionBasedOnType(type) {
            var self = this;
            var rights = 0;
            if (type === 'personal') {
                if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.sharePersonalPlaylistPermission >= 1) {
                    rights = self.user.corporation.corpSharingPermissions.sharePersonalPlaylistPermission;
                }
            } else if (type === 'corporate') {
                if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.corpPlaylistShareOptnPermission >= 1) {
                    rights = self.user.corporation.corpSharingPermissions.corpPlaylistShareOptnPermission;
                }
            } else if (type === 'trending') {
                if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareTrendingPlaylistPermission >= 1) {
                    rights = self.user.corporation.corpSharingPermissions.shareTrendingPlaylistPermission;
                }
            }
            return rights;
        },
        openCorporateShareModal: function openCorporateShareModal(playlistObj, type) {
            var self = this;
            self.sharePlaylistType = type;
            self.corpShareModalImage = playlistObj.userPlaylistVideos[0].thumbnailURL;
            self.corpShareModalDesc = playlistObj.description;
            self.corpShareModalTitle = playlistObj.title;
            self.selectedPlaylist = playlistObj;
            self.showCorporateShare = true;
            var rights = self.returnPermissionBasedOnType(type);
            if (rights === 1) {
                self.showShareCommunity = true;
                self.showShareIndividual = true;
                self.showShareFriends = true;
            } else if (rights === 2) {
                self.showShareCommunity = true;
                self.showShareIndividual = false;
                self.showShareFriends = false;
                self.shareOption = 'Corporate';
            } else if (rights === 3) {
                self.showShareCommunity = false;
                self.showShareFriends = false;
                self.showShareIndividual = true;
                self.shareOption = 'Individual';
            } else if (rights === 5) {
                self.showShareCommunity = false;
                self.showShareIndividual = false;
                self.showShareFriends = true;
                self.shareOption = 'Friends';
            } else {
                self.showShareCommunity = false;
                self.showShareIndividual = false;
                self.showShareFriends = false;
            }
        },
        maskEmailAddress: function maskEmailAddress(userEmail) {
            var avg = void 0,
                splitted = void 0,
                part1 = void 0,
                part2 = void 0;
            splitted = userEmail.split('@');
            part1 = splitted[0];
            var regex = /[^0-9.]/g;
            var maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1);
            console.log('maked', maskid);
            avg = part1.length / 2;
            part1 = part1.substring(0, part1.length - avg);
            part2 = splitted[1];
            var maskDomain = part2.split('.');
            return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1];
        },
        customLabel: function customLabel(option) {
            var findDuplicate = this.allCorps.find(function (x) {
                return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId;
            });

            if (findDuplicate) {
                var maskedEmail = this.maskEmailAddress(option.email);
                return option.firstName + ' ' + option.lastName + ' <' + maskedEmail + '>';
            } else {
                return option.firstName + ' ' + option.lastName;
            }
        },
        cancelCorporateModal: function cancelCorporateModal() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateShare = false;
                self.shareInProcess = false;
                self.sharePlaylistType = '';
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        onSharePlaylist: function onSharePlaylist() {
            var self = this;
            self.spinnerToggle();
            var emailArray = self.taggedEmails.map(function (x) {
                return x.name;
            });
            self.sharePayload.sharedPlaylistPreview = self.user.firstName + ' ' + self.user.lastName + ' shared a playlist with you on TONE Networks: \n' + self.sharePayload.sharedPlaylistTitle + '\n' + self.sharePayload.sharedEmailMessage;
            var sharePayload = {
                csvEmailRecepients: emailArray.join(','),
                userId: self.user.userId,
                playlistId: self.sharePayload.sharedPlaylistId,
                customizedMessage: self.sharePayload.sharedPlaylistPreview
            };
            self.$store.dispatch('EMAILSHAREPLAYLIST', { payload: sharePayload }).then(function () {
                if (!self.error.show) {
                    self.spinnerToggle();
                    self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(function () {
                        if (self.getTaggedEmailList) {
                            self.emailList = [];
                            self.emailList = self.getTaggedEmailList;
                            self.taggedEmails = [];
                            self.sharePayload.sharedPlaylistPreview = '';
                        }
                    });
                    self.$swal({
                        title: 'Email Sent!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    self.cancelModal();
                } else {
                    self.spinnerToggle();
                    self.cancelModal();
                }
            });
        },
        cancelModal: function cancelModal() {
            var self = this;
            var $ = __webpack_provided_window_dot_jQuery;
            self.sharePayload.sharedPlaylistId = 0;
            self.sharePayload.sharedPlaylistTitle = '';
            self.sharePayload.sharedEmailList = '';
            self.sharePayload.sharedEmailMessage = '';
            self.sharePayload.sharedPlaylistPreview = self.user.firstName + ' ' + self.user.lastName + ' shared a playlist with you on TONE Networks: \n' + self.sharePayload.sharedPlaylistTitle + ' \n';
            setTimeout(function () {
                self.showSharedModal = false;

                $('.modal-open').removeClass('modal-open');
            }, 500);
        },
        playProgressPlaylist: function playProgressPlaylist(playlistId, playlistType) {
            var playlistTitle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var videoCode = arguments[3];
            var videoTitle = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                if (playlistType.toString().toLowerCase() === 'corporation') {
                    this.$router.push('/playlist/' + playlistId + '/play/' + videoCode + '/' + this.user.corporation.corporationId + '/' + playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
                } else if (playlistType.toString().toLowerCase() === 'trending') {
                    this.$router.push('/playlist/trending/' + playlistId + '/play/' + videoCode + '/' + videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
                } else {
                    this.$router.push('/playlist/' + playlistId + '/play/' + videoCode);
                }
            }
        },
        playPlaylist: function playPlaylist(playlistId, videoCode) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/playlist/' + playlistId + '/play/' + videoCode);
            }
        },
        playTrendingPlaylist: function playTrendingPlaylist(playlistId, videoCode, videoTitle) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/playlist/trending/' + playlistId + '/play/' + videoCode + '/' + videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
            }
        },
        playCorpPlaylist: function playCorpPlaylist(playlistId, videoCode, playlistTitle) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/playlist/' + playlistId + '/play/' + videoCode + '/' + this.user.corporation.corporationId + '/' + playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
            }
        },
        removePlaylist: function removePlaylist(playlistId) {
            var self = this;
            if (self.getTrialDays < 0) {
                self.$router.push('/becomemember');
            } else {
                var removePayload = {
                    userId: self.user.userId,
                    playlistId: playlistId
                };
                self.$swal({
                    title: 'Remove',
                    text: 'Are you sure you want to remove this playlist?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, Please',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success',
                    cancelButtonClass: 'btn btn-danger',
                    buttonsStyling: false
                }).then(function (result) {
                    self.$store.dispatch('REMOVEPLAYLIST', { playlist: removePayload }).then(function () {
                        self.$swal({
                            title: 'Playlist has been removed',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                        console.log('called after removing');
                        self.$store.dispatch('GET_USER_PLAYLISTS_PROFILE', self.user.userId).then(function () {
                            if (self.getUserPlaylistsProfile) {
                                self.userPersonalPlaylists = null;
                                self.userPersonalPlaylists = self.getUserPlaylistsProfile.userPlaylists ? self.getUserPlaylistsProfile.userPlaylists : null;
                            }
                        });
                    });
                }, function (dismiss) {});
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this2 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this2.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        mountbraintree: function mountbraintree() {
            var self = this;
            if (self.getPaypalToken) {
                window.braintree.client.create({
                    authorization: 'production_6r7mxqgh_htw3nq9wp32w8h2x'
                }, function (clientErr, clientInstance) {
                    if (clientErr) {
                        console.error('Error creating client:', clientErr);
                        return;
                    }

                    window.braintree.paypalCheckout.create({
                        client: clientInstance
                    }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                        if (paypalCheckoutErr) {
                            console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
                            return;
                        }

                        window.paypal.Button.render({
                            env: 'production',
                            payment: function payment() {
                                return paypalCheckoutInstance.createPayment({
                                    flow: 'vault',
                                    amount: 5,
                                    currency: 'USD',
                                    intent: 'sale'
                                });
                            },
                            onAuthorize: function onAuthorize(data, actions) {
                                return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
                                    self.userPayments.paymentMethodNonce = payload.nonce;
                                    self.userPayments.paymentType = 'PayPal';
                                });
                            },
                            onCancel: function onCancel(data) {},
                            onError: function onError(err) {
                                console.error('checkout.js error', err);
                            }
                        }, '#paypal-button').then(function () {});
                    });
                });
            }
        },
        getRelatedImage: function getRelatedImage(image) {
            if (this.getDefaultImages) {
                var defImage = this.getDefaultImages.filter(function (img) {
                    return img.smallImgUrl === image;
                });
                return defImage[0].url;
            }
        },
        updateCharity: function updateCharity() {
            this.isCharityUpdate = false;
            sessionStorage.setItem('updatRedirect', true);
            this.$router.push('/giving');
        },
        checkAllInterests: function checkAllInterests() {
            this.interestIndexes = [];
            for (var i = 0, l = this.getAllInterests.length; i < l; i++) {
                this.interestIndexes.push(i);
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        showUpdateName: function showUpdateName() {
            this.showUpdateNameBox = !this.showUpdateNameBox;
        },
        showUpdateMobile: function showUpdateMobile() {
            this.showUpdateMobileBox = !this.showUpdateMobileBox;
        },
        showUpdateDOB: function showUpdateDOB() {
            this.showUpdateDOBBox = !this.showUpdateDOBBox;
        },
        showUpdatePassword: function showUpdatePassword() {
            this.showUpdatePasswordBox = !this.showUpdatePasswordBox;
        },
        showUpdateEmail: function showUpdateEmail() {
            this.showUpdateEmailBox = !this.showUpdateEmailBox;
        },
        showUpdatePayment: function showUpdatePayment() {
            this.showPaymentBox = !this.showPaymentBox;
            if (this.showPaymentBox) {
                if (this.user.stripeCustomerId) {
                    this.mountStripeElements();
                } else {
                    this.mountbraintree();
                }
                this.showPaymentHistoryBox = false;
            }
        },
        showPaymentHistory: function showPaymentHistory() {
            if (!this.showPaymentHistoryBox) {
                window.logEvents('Profile Page', 'click', 'Payment History Viewed');
            }
            this.showPaymentHistoryBox = !this.showPaymentHistoryBox;
        },

        switchTab: function switchTab(id) {
            var _this3 = this;

            console.log('id', id);
            for (var tab in this.tabs) {
                this.tabs[tab] = id === tab;
            }
            if (id === 'discussion') {
                this.$store.dispatch('DEFAULTIMAGESLIST').then(function () {
                    if (_this3.getDefaultImages) {
                        setTimeout(function () {
                            _this3.setCarousal();
                        }, 2000);
                    }
                });
            }
        },
        getInterestStatus: function getInterestStatus(interest) {
            if (this.getUserInterests) {
                var exists = this.getUserInterests.filter(function (selectedInterestId) {
                    return selectedInterestId.interestId === interest.interestId;
                });
                if (exists && exists.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/watch/' + videoCode);
            }
        },
        verifyPassword: function verifyPassword() {
            if (this.updatedPassword.length >= 6) {
                var re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/;
                if (!re.test(this.updatedPassword)) {
                    this.passwordError = 'Min 6 Chars, One Upper Case, One Lower Case!';
                    return false;
                }
                if (this.confirmPassword.length > 0) {
                    if (this.updatedPassword === this.confirmPassword) {
                        return true;
                    } else {
                        this.passwordError = 'Password do not match';
                        return false;
                    }
                } else {
                    return true;
                }
            } else {
                if (this.updatedPassword.length > 0) {
                    this.passwordError = 'Min 6 Chars, One Upper Case, One Lower Case!';
                    return false;
                } else {
                    return true;
                }
            }
        },
        verifyEmail: function verifyEmail(emailField) {
            if (emailField.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(emailField)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        setCarousal: function setCarousal() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_4_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$el).find('.responsive-slick-imagelist');
            $slick.each(function () {
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        updateInterests: function updateInterests() {
            var _this4 = this;

            if (this.selectedDays.length > 1) {
                this.spinnerToggle();
                var days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
                var daysSelected = [];
                this.selectedDays.forEach(function (index) {
                    daysSelected.push(days[index]);
                });
                var setDaysData = { userId: this.user.userId, days: daysSelected };
                for (var i = 0, l = this.interestIndexes.length; i < l; i++) {
                    var newUserInterest = {};
                    var selectedInterest = this.getAllInterests[this.interestIndexes[i]];

                    newUserInterest.interestId = selectedInterest.interestId;
                    newUserInterest.count = 5;
                    this.userInterests.push(newUserInterest);
                }
                this.user.interests = this.userInterests;
                this.$store.dispatch('SETDAYS', { data: setDaysData }).then(function () {});
                this.$store.dispatch('UPDATEINTERESTS', { loggedUser: this.user }).then(function () {
                    _this4.spinnerToggle();
                    _this4.$swal({
                        title: 'Your changes have been saved',
                        text: '',
                        type: 'success',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                });
            } else {
                this.$swal({
                    title: 'Please select at least two delivery days',
                    text: '',
                    type: 'error',
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(function () {}, function (dismiss) {
                    if (dismiss === 'timer') {}
                });
            }
        },
        onNameSubmit: function onNameSubmit() {
            var _this5 = this;

            this.spinnerToggle();
            this.user.firstName = this.updatedFirstName;
            this.user.lastName = this.updatedLastName;
            this.$store.dispatch('UPDATEUSERPROFILE', this.user).then(function () {
                _this5.spinnerToggle();
                _this5.showUpdateName();
            });
        },
        onMobileSubscriptionChanged: function onMobileSubscriptionChanged() {
            var _this6 = this;

            this.spinnerToggle();
            if (this.isMobileSubscribe) {
                this.user.isOptOutSMS = '1';
            } else {
                this.user.isOptOutSMS = '0';
            }
            this.$store.dispatch('UPDATEUSERPROFILE', this.user).then(function () {
                _this6.spinnerToggle();
            });
        },
        onMobileNotificationChanged: function onMobileNotificationChanged() {
            var _this7 = this;

            this.spinnerToggle();
            if (this.isPushNotificationSubscribe) {
                this.user.isOptOutPn = '1';
            } else {
                this.user.isOptOutPn = '0';
            }
            this.$store.dispatch('UPDATEUSERPROFILE', this.user).then(function () {
                _this7.spinnerToggle();
            });
        },
        onMobileSubmit: function onMobileSubmit() {
            var _this8 = this;

            this.spinnerToggle();
            if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                this.user.phoneNumber = this.phoneNumber;
                this.$store.dispatch('UPDATEUSERPROFILE', this.user).then(function () {
                    _this8.spinnerToggle();
                    _this8.showUpdateMobile();
                });
            }
        },
        setDefaultImage: function setDefaultImage(defaultImage) {
            window.logEvents('Profile Page', 'click', 'Default picture changed to: ' + defaultImage.title);
            this.spinnerToggle();
            this.user.picture = defaultImage.smallImgUrl;
            this.$store.dispatch('UPDATEUSERPROFILE', this.user).then(function () {});
        },
        onDOBSubmit: function onDOBSubmit() {
            var _this9 = this;

            this.spinnerToggle();
            this.user.dob = this.updatedDOB;
            this.$store.dispatch('UPDATEUSERPROFILE', this.user).then(function () {
                _this9.spinnerToggle();
                _this9.showUpdateDOB();
            });
        },
        onNewCardSubmit: function onNewCardSubmit() {
            var _this10 = this;

            var self = this;
            this.spinnerToggle();
            if (this.isStripe) {
                this.stripe.createToken(this.card).then(function (result) {
                    if (result.error) {
                        var errorElement = document.getElementById('card-errors');
                        errorElement.textContent = result.error.message;
                        _this10.spinnerToggle();
                    } else {
                        var stripeToken = result.token.id;
                        _this10.userPayments.stripeCardId = result.token.card.id;

                        _this10.userPayments.token = stripeToken;
                        _this10.user.userPayments = [];
                        _this10.user.userPayments.push(_this10.userPayments);
                        _this10.$store.dispatch('UPDATECREDITCARD', _this10.user).then(function () {
                            if (!_this10.error.show) {
                                _this10.spinnerToggle();
                                self.showUpdatePayment();
                                self.$store.dispatch('GETCREDITCARDINFO', _this10.user.userId).then(function () {
                                    _this10.$swal({
                                        title: 'Payment Method Changed!',
                                        text: '',
                                        type: 'success',
                                        timer: 3000,
                                        showCancelButton: false,
                                        showConfirmButton: false
                                    }).then(function () {}, function (dismiss) {
                                        if (dismiss === 'timer') {}
                                    });
                                });
                            } else {
                                _this10.spinnerToggle();
                            }
                        });
                    }
                });
            } else {
                if (this.userPayments.paymentMethodNonce) {
                    this.user.userPayments = [];
                    this.user.userPayments.push(this.userPayments);

                    this.$store.dispatch('UPDATECREDITCARD', this.user).then(function () {
                        if (!_this10.error.show) {
                            _this10.spinnerToggle();
                            self.showUpdatePayment();
                            _this10.$swal({
                                title: 'Payment Method Changed!',
                                text: '',
                                type: 'success',
                                timer: 3000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {}
                            });
                        } else {
                            _this10.spinnerToggle();
                        }
                    });
                } else {
                    this.$swal({
                        title: 'Please first click above paypal button to authorize',
                        type: 'error',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    this.spinnerToggle();
                }
            }
        },
        onPasswordSubmit: function onPasswordSubmit() {
            var _this11 = this;

            if (this.verifyPassword()) {
                this.spinnerToggle();
                var passwords = {};
                passwords.email = this.user.email.toLowerCase();
                passwords.password = this.oldPassword;
                passwords.newPassword = this.updatedPassword;
                this.$store.dispatch('UPDATEPROFILEPASSWORD', { passwords: passwords }).then(function () {
                    _this11.spinnerToggle();
                    _this11.showUpdatePassword();
                });
            }
        },
        onEmailChangeSubmit: function onEmailChangeSubmit() {
            var _this12 = this;

            var self = this;
            if (this.verifyEmail(this.newEmail)) {
                this.spinnerToggle();
                var payload = {};
                payload.userId = this.user.userId;
                payload.email = this.newEmail.toLowerCase();
                payload.oldEmail = this.user.email.toString().toLowerCase();
                payload.password = this.oldPasswordForEmail;
                this.$store.dispatch('UPDATEPROFILEEMAIL', { payload: payload }).then(function () {
                    if (self.error.show && self.error.originalMessage !== 'aws.cognito.UserNotConfirmed') {
                        self.spinnerToggle();
                        self.$swal({
                            title: self.error.message,
                            text: '',
                            type: 'error',
                            timer: 2000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                    } else {
                        self.$swal({
                            title: 'Check your email for confirmation',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });

                        var logUser = localStorage.getItem('loggedUser');
                        var logUserTemp = sessionStorage.getItem('loggedUserTemp');
                        if (logUserTemp) {
                            logUserTemp = JSON.parse(sessionStorage.getItem('loggedUserTemp'));
                            logUserTemp.status = 'Registered';
                            logUserTemp.email = payload.email;
                            self.user.status = 'Registered';
                            self.user.email = payload.email;
                            sessionStorage.setItem('loggedUserTemp', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(logUserTemp));
                        }
                        if (logUser) {
                            logUser = JSON.parse(localStorage.getItem('loggedUser'));
                            logUser.status = 'Registered';
                            logUser.email = payload.email;
                            self.user.status = 'Registered';
                            self.user.email = payload.email;
                            localStorage.setItem('loggedUser', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(logUser));
                        }
                        _this12.spinnerToggle();
                        _this12.showUpdateEmail();
                    }
                });
            }
        },
        mountStripeElements: function mountStripeElements() {
            var _this13 = this;

            setTimeout(function () {
                _this13.stripe = window.Stripe('pk_test_SLHUyTkZmNS1OnLNdclgNldo');
                var elements = _this13.stripe.elements();
                _this13.card = elements.create('card');
                _this13.card.mount('#card-element');
            }, 500);
        },
        cancelSubscription: function cancelSubscription() {
            var self = this;
            var userId = self.user.userId;
            self.$swal({
                title: 'Unsubscribe',
                text: 'Are you sure you want to unsubscribe?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Please',
                cancelButtonText: 'Cancel',
                confirmButtonClass: 'btn btn-success',
                cancelButtonClass: 'btn btn-danger',
                buttonsStyling: false
            }).then(function (result) {
                __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('CANCELSUBSCRIPTION', userId).then(function () {
                    self.user.status = 'CANCELLED';
                    self.$swal({
                        title: 'Check your email for confirmation',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                });
            }, function (dismiss) {});
        },
        setVideoStatus: function setVideoStatus(videoObject) {
            var _this14 = this;

            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0) {
                    exists[0].liked = '0';
                }
                this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(function () {
                    _this14.getAuthUserFavVideos.splice(_this14.getAuthUserFavVideos.indexOf(videoObject), 1);
                });
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getAllInterests', 'getCorporatePayload', 'getSelectedCharity', 'user', 'error', 'getUserInterests', 'getAuthUserFavVideos', 'getBillingHistory', 'getDefaultImages', 'getPaypalToken', 'getCreditCardInfo', 'getAlertMsgStatus', 'getAuthUserVideos', 'getUserPlaylists', 'getUserPlaylistsWithVideos', 'getTrialDays', 'getAllSiteContents', 'getCardExpiryDays', 'getUserPlaylistsProfile', 'getUserProgressProfile', 'getUpcomingEvent', 'getProfileCharitySection', 'getExpert', 'getTaggedEmailList', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor']), {
        styleInterestObjectComp: function styleInterestObjectComp(interestId) {
            var isSelected = this.interestIndexes.filter(function (x) {
                x.interestId === interestId;
            });
            if (isSelected && isSelected.length > 0) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor,
                    borderColor: this.getCorpButtonColor
                };
            } else {
                return {
                    border: '2px solid' + this.getCorpButtonColor + ' !important',
                    color: this.getCorpButtonColor
                };
            }
        }
    }),
    mounted: function mounted() {
        var _this15 = this;

        var self = this;
        setTimeout(function () {
            window.addeventatc.refresh();
        }, 2000);

        var param = this.$route.params.feature;
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.container.boxescontiner .row.nospace.flexrow > div').on('click', function () {
            var clickedDiv = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this)[0].id;
            var oldDiv = '';
            var activeRef = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.container.boxescontiner .row.nospace.flexrow').find('.active');
            if (activeRef[0] === undefined) {} else {
                oldDiv = activeRef[0].id;
            }
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.container.boxescontiner .row.nospace.flexrow > div').removeClass('active');
            if (clickedDiv !== oldDiv) {
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).addClass('active');
            }
        });
        if (this.user.isOptOutSMS === '1') {
            this.isMobileSubscribe = true;
        } else {
            this.isMobileSubscribe = false;
        }
        if (this.user.isOptOutPn === '1') {
            this.isPushNotificationSubscribe = true;
        } else {
            this.isPushNotificationSubscribe = false;
        }
        if (param && param.toLowerCase() === 'playlist') {
            this.switchTab('playlist');
            self.$store.dispatch('GETDYNAMICCONTENTS', 31).then(function () {
                if (self.getAllSiteContents) {
                    _this15.metaTag_pageTitle = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                    _this15.metaTag_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_DESCRIPTION');
                    _this15.metaTag_keywords = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_KEYWORDS');

                    _this15.metaTag_fb_title = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                    _this15.metaTag_fb_image = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                    _this15.metaTag_fb_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                    _this15.metaTag_fb_sitename = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                    _this15.metaTag_tw_title = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                    _this15.metaTag_tw_image = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                    _this15.metaTag_tw_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
                }
            });
        } else if (param && param.toLowerCase() === 'myprogress') {
            this.switchTab('coolFeatures');
            self.$store.dispatch('GETDYNAMICCONTENTS', 32).then(function () {
                if (self.getAllSiteContents) {
                    _this15.metaTag_pageTitle = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                    _this15.metaTag_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_DESCRIPTION');
                    _this15.metaTag_keywords = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_KEYWORDS');

                    _this15.metaTag_fb_title = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                    _this15.metaTag_fb_image = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                    _this15.metaTag_fb_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                    _this15.metaTag_fb_sitename = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                    _this15.metaTag_tw_title = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                    _this15.metaTag_tw_image = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                    _this15.metaTag_tw_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
                }
            });
        } else if (param && param.toLowerCase() === 'personalize') {
            this.switchTab('chat');
            self.$store.dispatch('GETDYNAMICCONTENTS', 33).then(function () {
                if (self.getAllSiteContents) {
                    _this15.metaTag_pageTitle = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                    _this15.metaTag_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_DESCRIPTION');
                    _this15.metaTag_keywords = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_KEYWORDS');

                    _this15.metaTag_fb_title = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                    _this15.metaTag_fb_image = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                    _this15.metaTag_fb_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                    _this15.metaTag_fb_sitename = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                    _this15.metaTag_tw_title = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                    _this15.metaTag_tw_image = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                    _this15.metaTag_tw_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
                }
            });
        } else if (param && param.toLowerCase() === 'myfav') {
            this.switchTab('videos');
            self.$store.dispatch('GETDYNAMICCONTENTS', 34).then(function () {
                if (self.getAllSiteContents) {
                    _this15.metaTag_pageTitle = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                    _this15.metaTag_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_DESCRIPTION');
                    _this15.metaTag_keywords = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_KEYWORDS');

                    _this15.metaTag_fb_title = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                    _this15.metaTag_fb_image = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                    _this15.metaTag_fb_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                    _this15.metaTag_fb_sitename = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                    _this15.metaTag_tw_title = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                    _this15.metaTag_tw_image = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                    _this15.metaTag_tw_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
                }
            });
        } else {
            self.$store.dispatch('GETDYNAMICCONTENTS', 15).then(function () {
                if (self.getAllSiteContents) {
                    _this15.metaTag_pageTitle = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                    _this15.metaTag_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_DESCRIPTION');
                    _this15.metaTag_keywords = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_KEYWORDS');

                    _this15.metaTag_fb_title = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                    _this15.metaTag_fb_image = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                    _this15.metaTag_fb_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                    _this15.metaTag_fb_sitename = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                    _this15.metaTag_tw_title = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                    _this15.metaTag_tw_image = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                    _this15.metaTag_tw_description = _this15.setDynamicSection(_this15.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
                }
            });
            this.$store.dispatch('DEFAULTIMAGESLIST').then(function () {
                if (_this15.getDefaultImages) {
                    setTimeout(function () {
                        _this15.setCarousal();
                    }, 2000);
                }
            });
        }
        if (this.user.isPaypalCustomer === '1') {
            this.$store.dispatch('GETPAYPALTOKEN');
        } else {
            this.$store.dispatch('GETCREDITCARDINFO', this.user.userId);
        }

        self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(function () {
            if (self.getTaggedEmailList) {
                self.emailList = [];
                self.emailList = self.getTaggedEmailList;
                console.log('email list', self.getTaggedEmailList);
            }
        });
        var corpId = 0;
        if (this.user.corporation && this.user.corporation.corporationId > 0) {
            corpId = this.user.corporation.corporationId;
        }
        this.$store.dispatch('GETALLINTERESTS', corpId).then(function () {
            _this15.$store.dispatch('GETUSERINTERESTS', _this15.user.userId).then(function () {
                for (var i = 0, l = _this15.getAllInterests.length; i < l; i++) {
                    if (_this15.getInterestStatus(_this15.getAllInterests[i])) {
                        _this15.interestIndexes.push(i);
                    }
                }
            });
        });
        this.$store.dispatch('GETALLEMAILDAYS', corpId).then(function (data) {
            _this15.$store.dispatch('GETALLEMAILDAYS', _this15.user.userId).then(function (data) {
                var capitalizedDays = _this15.daysOfWeek.map(function (day) {
                    return day.toUpperCase();
                });
                for (var i = 0; i < data.length; i++) {
                    var index = capitalizedDays.indexOf(data[i]);
                    if (index !== -1) {
                        _this15.selectedDays.push(index);
                    }
                }
            });
        });
        this.$store.dispatch('GETUSERFAVORITEVIDEOS', this.user.userId).then(function () {});
        this.$store.dispatch('GETBILLINGHISTORY', { userId: this.user.userId }).then(function () {});
        this.$store.dispatch('GETSELECTEDCHARITY', this.user.userId).then(function () {});
        if (this.user.stripeCustomerId) {
            this.isStripe = true;
        } else {
            this.isStripe = false;
        }

        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(function () {});
        this.$store.dispatch('GET_UPCOMING_EVENT').then(function () {
            if (self.getUpcomingEvent) {
                console.log('upcoming event', self.getUpcomingEvent);
                self.upcomingProfileEvent = self.getUpcomingEvent;
                if (self.upcomingProfileEvent) {
                    self.$store.dispatch('GETEXPERT', self.upcomingProfileEvent.expertId);
                }
            }
        });

        this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(function () {
            _this15.allCorps = [];
            if (_this15.getCorporatePayload) {
                console.log('payload corp', _this15.getCorporatePayload);
                _this15.corporateInfo = _this15.getCorporatePayload;
                _this15.allCorps = _this15.corporateInfo.lstCorporationUsers;
            }
        });

        var switchedCorpId = 0;
        if (sessionStorage.getItem('switchClientObject')) {
            var switchedCorp = sessionStorage.getItem('switchClientObject');
            switchedCorp = JSON.parse(switchedCorp);
            switchedCorpId = switchedCorp.corporationId;
        }
        var corpToSet = switchedCorpId > 0 ? switchedCorpId : corpId;
        var qryParam = [this.user.userId, corpToSet];
        this.$store.dispatch('GET_USER_PLAYLISTS_PROFILE', qryParam).then(function () {
            if (_this15.getUserPlaylistsProfile) {
                _this15.userPersonalPlaylists = _this15.getUserPlaylistsProfile.userPlaylists ? _this15.getUserPlaylistsProfile.userPlaylists : null;
                _this15.userCuratedPlaylists = _this15.getUserPlaylistsProfile.curatedPlaylists ? _this15.getUserPlaylistsProfile.curatedPlaylists : null;
                _this15.userCorpSharedPlaylists = _this15.getUserPlaylistsProfile.corporationPlaylists ? _this15.getUserPlaylistsProfile.corporationPlaylists : null;
                console.log('user personal playlists', _this15.userPersonalPlaylists);

                if (_this15.user && _this15.user.corporation && _this15.user.corporation.enableCorporatePage === 1) {} else {
                    _this15.userCorpSharedPlaylists = null;
                }
            }
        });
        this.$store.dispatch('GET_USER_PROGRESS_PROFILE', this.user.userId).then(function () {
            if (_this15.getUserProgressProfile) {
                _this15.isPlaylistWatched = _this15.getUserProgressProfile.anyPlaylistSeen;
                _this15.userProgressPlaylists = _this15.getUserProgressProfile.lstPlaylistStatsForProfile ? _this15.getUserProgressProfile.lstPlaylistStatsForProfile : null;
                _this15.userProgressEventsAttended = _this15.getUserProgressProfile.arrEventsAttended ? _this15.getUserProgressProfile.arrEventsAttended : null;
                _this15.userProgressVideosWatched = _this15.getUserProgressProfile.arrWatchedVideos ? _this15.getUserProgressProfile.arrWatchedVideos : null;
                _this15.userProgressTakeaways = _this15.getUserProgressProfile.arrVideosTakeaways ? _this15.getUserProgressProfile.arrVideosTakeaways : null;
                if (_this15.userProgressVideosWatched && _this15.userProgressVideosWatched.length > 0) {
                    if (_this15.userProgressVideosWatched[0].video_type !== 'WATCHED') {
                        _this15.isSectionWatched = false;
                    }
                }
                if (!_this15.userProgressTakeaways || _this15.userProgressTakeaways.length === 0) {
                    _this15.userProgressTakeaways = null;
                }

                console.log('user progress Takeaways', _this15.userProgressTakeaways);
            }
        });

        if (this.getAlertMsgStatus) {
            if (this.getTrialDays > 1) {
                this.expiredTrialMessage = 'Your trial period will expire in ' + this.getTrialDays + ' days. Become a Member';
            } else if (this.getTrialDays === 1) {
                this.expiredTrialMessage = 'Your trial is expiring tomorrow. Become a Member';
            } else if (this.getTrialDays === 0) {
                this.expiredTrialMessage = 'Your trial is expiring today. Become a Member';
            } else if (this.getTrialDays < 0) {
                this.expiredTrialMessage = 'Your trial has expired. Become a Member';
            }
        }
        this.$store.dispatch('GETDYNAMICCONTENTS', 15).then(function () {
            var self = _this15;
            if (self.getAllSiteContents) {
                self.imageText = _this15.setDynamicSection(_this15.getAllSiteContents, 'PROFILE_IMAGE_TEXT_01');

                self.personalPlaylistTitle = _this15.setDynamicSection(_this15.getAllSiteContents, 'PROFILE_YOUR_PLAYLIST_LABEL');
                self.trendingPlaylistTitle = _this15.setDynamicSection(_this15.getAllSiteContents, 'PROFILE_TONE_PLAYLIST_LABEL');
                self.corpPlaylistTitle = _this15.setDynamicSection(_this15.getAllSiteContents, 'PROFILE_CORP_PLAYLIST_LABEL');
                self.progressHeading1 = _this15.setDynamicSection(_this15.getAllSiteContents, 'PROGRESS_TAB_HDNG_1');
                self.progressHeading2 = _this15.setDynamicSection(_this15.getAllSiteContents, 'PROGRESS_TAB_HDNG_2');
                self.progressHeading3 = _this15.setDynamicSection(_this15.getAllSiteContents, 'PROGRESS_TAB_HDNG_3');
                self.progressEmptyTakeawayHdng1 = _this15.setDynamicSection(_this15.getAllSiteContents, 'PROFILE_EMPTY_TAKEAWAY_1');
                self.progressEmptyTakeawayHdng2 = _this15.setDynamicSection(_this15.getAllSiteContents, 'PROFILE_EMPTY_TAKEAWAY_2');
                self.progressEmptyTakeawayHdng3 = _this15.setDynamicSection(_this15.getAllSiteContents, 'PROFILE_EMPTY_TAKEAWAY_3');
                self.progressEmptyTakeawayHdng4 = _this15.setDynamicSection(_this15.getAllSiteContents, 'PROFILE_EMPTY_TAKEAWAY_4');
            }
        });

        if (this.getCardExpiryDays < 5 && this.user.ccExpAlarmFlag === 2) {
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()('html,body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#updatepaymentmethod').offset().top }, 800);
                _this15.showUpdatePayment();
            }, 800);
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'player',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default.a
    },
    methods: {
        redirectToRelatedVideos: function redirectToRelatedVideos() {
            this.$router.push('/relatedvideos');
        },
        onVideoComplete: function onVideoComplete() {
            var _this = this;

            this.currentStatus.watched = 'F';
            this.currentStatus.durationWatched = '100';
            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this.currentStatus = _this.getCurrentStatus;
            });
        },
        setUserLike: function setUserLike() {
            var _this2 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / this.getCurrentVideo[0].duration * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            if (this.currentStatus.liked === '1') {
                this.currentStatus.liked = '0';
            } else {
                this.currentStatus.liked = '1';
            }
            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this2.currentStatus = _this2.getCurrentStatus;
            });
        },
        setRating: function setRating(desc) {
            var _this3 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            var rating = '0';
            if (desc === 'funny') {
                rating = '1';
            } else if (desc === 'smart') {
                rating = '2';
            } else if (desc === 'helpful') {
                rating = '3';
            } else {
                rating = '0';
            }
            this.currentStatus.rating = rating;
            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this3.currentStatus = _this3.getCurrentStatus;
            });
        },
        logVideoEntry: function logVideoEntry() {
            var logWatchedEntry = {
                videoCode: this.$route.params.videoCode,
                userId: this.user.userId,
                playlistId: null,
                playlistCode: null,
                watched: 'N',
                rating: null,
                liked: '0',
                durationWatched: 0,
                thumbnailURL: null
            };
            this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {
                console.log('added');
            });
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/watch/' + videoCode);
            location.reload();
        },
        setCarousal: function setCarousal() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        }
    },
    data: function data() {
        return {
            activeTab: 0,
            currentVideo: '',
            currentStatus: '',
            currentVideoCode: this.$route.params.videoCode,
            recommendationList: ''
        };
    },
    mounted: function mounted() {
        var _this4 = this;

        this.$store.dispatch('GETCURRENTVIDEO', this.$route.params.videoCode).then(function () {
            var video = _this4.getCurrentVideo;
            _this4.currentVideo = {
                video: video[0].sources[3].file,
                title: video[0].title,
                img: video[0].image,
                playerID: new Date()
            };
            _this4.$store.dispatch('GETEXPERT', video[0].expertid).then(function () {});
            _this4.logVideoEntry();
        });

        this.$store.dispatch('GETVIDEOTRANSCRIPT', this.$route.params.videoCode).then(function () {});

        this.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', this.user.userId).then(function () {
            var code = void 0;
            console.log(code);
            var filteredList = _this4.getAuthRecommendedVideos.filter(function (code) {
                return code.mediaid !== _this4.currentVideoCode;
            });
            _this4.recommendationList = filteredList;
            setTimeout(function () {
                _this4.setCarousal();
            }, 2000);
        });

        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(function () {
            if (_this4.getAuthUserVideos) {
                var code = _this4.$route.params.videoCode;
                var exists = _this4.getAuthUserVideos.filter(function (code) {
                    return code.videoCode === _this4.currentVideoCode;
                });
                if (exists && exists.length > 0) {
                    _this4.currentStatus = exists[0];
                } else {
                    _this4.currentStatus = {
                        videoCode: _this4.$route.params.videoCode,
                        userId: _this4.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '0',
                        durationWatched: 0,
                        thumbnailURL: null
                    };
                }
                console.log(code);
            }
        });
        function init() {
            setHeight();
            initilizer();
        }
        function initilizer() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.rate').mouseover(function () {
                changeHeight();
            });
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.share').mouseover(function () {
                showSharing();
            });
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.video-player').on('mouseleave', '.right-hover-width', function () {
                resetHeight();
            });
        }
        function showSharing() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.share-hover-box').show();
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.left-video-icons').hide();
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.right-video-icons').addClass('right-hover-width');
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.icons-hover').addClass('icon-hover-width');
        }
        function resetHeight() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.left-video-icons').show();
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.right-video-icons').removeClass('right-hover-width');
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.icons-hover').removeClass('icon-hover-width');
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.rate-hover-box').hide();
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.share-hover-box').hide();
        }
        function changeHeight() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.left-video-icons').hide();
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.right-video-icons').addClass('right-hover-width');
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.icons-hover').addClass('icon-hover-width');
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.rate-hover-box').show();
        }
        function setHeight() {
            var $tabPane = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.tab-pane');
            var tabsHeight = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.nav-tabs').height();
            $tabPane.css({
                height: tabsHeight
            });
        }
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(init);
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert', 'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched']))
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
    spinner: false,
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'checkbox': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        'button-group': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        alert: alert
    },
    name: 'profile',
    data: function data() {
        return {
            spinner: false,
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            tabs: {
                videos: true,
                chat: false,
                discussion: false
            }
        };
    },
    methods: {
        switchTab: function switchTab(id) {
            for (var tab in this.tabs) {
                this.tabs[tab] = id === tab;
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/watch/' + videoCode);
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoStatus: function setVideoStatus(videoObject) {
            var _this = this;

            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0';
                    } else {
                        exists[0].liked = '1';
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(function () {
                        _this.$store.dispatch('GETAUTHUSERVIDEOS', _this.user.userId);
                    });
                } else {
                    var logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    };
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {
                        _this.$store.dispatch('GETAUTHUSERVIDEOS', _this.user.userId);
                    });
                }
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this2 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this2.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getAuthRecentlyWatchedVideos', 'user', 'error', 'getAuthUserVideos', 'getUserPlaylists', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'])),
    mounted: function mounted() {
        this.$store.dispatch('GETAUTHRECENTLYWATCHEDVIDEOS', this.user.userId).then(function () {});

        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(function () {});

        this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(function () {});
    }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_masked_input__ = __webpack_require__(30);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["accordion"],
        'panel': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["panel"],
        'masked-input': __WEBPACK_IMPORTED_MODULE_4_vue_masked_input__["a" /* default */],
        alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
        dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["dropdown"],
        radio: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["radio"],
        VuePassword: __WEBPACK_IMPORTED_MODULE_3_vue_password___default.a,
        checkbox: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        tabs: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tabs"],
        tab: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tab"],
        buttonGroup: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"]
    },
    name: 'signUp',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Redeem Your Gift',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Redeem Your Gift' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Redeem Your Gift' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            user: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                packageId: 0,
                comments: '',
                phoneNumber: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg'
            },
            spinner: false,
            alert: false,
            passwordError: '',
            paymentSection: false,
            isToggle: false,
            isChecked: false,
            defaultPlan: '',
            hidePasswordMeter: true,
            rawPhoneNumber: '',
            phoneNumber: '',
            dynamic_bullet_1: '',
            dynamic_bullet_2: '',
            dynamic_bullet_3: '',
            dynamic_bullet_4: '',
            dynamic_bullet_5: '',
            dynamic_bullet_6: ''
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (this.$route.query.params) {
            this.$store.dispatch('GETDYNAMICCONTENTS', 25).then(function () {
                if (_this.getAllSiteContents) {
                    _this.dynamic_bullet_1 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_1');
                    _this.dynamic_bullet_2 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_2');
                    _this.dynamic_bullet_3 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_3');
                    _this.dynamic_bullet_4 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_4');
                    _this.dynamic_bullet_5 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_5');
                    _this.dynamic_bullet_6 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_6');
                }
            });
            this.$store.dispatch('GETGIFTEE', this.$route.query.params).then(function () {
                if (_this.getGiftee) {
                    _this.user.firstName = _this.getGiftee.gifteeFirstName;
                    _this.user.lastName = _this.getGiftee.gifteeLastName;
                    _this.user.email = _this.getGiftee.gifteeEmail;
                    _this.user.packageId = _this.getGiftee.packageId;
                    _this.user.comments = _this.getGiftee.gifteeUuid;
                } else {
                    _this.$router.push('/');
                }
                _this.$store.dispatch('GETPLANS').then(function () {
                    var plan = _this.getAllPlans.filter(function (pln) {
                        return pln.packageId === _this.getGiftee.packageId;
                    });
                    _this.defaultPlan = plan[0];
                });
            });
        } else {
            if (this.getCorporateGiftingCode) {
                this.$router.push('/corporate/' + this.getCorporateGiftingCode);
            } else {
                this.$router.push('/');
            }
        }
    },

    methods: {
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        verifyPaymentSubmit: function verifyPaymentSubmit() {
            if (this.user.packageId > 0) {
                return false;
            }
            return true;
        },
        verifyPassword: function verifyPassword() {
            if (this.user.password.length >= 6) {
                var re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/;
                if (!re.test(this.user.password)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (this.user.password.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        verifyEmail: function verifyEmail() {
            if (this.user.email.length > 0) {
                var re = /^[\w\d.+-]+@[\w\d-]+\.[a-z]+$/i;
                if (!re.test(this.user.email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyFirstName: function verifyFirstName() {
            if (this.user.firstName.length > 0) {
                var re = /^[A-Za-z '-]+$/;
                if (!re.test(this.user.firstName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyLastName: function verifyLastName() {
            if (this.user.lastName.length > 0) {
                var re = /^[A-Za-z '-]+$/;
                if (!re.test(this.user.lastName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyCardHolderName: function verifyCardHolderName() {
            if (this.user.cardHolderName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.cardHolderName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onGifteeSubmit: function onGifteeSubmit() {
            var _this2 = this;

            if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                this.user.phoneNumber = this.phoneNumber;
            } else {
                this.phoneNumber = '';
                this.user.phoneNumber = '';
            }
            if (this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                this.spinnerToggle();
                this.user.email = this.user.email.toLowerCase();
                this.$store.dispatch('SAVEGIFTEE', { giftee: this.user }).then(function () {
                    if (!_this2.error.show) {
                        _this2.spinnerToggle();
                        _this2.$swal({
                            title: 'Registration Success!',
                            text: 'Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)',
                            type: 'success',
                            timer: 4000,
                            showCancelButton: false,
                            showConfirmButton: false,
                            customClass: 'sweetalert-lg-signup'
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                    } else {
                        _this2.spinnerToggle();
                    }
                });
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['error', 'isUserLoggedIn', 'getAllPlans', 'getGiftee', 'getCorporateGiftingCode', 'getAllSiteContents']))
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
    spinner: false,
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'checkbox': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        'button-group': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        alert: alert
    },
    name: 'profile',
    data: function data() {
        return {
            interestIndexes: [],
            userInterests: [],
            spinner: false,
            newPlaylistName: '',
            tabs: {
                videos: true,
                chat: false,
                discussion: false
            },
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0
        };
    },
    methods: {
        switchTab: function switchTab(id) {
            for (var tab in this.tabs) {
                this.tabs[tab] = id === tab;
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        getInterestStatus: function getInterestStatus(interest) {
            if (this.getUserInterests) {
                var selectedInterestId = void 0;
                console.log(selectedInterestId);
                var exists = this.getUserInterests.filter(function (selectedInterestId) {
                    return selectedInterestId.interestId === interest.interestId;
                });
                if (exists && exists.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/watch/' + videoCode);
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoStatus: function setVideoStatus(videoObject) {
            var _this = this;

            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0';
                    } else {
                        exists[0].liked = '1';
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(function () {
                        _this.$store.dispatch('GETAUTHUSERVIDEOS', _this.user.userId);
                    });
                } else {
                    var logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    };
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {
                        _this.$store.dispatch('GETAUTHUSERVIDEOS', _this.user.userId);
                    });
                }
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this2 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this2.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getAuthRecommendedVideos', 'user', 'error', 'getAuthUserVideos', 'getUserPlaylists', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'])),
    mounted: function mounted() {
        this.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', this.user.userId).then(function () {});

        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(function () {});
        this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(function () {});
    }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password__);






var crypto = __webpack_require__(166);
/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"], 'alert': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"], 'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"], VuePassword: __WEBPACK_IMPORTED_MODULE_3_vue_password___default.a
    },
    name: 'resetpassword',
    data: function data() {
        return {
            forgetpassword: {
                email: '',
                forgotPasswordCode: '',
                newPassword: ''
            },
            confirmPassword: '',
            passwordError: '',
            spinner: false,
            alert: false,
            changePwdSuccess: false,
            hidePasswordMeter: true
        };
    },
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },

        redirectLogin: function redirectLogin(event) {
            this.$router.push('/');
        },
        onSubmit: function onSubmit() {
            var _this = this;

            var self = this;
            if (this.forgetpassword && this.verifyPassword()) {
                this.$store.dispatch('CONFIRMPASSWORD', { user: this.forgetpassword }).then(function () {
                    if (!self.error.show) {
                        self.$swal({
                            title: 'Password Reset!',
                            text: 'Password Changed Successfully. Redirecting to Tone Networks..',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                        self.$router.push('/');
                    } else {
                        _this.$swal({
                            title: 'Password Reset Failed!',
                            text: 'Password request expires after 24 hours. Please generate a new password request and follow the link',
                            type: 'error',
                            timer: 6000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                        _this.$router.push('/');
                    }
                });
            }
        },
        verifyPassword: function verifyPassword() {
            if (this.forgetpassword.newPassword.length >= 6) {
                var re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/;
                if (!re.test(this.forgetpassword.newPassword)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (this.forgetpassword.newPassword.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['error', 'user', 'isUserLoggedIn'])),
    mounted: function mounted() {
        if (this.$route.query.params && !this.isUserLoggedIn) {
            var encryptedEmail = this.$route.query.params.substr(0, this.$route.query.params.indexOf('^'));
            var validationCode = this.$route.query.params.substr(this.$route.query.params.indexOf('^') + 1);

            var decipher = crypto.createDecipher('aes-256-cbc', 'tonenetworks');
            var decrypted = decipher.update(encryptedEmail, 'hex', 'utf-8');
            decrypted = decrypted + decipher.final('utf-8');
            this.forgetpassword.email = decrypted;
            this.forgetpassword.forgotPasswordCode = validationCode;
        } else {
            this.$router.push('/');
        }
    }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_dateHelpers_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_strap__);









/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_6_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_6_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_6_vue_strap__["accordion"],
        'panel': __WEBPACK_IMPORTED_MODULE_6_vue_strap__["panel"],
        modal: __WEBPACK_IMPORTED_MODULE_6_vue_strap__["modal"],

        jwplayer: __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue___default.a
    },
    name: 'resources',
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            hoverState: false,
            shareImagePayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                recipientFriendEmails: null,
                eventId: '',
                customizedMessage: '',
                playlistType: 6
            },
            shareEventSelected: null,
            showCorporateImageShare: false,
            corporateShareMessage: '',
            selectedPlaylist: null,
            corpShareModalImage: '',
            showCorporateShare: false,
            corpShareModalTitle: '',
            corpShareModalDesc: '',
            selectedCorps: [],
            allCorps: [],
            shareOption: 'Corporate',
            spinner: false,
            taggedEmails: [],
            emailList: [],
            previewMsg: 'Message Preview: \n',
            showSharedModal: false,
            shareInProcess: false,
            toggleSpinner: false,
            config: {
                weekends: true,
                month: true
            },
            monthEvents: [],
            liveEvent: null,
            talkEvent: null,
            currentVideo: null,
            advertisementVideo1: null,
            advertisementVideo2: null,
            reservationMsg: '',
            bannerEvent: '',
            eventURL: 'https://www1.dev-tonenetworks.com',
            sImage: '',
            sTitle: '',
            sDescription: '',
            seatReservation: {
                userEventId: 0,
                eventId: 0,
                userId: 0,
                status: 0,
                isAnonymous: 0
            },
            thought1_header: '',
            thought1_text: '',
            thought1_img: '',
            thought1_url: '',
            thought2_header: '',
            thought2_text: '',
            thought2_img: '',
            thought2_url: '',
            thought3_header: '',
            thought3_text: '',
            thought3_img: '',
            thought3_url: '',
            thought4_header: '',
            thought4_text: '',
            thought4_img: '',
            thought4_url: '',
            thought5_header: '',
            thought5_text: '',
            thought5_img: '',
            thought5_url: '',
            article1_header: '',
            article1_text: '',
            article1_img: '',
            article1_url: '',
            article2_header: '',
            article2_text: '',
            article2_img: '',
            article2_url: '',
            article3_header: '',
            article3_text: '',
            article3_img: '',
            article3_url: '',
            article4_header: '',
            article4_text: '',
            article4_img: '',
            article4_url: '',
            article5_header: '',
            article5_text: '',
            article5_img: '',
            article5_url: '',
            resourceCategory1_text: '',
            resourceCategory1_links: [],
            resourceCategory2_text: '',
            resourceCategory2_links: [],
            resourceCategory3_text: '',
            resourceCategory3_links: [],
            resourceCategory4_text: '',
            resourceCategory4_links: [],
            resourceCategory5_text: '',
            resourceCategory5_links: [],
            resourceCategory6_text: '',
            resourceCategory6_links: [],
            siteFeatures1_text: '',
            siteFeatures1_desc: '',
            siteFeatures2_text: '',
            siteFeatures2_desc: '',
            siteFeatures3_text: '',
            siteFeatures3_desc: '',
            siteFeatures4_text: '',
            siteFeatures4_desc: '',
            siteFeatures5_text: '',
            siteFeatures5_desc: '',
            siteFeatures6_text: '',
            siteFeatures6_desc: '',
            siteFeatures7_text: '',
            siteFeatures7_desc: '',
            advertisementBox1_text: '',
            advertisementBox1_video: '',
            advertisementBox1_image: '',
            advertisementBox2_text: '',
            advertisementBox2_video: '',
            advertisementBox2_image: '',
            video1Ref: '',
            adVideo1Ref: '',
            adVideo2Ref: '',
            video_code: '',
            video_title: '',
            metaTag_pageTitle: 'TONE Networks | Resources',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: '',
            subscriptionForm: {
                userId: null,
                email: '',
                name: '',
                comments: '',
                rating: 0,
                newsLetterEmail: '0',
                promotionalEmail: '0',
                representativeCall: '0'
            },
            firstAdvertisementBox: null,
            mediaColl: null,
            mediaFile: null,
            advColl: null
        };
    },
    watch: {
        'shareOption': function shareOption(to, from) {
            var self = this;
            self.selectedCorps = null;
            self.corporateShareMessage = '';
            self.taggedEmails = [];
        }
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        setTimeout(function () {
            window.addeventatc.refresh();
        }, 2000);
        this.$store.dispatch('GET_NEWS_RESOURCES').then(function () {
            if (_this.getAllNewsResources) {
                console.log('all resources', _this.getAllNewsResources);
                console.log('all featured articles', _this.getAllFeaturedArticles);
                console.log('all set tone articles', _this.getAllSetToneResources);
                console.log('all advertisement boxes', _this.getAllAdvertisementResources);
                _this.mediaColl = _this.getAllAdvertisementResources.map(function (item) {
                    var mediaCol = {};
                    mediaCol.newsResourcesId = item.newsResourcesId;
                    mediaCol.videoCode = item.videoCode ? item.videoCode : '';
                    mediaCol.articleHeader = item.articleHeader;
                    mediaCol.imageUrl = item.imageUrl;
                    mediaCol.videoObject = null;
                    return mediaCol;
                });
                console.log('mediaCol', self.mediaColl);
                self.returnAdVideo();
            }
        });
        this.$store.dispatch('GETDYNAMICCONTENTS', 11).then(function () {
            if (_this.getAllSiteContents) {
                _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');

                _this.siteFeatures1_text = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT1_HEAD');
                _this.siteFeatures1_desc = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT1_DESC');
                _this.siteFeatures2_text = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT2_HEAD');
                _this.siteFeatures2_desc = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT2_DESC');
                _this.siteFeatures3_text = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT3_HEAD');
                _this.siteFeatures3_desc = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT3_DESC');
                _this.siteFeatures4_text = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT4_HEAD');
                _this.siteFeatures4_desc = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT4_DESC');
                _this.siteFeatures5_text = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT5_HEAD');
                _this.siteFeatures5_desc = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT5_DESC');
                _this.siteFeatures6_text = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT6_HEAD');
                _this.siteFeatures6_desc = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT6_DESC');
                _this.siteFeatures7_text = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT7_HEAD');
                _this.siteFeatures7_desc = _this.setDynamicSection(_this.getAllSiteContents, 'SF_CAT7_DESC');

                _this.resourceCategory1_text = _this.setDynamicSection(_this.getAllSiteContents, 'RC_CAT1_HEAD');
                for (var i = 1; i < 21; i++) {
                    var linkObj = {};
                    var urlkey = 'RC_CAT1_LNK' + i + '_URL';
                    var urlValue = _this.setDynamicSection(_this.getAllSiteContents, urlkey);
                    var textkey = 'RC_CAT1_LNK' + i + '_TEXT';
                    var textValue = _this.setDynamicSection(_this.getAllSiteContents, textkey);
                    if (urlValue) {
                        linkObj.url = urlValue;
                        linkObj.title = textValue;
                        self.resourceCategory1_links.push(linkObj);
                    }
                }
                _this.resourceCategory2_text = _this.setDynamicSection(_this.getAllSiteContents, 'RC_CAT2_HEAD');
                for (var _i = 1; _i < 21; _i++) {
                    var _linkObj = {};
                    var _urlkey = 'RC_CAT2_LNK' + _i + '_URL';
                    var _urlValue = _this.setDynamicSection(_this.getAllSiteContents, _urlkey);
                    var _textkey = 'RC_CAT2_LNK' + _i + '_TEXT';
                    var _textValue = _this.setDynamicSection(_this.getAllSiteContents, _textkey);
                    if (_urlValue) {
                        _linkObj.url = _urlValue;
                        _linkObj.title = _textValue;
                        self.resourceCategory2_links.push(_linkObj);
                    }
                }
                _this.resourceCategory3_text = _this.setDynamicSection(_this.getAllSiteContents, 'RC_CAT3_HEAD');
                for (var _i2 = 1; _i2 < 21; _i2++) {
                    var _linkObj2 = {};
                    var _urlkey2 = 'RC_CAT3_LNK' + _i2 + '_URL';
                    var _urlValue2 = _this.setDynamicSection(_this.getAllSiteContents, _urlkey2);
                    var _textkey2 = 'RC_CAT3_LNK' + _i2 + '_TEXT';
                    var _textValue2 = _this.setDynamicSection(_this.getAllSiteContents, _textkey2);
                    if (_urlValue2) {
                        _linkObj2.url = _urlValue2;
                        _linkObj2.title = _textValue2;
                        self.resourceCategory3_links.push(_linkObj2);
                    }
                }
                _this.resourceCategory4_text = _this.setDynamicSection(_this.getAllSiteContents, 'RC_CAT4_HEAD');
                for (var _i3 = 1; _i3 < 21; _i3++) {
                    var _linkObj3 = {};
                    var _urlkey3 = 'RC_CAT4_LNK' + _i3 + '_URL';
                    var _urlValue3 = _this.setDynamicSection(_this.getAllSiteContents, _urlkey3);
                    var _textkey3 = 'RC_CAT4_LNK' + _i3 + '_TEXT';
                    var _textValue3 = _this.setDynamicSection(_this.getAllSiteContents, _textkey3);
                    if (_urlValue3) {
                        _linkObj3.url = _urlValue3;
                        _linkObj3.title = _textValue3;
                        self.resourceCategory4_links.push(_linkObj3);
                    }
                }
                _this.resourceCategory5_text = _this.setDynamicSection(_this.getAllSiteContents, 'RC_CAT5_HEAD');
                for (var _i4 = 1; _i4 < 21; _i4++) {
                    var _linkObj4 = {};
                    var _urlkey4 = 'RC_CAT5_LNK' + _i4 + '_URL';
                    var _urlValue4 = _this.setDynamicSection(_this.getAllSiteContents, _urlkey4);
                    var _textkey4 = 'RC_CAT5_LNK' + _i4 + '_TEXT';
                    var _textValue4 = _this.setDynamicSection(_this.getAllSiteContents, _textkey4);
                    if (_urlValue4) {
                        _linkObj4.url = _urlValue4;
                        _linkObj4.title = _textValue4;
                        self.resourceCategory5_links.push(_linkObj4);
                    }
                }
                _this.resourceCategory6_text = _this.setDynamicSection(_this.getAllSiteContents, 'RC_CAT6_HEAD');
                for (var _i5 = 1; _i5 < 21; _i5++) {
                    var _linkObj5 = {};
                    var _urlkey5 = 'RC_CAT6_LNK' + _i5 + '_URL';
                    var _urlValue5 = _this.setDynamicSection(_this.getAllSiteContents, _urlkey5);
                    var _textkey5 = 'RC_CAT6_LNK' + _i5 + '_TEXT';
                    var _textValue5 = _this.setDynamicSection(_this.getAllSiteContents, _textkey5);
                    if (_urlValue5) {
                        _linkObj5.url = _urlValue5;
                        _linkObj5.title = _textValue5;
                        self.resourceCategory6_links.push(_linkObj5);
                    }
                }

                _this.video_code = _this.setDynamicSection(_this.getAllSiteContents, 'VIDEO_CODE');
                _this.video_title = _this.setDynamicSection(_this.getAllSiteContents, 'VIDEO_TITLE');

                if (self.video_code && self.video_code.indexOf('http') < 0) {
                    self.$store.dispatch('GETCURRENTVIDEO', self.video_code).then(function () {
                        if (self.getCurrentVideo) {
                            var videoObj = self.getCurrentVideo[0];
                            self.currentVideo = {
                                video: videoObj.sources[videoObj.sources.length - 1].file,
                                title: videoObj.title,
                                img: videoObj.image,
                                playerID: new Date(),
                                tracks: videoObj.tracks,
                                Description: videoObj.description,
                                mediaId: videoObj.mediaid,
                                isMute: true
                            };
                            self.videoRef = window['currentVideoId'];
                        }
                    });
                }
            }
            setTimeout(function () {
                if (self.$route.params.feature) {
                    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html,body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#sFeatures').offset().top }, 800);
                }
            }, 1000);
        });
        self.$store.dispatch('GETEVENTLIST').then(function () {
            if (self.getEventList) {
                self.getEventList.forEach(function (event) {
                    var eveObj = {};
                    eveObj.title = self.getDateReferenceForEvent(event.start_date);
                    eveObj.start = event.start_date;
                    eveObj.id = event.eventId;
                    eveObj.allDay = true;
                    self.monthEvents.push(eveObj);
                });
                self.liveEvent = self.getEventList[0];
            }
        });
        if (self.user) {
            self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(function () {
                if (self.getTaggedEmailList) {
                    self.emailList = [];
                    self.emailList = self.getTaggedEmailList;
                    console.log('email list', self.getTaggedEmailList);
                }
            });

            this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(function () {
                _this.allCorps = [];
                if (_this.getCorporatePayload) {
                    _this.corporateInfo = _this.getCorporatePayload;
                    _this.allCorps = _this.corporateInfo.lstCorporationUsers;
                }
            });
        }
        setTimeout(function () {
            self.$store.dispatch('CACHEPAGE', window.location.href);
        }, 2000);
    },
    methods: {
        updateHoverState: function updateHoverState(isHover) {
            this.hoverState = isHover;
        },
        shareCorporateImage: function shareCorporateImage() {
            var self = this;
            self.shareImagePayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0;
            self.shareImagePayload.senderUserId = self.user.userId;
            self.shareImagePayload.recipientsUserIds = [];
            self.shareImagePayload.recipientFriendEmails = null;
            self.shareImagePayload.customizedMessage = self.corporateShareMessage;
            if (self.shareOption === 'Corporate') {
                self.shareImagePayload.recipientsUserIds = [];
                self.shareImagePayload.recipientFriendEmails = null;
            } else if (self.shareOption === 'Individual') {
                self.shareImagePayload.recipientFriendEmails = null;
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    self.shareImagePayload.recipientsUserIds = self.selectedCorps.map(function (x) {
                        return x.userId;
                    });
                }
            } else if (self.shareOption === 'Friends') {
                self.shareImagePayload.recipientsUserIds = [];
                var emailArray = self.taggedEmails.map(function (x) {
                    return x.name;
                });
                self.shareImagePayload.recipientFriendEmails = emailArray.join(',');
            } else {}
            self.shareImagePayload.eventId = self.shareEventSelected.eventId;
            self.shareInProcess = true;

            self.$store.dispatch('CORP_EVENT_SHARE', { payload: self.shareImagePayload }).then(function () {
                if (!self.error.show) {
                    self.spinnerToggle();
                    self.$swal({
                        title: 'Event has been shared!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });

                    self.cancelCorporateImageModal();
                } else {
                    self.cancelCorporateImageModal();
                }
            });
        },
        maskEmailAddress: function maskEmailAddress(userEmail) {
            var avg = void 0,
                splitted = void 0,
                part1 = void 0,
                part2 = void 0;
            splitted = userEmail.split('@');
            part1 = splitted[0];
            var regex = /[^0-9.]/g;
            var maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1);
            console.log('maked', maskid);
            avg = part1.length / 2;
            part1 = part1.substring(0, part1.length - avg);
            part2 = splitted[1];
            var maskDomain = part2.split('.');
            return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1];
        },
        customLabel: function customLabel(option) {
            var findDuplicate = this.allCorps.find(function (x) {
                return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId;
            });

            if (findDuplicate) {
                var maskedEmail = this.maskEmailAddress(option.email);
                return option.firstName + ' ' + option.lastName + ' <' + maskedEmail + '>';
            } else {
                return option.firstName + ' ' + option.lastName;
            }
        },
        openCorporateImageShareModal: function openCorporateImageShareModal() {
            var self = this;
            var tEvent = self.liveEvent;
            console.log('event for share', tEvent);
            self.shareInProcess = false;
            self.shareEventSelected = tEvent;
            self.corpShareModalImage = tEvent.img_url;
            self.corpShareModalDesc = tEvent.description;
            self.corpShareModalTitle = tEvent.title;
            self.showCorporateImageShare = true;
        },
        verifyEmailShare: function verifyEmailShare(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        addTag: function addTag(newTag) {
            var self = this;
            console.log('newTAg', newTag);
            var tag = {
                name: newTag
            };
            if (self.verifyEmailShare(newTag)) {
                self.emailList.push(tag);
                this.taggedEmails.push(tag);
                console.log('tagged emails', this.taggedEmails);
            } else {
                console.log('invalid email address, calling swal');
            }
        },
        cancelCorporateImageModal: function cancelCorporateImageModal() {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateImageShare = false;
                self.shareInProcess = false;
                __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        returnAdVideo: function returnAdVideo() {
            var self = this;
            self.mediaColl.forEach(function (item) {
                if (item.videoCode) {
                    self.$store.dispatch('GET_CURRENT_VIDEO_DATA_SYNC', item.videoCode).then(function (res) {
                        if (res) {
                            var videoObj = res[0];
                            var videoObject = {
                                video: videoObj.sources[videoObj.sources.length - 1].file,
                                title: videoObj.title,
                                img: videoObj.image,
                                playerID: new Date(),
                                tracks: videoObj.tracks,
                                Description: videoObj.description,
                                mediaId: videoObj.mediaid,
                                isMute: true
                            };
                            if (videoObject) {
                                item.videoObject = videoObject;
                            }
                        } else {
                            return null;
                        }
                    });
                }
            });
            this.firstAdvertisementBox = this.mediaColl.shift();
            console.log('first advertisement', this.firstAdvertisementBox);
            console.log('remaining advertisement', this.mediaColl);
        },
        calendarLogging: function calendarLogging(event, title) {
            var self = this;
            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);
            userPayload.push(self.$route.fullPath);
            userPayload.push('ADD_TO_CALENDAR');
            userPayload.push(title);
            self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload);
        },
        eventSelected: function eventSelected(event, jsEvent, view) {
            var selectedEvent = event.id;
            var findEvent = this.getEventList.filter(function (x) {
                return x.eventId === selectedEvent;
            });
            if (findEvent && findEvent.length > 0) {
                this.talkEvent = findEvent[0];
                setTimeout(function () {
                    window.addeventatc.refresh();
                }, 1000);
            }
        },
        verifyEmail: function verifyEmail(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onEmailSignUp: function onEmailSignUp() {
            var _this2 = this;

            var self = this;
            this.subscriptionForm.comments = 'Newsletter Subscription';
            this.subscriptionForm.newsLetterEmail = '1';
            this.displayMsg = 'Successfully subscribed to newsletter';
            this.subscriptionForm.email = this.subscriptionForm.email.toLowerCase();
            if (self.verifyEmail(this.subscriptionForm.email)) {
                this.$store.dispatch('SENDFEEDBACKFORM', this.subscriptionForm).then(function () {
                    window.logEvents('Newsletter subscription', 'Subscribed', 'Newsletter subscribed by ' + _this2.subscriptionForm.email);

                    self.$swal({
                        title: _this2.displayMsg,
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    setTimeout(function () {
                        _this2.subscriptionForm.email = '';
                        _this2.subscriptionForm.promotionalEmail = '0';
                        _this2.subscriptionForm.userId = null;
                        _this2.subscriptionForm.email = '';
                        _this2.subscriptionForm.name = '';
                        _this2.subscriptionForm.comments = '';
                        _this2.subscriptionForm.rating = 0;
                        _this2.subscriptionForm.newsLetterEmail = '0';
                        _this2.subscriptionForm.promotionalEmail = '0';
                        _this2.subscriptionForm.representativeCall = '0';
                    }, 2000);
                });
            }
        },
        openPanel: function openPanel(key) {
            var param = this.$route.params.feature;
            if (param) {
                if (key.toLowerCase().replace(/\s+/g, '') === param.toLowerCase().replace(/\s+/g, '')) {
                    return true;
                } else {
                    return false;
                }
            }
            return false;
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        getDateReferenceForEvent: function getDateReferenceForEvent(dte) {
            var dt = new Date(dte);
            var eHours = this.getHoursFormattedForEvents(dt);
            return eHours + ' ET';
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET';
            }
        },
        getExpertInfo: function getExpertInfo(expertId, info) {
            var reqInfo = void 0;
            if (this.getAllExperts) {
                var expert = this.getAllExperts.filter(function (exp) {
                    return exp.expertId === expertId;
                });
                if (info === 'name') {
                    reqInfo = expert[0].name;
                } else if (info === 'img') {
                    reqInfo = expert[0].small_image;
                } else if (info === 'biography') {
                    reqInfo = expert[0].biography;
                } else if (info === 'experties') {
                    reqInfo = expert[0].experties;
                }
            }
            return reqInfo;
        },
        getHoursFormattedForEvents: function getHoursFormattedForEvents(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + '' + ampm;
            return strTime;
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        },
        isUserEntrolled: function isUserEntrolled(eventId) {
            if (this.getUserEvents) {
                var filter = this.getUserEvents.filter(function (ev) {
                    return ev.eventId === eventId;
                });
                if (filter && filter.length > 0) {
                    return true;
                }
            }
            return false;
        },
        getMinutesBetweenDates: function getMinutesBetweenDates(startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime();
            return diff / 60000;
        },
        isEventToday: function isEventToday(evtDate) {
            var eventDate = new Date(evtDate);
            var currentDate = this.returnEasternTime();

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        isEventToday2: function isEventToday2(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var eventDate = new Date(evtDate);
            var eventEndDate = new Date(endDate);
            var currentDate = this.returnEasternTime();
            var switchTime = parseInt(defaultSwitchTime);
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        timeLeftInEvent: function timeLeftInEvent(evtDate) {
            var eventDate = new Date(evtDate);
            var currentDate = this.returnEasternTime();
            return this.getMinutesBetweenDates(currentDate, eventDate);
        },
        showJoin: function showJoin(bEvent) {
            if (bEvent) {
                if (this.isEventToday2(bEvent.start_date, bEvent.end_date, bEvent.eventSwitchTime, this.getEventSwitchTime)) {
                    return true;
                }
            }
            return false;
        },
        joinEvent: function joinEvent(event) {
            if (this.user) {
                this.$router.push('/event/' + event.eventId);
            } else {
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath');
                    sessionStorage.setItem('redirectPath', '/event/' + event.eventId);
                } else {
                    sessionStorage.setItem('redirectPath', '/event/' + event.eventId);
                }
                __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
            }
        },
        enrollUser: function enrollUser(event) {
            var _this3 = this;

            if (event.eventId === 1) {
                window.logEvents('Events Page', 'Tone Live Seat Reserved', 'Event Title: ' + event.title);
            } else {
                window.logEvents('Events Page', 'Tone Talk Seat Reserved', 'Event Title: ' + event.title);
            }
            this.seatReservation.eventId = event.eventId;
            this.seatReservation.userId = this.user.userId;
            this.seatReservation.status = '1';
            this.seatReservation.isAnonymous = '0';
            this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(function () {
                _this3.$store.dispatch('GETALLEXPERTS').then(function () {});
                _this3.$store.dispatch('GETUSEREVENTS', _this3.user.userId).then(function () {});
            });
        },
        returnEasternTime: function returnEasternTime() {
            var offset = -5;
            if (__WEBPACK_IMPORTED_MODULE_4__helpers_dateHelpers_js__["a" /* dateHelpers */].dstEnabled(new Date())) {
                offset = -4.0;
            }
            var clientDate = new Date();
            var utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
            var serverDate = new Date(utc + 3600000 * offset);
            return serverDate;
        },
        triggerLogin: function triggerLogin() {
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', '/events');
            } else {
                sessionStorage.setItem('redirectPath', '/events');
            }
            __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['user', 'error', 'getExpert', 'getEventList', 'getMainEvent', 'getTalkEvents', 'getLiveEvents', 'getLiveExperts', 'getTalkExperts', 'getBannerEvent', 'getMonthEvents', 'getCurrentVideo', 'getAllSiteContents', 'getEventSwitchTime', 'getAllNewsResources', 'getAllFeaturedArticles', 'getAllSetToneResources', 'getAllAdvertisementResources', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getTaggedEmailList', 'getCorporatePayload']), {
        styleObject: function styleObject() {
            if (this.hoverState) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor,
                    borderColor: this.getCorpButtonColor
                };
            } else {
                return {
                    color: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            }
        }
    })

});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dateHelpers_js__ = __webpack_require__(15);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Rules',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Event Rules',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Event Rules' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Event Rules' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            event: '',
            userEvent: '',
            seatReservation: {
                userEventId: 0,
                eventId: 0,
                userId: 0,
                status: 2,
                isAnonymous: 0
            }
        };
    },
    methods: {
        joinEvent: function joinEvent(isAnonymous) {
            var _this = this;

            this.updateUserStatus(isAnonymous);
            if (this.getSelectedEvent) {
                if (this.getSelectedEvent[0].type === '1') {
                    if (isAnonymous === '1') {
                        setTimeout(function () {
                            _this.$store.dispatch('GETUSEREVENTS', _this.user.userId).then(function () {
                                if (_this.getUserEvents) {
                                    var uEvent = _this.getUserEvents.filter(function (ev) {
                                        return ev.eventId === _this.getSelectedEvent[0].eventId;
                                    });
                                    uEvent[0].isAnonymous = '1';
                                    uEvent[0].firstName = 'Shoe-cognito';
                                    _this.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(function () {
                                        if (_this.getUserSignature) {
                                            _this.$router.push('/liveevent/' + _this.getSelectedEvent[0].eventId);
                                        }
                                    });
                                }
                            });
                        }, 500);
                    } else {
                        this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(function () {
                            if (_this.getUserSignature) {
                                _this.$router.push('/liveevent/' + _this.getSelectedEvent[0].eventId);
                            }
                        });
                    }
                } else {
                    if (isAnonymous === '1') {
                        setTimeout(function () {
                            _this.$store.dispatch('GETUSEREVENTS', _this.user.userId).then(function () {
                                if (_this.getUserEvents) {
                                    var uEvent = _this.getUserEvents.filter(function (ev) {
                                        return ev.eventId === _this.getSelectedEvent[0].eventId;
                                    });
                                    uEvent[0].isAnonymous = '1';
                                    uEvent[0].firstName = 'Shoe-cognito';
                                    _this.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(function () {
                                        if (_this.getUserSignature) {
                                            _this.$router.push('/talk/' + _this.getSelectedEvent[0].eventId);
                                        }
                                    });
                                }
                            });
                        }, 500);
                    } else {
                        this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(function () {
                            if (_this.getUserSignature) {
                                _this.$router.push('/talk/' + _this.getSelectedEvent[0].eventId);
                            }
                        });
                    }
                }
            }
        },
        returnEasternTime: function returnEasternTime() {
            var offset = -5;
            if (__WEBPACK_IMPORTED_MODULE_2__helpers_dateHelpers_js__["a" /* dateHelpers */].dstEnabled(new Date())) {
                offset = -4.0;
            }
            var clientDate = new Date();
            var utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
            var serverDate = new Date(utc + 3600000 * offset);
            return serverDate;
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET';
            }
        },
        isEventToday: function isEventToday(evtDate, endDate) {
            var eventDate = new Date(evtDate);
            var currentDate = this.returnEasternTime();
            var eventEndDate = new Date(endDate);

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= 15 && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        getMinutesBetweenDates: function getMinutesBetweenDates(startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime();
            return diff / 60000;
        },
        updateUserStatus: function updateUserStatus(status) {
            var _this2 = this;

            this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(function () {
                if (_this2.getUserEvents) {
                    var uEvent = _this2.getUserEvents.filter(function (ev) {
                        return ev.eventId === _this2.getSelectedEvent[0].eventId;
                    });
                    if (uEvent && uEvent.length > 0) {
                        _this2.seatReservation.eventId = _this2.getSelectedEvent[0].eventId;
                        _this2.seatReservation.userId = _this2.user.userId;
                        _this2.seatReservation.status = '2';
                        _this2.seatReservation.isAnonymous = status;
                        _this2.seatReservation.userEventId = uEvent[0].userEventId;
                        _this2.$store.dispatch('UPDATERESERVATION', _this2.seatReservation).then(function () {});
                    } else {
                        _this2.seatReservation.eventId = _this2.getSelectedEvent[0].eventId;
                        _this2.seatReservation.userId = _this2.user.userId;
                        _this2.seatReservation.status = '2';
                        _this2.seatReservation.isAnonymous = status;
                        _this2.$store.dispatch('SEATRESERVATION', _this2.seatReservation).then(function () {});
                    }
                }
            });
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        }
    },
    mounted: function mounted() {
        var self = this;
        if (self.$route.params.eventId) {
            self.$router.push('/event/' + self.$route.params.eventId);
        } else {
            self.$router.push('/event');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['user', 'getExpert', 'getSelectedEvent', 'getUserEvents', 'getUserSignature', 'getUserStatus', 'getTrialDays']))
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dateHelpers_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'rulescomp',
    props: ['data'],
    data: function data() {
        return {
            trialButtonTitle: 'Start Your Free Trial',
            hoverState: false,
            hoverStateCog: false,
            congnitoMsg: '',
            eventRef: null,
            event: '',
            userEvent: '',
            showRulesComp: false,
            seatReservation: {
                userEventId: 0,
                eventId: 0,
                userId: 0,
                status: 2,
                isAnonymous: 0
            }
        };
    },
    methods: {
        updateHoverState: function updateHoverState(isHover) {
            this.hoverState = isHover;
        },
        updateHoverStateCog: function updateHoverStateCog(isHover) {
            this.hoverStateCog = isHover;
        },
        UnauthJoinClick: function UnauthJoinClick(event) {
            var joinString = '/event/' + event.eventId;
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', joinString);
            } else {
                sessionStorage.setItem('redirectPath', joinString);
            }
            this.$router.push('/signup');
        },
        UnauthSignInClick: function UnauthSignInClick(event) {
            var joinString = '/event/' + event.eventId;
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', joinString);
            } else {
                sessionStorage.setItem('redirectPath', joinString);
            }
            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        joinEventUnAuth: function joinEventUnAuth(event) {
            var joinString = '/event/' + event.eventId;
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', joinString);
            } else {
                sessionStorage.setItem('redirectPath', joinString);
            }
            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        joinEvent: function joinEvent(isAnonymous) {
            var _this = this;

            console.log('1 -> RulesComp.vue -> joinEvent() -> isAnonymous = ', isAnonymous);
            this.updateUserStatus(isAnonymous);
            if (this.getSelectedEvent) {
                console.log('2 -> RulesComp.vue -> joinEvent() -> this.getSelectedEvent = ', this.getSelectedEvent);
                if (this.getSelectedEvent[0].type === '1') {
                    console.log('3 -> RulesComp.vue -> joinEvent() -> this.getSelectedEvent[0].type = ', this.getSelectedEvent[0].type);
                    if (isAnonymous === '1') {
                        console.log('4 -> RulesComp.vue -> joinEvent() -> isAnonymous = ', isAnonymous);
                        setTimeout(function () {
                            _this.$store.dispatch('GETUSEREVENTS', _this.user.userId).then(function (res) {
                                console.log('5 -> RulesComp.vue -> joinEvent() -> this.user.userId = ', _this.user.userId);
                                console.log('5B -> RulesComp.vue -> joinEvent() -> this.data.eventId = ', _this.data.eventId);
                                if (_this.getUserEvents) {
                                    var uEvent = _this.getUserEvents.filter(function (ev) {
                                        return ev.eventId === _this.data.eventId;
                                    });
                                    console.log('6 -> RulesComp.vue -> joinEvent() -> uEvent = ', uEvent);
                                    uEvent[0].isAnonymous = '1';
                                    uEvent[0].firstName = _this.user && _this.user.corporation && _this.user.corporation.showShoeMotif === 2 ? 'Incognito' : 'Shoe-cognito';
                                    uEvent[0].picture = _this.user && _this.user.corporation && _this.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile.png' : _this.user.picture;

                                    _this.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(function (res) {
                                        console.log('7 -> RulesComp.vue -> joinEvent() -> uEvent[0] = ', uEvent[0]);
                                        if (_this.getUserSignature) {
                                            console.log('8 -> RulesComp.vue -> joinEvent() -> this.getUserSignature = ', _this.getUserSignature);

                                            _this.$router.push('/liveevent/' + _this.data.eventId);
                                        }
                                    }).catch(function (err) {
                                        console.log('7A ERROR in GENERATESIGNATUREWITHEVENT ====> err = ', err);
                                    });
                                }
                            }).catch(function (err) {
                                console.log('8A ERROR in GETUSEREVENTS ====> err = ', err);
                            });
                        }, 500);
                    } else {
                        console.log('9 -> RulesComp.vue -> joinEvent() ->');

                        this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(function (res) {
                            console.log('10 -> RulesComp.vue -> joinEvent() -> this.user.userId = ', _this.user.userId);
                            if (_this.getUserSignature) {
                                console.log('11 -> RulesComp.vue -> joinEvent() -> this.getUserSignature = ', _this.getUserSignature);

                                _this.$router.push('/liveevent/' + _this.data.eventId);
                            }
                        }).catch(function (err) {
                            console.log('11A ERROR in GENERATESIGNATURE ====> err = ', err);
                        });
                    }
                } else {
                    console.log('12 -> RulesComp.vue -> joinEvent() -> isAnonymous = ', isAnonymous);
                    if (isAnonymous === '1') {
                        setTimeout(function () {
                            console.log('13 -> RulesComp.vue -> joinEvent() -> isAnonymous = ', isAnonymous);

                            _this.$store.dispatch('GETUSEREVENTS', _this.user.userId).then(function (res) {
                                console.log('14 -> RulesComp.vue -> joinEvent() -> this.user.userId = ', _this.user.userId);
                                console.log('14A -> RulesComp.vue -> joinEvent() -> this.data.eventId = ', _this.data.eventId);
                                if (_this.getUserEvents) {
                                    var uEvent = _this.getUserEvents.filter(function (ev) {
                                        return ev.eventId === _this.data.eventId;
                                    });
                                    console.log('15 -> RulesComp.vue -> joinEvent() -> uEvent[0] = ', uEvent[0]);
                                    uEvent[0].isAnonymous = '1';
                                    uEvent[0].firstName = _this.user && _this.user.corporation && _this.user.corporation.showShoeMotif === 2 ? 'Incognito' : 'Shoe-cognito';
                                    uEvent[0].picture = _this.user && _this.user.corporation && _this.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile.png' : _this.user.picture;

                                    _this.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(function (res) {
                                        console.log('16 -> RulesComp.vue -> joinEvent() -> GENERATESIGNATUREWITHEVENT');
                                        if (_this.getUserSignature) {
                                            console.log('17 -> RulesComp.vue -> joinEvent() -> this.getUserSignature = ', _this.getUserSignature);
                                            console.log('17A -> RulesComp.vue -> joinEvent() -> this.data.eventId = ', _this.data.eventId);

                                            _this.$router.push('/talk/' + _this.data.eventId);
                                        }
                                    }).catch(function (err) {
                                        console.log('17B ERROR in GENERATESIGNATUREWITHEVENT ====> err = ', err);
                                    });
                                }
                            }).catch(function (err) {
                                console.log('17C ERROR in GETUSEREVENTS ====> err = ', err);
                            });
                        }, 500);
                    } else {
                        this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(function (res) {
                            console.log('18 -> RulesComp.vue -> joinEvent() -> this.user.userId = ', _this.user.userId);
                            if (_this.getUserSignature) {
                                console.log('19 -> RulesComp.vue -> joinEvent() -> this.getUserSignature = ', _this.getUserSignature);
                                console.log('19A -> RulesComp.vue -> joinEvent() -> this.data.eventId = ', _this.data.eventId);

                                _this.$router.push('/talk/' + _this.data.eventId);
                            }
                        }).catch(function (err) {
                            console.log('19A ERROR in GENERATESIGNATURE ====> err = ', err);
                        });
                    }
                    console.log('20 -> RulesComp.vue -> joinEvent() -> COMPLETED');
                }
            }
        },
        returnEasternTime: function returnEasternTime() {
            var offset = -5;
            if (__WEBPACK_IMPORTED_MODULE_2__helpers_dateHelpers_js__["a" /* dateHelpers */].dstEnabled(new Date())) {
                offset = -4.0;
            }
            var clientDate = new Date();
            var utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
            var serverDate = new Date(utc + 3600000 * offset);
            return serverDate;
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET';
            }
        },
        isEventToday: function isEventToday(evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            var eventDate = new Date(evtDate);
            var currentDate = this.returnEasternTime();
            var eventEndDate = new Date(endDate);
            var switchTime = parseInt(defaultSwitchTime);
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime);
            }

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        getMinutesBetweenDates: function getMinutesBetweenDates(startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime();
            return diff / 60000;
        },
        updateUserStatus: function updateUserStatus(status) {
            var _this2 = this;

            this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(function (res) {
                if (_this2.getUserEvents) {
                    var uEvent = _this2.getUserEvents.filter(function (ev) {
                        console.log('1 -> updateUserStatus -> this.data.eventId = ', _this2.data.eventId);
                        return ev.eventId === _this2.data.eventId;
                    });
                    if (uEvent && uEvent.length > 0) {
                        console.log('2 -> updateUserStatus -> this.data.eventId = ', _this2.data.eventId);
                        _this2.seatReservation.eventId = _this2.data.eventId;
                        _this2.seatReservation.userId = _this2.user.userId;
                        _this2.seatReservation.status = '2';
                        _this2.seatReservation.isAnonymous = status;
                        _this2.seatReservation.userEventId = uEvent[0].userEventId;
                        _this2.$store.dispatch('UPDATERESERVATION', _this2.seatReservation).then(function () {});
                    } else {
                        console.log('3 -> updateUserStatus -> this.data.eventId = ', _this2.data.eventId);
                        _this2.seatReservation.eventId = _this2.data.eventId;
                        _this2.seatReservation.userId = _this2.user.userId;
                        _this2.seatReservation.status = '2';
                        _this2.seatReservation.isAnonymous = status;
                        _this2.$store.dispatch('SEATRESERVATION', _this2.seatReservation).then(function () {});
                    }
                }
            }).catch(function (err) {
                console.log('ERROR in -> updateUserStatus ->  GETUSEREVENTS ====> err = ', err);
            });
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        }
    },
    mounted: function mounted() {
        var self = this;
        self.eventRef = this.data;

        if (self.getTrialDays < 0) {
            self.$router.push('/becomemember');
        } else {
            if (self.user && self.user.corporation && self.user.corporation.showShoeMotif === 2) {
                self.cognitoMsg = 'incognito';
            } else {
                self.cognitoMsg = 'shoe-cognito';
            }
            if (self.eventRef.eventId > 0) {
                self.$store.dispatch('GETSELECTEDEVENT', self.eventRef.eventId).then(function (res) {
                    if (self.getSelectedEvent) {
                        self.$store.dispatch('GETEXPERT', self.getSelectedEvent[0].expertId).then(function () {});
                        if (self.user) {
                            self.$store.dispatch('GETUSEREVENTS', self.user.userId).then(function () {}).catch(function (err) {
                                console.log('ERROR in GETUSEREVENTS ====> err = ', err);
                            });
                        }
                    } else {}
                }).catch(function (err) {
                    console.log('ERROR in GETSELECTEDEVENT ====> err = ', err);
                });
            } else {}
        }
        if (self.getCorporateGiftInfo && self.getCorporateGiftInfo.button_label_01) {
            self.trialButtonTitle = self.getCorporateGiftInfo.button_label_01;
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['user', 'getExpert', 'getSelectedEvent', 'getUserEvents', 'getUserSignature', 'getUserStatus', 'getTrialDays', 'getEventSwitchTime', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getCorporateGiftInfo']), {
        styleObjectByName: function styleObjectByName() {
            if (this.hoverState) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor,
                    borderColor: this.getCorpButtonColor
                };
            } else {
                return {
                    color: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            }
        },
        styleObjectCognito: function styleObjectCognito() {
            if (this.hoverStateCog) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor,
                    borderColor: this.getCorpButtonColor
                };
            } else {
                return {
                    color: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            }
        }
    })
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pagination_2__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pagination_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_pagination_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);










/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        spinner: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["spinner"],
        alert: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["alert"],
        pagination: __WEBPACK_IMPORTED_MODULE_4_vue_pagination_2___default.a
    },
    name: 'search',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Search',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Search' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Search' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            contentToSearch: '',
            pageLimit: 6,
            pageStart: 1,
            pageEnd: 6,
            enteredValue: '',
            spinner: false,
            isBlankField: false,
            isEmptyResponse: false,
            currentPlan: '',
            signUpPath: '',
            sortOrder: false,
            tabs: {
                videos: true,
                events: false,
                playlists: false
            },
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            isNativeApp: false,
            searchResults: null,
            searchEventResults: null,
            searchPlaylistResult: null,

            page: {
                videos: 1,
                events: 1,
                playlists: 1
            },
            eventsPage: 1,
            playlistPage: 1,
            orderBy: ['asc']
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (navigator.userAgent.indexOf('gonative') > -1) {
            this.isNativeApp = true;
        }
        var currTabName = 'videos';
        var currPageNum = 1;
        var qryString = this.$route.params.qryString;
        var storedSearch = sessionStorage.getItem('searchQry');
        console.log('mounted () : storedSearch : ;' + storedSearch + ';, qryString = ;' + qryString + ';');
        var page = {
            videos: 1,
            events: 1,
            playlists: 1
        };
        if (qryString) {
            console.log('mounted () : qryString : storedSearch : ;' + storedSearch + ';, qryString = ;' + qryString + ';');
            this.contentToSearch = qryString.trim();
            this.initiateSearch();
            storedSearch = null;
        }
        if (storedSearch) {
            console.log('mounted () : storedSearch : storedSearch : ;' + storedSearch + ';, qryString = ;' + qryString + ';');
            this.contentToSearch = storedSearch.trim();
            this.loadOldSearch(qryString, page);
        }
        if (this.getMarketingPlan) {
            this.$store.dispatch('GETPLAN', this.getMarketingPlan).then(function () {
                _this.currentPlan = _this.getDefaultPlan;
                _this.signUpPath = 'signup/' + _this.getMarketingPlan;
            });
        } else {
            this.$store.dispatch('GETPLAN', '1MonthPlanChrgLate').then(function () {
                _this.currentPlan = _this.getDefaultPlan;
                _this.signUpPath = 'signup';
            });
        }

        if (sessionStorage.getItem('currTabName')) {
            currTabName = sessionStorage.getItem('currTabName');
        }
        console.log('mounted () : (sessionStorage.getItem(\'videoTabCurPageNum\')) = ' + sessionStorage.getItem('videoTabCurPageNum'));
        this.switchTab(currTabName);
        if (currTabName === 'videos') {
            if (sessionStorage.getItem('videoTabCurPageNum')) {
                currPageNum = parseInt(sessionStorage.getItem('videoTabCurPageNum'));
                console.log('mounted () : (sessionStorage.getItem(\'videoTabCurPageNum\')) = ' + sessionStorage.getItem('videoTabCurPageNum'));
            }

            if (this.getSearchResults && this.getSearchResults.length > 0) {
                this.setPage(currTabName, currPageNum, 41);
                this.page = page;
            }
        } else if (currTabName === 'events') {
            if (sessionStorage.getItem('eventTabCurPageNum')) {
                currPageNum = parseInt(sessionStorage.getItem('eventTabCurPageNum'));
            }
            if (this.getSearchExpertResults && this.getSearchExpertResults.length > 0) {
                this.setPage(currTabName, currPageNum, 42);
                this.page = page;
            }
        } else if (currTabName === 'playlists') {
            if (sessionStorage.getItem('plistTabCurPageNum')) {
                currPageNum = parseInt(sessionStorage.getItem('plistTabCurPageNum'));
            }
            if (this.getSearchPlaylistResults && this.getSearchPlaylistResults.userPlaylists && this.getSearchPlaylistResults.userPlaylists.length > 0) {
                this.setPage(currTabName, currPageNum, 43);
                this.page = page;
            }
        }
        console.log('mounted () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum);
        console.log('mounted () : this.user.userId : ;' + this.user.userId + ';, this.user = ;' + this.user + '; this.contentToSearch = ;' + this.contentToSearch + ';');
        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user && this.user.userId).then(function () {});

        this.$store.dispatch('GETUSERPLAYLISTS', this.user && this.user.userId).then(function () {});
    },

    methods: {
        formattedDuration: function formattedDuration(duration) {
            var hours = Math.floor(duration / 3600);
            var minutes = Math.floor(duration % 3600 / 60);
            var seconds = duration % 60;
            var formattedHours = hours > 0 ? hours + ':' : '';
            var formattedMinutes = minutes > 0 ? minutes + ':' : '0:';
            var formattedSeconds = seconds < 10 ? '0' + seconds : '' + seconds;
            return '' + formattedHours + formattedMinutes + formattedSeconds;
        },

        sort: function sort(value) {
            var _this2 = this;

            var corpId = 0;
            if (this.user && this.user.corporation && this.user.corporation.corporationId > 0) {
                corpId = this.user.corporation.corporationId;
            }
            this.spinnerToggle();
            var searchObject = {
                userId: this.user.userId,
                contentToSearch: this.contentToSearch,
                corporationId: corpId,
                sortby: value,
                sortorder: this.sortOrder ? 1 : -1
            };
            this.sortOrder = !this.sortOrder;
            this.$store.dispatch('SORTDATA', searchObject).then(function (res) {
                var lastContentToSearch = '';
                if (sessionStorage.getItem('searchQry')) {
                    lastContentToSearch = sessionStorage.getItem('searchQry');
                }
                if (_this2.contentToSearch !== lastContentToSearch) {
                    _this2.refreshSearch();
                }
                if (_this2.getSearchResults && _this2.getSearchResults.length !== 0) {
                    _this2.searchResults = _this2.getSearchResults;
                } else {
                    _this2.searchResults = null;
                }
                if (_this2.getSearchExpertResults && _this2.getSearchExpertResults.length !== 0) {
                    _this2.searchEventResults = _this2.getSearchExpertResults;
                } else {
                    _this2.searchEventResults = null;
                }
                if (_this2.getSearchPlaylistResults && _this2.getSearchPlaylistResults.userPlaylists && _this2.getSearchPlaylistResults.userPlaylists.length !== 0) {
                    _this2.searchPlaylistResult = _this2.getSearchPlaylistResults.userPlaylists;
                } else {
                    _this2.searchPlaylistResult = null;
                }

                if (_this2.searchResults === null && _this2.searchEventResults === null && _this2.searchPlaylistResult === null) {
                    _this2.isEmptyResponse = true;
                    _this2.refreshSearch();
                } else {
                    sessionStorage.setItem('searchQry', _this2.contentToSearch);
                }
                _this2.spinnerToggle();
            });
            this.$forceUpdate();
        },
        sortArrow: function sortArrow() {
            if (this.orderBy[0] === 'asc') {
                return '↑';
            }
            return '↓';
        },
        setPage: function setPage(tab, current, calledFrom) {
            var self = this;
            var totalPages, difference;
            console.log('Entered setPage : tab = ;' + tab + '; >>>> current = ;' + current + '; >>> calledFrom = ' + calledFrom);
            sessionStorage.setItem('currTabName', tab);

            if (tab === 'videos') {
                sessionStorage.setItem('videoTabCurPageNum', current);
                console.log('setPage : ================= (sessionStorage.getItem(\'videoTabCurPageNum\')) = ' + sessionStorage.getItem('videoTabCurPageNum'));
                if (self.getSearchResults && self.getSearchResults['length'] !== 0) {
                    totalPages = self.getSearchResults['length'];
                }
            } else if (tab === 'events') {
                sessionStorage.setItem('eventTabCurPageNum', current);
                if (self.getSearchExpertResults && self.getSearchExpertResults['length'] !== 0) {
                    totalPages = self.getSearchExpertResults['length'];
                }
            } else if (tab === 'playlists') {
                sessionStorage.setItem('plistTabCurPageNum', current);
                if (self.getSearchPlaylistResults && self.getSearchPlaylistResults.userPlaylists && self.getSearchPlaylistResults.userPlaylists.length !== 0) {
                    totalPages = self.getSearchPlaylistResults.userPlaylists.length;
                }
            }
            console.log('Entered setPage : totalPages = ;' + totalPages + ';');
            if (current * self.pageLimit > totalPages) {
                self.pageStart = current * self.pageLimit - self.pageLimit + 1;
                difference = current * self.pageLimit - totalPages;
                self.pageEnd = current * self.pageLimit - difference;
            } else {
                self.pageEnd = current * self.pageLimit;
                self.pageStart = self.pageEnd - self.pageLimit + 1;
            }
            self.page[tab] = current;
        },

        switchTab: function switchTab(id) {
            console.log('Entered switchTab : id = ;' + id + '; >>>>>>>>>>>>> Object.values(this.tabs) = ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.tabs));
            var currPageNum = 1;
            for (var tab in this.tabs) {
                if (id === 'videos') {
                    if (sessionStorage.getItem('videoTabCurPageNum')) {
                        currPageNum = parseInt(sessionStorage.getItem('videoTabCurPageNum'));
                        console.log('switchTab () : id = ' + id + ' >>> currPageNum = ' + currPageNum);
                    }
                } else if (id === 'events') {
                    if (sessionStorage.getItem('eventTabCurPageNum')) {
                        currPageNum = parseInt(sessionStorage.getItem('eventTabCurPageNum'));
                        console.log('switchTab () : id = ' + id + ' >>> currPageNum = ' + currPageNum);
                    }
                } else if (id === 'playlists') {
                    if (sessionStorage.getItem('plistTabCurPageNum')) {
                        currPageNum = parseInt(sessionStorage.getItem('plistTabCurPageNum'));
                        console.log('switchTab () : id = ' + id + ' >>> currPageNum = ' + currPageNum);
                    }
                }
                this.setPage(id, currPageNum, 5);
                this.tabs[tab] = id === tab;
                console.log('Entered switchTab : tab = ;' + tab + '; >>>>>>>>>>>>> Object.values(this.page) = ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.page));
            }
        },
        redirectToSignUp: function redirectToSignUp() {
            if (this.getMarketingPlan) {
                this.$router.push('/signup/' + this.getMarketingPlan);
            } else {
                this.$router.push('/signup');
            }
        },
        loadOldSearch: function loadOldSearch(qry, page) {
            var _this3 = this;

            console.log('Entered loadOldSearch');
            console.log('Entered loadOldSearch : qry = ;' + qry + '; >>>>> page = ;' + page + '; this.contentToSearch = ;' + this.contentToSearch + ';');
            console.log('Entered loadOldSearch : this.pageStart = ;' + this.pageStart + '; >>>>> this.pageEnd = ;' + this.pageEnd + ';');
            this.pageStart = 1;
            this.pageEnd = 6;
            if (this.contentToSearch.length !== 0) {
                this.enteredValue = this.contentToSearch;
                this.isBlankField = false;
                this.isEmptyResponse = false;
                this.spinnerToggle();
                var corpId = 0;
                if (this.user && this.user.corporation && this.user.corporation.corporationId > 0) {
                    corpId = this.user.corporation.corporationId;
                }
                var params = {
                    userId: this.user && this.user.userId,
                    contentToSearch: this.contentToSearch,
                    corporationId: corpId,
                    sortby: '_score',
                    sortorder: -1
                };
                this.$store.dispatch('GETSEARCHRESULTS_POST', params).then(function () {
                    window.logEvents('Search Page', 'click', 'Title Searched: ' + _this3.contentToSearch);
                    var lastContentToSearch = '';
                    if (sessionStorage.getItem('searchQry')) {
                        lastContentToSearch = sessionStorage.getItem('searchQry');
                    }
                    if (_this3.contentToSearch !== lastContentToSearch) {
                        _this3.refreshSearch();
                    }

                    if (_this3.getSearchResults && _this3.getSearchResults.length !== 0) {
                        _this3.searchResults = _this3.getSearchResults;
                    } else {
                        _this3.searchResults = null;
                    }
                    if (_this3.getSearchExpertResults && _this3.getSearchExpertResults.length !== 0) {
                        _this3.searchEventResults = _this3.getSearchExpertResults;
                    } else {
                        _this3.searchEventResults = null;
                    }
                    if (_this3.getSearchPlaylistResults && _this3.getSearchPlaylistResults.userPlaylists && _this3.getSearchPlaylistResults.userPlaylists.length !== 0) {
                        _this3.searchPlaylistResult = _this3.getSearchPlaylistResults.userPlaylists;
                    } else {
                        _this3.searchPlaylistResult = null;
                    }

                    if (_this3.searchResults === null && _this3.searchEventResults === null && _this3.searchPlaylistResult === null) {
                        _this3.isEmptyResponse = true;
                        _this3.refreshSearch();
                    } else {
                        sessionStorage.setItem('searchQry', _this3.contentToSearch);
                    }

                    var currTabName = 'videos';
                    var currPageNum = 1;
                    if (sessionStorage.getItem('currTabName')) {
                        currTabName = sessionStorage.getItem('currTabName');
                        console.log('loadOldSearch () : currTabName = ' + currTabName);
                    }
                    if (currTabName === 'videos') {
                        if (sessionStorage.getItem('videoTabCurPageNum')) {
                            currPageNum = parseInt(sessionStorage.getItem('videoTabCurPageNum'));
                            console.log('loadOldSearch () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum);
                        }
                    } else if (currTabName === 'events') {
                        if (sessionStorage.getItem('eventTabCurPageNum')) {
                            currPageNum = parseInt(sessionStorage.getItem('eventTabCurPageNum'));
                            console.log('loadOldSearch () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum);
                        }
                    } else if (currTabName === 'playlists') {
                        if (sessionStorage.getItem('plistTabCurPageNum')) {
                            currPageNum = parseInt(sessionStorage.getItem('plistTabCurPageNum'));
                            console.log('loadOldSearch () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum);
                        }
                    }
                    console.log('loadOldSearch () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum);

                    _this3.setPage(currTabName, currPageNum, 6);
                    _this3.spinnerToggle();
                });
            } else {
                this.$swal({
                    title: 'Please type something, the input field seems to be blank.',
                    text: '',
                    type: 'question',
                    timer: 3000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(function () {}, function (dismiss) {
                    if (dismiss === 'timer') {}
                });
            }
        },
        initiateSearch: function initiateSearch() {
            var _this4 = this;

            console.log('Entered : initiateSearch');
            this.page.videos = 1;
            this.page.events = 1;
            this.page.playlists = 1;
            this.pageStart = 1;
            this.pageEnd = 6;
            if (this.contentToSearch.length !== 0) {
                this.enteredValue = this.contentToSearch;
                this.isBlankField = false;
                this.isEmptyResponse = false;
                this.spinnerToggle();
                var corpId = 0;
                if (this.user && this.user.corporation && this.user.corporation.corporationId > 0) {
                    corpId = this.user.corporation.corporationId;
                }

                var params = {
                    userId: this.user && this.user.userId,
                    contentToSearch: this.contentToSearch,
                    corporationId: corpId,
                    sortby: '_score',
                    sortorder: -1
                };
                this.$store.dispatch('GETSEARCHRESULTS_POST', params).then(function () {
                    window.logEvents('Search Page', 'click', 'Title Searched: ' + _this4.contentToSearch);
                    var lastContentToSearch = '';
                    if (sessionStorage.getItem('searchQry')) {
                        lastContentToSearch = sessionStorage.getItem('searchQry');
                    }
                    if (_this4.contentToSearch !== lastContentToSearch) {
                        _this4.refreshSearch();
                    }

                    if (_this4.getSearchResults && _this4.getSearchResults.length !== 0) {
                        _this4.searchResults = _this4.getSearchResults;
                        setTimeout(function () {}, 5000);
                    } else {
                        _this4.searchResults = null;
                    }
                    if (_this4.getSearchExpertResults && _this4.getSearchExpertResults.length !== 0) {
                        _this4.searchEventResults = _this4.getSearchExpertResults;
                    } else {
                        _this4.searchEventResults = null;
                    }
                    if (_this4.getSearchPlaylistResults && _this4.getSearchPlaylistResults.userPlaylists && _this4.getSearchPlaylistResults.userPlaylists.length !== 0) {
                        _this4.searchPlaylistResult = _this4.getSearchPlaylistResults.userPlaylists;
                    } else {
                        _this4.searchPlaylistResult = null;
                    }

                    if (_this4.searchResults === null && _this4.searchEventResults === null && _this4.searchPlaylistResult === null) {
                        _this4.isEmptyResponse = true;
                        _this4.refreshSearch();
                    } else {
                        sessionStorage.setItem('searchQry', _this4.contentToSearch);
                    }
                    _this4.spinnerToggle();
                });
            } else {
                this.$swal({
                    title: 'Please type something, the input field seems to be blank.',
                    text: '',
                    type: 'question',
                    timer: 3000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(function () {}, function (dismiss) {
                    if (dismiss === 'timer') {}
                });
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode, videoTitle) {
            if (this.user && this.getTrialDays < 0) {
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath');
                    sessionStorage.setItem('redirectPath', '/watch/' + videoCode + '/' + videoTitle.replace(/\\s/g, '-').toLowerCase());
                } else {
                    sessionStorage.setItem('redirectPath', '/watch/' + videoCode + '/' + videoTitle.replace(/\\s/g, '-').toLowerCase());
                }
                this.$router.push('/becomemember');
            } else if (this.user) {
                this.$router.push('/watch/' + videoCode + '/' + videoTitle.replace(/\\s/g, '-').toLowerCase());
            } else {
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath');
                    sessionStorage.setItem('redirectPath', '/watch/' + videoCode + '/' + videoTitle.replace(/\\s/g, '-').toLowerCase());
                } else {
                    sessionStorage.setItem('redirectPath', '/watch/' + videoCode + '/' + videoTitle.replace(/\\s/g, '-').toLowerCase());
                }
                __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        limitTo: function limitTo(arr) {
            console.log('Entered : limitTo');
            console.log('Entered : limitTo = ;' + arr + '; >>> this.pageStart = ;' + this.pageStart + '; >>> this.pageEnd = ;' + this.pageEnd + ';');
            if (Array.isArray(arr)) {
                var currTabName = 'videos';
                var currPageNum = 1;
                if (sessionStorage.getItem('currTabName')) {
                    currTabName = sessionStorage.getItem('currTabName');
                    console.log('11 limitTo () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum);
                }
                if (currTabName === 'videos') {
                    if (sessionStorage.getItem('videoTabCurPageNum')) {
                        currPageNum = parseInt(sessionStorage.getItem('videoTabCurPageNum'));
                        console.log('22 limitTo () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum);
                    }
                } else if (currTabName === 'events') {
                    if (sessionStorage.getItem('eventTabCurPageNum')) {
                        currPageNum = parseInt(sessionStorage.getItem('eventTabCurPageNum'));
                        console.log('33 limitTo () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum);
                    }
                } else if (currTabName === 'playlists') {
                    if (sessionStorage.getItem('plistTabCurPageNum')) {
                        currPageNum = parseInt(sessionStorage.getItem('plistTabCurPageNum'));
                        console.log('44 limitTo () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum);
                    }
                }
                console.log('55 limitTo () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum);
                this.setPage(currTabName, currPageNum, 7);
                return arr && arr.slice(this.pageStart - 1, this.pageEnd);
            }
            return [];
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos && this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoStatus: function setVideoStatus(videoObject) {
            var _this5 = this;

            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos && this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0';
                    } else {
                        exists[0].liked = '1';
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(function () {
                        _this5.$store.dispatch('GETAUTHUSERVIDEOS', _this5.user.userId);
                    });
                } else {
                    var logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    };
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {
                        _this5.$store.dispatch('GETAUTHUSERVIDEOS', _this5.user.userId);
                    });
                }
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists && this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists && this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this6 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this6.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        refreshSearch: function refreshSearch() {
            console.log('refreshSearch () ===============================> : ');
            sessionStorage.removeItem('searchQry');
            sessionStorage.removeItem('currTabName');
            sessionStorage.removeItem('videoTabCurPageNum');
            sessionStorage.removeItem('eventTabCurPageNum');
            sessionStorage.removeItem('plistTabCurPageNum');
        },
        playPlaylist: function playPlaylist(playlistId, videoCode) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/playlist/' + playlistId + '/play/' + videoCode);
            }
        },
        playTrendingPlaylist: function playTrendingPlaylist(playlistId, videoCode, videoTitle) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/playlist/trending/' + playlistId + '/play/' + videoCode + '/' + videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
            }
        },
        playCorpPlaylist: function playCorpPlaylist(playlistId, videoCode, playlistTitle) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/playlist/' + playlistId + '/play/' + videoCode + '/' + this.user.corporation.corporationId + '/' + playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
            }
        },
        playVideoFunc: function playVideoFunc(videoCode, videoTitle) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/watch/' + videoCode + '/' + videoTitle.replace(/\\s/g, '-').toLowerCase());
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'getSearchResults', 'getSearchExpertResults', 'getSearchPlaylistResults', 'user', 'getDefaultPlan', 'getAllPlans', 'getMarketingPlan', 'getAuthUserVideos', 'getUserPlaylists', 'getTrialDays', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor']), {
        mFunc: function mFunc() {
            return this.searchResults.length;
        }
    })
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"]
    },
    name: 'setthetone',
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.sTitle,
            meta: [{ property: 'og:image', content: self.sImage }, { property: 'og:title', content: self.sTitle }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: self.sDesc
            }, { property: 'twitter:title', content: self.sTitle }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.sImage }, {
                property: 'twitter:description',
                content: self.sDesc
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            success: false,
            successMsg: '',
            contactForm: {
                emailAddress: '',
                phoneNumber: '',
                reason: '',
                comments: ''
            },
            videoURL: window.location.href,
            articleList: null,
            articleObject: null,
            articleId: 0,
            spinner: false,
            sharingTitle: 'TONE Networks, Set the Tone of Your Life',
            sharingDescription: 'Give the gift of knowledge and inspiration to the women you care about',
            toggleSpinner: false,
            sTitle: '',
            sImage: '',
            sDesc: ''
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'user', 'getAllArticles', 'getSelectedArticle'])),
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        redirectToNextArticle: function redirectToNextArticle(article) {
            this.$router.push('/setthetone/article/' + article.toneArticleId + '/' + article.articleHead.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
        }
    },
    watch: {
        '$route.params.articleId': function $routeParamsArticleId(to, from) {
            var self = this;

            self.articleId = self.$route.params.articleId;
            if (self.articleId > 0) {
                self.toggleSpinner = true;
                self.videoURL = window.location.href;

                self.$store.dispatch('GETALLARTICLES').then(function () {
                    if (self.getAllArticles) {
                        self.articleList = null;
                        self.articleList = self.getAllArticles.filter(function (x) {
                            return x.toneArticleId.toString() !== self.articleId.toString();
                        });
                    }
                });

                self.$store.dispatch('GETSELECTEDARTICLE', self.articleId).then(function () {
                    if (self.getSelectedArticle) {
                        self.articleObject = self.getSelectedArticle;
                        self.sTitle = 'TONE Article | ' + self.articleObject.articleHead;
                        self.sImage = self.articleObject.imageUrl;
                        self.sDesc = self.articleObject.paragraph1;
                        self.$store.dispatch('CACHEPAGE', window.location.href);
                        self.toggleSpinner = false;
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        var self = this;
        if (self.$route.params.articleId && self.$route.params.articleId > 0) {
            self.articleId = self.$route.params.articleId;
            self.$store.dispatch('GETALLARTICLES').then(function () {
                if (self.getAllArticles) {
                    self.articleList = self.getAllArticles.filter(function (x) {
                        return x.toneArticleId.toString() !== self.articleId.toString();
                    });
                }
            });
            self.$store.dispatch('GETSELECTEDARTICLE', self.articleId).then(function () {
                if (self.getSelectedArticle) {
                    self.articleObject = self.getSelectedArticle;
                    self.sTitle = 'TONE Article | ' + self.articleObject.articleHead;
                    self.sDesc = self.articleObject.paragraph1;
                    self.sImage = self.articleObject.imageUrl;
                    console.log('article', self.getSelectedArticle);
                }
            });
            self.$store.dispatch('CACHEPAGE', window.location.href);
        } else {
            self.$router.push('/');
        }
    }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_dateHelpers_js__ = __webpack_require__(15);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'player',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default.a
    },
    data: function data() {
        return {
            activeTab: 0,
            currentVideo: '',
            currentStatus: '',
            currentVideoCode: '',
            recommendationList: '',
            videoCompleted: false,
            videoSqueeze: false,
            hideLeftVideoIcons: false,
            addRightHoverWidthClass: false,
            addIconHoverWidthClass: false,
            showRateHoverBox: false,
            showShareHoverBox: false,
            showEnjoyHoverBox: false,
            addRightHoverEnjoyClass: false,
            addEnjoyHoverClass: false,
            captionTrack: '',
            viewTranscript: false,
            ratingOne: false,
            ratingTwo: false,
            ratingThree: false,
            ratingFour: false,
            hideAll: false,
            videoMessage: '',
            videoMessageIndex: Math.floor(Math.random() * 7),
            videoGif: '',
            videoGifIndex: Math.floor(Math.random() * 4),
            videoURL: window.location.href,
            playlistVideos: null,
            videoIndex: 0,
            showPlaylist: false,
            eventRef: null,
            titleURL: ''
        };
    },
    methods: {
        copyPlaylist: function copyPlaylist(playlistId, userId) {
            var self = this;
            var sharedPayload = {
                playlistId: playlistId,
                sharedToUserId: userId
            };
            this.$store.dispatch('COPYPLAYLIST', { copyPlaylistObject: sharedPayload }).then(function () {
                if (self.getCopiedPlaylistObject) {
                    self.$swal({
                        title: 'Playlist Created',
                        text: 'Redirecting..',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    self.$router.push('/playlist/' + self.getCopiedPlaylistObject[0].playlistId + '/play/' + self.$route.params.videoCode);
                } else {
                    self.$swal({
                        title: 'Playlist could not be created',
                        text: '',
                        type: 'error',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                }
            });
        },
        sortPlaylist: function sortPlaylist(a, b) {
            if (parseInt(a.eventVideoId) < parseInt(b.eventVideoId)) {
                return -1;
            }
            if (parseInt(a.eventVideoId) > parseInt(b.eventVideoId)) {
                return 1;
            }
            return 0;
        },
        getVideoIndex: function getVideoIndex(videoArray, videoCode) {
            var index;
            for (var i = 0; i < videoArray.length; ++i) {
                if (videoArray[i].videoCode === videoCode) {
                    index = i;
                    break;
                }
            }
            return index + 1;
        },
        toggleViewTranscript: function toggleViewTranscript() {
            this.viewTranscript = !this.viewTranscript;
        },
        redirectToRelatedVideos: function redirectToRelatedVideos() {
            this.$router.push('/relatedvideos');
        },
        getNextVideo: function getNextVideo(index) {
            if (index >= 0 && index < this.playlistVideos.length - 1) {
                return this.playlistVideos[index + 1];
            } else {
                return null;
            }
        },
        playVideo: function playVideo(playlistId, videoCode) {
            if (this.user) {
                this.$router.push('/playlistshare/' + playlistId + '/play/' + videoCode);
                window.location.reload();
            } else {
                if (this.getVideoIndex(this.playlistVideos, videoCode) <= 3) {
                    this.$router.push('/playlistshare/' + playlistId + '/play/' + videoCode);
                    window.location.reload();
                }
            }
        },
        onVideoComplete: function onVideoComplete() {
            var nextVideoReference = this.getNextVideo(this.videoIndex - 1);
            if (nextVideoReference && this.user) {
                this.$router.push('/playlistshare/' + this.$route.params.playlistId + '/play/' + nextVideoReference.videoCode);
                window.location.reload();
            } else {
                if (nextVideoReference && this.getVideoIndex(this.playlistVideos, nextVideoReference.videoCode) <= 3) {
                    this.$router.push('/playlistshare/' + this.$route.params.playlistId + '/play/' + nextVideoReference.videoCode);
                    window.location.reload();
                }
            }
        },
        setUserLike: function setUserLike() {
            var _this = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / this.getCurrentVideo[0].duration * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            if (this.currentStatus.liked === '1') {
                this.currentStatus.liked = '0';
            } else {
                this.currentStatus.liked = '1';
            }
            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this.currentStatus = _this.getCurrentStatus;
            });
        },
        setOpinion: function setOpinion(desc) {
            var _this2 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            var opinion = '0';
            if (desc === 'travel') {
                opinion = '1';
            } else if (desc === 'dating') {
                opinion = '2';
            } else if (desc === 'news') {
                opinion = '3';
            } else if (desc === 'recipes') {
                opinion = '4';
            } else {
                opinion = '0';
            }

            if (this.currentStatus.opinion === opinion) {
                this.currentStatus.opinion = '0';
            } else {
                this.currentStatus.opinion = opinion;
            }
            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this2.currentStatus = _this2.getCurrentStatus;
            });
        },
        setRating: function setRating(rating) {
            var _this3 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            if (this.currentStatus.rating === rating) {
                this.currentStatus.rating = '0';
            } else {
                this.currentStatus.rating = rating;
            }

            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this3.currentStatus = _this3.getCurrentStatus;
            });
        },
        logVideoEntry: function logVideoEntry() {
            var logWatchedEntry = {
                videoCode: this.$route.params.videoCode,
                userId: this.user.userId,
                playlistId: null,
                playlistCode: null,
                watched: 'N',
                rating: null,
                liked: '0',
                durationWatched: 0,
                thumbnailURL: null,
                opinion: null
            };
            this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {});
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode, videoTitle) {
            this.$router.push('/watch/' + videoCode + '/' + videoTitle.replace(/\\s/g, '-').toLowerCase());
            location.reload();
        },
        applyRatingClass: function applyRatingClass(rating) {
            if (rating === this.currentStatus.rating) {
                return true;
            } else {
                return false;
            }
        },
        setCarousal: function setCarousal() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.each(function () {
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        toggleVideoCompleted: function toggleVideoCompleted() {
            var self = this;
            self.videoCompleted = true;
            setTimeout(function () {
                self.videoSqueeze = true;
            }, 200);
        },
        replayVideo: function replayVideo() {
            var videoCode = this.$route.params.videoCode;
            this.videoCompleted = false;
            this.videoSqueeze = false;
            this.$router.push('/watch/' + videoCode);
            this.setVideoPlayerObject(videoCode);
        },
        changeHeight: function changeHeight() {
            this.hideLeftVideoIcons = true;
            this.showRateHoverBox = true;
            this.addRightHoverWidthClass = true;
            this.addIconHoverWidthClass = true;
            this.showShareHoverBox = false;
            this.showEnjoyHoverBox = false;
        },
        showSharing: function showSharing() {
            this.hideLeftVideoIcons = true;
            this.showShareHoverBox = true;
            this.addRightHoverWidthClass = true;
            this.addIconHoverWidthClass = true;
            this.showRateHoverBox = false;
            this.showEnjoyHoverBox = false;
        },
        redirectToHome: function redirectToHome() {
            this.$router.push('/');
        },
        showEnjoy: function showEnjoy() {
            this.showEnjoyHoverBox = true;
            this.hideLeftVideoIcons = true;
            this.addRightHoverEnjoyClass = true;
            this.addIconHoverWidthClass = true;
            this.addEnjoyHoverClass = true;
            this.showRateHoverBox = false;
            this.showShareHoverBox = false;
        },
        resetClass: function resetClass(bool) {
            if (bool) {
                this.hideLeftVideoIcons = false;
                this.addRightHoverWidthClass = false;
                this.addRightHoverEnjoyClass = false;
                this.addIconHoverWidthClass = false;
                this.showRateHoverBox = false;
                this.showShareHoverBox = false;
                this.showEnjoyHoverBox = false;
                this.addEnjoyHoverClass = false;
            } else {}
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    },
    watch: {},
    mounted: function mounted() {
        var _this4 = this;

        var self = this;
        if (self.user && self.user.trialEndDate) {
            var endingDate = new Date(self.user.trialEndDate.substr(0, 10));
            var currentDate = new Date();
            var remainingDays = __WEBPACK_IMPORTED_MODULE_6__helpers_dateHelpers_js__["a" /* dateHelpers */].getDatesDifference(endingDate, currentDate, 'days');
            if (remainingDays < 0) {
                self.$router.push('/becomemember');
            }
        }

        if (self.$route.params.playlistId && self.$route.params.videoCode) {
            var userId = self.user ? self.user.userId : 0;
            var payload = [];
            payload.push(self.$route.params.playlistId);
            payload.push(userId);
            self.$store.dispatch('GETSHAREDPLAYLISTS', payload).then(function () {
                if (self.getUserSharedPlaylists && self.getUserSharedPlaylists[0].copiedPlaylistId === 0) {
                    var findPlaylist = self.getUserSharedPlaylists.filter(function (x) {
                        return x.playlistId.toString() === self.$route.params.playlistId.toString();
                    });
                    if (findPlaylist && findPlaylist.length > 0) {
                        if (findPlaylist[0].userPlaylistVideos) {
                            var findVideo = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                                return x.videoCode.toString() === self.$route.params.videoCode.toString();
                            });
                            if (findVideo && findVideo.length > 0) {
                                self.playlistVideos = findPlaylist[0].userPlaylistVideos;
                                self.videoIndex = _this4.getVideoIndex(findPlaylist[0].userPlaylistVideos, self.$route.params.videoCode);

                                self.$store.dispatch('GETCURRENTVIDEO', self.user ? self.$route.params.videoCode : findVideo[0].promoVideoCode).then(function () {
                                    var video = _this4.getCurrentVideo;
                                    self.currentVideo = {
                                        video: video[0].sources[video[0].sources.length - 1].file,
                                        title: video[0].title,
                                        img: video[0].image,
                                        playerID: new Date(),
                                        tracks: video[0].tracks,
                                        Description: video[0].description,
                                        mediaId: video[0].mediaid
                                    };
                                    self.$store.dispatch('GETEXPERT', video[0].expertid).then(function () {});
                                });

                                self.$store.dispatch('GETVIDEOTRANSCRIPT', self.$route.params.videoCode).then(function () {});

                                if (self.user) {
                                    self.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', self.user.userId).then(function () {
                                        var filteredList = _this4.getAuthRecommendedVideos.filter(function (code) {
                                            return code.mediaid !== _this4.currentVideoCode;
                                        });
                                        _this4.recommendationList = filteredList;
                                        setTimeout(function () {
                                            _this4.setCarousal();
                                        }, 2000);
                                    });
                                }
                            } else {
                                console.info('1');
                                self.$router.push('/');
                            }
                        } else {
                            console.info('2');
                            self.$router.push('/');
                        }
                    } else {
                        console.info('3');
                        self.$router.push('/');
                    }
                } else if (self.getUserSharedPlaylists && self.getUserSharedPlaylists[0].copiedPlaylistId > 0) {
                    var newPlaylistId = self.getUserSharedPlaylists[0].copiedPlaylistId;
                    self.$router.push('/playlist/' + newPlaylistId + '/play/' + self.$route.params.videoCode);
                } else {
                    console.info('5');
                    self.$router.push('/');
                }
            });
        } else {
            console.info('6');
            self.$router.push('/');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert', 'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getUserPlaylists', 'getArchivePlaylist', 'getUserSharedPlaylists', 'getCopiedPlaylistObject']))
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_masked_input__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(13);









/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["accordion"],
        'masked-input': __WEBPACK_IMPORTED_MODULE_4_vue_masked_input__["a" /* default */],
        'panel': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["panel"],
        alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
        dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["dropdown"],
        radio: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["radio"],
        VuePassword: __WEBPACK_IMPORTED_MODULE_3_vue_password___default.a,
        checkbox: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        tabs: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tabs"],
        tab: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tab"],
        buttonGroup: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"],
        modal: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["modal"]
    },
    name: 'signUp',
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: 'TONE Networks | ' + self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            GifteeUser: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                packageId: 0,
                phoneNumber: '',
                comments: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/Sneakers.png'
            },
            user: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                cardHolderName: '',
                phoneNumber: '',
                packageId: '',
                userPayments: [],
                isPaypalCustomer: '',
                paypalSubscriptionId: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/Sneakers.png'
            },

            userPayments: {
                token: '',
                stripeCardId: '',
                paymentType: 'CC',
                paymentDate: new Date(),
                paypalPayerId: '',
                paypalPaymentId: '',
                paymentMethodNonce: ''
            },
            emailPattern: "^[a-zA-Z0-9._%+'\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}(\\.[a-zA-Z]{2,})?$",
            phoneNumber: '',
            spinner: false,
            alert: false,
            passwordError: '',
            confirmPassword: '',
            stripe: '',
            card: '',
            panelStatus: false,
            createSection: true,
            paymentSection: false,
            isToggle: false,
            defaultPlan: '',
            isChecked: false,
            reqPlanCode: this.$route.params.planId ? this.$route.params.planId : '1MonthPlanChrgLate',
            daysToCancel: 0,
            isStripe: true,
            packageId: 0,

            stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo',
            gateway: 'CC',
            paypalPayerID: '',
            paypalPaymentId: '',
            paypalToken: '',

            paypalResponse: '',
            giftCode: '',
            codeRedeemed: false,
            stripeErrorMessage: '',
            hidePasswordMeter: true,
            isMonthlySubscription: true,
            isAnnualSubscription: false,
            annualPlan: '',
            twoYearPlan: '',
            planAmount: 0,
            showPlanForm: false,
            currentPlanSelection: '',
            isFreePreviewEnabled: false,
            implementFreePlan: false,
            dynamic_bullet_1: '',
            dynamic_bullet_2: '',
            dynamic_bullet_3: '',
            dynamic_bullet_4: '',
            dynamic_bullet_5: '',
            dynamic_bullet_6: '',
            rawPhoneNumber: '',
            freeServiceFlag: false,
            paidServiceFlag: false,
            showResetModal: false,
            metaTag_pageTitle: 'TONE Networks | Sign-up',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: ''
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (navigator.userAgent.indexOf('gonative') > -1) {
            this.$router.push('/joinnative');
        } else if (this.getCorporateClient) {
            if (this.getCorporateClient.invitationCode === '2') {
                this.$router.push('/corporation/referral/buy/' + this.getCorporateClientId + '/' + this.getCorporateGiftingCode);
            } else {
                this.$router.push('/corporationgifting/' + this.getCorporateClientId + '/' + this.getCorporateGiftingCode);
            }
        }
        this.$store.dispatch('GETDYNAMICCONTENTS', 4).then(function () {
            if (_this.getAllSiteContents) {
                _this.dynamic_bullet_1 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_1');
                _this.dynamic_bullet_2 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_2');
                _this.dynamic_bullet_3 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_3');
                _this.dynamic_bullet_4 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_4');
                _this.dynamic_bullet_5 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_5');
                _this.dynamic_bullet_6 = _this.setDynamicSection(_this.getAllSiteContents, 'BULLET_6');

                _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
            }
        });
        this.$store.dispatch('GETAPPCONFIGRATION').then(function () {
            var freeService = _this.getFreePreviewStatus;
            var paidService = _this.getPaidMembershipFlag;
            if (freeService === 1) {
                _this.freeServiceFlag = true;
            } else {
                _this.freeServiceFlag = false;
            }
            if (paidService === 1) {
                _this.paidServiceFlag = true;
            } else {
                _this.paidServiceFlag = false;
            }

            console.log('free service', _this.freeServiceFlag);
            console.log('paid service', _this.paidServiceFlag);

            if (freeService === 1 && paidService === 1) {
                _this.isFreePreviewEnabled = true;
                _this.togglePlanView('trial');
            } else if (freeService === 1 && paidService === 0) {
                _this.togglePlanView('trial');
                _this.isFreePreviewEnabled = true;
                _this.showPlanForm = true;
                _this.implementFreePlan = true;
            } else if (freeService === 0 && paidService === 1) {
                _this.togglePlanView('buy');
                _this.showPlanForm = true;
                _this.mountStripeElement();
            } else {
                _this.togglePlanView('trial');
                _this.isFreePreviewEnabled = true;
                _this.showPlanForm = true;
                _this.implementFreePlan = true;
                _this.freeServiceFlag = true;
                _this.paidServiceFlag = false;
            }
        });
        this.$store.dispatch('GETPLAN', this.reqPlanCode).then(function () {
            _this.defaultPlan = _this.getDefaultPlan;
        });
        this.$store.dispatch('GETPLANS').then(function () {
            var annualPlan = _this.getAllPlans.filter(function (x) {
                return x.packageId === 32;
            });
            if (annualPlan && annualPlan.length > 0) {
                _this.annualPlan = annualPlan[0];
                _this.packageId = _this.annualPlan.packageId;
                _this.user.packageId = _this.annualPlan.packageId;
                _this.planAmount = _this.annualPlan.amount;
            }

            var twoYearPln = _this.getAllPlans.filter(function (x) {
                return x.packageId === 30;
            });
            if (twoYearPln && twoYearPln.length > 0) {
                _this.twoYearPlan = twoYearPln[0];
            }
        });
        this.$store.dispatch('GETPAYPALTOKEN');

        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(':input').blur(function () {
            if (__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).attr('name') !== 'password' && __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).attr('id') !== 'signuptermsconditionschckbox') {
                if (__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).val().length > 0) {
                    window.logEvents('Signup Page', 'Signup Page: Field.' + __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).attr('name'), 'Signup Page: Field.' + __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).attr('name') + ', val: ' + __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).val());
                } else {
                    window.logEvents('Signup Page', 'Signup Page: Field.' + __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).attr('name'), 'Signup Page: Field.' + __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).attr('name') + ', val: ' + 'skipped');
                }
            }
        });
    },

    methods: {
        SetupLogin: function SetupLogin() {
            this.showResetModal = false;
            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        cancelResetModal: function cancelResetModal() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showResetModal = false;
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        onSubmitForgetRequest: function onSubmitForgetRequest() {
            var self = this;
            console.log('email', self.user.email);

            this.$store.dispatch('FORGOTPASSWORD', { user: self.user }).then(function () {
                if (self.error.show) {
                    self.$swal({
                        title: self.error.message,
                        text: '',
                        type: 'error',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {
                            self.cancelResetModal();
                        }
                    });
                } else {
                    self.$swal({
                        title: 'Forgot Password Request Sent! Check your email and follow the reset link',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {
                            self.cancelResetModal();
                        }
                    });
                }
            });
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        togglePlanView: function togglePlanView(type) {
            var _this2 = this;

            if (type === this.currentPlanSelection) {} else {
                this.currentPlanSelection = type;
                this.showPlanForm = !this.showPlanForm;
                setTimeout(function () {
                    _this2.showPlanForm = true;
                }, 500);
                if (type === 'buy') {
                    this.implementFreePlan = false;
                    this.mountStripeElement();
                } else {
                    this.implementFreePlan = true;
                }
            }
        },
        applyActiveClass: function applyActiveClass(type) {
            if (this.currentPlanSelection === type) {
                return true;
            } else {
                return false;
            }
        },
        mountbraintree: function mountbraintree() {
            var self = this;
            if (self.getPaypalToken) {
                window.braintree.client.create({
                    authorization: 'production_6r7mxqgh_htw3nq9wp32w8h2x'
                }, function (clientErr, clientInstance) {
                    if (clientErr) {
                        console.error('Error creating client:', clientErr);
                        return;
                    }

                    window.braintree.paypalCheckout.create({
                        client: clientInstance
                    }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                        if (paypalCheckoutErr) {
                            console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
                            return;
                        }

                        window.paypal.Button.render({
                            env: 'production',
                            payment: function payment() {
                                return paypalCheckoutInstance.createPayment({
                                    flow: 'vault',
                                    amount: self.planAmount,
                                    currency: 'USD',
                                    intent: 'sale'
                                });
                            },
                            onAuthorize: function onAuthorize(data, actions) {
                                return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
                                    self.userPayments.paymentMethodNonce = payload.nonce;
                                });
                            },
                            onCancel: function onCancel(data) {},
                            onError: function onError(err) {
                                console.error('checkout.js error', err);
                            }
                        }, '#paypal-button').then(function () {});
                    });
                });
            }
        },
        redeemCode: function redeemCode() {
            var _this3 = this;

            if (this.giftCode && this.giftCode.length > 0) {
                this.spinnerToggle();
                this.$store.dispatch('GETGIFTEE', this.giftCode).then(function () {
                    _this3.spinnerToggle();
                    if (_this3.getGiftee) {
                        _this3.user.firstName = _this3.getGiftee.gifteeFirstName;
                        _this3.user.lastName = _this3.getGiftee.gifteeLastName;
                        _this3.user.email = _this3.getGiftee.gifteeEmail;
                        _this3.user.packageId = _this3.getGiftee.packageId;
                        _this3.user.comments = _this3.getGiftee.gifteeUuid;
                        _this3.codeRedeemed = true;
                        _this3.$store.dispatch('GETPLANS').then(function () {
                            var plan = _this3.getAllPlans.filter(function (pln) {
                                return pln.packageId === _this3.getGiftee.packageId;
                            });
                            _this3.defaultPlan = plan[0];
                        });
                    }
                });
            }
        },
        togglePaymentMethods: function togglePaymentMethods() {
            var _this4 = this;

            if (this.gateway === 'paypal') {
                this.isStripe = false;
                setTimeout(function () {
                    _this4.mountbraintree();
                }, 1000);
            } else {
                this.isStripe = true;
                this.mountStripeElement();
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this5 = this;

            if (this.user && this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                this.isToggle = false;
                this.spinnerToggle();
                this.$store.dispatch('VERIFYUSEREXISTS', { email: this.user.email }).then(function () {
                    _this5.spinnerToggle();
                    if (!_this5.error.show) {
                        _this5.isToggle = true;
                        _this5.createSection = false;
                        _this5.paymentSection = true;
                        _this5.user.cardHolderName = _this5.user.firstName + ' ' + _this5.user.lastName;

                        _this5.isStripe = true;
                        _this5.gateway = 'CC';
                        _this5.mountStripeElement();
                    }
                });
            }
        },
        mountStripeElement: function mountStripeElement() {
            var _this6 = this;

            setTimeout(function () {
                _this6.stripe = window.Stripe(_this6.stripeKey);
                var elements = _this6.stripe.elements();
                _this6.card = elements.create('card');
                _this6.card.mount('#card-element');
            }, 1200);
        },
        disablePaymentPanel: function disablePaymentPanel() {
            this.panelStatus = false;
        },
        verifyPaymentSubmit: function verifyPaymentSubmit() {
            if (this.user.packageId > 0) {
                return false;
            }
            return true;
        },
        verifyPassword: function verifyPassword() {
            if (this.user.password.length >= 6) {
                var re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/;
                if (!re.test(this.user.password)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (this.user.password.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        verifyEmail: function verifyEmail() {
            if (this.user.email.length > 0) {
                var re = /^[\w\d.+'-]+@[\w\d-]+(\.[\w\d-]+)*\.[a-z]+$/i;
                if (!re.test(this.user.email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyFirstName: function verifyFirstName() {
            if (this.user.firstName.length > 0) {
                var re = /^[A-Za-z '-]+$/;
                if (!re.test(this.user.firstName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyLastName: function verifyLastName() {
            if (this.user.lastName.length > 0) {
                var re = /^[A-Za-z '-]+$/;
                if (!re.test(this.user.lastName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyCardHolderName: function verifyCardHolderName() {
            if (this.user.cardHolderName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.cardHolderName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onPaymentSubmit: function onPaymentSubmit() {
            var _this7 = this;

            var self = this;
            if (this.codeRedeemed) {
                if (this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                    this.GifteeUser.firstName = this.user.firstName;
                    this.GifteeUser.lastName = this.user.lastName;
                    this.GifteeUser.email = this.user.email.toLowerCase();
                    this.GifteeUser.password = this.user.password;
                    this.GifteeUser.packageId = this.getGiftee.packageId;
                    this.GifteeUser.comments = this.getGiftee.gifteeUuid;
                    if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                        this.GifteeUser.phoneNumber = this.phoneNumber;
                    } else {
                        this.phoneNumber = '';
                        this.GifteeUser.phoneNumber = '';
                    }
                    this.spinnerToggle();
                    this.$store.dispatch('SAVEGIFTEE', { giftee: this.GifteeUser }).then(function () {
                        if (!_this7.error.show) {
                            _this7.spinnerToggle();
                            _this7.$swal({
                                title: 'Registration Success!',
                                text: 'Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)',
                                type: 'success',
                                timer: 4000,
                                showCancelButton: false,
                                showConfirmButton: false,
                                customClass: 'sweetalert-lg-signup'
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {}
                            });
                        } else {
                            _this7.spinnerToggle();
                            if (_this7.error.show) {
                                console.log('error', _this7.error.message);
                                if (_this7.error.message.toString().toLowerCase().indexOf('already exists') > -1) {
                                    _this7.showResetModal = true;
                                } else {
                                    _this7.$swal({
                                        title: 'An Error occurred while processing the request',
                                        text: _this7.error.message,
                                        type: 'error',
                                        timer: 3000,
                                        showCancelButton: false,
                                        showConfirmButton: false
                                    }).then(function () {}, function (dismiss) {
                                        if (dismiss === 'timer') {}
                                    });
                                }
                            }
                        }
                    });
                }
            } else if (this.isFreePreviewEnabled && this.currentPlanSelection === 'trial') {
                console.info('inside free preview');
                this.user.email = this.user.email.toLowerCase();
                if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                    this.user.phoneNumber = this.phoneNumber;
                } else {
                    this.phoneNumber = '';
                    this.user.phoneNumber = '';
                }
                if (this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                    this.spinnerToggle();
                    this.user.userPayments = [];
                    this.$store.dispatch('SAVEUSERWITHFREETIRAL', { newUser: this.user }).then(function () {
                        if (!_this7.error.show) {
                            _this7.spinnerToggle();
                            _this7.$swal({
                                title: 'Registration Success!',
                                text: 'Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)',
                                type: 'success',
                                timer: 4000,
                                showCancelButton: false,
                                showConfirmButton: false,
                                customClass: 'sweetalert-lg-signup'
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {}
                            });
                        } else {
                            _this7.spinnerToggle();
                            if (_this7.error.show) {
                                console.log('error', _this7.error.message);
                                if (_this7.error.message.toString().toLowerCase().indexOf('already exists') > -1) {
                                    _this7.showResetModal = true;
                                } else {
                                    _this7.$swal({
                                        title: 'An Error occurred while processing the request',
                                        text: _this7.error.message,
                                        type: 'error',
                                        timer: 3000,
                                        showCancelButton: false,
                                        showConfirmButton: false
                                    }).then(function () {}, function (dismiss) {
                                        if (dismiss === 'timer') {}
                                    });
                                }
                            }
                        }
                    });
                }
            } else {
                if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                    this.user.phoneNumber = this.phoneNumber;
                } else {
                    this.phoneNumber = '';
                    this.user.phoneNumber = '';
                }
                if (this.gateway !== 'CC') {
                    this.user.cardHolderName = ' ';
                }
                if (this.user && this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName() && this.verifyCardHolderName()) {
                    this.spinnerToggle();
                    this.user.email = this.user.email.toLowerCase();
                    this.$store.dispatch('VERIFYUSEREXISTS', { email: this.user.email }).then(function () {
                        if (!_this7.error.show) {
                            if (_this7.gateway === 'CC') {
                                _this7.stripe.createToken(_this7.card).then(function (result) {
                                    if (result.error) {
                                        _this7.spinnerToggle();

                                        self.stripeErrorMessage = result.error.message;
                                    } else {
                                        var stripeToken = result.token.id;
                                        var cardId = result.token.card.id;

                                        _this7.userPayments.token = stripeToken;
                                        _this7.userPayments.stripeCardId = cardId;
                                        if (_this7.user.userPayments.length > 0) {
                                            _this7.user.userPayments.pop();
                                        }
                                        _this7.user.userPayments.push(_this7.userPayments);
                                        if (stripeToken) {
                                            _this7.$store.dispatch('SIGNUPWITHPAYMENTPLAN', { user: _this7.user }).then(function () {
                                                if (!_this7.error.show) {
                                                    _this7.spinnerToggle();
                                                    _this7.$swal({
                                                        title: 'Registration Success!',
                                                        text: 'Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)',
                                                        type: 'success',
                                                        timer: 4000,
                                                        showCancelButton: false,
                                                        showConfirmButton: false,
                                                        customClass: 'sweetalert-lg-signup'
                                                    }).then(function () {}, function (dismiss) {
                                                        if (dismiss === 'timer') {}
                                                    });
                                                } else {
                                                    _this7.spinnerToggle();
                                                }
                                            });
                                        }
                                    }
                                });
                            } else if (_this7.userPayments.paymentMethodNonce) {
                                if (_this7.user.userPayments.length > 0) {
                                    _this7.user.userPayments.pop();
                                }
                                _this7.user.userPayments.push(_this7.userPayments);
                                if (_this7.userPayments.paymentMethodNonce) {
                                    _this7.$store.dispatch('SIGNUPWITHPAYMENTPLAN', { user: _this7.user }).then(function () {
                                        if (!_this7.error.show) {
                                            _this7.spinnerToggle();
                                            _this7.$swal({
                                                title: 'Registration Success!',
                                                text: 'For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)',
                                                type: 'success',
                                                timer: 4000,
                                                showCancelButton: false,
                                                showConfirmButton: false,
                                                customClass: 'sweetalert-lg-signup'
                                            }).then(function () {}, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        } else {
                                            _this7.spinnerToggle();
                                            if (_this7.error.show) {
                                                console.log('error', _this7.error.message);
                                                if (_this7.error.message.toString().toLowerCase().indexOf('already exists') > -1) {
                                                    _this7.showResetModal = true;
                                                } else {
                                                    _this7.$swal({
                                                        title: 'An Error occurred while processing the request',
                                                        text: _this7.error.message,
                                                        type: 'error',
                                                        timer: 3000,
                                                        showCancelButton: false,
                                                        showConfirmButton: false
                                                    }).then(function () {}, function (dismiss) {
                                                        if (dismiss === 'timer') {}
                                                    });
                                                }
                                            }
                                        }
                                    });
                                }
                            } else {
                                _this7.spinnerToggle();
                                if (_this7.error.show) {
                                    console.log('error', _this7.error.message);
                                    if (_this7.error.message.toString().toLowerCase().indexOf('already exists') > -1) {
                                        _this7.showResetModal = true;
                                    } else {
                                        _this7.$swal({
                                            title: 'An Error occurred while processing the request',
                                            text: _this7.error.message,
                                            type: 'error',
                                            timer: 3000,
                                            showCancelButton: false,
                                            showConfirmButton: false
                                        }).then(function () {}, function (dismiss) {
                                            if (dismiss === 'timer') {}
                                        });
                                    }
                                }
                            }
                        } else {
                            if (_this7.error.show) {
                                console.log('error', _this7.error.message);
                                if (_this7.error.message.toString().toLowerCase().indexOf('already exists') > -1) {
                                    _this7.showResetModal = true;
                                } else {
                                    _this7.$swal({
                                        title: 'An Error occurred while processing the request',
                                        text: _this7.error.message,
                                        type: 'error',
                                        timer: 3000,
                                        showCancelButton: false,
                                        showConfirmButton: false
                                    }).then(function () {}, function (dismiss) {
                                        if (dismiss === 'timer') {}
                                    });
                                }
                            }
                            _this7.spinnerToggle();
                        }
                    });
                }
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['error', 'isUserLoggedIn', 'getDefaultPlan', 'getGiftee', 'getAllPlans', 'getPaypalToken', 'getFreePreviewStatus', 'getTotalTrialDays', 'getAllSiteContents', 'getCorporateClient', 'getCorporateClientId', 'getCorporateGiftingCode', 'getPaidMembershipFlag'])),
    watch: {
        'user.firstName': function userFirstName(to, from) {
            this.user.cardHolderName = this.user.firstName + ' ' + this.user.lastName;
        },
        'user.lastName': function userLastName(to, from) {
            this.user.cardHolderName = this.user.firstName + ' ' + this.user.lastName;
        },
        'packageId': function packageId(to, from) {
            this.user.packageId = this.packageId;
            if (this.packageId === 32) {
                this.planAmount = this.annualPlan.amount;
            } else if (this.packageId === 30) {
                this.planAmount = this.twoYearPlan.amount;
            } else {
                this.planAmount = this.defaultPlan.amount;
            }
        },
        'gateway': function gateway(to, from) {
            var _this8 = this;

            if (this.gateway === 'paypal') {
                this.card.unmount('#card-element');
                this.stripeErrorMessage = '';
                this.isStripe = false;
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';
                this.userPayments.paymentType = 'PayPal';
                this.user.isPaypalCustomer = '1';
                this.userPayments.paymentMethodNonce = '';
                setTimeout(function () {
                    _this8.mountbraintree();
                }, 1000);
            } else {
                this.stripeErrorMessage = '';
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';
                this.user.isPaypalCustomer = '0';
                this.userPayments.paymentType = 'CC';
                this.userPayments.paymentMethodNonce = '';
                this.isStripe = true;
                setTimeout(function () {
                    _this8.mountStripeElement();
                }, 1000);
            }
        }
    }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"]
    },
    name: 'takeawaymobile',
    data: function data() {
        return {
            success: false,
            successMsg: '',
            takeawayObject: null,
            appNavigationURL: 'https://s3.amazonaws.com/tone-assets/app/navigation'
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['error', 'user', 'getOriginalVideoCode', 'getToneTakeaways'])),
    methods: {},
    mounted: function mounted() {
        var self = this;
        if (self.user && navigator.userAgent.indexOf('gonative') > -1) {
            var info = { userId: self.user.userId };
            var jsonFile = '';
            if (self.user.corporation && self.user.corporation.enableCorporatePage === 1) {
                jsonFile = 'sidebar_auth_corp.json';
            } else {
                jsonFile = 'sidebar_auth.json';
            }
            var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info);
            window.location.href = 'gonative://registration/send?customData=' + encodeURIComponent(json);

            __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.getJSON(self.appNavigationURL + '/' + jsonFile, function (data) {
                console.log('side navigation (uath) returned', data);
                var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
                window.location.href = 'gonative://sidebar/setItems?items=' + encodeURIComponent(json);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown);
            });
            if (navigator.userAgent.indexOf('gonativeand') <= -1) {
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.getJSON(self.appNavigationURL + '/bottomNav_auth.json', function (data) {
                        console.log('bottom navigation (auth) returned', data);
                        var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
                        window.location.href = 'gonative://tabs/setTabs?tabs=' + encodeURIComponent(json);
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown);
                    });
                }, 500);
            }

            self.$store.dispatch('GETTONETAKEAWAY', self.user.userId).then(function () {
                self.takeawayObject = self.getToneTakeaways;
            });
        } else {
            self.$router.push('/');
        }
    }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Talk',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Talk Event',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Talk Event' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Talk Event' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            showParticipants: false,
            chatRollURL: '',
            eventUsersArray: [],
            eventUserArray: [],
            chatrllRef: '',
            intervalId: '',
            jwEventRef: '',
            participantCount: 0,
            seatReservation: {
                userEventId: 0,
                eventId: 0,
                userId: 0,
                status: 0,
                isAnonymous: 0
            }
        };
    },
    methods: {
        setCarousal: function setCarousal() {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('.responsive-slick-eventusers');
            $slick.each(function () {
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        leaveEvent: function leaveEvent() {
            var _this = this;

            this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(function (res) {
                if (_this.getUserEvents) {
                    var uEvent = _this.getUserEvents.filter(function (ev) {
                        return ev.eventId === _this.$route.params.eventId;
                    });
                    if (uEvent && uEvent.length > 0) {
                        _this.seatReservation.eventId = _this.$route.params.eventId;
                        _this.seatReservation.userId = _this.user.userId;
                        _this.seatReservation.status = '1';
                        _this.seatReservation.isAnonymous = '0';
                        _this.seatReservation.userEventId = uEvent[0].userEventId;
                        _this.$store.dispatch('UPDATERESERVATION', _this.seatReservation).then(function (res) {
                            _this.$store.dispatch('LEAVEEVENT').then(function () {});
                        }).catch(function (err) {
                            console.log('ERROR in UPDATERESERVATION ====> err = ', err);
                        });
                    }
                }
            }, 300).catch(function (err) {
                console.log('inside leaveEvent () : ERROR in -> GETUSEREVENTS  ====> err = ', err);
            });
        },
        refreshAttendees: function refreshAttendees() {
            var _this2 = this;

            var self = this;

            if (self.getSelectedEvent) {
                self.$store.dispatch('GETEVENTUSERS', self.$route.params.eventId).then(function (res) {
                    if (self.getEventUsers) {
                        if (!self.getSelectedEvent[0].jw_rtmp_url) {
                            self.participantCount = self.getEventUsers.lstUserEvents.length;
                            self.eventUsersArray.splice(0, self.eventUsersArray.length);
                            __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this2.$el).find('.responsive-slick-eventusers').slick('unslick');

                            self.eventUserArray = self.getEventUsers.lstUserEvents;

                            while (self.eventUserArray.length > 0) {
                                self.eventUsersArray.push(self.eventUserArray.splice(0, 9));
                            }
                            setTimeout(function () {
                                self.setCarousal();
                            }, 1000);

                            if (self.getEventUsers.upcomingEvent) {
                                self.$swal({
                                    background: '#44bda8',
                                    title: 'This TONE event has ended. Add Next Upcoming Event to Your Calendar',
                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.getEventUsers.upcomingEvent.description + ' </span>',
                                    text: '',
                                    type: null,
                                    timer: 5000,
                                    showConfirmButton: true,
                                    showCloseButton: true,
                                    showCancelButton: false,
                                    confirmButtonColor: '#f0617d',
                                    confirmButtonText: 'Find out more'
                                }).then(function () {
                                    self.$router.push('/event');
                                }, function (dismiss) {
                                    if (dismiss === 'timer') {
                                        self.$router.push('/event');
                                    }
                                });
                            }
                        } else {
                            self.participantCount = self.getEventUsers.lstUserEvents.length;

                            if (self.getEventUsers.upcomingEvent) {
                                self.$swal({
                                    background: '#44bda8',
                                    title: self.getEventUsers.scheduleUpcomingEventMsg,
                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.getEventUsers.upcomingEvent.description + ' </span>',
                                    text: '',
                                    type: null,
                                    timer: 5000,
                                    showConfirmButton: true,
                                    showCloseButton: true,
                                    showCancelButton: false,
                                    confirmButtonColor: '#f0617d',
                                    confirmButtonText: 'Find out more'
                                }).then(function () {
                                    self.$router.push('/event');
                                }, function (dismiss) {
                                    if (dismiss === 'timer') {
                                        self.$router.push('/event');
                                    }
                                });
                            }
                        }
                    }
                }).catch(function (err) {
                    console.log('inside refreshAttendees () : ERROR in -> GETEVENTUSERS ====> err = ', err);
                });
            }
        }
    },
    mounted: function mounted() {
        var self = this;
        console.log('1 -> Talk.vue -> mounted () -> self.getUserSignature', self.getUserSignature);

        if (self.getUserSignature) {
            console.log('1A -> Talk.vue -> mounted () -> self.$route.params.eventId = ', self.$route.params.eventId);

            if (self.$route.params.eventId > 0) {
                console.log('1B -> Talk.vue -> mounted () -> self.$route.params.eventId = ', self.$route.params.eventId);

                self.$store.dispatch('GETSELECTEDEVENT', self.$route.params.eventId).then(function (res) {
                    console.log('2 -> Talk.vue -> mounted () -> ');

                    if (self.getSelectedEvent) {
                        self.chatrllRef = self.getSelectedEvent.chatroll_event_name;

                        console.log('3 -> Talk.vue -> mounted () -> self.getSelectedEvent[0].eventId = ', self.getSelectedEvent[0].eventId);
                        console.log('3A -> Talk.vue -> mounted () -> self.$route.params.eventId = ', self.$route.params.eventId);

                        self.$store.dispatch('GETEVENTUSERS', self.$route.params.eventId).then(function (res) {
                            if (self.getEventUsers) {
                                console.log('4 -> Talk.vue -> mounted () -> self.getEventUsers.lstUserEvents.length = ', self.getEventUsers.lstUserEvents.length);

                                self.participantCount = self.getEventUsers.lstUserEvents.length;
                                self.eventUserArray = self.getEventUsers.lstUserEvents;

                                console.log('4.1A -> Talk.vue -> mounted () -> self.eventUserArray.length = ', self.eventUserArray.length);
                                while (self.eventUserArray.length > 0) {
                                    self.eventUsersArray.push(self.eventUserArray.splice(0, 9));
                                }
                                console.log('4A -> Talk.vue -> mounted () -> ');
                                setTimeout(function () {
                                    self.setCarousal();
                                    window['interval'] = setInterval(function () {
                                        self.refreshAttendees();
                                    }, 30000);
                                }, 1000);
                                console.log('4B -> Talk.vue -> mounted () -> ');
                            }
                        }).catch(function (err) {
                            console.log('4C : ERROR in -> GETEVENTUSERS ====> err = ', err);
                        });
                        console.log('4D -> Talk.vue -> mounted () -> ');
                    } else {
                        console.log('5 -> Talk.vue -> mounted () -> ');

                        if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1) {
                            console.log('6 -> Talk.vue -> mounted () -> going to /corporation/mycommunity');

                            self.$router.push('/corporation/mycommunity');
                        } else {
                            if (self.user && self.user.adminAccessLevel === 1) {
                                console.log('7 -> Talk.vue -> mounted () -> ');

                                self.$router.push('/event/' + self.$route.params.eventId);
                            } else {
                                console.log('8 -> Talk.vue -> mounted () -> ');

                                self.$router.push('/events');
                            }
                        }
                    }
                }).catch(function (err) {
                    console.log('7A ERROR in -> GETSELECTEDEVENT  ====> err = ', err);
                });
            } else {
                if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1) {
                    console.log('9 -> Talk.vue -> mounted () -> ');

                    self.$router.push('/corporation/mycommunity');
                } else {
                    if (self.user && self.user.adminAccessLevel === 1) {
                        console.log('10 -> Talk.vue -> mounted () -> ');

                        self.$router.push('/event/' + self.$route.params.eventId);
                    } else {
                        console.log('11 -> Talk.vue -> mounted () -> ');

                        self.$router.push('/events');
                    }
                }
            }
        } else {
            if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1) {
                console.log('12 -> Talk.vue -> mounted () -> ');
                self.$router.push('/corporation/mycommunity');
            } else {
                if (self.user && self.user.adminAccessLevel === 1) {
                    console.log('13 -> Talk.vue -> mounted () -> self.$route.params.eventId = ', self.$route.params.eventId);
                    self.$router.push('/event/' + this.$route.params.eventId);
                } else {
                    console.log('14 -> Talk.vue -> mounted () -> ');
                    self.$router.push('/events');
                }
            }
        }

        if (self.getSelectedEvent) {
            var userPic = void 0;
            if (self.user && self.user.corporation && self.user.corporation.showShoeMotif === 2) {
                userPic = 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png';
            } else {
                userPic = this.user.picture;
            }
            if (self.getUserStatus === '0') {
                self.chatRollURL = self.getSelectedEvent[0].chatroll_event_name + '&uid=' + self.user.userId + '&uname=' + self.user.firstName + '&sig=' + self.getUserSignature + '&ismod=0&upic=' + userPic;
            } else {
                var uName = 'Shoe-cognito';
                if (self.user && self.user.corporation && self.user.corporation.showShoeMotif === 2) {
                    uName = 'Incognito';
                }
                self.chatRollURL = self.getSelectedEvent[0].chatroll_event_name + '&uid=' + self.user.userId + '&uname=' + uName + '&sig=' + self.getUserSignature + '&ismod=0&upic=' + userPic;
            }
        }

        self.jwEventRef = self.getSelectedEvent[0].jw_rtmp_url;
        console.log('15 -> Talk.vue -> mounted () -> ');
        self.$store.dispatch('GETUSEREVENTS', self.user.userId).then(function () {}).catch(function (err) {
            console.log('15A ERROR in GETUSEREVENTS ====> err = ', err);
        });
    },
    beforeDestroy: function beforeDestroy() {
        this.leaveEvent();
        clearInterval(window['interval']);
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['user', 'getExpert', 'getSelectedEvent', 'getUserEvents', 'getEventUsers', 'getUserSignature', 'getUserStatus', 'getShowCountFlag', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor']))
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"]
    },
    name: 'toneteasermobile',
    data: function data() {
        return {
            success: false,
            successMsg: '',
            teaserObject: null,
            appNavigationURL: 'https://s3.amazonaws.com/tone-assets/app/navigation'
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['error', 'user', 'getOriginalVideoCode', 'getToneTeasers'])),
    methods: {},
    mounted: function mounted() {
        var self = this;
        if (self.user && navigator.userAgent.indexOf('gonative') > -1) {
            var info = { userId: self.user.userId };
            var jsonFile = '';
            if (self.user.corporation && self.user.corporation.enableCorporatePage === 1) {
                jsonFile = 'sidebar_auth_corp.json';
            } else {
                jsonFile = 'sidebar_auth.json';
            }
            var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info);
            window.location.href = 'gonative://registration/send?customData=' + encodeURIComponent(json);

            __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.getJSON(self.appNavigationURL + '/' + jsonFile, function (data) {
                console.log('side navigation (uath) returned', data);
                var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
                window.location.href = 'gonative://sidebar/setItems?items=' + encodeURIComponent(json);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown);
            });
            if (navigator.userAgent.indexOf('gonativeand') <= -1) {
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.getJSON(self.appNavigationURL + '/bottomNav_auth.json', function (data) {
                        console.log('bottom navigation (auth) returned', data);
                        var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
                        window.location.href = 'gonative://tabs/setTabs?tabs=' + encodeURIComponent(json);
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown);
                    });
                }, 500);
            }

            self.$store.dispatch('GETTONETEASER', self.user.userId).then(function () {
                self.teaserObject = self.getToneTeasers;
            });
        } else {
            self.$router.push('/');
        }
    }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"]
    },
    name: 'login',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Terms',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Terms' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Terms' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            success: false,
            successMsg: '',
            contactForm: {
                emailAddress: '',
                phoneNumber: '',
                reason: '',
                comments: ''
            },
            spinner: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['error', 'user', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'])),
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this = this;

            if (this.contactForm.emailAddress && this.contactForm.phoneNumber) {
                this.spinnerToggle();
                this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(function () {
                    _this.success = true;
                    _this.successMsg = 'Your message has been sent, we will get back to you shortly!';
                    _this.spinnerToggle();
                });
            }
        }
    }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'checkbox': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["checkbox"],
        'button-group': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["buttonGroup"]
    },
    name: 'topic',
    data: function data() {
        this.$store.dispatch('INTEREST').then(function () {
            console.log('interest request data');
        });
        return {
            interestIndexes: [],
            spinner: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['interests'])),
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        filteredInterest: function filteredInterest(interestIndexes) {
            var vm = this;
            var selectedInterest = [];
            for (var i = 0; i < interestIndexes.length; i++) {
                selectedInterest.push(vm.interests[interestIndexes[i]]);
            }
            return selectedInterest;
        },
        proceedUserInfo: function proceedUserInfo() {
            var vm = this;
            if (vm.interestIndexes.length) {
                vm.spinnerToggle();
                setTimeout(function () {
                    vm.$store.dispatch('SIGNUP', { interest: vm.filteredInterest(vm.interestIndexes) }).then(function () {
                        vm.spinnerToggle();
                    });
                }, 1000);
            }
        }
    }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayListTemp_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayListTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayListTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuedraggable__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'player',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        draggable: __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayListTemp_vue___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: 'TONE Playlist | ' + self.currentVideo.title,
            meta: [{ property: 'og:image', content: self.currentVideo.img }, { property: 'og:title', content: self.currentVideo.title + ' | TONE Networks' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: self.currentVideo.Description
            }, { property: 'twitter:title', content: self.currentVideo.title + ' | TONE Networks' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.currentVideo.img }, {
                property: 'twitter:description',
                content: self.currentVideo.Description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            hoverState: false,
            hoverStateTranscript: false,
            activeTab: 0,
            currentVideo: '',
            currentStatus: '',
            currentVideoCode: this.$route.params.videoCode,
            recommendationList: '',
            videoCompleted: false,
            videoSqueeze: false,
            hideLeftVideoIcons: false,
            addRightHoverWidthClass: false,
            addIconHoverWidthClass: false,
            showRateHoverBox: false,
            showShareHoverBox: false,
            showEnjoyHoverBox: false,
            addRightHoverEnjoyClass: false,
            addEnjoyHoverClass: false,
            captionTrack: '',
            viewTranscript: false,
            ratingOne: false,
            ratingTwo: false,
            ratingThree: false,
            ratingFour: false,
            hideAll: false,
            videoMessage: '',
            videoMessageIndex: Math.floor(Math.random() * 7),
            videoGif: '',
            videoGifIndex: Math.floor(Math.random() * 4),
            videoURL: window.location.href,
            playlistVideos: null,
            videoIndex: 0,
            showPlaylist: false,
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            isMobileOrDesktop: false,
            showMenuOptions: false,
            dragFlagDisabled: true,
            playlistVideoCode: '',
            playlistId: 0,
            videoLogged: false
        };
    },
    beforeDestroy: function beforeDestroy() {
        var self = this;
        if (!self.videoLogged) {
            var watchedDuration = self.getCurrentVideoDurationWatched.duration;
            if (watchedDuration >= self.getCurrentVideo[0].duration) {
                self.updateUserPlaylistVideoView(true);
            } else {
                self.updateUserPlaylistVideoView(false);
            }
        }
    },

    methods: {
        videoChangedInPlaylist: function videoChangedInPlaylist() {
            console.log('1. -------------------------> videoChangedInPlaylist():');
        },
        playlistCompleted: function playlistCompleted() {

            console.log('2. -------------------------> playlistCompleted():');
        },
        updateHoverState: function updateHoverState(isHover) {
            this.hoverState = isHover;
        },
        updateHoverStateTranscript: function updateHoverStateTranscript(isHover) {
            this.hoverStateTranscript = isHover;
        },
        updateUserPlaylistVideoView: function updateUserPlaylistVideoView(isFull) {
            var self = this;
            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (isFull) {
                self.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, self.getCurrentVideo[0].duration, 'F');
            } else {
                if (self.getCurrentVideoDurationWatched) {
                    watchedDuration = self.getCurrentVideoDurationWatched.duration;
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(self.getCurrentVideo[0].duration) * 100);
                if (watchedPercentage >= 5) {
                    self.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, watchedDuration, 'P');
                } else {
                    self.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, watchedDuration, 'N');
                }
            }
        },
        logPlaylistVideoStatus: function logPlaylistVideoStatus(playlistId, videoCode, duration, watched) {
            console.log('video code in logging', videoCode);
            var self = this;
            var payload = {
                videoCode: videoCode,
                userId: self.user.userId,
                playlistId: playlistId,
                playlistType: 2,
                playlistCode: null,
                watched: watched,
                rating: null,
                liked: null,
                durationWatched: duration && duration > 0 ? duration : 0,
                thumbnailURL: null,
                opinion: null
            };
            self.$store.dispatch('SET_PLAYLIST_VIDEOSTATUS', payload).then(function () {});
        },
        filterPlaylistOptions: function filterPlaylistOptions(playlistId) {
            console.log('playlsit id', playlistId);
            var self = this;
            if (self.getUserPlaylists) {
                var filterPlaylist = self.getUserPlaylists.filter(function (x) {
                    return x.playlistId.toString() !== playlistId.toString();
                });
                console.log('playlists', filterPlaylist);
                if (filterPlaylist && filterPlaylist.length > 0) {
                    console.info('yes');
                    return true;
                } else {
                    console.info('no');
                    return false;
                }
            } else {
                return false;
            }
        },
        callDelete: function callDelete(video) {
            var _this = this;

            var self = this;
            self.selectedVideo = video.videoCode;
            self.selectedPlaylist = self.$route.params.playlistId.toString();
            if (video.videoCode === self.$route.params.videoCode) {
                var payload = {};
                payload.videoCode = video.videoCode;
                payload.userPlaylistId = self.$route.params.playlistId.toString();
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + video.videoCode + ' + ul').toggleClass('hide');
                    if (self.getUserPlaylists) {
                        var findPlaylist = self.getUserPlaylists.filter(function (x) {
                            return x.playlistId.toString() === self.$route.params.playlistId.toString();
                        });
                        if (findPlaylist && findPlaylist.length > 0) {
                            if (findPlaylist[0].userPlaylistVideos) {
                                self.playlistVideos = findPlaylist[0];
                                if (findPlaylist[0].userPlaylistVideos) {
                                    var userPlaylistVideos = findPlaylist[0].userPlaylistVideos;
                                    var findNextVideo = userPlaylistVideos.filter(function (x) {
                                        return x.videoCode !== self.$route.params.videoCode;
                                    });
                                    if (findNextVideo && findNextVideo.length > 0) {
                                        self.playVideo(self.$route.params.playlistId.toString(), findNextVideo[0].videoCode);
                                    } else {
                                        self.$router.push('/');
                                    }
                                } else {
                                    self.$router.push('/');
                                }
                            } else {
                                self.$router.push('/');
                            }
                        } else {
                            self.$router.push('/');
                        }
                    } else {
                        self.$router.push('/');
                    }
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.videoCode;
                _payload.userPlaylistId = self.$route.params.playlistId.toString();
                _payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: _payload }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + video.videoCode + ' + ul').toggleClass('hide');
                    if (self.getUserPlaylists) {
                        var findPlaylist = self.getUserPlaylists.filter(function (x) {
                            return x.playlistId.toString() === self.$route.params.playlistId.toString();
                        });
                        if (findPlaylist && findPlaylist.length > 0) {
                            if (findPlaylist[0].userPlaylistVideos) {
                                var findVideo = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                                    return x.videoCode.toString() === self.$route.params.videoCode.toString();
                                });
                                if (findVideo && findVideo.length > 0) {
                                    self.playlistVideos = findPlaylist[0];
                                    self.videoIndex = _this.getVideoIndex(findPlaylist[0].userPlaylistVideos, self.$route.params.videoCode);
                                }
                            } else {
                                self.$router.push('/');
                            }
                        } else {
                            self.$router.push('/');
                        }
                    } else {
                        self.$router.push('/');
                    }
                });
            }
        },
        listUpdated: function listUpdated(event) {},
        getVideoIndex: function getVideoIndex(videoArray, videoCode) {
            var index;
            for (var i = 0; i < videoArray.length; ++i) {
                if (videoArray[i].videoCode === videoCode) {
                    index = i;
                    break;
                }
            }
            return index + 1;
        },
        toggleViewTranscript: function toggleViewTranscript() {
            this.viewTranscript = !this.viewTranscript;
        },
        redirectToRelatedVideos: function redirectToRelatedVideos() {
            this.$router.push('/relatedvideos');
        },
        getNextVideo: function getNextVideo(index) {
            if (index >= 0 && index < this.playlistVideos.userPlaylistVideos.length - 1) {
                return this.playlistVideos.userPlaylistVideos[index + 1];
            } else {
                return null;
            }
        },
        playVideo: function playVideo(playlistId, videoCode, playlistTitle) {
            if (self.getItemChangeInPlaylist) {
                self.videoIndex = self.getItemChangeInPlaylist.index + 1;
                self.currentVideo = self.getItemChangeInPlaylist.item;
            }
            console.log('playVideo : playlistId = ', playlistId);
            console.log('playVideo : videoCode = ', videoCode);
            console.log('playVideo : playlistTitle = ', playlistTitle);
            var tempURL = '/playlist/trending/' + playlistId + '/play/' + videoCode + '/' + playlistTitle.replace(/[^a-zA-Z0-9]/g, '-');
            console.log('NEXT URL (tempURL = ) = ', tempURL);
            this.updateUserPlaylistVideoView(false);

            this.$router.push('/playlist/trending/' + playlistId + '/play/' + videoCode + '/' + playlistTitle.replace(/[^a-zA-Z0-9]/g, '-'));
            setTimeout(function () {
                location.reload();
            }, 500);
        },
        setUserLike: function setUserLike() {
            var _this2 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / this.getCurrentVideo[0].duration * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            if (this.currentStatus.liked === '1') {
                this.currentStatus.liked = '0';
            } else {
                this.currentStatus.liked = '1';
            }
            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this2.currentStatus = _this2.getCurrentStatus;
            });
        },
        setOpinion: function setOpinion(desc) {
            var _this3 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            var opinion = '0';
            if (desc === 'travel') {
                opinion = '1';
            } else if (desc === 'dating') {
                opinion = '2';
            } else if (desc === 'news') {
                opinion = '3';
            } else if (desc === 'recipes') {
                opinion = '4';
            } else {
                opinion = '0';
            }

            if (this.currentStatus.opinion === opinion) {
                this.currentStatus.opinion = '0';
            } else {
                this.currentStatus.opinion = opinion;
            }
            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this3.currentStatus = _this3.getCurrentStatus;
            });
        },
        setRating: function setRating(rating) {
            var _this4 = this;

            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (this.getCurrentVideoDurationWatched) {
                watchedDuration = this.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100);
            if (watchedPercentage >= 5) {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'P';
            } else {
                this.currentStatus.durationWatched = watchedPercentage.toString();
                this.currentStatus.watched = 'N';
            }

            if (this.currentStatus.rating === rating) {
                this.currentStatus.rating = '0';
            } else {
                this.currentStatus.rating = rating;
            }

            this.currentStatus.userId = this.user.userId;
            this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                _this4.currentStatus = _this4.getCurrentStatus;
            });
        },
        logVideoEntry: function logVideoEntry() {
            var logWatchedEntry = {
                videoCode: this.$route.params.videoCode,
                userId: this.user.userId,
                playlistId: null,
                playlistCode: null,
                watched: 'N',
                rating: null,
                liked: '0',
                durationWatched: 0,
                thumbnailURL: null,
                opinion: null
            };
            this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {});
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode, videoTitle) {
            this.$router.push('/watch/' + videoCode + '/' + videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
            location.reload();
        },
        applyRatingClass: function applyRatingClass(rating) {
            if (rating === this.currentStatus.rating) {
                return true;
            } else {
                return false;
            }
        },
        setCarousal: function setCarousal() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.each(function () {
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        toggleVideoCompleted: function toggleVideoCompleted() {
            var self = this;
            self.videoCompleted = true;
            setTimeout(function () {
                self.videoSqueeze = true;
            }, 200);
        },
        replayVideo: function replayVideo() {
            var videoCode = this.$route.params.videoCode;
            var videoTitle = this.$route.params.videoTitle;
            this.videoCompleted = false;
            this.videoSqueeze = false;
            this.$router.push('/watch/' + videoCode + '/' + videoTitle);
            this.setVideoPlayerObject(videoCode, videoTitle);
        },
        changeHeight: function changeHeight() {
            this.hideLeftVideoIcons = true;
            this.showRateHoverBox = true;
            this.addRightHoverWidthClass = true;
            this.addIconHoverWidthClass = true;
            this.showShareHoverBox = false;
            this.showEnjoyHoverBox = false;
        },
        showSharing: function showSharing() {
            this.hideLeftVideoIcons = true;
            this.showShareHoverBox = true;
            this.addRightHoverWidthClass = true;
            this.addIconHoverWidthClass = true;
            this.showRateHoverBox = false;
            this.showEnjoyHoverBox = false;
        },
        redirectToHome: function redirectToHome() {
            this.$router.push('/');
        },
        showEnjoy: function showEnjoy() {
            this.showEnjoyHoverBox = true;
            this.hideLeftVideoIcons = true;
            this.addRightHoverEnjoyClass = true;
            this.addIconHoverWidthClass = true;
            this.addEnjoyHoverClass = true;
            this.showRateHoverBox = false;
            this.showShareHoverBox = false;
        },
        resetClass: function resetClass(bool) {
            if (bool) {
                this.hideLeftVideoIcons = false;
                this.addRightHoverWidthClass = false;
                this.addRightHoverEnjoyClass = false;
                this.addIconHoverWidthClass = false;
                this.showRateHoverBox = false;
                this.showShareHoverBox = false;
                this.showEnjoyHoverBox = false;
                this.addEnjoyHoverClass = false;
            } else {}
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.videoCode;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.videoCode;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload2 = {};
                _payload2.videoCode = video.videoCode;
                _payload2.userId = this.user.userId;
                _payload2.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload2 }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.videoCode;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this5 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this5.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        playVideoInPlylist: function playVideoInPlylist(videoObjectToPlay) {
            var self = this;
            var videoIndex = self.getTrendingNewPlaylistObject.indexOf(videoObjectToPlay);
            console.log('playVideoInPlylist : actual video index', videoIndex);
            if (videoIndex > -1) {
                self.videoIndex = videoIndex + 1;
                console.log('playVideoInPlylist : video index of next video', videoIndex + 1);
                self.currentVideo = videoObjectToPlay;
                window.jwplayer().playlistItem(videoIndex);
            }
        }
    },
    watch: {
        'getItemChangeInPlaylist': function getItemChangeInPlaylist(to, from) {
            var self = this;
            console.log('1 ------------> getItemChangeInPlaylist');
            if (self.getItemChangeInPlaylist) {
                console.log('2 ------------> getItemChangeInPlaylist');

                self.videoIndex = self.getItemChangeInPlaylist.index + 1;
                self.currentVideo = self.getItemChangeInPlaylist.item;
            }

            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);

            console.log('3 ------------> getItemChangeInPlaylist : user activity', userPayload);
            this.$store.dispatch('LOGUSERACTIVITY', userPayload);

            console.log('getItemChangeInPlaylist : self.playlistId = ', self.playlistId);
            console.log('getItemChangeInPlaylist : self.currentVideo.videoCode = ', self.currentVideo.videoCode);
            console.log('getItemChangeInPlaylist : self.currentVideo.title = ', self.currentVideo.title);
            console.log('getItemChangeInPlaylist : self.currentVideo = ', self.currentVideo);
            console.log('getItemChangeInPlaylist : self.expertId = ', self.currentVideo.expertid);

            self.$store.dispatch('GETEXPERT', self.currentVideo.expertid).then(function () {});
        }
    },
    mounted: function mounted() {
        var _this6 = this;

        var self = this;
        console.info('inside trending player');
        if (self.user) {
            if (self.getTrialDays < 0) {
                self.$router.push('/becomemember');
            }

            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);
            userPayload.push(self.$route.fullPath);
            console.log('user activity', userPayload);
            this.$store.dispatch('LOGUSERACTIVITY', userPayload);
            if (__WEBPACK_IMPORTED_MODULE_5_jquery___default()(window).width() > 739) {
                self.showPlaylist = true;
            } else {
                self.showPlaylist = false;
            }
            self.playlistVideoCode = this.$route.params.videoCode;
            self.playlistId = this.$route.params.playlistId;
            this.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, 0, 'N');
            if (this.$route.params.playlistId && this.$route.params.videoCode) {
                self.$store.dispatch('GET_TRENDING_PLAYLISTS').then(function () {
                    if (self.getUserPlaylists) {
                        console.info(1);
                        var findPlaylist = self.getUserPlaylists.filter(function (x) {
                            return x.playlistId.toString() === self.$route.params.playlistId.toString();
                        });
                        if (findPlaylist && findPlaylist.length > 0) {
                            if (findPlaylist[0].userPlaylistVideos) {
                                var findVideo = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                                    return x.videoCode.toString() === self.$route.params.videoCode.toString();
                                });
                                console.info(2);
                                if (findVideo && findVideo.length > 0) {
                                    self.playlistVideos = findPlaylist[0];
                                    self.videoIndex = _this6.getVideoIndex(findPlaylist[0].userPlaylistVideos, self.$route.params.videoCode);

                                    self.$store.dispatch('GETCURRENTVIDEO', self.$route.params.videoCode).then(function () {
                                        var video = _this6.getCurrentVideo;
                                        self.currentVideo = {
                                            video: video[0].sources[video[0].sources.length - 1].file,
                                            title: video[0].title,
                                            img: video[0].image,
                                            playerID: new Date(),
                                            tracks: video[0].tracks,
                                            Description: video[0].description,
                                            mediaId: video[0].mediaid,
                                            expertId: video[0].expertId
                                        };
                                        self.$store.dispatch('GETEXPERT', video[0].expertid).then(function () {});
                                    });

                                    self.$store.dispatch('GETVIDEOTRANSCRIPT', self.$route.params.videoCode).then(function () {});

                                    self.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', self.user.userId).then(function () {
                                        var filteredList = _this6.getAuthRecommendedVideos.filter(function (code) {
                                            return code.mediaid !== _this6.currentVideoCode;
                                        });
                                        _this6.recommendationList = filteredList;
                                        setTimeout(function () {
                                            _this6.setCarousal();
                                        }, 2000);
                                    });
                                    self.$store.dispatch('LOAD_NEW_PLAYER_TRENDING_PLAYLISTS', self.$route.params.playlistId).then(function () {
                                        if (self.getTrendingNewPlaylistObject) {
                                            console.log('playlist object found : getTrendingNewPlaylistObject = ', self.getTrendingNewPlaylistObject);
                                            self.currentVideoCode = self.getTrendingNewPlaylistObject[0];
                                        }
                                    });
                                } else {
                                    self.$router.push('/mytone');
                                }
                            } else {
                                self.$router.push('/mytone');
                            }
                        } else {
                            self.$router.push('/mytone');
                        }
                    } else {
                        self.$router.push('/mytone');
                    }
                });
            } else {
                self.$router.push('/mytone');
            }
        } else {
            self.$router.push('/');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert', 'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getUserPlaylists', 'getTrialDays', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getTrendingNewPlaylistObject', 'getItemChangeInPlaylist']), {
        styleObject: function styleObject() {
            if (this.hoverState) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor,
                    borderColor: this.getCorpButtonColor
                };
            } else {
                return {
                    color: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            }
        },
        styleObjectTranscript: function styleObjectTranscript() {
            if (this.hoverStateTranscript && this.viewTranscript) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor + ' !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                };
            } else {
                return {
                    border: '2px solid' + this.getCorpButtonColor + ' !important',
                    color: this.getCorpButtonColor
                };
            }
        }
    })
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["accordion"],
        'panel': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["panel"],
        alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
        dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["dropdown"],
        radio: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["radio"],
        VuePassword: __WEBPACK_IMPORTED_MODULE_3_vue_password___default.a,
        checkbox: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        tabs: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tabs"],
        tab: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tab"],
        buttonGroup: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"]
    },
    name: 'signUp',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Your Trial has Expired',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Your Trial has Expired' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Your Trial has Expired' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            GifteeUser: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                packageId: 0,
                comments: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg'
            },
            userObject: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                cardHolderName: '',
                packageId: '',
                userPayments: [],
                isPaypalCustomer: '',
                paypalSubscriptionId: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg'
            },

            userPayments: {
                token: '',
                stripeCardId: '',
                paymentType: 'CC',
                paymentDate: new Date(),
                paypalPayerId: '',
                paypalPaymentId: '',
                paymentMethodNonce: ''
            },
            spinner: false,
            alert: false,
            passwordError: '',
            confirmPassword: '',
            stripe: '',
            card: '',
            panelStatus: false,
            createSection: true,
            paymentSection: false,
            isToggle: false,
            defaultPlan: '',
            isChecked: false,
            reqPlanCode: this.$route.params.planId ? this.$route.params.planId : '7DaysFree',
            daysToCancel: 0,
            isStripe: true,
            packageId: 0,

            stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo',
            gateway: 'CC',
            paypalPayerID: '',
            paypalPaymentId: '',
            paypalToken: '',

            paypalResponse: '',
            giftCode: '',
            codeRedeemed: false,
            stripeErrorMessage: '',
            hidePasswordMeter: true,
            isMonthlySubscription: true,
            isAnnualSubscription: false,
            annualPlan: '',
            planAmount: 0,
            twoYearPlan: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        console.info('inside become member');
        if (this.user && this.user.trialEndDate && this.user.trialEndDate.length > 0) {
            console.info('trial end date', this.user.trialEndDate);
            if (this.user && this.user.corporation && this.user.corporation.corporationId === 90) {
                console.log('corporation id is ', this.user.corporation.corporationId);
                this.$router.push('/become-member-novo');
            } else {
                this.$store.dispatch('GETPLANS').then(function () {
                    var regularPlan = _this.getAllPlans.filter(function (x) {
                        return x.packageId === 27;
                    });
                    if (regularPlan && regularPlan.length > 0) {
                        var regPlan = regularPlan[0];
                        _this.defaultPlan = regPlan;
                        _this.userObject.packageId = regPlan.packageId;
                        _this.packageId = regPlan.packageId;
                    }

                    var annualPlan = _this.getAllPlans.filter(function (x) {
                        return x.packageId === 31;
                    });
                    if (annualPlan && annualPlan.length > 0) {
                        _this.annualPlan = annualPlan[0];
                        _this.userObject.packageId = _this.annualPlan.packageId;
                        _this.packageId = _this.annualPlan.packageId;
                        _this.planAmount = _this.annualPlan.amount;
                    }

                    var twoYearPln = _this.getAllPlans.filter(function (x) {
                        return x.packageId === 29;
                    });
                    if (twoYearPln && twoYearPln.length > 0) {
                        _this.twoYearPlan = twoYearPln[0];
                    }
                });
                this.$store.dispatch('GETPAYPALTOKEN');
                this.mountStripeElement();
            }
        } else {
            this.$router.push('/');
        }
    },

    methods: {
        mountbraintree: function mountbraintree() {
            var self = this;
            if (self.getPaypalToken) {
                window.braintree.client.create({
                    authorization: 'production_6r7mxqgh_htw3nq9wp32w8h2x'
                }, function (clientErr, clientInstance) {
                    if (clientErr) {
                        console.error('Error creating client:', clientErr);
                        return;
                    }

                    window.braintree.paypalCheckout.create({
                        client: clientInstance
                    }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                        if (paypalCheckoutErr) {
                            console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
                            return;
                        }

                        window.paypal.Button.render({
                            env: 'production',
                            payment: function payment() {
                                return paypalCheckoutInstance.createPayment({
                                    flow: 'vault',
                                    amount: self.planAmount,
                                    currency: 'USD',
                                    intent: 'sale'
                                });
                            },
                            onAuthorize: function onAuthorize(data, actions) {
                                return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
                                    self.userPayments.paymentMethodNonce = payload.nonce;
                                });
                            },
                            onCancel: function onCancel(data) {},
                            onError: function onError(err) {
                                console.error('checkout.js error', err);
                            }
                        }, '#paypal-button').then(function () {});
                    });
                });
            }
        },
        redeemCode: function redeemCode() {
            var _this2 = this;

            if (this.giftCode && this.giftCode.length > 0) {
                this.spinnerToggle();
                this.$store.dispatch('GETGIFTEE', this.giftCode).then(function () {
                    _this2.spinnerToggle();
                    if (_this2.getGiftee) {
                        _this2.user.firstName = _this2.getGiftee.gifteeFirstName;
                        _this2.user.lastName = _this2.getGiftee.gifteeLastName;
                        _this2.user.email = _this2.getGiftee.gifteeEmail;
                        _this2.user.packageId = _this2.getGiftee.packageId;
                        _this2.user.comments = _this2.getGiftee.gifteeUuid;
                        _this2.codeRedeemed = true;
                        _this2.$store.dispatch('GETPLANS').then(function () {
                            var plan = _this2.getAllPlans.filter(function (pln) {
                                return pln.packageId === _this2.getGiftee.packageId;
                            });
                            _this2.defaultPlan = plan[0];
                        });
                    }
                });
            }
        },
        togglePaymentMethods: function togglePaymentMethods() {
            var _this3 = this;

            if (this.gateway === 'paypal') {
                this.isStripe = false;
                setTimeout(function () {
                    _this3.mountbraintree();
                }, 1000);
            } else {
                this.isStripe = true;
                this.mountStripeElement();
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this4 = this;

            if (this.user && this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                this.isToggle = false;
                this.spinnerToggle();
                this.$store.dispatch('VERIFYUSEREXISTS', { email: this.user.email }).then(function () {
                    _this4.spinnerToggle();
                    if (!_this4.error.show) {
                        _this4.isToggle = true;
                        _this4.createSection = false;
                        _this4.paymentSection = true;
                        _this4.user.cardHolderName = _this4.user.firstName + ' ' + _this4.user.lastName;

                        _this4.isStripe = true;
                        _this4.gateway = 'CC';
                        _this4.mountStripeElement();
                    }
                });
            }
        },
        mountStripeElement: function mountStripeElement() {
            var _this5 = this;

            setTimeout(function () {
                _this5.stripe = window.Stripe(_this5.stripeKey);
                var elements = _this5.stripe.elements();
                _this5.card = elements.create('card');
                _this5.card.mount('#card-element');
            }, 2000);
        },
        disablePaymentPanel: function disablePaymentPanel() {
            this.panelStatus = false;
        },
        verifyPaymentSubmit: function verifyPaymentSubmit() {
            if (this.user.packageId > 0) {
                return false;
            }
            return true;
        },
        verifyPassword: function verifyPassword() {
            if (this.user.password.length >= 6) {
                var re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/;
                if (!re.test(this.user.password)) {
                    this.passwordError = 'Min 8 Chars, One Upper Case, One Lower Case, One Digit!';
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyEmail: function verifyEmail() {
            if (this.user.email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(this.user.email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyFirstName: function verifyFirstName() {
            if (this.user.firstName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.firstName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyLastName: function verifyLastName() {
            if (this.user.lastName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.lastName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyCardHolderName: function verifyCardHolderName() {
            if (this.userObject.cardHolderName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.userObject.cardHolderName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onPaymentSubmit: function onPaymentSubmit() {
            var _this6 = this;

            var self = this;
            if (this.codeRedeemed) {
                if (this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                    this.GifteeUser.firstName = this.user.firstName;
                    this.GifteeUser.lastName = this.user.lastName;
                    this.GifteeUser.email = this.user.email.toLowerCase();
                    this.GifteeUser.password = this.user.password;
                    this.GifteeUser.packageId = this.getGiftee.packageId;
                    this.GifteeUser.comments = this.getGiftee.gifteeUuid;
                    this.spinnerToggle();
                    this.$store.dispatch('SAVEGIFTEE', { giftee: this.GifteeUser }).then(function () {
                        if (!_this6.error.show) {
                            _this6.spinnerToggle();
                            _this6.$swal({
                                title: 'Registration Success!',
                                text: 'Welcome To TONE! For your security, please check your inbox for a Validation Email - TONE Networks within the next 12 hours.  (Don’t see it…check your spam folder.)',
                                type: 'success',
                                timer: 4000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {}
                            });
                        } else {
                            _this6.spinnerToggle();
                        }
                    });
                }
            } else {
                if (this.gateway !== 'CC') {
                    this.userObject.cardHolderName = ' ';
                }
                if (this.userObject && this.verifyCardHolderName()) {
                    this.spinnerToggle();
                    this.userObject.email = this.user.email.toLowerCase();
                    this.userObject.userId = this.user.userId;
                    if (this.gateway === 'CC') {
                        this.stripe.createToken(this.card).then(function (result) {
                            if (result.error) {
                                _this6.spinnerToggle();

                                self.stripeErrorMessage = result.error.message;
                            } else {
                                var stripeToken = result.token.id;
                                var cardId = result.token.card.id;

                                _this6.userPayments.token = stripeToken;
                                _this6.userPayments.stripeCardId = cardId;
                                if (_this6.userObject.userPayments.length > 0) {
                                    _this6.userObject.userPayments.pop();
                                }
                                _this6.userObject.userPayments.push(_this6.userPayments);
                                if (stripeToken) {
                                    _this6.$store.dispatch('CHANGEFREEPREVIEWTOREGULAR', { user: _this6.userObject }).then(function () {
                                        if (!_this6.error.show) {
                                            _this6.spinnerToggle();
                                            _this6.$swal({
                                                title: 'Registration Success!',
                                                text: 'Welcome To TONE!',
                                                type: 'success',
                                                timer: 4000,
                                                showCancelButton: false,
                                                showConfirmButton: false
                                            }).then(function () {}, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        } else {
                                            _this6.spinnerToggle();
                                        }
                                    });
                                }
                            }
                        });
                    } else if (this.userPayments.paymentMethodNonce) {
                        if (this.userObject.userPayments.length > 0) {
                            this.userObject.userPayments.pop();
                        }
                        this.userObject.userPayments.push(this.userPayments);
                        if (this.userPayments.paymentMethodNonce) {
                            this.$store.dispatch('CHANGEFREEPREVIEWTOREGULAR', { user: this.userObject }).then(function () {
                                if (!_this6.error.show) {
                                    _this6.spinnerToggle();
                                    _this6.$swal({
                                        title: 'Registration Success!',
                                        text: 'Welcome To TONE!',
                                        type: 'success',
                                        timer: 4000,
                                        showCancelButton: false,
                                        showConfirmButton: false
                                    }).then(function () {}, function (dismiss) {
                                        if (dismiss === 'timer') {}
                                    });
                                } else {
                                    _this6.spinnerToggle();
                                }
                            });
                        }
                    } else {
                        this.spinnerToggle();
                    }
                }
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['error', 'isUserLoggedIn', 'getDefaultPlan', 'getGiftee', 'getAllPlans', 'getPaypalToken', 'getTrialDays', 'user'])),
    watch: {
        'user.firstName': function userFirstName(to, from) {
            this.user.cardHolderName = this.user.firstName + ' ' + this.user.lastName;
        },
        'user.lastName': function userLastName(to, from) {
            this.user.cardHolderName = this.user.firstName + ' ' + this.user.lastName;
        },
        'packageId': function packageId(to, from) {
            this.userObject.packageId = this.packageId;
            if (this.packageId === 31) {
                this.planAmount = this.annualPlan.amount;
            } else if (this.packageId === 29) {
                this.planAmount = this.twoYearPlan.amount;
            } else {
                this.planAmount = this.defaultPlan.amount;
            }
        },
        'gateway': function gateway(to, from) {
            var _this7 = this;

            if (this.gateway === 'paypal') {
                this.card.unmount('#card-element');
                this.stripeErrorMessage = '';
                this.isStripe = false;
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';
                this.userPayments.paymentType = 'PayPal';
                this.userObject.isPaypalCustomer = '1';
                this.userPayments.paymentMethodNonce = '';
                setTimeout(function () {
                    _this7.mountbraintree();
                }, 1000);
            } else {
                this.stripeErrorMessage = '';
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';
                this.userObject.isPaypalCustomer = '0';
                this.userPayments.paymentType = 'CC';
                this.userPayments.paymentMethodNonce = '';
                this.isStripe = true;
                setTimeout(function () {
                    _this7.mountStripeElement();
                }, 1000);
            }
        }
    }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        'accordion': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["accordion"],
        'panel': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["panel"],
        alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
        dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["dropdown"],
        radio: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["radio"],
        VuePassword: __WEBPACK_IMPORTED_MODULE_3_vue_password___default.a,
        checkbox: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        tabs: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tabs"],
        tab: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tab"],
        buttonGroup: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"]
    },
    name: 'signUp',
    metaInfo: function metaInfo() {
        return {
            title: 'TONE | Your Trial has Expired',
            meta: [{ property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, { property: 'og:title', content: 'TONE | Your Trial has Expired' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'twitter:title', content: 'TONE | Your Trial has Expired' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg' }, {
                property: 'twitter:description',
                content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            GifteeUser: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                packageId: 0,
                comments: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg'
            },
            userObject: {
                userId: 0,
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                cardHolderName: '',
                packageId: '',
                userPayments: [],
                isPaypalCustomer: '',
                paypalSubscriptionId: '',
                picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg'
            },

            userPayments: {
                token: '',
                stripeCardId: '',
                paymentType: 'CC',
                paymentDate: new Date(),
                paypalPayerId: '',
                paypalPaymentId: '',
                paymentMethodNonce: ''
            },
            spinner: false,
            alert: false,
            passwordError: '',
            confirmPassword: '',
            stripe: '',
            card: '',
            panelStatus: false,
            createSection: true,
            paymentSection: false,
            isToggle: false,
            defaultPlan: '',
            isChecked: false,
            reqPlanCode: this.$route.params.planId ? this.$route.params.planId : '7DaysFree',
            daysToCancel: 0,
            isStripe: true,
            packageId: 0,

            stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo',
            gateway: 'CC',
            paypalPayerID: '',
            paypalPaymentId: '',
            paypalToken: '',

            paypalResponse: '',
            giftCode: '',
            codeRedeemed: false,
            stripeErrorMessage: '',
            hidePasswordMeter: true,
            isMonthlySubscription: true,
            isAnnualSubscription: false,
            annualPlan: '',
            planAmount: 0,
            twoYearPlan: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        console.log('inside novo page');
        if (this.user && this.user.trialEndDate && this.user.trialEndDate.length > 0) {
            console.log('inside novo page 2');
            this.$store.dispatch('GETPLANS').then(function () {
                var regularPlan = _this.getAllPlans.filter(function (x) {
                    return x.packageId === 15;
                });
                if (regularPlan && regularPlan.length > 0) {
                    var regPlan = regularPlan[0];
                    _this.defaultPlan = regPlan;
                    _this.userObject.packageId = regPlan.packageId;
                    _this.packageId = regPlan.packageId;
                }

                var annualPlan = _this.getAllPlans.filter(function (x) {
                    return x.packageId === 12;
                });
                if (annualPlan && annualPlan.length > 0) {
                    _this.annualPlan = annualPlan[0];
                    _this.userObject.packageId = _this.annualPlan.packageId;
                    _this.packageId = _this.annualPlan.packageId;
                    _this.planAmount = _this.annualPlan.amount;
                }

                var twoYearPln = _this.getAllPlans.filter(function (x) {
                    return x.packageId === 11;
                });
                if (twoYearPln && twoYearPln.length > 0) {
                    _this.twoYearPlan = twoYearPln[0];
                }
            });

            this.$store.dispatch('GETPAYPALTOKEN');
            this.mountStripeElement();
        } else {
            this.$router.push('/');
        }
    },

    methods: {
        mountbraintree: function mountbraintree() {
            var self = this;
            if (self.getPaypalToken) {
                window.braintree.client.create({
                    authorization: 'production_6r7mxqgh_htw3nq9wp32w8h2x'
                }, function (clientErr, clientInstance) {
                    if (clientErr) {
                        console.error('Error creating client:', clientErr);
                        return;
                    }

                    window.braintree.paypalCheckout.create({
                        client: clientInstance
                    }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                        if (paypalCheckoutErr) {
                            console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
                            return;
                        }

                        window.paypal.Button.render({
                            env: 'production',
                            payment: function payment() {
                                return paypalCheckoutInstance.createPayment({
                                    flow: 'vault',
                                    amount: self.planAmount,
                                    currency: 'USD',
                                    intent: 'sale'
                                });
                            },
                            onAuthorize: function onAuthorize(data, actions) {
                                return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
                                    self.userPayments.paymentMethodNonce = payload.nonce;
                                });
                            },
                            onCancel: function onCancel(data) {},
                            onError: function onError(err) {
                                console.error('checkout.js error', err);
                            }
                        }, '#paypal-button').then(function () {});
                    });
                });
            }
        },
        redeemCode: function redeemCode() {
            var _this2 = this;

            if (this.giftCode && this.giftCode.length > 0) {
                this.spinnerToggle();
                this.$store.dispatch('GETGIFTEE', this.giftCode).then(function () {
                    _this2.spinnerToggle();
                    if (_this2.getGiftee) {
                        _this2.user.firstName = _this2.getGiftee.gifteeFirstName;
                        _this2.user.lastName = _this2.getGiftee.gifteeLastName;
                        _this2.user.email = _this2.getGiftee.gifteeEmail;
                        _this2.user.packageId = _this2.getGiftee.packageId;
                        _this2.user.comments = _this2.getGiftee.gifteeUuid;
                        _this2.codeRedeemed = true;
                        _this2.$store.dispatch('GETPLANS').then(function () {
                            var plan = _this2.getAllPlans.filter(function (pln) {
                                return pln.packageId === _this2.getGiftee.packageId;
                            });
                            _this2.defaultPlan = plan[0];
                        });
                    }
                });
            }
        },
        togglePaymentMethods: function togglePaymentMethods() {
            var _this3 = this;

            if (this.gateway === 'paypal') {
                this.isStripe = false;
                setTimeout(function () {
                    _this3.mountbraintree();
                }, 1000);
            } else {
                this.isStripe = true;
                this.mountStripeElement();
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        onSubmit: function onSubmit() {
            var _this4 = this;

            if (this.user && this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                this.isToggle = false;
                this.spinnerToggle();
                this.$store.dispatch('VERIFYUSEREXISTS', { email: this.user.email }).then(function () {
                    _this4.spinnerToggle();
                    if (!_this4.error.show) {
                        _this4.isToggle = true;
                        _this4.createSection = false;
                        _this4.paymentSection = true;
                        _this4.user.cardHolderName = _this4.user.firstName + ' ' + _this4.user.lastName;

                        _this4.isStripe = true;
                        _this4.gateway = 'CC';
                        _this4.mountStripeElement();
                    }
                });
            }
        },
        mountStripeElement: function mountStripeElement() {
            var _this5 = this;

            setTimeout(function () {
                _this5.stripe = window.Stripe(_this5.stripeKey);
                var elements = _this5.stripe.elements();
                _this5.card = elements.create('card');
                _this5.card.mount('#card-element');
            }, 2000);
        },
        disablePaymentPanel: function disablePaymentPanel() {
            this.panelStatus = false;
        },
        verifyPaymentSubmit: function verifyPaymentSubmit() {
            if (this.user.packageId > 0) {
                return false;
            }
            return true;
        },
        verifyPassword: function verifyPassword() {
            if (this.user.password.length >= 6) {
                var re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/;
                if (!re.test(this.user.password)) {
                    this.passwordError = 'Min 8 Chars, One Upper Case, One Lower Case, One Digit!';
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyEmail: function verifyEmail() {
            if (this.user.email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(this.user.email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyFirstName: function verifyFirstName() {
            if (this.user.firstName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.firstName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyLastName: function verifyLastName() {
            if (this.user.lastName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.user.lastName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyCardHolderName: function verifyCardHolderName() {
            if (this.userObject.cardHolderName.length > 0) {
                var re = /^[A-Za-z ]+$/;
                if (!re.test(this.userObject.cardHolderName)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onPaymentSubmit: function onPaymentSubmit() {
            var _this6 = this;

            var self = this;
            if (this.codeRedeemed) {
                if (this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                    this.GifteeUser.firstName = this.user.firstName;
                    this.GifteeUser.lastName = this.user.lastName;
                    this.GifteeUser.email = this.user.email.toLowerCase();
                    this.GifteeUser.password = this.user.password;
                    this.GifteeUser.packageId = this.getGiftee.packageId;
                    this.GifteeUser.comments = this.getGiftee.gifteeUuid;
                    this.spinnerToggle();
                    this.$store.dispatch('SAVEGIFTEE', { giftee: this.GifteeUser }).then(function () {
                        if (!_this6.error.show) {
                            _this6.spinnerToggle();
                            _this6.$swal({
                                title: 'Registration Success!',
                                text: 'Welcome To TONE! For your security, please check your inbox for a Validation Email - TONE Networks within the next 12 hours.  (Don’t see it…check your spam folder.)',
                                type: 'success',
                                timer: 4000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {}
                            });
                        } else {
                            _this6.spinnerToggle();
                        }
                    });
                }
            } else {
                this.userObject.packageId = 25;
                this.planAmount = 120;
                if (this.gateway !== 'CC') {
                    this.userObject.cardHolderName = ' ';
                }
                if (this.userObject && this.verifyCardHolderName()) {
                    this.spinnerToggle();
                    this.userObject.email = this.user.email.toLowerCase();
                    this.userObject.userId = this.user.userId;
                    if (this.gateway === 'CC') {
                        this.userObject.isPaypalCustomer = '0';
                        this.stripe.createToken(this.card).then(function (result) {
                            if (result.error) {
                                _this6.spinnerToggle();

                                self.stripeErrorMessage = result.error.message;
                            } else {
                                var stripeToken = result.token.id;
                                var cardId = result.token.card.id;

                                _this6.userPayments.token = stripeToken;
                                _this6.userPayments.stripeCardId = cardId;
                                if (_this6.userObject.userPayments.length > 0) {
                                    _this6.userObject.userPayments.pop();
                                }
                                _this6.userObject.userPayments.push(_this6.userPayments);
                                if (stripeToken) {
                                    _this6.$store.dispatch('CHANGE_FREEP_REVIEW_TO_REGULAR_NOVO', { user: _this6.userObject }).then(function () {
                                        if (!_this6.error.show) {
                                            _this6.spinnerToggle();
                                            _this6.$swal({
                                                title: 'Registration Success!',
                                                text: 'Welcome To TONE!',
                                                type: 'success',
                                                timer: 4000,
                                                showCancelButton: false,
                                                showConfirmButton: false
                                            }).then(function () {}, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        } else {
                                            _this6.spinnerToggle();
                                        }
                                    });
                                }
                            }
                        });
                    } else if (this.userPayments.paymentMethodNonce) {
                        if (this.userObject.userPayments.length > 0) {
                            this.userObject.userPayments.pop();
                        }
                        this.userObject.userPayments.push(this.userPayments);
                        if (this.userPayments.paymentMethodNonce) {
                            this.$store.dispatch('CHANGE_FREEP_REVIEW_TO_REGULAR_NOVO', { user: this.userObject }).then(function () {
                                if (!_this6.error.show) {
                                    _this6.spinnerToggle();
                                    _this6.$swal({
                                        title: 'Registration Success!',
                                        text: 'Welcome To TONE!',
                                        type: 'success',
                                        timer: 4000,
                                        showCancelButton: false,
                                        showConfirmButton: false
                                    }).then(function () {}, function (dismiss) {
                                        if (dismiss === 'timer') {}
                                    });
                                } else {
                                    _this6.spinnerToggle();
                                }
                            });
                        }
                    } else {
                        this.spinnerToggle();
                    }
                }
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['error', 'isUserLoggedIn', 'getDefaultPlan', 'getGiftee', 'getAllPlans', 'getPaypalToken', 'getTrialDays', 'user'])),
    watch: {
        'user.firstName': function userFirstName(to, from) {
            this.user.cardHolderName = this.user.firstName + ' ' + this.user.lastName;
        },
        'user.lastName': function userLastName(to, from) {
            this.user.cardHolderName = this.user.firstName + ' ' + this.user.lastName;
        },
        'packageId': function packageId(to, from) {},
        'gateway': function gateway(to, from) {
            var _this7 = this;

            if (this.gateway === 'paypal') {
                this.card.unmount('#card-element');
                this.stripeErrorMessage = '';
                this.isStripe = false;
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';
                this.userPayments.paymentType = 'PayPal';
                this.userObject.isPaypalCustomer = '1';
                this.userPayments.paymentMethodNonce = '';
                setTimeout(function () {
                    _this7.mountbraintree();
                }, 1000);
            } else {
                this.stripeErrorMessage = '';
                this.userPayments.token = '';
                this.userPayments.paypalPayerId = '';
                this.userPayments.paypalPaymentId = '';
                this.userPayments.stripeCardId = '';
                this.userObject.isPaypalCustomer = '0';
                this.userPayments.paymentType = 'CC';
                this.userPayments.paymentMethodNonce = '';
                this.isStripe = true;
                setTimeout(function () {
                    _this7.mountStripeElement();
                }, 1000);
            }
        }
    }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(13);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'UnAuth',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_2__JwPlayer_vue___default.a,
        modal: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["modal"],
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_3__JwPlayList_vue___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            menuClosed: true,
            corporateLiveStreamingFlag: false,
            currentPlayerID: null,
            showModal: false,
            showWatchVideoModal: false,
            workVideos: '',
            lifeVideos: '',
            mindbodyVideos: '',
            moneyVideos: '',
            charities: '',
            currentVideoDesc: '',
            planDescription: '',
            planId: '',
            defaultPlan: '',
            mainVideoPlay: '',
            unauthPromoVideo: '',
            liveEventVideo: '',
            corporateGiftCode: this.$route.params.giftCode ? this.$route.params.giftCode : '',
            liveEventURL: '',
            heroImageList: ['https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg', 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-2.jpg', 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-3.jpg'],

            dynamic_para_1: '',
            dynamic_para_2: '',
            dynamic_para_3: '',
            dynamic_para_4: '',
            dynamic_para_5: '',
            dynamic_para_6: '',
            dynamic_para_7: '',
            dynamic_para_8: '',
            dynamic_para_9: '',
            dynamic_para_10: '',
            dynamic_para_11: '',
            dynamic_para_12: '',
            dynamic_para_13: '',
            dynamic_para_14: '',
            dynamic_work_desc: '',
            dynamic_life_desc: '',
            dynamic_mindbody_desc: '',
            dynamic_money_desc: '',
            dynamic_event_desc: '',
            dynamic_aboutus_video2_title: '',
            dynamic_aboutus_video2_code: '',
            dynamic_logosection_header: 'TONE has been featured in',
            dynamic_testimonial_heading: 'Our members and clients love us!',
            heroImage1: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg',
            heroImage2: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-2.jpg',
            heroImage3: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-3.jpg',
            event1Image: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/icon_chat.png',
            event1Dest: '',
            event2Image: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/icon_communication.png',
            event2Dest: '',
            event3Image: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/icon_heel.png',
            event3Dest: '',
            allUnauthVideos: null,
            videoURL: window.location.href,
            videoReference: '',
            selectedRoute: 'work',
            isNativeApp: false,
            isNativeAppNavigation: false,

            corpLogos: null,
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: '',
            metaTag_pageTitle: 'Welcome to TONE Networks!',
            showGiftingLinks: false,
            appNavigationURL: 'https://s3.amazonaws.com/tone-assets/app/navigation',
            podcastHeadingLine1: '',
            podcastHeadingLine2: '',
            podcastBgColor: '',
            tabs: {
                work: true,
                life: false,
                mindbody: false,
                money: false
            }
        };
    },
    methods: {
        openTone4GoodLink: function openTone4GoodLink() {
            if (this.getFindOutMoreUrl) {
                window.open(this.getFindOutMoreUrl, '_blank');
            }
        },
        openToneForGoodLink: function openToneForGoodLink() {
            window.open('https://forgood.tonenetworks.com/?hs_preview=zMhyLpxA-30398892724', '_blank');
        },
        toggleShareMenu: function toggleShareMenu() {
            console.log('new toggle option', this.menuClosed);
            this.menuClosed = !this.menuClosed;
        },
        changeRoute: function changeRoute(option) {
            this.$router.push('/content/' + option);
        },
        returnShareURL: function returnShareURL(videoCode) {
            return this.videoURL + 'contentvideos/play/' + videoCode;
        },

        switchTab: function switchTab(id) {
            for (var tab in this.tabs) {
                this.tabs[tab] = id === tab;
            }
        },
        create: function create() {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_4_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.each(function () {
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this).slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        setLogoCarousal: function setLogoCarousal() {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_4_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$el).find('.responsive-slick-corplogos');
            $slick.each(function () {
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        createTopCarousal: function createTopCarousal() {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_4_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$el).find('.responsive-slick-slider-top');
            $slick.each(function () {
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this).slick({
                    dots: false,
                    useTransform: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 6000,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        destroy: function destroy() {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$el).find('.responsive-slick-slider').slick('unslick');
        },
        reSlick: function reSlick() {
            this.destroy();
            this.create();
        },
        redirectSignup: function redirectSignup(tag) {
            window.logEvents('Unauthenticated Page', 'click', tag);
            if (this.$route.params.planId) {
                this.$router.push('/signup/' + this.$route.params.planId);
            } else {
                this.$router.push('/signup/');
            }
        },
        redeemGiftcode: function redeemGiftcode(mode) {
            var self = this;
            if (mode === 'popup') {
                this.currentPlayerID = null;
                this.cancelModal('0');
            }
            setTimeout(function () {
                if (self.getCorporateClientId === '112' || self.getCorporateClientId === '197') {
                    self.$router.push('/corporationgiftingcustom/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
                } else if (self.getCorporateClient.invitationCode === '2') {
                    self.$router.push('/corporation/referral/buy/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
                } else {
                    self.$router.push('/corporationgifting/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
                }
            }, 400);
        },
        redirectSignupFromPopUp: function redirectSignupFromPopUp() {
            window.logEvents('Unauthenticated Page', 'click', 'Signup from Video Popup');
            this.cancelModal('0');
            if (this.$route.params.planId) {
                this.$router.push('/signup/' + this.$route.params.planId);
            } else {
                this.$router.push('/signup/');
            }
        },
        redirectLogin: function redirectLogin(event) {
            this.$router.push('/login');
        },
        setPlayer: function setPlayer(playerObject) {
            this.currentPlayerID = { video: playerObject.sources[1].file, title: playerObject.title, img: playerObject.image, playerID: new Date() };
            this.showModal = true;
        },
        cancelModal: function cancelModal(log) {
            if (log === '1') {
                window.logEvents('Unauthenticated Page', 'click', 'Video Popup Closed');
            }
            var self = this;
            var $ = __webpack_provided_window_dot_jQuery;
            this.currentPlayerID = null;
            setTimeout(function () {
                self.showModal = false;
                self.showWatchVideoModal = false;

                $('.modal-open').removeClass('modal-open');
            }, 200);
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        openModal: function openModal(mainVideoObj) {
            this.$router.push('/contentvideos/play/' + mainVideoObj.mediaid);
        },
        showCorporateLiveStreaming: function showCorporateLiveStreaming() {
            var self = this;
            if (self.$route.params.corporateId && self.$route.params.giftCode) {
                if (self.liveEventURL && self.corporateLiveStreamingFlag) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (self.liveEventURL) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    },
    watch: {
        'getGiftingLinksFlag': function getGiftingLinksFlag(to, from) {
            var self = this;
            if (self.getGiftingLinksFlag) {
                self.showGiftingLinks = false;
            } else {
                self.showGiftingLinks = true;
            }
        },
        'dynamic_aboutus_video2_code': function dynamic_aboutus_video2_code(to, from) {
            var _this = this;

            var self = this;
            if (self.dynamic_aboutus_video2_code && self.dynamic_aboutus_video2_code.length > 3 && (self.dynamic_aboutus_video2_code !== ' ' || self.dynamic_aboutus_video2_code !== '')) {
                self.$store.dispatch('GETPROMOVIDEOFORCODE', self.dynamic_aboutus_video2_code).then(function () {
                    if (self.getPromoVideo) {
                        var video = _this.getPromoVideo;
                        self.unauthPromoVideo = {
                            video: video[0].sources[video[0].sources.length - 1].file,
                            title: video[0].title,
                            img: video[0].image,
                            playerID: new Date(),
                            tracks: video[0].tracks,
                            Description: video[0].description,
                            mediaId: video[0].mediaid,
                            isMute: true,
                            showCaptions: true,
                            repeat: true,
                            autoStart: false
                        };
                        setTimeout(function () {
                            window.jwplayer().seek(1);
                            window.jwplayer().pause(true);
                        }, 500);
                    } else {
                        self.unauthPromoVideo = null;
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        var self = this;

        console.log('HERE - before gonative check!!!');
        if (navigator.userAgent.indexOf('gonative') > -1) {
            this.isNativeApp = true;
            this.isNativeAppNavigation = true;

            __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.getJSON(self.appNavigationURL + '/sidebar_unauth.json', function (data) {
                console.log('side navigation (unuath) returned', data);
                var json = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
                window.location.href = 'gonative://sidebar/setItems?items=' + encodeURIComponent(json);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown);
            });

            if (navigator.userAgent.indexOf('gonativeand') <= -1) {
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.getJSON(self.appNavigationURL + '/bottomNav_unauth.json', function (data) {
                        console.log('bottom navigation (unauth) returned', data);
                        var json = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
                        window.location.href = 'gonative://tabs/setTabs?tabs=' + encodeURIComponent(json);
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown);
                    });
                }, 500);
            }
        }
        setTimeout(function () {
            _this2.createTopCarousal();
            _this2.setLogoCarousal();
        }, 1500);
        this.currentPlayerID = null;
        this.$store.dispatch('GETDYNAMICCONTENTS', 1).then(function () {
            if (_this2.getAllSiteContents) {
                _this2.metaTag_pageTitle = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this2.metaTag_description = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this2.metaTag_keywords = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this2.metaTag_fb_title = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this2.metaTag_fb_image = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this2.metaTag_fb_description = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this2.metaTag_fb_sitename = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this2.metaTag_tw_title = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this2.metaTag_tw_image = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this2.metaTag_tw_description = _this2.setDynamicSection(_this2.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');

                _this2.dynamic_para_1 = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_CAROUSEL_HEADING_1');
                _this2.dynamic_para_2 = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_CAROUSEL_HEADING_2');
                _this2.dynamic_para_3 = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_CAROUSEL_HEADING_3');
                _this2.dynamic_para_4 = _this2.setDynamicSection(_this2.getAllSiteContents, 'VIDEO_HEADING');
                _this2.dynamic_para_5 = _this2.setDynamicSection(_this2.getAllSiteContents, 'EXPERT_HEADING');
                _this2.dynamic_para_6 = _this2.setDynamicSection(_this2.getAllSiteContents, 'EVENT_HEADING');
                _this2.dynamic_para_7 = _this2.setDynamicSection(_this2.getAllSiteContents, 'EVENT_SUB_HEADING_1');
                _this2.dynamic_para_8 = _this2.setDynamicSection(_this2.getAllSiteContents, 'EVENT_SUB_HEADING_2');
                _this2.dynamic_para_9 = _this2.setDynamicSection(_this2.getAllSiteContents, 'EVENT_SUB_HEADING_3');
                _this2.dynamic_para_10 = _this2.setDynamicSection(_this2.getAllSiteContents, 'CHARITY_HEADING_1');
                _this2.dynamic_para_11 = _this2.setDynamicSection(_this2.getAllSiteContents, 'CHARITY_SUB_HEADING_2');
                _this2.dynamic_para_12 = _this2.setDynamicSection(_this2.getAllSiteContents, 'LIVE_STREAMING_HEADING_1');
                _this2.dynamic_para_13 = _this2.setDynamicSection(_this2.getAllSiteContents, 'LIVE_STREAMING_SUB_HEADING_1');

                _this2.heroImage1 = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_CAROUSEL_IMG_1');
                _this2.heroImage2 = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_CAROUSEL_IMG_2');
                _this2.heroImage3 = _this2.setDynamicSection(_this2.getAllSiteContents, 'TOP_CAROUSEL_IMG_3');
                _this2.event1Image = _this2.setDynamicSection(_this2.getAllSiteContents, 'EVENT_SUB_HEADING_1_IMG');
                _this2.event1Dest = _this2.setDynamicSection(_this2.getAllSiteContents, 'EVENT_SUB_HEADING_1_URL');
                _this2.event2Image = _this2.setDynamicSection(_this2.getAllSiteContents, 'EVENT_SUB_HEADING_2_IMG');
                _this2.event2Dest = _this2.setDynamicSection(_this2.getAllSiteContents, 'EVENT_SUB_HEADING_2_URL');
                _this2.event3Image = _this2.setDynamicSection(_this2.getAllSiteContents, 'EVENT_SUB_HEADING_3_IMG');
                _this2.event3Dest = _this2.setDynamicSection(_this2.getAllSiteContents, 'EVENT_SUB_HEADING_3_URL');
                _this2.dynamic_logosection_header = _this2.setDynamicSection(_this2.getAllSiteContents, 'LOGO_SECTION_HEADING');
                _this2.dynamic_aboutus_video2_title = _this2.setDynamicSection(_this2.getAllSiteContents, 'ABOUTUS_VIDEO2_TEXT');
                _this2.dynamic_aboutus_video2_code = _this2.setDynamicSection(_this2.getAllSiteContents, 'ABOUTUS_VIDEO2_CODE');
                _this2.dynamic_testimonial_heading = _this2.setDynamicSection(_this2.getAllSiteContents, 'TESTIMONIAL_HEADING');

                _this2.podcastHeadingLine1 = _this2.setDynamicSection(_this2.getAllSiteContents, 'PODCAST_HDG_1');
                _this2.podcastHeadingLine2 = _this2.setDynamicSection(_this2.getAllSiteContents, 'PODCAST_HDG_2');
                _this2.podcastBgColor = _this2.setDynamicSection(_this2.getAllSiteContents, 'PODCAST_BG_COLOR');
            }
        });

        self.$store.dispatch('GET_PODCAST_FOR_SERVICE', 'buzzsprout').then(function () {});
        self.$store.dispatch('GET_ADVISORY_BOARD', 'ADVISORY BOARD').then(function () {});

        if (this.$route.params.planId) {
            this.planId = this.$route.params.planId;
            this.$store.dispatch('GETPLAN', this.planId).then(function () {
                _this2.defaultPlan = _this2.getDefaultPlan;
                _this2.planDescription = 'Start Your ' + _this2.defaultPlan.type + ' Trial';
                if (_this2.getDefaultPlan) {
                    _this2.$store.commit('setMarketingPlan', { planId: _this2.$route.params.planId });
                } else {
                    _this2.$store.commit('setMarketingPlan', { planId: null });
                }
            });
        } else if (this.$route.params.giftCode && this.$route.params.corporateId) {
            this.$store.commit('setCorporateGiftingCode', { giftCode: this.$route.params.giftCode });
            this.$store.commit('setCorporateClientId', { corporateClientId: this.$route.params.corporateId });
            this.$store.dispatch('GETCORPORATECLIENT', this.$route.params.corporateId).then(function () {
                if (_this2.getCorporateClient) {
                    _this2.$store.dispatch('GETCORPORATECLIENT_GIFT_DETAILS', { giftCode: _this2.$route.params.giftCode, corporationId: _this2.$route.params.corporateId }).then(function () {
                        if (_this2.getCorporateGiftInfo) {} else {
                            _this2.$store.commit('setCorporateGiftingCode', { giftCode: null });
                            _this2.$store.commit('setCorporateClientId', { corporateClientId: null });
                            if (localStorage.getItem('corporateClientObject')) {
                                localStorage.removeItem('corporateClientObject');
                            }
                            if (localStorage.getItem('corporateGiftInfoObject')) {
                                localStorage.removeItem('corporateGiftInfoObject');
                            }
                            _this2.$store.commit('setCorporateClient', { client: null });
                            _this2.$store.commit('setCorporateGiftInfo', { gift: null });
                        }
                    });
                }
            });
        } else {
            this.planDescription = 'Start Your 7-Day Free Trial';
            this.$store.commit('setMarketingPlan', { planId: 0 });
            this.$store.commit('setCorporateGiftingCode', { giftCode: null });
            this.$store.commit('setCorporateClientId', { corporateClientId: null });
            this.$store.commit('setCorporateClient', { client: null });
            if (localStorage.getItem('corporateClientObject')) {
                localStorage.removeItem('corporateClientObject');
            }
            this.$store.commit('setCorporateGiftInfo', { gift: null });
            if (localStorage.getItem('corporateGiftInfoObject')) {
                localStorage.removeItem('corporateGiftInfoObject');
            }
        }
        this.$store.dispatch('GETAPPCONFIGRATION').then(function () {
            if (_this2.getLiveStreamingStatus === 1) {
                _this2.liveEventURL = _this2.getLiveStreamingURL;
            } else {
                _this2.liveEventURL = null;
            }
            if (_this2.getCorporateLiveStreamFlag === 1) {
                _this2.corporateLiveStreamingFlag = true;
            } else {
                _this2.corporateLiveStreamingFlag = false;
            }
        });
        this.$store.dispatch('GETTESTIMONIALS', 'UNAUTH').then(function () {});

        this.$store.dispatch('GETUNAUTHVIDEOS', 'DEFAULT').then(function () {
            if (_this2.getAboutUsVideo) {
                _this2.mainVideoPlay = {
                    video: _this2.getAboutUsVideo.sources[_this2.getAboutUsVideo.sources.length - 1].file,
                    title: _this2.getAboutUsVideo.title,
                    img: _this2.getAboutUsVideo.image,
                    playerID: new Date(),
                    tracks: _this2.getAboutUsVideo.tracks,
                    isMute: true,
                    showCaptions: true,
                    repeat: true,
                    autoStart: false,
                    mediaId: _this2.getAboutUsVideo.mediaid
                };
                setTimeout(function () {
                    _this2.videoReference = window['currentVideoId'];
                    window.jwplayer().seek(1);
                    window.jwplayer().pause(true);
                }, 500);
            }

            _this2.workVideos = _this2.getWorkVideo;
            _this2.mindbodyVideos = _this2.getMindbodyVideo;
            _this2.lifeVideos = _this2.getLifeVideos;
            _this2.moneyVideos = _this2.getMoneyVideo;
            _this2.allUnauthVideos = _this2.getAllUnauthVideos.filter(function (x) {
                return x.tags === 'work' || x.tags === 'life' || x.tags === 'mindbody' || x.tags === 'money';
            });
            setTimeout(function () {
                _this2.create();
            }, 1000);
        });

        this.$store.dispatch('GETALLEXPERTS').then(function () {});

        this.$store.dispatch('GETALLCHARITIES').then(function () {
            _this2.charities = _this2.getAllCharities;
        });

        this.$store.dispatch('GETCOMPANYLOGOS', 'UNAUTH').then(function () {
            _this2.corpLogos = _this2.getCompanyLogos;
            if (_this2.corpLogos) {
                setTimeout(function () {
                    _this2.setLogoCarousal();
                }, 1000);
            }
        });
        if (sessionStorage.getItem('redirectPath')) {
            var redirectPath = sessionStorage.getItem('redirectPath');
            if (redirectPath.toLowerCase().indexOf('liveevent') >= 0 || redirectPath.toLowerCase().indexOf('talk') >= 0 || redirectPath.toLowerCase().indexOf('teaser') >= 0 || redirectPath.toLowerCase().indexOf('takeaway') >= 0 || redirectPath.toLowerCase().indexOf('playlist') >= 0 || redirectPath.toLowerCase().indexOf('trending') >= 0 || redirectPath.toLowerCase().indexOf('corporation/mycommunity') || redirectPath.toLowerCase().indexOf('becomemember') >= 0 || redirectPath.toLowerCase().indexOf('tonearchive') >= 0 || redirectPath.toLowerCase().indexOf('/events') >= 0) {
                __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
            }
        }

        this.$store.dispatch('CACHEPAGE', window.location.href);
        if (self.getGiftingLinksFlag) {
            self.showGiftingLinks = false;
        } else {
            self.showGiftingLinks = true;
        }
        if (this.user) {
            window.juapp('arb', '[userId]', '[auth]');
        } else {
            window.juapp('arb', '[userId]', '[unauth]');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])(['getWorkVideo', 'getLifeVideos', 'getMoneyVideo', 'getMindbodyVideo', 'getCommunityVideo', 'getMainVideo', 'error', 'getAllCharities', 'getDefaultPlan', 'getWorkLearnMoreVideo', 'getLifeLearnMoreVideo', 'getMindbodyLearnMoreVideo', 'getMoneyLearnMoreVideo', 'getCommunityLearnMoreVideo', 'getLiveEventVideo', 'getCorporateGiftingCode', 'getCorporateClientId', 'getCorporateClient', 'getLiveStreamingStatus', 'getLiveStreamingURL', 'getAllSiteContents', 'getAllTestimonials', 'getAboutUsVideo', 'getAllUnauthVideos', 'getAllExperts', 'getCorporateLiveStreamFlag', 'getPromoVideo', 'getCompanyLogos', 'getGiftingLinksFlag', 'getFindOutMoreUrl', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor', 'getCorporateGiftInfo', 'getServicePodcast', 'getAdvisoryBoard']))
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'player',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: 'TONE Video | ' + self.currentVideo.title,
            meta: [{ property: 'og:image', content: self.currentVideo.img }, { property: 'og:title', content: self.currentVideo.title + ' | TONE Networks' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: self.currentVideo.Description
            }, { property: 'twitter:title', content: self.currentVideo.title + ' | TONE Networks' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.currentVideo.img }, {
                property: 'twitter:description',
                content: self.currentVideo.Description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            activeTab: 0,
            currentVideo: '',
            currentStatus: '',
            currentVideoCode: this.$route.params.videoCode,
            recommendationList: '',
            videoCompleted: false,
            videoSqueeze: false,
            hideLeftVideoIcons: false,
            addRightHoverWidthClass: false,
            addIconHoverWidthClass: false,
            showRateHoverBox: false,
            showShareHoverBox: false,
            showEnjoyHoverBox: false,
            addRightHoverEnjoyClass: false,
            addEnjoyHoverClass: false,
            captionTrack: '',
            viewTranscript: false,
            ratingOne: false,
            ratingTwo: false,
            ratingThree: false,
            ratingFour: false,
            hideAll: false,
            videoMessage: '',
            videoMessageIndex: Math.floor(Math.random() * 7),
            videoGif: '',
            videoGifIndex: Math.floor(Math.random() * 4),
            videoURL: window.location.href,
            videoNotFoundFlag: false,
            videoTag: '',
            videoList: '',
            categoryVideoList: '',
            videoExpert: '',
            showThumbnail: false,
            invalidVideo: false
        };
    },
    methods: {
        stopVideo: function stopVideo(flag) {
            var videoReference = window['currentVideoId'];
            if (flag === 'stop') {
                setTimeout(function () {
                    window.jwplayer(videoReference).seek(1);
                    window.jwplayer(videoReference).pause(true);
                }, 1200);
            } else {
                window.jwplayer(videoReference).play(true);
            }
        },
        redeemCode: function redeemCode() {
            var self = this;
            if (self.getCorporateClientId === '112' || self.getCorporateClientId === '197') {
                self.$router.push('/corporationgiftingcustom/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
            } else if (self.getCorporateClient.invitationCode === '2') {
                self.$router.push('/corporation/referral/buy/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
            } else {
                self.$router.push('/corporationgifting/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/contentvideos/play/' + videoCode);
            location.reload();
        },
        redirectToHome: function redirectToHome() {
            this.$router.push('/');
        },
        triggerLogin: function triggerLogin(videoCode) {
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', '/watch/' + videoCode);
            } else {
                sessionStorage.setItem('redirectPath', '/watch/' + videoCode);
            }
            __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        create: function create() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.each(function () {
                __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this).slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        }
    },
    watch: {
        'invalidVideo': function invalidVideo(to, from) {
            var self = this;
            if (self.invalidVideo) {
                self.$swal({
                    title: 'Video is only available for authenticated users!',
                    text: '',
                    type: 'error',
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(function () {}, function (dismiss) {
                    if (dismiss === 'timer') {
                        self.$router.push('/');
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        var refBy = self.$route.params.refBy;
        var promptLogin = false;
        if (refBy && (refBy.toLowerCase() === 'toneteaser' || refBy.toLowerCase() === 'tonetakeaway')) {
            promptLogin = true;
        }
        var fromUnauthPage = 'DEFAULT';
        if (localStorage.getItem('fromUnauthPage')) {
            fromUnauthPage = localStorage.getItem('fromUnauthPage');
        }
        console.log('================> fromUnauthPage = ' + fromUnauthPage);
        sessionStorage.setItem('redirectPath', this.$route.fullPath);
        if (!self.user) {
            self.$store.dispatch('GETUNAUTHVIDEOS', fromUnauthPage).then(function () {
                if (_this.getAllUnauthVideos) {
                    var video = _this.getAllUnauthVideos.filter(function (x) {
                        return x.mediaid === self.$route.params.videoCode;
                    });
                    if (video && video.length > 0) {
                        var originalCode = video[0].original_video_code;
                        if (!originalCode) {
                            originalCode = video[0].mediaid;
                        }
                        self.$store.dispatch('SETORIGINALVIDEOCODE', originalCode).then(function () {
                            self.$store.dispatch('SETORIGINALVIDEOTITLE', video[0].title);
                            if (promptLogin) {
                                __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
                            }
                        });
                        var vTag = video[0].tags;
                        var expertId = video[0].expertid;
                        self.videoNotFoundFlag = false;
                        if (vTag.indexOf('work-promo') >= 0) {
                            self.videoTag = 'WORK';
                            self.videoList = self.getWorkVideo.filter(function (x) {
                                return x.mediaid !== self.$route.params.videoCode;
                            });
                            setTimeout(function () {
                                _this.create();
                            }, 1500);
                            self.$store.dispatch('GETAUTHVIDEOS', 'WORK').then(function () {
                                if (self.getAuthWorkVideos) {
                                    self.categoryVideoList = self.getAuthWorkVideos.slice(0, 15);
                                }
                            });
                        } else if (vTag.indexOf('life-promo') >= 0) {
                            self.videoTag = 'LIFE';
                            self.videoList = self.getLifeVideos.filter(function (x) {
                                return x.mediaid !== self.$route.params.videoCode;
                            });
                            setTimeout(function () {
                                _this.create();
                            }, 1500);
                            self.$store.dispatch('GETAUTHVIDEOS', 'LIFE').then(function () {
                                if (self.getAuthLifeVideos) {
                                    self.categoryVideoList = self.getAuthLifeVideos.slice(0, 15);
                                }
                            });
                        } else if (vTag.indexOf('money-promo') >= 0) {
                            self.videoTag = 'MONEY';
                            self.videoList = self.getMoneyVideo.filter(function (x) {
                                return x.mediaid !== self.$route.params.videoCode;
                            });
                            setTimeout(function () {
                                _this.create();
                            }, 1500);
                            self.$store.dispatch('GETAUTHVIDEOS', 'MONEY').then(function () {
                                if (self.getAuthMoneyVideos) {
                                    self.categoryVideoList = self.getAuthMoneyVideos.slice(0, 15);
                                }
                            });
                        } else if (vTag.indexOf('mindbody-promo') >= 0) {
                            self.videoTag = 'MINDBODY';
                            self.videoList = self.getMindbodyVideo.filter(function (x) {
                                return x.mediaid !== self.$route.params.videoCode;
                            });
                            setTimeout(function () {
                                _this.create();
                            }, 1500);
                            _this.$store.dispatch('GETAUTHVIDEOS', 'MINDBODY').then(function () {
                                if (self.getAuthMindbodyVideos) {
                                    self.categoryVideoList = self.getAuthMindbodyVideos.slice(0, 15);
                                }
                            });
                        } else if (vTag.indexOf('community') >= 0) {
                            self.videoTag = 'COMMUNITY';
                            self.videoList = self.getCommunityVideo.filter(function (x) {
                                return x.mediaid !== self.$route.params.videoCode;
                            });
                            setTimeout(function () {
                                _this.create();
                            }, 1500);
                            self.videoList = null;
                            self.categoryVideoList = '';
                        } else {
                            self.categoryVideoList = '';
                            self.videoTag = null;
                            self.videoList = null;
                        }
                        self.currentVideo = {
                            video: video[0].sources[video[0].sources.length - 1].file,
                            title: video[0].title,
                            img: video[0].image,
                            playerID: new Date(),
                            tracks: video[0].tracks,
                            Description: video[0].description,
                            mediaId: video[0].mediaid
                        };
                        self.$store.dispatch('CACHEPAGE', self.videoURL);
                        if (promptLogin) {
                            self.stopVideo('stop');
                        }
                        if (expertId && expertId > 0) {
                            self.$store.dispatch('GETEXPERT', expertId).then(function () {
                                if (self.getExpert) {
                                    self.videoExpert = self.getExpert;
                                }
                            });
                        } else {
                            self.videoExpert = null;
                        }
                    } else {
                        self.$store.dispatch('GETCURRENTVIDEO', self.$route.params.videoCode).then(function () {
                            if (self.getCurrentVideo) {
                                var mainVideoSource = self.getCurrentVideo[0];
                                var videoCodeToSet = self.$route.params.videoCode;
                                if (mainVideoSource.promo_video_code && mainVideoSource.promo_video_code !== 'null') {
                                    console.log('INSIDE UnauthVideoPlayer.vue ::: GOING TO RUN ORIGINAL : 6 mainVideoSource.promo_video_code = ', mainVideoSource.promo_video_code);
                                    videoCodeToSet = mainVideoSource.promo_video_code;
                                } else if (mainVideoSource.tags.toLowerCase().indexOf('marketingvideo') >= 0) {
                                    console.log('INSIDE UnauthVideoPlayer.vue ::: marketingvideo = ');
                                    videoCodeToSet = mainVideoSource.mediaid;
                                } else if (mainVideoSource.tags.indexOf('-promo') >= 0) {
                                    console.log('INSIDE UnauthVideoPlayer.vue ::: GOING TO RUN PROMO : mainVideoSource.promo_video_code = ', mainVideoSource.promo_video_code);
                                    videoCodeToSet = mainVideoSource.mediaid;
                                } else {
                                    console.log('INSIDE UnauthVideoPlayer.vue ::: self.showThumbnail = true = 00000000000000000000');
                                    self.showThumbnail = true;
                                }
                                if (videoCodeToSet) {
                                    self.$store.dispatch('GETPROMOVIDEOFORCODE', videoCodeToSet).then(function () {
                                        if (self.getPromoVideo) {
                                            var _video = _this.getPromoVideo;
                                            var _originalCode = _video[0].original_video_code;
                                            if (!_originalCode) {
                                                _originalCode = _video[0].mediaid;
                                            }
                                            self.$store.dispatch('SETORIGINALVIDEOCODE', _originalCode).then(function () {
                                                self.$store.dispatch('SETORIGINALVIDEOTITLE', _video[0].title);
                                                if (promptLogin) {
                                                    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
                                                }
                                            });
                                            self.currentVideo = {
                                                video: _video[0].sources[_video[0].sources.length - 1].file,
                                                title: _video[0].title,
                                                img: _video[0].image,
                                                playerID: new Date(),
                                                tracks: _video[0].tracks,
                                                Description: _video[0].description,
                                                mediaId: _video[0].mediaid
                                            };
                                            self.$store.dispatch('CACHEPAGE', self.videoURL);
                                            if (promptLogin) {
                                                self.stopVideo('stop');
                                            }
                                            self.$store.dispatch('GETEXPERT', _video[0].expertid).then(function () {
                                                if (self.getExpert) {
                                                    self.videoExpert = self.getExpert;
                                                } else {
                                                    console.log('video title', _video[0].title);
                                                    console.log('video description', _video[0].description);
                                                    if (self.showThumbnail && (!self.currentVideo.title || !self.currentVideo.Description)) {
                                                        self.invalidVideo = true;
                                                    }
                                                }
                                            });

                                            if (mainVideoSource.tags.toLowerCase().indexOf('work') >= 0) {
                                                self.videoTag = 'WORK';
                                                self.videoList = self.getWorkVideo;
                                                setTimeout(function () {
                                                    _this.create();
                                                }, 1500);
                                                self.$store.dispatch('GETAUTHVIDEOS', 'WORK').then(function () {
                                                    if (self.getAuthWorkVideos) {
                                                        self.categoryVideoList = self.getAuthWorkVideos.slice(0, 15);
                                                    }
                                                });
                                            } else if (mainVideoSource.tags.toLowerCase().indexOf('life-promo') >= 0) {
                                                self.videoTag = 'LIFE';
                                                self.videoList = self.getLifeVideos;
                                                setTimeout(function () {
                                                    _this.create();
                                                }, 1500);
                                                self.$store.dispatch('GETAUTHVIDEOS', 'LIFE').then(function () {
                                                    if (self.getAuthLifeVideos) {
                                                        self.categoryVideoList = self.getAuthLifeVideos.slice(0, 15);
                                                    }
                                                });
                                            } else if (mainVideoSource.tags.toLowerCase().indexOf('money-promo') >= 0) {
                                                self.videoTag = 'MONEY';
                                                self.videoList = self.getMoneyVideo;
                                                setTimeout(function () {
                                                    _this.create();
                                                }, 1500);
                                                self.$store.dispatch('GETAUTHVIDEOS', 'MONEY').then(function () {
                                                    if (self.getAuthMoneyVideos) {
                                                        self.categoryVideoList = self.getAuthMoneyVideos.slice(0, 15);
                                                    }
                                                });
                                            } else if (mainVideoSource.tags.toLowerCase().indexOf('mindbody-promo') >= 0) {
                                                self.videoTag = 'MINDBODY';
                                                self.videoList = self.getMindbodyVideo;
                                                setTimeout(function () {
                                                    _this.create();
                                                }, 1500);
                                                _this.$store.dispatch('GETAUTHVIDEOS', 'MINDBODY').then(function () {
                                                    if (self.getAuthMindbodyVideos) {
                                                        self.categoryVideoList = self.getAuthMindbodyVideos.slice(0, 15);
                                                    }
                                                });
                                            } else if (mainVideoSource.tags.toLowerCase().indexOf('community') >= 0) {
                                                self.videoTag = 'COMMUNITY';
                                                self.videoList = self.getCommunityVideo;
                                                setTimeout(function () {
                                                    _this.create();
                                                }, 1500);
                                                self.videoList = null;
                                                self.categoryVideoList = '';
                                            } else {
                                                self.categoryVideoList = '';
                                                self.videoTag = null;
                                                self.videoList = null;
                                            }
                                        }
                                    });
                                } else {
                                    self.$router.push('/');
                                }
                            } else {
                                self.$swal({
                                    title: 'Video not found',
                                    text: '',
                                    type: 'error',
                                    timer: 2000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(function () {}, function (dismiss) {
                                    if (dismiss === 'timer') {
                                        self.$router.push('/');
                                    }
                                });
                            }
                        });
                    }
                }
            });
        } else {
            console.log('inside redirect');
            var originalVideoCode = self.$route.params.videoCode;
            self.$store.dispatch('GETCURRENTVIDEO', self.$route.params.videoCode).then(function () {
                if (self.getCurrentVideo) {
                    console.log('video found in unuath', self.getCurrentVideo[0]);
                    if (self.getCurrentVideo[0].original_video_code) {
                        originalVideoCode = self.getCurrentVideo[0].original_video_code;
                        self.$router.push('/watch/' + originalVideoCode + '/' + self.getCurrentVideo[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
                    } else {
                        self.$router.push('/watch/' + self.$route.params.videoCode + '/' + self.getCurrentVideo[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase());
                    }
                } else {
                    self.$router.push('/');
                }
            });
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'getWorkVideo', 'getLifeVideos', 'getMoneyVideo', 'getMindbodyVideo', 'getCommunityVideo', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert', 'getPromoVideo', 'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getAllUnauthVideos', 'getCorporateGiftingCode', 'getAuthWorkVideos', 'getAuthLifeVideos', 'getAuthMindbodyVideos', 'getAuthMoneyVideos', 'getCorporateClient', 'getCorporateClientId', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor', 'getCorporateGiftInfo']))
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(13);







var crypto = __webpack_require__(166);

/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
        spinner: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"]
    },
    name: 'validate',
    data: function data() {
        return {
            userObj: {
                email: '',
                code: '',
                validationCode: ''
            },
            spinner: false,
            paramEmail: '',
            paramValidationCode: '',
            validationSuccess: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['error', 'user', 'getValidationStatusError'])),
    methods: {
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },

        onSubmit: function onSubmit() {
            var _this = this;

            if (this.user) {
                this.$store.dispatch('VALIDATE', { user: this.user }).then(function () {
                    if (!_this.error.show) {
                        _this.validationSuccess = true;
                        setTimeout(function () {
                            _this.validationSuccess = false;
                            _this.$router.push('/');
                        }, 4000);
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        var self = this;

        if (self.user && (this.user.status.toLowerCase() === 'confirm' || self.user.status.toLowerCase() === 'confirmed')) {
            setTimeout(function () {
                self.$swal({
                    title: 'Your account has already been validated',
                    text: '',
                    type: 'info',
                    timer: 3000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(function () {}, function (dismiss) {
                    if (dismiss === 'timer') {}
                });
            }, 500);
            self.$router.push('/mytone');
        } else if (self.user && (self.user.status.toLowerCase() === 'register' || self.user.status.toLowerCase() === 'registered')) {
            if (self.$route.query.params) {
                var encryptedEmail = self.$route.query.params.substr(0, self.$route.query.params.indexOf('^'));
                var validationCode = self.$route.query.params.substr(self.$route.query.params.indexOf('^') + 1);

                var decipher = crypto.createDecipher('aes-256-cbc', 'tonenetworks');
                var decrypted = decipher.update(encryptedEmail, 'hex', 'utf-8');
                decrypted = decrypted + decipher.final('utf-8');
                self.userObj.email = decrypted;
                self.userObj.validationCode = validationCode;
                if (self.userObj.email.length > 0 && self.userObj.validationCode.length > 0) {
                    self.$store.dispatch('VALIDATE', { user: self.userObj }).then(function () {
                        if (!self.error.show) {
                            self.validationSuccess = true;
                            setTimeout(function () {
                                var logUserTemp = sessionStorage.getItem('loggedUserTemp');
                                if (logUserTemp) {
                                    logUserTemp = JSON.parse(sessionStorage.getItem('loggedUserTemp'));
                                    logUserTemp.status = 'CONFIRMED';
                                    self.user.status = 'CONFIRMED';
                                    sessionStorage.setItem('loggedUserTemp', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(logUserTemp));
                                }
                                var logUser = localStorage.getItem('loggedUser');
                                if (logUser) {
                                    logUser = JSON.parse(localStorage.getItem('loggedUser'));
                                    logUser.status = 'CONFIRMED';
                                    self.user.status = 'CONFIRMED';
                                    localStorage.setItem('loggedUser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(logUser));
                                }
                                self.validationSuccess = false;
                                self.$router.push('/mytone');
                            }, 4000);
                        } else {
                            self.$swal({
                                title: 'Validation Email has Expired!',
                                text: 'This validation email has expired. Do you want to resend the email?',
                                type: 'error',
                                showCancelButton: true,
                                confirmButtonText: 'Yes, Please',
                                cancelButtonText: 'Cancel',
                                confirmButtonClass: 'btn btn-success',
                                cancelButtonClass: 'btn btn-danger',
                                buttonsStyling: false
                            }).then(function (result) {
                                self.$store.dispatch('RESENDVALIDATIONCODE', encryptedEmail).then(function () {
                                    self.$swal({
                                        title: 'Check your mailbox for new validation email',
                                        text: '',
                                        type: 'success',
                                        timer: 3000,
                                        showCancelButton: false,
                                        showConfirmButton: false
                                    }).then(function () {}, function (dismiss) {
                                        if (dismiss === 'timer') {}
                                    });
                                });
                                setTimeout(function () {
                                    self.$router.push('/mytone');
                                }, 4000);
                            });
                        }
                    });
                } else {
                    self.$router.push('/mytone');
                }
            }
        } else {
            if (self.$route.query.params) {
                var _encryptedEmail = self.$route.query.params.substr(0, self.$route.query.params.indexOf('^'));
                var _validationCode = self.$route.query.params.substr(self.$route.query.params.indexOf('^') + 1);

                var _decipher = crypto.createDecipher('aes-256-cbc', 'tonenetworks');
                var _decrypted = _decipher.update(_encryptedEmail, 'hex', 'utf-8');
                _decrypted = _decrypted + _decipher.final('utf-8');
                self.userObj.email = _decrypted;
                self.userObj.validationCode = _validationCode;
                if (self.userObj.email.length > 0 && self.userObj.validationCode.length > 0 && !self.getValidationStatusError) {
                    self.$store.dispatch('VERIFYUSERSTATUS', self.userObj.email).then(function () {
                        if (!self.getValidationStatusError) {
                            self.$store.dispatch('VALIDATE', { user: self.userObj }).then(function () {
                                if (!self.error.show) {
                                    self.validationSuccess = true;
                                    setTimeout(function () {
                                        self.validationSuccess = false;
                                        self.$router.push('/');
                                        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
                                    }, 4000);
                                } else {
                                    self.$swal({
                                        title: 'Validation Email has Expired!',
                                        text: 'This validation email has expired. Do you want to resend the email?',
                                        type: 'error',
                                        showCancelButton: true,
                                        confirmButtonText: 'Yes, Please',
                                        cancelButtonText: 'Cancel',
                                        confirmButtonClass: 'btn btn-success',
                                        cancelButtonClass: 'btn btn-danger',
                                        buttonsStyling: false
                                    }).then(function (result) {
                                        self.$store.dispatch('RESENDVALIDATIONCODE', self.userObj.email).then(function () {
                                            self.$router.push('/');
                                            self.$swal({
                                                title: 'Check your mailbox for new validation email',
                                                text: '',
                                                type: 'success',
                                                timer: 3000,
                                                showCancelButton: false,
                                                showConfirmButton: false
                                            }).then(function () {}, function (dismiss) {
                                                if (dismiss === 'timer') {
                                                    self.$router.push('/');
                                                }
                                            });
                                        });
                                    }, function (dismiss) {
                                        self.$router.push('/');
                                    });
                                }
                            });
                        } else {
                            self.$swal({
                                title: 'Your account has already been validated',
                                text: '',
                                type: 'info',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {
                                    self.$router.push('/');
                                }
                            });
                        }
                    });
                }
            } else {
                self.$router.push('/');
            }
        }
    }
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slick_carousel__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_slick_carousel_dist_vue_slick_carousel_css__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_slick_carousel_dist_vue_slick_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_slick_carousel_dist_vue_slick_carousel_css__);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'player',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default.a,
        'bs-input': __WEBPACK_IMPORTED_MODULE_5_vue_strap__["input"],
        modal: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["modal"],
        spinner: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["spinner"],
        VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_7_vue_slick_carousel___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: 'TONE Video | ' + self.currentVideo.title,
            meta: [{ property: 'og:image', content: self.currentVideo.img }, { property: 'og:title', content: self.currentVideo.title + ' | TONE Networks' }, { property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand' }, {
                property: 'og:description',
                content: self.currentVideo.Description
            }, { property: 'twitter:title', content: self.currentVideo.title + ' | TONE Networks' }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.currentVideo.img }, {
                property: 'twitter:description',
                content: self.currentVideo.Description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            carouselSettings: {
                'dots': false,
                'infinite': true,
                'speed': 500,
                'slidesToShow': 3,
                'slidesToScroll': 1,
                'initialSlide': 0,
                'responsive': [{
                    'breakpoint': 1024,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'infinite': true,
                        'dots': true
                    }
                }, {
                    'breakpoint': 600,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'initialSlide': 2
                    }
                }, {
                    'breakpoint': 480,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1
                    }
                }]
            },
            options: [{ name: 'Vue.js', code: 'vu' }, { name: 'Javascript', code: 'js' }, { name: 'Open Source', code: 'os' }],
            playTheVideo: true,
            hoverState: false,
            hoverStateTranscript: false,
            showShareCommunity: false,
            showShareIndividual: false,
            showShareFriends: false,
            taggedEmails: [],
            emailList: [],
            previewMsg: 'Message Preview: \n',
            showSharedModal: false,
            shareInProcess: false,
            activeTab: 0,
            currentVideo: '',
            currentStatus: '',
            currentVideoCode: this.$route.params.videoCode,
            recommendationList: '',
            videoCompleted: false,
            videoSqueeze: false,
            hideLeftVideoIcons: false,
            addRightHoverWidthClass: false,
            addIconHoverWidthClass: false,
            showRateHoverBox: false,
            showShareHoverBox: false,
            showEnjoyHoverBox: false,
            addRightHoverEnjoyClass: false,
            addEnjoyHoverClass: false,
            captionTrack: '',
            viewTranscript: false,
            ratingOne: false,
            ratingTwo: false,
            ratingThree: false,
            ratingFour: false,
            hideAll: false,
            videoMessage: '',
            videoMessageIndex: Math.floor(Math.random() * 7),
            videoGif: '',
            videoGifIndex: Math.floor(Math.random() * 4),
            videoURL: window.location.href,
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            isTrialExpired: false,
            showMemberOverlay: false,
            showRatingMessage: false,
            showCorporateShare: false,
            shareOption: 'Corporate',
            corporateShareMessage: '',
            corporateInfo: null,
            selectedCorps: null,
            sharingMessage: '',
            spinner: false,
            isVideoPrivate: false,
            shareVideoPayload: {
                corporationId: 0,
                recipientFriendEmails: null,
                senderUserId: 0,
                recipientsUserIds: [],
                videoCode: '',
                messageText: ''
            },
            sharePayload: {
                tmpVideCode: '',
                sharedEmailList: '',
                sharedEmailMessage: '',
                sharedPlaylistPreview: ''
            },
            allCorps: [{ name: 'Ann Carlsen', corporationId: '1' }, { name: 'Jet Blue', corporationId: '2' }, { name: 'AMC Networks', corporationId: '3' }]
        };
    },
    watch: {
        'sharePayload.sharedEmailMessage': function sharePayloadSharedEmailMessage(to, from) {
            var self = this;

            var oriiginalMessage = self.user.firstName + ' ' + self.user.lastName + ' shared a video with you on TONE Networks: \n' + self.currentVideo.title + ' \n';
            if (self.showSharedModal && self.sharePayload.sharedEmailMessage && self.sharePayload.sharedEmailMessage.length > 0) {
                self.sharePayload.sharedPlaylistPreview = '' + self.previewMsg + oriiginalMessage + self.sharePayload.sharedEmailMessage;
            } else {
                self.sharePayload.sharedPlaylistPreview = '' + self.previewMsg + self.user.firstName + ' ' + self.user.lastName + ' shared a video with you on TONE Networks: \n' + self.currentVideo.title + ' \n';
            }
        },
        'showCorporateShare': function showCorporateShare(to, from) {
            var self = this;
            if (self.showCorporateShare) {
                self.selectedCorps = null;
                self.corporateShareMessage = '';
                self.taggedEmails = [];
            }
        },
        'shareOption': function shareOption(to, from) {
            var self = this;
            self.selectedCorps = null;
            self.corporateShareMessage = '';
            self.taggedEmails = [];
        }
    },
    methods: {
        updateHoverState: function updateHoverState(isHover) {
            this.hoverState = isHover;
        },
        updateHoverStateTranscript: function updateHoverStateTranscript(isHover) {
            this.hoverStateTranscript = isHover;
        },
        showSharingModal: function showSharingModal() {
            var self = this;
            if (self.user && self.user.corporation === null) {
                self.showSharedModal = true;
            } else {
                self.showCorporateShare = true;
                if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareVideoPermission >= 1) {
                    var rights = self.user.corporation.corpSharingPermissions.shareVideoPermission;
                    console.log('rights', rights);
                    if (rights === 1) {
                        self.showShareCommunity = true;
                        self.showShareIndividual = true;
                        self.showShareFriends = true;
                    } else if (rights === 2) {
                        self.showShareCommunity = true;
                        self.showShareIndividual = false;
                        self.showShareFriends = false;
                        self.shareOption = 'Corporate';
                    } else if (rights === 3) {
                        self.showShareCommunity = false;
                        self.showShareFriends = false;
                        self.showShareIndividual = true;
                        self.shareOption = 'Individual';
                    } else if (rights === 5) {
                        self.showShareCommunity = false;
                        self.showShareIndividual = false;
                        self.showShareFriends = true;
                        self.shareOption = 'Friends';
                    } else {
                        self.showShareCommunity = false;
                        self.showShareIndividual = false;
                        self.showShareFriends = false;
                    }
                }
            }
        },
        handleCorporateShareModal: function handleCorporateShareModal() {
            var self = this;
            self.showCorporateShare = true;

            if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareVideoPermission >= 1) {
                var rights = self.user.corporation.corpSharingPermissions.shareVideoPermission;
                console.log('rights', rights);
                if (rights === 1) {
                    self.showShareCommunity = true;
                    self.showShareIndividual = true;
                } else if (rights === 2) {
                    self.showShareCommunity = true;
                    self.showShareIndividual = false;
                    self.shareOption = 'Corporate';
                    self.showCorporateShare = true;
                } else if (rights === 3) {
                    self.showShareCommunity = false;
                    self.showShareIndividual = true;
                    self.shareOption = 'Individual';
                } else {
                    self.showShareCommunity = false;
                    self.showShareIndividual = false;
                }
            }
        },
        addTag: function addTag(newTag) {
            var self = this;
            console.log('newTAg', newTag);
            var tag = {
                name: newTag
            };
            if (self.verifyEmail(newTag)) {
                self.emailList.push(tag);
                this.taggedEmails.push(tag);
                console.log('tagged emails', this.taggedEmails);
            } else {
                console.log('invalid email address, calling swal');
            }
        },
        verifyEmail: function verifyEmail(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        verifyEmailList: function verifyEmailList(emailList) {
            var removeWhiteSpace = emailList.filter(function (x) {
                return x.trim();
            });
            var updatedList = removeWhiteSpace.filter(function (x) {
                return x !== '' && x !== ' ' && x !== '  ';
            });
            var self = this;
            var re = /\S+@\S+\.\S+/;
            for (var i = 0; i < updatedList.length; i++) {
                if (updatedList[i] && updatedList[i] !== ' ' && !re.test(updatedList[i])) {
                    self.failedEmail = updatedList[i];
                    return false;
                }
            }
            self.failedEmail = '';
            self.sharePayload.sharedEmailList = updatedList.join(',');
            return true;
        },
        cancelEmailShareModal: function cancelEmailShareModal() {
            var self = this;
            var $ = __webpack_provided_window_dot_jQuery;
            self.sharePayload.tmpVideCode = '';
            self.sharePayload.sharedEmailList = '';
            self.sharePayload.sharedEmailMessage = '';
            self.sharePayload.sharedPlaylistPreview = self.user.firstName + ' ' + self.user.lastName + ' shared a video with you on TONE Networks: \n' + self.currentVideo.title + ' \n';
            setTimeout(function () {
                self.showSharedModal = false;

                $('.modal-open').removeClass('modal-open');
            }, 500);
        },
        onSharePlaylist: function onSharePlaylist() {
            var self = this;
            self.spinnerToggle();
            var emailArray = self.taggedEmails.map(function (x) {
                return x.name;
            });
            self.sharePayload.sharedPlaylistPreview = self.user.firstName + ' ' + self.user.lastName + ' shared a video with you on TONE Networks: \n' + self.currentVideo.title + '\n' + self.sharePayload.sharedEmailMessage;
            var sharePayload = {
                csvEmailRecepients: emailArray.join(','),
                userId: self.user.userId,
                tmpVideCode: self.$route.params.videoCode,
                customizedMessage: self.sharePayload.sharedPlaylistPreview
            };
            self.$store.dispatch('EMAILSHAREVIDEO', { payload: sharePayload }).then(function () {
                if (!self.error.show) {
                    self.spinnerToggle();
                    self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(function () {
                        if (self.getTaggedEmailList) {
                            self.emailList = [];
                            self.emailList = self.getTaggedEmailList;
                            self.taggedEmails = [];
                            self.sharePayload.sharedPlaylistPreview = '';
                        }
                    });
                    self.$swal({
                        title: 'Email Sent!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    self.cancelEmailShareModal();
                } else {
                    self.spinnerToggle();
                    self.cancelEmailShareModal();
                }
            });
        },
        maskEmailAddress: function maskEmailAddress(userEmail) {
            var avg = void 0,
                splitted = void 0,
                part1 = void 0,
                part2 = void 0;
            splitted = userEmail.split('@');
            part1 = splitted[0];
            var regex = /[^0-9.]/g;
            var maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1);
            console.log('maked', maskid);
            avg = part1.length / 2;
            part1 = part1.substring(0, part1.length - avg);
            part2 = splitted[1];
            var maskDomain = part2.split('.');
            return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1];
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        shareCorporateVideo: function shareCorporateVideo() {
            var self = this;
            self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0;
            self.shareVideoPayload.senderUserId = self.user.userId;
            self.shareVideoPayload.recipientsUserIds = [];
            self.shareVideoPayload.recipientFriendEmails = null;
            self.shareVideoPayload.messageText = self.corporateShareMessage;
            if (self.shareOption === 'Corporate') {
                self.shareVideoPayload.recipientsUserIds = [];
                self.shareVideoPayload.recipientFriendEmails = null;
            } else if (self.shareOption === 'Individual') {
                self.shareVideoPayload.recipientFriendEmails = null;
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    var userIdArray = self.selectedCorps.map(function (x) {
                        return x.userId;
                    });
                    self.shareVideoPayload.recipientsUserIds = userIdArray;
                }
            } else if (self.shareOption === 'Friends') {
                self.shareVideoPayload.recipientsUserIds = [];
                var emailArray = self.taggedEmails.map(function (x) {
                    return x.name;
                });
                self.shareVideoPayload.recipientFriendEmails = emailArray.join(',');
            } else {}
            self.shareVideoPayload.videoCode = self.currentVideo.mediaid;
            console.log('final payload', self.shareVideoPayload);
            self.shareInProcess = true;

            self.$store.dispatch('VIDEOCORPORATESHARE', { payload: self.shareVideoPayload }).then(function () {
                if (!self.error.show) {
                    self.spinnerToggle();
                    self.$swal({
                        title: 'Video has been shared!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });

                    self.cancelCorporateModal();
                } else {
                    self.cancelCorporateModal();
                }
            });
        },
        customLabel: function customLabel(option) {
            var findDuplicate = this.allCorps.find(function (x) {
                return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId;
            });
            if (findDuplicate) {
                var maskedEmail = this.maskEmailAddress(option.email);
                return option.firstName + ' ' + option.lastName + ' <' + maskedEmail + '>';
            } else {
                return option.firstName + ' ' + option.lastName;
            }
        },
        cancelCorporateModal: function cancelCorporateModal() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showCorporateShare = false;
                self.shareInProcess = false;

                __WEBPACK_IMPORTED_MODULE_6_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        cancelMemberModal: function cancelMemberModal() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showMemberOverlay = false;
                var videoReference = window['currentVideoId'];
                window.jwplayer(videoReference).pause(false);
                __WEBPACK_IMPORTED_MODULE_6_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);

            var videoReference = window['currentVideoId'];
            window.jwplayer(videoReference).pause(false);
        },
        toggleViewTranscript: function toggleViewTranscript() {
            this.viewTranscript = !this.viewTranscript;
        },
        redirectToRelatedVideos: function redirectToRelatedVideos() {
            this.$router.push('/relatedvideos');
        },
        onVideoComplete: function onVideoComplete() {
            var self = this;

            if (!self.isTrialExpired) {
                self.toggleVideoCompleted();
                self.currentStatus.watched = 'F';
                self.currentStatus.durationWatched = self.getCurrentVideo[0].duration;
                self.currentStatus.userId = this.user.userId;
                self.$store.dispatch('SETVIDEOSTATUS', self.currentStatus).then(function () {
                    self.currentStatus = self.getCurrentStatus;
                });
            }
        },
        setUserLike: function setUserLike() {
            var _this = this;

            var self = this;
            if (!self.isTrialExpired) {
                var watchedDuration = void 0,
                    watchedPercentage = void 0;
                if (self.getCurrentVideoDurationWatched) {
                    watchedDuration = self.getCurrentVideoDurationWatched.duration;
                } else {
                    watchedDuration = 0;
                }
                if (watchedDuration > 0) {
                    watchedPercentage = parseInt(watchedDuration / self.getCurrentVideo[0].duration * 100);
                } else {
                    watchedPercentage = 0;
                }
                if (watchedPercentage >= 5) {
                    self.currentStatus.durationWatched = watchedDuration.toString();
                    self.currentStatus.watched = 'P';
                } else {
                    self.currentStatus.durationWatched = watchedDuration.toString();
                    self.currentStatus.watched = 'N';
                }

                if (self.currentStatus.liked === '1') {
                    self.currentStatus.liked = '0';
                } else {
                    self.currentStatus.liked = '1';
                }
                self.currentStatus.userId = self.user.userId;
                self.$store.dispatch('SETVIDEOSTATUS', self.currentStatus).then(function () {
                    self.currentStatus = _this.getCurrentStatus;
                });
            }
        },
        setOpinion: function setOpinion(desc) {
            var _this2 = this;

            var self = this;
            if (!self.isTrialExpired) {
                var watchedDuration = void 0,
                    watchedPercentage = void 0;
                if (self.getCurrentVideoDurationWatched) {
                    watchedDuration = this.getCurrentVideoDurationWatched.duration;
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(self.getCurrentVideo[0].duration) * 100);
                if (watchedPercentage >= 5) {
                    self.currentStatus.durationWatched = watchedDuration.toString();
                    self.currentStatus.watched = 'P';
                } else {
                    self.currentStatus.durationWatched = watchedDuration.toString();
                    self.currentStatus.watched = 'N';
                }

                var opinion = '0';
                if (desc === 'travel') {
                    opinion = '1';
                } else if (desc === 'dating') {
                    opinion = '2';
                } else if (desc === 'news') {
                    opinion = '3';
                } else if (desc === 'recipes') {
                    opinion = '4';
                } else {
                    opinion = '0';
                }

                if (self.currentStatus.opinion === opinion) {
                    self.currentStatus.opinion = '0';
                } else {
                    self.currentStatus.opinion = opinion;
                }
                self.currentStatus.userId = self.user.userId;
                self.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(function () {
                    self.currentStatus = _this2.getCurrentStatus;
                });
            }
        },
        setRatingChart: function setRatingChart(rating) {
            var _this3 = this;

            var self = this;
            if (!self.isTrialExpired) {
                self.showRatingMessage = false;
                var watchedDuration = void 0,
                    watchedPercentage = void 0;
                if (self.getCurrentVideoDurationWatched) {
                    watchedDuration = self.getCurrentVideoDurationWatched.duration;
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100);
                if (watchedPercentage >= 5) {
                    self.currentStatus.durationWatched = watchedDuration.toString();
                    self.currentStatus.watched = 'P';
                } else {
                    self.currentStatus.durationWatched = watchedDuration.toString();
                    self.currentStatus.watched = 'N';
                }

                if (self.currentStatus.rating === rating) {
                    self.currentStatus.rating = '0';
                } else {
                    self.currentStatus.rating = rating;
                }

                self.currentStatus.userId = self.user.userId;
                self.$store.dispatch('SETVIDEOSTATUS', self.currentStatus).then(function () {
                    self.currentStatus = _this3.getCurrentStatus;
                    if (self.currentStatus.rating !== '0' || self.currentStatus.rating === null) {
                        self.showRatingMessage = true;
                    }
                });
            }
        },
        setRating: function setRating(rating) {
            var _this4 = this;

            var self = this;
            if (!self.isTrialExpired) {
                var watchedDuration = void 0,
                    watchedPercentage = void 0;
                if (self.getCurrentVideoDurationWatched) {
                    watchedDuration = self.getCurrentVideoDurationWatched.duration;
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100);
                if (watchedPercentage >= 5) {
                    self.currentStatus.durationWatched = watchedDuration.toString();
                    self.currentStatus.watched = 'P';
                } else {
                    self.currentStatus.durationWatched = watchedDuration.toString();
                    self.currentStatus.watched = 'N';
                }

                if (self.currentStatus.rating === rating) {
                    self.currentStatus.rating = '0';
                } else {
                    self.currentStatus.rating = rating;
                }

                self.currentStatus.userId = self.user.userId;
                self.$store.dispatch('SETVIDEOSTATUS', self.currentStatus).then(function () {
                    self.currentStatus = _this4.getCurrentStatus;
                    if (self.currentStatus.rating !== '0' || self.currentStatus.rating === null) {}
                });
            }
        },
        logVideoEntry: function logVideoEntry() {
            var self = this;
            if (!self.isTrialExpired) {
                var logWatchedEntry = {
                    videoCode: this.$route.params.videoCode,
                    userId: this.user.userId,
                    playlistId: null,
                    playlistCode: null,
                    watched: 'N',
                    rating: null,
                    liked: '0',
                    durationWatched: 0,
                    thumbnailURL: null,
                    opinion: null
                };
                self.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {});
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/watch/' + videoCode);
            location.reload();
        },
        applyRatingClass: function applyRatingClass(rating) {
            if (rating === this.currentStatus.rating) {
                return true;
            } else {
                return false;
            }
        },
        setCarousal: function setCarousal() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.each(function () {
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        },
        toggleVideoCompleted: function toggleVideoCompleted() {
            var self = this;
            self.videoCompleted = true;
            setTimeout(function () {
                if (self.showCorporateShare) {
                    self.cancelCorporateModal();
                }
                self.videoSqueeze = true;
            }, 200);
        },
        replayVideo: function replayVideo() {
            var videoCode = this.$route.params.videoCode;
            this.videoCompleted = false;
            this.videoSqueeze = false;
            this.$router.push('/watch/' + videoCode);
            this.setVideoPlayerObject(videoCode);
        },
        changeHeight: function changeHeight() {
            this.hideLeftVideoIcons = true;
            this.showRateHoverBox = true;
            this.addRightHoverWidthClass = true;
            this.addIconHoverWidthClass = true;
            this.showShareHoverBox = false;
            this.showEnjoyHoverBox = false;
        },
        showSharing: function showSharing() {
            this.hideLeftVideoIcons = true;
            this.showShareHoverBox = true;
            this.addRightHoverWidthClass = true;
            this.addIconHoverWidthClass = true;
            this.showRateHoverBox = false;
            this.showEnjoyHoverBox = false;
        },
        redirectToHome: function redirectToHome() {
            this.$router.push('/');
        },
        showEnjoy: function showEnjoy() {
            this.showEnjoyHoverBox = true;
            this.hideLeftVideoIcons = true;
            this.addRightHoverEnjoyClass = true;
            this.addIconHoverWidthClass = true;
            this.addEnjoyHoverClass = true;
            this.showRateHoverBox = false;
            this.showShareHoverBox = false;
        },
        resetClass: function resetClass(bool) {
            if (bool) {
                this.hideLeftVideoIcons = false;
                this.addRightHoverWidthClass = false;
                this.addRightHoverEnjoyClass = false;
                this.addIconHoverWidthClass = false;
                this.showRateHoverBox = false;
                this.showShareHoverBox = false;
                this.showEnjoyHoverBox = false;
                this.addEnjoyHoverClass = false;
            } else {}
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this5 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this5.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        updateUserVideoView: function updateUserVideoView() {
            var _this6 = this;

            var self = this;
            if (!self.isTrialExpired) {
                var watchedDuration = void 0,
                    watchedPercentage = void 0;
                if (self.getCurrentVideoDurationWatched) {
                    watchedDuration = self.getCurrentVideoDurationWatched.duration;
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(self.getCurrentVideo[0].duration) * 100);
                if (watchedPercentage >= 5) {
                    self.currentStatus.durationWatched = watchedDuration.toString();
                    self.currentStatus.watched = 'P';
                } else {
                    self.currentStatus.durationWatched = watchedDuration.toString();
                    self.currentStatus.watched = 'N';
                }
                self.currentStatus.userId = self.user.userId;
                self.$store.dispatch('SETVIDEOSTATUS', self.currentStatus).then(function () {
                    self.currentStatus = _this6.getCurrentStatus;
                });
            }
        }
    },
    mounted: function mounted() {
        var _this7 = this;

        var self = this;

        var userPayload = [];
        var uId = 0;
        if (self.user) {
            uId = self.user.userId;
        }
        userPayload.push(uId);
        userPayload.push(self.$route.fullPath);
        console.log('user activity', userPayload);
        self.$store.dispatch('LOGUSERACTIVITY', userPayload);
        if (self.getTrialDays < 0) {
            self.isTrialExpired = true;
            var parameter = self.$route.params.refBy;
            if (parameter && (parameter.toLowerCase() === 'toneteaser' || parameter.toLowerCase() === 'tonetakeaway')) {} else {
                self.$router.push('/mytone');
            }
        }

        self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(function () {
            if (self.getTaggedEmailList) {
                self.emailList = [];
                self.emailList = self.getTaggedEmailList;
                console.log('email list', self.getTaggedEmailList);
            }
        });
        if (!self.isTrialExpired) {
            window.addEventListener('beforeunload', this.updateUserVideoView);
            this.$store.dispatch('GETCURRENTVIDEO', this.$route.params.videoCode).then(function () {
                if (_this7.getCurrentVideo) {
                    var video = _this7.getCurrentVideo;
                    if (video[0].isPrivate && video[0].isPrivate === '1') {
                        self.isVideoPrivate = true;
                        if (self.isVideoPrivate) {
                            if (self.user && self.user.corporation && self.user.corporation.corporationId.toString() === video[0].episode_id.toString()) {} else {
                                setTimeout(function () {
                                    _this7.$swal({
                                        title: 'Exclusive Content',
                                        text: 'Your account doesn\'t have access to this video',
                                        type: 'error',
                                        timer: 3000,
                                        showCancelButton: false,
                                        showConfirmButton: false
                                    }).then(function () {}, function (dismiss) {
                                        if (dismiss === 'timer') {
                                            self.$router.push('/mytone');
                                        }
                                    });
                                }, 1000);
                                self.playTheVideo = false;
                            }
                        }
                    }
                    console.log('is video private', self.isVideoPrivate);
                    _this7.currentVideo = {
                        video: video[0].sources[video[0].sources.length - 1].file,
                        title: video[0].title,
                        img: video[0].image,
                        playerID: new Date(),
                        tracks: video[0].tracks,
                        Description: video[0].description,
                        mediaId: video[0].mediaid,
                        mediaid: video[0].mediaid,
                        isPrivate: self.isVideoPrivate
                    };
                    self.$store.dispatch('CACHEPAGE', self.videoURL);
                    _this7.$store.dispatch('GETEXPERT', video[0].expertid).then(function () {});
                } else {
                    _this7.$swal({
                        title: 'Video not found',
                        text: '',
                        type: 'error',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {
                            self.$router.push('/mytone');
                        }
                    });
                }
            });

            this.$store.dispatch('GETVIDEOTRANSCRIPT', this.$route.params.videoCode).then(function () {});

            this.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', this.user.userId).then(function () {
                var filteredList = _this7.getAuthRecommendedVideos.filter(function (code) {
                    return code.mediaid !== _this7.currentVideoCode;
                });
                _this7.recommendationList = filteredList;
            });

            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(function () {
                if (_this7.getAuthUserVideos) {
                    var code = _this7.$route.params.videoCode;
                    var exists = _this7.getAuthUserVideos.filter(function (code) {
                        return code.videoCode === _this7.currentVideoCode;
                    });
                    if (exists && exists.length > 0) {
                        _this7.currentStatus = exists[0];
                    } else {
                        _this7.currentStatus = {
                            videoCode: _this7.$route.params.videoCode,
                            userId: _this7.user.userId,
                            playlistId: null,
                            playlistCode: null,
                            watched: 'N',
                            rating: null,
                            liked: '0',
                            durationWatched: 0,
                            thumbnailURL: null,
                            opinion: null
                        };
                        _this7.logVideoEntry();
                    }
                    console.log(code);
                }
            });

            this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(function () {});

            this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(function () {
                _this7.allCorps = [];
                if (_this7.getCorporatePayload) {
                    _this7.corporateInfo = _this7.getCorporatePayload;
                    _this7.allCorps = _this7.corporateInfo.lstCorporationUsers;
                }
            });
            this.videoMessage = this.getVideEndMessage[this.videoMessageIndex];
            this.$root.$on('social_shares_open', function (network, url) {
                window.logEvents('Video Player Page', 'social share', 'Video shared on: ' + network);
            });
        } else {
            if (this.user && this.user.corporation && this.user.corporation.corporationId === 90 && this.getTrialDays < 0) {
                this.$router.push('/become-member-novo');
            } else {
                self.showMemberOverlay = true;
                self.$store.dispatch('GETCURRENTVIDEO', self.$route.params.videoCode).then(function () {
                    if (self.getCurrentVideo) {
                        self.$store.dispatch('GETPROMOVIDEOFORCODE', self.getCurrentVideo[0].promo_video_code).then(function () {
                            if (self.getPromoVideo) {
                                var video = self.getPromoVideo;
                                self.currentVideo = {
                                    video: video[0].sources[video[0].sources.length - 1].file,
                                    title: video[0].title,
                                    img: video[0].image,
                                    playerID: new Date(),
                                    tracks: video[0].tracks,
                                    Description: video[0].description,
                                    mediaId: video[0].mediaid,
                                    mediaid: video[0].mediaid
                                };
                                self.$store.dispatch('GETEXPERT', video[0].expertid).then(function () {});
                                setTimeout(function () {
                                    var videoReference = window['currentVideoId'];
                                    window.jwplayer(videoReference).seek(1);
                                    window.jwplayer(videoReference).pause(true);
                                }, 800);
                            }
                        });
                    }
                });

                this.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', this.user.userId).then(function () {
                    var filteredList = _this7.getAuthRecommendedVideos.filter(function (code) {
                        return code.mediaid !== _this7.currentVideoCode;
                    });
                    _this7.recommendationList = filteredList;
                    setTimeout(function () {
                        _this7.setCarousal();
                    }, 2000);
                });

                this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(function () {
                    if (_this7.getAuthUserVideos) {
                        var code = _this7.$route.params.videoCode;
                        var exists = _this7.getAuthUserVideos.filter(function (code) {
                            return code.videoCode === _this7.currentVideoCode;
                        });
                        if (exists && exists.length > 0) {
                            _this7.currentStatus = exists[0];
                        } else {
                            _this7.currentStatus = {
                                videoCode: _this7.$route.params.videoCode,
                                userId: _this7.user.userId,
                                playlistId: null,
                                playlistCode: null,
                                watched: 'N',
                                rating: null,
                                liked: '0',
                                durationWatched: 0,
                                thumbnailURL: null,
                                opinion: null
                            };
                        }
                        console.log(code);
                    }
                });

                this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(function () {
                    _this7.allCorps = [];
                    if (_this7.getCorporatePayload) {
                        console.log('payload corp', _this7.getCorporatePayload);
                        _this7.corporateInfo = _this7.getCorporatePayload;
                        _this7.allCorps = _this7.corporateInfo.lstCorporationUsers;
                    }
                });

                this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(function () {});
                this.videoMessage = this.getVideEndMessage[this.videoMessageIndex];
                this.$root.$on('social_shares_open', function (network, url) {
                    window.logEvents('Video Player Page', 'social share', 'Video shared on: ' + network);
                });
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'error', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert', 'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getUserPlaylists', 'getPromoVideo', 'getTrialDays', 'getCorporatePayload', 'getCardExpiryDays', 'getTaggedEmailList', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor']), {
        styleObject: function styleObject() {
            if (this.hoverState) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor,
                    borderColor: this.getCorpButtonColor
                };
            } else {
                return {
                    color: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            }
        },
        styleObjectTranscript: function styleObjectTranscript() {
            if (this.hoverStateTranscript && this.viewTranscript) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor + ' !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                };
            } else {
                return {
                    border: '2px solid' + this.getCorpButtonColor + ' !important',
                    color: this.getCorpButtonColor
                };
            }
        }
    }),
    beforeDestroy: function beforeDestroy() {
        var _this8 = this;

        var self = this;
        if (!self.isTrialExpired) {
            var watchedDuration = void 0,
                watchedPercentage = void 0;
            if (self.getCurrentVideoDurationWatched) {
                watchedDuration = self.getCurrentVideoDurationWatched.duration;
            }
            watchedPercentage = parseInt(watchedDuration / parseInt(self.getCurrentVideo[0].duration) * 100);
            if (watchedPercentage >= 5) {
                console.log('percent watch 1 ', watchedPercentage);
                self.currentStatus.durationWatched = watchedDuration.toString();
                self.currentStatus.watched = 'P';
            } else {
                console.log('duration watch 1 ', watchedDuration);
                self.currentStatus.durationWatched = watchedDuration.toString();
                self.currentStatus.watched = 'N';
            }
            self.currentStatus.userId = self.user.userId;
            self.$store.dispatch('SETVIDEOSTATUS', self.currentStatus).then(function () {
                self.currentStatus = _this8.getCurrentStatus;
            });
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
    spinner: false,
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
        'checkbox': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["checkbox"],
        'button-group': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["buttonGroup"],
        'spinner': __WEBPACK_IMPORTED_MODULE_2_vue_strap__["spinner"],
        alert: alert
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    name: 'profile',
    data: function data() {
        return {
            metaTag_pageTitle: '',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: '',
            categoryVideos: null,
            spinnerText: 'fetching videos',
            interestIndexes: [],
            spinner: false,
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            firstVideoObject: '',
            toggleSpinner: false,
            showAllVideosFlag: false,
            isMobile: false,
            tabs: {
                videos: true,
                chat: false,
                discussion: false
            }
        };
    },
    watch: {
        'interestIndexes': function interestIndexes(to, from) {
            var self = this;
            self.spinnerText = 'fetching videos';
            self.toggleSpinner = true;
            self.showAllVideosFlag = false;
            var corpId = 0;
            if (self.user.corporation && this.user.corporation.corporationId > 0) {
                corpId = this.user.corporation.corporationId;
            }
            if (self.interestIndexes && self.interestIndexes.length > 0) {
                var tmpInterest = self.interestIndexes[self.interestIndexes.length - 1];
                console.log('category selected : tmpInterest = ', tmpInterest);
                self.interestIndexes.length = 0;
                self.interestIndexes[0] = tmpInterest;
                console.log('category selected', self.interestIndexes);
                var payload = {
                    corpId: corpId,
                    lstInterestSubCategoryName: self.interestIndexes
                };
                self.$store.dispatch('GETFILTEREDWORKVIDEOS', { payload: payload }).then(function () {
                    console.log('Results', self.getAuthWorkVideos.length);
                    self.toggleSpinner = false;
                });
            } else {
                var _corpId = 0;
                if (self.user.corporation && this.user.corporation.corporationId > 0) {
                    _corpId = this.user.corporation.corporationId;
                }
                var params = ['WORK', _corpId];
                self.$store.dispatch('GETAUTHVIDEOS', params).then(function () {
                    if (self.getAuthWorkVideos) {
                        self.toggleSpinner = false;
                    }
                });
            }
        }
    },
    methods: {
        formattedDuration: function formattedDuration(duration) {
            var hours = Math.floor(duration / 3600);
            var minutes = Math.floor(duration % 3600 / 60);
            var seconds = duration % 60;
            var formattedHours = hours > 0 ? hours + ':' : '';
            var formattedMinutes = minutes > 0 ? minutes + ':' : '0:';
            var formattedSeconds = seconds < 10 ? '0' + seconds : '' + seconds;
            return '' + formattedHours + formattedMinutes + formattedSeconds;
        },
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        styleInterestObject: function styleInterestObject(interestId) {
            var isSelected = this.interestIndexes.filter(function (x) {
                return x.toString() === interestId.toString();
            });
            if (isSelected && isSelected.length > 0) {
                return {
                    color: '#FFFFFF',
                    backgroundColor: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            } else {
                return {
                    color: this.getCorpButtonColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: this.getCorpButtonColor
                };
            }
        },
        showAllVideos: function showAllVideos(ref) {
            var _this = this;

            if (ref === 'top') {
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html,body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#btmLink').offset().top }, 800);
                    _this.toggleSpinner = true;
                    _this.showAllVideosFlag = true;
                    setTimeout(function () {
                        _this.toggleSpinner = false;
                    }, 700);
                }, 800);
            } else {
                this.toggleSpinner = true;
                this.showAllVideosFlag = true;
                setTimeout(function () {
                    _this.toggleSpinner = false;
                }, 700);
            }
        },
        hideCompleteList: function hideCompleteList() {
            var self = this;
            if (self.getAuthWorkVideos && self.getAuthWorkVideos.length <= 99 && !self.showAllVideosFlag) {
                return true;
            } else if (self.getAuthWorkVideos && self.getAuthWorkVideos.length > 99 && self.showAllVideosFlag) {
                return false;
            }
            return true;
        },

        switchTab: function switchTab(id) {
            for (var tab in this.tabs) {
                this.tabs[tab] = id === tab;
            }
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            if (this.getTrialDays < 0) {
                this.$router.push('/becomemember');
            } else {
                this.$router.push('/watch/' + videoCode);
            }
        },
        getVideoStatus: function getVideoStatus(videoObject) {
            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        setVideoStatus: function setVideoStatus(videoObject) {
            var _this2 = this;

            if (this.getAuthUserVideos) {
                var mediaId = videoObject.mediaid;
                var exists = this.getAuthUserVideos.filter(function (videoObject) {
                    return videoObject.videoCode === mediaId;
                });
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0';
                    } else {
                        exists[0].liked = '1';
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(function () {
                        _this2.$store.dispatch('GETAUTHUSERVIDEOS', _this2.user.userId);
                    });
                } else {
                    var logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    };
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(function () {
                        _this2.$store.dispatch('GETAUTHUSERVIDEOS', _this2.user.userId);
                    });
                }
            }
        },
        setPlaylistVideoStatus: function setPlaylistVideoStatus(video, playlist, currentStatus) {
            var self = this;
            self.selectedVideo = video.mediaid;
            self.selectedPlaylist = playlist.playlistId;
            if (currentStatus) {
                var payload = {};
                payload.videoCode = video.mediaid;
                payload.userPlaylistId = playlist.playlistId;
                payload.userId = this.user.userId;
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', { playlist: payload }).then(function () {
                    self.videoAdded = false;
                    self.videoRemoved = true;
                });
            } else {
                var _payload = {};
                _payload.videoCode = video.mediaid;
                _payload.userId = this.user.userId;
                _payload.userPlaylistId = playlist.playlistId;
                this.$store.dispatch('ADDVIDEOINPLAYLIST', { playlist: _payload }).then(function () {
                    self.videoAdded = true;
                    self.videoRemoved = false;
                });
            }
            setTimeout(function () {
                self.videoAdded = false;
                self.videoRemoved = false;
            }, 1500);
        },
        verifyPlaylistExists: function verifyPlaylistExists() {
            if (this.getUserPlaylists) {
                var playlistsWithVideo = this.getUserPlaylists.filter(function (x) {
                    return x.userPlaylistVideos !== null;
                });
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        verifyVideoExists: function verifyVideoExists(playlist, video) {
            var self = this;
            if (this.getUserPlaylists) {
                var findPlaylist = this.getUserPlaylists.filter(function (x) {
                    return x.playlistId === playlist.playlistId;
                });
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        var videos = findPlaylist[0].userPlaylistVideos.filter(function (x) {
                            return x.videoCode === video.mediaid;
                        });
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        addNewPlayList: function addNewPlayList() {
            var _this3 = this;

            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                var payload = {};
                payload.userId = this.user.userId;
                payload.title = this.newPlaylistName;
                this.$store.dispatch('CREATEPLAYLIST', { playlist: payload }).then(function () {
                    _this3.newPlaylistName = '';
                });
            }
        },
        showPlaylistMenu: function showPlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        },
        hidePlaylistMenu: function hidePlaylistMenu(videoCode) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + videoCode + ' + ul').toggleClass('hide');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getAuthWorkVideos', 'user', 'error', 'getAuthUserVideos', 'getUserPlaylists', 'getTrialDays', 'getVideoSubcategories', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getAllSiteContents'])),
    mounted: function mounted() {
        var _this4 = this;

        var self = this;
        self.$store.dispatch('GETDYNAMICCONTENTS', 27).then(function () {
            if (self.getAllSiteContents) {
                _this4.metaTag_pageTitle = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this4.metaTag_description = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this4.metaTag_keywords = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this4.metaTag_fb_title = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this4.metaTag_fb_image = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this4.metaTag_fb_description = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this4.metaTag_fb_sitename = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this4.metaTag_tw_title = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this4.metaTag_tw_image = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this4.metaTag_tw_description = _this4.setDynamicSection(_this4.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
            }
        });
        var checkMobile = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width();
        if (checkMobile < 767) {
            self.isMobile = true;
        } else {
            self.isMobile = false;
        }
        self.toggleSpinner = true;
        var corpId = 0;
        if (self.user.corporation && this.user.corporation.corporationId > 0) {
            corpId = this.user.corporation.corporationId;
        }
        var params = ['WORK', corpId];
        self.$store.dispatch('GETAUTHVIDEOS', params).then(function () {
            if (self.getAuthWorkVideos) {
                console.log('initial load', self.getAuthWorkVideos.length);
                self.firstVideoObject = self.getAuthWorkVideos[0];
                self.$store.dispatch('CACHEPAGE', window.location.href);
                self.toggleSpinner = false;
            }
        });
        self.$store.dispatch('GETVIDEOSUBCATEGORIES', params).then(function () {});

        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(function () {});

        this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(function () {});
    }
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'contentworkplayer',
    components: {
        jwplayer: __WEBPACK_IMPORTED_MODULE_1__JwPlayer_vue___default.a,
        'jwplaylist': __WEBPACK_IMPORTED_MODULE_2__JwPlayList_vue___default.a
    },
    metaInfo: function metaInfo() {
        var self = this;
        return {
            title: self.metaTag_pageTitle,
            meta: [{ name: 'keywords', content: self.metaTag_keywords }, { name: 'description', content: self.metaTag_description }, { property: 'og:image', content: self.metaTag_fb_image }, { property: 'og:title', content: self.metaTag_fb_title }, { property: 'og:site_name', content: self.metaTag_fb_sitename }, {
                property: 'og:description',
                content: self.metaTag_fb_description
            }, { property: 'twitter:title', content: self.metaTag_tw_title }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:image', content: self.metaTag_tw_image }, {
                property: 'twitter:description',
                content: self.metaTag_tw_description
            }, { property: 'og:image:width', content: '300' }, { property: 'og:image:height', content: '300' }]
        };
    },

    data: function data() {
        return {
            activeTab: 0,
            currentVideo: '',
            currentStatus: '',
            currentVideoCode: this.$route.params.videoCode,
            recommendationList: '',
            videoCompleted: false,
            videoSqueeze: false,
            hideLeftVideoIcons: false,
            addRightHoverWidthClass: false,
            addIconHoverWidthClass: false,
            showRateHoverBox: false,
            showShareHoverBox: false,
            showEnjoyHoverBox: false,
            addRightHoverEnjoyClass: false,
            addEnjoyHoverClass: false,
            captionTrack: '',
            viewTranscript: false,
            ratingOne: false,
            ratingTwo: false,
            ratingThree: false,
            ratingFour: false,
            hideAll: false,
            videoMessage: '',
            videoMessageIndex: Math.floor(Math.random() * 7),
            videoGif: '',
            videoGifIndex: Math.floor(Math.random() * 4),
            videoURL: window.location.href,
            videoNotFoundFlag: false,
            videoTag: '',
            videoList: '',
            categoryVideoList: null,
            videoExpert: '',
            categoryVideoList24: null,
            sharingImage: '',
            sharingTitle: '',
            sharingDescription: '',
            metaTag_pageTitle: '',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: '',
            showComponent: false
        };
    },
    methods: {
        setDynamicSection: function setDynamicSection(coll, key) {
            var valCol = coll.filter(function (x) {
                return x.content_id === key;
            });
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value;
            } else {
                return '';
            }
        },
        redeemCode: function redeemCode() {
            var self = this;
            if (self.getCorporateClient.invitationCode === '2') {
                self.$router.push('/corporation/referral/buy/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
            } else {
                self.$router.push('/corporationgifting/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
            }
        },
        setVideoPlayerObject: function setVideoPlayerObject(videoCode) {
            this.$router.push('/contentvideos/play/' + videoCode);
            location.reload();
        },
        redirectToHome: function redirectToHome() {
            this.$router.push('/');
        },
        triggerLogin: function triggerLogin(videoCode) {
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath');
                sessionStorage.setItem('redirectPath', '/watch/' + videoCode);
            } else {
                sessionStorage.setItem('redirectPath', '/watch/' + videoCode);
            }
            __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setTriggerLogin', { loginStatus: true });
        },
        create: function create() {
            __WEBPACK_IMPORTED_MODULE_6_jquery___default.a.slick = __WEBPACK_IMPORTED_MODULE_3_slick_carousel___default.a;
            var $slick = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el).find('.responsive-slick-slider');
            $slick.each(function () {
                __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this).slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                });
            });
        }
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        var videoCode = null;
        var contentCategory = 'work-promo';
        var fullPath = this.$route.fullPath;
        console.log('================> fullPath = ' + fullPath);
        localStorage.setItem('fromUnauthPage', 'work-promo');
        self.$store.dispatch('GETDYNAMICCONTENTS', 24).then(function () {
            if (self.getAllSiteContents) {

                _this.metaTag_pageTitle = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_PAGE_TITLE');
                _this.metaTag_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_DESCRIPTION');
                _this.metaTag_keywords = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_KEYWORDS');

                _this.metaTag_fb_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE');
                _this.metaTag_fb_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE');
                _this.metaTag_fb_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION');
                _this.metaTag_fb_sitename = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME');

                _this.metaTag_tw_title = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_TITLE');
                _this.metaTag_tw_image = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE');
                _this.metaTag_tw_description = _this.setDynamicSection(_this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION');
            }
        });

        if (!self.user) {
            self.$store.dispatch('GETUNAUTHVIDEOS', 'work-promo').then(function () {
                if (_this.getAllUnauthVideos) {
                    if (videoCode) {} else {
                        var video = _this.getAllUnauthVideos.filter(function (x) {
                            return x.tags.indexOf('work-promo') > -1;
                        });
                        if (video && video.length > 0) {
                            var vTag = contentCategory;
                            var expertId = video[0].expertid;
                            self.videoNotFoundFlag = false;
                            if (vTag.indexOf('work-promo') >= 0) {
                                self.videoTag = 'WORK';
                                self.videoList = self.getWorkVideo.filter(function (x) {
                                    return x.mediaid !== video[0].mediaid;
                                });
                                setTimeout(function () {
                                    _this.create();
                                }, 1500);

                                if (video && video.length > 15) {
                                    self.categoryVideoList = video.slice(0, 15);
                                } else {
                                    self.categoryVideoList = video;
                                }
                            } else {
                                self.categoryVideoList = '';
                                self.videoTag = null;
                                self.videoList = null;
                            }

                            self.sharingTitle = video[0].title;
                            self.sharingImage = video[0].image;
                            self.sharingDescription = video[0].description;
                            self.currentVideo = {
                                video: video[0].sources[video[0].sources.length - 1].file,
                                title: video[0].title,
                                img: video[0].image,
                                playerID: new Date(),
                                tracks: video[0].tracks,
                                Description: video[0].description,
                                mediaId: video[0].mediaid
                            };
                            self.$store.dispatch('CACHEPAGE', self.videoURL);
                            if (expertId && expertId > 0) {
                                self.$store.dispatch('GETEXPERT', expertId).then(function () {
                                    if (self.getExpert) {
                                        self.videoExpert = self.getExpert;
                                    }
                                });
                            } else {
                                self.videoExpert = null;
                            }
                        } else {
                            self.$swal({
                                title: 'Video not found or not available for unauthenticated users!',
                                text: '',
                                type: 'error',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(function () {}, function (dismiss) {
                                if (dismiss === 'timer') {
                                    self.$router.push('/');
                                }
                            });
                        }
                    }
                }
            });
        } else {
            console.info('1');
            self.$router.push('/');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'getWorkVideo', 'getLifeVideos', 'getMoneyVideo', 'getMindbodyVideo', 'getCommunityVideo', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert', 'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getAllUnauthVideos', 'getCorporateGiftingCode', 'getAuthWorkVideos', 'getAuthLifeVideos', 'getAuthMindbodyVideos', 'getAuthMoneyVideos', 'getCorporateClient', 'getCorporateClientId', 'getAllSiteContents', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor', 'getCorporateGiftInfo']), {
        styleBackground: function styleBackground() {
            return ['btn', 'btn-primary'];
        },
        styleSocialbackground: function styleSocialbackground() {
            return {
                '--background-color': this.corpButtonColor + ' !important'
            };
        }
    }),
    updated: function updated() {
        this.showComponent = true;
    }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"],
        'navbar': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["navbar"]
    },
    name: 'footer',
    data: function data() {
        return {
            signup: {
                email: ''
            },
            subscriptionForm: {
                userId: null,
                email: '',
                name: '',
                comments: '',
                rating: 0,
                newsLetterEmail: '0',
                promotionalEmail: '0',
                representativeCall: '0'
            },
            success: false,
            successMsg: '',
            displayMsg: '',
            placeHolderText: '',
            buttonTitle: '',
            bYear: new Date().getFullYear(),
            articleRoute: '',
            showGiftingLinks: false
        };
    },

    methods: {
        verifyEmail: function verifyEmail(email) {
            if (email.length > 0) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(email)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        onSubmitEmail: function onSubmitEmail() {
            var _this = this;

            var self = this;
            if (this.user && this.user !== null) {
                this.subscriptionForm.userId = this.user.userId;
                this.subscriptionForm.comments = 'Refer a Friend';
                this.subscriptionForm.promotionalEmail = '1';
                this.displayMsg = 'Successfully referred to your friend';
            } else {
                this.subscriptionForm.comments = 'Newsletter Subscription';
                this.subscriptionForm.newsLetterEmail = '1';
                this.displayMsg = 'Successfully subscribed to newsletter';
            }
            this.subscriptionForm.email = this.subscriptionForm.email.toLowerCase();
            if (self.verifyEmail(this.subscriptionForm.email)) {
                this.$store.dispatch('SENDFEEDBACKFORM', this.subscriptionForm).then(function () {
                    if (_this.subscriptionForm.comments === 'Refer a Friend') {
                        window.logEvents('Newsletter subscription', 'Subscribed', 'Newsletter subscribed by ' + _this.subscriptionForm.email);
                    } else {
                        window.logEvents('Refer a friend', 'Referred', 'Refer a friend by ' + _this.subscriptionForm.email);
                    }

                    self.$swal({
                        title: _this.displayMsg,
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    setTimeout(function () {
                        _this.success = false;
                        _this.subscriptionForm.email = '';
                        _this.subscriptionForm.promotionalEmail = '0';
                        _this.subscriptionForm.userId = null;
                        _this.subscriptionForm.email = '';
                        _this.subscriptionForm.name = '';
                        _this.subscriptionForm.comments = '';
                        _this.subscriptionForm.rating = 0;
                        _this.subscriptionForm.newsLetterEmail = '0';
                        _this.subscriptionForm.promotionalEmail = '0';
                        _this.subscriptionForm.representativeCall = '0';
                    }, 2000);
                });
            }
        }
    },
    watch: {
        'getGiftingLinksFlag': function getGiftingLinksFlag(to, from) {
            var self = this;
            if (self.getGiftingLinksFlag) {
                self.showGiftingLinks = false;
            } else {
                self.showGiftingLinks = true;
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'getAllArticles', 'getSiteStatus', 'getGiftingLinksFlag', 'getCorpFooterColor']), {
        currentRoute: function currentRoute() {
            return this.$route;
        },
        displayMessage: function displayMessage() {
            if (this.user) {
                if (this.user.userId > 0) {
                    return 'unauth';
                } else {
                    return 'auth';
                }
            } else {
                return 'unauth';
            }
        }
    }),
    mounted: function mounted() {
        var _this2 = this;

        this.$store.dispatch('GETALLARTICLES').then(function () {
            if (_this2.getAllArticles) {
                _this2.articleRoute = '/setthetone/article/' + _this2.getAllArticles[0].toneArticleId + '/' + _this2.getAllArticles[0].articleHead.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();
            } else {
                _this2.articleRoute = null;
            }
        });
        if (this.getGiftingLinksFlag) {
            this.showGiftingLinks = false;
        } else {
            this.showGiftingLinks = true;
        }

        var $ = __webpack_provided_window_dot_jQuery;
        $('.footer-nav li.scroll-up a').on('click', function (e) {
            e.preventDefault();

            var hash = this.hash;

            if ($(hash).length) {
                $('body, html').animate({
                    scrollTop: $(hash).offset().top
                }, 500, function () {});
            } else {
                window.location.hash = hash;
            }
        });
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_dateHelpers_js__ = __webpack_require__(15);









/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'navbar': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["navbar"],
        'bs-input': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
        'spinner': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["spinner"],
        'alert': __WEBPACK_IMPORTED_MODULE_1_vue_strap__["alert"],
        modal: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["modal"],
        checkbox: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["checkbox"]
    },
    props: ['hideNav'],
    name: 'header',
    data: function data() {
        return {
            isMobile: false,
            headerConfig: {
                isLoggedIn: false,
                background: '#44bda8'
            },
            info: {
                email: '',
                password: ''
            },
            forgetPassword: {
                email: ''
            },
            isNav: this.hideNav,
            showModal: false,
            spinner: false,
            isForget: false,
            isChecked: true,
            forgotPasswordSuccess: false,
            showExpertsModal: false,
            eventDescription: '',
            showEvent: false,
            authEventDescription: '',
            showAlertMsg: false,
            alertMsg: '',
            category: this.$route.params.contentCateogry,
            hideBanner: false,
            isNativeApp: false,
            isNativeAppNavigation: false,
            msgBoard: null,
            msgDuration: 0,
            startMsgBoard: true,
            intervalId: 0,
            expiryDateLimit: 265,
            showExpiryModal: false,
            showExpiredModal: false,
            showGiftIcon: true,
            customGiftMessage: '',
            customGiftUrl: '',
            showGiftingLinks: false
        };
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        this.category = to.params.contentCateogry;
        next();
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(window['intervalMsgBoard']);
    },

    watch: {
        'getGiftingLinksFlag': function getGiftingLinksFlag(to, from) {
            var self = this;
            if (self.getGiftingLinksFlag) {
                self.showGiftingLinks = false;
            } else {
                self.showGiftingLinks = true;
            }
        },
        'getCardExpiryDays': function getCardExpiryDays(to, from) {},
        '$route': function $route(to, from) {
            this.isNav = this.hideNav;
        },
        'getLoginTriggerStatus': function getLoginTriggerStatus(to, from) {
            if (this.getLoginTriggerStatus && !this.user) {
                this.openModal('login');
            }
        },
        'currentRoute.name': function currentRouteName(to, from) {
            var _this = this;

            var self = this;
            if (self.user && self.user.userId > 0) {
                self.$store.dispatch('UPDATEUSERPAYLOAD', self.user.userId).then(function () {
                    if (self.getCardExpiryDays) {
                        if (self.getCardExpiryDays < 0 && self.user.ccExpiryDate && self.user.ccExpAlarmFlag === 2) {
                            if (_this.currentRoute.name !== 'Profile' && _this.currentRoute.name !== 'B2b' && _this.currentRoute.name !== 'ToneResources' && _this.currentRoute.name !== 'Terms' && _this.currentRoute.name !== 'AboutUs' && _this.currentRoute.name !== 'ContactUs' && _this.currentRoute.name !== 'PressRelease' && _this.currentRoute.name !== 'FAQ' && _this.currentRoute.name !== 'PrivacyPolicy' && _this.currentRoute.name !== 'Feedback') {
                                self.showExpiredModal = true;
                                self.$router.next(false);
                            }
                        }
                    }
                });
            }
            this.$store.dispatch('GETAPPCONFIGRATION');
            if (self.getSiteStatus) {
                self.$router.push('/sitemaintenance');
            } else {
                if (this.currentRoute.name === 'Player' || this.currentRoute.name === 'PlaylistVideoPlayer' || this.currentRoute.name === 'CorpPlaylistVideoPlayer' || this.currentRoute.name === 'ArchivePlayer') {
                    console.log('(inside Header.vue) dismiss video player activity');
                } else {
                    console.log('log user navigation');
                    var userPayload = [];
                    var uId = 0;
                    if (self.user) {
                        uId = self.user.userId;
                    }
                    userPayload.push(uId);
                    userPayload.push(self.currentRoute.fullPath);
                    console.log('user activity', userPayload);
                    self.$store.dispatch('LOGUSERACTIVITY', userPayload);
                }
                if (self.startMsgBoard && self.user && self.user.userId > 0 && self.msgDuration > 10 && self.msgBoard) {
                    var removedItem = self.msgBoard.shift();
                    self.msgBoard.push(removedItem);
                }
                if (this.user && this.getAlertMsgStatus && this.getTrialDays < 0) {
                    if (this.user && this.user.corporation && this.user.corporation.corporationId === 90) {
                        this.$router.push('/become-member-novo');
                    } else {
                        if (this.currentRoute.name === 'Experts' || this.currentRoute.name === 'Expert' || this.currentRoute.name === 'Event' || this.currentRoute.name === 'ContactUs' || this.currentRoute.name === 'AboutUs' || this.currentRoute.name === 'Feedback' || this.currentRoute.name === 'Terms' || this.currentRoute.name === 'FAQ' || this.currentRoute.name === 'PrivacyPolicy' || this.currentRoute.name === 'Search' || this.currentRoute.name === 'Profile' || this.currentRoute.name === 'Gift' || this.currentRoute.name === 'Gifts' || this.currentRoute.name === 'Work' || this.currentRoute.name === 'Life' || this.currentRoute.name === 'Mindbody' || this.currentRoute.name === 'Money' || this.currentRoute.name === 'Player' || this.currentRoute.name === 'B2b' || this.currentRoute.name === 'Press') {} else {
                            if (this.user && this.user.corporation && this.user.corporation.corporationId === 90) {
                                this.$router.push('/become-member-novo');
                            } else {
                                this.$router.push('/becomemember');
                            }
                        }
                    }
                }
            }
        }
    },
    methods: {
        handleCorporateGiftingStatus: function handleCorporateGiftingStatus() {
            var self = this;
            if (self.user && self.user.corporation && self.user.corporation.corporationId > 0 && self.user.corporation.giftIconState === '3') {
                self.showGiftIcon = true;
                self.customGiftMessage = self.user.corporation.giftIconMessage;
                self.customGiftUrl = self.user.corporation.giftIconUrl;
            } else if (self.user && self.user.corporation && self.user.corporation.corporationId > 0 && self.user.corporation.giftIconState === '2') {
                self.showGiftIcon = true;
                self.customGiftMessage = '';
                self.customGiftUrl = '';
            } else {
                self.showGiftIcon = true;
                self.customGiftMessage = '';
                self.customGiftUrl = '';
            }
        },
        cancelExpiryModal: function cancelExpiryModal() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showExpiryModal = false;
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        cancelExpiredModal: function cancelExpiredModal() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html').removeClass('model-open');
            var self = this;
            window.setTimeout(function () {
                self.showExpiredModal = false;
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },

        logout: function logout(event) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#header-navbar').toggleClass('in');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.navbar-toggle').toggleClass('collapsed active');
            this.$store.dispatch('LOGOUT', this.user);
        },
        initiateMessageBoard: function initiateMessageBoard(interRef) {
            var removedItem = this.msgBoard.shift();
            this.msgBoard.push(removedItem);
        },
        closeBanner: function closeBanner() {
            this.startMsgBoard = false;
            clearInterval(window['intervalMsgBoard']);
        },
        corpBannerRedirect: function corpBannerRedirect(cUrl) {
            var self = this;
            if (cUrl) {
                var url = cUrl.trim();
                if (url.indexOf('http') > -1) {
                    window.open(url, 'toolbar=yes');
                } else if (url.indexOf('/') === 0) {
                    self.$router.push(url);
                } else {}
            } else {}
        },
        messageBoardRedirect: function messageBoardRedirect(msg) {
            var self = this;
            var userPayload = [];
            var uId = 0;
            if (self.user) {
                uId = self.user.userId;
            }
            userPayload.push(uId);
            userPayload.push(self.currentRoute.fullPath);
            userPayload.push('BLUE_BANNER_CLICK');
            userPayload.push(msg.bannerMessage);
            self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload);
            if (msg.destinationURL) {
                var url = msg.destinationURL.trim();
                if (url.indexOf('http') > -1) {
                    window.open(url, 'toolbar=yes');
                    var removedItem = self.msgBoard.shift();
                    self.msgBoard.push(removedItem);
                } else if (url.indexOf('/') === 0) {
                    self.$router.push(url);
                } else {}
            } else {}
        },
        redeemGiftcodeMobile: function redeemGiftcodeMobile() {
            console.log('10 inside header.vue [redeemGiftcodeMobile ()] ----------------> this.getCorporateClientId = ', this.getCorporateClientId);

            if (this.getCorporateClientId === '112' || this.getCorporateClientId === '197') {
                this.$router.push('/corporationgiftingcustom/' + this.getCorporateClientId + '/' + this.getCorporateGiftingCode);
            } else if (this.getCorporateClient.invitationCode === '2') {
                this.$router.push('/corporation/referral/buy/' + this.getCorporateClientId + '/' + this.getCorporateGiftingCode);
            } else {
                this.$router.push('/corporationgifting/' + this.getCorporateClientId + '/' + this.getCorporateGiftingCode);
            }
            this.checkAndToggleMenu();
        },
        redeemGiftcode: function redeemGiftcode() {
            console.log('10 inside header.vue [redeemGiftcode ()] ----------------> this.getCorporateClientId = ', this.getCorporateClientId);

            if (this.getCorporateClientId === '112' || this.getCorporateClientId === '197') {
                this.$router.push('/corporationgiftingcustom/' + this.getCorporateClientId + '/' + this.getCorporateGiftingCode);
            } else if (this.getCorporateClient.invitationCode === '2') {
                this.$router.push('/corporation/referral/buy/' + this.getCorporateClientId + '/' + this.getCorporateGiftingCode);
            } else {
                this.$router.push('/corporationgifting/' + this.getCorporateClientId + '/' + this.getCorporateGiftingCode);
            }
        },
        getDateReference: function getDateReference(dte, type) {
            var dt = new Date(dte);
            var dayStr = void 0,
                monStr = void 0;
            var eDay = dt.getDate();
            var eHours = this.getHoursFormatted(dt);
            var eMonth = dt.getMonth() + 1;
            var day = void 0;

            if (dt.getDay() === 0) {
                day = 'Sunday';
            } else if (dt.getDay() === 1) {
                day = 'Monday';
            } else if (dt.getDay() === 2) {
                day = 'Tuesday';
            } else if (dt.getDay() === 3) {
                day = 'Wednesday';
            } else if (dt.getDay() === 4) {
                day = 'Thursday';
            } else if (dt.getDay() === 5) {
                day = 'Friday';
            } else if (dt.getDay() === 6) {
                day = 'Saturday';
            } else {
                day = '';
            }

            if (eDay === 1) {
                dayStr = '1st';
            } else if (eDay === 2) {
                dayStr = '2nd';
            } else if (eDay === 3) {
                dayStr = '3rd';
            } else if (eDay === 21) {
                dayStr = '21st';
            } else if (eDay === 22) {
                dayStr = '22nd';
            } else if (eDay === 23) {
                dayStr = '23rd';
            } else if (eDay === 31) {
                dayStr = '31st';
            } else {
                dayStr = eDay + 'th';
            }

            if (eMonth === 1) {
                monStr = 'January';
            } else if (eMonth === 2) {
                monStr = 'February';
            } else if (eMonth === 3) {
                monStr = 'March';
            } else if (eMonth === 4) {
                monStr = 'April';
            } else if (eMonth === 5) {
                monStr = 'May';
            } else if (eMonth === 6) {
                monStr = 'June';
            } else if (eMonth === 7) {
                monStr = 'July';
            } else if (eMonth === 8) {
                monStr = 'August';
            } else if (eMonth === 9) {
                monStr = 'September';
            } else if (eMonth === 10) {
                monStr = 'October';
            } else if (eMonth === 11) {
                monStr = 'November';
            } else if (eMonth === 12) {
                monStr = 'December';
            }
            if (type === 'event') {
                return monStr + ' ' + dayStr;
            } else if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!';
            } else if (type === 'live') {
                return monStr + ' ' + eDay;
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET';
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET';
            }
        },
        redirectToFeedback: function redirectToFeedback() {
            this.$router.push('/feedback');
        },
        cancelModal: function cancelModal() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html').removeClass('model-open');
            var self = this;

            setTimeout(function () {
                self.showModal = false;

                self.isForget = false;

                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        cancelExpertsModal: function cancelExpertsModal() {
            var self = this;

            setTimeout(function () {
                self.showExpertsModal = false;

                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.modal-open').removeClass('modal-open');
            }, 500);
        },
        openModal: function openModal(status) {
            window.logEvents('Unauthenticated Page', 'click', 'Login');
            var originalVideoCode = this.getOriginalVideoCode;
            var originalVieoTitle = this.getOriginalVideoTitle;
            if (this.currentRoute.name === 'SharePlayer') {
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath');
                    sessionStorage.setItem('redirectPath', this.currentRoute.path);
                } else {
                    sessionStorage.setItem('redirectPath', this.currentRoute.path);
                }
            } else if (originalVideoCode && this.currentRoute.name === 'UnauthPlayer') {
                var refBy = this.$route.params.refBy;
                if (refBy && (refBy.toLowerCase() === 'toneteaser' || refBy.toLowerCase() === 'tonetakeaway')) {
                    if (sessionStorage.getItem('redirectPath')) {
                        sessionStorage.removeItem('redirectPath');
                        if (originalVieoTitle) {
                            sessionStorage.setItem('redirectPath', '/watch/' + originalVideoCode + '/' + refBy + '/' + originalVieoTitle);
                        } else {
                            sessionStorage.setItem('redirectPath', '/watch/' + originalVideoCode + '/' + refBy);
                        }
                    } else {
                        if (originalVieoTitle) {
                            sessionStorage.setItem('redirectPath', '/watch/' + originalVideoCode + '/' + refBy + '/' + originalVieoTitle);
                        } else {
                            sessionStorage.setItem('redirectPath', '/watch/' + originalVideoCode + '/' + refBy);
                        }
                    }
                } else {
                    if (sessionStorage.getItem('redirectPath')) {
                        sessionStorage.removeItem('redirectPath');
                        if (originalVieoTitle) {
                            sessionStorage.setItem('redirectPath', '/watch/' + originalVideoCode + '/' + originalVieoTitle);
                        } else {
                            sessionStorage.setItem('redirectPath', '/watch/' + originalVideoCode);
                        }
                    } else {
                        if (originalVieoTitle) {
                            sessionStorage.setItem('redirectPath', '/watch/' + originalVideoCode + '/' + originalVieoTitle);
                        } else {
                            sessionStorage.setItem('redirectPath', '/watch/' + originalVideoCode);
                        }
                    }
                }
            }
            if (status === 'login') {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('html').addClass('model-open');
            }
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#header-navbar').removeClass('in');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.navbar-toggle').removeClass('collapsed active');
            this.showModal = true;
        },
        gotoProfile: function gotoProfile() {
            this.checkAndToggleMenu();
            this.$router.push('/profile');
        },
        joinEventFromBanner: function joinEventFromBanner(eventId) {},
        checkAndToggleMenu: function checkAndToggleMenu() {
            setTimeout(function () {
                if (__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#header-navbar').hasClass('in')) {
                    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#header-navbar').toggleClass('in');
                    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.navbar-toggle').toggleClass('collapsed active');
                }
            }, 50);
        },
        spinnerToggle: function spinnerToggle() {
            this.spinner = !this.spinner;
        },
        logoClickRedirect: function logoClickRedirect() {
            var self = this;
            if (self.user && self.currentRoute.name === 'Hello') {
                window.location.reload();
                return;
            }
            self.checkAndToggleMenu();
            if (self.getMarketingPlan || self.getCorporateGiftingCode) {
                if (self.getCorporateGiftingCode) {
                    if (self.getCorporateClient.invitationCode === '2') {
                        self.$router.push('/corporation/referral/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
                    } else {
                        self.$router.push('/corporation/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
                    }
                } else {
                    self.$router.push('/plan/' + this.getMarketingPlan);
                }
            } else {
                self.$router.push('/');
            }
        },
        directToSignup: function directToSignup() {
            window.logEvents('Unauthenticated Page', 'click', 'Signup from Header');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#header-navbar').toggleClass('in');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.navbar-toggle').toggleClass('collapsed active');
            if (this.getMarketingPlan) {
                this.$router.push('/signup/' + this.getMarketingPlan);
            } else {
                this.$router.push('/signup');
            }
        },
        redirectToUnAuthenticatedPage: function redirectToUnAuthenticatedPage(route) {
            var hash = route;
            window.scrollTo(0, 0);
            this.$router.push('/');
            setTimeout(function () {
                if (__WEBPACK_IMPORTED_MODULE_3_jquery___default()(hash).length) {
                    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('body, html').animate({
                        scrollTop: __WEBPACK_IMPORTED_MODULE_3_jquery___default()(hash).offset().top
                    }, 1000, function () {});
                }
            }, 1000);
        },
        searchClick: function searchClick() {
            this.$router.push('/search');
            this.checkAndToggleMenu();
        },
        headerMenusClick: function headerMenusClick(route) {
            window.logEvents('Feedback Page', 'Tell Us What you Think Link Clicked');
            this.$router.push(route);
            this.checkAndToggleMenu();
        },
        expertsClick: function expertsClick() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#header-navbar').toggleClass('in');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.navbar-toggle').toggleClass('collapsed active');

            if (!this.isUserLoggedIn) {
                this.showExpertsModal = true;
            } else {
                this.$router.push('/experts');
            }
        },
        redirectSignup: function redirectSignup() {
            this.cancelModal();
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#header-navbar').toggleClass('in');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.navbar-toggle').toggleClass('collapsed active');
            if (this.getMarketingPlan > 0) {
                this.$router.push('/signup/' + this.getMarketingPlan);
            } else {
                this.$router.push('/signup');
            }
        },
        returnEasternTime: function returnEasternTime() {
            var offset = -5;
            if (__WEBPACK_IMPORTED_MODULE_4__helpers_dateHelpers_js__["a" /* dateHelpers */].dstEnabled(new Date())) {
                offset = -4.0;
            }
            var clientDate = new Date();
            var utc = clientDate.getTime() + clientDate.getTimezoneOffset() * 60000;
            var serverDate = new Date(utc + 3600000 * offset);

            return serverDate;
        },
        isEventToday: function isEventToday(evtDate) {
            var eventDate = new Date(evtDate);
            var currentDate = this.returnEasternTime();

            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) >= 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        JoinEventOrRedirect: function JoinEventOrRedirect() {
            var _this2 = this;

            console.log('1 -> Header.vue -> JoinEventOrRedirect() -> ');
            if (this.getEventList) {
                console.log('2 -> Header.vue -> JoinEventOrRedirect() -> this.getEventList = ', this.getEventList);
                var ev = this.getEventList.filter(function (e) {
                    return e.eventId === _this2.getBannerEvent;
                });
                console.log('3 -> Header.vue -> JoinEventOrRedirect() -> ev = ', ev);
                if (ev && ev.length > 0) {
                    var eventDate = new Date(ev[0].start_date);
                    var eventEndDate = new Date(ev[0].end_date);
                    var currentDate = this.returnEasternTime();
                    console.log('4A -> Header.vue -> JoinEventOrRedirect() -> eventDate.getDate() = ', eventDate.getDate());
                    console.log('4B -> Header.vue -> JoinEventOrRedirect() -> currentDate = ', currentDate);
                    if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                        console.log('5 -> Header.vue -> JoinEventOrRedirect() -> ev = ', ev);
                        if (this.getMinutesBetweenDates(currentDate, eventDate) <= 60 && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                            console.log('6 -> Header.vue -> JoinEventOrRedirect() -> ev = ', ev);
                            this.$router.push('/events');
                        } else {
                            console.log('7 -> Header.vue -> JoinEventOrRedirect() -> ev = ', ev);
                            this.$router.push('/events');
                        }
                    } else {
                        console.log('8 -> Header.vue -> JoinEventOrRedirect() ->');
                        this.$router.push('/events');
                    }
                    console.log('9 -> Header.vue -> JoinEventOrRedirect() ->');
                }
            } else {
                console.log('10 -> Header.vue -> JoinEventOrRedirect() ->');
                this.$router.push('/events');
            }
            console.log('11 -> Header.vue -> JoinEventOrRedirect() ->');
        },
        getMinutesBetweenDates: function getMinutesBetweenDates(startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime();
            return diff / 60000;
        },
        getHoursFormatted: function getHoursFormatted(time) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours === 0 ? '12' : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        },
        onSubmit: function onSubmit() {
            var _this3 = this;

            var self = this;
            if (self.info.email && self.info.password) {
                self.spinnerToggle();
                self.$store.dispatch('LOGIN', { user: self.info }).then(function () {
                    self.spinnerToggle();
                    if (!self.error.show) {
                        if (__WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width() > 739) {} else {
                            var _self = _this3;
                            var eventDesc;
                            _this3.$store.dispatch('GETEVENTLIST').then(function () {
                                if (_this3.getEventList) {
                                    var currentDate = _this3.returnEasternTime();
                                    var eMonth = currentDate.getMonth() + 1;
                                    eMonth = eMonth >= 10 ? eMonth : '0' + eMonth;
                                    var eDate = currentDate.getDate() >= 10 ? currentDate.getDate() : '0' + currentDate.getDate();
                                    var formattedDate = eMonth + '/' + eDate + '/' + currentDate.getFullYear();

                                    var eventsOnDate = _this3.getEventList.filter(function (ev) {
                                        return ev.start_date.substr(0, 10) === formattedDate;
                                    });

                                    var eventsNotOnDate = _this3.getEventList.filter(function (ev) {
                                        return new Date(ev.start_date.substr(0, 10)) > new Date(formattedDate);
                                    });
                                    if (eventsOnDate && eventsOnDate.length > 0) {
                                        if (_this3.isEventToday(eventsOnDate[0].end_date)) {
                                            var eventTime = new Date(eventsOnDate[0].start_date);
                                            var eventHrs = _this3.getHoursFormatted(eventTime);
                                            _this3.$store.dispatch('SETBANNEREVENT', eventsOnDate[0].eventId).then(function () {});
                                            if (eventsOnDate[0].type === '1') {
                                                eventDesc = 'Join us for TONE Live at ' + eventHrs + ' ET';
                                                _this3.eventDescription = eventsOnDate[0].unAuthBannerText;
                                            } else {
                                                eventDesc = 'Join us for TONE Talks at ' + eventHrs + ' ET';
                                                _this3.eventDescription = eventsOnDate[0].unAuthBannerText;
                                            }
                                            if (_self.currentRoute.name === 'Hello') {
                                                if (_self.user && _self.user.corporation == null) {
                                                    _self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText: 'Find out more'
                                                    }).then(function () {
                                                        _self.JoinEventOrRedirect();
                                                    }, function (dismiss) {
                                                        if (dismiss === 'timer') {}
                                                    });
                                                } else if (_self.user && _self.user.corporation && _self.user.corporation.enableCorporatePage === 1 && _self.user.corporation.bnrLinkState === 1) {
                                                    _self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText: 'Find out more'
                                                    }).then(function () {
                                                        _self.JoinEventOrRedirect();
                                                    }, function (dismiss) {
                                                        if (dismiss === 'timer') {}
                                                    });
                                                } else if (_self.user && _self.user.corporation && _self.user.corporation.enableCorporatePage === 1 && _self.user.corporation.bnrLinkState === 2) {
                                                    _self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + _self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText: 'Find out more'
                                                    }).then(function () {
                                                        _self.$router.push('/corporation/mycommunity');
                                                    }, function (dismiss) {
                                                        if (dismiss === 'timer') {}
                                                    });
                                                } else if (_self.user && _self.user.corporation && _self.user.corporation.enableCorporatePage === 1 && _self.user.corporation.bnrLinkState === 3) {
                                                    _self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + _self.user.corporation.bnrCustomMsg + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText: 'Find out more'
                                                    }).then(function () {
                                                        _self.$router.push(_self.user.corporation.bnrCustomMsgUrl);
                                                    }, function (dismiss) {
                                                        if (dismiss === 'timer') {}
                                                    });
                                                }
                                            } else {}
                                        } else {
                                            if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                                _this3.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(function () {});
                                                if (eventsNotOnDate[0].type === '1') {
                                                    _this3.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                                    _this3.authEventDescription = eventsNotOnDate[0].authBannerText;
                                                } else {
                                                    _this3.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                                    _this3.authEventDescription = eventsNotOnDate[0].authBannerText;
                                                }
                                                eventDesc = _this3.eventDescription;
                                                if (_self.currentRoute.name === 'Hello') {
                                                    if (_self.user && _self.user.corporation == null) {
                                                        _self.$swal({
                                                            background: '#44bda8',
                                                            title: '',
                                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                            text: '',
                                                            type: null,
                                                            timer: 5000,
                                                            showConfirmButton: true,
                                                            showCloseButton: true,
                                                            showCancelButton: false,
                                                            confirmButtonColor: '#f0617d',
                                                            confirmButtonText: 'Find out more'
                                                        }).then(function () {
                                                            _self.JoinEventOrRedirect();
                                                        }, function (dismiss) {
                                                            if (dismiss === 'timer') {}
                                                        });
                                                    } else if (_self.user && _self.user.corporation && _self.user.corporation.enableCorporatePage === 1 && _self.user.corporation.bnrLinkState === 1) {
                                                        _self.$swal({
                                                            background: '#44bda8',
                                                            title: '',
                                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                            text: '',
                                                            type: null,
                                                            timer: 5000,
                                                            showConfirmButton: true,
                                                            showCloseButton: true,
                                                            showCancelButton: false,
                                                            confirmButtonColor: '#f0617d',
                                                            confirmButtonText: 'Find out more'
                                                        }).then(function () {
                                                            _self.JoinEventOrRedirect();
                                                        }, function (dismiss) {
                                                            if (dismiss === 'timer') {}
                                                        });
                                                    } else if (_self.user && _self.user.corporation && _self.user.corporation.enableCorporatePage === 1 && _self.user.corporation.bnrLinkState === 2) {
                                                        _self.$swal({
                                                            background: '#44bda8',
                                                            title: '',
                                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + _self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                            text: '',
                                                            type: null,
                                                            timer: 5000,
                                                            showConfirmButton: true,
                                                            showCloseButton: true,
                                                            showCancelButton: false,
                                                            confirmButtonColor: '#f0617d',
                                                            confirmButtonText: 'Find out more'
                                                        }).then(function () {
                                                            _self.$router.push('/corporation/mycommunity');
                                                        }, function (dismiss) {
                                                            if (dismiss === 'timer') {}
                                                        });
                                                    } else if (_self.user && _self.user.corporation && _self.user.corporation.enableCorporatePage === 1 && _self.user.corporation.bnrLinkState === 3) {
                                                        _self.$swal({
                                                            background: '#44bda8',
                                                            title: '',
                                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + _self.user.corporation.bnrCustomMsg + ' </span>',
                                                            text: '',
                                                            type: null,
                                                            timer: 5000,
                                                            showConfirmButton: true,
                                                            showCloseButton: true,
                                                            showCancelButton: false,
                                                            confirmButtonColor: '#f0617d',
                                                            confirmButtonText: 'Find out more'
                                                        }).then(function () {
                                                            _self.$router.push(_self.user.corporation.bnrCustomMsgUrl);
                                                        }, function (dismiss) {
                                                            if (dismiss === 'timer') {}
                                                        });
                                                    }
                                                } else {}
                                            }
                                        }
                                    } else {
                                        if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                            _this3.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(function () {});
                                            if (eventsNotOnDate[0].type === '1') {
                                                _this3.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                                _this3.authEventDescription = eventsNotOnDate[0].authBannerText;
                                            } else {
                                                _this3.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                                _this3.authEventDescription = eventsNotOnDate[0].authBannerText;
                                            }
                                            eventDesc = _this3.eventDescription;
                                            if (_self.currentRoute.name === 'Hello') {
                                                if (_self.user && _self.user.corporation == null) {
                                                    _self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText: 'Find out more'
                                                    }).then(function () {
                                                        _self.JoinEventOrRedirect();
                                                    }, function (dismiss) {
                                                        if (dismiss === 'timer') {}
                                                    });
                                                } else if (_self.user && _self.user.corporation && _self.user.corporation.enableCorporatePage === 1 && _self.user.corporation.bnrLinkState === 1) {
                                                    _self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText: 'Find out more'
                                                    }).then(function () {
                                                        _self.JoinEventOrRedirect();
                                                    }, function (dismiss) {
                                                        if (dismiss === 'timer') {}
                                                    });
                                                } else if (_self.user && _self.user.corporation && _self.user.corporation.enableCorporatePage === 1 && _self.user.corporation.bnrLinkState === 2) {
                                                    _self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + _self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText: 'Find out more'
                                                    }).then(function () {
                                                        _self.$router.push('/corporation/mycommunity');
                                                    }, function (dismiss) {
                                                        if (dismiss === 'timer') {}
                                                    });
                                                } else if (_self.user && _self.user.corporation && _self.user.corporation.enableCorporatePage === 1 && _self.user.corporation.bnrLinkState === 3) {
                                                    _self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + _self.user.corporation.bnrCustomMsg + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText: 'Find out more'
                                                    }).then(function () {
                                                        _self.$router.push(_self.user.corporation.bnrCustomMsgUrl);
                                                    }, function (dismiss) {
                                                        if (dismiss === 'timer') {}
                                                    });
                                                }
                                            } else {}
                                        }
                                    }
                                }
                            });
                        }
                    }
                    if (self.error.show && self.error.originalMessage !== 'aws.cognito.UserNotConfirmed') {
                        self.$swal({
                            title: self.error.message,
                            text: '',
                            type: 'error',
                            timer: 2000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(function () {}, function (dismiss) {
                            if (dismiss === 'timer') {}
                        });
                    } else if (self.error.show && self.error.originalMessage === 'aws.cognito.UserNotConfirmed') {
                        self.$swal({
                            title: 'Validate Your Email Address',
                            text: 'We have already sent you a validation email. Do you want us to resend it?',
                            type: 'error',
                            showCancelButton: true,
                            confirmButtonText: 'Yes, Please',
                            cancelButtonText: 'Cancel',
                            confirmButtonClass: 'btn btn-success',
                            cancelButtonClass: 'btn btn-danger',
                            buttonsStyling: false
                        }).then(function (result) {
                            self.$store.dispatch('RESENDVALIDATIONCODE', self.info.email).then(function () {
                                self.$swal({
                                    title: 'Check your mailbox for new validation email',
                                    text: '',
                                    type: 'success',
                                    timer: 3000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(function () {}, function (dismiss) {
                                    if (dismiss === 'timer') {}
                                });
                                self.cancelModal();
                            });
                        }, function (dismiss) {});
                    } else {
                        self.cancelModal();
                    }
                });
            }
        },

        onSubmitForgetRequest: function onSubmitForgetRequest() {
            var _this4 = this;

            var self = this;
            this.spinnerToggle();
            this.$store.dispatch('FORGOTPASSWORD', { user: this.forgetPassword }).then(function () {
                _this4.spinnerToggle();
                if (self.error.show) {
                    self.$swal({
                        title: self.error.message,
                        text: '',
                        type: 'error',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                } else {
                    self.$swal({
                        title: 'Forgot Password Request Sent! Check your email and follow the reset link',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(function () {}, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                    self.cancelModal();
                }
            });
        },
        openTonePodPage: function openTonePodPage() {
            window.open('https://www.podpage.com/have-you-had-this-conversation/', '_blank');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['isUserLoggedIn', 'user', 'isScrolled', 'error', 'getMarketingPlan', 'getAllExperts', 'getEventList', 'getBannerEvent', 'getLoginTriggerStatus', 'getAlertMsgStatus', 'getTrialDays', 'getCorporateGiftingCode', 'getCorporateClientId', 'getCorporateClient', 'getOriginalVideoCode', 'getOriginalVideoTitle', 'getMessageDuration', 'getMessageBoard', 'getSiteStatus', 'getGiftingText', 'getCardExpiryDays', 'getCustomUnauthBannerStatus', 'getCustomUnauthBannerText', 'getCustomUnauthBannerLink', 'getGiftingLinksFlag', 'getAuthLeftTopBannerMessage', 'getAuthLeftTopBannerUrl', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getCorporateGiftInfo']), {
        currentRoute: function currentRoute() {
            return this.$route;
        }
    }),
    mounted: function mounted() {
        var _this5 = this;

        var self = this;
        var $ = __webpack_provided_window_dot_jQuery;
        if ($(window).width() > 767) {
            self.isMobile = false;
        } else {
            self.isMobile = true;
        }
        console.log('(inside Header.vue) current route', self.currentRoute);
        clearInterval(window['intervalMsgBoard']);

        if (navigator.userAgent.indexOf('gonative') > -1) {
            this.isNativeApp = true;
            this.isNativeAppNavigation = true;
        }
        this.$store.dispatch('GETAPPCONFIGRATION').then(function () {
            if (self.getSiteStatus) {
                self.$router.push('/sitemaintenance');
            }

            _this5.msgDuration = _this5.getMessageDuration * 1000;
        });
        if (self.getGiftingLinksFlag) {
            self.showGiftingLinks = false;
        } else {
            self.showGiftingLinks = true;
        }
        var corpId = 0;
        if (self.user && self.user.corporation && this.user.corporation.corporationId > 0) {
            corpId = this.user.corporation.corporationId;
        }
        this.$store.dispatch('GETMESSAGEBOARD', corpId).then(function () {
            _this5.msgBoard = _this5.getMessageBoard;
        });
        setTimeout(function () {
            if (self.user && self.user.userId > 0 && self.msgDuration > 10) {
                self.$store.dispatch('UPDATEUSERPAYLOAD', self.user.userId);
                clearInterval(window['intervalMsgBoard']);
                window['intervalMsgBoard'] = setInterval(function () {
                    self.initiateMessageBoard();
                }, self.msgDuration);
            }
            if (self.user && self.user.userId > 0 && self.user.ccExpiryDate && self.user.ccExpAlarmFlag === 2) {
                self.$store.dispatch('UPDATEUSERPAYLOAD', self.user.userId).then(function () {
                    if (self.getCardExpiryDays) {
                        if (self.getCardExpiryDays >= 0 && self.getCardExpiryDays <= 5) {
                            self.showExpiryModal = true;
                        } else if (self.getCardExpiryDays < 0) {
                            if (_this5.currentRoute.name !== 'Profile') {
                                self.showExpiredModal = true;
                            }
                        }
                    }
                });
            }

            if (_this5.user && _this5.user.corporation && _this5.user.corporation.corporationId === 90 && _this5.getTrialDays < 0) {
                _this5.$router.push('/become-member-novo');
            }
        }, 1200);
        this.$store.dispatch('GETALLEXPERTS').then(function () {});
        $('.navbar-header .navbar-toggle').on('click', function () {
            $(this).toggleClass('active');
        });
        $('.userProfile>span>a').on('click', function () {
            $('#header-navbar').toggleClass('in');
            $('.navbar-toggle').toggleClass('collapsed active');
        });

        $('.toggleMenu').on('click', function () {
            self.checkAndToggleMenu();
        });
        $('#header-navbar ul.application-icons li').on('click', 'a.not-logged', function (e) {
            e.preventDefault();

            var hash = this.hash;

            if (!self.isUserLoggedIn) {
                $('#header-navbar').toggleClass('in');
                $('.navbar-toggle').toggleClass('collapsed active');
                if (self.$route.name !== 'UnAuth') {
                    if (self.getCorporateGiftingCode || self.getCorporateClientId) {
                        window.scrollTo(0, 0);
                        self.$router.push('/corporation/' + self.getCorporateClientId + '/' + self.getCorporateGiftingCode);
                    } else {
                        window.scrollTo(0, 0);
                        self.$router.push('/');
                    }
                    setTimeout(function () {
                        if ($(hash).length) {
                            $('body, html').animate({
                                scrollTop: $(hash).offset().top
                            }, 1000, function () {});
                        }
                    }, 2000);
                } else {
                    if ($(hash).length) {
                        $('body, html').animate({
                            scrollTop: $(hash).offset().top
                        }, 1000, function () {});
                    }
                }
            } else {
                window.location.hash = hash;
                $('#header-navbar').toggleClass('in');
                $('.navbar-toggle').toggleClass('collapsed active');
            }
        });
        $('#header-navbar ul.application-icons li').on('click', 'a.logged', function (e) {
            $('#header-navbar').toggleClass('in');
            $('.navbar-toggle').toggleClass('collapsed active');
        });

        if ($(window).width() > 739) {
            this.$store.dispatch('GETEVENTLIST').then(function () {
                if (_this5.getEventList) {
                    var currentDate = _this5.returnEasternTime();
                    var eMonth = currentDate.getMonth() + 1;
                    eMonth = eMonth >= 10 ? eMonth : '0' + eMonth;
                    var eDate = currentDate.getDate() >= 10 ? currentDate.getDate() : '0' + currentDate.getDate();
                    var formattedDate = eMonth + '/' + eDate + '/' + currentDate.getFullYear();

                    var eventsOnDate = _this5.getEventList.filter(function (ev) {
                        return ev.start_date.substr(0, 10) === formattedDate;
                    });

                    var eventsNotOnDate = _this5.getEventList.filter(function (ev) {
                        return new Date(ev.start_date.substr(0, 10)) > new Date(formattedDate);
                    });
                    if (eventsOnDate && eventsOnDate.length > 0) {
                        if (_this5.isEventToday(eventsOnDate[0].end_date)) {
                            _this5.$store.dispatch('SETBANNEREVENT', eventsOnDate[0].eventId).then(function () {});
                            if (eventsOnDate[0].type === '1') {
                                _this5.eventDescription = eventsOnDate[0].unAuthBannerText;
                                _this5.authEventDescription = eventsOnDate[0].authBannerText;
                            } else {
                                _this5.eventDescription = eventsOnDate[0].unAuthBannerText;
                                _this5.authEventDescription = eventsOnDate[0].authBannerText;
                            }
                        } else {
                            if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                _this5.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(function () {});
                                if (eventsNotOnDate[0].type === '1') {
                                    _this5.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                    _this5.authEventDescription = eventsNotOnDate[0].authBannerText;
                                } else {
                                    _this5.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                    _this5.authEventDescription = eventsNotOnDate[0].authBannerText;
                                }
                            }
                        }
                    } else {
                        if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                            _this5.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(function () {
                                _this5.showEvent = true;
                            });
                            if (eventsNotOnDate[0].type === '1') {
                                _this5.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                _this5.authEventDescription = eventsNotOnDate[0].authBannerText;
                            } else {
                                _this5.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                _this5.authEventDescription = eventsNotOnDate[0].authBannerText;
                            }
                        }
                    }
                }
            });
        } else {
            var eventDesc = void 0;
            this.$store.dispatch('GETAPPCONFIGRATION').then(function () {
                if (self.currentRoute.name === 'UnAuth' && self.getCustomUnauthBannerStatus) {
                    self.$swal({
                        background: '#44bda8',
                        title: '',
                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.getCustomUnauthBannerText + ' </span>',
                        text: '',
                        type: null,
                        timer: 5000,
                        showConfirmButton: true,
                        showCloseButton: true,
                        showCancelButton: false,
                        confirmButtonColor: '#f0617d',
                        confirmButtonText: 'Find out more'
                    }).then(function () {
                        self.$router.push(self.getCustomUnauthBannerLink);
                    }, function (dismiss) {
                        if (dismiss === 'timer') {}
                    });
                } else {
                    _this5.$store.dispatch('GETEVENTLIST').then(function () {
                        if (_this5.getEventList) {
                            var currentDate = _this5.returnEasternTime();
                            var eMonth = currentDate.getMonth() + 1;
                            eMonth = eMonth >= 10 ? eMonth : '0' + eMonth;
                            var eDate = currentDate.getDate() >= 10 ? currentDate.getDate() : '0' + currentDate.getDate();
                            var formattedDate = eMonth + '/' + eDate + '/' + currentDate.getFullYear();

                            var eventsOnDate = _this5.getEventList.filter(function (ev) {
                                return ev.start_date.substr(0, 10) === formattedDate;
                            });

                            var eventsNotOnDate = _this5.getEventList.filter(function (ev) {
                                return new Date(ev.start_date.substr(0, 10)) > new Date(formattedDate);
                            });
                            if (eventsOnDate && eventsOnDate.length > 0) {
                                if (_this5.isEventToday(eventsOnDate[0].end_date)) {
                                    var eventTime = new Date(eventsOnDate[0].start_date);
                                    var eventHrs = _this5.getHoursFormatted(eventTime);
                                    _this5.$store.dispatch('SETBANNEREVENT', eventsOnDate[0].eventId).then(function () {});
                                    if (eventsOnDate[0].type === '1') {
                                        eventDesc = 'Join us for TONE Live at ' + eventHrs + ' ET';
                                        _this5.eventDescription = eventDesc;
                                    } else {
                                        eventDesc = 'Join us for TONE Talks at ' + eventHrs + ' ET';
                                        _this5.eventDescription = eventDesc;
                                    }
                                    if (self.currentRoute.name === 'UnAuth') {
                                        self.$swal({
                                            background: '#44bda8',
                                            title: '',
                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                            text: '',
                                            type: null,
                                            timer: 5000,
                                            showConfirmButton: true,
                                            showCloseButton: true,
                                            showCancelButton: false,
                                            confirmButtonColor: '#f0617d',
                                            confirmButtonText: 'Find out more'
                                        }).then(function () {
                                            self.$router.push('/event');
                                        }, function (dismiss) {
                                            if (dismiss === 'timer') {}
                                        });
                                    } else if (self.currentRoute.name === 'Hello') {
                                        if (self.user && self.user.corporation == null) {
                                            self.$swal({
                                                background: '#44bda8',
                                                title: '',
                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                text: '',
                                                type: null,
                                                timer: 5000,
                                                showConfirmButton: true,
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                confirmButtonColor: '#f0617d',
                                                confirmButtonText: 'Find out more'
                                            }).then(function () {
                                                self.JoinEventOrRedirect();
                                            }, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 1) {
                                            self.$swal({
                                                background: '#44bda8',
                                                title: '',
                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                text: '',
                                                type: null,
                                                timer: 5000,
                                                showConfirmButton: true,
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                confirmButtonColor: '#f0617d',
                                                confirmButtonText: 'Find out more'
                                            }).then(function () {
                                                self.JoinEventOrRedirect();
                                            }, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 2) {
                                            self.$swal({
                                                background: '#44bda8',
                                                title: '',
                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                text: '',
                                                type: null,
                                                timer: 5000,
                                                showConfirmButton: true,
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                confirmButtonColor: '#f0617d',
                                                confirmButtonText: 'Find out more'
                                            }).then(function () {
                                                self.$router.push('/corporation/mycommunity');
                                            }, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 3) {
                                            self.$swal({
                                                background: '#44bda8',
                                                title: '',
                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.bnrCustomMsg + ' </span>',
                                                text: '',
                                                type: null,
                                                timer: 5000,
                                                showConfirmButton: true,
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                confirmButtonColor: '#f0617d',
                                                confirmButtonText: 'Find out more'
                                            }).then(function () {
                                                self.$router.push(self.user.corporation.bnrCustomMsgUrl);
                                            }, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        }
                                    } else {}
                                } else {
                                    if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                        _this5.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(function () {});
                                        if (eventsNotOnDate[0].type === '1') {
                                            _this5.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                            _this5.authEventDescription = eventsNotOnDate[0].authBannerText;
                                        } else {
                                            _this5.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                            _this5.authEventDescription = eventsNotOnDate[0].authBannerText;
                                        }
                                        eventDesc = _this5.eventDescription;
                                        if (self.currentRoute.name === 'UnAuth') {
                                            self.$swal({
                                                background: '#44bda8',
                                                title: '',
                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                text: '',
                                                type: null,
                                                timer: 5000,
                                                showConfirmButton: true,
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                confirmButtonColor: '#f0617d',
                                                confirmButtonText: 'Find out more'
                                            }).then(function () {
                                                self.$router.push('/event');
                                            }, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        } else if (self.currentRoute.name === 'Hello') {
                                            if (self.user && self.user.corporation == null) {
                                                self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText: 'Find out more'
                                                }).then(function () {
                                                    self.JoinEventOrRedirect();
                                                }, function (dismiss) {
                                                    if (dismiss === 'timer') {}
                                                });
                                            } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 1) {
                                                self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText: 'Find out more'
                                                }).then(function () {
                                                    self.JoinEventOrRedirect();
                                                }, function (dismiss) {
                                                    if (dismiss === 'timer') {}
                                                });
                                            } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 2) {
                                                self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText: 'Find out more'
                                                }).then(function () {
                                                    self.$router.push('/corporation/mycommunity');
                                                }, function (dismiss) {
                                                    if (dismiss === 'timer') {}
                                                });
                                            } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 3) {
                                                self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.bnrCustomMsg + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText: 'Find out more'
                                                }).then(function () {
                                                    self.$router.push(self.user.corporation.bnrCustomMsgUrl);
                                                }, function (dismiss) {
                                                    if (dismiss === 'timer') {}
                                                });
                                            }
                                        } else {}
                                    }
                                }
                            } else {
                                if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                    _this5.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(function () {});
                                    if (eventsNotOnDate[0].type === '1') {
                                        _this5.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                        _this5.authEventDescription = eventsNotOnDate[0].authBannerText;
                                    } else {
                                        _this5.eventDescription = eventsNotOnDate[0].unAuthBannerText;
                                        _this5.authEventDescription = eventsNotOnDate[0].authBannerText;
                                    }
                                    eventDesc = _this5.eventDescription;
                                    if (self.currentRoute.name === 'UnAuth') {
                                        self.$swal({
                                            background: '#44bda8',
                                            title: '',
                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                            text: '',
                                            type: null,
                                            timer: 5000,
                                            showConfirmButton: true,
                                            showCloseButton: true,
                                            showCancelButton: false,
                                            confirmButtonColor: '#f0617d',
                                            confirmButtonText: 'Find out more'
                                        }).then(function () {
                                            self.$router.push('/event');
                                        }, function (dismiss) {
                                            if (dismiss === 'timer') {}
                                        });
                                    } else if (self.currentRoute.name === 'Hello') {
                                        if (self.user && self.user.corporation == null) {
                                            self.$swal({
                                                background: '#44bda8',
                                                title: '',
                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                text: '',
                                                type: null,
                                                timer: 5000,
                                                showConfirmButton: true,
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                confirmButtonColor: '#f0617d',
                                                confirmButtonText: 'Find out more'
                                            }).then(function () {
                                                self.JoinEventOrRedirect();
                                            }, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 1) {
                                            self.$swal({
                                                background: '#44bda8',
                                                title: '',
                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                text: '',
                                                type: null,
                                                timer: 5000,
                                                showConfirmButton: true,
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                confirmButtonColor: '#f0617d',
                                                confirmButtonText: 'Find out more'
                                            }).then(function () {
                                                self.JoinEventOrRedirect();
                                            }, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 2) {
                                            self.$swal({
                                                background: '#44bda8',
                                                title: '',
                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                text: '',
                                                type: null,
                                                timer: 5000,
                                                showConfirmButton: true,
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                confirmButtonColor: '#f0617d',
                                                confirmButtonText: 'Find out more'
                                            }).then(function () {
                                                self.$router.push('/corporation/mycommunity');
                                            }, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 3) {
                                            self.$swal({
                                                background: '#44bda8',
                                                title: '',
                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.bnrCustomMsg + ' </span>',
                                                text: '',
                                                type: null,
                                                timer: 5000,
                                                showConfirmButton: true,
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                confirmButtonColor: '#f0617d',
                                                confirmButtonText: 'Find out more'
                                            }).then(function () {
                                                self.$router.push(self.user.corporation.bnrCustomMsgUrl);
                                            }, function (dismiss) {
                                                if (dismiss === 'timer') {}
                                            });
                                        }
                                    } else {}
                                }
                            }
                        }
                    });
                }
            });
        }
        console.log('inside Header.vue : clearing SEARCH SESSION STORAGE ------------');
        sessionStorage.removeItem('searchQry');
        sessionStorage.removeItem('currTabName');
        sessionStorage.removeItem('videoTabCurPageNum');
        sessionStorage.removeItem('eventTabCurPageNum');
        sessionStorage.removeItem('plistTabCurPageNum');
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.contact-us-form .contact-form .form form .form-group textarea.form-control {\n    max-height: 100px;\n    min-height: 100px;\n    min-width: 100%;\n    max-width: 100%;\n    width: 100% !important;\n    height: 100px !important;\n    resize: none;\n}\n", ""]);

// exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#contactus_phonenumber[data-v-00563de2] {\n    padding: 0 30px 0 15px;\n    height: 60px;\n    margin-bottom: 20px;\n}\n.contact-us-form p[data-v-00563de2] {\n    font-size: 22px;\n    font-family: sans-serif;\n    letter-spacing: 0.5px;\n    margin: 0 0 30px 0;\n    font-weight: normal;\n    line-height: 1;\n    color: #777777;\n}\n.contact-us-form h2[data-v-00563de2] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 40px 0 15px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n}\n.bodyContent[data-v-00563de2] {\n    padding: 0 20px;\n}\n.contact-us-form .login-modal h2[data-v-00563de2] {\n    color: #333;\n    font-size: 25px;\n    margin: 40px 0;\n}\n.form[data-v-00563de2] {\n    border: 1px solid #ccc;\n    padding: 15px;\n}\nh2.boxed[data-v-00563de2] {\n}\n.login-page-wrapper.contact-us-form.bodyfont-unauth h2.boxed[data-v-00563de2] {\n    font-size: 21px;\n    text-align: left;\n    padding: 15px;\n    color: #fff;\n    background: #f0617d;\n}\n.login-page-wrapper.contact-us-form.bodyfont-unauth .padded p[data-v-00563de2] {\n    text-align: left;\n    font-size: 18px;\n    color:#000;\n    padding: 0 15px;\n}\n.boxpink[data-v-00563de2] {\n}\n.list-group[data-v-00563de2] {\n    border: 1px solid #ccc;\n    padding: 15px;\n    text-align: left;\n    border-top: 0 none transparent;\n}\n.login-page-wrapper.contact-us-form.bodyfont-unauth .boxpink h2.boxed[data-v-00563de2] {\n    margin: 0;\n}\n.list-group li[data-v-00563de2] {\n    font-size: 18px;\n    color: #000;\n    margin: 0 0 15px;\n}\n.form h3[data-v-00563de2] {\n    text-align: left;\n    margin: 0 0 15px;\n    font-size: 21px;\n}\n.form[data-v-00563de2] {\n    color: #000;\n}\n.form a[data-v-00563de2] {\n    color: #000;\n    text-decoration: underline;\n    font-family:inherit !important;\n}\n", ""]);

// exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.vtrnscript a{cursor: pointer\n}\n@media(max-width:767px){\n.sharesmallpink.watchVideoModal span.multiselect__tag {\n        white-space: normal;\n        width: 100%;\n}\n}\n.fixgraybg .video-player .left-video-icons{background:transparent;\n}\nul.mobilesocialicons {\n        display: inline-block;\n        margin: 0;\n        font-size: 30px;\n        padding: 0;\n        float: left;\n}\nul.mobilesocialicons li {\n        display: inline-block;\n        margin: 0;\n        padding: 0;\n        margin-right: 5px;\n        float: left;\n}\nul.mobilesocialicons + div {\n        display: inline-block;\n}\nli .plusicon.btn-group {\n        position: relative !important;\n        top:0;\n        left:0;\n        right:auto;\n        bottom:auto;\n}\n.text-right.mobileiconholder>div>span i{\n        font-size:24px;\n}\n.text-right.mobileiconholder>div>span {\n        display:inline-block;\n        color: #fff;\n        background: #f0617d;\n        padding: 0;\n        border-radius: 50%;\n        height: 42px;\n        width: 42px;\n        line-height: 46px;\n        font-size: 21px;\n        text-align: center;\n}\n.text-right.mobileiconholder ul.mobilesocialicons > li > a > i {\n        color: #fff;\n        background: #f0617d;\n        padding: 0;\n        border-radius: 50%;\n        height: 42px;\n        width: 42px;\n        line-height: 46px;\n        font-size: 21px;\n        text-align: center;\n        float: left;\n}\n.text-right.mobileiconholder ul.mobilesocialicons li .plusicon.btn-group img{\n        filter:brightness(10);\n        -ms-filter: brightness(10);\n        max-width: 28px;\n        height:auto;\n}\n.text-right.mobileiconholder ul.mobilesocialicons li .plusicon.btn-group {\n        background: #f0617d;\n        padding: 0;\n        border-radius: 50%;\n        height: 42px;\n        width: 42px;\n        line-height: 1.3;\n        font-size: 13px;\n        text-align: center;\n        float: left;\n}\n.text-right.mobileiconholder ul.mobilesocialicons li .plusicon.btn-group>button.dropdown-toggle.ellipsis.pull-right {\n        width: 39px;\n        padding: 0;\n        line-height: 38px;\n}\n.text-right.mobileiconholder {\n        float: right;\n}\nul.mobilesocialicons li ul li {\n        display: block !important;\n        float: none;\n}\n.icons-hover img.menuiconbutton {\n        height: auto;\n        width: 26px;\n        float: left;\n        top: 4px;\n        position: relative;\n        filter: brightness(10);\n        -ms-filter: brightness(10);\n        margin-right: 10px;\n}\n.icons-hover .plusicon.btn-group button.dropdown-toggle.ellipsis.pull-right+ ul {\n        left: auto;\n        right: 0;\n        color: #343434;\n}\n.video-player .right-video-icons .icons-hover button.dropdown-toggle.ellipsis.pull-right+ ul li {\n        margin: 0 0 5px;\n}\n@media(min-width:1025px){\n.text-right.mobileiconholder{display:none;\n}\n}\n", ""]);

// exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n@media(max-width:767px){\n.text-right.mobileiconholder > i.fa.fa-2x.fa-share-square-o.cursor[data-v-02cadb06] {\n        display: inline-block;\n        color: #fff;\n        background: #f0617d;\n        padding: 0;\n        border-radius: 50%;\n        height: 42px;\n        width: 42px;\n        line-height: 46px;\n        font-size: 21px;\n        text-align: center;\n}\n}\n.social-share-manage[data-v-02cadb06] {\n    width: 160px;\n    display: -ms-flexbox;\n    display: flex;\n}\n.social-share-manage>div[data-v-02cadb06] {\n}\n.social-share-manage >i[data-v-02cadb06] {\n    -ms-flex: 1;\n        flex: 1;\n}\n.pinkh2[data-v-02cadb06]{\n    color: #f0617d;\n}\n<!\\-- Added for message transition \\-->\n.bounce-enter-active[data-v-02cadb06] {\n    animation: bounce-in 1s;\n}\n.bounce-leave-active[data-v-02cadb06] {\n    animation: bounce-in .5s reverse;\n}\n@keyframes bounce-in {\n0% {\n        transform: scale(0);\n}\n50% {\n        transform: scale(1.5);\n}\n100% {\n        transform: scale(1);\n}\n}\n<!\\-- Change End \\-->\n.video-player-wrapper .watch-again .current-video-img img[data-v-02cadb06] {\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.video-player .right-video-icons .enjoy-hover-box[data-v-02cadb06] {\n    width: 20%;\n    height: 100%;\n    background: #f0617d;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 15% 0px 0;\n    text-align: left;\n}\n.video-player .right-video-icons .enjoy-hover-box button.btn[data-v-02cadb06] {\n    margin: 0 0 10px;\n    border-color: white;\n    border-radius: 3px;\n    padding: 12px 0 13px;\n    display: block;\n    width: 80%;\n    margin: 0px auto 10px;\n    color: #fff;\n}\n.video-player-wrapper .tooltipBox[data-v-02cadb06] {\n    width: 100%;\n    text-align: center;\n    padding-bottom: 10px;\n    height: 35px;\n    margin-top: 24px;\n}\n@media (min-width:768px) {\n.video-player .right-video-icons .enjoy-hover-box[data-v-02cadb06] {\n        padding: 117px 0px 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating[data-v-02cadb06] {\n        overflow: hidden;\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating p[data-v-02cadb06] {\n        color: white;\n        display: block;\n        font-size: 16px;\n        letter-spacing: 0.5px;\n        margin-top: 23px;\n        margin-bottom: 20px;\n        padding: 0 10%;\n        text-align: center;\n}\n}\n.video-player .right-video-icons .rate-hover-box span[data-v-02cadb06] {\n    margin-bottom: 20px;\n}\n.video-player .right-video-icons .rate-hover-box button[data-v-02cadb06]:hover {\n    background: #ac2925;\n}\n.video-player .btn-danger[data-v-02cadb06]:focus {\n    background: inherit;\n    border-color: inherit;\n    outline: none;\n}\n.video-player .right-video-icons div button.btn-danger[data-v-02cadb06]:hover{\n    background:rgba(0,0,0,0.1);\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-02cadb06]:hover{\n    background:#ac2925;\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-02cadb06]:focus{\ncolor: #fff;\nbackground-color: #ac2925;\nborder-color: #fff;\n}\n.profile-content img[data-v-02cadb06] {\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center center;\n       object-position: center center;\n}\n.btn-group.plusicon[data-v-02cadb06] {\n    position: absolute;\n    right: 50px;\n    bottom: 0px;\n    height: 29px;\n}\nli.divider[data-v-02cadb06] {\n    border-bottom: 1px solid #ddd;\n    margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-02cadb06] {\n    background: transparent;\n    border: 0 none transparent;\n    padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-02cadb06]{\n    font-size: 21px;\n    top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-02cadb06]{\n    padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-02cadb06],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-02cadb06] {\n    padding: 3px 15px;\n    margin-bottom: 5px;\n    display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-02cadb06],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-02cadb06] {\n    height: 30px;\n    padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-02cadb06],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-02cadb06] {\n    position: absolute;\n    top: 6px;\n    font-size:24px;\n    right:20px;\n    cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-02cadb06],\nbutton.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-02cadb06]{\n    position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-02cadb06],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul[data-v-02cadb06]{\n    left: 0;\n    right: auto;\n    width: 230px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    top: 100%;\n    position: absolute;\n    z-index: 5000;\n    list-style: none;\n    text-align: left;\n    padding: 15px;\n}\n.backdropformenu[data-v-02cadb06]{\n    position:fixed;\n    z-index:4900;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-02cadb06]{\n    height: 24px;\n    width: 37px;\n}\n.menuiconbutton[data-v-02cadb06]{\n    height: 24px;\n    width: 37px;\n}\n.fade-enter-active[data-v-02cadb06], .fade-leave-active[data-v-02cadb06] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-02cadb06], .fade-leave-to[data-v-02cadb06] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-02cadb06]{\n    font-size: 10px;\n}\nspan.removed[data-v-02cadb06] {\n    color: red;\n}\nspan.added[data-v-02cadb06] {\n    color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-02cadb06] {\n    position: relative;\n    display:block;\n}\n.trailexp .icons-hover[data-v-02cadb06] {\n    display: none;\n}\nbutton#videoplayer_videoredirect[data-v-02cadb06] {\n    border-radius: 5px;\n    font-weight: 700;\n}\nbutton#videoplayer_videostay[data-v-02cadb06] {\n    background: white;\n    color: #44bda8;\n    border: 1px solid #44bda8;\n    white-space: normal;\n    line-height: 1;\n    padding: 6px;\n    border-radius: 5px;\n}\n.watchVideoModal .modal-dialog .modal-body p[data-v-02cadb06] {\n    padding: 16px 60px 19px 60px;\n}\n.watchVideoModal.modal.zoom.in[data-v-02cadb06] {\n    z-index: 500000;\n}\n.sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader[data-v-02cadb06] {\n    background: #f0617d;\n    color: #fff;\n    font-size: 25px;\n    text-align: left;\n    padding: 15px 25px;\n    font-weight: 700;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body p[data-v-02cadb06]{\n    padding: 0;\n    margin: 0 0 20px;\n}\n.row.sharefb[data-v-02cadb06] {\n    background: #eee;\n    margin-left: 0;\n    margin-right: 0;\n}\n.row.sharefb > div[data-v-02cadb06] {\n    padding: 5px;\n    text-align: left;\n}\n.row.sharefb .col-sm-5 img[data-v-02cadb06] {\n    max-width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-02cadb06] {\n    font-size: 14px;\n    font-weight: 300;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6[data-v-02cadb06] {\n    text-transform: uppercase;\n    font-size: 12px;\n    margin: 10px 0 5px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4[data-v-02cadb06] {\n    margin: 0 0 5px;\n    font-weight:700;\n}\n.row.buttonsinpopup[data-v-02cadb06] {\n    padding-top: 20px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-02cadb06] {\n    background: #fff;\n    color: #333;\n    border: 1px solid #cacaca;\n    width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body[data-v-02cadb06] {\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink[data-v-02cadb06] {\n    background: #f0617d;\n    width: 100%;\n    margin: 0;\n    border: 1px solid #f0617d;\n}\n.usernamenimg.text-left table[data-v-02cadb06] {\n    max-width: 100%;\n    margin: 0 0 20px;\n    width: 190px;\n}\na.popupsharingoptionlink[data-v-02cadb06] {\n    display: block;\n    color: #fff;\n    text-decoration: none;\n    max-width: 150px;\n    font-size: 18px;\n    font-weight: 700;\n    padding-top: 15px;\n    text-align: center;\n}\na.popupsharingoptionlink i[data-v-02cadb06]:before {\n    color: #fff;\n}\na.popupsharingoptionlink i.fa.fa-share-square-o[data-v-02cadb06] {\n    margin: 0;\n    font-size: 20px;\n    /* display: block; */\n}\n.strongselec[data-v-02cadb06]{\n    font-weight:700;\n}\n@media(max-width:475px){\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-02cadb06] {\n        padding-left: 0;\n        padding-right: 0;\n}\n}\n.showmobile[data-v-02cadb06]{display:none;\n}\n@media(max-width:767px){\n.usernamenimg.text-left[data-v-02cadb06] {\n        display: none;\n}\n.showmobile[data-v-02cadb06]{\n        display: block;\n}\n.alert.alert-default[data-v-02cadb06] {\n        background: #eee;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-02cadb06] {\n        display: none;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow[data-v-02cadb06] {\n        top: 1px;\n        right: -13px;\n}\n.row.sharefb[data-v-02cadb06] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n}\n}\n/*Changes for Corporate Share*/\n\n", ""]);

// exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.topic[data-v-02ed8db0]{\n    width: 40%;\n    margin: 0 auto;\n}\n.topic .inputIcon[data-v-02ed8db0]{\n    border: none;\n    background: #f6f6f6;\n}\n.topic .pageHeading[data-v-02ed8db0]{\n    font-size: 32px;\n    color: #009cf6;\n    font-weight: lighter;\n    margin: 0 0 25px 0;\n}\n.topic p[data-v-02ed8db0]{\n    font-size: 14px;\n    color: #979797;\n    margin: 0;\n}\n.topic .containerBox[data-v-02ed8db0]{\n    margin-top: 50px;\n}\n.topic .tagsContainer[data-v-02ed8db0]{\n    margin: 25px 0;\n}\n.topic .tag[data-v-02ed8db0]{\n    padding: 6px 12px;\n    background: transparent;\n    border: 1px solid #c6c6c6;\n    border-radius: 5px;\n    margin: 5px;\n}\n.formButton[data-v-02ed8db0]{\n    margin: 25px 0 50px;\n    width: 130px;\n    height: 47px;\n    color: #91ab45;\n    border-color: #91ab45;\n    background-color: transparent;\n    transition: 0.5s;\n    padding:0;\n}\n.formButton a[data-v-02ed8db0]{\n    display: block;\n    padding: 13px 12px;\n    color: #91ab45;\n    text-decoration: none;\n    transition: 0.5s;\n}\n.formButton[data-v-02ed8db0]:hover{\n    border-color: #91ab45;\n    background-color: #91ab45;\n    transition: 0.5s;\n}\n.formButton:hover a[data-v-02ed8db0]{\n    color: #ffffff;\n}\n.min-padding[data-v-02ed8db0] {\n    margin: 0.5em;\n}\n", ""]);

// exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.weblink[data-v-03049a46] {\n    text-transform: lowercase;\n    font-size: 14px;\n    line-height: 1.3;\n    display:block;\n    text-indent:1.5px;\n}\n", ""]);

// exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.set-error[data-v-07c2a42a]{\n    border-color: #a94442 !important;\n    color:#a94442 !important;\n}\n.StripeElement[data-v-07c2a42a] {\n    background-color: white;\n    padding: 2em 1em;\n    border: 1px solid #ccc;\n    box-shadow: 0 1px 3px 0 #e6ebf1;\n    transition: box-shadow 150ms ease;\n    height: 34px;\n}\n.float-right.paymentswitch.btn-group[data-v-07c2a42a] {\n    margin: 0 0 30px;\n}\n.StripeElement--focus[data-v-07c2a42a] {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n}\n.StripeElement--invalid[data-v-07c2a42a] {\n    border-color: #fa755a;\n}\n.StripeElement--webkit-autofill[data-v-07c2a42a] {\n    background-color: #fefde5 !important;\n}\n.radiowrapper[data-v-07c2a42a] {\n    padding: 0 35px 35px;\n    color: #f0617d;\n}\n.showmobile[data-v-07c2a42a]{\n    display:none;\n}\n.stripeholder[data-v-07c2a42a] {\n    position: relative;\n}\ni.fa.fa-lock.overlapstripe[data-v-07c2a42a] {\n    position: absolute;\n    left: 18px;\n    top: 10px;\n    font-size: 18px;\n    color: #b2b8c7;\n}\n@media (max-width:767px){\n.hidemobile[data-v-07c2a42a]{\n        display:none;\n}\n.showmobile[data-v-07c2a42a]{\n        display:inherit;\n}\n.signUp .left-content h4[data-v-07c2a42a] {\n        font-size: 14px;\n        letter-spacing: 0px;\n}\n.signUp .main-content h2[data-v-07c2a42a] {\n        margin: 15px 0;\n        line-height: 20px;\n        font-size: 18px;\n}\n.signUp #redeem_pwderrormsg[data-v-07c2a42a] {\n        margin-bottom: 8px;\n        line-height: 1.3;\n        letter-spacing: 1px;\n}\n.signUp .left-content .create-account #redeem_button[data-v-07c2a42a] {\n        margin: 0;\n}\n.signUp .right-content .jumbotron[data-v-07c2a42a] {\n        padding: 6px;\n        margin-top: 7px;\n}\n.signUp .right-content .jumbotron h2[data-v-07c2a42a] {\n        margin: 0;\n        font-size: 21px;\n}\n.signUp .right-content .jumbotron p[data-v-07c2a42a] {\n        display: none;\n}\n.signUp .right-content .card[data-v-07c2a42a] {\n        padding: 10px 10px;\n}\n.signUp .right-content .card .card-block .list-group li[data-v-07c2a42a] {\n        font-size: 16px;\n        margin: 0 0 10px;\n}\n.signUp .left-content hr[data-v-07c2a42a] {\n        display: none;\n}\n.row.margin-top[data-v-07c2a42a] {\n        margin-top: 0px;\n}\n}\n\n/* Media query for mobile viewport */\n@media screen and (max-width: 400px) {\n#paypal-button-container[data-v-07c2a42a] {\n        width: 100%;\n}\n}\n\n/* Media query for desktop viewport */\n@media screen and (min-width: 400px) {\n#paypal-button-container[data-v-07c2a42a] {\n        width: 250px;\n        display: inline-block;\n}\n}\nbody .margin-top[data-v-07c2a42a] {\n    margin-top: 89px;\n    margin-bottom: 70px;\n}\nbody .signUp .right-content .card .card-block .list-group[data-v-07c2a42a]{\n    margin-bottom:0px;\n}\n", ""]);

// exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.container .rules-expert-content img[data-v-07f96927] {\n    width: 160px;\n    height: 160px;\n    display: block;\n    margin: 0 auto 25px;\n    border-radius: 50%;\n}\n.container .marginTop .ruleImages p[data-v-07f96927] {\n    text-align: left;\n    color: #000000;\n    font-family: sans-serif;\n    padding: 0 0 0 30px;\n    line-height: 1.2;\n    margin: 0;\n    position: absolute;\n}\n@media(min-width:993px){\n.rules-banner[data-v-07f96927]{\n        height: auto;\n        min-height: 582px;\n        padding-bottom: 80px;\n}\n}\nbutton.sigup-green-join-button[data-v-07f96927] {\n    font-family: 'Montserrat', sans-serif !important;\n    padding: 10px 16px;\n    font-size: 18px;\n    line-height: 1.33333;\n    border-radius: 6px;\n    color: #fff;\n    background-color: #5cb85c;\n    border-color: #4cae4c;\n}\nbutton.sigup-green-join-button[data-v-07f96927]:hover {\n    color: #fff;\n    background-color: #449d44;\n    border-color: #398439;\n}\n", ""]);

// exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.attendeesImg>.userImage span[data-v-0c70a2bb] {\n    word-wrap: normal;\n    white-space: nowrap;\n}\n.btn-pink[data-v-0c70a2bb]{\n    color: #f0617d;\n    border: 1px solid #f0617d;\n    background: none;\n    outline: none;\n    font-size: 16px;\n    font-family: sans-serif;\n    letter-spacing: 0.3px;\n    float: left;\n    margin-left: 0px;\n    width: 100%;\n    padding: 13px 15px 9px;\n    border-radius: 3px;\n    margin-top: 10px;\n    max-width: 100%;\n}\n@media(min-width:768px){\n.innerpadding[data-v-0c70a2bb] {\n        padding-top: 36px;\n}\n}\n", ""]);

// exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*.socialicons i{*/\n    /*margin-right:30px;*/\n/*}*/\n/*@media(max-width:767px) {*/\n    /*.socialicons i {*/\n        /*color: #333;*/\n    /*}*/\n/*}*/\n", ""]);

// exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.socialicons  > .holder .fa {\n    color: #fff;\n    line-height: 42px;\n    width: 42px;\n    text-align: center;\n    display: block;\n    letter-spacing: 0;\n}\n.socialicons  > .holder {\n    background: #f0617d;\n    width: 42px;\n    display: inline-block;\n    height: 42px;\n    line-height: 42px;\n    border-radius: 50%;\n}\n.socialicons > a img {\n    max-width: 42px;\n}\n@media(min-width:768px){\n.socialicons  > .holder {\n        margin: 0 0 20px;\n        display:block;\n}\n.over-lay .row {\n        min-height: 450px;\n}\n}\n", ""]);

// exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.socialicons[data-v-0ed553c4] {\n        color: #f0617d;\n        letter-spacing: 10px;\n}\n@media(max-width:767px) {\n.socialicons[data-v-0ed553c4] {\n            color: #f0617d;\n            margin: 20px 0 0;\n}\n}\nh2.heading[data-v-0ed553c4] {\n        color: #f0617d;\n        text-transform: capitalize;\n        margin: 47px 0 35px 0;\n        letter-spacing: 0.5px;\n        font-family: sans-serif;\n        font-size: 30px;\n}\n.aboutlogoholder[data-v-0ed553c4] {\n        min-height: 300px;\n        line-height: 300px;\n}\n.mtop30[data-v-0ed553c4] {\n        margin-top: 30px;\n}\n.row.aboutrow p[data-v-0ed553c4] {\n        font-size: 17px;\n        text-align: left;\n        line-height: 1.3;\n        letter-spacing: 2px;\n}\nh3[data-v-0ed553c4] {\n        color: #f0617d;\n        letter-spacing: 4px;\n        font-size: 24px;\n        line-height: 1.5;\n        margin: 30px 0 20px;\n}\nh4[data-v-0ed553c4] {\n        color: #454545;\n        letter-spacing: 2px;\n        font-size: 18px;\n        text-align: left;\n        line-height: 1.5;\n\t\tfont-weight:700;\n}\nh4.welcomemessage[data-v-0ed553c4] {\n        text-align: center;\n        margin: 50px 0 0;\n        color: inherit;\n        color: #f0617d;\n}\nh2.welcomemessage[data-v-0ed553c4] {\n        letter-spacing: 8px;\n        margin: 20px 0 60px;\n        text-transform: uppercase;\n}\n.slide-player img[data-v-0ed553c4] {\n        max-width: 100%;\n}\n@media(max-width:480px){\nbody h4[data-v-0ed553c4] {\n            font-size: 18px !important;\n}\nh3[data-v-0ed553c4] {\n            font-size: 24px !important;\n            line-height: 1.1 !important;\n}\nh2.welcomemessage[data-v-0ed553c4] {\n            letter-spacing: 3px !important;\n}\n}\n.over-lay[data-v-0ed553c4] {\n    /*background-image: url(https://s3.amazonaws.com/tone-assets/images/TONEGiftingHolidays.jpg);background-repeat: no-repeat;*/\n    background-image: url(" + __webpack_require__(116) + ");background-repeat: no-repeat;\n    background-size: cover;\n    background-position: 50% 50%;\n    width: 100%;\n    display: inline-block;\n    padding: 50px 0 50px;\n}\n.over-lay .main-heading p[data-v-0ed553c4] {\n    margin-top: 15px;\n    font-size: 20px;\n    line-height: 31px;\n    font-family: \"Quicksand\", sans-serif;\n}\n.over-lay ul[data-v-0ed553c4] {\n    margin: 30px 0 0;\n    padding: 0;\n}\n.over-lay ul[data-v-0ed553c4] {\n    font-size: 27px;\n    font-weight: 500;\n    line-height: 1.2;\n}\n.over-lay ul li[data-v-0ed553c4] {\n    list-style: none;\n    margin: 0 0 0px;\n}\n.main-heading .btn[data-v-0ed553c4] {\n        margin: 30px 0;\n        font-size: 24px;\n}\n.showMobile[data-v-0ed553c4]{display:block;\n}\n@media(min-width:768px){\n.showMobile[data-v-0ed553c4]{display:none;\n}\n.over-lay h1[data-v-0ed553c4] {\n    color: #fff;\n\tclear:both;\n}\n.over-lay ul li[data-v-0ed553c4]:nth-child(1) {\n    clear: left;\n    float: left;\n    margin-right: 10px;\n}\n.over-lay .container[data-v-0ed553c4] {\n        max-width: 95%;\n        width: 100%;\n}\n}\n.over-lay[data-v-0ed553c4]:before {\n        z-index:5;\n        background-image:url(" + __webpack_require__(341) + ");\n        /*content:\"\";*/\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-size: cover !important;\n        background-position: left top !important;\n}\n.over-lay[data-v-0ed553c4] {\n    position: relative;\n}\n.over-lay .container[data-v-0ed553c4] {\n    position: relative;\n    z-index: 10;\n\tcolor:#fff;\n}\nul.tonepoints[data-v-0ed553c4] {\n    font-size: 18px;\n    letter-spacing: 2px;\n}\nul.tonepoints li[data-v-0ed553c4] {\n    margin: 0 0 20px;\n}\n@media (max-width:767px){\n.over-lay.text-left[data-v-0ed553c4] {\n        background-image: none;\n        padding: 20px 0;\n        color: #333 !important;\n}\n.main-heading .btn[data-v-0ed553c4] {\n        margin: 10px 0 30px;\n        font-size: 24px;\n}\n.over-lay[data-v-0ed553c4]:before , .over-lay[data-v-0ed553c4]:after {\n        display: none;\n}\n.over-lay h1[data-v-0ed553c4] {\n        color: #343434;\n}\n.over-lay .main-heading p[data-v-0ed553c4] {\n        color: #343434;\n}\n.over-lay ul li[data-v-0ed553c4] {\n        color: #343434;\n}\n}\n.row.aboutrow[data-v-0ed553c4] {\n        padding-bottom: 50px;\n}\n/*gift section classes*/\n.gift-item[data-v-0ed553c4]:before {\n    background: url(" + __webpack_require__(76) + ");\n\tcontent:\"\";\n    height: 150px;\n    display: block;\n    /* width: 100%; */\n    position: absolute;\n    background-position: center !important;\n    background-repeat: no-repeat !important;\n    transform: translateY(-50%);\n    /* margin: 120px 0 0; */\n    /* top: -30px; */\n    top: 0;\n    right: 0;\n    left: 0;\n}\n.gift-item[data-v-0ed553c4] {\n    background: #54d9ec;\n    color: #fff;\n    margin: 120px 0 0;\n    padding: 80px 20px 20px;\n    position: relative;\n    text-align: center;\n}\n.gift-item h5[data-v-0ed553c4] {\n    font-size: 22px;\n    /* font-weight: 100 !important; */\n}\n.gift-item h5 small[data-v-0ed553c4] {\n    color: #fff;\n}\n.gift-item button[data-v-0ed553c4] {\n    background: #0eb4ce;\n    border: 2px solid #13a8bf;\n    padding: 10px 25px;\n    margin: 10px 0;\n}\n.gifts.row[data-v-0ed553c4] {\n    margin-bottom: 50px;\n}\n@media(min-width:768px){\n}\n@media(max-width:767px){\n.vedioplayerholder[data-v-0ed553c4] {\n            margin-top: 20px;\n}\n}\n\n    /*social icons settings*/\n@media(min-width:768px){\n.socialicons[data-v-0ed553c4] {\n            position: absolute;\n            right: 30px;\n            width: 20px;\n            top:calc(100% + 70px);\n}\n.over-lay .col-sm-5[data-v-0ed553c4] {\n            position: static;\n}\n.socialicons span[data-v-0ed553c4] {\n            margin: 0 0 20px;\n            display: block;\n}\n}\n@media(min-width:992px){\n.socialicons[data-v-0ed553c4] {\n            top: calc(100% + 70px);\n}\n}\n@media(min-width:1200px){\n.socialicons[data-v-0ed553c4] {\n            top: calc(100% + 70px);\n}\n}\n@media(max-width:767px){\n.hideMobile[data-v-0ed553c4] {\n            display: none;\n}\n.over-lay ul[data-v-0ed553c4]{\n            font-size:22px;\n}\n}\n@media(min-width:768px) {\n.over-lay ul[data-v-0ed553c4], .over-lay H1[data-v-0ed553c4] {\n            text-shadow: 0 3px 6px rgba(0, 0, 0, 0.5);\n}\n}\n", ""]);

// exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n@media(min-width:320px) and (max-width:767px){\n.video-player.autoheight {\n        height: auto;\n}\n.autoheight.video-player .jwplayer.jw-flag-aspect-mode {\n        height: auto !important;\n}\n}\n.autoheight div.jw-error.jw-reset {\n    height: 25vw !important;\n}\n.video-player .left-video-icons{\n    height: 25vw !important;\n}\n.autoheight{\n    height: auto !important;\n    padding-bottom:20px;\n}\n", ""]);

// exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n@media(max-width:768px){\n.row.morevediosrow[data-v-0f63bdda] {\n            margin: 0;\n}\n}\na[data-v-0f63bdda] {\n        cursor: pointer !important;\n}\n.video-player-wrapper .watch-again .current-video-img img[data-v-0f63bdda] {\n        -o-object-fit: cover;\n           object-fit: cover;\n}\n.video-player .right-video-icons .enjoy-hover-box[data-v-0f63bdda] {\n        width: 20%;\n        height: 100%;\n        background: #f0617d;\n        position: absolute;\n        top: 0;\n        right: 0;\n        padding: 15% 0px 0;\n        text-align: left;\n}\n.video-player .right-video-icons .enjoy-hover-box button.btn[data-v-0f63bdda] {\n        margin: 0 0 10px;\n        border-color: white;\n        border-radius: 3px;\n        padding: 12px 0 13px;\n        display: block;\n        width: 80%;\n        margin: 0px auto 10px;\n        color: #fff;\n}\n.video-player-wrapper .tooltipBox[data-v-0f63bdda] {\n        width: 100%;\n        text-align: center;\n        padding-bottom: 10px;\n        height: 35px;\n        margin-top: 24px;\n}\n.row.morevediosrow img[data-v-0f63bdda] {\n        max-width: 100%;\n}\n.clearfix[data-v-0f63bdda] {\n        clear: both;\n}\n.gap[data-v-0f63bdda] {\n        height: 30px;\n}\nh3.pinkheading[data-v-0f63bdda] {\n        color: #f0617d;\n        font-size: 28px;\n        letter-spacing: 2px;\n        margin: 10px 0 20px;\n}\nul.pinkheading li  a[data-v-0f63bdda] {\n}\nul.pinkheading li[data-v-0f63bdda] {\n        margin: 5px 0 5px;\n}\nul.pinkheading[data-v-0f63bdda] {\n        margin: 0;\n        padding: 0;\n        font-size: 19px;\n        font-weight: 900;\n        list-style: none;\n}\n.row.morevediosrow > div[data-v-0f63bdda]:after {\n        content: \"\\F04B\";\n        font-family: fontawesome;\n        position: absolute;\n        top: calc(50% - 25px);\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%);\n        color: rgba(255, 255, 255, 0.75);\n        font-size: 57px;\n        height: 90px;\n        width: 90px;\n        line-height: 84px;\n        border: 5px solid;\n        border-radius: 50%;\n        text-align: center;\n        padding-left: 12px;\n        cursor: pointer;\n        pointer-events: none;\n}\n@media (min-width:768px) {\n.video-player .right-video-icons .enjoy-hover-box[data-v-0f63bdda] {\n            padding: 117px 0px 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating[data-v-0f63bdda] {\n            overflow: hidden;\n            position: absolute;\n            left: 0;\n            right: 0;\n            bottom: 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating p[data-v-0f63bdda] {\n            color: white;\n            display: block;\n            font-size: 16px;\n            letter-spacing: 0.5px;\n            margin-top: 23px;\n            margin-bottom: 20px;\n            padding: 0 10%;\n            text-align: center;\n}\n}\n.video-player .right-video-icons .rate-hover-box span[data-v-0f63bdda] {\n        margin-bottom: 20px;\n}\n.video-player .right-video-icons .rate-hover-box button[data-v-0f63bdda]:hover {\n        background: #ac2925;\n}\n.video-player .btn-danger[data-v-0f63bdda]:focus {\n        background: inherit;\n        border-color: inherit;\n        outline: none;\n}\n.video-player .right-video-icons div button.btn-danger[data-v-0f63bdda]:hover{\n        background:rgba(0,0,0,0.1);\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-0f63bdda]:hover{\n        background:#ac2925;\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-0f63bdda]:focus{\n    color: #fff;\n    background-color: #ac2925;\n    border-color: #fff;\n}\n.profile-content img[data-v-0f63bdda] {\n        -o-object-fit: cover;\n           object-fit: cover;\n        -o-object-position: center center;\n           object-position: center center;\n}\n.video-player .left-video-icons[data-v-0f63bdda] {\n        background: white;\n        color: white;\n        width: 15%;\n        float: left;\n        height: 100%;\n}\nh3.errormessage[data-v-0f63bdda] {\n        color: #f0617d;\n        letter-spacing: 3px;\n        margin: 70px 20px;\n}\n@media(max-width:767px){\n.row.morevediosrow img[data-v-0f63bdda] {\n            margin-bottom: 10px;\n}\n.sliderTalkBox[data-v-0f63bdda] {\n            padding: 0 15px;\n}\n}\n.row.morevediosrow p.text-wrap-title.cursor[data-v-0f63bdda] {\n        font-size: 18px;\n        text-align: left;\n        color: #000;\n}\n.slick-slide[data-v-0f63bdda] {\n        text-align: left;\n}\n.slick-slide  p[data-v-0f63bdda] {\n        height: 152px;\n        overflow-y: auto;\n        margin: 0 0 20px;\n}\n.hello-page-wrapper.video-player-wrapper[data-v-0f63bdda] {\n        padding-bottom:50px;\n}\n[data-v-0f63bdda]::-webkit-scrollbar {\n  width: 8px;\n}\n[data-v-0f63bdda]::-webkit-scrollbar-track {  \n  border-radius: 10px;\n  box-shadow: inset 0 0 5px grey;\n}\n[data-v-0f63bdda]::-webkit-scrollbar-thumb {\n  background: rgb(240, 97, 125); \n  border-radius: 10px;\n}\n[data-v-0f63bdda]::-webkit-scrollbar-thumb:hover {\n  background: #b30000;\n}\n@media(min-width:768px){\n.slick-slide h2[data-v-0f63bdda] {\n            min-height: 66px;\n}\n}\n.slick-slide a:hover h2[data-v-0f63bdda] {\n        color: #f27991 !important;\n        text-decoration: none;\n}\n.slick-slide a[data-v-0f63bdda]:hover {\n        color: #f27991;\n        text-decoration: none;\n}\n.row.morevediosrow a[data-v-0f63bdda]:hover, .row.morevediosrow a:hover p[data-v-0f63bdda] {\n        color: #f1617d !important;\n        text-decoration: none;\n}\n.container-icons > div > span[data-v-0f63bdda] {\n        display: inline-block;\n        background: #f0617d;\n        height: 50px;\n        width: 50px;\n        color: #fff;\n        text-align: center;\n        line-height: 60px;\n        border-radius: 50%;\n}\n@media (min-width:320px) and (max-width:575px){\n.container-icons.vpage[data-v-0f63bdda] {\n            float: left;\n            width: 100%;\n            text-align: center;\n}\np.video-description+div[data-v-0f63bdda] {\n            width: 100%;\n            text-align: center;\n            margin: 0 0 20px;\n}\n}\n@media(max-width:767px){\n.row.morevediosrow > div[data-v-0f63bdda]:after{\n            top: 26vw;\n            width: 60px;\n            height: 60px;\n            font-size: 30px;\n            line-height: 50px;\n            padding-left: 5px;\n}\n}\n", ""]);

// exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.set-error[data-v-11799b4e]{\n    border-color: #a94442 !important;\n    color:#a94442 !important;\n}\n.StripeElement[data-v-11799b4e] {\n    background-color: white;\n    padding: 2em 1em;\n    border: 1px solid #ccc;\n    box-shadow: 0 1px 3px 0 #e6ebf1;\n    transition: box-shadow 150ms ease;\n    height: 34px;\n}\n.float-right.paymentswitch.btn-group[data-v-11799b4e] {\n    margin: 0 0 30px;\n}\n.StripeElement--focus[data-v-11799b4e] {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n}\n.StripeElement--invalid[data-v-11799b4e] {\n    border-color: #fa755a;\n}\n.StripeElement--webkit-autofill[data-v-11799b4e] {\n    background-color: #fefde5 !important;\n}\n.radiowrapper[data-v-11799b4e] {\n    padding: 0 35px 35px;\n    color: #f0617d;\n}\n.showmobile[data-v-11799b4e]{\n    display:none;\n}\n.stripeholder[data-v-11799b4e] {\n    position: relative;\n}\ni.fa.fa-lock.overlapstripe[data-v-11799b4e] {\n    position: absolute;\n    left: 18px;\n    top: 10px;\n    font-size: 18px;\n    color: #b2b8c7;\n}\n@media (max-width:767px){\n.hidemobile[data-v-11799b4e]{\n        display:none;\n}\n.showmobile[data-v-11799b4e]{\n        display:inherit;\n}\n.signUp .left-content h4[data-v-11799b4e] {\n        font-size: 14px;\n        letter-spacing: 0px;\n}\n.signUp .main-content h2[data-v-11799b4e] {\n        margin: 15px 0;\n        line-height: 20px;\n        font-size: 18px;\n}\n.signUp #redeem_pwderrormsg[data-v-11799b4e] {\n        margin-bottom: 8px;\n        line-height: 1.3;\n        letter-spacing: 1px;\n}\n.signUp .left-content .create-account #redeem_button[data-v-11799b4e] {\n        margin: 0;\n}\n.signUp .right-content .jumbotron[data-v-11799b4e] {\n        padding: 6px;\n        margin-top: 7px;\n}\n.signUp .right-content .jumbotron h2[data-v-11799b4e] {\n        margin: 0;\n        font-size: 21px;\n}\n.signUp .right-content .jumbotron p[data-v-11799b4e] {\n        display: none;\n}\n.signUp .right-content .card[data-v-11799b4e] {\n        padding: 10px 10px;\n}\n.signUp .right-content .card .card-block .list-group li[data-v-11799b4e] {\n        font-size: 16px;\n        margin: 0 0 10px;\n}\n.signUp .left-content hr[data-v-11799b4e] {\n        display: none;\n}\n.row.margin-top[data-v-11799b4e] {\n        margin-top: 0px;\n}\n}\n\n/* Media query for mobile viewport */\n@media screen and (max-width: 400px) {\n#paypal-button-container[data-v-11799b4e] {\n        width: 100%;\n}\n}\n\n/* Media query for desktop viewport */\n@media screen and (min-width: 400px) {\n#paypal-button-container[data-v-11799b4e] {\n        width: 250px;\n        display: inline-block;\n}\n}\nbody .margin-top[data-v-11799b4e] {\n    margin-top: 89px;\n    margin-bottom: 70px;\n}\nbody .signUp .right-content .card .card-block .list-group[data-v-11799b4e]{\n    margin-bottom:0px;\n}\n", ""]);

// exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\np strong[data-v-124f4978] {\n    font-weight: 900;\n    color: #000;\n}\n.text-left p[data-v-124f4978] {\n    font-size: 16px;\n}\n", ""]);

// exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\np strong[data-v-13ed2e4a] {\n    font-weight: 900;\n    color: #000;\n}\n.text-left p[data-v-13ed2e4a] {\n    font-size: 16px;\n}\n", ""]);

// exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.contact-us-form .contact-form .form form .form-group textarea.form-control {\n    max-height: 100px;\n    min-height: 100px;\n    min-width: 100%;\n    max-width: 100%;\n    width: 100% !important;\n    height: 100px !important;\n    resize: none;\n}\n.contactformb2b input.form-control, .contactformb2b #resetpassword_password {\n    border-top: 0;\n    border-left: 0;\n    border-right: 0;\n    box-shadow: 0 0 0 transparent;\n}\n.contactformholder .help-block.with-errors {\n    position: absolute;\n    color: #ffa2a2;\n    bottom: -20px;\n    font-size: 11px;\n}\n.contactformholder .form-group {\n    padding-bottom: 5px;\n}\nhtml .logoscarosal .slide-player {\n    margin: 0;\n}\n.logoscarosal .slick-track {\n    margin: auto;\n}\n.Videoscarosal .slick-slide {\n    padding: 0 15px;\n}\nhtml .Videoscarosal .slide-player {\n    background: transparent;\n}\nhtml .Videoscarosal .slide-player p {\n    text-align: center;\n    line-height: 1.2;\n    font-weight: normal;\n    letter-spacing: unset;\n}\nhtml .Videoscarosal .slide-player p small {\n    text-align: center;\n    display:block;\n    font-size:14px;\n}\n", ""]);

// exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.hubspotForm[data-v-14cf791a] {\n    margin: 2% 10%;\n    max-width: 80%;\n}\n.hubspotHeading[data-v-14cf791a] {\n   margin-top: 30px;\n}\n.testimonialscarosal .container[data-v-14cf791a] {\n    margin-bottom:-30px;\n}\n.content-style[data-v-14cf791a] {\n  text-align: left;\n}\n.content-style i[data-v-14cf791a] {\n  margin-right: 10px;\n}\n.real-results[data-v-14cf791a]{\n    padding: 40px;\n}\n.real-results span[data-v-14cf791a]{\n  font-size: 96px;\n  color: #f0617d;\n}\n.real-results p[data-v-14cf791a]{\n  font-size: 16px;\n}\n#contactus_phonenumber[data-v-14cf791a] {\n    padding: 0 30px 0 15px;\n    height: 60px;\n    margin-bottom: 20px;\n}\n.contact-us-form p[data-v-14cf791a] {\n    font-size: 22px;\n    font-family: sans-serif;\n    letter-spacing: 0.5px;\n    margin: 0 0 30px 0;\n    font-weight: normal;\n    line-height: 1;\n    color: #777777;\n}\n.contact-us-form h2[data-v-14cf791a] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 40px 0 15px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n}\n.responsiveimg[data-v-14cf791a] {\n    height: auto;\n    width: 100%;\n}\n.b2bwrapper[data-v-14cf791a] {\n}\n.b2bwrapper[data-v-14cf791a] {\n    background: #eee;\n}\n.container.b2b[data-v-14cf791a] {\n    text-align: left;\n}\n.white[data-v-14cf791a] {\n    background: #fff;\n    font-size: 18px;\n    padding: 20px;\n    margin: 30px 0;\n}\n.row.centericons img[data-v-14cf791a] {\n    margin: 0 auto 20px;\n    display: block;\n    width: 100px;\n    height: 100px;\n    -o-object-fit: contain;\n       object-fit: contain;\n    -o-object-position: center;\n       object-position: center;\n}\n.row.centericons h4[data-v-14cf791a] {\n    /* text-align: left; */\n    font-weight: 500;\n    font-size: 19px;\n}\n.row.centericons p[data-v-14cf791a] {\n    font-size: 16px;\n}\n.contactformholder[data-v-14cf791a] {\n    background: #666;\n    color: #fff;\n    padding: 20px;\n}\nbutton#contact_sendbutton[data-v-14cf791a] {\n    background: #f0617d;\n    padding: 10px 50px;\n    min-width: 220px;\n    border-radius: 50px;\n    margin: 20px auto 30px;\n    font-size: 16px;\n    font-weight: 900;\n    color: #fff;\n}\nform#contactus_form[data-v-14cf791a] {\n    margin: 30px 0;\n}\n.b2b > h2[data-v-14cf791a] {\n    font-weight: 900;\n    font-family: 'Zilla Slab', serif !important;\n}\n.container.b2b[data-v-14cf791a] {\n    /* font-family: \"Quicksand\", sans-serif !important; */\n}\n.white[data-v-14cf791a] {\n    font-family: \"Quicksand\", sans-serif !important;\n}\n.contactformholder p[data-v-14cf791a]{\n    font-family: 'Zilla Slab', serif !important;\n}\n.contactformholder h2[data-v-14cf791a] {\n    font-weight: 900;\n    font-family: 'Zilla Slab', serif !important;\n}\n@media(min-width:768px){\n.row.centericons[data-v-14cf791a] {\n        display: -ms-flexbox;\n        display: flex;\n}\n}\n@media(max-width:767px){\n.b2b > h2[data-v-14cf791a] {\n            font-size: 21px;\n}\n.white[data-v-14cf791a] {\n            font-size: 16px !important;\n}\n}\n.contactformholder a[data-v-14cf791a] {\n    font-weight: 900;\n    color: #ffffff;\n    text-decoration: underline;\n    font-size: 19px;\n}\n@media(min-width:768px){\n.responsiveimg[data-v-14cf791a] {\n        max-height: 65vh;\n        -o-object-fit: cover;\n           object-fit: cover;\n}\n.b2b > h2[data-v-14cf791a]:first-of-type {\n        position: absolute;\n        top: 0;\n        transform: translateY(-100%);\n        margin: -20px 0 0;\n        color: #fff;\n        text-shadow: 0px 0px 4px #000;\n}\n.b2b[data-v-14cf791a] {\n        position: relative;\n}\n}\n.coverimg[data-v-14cf791a] {\n    position: relative;\n}\n.responsiveimg[data-v-14cf791a] {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n}\n.container.showmobile[data-v-14cf791a] {\n    display: none;\n}\n.coverimg[data-v-14cf791a] {\n    min-height: 65vh;\n}\n.coverimg[data-v-14cf791a] {\n    text-align: left;\n    color: #fff;\n}\n.coverimg[data-v-14cf791a]:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 100;\n    bottom: 0;\n    knob\n    background: rgba(0,0,0,1);\n    background: -webkit-gradient(left top, right top, color-stop(0%, rgba(0,0,0,1)), color-stop(100%, rgba(0,0,0,0)));\n    background: linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#000000', GradientType=1 );\n}\n.coverimg .container[data-v-14cf791a] {\n    position: relative;\n    z-index: 200;\n}\nbutton.btn.btn-rounded.btn-primary.btn-lg[data-v-14cf791a] {\n    border-radius: 50px;\n    padding: 10px 40px;\n}\n.pannelsection[data-v-14cf791a] {\n    padding: 20px 0;\n}\nh2[data-v-14cf791a] {\n    font-style: italic;\n    margin: 10px 0 40px;\n}\n.Videoscarosal[data-v-14cf791a] {\n    padding: 40px 0;\n    background: #eee;\n}\n.pannelsection[data-v-14cf791a], .testimonialscarosal[data-v-14cf791a] {\n    background: #eee;\n    padding: 40px 0;\n}\n.contactformb2b h2[data-v-14cf791a]:after ,\n.logoscarosal h2[data-v-14cf791a]:after {\n    content: \"\";\n    display: block;\n    height: 2px;\n    background: #f0617d;\n    margin: 20px auto;\n    max-width: 70px;\n}\n.contactformb2b[data-v-14cf791a] {\n    padding: 40px 0;\n}\n.contactformb2b p[data-v-14cf791a] {\n    font-size: 16px;\n}\n.ceniconholder[data-v-14cf791a] {\n    background: #fff;\n    padding: 20px 20px 30px 20px;\n    /* min-height: 380px; */\n    /* border-radius: 20px; */\n    /* box-shadow: 5px 5px 5px rgba(0 , 0, 0, 0.5); */\n}\n.logoscarosal[data-v-14cf791a] {\n    padding: 40px 0;\n}\n.logoscarosal img[data-v-14cf791a] {\n    width: 90%;\n    height: auto;\n    margin: 0 5%;\n}\n.testimonialscarosal blockquote[data-v-14cf791a] {\n    background-color: transparent;\n    border: 0 none transparent;\n    width: 100%;\n    font-size: 24px;\n}\nhtml .testimonialscarosal .slide-player[data-v-14cf791a] {\n    background: transparent;\n}\n.testimonialscarosal blockquote .author[data-v-14cf791a] {\n    font-size: 16px;\n    color: #000;\n    margin: 10px 0 0;\n}\n.testimonialscarosal blockquote[data-v-14cf791a]:before ,\n.testimonialscarosal blockquote[data-v-14cf791a]:after {\n    color: #f0617d;\n    font-size:150%;\n    display:block;\n    line-height:1;\n    margin:0;\n    padding:0;\n}\n.testimonialscarosal blockquote[data-v-14cf791a]:before {\n    content: '\\201C';\n}\n.testimonialscarosal blockquote[data-v-14cf791a]:after {\n    content: '\\201D';\n    margin: 20px 0 0;\n}\n.coverimg i.fa.fa-play-circle[data-v-14cf791a] {\n    display:none;\n}\n.coverimg a.watchvideolink[data-v-14cf791a] {\n    display:none;\n}\n.coverimg.hasvideo i.fa.fa-play-circle[data-v-14cf791a] {\n    display:block;\n    cursor: pointer;\n}\n.coverimg.hasvideo a.watchvideolink[data-v-14cf791a] {\n    display:block;\n    cursor: pointer;\n}\n.coverimg.hasvideo i.fa.fa-play-circle[data-v-14cf791a] {\n    font-size: 50px;\n    color: #fff;\n    position: absolute;\n    z-index: 500;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50% , -50%);\n}\n.coverimg.hasvideo a.watchvideolink[data-v-14cf791a] {\n    color: #fff;\n    bottom: 20px;\n    right: 20px;\n    position: absolute;\n    font-size: 21px;\n    font-weight: bold;\n    z-index: 500;\n    text-decoration: none;\n}\n.coverimg[data-v-14cf791a] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.coverimg  h1[data-v-14cf791a] {\n    margin-top:0;\n}\n.row.centericons h4[data-v-14cf791a]:before {\n    content: \"\";\n    display: block;\n    height: 2px;\n    width: 50px;\n    margin: 20px auto;\n    background: gray;\n}\n@media(max-width:767px){\n.responsiveimg[data-v-14cf791a] {\n            position: static;\n            height: auto;\n            max-height: none;\n}\n.coverimg[data-v-14cf791a] {\n            height: auto;\n            max-height: none;\n            display: block;\n            min-height: 0;\n            line-height: 0;\n}\n.coverimg .container[data-v-14cf791a] {\n            display: none;\n}\n.container.showmobile[data-v-14cf791a]{\n            display: block;\n            text-align: left;\n}\n.container.showmobile button.btn.btn-rounded.btn-primary.btn-lg[data-v-14cf791a] {\n            margin: 20px auto 30px;\n            display: block;\n}\n.ceniconholder[data-v-14cf791a] {\n            margin: 0 0 30px;\n}\n}\n.b2bVideoModal a[data-v-14cf791a]{\n    position: absolute;\n    border: 1px solid #000;\n    padding: 8px;\n    border-radius: 50%;\n    top: -20px;\n    background: #fff;\n    right: -20px;\n}\n.b2bVideoModal img[data-v-14cf791a] {\n    filter: brightness(0.0);\n}\n.watchVideoModal .modal-dialog .modal-body[data-v-14cf791a] {\n    padding: 20px;\n}\n.watchVideoModal .modal-dialog button.btn.btn-rounded.btn-primary.btn-lg[data-v-14cf791a] {\n    margin: 10px auto 40px;\n}\n.watchVideoModal > div[data-v-14cf791a] {\n    max-width: 500px;\n}\n@media(min-width:767px) and (max-width:992px){\n.coverimg .responsiveimg[data-v-14cf791a] {\n        min-height: 100% !important;\n        max-height: 100% !important;\n}\n}\n@media(max-width:767px){\n.b2bVideoModal a[data-v-14cf791a] {\n        padding: 3px;\n        top: -5px;\n        right: -5px;\n        line-height: 0;\n        height: 23px;\n        width: 23px;\n        display: block;\n        z-index: 500000000;\n}\n.b2bVideoModal a img[data-v-14cf791a] {\n        width: 15px;\n}\n}\n.flexow.row[data-v-14cf791a] {\n    display: -ms-flexbox;\n    display: flex;\n}\n.flexow.row .col-sm[data-v-14cf791a] {\n    padding: 10px;\n    -ms-flex: 1;\n        flex: 1;\n}\n.flexow.row .col-sm  .ceniconholder[data-v-14cf791a] {\n    height: 100%;\n}\n@media(max-width:767px){\n.flexow.row[data-v-14cf791a]{\n        -ms-flex-direction:column;\n            flex-direction:column;\n}\n}\n", ""]);

// exports


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\np strong[data-v-19786ae6] {\n    font-weight: 900;\n    color: #000;\n}\n.text-left p[data-v-19786ae6] {\n    font-size: 16px;\n}\n", ""]);

// exports


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#feedback_comments textarea {\n    height: 100px !important;\n    max-width: 100%;\n    min-width: 100%;\n    max-height: 100px;\n    min-height: 100px;\n    resize: none;\n}\n", ""]);

// exports


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.main-content p[data-v-1a23b194] {\n    font-size: 22px;\n    font-family: sans-serif;\n    letter-spacing: 0.5px;\n    margin: 0 0 30px 0;\n    font-weight: normal;\n    line-height: 1;\n    color: #777777;\n}\n.main-content h2[data-v-1a23b194] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 40px 0 15px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n}\n", ""]);

// exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.JWvideoHandler>button.pink-button[data-v-1ad9f1ae] {\n    position: absolute;\n    z-index: 100;\n    bottom: 60px;\n    left: 50%;\n    transform: translateX(-50%);\n    color: white;\n    font-size: 16px;\n    border: none;\n    width: 253px;\n    padding: 14px 15px 12px;\n    border-radius: 3px;\n    background: rgb(240, 97, 125) !important;\n    text-transform: uppercase !important;\n    letter-spacing: 1px !important;\n}\n.JWvideoHandler[data-v-1ad9f1ae] {\n    position: relative;\n}\n.jwplayer.jw-flag-fullscreen+button[data-v-1ad9f1ae] {\n    position: fixed;\n    z-index: 999999999999999999;\n}\n@media(max-width:1024px) {\n.JWvideoHandler[data-v-1ad9f1ae] {\n        width: 100%;\n        display: table;\n}\n}\n@media(max-width:767px){\n.JWvideoHandler>button.pink-button[data-v-1ad9f1ae] {\n        font-size: 14px;\n        border: none;\n        width: auto;\n        padding: 8px 10px 5px;\n}\n}\n.fade-enter-active[data-v-1ad9f1ae], .fade-leave-active[data-v-1ad9f1ae] {\n    transition: opacity 1s;\n}\n.fade-enter[data-v-1ad9f1ae], .fade-leave-to[data-v-1ad9f1ae] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\n@media(min-width:1350px){\n.JWvideoHandler>button.pink-button[data-v-1ad9f1ae]{\n        bottom:15%;\n}\n}\n/* #master-wrapper {*/\n/*     display: flex;*/\n/*     flex-direction: row;*/\n/*     justify-content: center;*/\n/* }*/\n/*#playlist {*/\n/*    width: 360px;*/\n/*    height: 360px;*/\n/*    background-color: black;*/\n/*    overflow: scroll;*/\n/*}*/\n/*.playlist-item {*/\n/*    width: calc(100% - 20px);*/\n/*    height: auto;*/\n/*    display: flex;*/\n/*    flex-direction: row;*/\n/*    align-items: center;*/\n/*    justify-content: flex-start;*/\n/*    font-family: sans-serif;*/\n/*    color: white;*/\n/*    padding: 5px 10px;*/\n/*    cursor: pointer;*/\n/*}*/\n/*.playlist-item img {*/\n/*    height: 100px;*/\n/*    display: inline-block;*/\n/*    margin-right: 10px;*/\n/*}*/\n", ""]);

// exports


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.text-wrap-title-1[data-v-21385b83] {\n    right: -14px;\n    position: absolute;\n    background-color: rgb(68, 189, 168) !important;\n    color: #fff !important;\n    font-size: 12px !important;\n    padding: 2px 4px !important;\n    border-top-left-radius: 4px !important;\n    line-height: 1.1 !important;\n}\n.align-to-bottom[data-v-21385b83] {\n    right: -13px !important;\n    top: -9px !important;\n}\n.jw-img-1[data-v-21385b83] {\n    max-width: 100%; /* Ensure the image does not exceed its container width */\n}\n.image-container[data-v-21385b83] {\n    position: relative;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n}\n.btn-group.plusicon[data-v-21385b83] {\n    position: absolute;\n    right: 50px;\n    bottom: 0px;\n    height: 29px;\n}\nli.divider[data-v-21385b83] {\n    border-bottom: 1px solid #ddd;\n    margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-21385b83] {\n    background: transparent;\n    border: 0 none transparent;\n    padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-21385b83]{\n    font-size: 21px;\n    top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-21385b83]{\n    padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-21385b83],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-21385b83] {\n    padding: 3px 15px;\n    margin-bottom: 5px;\n    display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-21385b83],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-21385b83] {\n    height: 30px;\n    padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-21385b83],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-21385b83] {\n    position: absolute;\n    top: 6px;\n    font-size:24px;\n    right:20px;\n    cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-21385b83],\nbutton.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-21385b83]{\n    position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-21385b83],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul[data-v-21385b83]{\n    left: 0;\n    right: auto;\n    width: 230px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    top: 100%;\n    position: absolute;\n    z-index: 5000;\n    list-style: none;\n    text-align: left;\n    padding: 15px;\n}\n.backdropformenu[data-v-21385b83]{\n    position:fixed;\n    z-index:4900;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-21385b83]{\n    height: 24px;\n    width: 37px;\n}\n.menuiconbutton[data-v-21385b83]{\n    height: 24px;\n    width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-21385b83] {\n    left: auto ;\n    right: 0;\n}\n.fade-enter-active[data-v-21385b83], .fade-leave-active[data-v-21385b83] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-21385b83], .fade-leave-to[data-v-21385b83] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-21385b83]{\n    font-size: 10px;\n}\nspan.removed[data-v-21385b83] {\n    color: red;\n}\nspan.added[data-v-21385b83] {\n    color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-21385b83] {\n    position: relative;\n    display:block;\n}\n.bolder[data-v-21385b83] {\n    font-size: 18px;\n    font-weight: 900;\n}\n@media(max-width:767px){\n.hidemobile[data-v-21385b83]{display:none;\n}\n}\n", ""]);

// exports


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.list-complete-item {\n    padding: 4px;\n    margin-top: 4px;\n    border: solid 1px;\n    transition: all 1s;\n}\n.list-complete-enter, .list-complete-leave-active {\n    opacity: 0;\n}\nbody{\n    -ms-overflow-style:scrollbar;\n}\n.fixgraybgpl .video-player .left-video-icons{background:transparent;\n}\n@media(max-width:992px) {\n.side-content pre {\n        overflow: scroll;\n        white-space: pre-wrap;\n}\n.fixgraybgpl .video-player .jwplayer.jw-flag-aspect-mode {\n        height: auto !important;\n}\n}\n/*@media (max-width: 991px) and (min-width: 320px){\n    .fixgraybgpl .video-player .reset-video-width {\n        max-width:85%;\n    }\n}*/\n", ""]);

// exports


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.video-player-wrapper .watch-again .current-video-img img[data-v-23798c26] {\n     -o-object-fit: cover;\n        object-fit: cover;\n}\n.video-player .right-video-icons .enjoy-hover-box[data-v-23798c26] {\n     width: 20%;\n     height: 100%;\n     background: #f0617d;\n     position: absolute;\n     top: 0;\n     right: 0;\n     padding: 15% 0px 0;\n     text-align: left;\n}\n.video-player .right-video-icons .enjoy-hover-box button.btn[data-v-23798c26] {\n     margin: 0 0 10px;\n     border-color: white;\n     border-radius: 3px;\n     padding: 12px 0 13px;\n     display: block;\n     width: 80%;\n     margin: 0px auto 10px;\n     color: #fff;\n}\n.video-player-wrapper .tooltipBox[data-v-23798c26] {\n     width: 100%;\n     text-align: center;\n     padding-bottom: 10px;\n     height: 35px;\n     margin-top: 24px;\n}\n@media (min-width:768px) {\n.video-player .right-video-icons .enjoy-hover-box[data-v-23798c26] {\n         padding: 117px 0px 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating[data-v-23798c26] {\n         overflow: hidden;\n         position: absolute;\n         left: 0;\n         right: 0;\n         bottom: 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating p[data-v-23798c26] {\n         color: white;\n         display: block;\n         font-size: 16px;\n         letter-spacing: 0.5px;\n         margin-top: 23px;\n         margin-bottom: 20px;\n         padding: 0 10%;\n         text-align: center;\n}\n}\n.video-player .right-video-icons .rate-hover-box span[data-v-23798c26] {\n     margin-bottom: 20px;\n}\n.video-player .right-video-icons .rate-hover-box button[data-v-23798c26]:hover {\n     background: #ac2925;\n}\n.video-player .btn-danger[data-v-23798c26]:focus {\n     background: inherit;\n     border-color: inherit;\n     outline: none;\n}\n.video-player .right-video-icons div button.btn-danger[data-v-23798c26]:hover{\n     background:rgba(0,0,0,0.1);\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-23798c26]:hover{\n     background:#ac2925;\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-23798c26]:focus{\n color: #fff;\n background-color: #ac2925;\n border-color: #fff;\n}\n.profile-content img[data-v-23798c26] {\n     -o-object-fit: cover;\n        object-fit: cover;\n     -o-object-position: center center;\n        object-position: center center;\n}\n.playlistholderdiv[data-v-23798c26] {\n     width: 15%;\n     color: #fff;\n     position: absolute;\n     top: 0;\n     right: 0;\n     padding: 15px;\n     bottom: 0;\n     overflow-y: auto;\n}\n.playlistholderdiv img[data-v-23798c26] {\n     max-width: 100%;\n     margin: 0 0 10px;\n}\n.fixgraybgpl .video-player-background[data-v-23798c26] {\n     position: relative;\n}\n.playlistholderdiv h4[data-v-23798c26] {\n     font-size: 16px;\n}\n.playlistholderdiv p[data-v-23798c26] {\n     font-size: 14px !important;\n}\n.playlistentrydiv[data-v-23798c26] {\n     position: relative;\n}\n.playlistentrydiv.playing[data-v-23798c26]:after {\n     position: absolute;\n     right: 0;\n     text-align: center;\n     font-weight: 900;\n     text-shadow: 0 1px 3px rgba(0,0,0,0.75);\n     content: \"\";\n     height: 0;\n     width: 0;\n     border: 10px solid transparent;\n     top: 12px;\n     border-left-color: #f0617d;\n     transform: translateY(-0%);\n     left: 2px;\n}\n.playlistentrydiv.playingMobile[data-v-23798c26]:after {\n     position: absolute;\n     right: 0;\n     text-align: center;\n     font-weight: 900;\n     text-shadow: 0 1px 3px rgba(0,0,0,0.75);\n     content: \"\";\n     height: 0;\n     width: 0;\n     border: 10px solid transparent;\n     top: 2px;\n     border-left-color: #f0617d;\n     transform: translateY(-0%);\n     left: 2px;\n}\n@media(max-width:5992px) {\n.playlistholderdiv[data-v-23798c26] {\n         width: 100%;\n         position: static;\n         overflow: visible;\n}\n.playlistholderdiv img[data-v-23798c26] {\n         width: 100px;\n         float: left;\n         margin: 0px 15px 10px 0;\n}\n.playlistentrydiv[data-v-23798c26] {\n         overflow: hidden;\n         text-align: left;\n         border-bottom: 1px solid #666;\n         margin: 0 0 0px;\n}\n.playlistentrydiv[data-v-23798c26] {\n         transition: all 0.5s ease;\n         cursor: pointer;\n}\n.playlistentrydiv[data-v-23798c26]:hover {\n         background: #fff;\n}\n.playlistentrydiv:hover > p[data-v-23798c26] {\n         transition: all 0.5s ease;\n         color: #000;\n}\ndiv:last-of-type > .playlistentrydiv[data-v-23798c26] {\n         margin: 0;\n         border-bottom: 0 none transparent;\n}\ndiv:last-of-type > .playlistentrydiv img[data-v-23798c26] {\n         margin-bottom: 0;\n}\n}\n.btn-group.plusicon[data-v-23798c26] {\n     position: absolute;\n     right: 50px;\n     bottom: 0px;\n     height: 29px;\n}\nli.divider[data-v-23798c26] {\n     border-bottom: 1px solid #ddd;\n     margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-23798c26] {\n     background: transparent;\n     border: 0 none transparent;\n     padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-23798c26]{\n     font-size: 21px;\n     top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-23798c26]{\n     padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-23798c26],\n button.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-23798c26] {\n     padding: 3px 15px;\n     margin-bottom: 5px;\n     display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-23798c26],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-23798c26] {\n     height: 30px;\n     padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-23798c26],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-23798c26] {\n     position: absolute;\n     top: 6px;\n     font-size:24px;\n     right:20px;\n     cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-23798c26],\n button.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-23798c26]{\n     position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-23798c26],\n button.dropdown-toggle.ellipsis.pull-right+ ul[data-v-23798c26]{\n     left: 0;\n     right: auto;\n     width: 230px;\n     background: #fff;\n     border: 1px solid #ddd;\n     border-radius: 5px;\n     top: 100%;\n     position: absolute;\n     z-index: 5000;\n     list-style: none;\n     text-align: left;\n     padding: 15px;\n}\n.backdropformenu[data-v-23798c26]{\n     position:fixed;\n     z-index:4900;\n     top:0;\n     left:0;\n     right:0;\n     bottom:0;\n     background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-23798c26]{\n     height: 24px;\n     width: 37px;\n}\n.menuiconbutton[data-v-23798c26]{\n     height: 24px;\n     width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-23798c26] {\n     left: auto ;\n     right: 0;\n}\n.fade-enter-active[data-v-23798c26], .fade-leave-active[data-v-23798c26] {\n     transition: opacity .5s;\n}\n.fade-enter[data-v-23798c26], .fade-leave-to[data-v-23798c26] /* .fade-leave-active below version 2.1.8 */ {\n     opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-23798c26]{\n     font-size: 10px;\n}\nspan.removed[data-v-23798c26] {\n     color: red;\n}\nspan.added[data-v-23798c26] {\n     color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-23798c26] {\n     position: relative;\n     display:block;\n}\n/*Copied for Playlist Options*/\n.btn-group.plusicon[data-v-23798c26] {\n     position: absolute;\n     right: 50px;\n     bottom: 0px;\n     height: 29px;\n}\nli.divider[data-v-23798c26] {\n     border-bottom: 1px solid #ddd;\n     margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-23798c26] {\n     background: transparent;\n     border: 0 none transparent;\n     padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-23798c26]{\n     font-size: 21px;\n     top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-23798c26]{\n     padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-23798c26],\n button.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-23798c26] {\n     padding: 3px 15px;\n     margin-bottom: 5px;\n     display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-23798c26],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-23798c26] {\n     height: 30px;\n     padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-23798c26],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-23798c26] {\n     position: absolute;\n     top: 6px;\n     font-size:24px;\n     right:20px;\n     cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-23798c26],\n button.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-23798c26]{\n     position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-23798c26],\n button.dropdown-toggle.ellipsis.pull-right+ ul[data-v-23798c26]{\n     left: 0;\n     right: auto;\n     width: 230px;\n     background: #fff;\n     border: 1px solid #ddd;\n     border-radius: 5px;\n     top: 100%;\n     position: absolute;\n     z-index: 5000;\n     list-style: none;\n     text-align: left;\n     padding: 15px;\n}\n.backdropformenu[data-v-23798c26]{\n     position:fixed;\n     z-index:4900;\n     top:0;\n     left:0;\n     right:0;\n     bottom:0;\n     background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-23798c26]{\n     height: 24px;\n     width: 37px;\n}\n.menuiconbutton[data-v-23798c26]{\n     height: 24px;\n     width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-23798c26] {\n     left: auto ;\n     right: 0;\n}\n.fade-enter-active[data-v-23798c26], .fade-leave-active[data-v-23798c26] {\n     transition: opacity .5s;\n}\n.fade-enter[data-v-23798c26], .fade-leave-to[data-v-23798c26] /* .fade-leave-active below version 2.1.8 */ {\n     opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-23798c26]{\n     font-size: 10px;\n}\nspan.removed[data-v-23798c26] {\n     color: red;\n}\nspan.added[data-v-23798c26] {\n     color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-23798c26] {\n     position: relative;\n     display:block;\n}\n.playlistholderdiv button.dropdown-toggle.ellipsis.pull-right[data-v-23798c26] {\n     display: block;\n     top: 0px;\n     font-size: 0;\n     line-height: 1;\n     color: #f0617d;\n     height: 10px;\n     width: 30px;\n     right: 0;\n}\n.playlistholderdiv .plusicon.btn-group[data-v-23798c26] {\n     top: 0;\n     right: 0;\n     width: 100%;\n     max-width:350px\n}\n.playlistholderdiv button.dropdown-toggle.ellipsis.pull-right[data-v-23798c26]:before {\n     content: \"...\";\n     position: absolute;\n     top: -10px;\n     line-height: 0;\n     font-size: 50px;\n     display: block;\n     right: 5px;\n     letter-spacing: -2px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-23798c26] {\n     padding: 5px;\n     top: 11px;\n     width: 100%;\n     border-radius:0;\n     border:0 none transparent;\n}\n.playlistholderdiv li.divider[data-v-23798c26] {\n     margin: 2px 0 4px;\n}\n.playlistholderdiv button.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-23798c26] {\n     padding: 0 !important;\n     margin: 0;\n     font-size: 10px;\n}\n.playlistholderdiv input[type=\"checkbox\"][data-v-23798c26] {position: relative;top: 3px;\n}\n.playlistentrydiv[data-v-23798c26] {\n     overflow:visible !important;\n     clear:both;\n     display:table;\n     width:100%;\n     padding-top:10px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-23798c26] {\n     color: #000;\n}\n.playlistholderdiv>div>span>div:last-of-type .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-23798c26] {\n     top: auto;\n     bottom: 20px;\n}\n.playlistholderdiv>div>span>div:last-of-type .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-23798c26] {\n     top: 11px;\n     bottom: auto;\n}\n.playlistentrydiv[data-v-23798c26] {\n     padding-right: 30px;\n}\n", ""]);

// exports


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.community-content h2[data-v-24b2f4ca] {\n    margin: 0 0 20px;\n}\nh2 + button.button.btn.btn-pink.btn-primary.pull-center[data-v-24b2f4ca] {\n    margin: 0 auto 30px;\n}\n.community-content .communityBox h2[data-v-24b2f4ca] {\n    margin:  0 0 20px;\n    line-height: 1.3;\n}\n.community-content .communityBox p[data-v-24b2f4ca] {\n    margin: 0 0 20px;\n}\n.community-content .sliderEventBox .slick-slide img[data-v-24b2f4ca] {\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center;\n       object-position: center;\n    height:auto;\n}\n.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent[data-v-24b2f4ca] {\n    border-radius: 3px;\n    margin: 20px 0 0;\n}\n.sliderEventBox p[data-v-24b2f4ca] {\n    min-height: 155px;\n}\n/*.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent.disabled ,*/\n/*.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent.disabled:hover {*/\n    /*background: transparent;*/\n    /*color: #e08383 !important;*/\n/*}*/\n@media(min-width:768px){\n.sliderTalkBox>h2+p[data-v-24b2f4ca] {\n        position: relative;\n        top: -40px;\n        color: #303030;\n        font-size: 15px;\n        font-weight: 500;\n        font-family: sans-serif;\n        letter-spacing: 0.3px;\n}\n.community-content .sliderEventBox[data-v-24b2f4ca] {\n        margin: 70px 0 100px 0;\n}\n}\n.community-content .communityBox button[data-v-24b2f4ca]{width:auto;\n}\n.community-content .communityBox h5[data-v-24b2f4ca] {\n    margin: 0 0 35px 0;\n}\n.community-content .sliderTalkBox .slick-slide p[data-v-24b2f4ca] {\n    margin: 0 0 20px 0;\n    color: #303030;\n    font-size: 14px;\n    line-height: 22px;\n    font-family: sans-serif;\n    padding: 0 10px 0 10px;\n    text-align: left;\n    letter-spacing: 0.5px;\n}\n.selected-event[data-v-24b2f4ca] {\n    content: \"\\F00C\";\n    font: normal normal normal 14px/1 FontAwesome;\n    position: absolute;\n    color: white;\n    right: 20.5px;\n    top: 24px;\n    font-size: 18px;\n}\n.slick-slide button.button[data-v-24b2f4ca] {\n    color: #f0617d;\n    border: 1px solid #f0617d;\n    background: none;\n    outline: none;\n    font-size: 16px;\n    font-family: sans-serif;\n    letter-spacing: 0.3px;\n    float: left;\n    margin-left: 10px;\n    width: 278px;\n    padding: 18px 15px 14px;\n    border-radius: 3px;\n    margin-top: 10px;\n}\n.sliderTalkBox .slider p[data-v-24b2f4ca] {\n    min-height: 160px;\n}\n.community-content .sliderTalkBox .slick-slide h5[data-v-24b2f4ca] {\n    text-align: left;\n    padding: 0 10px;\n}\n.sliderTalkBox .slider h2[data-v-24b2f4ca]{\n    color: #303030;\n    margin: 15px 0 15px 0;\n    line-height: 31px;\n    text-align: left;\n    font-family: sans-serif;\n    padding: 0 20px 0 10px;\n    font-size: 20px;\n    text-transform: inherit;\n}\n.slick-slide .addeventatc.pinkoutlinebtn[data-v-24b2f4ca] {\n    padding: 11px 12px 11px 37px !important;\n}\nbutton.share-event[data-v-24b2f4ca] {\n    color: rgb(240, 97, 125) !important;\n    border: 1px solid rgb(240, 97, 125) !important;\n    background-image: none !important;\n    font-weight: 600;\n    line-height: 100%;\n    background: #fff !important;\n    font-size: 15px !important;\n    text-decoration: none;\n    border-radius: 3px !important;\n    cursor: pointer;\n    -webkit-font-smoothing: antialiased!important;\n    outline-color: rgba(0,78,255,0.5) !important;\n    text-shadow: 1px 1px 1px rgb(0 0 0 / 0%);\n    display: inline-block;\n    position: relative;\n    /*z-index: 99998;*/\n    font-family: \"Open Sans\",Roboto,\"Helvetica Neue\",Helvetica,Optima,Segoe,\"Segoe UI\",Candara,Calibri,Arial,sans-serif !important;\n    padding: 12px 12px 12px 12px !important;\n    margin-left: 10px !important;\n    width: 173px !important;\n    display: inline-block;\n    float: left !important;\n    box-shadow: 0 0 0 0.5px rgba(50,50,93,.17), 0 2px 5px 0 rgba(50,50,93,.1), 0 1px 1.5px 0 rgba(0,0,0,.07), 0 1px 2px 0 rgba(0,0,0,.08), 0 0 0 0 transparent!important;\n}\n.addeventatc.pinkoutlinebtn[data-v-24b2f4ca] {\n    float: left;\n}\n@media(max-width:991px){\n.community-content .communityBox .addeventatc.pinkoutlinebtn[data-v-24b2f4ca]{\n        margin-left:0 !important;\n        margin-right:10px;\n        margin-bottom:10px;\n}\n.community-content .communityBox button.share-event[data-v-24b2f4ca]{\n        margin-left:0 !important;\n}\n}\n@media(max-width:767px){\n.community-content .communityBox .addeventatc.pinkoutlinebtn[data-v-24b2f4ca]{\n        margin-left:15px !important;\n}\n.community-content .communityBox button.share-event[data-v-24b2f4ca]{\n        margin-left:15px !important;\n}\n}\n.slick-slide .addeventatc.pinkoutlinebtn[data-v-24b2f4ca] {\n    padding: 13px 12px 12px 37px !important;\n}\n.slick-slide button.share-event[data-v-24b2f4ca] {\n    width: auto !important;\n    margin: 10px;\n}\n/*Changes for Corporate Modal*/\n.sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader[data-v-24b2f4ca] {\n    background: #f0617d;\n    color: #fff;\n    font-size: 25px;\n    text-align: left;\n    padding: 15px 25px;\n    font-weight: 700;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body p[data-v-24b2f4ca]{\n    padding: 0;\n    margin: 0 0 20px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-24b2f4ca] {\n    background: #fff;\n    color: #333;\n    border: 1px solid #cacaca;\n    width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body[data-v-24b2f4ca] {\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink[data-v-24b2f4ca] {\n    background: #f0617d;\n    width: 100%;\n    margin: 0;\n    border: 1px solid #f0617d;\n}\n@media(max-width:475px){\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-24b2f4ca] {\n        padding-left: 0;\n        padding-right: 0;\n}\n}\n.row.sharefb[data-v-24b2f4ca] {\n    background: #eee;\n    margin-left: 0;\n    margin-right: 0;\n}\n.row.sharefb > div[data-v-24b2f4ca] {\n    padding: 5px;\n    text-align: left;\n}\n.row.sharefb .col-sm-5 img[data-v-24b2f4ca] {\n    max-width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-24b2f4ca] {\n    font-size: 14px;\n    font-weight: 300;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6[data-v-24b2f4ca] {\n    text-transform: uppercase;\n    font-size: 12px;\n    margin: 10px 0 5px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4[data-v-24b2f4ca] {\n    margin: 0 0 5px;\n    font-weight:700;\n}\n.showmobile[data-v-24b2f4ca]{display:none;\n}\n@media(max-width:767px){\n.usernamenimg.text-left[data-v-24b2f4ca] {\n        display: none;\n}\n.showmobile[data-v-24b2f4ca]{\n        display: block;\n}\n.alert.alert-default[data-v-24b2f4ca] {\n        background: #eee;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-24b2f4ca] {\n        display: none;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow[data-v-24b2f4ca] {\n        top: 1px;\n        right: -13px;\n}\n.row.sharefb[data-v-24b2f4ca] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.pinksidebarmin[data-v-24b2f4ca]{\n        padding:0 !important;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        -ms-flex-preferred-size: auto;\n            flex-basis: auto;\n        display: flex ;\n        -ms-flex-align: stretch ;\n            align-items: stretch ;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.pinksidebarmin > *[data-v-24b2f4ca] {\n        padding: 6px 0 !important;\n        margin: 0 !important;\n        -ms-flex: 100;\n            flex: 100;\n        text-align:center;\n}\n}\n.watchVideoModal .modal-dialog .modal-body p[data-v-24b2f4ca] {\n    padding: 16px 60px 19px 60px;\n}\n.modal[data-v-24b2f4ca] {\n    z-index: 999999;\n}\n.community-content .communityBox h2[data-v-24b2f4ca] {\n    /*color: #44bda8;*/\n    font-size: 24px;\n}\n.community-content .communityBox[data-v-24b2f4ca] {\n    width: 100%;\n}\n", ""]);

// exports


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.container-icons.vpage > div > span {\n    display: inline-block;\n    background: #f0617d;\n    height: 50px;\n    width: 50px;\n    color: #fff;\n    text-align: center;\n    line-height: 60px;\n    border-radius: 50%;\n}\n.container-icons.vpage {\n    text-align: right;\n}\n.largeslidesilderplayicon .slick-slide:after {\n    content: \"\\F04B\";\n    font-family: fontawesome;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%) translateY(-50%);\n    color: rgba(255, 255, 255, 0.75);\n    font-size: 78px;\n    height: 120px;\n    width: 120px;\n    line-height: 107px;\n    border: 5px solid;\n    border-radius: 50%;\n    text-align: center;\n    padding-left: 22px;\n    cursor: pointer;\n}\n.largeslidesilderplayicon .slick-prev, .largeslidesilderplayicon .slick-next {\n    top: 50%;\n    margin-top: -33px;\n    z-index: 5;\n    line-height: 1;\n    width: auto;\n}\n.largeslidesilderplayicon {\n    padding: 0 60px;\n}\nbody .largeslidesilderplayicon .slick-next:before, body .largeslidesilderplayicon .slick-prev:before {\n    color: #333 !important;\n    font-size: 50px;\n    line-height: 0 !important;\n}\nbody .largeslidesilderplayicon .slick-next:before{\n    content:\">\" !important;\n}\nbody .largeslidesilderplayicon .slick-prev:before {\n    content:\"<\" !important;\n}\n.largeslidesilderplayicon .slick-next {\n    right: 20px;\n}\n.largeslidesilderplayicon .slick-prev {\n    left: 20px;\n}\n@media(min-width:320px) and (max-width:767px){\n.largeslidesilderplayicon .slick-slide:after {\n        font-size: 30px;\n        height: 70px;\n        width: 70px;\n        line-height: 60px;\n        margin-top: -20px;\n        padding-left: 10px;\n}\n.video-player.autoheight {\n        height: auto;\n}\n.autoheight.video-player .jwplayer.jw-flag-aspect-mode {\n        height: auto !important;\n}\n}\n.autoheight div.jw-error.jw-reset {\n    height: 25vw !important;\n}\n.video-player .left-video-icons{\n    height: 25vw !important;\n}\n.autoheight{\n    height: auto !important;\n    padding-bottom:20px;\n}\n.row.morevediosrow .largeslidesilderplayicon.slider .slick-track .slick-slide .slide-player img {\n    height: auto !important;\n}\n.row.morevediosrow .largeslidesilderplayicon.slider .slick-track .slick-slide .slide-player {\n    margin: 0;\n}\n.row.morevediosrow .largeslidesilderplayicon.slider .slick-track .slick-slide .slide-player>div {\n    padding: 10px;\n}\n.row.morevediosrow .slider.responsive-slick-slider.largeslidesilderplayicon.slick-slider .slick-slide:after {\n    top: calc(50% - 25px);\n    width: 90px;\n    height: 90px;\n    line-height: 90px;\n    font-size: 40px;\n    line-height: 79px;\n    padding-left: 10px;\n    pointer-events: none;\n}\n@media(max-width:767px){\n.row.morevediosrow .slider.responsive-slick-slider.largeslidesilderplayicon.slick-slider .slick-slide:after {\n        top: calc(50%);\n        width: 60px;\n        height: 60px;\n        font-size: 30px;\n        line-height: 50px;\n        padding-left: 5px;\n}\n}\n", ""]);

// exports


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\na[data-v-270784da] {\n    cursor: pointer !important;\n}\n.video-player-wrapper .watch-again .current-video-img img[data-v-270784da] {\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.video-player .right-video-icons .enjoy-hover-box[data-v-270784da] {\n    width: 20%;\n    height: 100%;\n    background: #f0617d;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 15% 0px 0;\n    text-align: left;\n}\n.video-player .right-video-icons .enjoy-hover-box button.btn[data-v-270784da] {\n    margin: 0 0 10px;\n    border-color: white;\n    border-radius: 3px;\n    padding: 12px 0 13px;\n    display: block;\n    width: 80%;\n    margin: 0px auto 10px;\n    color: #fff;\n}\n.video-player-wrapper .tooltipBox[data-v-270784da] {\n    width: 100%;\n    text-align: center;\n    padding-bottom: 10px;\n    height: 35px;\n    margin-top: 24px;\n}\n.row.morevediosrow img[data-v-270784da] {\n    max-width: 100%;\n}\n.clearfix[data-v-270784da] {\n    clear: both;\n}\n.gap[data-v-270784da] {\n    height: 30px;\n}\nh3.pinkheading[data-v-270784da] {\n    color: #f0617d;\n    font-size: 28px;\n    letter-spacing: 2px;\n    margin: 10px 0 20px;\n}\nul.pinkheading li  a[data-v-270784da] {\n}\nul.pinkheading li[data-v-270784da] {\n    margin: 5px 0 5px;\n}\nul.pinkheading[data-v-270784da] {\n    margin: 0;\n    padding: 0;\n    font-size: 19px;\n    font-weight: 900;\n    list-style: none;\n}\n@media (min-width:768px) {\n.video-player .right-video-icons .enjoy-hover-box[data-v-270784da] {\n        padding: 117px 0px 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating[data-v-270784da] {\n        overflow: hidden;\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating p[data-v-270784da] {\n        color: white;\n        display: block;\n        font-size: 16px;\n        letter-spacing: 0.5px;\n        margin-top: 23px;\n        margin-bottom: 20px;\n        padding: 0 10%;\n        text-align: center;\n}\n}\n.video-player .right-video-icons .rate-hover-box span[data-v-270784da] {\n    margin-bottom: 20px;\n}\n.video-player .right-video-icons .rate-hover-box button[data-v-270784da]:hover {\n    background: #ac2925;\n}\n.video-player .btn-danger[data-v-270784da]:focus {\n    background: inherit;\n    border-color: inherit;\n    outline: none;\n}\n.video-player .right-video-icons div button.btn-danger[data-v-270784da]:hover{\n    background:rgba(0,0,0,0.1);\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-270784da]:hover{\n    background:#ac2925;\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-270784da]:focus{\n    color: #fff;\n    background-color: #ac2925;\n    border-color: #fff;\n}\n.profile-content img[data-v-270784da] {\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center center;\n       object-position: center center;\n}\n.video-player .left-video-icons[data-v-270784da] {\n    background: white;\n    color: white;\n    width: 15%;\n    float: left;\n    height: 100%;\n}\nh3.errormessage[data-v-270784da] {\n    color: #f0617d;\n    letter-spacing: 3px;\n    margin: 70px 20px;\n}\n@media(max-width:767px){\n.row.morevediosrow img[data-v-270784da] {\n        margin:0 0 10px;\n}\n}\n.row.morevediosrow p.text-wrap-title.cursor[data-v-270784da] {\n    font-size: 20px;\n    text-align: left;\n    color: #000;\n}\n.container-icons > div > span[data-v-270784da] {\n    display: inline-block;\n    background: #f0617d;\n    height: 50px;\n    width: 50px;\n    color: #fff;\n    text-align: center;\n    line-height: 60px;\n    border-radius: 50%;\n}\np.text-wrap-title.cursor[data-v-270784da] {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\nh2.pink-text-headline[data-v-270784da] {\n    margin: 30px 0 30px;\n}\np.video-description[data-v-270784da] {\n    font-size: 23px;\n}\n.row.morevediosrow p.text-wrap-title.cursor[data-v-270784da] {\n    font-size: 20px;\n}\n.tabContent p.text-wrap-title.cursor[data-v-270784da] {\n    font-size: 17px;\n}\n@media(max-width:768px){\n.row.morevediosrow[data-v-270784da] {\n        margin: 0;\n}\n}\n", ""]);

// exports


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.set-error[data-v-2791f852]{\n    border-color: #a94442 !important;\n    color:#a94442 !important;\n}\n.StripeElement[data-v-2791f852] {\n    background-color: white;\n    padding: 2em 1em;\n    border: 1px solid #ccc;\n    box-shadow: 0 1px 3px 0 #e6ebf1;\n    transition: box-shadow 150ms ease;\n    height: 34px;\n}\n.float-right.paymentswitch.btn-group[data-v-2791f852] {\n    margin: 0 0 30px;\n}\n.StripeElement--focus[data-v-2791f852] {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n}\n.StripeElement--invalid[data-v-2791f852] {\n    border-color: #fa755a;\n}\n.StripeElement--webkit-autofill[data-v-2791f852] {\n    background-color: #fefde5 !important;\n}\n.radiowrapper[data-v-2791f852] {\n    padding: 0 35px 35px;\n    color: #f0617d;\n}\n.showmobile[data-v-2791f852]{\n    display:none;\n}\n.stripeholder[data-v-2791f852] {\n    position: relative;\n}\ni.fa.fa-lock.overlapstripe[data-v-2791f852] {\n    position: absolute;\n    left: 18px;\n    top: 10px;\n    font-size: 18px;\n    color: #b2b8c7;\n}\n@media (max-width:767px){\n.hidemobile[data-v-2791f852]{\n        display:none;\n}\n.showmobile[data-v-2791f852]{\n        display:inherit;\n}\n.signUp .left-content h4[data-v-2791f852] {\n        font-size: 14px;\n        letter-spacing: 0px;\n}\n.signUp .main-content h2[data-v-2791f852] {\n        margin: 15px 0;\n        line-height: 20px;\n        font-size: 18px;\n}\n.signUp #redeem_pwderrormsg[data-v-2791f852] {\n        margin-bottom: 8px;\n        line-height: 1.3;\n        letter-spacing: 1px;\n}\n.signUp .left-content .create-account #redeem_button[data-v-2791f852] {\n        margin: 0;\n}\n.signUp .right-content .jumbotron[data-v-2791f852] {\n        padding: 6px;\n        margin-top: 7px;\n}\n.signUp .right-content .jumbotron h2[data-v-2791f852] {\n        margin: 0;\n        font-size: 21px;\n}\n.signUp .right-content .jumbotron p[data-v-2791f852] {\n        display: none;\n}\n.signUp .right-content .card[data-v-2791f852] {\n        padding: 10px 10px;\n}\n.signUp .right-content .card .card-block .list-group li[data-v-2791f852] {\n        font-size: 16px;\n        margin: 0 0 10px;\n}\n.signUp .left-content hr[data-v-2791f852] {\n        display: none;\n}\n.row.margin-top[data-v-2791f852] {\n        margin-top: 0px;\n}\n}\n\n/* Media query for mobile viewport */\n@media screen and (max-width: 400px) {\n#paypal-button-container[data-v-2791f852] {\n        width: 100%;\n}\n}\n\n/* Media query for desktop viewport */\n@media screen and (min-width: 400px) {\n#paypal-button-container[data-v-2791f852] {\n        width: 250px;\n        display: inline-block;\n}\n}\nbody .margin-top[data-v-2791f852] {\n    margin-top: 89px;\n    margin-bottom: 70px;\n}\nbody .signUp .right-content .card .card-block .list-group[data-v-2791f852]{\n    margin-bottom:0px;\n}\n", ""]);

// exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.container-icons.vpage > div > span {\n    display: inline-block;\n    background: #f0617d;\n    height: 50px;\n    width: 50px;\n    color: #fff;\n    text-align: center;\n    line-height: 60px;\n    border-radius: 50%;\n}\n.container-icons.vpage {\n    text-align: right;\n}\n@media(min-width:320px) and (max-width:767px){\n.video-player.autoheight {\n        height: auto;\n}\n.autoheight.video-player .jwplayer.jw-flag-aspect-mode {\n        height: auto !important;\n}\n}\n.autoheight div.jw-error.jw-reset {\n    height: 25vw !important;\n}\n.video-player .left-video-icons{\n    height: 25vw !important;\n}\n.autoheight{\n    height: auto !important;\n    padding-bottom:20px;\n}\n", ""]);

// exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n@media(max-width:768px){\n.row.morevediosrow[data-v-2d26e445] {\n        margin: 0;\n}\n}\na[data-v-2d26e445] {\n    cursor: pointer !important;\n}\n.video-player-wrapper .watch-again .current-video-img img[data-v-2d26e445] {\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.video-player .right-video-icons .enjoy-hover-box[data-v-2d26e445] {\n    width: 20%;\n    height: 100%;\n    background: #f0617d;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 15% 0px 0;\n    text-align: left;\n}\n.video-player .right-video-icons .enjoy-hover-box button.btn[data-v-2d26e445] {\n    margin: 0 0 10px;\n    border-color: white;\n    border-radius: 3px;\n    padding: 12px 0 13px;\n    display: block;\n    width: 80%;\n    margin: 0px auto 10px;\n    color: #fff;\n}\n.video-player-wrapper .tooltipBox[data-v-2d26e445] {\n    width: 100%;\n    text-align: center;\n    padding-bottom: 10px;\n    height: 35px;\n    margin-top: 24px;\n}\n.row.morevediosrow img[data-v-2d26e445] {\n    max-width: 100%;\n}\n.clearfix[data-v-2d26e445] {\n    clear: both;\n}\n.gap[data-v-2d26e445] {\n    height: 30px;\n}\nh3.pinkheading[data-v-2d26e445] {\n    color: #f0617d;\n    font-size: 28px;\n    letter-spacing: 2px;\n    margin: 10px 0 20px;\n}\nul.pinkheading li  a[data-v-2d26e445] {\n}\nul.pinkheading li[data-v-2d26e445] {\n    margin: 5px 0 5px;\n}\nul.pinkheading[data-v-2d26e445] {\n    margin: 0;\n    padding: 0;\n    font-size: 19px;\n    font-weight: 900;\n    list-style: none;\n}\n/*.row.morevediosrow > div:after {*/\n    /*content: \"\\f04b\";*/\n    /*font-family: fontawesome;*/\n    /*position: absolute;*/\n    /*top: 50%;*/\n    /*left: 50%;*/\n    /*transform: translateX(-50%) translateY(-50%);*/\n    /*color: rgba(255, 255, 255, 0.75);*/\n    /*font-size: 78px;*/\n    /*height: 120px;*/\n    /*width: 120px;*/\n    /*line-height: 107px;*/\n    /*border: 5px solid;*/\n    /*border-radius: 50%;*/\n    /*text-align: center;*/\n    /*padding-left: 22px;*/\n    /*cursor: pointer;*/\n/*}*/\n@media (min-width:768px) {\n.video-player .right-video-icons .enjoy-hover-box[data-v-2d26e445] {\n        padding: 117px 0px 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating[data-v-2d26e445] {\n        overflow: hidden;\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating p[data-v-2d26e445] {\n        color: white;\n        display: block;\n        font-size: 16px;\n        letter-spacing: 0.5px;\n        margin-top: 23px;\n        margin-bottom: 20px;\n        padding: 0 10%;\n        text-align: center;\n}\n}\n.video-player .right-video-icons .rate-hover-box span[data-v-2d26e445] {\n    margin-bottom: 20px;\n}\n.video-player .right-video-icons .rate-hover-box button[data-v-2d26e445]:hover {\n    background: #ac2925;\n}\n.video-player .btn-danger[data-v-2d26e445]:focus {\n    background: inherit;\n    border-color: inherit;\n    outline: none;\n}\n.video-player .right-video-icons div button.btn-danger[data-v-2d26e445]:hover{\n    background:rgba(0,0,0,0.1);\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-2d26e445]:hover{\n    background:#ac2925;\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-2d26e445]:focus{\n    color: #fff;\n    background-color: #ac2925;\n    border-color: #fff;\n}\n.profile-content img[data-v-2d26e445] {\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center center;\n       object-position: center center;\n}\n.video-player .left-video-icons[data-v-2d26e445] {\n    background: white;\n    color: white;\n    width: 15%;\n    float: left;\n    height: 100%;\n}\nh3.errormessage[data-v-2d26e445] {\n    color: #f0617d;\n    letter-spacing: 3px;\n    margin: 70px 20px;\n}\n@media(max-width:767px){\n.row.morevediosrow img[data-v-2d26e445] {\n        margin: 0 0 10px;\n}\n}\n.row.morevediosrow p.text-wrap-title.cursor[data-v-2d26e445] {\n    font-size: 20px;\n    text-align: left;\n    color: #000;\n}\n.container-icons > div > span[data-v-2d26e445] {\n    display: inline-block;\n    background: #f0617d;\n    height: 50px;\n    width: 50px;\n    color: #fff;\n    text-align: center;\n    line-height: 60px;\n    border-radius: 50%;\n}\np.text-wrap-title.cursor[data-v-2d26e445] {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\nh2.pink-text-headline[data-v-2d26e445] {\n    margin: 30px 0 30px;\n}\np.video-description[data-v-2d26e445] {\n    font-size: 23px;\n}\n.row.morevediosrow p.text-wrap-title.cursor[data-v-2d26e445] {\n    font-size: 20px;\n}\n.tabContent p.text-wrap-title.cursor[data-v-2d26e445] {\n    font-size: 17px;\n}\n", ""]);

// exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\nbody{\n    -ms-overflow-style:scrollbar;\n}\n.fixgraybgpl .video-player .left-video-icons{background:transparent;\n}\n@media(max-width:992px) {\n.side-content pre {\n        overflow: scroll;\n        white-space: pre-wrap;\n}\n.fixgraybgpl .video-player .jwplayer.jw-flag-aspect-mode {\n        height: auto !important;\n}\n}\n/*@media (max-width: 991px) and (min-width: 320px){\n    .fixgraybgpl .video-player .reset-video-width {\n        max-width:85%;\n    }\n}*/\n", ""]);

// exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.video-player-wrapper .watch-again .current-video-img img[data-v-2dc49f94] {\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.video-player .right-video-icons .enjoy-hover-box[data-v-2dc49f94] {\n    width: 20%;\n    height: 100%;\n    background: #f0617d;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 15% 0px 0;\n    text-align: left;\n}\n.video-player .right-video-icons .enjoy-hover-box button.btn[data-v-2dc49f94] {\n    margin: 0 0 10px;\n    border-color: white;\n    border-radius: 3px;\n    padding: 12px 0 13px;\n    display: block;\n    width: 80%;\n    margin: 0px auto 10px;\n    color: #fff;\n}\n.video-player-wrapper .tooltipBox[data-v-2dc49f94] {\n    width: 100%;\n    text-align: center;\n    padding-bottom: 10px;\n    height: 35px;\n    margin-top: 24px;\n}\n@media (min-width:768px) {\n.video-player .right-video-icons .enjoy-hover-box[data-v-2dc49f94] {\n        padding: 117px 0px 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating[data-v-2dc49f94] {\n        overflow: hidden;\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating p[data-v-2dc49f94] {\n        color: white;\n        display: block;\n        font-size: 16px;\n        letter-spacing: 0.5px;\n        margin-top: 23px;\n        margin-bottom: 20px;\n        padding: 0 10%;\n        text-align: center;\n}\n}\n.video-player .right-video-icons .rate-hover-box span[data-v-2dc49f94] {\n    margin-bottom: 20px;\n}\n.video-player .right-video-icons .rate-hover-box button[data-v-2dc49f94]:hover {\n    background: #ac2925;\n}\n.video-player .btn-danger[data-v-2dc49f94]:focus {\n    background: inherit;\n    border-color: inherit;\n    outline: none;\n}\n.video-player .right-video-icons div button.btn-danger[data-v-2dc49f94]:hover{\n    background:rgba(0,0,0,0.1);\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-2dc49f94]:hover{\n    background:#ac2925;\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-2dc49f94]:focus{\ncolor: #fff;\nbackground-color: #ac2925;\nborder-color: #fff;\n}\n.profile-content img[data-v-2dc49f94] {\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center center;\n       object-position: center center;\n}\n.playlistholderdiv[data-v-2dc49f94] {\n    width: 15%;\n    color: #fff;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 15px;\n    bottom: 0;\n    overflow-y: auto;\n}\n.playlistholderdiv img[data-v-2dc49f94] {\n    max-width: 100%;\n    margin: 0 0 10px;\n}\n.fixgraybgpl .video-player-background[data-v-2dc49f94] {\n    position: relative;\n}\n.playlistholderdiv h4[data-v-2dc49f94] {\n    font-size: 16px;\n}\n.playlistholderdiv p[data-v-2dc49f94] {\n    font-size: 14px !important;\n}\n.playlistentrydiv[data-v-2dc49f94] {\n    position: relative;\n}\n.playlistentrydiv.playing[data-v-2dc49f94]:after {\n    position: absolute;\n    right: 0;\n    text-align: center;\n    font-weight: 900;\n    text-shadow: 0 1px 3px rgba(0,0,0,0.75);\n    content: \"\";\n    height: 0;\n    width: 0;\n    border: 10px solid transparent;\n    top: 2px;\n    border-left-color: #f0617d;\n    transform: translateY(-0%);\n    left: 2px;\n}\n.playlistentrydiv.playingMobile[data-v-2dc49f94]:after {\n    position: absolute;\n    right: 0;\n    text-align: center;\n    font-weight: 900;\n    text-shadow: 0 1px 3px rgba(0,0,0,0.75);\n    content: \"\";\n    height: 0;\n    width: 0;\n    border: 10px solid transparent;\n    top: 2px;\n    border-left-color: #f0617d;\n    transform: translateY(-0%);\n    left: 2px;\n}\n@media(max-width:992px) {\n.playlistholderdiv[data-v-2dc49f94] {\n        width: 100%;\n        position: static;\n}\n.playlistholderdiv img[data-v-2dc49f94] {\n        width: 100px;\n        float: left;\n        margin: 0px 15px 15px 0;\n}\n.playlistentrydiv[data-v-2dc49f94] {\n        overflow: hidden;\n        text-align: left;\n        border-bottom: 1px solid #666;\n        margin: 0 0 15px;\n}\ndiv:last-of-type > .playlistentrydiv[data-v-2dc49f94] {\n        margin: 0;\n        border-bottom: 0 none transparent;\n}\ndiv:last-of-type > .playlistentrydiv img[data-v-2dc49f94] {\n        margin-bottom: 0;\n}\n}\n/*Changes for Corporate Modal*/\n.sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader[data-v-2dc49f94] {\n    background: #f0617d;\n    color: #fff;\n    font-size: 25px;\n    text-align: left;\n    padding: 15px 25px;\n    font-weight: 700;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body p[data-v-2dc49f94]{\n    padding: 0;\n    margin: 0 0 20px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-2dc49f94] {\n    background: #fff;\n    color: #333;\n    border: 1px solid #cacaca;\n    width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body[data-v-2dc49f94] {\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink[data-v-2dc49f94] {\n    background: #f0617d;\n    width: 100%;\n    margin: 0;\n    border: 1px solid #f0617d;\n}\n@media(max-width:475px){\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-2dc49f94] {\n        padding-left: 0;\n        padding-right: 0;\n}\n}\n.row.sharefb[data-v-2dc49f94] {\n    background: #eee;\n    margin-left: 0;\n    margin-right: 0;\n}\n.row.sharefb > div[data-v-2dc49f94] {\n    padding: 5px;\n    text-align: left;\n}\n.row.sharefb .col-sm-5 img[data-v-2dc49f94] {\n    max-width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-2dc49f94] {\n    font-size: 14px;\n    font-weight: 300;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6[data-v-2dc49f94] {\n    text-transform: uppercase;\n    font-size: 12px;\n    margin: 10px 0 5px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4[data-v-2dc49f94] {\n    margin: 0 0 5px;\n    font-weight:700;\n}\n.showmobile[data-v-2dc49f94]{display:none;\n}\n@media(max-width:767px){\n.usernamenimg.text-left[data-v-2dc49f94] {\n        display: none;\n}\n.showmobile[data-v-2dc49f94]{\n        display: block;\n}\n.alert.alert-default[data-v-2dc49f94] {\n        background: #eee;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-2dc49f94] {\n        display: none;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow[data-v-2dc49f94] {\n        top: 1px;\n        right: -13px;\n}\n.row.sharefb[data-v-2dc49f94] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.pinksidebarmin[data-v-2dc49f94]{\n        padding:0 !important;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        -ms-flex-preferred-size: auto;\n            flex-basis: auto;\n        display: flex ;\n        -ms-flex-align: stretch ;\n            align-items: stretch ;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.pinksidebarmin > *[data-v-2dc49f94] {\n        padding: 6px 0 !important;\n        margin: 0 !important;\n        -ms-flex: 100;\n            flex: 100;\n        text-align:center;\n}\n}\n.watchVideoModal .modal-dialog .modal-body p[data-v-2dc49f94] {\n    padding: 16px 60px 19px 60px;\n}\n.modal[data-v-2dc49f94] {\n    z-index: 999999;\n}\n", ""]);

// exports


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.JWvideoHandler>button.pink-button[data-v-2f3b14a2] {\n    position: absolute;\n    z-index: 100;\n    bottom: 60px;\n    left: 50%;\n    transform: translateX(-50%);\n    color: white;\n    font-size: 16px;\n    border: none;\n    width: 253px;\n    padding: 14px 15px 12px;\n    border-radius: 3px;\n    background: rgb(240, 97, 125) !important;\n    text-transform: uppercase !important;\n    letter-spacing: 1px !important;\n}\n.JWvideoHandler[data-v-2f3b14a2] {\n    position: relative;\n}\n.jwplayer.jw-flag-fullscreen+button[data-v-2f3b14a2] {\n    position: fixed;\n    z-index: 999999999999999999;\n}\n@media(max-width:1024px) {\n.JWvideoHandler[data-v-2f3b14a2] {\n        width: 100%;\n        display: table;\n}\n}\n@media(max-width:767px){\n.JWvideoHandler>button.pink-button[data-v-2f3b14a2] {\n        font-size: 14px;\n        border: none;\n        width: auto;\n        padding: 8px 10px 5px;\n}\n}\n.fade-enter-active[data-v-2f3b14a2], .fade-leave-active[data-v-2f3b14a2] {\n    transition: opacity 1s;\n}\n.fade-enter[data-v-2f3b14a2], .fade-leave-to[data-v-2f3b14a2] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\n@media(min-width:1350px){\n.JWvideoHandler>button.pink-button[data-v-2f3b14a2]{\n        bottom:15%;\n}\n}\n/* #master-wrapper {*/\n/*     display: flex;*/\n/*     flex-direction: row;*/\n/*     justify-content: center;*/\n/* }*/\n/*#playlist {*/\n/*    width: 360px;*/\n/*    height: 360px;*/\n/*    background-color: black;*/\n/*    overflow: scroll;*/\n/*}*/\n/*.playlist-item {*/\n/*    width: calc(100% - 20px);*/\n/*    height: auto;*/\n/*    display: flex;*/\n/*    flex-direction: row;*/\n/*    align-items: center;*/\n/*    justify-content: flex-start;*/\n/*    font-family: sans-serif;*/\n/*    color: white;*/\n/*    padding: 5px 10px;*/\n/*    cursor: pointer;*/\n/*}*/\n/*.playlist-item img {*/\n/*    height: 100px;*/\n/*    display: inline-block;*/\n/*    margin-right: 10px;*/\n/*}*/\n", ""]);

// exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.signUp .left-content h4[data-v-304dffb6] {\n    letter-spacing: 1px;\n}\n.stripeholder[data-v-304dffb6] {\n    position: relative;\n}\ni.fa.fa-lock.overlapstripe[data-v-304dffb6] {\n    position: absolute;\n    left: 18px;\n    top: 10px;\n    font-size: 18px;\n    color: #b2b8c7;\n}\n.codediv[data-v-304dffb6] {\n    padding: 10px 0 0;\n}\n.codediv + .row.code[data-v-304dffb6] {\n    padding-top: 0;\n}\n.stripeholder[data-v-304dffb6] {\n}\n.codediv .stripeholder[data-v-304dffb6] {\n    margin-bottom: 20px;\n}\n.codediv .col-md-12[data-v-304dffb6] {\n    min-height: 0;\n}\n.StripeElement[data-v-304dffb6] {\n    background-color: white;\n    padding: 2em 1em;\n    border: 1px solid #ccc;\n    box-shadow: 0 1px 3px 0 #e6ebf1;\n    transition: box-shadow 150ms ease;\n    height: 34px;\n}\n.float-right.paymentswitch.btn-group[data-v-304dffb6] {\n    margin: 0 0 30px;\n}\n.StripeElement--focus[data-v-304dffb6] {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n}\n.StripeElement--invalid[data-v-304dffb6] {\n    border-color: #fa755a;\n}\n.StripeElement--webkit-autofill[data-v-304dffb6] {\n    background-color: #fefde5 !important;\n}\n.radiowrapper[data-v-304dffb6] {\n    padding: 0px;\n    color: #f0617d;\n}\n/* Media query for mobile viewport*/\n@media screen and (max-width: 400px) {\n#paypal-button-container[data-v-304dffb6] {\n        width: 100%;\n}\n}\n\n/*Media query for desktop viewport */\n@media screen and (min-width: 400px) {\n#paypal-button-container[data-v-304dffb6] {\n        width: 250px;\n        display: inline-block;\n}\n}\ntable[data-v-304dffb6] {\n    font-size: 12px;\n    letter-spacing: 0;\n    width:100%;\n}\ntable td[data-v-304dffb6] {\n    text-align: left;\n    padding: 12px;\n}\ntable th[data-v-304dffb6] {\n    text-align: left;\n    padding: 12px;\n    background: #f0617d;\n    color:#fff;\n}\nh2[data-v-304dffb6] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 45px 0 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n    text-align:center;\n}\ntr[data-v-304dffb6] {\n    border-bottom: 1px solid #ddd;\n}\nli.list-group-item[data-v-304dffb6] {\n    float: left;\n    width: 48%;\n    padding: 5px;\n    margin: 40px 1% 30px;\n    background-size: 100px !important;\n    border-radius: 0 !important;\n    height: auto;\n    background-color: #f9f9f9;\n    padding-top: 60px;\n}\nli.list-group-item[data-v-304dffb6]:before {\n    background-image: url(" + __webpack_require__(336) + ") !important;\n    float: left;\n    width: 100%;\n    padding: 2%;\n    background-size: contain !important;\n    border-radius: 0 !important;\n    background-color: transparent;\n    background-repeat: no-repeat;\n    background-position: center top;\n    border: 0 none transparent;\n    content: \"\";\n    position: absolute;\n    top: -43px;\n    height: 100px;\n}\nli h5[data-v-304dffb6] {letter-spacing: 1px;text-align: center;\n}\n.row.margin-top[data-v-304dffb6] {\n    margin-bottom: 80px;\n}\n.signUp .right-content .jumbotron[data-v-304dffb6] {\n    padding: 10px;\n}\n.signUp .left-content .panel-body .form-group[data-v-304dffb6] {\n    margin-bottom: 10px;\n}\n\n/*gift section classes*/\n.gift-item[data-v-304dffb6]:before {\n    background: url(" + __webpack_require__(76) + ");\n    content:\"\";\n    height: 150px;\n    display: block;\nposition: absolute;\n    background-position: center !important;\n    background-repeat: no-repeat !important;\n    transform: translateY(-50%);\ntop: 0;\n    right: 0;\n    left: 0;\n}\n.gift-item[data-v-304dffb6] {\n    background: #54d9ec;\n    color: #fff;\n    margin: 120px 0 0;\n    padding: 80px 20px 20px;\n    position: relative;\n    text-align: center;\n}\n.gift-item h5[data-v-304dffb6] {\n    font-size: 22px;\n}\n.gift-item h5 small[data-v-304dffb6] {\n    color: #fff;\n}\n.gift-item button[data-v-304dffb6] {\n    background: #0eb4ce;\n    border: 2px solid #13a8bf;\n    padding: 10px 25px;\n    margin: 10px 0;\n}\n.gifts.row[data-v-304dffb6] {\n    margin-bottom: 50px;\n}\nbutton.active[data-v-304dffb6] {\n    outline: 1px solid blue;\n}\ndiv#paypal-button[data-v-304dffb6] {\n    /*text-align: left;*/\n    margin: 0 12px !important;\n    position: relative;\n    top: -8px;\n}\n@media(min-width:768px){\n.col-md-8 .col-sm-6 .gift-item[data-v-304dffb6] {\n        padding: 40px 10px 10px;\n        margin: 50px 0 10px;\n}\n.col-md-8 .col-sm-6 .gift-item h5[data-v-304dffb6] {\n        font-size: 16px;\n}\n.col-md-8 .col-sm-6 .gift-item[data-v-304dffb6]:before {\n        height: 80px;\n        background-size: contain;\n}\n.col-md-8 .col-sm-6 .gift-item button[data-v-304dffb6] {\n        padding: 5px;\n}\nh4.margin-bot-20[data-v-304dffb6] {\n        margin: 0 0 70px !important;\n}\ninput#corporateUpload[data-v-304dffb6] {\n        margin: 0 0 100px;\n}\n}\n@media(min-width:320px) and (max-width:375px){\n    /*table  tr  td:nth-child(2) , table  tr  th:nth-child(2) {*/\n        /*display: none;*/\n    /*}*/\n\n    /*table  tr  td:nth-child(3) , table  tr  th:nth-child(3) {*/\n        /*display: none;*/\n    /*}*/\n}\n@media(min-width:376px) and (max-width:425px){\n\n    /*table  tr  td:nth-child(3) , table  tr  th:nth-child(3) {*/\n        /*display: none;*/\n    /*}*/\n}\n@media(min-width: 320px) and (max-width: 767px){\ntable  tr  th[data-v-304dffb6]{\n        white-space: nowrap;\n        font-size: 14px;\n}\ntable  tr  td[data-v-304dffb6]{\n        white-space: nowrap;\n        font-size: 14px;\n}\n}\n.col-md-8[data-v-304dffb6] {\n    width: 100%;\n}\n\n", ""]);

// exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\nspan.heading[data-v-30ce6f02] {\n        position: relative;\n        width: 100%;\n        display: block;\n        font-size: 19px;\n        font-weight: 500;\n        color: #a9a9a9;\n}\n.checkboxholder .radio[data-v-30ce6f02] {\n        text-align: center;\n        border: 1px solid #ddd;\n        padding: 10px;\n}\n.checkboxholder[data-v-30ce6f02] {\n}\n.checkboxholder .radio label[data-v-30ce6f02] {\n        padding: 0;\n        letter-spacing: 0;\n}\n.checkboxholder .radio label span[data-v-30ce6f02] {\n        display: block;\n}\n.checkboxholder .radio label input[data-v-30ce6f02] {\n        position: relative;\n        margin: 20px 0;\n}\nspan.footertext[data-v-30ce6f02] {\n        font-weight: 500;\n        color: #a9a9a9;\n}\nspan.plan-price[data-v-30ce6f02] {\n        font-size: 34px;\n        font-weight: 900;\n        color: #a9a9a9;\n}\n.radio.popular[data-v-30ce6f02]:before {\n        /*content: \"Your special 12 Month Plan will be reimbursed by NNI\";*/\n        position: absolute;\n        left: 0;\n        right: 0;\n        line-height: 1.3;\n        /*background: #f0617d;*/\n        color: black;\n        transform: translatey(-100%);\n        margin-top: -10px;\n        padding: 5px 0;\n}\n.checkboxholder[data-v-30ce6f02] {\n        /*padding-top: 30px;*/\n}\nspan.permonth[data-v-30ce6f02] {\n        display: block;\n        font-size: 14px;\n}\nspan.plan-price[data-v-30ce6f02] {\n        line-height: 1.2;\n        padding-top: 20px;\n}\n@media(min-width:768px){\n.radio.popular[data-v-30ce6f02] {\n            margin-top: 30px;\n}\n}\n@media(max-width:767px){\n.radio.popular[data-v-3a43d266][data-v-30ce6f02]:before {\n            position: absolute;\n            transform: translateY(-20px);\n}\n.radio.popular[data-v-30ce6f02] {\n            padding-top: 30px !important;\n}\n}\n.StripeElement[data-v-30ce6f02] {\n        background-color: white;\n        padding: 2em 1em;\n        border: 1px solid #ccc;\n        box-shadow: 0 1px 3px 0 #e6ebf1;\n        transition: box-shadow 150ms ease;\n        height: 34px;\n}\n.float-right.paymentswitch.btn-group[data-v-30ce6f02] {\n        margin: 0 0 30px;\n}\n.StripeElement--focus[data-v-30ce6f02] {\n        box-shadow: 0 1px 3px 0 #cfd7df;\n}\n.StripeElement--invalid[data-v-30ce6f02] {\n        border-color: #fa755a;\n}\n.StripeElement--webkit-autofill[data-v-30ce6f02] {\n        background-color: #fefde5 !important;\n}\n.radiowrapper[data-v-30ce6f02] {\n        padding: 0 0px 10px;\n        color: #f0617d;\n}\ndiv#paypal-button[data-v-30ce6f02] {\n    text-align: center;\n}\n.codediv[data-v-30ce6f02] {\n    padding: 10px 0 0;\n}\n.codediv + .row.code[data-v-30ce6f02] {\n    padding-top: 0;\n}\n@media(min-width:768px) {\n.row.code + label.terms-and-condition[data-v-30ce6f02] {\n        margin: 0;\n}\n}\n.stripeholder[data-v-30ce6f02] {\n}\n.codediv .stripeholder[data-v-30ce6f02] {\n    margin-bottom: 20px;\n}\n.codediv .col-md-12[data-v-30ce6f02] {\n    min-height: 0;\n}\n.showmobile[data-v-30ce6f02]{\n        display:none;\n}\n.stripeholder[data-v-30ce6f02] {\n        position: relative;\n}\ni.fa.fa-lock.overlapstripe[data-v-30ce6f02] {\n        position: absolute;\n        left: 18px;\n        top: 10px;\n        font-size: 18px;\n        color: #b2b8c7;\n}\nbutton.redeem.btn.formButton.btn-block[data-v-30ce6f02] {\n        margin: 0;\n}\n.row.code[data-v-30ce6f02] {\n        padding-top: 20px;\n}\n@media (max-width:767px){\n.hidemobile[data-v-30ce6f02]{\n            display:none;\n}\n.showmobile[data-v-30ce6f02]{\n            display:inherit;\n}\n.signUp .left-content h4[data-v-30ce6f02] {\n            font-size: 14px;\n            letter-spacing: 0px;\n}\n.signUp .main-content h2[data-v-30ce6f02] {\n            margin: 15px 0;\n            line-height: 20px;\n            font-size: 18px;\n}\n.signUp #signup_pwderrormsg[data-v-30ce6f02] {\n            margin-bottom: 8px;\n            line-height: 1.3;\n            letter-spacing: 1px;\n}\n.signUp .left-content .create-account #signup_button[data-v-30ce6f02] {\n            margin: 0;\n}\n.signUp .right-content .jumbotron[data-v-30ce6f02] {\n            padding: 6px;\n            margin-top: 7px;\n}\n.signUp .right-content .jumbotron h2[data-v-30ce6f02] {\n            margin: 0;\n            font-size: 21px;\n}\n.signUp .right-content .jumbotron p[data-v-30ce6f02] {\n            display: none;\n}\n.signUp .right-content .card[data-v-30ce6f02] {\n            padding: 10px 10px;\n}\n.signUp .right-content .card .card-block .list-group li[data-v-30ce6f02] {\n            font-size: 16px;\n            margin: 0 0 10px;\n}\n.signUp .left-content hr[data-v-30ce6f02] {\n            display: none;\n}\n.row.margin-top[data-v-30ce6f02] {\n            margin-top: 0px;\n}\ndiv#paypal-button[data-v-30ce6f02] {\n\t\t\ttext-align: center!important;\n\t\t\ttop: -3px;\n}\n.codediv .stripeholder[data-v-30ce6f02] {\n            margin-bottom: 10px;\n}\n}\n\n    /* Media query for mobile viewport */\n@media screen and (max-width: 400px) {\n#paypal-button-container[data-v-30ce6f02] {\n            width: 100%;\n}\n}\n\n    /* Media query for desktop viewport */\n@media screen and (min-width: 400px) {\n#paypal-button-container[data-v-30ce6f02] {\n            width: 250px;\n            display: inline-block;\n}\n}\nbutton.redeem.btn.formButton.btn-block[data-v-30ce6f02] {\n        letter-spacing: 0;\n}\n.checkboxholder[data-v-30ce6f02] {\n        /*padding-left: 30px;*/\n        padding-bottom: 10px;\n}\n.checkboxholder .checkbox[data-v-30ce6f02] {\n        font-size: 16px;\n        letter-spacing: 3px;\n        margin: 15px 0;\n}\n.redoutlinebox[data-v-30ce6f02] {\n        border: 2px solid #f0617d;\n        padding: 10px;\n        margin: 0px 0px 20px;\n        text-align: justify;\n}\n.checkboxholder .radio input[type=\"radio\"][data-v-30ce6f02] {\n        opacity:1;\n        z-index:20;\n        top: 2px;\n}\nbody .margin-top[data-v-30ce6f02] {\n        margin-top: 89px;\n        margin-bottom: 70px;\n}\nbody .signUp .right-content .card .card-block .list-group[data-v-30ce6f02]{\n        margin-bottom:0px;\n}\n", ""]);

// exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.spinner-gritcode.pink .spinner-circle {\n    border-right-color: #f0617d;\n}\n.spinner-gritcode.pink .spinner-text {\n    color: #f0617d;\n}\n.interest-container.work .btn.btn-default {\n    margin: 0 10px 30px;\n    border-radius: 10px !important;\n    border: 2px solid #f0617d;\n    padding: 10px 20px;\n    color: #333;\n    font-weight: bold;\n}\n.interest-container.work .btn.btn-default.active , .interest-container.work .btn.btn-default.active:hover {\n    background: #f0617d;\n    box-shadow: 0 0 0 transparent;\n    color: #fff;\n}\n.interest-container.work .btn-group {\n    text-align: center;\n}\n.interest-container.work .btn.btn-default {\n    float: none;\n}\n.interest-container.work .btn-group {\n    max-width: 1140px;\n}\n.interest-container.work .btn.btn-default:hover {\n    color: #f0617d;\n    background: #fff;\n    box-shadow: 0 0 0 transparent;\n}\n@media(max-width:768px){\n.interest-container.work .btn.btn-default {\n        width: 48%;\n        float: left;\n        margin: 1%;\n}\n}\n@media(max-width:479px){\n.interest-container.work .btn.btn-default {\n        width: 100%;\n        float: left;\n        margin: 1%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.text-wrap-title-1[data-v-32e87aa0] {\n    right: -14px;\n    position: absolute;\n    background-color: rgb(68, 189, 168) !important;\n    color: #fff !important;\n    font-size: 12px !important;\n    padding: 2px 4px !important;\n    border-top-left-radius: 4px !important;\n    line-height: 1.1 !important;\n}\n.align-to-bottom[data-v-32e87aa0] {\n    right: -13px !important;\n    top: -9px !important;\n}\n.jw-img-1[data-v-32e87aa0] {\n    max-width: 100%; /* Ensure the image does not exceed its container width */\n}\n.image-container[data-v-32e87aa0] {\n    position: relative;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n}\n.btn-group.plusicon[data-v-32e87aa0] {\n    position: absolute;\n    right: 50px;\n    bottom: 0px;\n    height: 29px;\n}\nli.divider[data-v-32e87aa0] {\n    border-bottom: 1px solid #ddd;\n    margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-32e87aa0] {\n    background: transparent;\n    border: 0 none transparent;\n    padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-32e87aa0]{\n    font-size: 21px;\n    top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-32e87aa0]{\n    padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-32e87aa0],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-32e87aa0] {\n    padding: 3px 15px;\n    margin-bottom: 5px;\n    display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-32e87aa0],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-32e87aa0] {\n    height: 30px;\n    padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-32e87aa0],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-32e87aa0] {\n    position: absolute;\n    top: 6px;\n    font-size:24px;\n    right:20px;\n    cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-32e87aa0],\nbutton.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-32e87aa0]{\n    position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-32e87aa0],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul[data-v-32e87aa0]{\n    left: 0;\n    right: auto;\n    width: 230px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    top: 100%;\n    position: absolute;\n    z-index: 5000;\n    list-style: none;\n    text-align: left;\n    padding: 15px;\n}\n.backdropformenu[data-v-32e87aa0]{\n    position:fixed;\n    z-index:4900;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-32e87aa0]{\n    height: 24px;\n    width: 37px;\n}\n.menuiconbutton[data-v-32e87aa0]{\n    height: 24px;\n    width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-32e87aa0] {\n        left: auto ;\n        right: 0;\n}\n.fade-enter-active[data-v-32e87aa0], .fade-leave-active[data-v-32e87aa0] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-32e87aa0], .fade-leave-to[data-v-32e87aa0] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-32e87aa0]{\n    font-size: 10px;\n}\nspan.removed[data-v-32e87aa0] {\n    color: red;\n}\nspan.added[data-v-32e87aa0] {\n    color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-32e87aa0] {\n    position: relative;\n    display:block;\n}\n.bolder[data-v-32e87aa0] {\n    font-size: 18px;\n    font-weight: 900;\n}\n@media(max-width:767px){\n.hidemobile[data-v-32e87aa0]{display:none;\n}\n}\n", ""]);

// exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.hello-page-wrapper .theme-bg-img .left-panel .container-icons span {\n    color:#343434;\n}\n@media(max-width:767px){\n.responsive-slick-charity-slider .slick-list {\n        width: 100%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.align-to-bottom[data-v-331b4fd3] {\n    //bottom: -10px !important;\n    right: 0px !important;\n}\n.jw-img-1[data-v-331b4fd3] {\n    max-width: 100%; /* Ensure the image does not exceed its container width */\n}\n.image-container[data-v-331b4fd3] {\n    position: relative;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n}\n.postion-title[data-v-331b4fd3]{\n    position: absolute;\n    bottom: 8px;\n}\n.text-wrap-title-1[data-v-331b4fd3] {\n    right: -14px;\n    position: absolute;\n    background-color: rgb(68, 189, 168) !important;\n    color: #fff;\n    padding: 2px 4px;\n    font-size: 12px;\n    border-top-left-radius: 4px;\n    line-height: 1.1 !important;\n}\n.recent-style[data-v-331b4fd3] {\n    top: 60px !important;\n}\n.slick-slide img[data-v-331b4fd3] {\n    width: 100%;\n    /*height: 200px;*/\n    -o-object-fit: contain;\n       object-fit: contain;\n    margin-top:70px;\n    margin-bottom:70px;\n}\n@media(max-width:992px){\n.slick-slide img[data-v-331b4fd3] {\n        margin: 10px 0;\n}\n}\n.funnies-img img[data-v-331b4fd3]{\n    width: auto;\n    margin: 0 auto;\n    -o-object-fit: contain;\n       object-fit: contain;\n}\n.funnies-img.smallslide>img[data-v-331b4fd3] {\n    height: 380px;\n}\n.newcontentloaded[data-v-331b4fd3] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 7px 0 25px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n    font-size: 30px;\n}\n.funnies-img.smallslide>img.bgimgfunny[data-v-331b4fd3] {\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.hello-page-wrapper .recently-watched[data-v-331b4fd3] {\n    margin-bottom: 50px;\n}\n@media (min-width:768px) {\n.hello-page-wrapper .recently-watched .jw-img[data-v-331b4fd3] {\n        MARGIN-TOP: 0;\n        margin-bottom: 0;\n}\n}\n@media(max-width:767px){\n.funnies-img.smallslide>img.bgimgfunny[data-v-331b4fd3] {\n        display:none;\n}\n}\n.hello-page-wrapper .random .blog-section .panel i.fa.fa-play-circle-o[data-v-331b4fd3] {\n    position: static;\n    color:#666;\n    height: auto !important;\n    width: auto !important;\n}\n.hello-page-wrapper .random .blog-section .panel[data-v-331b4fd3] {\n    text-align: left;\n}\n.hello-page-wrapper .expert-section .experts[data-v-331b4fd3] {\n    margin-top: 0em;\n}\n.experts.teal[data-v-331b4fd3] {\n    background-color: teal;\n    color: #fff;\n    padding: 20px;\n    text-align: center;\n}\n.experts.teal h2[data-v-331b4fd3] {\n    color: #fff;\n    text-align: center;\n}\n.hello-page-wrapper .expert-section .experts.teal p[data-v-331b4fd3] {\n    color: #fff;\n    text-align: center;\n    line-height: 1.3;\n}\n.hello-page-wrapper .main-content hr[data-v-331b4fd3]{\n    float:left;\n}\n.hello-page-wrapper .main-content hr+span[data-v-331b4fd3]{\n    display:block;\n    clear:both;\n}\n.btn-group.plusicon[data-v-331b4fd3] {\n    position: absolute;\n    left: 15px;\n    bottom: -35px;\n    height: 29px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right i[data-v-331b4fd3] {\n    color: #333;\n}\n.random-section-head .btn-group.plusicon[data-v-331b4fd3] {\n    left: auto;\n    right: 50px;\n    bottom: -32px;\n}\nli.divider[data-v-331b4fd3] {\n    border-bottom: 1px solid #ddd;\n    margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-331b4fd3] {\n    background: transparent;\n    border: 0 none transparent;\n    padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-331b4fd3]{\n    font-size: 21px;\n    top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-331b4fd3]{\n    padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-331b4fd3],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-331b4fd3] {\n    padding: 3px 0px;\n    margin-bottom: 5px;\n    display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-331b4fd3],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-331b4fd3] {\n    height: 30px;\n    padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-331b4fd3],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-331b4fd3] {\n    position: absolute;\n    top: 6px;\n    font-size: 24px;\n    right: 7px;\n    cursor: pointer;\n    height: auto !important;\n    width: auto !important;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-331b4fd3],\nbutton.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-331b4fd3]{\n    position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-331b4fd3] {\n    margin: 0;\n}\n.slick-slide button.dropdown-toggle.ellipsis.pull-right+ ul[data-v-331b4fd3] {\n    overflow-y: auto;\n    max-height: 250px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-331b4fd3],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul[data-v-331b4fd3]{\n    left: 0;\n    right: auto;\n    width: 230px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    top: 100%;\n    position: absolute;\n    z-index: 5000;\n    list-style: none;\n    text-align: left;\n    padding: 15px;\n}\n.backdropformenu[data-v-331b4fd3]{\n    position:fixed;\n    z-index:4900;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    background: transparent;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-331b4fd3] {\n    left: auto ;\n    right: 0;\n}\n.fade-enter-active[data-v-331b4fd3], .fade-leave-active[data-v-331b4fd3] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-331b4fd3], .fade-leave-to[data-v-331b4fd3] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-331b4fd3]{\n    font-size: 10px;\n}\nspan.removed[data-v-331b4fd3] {\n    color: red;\n}\nspan.added[data-v-331b4fd3] {\n    color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-331b4fd3] {\n    position: relative;\n    display:block;\n}\n.fade-enter-active[data-v-331b4fd3], .fade-leave-active[data-v-331b4fd3] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-331b4fd3], .fade-leave-to[data-v-331b4fd3] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-331b4fd3]{\n    font-size: 10px;\n}\nspan.removed[data-v-331b4fd3] {\n    color: red;\n}\nspan.added[data-v-331b4fd3] {\n    color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-331b4fd3] {\n    position: relative;\n    display:block;\n}\n.hello-page-wrapper .random .blog-section .panel label.notificationwithcheckboxes span[data-v-331b4fd3] {\n    font-size: 10px;\n    position: static;\n}\n.imgbalnace .col-md-6 img[data-v-331b4fd3] {\n    margin: 0;\n}\n.imgbalnace .col-md-6[data-v-331b4fd3]{\n    padding-top:70px;\n}\nsection.applicationdownload[data-v-331b4fd3] {\n    padding: 300px 20px 30px;\n    background-image: url(https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/app-image-resized-new.png);\n    background-size: cover;\n    background-position: center;\n    position: relative;\n}\nsection.applicationdownload img.showmobile[data-v-331b4fd3] {\n    display: none;\n}\nsection.applicationdownload b[data-v-331b4fd3] {\n    color: #fff;\n}\nsection.applicationdownload[data-v-331b4fd3]:after {\n    content: \"\";\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.35);\n}\nsection.applicationdownload>*[data-v-331b4fd3] {\n    position: relative;\n    z-index: 1;\n}\nsection.applicationdownload h2[data-v-331b4fd3] {\n    font-family: Zilla Slab,serif;\n    font-size: 45px!important;\n    font-style: normal;\n    margin: 0 0 140px;\n}\nsection.applicationdownload .appbtn[data-v-331b4fd3] {\n    max-width: 220px;\n    margin: 0 25px;\n}\n@media(max-width:768px) {\nsection.applicationdownload .appbtn[data-v-331b4fd3] {\n        max-width: 220px;\n        margin: 0 10px;\n}\nsection.applicationdownload img.showmobile[data-v-331b4fd3] {\n        display: block;\n        width: 100%;\n}\nsection.applicationdownload[data-v-331b4fd3] {\n        padding: 0 0 50px;\n        background: #fff;\n}\nsection.applicationdownload h2[data-v-331b4fd3] {\n        margin: 40px 0;\n        color: #000;\n        padding: 0 20px;\n}\nsection.applicationdownload[data-v-331b4fd3]:after {\n        display: none;\n}\nsection.applicationdownload h2 b[data-v-331b4fd3] {\n        color: #000;\n        font-size: 34px !important;\n}\n}\n@media(max-width:767px){\np.right-heart-icon[data-v-331b4fd3] {\n        margin-bottom: 37px;\n}\n.random-section-head .btn-group.plusicon[data-v-331b4fd3]{\n        bottom: -40px;\n}\n.slick-slider[data-v-331b4fd3] {\n        margin-bottom: 70px;\n}\n.funnies-img.smallslide>img[data-v-331b4fd3] {\n        max-width: 100%;\n}\n}\n.showMobile[data-v-331b4fd3] {\n    display: none;\n}\n@media(max-width:767px){\n.hidemobile[data-v-331b4fd3] {\n        display: none !important;\n}\n.showMobile[data-v-331b4fd3] {\n        display: block;\n}\n}\n.theme-bg-img[data-v-331b4fd3] {\n    background-color: #f4f4f4;\n    background-image: none !important;\n    color: #000;\n}\n.hello-page-wrapper .theme-bg-img .main-content h2[data-v-331b4fd3] {\n    color: #000;\n}\n.coloredpannel[data-v-331b4fd3] {\n    padding: 20px 20px 0px;\n}\n.hello-page-wrapper .left-panel .high-lighter[data-v-331b4fd3] {\n    background: none;\n    color: #343434;\n}\n.hello-page-wrapper .left-panel i.fa[data-v-331b4fd3] {\n    color: #adadad !important;\n}\n.hello-page-wrapper .left-panel i.fa.fa-play-circle-o[data-v-331b4fd3] {\n    color: #000 !important;\n}\n.hello-page-wrapper .left-panel h4[data-v-331b4fd3] {\n    color: #8e8e8e;\n    margin: 0 0 50px;\n}\n.hello-page-wrapper .purple.theme-bg-img .main-content h2 b[data-v-331b4fd3] {\n    color: #93688e\n}\n.purple .coloredpannel[data-v-331b4fd3] {\n    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#93688e+0,ffffff+100 */\n    background: #93688e; /* Old browsers */ /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */\n    background: linear-gradient(to bottom,  #93688e 0%,#ffffff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#93688e', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */\n}\n.hello-page-wrapper .theme-bg-img.purple .right-panel .interest-mood[data-v-331b4fd3] {\n    background-color: #93688e\n}\n.hello-page-wrapper .orange.theme-bg-img .main-content h2 b[data-v-331b4fd3] {\n    color: #faa51e\n}\n.orange .coloredpannel[data-v-331b4fd3] {\n    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#faa51e+0,ffffff+100 */\n    background: #faa51e; /* Old browsers */ /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */\n    background: linear-gradient(to bottom,  #faa51e 0%,#ffffff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#faa51e', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */\n}\n.hello-page-wrapper .theme-bg-img.orange .right-panel .interest-mood[data-v-331b4fd3] {\n    background-color: #faa51e\n}\n.hello-page-wrapper .teal.theme-bg-img .main-content h2 b[data-v-331b4fd3] {\n    color: #44bda8\n}\n.teal .coloredpannel[data-v-331b4fd3] {\n    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#44bda8+0,ffffff+100 */\n    background: #44bda8; /* Old browsers */ /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */\n    background: linear-gradient(to bottom,  #44bda8 0%,#ffffff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#44bda8', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */\n}\n.hello-page-wrapper .theme-bg-img.teal .right-panel .interest-mood[data-v-331b4fd3] {\n    background-color: #44bda8\n}\n.hello-page-wrapper .pink.theme-bg-img .main-content h2 b[data-v-331b4fd3] {\n    color: #f0617d\n}\n.pink .coloredpannel[data-v-331b4fd3] {\n    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#93688e+0,ffffff+100 */\n    background: #93688e; /* Old browsers */ /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */\n    background: linear-gradient(to bottom,  #f0617d 0%,#ffffff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f0617d', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */\n}\n.hello-page-wrapper .theme-bg-img.pink .right-panel .interest-mood[data-v-331b4fd3] {\n    background-color: #f0617d\n}\n.shadowdrop[data-v-331b4fd3] {\n    box-shadow: 0 11px 15px rgba(0,0,0, 0.25);\n}\n.questions-content[data-v-331b4fd3] {\n    background: white;\n    color: #fff;\n    border: 1px solid #ddd;\n}\n.hello-page-wrapper .main-content hr[data-v-331b4fd3] {\n    border-color: #343434;\n}\nbutton.share-event[data-v-331b4fd3] {\n    color: rgb(240, 97, 125) !important;\n    border: 1px solid rgb(240, 97, 125) !important;\n    background-image: none !important;\n    font-weight: 600;\n    line-height: 100%;\n    background: #fff !important;\n    font-size: 15px !important;\n    text-decoration: none;\n    border-radius: 3px !important;\n    cursor: pointer;\n    -webkit-font-smoothing: antialiased!important;\n    outline-color: rgba(0,78,255,0.5) !important;\n    text-shadow: 1px 1px 1px rgb(0 0 0 / 0%);\n    display: inline-block;\n    position: relative;\n    /*z-index: 99998;*/\n    font-family: \"Open Sans\",Roboto,\"Helvetica Neue\",Helvetica,Optima,Segoe,\"Segoe UI\",Candara,Calibri,Arial,sans-serif !important;\n    padding: 12px 12px 12px 12px !important;\n    margin-left: 10px !important;\n    width: 173px !important;\n    display: inline-block;\n    float: left !important;\n    box-shadow: 0 0 0 0.5px rgba(50,50,93,.17), 0 2px 5px 0 rgba(50,50,93,.1), 0 1px 1.5px 0 rgba(0,0,0,.07), 0 1px 2px 0 rgba(0,0,0,.08), 0 0 0 0 transparent!important;\n}\n.addeventatc.pinkoutlinebtn[data-v-331b4fd3] {\n    float: left;\n}\n/*.slick-slide .addeventatc.pinkoutlinebtn {*/\n/*    padding: 13px 12px 12px 37px !important;*/\n/*}*/\n\n/*.slick-slide button.share-event {*/\n/*    width: auto !important;*/\n/*    margin: 10px;*/\n/*}*/\n@media(max-width:991px){\n.addeventatc.pinkoutlinebtn[data-v-331b4fd3]{\n        margin-left:0 !important;\n        margin-right:10px;\n        margin-bottom:10px;\n}\nbutton.share-event[data-v-331b4fd3]{\n        margin-left:0 !important;\n}\n}\n@media(max-width:767px){\n.addeventatc.pinkoutlinebtn[data-v-331b4fd3]{margin-left:10px !important;\n}\nbutton.share-event[data-v-331b4fd3]{\n        margin-left:5px !important;\n}\n}\n@media(max-width:991px){\n.addeventatc.pinkoutlinebtn[data-v-331b4fd3]{\n        margin-left:0 !important;\n        margin-right:10px;\n        margin-bottom:10px;\n}\nbutton.share-event[data-v-331b4fd3]{\n        margin-left:0 !important;\n}\n}\n@media(max-width:767px){\n.addeventatc.pinkoutlinebtn[data-v-331b4fd3]{\n        margin-left:0px !important;\n}\nbutton.share-event[data-v-331b4fd3]{\n        margin-left:0px !important;\n}\n}\n@media(max-width:991px){\n.addeventatc.pinkoutlinebtn[data-v-331b4fd3]{\n        margin-left:0 !important;\n        margin-right:10px;\n        margin-bottom:10px;\n}\nbutton.share-event[data-v-331b4fd3]{\n        margin-left:0 !important;\n}\n}\n@media(max-width:767px){\n.addeventatc.pinkoutlinebtn[data-v-331b4fd3]{\n        margin-left:0px !important;\n}\nbutton.share-event[data-v-331b4fd3]{\n        margin-left:0px !important;\n}\n}\n/*Changes for Corporate Modal*/\n.sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader[data-v-331b4fd3] {\n    background: #f0617d;\n    color: #fff;\n    font-size: 25px;\n    text-align: left;\n    padding: 15px 25px;\n    font-weight: 700;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body p[data-v-331b4fd3]{\n    padding: 0;\n    margin: 0 0 20px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-331b4fd3] {\n    background: #fff;\n    color: #333;\n    border: 1px solid #cacaca;\n    width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body[data-v-331b4fd3] {\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink[data-v-331b4fd3] {\n    background: #f0617d;\n    width: 100%;\n    margin: 0;\n    border: 1px solid #f0617d;\n}\n@media(max-width:475px){\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-331b4fd3] {\n        padding-left: 0;\n        padding-right: 0;\n}\n}\n.row.sharefb[data-v-331b4fd3] {\n    background: #eee;\n    margin-left: 0;\n    margin-right: 0;\n}\n.row.sharefb > div[data-v-331b4fd3] {\n    padding: 5px;\n    text-align: left;\n}\n.row.sharefb .col-sm-5 img[data-v-331b4fd3] {\n    max-width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-331b4fd3] {\n    font-size: 14px;\n    font-weight: 300;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6[data-v-331b4fd3] {\n    text-transform: uppercase;\n    font-size: 12px;\n    margin: 10px 0 5px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4[data-v-331b4fd3] {\n    margin: 0 0 5px;\n    font-weight:700;\n}\n.showmobile[data-v-331b4fd3]{display:none;\n}\n@media(max-width:767px){\n.usernamenimg.text-left[data-v-331b4fd3] {\n        display: none;\n}\n.showmobile[data-v-331b4fd3]{\n        display: block;\n}\n.alert.alert-default[data-v-331b4fd3] {\n        background: #eee;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-331b4fd3] {\n        display: none;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow[data-v-331b4fd3] {\n        top: 1px;\n        right: -13px;\n}\n.row.sharefb[data-v-331b4fd3] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.pinksidebarmin[data-v-331b4fd3]{\n        padding:0 !important;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        -ms-flex-preferred-size: auto;\n            flex-basis: auto;\n        display: flex ;\n        -ms-flex-align: stretch ;\n            align-items: stretch ;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.pinksidebarmin > *[data-v-331b4fd3] {\n        padding: 6px 0 !important;\n        margin: 0 !important;\n        -ms-flex: 100;\n            flex: 100;\n        text-align:center;\n}\n}\n.watchVideoModal .modal-dialog .modal-body p[data-v-331b4fd3] {\n    padding: 16px 60px 19px 60px;\n}\n.modal[data-v-331b4fd3] {\n    z-index: 999999;\n}\n.addeventatc[data-v-331b4fd3] {\n    padding: 12px 12px 12px 37px !important;\n}\n", ""]);

// exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.set-error[data-v-36e0590c]{\n    border-color: #a94442 !important;\n    color:#a94442 !important;\n}\n.StripeElement[data-v-36e0590c] {\n    background-color: white;\n    padding: 2em 1em;\n    border: 1px solid #ccc;\n    box-shadow: 0 1px 3px 0 #e6ebf1;\n    transition: box-shadow 150ms ease;\n    height: 34px;\n}\n.float-right.paymentswitch.btn-group[data-v-36e0590c] {\n    margin: 0 0 30px;\n}\n.StripeElement--focus[data-v-36e0590c] {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n}\n.StripeElement--invalid[data-v-36e0590c] {\n    border-color: #fa755a;\n}\n.StripeElement--webkit-autofill[data-v-36e0590c] {\n    background-color: #fefde5 !important;\n}\n.radiowrapper[data-v-36e0590c] {\n    padding: 0 35px 35px;\n    color: #f0617d;\n}\n.showmobile[data-v-36e0590c]{\n    display:none;\n}\n.stripeholder[data-v-36e0590c] {\n    position: relative;\n}\ni.fa.fa-lock.overlapstripe[data-v-36e0590c] {\n    position: absolute;\n    left: 18px;\n    top: 10px;\n    font-size: 18px;\n    color: #b2b8c7;\n}\n@media (max-width:767px){\n.hidemobile[data-v-36e0590c]{\n        display:none;\n}\n.showmobile[data-v-36e0590c]{\n        display:inherit;\n}\n.signUp .left-content h4[data-v-36e0590c] {\n        font-size: 14px;\n        letter-spacing: 0px;\n}\n.signUp .main-content h2[data-v-36e0590c] {\n        margin: 15px 0;\n        line-height: 20px;\n        font-size: 18px;\n}\n.signUp #redeem_pwderrormsg[data-v-36e0590c] {\n        margin-bottom: 8px;\n        line-height: 1.3;\n        letter-spacing: 1px;\n}\n.signUp .left-content .create-account #redeem_button[data-v-36e0590c] {\n        margin: 0;\n}\n.signUp .right-content .jumbotron[data-v-36e0590c] {\n        padding: 6px;\n        margin-top: 7px;\n}\n.signUp .right-content .jumbotron h2[data-v-36e0590c] {\n        margin: 0;\n        font-size: 21px;\n}\n.signUp .right-content .jumbotron p[data-v-36e0590c] {\n        display: none;\n}\n.signUp .right-content .card[data-v-36e0590c] {\n        padding: 10px 10px;\n}\n.signUp .right-content .card .card-block .list-group li[data-v-36e0590c] {\n        font-size: 16px;\n        margin: 0 0 10px;\n}\n.signUp .left-content hr[data-v-36e0590c] {\n        display: none;\n}\n.row.margin-top[data-v-36e0590c] {\n        margin-top: 0px;\n}\n}\n\n/* Media query for mobile viewport */\n@media screen and (max-width: 400px) {\n#paypal-button-container[data-v-36e0590c] {\n        width: 100%;\n}\n}\n\n/* Media query for desktop viewport */\n@media screen and (min-width: 400px) {\n#paypal-button-container[data-v-36e0590c] {\n        width: 250px;\n        display: inline-block;\n}\n}\nbody .margin-top[data-v-36e0590c] {\n    margin-top: 89px;\n    margin-bottom: 70px;\n}\nbody .signUp .right-content .card .card-block .list-group[data-v-36e0590c]{\n    margin-bottom:0px;\n}\n", ""]);

// exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.main-content.emailrules {\n        max-width: 767px;\n        margin: auto;\n}\n.main-content.emailrules label.open.checkbox.default {\n        font-size: 24px;\n        text-align: left;\n        padding-left: 30px;\n}\n.main-content.emailrules \tlabel.checkbox > span.icon.dropdown-toggle.bg {\n        margin-top: 4px;\n        width: 2rem;\n        height: 2rem;\n        background: white;\n        border: 2px solid #ddd;\n}\n.main-content.emailrules label.checkbox.active > .icon {\n        margin-top: 7px;\n        background-position: center !important;\n        width: 20px;\n}\nstrong {\n}\n.main-content.emailrules button.btn.formButton.btn-block {\nborder-radius: 8px;\nmax-width: 200px;\nmargin: 30px;\n}\n.main-content.emailrules h2.heading + h2 {\ntext-align: left;\npadding: 10px 30px;\n}\n", ""]);

// exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.center[data-v-3710880a] {\n}\n.margin-left[data-v-3710880a] {\n    margin-left: 30px;\n}\n.bg-white[data-v-3710880a] {\n    background-color: white;\n}\n.checkboxcontent[data-v-3710880a] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n.checkboxcontent strong[data-v-3710880a] {\n    font-weight: 600 !important;\n}\n.smpreferences[data-v-3710880a] {\n    padding-left: 50px;\n}\n.smpreferences small[data-v-3710880a] {\n    font-weight: 500 !important;\n}\n.validate .form[data-v-3710880a]{\n    text-align: left;\n    width: 40%;\n    margin: 50px auto;\n}\nh2.heading[data-v-3710880a] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 47px 0 35px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n    font-size: 30px;\n}\n.validate h1[data-v-3710880a]{\n    font-size: 32px;\n    color: #009cf6;\n    font-weight: lighter;\n    margin: 0 0 25px 0;\n}\n.validate p[data-v-3710880a]{\n    font-size: 14px;\n    color: #979797;\n    margin: 0;\n}\n.padding-minus[data-v-3710880a]{\n    padding:0;\n}\n.validate .form .form-input[data-v-3710880a]{\n    margin-bottom: 25px ;\n}\n.validate .form .forgotPassword[data-v-3710880a]{\n    float: right;\n    color: black\n}\n.validate .form .forgotPassword[data-v-3710880a]:hover{\n    float: right;\n    color: #337ab7;\n}\n.formButton[data-v-3710880a]{\n    margin: 25px 0 50px;\n    width: 130px;\n    height: 47px;\n    color: black !important;\n    border: 1px solid black !important;\n    background-color: #ddd !important;\n    font-size: 22px !important;\n    font-weight: 600px !important;\n    margin-top: 44px !important;\n    margin-bottom: 40px !important;\n    max-width: 263px !important;\n    margin: 25px auto !important;\n    transition: 0.5s;\n    padding:14px 20px !important;\n}\nbutton.btn.formButton.btn-block[data-v-3710880a]:hover {\n    background: #f0617d !important;\n    color: white !important;\n}\n.formButton a[data-v-3710880a]{\n    display: block;\n    padding: 13px 12px;\n    color: #91ab45;\n    text-decoration: none;\n    transition: 0.5s;\n}\n.formButton[data-v-3710880a]:hover{\n    border-color: #91ab45;\n    background-color: #91ab45;\n    transition: 0.5s;\n    color: #ffffff;\n}\n.btn-spinner[data-v-3710880a]{\n    bottom:15px\n}\n", ""]);

// exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.liveEvent ul.slick-dots {\n    display: none !important;\n}\n.btn-pink{\n    margin: 10px auto;\n    display: block;\n    float: none;\n}\n", ""]);

// exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n@media(min-width:1200px){\n.liveEvent .col-md-offset-3.col-md-6 iframe[data-v-37fd3ce2] {\n    position:static !important;\n}\n.liveEvent .col-md-offset-3.col-md-6[data-v-37fd3ce2] {\n\n        z-index: 20;\n        position:relative;\n        margin-bottom: 50px;\n}\n.attendees[data-v-37fd3ce2] {\n        position: relative;\n        margin-top: 70px;\n        left: 0;\n        right: 0;\n        z-index: 10;\n}\n.liveEvent[data-v-37fd3ce2] {\n        position: relative;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage[data-v-37fd3ce2] {\n        width: 20%;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage[data-v-37fd3ce2]:nth-of-type(12), .liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage[data-v-37fd3ce2]:nth-of-type(14) {\n        /*margin-right: 60%;*/\n}\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage .liveImage[data-v-37fd3ce2] {\n    width: 100%;\n    text-align: center;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage .liveImage img[data-v-37fd3ce2] {\n    -o-object-fit:contain;\n       object-fit:contain;\n}\n", ""]);

// exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\nbody{\n    -ms-overflow-style:scrollbar;\n}\n.fixgraybgpl .video-player .left-video-icons{background:transparent;\n}\n@media(max-width:992px) {\n.side-content pre {\n        overflow: scroll;\n        white-space: pre-wrap;\n}\n.fixgraybgpl .video-player .jwplayer.jw-flag-aspect-mode {\n        height: auto !important;\n}\n}\n/*@media (max-width: 991px) and (min-width: 320px){\n    .fixgraybgpl .video-player .reset-video-width {\n        max-width:85%;\n    }\n}*/\n", ""]);

// exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.video-player-wrapper .watch-again .current-video-img img[data-v-38b18f5a] {\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.video-player .right-video-icons .enjoy-hover-box[data-v-38b18f5a] {\n    width: 20%;\n    height: 100%;\n    background: #f0617d;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 15% 0px 0;\n    text-align: left;\n}\n.video-player .right-video-icons .enjoy-hover-box button.btn[data-v-38b18f5a] {\n    margin: 0 0 10px;\n    border-color: white;\n    border-radius: 3px;\n    padding: 12px 0 13px;\n    display: block;\n    width: 80%;\n    margin: 0px auto 10px;\n    color: #fff;\n}\n.video-player-wrapper .tooltipBox[data-v-38b18f5a] {\n    width: 100%;\n    text-align: center;\n    padding-bottom: 10px;\n    height: 35px;\n    margin-top: 24px;\n}\n@media (min-width:768px) {\n.video-player .right-video-icons .enjoy-hover-box[data-v-38b18f5a] {\n        padding: 117px 0px 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating[data-v-38b18f5a] {\n        overflow: hidden;\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating p[data-v-38b18f5a] {\n        color: white;\n        display: block;\n        font-size: 16px;\n        letter-spacing: 0.5px;\n        margin-top: 23px;\n        margin-bottom: 20px;\n        padding: 0 10%;\n        text-align: center;\n}\n}\n.video-player .right-video-icons .rate-hover-box span[data-v-38b18f5a] {\n    margin-bottom: 20px;\n}\n.video-player .right-video-icons .rate-hover-box button[data-v-38b18f5a]:hover {\n    background: #ac2925;\n}\n.video-player .btn-danger[data-v-38b18f5a]:focus {\n    background: inherit;\n    border-color: inherit;\n    outline: none;\n}\n.video-player .right-video-icons div button.btn-danger[data-v-38b18f5a]:hover{\n    background:rgba(0,0,0,0.1);\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-38b18f5a]:hover{\n    background:#ac2925;\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-38b18f5a]:focus{\ncolor: #fff;\nbackground-color: #ac2925;\nborder-color: #fff;\n}\n.profile-content img[data-v-38b18f5a] {\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center center;\n       object-position: center center;\n}\n.playlistholderdiv[data-v-38b18f5a] {\n    width: 15%;\n    color: #fff;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 15px;\n    bottom: 0;\n    overflow-y: auto;\n}\n.playlistholderdiv img[data-v-38b18f5a] {\n    max-width: 100%;\n    margin: 0 0 10px;\n}\n.fixgraybgpl .video-player-background[data-v-38b18f5a] {\n    position: relative;\n}\n.playlistholderdiv h4[data-v-38b18f5a] {\n    font-size: 16px;\n}\n.playlistholderdiv p[data-v-38b18f5a] {\n    font-size: 14px !important;\n}\n.playlistentrydiv[data-v-38b18f5a] {\n    position: relative;\n}\n.playlistentrydiv.playing[data-v-38b18f5a]:after {\n    position: absolute;\n    right: 0;\n    text-align: center;\n    font-weight: 900;\n    text-shadow: 0 1px 3px rgba(0,0,0,0.75);\n    content: \"\";\n    height: 0;\n    width: 0;\n    border: 10px solid transparent;\n    top: 2px;\n    border-left-color: #f0617d;\n    transform: translateY(-0%);\n    left: 2px;\n}\n.playlistentrydiv.playingMobile[data-v-38b18f5a]:after {\n    position: absolute;\n    right: 0;\n    text-align: center;\n    font-weight: 900;\n    text-shadow: 0 1px 3px rgba(0,0,0,0.75);\n    content: \"\";\n    height: 0;\n    width: 0;\n    border: 10px solid transparent;\n    top: 2px;\n    border-left-color: #f0617d;\n    transform: translateY(-0%);\n    left: 2px;\n}\n.playlistholderdiv button.btn.formButton.btn-block[data-v-38b18f5a] {\n    border-radius: 5px;\n}\n@media(max-width:1024px) {\n.playlistholderdiv[data-v-38b18f5a] {\n        width: 100%;\n        position: static;\n}\n.playlistholderdiv img[data-v-38b18f5a] {\n        width: 100px;\n        float: left;\n        margin: 0px 15px 15px 0;\n}\n.playlistentrydiv[data-v-38b18f5a] {\n        overflow: hidden;\n        text-align: left;\n        border-bottom: 1px solid #666;\n        margin: 0 0 15px;\n}\ndiv:last-of-type > .playlistentrydiv[data-v-38b18f5a] {\n        margin: 0;\n        border-bottom: 0 none transparent;\n}\ndiv:last-of-type > .playlistentrydiv img[data-v-38b18f5a] {\n        margin-bottom: 0;\n}\n}\n.gray[data-v-38b18f5a]:before {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: block;\n    content: \"\";\n    background: rgba(0, 0, 0, 0.58);\n}\n.gray[data-v-38b18f5a] {\n    position: relative;\n}\n", ""]);

// exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\np strong[data-v-38c57b52] {\n    font-weight: 900;\n    color: #000;\n}\n.text-left p[data-v-38c57b52] {\n    font-size: 16px;\n}\nlegend[data-v-38c57b52] {\n    color: #f0617d;\n}\nimg[data-v-38c57b52] {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    width: 65%;\n}\n", ""]);

// exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.set-error[data-v-3a123387]{\n    border-color: #a94442 !important;\n    color:#a94442 !important;\n}\n.StripeElement[data-v-3a123387] {\n    background-color: white;\n    padding: 2em 1em;\n    border: 1px solid #ccc;\n    box-shadow: 0 1px 3px 0 #e6ebf1;\n    transition: box-shadow 150ms ease;\n    height: 34px;\n}\n.float-right.paymentswitch.btn-group[data-v-3a123387] {\n    margin: 0 0 30px;\n}\n.StripeElement--focus[data-v-3a123387] {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n}\n.StripeElement--invalid[data-v-3a123387] {\n    border-color: #fa755a;\n}\n.StripeElement--webkit-autofill[data-v-3a123387] {\n    background-color: #fefde5 !important;\n}\n.radiowrapper[data-v-3a123387] {\n    padding: 0 0px 10px;\n    color: #f0617d;\n}\ndiv#paypal-button[data-v-3a123387] {\n    text-align: center;\n}\n.codediv[data-v-3a123387] {\n    padding: 10px 0 0;\n}\n.codediv + .row.code[data-v-3a123387] {\n    padding-top: 0;\n}\n@media(min-width:768px) {\n.row.code + label.terms-and-condition[data-v-3a123387] {\n        margin: 0;\n}\n}\n.stripeholder[data-v-3a123387] {\n}\n.codediv .stripeholder[data-v-3a123387] {\n    margin-bottom: 20px;\n}\n.codediv .col-md-12[data-v-3a123387] {\n    min-height: 0;\n}\n.showmobile[data-v-3a123387]{\n    display:none;\n}\n.stripeholder[data-v-3a123387] {\n    position: relative;\n}\ni.fa.fa-lock.overlapstripe[data-v-3a123387] {\n    position: absolute;\n    left: 18px;\n    top: 10px;\n    font-size: 18px;\n    color: #b2b8c7;\n}\nbutton.redeem.btn.formButton.btn-block[data-v-3a123387] {\n    margin: 0;\n}\n.row.code[data-v-3a123387] {\n    padding-top: 20px;\n}\n@media(max-width:479px){\n.innerpart[data-v-3a123387] {\n        font-size: 17px;\n        letter-spacing: 0;\n}\n}\n@media (max-width:767px){\n.hidemobile[data-v-3a123387]{\n        display:none;\n}\n.showmobile[data-v-3a123387]{\n        display:inherit;\n}\n.signUp .left-content h4[data-v-3a123387] {\n        font-size: 14px;\n        letter-spacing: 0px;\n}\n.signUp .main-content h2[data-v-3a123387] {\n        margin: 15px 0;\n        line-height: 20px;\n        font-size: 18px;\n}\n.signUp #signup_pwderrormsg[data-v-3a123387] {\n        margin-bottom: 8px;\n        line-height: 1.3;\n        letter-spacing: 1px;\n}\n.signUp .left-content .create-account #signup_button[data-v-3a123387] {\n        margin: 0;\n}\n.signUp .right-content .jumbotron[data-v-3a123387] {\n        padding: 6px;\n        margin-top: 7px;\n}\n.signUp .right-content .jumbotron h2[data-v-3a123387] {\n        margin: 0;\n        font-size: 21px;\n}\n.signUp .right-content .jumbotron p[data-v-3a123387] {\n        display: none;\n}\n.signUp .right-content .card[data-v-3a123387] {\n        padding: 10px 10px;\n}\n.signUp .right-content .card .card-block .list-group li[data-v-3a123387] {\n        font-size: 16px;\n        margin: 0 0 10px;\n}\n.signUp .left-content hr[data-v-3a123387] {\n        display: none;\n}\n.row.margin-top[data-v-3a123387] {\n        margin-top: 0px;\n}\ndiv#paypal-button[data-v-3a123387] {\n        text-align: center!important;\n        top: -3px;\n}\n.codediv .stripeholder[data-v-3a123387] {\n        margin-bottom: 10px;\n}\n}\n\n/* Media query for mobile viewport */\n@media screen and (max-width: 400px) {\n#paypal-button-container[data-v-3a123387] {\n        width: 100%;\n}\n}\n\n/* Media query for desktop viewport */\n@media screen and (min-width: 400px) {\n#paypal-button-container[data-v-3a123387] {\n        width: 250px;\n        display: inline-block;\n}\n}\nbutton.redeem.btn.formButton.btn-block[data-v-3a123387] {\n    letter-spacing: 0;\n}\n.checkboxholder[data-v-3a123387] {\n    padding-bottom: 10px;\n}\n.checkboxholder .checkbox[data-v-3a123387] {\n    font-size: 16px;\n    letter-spacing: 3px;\n    margin: 15px 0;\n}\n.redoutlinebox[data-v-3a123387] {\n    border: 2px solid #f0617d;\n    padding: 10px;\n    margin: 0px 0px 20px;\n    text-align: justify;\n}\n.checkboxholder .radio input[type=\"radio\"][data-v-3a123387] {\n    opacity:1;\n    z-index:20;\n    top: 2px;\n}\nbody .margin-top[data-v-3a123387] {\n    margin-top: 89px;\n    margin-bottom: 70px;\n}\nbody .signUp .right-content .card .card-block .list-group[data-v-3a123387]{\n    margin-bottom:0px;\n}\n.choice-holder[data-v-3a123387] {\n    border: 1px solid #ddd;\n    margin: 0 0 20px;\n    padding: 20px 0;\n    font-size: 16px;\n    font-weight: 500;\n}\n.choice-holder .btn[data-v-3a123387] {\n    margin: 10px auto;\n}\n.innerpart[data-v-3a123387] {\n    margin: auto;\n    max-width: 220px;\n    padding: 0 10px;\n}\n.choice-holder > .row[data-v-3a123387] {\n    margin: 0;\n}\n.choice-holder > .row > .col-xs-6[data-v-3a123387] {\n    padding: 0;\n}\nspan.heading[data-v-3a123387] {\n    position: relative;\n    width: 100%;\n    display: block;\n    font-size: 19px;\n    font-weight: 500;\n    color: #a9a9a9;\n}\n.checkboxholder .radio[data-v-3a123387] {\n    text-align: center;\n    border: 1px solid #ddd;\n    padding: 10px;\n}\n.checkboxholder[data-v-3a123387] {\n}\n.checkboxholder .radio label[data-v-3a123387] {\n    padding: 0;\n    letter-spacing: 0;\n}\n.checkboxholder .radio label span[data-v-3a123387] {\n    display: block;\n}\n.checkboxholder .radio label input[data-v-3a123387] {\n    position: relative;\n    margin: 20px 0;\n}\nspan.footertext[data-v-3a123387] {\n    font-weight: 500;\n    color: #a9a9a9;\n}\nspan.plan-price[data-v-3a123387] {\n    font-size: 34px;\n    font-weight: 900;\n    color: #a9a9a9;\n}\n.radio.popular[data-v-3a123387]:before {\n    content: \"Most Popular Deal\";\n    position: absolute;\n    left: 0;\n    right: 0;\n    line-height: 1.3;\n    background: #f0617d;\n    color: #fff;\n    transform: translatey(-100%);\n    margin-top: -10px;\n    padding: 5px 0;\n}\n.checkboxholder[data-v-3a123387] {\n    padding-top: 30px;\n}\nspan.permonth[data-v-3a123387] {\n    display: block;\n    font-size: 14px;\n}\nspan.plan-price[data-v-3a123387] {\n    line-height: 1.2;\n    padding-top: 20px;\n}\n@media(max-width:767px){\n.radio.popular[data-v-3a43d266][data-v-3a123387]:before {\n        position: absolute;\n        transform: translateY(-20px);\n}\n.radio.popular[data-v-3a123387] {\n        padding-top: 30px !important;\n}\n}\n.bounce-enter-active[data-v-3a123387] {\n    animation: bounce-in .5s;\n}\n/*.bounce-leave-active {*/\n/*animation: bounce-in .1s reverse;*/\n/*}*/\n@keyframes bounce-in {\n0% {\n        transform: scale(0);\n}\n50% {\n        transform: scale(1.5);\n}\n100% {\n        transform: scale(1);\n}\n}\n", ""]);

// exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.list-complete-item {\n    padding: 4px;\n    margin-top: 4px;\n    border: solid 1px;\n    transition: all 1s;\n}\n.list-complete-enter, .list-complete-leave-active {\n    opacity: 0;\n}\nbody{\n    -ms-overflow-style:scrollbar;\n}\n.fixgraybgpl .video-player .left-video-icons{background:transparent;\n}\n@media(max-width:992px) {\n.side-content pre {\n        overflow: scroll;\n        white-space: pre-wrap;\n}\n.fixgraybgpl .video-player .jwplayer.jw-flag-aspect-mode {\n        height: auto !important;\n}\n}\n/*@media (max-width: 991px) and (min-width: 320px){\n    .fixgraybgpl .video-player .reset-video-width {\n        max-width:85%;\n    }\n}*/\n", ""]);

// exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.video-player-wrapper .watch-again .current-video-img img[data-v-420f1dc1] {\n     -o-object-fit: cover;\n        object-fit: cover;\n}\n.video-player .right-video-icons .enjoy-hover-box[data-v-420f1dc1] {\n     width: 20%;\n     height: 100%;\n     background: #f0617d;\n     position: absolute;\n     top: 0;\n     right: 0;\n     padding: 15% 0px 0;\n     text-align: left;\n}\n.video-player .right-video-icons .enjoy-hover-box button.btn[data-v-420f1dc1] {\n     margin: 0 0 10px;\n     border-color: white;\n     border-radius: 3px;\n     padding: 12px 0 13px;\n     display: block;\n     width: 80%;\n     margin: 0px auto 10px;\n     color: #fff;\n}\n.video-player-wrapper .tooltipBox[data-v-420f1dc1] {\n     width: 100%;\n     text-align: center;\n     padding-bottom: 10px;\n     height: 35px;\n     margin-top: 24px;\n}\n@media (min-width:768px) {\n.video-player .right-video-icons .enjoy-hover-box[data-v-420f1dc1] {\n         padding: 117px 0px 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating[data-v-420f1dc1] {\n         overflow: hidden;\n         position: absolute;\n         left: 0;\n         right: 0;\n         bottom: 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating p[data-v-420f1dc1] {\n         color: white;\n         display: block;\n         font-size: 16px;\n         letter-spacing: 0.5px;\n         margin-top: 23px;\n         margin-bottom: 20px;\n         padding: 0 10%;\n         text-align: center;\n}\n}\n.video-player .right-video-icons .rate-hover-box span[data-v-420f1dc1] {\n     margin-bottom: 20px;\n}\n.video-player .right-video-icons .rate-hover-box button[data-v-420f1dc1]:hover {\n     background: #ac2925;\n}\n.video-player .btn-danger[data-v-420f1dc1]:focus {\n     background: inherit;\n     border-color: inherit;\n     outline: none;\n}\n.video-player .right-video-icons div button.btn-danger[data-v-420f1dc1]:hover{\n     background:rgba(0,0,0,0.1);\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-420f1dc1]:hover{\n     background:#ac2925;\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-420f1dc1]:focus{\n color: #fff;\n background-color: #ac2925;\n border-color: #fff;\n}\n.profile-content img[data-v-420f1dc1] {\n     -o-object-fit: cover;\n        object-fit: cover;\n     -o-object-position: center center;\n        object-position: center center;\n}\n.playlistholderdiv[data-v-420f1dc1] {\n     width: 15%;\n     color: #fff;\n     position: absolute;\n     top: 0;\n     right: 0;\n     padding: 15px;\n     bottom: 0;\n     overflow-y: auto;\n}\n.playlistholderdiv img[data-v-420f1dc1] {\n     max-width: 100%;\n     margin: 0 0 10px;\n}\n.fixgraybgpl .video-player-background[data-v-420f1dc1] {\n     position: relative;\n}\n.playlistholderdiv h4[data-v-420f1dc1] {\n     font-size: 16px;\n}\n.playlistholderdiv p[data-v-420f1dc1] {\n     font-size: 14px !important;\n}\n.playlistentrydiv[data-v-420f1dc1] {\n     position: relative;\n}\n.playlistentrydiv.playing[data-v-420f1dc1]:after {\n     position: absolute;\n     right: 0;\n     text-align: center;\n     font-weight: 900;\n     text-shadow: 0 1px 3px rgba(0,0,0,0.75);\n     content: \"\";\n     height: 0;\n     width: 0;\n     border: 10px solid transparent;\n     top: 12px;\n     border-left-color: #f0617d;\n     transform: translateY(-0%);\n     left: 2px;\n}\n.playlistentrydiv.playingMobile[data-v-420f1dc1]:after {\n     position: absolute;\n     right: 0;\n     text-align: center;\n     font-weight: 900;\n     text-shadow: 0 1px 3px rgba(0,0,0,0.75);\n     content: \"\";\n     height: 0;\n     width: 0;\n     border: 10px solid transparent;\n     top: 2px;\n     border-left-color: #f0617d;\n     transform: translateY(-0%);\n     left: 2px;\n}\n@media(max-width:5992px) {\n.playlistholderdiv[data-v-420f1dc1] {\n         width: 100%;\n         position: static;\n         overflow: visible;\n}\n.playlistholderdiv img[data-v-420f1dc1] {\n         width: 100px;\n         float: left;\n         margin: 0px 15px 10px 0;\n}\n.playlistentrydiv[data-v-420f1dc1] {\n         overflow: hidden;\n         text-align: left;\n         border-bottom: 1px solid #666;\n         margin: 0 0 0px;\n}\n.playlistentrydiv[data-v-420f1dc1] {\n         transition: all 0.5s ease;\n         cursor: pointer;\n}\n.playlistentrydiv[data-v-420f1dc1]:hover {\n         background: #fff;\n}\n.playlistentrydiv:hover > p[data-v-420f1dc1] {\n         transition: all 0.5s ease;\n         color: #000;\n}\ndiv:last-of-type > .playlistentrydiv[data-v-420f1dc1] {\n         margin: 0;\n         border-bottom: 0 none transparent;\n}\ndiv:last-of-type > .playlistentrydiv img[data-v-420f1dc1] {\n         margin-bottom: 0;\n}\n}\n.btn-group.plusicon[data-v-420f1dc1] {\n     position: absolute;\n     right: 50px;\n     bottom: 0px;\n     height: 29px;\n}\nli.divider[data-v-420f1dc1] {\n     border-bottom: 1px solid #ddd;\n     margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-420f1dc1] {\n     background: transparent;\n     border: 0 none transparent;\n     padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-420f1dc1]{\n     font-size: 21px;\n     top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-420f1dc1]{\n     padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-420f1dc1],\n button.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-420f1dc1] {\n     padding: 3px 15px;\n     margin-bottom: 5px;\n     display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-420f1dc1],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-420f1dc1] {\n     height: 30px;\n     padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-420f1dc1],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-420f1dc1] {\n     position: absolute;\n     top: 6px;\n     font-size:24px;\n     right:20px;\n     cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-420f1dc1],\n button.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-420f1dc1]{\n     position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-420f1dc1],\n button.dropdown-toggle.ellipsis.pull-right+ ul[data-v-420f1dc1]{\n     left: 0;\n     right: auto;\n     width: 230px;\n     background: #fff;\n     border: 1px solid #ddd;\n     border-radius: 5px;\n     top: 100%;\n     position: absolute;\n     z-index: 5000;\n     list-style: none;\n     text-align: left;\n     padding: 15px;\n}\n.backdropformenu[data-v-420f1dc1]{\n     position:fixed;\n     z-index:4900;\n     top:0;\n     left:0;\n     right:0;\n     bottom:0;\n     background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-420f1dc1]{\n     height: 24px;\n     width: 37px;\n}\n.menuiconbutton[data-v-420f1dc1]{\n     height: 24px;\n     width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-420f1dc1] {\n     left: auto ;\n     right: 0;\n}\n.fade-enter-active[data-v-420f1dc1], .fade-leave-active[data-v-420f1dc1] {\n     transition: opacity .5s;\n}\n.fade-enter[data-v-420f1dc1], .fade-leave-to[data-v-420f1dc1] /* .fade-leave-active below version 2.1.8 */ {\n     opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-420f1dc1]{\n     font-size: 10px;\n}\nspan.removed[data-v-420f1dc1] {\n     color: red;\n}\nspan.added[data-v-420f1dc1] {\n     color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-420f1dc1] {\n     position: relative;\n     display:block;\n}\n/*Copied for Playlist Options*/\n.btn-group.plusicon[data-v-420f1dc1] {\n     position: absolute;\n     right: 50px;\n     bottom: 0px;\n     height: 29px;\n}\nli.divider[data-v-420f1dc1] {\n     border-bottom: 1px solid #ddd;\n     margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-420f1dc1] {\n     background: transparent;\n     border: 0 none transparent;\n     padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-420f1dc1]{\n     font-size: 21px;\n     top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-420f1dc1]{\n     padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-420f1dc1],\n button.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-420f1dc1] {\n     padding: 3px 15px;\n     margin-bottom: 5px;\n     display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-420f1dc1],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-420f1dc1] {\n     height: 30px;\n     padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-420f1dc1],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-420f1dc1] {\n     position: absolute;\n     top: 6px;\n     font-size:24px;\n     right:20px;\n     cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-420f1dc1],\n button.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-420f1dc1]{\n     position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-420f1dc1],\n button.dropdown-toggle.ellipsis.pull-right+ ul[data-v-420f1dc1]{\n     left: 0;\n     right: auto;\n     width: 230px;\n     background: #fff;\n     border: 1px solid #ddd;\n     border-radius: 5px;\n     top: 100%;\n     position: absolute;\n     z-index: 5000;\n     list-style: none;\n     text-align: left;\n     padding: 15px;\n}\n.backdropformenu[data-v-420f1dc1]{\n     position:fixed;\n     z-index:4900;\n     top:0;\n     left:0;\n     right:0;\n     bottom:0;\n     background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-420f1dc1]{\n     height: 24px;\n     width: 37px;\n}\n.menuiconbutton[data-v-420f1dc1]{\n     height: 24px;\n     width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-420f1dc1] {\n     left: auto ;\n     right: 0;\n}\n.fade-enter-active[data-v-420f1dc1], .fade-leave-active[data-v-420f1dc1] {\n     transition: opacity .5s;\n}\n.fade-enter[data-v-420f1dc1], .fade-leave-to[data-v-420f1dc1] /* .fade-leave-active below version 2.1.8 */ {\n     opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-420f1dc1]{\n     font-size: 10px;\n}\nspan.removed[data-v-420f1dc1] {\n     color: red;\n}\nspan.added[data-v-420f1dc1] {\n     color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-420f1dc1] {\n     position: relative;\n     display:block;\n}\n.playlistholderdiv button.dropdown-toggle.ellipsis.pull-right[data-v-420f1dc1] {\n     display: block;\n     top: 0px;\n     font-size: 0;\n     line-height: 1;\n     color: #f0617d;\n     height: 10px;\n     width: 30px;\n     right: 0;\n}\n.playlistholderdiv .plusicon.btn-group[data-v-420f1dc1] {\n     top: 0;\n     right: 0;\n     width: 100%;\n     max-width:350px\n}\n.playlistholderdiv button.dropdown-toggle.ellipsis.pull-right[data-v-420f1dc1]:before {\n     content: \"...\";\n     position: absolute;\n     top: -10px;\n     line-height: 0;\n     font-size: 50px;\n     display: block;\n     right: 5px;\n     letter-spacing: -2px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-420f1dc1] {\n     padding: 5px;\n     top: 11px;\n     width: 100%;\n     border-radius:0;\n     border:0 none transparent;\n}\n.playlistholderdiv li.divider[data-v-420f1dc1] {\n     margin: 2px 0 4px;\n}\n.playlistholderdiv button.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-420f1dc1] {\n     padding: 0 !important;\n     margin: 0;\n     font-size: 10px;\n}\n.playlistholderdiv input[type=\"checkbox\"][data-v-420f1dc1] {position: relative;top: 3px;\n}\n.playlistentrydiv[data-v-420f1dc1] {\n     overflow:visible !important;\n     clear:both;\n     display:table;\n     width:100%;\n     padding-top:10px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-420f1dc1] {\n     color: #000;\n}\n.playlistholderdiv>div>span>div:last-of-type .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-420f1dc1] {\n     top: auto;\n     bottom: 20px;\n}\n.playlistholderdiv>div>span>div:last-of-type .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-420f1dc1] {\n     top: 11px;\n     bottom: auto;\n}\n.playlistentrydiv[data-v-420f1dc1] {\n     padding-right: 30px;\n}\n", ""]);

// exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.smedia span {\n    padding: 5px;\n}\n.unauth-header .notificationtext {\n    font-family: 'Zilla Slab', serif;\n}\n.topbanner-fixedheight {\n    background: #efefef;\n}\n.topbanner-fixedheight > div:not(.Welcome-text) {\n    max-height: inherit;\n}\n.topbanner-fixedheight > div >div#introVideo {\n    max-height: inherit;\n}\n.topbanner-fixedheight .jwplayer.jw-stretch-uniform video{-o-object-fit:cover;object-fit:cover;\n}\n.welcome-text {\n    font-size: 30px;\n    text-align: center;\n    color: #FFF;\n    position: absolute;\n    top: 5px;\n    left: 30px;\n    font-weight: bold;\n}\nsection.greysection {\n    background: #efefef;\n}\n.entryholder p {\n    font-size: 17px;\n    font-weight:500;\n    color:#000;\n}\n.entryholder {\n    margin-bottom: 50px;\n}\n.entryholder:nth-of-type(3) {\n    border-bottom: 10px solid #966c91;\n}\n.entryholder:nth-of-type(4) {\n    border-bottom: 10px solid #f9a827;\n}\n.entryholder:nth-of-type(5) {\n    border-bottom: 10px solid #adc736;\n}\n.entryholder:nth-of-type(6) {\n    border-bottom: 10px solid #57c1af;\n}\n.entryholder h3{\n    color:#f0778f;\n    font-size:30px;\n    padding-right:10px;\n}\nbody .un-auth-wrappers .slider  h1 {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translateY(-50%) translateX(-50%);\n    color: #fff;\n    font-size: 38px;\n    width: 860px;\n    max-width: 100%;\n}\n.buttonholderbanner {\n    position: absolute;\n    bottom: 30px;\n    left: 0;\n    right: 0;\n    padding: 10px;\n    color: #fff;\n}\n.buttonholderbanner .home-pink-button {\n    background: #f0617d;\n    border: 0;\n    /*padding: 10px 70px;*/\n    margin:0 0 10px;\n}\nbody .un-auth-wrappers .slider .slick-next:before{\n    content:\">\";\n    color:#fff !important;\n    font-size: 60px;\n    font-weight:900 !important;\n    text-shadow: 0px 2px 2px rgba(0,0,0,0.75);\n}\nbody .un-auth-wrappers .slider .slick-prev:before{\n    content:\"<\";\n    color:#fff !important;\n    font-size: 60px;\n    font-weight: 900 !important;\n    text-shadow: 0px 2px 2px rgba(0,0,0,0.75);\n}\nbody .un-auth-wrappers .slick-prev {\n    left: 50px;\n}\nbody .un-auth-wrappers .slick-next {\n    right: 50px;\n}\nhtml body .un-auth-wrappers .slide-player{\n    margin:0;\n    /*min-height: 275px;*/\n}\n.home-pink-button {\n    background: #f0617d;\n    border: 0;\n    padding: 10px;\n    color:#fff;\n    margin: 30px auto;\n    min-width: 220px;\n    text-transform: uppercase;\n}\nsection.testimonialsection {\n    padding: 80px 20px 40px;\n    background: #b3c94e;\n    color:#fff;\n    font-family: 'Zilla Slab', serif;\n}\nsection.testimonialsection h3 {\n    color: #fff;\n    font-style: italic;\n}\nsection.testimonialsection h2 {\n    margin: 20px 20px 40px;\n    font-size: 90px;\n}\nsection.testimonialsection .col-sm-6 h1,\nsection.testimonialsection .col-sm-6 h2,\nsection.testimonialsection .col-sm-6 h3,\nsection.testimonialsection .col-sm-6 h4 {\n    margin: 0 0 20px;\n    font-style:italic;\n}\nsection.testimonialsection .col-sm-6 h1{\n    font-size: 43px;\n    font-weight:600;\n}\nsection.testimonialsection .col-sm-6 h2{\n    font-size:38px;\n    font-weight:600;\n}\nsection.testimonialsection .col-sm-6 h3{\n    font-size:34px;\n    font-weight:600;\n}\nsection.testimonialsection .col-sm-6 h4{\n    font-size:29px;\n    font-weight:600;\n}\nsection.testimonialsection .author {\n    font-size: 18px;\n    margin: 10px 0;\n    font-style: normal;\n    font-weight: 100;\n}\nsection.aboutussection h2 {\n    font-size: 42px;\n    font-family: 'Zilla Slab', serif;\n    margin: 30px 0;\n}\nbody .un-auth-wrappers section.videoSections .tabs-content .slick-slider  .slick-slide{\n    padding-left: 100px;\n    padding-right: 80px;\n}\nbody .un-auth-wrappers section.videoSections .tabs-content .slider .slick-prev:before {\n    color:#000 !important;\n    line-height: 0;\n}\nbody .un-auth-wrappers section.videoSections .tabs-content .slider .slick-next:before {\n    color:#000 !important;\n    line-height: 0;\n}\nbody .un-auth-wrappers section.videoSections .tabs-content .slider .slick-prev {\n    left:40px\n}\nbody .un-auth-wrappers section.videoSections .tabs-content .slider .slick-next {\n    right:40px\n}\n.hide-mobile{\n    display:block;\n}\n@media(min-width:992px){\n.col-xs-6.col-sm-6.col-md-3.slide-player:nth-of-type(4n + 5) {\n        clear: left;\n}\n}\n@media(min-width:768px) and (max-width:991px){\n.col-xs-6.col-sm-6.col-md-3.slide-player:nth-of-type(odd) {\n        clear: left;\n}\n}\n@media(max-width:767px){\n.slick-slider{\n        margin-bottom:0;\n}\n.hide-mobile{\n        display:none;\n}\nhtml body .un-auth-wrappers .slider h1 {\n        font-size: 18px !important;\n        padding: 20px;\n        position:static;\n        transform: translateY(0%) translateX(0%);\n        color: #000;\n}\n.buttonholderbanner {\n        position: static;\n        bottom: 0;\n        padding: 5px;\n        color:#000;\n}\nbody .unauth-header header .nav-container .mobile-loginLogoutholder{\n        position:static;\n}\n.unauth-header header .nav-container .navbar-header a.navbar-toggle {\n        padding: 10px;\n        top: 5px;\n        margin: 0;\n        height: 10px;\n        width: 10px;\n}\nbody .unauth-header header .nav-container .mobile-loginLogoutholder a.btn.btn-link {\n        padding: 3px 10px;\n        border: 0 none transparent;\n        font-size: 18px;\n        margin: 0;\n}\n.tabs > ul {\n        margin: 0;\n        padding: 0;\n}\nselect.show-mobile.routeselect {\n        margin: 0 auto 30px;\n        background: #f0617d;\n        color: #fff;\n        border: 0 none transparent;\n        text-align: center;\n        outline: none 0 transparent;\n        min-width: 200px;\n        padding: 10px;\n}\nselect.show-mobile.routeselect option {\n        background: #fff;\n        color: #343434;\n        border-color: #f0617d;\n        outline: none 0 transparent;\n}\nbody .un-auth-wrappers .topcarosal button.slick-prev.slick-arrow ,\n    body .un-auth-wrappers .topcarosal button.slick-next.slick-arrow {\n        top: 25%;\n}\nbody .un-auth-wrappers .topcarosal button.slick-prev.slick-arrow:before ,\n    body .un-auth-wrappers .topcarosal button.slick-next.slick-arrow:before {\n        color:#fff !important;\n}\nbody .un-auth-wrappers .slider .slick-prev:before{\n        color:#000 !important;\n}\nbody .un-auth-wrappers .slider .slick-next:before{\n        color:#000 !important;\n}\nbody .un-auth-wrappers .slick-next {\n        right: 10px !important;\n}\nbody .un-auth-wrappers .slick-prev {\n        left: 10px !important;\n}\nsection.extertcontainer img {\n        display: block;\n}\nsection.testimonialsection h2 {\n        font-size: 44px;\n}\n}\n@media(min-width:768px){\nsection.extertcontainer .col-xs-6:nth-of-type(6n + 7) {\n        clear: left;\n}\n}\nsection.eventssections a {\n    color: #fff;\n}\nsection.eventssections h4 {\n    color: #fff;\n}\n", ""]);

// exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.entryholder ul.slick-dots {\n    display: none !important;\n}\n.slick-prev.slick-disabled:before, .slick-next.slick-disabled:before{opacity:0;\n}\n.un-auth-wrappers .slick-next{\n    right:0;\n}\n.un-auth-wrappers .slick-prev {\n    left: -7px;\n    z-index: 1;\n}\n.un-auth-wrappers .tabContent  .row.video-row i.fa {\n    font-size: 20px ;\n    color:#666;\n    margin:0 3px;\n}\n.entryholder .content.cursor.text-left {\n    display: none;\n}\n.entryholder .slick-slider {\n    margin: 0;\n}\n.entryholder .slide-player {\n    margin: 0;\n}\n.unauth-share-options {\n    position: fixed;\n    padding: 10px 0;\n    z-index: 1;\n    right: 0;\n    top: 261px;\n    width: 80px;\n    background: rgba(255, 255, 255, 0.6)\n}\n.un-auth-wrappers {\n    position: relative;\n}\n.unauth-share-options > span {\n    display: block;\n    padding: 10px;\n}\n.closed span.closearrow {\n    transform: translateX(100%);\n}\n.unauth-share-options {\n    transition: all 1s ease;\n}\n.closed .unauth-share-options {\n    transform: translateX(100%);\n}\nspan.openarrow {\n    position: fixed;\n    right: 0;\n    width: 80px;\n    transition: all 1s ease;\n    transform: translateX(100%);\n    background: rgba(255, 255, 255, 0.6);\n    display: block;\n    padding: 10px;\n    z-index:200;\n    top: 212px;\n}\nspan.closearrow {\n    position: fixed;\n    right: 0;\n    width: 80px;\n    transition: all 1s ease;\n    background: rgba(255, 255, 255, 0.6);\n    display: block;\n    padding: 10px;\n    z-index: 100;\n    top: 212px;\n}\n.closed > span.openarrow {\n    transform: translateX(0);\n}\n@media(min-width:768px) and (max-width:1199px){\nspan.closearrow ,\n    span.openarrow {\n        top: 197px !important;\n}\n.unauth-share-options {\n        top: 246px;\n}\n}\n@media (max-width:767px){\nspan.closearrow ,\n    span.openarrow {\n        top: 73px !important;\n}\n.unauth-share-options {\n        top: 122px;\n}\nspan.closearrow ,\n    span.openarrow {\n        background: rgba(255, 255, 255, 0.75);\n}\n.unauth-share-options {\n        background: rgba(255, 255, 255, 0.75)\n}\n}\n@media (min-width:1800px) {\nspan.closearrow,\n    span.openarrow {\n        top: 373px !important;\n}\n.unauth-share-options {\n        top: 422px;\n}\n}\n.logoslider .slick-slide img {\n    width: 130px;\n}\nbody .un-auth-wrappers .logoslider .slick-next , body .un-auth-wrappers .logoslider .slick-prev {\n    top: 60px;\n    background: transparent;\n    height: auto;\n    width: auto;\n    line-height: 1;\n    height: 50px;\n    width: 50px;\n    color: #fff;\n    right: -50px !important;\n    text-align: center;\n}\nbody .un-auth-wrappers .logoslider .slick-next:before , body .un-auth-wrappers .logoslider .slick-prev:before {\n    font-size: 30px;\n    display: block;\n    font-weight: 900;\n    text-shadow: 0 0 0 transparent;\n    line-height: 47px !important;\n    color: #fff !important;\n    background: #A9A9A9 !important;\n    height: 50px;\n    width: 50px;\n    border-radius: 50%;\n    text-align: center;\n}\nbody .un-auth-wrappers .logoslider .slick-prev {\n    left: -50px !important;\n    text-align: center;\n}\n.container.logoslider {\n    padding: 0 50px;\n}\nhtml body .un-auth-wrappers .logoslider .slide-player {\n    text-align: center;\n}\nhtml body .un-auth-wrappers .logoslider .slide-player img {\n    margin: 0 auto 20px;\n}\nhtml body .un-auth-wrappers .logoslider .slide-player h4,\nhtml body .un-auth-wrappers .logoslider .slide-player p{\n    max-width:200px;\n    display :block;\n    margin:0 auto;\n}\n@media(max-width:767px){\n.container.logoslider {\n        padding: 0 70px;\n}\n}\n.logoslider ul.slick-dots {\n    display: none !important;\n}\n.container.logoslider {\n    padding-bottom: 50px !important;\n}\n\n", ""]);

// exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.pinkh2[data-v-434fb5b0]{\n    color: #f0617d;\n    font-family: 'Zilla Slab', serif\n}\n.home-top-img img[data-v-434fb5b0] {\n    max-width: 100%;\n}\n.home-top-img img[data-v-434fb5b0] {\n    max-width: 100%;\n}\n.home-top-img[data-v-434fb5b0] {\n    position: relative;\n}\n.layover[data-v-434fb5b0] {\n    background: rgba(0,0,0,0.5);\n    position: absolute;\n    color: #fff;\n    font-weight: bold;\n    font-size: 18px;\n    padding: 20px;\n    left: 0px;\n    right: 0px;\n    top: 0;\n    bottom: 0;\n}\n.layover span[data-v-434fb5b0] {\n    position: absolute;\n    top: 50%;\n    letter-spacing: 5px;\n    font-size: 26px;\n    display: block;\n    line-height: 1.3;\n    transform: translateY(-50%);\n    left: 0;\n    right: 0;\n    text-align: center;\n}\n.layover.default span[data-v-434fb5b0] {\n    text-shadow: 0 3px 4px rgba(0,0,0,0.75);\n}\n.layover[data-v-434fb5b0]{\n    transition: all 0.5s ease;\n    opacity:0;\n}\n.home-top-img:hover .layover[data-v-434fb5b0]{\n    opacity:1;\n}\n.gap[data-v-434fb5b0]{height: 30px;\n}\n.layover.default[data-v-434fb5b0]{\n    opacity:1;\n    background: transparent;\n}\n.home-top-img:hover .layover.default[data-v-434fb5b0]{\n    opacity:0;\n}\nh1.main[data-v-434fb5b0] {\n    font-size: 36px;\n    color: #f0617d;\n    font-family: sans-serif;\n    margin: 0 0 20px;\n}\n@media(max-width:767px) {\nh3.heading\n    > i > img[data-v-434fb5b0] {\n        max-width: 46px;\n}\n}\ndiv#keywords[data-v-434fb5b0] {\n    color:#f0617d;\n    font-size:32px;\n    padding:10px 0 0;\n}\n@media(max-width:1200px){\n.un-auth-wrappers .over-lay .main-heading h1[data-v-434fb5b0] {\n        padding: 0 !important;\n}\n}\n@media(max-width:767px){\n.gap-for-mobile.clearfix[data-v-434fb5b0] {\n        height: 10px;\n}\n.un-auth-wrappers .blog-section p[data-v-434fb5b0] {\n        margin: 10px 0 5px !important;\n        line-height: 1.5;\n}\ndiv#giving_scroll\n    .goods-section.clearfix\n    .margin-bottom-40 h1[data-v-434fb5b0]{\n        margin-top:0 !important;\n}\n.goods-section.clearfix[data-v-434fb5b0] {\n        margin-top: -50px;\n}\n.layover.default span[data-v-434fb5b0] {\n        display: block;\n        border: 2px solid #fff;\n        margin-left: 20px;\n        margin-right: 20px;\n}\n.layover span[data-v-434fb5b0] {\n        padding: 20px;\n}\n.row.padding30[data-v-434fb5b0] {\n        margin: 0 -30px;\n}\n}\n@media(min-width:768px){\n.row.padding30[data-v-434fb5b0] {\n        margin-left: 0;\n        margin-right: 0;\n}\n.row.padding30 .col-sm-4[data-v-434fb5b0] {\n        padding: 0 30px;\n}\n}\n.sub-heading[data-v-434fb5b0] {\n    letter-spacing: 2px;\n    font-size: 19px;\n    font-weight: 600;\n    color:#000;\n    margin: 0 0 30px;\n}\nh3[data-v-434fb5b0]{\n    font-size:28px;\n    color:#000;\n    margin: 0 0 20px;\n}\n.welcome-text[data-v-434fb5b0]{\n    font-size: 15px;\n    letter-spacing: 1px;\n    font-weight: 600;\n}\n.watchVideoModal .modal-dialog .modal-body button[data-v-434fb5b0] {\n    color: #fff !important;\n    background-color: #5cb85c !important;\n    border-color: #4cae4c !important;\n}\n.watchVideoModal .modal-dialog .modal-body button[data-v-434fb5b0]:hover {\n    color: #fff;\n    background-color: #449d44;\n    border-color: #398439;\n}\nsection.extertcontainer img[data-v-434fb5b0] {\n    max-width: 100%;\n    border-radius: 50%;\n    margin: 0 auto 10px;\n}\nsection.extertcontainer h2[data-v-434fb5b0]{\n    font-size:26px;\n    color:#f0617d;\n    margin:10px 20px 40px;\n}\nsection.extertcontainer[data-v-434fb5b0]{\n    padding:50px 0;\n}\nsection.extertcontainer[data-v-434fb5b0] {\n    font-size: 16px;\n    color: #f0617d;\n}\nimg.fullscreenimg[data-v-434fb5b0] {\n    width: 100%;\n}\nsection.eventssections[data-v-434fb5b0] {\n    background: #f7a434;\n    color: #fff;\n    padding: 50px 20px 50px;\n}\nsection.eventssections h2[data-v-434fb5b0] {\n    max-width: 850px;\n    margin: 10px auto 20px;\n    font-family: 'Zilla Slab', serif;\n    font-size: 36px;\n}\nsection.eventssections h4[data-v-434fb5b0] {\n    font-size: 20px;\n    max-width: 300px;\n    margin: 20px auto;\n    font-weight:700;\n}\nsection.eventssections img[data-v-434fb5b0] {\n    max-width: 70px;\n    margin: 30px auto 10px;\n}\n.livestreaming[data-v-434fb5b0] {\n    font-family: 'Zilla Slab', serif;\n    padding-top:40px;\n}\nsection.charitycontainer img[data-v-434fb5b0] {\n    max-width: 100%;\n    margin: 0 auto 10px;\n}\nsection.charitycontainer[data-v-434fb5b0] {\n    background: url(" + __webpack_require__(849) + ");\n    color: #fff;\n    background-size: cover;\n    background-position: center;\n    padding-top:40px;\n    padding-bottom: 10px;\n}\n@media(min-width:1440px){\nsection.charitycontainer[data-v-434fb5b0] {\n        background-position: center top;\n        padding-top: 80px;\n        padding-bottom: 20px;\n}\n}\n@media(min-width:1600px)\n{\nsection.charitycontainer[data-v-434fb5b0] {\n        background-image: url(" + __webpack_require__(848) + ");\n        background-position: center top;\n        background-size: cover;\n        padding-top: 80px;\n        padding-bottom: 50px;\n}\n}\nsection.charitycontainer > .fa[data-v-434fb5b0] {\n    font-size: 50px;\n}\nsection.charitycontainer i.fa[data-v-434fb5b0] {\n    font-size: 50px;\n    margin-top: 50px;\n}\nimg.white-img[data-v-434fb5b0] {\n    filter: brightness(1000%);\n}\nsection.charitycontainer p[data-v-434fb5b0] {\n    font-size: 24px;\n}\nsection.charitycontainer h2[data-v-434fb5b0] {\n    font-size: 42px;\n    font-family: 'Zilla Slab', serif;\n}\na.yellowbtn[data-v-434fb5b0] {\n    background: #f7a434;\n    font-size: 18px;\n    background: #f7a434;\n    font-size: 18px;\n    margin: 4px;\n    border: 0 none transparent;\n    padding: 11px 22px;\n    color: white;\n    min-width: 250px !important;\n    display: inline-block;\n    margin: 0;\n}\n/*.tabContent:not(.current) {*/\n    /*display: none;*/\n/*}*/\n.tabs ul li a[data-v-434fb5b0] {\n    display: block;\n    background: #ee637e;\n    color: #fff;\n    min-width: 216px;\n    padding: 2px;\n    font-family: 'Zilla Slab', serif;\n    font-weight: 300;\n    font-size: 25px;\n}\n.tabs ul li[data-v-434fb5b0] {\n    display: inline-block;\n    margin: 10px;\n}\n.tabs ul li:nth-of-type(2) a[data-v-434fb5b0]{\n    background:#f7a434;\n}\n.tabs ul li:nth-of-type(3) a[data-v-434fb5b0]{\n    background:#946084;\n}\n.tabs ul li:nth-of-type(4) a[data-v-434fb5b0]{\n    background:#aec643;\n}\n.tabContent i.fa[data-v-434fb5b0] {\n    font-size: 21px;\n    color: #616161;\n    margin:0 3px;\n}\n.tabContent i[data-v-434fb5b0], .tabContent p[data-v-434fb5b0] {\n    font-size: 18px;\n    font-weight: 400;\n    font-weight: 400;\n    line-height: 1;\n    text-transform: capitalize;\n}\n.tabContent i[data-v-434fb5b0]{\n    margin:0 3px\n}\nsection.extertcontainer .col-sm-2[data-v-434fb5b0] {\n    font-style:italic;\n    line-height:1;\n}\np.cursor.video-title[data-v-434fb5b0]{\n    font-family: 'Zilla Slab', serif;\n    margin: 7px 0 15px;\n    font-weight: 500;\n    text-align: center;\n    text-transform: capitalize;\n    font-size: 19px;\n}\n.tabs-content h2.text-center[data-v-434fb5b0] {\n    font-size: 52px;\n    max-width: 980px;\n    margin: 30px auto;\n    font-family: 'Zilla Slab', serif;\n}\na[data-v-434fb5b0] {\n}\n.tabs ul li a[data-v-434fb5b0] {\n    font-family: 'Zilla Slab', serif;\n    font-weight: 100;\n}\nbody .un-auth-wrappers .slider h1[data-v-434fb5b0] {\n    font-family: 'Zilla Slab', serif;\n    font-size: 44px;\n}\nbutton.home-pink-button[data-v-434fb5b0] {\n    font-size: 19px;\n    font-family: 'Montserrat', sans-serif;\n}\n.buttonholderbanner i[data-v-434fb5b0] {\n    font-size: 130%;\n}\n.buttonholderbanner > span[data-v-434fb5b0] {\n    cursor: pointer;\n    display:inline-block;\n}\n.row.video-row img.jw-img[data-v-434fb5b0] {\n    border: 1px solid #666;\n}\nsection.extertcontainer h2[data-v-434fb5b0] {\n    font-family: 'Zilla Slab', serif;\n    font-size: 32px ;\n}\n.row.video-row i.fa[data-v-434fb5b0] {\n    font-size: 18px;\n}\nbody .un-auth-wrappers .slider h1[data-v-434fb5b0] {\n    font-family: 'Zilla Slab', serif;\n    font-size: 44px;\n}\nbutton.home-pink-button[data-v-434fb5b0] {\n    font-size: 19px;\n}\n.row.video-row img.jw-img[data-v-434fb5b0] {\n    border: 1px solid #666;\n}\n.row.video-row\n    img.jw-img[data-v-434fb5b0] {      border: 1px solid #666;\n}\nsection.extertcontainer h2[data-v-434fb5b0] {\n    font-family: 'Zilla Slab', serif;\n    font-size: 28px !important;\n    font-style:normal;\n}\nsection.extertcontainer button[data-v-434fb5b0]{\n\n    font-style:normal;\n}\nsection.extertcontainer[data-v-434fb5b0] {\n    font-family: 'Zilla Slab', serif;\n}\n.show-mobile[data-v-434fb5b0] {\n    display: none;\n}\n@media(max-width:767px){\nsection.extertcontainer .col-sm-2.col-xs-6[data-v-434fb5b0] {\n        min-height: 210px;\n        min-height: 60vw;\n}\nsection.extertcontainer h2[data-v-434fb5b0] {\n        font-size: 19px !important;\n}\n.tabs-content h2.text-center[data-v-434fb5b0] {\n        font-size: 21px;\n}\n.show-mobile[data-v-434fb5b0] {\n        display: block;\n}\nsection.charitycontainer[data-v-434fb5b0] {\n        padding-top: 0;\n}\nsection.charitycontainer img.show-mobile[data-v-434fb5b0] {\n        margin: 0 0 40px;\n}\nsection.charitycontainer[data-v-434fb5b0] {\n        background: #a36285;\n}\nsection.charitycontainer .row[data-v-434fb5b0] {\n        width: auto !important;\n}\n.row.mobilevideotabs.show-mobile > .col-xs-6[data-v-434fb5b0] {\n        padding: 0 0 20px;\n        line-height: 1;\n}\n.row.mobilevideotabs.show-mobile >\n    .col-xs-6[data-v-434fb5b0]:nth-of-type(odd) {\n        clear: left;\n}\n.row.mobilevideotabs.show-mobile >\n    .col-xs-6 p.cursor.video-title[data-v-434fb5b0] {\n        margin: 7px 0 15px !important;\n}\n}\nsection.aboutussection[data-v-434fb5b0] {\n    padding-bottom: 10px;\n}\nsection.eventssections.text-center[data-v-434fb5b0] {\n    padding-bottom: 10px;\n}\nsection.testimonialsection[data-v-434fb5b0] {\n    padding-bottom: 10px;\n}\nsection.extertcontainer[data-v-434fb5b0] {\n    padding-bottom: 10px;\n}\nsection.extertcontainer .col-sm-2[data-v-434fb5b0] {\n    padding-bottom: 20px;\n}\nsection.videoSections button.home-pink-button[data-v-434fb5b0] {\n    margin: 0;\n}\nsection.videoSections button.home-pink-button[data-v-434fb5b0] {\n    margin: 0;\n}\n.centerpadding[data-v-434fb5b0] {\n    max-width: 550px;\n    margin: auto;\n}\n.centerpadding h2[data-v-434fb5b0] {\n    margin-bottom: 20px;\n}\n.centerpadding p[data-v-434fb5b0] {\n    margin-bottom: 20px;\n}\n@media(max-width:1024px){\nbody .un-auth-wrappers .slider h1[data-v-434fb5b0]\n    {\n        margin:0;\n        padding:0 30px;\n}\n}\n@media(max-width:992px) and (min-width:768px){\nbody .un-auth-wrappers .slider h1[data-v-434fb5b0]\n    {margin: 0 auto;font-size:40px !important;top:40px;transform: translateX(-50%) translateY(0%);padding:0 50px;\n}\n}\n@media(min-width:803px) and (max-width:1050px){\n.tabs.hide-mobile ul li a[data-v-434fb5b0] {\n        width: 100%;\n        padding: 0;\n        min-width: 0;\n}\n.tabs.hide-mobile ul li[data-v-434fb5b0] {\n        margin: 1%;\n        width: 22%;\n}\n.tabs.hide-mobile ul[data-v-434fb5b0] {\n        padding: 0;\n}\n}\nsection.extertcontainer .col-sm-12[data-v-434fb5b0] {\n    clear:both;\n}\nsection.applicationdownload[data-v-434fb5b0] {\n    padding: 300px 20px 30px;\n    background-image: url(https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/app-image-resized-new.png);\n    background-size: cover;\n    background-position: center;\n    position: relative;\n}\nsection.applicationdownload img.showmobile[data-v-434fb5b0] {\n    display: none;\n}\nsection.applicationdownload b[data-v-434fb5b0] {\n    color: #fff;\n}\nsection.applicationdownload[data-v-434fb5b0]:after {\n    content: \"\";\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.35);\n}\nsection.applicationdownload>*[data-v-434fb5b0] {\n    position: relative;\n    z-index: 1;\n}\nsection.applicationdownload h2[data-v-434fb5b0] {\n    font-family: Zilla Slab,serif;\n    font-size: 45px!important;\n    font-style: normal;\n    margin: 0 0 140px;\n}\nsection.applicationdownload .appbtn[data-v-434fb5b0] {\n    max-width: 220px;\n    margin: 0 25px;\n}\n@media(max-width:768px){\nsection.applicationdownload .appbtn[data-v-434fb5b0] {\n        max-width: 220px;\n        margin: 0 10px;\n}\nsection.applicationdownload img.showmobile[data-v-434fb5b0] {\n        display: block;\n        width: 100%;\n}\nsection.applicationdownload[data-v-434fb5b0] {\n        padding: 0 0 50px;\n        background: #fff;\n}\nsection.applicationdownload h2[data-v-434fb5b0] {\n        margin: 40px 0;\n        color: #000;\n        padding: 0 20px;\n}\nsection.applicationdownload[data-v-434fb5b0]:after {\n        display: none;\n}\nsection.applicationdownload h2 b[data-v-434fb5b0] {\n        color: #000;\n        font-size: 34px!important;\n}\n}\n@media(min-width:768px){\nsection.radiosection .row[data-v-434fb5b0] {display: -ms-flexbox;display: flex;-ms-flex-pack: center;justify-content: center;\n}\n}\n/* .radiosection {padding:10px 20px;background:#eee;} */\n.radiosection[data-v-434fb5b0] {padding:10px 20px;\n}\nsection.radiosection p[data-v-434fb5b0] {\n    font-size: 18px;\n}\nsection.radiosection h4[data-v-434fb5b0] {\n    font-weight: 700;\n    font-size: 21px;\n}\n/* ADVISORY BOARD SECTION BELOW */\nsection.text-left.advisory[data-v-434fb5b0] {\n    max-width: 900px;\n    padding: 0 40px 20px;\n    border-top: 5px solid #faa51e;\n    border-bottom: 5px solid #faa51e;\n    margin: 60px auto;\n    position: relative;\n}\nsection.text-left.advisory[data-v-434fb5b0]:before {content: \"\";background-color: #bde8e1;width: 5px;top: 10px;bottom: 10px;left: 20px;display: block; position: absolute;\n}\nsection.text-left.advisory .mb-3[data-v-434fb5b0] {\n    margin-bottom: 10px;\n}\n\n", ""]);

// exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.expert-page-wrapper .main h2[data-v-4572d5bb] {\n    margin-top: 0;\n}\nh2.pinkh2[data-v-4572d5bb]{\n    font-size: 29px;\n    color: #f0617d !important;\n    text-transform: uppercase;\n    font-weight:700;\n}\n.expert-page-wrapper .random .blog-section h2.pinkh2[data-v-4572d5bb]{\n    font-size: 29px;\n    color: #f0617d !important;\n    text-transform: uppercase;\n}\n.blog-section.videossection.clearfix .panel .panel-body > .col-md-12.margin-top-20.margin-bottom-40[data-v-4572d5bb] {\n    margin: 10px 0;\n    padding: 0;\n}\n.blog-section.videossection.clearfix .panel .panel-body > .col-md-12.margin-top-20.margin-bottom-40 p[data-v-4572d5bb] {\n    font-size: 15px;\n}\n.blog-section.videossection.clearfix .panel .panel-body > .col-md-12.margin-top-20.margin-bottom-40 > p > i.fa.fa-play-circle-o[data-v-4572d5bb] {\n    position: relative;\n    font-size: 25px;\n    width: auto !important;\n    color:black;\n    margin-right:10px;\n    top:3px\n}\n.blog-section.videossection.clearfix .panel .panel-body[data-v-4572d5bb] {\n    cursor: pointer;\n}\nimg.img-responsive[data-v-4572d5bb] {\n    width: 100%;\n}\n.expert-page-wrapper .main img[data-v-4572d5bb]{height:auto;\n}\n.expert-page-wrapper .live-chat\nimg.nostyle[data-v-4572d5bb] {\n    width: auto;\n    height: auto;\n    max-width: 90%;\n    float: left;\n}\n.experts h2[data-v-4572d5bb] {\n    margin-top: 0;\n}\n.pintlist-holder[data-v-4572d5bb] {padding: 0 0 50px;\n}\nul.pink_container[data-v-4572d5bb] {\n    padding: 20px;\n    color: #f0617d;\n    font-weight: 700;\n    font-size: 18px;\n    margin: 30px 0;\n    border: 2px solid #f0617d;\n    list-style: none;\n}\nul.pink_container li[data-v-4572d5bb] {\n    line-height: 1.3;\n    padding: 0 0 10px;\n}\n.btn-group.plusicon[data-v-4572d5bb] {\n    position: absolute;\n    right: 50px;\n    bottom: 0px;\n    height: 29px;\n    z-index:200;\n}\nli.divider[data-v-4572d5bb] {\n    border-bottom: 1px solid #ddd;\n    margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-4572d5bb] {\n    background: transparent;\n    border: 0 none transparent;\n    padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-4572d5bb]{\n    font-size: 21px;\n    top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-4572d5bb]{\n    padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-4572d5bb],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-4572d5bb] {\n    padding: 3px 15px;\n    margin-bottom: 5px;\n    display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-4572d5bb],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-4572d5bb] {\n    height: 30px;\n    padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-4572d5bb],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-4572d5bb] {\n    position: absolute;\n    top: 6px;\n    font-size:24px;\n    right:20px;\n    cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-4572d5bb],\nbutton.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-4572d5bb]{\n    position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-4572d5bb],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul[data-v-4572d5bb]{\n    left: 0;\n    right: auto;\n    width: 230px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    top: 100%;\n    position: absolute;\n    z-index: 5000;\n    list-style: none;\n    text-align: left;\n    padding: 15px;\n}\n.backdropformenu[data-v-4572d5bb]{\n    position:fixed;\n    z-index:4900;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-4572d5bb]{\n    height: 24px;\n    width: 37px;\n}\n.menuiconbutton[data-v-4572d5bb]{\n    height: 24px;\n    width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-4572d5bb] {\n    left: auto ;\n    right: 0;\n}\n.fade-enter-active[data-v-4572d5bb], .fade-leave-active[data-v-4572d5bb] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-4572d5bb], .fade-leave-to[data-v-4572d5bb] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-4572d5bb]{\n    font-size: 10px;\n}\nspan.removed[data-v-4572d5bb] {\n    color: red;\n}\nspan.added[data-v-4572d5bb] {\n    color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-4572d5bb] {\n    position: relative;\n    display:block;\n}\nlabel.notificationwithcheckboxes[data-v-4572d5bb] {\n}\n.career-page-wrapper .featured .experts p[data-v-4572d5bb]{\n    font-weight:normal;\n}\n.row.yourFaves p.text-wrap-title.cursor[data-v-4572d5bb] {\n    text-align: left;\n    font-size: 15px;\n    white-space: nowrap;\n    font-weight: normal;\n    line-height: 1.8;\n    color: #5e5e5e;\n    margin-top:10px;\n    overflow:hidden;\n    text-overflow:ellipsis;\n}\n.row.yourFaves p.text-wrap-title.cursor i.fa.fa-play-circle-o[data-v-4572d5bb] {\n    position: relative;\n    font-size: 25px;\n    width: auto !important;\n    color: black;\n    margin-right: 10px;\n    top: 3px;\n}\n.row.yourFaves hr[data-v-4572d5bb] {\n    margin: 0;\n}\n.row.yourFaves p.right-heart-icon[data-v-4572d5bb] {\n    text-align: right;\n    top: 10px;\n    position: relative;\n    z-index: 100;\n}\n.row.random-section-head.yourFaves.exceptionalsettings\np.text-wrap-title.cursor i.fa.fa-play-circle-o[data-v-4572d5bb]{\n    height:20px !important;\n}\n.row.random-section-head.yourFaves.exceptionalsettings\n.plusicon.btn-group[data-v-4572d5bb] {\n    bottom:15px;\n}\n@media(min-width:992px){\n.row.random-section-head.yourFaves.exceptionalsettings .col-xs-12.col-sm-6.col-md-4.bottom-margin[data-v-4572d5bb]:nth-of-type(3n + 1) {\n        clear: left;\n}\n}\n", ""]);

// exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\nbutton.fc-prev-button.fc-button.fc-state-default.fc-corner-left {\n        display: none;\n}\n.fc-right {\n        display: none;\n}\nbutton.fc-next-button.fc-button.fc-state-default.fc-corner-right {\n        display: none;\n        /*background: #f0617d;*/\n        /*color: #fff;*/\n        /*text-shadow: 0 0 0 transparent;*/\n        /*border: 0;*/\n        /*border-radius: 0;*/\n        /*float: right;*/\n}\n.fc-button-group {\n        position: absolute;\n        right: 15px;\n}\n.calendarholder .fc-today-button {\n        display: none;\n}\n.resource-content .fc-content-skeleton span.fc-title:before {\n        content: \"\\F005\";\n        font-family: fontawesome;\n        color:#efc662;\n}\n.resource-content .fc-content-skeleton span.fc-title {\n        white-space: normal;\n        word-wrap:break-word;\n}\n.resource-content .fc-scroller.fc-day-grid-container {\n        height: auto !important;\n        overflow: visible !important;\n}\n.accordionholder .panel-collapse:after {\n        /*border: 1px solid #f0617d;*/\n        /*position: absolute;*/\n        /*content: \"\";*/\n        /*top: 0;*/\n        /*left: 0;*/\n        /*right: 0;*/\n        /*bottom: 0;*/\n}\n.accordionholder .panel.panel-default {\n        position: relative;\n}\n.accordionholder .panel-body a {\n        font-weight: bold;\n        text-decoration: underline;\n}\n.accordionholder .panel-body a:before {\n        position: relative;\n        display: inline-block;\n        content: \"\";\n        width: 10px;\n        height: 10px;\n        background: #f0617d;\n        border-radius: 50%;\n        margin-right: 10px;\n}\nbutton.share-event {\n        color: rgb(240, 97, 125) !important;\n        border: 1px solid rgb(240, 97, 125) !important;\n        background-image: none !important;\n        font-weight: 600;\n        line-height: 100%;\n        background: #fff !important;\n        font-size: 15px !important;\n        text-decoration: none;\n        border-radius: 3px !important;\n        cursor: pointer;\n        -webkit-font-smoothing: antialiased!important;\n        outline-color: rgba(0,78,255,0.5) !important;\n        text-shadow: 1px 1px 1px rgb(0 0 0 / 0%);\n        display: inline-block;\n        position: relative;\n        /*z-index: 99998;*/\n        font-family: \"Open Sans\",Roboto,\"Helvetica Neue\",Helvetica,Optima,Segoe,\"Segoe UI\",Candara,Calibri,Arial,sans-serif !important;\n        padding: 12px 12px 12px 12px !important;\n        margin-left: 10px !important;\n        width: 173px !important;\n        display: inline-block;\n        float: left !important;\n        box-shadow: 0 0 0 0.5px rgba(50,50,93,.17), 0 2px 5px 0 rgba(50,50,93,.1), 0 1px 1.5px 0 rgba(0,0,0,.07), 0 1px 2px 0 rgba(0,0,0,.08), 0 0 0 0 transparent!important;\n}\n.addeventatc.pinkoutlinebtn {\n        float: left;\n}\n@media(max-width:991px){\n.addeventatc.pinkoutlinebtn{\nmargin-left:0 !important;\nmargin-right:10px;\nmargin-bottom:10px;\n}\nbutton.share-event{\nmargin-left:0 !important;\n}\n}\n@media(max-width:767px){\n.addeventatc.pinkoutlinebtn{margin-left:10px !important;\n}\nbutton.share-event{\nmargin-left:5px !important;\n}\n}\n\n", ""]);

// exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.col-sm-7 .container-responsive h4[data-v-46d191b4] {\n    color: #f0617d;\n    border-bottom: 2px solid #f0617d;\n    padding-bottom: 10px;\n    margin-bottom: 15px;\n}\n.resource-content .sliderEventBox .slick-slide img[data-v-46d191b4] {\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center;\n       object-position: center;\n    height:auto;\n}\n.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent[data-v-46d191b4] {\n    border-radius: 3px;\n    margin: 20px 0 0;\n}\n.sliderEventBox p[data-v-46d191b4] {\n    min-height: 155px;\n}\n/*.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent.disabled ,*/\n/*.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent.disabled:hover {*/\n/*background: transparent;*/\n/*color: #e08383 !important;*/\n/*}*/\n@media(min-width:768px){\n.sliderTalkBox>h2+p[data-v-46d191b4] {\n        position: relative;\n        top: -40px;\n        color: #303030;\n        font-size: 15px;\n        font-weight: 500;\n        font-family: sans-serif;\n        letter-spacing: 0.3px;\n}\n.resource-content .sliderEventBox[data-v-46d191b4] {\n        margin: 70px 0 100px 0;\n}\n}\n.resource-content .communityBox button[data-v-46d191b4]{width:auto;\n}\n.resource-content .communityBox h5[data-v-46d191b4] {\n    margin: 0 0 35px 0;\n}\n.resource-content .sliderTalkBox .slick-slide p[data-v-46d191b4] {\n    margin: 0 0 20px 0;\n    color: #303030;\n    font-size: 14px;\n    line-height: 22px;\n    font-family: sans-serif;\n    padding: 0 10px 0 10px;\n    text-align: left;\n    letter-spacing: 0.5px;\n}\n.selected-event[data-v-46d191b4] {\n    content: \"\\F00C\";\n    font: normal normal normal 14px/1 FontAwesome;\n    position: absolute;\n    color: white;\n    right: 20.5px;\n    top: 24px;\n    font-size: 18px;\n}\n.slick-slide button.button[data-v-46d191b4] {\n    color: #f0617d;\n    border: 1px solid #f0617d;\n    background: none;\n    outline: none;\n    font-size: 16px;\n    font-family: sans-serif;\n    letter-spacing: 0.3px;\n    float: left;\n    margin-left: 10px;\n    width: 278px;\n    padding: 18px 15px 14px;\n    border-radius: 3px;\n    margin-top: 10px;\n}\n.sliderTalkBox .slider p[data-v-46d191b4] {\n    min-height: 160px;\n}\n.resource-content .sliderTalkBox .slick-slide h5[data-v-46d191b4] {\n    text-align: left;\n    padding: 0 10px;\n}\n.sliderTalkBox .slider h2[data-v-46d191b4]{\n    color: #303030;\n    margin: 15px 0 15px 0;\n    line-height: 31px;\n    text-align: left;\n    font-family: sans-serif;\n    padding: 0 20px 0 10px;\n    font-size: 20px;\n    text-transform: inherit;\n}\nimg[data-v-46d191b4] {\n    max-width: 100%;\n}\n.container-responsive[data-v-46d191b4] {\n    text-align: left;\n}\nh3[data-v-46d191b4] {\n    background: #f0617d;\n    color: #fff;\n    padding: 5px;\n}\nh4[data-v-46d191b4] {\n    font-weight: 900;\n    font-size: 18px;\n}\n.smlbuttonholder[data-v-46d191b4] {\n    padding: 20px 0 30px;\n}\n.fc .fc-toolbar>*>h2[data-v-46d191b4] {\n    font-size: 21px;\n    font-weight: 900;\n    color: #232323;\n    letter-spacing: 0;\n}\n.advertizmentbox[data-v-46d191b4] {\n    border: 2px solid #ddd;\n    margin: 0 0 30px;\n    /*padding: 20px;*/\n}\n\n/*.advertizmentbox:empty:after {\n    content: \"Advertisement Box\";\n    display: block;\n    text-align: center;\n    padding: 70px 0;\n    font-weight: 900;\n}*/\nbutton.yellowbtn[data-v-46d191b4] {\n    background: #f7f75e;\n    border: 0 none transparent;\n    padding: 8px 20px;\n    line-height: 1;\n    display: block;\n    margin: 0 auto 20px;\n    border-radius: 30px;\n}\n.socialblocks > a >i[data-v-46d191b4] {\n    color: #fff;\n    margin: 0 0 0;\n    line-height: 70px;\n    display: block;\n}\n.socialblocks > a[data-v-46d191b4] {\n    background: #f0617d;\n    width: 70px;\n    display: inline-block;\n    text-align: center;\n    line-height: 70px;\n}\n.socialblocks > a[data-v-46d191b4] {\n}\n.socialblocks[data-v-46d191b4] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n}\nh3.adboxheading[data-v-46d191b4] {\n    margin-bottom: 30px;\n}\n.container[data-v-46d191b4] {\n    padding-bottom: 50px;\n}\n/*Changes for Corporate Modal*/\n.sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader[data-v-46d191b4] {\n    background: #f0617d;\n    color: #fff;\n    font-size: 25px;\n    text-align: left;\n    padding: 15px 25px;\n    font-weight: 700;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body p[data-v-46d191b4]{\n    padding: 0;\n    margin: 0 0 20px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-46d191b4] {\n    background: #fff;\n    color: #333;\n    border: 1px solid #cacaca;\n    width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body[data-v-46d191b4] {\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink[data-v-46d191b4] {\n    background: #f0617d;\n    width: 100%;\n    margin: 0;\n    border: 1px solid #f0617d;\n}\n@media(max-width:475px){\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-46d191b4] {\n        padding-left: 0;\n        padding-right: 0;\n}\n}\n.row.sharefb[data-v-46d191b4] {\n    background: #eee;\n    margin-left: 0;\n    margin-right: 0;\n}\n.row.sharefb > div[data-v-46d191b4] {\n    padding: 5px;\n    text-align: left;\n}\n.row.sharefb .col-sm-5 img[data-v-46d191b4] {\n    max-width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-46d191b4] {\n    font-size: 14px;\n    font-weight: 300;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6[data-v-46d191b4] {\n    text-transform: uppercase;\n    font-size: 12px;\n    margin: 10px 0 5px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4[data-v-46d191b4] {\n    margin: 0 0 5px;\n    font-weight:700;\n}\n.showmobile[data-v-46d191b4]{display:none;\n}\n@media(max-width:767px){\n.usernamenimg.text-left[data-v-46d191b4] {\n        display: none;\n}\n.showmobile[data-v-46d191b4]{\n        display: block;\n}\n.alert.alert-default[data-v-46d191b4] {\n        background: #eee;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-46d191b4] {\n        display: none;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow[data-v-46d191b4] {\n        top: 1px;\n        right: -13px;\n}\n.row.sharefb[data-v-46d191b4] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.pinksidebarmin[data-v-46d191b4]{\n        padding:0 !important;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        -ms-flex-preferred-size: auto;\n            flex-basis: auto;\n        display: flex ;\n        -ms-flex-align: stretch ;\n            align-items: stretch ;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.pinksidebarmin > *[data-v-46d191b4] {\n        padding: 6px 0 !important;\n        margin: 0 !important;\n        -ms-flex: 100;\n            flex: 100;\n        text-align:center;\n}\n}\n.watchVideoModal .modal-dialog .modal-body p[data-v-46d191b4] {\n    padding: 16px 60px 19px 60px;\n}\n.modal[data-v-46d191b4] {\n    z-index: 999999;\n}\n\n", ""]);

// exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.contact-us-form .contact-form .form form .form-group textarea.form-control {\n    max-height: 100px;\n    min-height: 100px;\n    min-width: 100%;\n    max-width: 100%;\n    width: 100% !important;\n    height: 100px !important;\n    resize: none;\n}\n.contact-us-form .contactformtexttone p{font-size:18px\n}\n", ""]);

// exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.bounce-enter-active[data-v-476d1140] {\n        animation: bounce-in .5s;\n}\n.bounce-leave-active[data-v-476d1140] {\n    animation: bounce-in .1s reverse;\n}\n@keyframes bounce-in {\n0% {\n            transform: scale(0);\n}\n50% {\n            transform: scale(1.5);\n}\n100% {\n            transform: scale(1);\n}\n}\n#contactus_phone[data-v-476d1140] {\n    padding: 0 30px 0 15px;\n    height: 60px;\n    margin-bottom: 20px;\n}\n.contact-us-form p[data-v-476d1140] {\n    font-size: 22px;\n    font-family: sans-serif;\n    letter-spacing: 0.5px;\n    margin: 0 0 30px 0;\n    font-weight: normal;\n    line-height: 1;\n    color: #777777;\n}\n.contact-us-form h2[data-v-476d1140] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 40px 0 15px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n}\n", ""]);

// exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.JWvideoHandler>button.pink-button[data-v-4ac67fc6] {\n    position: absolute;\n    z-index: 100;\n    bottom: 60px;\n    left: 50%;\n    transform: translateX(-50%);\n    color: white;\n    font-size: 16px;\n    border: none;\n    width: 253px;\n    padding: 14px 15px 12px;\n    border-radius: 3px;\n    background: rgb(240, 97, 125) !important;\n    text-transform: uppercase !important;\n    letter-spacing: 1px !important;\n}\n.JWvideoHandler[data-v-4ac67fc6] {\n    position: relative;\n}\n.jwplayer.jw-flag-fullscreen+button[data-v-4ac67fc6] {\n    position: fixed;\n    z-index: 999999999999999999;\n}\n@media(max-width:1024px) {\n.JWvideoHandler[data-v-4ac67fc6] {\n        width: 100%;\n        display: table;\n}\n}\n@media(max-width:767px){\n.JWvideoHandler>button.pink-button[data-v-4ac67fc6] {\n        font-size: 14px;\n        border: none;\n        width: auto;\n        padding: 8px 10px 5px;\n}\n}\n.fade-enter-active[data-v-4ac67fc6], .fade-leave-active[data-v-4ac67fc6] {\n    transition: opacity 1s;\n}\n.fade-enter[data-v-4ac67fc6], .fade-leave-to[data-v-4ac67fc6] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\n@media(min-width:1350px){\n.JWvideoHandler>button.pink-button[data-v-4ac67fc6]{\n        bottom:15%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.list-complete-item {\n    padding: 4px;\n    margin-top: 4px;\n    border: solid 1px;\n    transition: all 1s;\n}\n.list-complete-enter, .list-complete-leave-active {\n    opacity: 0;\n}\nbody{\n    -ms-overflow-style:scrollbar;\n}\n.fixgraybgpl .video-player .left-video-icons{background:transparent;\n}\n@media(max-width:992px) {\n.side-content pre {\n        overflow: scroll;\n        white-space: pre-wrap;\n}\n.fixgraybgpl .video-player .jwplayer.jw-flag-aspect-mode {\n        height: auto !important;\n}\n}\n/*@media (max-width: 991px) and (min-width: 320px){\n    .fixgraybgpl .video-player .reset-video-width {\n        max-width:85%;\n    }\n}*/\n", ""]);

// exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.playlistholderdiv .plusicon.btn-group[data-v-4d9ff14b] {\n     z-index: 100;\n}\n.clickable-content[data-v-4d9ff14b] {\n     overflow: hidden;\n     margin-top: -10px;\n     padding-top: 10px;\n     width: calc(100% + 30px);\n     position: relative;\n     z-index: 50;\n}\n.plusicon.btn-group[data-v-4d9ff14b] {\n     z-index: 100;\n}\n.video-player-wrapper .watch-again .current-video-img img[data-v-4d9ff14b] {\n     -o-object-fit: cover;\n        object-fit: cover;\n}\n.video-player .right-video-icons .enjoy-hover-box[data-v-4d9ff14b] {\n     width: 20%;\n     height: 100%;\n     background: #f0617d;\n     position: absolute;\n     top: 0;\n     right: 0;\n     padding: 15% 0px 0;\n     text-align: left;\n}\n.video-player .right-video-icons .enjoy-hover-box button.btn[data-v-4d9ff14b] {\n     margin: 0 0 10px;\n     border-color: white;\n     border-radius: 3px;\n     padding: 12px 0 13px;\n     display: block;\n     width: 80%;\n     margin: 0px auto 10px;\n     color: #fff;\n}\n.video-player-wrapper .tooltipBox[data-v-4d9ff14b] {\n     width: 100%;\n     text-align: center;\n     padding-bottom: 10px;\n     height: 35px;\n     margin-top: 24px;\n}\n@media (min-width:768px) {\n.video-player .right-video-icons .enjoy-hover-box[data-v-4d9ff14b] {\n         padding: 117px 0px 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating[data-v-4d9ff14b] {\n         overflow: hidden;\n         position: absolute;\n         left: 0;\n         right: 0;\n         bottom: 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating p[data-v-4d9ff14b] {\n         color: white;\n         display: block;\n         font-size: 16px;\n         letter-spacing: 0.5px;\n         margin-top: 23px;\n         margin-bottom: 20px;\n         padding: 0 10%;\n         text-align: center;\n}\n}\n.video-player .right-video-icons .rate-hover-box span[data-v-4d9ff14b] {\n     margin-bottom: 20px;\n}\n.video-player .right-video-icons .rate-hover-box button[data-v-4d9ff14b]:hover {\n     background: #ac2925;\n}\n.video-player .btn-danger[data-v-4d9ff14b]:focus {\n     background: inherit;\n     border-color: inherit;\n     outline: none;\n}\n.video-player .right-video-icons div button.btn-danger[data-v-4d9ff14b]:hover{\n     background:rgba(0,0,0,0.1);\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-4d9ff14b]:hover{\n     background:#ac2925;\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-4d9ff14b]:focus{\n color: #fff;\n background-color: #ac2925;\n border-color: #fff;\n}\n.profile-content img[data-v-4d9ff14b] {\n     -o-object-fit: cover;\n        object-fit: cover;\n     -o-object-position: center center;\n        object-position: center center;\n}\n.playlistholderdiv[data-v-4d9ff14b] {\n     width: 15%;\n     color: #fff;\n     position: absolute;\n     top: 0;\n     right: 0;\n     padding: 15px;\n     bottom: 0;\n     overflow-y: auto;\n}\n.playlistholderdiv img[data-v-4d9ff14b] {\n     max-width: 100%;\n     margin: 0 0 10px;\n}\n.fixgraybgpl .video-player-background[data-v-4d9ff14b] {\n     position: relative;\n}\n.playlistholderdiv h4[data-v-4d9ff14b] {\n     font-size: 16px;\n}\n.playlistholderdiv p[data-v-4d9ff14b] {\n     font-size: 14px !important;\n}\n.playlistentrydiv[data-v-4d9ff14b] {\n     position: relative;\n}\n.playlistentrydiv.playing[data-v-4d9ff14b]:after {\n     position: absolute;\n     right: 0;\n     text-align: center;\n     font-weight: 900;\n     text-shadow: 0 1px 3px rgba(0,0,0,0.75);\n     content: \"\";\n     height: 0;\n     width: 0;\n     border: 10px solid transparent;\n     top: 12px;\n     border-left-color: #f0617d;\n     transform: translateY(-0%);\n     left: 2px;\n}\n.playlistentrydiv.playingMobile[data-v-4d9ff14b]:after {\n     position: absolute;\n     right: 0;\n     text-align: center;\n     font-weight: 900;\n     text-shadow: 0 1px 3px rgba(0,0,0,0.75);\n     content: \"\";\n     height: 0;\n     width: 0;\n     border: 10px solid transparent;\n     top: 2px;\n     border-left-color: #f0617d;\n     transform: translateY(-0%);\n     left: 2px;\n}\n@media(max-width:5992px) {\n.playlistholderdiv[data-v-4d9ff14b] {\n         width: 100%;\n         position: static;\n         overflow: visible;\n}\n.playlistholderdiv img[data-v-4d9ff14b] {\n         width: 100px;\n         float: left;\n         margin: 0px 15px 10px 0;\n}\n.playlistentrydiv[data-v-4d9ff14b] {\n         overflow: hidden;\n         text-align: left;\n         border-bottom: 1px solid #666;\n         margin: 0 0 0px;\n}\n.playlistentrydiv[data-v-4d9ff14b] {\n         transition: all 0.5s ease;\n         cursor: move;\n}\n.playlistentrydiv[data-v-4d9ff14b]:hover {\n         background: #fff;\n}\n.playlistentrydiv:hover > p[data-v-4d9ff14b] {\n         transition: all 0.5s ease;\n         color: #000;\n}\ndiv:last-of-type > .playlistentrydiv[data-v-4d9ff14b] {\n         margin: 0;\n         border-bottom: 0 none transparent;\n}\ndiv:last-of-type > .playlistentrydiv img[data-v-4d9ff14b] {\n         margin-bottom: 0;\n}\n}\n.btn-group.plusicon[data-v-4d9ff14b] {\n     position: absolute;\n     right: 50px;\n     bottom: 0px;\n     height: 29px;\n}\nli.divider[data-v-4d9ff14b] {\n     border-bottom: 1px solid #ddd;\n     margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-4d9ff14b] {\n     background: transparent;\n     border: 0 none transparent;\n     padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-4d9ff14b]{\n     font-size: 21px;\n     top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-4d9ff14b]{\n     padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-4d9ff14b],\n button.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-4d9ff14b] {\n     padding: 3px 15px;\n     margin-bottom: 5px;\n     display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-4d9ff14b],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-4d9ff14b] {\n     height: 30px;\n     padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-4d9ff14b],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-4d9ff14b] {\n     position: absolute;\n     top: 6px;\n     font-size:24px;\n     right:20px;\n     cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-4d9ff14b],\n button.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-4d9ff14b]{\n     position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-4d9ff14b],\n button.dropdown-toggle.ellipsis.pull-right+ ul[data-v-4d9ff14b]{\n     left: 0;\n     right: auto;\n     width: 230px;\n     background: #fff;\n     border: 1px solid #ddd;\n     border-radius: 5px;\n     top: 100%;\n     position: absolute;\n     z-index: 5000;\n     list-style: none;\n     text-align: left;\n     padding: 15px;\n}\n.backdropformenu[data-v-4d9ff14b]{\n     position:fixed;\n     z-index:4900;\n     top:0;\n     left:0;\n     right:0;\n     bottom:0;\n     background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-4d9ff14b]{\n     height: 24px;\n     width: 37px;\n}\n.menuiconbutton[data-v-4d9ff14b]{\n     height: 24px;\n     width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-4d9ff14b] {\n     left: auto ;\n     right: 0;\n}\n.fade-enter-active[data-v-4d9ff14b], .fade-leave-active[data-v-4d9ff14b] {\n     transition: opacity .5s;\n}\n.fade-enter[data-v-4d9ff14b], .fade-leave-to[data-v-4d9ff14b] /* .fade-leave-active below version 2.1.8 */ {\n     opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-4d9ff14b]{\n     font-size: 10px;\n}\nspan.removed[data-v-4d9ff14b] {\n     color: red;\n}\nspan.added[data-v-4d9ff14b] {\n     color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-4d9ff14b] {\n     position: relative;\n     display:block;\n}\n/*Copied for Playlist Options*/\n.btn-group.plusicon[data-v-4d9ff14b] {\n     position: absolute;\n     right: 50px;\n     bottom: 0px;\n     height: 29px;\n}\nli.divider[data-v-4d9ff14b] {\n     border-bottom: 1px solid #ddd;\n     margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-4d9ff14b] {\n     background: transparent;\n     border: 0 none transparent;\n     padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-4d9ff14b]{\n     font-size: 21px;\n     top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-4d9ff14b]{\n     padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-4d9ff14b],\n button.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-4d9ff14b] {\n     padding: 3px 15px;\n     margin-bottom: 5px;\n     display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-4d9ff14b],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-4d9ff14b] {\n     height: 30px;\n     padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-4d9ff14b],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-4d9ff14b] {\n     position: absolute;\n     top: 6px;\n     font-size:24px;\n     right:20px;\n     cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-4d9ff14b],\n button.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-4d9ff14b]{\n     position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-4d9ff14b],\n button.dropdown-toggle.ellipsis.pull-right+ ul[data-v-4d9ff14b]{\n     left: 0;\n     right: auto;\n     width: 230px;\n     background: #fff;\n     border: 1px solid #ddd;\n     border-radius: 5px;\n     top: 100%;\n     position: absolute;\n     z-index: 5000;\n     list-style: none;\n     text-align: left;\n     padding: 15px;\n}\n.profile .tabContent .menuiconbutton[data-v-4d9ff14b]{\n     height: 24px;\n     width: 37px;\n}\n.menuiconbutton[data-v-4d9ff14b]{\n     height: 24px;\n     width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-4d9ff14b] {\n     left: auto ;\n     right: 0;\n}\n.fade-enter-active[data-v-4d9ff14b], .fade-leave-active[data-v-4d9ff14b] {\n     transition: opacity .5s;\n}\n.fade-enter[data-v-4d9ff14b], .fade-leave-to[data-v-4d9ff14b] /* .fade-leave-active below version 2.1.8 */ {\n     opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-4d9ff14b]{\n     font-size: 10px;\n}\nspan.removed[data-v-4d9ff14b] {\n     color: red;\n}\nspan.added[data-v-4d9ff14b] {\n     color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-4d9ff14b] {\n     position: relative;\n     display:block;\n}\n.playlistholderdiv button.dropdown-toggle.ellipsis.pull-right[data-v-4d9ff14b] {\n     display: block;\n     top: 0px;\n     font-size: 0;\n     line-height: 1;\n     color: #f0617d;\n     height: 10px;\n     width: 30px;\n     right: 0;\n}\n.playlistholderdiv .plusicon.btn-group[data-v-4d9ff14b] {\n     top: 0;\n     right: 0;\n     width: 100%;\n     max-width:350px\n}\n.playlistholderdiv button.dropdown-toggle.ellipsis.pull-right[data-v-4d9ff14b]:before {\n     content: \"...\";\n     position: absolute;\n     top: -10px;\n     line-height: 0;\n     font-size: 50px;\n     display: block;\n     right: 5px;\n     letter-spacing: -2px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-4d9ff14b] {\n     padding: 5px;\n     top: 11px;\n     width: 100%;\n     border-radius:0;\n     border:0 none transparent;\n}\n.playlistholderdiv li.divider[data-v-4d9ff14b] {\n     margin: 2px 0 4px;\n}\n.playlistholderdiv button.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-4d9ff14b] {\n     padding: 0 !important;\n     margin: 0;\n     font-size: 10px;\n}\n.playlistholderdiv input[type=\"checkbox\"][data-v-4d9ff14b] {position: relative;top: 3px;\n}\n.playlistentrydiv[data-v-4d9ff14b] {\n     overflow:visible !important;\n     clear:both;\n     display:table;\n     width:100%;\n     padding-top:10px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-4d9ff14b] {\n     color: #000;\n}\n.playlistholderdiv>div>span>div:last-of-type .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-4d9ff14b] {\n     top: auto;\n     bottom: 20px;\n}\n.playlistholderdiv>div>span>div:last-of-type .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-4d9ff14b] {\n     top: 11px;\n     bottom: auto;\n}\n.playlistentrydiv[data-v-4d9ff14b] {\n     padding-right: 30px;\n}\n", ""]);

// exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\nbody footer span.input-group-addon.cursor > button {\n    height: 56px;\n    display: block;\n    margin: 0;\n    padding: 0;\n    float: none;\n    width: 100%;\n}\nbody footer span.input-group-addon.cursor {\n    padding: 0;\n    margin: 0;\n}\nfooter .input-group.input-md.float-right.sendrefrel .input-group-addon{\n    width:35%\n}\n", ""]);

// exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.row1[data-v-4f319b61] {margin-top: 2em\n}\n.form-control-1[data-v-4f319b61] {\n    min-width: 250px !important;\n}\n.form-control-2[data-v-4f319b61] {\n    min-width: 100px !important;\n}\n.footer-container[data-v-4f319b61] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.logo-img[data-v-4f319b61] {\n    max-width: 100%; /* Ensure the logo doesn't exceed the container width */\n    height: auto; /* Maintain the aspect ratio while resizing */\n    max-height: 100px; /* Set the maximum height for the logo */\n}\n.footer-compnay-name[data-v-4f319b61] {\n    color: #fff !important;\n    display: inline-block;\n    padding: 0;\n}\nfooter .navbar-nav li[data-v-4f319b61] {\n    float: none;\n    width:auto !important;\n    text-align: center;\n    display: inline-block;\n    padding: 0 15px;\n}\nfooter .footer-links[data-v-4f319b61] {\n    margin-left:auto;\n    margin-right:auto;\n    float:none;\n    text-align: center;\n}\nfooter .footer-links a[data-v-4f319b61] {\n    margin-left:1.25em;\n    margin-right:1.25em;\n}\nfooter form#footer_form + .footer-links[data-v-4f319b61] {\n    margin-left: 0 ;\n    margin-right: 0 ;\n    float:left;\n    text-align:left;\n}\nfooter form#footer_form + .footer-links a[data-v-4f319b61] {\n    margin-left:2.5em;\n    margin-right:0;\n}\n@media(max-width:991px){\nfooter .footer-links a[data-v-4f319b61] {\n    margin: 1em !important;\n    float: none;\n}\nfooter .footer-links[data-v-4f319b61] {\n    text-align: center !important;\n}\n}\nfooter .nav-pills li a[data-v-4f319b61] {\n    color: #fff;\n}\n", ""]);

// exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\ninput.form-control , #resetpassword_password {\n    height: 57px;\n    border-radius: 0;\n    padding:10px;\n}\nspan.form-control-feedback {\n    height: 47px;\n    line-height: 47px;\n}\nsvg.VuePassword__Meter {\n    margin: 20px 0 0;\n}\n.formButton.btn.btn-block{\n    outline: none;\n    border-radius: 0;\n    font-family: 'Open Sans', sans-serif;\n    font-size: 16px;\n    padding: 1em 1em;\n    background: #f0617d;\n    border: 1px solid #f0617d;\n    color: #fff;\n    width: 100%;\n    margin: 20px 0 ;\n    height: auto;\n}\nbutton#resetpassword_cancel {\n    background:#ddd;\n    border-color:#ddd;\n}\n\n", ""]);

// exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.set-error[data-v-55855f0b]{\n    border-color: #a94442 !important;\n    color:#a94442 !important;\n}\n.form[data-v-55855f0b]{\n    text-align: left;\n    width: 40%;\n    margin: 50px auto;\n    overflow: hidden;\n}\n.h1[data-v-55855f0b]{\n    font-size: 32px;\n    color: #009cf6;\n    font-weight: lighter;\n    margin: 0 0 25px 0;\n}\np[data-v-55855f0b]{\n    font-size: 14px;\n    color: #979797;\n    margin: 0;\n}\n.padding-minus[data-v-55855f0b]{\n    padding:0;\n}\n.form .form-input[data-v-55855f0b]{\n    margin-bottom: 25px ;\n}\n.form .forgotPassword[data-v-55855f0b]{\n    float: right;\n    color: black\n}\n.form .forgotPassword[data-v-55855f0b]:hover{\n    float: right;\n    color: #337ab7;\n}\n@media (max-width:767px){\n.form[data-v-55855f0b] {\n        width: 100%;\n}\n}\n.formButton[data-v-55855f0b]{\n    margin: 25px 0 50px;\n    width: 130px;\n    height: 47px;\n    color: #91ab45;\n    border-color: #91ab45;\n    background-color: transparent;\n    transition: 0.5s;\n    padding:0;\n}\n.formButton a[data-v-55855f0b]{\n    display: block;\n    padding: 13px 12px;\n    color: #91ab45;\n    text-decoration: none;\n    transition: 0.5s;\n}\n.formButton[data-v-55855f0b]:hover{\n    border-color: #91ab45;\n    background-color: #91ab45;\n    transition: 0.5s;\n    color: #ffffff;\n}\n.btn-spinner[data-v-55855f0b]{\n    bottom:15px\n}\nh1[data-v-55855f0b] {\n    color: #f0617d;\n    margin: 70px 0 30px;\n}\n\n", ""]);

// exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports
exports.push([module.i, "@import url(https://maxcdn.bootstrapcdn.com/font-awesome/latest/css/font-awesome.min.css);", ""]);
exports.push([module.i, "@import url(https://unpkg.com/vue-multiselect@2.0.2/dist/vue-multiselect.min.css);", ""]);
exports.push([module.i, "@import url(https://unpkg.com/animate.css@3.5.1/animate.css);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Quicksand:300,400);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:100, 300);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto+Mono:100,300);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Montserrat:100,200,300,400,500,600,700,800,900);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Playfair+Display:400,700,900);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Zilla+Slab:300,400,500,600,700);", ""]);
exports.push([module.i, "@import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,700);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto:300);", ""]);

// module
exports.push([module.i, "\n@charset \"UTF-8\";\n/*!\n * Bootstrap v3.4.1 (https://getbootstrap.com/)\n * Copyright 2011-2019 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */\nhtml {\n  font-family: sans-serif;\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n}\nbody {\n  margin: 0;\n}\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline;\n}\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n[hidden],\ntemplate {\n  display: none;\n}\na {\n  background-color: transparent;\n}\na:active,\na:hover {\n  outline: 0;\n}\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  text-decoration: underline dotted;\n}\nb,\nstrong {\n  font-weight: bold;\n}\ndfn {\n  font-style: italic;\n}\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\nmark {\n  background: #ff0;\n  color: #000;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsup {\n  top: -0.5em;\n}\nsub {\n  bottom: -0.25em;\n}\nimg {\n  border: 0;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\nfigure {\n  margin: 1em 40px;\n}\nhr {\n  box-sizing: content-box;\n  height: 0;\n}\npre {\n  overflow: auto;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\nbutton {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\ninput {\n  line-height: normal;\n}\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n  box-sizing: content-box;\n}\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\nlegend {\n  border: 0;\n  padding: 0;\n}\ntextarea {\n  overflow: auto;\n}\noptgroup {\n  font-weight: bold;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\ntd,\nth {\n  padding: 0;\n}\n\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */\n@media print {\n*,\n  *:before,\n  *:after {\n    color: #000 !important;\n    text-shadow: none !important;\n    background: transparent !important;\n    box-shadow: none !important;\n}\na,\n  a:visited {\n    text-decoration: underline;\n}\na[href]:after {\n    content: \" (\" attr(href) \")\";\n}\nabbr[title]:after {\n    content: \" (\" attr(title) \")\";\n}\na[href^=\"#\"]:after,\n  a[href^=\"javascript:\"]:after {\n    content: \"\";\n}\npre,\n  blockquote {\n    border: 1px solid #999;\n    page-break-inside: avoid;\n}\nthead {\n    display: table-header-group;\n}\ntr,\n  img {\n    page-break-inside: avoid;\n}\nimg {\n    max-width: 100% !important;\n}\np,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n}\nh2,\n  h3 {\n    page-break-after: avoid;\n}\n.navbar {\n    display: none;\n}\n.btn > .caret,\n  .dropup > .btn > .caret {\n    border-top-color: #000 !important;\n}\n.label {\n    border: 1px solid #000;\n}\n.table {\n    border-collapse: collapse !important;\n}\n.table td,\n    .table th {\n      background-color: #fff !important;\n}\n.table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ddd !important;\n}\n}\n@font-face {\n  font-family: \"Glyphicons Halflings\";\n  src: url(" + __webpack_require__(342) + ");\n  src: url(" + __webpack_require__(342) + "?#iefix) format(\"embedded-opentype\"), url(" + __webpack_require__(855) + ") format(\"woff2\"), url(" + __webpack_require__(854) + ") format(\"woff\"), url(" + __webpack_require__(853) + ") format(\"truetype\"), url(" + __webpack_require__(851) + "#glyphicons_halflingsregular) format(\"svg\");\n}\n.glyphicon {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  font-family: \"Glyphicons Halflings\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.glyphicon-asterisk:before {\n  content: \"*\";\n}\n.glyphicon-plus:before {\n  content: \"+\";\n}\n.glyphicon-euro:before,\n.glyphicon-eur:before {\n  content: \"\\20AC\";\n}\n.glyphicon-minus:before {\n  content: \"\\2212\";\n}\n.glyphicon-cloud:before {\n  content: \"\\2601\";\n}\n.glyphicon-envelope:before {\n  content: \"\\2709\";\n}\n.glyphicon-pencil:before {\n  content: \"\\270F\";\n}\n.glyphicon-glass:before {\n  content: \"\\E001\";\n}\n.glyphicon-music:before {\n  content: \"\\E002\";\n}\n.glyphicon-search:before {\n  content: \"\\E003\";\n}\n.glyphicon-heart:before {\n  content: \"\\E005\";\n}\n.glyphicon-star:before {\n  content: \"\\E006\";\n}\n.glyphicon-star-empty:before {\n  content: \"\\E007\";\n}\n.glyphicon-user:before {\n  content: \"\\E008\";\n}\n.glyphicon-film:before {\n  content: \"\\E009\";\n}\n.glyphicon-th-large:before {\n  content: \"\\E010\";\n}\n.glyphicon-th:before {\n  content: \"\\E011\";\n}\n.glyphicon-th-list:before {\n  content: \"\\E012\";\n}\n.glyphicon-ok:before {\n  content: \"\\E013\";\n}\n.glyphicon-remove:before {\n  content: \"\\E014\";\n}\n.glyphicon-zoom-in:before {\n  content: \"\\E015\";\n}\n.glyphicon-zoom-out:before {\n  content: \"\\E016\";\n}\n.glyphicon-off:before {\n  content: \"\\E017\";\n}\n.glyphicon-signal:before {\n  content: \"\\E018\";\n}\n.glyphicon-cog:before {\n  content: \"\\E019\";\n}\n.glyphicon-trash:before {\n  content: \"\\E020\";\n}\n.glyphicon-home:before {\n  content: \"\\E021\";\n}\n.glyphicon-file:before {\n  content: \"\\E022\";\n}\n.glyphicon-time:before {\n  content: \"\\E023\";\n}\n.glyphicon-road:before {\n  content: \"\\E024\";\n}\n.glyphicon-download-alt:before {\n  content: \"\\E025\";\n}\n.glyphicon-download:before {\n  content: \"\\E026\";\n}\n.glyphicon-upload:before {\n  content: \"\\E027\";\n}\n.glyphicon-inbox:before {\n  content: \"\\E028\";\n}\n.glyphicon-play-circle:before {\n  content: \"\\E029\";\n}\n.glyphicon-repeat:before {\n  content: \"\\E030\";\n}\n.glyphicon-refresh:before {\n  content: \"\\E031\";\n}\n.glyphicon-list-alt:before {\n  content: \"\\E032\";\n}\n.glyphicon-lock:before {\n  content: \"\\E033\";\n}\n.glyphicon-flag:before {\n  content: \"\\E034\";\n}\n.glyphicon-headphones:before {\n  content: \"\\E035\";\n}\n.glyphicon-volume-off:before {\n  content: \"\\E036\";\n}\n.glyphicon-volume-down:before {\n  content: \"\\E037\";\n}\n.glyphicon-volume-up:before {\n  content: \"\\E038\";\n}\n.glyphicon-qrcode:before {\n  content: \"\\E039\";\n}\n.glyphicon-barcode:before {\n  content: \"\\E040\";\n}\n.glyphicon-tag:before {\n  content: \"\\E041\";\n}\n.glyphicon-tags:before {\n  content: \"\\E042\";\n}\n.glyphicon-book:before {\n  content: \"\\E043\";\n}\n.glyphicon-bookmark:before {\n  content: \"\\E044\";\n}\n.glyphicon-print:before {\n  content: \"\\E045\";\n}\n.glyphicon-camera:before {\n  content: \"\\E046\";\n}\n.glyphicon-font:before {\n  content: \"\\E047\";\n}\n.glyphicon-bold:before {\n  content: \"\\E048\";\n}\n.glyphicon-italic:before {\n  content: \"\\E049\";\n}\n.glyphicon-text-height:before {\n  content: \"\\E050\";\n}\n.glyphicon-text-width:before {\n  content: \"\\E051\";\n}\n.glyphicon-align-left:before {\n  content: \"\\E052\";\n}\n.glyphicon-align-center:before {\n  content: \"\\E053\";\n}\n.glyphicon-align-right:before {\n  content: \"\\E054\";\n}\n.glyphicon-align-justify:before {\n  content: \"\\E055\";\n}\n.glyphicon-list:before {\n  content: \"\\E056\";\n}\n.glyphicon-indent-left:before {\n  content: \"\\E057\";\n}\n.glyphicon-indent-right:before {\n  content: \"\\E058\";\n}\n.glyphicon-facetime-video:before {\n  content: \"\\E059\";\n}\n.glyphicon-picture:before {\n  content: \"\\E060\";\n}\n.glyphicon-map-marker:before {\n  content: \"\\E062\";\n}\n.glyphicon-adjust:before {\n  content: \"\\E063\";\n}\n.glyphicon-tint:before {\n  content: \"\\E064\";\n}\n.glyphicon-edit:before {\n  content: \"\\E065\";\n}\n.glyphicon-share:before {\n  content: \"\\E066\";\n}\n.glyphicon-check:before {\n  content: \"\\E067\";\n}\n.glyphicon-move:before {\n  content: \"\\E068\";\n}\n.glyphicon-step-backward:before {\n  content: \"\\E069\";\n}\n.glyphicon-fast-backward:before {\n  content: \"\\E070\";\n}\n.glyphicon-backward:before {\n  content: \"\\E071\";\n}\n.glyphicon-play:before {\n  content: \"\\E072\";\n}\n.glyphicon-pause:before {\n  content: \"\\E073\";\n}\n.glyphicon-stop:before {\n  content: \"\\E074\";\n}\n.glyphicon-forward:before {\n  content: \"\\E075\";\n}\n.glyphicon-fast-forward:before {\n  content: \"\\E076\";\n}\n.glyphicon-step-forward:before {\n  content: \"\\E077\";\n}\n.glyphicon-eject:before {\n  content: \"\\E078\";\n}\n.glyphicon-chevron-left:before {\n  content: \"\\E079\";\n}\n.glyphicon-chevron-right:before {\n  content: \"\\E080\";\n}\n.glyphicon-plus-sign:before {\n  content: \"\\E081\";\n}\n.glyphicon-minus-sign:before {\n  content: \"\\E082\";\n}\n.glyphicon-remove-sign:before {\n  content: \"\\E083\";\n}\n.glyphicon-ok-sign:before {\n  content: \"\\E084\";\n}\n.glyphicon-question-sign:before {\n  content: \"\\E085\";\n}\n.glyphicon-info-sign:before {\n  content: \"\\E086\";\n}\n.glyphicon-screenshot:before {\n  content: \"\\E087\";\n}\n.glyphicon-remove-circle:before {\n  content: \"\\E088\";\n}\n.glyphicon-ok-circle:before {\n  content: \"\\E089\";\n}\n.glyphicon-ban-circle:before {\n  content: \"\\E090\";\n}\n.glyphicon-arrow-left:before {\n  content: \"\\E091\";\n}\n.glyphicon-arrow-right:before {\n  content: \"\\E092\";\n}\n.glyphicon-arrow-up:before {\n  content: \"\\E093\";\n}\n.glyphicon-arrow-down:before {\n  content: \"\\E094\";\n}\n.glyphicon-share-alt:before {\n  content: \"\\E095\";\n}\n.glyphicon-resize-full:before {\n  content: \"\\E096\";\n}\n.glyphicon-resize-small:before {\n  content: \"\\E097\";\n}\n.glyphicon-exclamation-sign:before {\n  content: \"\\E101\";\n}\n.glyphicon-gift:before {\n  content: \"\\E102\";\n}\n.glyphicon-leaf:before {\n  content: \"\\E103\";\n}\n.glyphicon-fire:before {\n  content: \"\\E104\";\n}\n.glyphicon-eye-open:before {\n  content: \"\\E105\";\n}\n.glyphicon-eye-close:before {\n  content: \"\\E106\";\n}\n.glyphicon-warning-sign:before {\n  content: \"\\E107\";\n}\n.glyphicon-plane:before {\n  content: \"\\E108\";\n}\n.glyphicon-calendar:before {\n  content: \"\\E109\";\n}\n.glyphicon-random:before {\n  content: \"\\E110\";\n}\n.glyphicon-comment:before {\n  content: \"\\E111\";\n}\n.glyphicon-magnet:before {\n  content: \"\\E112\";\n}\n.glyphicon-chevron-up:before {\n  content: \"\\E113\";\n}\n.glyphicon-chevron-down:before {\n  content: \"\\E114\";\n}\n.glyphicon-retweet:before {\n  content: \"\\E115\";\n}\n.glyphicon-shopping-cart:before {\n  content: \"\\E116\";\n}\n.glyphicon-folder-close:before {\n  content: \"\\E117\";\n}\n.glyphicon-folder-open:before {\n  content: \"\\E118\";\n}\n.glyphicon-resize-vertical:before {\n  content: \"\\E119\";\n}\n.glyphicon-resize-horizontal:before {\n  content: \"\\E120\";\n}\n.glyphicon-hdd:before {\n  content: \"\\E121\";\n}\n.glyphicon-bullhorn:before {\n  content: \"\\E122\";\n}\n.glyphicon-bell:before {\n  content: \"\\E123\";\n}\n.glyphicon-certificate:before {\n  content: \"\\E124\";\n}\n.glyphicon-thumbs-up:before {\n  content: \"\\E125\";\n}\n.glyphicon-thumbs-down:before {\n  content: \"\\E126\";\n}\n.glyphicon-hand-right:before {\n  content: \"\\E127\";\n}\n.glyphicon-hand-left:before {\n  content: \"\\E128\";\n}\n.glyphicon-hand-up:before {\n  content: \"\\E129\";\n}\n.glyphicon-hand-down:before {\n  content: \"\\E130\";\n}\n.glyphicon-circle-arrow-right:before {\n  content: \"\\E131\";\n}\n.glyphicon-circle-arrow-left:before {\n  content: \"\\E132\";\n}\n.glyphicon-circle-arrow-up:before {\n  content: \"\\E133\";\n}\n.glyphicon-circle-arrow-down:before {\n  content: \"\\E134\";\n}\n.glyphicon-globe:before {\n  content: \"\\E135\";\n}\n.glyphicon-wrench:before {\n  content: \"\\E136\";\n}\n.glyphicon-tasks:before {\n  content: \"\\E137\";\n}\n.glyphicon-filter:before {\n  content: \"\\E138\";\n}\n.glyphicon-briefcase:before {\n  content: \"\\E139\";\n}\n.glyphicon-fullscreen:before {\n  content: \"\\E140\";\n}\n.glyphicon-dashboard:before {\n  content: \"\\E141\";\n}\n.glyphicon-paperclip:before {\n  content: \"\\E142\";\n}\n.glyphicon-heart-empty:before {\n  content: \"\\E143\";\n}\n.glyphicon-link:before {\n  content: \"\\E144\";\n}\n.glyphicon-phone:before {\n  content: \"\\E145\";\n}\n.glyphicon-pushpin:before {\n  content: \"\\E146\";\n}\n.glyphicon-usd:before {\n  content: \"\\E148\";\n}\n.glyphicon-gbp:before {\n  content: \"\\E149\";\n}\n.glyphicon-sort:before {\n  content: \"\\E150\";\n}\n.glyphicon-sort-by-alphabet:before {\n  content: \"\\E151\";\n}\n.glyphicon-sort-by-alphabet-alt:before {\n  content: \"\\E152\";\n}\n.glyphicon-sort-by-order:before {\n  content: \"\\E153\";\n}\n.glyphicon-sort-by-order-alt:before {\n  content: \"\\E154\";\n}\n.glyphicon-sort-by-attributes:before {\n  content: \"\\E155\";\n}\n.glyphicon-sort-by-attributes-alt:before {\n  content: \"\\E156\";\n}\n.glyphicon-unchecked:before {\n  content: \"\\E157\";\n}\n.glyphicon-expand:before {\n  content: \"\\E158\";\n}\n.glyphicon-collapse-down:before {\n  content: \"\\E159\";\n}\n.glyphicon-collapse-up:before {\n  content: \"\\E160\";\n}\n.glyphicon-log-in:before {\n  content: \"\\E161\";\n}\n.glyphicon-flash:before {\n  content: \"\\E162\";\n}\n.glyphicon-log-out:before {\n  content: \"\\E163\";\n}\n.glyphicon-new-window:before {\n  content: \"\\E164\";\n}\n.glyphicon-record:before {\n  content: \"\\E165\";\n}\n.glyphicon-save:before {\n  content: \"\\E166\";\n}\n.glyphicon-open:before {\n  content: \"\\E167\";\n}\n.glyphicon-saved:before {\n  content: \"\\E168\";\n}\n.glyphicon-import:before {\n  content: \"\\E169\";\n}\n.glyphicon-export:before {\n  content: \"\\E170\";\n}\n.glyphicon-send:before {\n  content: \"\\E171\";\n}\n.glyphicon-floppy-disk:before {\n  content: \"\\E172\";\n}\n.glyphicon-floppy-saved:before {\n  content: \"\\E173\";\n}\n.glyphicon-floppy-remove:before {\n  content: \"\\E174\";\n}\n.glyphicon-floppy-save:before {\n  content: \"\\E175\";\n}\n.glyphicon-floppy-open:before {\n  content: \"\\E176\";\n}\n.glyphicon-credit-card:before {\n  content: \"\\E177\";\n}\n.glyphicon-transfer:before {\n  content: \"\\E178\";\n}\n.glyphicon-cutlery:before {\n  content: \"\\E179\";\n}\n.glyphicon-header:before {\n  content: \"\\E180\";\n}\n.glyphicon-compressed:before {\n  content: \"\\E181\";\n}\n.glyphicon-earphone:before {\n  content: \"\\E182\";\n}\n.glyphicon-phone-alt:before {\n  content: \"\\E183\";\n}\n.glyphicon-tower:before {\n  content: \"\\E184\";\n}\n.glyphicon-stats:before {\n  content: \"\\E185\";\n}\n.glyphicon-sd-video:before {\n  content: \"\\E186\";\n}\n.glyphicon-hd-video:before {\n  content: \"\\E187\";\n}\n.glyphicon-subtitles:before {\n  content: \"\\E188\";\n}\n.glyphicon-sound-stereo:before {\n  content: \"\\E189\";\n}\n.glyphicon-sound-dolby:before {\n  content: \"\\E190\";\n}\n.glyphicon-sound-5-1:before {\n  content: \"\\E191\";\n}\n.glyphicon-sound-6-1:before {\n  content: \"\\E192\";\n}\n.glyphicon-sound-7-1:before {\n  content: \"\\E193\";\n}\n.glyphicon-copyright-mark:before {\n  content: \"\\E194\";\n}\n.glyphicon-registration-mark:before {\n  content: \"\\E195\";\n}\n.glyphicon-cloud-download:before {\n  content: \"\\E197\";\n}\n.glyphicon-cloud-upload:before {\n  content: \"\\E198\";\n}\n.glyphicon-tree-conifer:before {\n  content: \"\\E199\";\n}\n.glyphicon-tree-deciduous:before {\n  content: \"\\E200\";\n}\n.glyphicon-cd:before {\n  content: \"\\E201\";\n}\n.glyphicon-save-file:before {\n  content: \"\\E202\";\n}\n.glyphicon-open-file:before {\n  content: \"\\E203\";\n}\n.glyphicon-level-up:before {\n  content: \"\\E204\";\n}\n.glyphicon-copy:before {\n  content: \"\\E205\";\n}\n.glyphicon-paste:before {\n  content: \"\\E206\";\n}\n.glyphicon-alert:before {\n  content: \"\\E209\";\n}\n.glyphicon-equalizer:before {\n  content: \"\\E210\";\n}\n.glyphicon-king:before {\n  content: \"\\E211\";\n}\n.glyphicon-queen:before {\n  content: \"\\E212\";\n}\n.glyphicon-pawn:before {\n  content: \"\\E213\";\n}\n.glyphicon-bishop:before {\n  content: \"\\E214\";\n}\n.glyphicon-knight:before {\n  content: \"\\E215\";\n}\n.glyphicon-baby-formula:before {\n  content: \"\\E216\";\n}\n.glyphicon-tent:before {\n  content: \"\\26FA\";\n}\n.glyphicon-blackboard:before {\n  content: \"\\E218\";\n}\n.glyphicon-bed:before {\n  content: \"\\E219\";\n}\n.glyphicon-apple:before {\n  content: \"\\F8FF\";\n}\n.glyphicon-erase:before {\n  content: \"\\E221\";\n}\n.glyphicon-hourglass:before {\n  content: \"\\231B\";\n}\n.glyphicon-lamp:before {\n  content: \"\\E223\";\n}\n.glyphicon-duplicate:before {\n  content: \"\\E224\";\n}\n.glyphicon-piggy-bank:before {\n  content: \"\\E225\";\n}\n.glyphicon-scissors:before {\n  content: \"\\E226\";\n}\n.glyphicon-bitcoin:before {\n  content: \"\\E227\";\n}\n.glyphicon-btc:before {\n  content: \"\\E227\";\n}\n.glyphicon-xbt:before {\n  content: \"\\E227\";\n}\n.glyphicon-yen:before {\n  content: \"\\A5\";\n}\n.glyphicon-jpy:before {\n  content: \"\\A5\";\n}\n.glyphicon-ruble:before {\n  content: \"\\20BD\";\n}\n.glyphicon-rub:before {\n  content: \"\\20BD\";\n}\n.glyphicon-scale:before {\n  content: \"\\E230\";\n}\n.glyphicon-ice-lolly:before {\n  content: \"\\E231\";\n}\n.glyphicon-ice-lolly-tasted:before {\n  content: \"\\E232\";\n}\n.glyphicon-education:before {\n  content: \"\\E233\";\n}\n.glyphicon-option-horizontal:before {\n  content: \"\\E234\";\n}\n.glyphicon-option-vertical:before {\n  content: \"\\E235\";\n}\n.glyphicon-menu-hamburger:before {\n  content: \"\\E236\";\n}\n.glyphicon-modal-window:before {\n  content: \"\\E237\";\n}\n.glyphicon-oil:before {\n  content: \"\\E238\";\n}\n.glyphicon-grain:before {\n  content: \"\\E239\";\n}\n.glyphicon-sunglasses:before {\n  content: \"\\E240\";\n}\n.glyphicon-text-size:before {\n  content: \"\\E241\";\n}\n.glyphicon-text-color:before {\n  content: \"\\E242\";\n}\n.glyphicon-text-background:before {\n  content: \"\\E243\";\n}\n.glyphicon-object-align-top:before {\n  content: \"\\E244\";\n}\n.glyphicon-object-align-bottom:before {\n  content: \"\\E245\";\n}\n.glyphicon-object-align-horizontal:before {\n  content: \"\\E246\";\n}\n.glyphicon-object-align-left:before {\n  content: \"\\E247\";\n}\n.glyphicon-object-align-vertical:before {\n  content: \"\\E248\";\n}\n.glyphicon-object-align-right:before {\n  content: \"\\E249\";\n}\n.glyphicon-triangle-right:before {\n  content: \"\\E250\";\n}\n.glyphicon-triangle-left:before {\n  content: \"\\E251\";\n}\n.glyphicon-triangle-bottom:before {\n  content: \"\\E252\";\n}\n.glyphicon-triangle-top:before {\n  content: \"\\E253\";\n}\n.glyphicon-console:before {\n  content: \"\\E254\";\n}\n.glyphicon-superscript:before {\n  content: \"\\E255\";\n}\n.glyphicon-subscript:before {\n  content: \"\\E256\";\n}\n.glyphicon-menu-left:before {\n  content: \"\\E257\";\n}\n.glyphicon-menu-right:before {\n  content: \"\\E258\";\n}\n.glyphicon-menu-down:before {\n  content: \"\\E259\";\n}\n.glyphicon-menu-up:before {\n  content: \"\\E260\";\n}\n* {\n  box-sizing: border-box;\n}\n*:before,\n*:after {\n  box-sizing: border-box;\n}\nhtml {\n  font-size: 10px;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\nbody {\n  font-family: \"Quicksand\", sans-serif;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #5E5E5E;\n  background-color: #fff;\n}\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\na {\n  color: #f0617d;\n  text-decoration: none;\n}\na:hover, a:focus {\n    color: #e91b44;\n    text-decoration: underline;\n}\na:focus {\n    outline: 5px auto -webkit-focus-ring-color;\n    outline-offset: -2px;\n}\nfigure {\n  margin: 0;\n}\nimg {\n  vertical-align: middle;\n}\n.img-responsive {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n.img-rounded {\n  border-radius: 6px;\n}\n.img-thumbnail {\n  padding: 4px;\n  line-height: 1.42857;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  transition: all 0.2s ease-in-out;\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n}\n.img-circle {\n  border-radius: 50%;\n}\nhr {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 1px solid #eeeeee;\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n}\n[role=\"button\"] {\n  cursor: pointer;\n}\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\nh1 small,\n  h1 .small, h2 small,\n  h2 .small, h3 small,\n  h3 .small, h4 small,\n  h4 .small, h5 small,\n  h5 .small, h6 small,\n  h6 .small,\n  .h1 small,\n  .h1 .small, .h2 small,\n  .h2 .small, .h3 small,\n  .h3 .small, .h4 small,\n  .h4 .small, .h5 small,\n  .h5 .small, .h6 small,\n  .h6 .small {\n    font-weight: 400;\n    line-height: 1;\n    color: #777777;\n}\nh1, .h1,\nh2, .h2,\nh3, .h3 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\nh1 small,\n  h1 .small, .h1 small,\n  .h1 .small,\n  h2 small,\n  h2 .small, .h2 small,\n  .h2 .small,\n  h3 small,\n  h3 .small, .h3 small,\n  .h3 .small {\n    font-size: 65%;\n}\nh4, .h4,\nh5, .h5,\nh6, .h6 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\nh4 small,\n  h4 .small, .h4 small,\n  .h4 .small,\n  h5 small,\n  h5 .small, .h5 small,\n  .h5 .small,\n  h6 small,\n  h6 .small, .h6 small,\n  .h6 .small {\n    font-size: 75%;\n}\nh1, .h1 {\n  font-size: 32px;\n}\nh2, .h2 {\n  font-size: 30px;\n}\nh3, .h3 {\n  font-size: 24px;\n}\nh4, .h4 {\n  font-size: 18px;\n}\nh5, .h5 {\n  font-size: 14px;\n}\nh6, .h6 {\n  font-size: 12px;\n}\np {\n  margin: 0 0 10px;\n}\n.lead {\n  margin-bottom: 20px;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.4;\n}\n@media (min-width: 768px) {\n.lead {\n      font-size: 21px;\n}\n}\nsmall,\n.small {\n  font-size: 85%;\n}\nmark,\n.mark {\n  padding: .2em;\n  background-color: #fcf8e3;\n}\n.text-left {\n  text-align: left;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-justify {\n  text-align: justify;\n}\n.text-nowrap {\n  white-space: nowrap;\n}\n.text-lowercase {\n  text-transform: lowercase;\n}\n.text-uppercase, .initialism {\n  text-transform: uppercase;\n}\n.text-capitalize {\n  text-transform: capitalize;\n}\n.text-muted {\n  color: #777777;\n}\n.text-primary {\n  color: #f0617d;\n}\na.text-primary:hover,\na.text-primary:focus {\n  color: #ec3257;\n}\n.text-success {\n  color: #3c763d;\n}\na.text-success:hover,\na.text-success:focus {\n  color: #2b542c;\n}\n.text-info {\n  color: #31708f;\n}\na.text-info:hover,\na.text-info:focus {\n  color: #245269;\n}\n.text-warning {\n  color: #8a6d3b;\n}\na.text-warning:hover,\na.text-warning:focus {\n  color: #66512c;\n}\n.text-danger {\n  color: #a94442;\n}\na.text-danger:hover,\na.text-danger:focus {\n  color: #843534;\n}\n.bg-primary {\n  color: #fff;\n}\n.bg-primary {\n  background-color: #f0617d;\n}\na.bg-primary:hover,\na.bg-primary:focus {\n  background-color: #ec3257;\n}\n.bg-success {\n  background-color: #dff0d8;\n}\na.bg-success:hover,\na.bg-success:focus {\n  background-color: #c1e2b3;\n}\n.bg-info {\n  background-color: #d9edf7;\n}\na.bg-info:hover,\na.bg-info:focus {\n  background-color: #afd9ee;\n}\n.bg-warning {\n  background-color: #fcf8e3;\n}\na.bg-warning:hover,\na.bg-warning:focus {\n  background-color: #f7ecb5;\n}\n.bg-danger {\n  background-color: #f2dede;\n}\na.bg-danger:hover,\na.bg-danger:focus {\n  background-color: #e4b9b9;\n}\n.page-header {\n  padding-bottom: 9px;\n  margin: 40px 0 20px;\n  border-bottom: 1px solid #eeeeee;\n}\nul,\nol {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\nul ul,\n  ul ol,\n  ol ul,\n  ol ol {\n    margin-bottom: 0;\n}\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n  margin-left: -5px;\n}\n.list-inline > li {\n    display: inline-block;\n    padding-right: 5px;\n    padding-left: 5px;\n}\ndl {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\ndt,\ndd {\n  line-height: 1.42857;\n}\ndt {\n  font-weight: 700;\n}\ndd {\n  margin-left: 0;\n}\n.dl-horizontal dd:before, .dl-horizontal dd:after {\n  display: table;\n  content: \" \";\n}\n.dl-horizontal dd:after {\n  clear: both;\n}\n@media (min-width: 768px) {\n.dl-horizontal dt {\n    float: left;\n    width: 160px;\n    clear: left;\n    text-align: right;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.dl-horizontal dd {\n    margin-left: 180px;\n}\n}\nabbr[title],\nabbr[data-original-title] {\n  cursor: help;\n}\n.initialism {\n  font-size: 90%;\n}\nblockquote {\n  padding: 10px 20px;\n  margin: 0 0 20px;\n  font-size: 17.5px;\n  border-left: 5px solid #eeeeee;\n}\nblockquote p:last-child,\n  blockquote ul:last-child,\n  blockquote ol:last-child {\n    margin-bottom: 0;\n}\nblockquote footer,\n  blockquote small,\n  blockquote .small {\n    display: block;\n    font-size: 80%;\n    line-height: 1.42857;\n    color: #777777;\n}\nblockquote footer:before,\n    blockquote small:before,\n    blockquote .small:before {\n      content: \"\\2014   \\A0\";\n}\n.blockquote-reverse,\nblockquote.pull-right {\n  padding-right: 15px;\n  padding-left: 0;\n  text-align: right;\n  border-right: 5px solid #eeeeee;\n  border-left: 0;\n}\n.blockquote-reverse footer:before,\n  .blockquote-reverse small:before,\n  .blockquote-reverse .small:before,\n  blockquote.pull-right footer:before,\n  blockquote.pull-right small:before,\n  blockquote.pull-right .small:before {\n    content: \"\";\n}\n.blockquote-reverse footer:after,\n  .blockquote-reverse small:after,\n  .blockquote-reverse .small:after,\n  blockquote.pull-right footer:after,\n  blockquote.pull-right small:after,\n  blockquote.pull-right .small:after {\n    content: \"\\A0   \\2014\";\n}\naddress {\n  margin-bottom: 20px;\n  font-style: normal;\n  line-height: 1.42857;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\ncode {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #c7254e;\n  background-color: #f9f2f4;\n  border-radius: 4px;\n}\nkbd {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #fff;\n  background-color: #333;\n  border-radius: 3px;\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\nkbd kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: 700;\n    box-shadow: none;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857;\n  color: #333333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\npre code {\n    padding: 0;\n    font-size: inherit;\n    color: inherit;\n    white-space: pre-wrap;\n    background-color: transparent;\n    border-radius: 0;\n}\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n.container {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n.container:before, .container:after {\n    display: table;\n    content: \" \";\n}\n.container:after {\n    clear: both;\n}\n@media (min-width: 768px) {\n.container {\n      width: 750px;\n}\n}\n@media (min-width: 992px) {\n.container {\n      width: 970px;\n}\n}\n@media (min-width: 1200px) {\n.container {\n      width: 1170px;\n}\n}\n.container-fluid {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n.container-fluid:before, .container-fluid:after {\n    display: table;\n    content: \" \";\n}\n.container-fluid:after {\n    clear: both;\n}\n.row {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.row:before, .row:after {\n    display: table;\n    content: \" \";\n}\n.row:after {\n    clear: both;\n}\n.row-no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n.row-no-gutters [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0;\n}\n.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {\n  position: relative;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12 {\n  float: left;\n}\n.col-xs-1 {\n  width: 8.33333%;\n}\n.col-xs-2 {\n  width: 16.66667%;\n}\n.col-xs-3 {\n  width: 25%;\n}\n.col-xs-4 {\n  width: 33.33333%;\n}\n.col-xs-5 {\n  width: 41.66667%;\n}\n.col-xs-6 {\n  width: 50%;\n}\n.col-xs-7 {\n  width: 58.33333%;\n}\n.col-xs-8 {\n  width: 66.66667%;\n}\n.col-xs-9 {\n  width: 75%;\n}\n.col-xs-10 {\n  width: 83.33333%;\n}\n.col-xs-11 {\n  width: 91.66667%;\n}\n.col-xs-12 {\n  width: 100%;\n}\n.col-xs-pull-0 {\n  right: auto;\n}\n.col-xs-pull-1 {\n  right: 8.33333%;\n}\n.col-xs-pull-2 {\n  right: 16.66667%;\n}\n.col-xs-pull-3 {\n  right: 25%;\n}\n.col-xs-pull-4 {\n  right: 33.33333%;\n}\n.col-xs-pull-5 {\n  right: 41.66667%;\n}\n.col-xs-pull-6 {\n  right: 50%;\n}\n.col-xs-pull-7 {\n  right: 58.33333%;\n}\n.col-xs-pull-8 {\n  right: 66.66667%;\n}\n.col-xs-pull-9 {\n  right: 75%;\n}\n.col-xs-pull-10 {\n  right: 83.33333%;\n}\n.col-xs-pull-11 {\n  right: 91.66667%;\n}\n.col-xs-pull-12 {\n  right: 100%;\n}\n.col-xs-push-0 {\n  left: auto;\n}\n.col-xs-push-1 {\n  left: 8.33333%;\n}\n.col-xs-push-2 {\n  left: 16.66667%;\n}\n.col-xs-push-3 {\n  left: 25%;\n}\n.col-xs-push-4 {\n  left: 33.33333%;\n}\n.col-xs-push-5 {\n  left: 41.66667%;\n}\n.col-xs-push-6 {\n  left: 50%;\n}\n.col-xs-push-7 {\n  left: 58.33333%;\n}\n.col-xs-push-8 {\n  left: 66.66667%;\n}\n.col-xs-push-9 {\n  left: 75%;\n}\n.col-xs-push-10 {\n  left: 83.33333%;\n}\n.col-xs-push-11 {\n  left: 91.66667%;\n}\n.col-xs-push-12 {\n  left: 100%;\n}\n.col-xs-offset-0 {\n  margin-left: 0%;\n}\n.col-xs-offset-1 {\n  margin-left: 8.33333%;\n}\n.col-xs-offset-2 {\n  margin-left: 16.66667%;\n}\n.col-xs-offset-3 {\n  margin-left: 25%;\n}\n.col-xs-offset-4 {\n  margin-left: 33.33333%;\n}\n.col-xs-offset-5 {\n  margin-left: 41.66667%;\n}\n.col-xs-offset-6 {\n  margin-left: 50%;\n}\n.col-xs-offset-7 {\n  margin-left: 58.33333%;\n}\n.col-xs-offset-8 {\n  margin-left: 66.66667%;\n}\n.col-xs-offset-9 {\n  margin-left: 75%;\n}\n.col-xs-offset-10 {\n  margin-left: 83.33333%;\n}\n.col-xs-offset-11 {\n  margin-left: 91.66667%;\n}\n.col-xs-offset-12 {\n  margin-left: 100%;\n}\n@media (min-width: 768px) {\n.col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {\n    float: left;\n}\n.col-sm-1 {\n    width: 8.33333%;\n}\n.col-sm-2 {\n    width: 16.66667%;\n}\n.col-sm-3 {\n    width: 25%;\n}\n.col-sm-4 {\n    width: 33.33333%;\n}\n.col-sm-5 {\n    width: 41.66667%;\n}\n.col-sm-6 {\n    width: 50%;\n}\n.col-sm-7 {\n    width: 58.33333%;\n}\n.col-sm-8 {\n    width: 66.66667%;\n}\n.col-sm-9 {\n    width: 75%;\n}\n.col-sm-10 {\n    width: 83.33333%;\n}\n.col-sm-11 {\n    width: 91.66667%;\n}\n.col-sm-12 {\n    width: 100%;\n}\n.col-sm-pull-0 {\n    right: auto;\n}\n.col-sm-pull-1 {\n    right: 8.33333%;\n}\n.col-sm-pull-2 {\n    right: 16.66667%;\n}\n.col-sm-pull-3 {\n    right: 25%;\n}\n.col-sm-pull-4 {\n    right: 33.33333%;\n}\n.col-sm-pull-5 {\n    right: 41.66667%;\n}\n.col-sm-pull-6 {\n    right: 50%;\n}\n.col-sm-pull-7 {\n    right: 58.33333%;\n}\n.col-sm-pull-8 {\n    right: 66.66667%;\n}\n.col-sm-pull-9 {\n    right: 75%;\n}\n.col-sm-pull-10 {\n    right: 83.33333%;\n}\n.col-sm-pull-11 {\n    right: 91.66667%;\n}\n.col-sm-pull-12 {\n    right: 100%;\n}\n.col-sm-push-0 {\n    left: auto;\n}\n.col-sm-push-1 {\n    left: 8.33333%;\n}\n.col-sm-push-2 {\n    left: 16.66667%;\n}\n.col-sm-push-3 {\n    left: 25%;\n}\n.col-sm-push-4 {\n    left: 33.33333%;\n}\n.col-sm-push-5 {\n    left: 41.66667%;\n}\n.col-sm-push-6 {\n    left: 50%;\n}\n.col-sm-push-7 {\n    left: 58.33333%;\n}\n.col-sm-push-8 {\n    left: 66.66667%;\n}\n.col-sm-push-9 {\n    left: 75%;\n}\n.col-sm-push-10 {\n    left: 83.33333%;\n}\n.col-sm-push-11 {\n    left: 91.66667%;\n}\n.col-sm-push-12 {\n    left: 100%;\n}\n.col-sm-offset-0 {\n    margin-left: 0%;\n}\n.col-sm-offset-1 {\n    margin-left: 8.33333%;\n}\n.col-sm-offset-2 {\n    margin-left: 16.66667%;\n}\n.col-sm-offset-3 {\n    margin-left: 25%;\n}\n.col-sm-offset-4 {\n    margin-left: 33.33333%;\n}\n.col-sm-offset-5 {\n    margin-left: 41.66667%;\n}\n.col-sm-offset-6 {\n    margin-left: 50%;\n}\n.col-sm-offset-7 {\n    margin-left: 58.33333%;\n}\n.col-sm-offset-8 {\n    margin-left: 66.66667%;\n}\n.col-sm-offset-9 {\n    margin-left: 75%;\n}\n.col-sm-offset-10 {\n    margin-left: 83.33333%;\n}\n.col-sm-offset-11 {\n    margin-left: 91.66667%;\n}\n.col-sm-offset-12 {\n    margin-left: 100%;\n}\n}\n@media (min-width: 992px) {\n.col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12 {\n    float: left;\n}\n.col-md-1 {\n    width: 8.33333%;\n}\n.col-md-2 {\n    width: 16.66667%;\n}\n.col-md-3 {\n    width: 25%;\n}\n.col-md-4 {\n    width: 33.33333%;\n}\n.col-md-5 {\n    width: 41.66667%;\n}\n.col-md-6 {\n    width: 50%;\n}\n.col-md-7 {\n    width: 58.33333%;\n}\n.col-md-8 {\n    width: 66.66667%;\n}\n.col-md-9 {\n    width: 75%;\n}\n.col-md-10 {\n    width: 83.33333%;\n}\n.col-md-11 {\n    width: 91.66667%;\n}\n.col-md-12 {\n    width: 100%;\n}\n.col-md-pull-0 {\n    right: auto;\n}\n.col-md-pull-1 {\n    right: 8.33333%;\n}\n.col-md-pull-2 {\n    right: 16.66667%;\n}\n.col-md-pull-3 {\n    right: 25%;\n}\n.col-md-pull-4 {\n    right: 33.33333%;\n}\n.col-md-pull-5 {\n    right: 41.66667%;\n}\n.col-md-pull-6 {\n    right: 50%;\n}\n.col-md-pull-7 {\n    right: 58.33333%;\n}\n.col-md-pull-8 {\n    right: 66.66667%;\n}\n.col-md-pull-9 {\n    right: 75%;\n}\n.col-md-pull-10 {\n    right: 83.33333%;\n}\n.col-md-pull-11 {\n    right: 91.66667%;\n}\n.col-md-pull-12 {\n    right: 100%;\n}\n.col-md-push-0 {\n    left: auto;\n}\n.col-md-push-1 {\n    left: 8.33333%;\n}\n.col-md-push-2 {\n    left: 16.66667%;\n}\n.col-md-push-3 {\n    left: 25%;\n}\n.col-md-push-4 {\n    left: 33.33333%;\n}\n.col-md-push-5 {\n    left: 41.66667%;\n}\n.col-md-push-6 {\n    left: 50%;\n}\n.col-md-push-7 {\n    left: 58.33333%;\n}\n.col-md-push-8 {\n    left: 66.66667%;\n}\n.col-md-push-9 {\n    left: 75%;\n}\n.col-md-push-10 {\n    left: 83.33333%;\n}\n.col-md-push-11 {\n    left: 91.66667%;\n}\n.col-md-push-12 {\n    left: 100%;\n}\n.col-md-offset-0 {\n    margin-left: 0%;\n}\n.col-md-offset-1 {\n    margin-left: 8.33333%;\n}\n.col-md-offset-2 {\n    margin-left: 16.66667%;\n}\n.col-md-offset-3 {\n    margin-left: 25%;\n}\n.col-md-offset-4 {\n    margin-left: 33.33333%;\n}\n.col-md-offset-5 {\n    margin-left: 41.66667%;\n}\n.col-md-offset-6 {\n    margin-left: 50%;\n}\n.col-md-offset-7 {\n    margin-left: 58.33333%;\n}\n.col-md-offset-8 {\n    margin-left: 66.66667%;\n}\n.col-md-offset-9 {\n    margin-left: 75%;\n}\n.col-md-offset-10 {\n    margin-left: 83.33333%;\n}\n.col-md-offset-11 {\n    margin-left: 91.66667%;\n}\n.col-md-offset-12 {\n    margin-left: 100%;\n}\n}\n@media (min-width: 1200px) {\n.col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12 {\n    float: left;\n}\n.col-lg-1 {\n    width: 8.33333%;\n}\n.col-lg-2 {\n    width: 16.66667%;\n}\n.col-lg-3 {\n    width: 25%;\n}\n.col-lg-4 {\n    width: 33.33333%;\n}\n.col-lg-5 {\n    width: 41.66667%;\n}\n.col-lg-6 {\n    width: 50%;\n}\n.col-lg-7 {\n    width: 58.33333%;\n}\n.col-lg-8 {\n    width: 66.66667%;\n}\n.col-lg-9 {\n    width: 75%;\n}\n.col-lg-10 {\n    width: 83.33333%;\n}\n.col-lg-11 {\n    width: 91.66667%;\n}\n.col-lg-12 {\n    width: 100%;\n}\n.col-lg-pull-0 {\n    right: auto;\n}\n.col-lg-pull-1 {\n    right: 8.33333%;\n}\n.col-lg-pull-2 {\n    right: 16.66667%;\n}\n.col-lg-pull-3 {\n    right: 25%;\n}\n.col-lg-pull-4 {\n    right: 33.33333%;\n}\n.col-lg-pull-5 {\n    right: 41.66667%;\n}\n.col-lg-pull-6 {\n    right: 50%;\n}\n.col-lg-pull-7 {\n    right: 58.33333%;\n}\n.col-lg-pull-8 {\n    right: 66.66667%;\n}\n.col-lg-pull-9 {\n    right: 75%;\n}\n.col-lg-pull-10 {\n    right: 83.33333%;\n}\n.col-lg-pull-11 {\n    right: 91.66667%;\n}\n.col-lg-pull-12 {\n    right: 100%;\n}\n.col-lg-push-0 {\n    left: auto;\n}\n.col-lg-push-1 {\n    left: 8.33333%;\n}\n.col-lg-push-2 {\n    left: 16.66667%;\n}\n.col-lg-push-3 {\n    left: 25%;\n}\n.col-lg-push-4 {\n    left: 33.33333%;\n}\n.col-lg-push-5 {\n    left: 41.66667%;\n}\n.col-lg-push-6 {\n    left: 50%;\n}\n.col-lg-push-7 {\n    left: 58.33333%;\n}\n.col-lg-push-8 {\n    left: 66.66667%;\n}\n.col-lg-push-9 {\n    left: 75%;\n}\n.col-lg-push-10 {\n    left: 83.33333%;\n}\n.col-lg-push-11 {\n    left: 91.66667%;\n}\n.col-lg-push-12 {\n    left: 100%;\n}\n.col-lg-offset-0 {\n    margin-left: 0%;\n}\n.col-lg-offset-1 {\n    margin-left: 8.33333%;\n}\n.col-lg-offset-2 {\n    margin-left: 16.66667%;\n}\n.col-lg-offset-3 {\n    margin-left: 25%;\n}\n.col-lg-offset-4 {\n    margin-left: 33.33333%;\n}\n.col-lg-offset-5 {\n    margin-left: 41.66667%;\n}\n.col-lg-offset-6 {\n    margin-left: 50%;\n}\n.col-lg-offset-7 {\n    margin-left: 58.33333%;\n}\n.col-lg-offset-8 {\n    margin-left: 66.66667%;\n}\n.col-lg-offset-9 {\n    margin-left: 75%;\n}\n.col-lg-offset-10 {\n    margin-left: 83.33333%;\n}\n.col-lg-offset-11 {\n    margin-left: 91.66667%;\n}\n.col-lg-offset-12 {\n    margin-left: 100%;\n}\n}\ntable {\n  background-color: transparent;\n}\ntable col[class*=\"col-\"] {\n    position: static;\n    display: table-column;\n    float: none;\n}\ntable td[class*=\"col-\"],\n  table th[class*=\"col-\"] {\n    position: static;\n    display: table-cell;\n    float: none;\n}\ncaption {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  color: #777777;\n  text-align: left;\n}\nth {\n  text-align: left;\n}\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 20px;\n}\n.table > thead > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > th,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > th,\n  .table > tfoot > tr > td {\n    padding: 8px;\n    line-height: 1.42857;\n    vertical-align: top;\n    border-top: 1px solid #ddd;\n}\n.table > thead > tr > th {\n    vertical-align: bottom;\n    border-bottom: 2px solid #ddd;\n}\n.table > caption + thead > tr:first-child > th,\n  .table > caption + thead > tr:first-child > td,\n  .table > colgroup + thead > tr:first-child > th,\n  .table > colgroup + thead > tr:first-child > td,\n  .table > thead:first-child > tr:first-child > th,\n  .table > thead:first-child > tr:first-child > td {\n    border-top: 0;\n}\n.table > tbody + tbody {\n    border-top: 2px solid #ddd;\n}\n.table .table {\n    background-color: #fff;\n}\n.table-condensed > thead > tr > th,\n.table-condensed > thead > tr > td,\n.table-condensed > tbody > tr > th,\n.table-condensed > tbody > tr > td,\n.table-condensed > tfoot > tr > th,\n.table-condensed > tfoot > tr > td {\n  padding: 5px;\n}\n.table-bordered {\n  border: 1px solid #ddd;\n}\n.table-bordered > thead > tr > th,\n  .table-bordered > thead > tr > td,\n  .table-bordered > tbody > tr > th,\n  .table-bordered > tbody > tr > td,\n  .table-bordered > tfoot > tr > th,\n  .table-bordered > tfoot > tr > td {\n    border: 1px solid #ddd;\n}\n.table-bordered > thead > tr > th,\n  .table-bordered > thead > tr > td {\n    border-bottom-width: 2px;\n}\n.table-striped > tbody > tr:nth-of-type(odd) {\n  background-color: #f9f9f9;\n}\n.table-hover > tbody > tr:hover {\n  background-color: #f5f5f5;\n}\n.table > thead > tr > td.active,\n.table > thead > tr > th.active,\n.table > thead > tr.active > td,\n.table > thead > tr.active > th,\n.table > tbody > tr > td.active,\n.table > tbody > tr > th.active,\n.table > tbody > tr.active > td,\n.table > tbody > tr.active > th,\n.table > tfoot > tr > td.active,\n.table > tfoot > tr > th.active,\n.table > tfoot > tr.active > td,\n.table > tfoot > tr.active > th {\n  background-color: #f5f5f5;\n}\n.table-hover > tbody > tr > td.active:hover,\n.table-hover > tbody > tr > th.active:hover,\n.table-hover > tbody > tr.active:hover > td,\n.table-hover > tbody > tr:hover > .active,\n.table-hover > tbody > tr.active:hover > th {\n  background-color: #e8e8e8;\n}\n.table > thead > tr > td.success,\n.table > thead > tr > th.success,\n.table > thead > tr.success > td,\n.table > thead > tr.success > th,\n.table > tbody > tr > td.success,\n.table > tbody > tr > th.success,\n.table > tbody > tr.success > td,\n.table > tbody > tr.success > th,\n.table > tfoot > tr > td.success,\n.table > tfoot > tr > th.success,\n.table > tfoot > tr.success > td,\n.table > tfoot > tr.success > th {\n  background-color: #dff0d8;\n}\n.table-hover > tbody > tr > td.success:hover,\n.table-hover > tbody > tr > th.success:hover,\n.table-hover > tbody > tr.success:hover > td,\n.table-hover > tbody > tr:hover > .success,\n.table-hover > tbody > tr.success:hover > th {\n  background-color: #d0e9c6;\n}\n.table > thead > tr > td.info,\n.table > thead > tr > th.info,\n.table > thead > tr.info > td,\n.table > thead > tr.info > th,\n.table > tbody > tr > td.info,\n.table > tbody > tr > th.info,\n.table > tbody > tr.info > td,\n.table > tbody > tr.info > th,\n.table > tfoot > tr > td.info,\n.table > tfoot > tr > th.info,\n.table > tfoot > tr.info > td,\n.table > tfoot > tr.info > th {\n  background-color: #d9edf7;\n}\n.table-hover > tbody > tr > td.info:hover,\n.table-hover > tbody > tr > th.info:hover,\n.table-hover > tbody > tr.info:hover > td,\n.table-hover > tbody > tr:hover > .info,\n.table-hover > tbody > tr.info:hover > th {\n  background-color: #c4e3f3;\n}\n.table > thead > tr > td.warning,\n.table > thead > tr > th.warning,\n.table > thead > tr.warning > td,\n.table > thead > tr.warning > th,\n.table > tbody > tr > td.warning,\n.table > tbody > tr > th.warning,\n.table > tbody > tr.warning > td,\n.table > tbody > tr.warning > th,\n.table > tfoot > tr > td.warning,\n.table > tfoot > tr > th.warning,\n.table > tfoot > tr.warning > td,\n.table > tfoot > tr.warning > th {\n  background-color: #fcf8e3;\n}\n.table-hover > tbody > tr > td.warning:hover,\n.table-hover > tbody > tr > th.warning:hover,\n.table-hover > tbody > tr.warning:hover > td,\n.table-hover > tbody > tr:hover > .warning,\n.table-hover > tbody > tr.warning:hover > th {\n  background-color: #faf2cc;\n}\n.table > thead > tr > td.danger,\n.table > thead > tr > th.danger,\n.table > thead > tr.danger > td,\n.table > thead > tr.danger > th,\n.table > tbody > tr > td.danger,\n.table > tbody > tr > th.danger,\n.table > tbody > tr.danger > td,\n.table > tbody > tr.danger > th,\n.table > tfoot > tr > td.danger,\n.table > tfoot > tr > th.danger,\n.table > tfoot > tr.danger > td,\n.table > tfoot > tr.danger > th {\n  background-color: #f2dede;\n}\n.table-hover > tbody > tr > td.danger:hover,\n.table-hover > tbody > tr > th.danger:hover,\n.table-hover > tbody > tr.danger:hover > td,\n.table-hover > tbody > tr:hover > .danger,\n.table-hover > tbody > tr.danger:hover > th {\n  background-color: #ebcccc;\n}\n.table-responsive {\n  min-height: .01%;\n  overflow-x: auto;\n}\n@media screen and (max-width: 767px) {\n.table-responsive {\n      width: 100%;\n      margin-bottom: 15px;\n      overflow-y: hidden;\n      -ms-overflow-style: -ms-autohiding-scrollbar;\n      border: 1px solid #ddd;\n}\n.table-responsive > .table {\n        margin-bottom: 0;\n}\n.table-responsive > .table > thead > tr > th,\n        .table-responsive > .table > thead > tr > td,\n        .table-responsive > .table > tbody > tr > th,\n        .table-responsive > .table > tbody > tr > td,\n        .table-responsive > .table > tfoot > tr > th,\n        .table-responsive > .table > tfoot > tr > td {\n          white-space: nowrap;\n}\n.table-responsive > .table-bordered {\n        border: 0;\n}\n.table-responsive > .table-bordered > thead > tr > th:first-child,\n        .table-responsive > .table-bordered > thead > tr > td:first-child,\n        .table-responsive > .table-bordered > tbody > tr > th:first-child,\n        .table-responsive > .table-bordered > tbody > tr > td:first-child,\n        .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n        .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n          border-left: 0;\n}\n.table-responsive > .table-bordered > thead > tr > th:last-child,\n        .table-responsive > .table-bordered > thead > tr > td:last-child,\n        .table-responsive > .table-bordered > tbody > tr > th:last-child,\n        .table-responsive > .table-bordered > tbody > tr > td:last-child,\n        .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n        .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n          border-right: 0;\n}\n.table-responsive > .table-bordered > tbody > tr:last-child > th,\n        .table-responsive > .table-bordered > tbody > tr:last-child > td,\n        .table-responsive > .table-bordered > tfoot > tr:last-child > th,\n        .table-responsive > .table-bordered > tfoot > tr:last-child > td {\n          border-bottom: 0;\n}\n}\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 20px;\n  font-size: 21px;\n  line-height: inherit;\n  color: #333333;\n  border: 0;\n  border-bottom: 1px solid #e5e5e5;\n}\nlabel {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: 700;\n}\ninput[type=\"search\"] {\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  appearance: none;\n}\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9;\n  line-height: normal;\n}\ninput[type=\"radio\"][disabled], input[type=\"radio\"].disabled,\n  fieldset[disabled] input[type=\"radio\"],\n  input[type=\"checkbox\"][disabled],\n  input[type=\"checkbox\"].disabled,\n  fieldset[disabled]\n  input[type=\"checkbox\"] {\n    cursor: not-allowed;\n}\ninput[type=\"file\"] {\n  display: block;\n}\ninput[type=\"range\"] {\n  display: block;\n  width: 100%;\n}\nselect[multiple],\nselect[size] {\n  height: auto;\n}\ninput[type=\"file\"]:focus,\ninput[type=\"radio\"]:focus,\ninput[type=\"checkbox\"]:focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\noutput {\n  display: block;\n  padding-top: 7px;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #555555;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #555555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n.form-control:focus {\n    border-color: #66afe9;\n    outline: 0;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\n}\n.form-control::-moz-placeholder {\n    color: #999;\n    opacity: 1;\n}\n.form-control:-ms-input-placeholder {\n    color: #999;\n}\n.form-control::-webkit-input-placeholder {\n    color: #999;\n}\n.form-control::-ms-expand {\n    background-color: transparent;\n    border: 0;\n}\n.form-control[disabled], .form-control[readonly],\n  fieldset[disabled] .form-control {\n    background-color: #eeeeee;\n    opacity: 1;\n}\n.form-control[disabled],\n  fieldset[disabled] .form-control {\n    cursor: not-allowed;\n}\ntextarea.form-control {\n  height: auto;\n}\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\ninput[type=\"date\"].form-control,\n  input[type=\"time\"].form-control,\n  input[type=\"datetime-local\"].form-control,\n  input[type=\"month\"].form-control {\n    line-height: 34px;\n}\ninput[type=\"date\"].input-sm, .input-group-sm > input.form-control[type=\"date\"],\n  .input-group-sm > input.input-group-addon[type=\"date\"],\n  .input-group-sm > .input-group-btn > input.btn[type=\"date\"],\n  .input-group-sm input[type=\"date\"],\n  input[type=\"time\"].input-sm,\n  .input-group-sm > input.form-control[type=\"time\"],\n  .input-group-sm > input.input-group-addon[type=\"time\"],\n  .input-group-sm > .input-group-btn > input.btn[type=\"time\"],\n  .input-group-sm\n  input[type=\"time\"],\n  input[type=\"datetime-local\"].input-sm,\n  .input-group-sm > input.form-control[type=\"datetime-local\"],\n  .input-group-sm > input.input-group-addon[type=\"datetime-local\"],\n  .input-group-sm > .input-group-btn > input.btn[type=\"datetime-local\"],\n  .input-group-sm\n  input[type=\"datetime-local\"],\n  input[type=\"month\"].input-sm,\n  .input-group-sm > input.form-control[type=\"month\"],\n  .input-group-sm > input.input-group-addon[type=\"month\"],\n  .input-group-sm > .input-group-btn > input.btn[type=\"month\"],\n  .input-group-sm\n  input[type=\"month\"] {\n    line-height: 30px;\n}\ninput[type=\"date\"].input-lg, .input-group-lg > input.form-control[type=\"date\"],\n  .input-group-lg > input.input-group-addon[type=\"date\"],\n  .input-group-lg > .input-group-btn > input.btn[type=\"date\"],\n  .input-group-lg input[type=\"date\"],\n  input[type=\"time\"].input-lg,\n  .input-group-lg > input.form-control[type=\"time\"],\n  .input-group-lg > input.input-group-addon[type=\"time\"],\n  .input-group-lg > .input-group-btn > input.btn[type=\"time\"],\n  .input-group-lg\n  input[type=\"time\"],\n  input[type=\"datetime-local\"].input-lg,\n  .input-group-lg > input.form-control[type=\"datetime-local\"],\n  .input-group-lg > input.input-group-addon[type=\"datetime-local\"],\n  .input-group-lg > .input-group-btn > input.btn[type=\"datetime-local\"],\n  .input-group-lg\n  input[type=\"datetime-local\"],\n  input[type=\"month\"].input-lg,\n  .input-group-lg > input.form-control[type=\"month\"],\n  .input-group-lg > input.input-group-addon[type=\"month\"],\n  .input-group-lg > .input-group-btn > input.btn[type=\"month\"],\n  .input-group-lg\n  input[type=\"month\"] {\n    line-height: 46px;\n}\n}\n.form-group {\n  margin-bottom: 15px;\n}\n.radio,\n.checkbox {\n  position: relative;\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.radio.disabled label,\n  fieldset[disabled] .radio label,\n  .checkbox.disabled label,\n  fieldset[disabled]\n  .checkbox label {\n    cursor: not-allowed;\n}\n.radio label,\n  .checkbox label {\n    min-height: 20px;\n    padding-left: 20px;\n    margin-bottom: 0;\n    font-weight: 400;\n    cursor: pointer;\n}\n.radio input[type=\"radio\"],\n.radio-inline input[type=\"radio\"],\n.checkbox input[type=\"checkbox\"],\n.checkbox-inline input[type=\"checkbox\"] {\n  position: absolute;\n  margin-top: 4px \\9;\n  margin-left: -20px;\n}\n.radio + .radio,\n.checkbox + .checkbox {\n  margin-top: -5px;\n}\n.radio-inline,\n.checkbox-inline {\n  position: relative;\n  display: inline-block;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: 400;\n  vertical-align: middle;\n  cursor: pointer;\n}\n.radio-inline.disabled,\n  fieldset[disabled] .radio-inline,\n  .checkbox-inline.disabled,\n  fieldset[disabled]\n  .checkbox-inline {\n    cursor: not-allowed;\n}\n.radio-inline + .radio-inline,\n.checkbox-inline + .checkbox-inline {\n  margin-top: 0;\n  margin-left: 10px;\n}\n.form-control-static {\n  min-height: 34px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  margin-bottom: 0;\n}\n.form-control-static.input-lg, .input-group-lg > .form-control-static.form-control,\n  .input-group-lg > .form-control-static.input-group-addon,\n  .input-group-lg > .input-group-btn > .form-control-static.btn, .form-control-static.input-sm, .input-group-sm > .form-control-static.form-control,\n  .input-group-sm > .form-control-static.input-group-addon,\n  .input-group-sm > .input-group-btn > .form-control-static.btn {\n    padding-right: 0;\n    padding-left: 0;\n}\n.input-sm, .input-group-sm > .form-control,\n.input-group-sm > .input-group-addon,\n.input-group-sm > .input-group-btn > .btn {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\nselect.input-sm, .input-group-sm > select.form-control,\n.input-group-sm > select.input-group-addon,\n.input-group-sm > .input-group-btn > select.btn {\n  height: 30px;\n  line-height: 30px;\n}\ntextarea.input-sm, .input-group-sm > textarea.form-control,\n.input-group-sm > textarea.input-group-addon,\n.input-group-sm > .input-group-btn > textarea.btn,\nselect[multiple].input-sm,\n.input-group-sm > select.form-control[multiple],\n.input-group-sm > select.input-group-addon[multiple],\n.input-group-sm > .input-group-btn > select.btn[multiple] {\n  height: auto;\n}\n.form-group-sm .form-control {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.form-group-sm select.form-control {\n  height: 30px;\n  line-height: 30px;\n}\n.form-group-sm textarea.form-control,\n.form-group-sm select[multiple].form-control {\n  height: auto;\n}\n.form-group-sm .form-control-static {\n  height: 30px;\n  min-height: 32px;\n  padding: 6px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.input-lg, .input-group-lg > .form-control,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .btn {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33333;\n  border-radius: 6px;\n}\nselect.input-lg, .input-group-lg > select.form-control,\n.input-group-lg > select.input-group-addon,\n.input-group-lg > .input-group-btn > select.btn {\n  height: 46px;\n  line-height: 46px;\n}\ntextarea.input-lg, .input-group-lg > textarea.form-control,\n.input-group-lg > textarea.input-group-addon,\n.input-group-lg > .input-group-btn > textarea.btn,\nselect[multiple].input-lg,\n.input-group-lg > select.form-control[multiple],\n.input-group-lg > select.input-group-addon[multiple],\n.input-group-lg > .input-group-btn > select.btn[multiple] {\n  height: auto;\n}\n.form-group-lg .form-control {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33333;\n  border-radius: 6px;\n}\n.form-group-lg select.form-control {\n  height: 46px;\n  line-height: 46px;\n}\n.form-group-lg textarea.form-control,\n.form-group-lg select[multiple].form-control {\n  height: auto;\n}\n.form-group-lg .form-control-static {\n  height: 46px;\n  min-height: 38px;\n  padding: 11px 16px;\n  font-size: 18px;\n  line-height: 1.33333;\n}\n.has-feedback {\n  position: relative;\n}\n.has-feedback .form-control {\n    padding-right: 42.5px;\n}\n.form-control-feedback {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  display: block;\n  width: 34px;\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  pointer-events: none;\n}\n.input-lg + .form-control-feedback, .input-group-lg > .form-control + .form-control-feedback, .input-group-lg > .input-group-addon + .form-control-feedback, .input-group-lg > .input-group-btn > .btn + .form-control-feedback,\n.input-group-lg + .form-control-feedback,\n.form-group-lg .form-control + .form-control-feedback {\n  width: 46px;\n  height: 46px;\n  line-height: 46px;\n}\n.input-sm + .form-control-feedback, .input-group-sm > .form-control + .form-control-feedback, .input-group-sm > .input-group-addon + .form-control-feedback, .input-group-sm > .input-group-btn > .btn + .form-control-feedback,\n.input-group-sm + .form-control-feedback,\n.form-group-sm .form-control + .form-control-feedback {\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n}\n.has-success .help-block,\n.has-success .control-label,\n.has-success .radio,\n.has-success .checkbox,\n.has-success .radio-inline,\n.has-success .checkbox-inline,\n.has-success.radio label,\n.has-success.checkbox label,\n.has-success.radio-inline label,\n.has-success.checkbox-inline label {\n  color: #3c763d;\n}\n.has-success .form-control {\n  border-color: #3c763d;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.has-success .form-control:focus {\n    border-color: #2b542c;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;\n}\n.has-success .input-group-addon {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #3c763d;\n}\n.has-success .form-control-feedback {\n  color: #3c763d;\n}\n.has-warning .help-block,\n.has-warning .control-label,\n.has-warning .radio,\n.has-warning .checkbox,\n.has-warning .radio-inline,\n.has-warning .checkbox-inline,\n.has-warning.radio label,\n.has-warning.checkbox label,\n.has-warning.radio-inline label,\n.has-warning.checkbox-inline label {\n  color: #8a6d3b;\n}\n.has-warning .form-control {\n  border-color: #8a6d3b;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.has-warning .form-control:focus {\n    border-color: #66512c;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;\n}\n.has-warning .input-group-addon {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #8a6d3b;\n}\n.has-warning .form-control-feedback {\n  color: #8a6d3b;\n}\n.has-error .help-block,\n.has-error .control-label,\n.has-error .radio,\n.has-error .checkbox,\n.has-error .radio-inline,\n.has-error .checkbox-inline,\n.has-error.radio label,\n.has-error.checkbox label,\n.has-error.radio-inline label,\n.has-error.checkbox-inline label {\n  color: #a94442;\n}\n.has-error .form-control {\n  border-color: #a94442;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.has-error .form-control:focus {\n    border-color: #843534;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;\n}\n.has-error .input-group-addon {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #a94442;\n}\n.has-error .form-control-feedback {\n  color: #a94442;\n}\n.has-feedback label ~ .form-control-feedback {\n  top: 25px;\n}\n.has-feedback label.sr-only ~ .form-control-feedback {\n  top: 0;\n}\n.help-block {\n  display: block;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: #9e9e9e;\n}\n@media (min-width: 768px) {\n.form-inline .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle;\n}\n.form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n}\n.form-inline .form-control-static {\n    display: inline-block;\n}\n.form-inline .input-group {\n    display: inline-table;\n    vertical-align: middle;\n}\n.form-inline .input-group .input-group-addon,\n    .form-inline .input-group .input-group-btn,\n    .form-inline .input-group .form-control {\n      width: auto;\n}\n.form-inline .input-group > .form-control {\n    width: 100%;\n}\n.form-inline .control-label {\n    margin-bottom: 0;\n    vertical-align: middle;\n}\n.form-inline .radio,\n  .form-inline .checkbox {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: middle;\n}\n.form-inline .radio label,\n    .form-inline .checkbox label {\n      padding-left: 0;\n}\n.form-inline .radio input[type=\"radio\"],\n  .form-inline .checkbox input[type=\"checkbox\"] {\n    position: relative;\n    margin-left: 0;\n}\n.form-inline .has-feedback .form-control-feedback {\n    top: 0;\n}\n}\n.form-horizontal .radio,\n.form-horizontal .checkbox,\n.form-horizontal .radio-inline,\n.form-horizontal .checkbox-inline {\n  padding-top: 7px;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.form-horizontal .radio,\n.form-horizontal .checkbox {\n  min-height: 27px;\n}\n.form-horizontal .form-group {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.form-horizontal .form-group:before, .form-horizontal .form-group:after {\n    display: table;\n    content: \" \";\n}\n.form-horizontal .form-group:after {\n    clear: both;\n}\n@media (min-width: 768px) {\n.form-horizontal .control-label {\n    padding-top: 7px;\n    margin-bottom: 0;\n    text-align: right;\n}\n}\n.form-horizontal .has-feedback .form-control-feedback {\n  right: 15px;\n}\n@media (min-width: 768px) {\n.form-horizontal .form-group-lg .control-label {\n    padding-top: 11px;\n    font-size: 18px;\n}\n}\n@media (min-width: 768px) {\n.form-horizontal .form-group-sm .control-label {\n    padding-top: 6px;\n    font-size: 12px;\n}\n}\n.btn {\n  display: inline-block;\n  margin-bottom: 0;\n  font-weight: normal;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  cursor: pointer;\n  background-image: none;\n  border: 1px solid transparent;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857;\n  border-radius: 4px;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.btn:focus, .btn.focus, .btn:active:focus, .btn:active.focus, .btn.active:focus, .btn.active.focus {\n    outline: 5px auto -webkit-focus-ring-color;\n    outline-offset: -2px;\n}\n.btn:hover, .btn:focus, .btn.focus {\n    color: #333;\n    text-decoration: none;\n}\n.btn:active, .btn.active {\n    background-image: none;\n    outline: 0;\n    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.btn.disabled, .btn[disabled],\n  fieldset[disabled] .btn {\n    cursor: not-allowed;\n    filter: alpha(opacity=65);\n    opacity: 0.65;\n    box-shadow: none;\n}\na.btn.disabled,\nfieldset[disabled] a.btn {\n  pointer-events: none;\n}\n.btn-default {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn-default:focus, .btn-default.focus {\n    color: #333;\n    background-color: #e6e6e6;\n    border-color: #8c8c8c;\n}\n.btn-default:hover {\n    color: #333;\n    background-color: #e6e6e6;\n    border-color: #adadad;\n}\n.btn-default:active, .btn-default.active,\n  .open > .btn-default.dropdown-toggle {\n    color: #333;\n    background-color: #e6e6e6;\n    background-image: none;\n    border-color: #adadad;\n}\n.btn-default:active:hover, .btn-default:active:focus, .btn-default:active.focus, .btn-default.active:hover, .btn-default.active:focus, .btn-default.active.focus,\n    .open > .btn-default.dropdown-toggle:hover,\n    .open > .btn-default.dropdown-toggle:focus,\n    .open > .btn-default.dropdown-toggle.focus {\n      color: #333;\n      background-color: #d4d4d4;\n      border-color: #8c8c8c;\n}\n.btn-default.disabled:hover, .btn-default.disabled:focus, .btn-default.disabled.focus, .btn-default[disabled]:hover, .btn-default[disabled]:focus, .btn-default[disabled].focus,\n  fieldset[disabled] .btn-default:hover,\n  fieldset[disabled] .btn-default:focus,\n  fieldset[disabled] .btn-default.focus {\n    background-color: #fff;\n    border-color: #ccc;\n}\n.btn-default .badge {\n    color: #fff;\n    background-color: #333;\n}\n.btn-primary {\n  color: #fff;\n  background-color: #f0617d;\n  border-color: #ee4a6a;\n}\n.btn-primary:focus, .btn-primary.focus {\n    color: #fff;\n    background-color: #ec3257;\n    border-color: #a8102e;\n}\n.btn-primary:hover {\n    color: #fff;\n    background-color: #ec3257;\n    border-color: #e5163e;\n}\n.btn-primary:active, .btn-primary.active,\n  .open > .btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #ec3257;\n    background-image: none;\n    border-color: #e5163e;\n}\n.btn-primary:active:hover, .btn-primary:active:focus, .btn-primary:active.focus, .btn-primary.active:hover, .btn-primary.active:focus, .btn-primary.active.focus,\n    .open > .btn-primary.dropdown-toggle:hover,\n    .open > .btn-primary.dropdown-toggle:focus,\n    .open > .btn-primary.dropdown-toggle.focus {\n      color: #fff;\n      background-color: #e5163e;\n      border-color: #a8102e;\n}\n.btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled.focus, .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled].focus,\n  fieldset[disabled] .btn-primary:hover,\n  fieldset[disabled] .btn-primary:focus,\n  fieldset[disabled] .btn-primary.focus {\n    background-color: #f0617d;\n    border-color: #ee4a6a;\n}\n.btn-primary .badge {\n    color: #f0617d;\n    background-color: #fff;\n}\n.btn-success {\n  color: #fff;\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n.btn-success:focus, .btn-success.focus {\n    color: #fff;\n    background-color: #449d44;\n    border-color: #255625;\n}\n.btn-success:hover {\n    color: #fff;\n    background-color: #449d44;\n    border-color: #398439;\n}\n.btn-success:active, .btn-success.active,\n  .open > .btn-success.dropdown-toggle {\n    color: #fff;\n    background-color: #449d44;\n    background-image: none;\n    border-color: #398439;\n}\n.btn-success:active:hover, .btn-success:active:focus, .btn-success:active.focus, .btn-success.active:hover, .btn-success.active:focus, .btn-success.active.focus,\n    .open > .btn-success.dropdown-toggle:hover,\n    .open > .btn-success.dropdown-toggle:focus,\n    .open > .btn-success.dropdown-toggle.focus {\n      color: #fff;\n      background-color: #398439;\n      border-color: #255625;\n}\n.btn-success.disabled:hover, .btn-success.disabled:focus, .btn-success.disabled.focus, .btn-success[disabled]:hover, .btn-success[disabled]:focus, .btn-success[disabled].focus,\n  fieldset[disabled] .btn-success:hover,\n  fieldset[disabled] .btn-success:focus,\n  fieldset[disabled] .btn-success.focus {\n    background-color: #5cb85c;\n    border-color: #4cae4c;\n}\n.btn-success .badge {\n    color: #5cb85c;\n    background-color: #fff;\n}\n.btn-info {\n  color: #fff;\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n.btn-info:focus, .btn-info.focus {\n    color: #fff;\n    background-color: #31b0d5;\n    border-color: #1b6d85;\n}\n.btn-info:hover {\n    color: #fff;\n    background-color: #31b0d5;\n    border-color: #269abc;\n}\n.btn-info:active, .btn-info.active,\n  .open > .btn-info.dropdown-toggle {\n    color: #fff;\n    background-color: #31b0d5;\n    background-image: none;\n    border-color: #269abc;\n}\n.btn-info:active:hover, .btn-info:active:focus, .btn-info:active.focus, .btn-info.active:hover, .btn-info.active:focus, .btn-info.active.focus,\n    .open > .btn-info.dropdown-toggle:hover,\n    .open > .btn-info.dropdown-toggle:focus,\n    .open > .btn-info.dropdown-toggle.focus {\n      color: #fff;\n      background-color: #269abc;\n      border-color: #1b6d85;\n}\n.btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled.focus, .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled].focus,\n  fieldset[disabled] .btn-info:hover,\n  fieldset[disabled] .btn-info:focus,\n  fieldset[disabled] .btn-info.focus {\n    background-color: #5bc0de;\n    border-color: #46b8da;\n}\n.btn-info .badge {\n    color: #5bc0de;\n    background-color: #fff;\n}\n.btn-warning {\n  color: #fff;\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n.btn-warning:focus, .btn-warning.focus {\n    color: #fff;\n    background-color: #ec971f;\n    border-color: #985f0d;\n}\n.btn-warning:hover {\n    color: #fff;\n    background-color: #ec971f;\n    border-color: #d58512;\n}\n.btn-warning:active, .btn-warning.active,\n  .open > .btn-warning.dropdown-toggle {\n    color: #fff;\n    background-color: #ec971f;\n    background-image: none;\n    border-color: #d58512;\n}\n.btn-warning:active:hover, .btn-warning:active:focus, .btn-warning:active.focus, .btn-warning.active:hover, .btn-warning.active:focus, .btn-warning.active.focus,\n    .open > .btn-warning.dropdown-toggle:hover,\n    .open > .btn-warning.dropdown-toggle:focus,\n    .open > .btn-warning.dropdown-toggle.focus {\n      color: #fff;\n      background-color: #d58512;\n      border-color: #985f0d;\n}\n.btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled.focus, .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled].focus,\n  fieldset[disabled] .btn-warning:hover,\n  fieldset[disabled] .btn-warning:focus,\n  fieldset[disabled] .btn-warning.focus {\n    background-color: #f0ad4e;\n    border-color: #eea236;\n}\n.btn-warning .badge {\n    color: #f0ad4e;\n    background-color: #fff;\n}\n.btn-danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.btn-danger:focus, .btn-danger.focus {\n    color: #fff;\n    background-color: #c9302c;\n    border-color: #761c19;\n}\n.btn-danger:hover {\n    color: #fff;\n    background-color: #c9302c;\n    border-color: #ac2925;\n}\n.btn-danger:active, .btn-danger.active,\n  .open > .btn-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #c9302c;\n    background-image: none;\n    border-color: #ac2925;\n}\n.btn-danger:active:hover, .btn-danger:active:focus, .btn-danger:active.focus, .btn-danger.active:hover, .btn-danger.active:focus, .btn-danger.active.focus,\n    .open > .btn-danger.dropdown-toggle:hover,\n    .open > .btn-danger.dropdown-toggle:focus,\n    .open > .btn-danger.dropdown-toggle.focus {\n      color: #fff;\n      background-color: #ac2925;\n      border-color: #761c19;\n}\n.btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled.focus, .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled].focus,\n  fieldset[disabled] .btn-danger:hover,\n  fieldset[disabled] .btn-danger:focus,\n  fieldset[disabled] .btn-danger.focus {\n    background-color: #d9534f;\n    border-color: #d43f3a;\n}\n.btn-danger .badge {\n    color: #d9534f;\n    background-color: #fff;\n}\n.btn-link {\n  font-weight: 400;\n  color: #f0617d;\n  border-radius: 0;\n}\n.btn-link, .btn-link:active, .btn-link.active, .btn-link[disabled],\n  fieldset[disabled] .btn-link {\n    background-color: transparent;\n    box-shadow: none;\n}\n.btn-link, .btn-link:hover, .btn-link:focus, .btn-link:active {\n    border-color: transparent;\n}\n.btn-link:hover, .btn-link:focus {\n    color: #e91b44;\n    text-decoration: underline;\n    background-color: transparent;\n}\n.btn-link[disabled]:hover, .btn-link[disabled]:focus,\n  fieldset[disabled] .btn-link:hover,\n  fieldset[disabled] .btn-link:focus {\n    color: #777777;\n    text-decoration: none;\n}\n.btn-lg, .btn-group-lg > .btn {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33333;\n  border-radius: 6px;\n}\n.btn-sm, .btn-group-sm > .btn {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.btn-xs, .btn-group-xs > .btn {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn-block + .btn-block {\n  margin-top: 5px;\n}\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%;\n}\n.fade {\n  opacity: 0;\n  transition: opacity 0.15s linear;\n}\n.fade.in {\n    opacity: 1;\n}\n.collapse {\n  display: none;\n}\n.collapse.in {\n    display: block;\n}\ntr.collapse.in {\n  display: table-row;\n}\ntbody.collapse.in {\n  display: table-row-group;\n}\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition-property: height, visibility;\n  transition-duration: 0.35s;\n  transition-timing-function: ease;\n}\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid \\9;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n.dropup,\n.dropdown {\n  position: relative;\n}\n.dropdown-toggle:focus {\n  outline: 0;\n}\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  font-size: 14px;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n}\n.dropdown-menu.pull-right {\n    right: 0;\n    left: auto;\n}\n.dropdown-menu .divider {\n    height: 1px;\n    margin: 9px 0;\n    overflow: hidden;\n    background-color: #e5e5e5;\n}\n.dropdown-menu > li > a {\n    display: block;\n    padding: 3px 20px;\n    clear: both;\n    font-weight: 400;\n    line-height: 1.42857;\n    color: #333333;\n    white-space: nowrap;\n}\n.dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {\n      color: #262626;\n      text-decoration: none;\n      background-color: #f5f5f5;\n}\n.dropdown-menu > .active > a, .dropdown-menu > .active > a:hover, .dropdown-menu > .active > a:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: #f0617d;\n  outline: 0;\n}\n.dropdown-menu > .disabled > a, .dropdown-menu > .disabled > a:hover, .dropdown-menu > .disabled > a:focus {\n  color: #777777;\n}\n.dropdown-menu > .disabled > a:hover, .dropdown-menu > .disabled > a:focus {\n  text-decoration: none;\n  cursor: not-allowed;\n  background-color: transparent;\n  background-image: none;\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);\n}\n.open > .dropdown-menu {\n  display: block;\n}\n.open > a {\n  outline: 0;\n}\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n.dropdown-header {\n  display: block;\n  padding: 3px 20px;\n  font-size: 12px;\n  line-height: 1.42857;\n  color: #777777;\n  white-space: nowrap;\n}\n.dropdown-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 990;\n}\n.pull-right > .dropdown-menu {\n  right: 0;\n  left: auto;\n}\n.dropup .caret,\n.navbar-fixed-bottom .dropdown .caret {\n  content: \"\";\n  border-top: 0;\n  border-bottom: 4px dashed;\n  border-bottom: 4px solid \\9;\n}\n.dropup .dropdown-menu,\n.navbar-fixed-bottom .dropdown .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-bottom: 2px;\n}\n@media (min-width: 768px) {\n.navbar-right .dropdown-menu {\n    right: 0;\n    left: auto;\n}\n.navbar-right .dropdown-menu-left {\n    left: 0;\n    right: auto;\n}\n}\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n  .btn-group-vertical > .btn {\n    position: relative;\n    float: left;\n}\n.btn-group > .btn:hover, .btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n    .btn-group-vertical > .btn:hover,\n    .btn-group-vertical > .btn:focus,\n    .btn-group-vertical > .btn:active,\n    .btn-group-vertical > .btn.active {\n      z-index: 2;\n}\n.btn-group .btn + .btn,\n.btn-group .btn + .btn-group,\n.btn-group .btn-group + .btn,\n.btn-group .btn-group + .btn-group {\n  margin-left: -1px;\n}\n.btn-toolbar {\n  margin-left: -5px;\n}\n.btn-toolbar:before, .btn-toolbar:after {\n    display: table;\n    content: \" \";\n}\n.btn-toolbar:after {\n    clear: both;\n}\n.btn-toolbar .btn,\n  .btn-toolbar .btn-group,\n  .btn-toolbar .input-group {\n    float: left;\n}\n.btn-toolbar > .btn,\n  .btn-toolbar > .btn-group,\n  .btn-toolbar > .input-group {\n    margin-left: 5px;\n}\n.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n.btn-group > .btn:first-child {\n  margin-left: 0;\n}\n.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.btn-group > .btn:last-child:not(:first-child),\n.btn-group > .dropdown-toggle:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group > .btn-group {\n  float: left;\n}\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group > .btn-group:first-child:not(:last-child) > .btn:last-child,\n.btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group .dropdown-toggle:active,\n.btn-group.open .dropdown-toggle {\n  outline: 0;\n}\n.btn-group > .btn + .dropdown-toggle {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.btn-group > .btn-lg + .dropdown-toggle, .btn-group-lg.btn-group > .btn + .dropdown-toggle {\n  padding-right: 12px;\n  padding-left: 12px;\n}\n.btn-group.open .dropdown-toggle {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.btn-group.open .dropdown-toggle.btn-link {\n    box-shadow: none;\n}\n.btn .caret {\n  margin-left: 0;\n}\n.btn-lg .caret, .btn-group-lg > .btn .caret {\n  border-width: 5px 5px 0;\n  border-bottom-width: 0;\n}\n.dropup .btn-lg .caret, .dropup .btn-group-lg > .btn .caret {\n  border-width: 0 5px 5px;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group,\n.btn-group-vertical > .btn-group > .btn {\n  display: block;\n  float: none;\n  width: 100%;\n  max-width: 100%;\n}\n.btn-group-vertical > .btn-group:before, .btn-group-vertical > .btn-group:after {\n  display: table;\n  content: \" \";\n}\n.btn-group-vertical > .btn-group:after {\n  clear: both;\n}\n.btn-group-vertical > .btn-group > .btn {\n  float: none;\n}\n.btn-group-vertical > .btn + .btn,\n.btn-group-vertical > .btn + .btn-group,\n.btn-group-vertical > .btn-group + .btn,\n.btn-group-vertical > .btn-group + .btn-group {\n  margin-top: -1px;\n  margin-left: 0;\n}\n.btn-group-vertical > .btn:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn:first-child:not(:last-child) {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .btn:last-child,\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.btn-group-justified {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n.btn-group-justified > .btn,\n  .btn-group-justified > .btn-group {\n    display: table-cell;\n    float: none;\n    width: 1%;\n}\n.btn-group-justified > .btn-group .btn {\n    width: 100%;\n}\n.btn-group-justified > .btn-group .dropdown-menu {\n    left: auto;\n}\n[data-toggle=\"buttons\"] > .btn input[type=\"radio\"],\n[data-toggle=\"buttons\"] > .btn input[type=\"checkbox\"],\n[data-toggle=\"buttons\"] > .btn-group > .btn input[type=\"radio\"],\n[data-toggle=\"buttons\"] > .btn-group > .btn input[type=\"checkbox\"] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n}\n.input-group[class*=\"col-\"] {\n    float: none;\n    padding-right: 0;\n    padding-left: 0;\n}\n.input-group .form-control {\n    position: relative;\n    z-index: 2;\n    float: left;\n    width: 100%;\n    margin-bottom: 0;\n}\n.input-group .form-control:focus {\n      z-index: 3;\n}\n.input-group-addon,\n.input-group-btn,\n.input-group .form-control {\n  display: table-cell;\n}\n.input-group-addon:not(:first-child):not(:last-child),\n  .input-group-btn:not(:first-child):not(:last-child),\n  .input-group .form-control:not(:first-child):not(:last-child) {\n    border-radius: 0;\n}\n.input-group-addon,\n.input-group-btn {\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.input-group-addon {\n  padding: 6px 12px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1;\n  color: #555555;\n  text-align: center;\n  background-color: #eeeeee;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.input-group-addon.input-sm,\n  .input-group-sm > .input-group-addon,\n  .input-group-sm > .input-group-btn > .input-group-addon.btn {\n    padding: 5px 10px;\n    font-size: 12px;\n    border-radius: 3px;\n}\n.input-group-addon.input-lg,\n  .input-group-lg > .input-group-addon,\n  .input-group-lg > .input-group-btn > .input-group-addon.btn {\n    padding: 10px 16px;\n    font-size: 18px;\n    border-radius: 6px;\n}\n.input-group-addon input[type=\"radio\"],\n  .input-group-addon input[type=\"checkbox\"] {\n    margin-top: 0;\n}\n.input-group .form-control:first-child,\n.input-group-addon:first-child,\n.input-group-btn:first-child > .btn,\n.input-group-btn:first-child > .btn-group > .btn,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group-btn:last-child > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group-addon:first-child {\n  border-right: 0;\n}\n.input-group .form-control:last-child,\n.input-group-addon:last-child,\n.input-group-btn:last-child > .btn,\n.input-group-btn:last-child > .btn-group > .btn,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child),\n.input-group-btn:first-child > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group-addon:last-child {\n  border-left: 0;\n}\n.input-group-btn {\n  position: relative;\n  font-size: 0;\n  white-space: nowrap;\n}\n.input-group-btn > .btn {\n    position: relative;\n}\n.input-group-btn > .btn + .btn {\n      margin-left: -1px;\n}\n.input-group-btn > .btn:hover, .input-group-btn > .btn:focus, .input-group-btn > .btn:active {\n      z-index: 2;\n}\n.input-group-btn:first-child > .btn,\n  .input-group-btn:first-child > .btn-group {\n    margin-right: -1px;\n}\n.input-group-btn:last-child > .btn,\n  .input-group-btn:last-child > .btn-group {\n    z-index: 2;\n    margin-left: -1px;\n}\n.nav {\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.nav:before, .nav:after {\n    display: table;\n    content: \" \";\n}\n.nav:after {\n    clear: both;\n}\n.nav > li {\n    position: relative;\n    display: block;\n}\n.nav > li > a {\n      position: relative;\n      display: block;\n      padding: 10px 15px;\n}\n.nav > li > a:hover, .nav > li > a:focus {\n        text-decoration: none;\n        background-color: #eeeeee;\n}\n.nav > li.disabled > a {\n      color: #777777;\n}\n.nav > li.disabled > a:hover, .nav > li.disabled > a:focus {\n        color: #777777;\n        text-decoration: none;\n        cursor: not-allowed;\n        background-color: transparent;\n}\n.nav .open > a, .nav .open > a:hover, .nav .open > a:focus {\n    background-color: #eeeeee;\n    border-color: #f0617d;\n}\n.nav .nav-divider {\n    height: 1px;\n    margin: 9px 0;\n    overflow: hidden;\n    background-color: #e5e5e5;\n}\n.nav > li > a > img {\n    max-width: none;\n}\n.nav-tabs {\n  border-bottom: 1px solid #ddd;\n}\n.nav-tabs > li {\n    float: left;\n    margin-bottom: -1px;\n}\n.nav-tabs > li > a {\n      margin-right: 2px;\n      line-height: 1.42857;\n      border: 1px solid transparent;\n      border-radius: 4px 4px 0 0;\n}\n.nav-tabs > li > a:hover {\n        border-color: #eeeeee #eeeeee #ddd;\n}\n.nav-tabs > li.active > a, .nav-tabs > li.active > a:hover, .nav-tabs > li.active > a:focus {\n      color: #555555;\n      cursor: default;\n      background-color: #fff;\n      border: 1px solid #ddd;\n      border-bottom-color: transparent;\n}\n.nav-pills > li {\n  float: left;\n}\n.nav-pills > li > a {\n    border-radius: 4px;\n}\n.nav-pills > li + li {\n    margin-left: 2px;\n}\n.nav-pills > li.active > a, .nav-pills > li.active > a:hover, .nav-pills > li.active > a:focus {\n    color: #fff;\n    background-color: #f0617d;\n}\n.nav-stacked > li {\n  float: none;\n}\n.nav-stacked > li + li {\n    margin-top: 2px;\n    margin-left: 0;\n}\n.nav-justified, .nav-tabs.nav-justified {\n  width: 100%;\n}\n.nav-justified > li, .nav-tabs.nav-justified > li {\n    float: none;\n}\n.nav-justified > li > a, .nav-tabs.nav-justified > li > a {\n      margin-bottom: 5px;\n      text-align: center;\n}\n.nav-justified > .dropdown .dropdown-menu {\n    top: auto;\n    left: auto;\n}\n@media (min-width: 768px) {\n.nav-justified > li, .nav-tabs.nav-justified > li {\n      display: table-cell;\n      width: 1%;\n}\n.nav-justified > li > a, .nav-tabs.nav-justified > li > a {\n        margin-bottom: 0;\n}\n}\n.nav-tabs-justified, .nav-tabs.nav-justified {\n  border-bottom: 0;\n}\n.nav-tabs-justified > li > a, .nav-tabs.nav-justified > li > a {\n    margin-right: 0;\n    border-radius: 4px;\n}\n.nav-tabs-justified > .active > a, .nav-tabs.nav-justified > .active > a,\n  .nav-tabs-justified > .active > a:hover,\n  .nav-tabs.nav-justified > .active > a:hover,\n  .nav-tabs-justified > .active > a:focus,\n  .nav-tabs.nav-justified > .active > a:focus {\n    border: 1px solid #ddd;\n}\n@media (min-width: 768px) {\n.nav-tabs-justified > li > a, .nav-tabs.nav-justified > li > a {\n      border-bottom: 1px solid #ddd;\n      border-radius: 4px 4px 0 0;\n}\n.nav-tabs-justified > .active > a, .nav-tabs.nav-justified > .active > a,\n    .nav-tabs-justified > .active > a:hover,\n    .nav-tabs.nav-justified > .active > a:hover,\n    .nav-tabs-justified > .active > a:focus,\n    .nav-tabs.nav-justified > .active > a:focus {\n      border-bottom-color: #fff;\n}\n}\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.navbar {\n  position: relative;\n  min-height: 50px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n}\n.navbar:before, .navbar:after {\n    display: table;\n    content: \" \";\n}\n.navbar:after {\n    clear: both;\n}\n@media (min-width: 768px) {\n.navbar {\n      border-radius: 4px;\n}\n}\n.navbar-header:before, .navbar-header:after {\n  display: table;\n  content: \" \";\n}\n.navbar-header:after {\n  clear: both;\n}\n@media (min-width: 768px) {\n.navbar-header {\n    float: left;\n}\n}\n.navbar-collapse {\n  padding-right: 15px;\n  padding-left: 15px;\n  overflow-x: visible;\n  border-top: 1px solid transparent;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  -webkit-overflow-scrolling: touch;\n}\n.navbar-collapse:before, .navbar-collapse:after {\n    display: table;\n    content: \" \";\n}\n.navbar-collapse:after {\n    clear: both;\n}\n.navbar-collapse.in {\n    overflow-y: auto;\n}\n@media (min-width: 768px) {\n.navbar-collapse {\n      width: auto;\n      border-top: 0;\n      box-shadow: none;\n}\n.navbar-collapse.collapse {\n        display: block !important;\n        height: auto !important;\n        padding-bottom: 0;\n        overflow: visible !important;\n}\n.navbar-collapse.in {\n        overflow-y: visible;\n}\n.navbar-fixed-top .navbar-collapse,\n      .navbar-static-top .navbar-collapse,\n      .navbar-fixed-bottom .navbar-collapse {\n        padding-right: 0;\n        padding-left: 0;\n}\n}\n.navbar-fixed-top,\n.navbar-fixed-bottom {\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n.navbar-fixed-top .navbar-collapse,\n  .navbar-fixed-bottom .navbar-collapse {\n    max-height: 340px;\n}\n@media (max-device-width: 480px) and (orientation: landscape) {\n.navbar-fixed-top .navbar-collapse,\n      .navbar-fixed-bottom .navbar-collapse {\n        max-height: 200px;\n}\n}\n@media (min-width: 768px) {\n.navbar-fixed-top,\n    .navbar-fixed-bottom {\n      border-radius: 0;\n}\n}\n.navbar-fixed-top {\n  top: 0;\n  border-width: 0 0 1px;\n}\n.navbar-fixed-bottom {\n  bottom: 0;\n  margin-bottom: 0;\n  border-width: 1px 0 0;\n}\n.container > .navbar-header,\n.container > .navbar-collapse,\n.container-fluid > .navbar-header,\n.container-fluid > .navbar-collapse {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n@media (min-width: 768px) {\n.container > .navbar-header,\n    .container > .navbar-collapse,\n    .container-fluid > .navbar-header,\n    .container-fluid > .navbar-collapse {\n      margin-right: 0;\n      margin-left: 0;\n}\n}\n.navbar-static-top {\n  z-index: 1000;\n  border-width: 0 0 1px;\n}\n@media (min-width: 768px) {\n.navbar-static-top {\n      border-radius: 0;\n}\n}\n.navbar-brand {\n  float: left;\n  height: 50px;\n  padding: 15px 15px;\n  font-size: 18px;\n  line-height: 20px;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n    text-decoration: none;\n}\n.navbar-brand > img {\n    display: block;\n}\n@media (min-width: 768px) {\n.navbar > .container .navbar-brand,\n    .navbar > .container-fluid .navbar-brand {\n      margin-left: -15px;\n}\n}\n.navbar-toggle {\n  position: relative;\n  float: right;\n  padding: 9px 10px;\n  margin-right: 15px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  background-color: transparent;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.navbar-toggle:focus {\n    outline: 0;\n}\n.navbar-toggle .icon-bar {\n    display: block;\n    width: 22px;\n    height: 2px;\n    border-radius: 1px;\n}\n.navbar-toggle .icon-bar + .icon-bar {\n    margin-top: 4px;\n}\n@media (min-width: 768px) {\n.navbar-toggle {\n      display: none;\n}\n}\n.navbar-nav {\n  margin: 7.5px -15px;\n}\n.navbar-nav > li > a {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    line-height: 20px;\n}\n@media (max-width: 767px) {\n.navbar-nav .open .dropdown-menu {\n      position: static;\n      float: none;\n      width: auto;\n      margin-top: 0;\n      background-color: transparent;\n      border: 0;\n      box-shadow: none;\n}\n.navbar-nav .open .dropdown-menu > li > a,\n      .navbar-nav .open .dropdown-menu .dropdown-header {\n        padding: 5px 15px 5px 25px;\n}\n.navbar-nav .open .dropdown-menu > li > a {\n        line-height: 20px;\n}\n.navbar-nav .open .dropdown-menu > li > a:hover, .navbar-nav .open .dropdown-menu > li > a:focus {\n          background-image: none;\n}\n}\n@media (min-width: 768px) {\n.navbar-nav {\n      float: left;\n      margin: 0;\n}\n.navbar-nav > li {\n        float: left;\n}\n.navbar-nav > li > a {\n          padding-top: 15px;\n          padding-bottom: 15px;\n}\n}\n.navbar-form {\n  padding: 10px 15px;\n  margin-right: -15px;\n  margin-left: -15px;\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n@media (min-width: 768px) {\n.navbar-form .form-group {\n      display: inline-block;\n      margin-bottom: 0;\n      vertical-align: middle;\n}\n.navbar-form .form-control {\n      display: inline-block;\n      width: auto;\n      vertical-align: middle;\n}\n.navbar-form .form-control-static {\n      display: inline-block;\n}\n.navbar-form .input-group {\n      display: inline-table;\n      vertical-align: middle;\n}\n.navbar-form .input-group .input-group-addon,\n      .navbar-form .input-group .input-group-btn,\n      .navbar-form .input-group .form-control {\n        width: auto;\n}\n.navbar-form .input-group > .form-control {\n      width: 100%;\n}\n.navbar-form .control-label {\n      margin-bottom: 0;\n      vertical-align: middle;\n}\n.navbar-form .radio,\n    .navbar-form .checkbox {\n      display: inline-block;\n      margin-top: 0;\n      margin-bottom: 0;\n      vertical-align: middle;\n}\n.navbar-form .radio label,\n      .navbar-form .checkbox label {\n        padding-left: 0;\n}\n.navbar-form .radio input[type=\"radio\"],\n    .navbar-form .checkbox input[type=\"checkbox\"] {\n      position: relative;\n      margin-left: 0;\n}\n.navbar-form .has-feedback .form-control-feedback {\n      top: 0;\n}\n}\n@media (max-width: 767px) {\n.navbar-form .form-group {\n      margin-bottom: 5px;\n}\n.navbar-form .form-group:last-child {\n        margin-bottom: 0;\n}\n}\n@media (min-width: 768px) {\n.navbar-form {\n      width: auto;\n      padding-top: 0;\n      padding-bottom: 0;\n      margin-right: 0;\n      margin-left: 0;\n      border: 0;\n      box-shadow: none;\n}\n}\n.navbar-nav > li > .dropdown-menu {\n  margin-top: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {\n  margin-bottom: 0;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.navbar-btn {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n.navbar-btn.btn-sm, .btn-group-sm > .navbar-btn.btn {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n.navbar-btn.btn-xs, .btn-group-xs > .navbar-btn.btn {\n    margin-top: 14px;\n    margin-bottom: 14px;\n}\n.navbar-text {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n@media (min-width: 768px) {\n.navbar-text {\n      float: left;\n      margin-right: 15px;\n      margin-left: 15px;\n}\n}\n@media (min-width: 768px) {\n.navbar-left {\n    float: left !important;\n}\n.navbar-right {\n    float: right !important;\n    margin-right: -15px;\n}\n.navbar-right ~ .navbar-right {\n      margin-right: 0;\n}\n}\n.navbar-default {\n  background-color: #f8f8f8;\n  border-color: #e7e7e7;\n}\n.navbar-default .navbar-brand {\n    color: #777;\n}\n.navbar-default .navbar-brand:hover, .navbar-default .navbar-brand:focus {\n      color: #5e5e5e;\n      background-color: transparent;\n}\n.navbar-default .navbar-text {\n    color: #777;\n}\n.navbar-default .navbar-nav > li > a {\n    color: #777;\n}\n.navbar-default .navbar-nav > li > a:hover, .navbar-default .navbar-nav > li > a:focus {\n      color: #333;\n      background-color: transparent;\n}\n.navbar-default .navbar-nav > .active > a, .navbar-default .navbar-nav > .active > a:hover, .navbar-default .navbar-nav > .active > a:focus {\n    color: #555;\n    background-color: #e7e7e7;\n}\n.navbar-default .navbar-nav > .disabled > a, .navbar-default .navbar-nav > .disabled > a:hover, .navbar-default .navbar-nav > .disabled > a:focus {\n    color: #ccc;\n    background-color: transparent;\n}\n.navbar-default .navbar-nav > .open > a, .navbar-default .navbar-nav > .open > a:hover, .navbar-default .navbar-nav > .open > a:focus {\n    color: #555;\n    background-color: #e7e7e7;\n}\n@media (max-width: 767px) {\n.navbar-default .navbar-nav .open .dropdown-menu > li > a {\n      color: #777;\n}\n.navbar-default .navbar-nav .open .dropdown-menu > li > a:hover, .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {\n        color: #333;\n        background-color: transparent;\n}\n.navbar-default .navbar-nav .open .dropdown-menu > .active > a, .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover, .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {\n      color: #555;\n      background-color: #e7e7e7;\n}\n.navbar-default .navbar-nav .open .dropdown-menu > .disabled > a, .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover, .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n      color: #ccc;\n      background-color: transparent;\n}\n}\n.navbar-default .navbar-toggle {\n    border-color: #ddd;\n}\n.navbar-default .navbar-toggle:hover, .navbar-default .navbar-toggle:focus {\n      background-color: #ddd;\n}\n.navbar-default .navbar-toggle .icon-bar {\n      background-color: #888;\n}\n.navbar-default .navbar-collapse,\n  .navbar-default .navbar-form {\n    border-color: #e7e7e7;\n}\n.navbar-default .navbar-link {\n    color: #777;\n}\n.navbar-default .navbar-link:hover {\n      color: #333;\n}\n.navbar-default .btn-link {\n    color: #777;\n}\n.navbar-default .btn-link:hover, .navbar-default .btn-link:focus {\n      color: #333;\n}\n.navbar-default .btn-link[disabled]:hover, .navbar-default .btn-link[disabled]:focus,\n    fieldset[disabled] .navbar-default .btn-link:hover,\n    fieldset[disabled] .navbar-default .btn-link:focus {\n      color: #ccc;\n}\n.navbar-inverse {\n  background-color: #222;\n  border-color: #090909;\n}\n.navbar-inverse .navbar-brand {\n    color: #9d9d9d;\n}\n.navbar-inverse .navbar-brand:hover, .navbar-inverse .navbar-brand:focus {\n      color: #fff;\n      background-color: transparent;\n}\n.navbar-inverse .navbar-text {\n    color: #9d9d9d;\n}\n.navbar-inverse .navbar-nav > li > a {\n    color: #9d9d9d;\n}\n.navbar-inverse .navbar-nav > li > a:hover, .navbar-inverse .navbar-nav > li > a:focus {\n      color: #fff;\n      background-color: transparent;\n}\n.navbar-inverse .navbar-nav > .active > a, .navbar-inverse .navbar-nav > .active > a:hover, .navbar-inverse .navbar-nav > .active > a:focus {\n    color: #fff;\n    background-color: #090909;\n}\n.navbar-inverse .navbar-nav > .disabled > a, .navbar-inverse .navbar-nav > .disabled > a:hover, .navbar-inverse .navbar-nav > .disabled > a:focus {\n    color: #444;\n    background-color: transparent;\n}\n.navbar-inverse .navbar-nav > .open > a, .navbar-inverse .navbar-nav > .open > a:hover, .navbar-inverse .navbar-nav > .open > a:focus {\n    color: #fff;\n    background-color: #090909;\n}\n@media (max-width: 767px) {\n.navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {\n      border-color: #090909;\n}\n.navbar-inverse .navbar-nav .open .dropdown-menu .divider {\n      background-color: #090909;\n}\n.navbar-inverse .navbar-nav .open .dropdown-menu > li > a {\n      color: #9d9d9d;\n}\n.navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover, .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {\n        color: #fff;\n        background-color: transparent;\n}\n.navbar-inverse .navbar-nav .open .dropdown-menu > .active > a, .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover, .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {\n      color: #fff;\n      background-color: #090909;\n}\n.navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a, .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover, .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n      color: #444;\n      background-color: transparent;\n}\n}\n.navbar-inverse .navbar-toggle {\n    border-color: #333;\n}\n.navbar-inverse .navbar-toggle:hover, .navbar-inverse .navbar-toggle:focus {\n      background-color: #333;\n}\n.navbar-inverse .navbar-toggle .icon-bar {\n      background-color: #fff;\n}\n.navbar-inverse .navbar-collapse,\n  .navbar-inverse .navbar-form {\n    border-color: #101010;\n}\n.navbar-inverse .navbar-link {\n    color: #9d9d9d;\n}\n.navbar-inverse .navbar-link:hover {\n      color: #fff;\n}\n.navbar-inverse .btn-link {\n    color: #9d9d9d;\n}\n.navbar-inverse .btn-link:hover, .navbar-inverse .btn-link:focus {\n      color: #fff;\n}\n.navbar-inverse .btn-link[disabled]:hover, .navbar-inverse .btn-link[disabled]:focus,\n    fieldset[disabled] .navbar-inverse .btn-link:hover,\n    fieldset[disabled] .navbar-inverse .btn-link:focus {\n      color: #444;\n}\n.breadcrumb {\n  padding: 8px 15px;\n  margin-bottom: 20px;\n  list-style: none;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n.breadcrumb > li {\n    display: inline-block;\n}\n.breadcrumb > li + li:before {\n      padding: 0 5px;\n      color: #ccc;\n      content: \"/\\A0\";\n}\n.breadcrumb > .active {\n    color: #777777;\n}\n.pagination {\n  display: inline-block;\n  padding-left: 0;\n  margin: 20px 0;\n  border-radius: 4px;\n}\n.pagination > li {\n    display: inline;\n}\n.pagination > li > a,\n    .pagination > li > span {\n      position: relative;\n      float: left;\n      padding: 6px 12px;\n      margin-left: -1px;\n      line-height: 1.42857;\n      color: #f0617d;\n      text-decoration: none;\n      background-color: #fff;\n      border: 1px solid #ddd;\n}\n.pagination > li > a:hover, .pagination > li > a:focus,\n      .pagination > li > span:hover,\n      .pagination > li > span:focus {\n        z-index: 2;\n        color: #e91b44;\n        background-color: #eeeeee;\n        border-color: #ddd;\n}\n.pagination > li:first-child > a,\n    .pagination > li:first-child > span {\n      margin-left: 0;\n      border-top-left-radius: 4px;\n      border-bottom-left-radius: 4px;\n}\n.pagination > li:last-child > a,\n    .pagination > li:last-child > span {\n      border-top-right-radius: 4px;\n      border-bottom-right-radius: 4px;\n}\n.pagination > .active > a, .pagination > .active > a:hover, .pagination > .active > a:focus,\n  .pagination > .active > span,\n  .pagination > .active > span:hover,\n  .pagination > .active > span:focus {\n    z-index: 3;\n    color: #fff;\n    cursor: default;\n    background-color: #f0617d;\n    border-color: #f0617d;\n}\n.pagination > .disabled > span,\n  .pagination > .disabled > span:hover,\n  .pagination > .disabled > span:focus,\n  .pagination > .disabled > a,\n  .pagination > .disabled > a:hover,\n  .pagination > .disabled > a:focus {\n    color: #777777;\n    cursor: not-allowed;\n    background-color: #fff;\n    border-color: #ddd;\n}\n.pagination-lg > li > a,\n.pagination-lg > li > span {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33333;\n}\n.pagination-lg > li:first-child > a,\n.pagination-lg > li:first-child > span {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.pagination-lg > li:last-child > a,\n.pagination-lg > li:last-child > span {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.pagination-sm > li > a,\n.pagination-sm > li > span {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.pagination-sm > li:first-child > a,\n.pagination-sm > li:first-child > span {\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.pagination-sm > li:last-child > a,\n.pagination-sm > li:last-child > span {\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n.pager {\n  padding-left: 0;\n  margin: 20px 0;\n  text-align: center;\n  list-style: none;\n}\n.pager:before, .pager:after {\n    display: table;\n    content: \" \";\n}\n.pager:after {\n    clear: both;\n}\n.pager li {\n    display: inline;\n}\n.pager li > a,\n    .pager li > span {\n      display: inline-block;\n      padding: 5px 14px;\n      background-color: #fff;\n      border: 1px solid #ddd;\n      border-radius: 15px;\n}\n.pager li > a:hover,\n    .pager li > a:focus {\n      text-decoration: none;\n      background-color: #eeeeee;\n}\n.pager .next > a,\n  .pager .next > span {\n    float: right;\n}\n.pager .previous > a,\n  .pager .previous > span {\n    float: left;\n}\n.pager .disabled > a,\n  .pager .disabled > a:hover,\n  .pager .disabled > a:focus,\n  .pager .disabled > span {\n    color: #777777;\n    cursor: not-allowed;\n    background-color: #fff;\n}\n.label {\n  display: inline;\n  padding: .2em .6em .3em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: .25em;\n}\n.label:empty {\n    display: none;\n}\n.btn .label {\n    position: relative;\n    top: -1px;\n}\na.label:hover, a.label:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.label-default {\n  background-color: #777777;\n}\n.label-default[href]:hover, .label-default[href]:focus {\n    background-color: #5e5e5e;\n}\n.label-primary {\n  background-color: #f0617d;\n}\n.label-primary[href]:hover, .label-primary[href]:focus {\n    background-color: #ec3257;\n}\n.label-success {\n  background-color: #5cb85c;\n}\n.label-success[href]:hover, .label-success[href]:focus {\n    background-color: #449d44;\n}\n.label-info {\n  background-color: #5bc0de;\n}\n.label-info[href]:hover, .label-info[href]:focus {\n    background-color: #31b0d5;\n}\n.label-warning {\n  background-color: #f0ad4e;\n}\n.label-warning[href]:hover, .label-warning[href]:focus {\n    background-color: #ec971f;\n}\n.label-danger {\n  background-color: #d9534f;\n}\n.label-danger[href]:hover, .label-danger[href]:focus {\n    background-color: #c9302c;\n}\n.badge {\n  display: inline-block;\n  min-width: 10px;\n  padding: 3px 7px;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: #777777;\n  border-radius: 10px;\n}\n.badge:empty {\n    display: none;\n}\n.btn .badge {\n    position: relative;\n    top: -1px;\n}\n.btn-xs .badge, .btn-group-xs > .btn .badge,\n  .btn-group-xs > .btn .badge {\n    top: 0;\n    padding: 1px 5px;\n}\n.list-group-item.active > .badge,\n  .nav-pills > .active > a > .badge {\n    color: #f0617d;\n    background-color: #fff;\n}\n.list-group-item > .badge {\n    float: right;\n}\n.list-group-item > .badge + .badge {\n    margin-right: 5px;\n}\n.nav-pills > li > a > .badge {\n    margin-left: 3px;\n}\na.badge:hover, a.badge:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.jumbotron {\n  padding-top: 30px;\n  padding-bottom: 30px;\n  margin-bottom: 30px;\n  color: inherit;\n  background-color: #eeeeee;\n}\n.jumbotron h1,\n  .jumbotron .h1 {\n    color: inherit;\n}\n.jumbotron p {\n    margin-bottom: 15px;\n    font-size: 21px;\n    font-weight: 200;\n}\n.jumbotron > hr {\n    border-top-color: #d5d5d5;\n}\n.container .jumbotron,\n  .container-fluid .jumbotron {\n    padding-right: 15px;\n    padding-left: 15px;\n    border-radius: 6px;\n}\n.jumbotron .container {\n    max-width: 100%;\n}\n@media screen and (min-width: 768px) {\n.jumbotron {\n      padding-top: 48px;\n      padding-bottom: 48px;\n}\n.container .jumbotron,\n      .container-fluid .jumbotron {\n        padding-right: 60px;\n        padding-left: 60px;\n}\n.jumbotron h1,\n      .jumbotron .h1 {\n        font-size: 63px;\n}\n}\n.thumbnail {\n  display: block;\n  padding: 4px;\n  margin-bottom: 20px;\n  line-height: 1.42857;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  transition: border 0.2s ease-in-out;\n}\n.thumbnail > img,\n  .thumbnail a > img {\n    display: block;\n    max-width: 100%;\n    height: auto;\n    margin-right: auto;\n    margin-left: auto;\n}\n.thumbnail .caption {\n    padding: 9px;\n    color: #5E5E5E;\n}\na.thumbnail:hover,\na.thumbnail:focus,\na.thumbnail.active {\n  border-color: #f0617d;\n}\n.alert {\n  padding: 15px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.alert h4 {\n    margin-top: 0;\n    color: inherit;\n}\n.alert .alert-link {\n    font-weight: bold;\n}\n.alert > p,\n  .alert > ul {\n    margin-bottom: 0;\n}\n.alert > p + p {\n    margin-top: 5px;\n}\n.alert-dismissable,\n.alert-dismissible {\n  padding-right: 35px;\n}\n.alert-dismissable .close,\n  .alert-dismissible .close {\n    position: relative;\n    top: -2px;\n    right: -21px;\n    color: inherit;\n}\n.alert-success {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n}\n.alert-success hr {\n    border-top-color: #c9e2b3;\n}\n.alert-success .alert-link {\n    color: #2b542c;\n}\n.alert-info {\n  color: #31708f;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}\n.alert-info hr {\n    border-top-color: #a6e1ec;\n}\n.alert-info .alert-link {\n    color: #245269;\n}\n.alert-warning {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n}\n.alert-warning hr {\n    border-top-color: #f7e1b5;\n}\n.alert-warning .alert-link {\n    color: #66512c;\n}\n.alert-danger {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n}\n.alert-danger hr {\n    border-top-color: #e4b9c0;\n}\n.alert-danger .alert-link {\n    color: #843534;\n}\n@keyframes progress-bar-stripes {\nfrom {\n    background-position: 40px 0;\n}\nto {\n    background-position: 0 0;\n}\n}\n.progress {\n  height: 20px;\n  margin-bottom: 20px;\n  overflow: hidden;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n.progress-bar {\n  float: left;\n  width: 0%;\n  height: 100%;\n  font-size: 12px;\n  line-height: 20px;\n  color: #fff;\n  text-align: center;\n  background-color: #f0617d;\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  transition: width 0.6s ease;\n}\n.progress-striped .progress-bar,\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 40px 40px;\n}\n.progress.active .progress-bar,\n.progress-bar.active {\n  animation: progress-bar-stripes 2s linear infinite;\n}\n.progress-bar-success {\n  background-color: #5cb85c;\n}\n.progress-striped .progress-bar-success {\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n.progress-bar-info {\n  background-color: #5bc0de;\n}\n.progress-striped .progress-bar-info {\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n.progress-bar-warning {\n  background-color: #f0ad4e;\n}\n.progress-striped .progress-bar-warning {\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n.progress-bar-danger {\n  background-color: #d9534f;\n}\n.progress-striped .progress-bar-danger {\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n.media {\n  margin-top: 15px;\n}\n.media:first-child {\n    margin-top: 0;\n}\n.media,\n.media-body {\n  overflow: hidden;\n  zoom: 1;\n}\n.media-body {\n  width: 10000px;\n}\n.media-object {\n  display: block;\n}\n.media-object.img-thumbnail {\n    max-width: none;\n}\n.media-right,\n.media > .pull-right {\n  padding-left: 10px;\n}\n.media-left,\n.media > .pull-left {\n  padding-right: 10px;\n}\n.media-left,\n.media-right,\n.media-body {\n  display: table-cell;\n  vertical-align: top;\n}\n.media-middle {\n  vertical-align: middle;\n}\n.media-bottom {\n  vertical-align: bottom;\n}\n.media-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.media-list {\n  padding-left: 0;\n  list-style: none;\n}\n.list-group {\n  padding-left: 0;\n  margin-bottom: 20px;\n}\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n.list-group-item:first-child {\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n}\n.list-group-item:last-child {\n    margin-bottom: 0;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n.list-group-item.disabled, .list-group-item.disabled:hover, .list-group-item.disabled:focus {\n    color: #777777;\n    cursor: not-allowed;\n    background-color: #eeeeee;\n}\n.list-group-item.disabled .list-group-item-heading, .list-group-item.disabled:hover .list-group-item-heading, .list-group-item.disabled:focus .list-group-item-heading {\n      color: inherit;\n}\n.list-group-item.disabled .list-group-item-text, .list-group-item.disabled:hover .list-group-item-text, .list-group-item.disabled:focus .list-group-item-text {\n      color: #777777;\n}\n.list-group-item.active, .list-group-item.active:hover, .list-group-item.active:focus {\n    z-index: 2;\n    color: #fff;\n    background-color: #f0617d;\n    border-color: #f0617d;\n}\n.list-group-item.active .list-group-item-heading,\n    .list-group-item.active .list-group-item-heading > small,\n    .list-group-item.active .list-group-item-heading > .small, .list-group-item.active:hover .list-group-item-heading,\n    .list-group-item.active:hover .list-group-item-heading > small,\n    .list-group-item.active:hover .list-group-item-heading > .small, .list-group-item.active:focus .list-group-item-heading,\n    .list-group-item.active:focus .list-group-item-heading > small,\n    .list-group-item.active:focus .list-group-item-heading > .small {\n      color: inherit;\n}\n.list-group-item.active .list-group-item-text, .list-group-item.active:hover .list-group-item-text, .list-group-item.active:focus .list-group-item-text {\n      color: white;\n}\na.list-group-item,\nbutton.list-group-item {\n  color: #555;\n}\na.list-group-item .list-group-item-heading,\n  button.list-group-item .list-group-item-heading {\n    color: #333;\n}\na.list-group-item:hover, a.list-group-item:focus,\n  button.list-group-item:hover,\n  button.list-group-item:focus {\n    color: #555;\n    text-decoration: none;\n    background-color: #f5f5f5;\n}\nbutton.list-group-item {\n  width: 100%;\n  text-align: left;\n}\n.list-group-item-success {\n  color: #3c763d;\n  background-color: #dff0d8;\n}\na.list-group-item-success,\nbutton.list-group-item-success {\n  color: #3c763d;\n}\na.list-group-item-success .list-group-item-heading,\n  button.list-group-item-success .list-group-item-heading {\n    color: inherit;\n}\na.list-group-item-success:hover, a.list-group-item-success:focus,\n  button.list-group-item-success:hover,\n  button.list-group-item-success:focus {\n    color: #3c763d;\n    background-color: #d0e9c6;\n}\na.list-group-item-success.active, a.list-group-item-success.active:hover, a.list-group-item-success.active:focus,\n  button.list-group-item-success.active,\n  button.list-group-item-success.active:hover,\n  button.list-group-item-success.active:focus {\n    color: #fff;\n    background-color: #3c763d;\n    border-color: #3c763d;\n}\n.list-group-item-info {\n  color: #31708f;\n  background-color: #d9edf7;\n}\na.list-group-item-info,\nbutton.list-group-item-info {\n  color: #31708f;\n}\na.list-group-item-info .list-group-item-heading,\n  button.list-group-item-info .list-group-item-heading {\n    color: inherit;\n}\na.list-group-item-info:hover, a.list-group-item-info:focus,\n  button.list-group-item-info:hover,\n  button.list-group-item-info:focus {\n    color: #31708f;\n    background-color: #c4e3f3;\n}\na.list-group-item-info.active, a.list-group-item-info.active:hover, a.list-group-item-info.active:focus,\n  button.list-group-item-info.active,\n  button.list-group-item-info.active:hover,\n  button.list-group-item-info.active:focus {\n    color: #fff;\n    background-color: #31708f;\n    border-color: #31708f;\n}\n.list-group-item-warning {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n}\na.list-group-item-warning,\nbutton.list-group-item-warning {\n  color: #8a6d3b;\n}\na.list-group-item-warning .list-group-item-heading,\n  button.list-group-item-warning .list-group-item-heading {\n    color: inherit;\n}\na.list-group-item-warning:hover, a.list-group-item-warning:focus,\n  button.list-group-item-warning:hover,\n  button.list-group-item-warning:focus {\n    color: #8a6d3b;\n    background-color: #faf2cc;\n}\na.list-group-item-warning.active, a.list-group-item-warning.active:hover, a.list-group-item-warning.active:focus,\n  button.list-group-item-warning.active,\n  button.list-group-item-warning.active:hover,\n  button.list-group-item-warning.active:focus {\n    color: #fff;\n    background-color: #8a6d3b;\n    border-color: #8a6d3b;\n}\n.list-group-item-danger {\n  color: #a94442;\n  background-color: #f2dede;\n}\na.list-group-item-danger,\nbutton.list-group-item-danger {\n  color: #a94442;\n}\na.list-group-item-danger .list-group-item-heading,\n  button.list-group-item-danger .list-group-item-heading {\n    color: inherit;\n}\na.list-group-item-danger:hover, a.list-group-item-danger:focus,\n  button.list-group-item-danger:hover,\n  button.list-group-item-danger:focus {\n    color: #a94442;\n    background-color: #ebcccc;\n}\na.list-group-item-danger.active, a.list-group-item-danger.active:hover, a.list-group-item-danger.active:focus,\n  button.list-group-item-danger.active,\n  button.list-group-item-danger.active:hover,\n  button.list-group-item-danger.active:focus {\n    color: #fff;\n    background-color: #a94442;\n    border-color: #a94442;\n}\n.list-group-item-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.list-group-item-text {\n  margin-bottom: 0;\n  line-height: 1.3;\n}\n.panel {\n  margin-bottom: 20px;\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n.panel-body {\n  padding: 15px;\n}\n.panel-body:before, .panel-body:after {\n    display: table;\n    content: \" \";\n}\n.panel-body:after {\n    clear: both;\n}\n.panel-heading {\n  padding: 10px 15px;\n  border-bottom: 1px solid transparent;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel-heading > .dropdown .dropdown-toggle {\n    color: inherit;\n}\n.panel-title {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 16px;\n  color: inherit;\n}\n.panel-title > a,\n  .panel-title > small,\n  .panel-title > .small,\n  .panel-title > small > a,\n  .panel-title > .small > a {\n    color: inherit;\n}\n.panel-footer {\n  padding: 10px 15px;\n  background-color: #f5f5f5;\n  border-top: 1px solid #ddd;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel > .list-group,\n.panel > .panel-collapse > .list-group {\n  margin-bottom: 0;\n}\n.panel > .list-group .list-group-item,\n  .panel > .panel-collapse > .list-group .list-group-item {\n    border-width: 1px 0;\n    border-radius: 0;\n}\n.panel > .list-group:first-child .list-group-item:first-child,\n  .panel > .panel-collapse > .list-group:first-child .list-group-item:first-child {\n    border-top: 0;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n}\n.panel > .list-group:last-child .list-group-item:last-child,\n  .panel > .panel-collapse > .list-group:last-child .list-group-item:last-child {\n    border-bottom: 0;\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px;\n}\n.panel > .panel-heading + .panel-collapse > .list-group .list-group-item:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.panel-heading + .list-group .list-group-item:first-child {\n  border-top-width: 0;\n}\n.list-group + .panel-footer {\n  border-top-width: 0;\n}\n.panel > .table,\n.panel > .table-responsive > .table,\n.panel > .panel-collapse > .table {\n  margin-bottom: 0;\n}\n.panel > .table caption,\n  .panel > .table-responsive > .table caption,\n  .panel > .panel-collapse > .table caption {\n    padding-right: 15px;\n    padding-left: 15px;\n}\n.panel > .table:first-child,\n.panel > .table-responsive:first-child > .table:first-child {\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel > .table:first-child > thead:first-child > tr:first-child,\n  .panel > .table:first-child > tbody:first-child > tr:first-child,\n  .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child,\n  .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child {\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n}\n.panel > .table:first-child > thead:first-child > tr:first-child td:first-child,\n    .panel > .table:first-child > thead:first-child > tr:first-child th:first-child,\n    .panel > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n    .panel > .table:first-child > tbody:first-child > tr:first-child th:first-child,\n    .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child,\n    .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child,\n    .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n    .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child {\n      border-top-left-radius: 3px;\n}\n.panel > .table:first-child > thead:first-child > tr:first-child td:last-child,\n    .panel > .table:first-child > thead:first-child > tr:first-child th:last-child,\n    .panel > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n    .panel > .table:first-child > tbody:first-child > tr:first-child th:last-child,\n    .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child,\n    .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child,\n    .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n    .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child {\n      border-top-right-radius: 3px;\n}\n.panel > .table:last-child,\n.panel > .table-responsive:last-child > .table:last-child {\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel > .table:last-child > tbody:last-child > tr:last-child,\n  .panel > .table:last-child > tfoot:last-child > tr:last-child,\n  .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child,\n  .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child {\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px;\n}\n.panel > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n    .panel > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n    .panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n    .panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child,\n    .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n    .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n    .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n    .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child {\n      border-bottom-left-radius: 3px;\n}\n.panel > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n    .panel > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n    .panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n    .panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child,\n    .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n    .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n    .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n    .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child {\n      border-bottom-right-radius: 3px;\n}\n.panel > .panel-body + .table,\n.panel > .panel-body + .table-responsive,\n.panel > .table + .panel-body,\n.panel > .table-responsive + .panel-body {\n  border-top: 1px solid #ddd;\n}\n.panel > .table > tbody:first-child > tr:first-child th,\n.panel > .table > tbody:first-child > tr:first-child td {\n  border-top: 0;\n}\n.panel > .table-bordered,\n.panel > .table-responsive > .table-bordered {\n  border: 0;\n}\n.panel > .table-bordered > thead > tr > th:first-child,\n  .panel > .table-bordered > thead > tr > td:first-child,\n  .panel > .table-bordered > tbody > tr > th:first-child,\n  .panel > .table-bordered > tbody > tr > td:first-child,\n  .panel > .table-bordered > tfoot > tr > th:first-child,\n  .panel > .table-bordered > tfoot > tr > td:first-child,\n  .panel > .table-responsive > .table-bordered > thead > tr > th:first-child,\n  .panel > .table-responsive > .table-bordered > thead > tr > td:first-child,\n  .panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,\n  .panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,\n  .panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n  .panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n    border-left: 0;\n}\n.panel > .table-bordered > thead > tr > th:last-child,\n  .panel > .table-bordered > thead > tr > td:last-child,\n  .panel > .table-bordered > tbody > tr > th:last-child,\n  .panel > .table-bordered > tbody > tr > td:last-child,\n  .panel > .table-bordered > tfoot > tr > th:last-child,\n  .panel > .table-bordered > tfoot > tr > td:last-child,\n  .panel > .table-responsive > .table-bordered > thead > tr > th:last-child,\n  .panel > .table-responsive > .table-bordered > thead > tr > td:last-child,\n  .panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,\n  .panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,\n  .panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n  .panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n    border-right: 0;\n}\n.panel > .table-bordered > thead > tr:first-child > td,\n  .panel > .table-bordered > thead > tr:first-child > th,\n  .panel > .table-bordered > tbody > tr:first-child > td,\n  .panel > .table-bordered > tbody > tr:first-child > th,\n  .panel > .table-responsive > .table-bordered > thead > tr:first-child > td,\n  .panel > .table-responsive > .table-bordered > thead > tr:first-child > th,\n  .panel > .table-responsive > .table-bordered > tbody > tr:first-child > td,\n  .panel > .table-responsive > .table-bordered > tbody > tr:first-child > th {\n    border-bottom: 0;\n}\n.panel > .table-bordered > tbody > tr:last-child > td,\n  .panel > .table-bordered > tbody > tr:last-child > th,\n  .panel > .table-bordered > tfoot > tr:last-child > td,\n  .panel > .table-bordered > tfoot > tr:last-child > th,\n  .panel > .table-responsive > .table-bordered > tbody > tr:last-child > td,\n  .panel > .table-responsive > .table-bordered > tbody > tr:last-child > th,\n  .panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td,\n  .panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th {\n    border-bottom: 0;\n}\n.panel > .table-responsive {\n  margin-bottom: 0;\n  border: 0;\n}\n.panel-group {\n  margin-bottom: 20px;\n}\n.panel-group .panel {\n    margin-bottom: 0;\n    border-radius: 4px;\n}\n.panel-group .panel + .panel {\n      margin-top: 5px;\n}\n.panel-group .panel-heading {\n    border-bottom: 0;\n}\n.panel-group .panel-heading + .panel-collapse > .panel-body,\n    .panel-group .panel-heading + .panel-collapse > .list-group {\n      border-top: 1px solid #ddd;\n}\n.panel-group .panel-footer {\n    border-top: 0;\n}\n.panel-group .panel-footer + .panel-collapse .panel-body {\n      border-bottom: 1px solid #ddd;\n}\n.panel-default {\n  border-color: #ddd;\n}\n.panel-default > .panel-heading {\n    color: #333333;\n    background-color: #f5f5f5;\n    border-color: #ddd;\n}\n.panel-default > .panel-heading + .panel-collapse > .panel-body {\n      border-top-color: #ddd;\n}\n.panel-default > .panel-heading .badge {\n      color: #f5f5f5;\n      background-color: #333333;\n}\n.panel-default > .panel-footer + .panel-collapse > .panel-body {\n    border-bottom-color: #ddd;\n}\n.panel-primary {\n  border-color: #f0617d;\n}\n.panel-primary > .panel-heading {\n    color: #fff;\n    background-color: #f0617d;\n    border-color: #f0617d;\n}\n.panel-primary > .panel-heading + .panel-collapse > .panel-body {\n      border-top-color: #f0617d;\n}\n.panel-primary > .panel-heading .badge {\n      color: #f0617d;\n      background-color: #fff;\n}\n.panel-primary > .panel-footer + .panel-collapse > .panel-body {\n    border-bottom-color: #f0617d;\n}\n.panel-success {\n  border-color: #d6e9c6;\n}\n.panel-success > .panel-heading {\n    color: #3c763d;\n    background-color: #dff0d8;\n    border-color: #d6e9c6;\n}\n.panel-success > .panel-heading + .panel-collapse > .panel-body {\n      border-top-color: #d6e9c6;\n}\n.panel-success > .panel-heading .badge {\n      color: #dff0d8;\n      background-color: #3c763d;\n}\n.panel-success > .panel-footer + .panel-collapse > .panel-body {\n    border-bottom-color: #d6e9c6;\n}\n.panel-info {\n  border-color: #bce8f1;\n}\n.panel-info > .panel-heading {\n    color: #31708f;\n    background-color: #d9edf7;\n    border-color: #bce8f1;\n}\n.panel-info > .panel-heading + .panel-collapse > .panel-body {\n      border-top-color: #bce8f1;\n}\n.panel-info > .panel-heading .badge {\n      color: #d9edf7;\n      background-color: #31708f;\n}\n.panel-info > .panel-footer + .panel-collapse > .panel-body {\n    border-bottom-color: #bce8f1;\n}\n.panel-warning {\n  border-color: #faebcc;\n}\n.panel-warning > .panel-heading {\n    color: #8a6d3b;\n    background-color: #fcf8e3;\n    border-color: #faebcc;\n}\n.panel-warning > .panel-heading + .panel-collapse > .panel-body {\n      border-top-color: #faebcc;\n}\n.panel-warning > .panel-heading .badge {\n      color: #fcf8e3;\n      background-color: #8a6d3b;\n}\n.panel-warning > .panel-footer + .panel-collapse > .panel-body {\n    border-bottom-color: #faebcc;\n}\n.panel-danger {\n  border-color: #ebccd1;\n}\n.panel-danger > .panel-heading {\n    color: #a94442;\n    background-color: #f2dede;\n    border-color: #ebccd1;\n}\n.panel-danger > .panel-heading + .panel-collapse > .panel-body {\n      border-top-color: #ebccd1;\n}\n.panel-danger > .panel-heading .badge {\n      color: #f2dede;\n      background-color: #a94442;\n}\n.panel-danger > .panel-footer + .panel-collapse > .panel-body {\n    border-bottom-color: #ebccd1;\n}\n.embed-responsive {\n  position: relative;\n  display: block;\n  height: 0;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive .embed-responsive-item,\n  .embed-responsive iframe,\n  .embed-responsive embed,\n  .embed-responsive object,\n  .embed-responsive video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n}\n.embed-responsive-16by9 {\n  padding-bottom: 56.25%;\n}\n.embed-responsive-4by3 {\n  padding-bottom: 75%;\n}\n.well {\n  min-height: 20px;\n  padding: 19px;\n  margin-bottom: 20px;\n  background-color: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n.well blockquote {\n    border-color: #ddd;\n    border-color: rgba(0, 0, 0, 0.15);\n}\n.well-lg {\n  padding: 24px;\n  border-radius: 6px;\n}\n.well-sm {\n  padding: 9px;\n  border-radius: 3px;\n}\n.close {\n  float: right;\n  font-size: 21px;\n  font-weight: bold;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  filter: alpha(opacity=20);\n  opacity: 0.2;\n}\n.close:hover, .close:focus {\n    color: #000;\n    text-decoration: none;\n    cursor: pointer;\n    filter: alpha(opacity=50);\n    opacity: 0.5;\n}\nbutton.close {\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  -webkit-appearance: none;\n  appearance: none;\n}\n.modal-open {\n  overflow: hidden;\n}\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n}\n.modal.fade .modal-dialog {\n    transform: translate(0, -25%);\n    transition: transform 0.3s ease-out;\n}\n.modal.in .modal-dialog {\n    transform: translate(0, 0);\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n.modal-content {\n  position: relative;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #999;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);\n  outline: 0;\n}\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000;\n}\n.modal-backdrop.fade {\n    filter: alpha(opacity=0);\n    opacity: 0;\n}\n.modal-backdrop.in {\n    filter: alpha(opacity=50);\n    opacity: 0.5;\n}\n.modal-header {\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5;\n}\n.modal-header:before, .modal-header:after {\n    display: table;\n    content: \" \";\n}\n.modal-header:after {\n    clear: both;\n}\n.modal-header .close {\n  margin-top: -2px;\n}\n.modal-title {\n  margin: 0;\n  line-height: 1.42857;\n}\n.modal-body {\n  position: relative;\n  padding: 15px;\n}\n.modal-footer {\n  padding: 15px;\n  text-align: right;\n  border-top: 1px solid #e5e5e5;\n}\n.modal-footer:before, .modal-footer:after {\n    display: table;\n    content: \" \";\n}\n.modal-footer:after {\n    clear: both;\n}\n.modal-footer .btn + .btn {\n    margin-bottom: 0;\n    margin-left: 5px;\n}\n.modal-footer .btn-group .btn + .btn {\n    margin-left: -1px;\n}\n.modal-footer .btn-block + .btn-block {\n    margin-left: 0;\n}\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n@media (min-width: 768px) {\n.modal-dialog {\n    width: 600px;\n    margin: 30px auto;\n}\n.modal-content {\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n}\n.modal-sm {\n    width: 300px;\n}\n}\n@media (min-width: 992px) {\n.modal-lg {\n    width: 900px;\n}\n}\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  font-family: \"Quicksand\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.42857;\n  line-break: auto;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n  font-size: 12px;\n  filter: alpha(opacity=0);\n  opacity: 0;\n}\n.tooltip.in {\n    filter: alpha(opacity=90);\n    opacity: 0.9;\n}\n.tooltip.top {\n    padding: 5px 0;\n    margin-top: -3px;\n}\n.tooltip.right {\n    padding: 0 5px;\n    margin-left: 3px;\n}\n.tooltip.bottom {\n    padding: 5px 0;\n    margin-top: 3px;\n}\n.tooltip.left {\n    padding: 0 5px;\n    margin-left: -3px;\n}\n.tooltip.top .tooltip-arrow {\n    bottom: 0;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px 5px 0;\n    border-top-color: #000;\n}\n.tooltip.top-left .tooltip-arrow {\n    right: 5px;\n    bottom: 0;\n    margin-bottom: -5px;\n    border-width: 5px 5px 0;\n    border-top-color: #000;\n}\n.tooltip.top-right .tooltip-arrow {\n    bottom: 0;\n    left: 5px;\n    margin-bottom: -5px;\n    border-width: 5px 5px 0;\n    border-top-color: #000;\n}\n.tooltip.right .tooltip-arrow {\n    top: 50%;\n    left: 0;\n    margin-top: -5px;\n    border-width: 5px 5px 5px 0;\n    border-right-color: #000;\n}\n.tooltip.left .tooltip-arrow {\n    top: 50%;\n    right: 0;\n    margin-top: -5px;\n    border-width: 5px 0 5px 5px;\n    border-left-color: #000;\n}\n.tooltip.bottom .tooltip-arrow {\n    top: 0;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 0 5px 5px;\n    border-bottom-color: #000;\n}\n.tooltip.bottom-left .tooltip-arrow {\n    top: 0;\n    right: 5px;\n    margin-top: -5px;\n    border-width: 0 5px 5px;\n    border-bottom-color: #000;\n}\n.tooltip.bottom-right .tooltip-arrow {\n    top: 0;\n    left: 5px;\n    margin-top: -5px;\n    border-width: 0 5px 5px;\n    border-bottom-color: #000;\n}\n.tooltip-inner {\n  max-width: 200px;\n  padding: 3px 8px;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 4px;\n}\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: none;\n  max-width: 276px;\n  padding: 1px;\n  font-family: \"Quicksand\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.42857;\n  line-break: auto;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n  font-size: 14px;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n}\n.popover.top {\n    margin-top: -10px;\n}\n.popover.right {\n    margin-left: 10px;\n}\n.popover.bottom {\n    margin-top: 10px;\n}\n.popover.left {\n    margin-left: -10px;\n}\n.popover > .arrow {\n    border-width: 11px;\n}\n.popover > .arrow, .popover > .arrow:after {\n      position: absolute;\n      display: block;\n      width: 0;\n      height: 0;\n      border-color: transparent;\n      border-style: solid;\n}\n.popover > .arrow:after {\n      content: \"\";\n      border-width: 10px;\n}\n.popover.top > .arrow {\n    bottom: -11px;\n    left: 50%;\n    margin-left: -11px;\n    border-top-color: #999999;\n    border-top-color: rgba(0, 0, 0, 0.25);\n    border-bottom-width: 0;\n}\n.popover.top > .arrow:after {\n      bottom: 1px;\n      margin-left: -10px;\n      content: \" \";\n      border-top-color: #fff;\n      border-bottom-width: 0;\n}\n.popover.right > .arrow {\n    top: 50%;\n    left: -11px;\n    margin-top: -11px;\n    border-right-color: #999999;\n    border-right-color: rgba(0, 0, 0, 0.25);\n    border-left-width: 0;\n}\n.popover.right > .arrow:after {\n      bottom: -10px;\n      left: 1px;\n      content: \" \";\n      border-right-color: #fff;\n      border-left-width: 0;\n}\n.popover.bottom > .arrow {\n    top: -11px;\n    left: 50%;\n    margin-left: -11px;\n    border-top-width: 0;\n    border-bottom-color: #999999;\n    border-bottom-color: rgba(0, 0, 0, 0.25);\n}\n.popover.bottom > .arrow:after {\n      top: 1px;\n      margin-left: -10px;\n      content: \" \";\n      border-top-width: 0;\n      border-bottom-color: #fff;\n}\n.popover.left > .arrow {\n    top: 50%;\n    right: -11px;\n    margin-top: -11px;\n    border-right-width: 0;\n    border-left-color: #999999;\n    border-left-color: rgba(0, 0, 0, 0.25);\n}\n.popover.left > .arrow:after {\n      right: 1px;\n      bottom: -10px;\n      content: \" \";\n      border-right-width: 0;\n      border-left-color: #fff;\n}\n.popover-title {\n  padding: 8px 14px;\n  margin: 0;\n  font-size: 14px;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-radius: 5px 5px 0 0;\n}\n.popover-content {\n  padding: 9px 14px;\n}\n.carousel {\n  position: relative;\n}\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner > .item {\n    position: relative;\n    display: none;\n    transition: 0.6s ease-in-out left;\n}\n.carousel-inner > .item > img,\n    .carousel-inner > .item > a > img {\n      display: block;\n      max-width: 100%;\n      height: auto;\n      line-height: 1;\n}\n@media all and (transform-3d), (-webkit-transform-3d) {\n.carousel-inner > .item {\n        transition: transform 0.6s ease-in-out;\n        -webkit-backface-visibility: hidden;\n        backface-visibility: hidden;\n        perspective: 1000px;\n}\n.carousel-inner > .item.next, .carousel-inner > .item.active.right {\n          transform: translate3d(100%, 0, 0);\n          left: 0;\n}\n.carousel-inner > .item.prev, .carousel-inner > .item.active.left {\n          transform: translate3d(-100%, 0, 0);\n          left: 0;\n}\n.carousel-inner > .item.next.left, .carousel-inner > .item.prev.right, .carousel-inner > .item.active {\n          transform: translate3d(0, 0, 0);\n          left: 0;\n}\n}\n.carousel-inner > .active,\n  .carousel-inner > .next,\n  .carousel-inner > .prev {\n    display: block;\n}\n.carousel-inner > .active {\n    left: 0;\n}\n.carousel-inner > .next,\n  .carousel-inner > .prev {\n    position: absolute;\n    top: 0;\n    width: 100%;\n}\n.carousel-inner > .next {\n    left: 100%;\n}\n.carousel-inner > .prev {\n    left: -100%;\n}\n.carousel-inner > .next.left,\n  .carousel-inner > .prev.right {\n    left: 0;\n}\n.carousel-inner > .active.left {\n    left: -100%;\n}\n.carousel-inner > .active.right {\n    left: 100%;\n}\n.carousel-control {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 15%;\n  font-size: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\n  background-color: rgba(0, 0, 0, 0);\n  filter: alpha(opacity=50);\n  opacity: 0.5;\n}\n.carousel-control.left {\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);\n    background-repeat: repeat-x;\n}\n.carousel-control.right {\n    right: 0;\n    left: auto;\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);\n    background-repeat: repeat-x;\n}\n.carousel-control:hover, .carousel-control:focus {\n    color: #fff;\n    text-decoration: none;\n    outline: 0;\n    filter: alpha(opacity=90);\n    opacity: 0.9;\n}\n.carousel-control .icon-prev,\n  .carousel-control .icon-next,\n  .carousel-control .glyphicon-chevron-left,\n  .carousel-control .glyphicon-chevron-right {\n    position: absolute;\n    top: 50%;\n    z-index: 5;\n    display: inline-block;\n    margin-top: -10px;\n}\n.carousel-control .icon-prev,\n  .carousel-control .glyphicon-chevron-left {\n    left: 50%;\n    margin-left: -10px;\n}\n.carousel-control .icon-next,\n  .carousel-control .glyphicon-chevron-right {\n    right: 50%;\n    margin-right: -10px;\n}\n.carousel-control .icon-prev,\n  .carousel-control .icon-next {\n    width: 20px;\n    height: 20px;\n    font-family: serif;\n    line-height: 1;\n}\n.carousel-control .icon-prev:before {\n    content: \"\\2039\";\n}\n.carousel-control .icon-next:before {\n    content: \"\\203A\";\n}\n.carousel-indicators {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  z-index: 15;\n  width: 60%;\n  padding-left: 0;\n  margin-left: -30%;\n  text-align: center;\n  list-style: none;\n}\n.carousel-indicators li {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    margin: 1px;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: #000 \\9;\n    background-color: rgba(0, 0, 0, 0);\n    border: 1px solid #fff;\n    border-radius: 10px;\n}\n.carousel-indicators .active {\n    width: 12px;\n    height: 12px;\n    margin: 0;\n    background-color: #fff;\n}\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\n}\n.carousel-caption .btn {\n    text-shadow: none;\n}\n@media screen and (min-width: 768px) {\n.carousel-control .glyphicon-chevron-left,\n  .carousel-control .glyphicon-chevron-right,\n  .carousel-control .icon-prev,\n  .carousel-control .icon-next {\n    width: 30px;\n    height: 30px;\n    margin-top: -10px;\n    font-size: 30px;\n}\n.carousel-control .glyphicon-chevron-left,\n  .carousel-control .icon-prev {\n    margin-left: -10px;\n}\n.carousel-control .glyphicon-chevron-right,\n  .carousel-control .icon-next {\n    margin-right: -10px;\n}\n.carousel-caption {\n    right: 20%;\n    left: 20%;\n    padding-bottom: 30px;\n}\n.carousel-indicators {\n    bottom: 20px;\n}\n}\n.clearfix:before, .clearfix:after {\n  display: table;\n  content: \" \";\n}\n.clearfix:after {\n  clear: both;\n}\n.center-block {\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n}\n.pull-right {\n  float: right !important;\n}\n.pull-left {\n  float: left !important;\n}\n.hide {\n  display: none !important;\n}\n.show {\n  display: block !important;\n}\n.invisible {\n  visibility: hidden;\n}\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n.hidden {\n  display: none !important;\n}\n.affix {\n  position: fixed;\n}\n@-ms-viewport {\n  width: device-width;\n}\n.visible-xs {\n  display: none !important;\n}\n.visible-sm {\n  display: none !important;\n}\n.visible-md {\n  display: none !important;\n}\n.visible-lg {\n  display: none !important;\n}\n.visible-xs-block,\n.visible-xs-inline,\n.visible-xs-inline-block,\n.visible-sm-block,\n.visible-sm-inline,\n.visible-sm-inline-block,\n.visible-md-block,\n.visible-md-inline,\n.visible-md-inline-block,\n.visible-lg-block,\n.visible-lg-inline,\n.visible-lg-inline-block {\n  display: none !important;\n}\n@media (max-width: 767px) {\n.visible-xs {\n    display: block !important;\n}\ntable.visible-xs {\n    display: table !important;\n}\ntr.visible-xs {\n    display: table-row !important;\n}\nth.visible-xs,\n  td.visible-xs {\n    display: table-cell !important;\n}\n}\n@media (max-width: 767px) {\n.visible-xs-block {\n    display: block !important;\n}\n}\n@media (max-width: 767px) {\n.visible-xs-inline {\n    display: inline !important;\n}\n}\n@media (max-width: 767px) {\n.visible-xs-inline-block {\n    display: inline-block !important;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.visible-sm {\n    display: block !important;\n}\ntable.visible-sm {\n    display: table !important;\n}\ntr.visible-sm {\n    display: table-row !important;\n}\nth.visible-sm,\n  td.visible-sm {\n    display: table-cell !important;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.visible-sm-block {\n    display: block !important;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.visible-sm-inline {\n    display: inline !important;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.visible-sm-inline-block {\n    display: inline-block !important;\n}\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n.visible-md {\n    display: block !important;\n}\ntable.visible-md {\n    display: table !important;\n}\ntr.visible-md {\n    display: table-row !important;\n}\nth.visible-md,\n  td.visible-md {\n    display: table-cell !important;\n}\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n.visible-md-block {\n    display: block !important;\n}\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n.visible-md-inline {\n    display: inline !important;\n}\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n.visible-md-inline-block {\n    display: inline-block !important;\n}\n}\n@media (min-width: 1200px) {\n.visible-lg {\n    display: block !important;\n}\ntable.visible-lg {\n    display: table !important;\n}\ntr.visible-lg {\n    display: table-row !important;\n}\nth.visible-lg,\n  td.visible-lg {\n    display: table-cell !important;\n}\n}\n@media (min-width: 1200px) {\n.visible-lg-block {\n    display: block !important;\n}\n}\n@media (min-width: 1200px) {\n.visible-lg-inline {\n    display: inline !important;\n}\n}\n@media (min-width: 1200px) {\n.visible-lg-inline-block {\n    display: inline-block !important;\n}\n}\n@media (max-width: 767px) {\n.hidden-xs {\n    display: none !important;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.hidden-sm {\n    display: none !important;\n}\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n.hidden-md {\n    display: none !important;\n}\n}\n@media (min-width: 1200px) {\n.hidden-lg {\n    display: none !important;\n}\n}\n.visible-print {\n  display: none !important;\n}\n@media print {\n.visible-print {\n    display: block !important;\n}\ntable.visible-print {\n    display: table !important;\n}\ntr.visible-print {\n    display: table-row !important;\n}\nth.visible-print,\n  td.visible-print {\n    display: table-cell !important;\n}\n}\n.visible-print-block {\n  display: none !important;\n}\n@media print {\n.visible-print-block {\n      display: block !important;\n}\n}\n.visible-print-inline {\n  display: none !important;\n}\n@media print {\n.visible-print-inline {\n      display: inline !important;\n}\n}\n.visible-print-inline-block {\n  display: none !important;\n}\n@media print {\n.visible-print-inline-block {\n      display: inline-block !important;\n}\n}\n@media print {\n.hidden-print {\n    display: none !important;\n}\n}\n.btn-transparent {\n  background-color: transparent;\n  color: inherit;\n  transition: background .2s ease-in-out, border .2s ease-in-out;\n}\n.btn-primary.btn-transparent {\n  color: #428bca;\n}\n.btn-success.btn-transparent {\n  color: #5cb85c;\n}\n.btn-info.btn-transparent {\n  color: #5bc0de;\n}\n.btn-warning.btn-transparent {\n  color: #f0ad4e;\n}\n.btn-danger.btn-transparent {\n  color: #d9534f;\n}\n.btn-primary.btn-transparent:hover,\n.btn-success.btn-transparent:hover,\n.btn-info.btn-transparent:hover,\n.btn-warning.btn-transparent:hover,\n.btn-danger.btn-transparent:hover,\n.btn-primary.btn-transparent:focus,\n.btn-success.btn-transparent:focus,\n.btn-info.btn-transparent:focus,\n.btn-warning.btn-transparent:focus,\n.btn-danger.btn-transparent:focus {\n  color: #fff !important;\n}\n.slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.slick-list {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n.slick-list:focus {\n    outline: none;\n}\n.slick-loading .slick-list {\n    background: white url(" + __webpack_require__(338) + ") center center no-repeat;\n}\n.slick-list.dragging {\n    cursor: pointer;\n    cursor: hand;\n}\n.slick-slider .slick-list,\n.slick-track,\n.slick-slide,\n.slick-slide img {\n  transform: translate3d(0, 0, 0);\n}\n.slick-track {\n  position: relative;\n  left: 0;\n  top: 0;\n  display: block;\n  zoom: 1;\n}\n.slick-track:before, .slick-track:after {\n    content: \"\";\n    display: table;\n}\n.slick-track:after {\n    clear: both;\n}\n.slick-loading .slick-track {\n    visibility: hidden;\n}\n.slick-slide {\n  float: left;\n  height: 100%;\n  min-height: 1px;\n  display: none;\n}\n.slick-slide img {\n    display: block;\n}\n.slick-slide img.slick-loading {\n      background: white url(" + __webpack_require__(338) + ") center center no-repeat;\n      padding-bottom: 100%;\n}\n.slick-slide.dragging img {\n    pointer-events: none;\n}\n.slick-initialized .slick-slide {\n    display: block;\n}\n.slick-loading .slick-slide {\n    visibility: hidden;\n}\n.slick-vertical .slick-slide {\n    display: block;\n    height: auto;\n    border: 1px solid transparent;\n}\n\n/* Icons */\n@font-face {\n  font-family: \"slick\";\n  src: url(" + __webpack_require__(343) + ");\n  src: url(" + __webpack_require__(343) + "?#iefix) format(\"embedded-opentype\"), url(" + __webpack_require__(857) + ") format(\"woff\"), url(" + __webpack_require__(856) + ") format(\"truetype\"), url(" + __webpack_require__(852) + "#slick) format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n/* Arrows */\n.slick-prev,\n.slick-next {\n  position: absolute;\n  display: block;\n  height: 20px;\n  width: 20px;\n  line-height: 0;\n  font-size: 0;\n  cursor: pointer;\n  background: transparent;\n  color: transparent;\n  top: 38%;\n  margin-top: -10px;\n  padding: 0;\n  border: none;\n  outline: none;\n}\n.slick-prev:focus,\n  .slick-next:focus {\n    outline: none;\n}\n.slick-prev.slick-disabled:before,\n  .slick-next.slick-disabled:before {\n    opacity: 0.25;\n}\n.slick-prev:before, .slick-next:before {\n  font-family: \"slick\";\n  font-size: 30px;\n  line-height: 1;\n  color: #dbdbdb;\n  opacity: 0.85;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.slick-prev {\n  left: -35px;\n}\n.slick-prev:before {\n    content: '\\2190';\n}\n.slick-next {\n  right: -25px;\n}\n.slick-next:before {\n    content: '\\2192';\n}\n\n/* Dots */\n.slick-slider {\n  margin-bottom: 30px;\n}\n.slick-dots {\n  position: absolute;\n  bottom: -45px;\n  list-style: none;\n  display: block;\n  text-align: center;\n  padding: 0px;\n  width: 100%;\n}\n.slick-dots li {\n    position: relative;\n    display: inline-block;\n    height: 20px;\n    width: 20px;\n    margin: 0px 5px;\n    padding: 0px;\n    cursor: pointer;\n}\n.slick-dots li button {\n      border: 0;\n      background: transparent;\n      display: block;\n      height: 20px;\n      width: 20px;\n      outline: none;\n      line-height: 0;\n      font-size: 0;\n      color: transparent;\n      padding: 5px;\n      cursor: pointer;\n      outline: none;\n}\n.slick-dots li button:focus {\n        outline: none;\n}\n.slick-dots li button:before {\n        position: absolute;\n        top: 0;\n        left: 0;\n        content: '\\2022';\n        width: 20px;\n        height: 20px;\n        font-family: \"slick\";\n        font-size: 6px;\n        line-height: 20px;\n        text-align: center;\n        color: black;\n        opacity: 0.25;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n}\n.slick-dots li.slick-active button:before {\n      opacity: 0.75;\n}\n.content {\n  width: 100%;\n  margin: auto;\n}\nhtml {\n  background: #f0617d;\n  color: #fff;\n}\nhtml .slide-player {\n    background: #fff;\n    font-size: 16px;\n    margin: 7px;\n    position: relative;\n    text-align: center;\n}\nhtml .slide-player p {\n      color: black;\n      text-align: left;\n      margin: 10px 15px;\n      letter-spacing: 1px;\n      font-size: 20px;\n      padding: 0 10px 0 0;\n}\n\n/* Dots */\n.slick-slider {\n  margin-bottom: 30px;\n}\n.slick-dots {\n  position: absolute;\n  bottom: -45px;\n  list-style: none;\n  display: block;\n  text-align: center;\n  padding: 0px;\n  width: 100%;\n}\n.slick-dots li {\n    position: relative;\n    display: inline-block;\n    height: 20px;\n    width: 20px;\n    margin: 0px 5px;\n    padding: 0px;\n    cursor: pointer;\n}\n.slick-dots li button {\n      border: 0;\n      background: transparent;\n      display: block;\n      height: 20px;\n      width: 20px;\n      outline: none;\n      line-height: 0;\n      font-size: 0;\n      color: transparent;\n      padding: 5px;\n      cursor: pointer;\n      outline: none;\n}\n.slick-dots li button:focus {\n        outline: none;\n}\n.slick-dots li button:before {\n        position: absolute;\n        top: 0;\n        left: 0;\n        content: '\\2022';\n        width: 20px;\n        height: 20px;\n        font-family: \"slick\";\n        font-size: 20px;\n        line-height: 20px;\n        text-align: center;\n        color: #f0617d;\n        opacity: 0.25;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n}\n.slick-dots li.slick-active button:before {\n      opacity: 0.75;\n}\n.margin-top-5 {\n  margin-top: 5px;\n}\n.active-icon {\n  color: #f0617d;\n}\n.active-icon:hover {\n    color: #f0617d !important;\n}\n.slider .slick-slide {\n  outline: none;\n}\n.slider .slick-slide:focus {\n    outline: none;\n}\n.margin-top-10 {\n  margin-top: 10px;\n}\nbody {\n  padding-right: 0 !important;\n}\n.margin-top-20 {\n  margin-top: 20px;\n}\n.margin-top-30 {\n  margin-top: 30px;\n}\n.margin-top-40 {\n  margin-top: 40px;\n}\n.margin-bottom-10 {\n  margin-bottom: 10px !important;\n}\n.margin-bottom-20 {\n  margin-bottom: 20px !important;\n}\n.margin-bottom-30 {\n  margin-bottom: 30px !important;\n}\n.margin-bottom-40 {\n  margin-bottom: 40px !important;\n}\n.margin-right-5 {\n  margin-right: 5px;\n}\n.padding-top-10 {\n  padding-top: 10px;\n}\n.padding-top-20 {\n  padding-top: 20px;\n}\n.padding-top-30 {\n  padding-top: 30px;\n}\n.padding-top-40 {\n  padding-top: 40px;\n}\n.padding-bottom-10 {\n  padding-bottom: 10px !important;\n}\n.padding-bottom-20 {\n  padding-bottom: 20px !important;\n}\n.padding-bottom-30 {\n  padding-bottom: 30px !important;\n}\n.padding-bottom-40 {\n  padding-bottom: 40px !important;\n}\n.padding-right-5 {\n  padding-right: 5px;\n}\n.float-right {\n  float: right;\n}\n.float-left {\n  float: left;\n}\n.cursor {\n  cursor: pointer !important;\n}\n.activeIcons {\n  color: #f0617d;\n}\n.activeIcons:before {\n    content: \"\\F004\";\n}\n@media (max-width: 767px) {\nheader .nav-container #header-navbar .navbar-right li.mid-icons.mobile-responsive-hide {\n    display: none !important;\n}\n}\nbody .slick-next:before,\nbody .slick-prev:before {\n  color: #A9A9A9 !important;\n}\n.btn-pink {\n  color: #f0617d;\n  border: 1px solid #f0617d;\n  background: none;\n  outline: none;\n  font-size: 16px;\n  font-family: sans-serif;\n  letter-spacing: 0.3px;\n  float: left;\n  margin-left: 10px;\n  width: 278px;\n  padding: 18px 15px 14px;\n  border-radius: 3px;\n  margin-top: 10px;\n}\n.addeventatc.pinkoutlinebtn {\n  border: 1px solid #f0617d;\n  color: #f0617d !important;\n  background-image: none !important;\n}\n.addeventatc.pinkoutlinebtn:before {\n  content: \"\\F133\";\n  font-family: fontawesome;\n  font-size: 125%;\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.addeventatc.pinkoutlinebtn span.addeventatc_icon.atc_node {\n  display: none;\n}\n.slick-slide .addeventatc_dropdown[aria-hidden=\"false\"] {\n  top: auto !important;\n  bottom: 100%;\n  left: 0 !important;\n  right: auto;\n}\n.pink-text-headline {\n  color: #f0617d;\n}\n.innerimggray img {\n  /* CSS3 filter, WebKit kernel, Firefox outside the most modern browsers*/\n  -moz-filter: grayscale(100%);\n  /* There is no implementation */\n  -ms-filter: grayscale(100%);\n  -o-filter: grayscale(100%);\n  filter: grayscale(100%);\n  /* CSS3 filter, standard*/\n  filter: gray;\n  /* IE 6-9 */\n  opacity: 0.5;\n}\n.innerimggray > hr {\n  display: none;\n}\n.innerimggray > .plusicon.btn-group {\n  display: none;\n}\n.innerimggray > p.right-heart-icon {\n  display: none;\n}\n.sweetalert-lg-signup {\n  max-width: 800px !important;\n  width: 100% !important;\n}\n.pinkbordercomp > div {\n  border: 1px solid #f0617d;\n  padding: 20px;\n  margin: 20px 0;\n  border-radius: 3px;\n  -webkit-font-smoothing: antialiased !important;\n  /* outline-color: rgba(0,78,255,0.5); */\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);\n  -webkit-user-select: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  box-shadow: 0 3px 4px 0px rgba(0, 0, 0, 0.17);\n}\n.pinkbordercomp > div div {\n  display: block !important;\n  float: none;\n  overflow: hidden;\n  text-align: center;\n}\n.pinkbordercomp > div div span {\n  color: #f0617d;\n}\n.pinkbordercomp button {\n  float: none;\n  margin: 0 10px 20px;\n}\n.pinkbordercomp button {\n  color: #f0617d;\n  border: 1px solid #f0617d;\n  background: none;\n  outline: none;\n  font-size: 16px;\n  font-family: sans-serif;\n  letter-spacing: 0.3px;\n  width: 278px;\n  padding: 18px 15px 14px;\n  border-radius: 3px;\n  float: none !important;\n  margin: 0 10px 20px;\n}\nbody .pinkbordercomp button:hover {\n  background: #f0617d;\n  color: #ffffff;\n}\nbody .pinkbordercomp button[disabled='disabled']:hover, body .pinkbordercomp button[disabled='disabled'] span {\n  color: #999;\n}\n@media (max-width: 768px) {\n.pinkbordercomp button {\n    width: 100%;\n    margin: 0 0 20px;\n}\n}\n.btn-pink.btn-primary:hover {\n  color: #fff;\n  background-color: #f0617d;\n  border-color: #f0617d;\n}\nbody .pinkbordercomp button[disabled=\"disabled\"]:hover,\nbody .pinkbordercomp button[disabled=\"disabled\"] {\n  border-color: #999;\n  color: #999;\n  background: none !important;\n}\n.addeventatc {\n  z-index: 1000 !important;\n}\n.jw-display-icon-container.jw-display-icon-rewind.jw-reset {\n  min-width: 55px;\n}\n.contactformtexttone h3 {\n  color: #f0617d;\n}\n.contactformtexttone p {\n  font-size: 16px;\n}\na.pinklinkcontectext {\n  font-size: 18px;\n}\na.nounderline:hover {\n  text-decoration: none;\n  outline: none !important;\n}\n.private-contents:after {\n  content: \"private\";\n  position: absolute;\n  z-index: 100;\n  font-size: 20px;\n  display: block;\n  top: 0;\n  right: 25px;\n}\n.private-contents:before {\n  content: \"\\F06E\";\n  right: 96px;\n  position: absolute;\n  z-index: 100;\n  font-family: fontawesome;\n  font-size: 22px;\n}\n.control-disabled > * {\n  opacity: 0.3;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.slick-slider {\n  touch-action: auto;\n  -ms-touch-action: auto;\n}\n.this-is-a-test-class {\n  font-family: fontawesome;\n  font-size: 22px;\n}\n.jw-img {\n  cursor: pointer;\n  height: auto !important;\n  width: 100%;\n  position: relative;\n  display: block;\n  min-height: 0;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n.nav-icon {\n  background-size: contain;\n  width: 25px !important;\n  height: 25px;\n}\n.community-icon {\n  display: inline-block;\n  width: 30px !important;\n  background-repeat: no-repeat;\n  background-image: url(" + __webpack_require__(814) + ");\n}\n.mind-body-icon {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-image: url(" + __webpack_require__(818) + ");\n}\n.giving-icon {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-image: url(" + __webpack_require__(815) + ");\n}\n.inspiration-icon {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-image: url(" + __webpack_require__(817) + ");\n}\n.money-icon {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-image: url(" + __webpack_require__(821) + ");\n}\n.money-pink-icon {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-image: url(" + __webpack_require__(819) + ");\n}\n.career-icon {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-image: url(" + __webpack_require__(825) + ");\n}\n.search-icon {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-image: url(" + __webpack_require__(823) + ");\n}\n.fav-icon {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-image: url(" + __webpack_require__(835) + ");\n}\n.career-pink-icon {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-image: url(" + __webpack_require__(850) + ");\n}\n.inspiration-pink-icon {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-image: url(" + __webpack_require__(836) + ");\n}\n.mind-body-pink-icon {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-image: url(" + __webpack_require__(838) + ");\n}\n.tooltip {\n  display: block !important;\n  padding: 4px;\n  z-index: 999;\n}\n.tooltip .tooltip-inner {\n    background: black;\n    color: white;\n    border-radius: 3px;\n    padding: 5px 10px 4px;\n}\n.tooltip .tooltip-arrow {\n    display: none;\n}\n.tooltip[aria-hidden='true'] {\n    visibility: hidden;\n    opacity: 0;\n    transition: opacity .15s, visibility .15s;\n}\n.tooltip[aria-hidden='false'] {\n    visibility: visible;\n    opacity: 1;\n    transition: opacity .15s;\n}\n.fixed-fab-btn {\n  position: absolute;\n  top: 8px;\n  right: 5px;\n  color: #fff;\n  width: 150px;\n  height: 20px;\n  text-align: center;\n  z-index: 999;\n  box-shadow: 0 1px 5px 0 #44bda8;\n  text-decoration: none;\n}\n.fixed-fab-btn:hover {\n    color: #fff;\n}\n.fixed-fab-btn:active {\n    text-decoration: none;\n    box-shadow: 0 0 0 0 #44bda8;\n    transform: translateY(3px);\n}\n.fixed-fab-btn:focus {\n    color: #fff;\n    outline: none;\n    box-shadow: 0 1px 5px 0 #44bda8;\n    text-decoration: none;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.fixed-fab-btn {\n    top: 0;\n    bottom: 0;\n    right: 0;\n    box-shadow: 0 0 0 0;\n}\n}\nheader .logo {\n  width: 171px;\n  height: 136px;\n  margin: 0 auto;\n  padding: 34px 0 0 0;\n}\nheader .nav-container {\n  background: #fff;\n}\nheader .nav-container .navbar {\n    border-radius: 0;\n    margin-bottom: 0;\n    border: none;\n}\nheader .nav-container .navbar .margin-left {\n      margin-left: 9%;\n}\nheader .nav-container .navbar-toggle {\n    z-index: 1;\n}\nheader .nav-container .navbar-alignit .navbar-header {\n    transform-style: preserve-3d;\n    height: 50px;\n}\nheader .nav-container .navbar-alignit .navbar-brand {\n    top: 50%;\n    display: block;\n    position: relative;\n    height: auto;\n    transform: translate(0, -50%);\n    margin-right: 15px;\n    margin-left: 15px;\n}\nheader .nav-container .navbar-nav li {\n    margin: 0 0 0 30px;\n}\nheader .nav-container .navbar-nav li .dropdown-menu {\n      z-index: 9999;\n}\nheader .nav-container a {\n    text-align: center;\n    padding: 23px 4px 12px 4px;\n}\nheader .nav-container a i {\n      width: 37%;\n      margin: 0 auto 0;\n      text-align: center;\n}\nheader .nav-container a p {\n      letter-spacing: 1px;\n      color: #5E5E5E;\n      margin: 2px 0 0 0;\n      font-size: 15px;\n}\nheader .nav-container #header-navbar .navbar-right img {\n    height: 55px !important;\n}\nheader .nav-container #header-navbar .navbar-right li.mid-icons {\n    top: 30px;\n    margin: 0 15px;\n}\nheader .nav-container #header-navbar .navbar-right li.mid-icons a {\n      padding: 0;\n}\nheader .nav-container #header-navbar .navbar-right .userProfile {\n    margin: 0;\n    text-align: center;\n}\nheader .nav-container #header-navbar .navbar-right .userProfile a {\n      padding: 20px 5px 12px 5px;\n      text-decoration: none;\n}\nheader .nav-container #header-navbar .navbar-right .userProfile a span {\n        text-decoration: none;\n        color: #5E5E5E;\n}\nheader .nav-container #header-navbar .navbar-right .badge {\n    position: absolute;\n    padding: 6px 9px 6px 9px;\n    border-radius: 100%;\n    font-size: 12px;\n    background-color: #f0617d;\n    left: 2px;\n}\nheader .nav-container #header-navbar .navbar-right .login-btn a {\n    border: 1px solid #9c9c9c;\n    padding: 8px 16px !important;\n    top: -6px !important;\n}\nheader .nav-container .navbar-header button {\n    background: none !important;\n}\nheader .nav-container .navbar-header button:hover, header .nav-container .navbar-header button:focus {\n      background: none !important;\n}\nheader .nav-container .navbar-header a.navbar-toggle {\n    display: none;\n    border: none;\n    top: 4px;\n}\nheader .navbar-toggle {\n  width: 50px;\n}\nheader .navbar-toggle .icon-bar {\n    position: relative;\n    transition: all 500ms ease-in-out;\n    background: #f3f3f3;\n}\nheader .navbar-toggle .icon-bar:nth-of-type(3) {\n    width: 28px;\n}\nheader .navbar-toggle.active .icon-bar:nth-of-type(2) {\n  top: 6px;\n  transform: rotate(45deg);\n  width: 28px;\n}\nheader .navbar-toggle.active .icon-bar:nth-of-type(3) {\n  background-color: transparent;\n  width: 0;\n}\nheader .navbar-toggle.active .icon-bar:last-child {\n  top: -6px;\n  transform: rotate(-45deg);\n  width: 28px;\n}\nheader .sign-up-button {\n  margin: 0 !important;\n}\nheader .sign-up-button a {\n    border: 1px solid #9c9c9c;\n    padding: 8px 10.3px !important;\n    top: -6px !important;\n}\nheader .sign-up-button a:hover {\n      border: 1px solid #9c9c9c;\n}\n.loginModal .modal-dialog {\n  width: 915px;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.loginModal .modal-dialog .modal-content {\n    border-radius: 3px;\n}\n.loginModal .modal-dialog .modal-body {\n    padding: 15px 15px 100px;\n}\n.loginModal .modal-dialog .modal-body .bodyContent {\n      width: 48%;\n      margin: 0 auto;\n      display: block !important;\n      padding: 55px 0 0 0;\n}\n.loginModal .modal-dialog .modal-body .bodyContent h2 {\n        margin: 0 0 20px 0;\n        font-size: 36px;\n        color: #44bda8;\n        font-family: sans-serif;\n        padding: 0;\n}\n.loginModal .modal-dialog .modal-body .bodyContent p {\n        color: #5E5E5E;\n        line-height: 22px;\n        margin: 0;\n        font-family: sans-serif;\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form {\n        display: inline-block;\n        width: 100%;\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form form div {\n          padding: 0;\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form form div input {\n            height: 46px;\n            border-radius: 0;\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form form div .form-control-feedback {\n            top: 7px;\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form form button {\n          background: #44bda8;\n          color: white;\n          width: 100%;\n          padding: 13px 15px 11px;\n          letter-spacing: 0.3px;\n          font-size: 16px;\n          margin: 25px 0 28px 0;\n          outline: none;\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form form a {\n          float: left;\n          color: #44bda8;\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form form .checkbox {\n          margin: 30px 0 0 0;\n          color: #303030;\n          font-family: sans-serif;\n          text-transform: capitalize;\n          font-size: 14px;\n          padding-left: 30px;\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form form .checkbox span {\n            top: -1px;\n            width: 1.9rem;\n            height: 1.9rem;\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form form .checkbox .btn-primary.dropdown-toggle {\n            background-color: #44bda8;\n            border-color: #44bda8;\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form #forgot_password_form {\n          width: 100%;\n          display: inline-block;\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form #forgot_password_form input {\n            width: 100%;\n            height: 60px;\n            margin-top: 25px;\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form #forgot_password_form button {\n            margin: 16px 0 28px 0;\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form #forgot_password_form .form-control-feedback {\n            top: 13px;\n}\n.loginModal .modal-dialog .loginHeaderModal {\n    background: #44bda8;\n    padding: 17px 0 17px 0;\n    text-align: center;\n    position: relative;\n}\n.loginModal .modal-dialog .loginHeaderModal img {\n      width: 94px;\n      height: 40px;\n}\n.loginModal .modal-dialog .loginHeaderModal .watchVideoArrow {\n      width: 24px;\n      height: 24px;\n      position: absolute;\n      right: 0;\n      margin: 8px 24px 0 0;\n}\n@media (min-width: 290px) and (max-width: 767px) {\n.navbar-collapse {\n    padding: 0 !important;\n}\n.navbar-collapse .navbar-nav {\n      margin: 7.5px 0;\n}\nheader .nav-container .navbar .margin-left {\n    margin-left: 0;\n}\nheader .nav-container #header-navbar .navbar-right {\n    display: inline-block !important;\n    width: 100% !important;\n    margin: 0 auto !important;\n    text-align: center;\n}\nheader .nav-container #header-navbar .navbar-right li {\n      display: inline-block !important;\n}\nheader .nav-container #header-navbar .navbar-right li.mid-icons {\n      top: -20px !important;\n      margin: 0 20px !important;\n}\nheader .nav-container #header-navbar .navbar-right .login-btn a {\n      color: white;\n}\nheader .nav-container #header-navbar .navbar-left li a {\n    text-align: justify !important;\n    width: 170px;\n    margin: 0 auto;\n    line-height: 30px;\n    padding: 15px 0;\n}\nheader .nav-container #header-navbar .navbar-left li a i {\n      float: left;\n}\nheader .nav-container #header-navbar .navbar-left li a:hover {\n      background-color: transparent;\n}\nheader .nav-container #header-navbar .navbar-left li a p {\n      color: white;\n      margin-bottom: 0;\n}\nheader .nav-container #header-navbar .navbar-left li:hover {\n    background-color: transparent;\n}\nheader .nav-container #header-navbar .navbar-left p {\n    display: inline !important;\n    margin: 0 1em !important;\n}\nheader .nav-container #header-navbar .margin-default {\n    margin: 0 !important;\n}\nheader .nav-container #header-navbar .margin-minimum {\n    margin: 30px 0 0 0 !important;\n}\n.default-min-height[data-v-7deab794] {\n    min-height: 50px !important;\n}\n.navbar-header a.navbar-toggle {\n    display: block !important;\n}\n.heart-icon {\n    float: right;\n    margin: 12px 17px 0;\n}\n.showHeaderMobile .logo {\n    display: block;\n}\n}\n@media (min-width: 768px) and (max-width: 1023px) {\n#header-navbar {\n    padding: 0 !important;\n}\n#header-navbar .navbar-right {\n      margin-right: 0;\n}\n#header-navbar .navbar-right li a {\n        margin: 0 5px !important;\n}\n#header-navbar .navbar-left a p {\n      letter-spacing: 2px !important;\n}\nheader .nav-container .navbar .margin-left {\n    margin-left: 0;\n}\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.loginModal .modal-dialog {\n    width: 95%;\n}\n.loginModal .modal-dialog .modal-body .bodyContent {\n    width: 100%;\n    padding: 10px 0 0 0;\n}\n.loginModal .modal-dialog .modal-body {\n    padding: 15px 15px 30px;\n}\n.loginModal .modal-dialog .modal-body .bodyContent h2 {\n    font-size: 26px;\n}\nheader .sign-up-button a {\n    color: white;\n}\nheader .nav-container #header-navbar .navbar-right .userProfile span {\n    color: #fff;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\nheader .nav-container .brand-centered {\n    width: 75%;\n}\nheader .nav-container a {\n    font-size: 13px;\n}\n.loginModal .modal-dialog {\n    width: 95%;\n}\n.loginModal .modal-dialog .modal-body .bodyContent {\n    width: 60%;\n}\nheader .nav-container .navbar-nav li {\n    margin: 0;\n}\nheader .nav-container #header-navbar .navbar-right li.mid-icons {\n    margin: 0 3px;\n}\n}\n@media (max-width: 767px) {\n.nav-container .navbar-header a.navbar-toggle {\n    position: absolute;\n    top: 13px !important;\n    right: 0px;\n}\n.unauth-header header .nav-container .navbar-header a.navbar-toggle {\n    position: relative;\n    top: 7px !important;\n    right: 5px;\n}\n}\nbody {\n  padding-top: 0 !important;\n}\n.scroll-nav-wrapper .animated {\n  animation-duration: 0.5s;\n  animation-fill-mode: both;\n}\n.scroll-nav-wrapper li i {\n  font-size: 1.4em;\n}\n.scroll-nav-wrapper li.nav-route-links a {\n  color: #f3f3f3;\n}\n.scroll-nav-wrapper .navbar-brand {\n  margin-left: 0 !important;\n}\n.scroll-nav-wrapper .nav-home-link a {\n  border: 1px solid #777;\n  height: 35px;\n  width: 70px;\n  margin: 8px auto;\n  display: inline-block;\n  padding: 8px 0 0 9px;\n}\n.scroll-nav-wrapper .nav-top-search {\n  font-weight: lighter !important;\n  font-size: 1em;\n  margin-right: 7em !important;\n}\n.scroll-nav-wrapper .nav-user {\n  margin-right: 2em;\n}\n.scroll-nav-wrapper .nav-user-separator a {\n  padding-right: 0;\n}\n.scroll-nav-wrapper .nav-user-separator a i {\n    border-right: 1px solid #777;\n    padding-right: 20px;\n}\n\n/*media query start here mobile version*/\n@media (min-width: 320px) and (max-width: 767px) {\n.navbar-fixed-top .navbar-collapse,\n  .navbar-fixed-bottom .navbar-collapse {\n    max-height: 100%;\n}\n.scroll-nav-wrapper .nav-user-separator a i {\n    border: none;\n}\n.scroll-nav-wrapper .nav-top-search {\n    margin-right: 0 !important;\n}\n.scroll-nav-wrapper li:nth-child(6) {\n    display: inline-block;\n}\n.scroll-nav-wrapper li:nth-child(7) {\n    display: inline-block;\n}\n.scroll-nav-wrapper li:nth-child(8) {\n    display: inline-block;\n}\n.scroll-nav-wrapper li:nth-child(9) {\n    display: inline-block;\n}\n.scroll-nav-wrapper li:last-child {\n    display: inline-block;\n}\n.navbar-nav {\n    text-align: center;\n}\n.scroll-nav-wrapper .nav-home-link a {\n    padding: 8px 0 0 0;\n}\n}\n\n/*media query end here mobile version*/\n/*media query start here tab version*/\n@media (min-width: 768px) and (max-width: 991px) {\n.nav > li > a {\n    padding: 15px 10px;\n}\n.scroll-nav-wrapper .nav-top-search {\n    margin-right: 0 !important;\n}\n}\n\n/*media query end here tab version*/\nfooter {\n  background: #f0617d;\n}\nfooter .margin-top-bottom {\n    margin: 4em auto;\n}\nfooter .margin-top-bottom input {\n      padding: 0 20px 0 20px;\n      height: 56px;\n}\nfooter .input-md {\n    width: 60%;\n}\nfooter .form-control {\n    border: none;\n    border-radius: 0;\n    padding: 2em 1em;\n}\nfooter .input-group-addon {\n    padding-left: 15px;\n    font-family: sans-serif;\n    width: 25%;\n    border-radius: 0;\n    background-color: #f8e71c;\n    font-size: 14px;\n    border: none;\n    color: #4a4a4a;\n}\nfooter .input-group-addon:hover {\n      outline: 1px solid #b8860b;\n}\nfooter .footer-links {\n    margin-top: 15px;\n    text-align: left;\n}\nfooter .footer-links a {\n      margin: 0 0 0 2.5em;\n      color: #fff;\n      text-decoration: none;\n}\nfooter .footer-links a:hover {\n        color: black;\n}\nfooter .navbar {\n    min-height: 0;\n    border: none;\n    border-radius: 0;\n    background: #f0617d;\n}\nfooter .navbar .container {\n      width: 100% !important;\n}\nfooter .navbar-nav {\n    width: 100%;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    text-align: center;\n}\nfooter .navbar-nav ul {\n      margin: 0;\n      padding: 0;\n}\nfooter .navbar-nav li {\n      width: 12%;\n      float: none;\n      text-align: center;\n      display: inline-block;\n}\nfooter .navbar-nav li a {\n        color: #fff !important;\n        display: inline-block;\n        padding: 0;\n        font-size: 16px;\n}\nfooter .nav-pills {\n    font-size: 12px;\n}\nfooter .nav-pills li {\n      float: none;\n      display: inline-block;\n}\nfooter .nav-pills li a {\n        padding: 10px 10px;\n}\nfooter span.input-group-addon.cursor > button {\n  background: transparent;\n  border: 0 none transparent;\n  color: inherit;\n  outline: 0 none transparent;\n}\n\n/*media query start here mobile version*/\n@media (min-width: 320px) and (max-width: 767px) {\nfooter .margin-top-bottom {\n    margin: 1em auto;\n}\nfooter .input-md {\n    width: 100%;\n}\nfooter .form-control {\n    padding: 2em 1em;\n}\nfooter .footer-links {\n    margin-top: 30px;\n    text-align: center;\n}\nfooter .footer-links a {\n    margin: 0 10px 0 5px;\n}\n.footer-nav .navbar-header {\n    display: none;\n}\n.footer-nav .navbar-collapse {\n    display: block;\n    border: none;\n    box-shadow: 0 0 0 0;\n}\nfooter .navbar-nav li {\n    width: 100%;\n    line-height: 36px;\n    font-weight: 600;\n}\n.nav-pills li {\n    display: block !important;\n    font-weight: 600;\n    font-size: 14px;\n}\n}\n\n/*media query start here tab version*/\n@media (min-width: 768px) and (max-width: 991px) {\n.footer-nav .container {\n    width: 100%;\n}\nfooter .navbar-nav li {\n    width: 22%;\n}\n}\n.signUp {\n  letter-spacing: 3px;\n}\n.signUp .terms-and-condition {\n    letter-spacing: 1.5px;\n}\n.signUp .terms-and-condition span {\n      left: 2px;\n}\n.signUp #signup_password, .signUp #signup_confirmPassword {\n    z-index: 1;\n    height: 59px;\n    padding: 0 12px;\n}\n.signUp #signup_pwderrormsg {\n    margin-bottom: 5px;\n}\n.signUp .VuePassword, .signUp .VuePassword__Input {\n    margin-bottom: 10px;\n}\n.signUp .VuePassword__Message {\n    display: none;\n}\n.signUp .disabled {\n    pointer-events: none !important;\n}\n.signUp .main-content h2 {\n    line-height: 36px;\n    margin: 15px 0 70px 0;\n    letter-spacing: 1px;\n    font-size: 26px;\n}\n.signUp .left-content hr {\n    width: 10%;\n    border-top: 1px solid #0d0d0d;\n    margin: 0;\n}\n.signUp .left-content h2 {\n    font-family: 'Open Sans', sans-serif;\n}\n.signUp .left-content h4 {\n    font-size: 24px;\n    font-family: 'Open Sans', sans-serif;\n    margin: 0;\n}\n.signUp .left-content h4 span.sign-up-info {\n      font-size: 16px;\n}\n.signUp .left-content h4 p.sign-up-info {\n      margin: 0.5em 0 0 1.5em;\n      font-size: 20px;\n}\n.signUp .left-content .panel {\n    border-radius: 0;\n    padding: 2em;\n}\n.signUp .left-content .panel-group .panel + .panel {\n    margin: 0;\n}\n.signUp .left-content .panel-heading {\n    background-color: #fff;\n    padding: 0;\n}\n.signUp .left-content .panel-heading h4 {\n      letter-spacing: 1px;\n}\n.signUp .left-content .panel-body {\n    border-top: 0 !important;\n    padding: 5px 0;\n}\n.signUp .left-content .panel-body .form-group {\n      margin-bottom: 20px;\n}\n.signUp .left-content .panel-body .form-group .form-control-feedback {\n        top: 14px;\n}\n.signUp .left-content .form-control {\n    border-radius: 0;\n    height: 59px;\n}\n.signUp .left-content #singup_plans {\n    height: 60px;\n    padding: 1em 1em;\n    margin-bottom: 2px;\n}\n.signUp .left-content .create-account #signup_button {\n    outline: none;\n    border-radius: 0;\n    font-family: 'Open Sans', sans-serif;\n    font-size: 16px;\n    padding: 1em 1em;\n    background: #f0617d;\n    border: 1px solid #f0617d;\n    color: #fff;\n}\n.signUp .left-content .create-account p {\n    font-size: 14px;\n    color: #979797;\n    margin: 0;\n}\n.signUp .left-content .create-account .padding-minus {\n    padding: 0;\n}\n.signUp .left-content .create-account .padding-minus-right {\n    padding-right: 0;\n}\n.signUp .left-content .create-account .btn-spinner {\n    bottom: -15px;\n}\n.signUp .left-content .create-account .form input.form-control {\n    z-index: 100;\n    position: relative;\n}\n.signUp .left-content .payment-method .heading {\n    font-size: 14px;\n    color: #979797;\n    margin: 0;\n}\n.signUp .left-content .payment-method button {\n    border-radius: 0;\n    font-family: 'Open Sans', sans-serif;\n    font-size: 16px;\n    padding: 1em 1em;\n    background: #f0617d;\n    border: 1px solid #f0617d;\n    color: #fff;\n}\n.signUp .left-content .payment-method .padding-minus {\n    padding: 0;\n}\n.signUp .left-content .payment-method .padding-minus-right {\n    padding-right: 0;\n}\n.signUp .left-content .verified-security-content {\n    margin-top: 2em;\n    margin-bottom: 2em;\n    font-size: 12px;\n    letter-spacing: normal;\n}\n.signUp .right-content .jumbotron {\n    background: #f0617d;\n    color: #fff;\n    font-family: 'Open Sans', sans-serif;\n    border-radius: 0;\n    margin-bottom: 0;\n}\n.signUp .right-content .jumbotron h2 {\n      margin-top: 5px;\n      letter-spacing: 1px;\n      margin-bottom: 20px;\n}\n.signUp .right-content .jumbotron p {\n      font-size: 16px;\n      margin-bottom: 0;\n      letter-spacing: 1px;\n}\n.signUp .right-content .card {\n    font-family: 'Open Sans', sans-serif;\n    color: #000;\n    padding: 40px 20px 50px 50px;\n    border: 1px solid #ccc;\n    border-top: 0;\n    width: 100%;\n}\n.signUp .right-content .card h3 {\n      padding: 10px;\n      font-size: 28px;\n}\n.signUp .right-content .card .card-header {\n      padding: 0;\n      color: #333333;\n      text-align: left;\n}\n.signUp .right-content .card .card-header h3 {\n        margin: 20px 0 70px 0;\n        padding: 0;\n        letter-spacing: 1px;\n}\n.signUp .right-content .card .card-block .list-group {\n      text-align: left;\n      margin-bottom: 100px;\n}\n.signUp .right-content .card .list-group {\n      margin-bottom: 0;\n}\n.signUp .right-content .card .list-group .list-group-item {\n        text-align: left;\n        border: none;\n        border-radius: 0;\n        padding: 0;\n        letter-spacing: 1px;\n}\n.signUp .right-content .card .list-group li {\n        font-size: 18px;\n        padding: 0;\n        letter-spacing: 1px;\n}\n.signUp .right-content .card .card-footer li {\n      padding: 0.2em 1em;\n}\n.signUp .right-content .card .card-footer .list-group {\n      margin-bottom: 20px;\n}\n.margin-top {\n  margin-top: 89px;\n  margin-bottom: 260px;\n}\n.panel-group {\n  margin-bottom: 0;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.margin-top {\n    margin-top: 30px;\n    margin-bottom: 40px;\n}\n.signUp .main-content h2 {\n    margin: 15px 0 40px 0;\n}\n.signUp .left-content .panel {\n    padding: 1em;\n}\n.signUp .left-content .panel-heading h4 {\n    font-size: 20px;\n}\n.signUp .left-content .panel-body .form-group {\n    margin-bottom: 10px;\n}\n.signUp .right-content .jumbotron {\n    margin-top: 15px;\n}\n.signUp .right-content .card {\n    padding: 20px 20px 30px 20px;\n}\n.signUp .right-content .card .card-header h3 {\n    margin: 0 0 20px 0;\n}\n.signUp .right-content .card .card-block .list-group {\n    margin-bottom: 30px;\n}\n.signUp .right-content .card .card-footer .list-group {\n    margin-bottom: 0;\n}\n.signUp .right-content .jumbotron h2 {\n    font-size: 26px;\n}\n}\n.hello-page-wrapper .responsive-slick-charity-slider .slick-prev, .hello-page-wrapper .responsive-slick-charity-slider .slick-next {\n  top: 60% !important;\n}\n.hello-page-wrapper .charity-section-img img {\n  width: 100%;\n}\n.hello-page-wrapper .charity-section-img div {\n  margin-bottom: 15px;\n}\n.hello-page-wrapper .charity-5 {\n  width: 20%;\n  float: left;\n}\n.hello-page-wrapper .theme-bg-img {\n  background-image: url(" + __webpack_require__(847) + ") !important;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.hello-page-wrapper .welcome {\n  padding: 0;\n}\n.hello-page-wrapper .no-padding {\n  padding: 0 !important;\n}\n.hello-page-wrapper .main-content {\n  margin: 5em auto;\n}\n.hello-page-wrapper .main-content hr {\n    width: 5%;\n    margin-left: 0;\n    border-top: 1px solid #fff;\n}\n.hello-page-wrapper .main-content h2 {\n    color: #f3f3f3;\n    font-weight: lighter;\n    letter-spacing: 5px;\n}\n.hello-page-wrapper .left-panel {\n  text-align: left;\n}\n.hello-page-wrapper .left-panel h1 {\n    color: #020202;\n    font-size: 26px;\n    line-height: 45px;\n    letter-spacing: 2.2px;\n}\n.hello-page-wrapper .left-panel .jumbotron {\n    text-align: center;\n    background: #cccccc;\n    height: 420px;\n    padding: 0;\n    margin: 0;\n    border-radius: 0;\n}\n.hello-page-wrapper .left-panel .panel {\n    padding: 2em 2em 2em 4em;\n    border: none;\n    border-radius: 0;\n}\n.hello-page-wrapper .left-panel .panel p {\n      font-size: 16px !important;\n}\n.hello-page-wrapper .left-panel .panel .panel-footer {\n      border: none;\n      background: inherit;\n      padding: 0;\n      margin-top: 3em;\n}\n.hello-page-wrapper .left-panel .panel .panel-footer .text-like {\n        color: #44bda8;\n        font-size: 16px;\n        font-weight: bold;\n}\n.hello-page-wrapper .left-panel .panel .panel-footer .icon-like {\n        float: right;\n        color: #f0617d;\n}\n.hello-page-wrapper .left-panel .high-lighter {\n    background: inherit;\n    color: #f3f3f3;\n    text-align: center;\n    border: none;\n    box-shadow: none;\n    padding: 2em 2em 6em 4em;\n}\n.hello-page-wrapper .left-panel .high-lighter .userName {\n      margin: 10px 0 10px 0;\n      font-size: 36px;\n      font-family: sans-serif;\n      font-weight: 400;\n}\n.hello-page-wrapper .left-panel .high-lighter h2 {\n      line-height: 1.8;\n      letter-spacing: 5px;\n      font-weight: 100;\n}\n.hello-page-wrapper .left-panel .container-icons {\n    margin-top: 20px;\n}\n.hello-page-wrapper .left-panel .container-icons a {\n      color: #f3f3f3;\n      padding: 10px 10px 0;\n}\n.hello-page-wrapper .left-panel .container-icons a:focus, .hello-page-wrapper .left-panel .container-icons a:hover {\n        color: #000;\n}\n.hello-page-wrapper .left-panel .container-icons span {\n      margin: 0 15px 0 15px;\n      color: #fff;\n      text-decoration: none;\n}\n.hello-page-wrapper .left-panel .container-icons span:hover {\n        color: #000000;\n}\n.hello-page-wrapper .right-panel h4 {\n  color: #020202;\n  font-size: 18px;\n  line-height: 30px;\n  letter-spacing: 2.2px;\n}\n.hello-page-wrapper .right-panel .jumbotron {\n  background: #cccccc;\n  height: 200px;\n  margin: 0;\n  border-radius: 0;\n  padding: 0;\n}\n.hello-page-wrapper .right-panel .panel {\n  padding: 2em 2em 2em 2em;\n  box-shadow: none;\n  text-align: left;\n  border: none;\n  border-radius: 0;\n}\n.hello-page-wrapper .right-panel .panel p {\n    font-size: 16px !important;\n}\n.hello-page-wrapper .right-panel .panel .panel-footer {\n    border: none;\n    background: inherit;\n    padding: 0;\n    margin-top: 1em;\n}\n.hello-page-wrapper .right-panel .panel .panel-footer .text-like {\n      color: inherit;\n      font-size: 16px;\n      font-weight: bold;\n}\n.hello-page-wrapper .right-panel .panel .panel-footer .icon-like {\n      float: right;\n      color: #f0617d;\n}\n.hello-page-wrapper .right-panel .interest-mood {\n  border-radius: 1.5px;\n  background: #44bda8;\n  padding: 1em 1em 1em 2em;\n  margin: 0 1em;\n  margin-bottom: 70px;\n}\n.hello-page-wrapper .right-panel .interest-mood h4 {\n    color: #f3f3f3;\n    font-size: 20px;\n    line-height: 30px;\n    letter-spacing: 1.5px;\n}\n.hello-page-wrapper .right-panel .interest-mood button {\n    margin-top: 11px;\n    padding: 18px 40px;\n    font-size: 16px;\n    background: inherit;\n    outline: 1px solid #f3f3f3;\n    color: #f3f3f3;\n}\n.hello-page-wrapper .right-panel .interest-mood button:hover, .hello-page-wrapper .right-panel .interest-mood button:focus {\n      font-weight: bold;\n}\n.hello-page-wrapper .charity-content {\n  margin: -45px auto 0;\n}\n.hello-page-wrapper .charity .charity-header {\n  padding: 2em 0 0 0;\n  width: 65%;\n  margin: 45px auto;\n  background: #fff;\n}\n.hello-page-wrapper .charity .charity-header .title {\n    color: #f0617d;\n    letter-spacing: 0.1em;\n}\n.hello-page-wrapper .charity .charity-header .desc {\n    color: #5E5E5E;\n}\n.hello-page-wrapper .charity .charity-header p {\n    margin-top: 1em;\n    font-size: 22px;\n}\n.hello-page-wrapper .charity .thumbnail {\n  border: none;\n}\n.hello-page-wrapper .charity .charity-btn {\n  font-size: 16px;\n  font-weight: bold;\n  color: #f0617d;\n  border-color: #f0617d;\n  padding: 15px 60px;\n  line-height: 1.33333;\n  border-radius: 2px;\n  outline: none;\n}\n.hello-page-wrapper .recently-watched {\n  margin-bottom: 10em;\n}\n.hello-page-wrapper .recently-watched .slide-player .text-wrap-title {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n.hello-page-wrapper .recently-watched .slide-player hr {\n    margin: 0 1em;\n    border: 0;\n    border-top: 1px solid #eeeeee;\n}\n.hello-page-wrapper .recently-watched .slide-player .right-heart-icon {\n    margin: 0;\n    float: left;\n    width: 100%;\n    padding: 10px 0 0 0;\n}\n.hello-page-wrapper .recently-watched .slide-player .right-heart-icon i {\n      color: #f0617d;\n      float: right;\n      font-size: 28px;\n}\n.hello-page-wrapper .recently-watched .jw-img {\n    height: 206px !important;\n}\n.hello-page-wrapper .recently-watched h2 {\n    margin: 2em auto;\n}\n.hello-page-wrapper .recently-watched .recently-watched-btn {\n    margin-top: 2em;\n    font-size: 16px;\n    font-weight: bold;\n    color: #f0617d;\n    border-color: #f0617d;\n    padding: 15px 60px;\n    line-height: 1.33333;\n    border-radius: 2px;\n    outline: none;\n}\n.hello-page-wrapper .expert-section img {\n  max-width: 100%;\n}\n.hello-page-wrapper .expert-section .experts {\n  line-height: 25px;\n  margin-top: 4em;\n  letter-spacing: 0.2em;\n  text-align: left;\n}\n.hello-page-wrapper .expert-section .experts p {\n    font-size: 16px;\n    color: black;\n    font-weight: 400;\n}\n.hello-page-wrapper .expert-section .expert-section-btn {\n  margin-top: 2em;\n  font-size: 16px;\n  font-weight: bold;\n  color: #f0617d;\n  border-color: #f0617d;\n  padding: 15px 60px;\n  line-height: 1.33333;\n  border-radius: 2px;\n  outline: none;\n}\n.hello-page-wrapper .expert-section .expert-tabs .tab-content {\n  margin: 60px 0;\n}\n.hello-page-wrapper .expert-section .expert-tabs ul.nav-tabs {\n  width: 60%;\n  margin: 0 auto;\n}\n.hello-page-wrapper .expert-section .expert-tabs ul.nav-tabs li {\n    float: left;\n    width: 32%;\n    margin-right: 0;\n}\n.hello-page-wrapper .expert-section .expert-tabs ul.nav-tabs li a {\n      letter-spacing: 0.2em;\n      color: #000;\n      margin-right: 0;\n}\n.hello-page-wrapper .expert-section .expert-tabs ul.nav-tabs li.active a {\n    border-color: #fff;\n    border-bottom-color: #f0617d;\n    border-bottom: 3px solid #f0617d;\n    border-left: 0;\n    border-right: 0;\n    border-radius: 0;\n}\n.hello-page-wrapper .random .jw-img {\n  height: 206px !important;\n}\n.hello-page-wrapper .random .random-section-header-sm {\n  display: none;\n}\n.hello-page-wrapper .random .blog-section i {\n  color: #f0617d;\n  width: 45px !important;\n  height: 45px !important;\n}\n.hello-page-wrapper .random .blog-section hr {\n  margin: 10px;\n}\n.hello-page-wrapper .random .blog-section h4 {\n  letter-spacing: 2.2px;\n  font-size: 20px;\n  color: black;\n  font-weight: lighter;\n  line-height: 1.5;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.hello-page-wrapper .random .blog-section .heading {\n  color: #f0617d;\n  font-weight: lighter;\n  font-size: 28px;\n  letter-spacing: 2px;\n  margin-bottom: 45px;\n}\n.hello-page-wrapper .random .blog-section p {\n  line-height: 1.8;\n}\n.hello-page-wrapper .random .blog-section .jumbotron {\n  background: #9e9e9e;\n  height: 200px;\n  margin: 0;\n  border-radius: 0;\n}\n.hello-page-wrapper .random .blog-section .panel {\n  box-shadow: none;\n  border: none;\n  border-radius: 0;\n}\n.hello-page-wrapper .random .blog-section .panel i {\n    position: absolute;\n    right: 0;\n}\n.hello-page-wrapper .random .blog-section .panel a {\n    font-size: 18px;\n    color: black;\n}\n.hello-page-wrapper .random .blog-section .panel span {\n    font-size: 2em;\n    position: absolute;\n    top: -2px;\n}\n.hello-page-wrapper .random .blog-section .side-border-left {\n  border-left: 1px solid #dbdbdb;\n}\n.hello-page-wrapper .random .blog-section .side-border-left:first-of-type {\n    border-left: 0;\n}\n.charity-slider .slider .slide-player img {\n  height: 206px !important;\n}\n.questions-content {\n  background: rgba(243, 244, 246, 0.9);\n  padding: 35px 41px 25px 40px;\n  margin-bottom: 70px;\n}\n.questions-content button {\n    width: 100%;\n    height: 56px;\n    background: none;\n    border: 1px solid #f0617d;\n    border-radius: 3px;\n    margin-bottom: 10px;\n    color: #f0617d;\n    font-size: 16px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    font-family: inherit;\n    padding: 5px 50px 0 65px;\n    outline: none;\n}\n.questions-content button img {\n      margin-right: 10px;\n      float: left;\n}\n.questions-content button span {\n      float: left;\n      text-align: left;\n}\n.questions-content button:hover {\n      box-shadow: 0 0 4px 0 #f0617d;\n}\n.questions-content button:active {\n      box-shadow: 0 0 0 0 #f0617d;\n      -webkit-transform: translateY(1px);\n}\n.questions-content .no-thanks {\n    font-size: 16px;\n    text-transform: capitalize;\n    font-weight: 400;\n    display: block;\n    margin: 20px 0 0 0;\n}\n.questions-content .no-thanks a {\n      color: #5E5E5E;\n      text-decoration: none;\n}\n.charitiesLogin {\n  width: 20%;\n}\n.charitiesLogin img {\n    width: 100%;\n}\n.mobile-version {\n  display: none;\n}\n\n/*media query start here mobile version*/\n@media (min-width: 320px) and (max-width: 767px) {\n.hello-page-wrapper .expert-section .expert-tabs ul.nav-tabs li a {\n    padding: 10px 0;\n    border-bottom: 1px solid #ddd;\n}\n.hello-page-wrapper .right-panel .interest-mood {\n    margin: 0 0.6px 30px 0;\n}\n.random-section-header {\n    display: none;\n}\n.random-section-header-sm {\n    display: block !important;\n}\n.featured-section .featured-content {\n    text-align: center !important;\n}\n.expert-section .expert-tabs .experts {\n    text-align: center !important;\n}\n.navbar-default .navbar-header button {\n    border: none !important;\n}\n.hello-page-wrapper .expert-section .expert-section-btn {\n    padding: 15px 20px;\n    width: 100%;\n}\n.hello-page-wrapper .left-panel .panel, .hello-page-wrapper .right-panel .panel {\n    padding: 1em;\n}\n.hello-page-wrapper .left-panel h1 {\n    font-size: 18px;\n    line-height: 30px;\n    letter-spacing: 1.2px;\n    margin: 10px 0 20px 0;\n}\n.hello-page-wrapper .left-panel h1 br {\n    display: none;\n}\n.hello-page-wrapper .left-panel .high-lighter {\n    padding: 0 !important;\n}\n.hello-page-wrapper .left-panel .high-lighter h2 {\n    line-height: 50px;\n    letter-spacing: 3px;\n    margin: 0 !important;\n}\n.hello-page-wrapper .main-content hr {\n    width: 28%;\n}\n.hello-page-wrapper .main-content h2 br {\n    display: none;\n}\n.hello-page-wrapper .right-panel h4 {\n    font-size: 18px;\n    line-height: 30px;\n    letter-spacing: 1.2px;\n    margin: 10px 0 10px 0;\n}\n.hello-page-wrapper .right-panel .panel p {\n    line-height: 28px;\n    letter-spacing: 0.6px;\n    font-size: 15px !important;\n}\n.hello-page-wrapper .charity .charity-header {\n    padding: 1em 0 0 0;\n    width: 100%;\n}\n.hello-page-wrapper .right-panel .panel .panel-footer .text-like {\n    padding-bottom: 5px;\n}\n.hello-page-wrapper .recently-watched {\n    margin-bottom: 1em;\n}\n.hello-page-wrapper .expert-section .experts {\n    margin-top: 2em;\n    padding: 0;\n    text-align: left !important;\n}\n.hello-page-wrapper .expert-section .experts h2 {\n      font-size: 21px;\n      letter-spacing: 0.5px;\n      line-height: 32px;\n      margin: 10px 0 0;\n}\n.hello-page-wrapper .expert-section .expert-section-btn {\n    margin-top: 0;\n}\n.hello-page-wrapper .expert-section .experts p {\n    font-size: 16px;\n    letter-spacing: 0.4px;\n    margin: 0;\n    line-height: 28px;\n}\n.hello-page-wrapper .expert-section .experts p br {\n      display: none;\n}\n.hello-page-wrapper .expert-section .experts .date {\n    font-weight: bolder;\n}\n.hello-page-wrapper .random .blog-section {\n    padding: 0;\n}\n.hello-page-wrapper .main-content h2 {\n    font-size: 18px;\n    letter-spacing: 1.5px;\n    line-height: 24px;\n}\n.hello-page-wrapper .main-content {\n    margin: 2.5em auto 3rem;\n}\n.extra-small {\n    padding-right: 0;\n}\n.hello-page-wrapper .right-panel .interest-mood h4 {\n    font-size: 19px;\n}\n.hello-page-wrapper .right-panel .interest-mood button {\n    padding: 18px 0;\n    width: 100%;\n}\n.margin-bottom-40 {\n    margin-bottom: 20px !important;\n    padding: 0;\n}\n.thumbnail {\n    margin-bottom: 10px;\n}\n.hello-page-wrapper .charity .charity-btn {\n    letter-spacing: 0.5px;\n    margin: 10px 0 10px 0;\n}\n.hello-page-wrapper .recently-watched h2 {\n    margin: 2rem auto 3rem;\n    font-size: 26px;\n}\n.margin-top-40 {\n    margin-top: 10px;\n}\n.hello-page-wrapper .expert-section .expert-tabs ul.nav-tabs {\n    width: 100%;\n}\n.hello-page-wrapper .expert-section .expert-tabs .tab-content {\n    margin: 30px 0;\n}\nheader .nav-container .navbar {\n    background: #f0617d;\n    text-align: center;\n    padding-top: 10px;\n}\nheader .nav-container .navbar svg {\n    width: 100px;\n    height: 50px;\n    margin-left: -30px;\n    cursor: pointer;\n}\nheader .logo {\n    display: none;\n}\n.navbar-default .navbar-toggle .icon-bar {\n    background-color: #fff;\n}\n.mobile-version {\n    display: inline-block;\n}\n.hello-page-wrapper .expert-section .expert-tabs ul.nav-tabs li.active a {\n    border-radius: 0;\n}\n.hello-page-wrapper .random .blog-section h4 {\n    font-size: 18px;\n    font-weight: 400;\n    letter-spacing: 1px;\n}\n.hello-page-wrapper .left-panel .panel p {\n    line-height: 28px;\n    letter-spacing: 0.6px;\n    font-size: 15px !important;\n}\n.hello-page-wrapper .left-panel .panel .panel-footer {\n    padding: 5px 0 10px 0;\n    margin-top: 1em;\n}\n.right-panel .panel {\n    margin-bottom: 0;\n}\n.un-auth-wrappers .slick-next {\n    right: -8px !important;\n}\n.un-auth-wrappers .slick-prev {\n    left: -9px !important;\n    z-index: 999;\n}\n.un-auth-wrappers .slick-next:before, .un-auth-wrappers .slick-prev:before {\n    font-size: 20px !important;\n}\n.navbar-default .navbar-nav > li > a {\n    color: white !important;\n}\n.navbar-default .navbar-nav > li > a i {\n    float: left;\n}\nhtml .slide-player p {\n    margin: 10px 0;\n    padding: 0 10px;\n    letter-spacing: 1px;\n    font-size: 18px;\n    line-height: 28px;\n}\n.hello-page-wrapper .charity .charity-header .title h2 {\n    font-size: 26px;\n}\n.hello-page-wrapper .charity .charity-header p {\n    margin-top: 0.8em;\n    font-size: 18px;\n    letter-spacing: 1px;\n}\n.mobile-responsive-tabs {\n    overflow: auto;\n    width: 100%;\n    display: inline-block;\n}\n.hello-page-wrapper .random .blog-section p {\n    line-height: 1.8;\n    font-size: 16px;\n    letter-spacing: 0.3px;\n}\n.hello-page-wrapper .random .blog-section p br {\n    display: none;\n}\n.hello-page-wrapper .random .blog-section .panel .fa-angle-double-right {\n    font-size: 2em !important;\n    position: absolute;\n    top: -2px !important;\n}\n.mobile-responsive-hide {\n    display: none;\n}\n.watch-all {\n    margin-bottom: 40px !important;\n}\n.responsive-social-icons {\n    margin-bottom: 70px;\n}\n}\n\n/*media query end here mobile version*/\n/*media query start here tab version*/\n@media (min-width: 768px) and (max-width: 992px) {\n.featured-section .featured-content {\n    text-align: center !important;\n}\n.hello-page-wrapper .main-content h2 br {\n    display: none;\n}\n.hello-page-wrapper .main-content h2 br {\n    display: none;\n}\n.right-panel .panel {\n    margin-top: 0;\n}\n.hello-page-wrapper .left-panel h1 {\n    font-size: 18px;\n    margin: 0;\n    line-height: 35px;\n}\n.hello-page-wrapper .left-panel h1 br {\n      display: none;\n}\n.hello-page-wrapper .left-panel .panel .panel-footer {\n    border: none;\n    background: inherit;\n    padding: 0;\n    margin-top: 1em;\n}\n.expert-section .expert-tabs .experts {\n    text-align: center !important;\n}\n.hello-page-wrapper .right-panel .interest-mood button {\n    float: right;\n    margin-right: 10px;\n}\n.hello-page-wrapper .left-panel .high-lighter {\n    padding: 2em 2em 0 4em;\n}\n.hello-page-wrapper .right-panel .interest-mood {\n    margin-bottom: 0 !important;\n}\n.hello-page-wrapper .expert-section .expert-tabs ul.nav-tabs {\n    width: 85%;\n}\nfooter .input-md {\n    width: 100%;\n    margin-bottom: 15px;\n}\nfooter .footer-links {\n    text-align: center;\n}\n.responsive-social-icons {\n    margin-bottom: 70px;\n}\n}\n\n/*media query end here tab version*/\n@media (min-width: 992px) and (max-width: 1200px) {\n.hello-page-wrapper .expert-section .expert-tabs ul.nav-tabs {\n    width: 70%;\n    margin: 0 auto;\n}\n.hello-page-wrapper .left-panel .high-lighter {\n    padding: 2em 2em 0 4em;\n    margin: 0;\n}\n.hello-page-wrapper .right-panel .interest-mood {\n    margin-bottom: 70px !important;\n}\n}\n.slick-prev {\n  left: -14px;\n}\n.slick-next {\n  right: -12px;\n}\n.slick-next:before, .slick-prev:before {\n  font-size: 22px;\n}\n.player-content {\n  padding: 0 130px 0 130px;\n  text-align: left;\n}\n.player-content h4 {\n    font-size: 30px;\n    margin: 50px 0 30px 0;\n    color: black;\n}\n.player-content p {\n    color: black;\n    font-size: 16px;\n    line-height: 27px;\n    margin: 0 0 25px 0;\n}\n.player-content .btn-transparent {\n    border-radius: 3px;\n    padding: 16px 28px 15px 28px;\n}\n.profile-content {\n  padding: 10px 0 20px 0;\n  float: left;\n  width: 100%;\n}\n.profile-content img {\n    width: 45px;\n    height: 45px;\n    border-radius: 50%;\n    float: left;\n    margin-right: 14px;\n}\n.profile-content h4 {\n    margin: 1px 0 5px 0;\n    float: left;\n    width: 93%;\n    font-size: 20px;\n    color: black;\n}\n.profile-content span {\n    float: left;\n    width: 93%;\n    font-size: 14px;\n    color: black;\n}\n.side-content {\n  display: inline-block;\n  padding: 20px 0 30px 30px;\n  border-left: 6px solid #f0617d;\n}\n.side-content pre {\n    margin: 10px 0 10px;\n}\n.side-content .boxes {\n    margin-bottom: 30px;\n}\n.side-content .boxes p {\n      margin: 0;\n}\n.side-content .boxes span {\n      color: #f0617d;\n      font-size: 16px;\n      letter-spacing: 1px;\n}\n.side-content .boxes:last-of-type {\n      margin-bottom: 0;\n}\n.video-player {\n  position: relative;\n  height: 38.7vw;\n}\n.video-player .left-video-icons {\n    background: #303030;\n    color: white;\n    width: 15%;\n    float: left;\n    height: 100%;\n}\n.video-player .right-video-icons {\n    background: #303030;\n    width: 15%;\n    float: left;\n    height: 100%;\n}\n.video-player .right-video-icons .icons-hover {\n      color: white;\n      top: 0;\n      right: 0;\n      padding: 155px 0 120px 0;\n}\n.video-player .right-video-icons .icons-hover ul {\n        padding: 0;\n        margin: 0;\n}\n.video-player .right-video-icons .icons-hover ul li {\n          list-style: none;\n          margin-bottom: 50px;\n}\n.video-player .right-video-icons .icons-hover ul li:last-of-type {\n            margin-bottom: 0;\n}\n.video-player .right-video-icons .icons-hover ul li a {\n            color: white;\n            text-decoration: none;\n            letter-spacing: 0.5px;\n}\n.video-player .right-video-icons .icons-hover ul li a i {\n              font-size: 20px;\n}\n.video-player .right-video-icons .icons-hover ul li a:hover {\n              color: #f0617d;\n}\n.video-player .right-video-icons .rate-hover-box {\n      width: 20%;\n      height: 100%;\n      background: #f0617d;\n      position: absolute;\n      top: 0;\n      right: 0;\n      padding: 150px 0 0 0;\n}\n.video-player .right-video-icons .rate-hover-box button {\n        color: white;\n        border-color: white;\n        border-radius: 3px;\n        padding: 12px 0 13px;\n        display: inline-block;\n        width: 80%;\n        margin-bottom: 10px;\n}\n.video-player .right-video-icons .rate-hover-box button i {\n          font-size: 28px;\n          margin: 0 8px 0 0;\n          position: relative;\n          top: 3px;\n}\n.video-player .right-video-icons .rate-hover-box button:hover {\n          background: #f0617d;\n}\n.video-player .right-video-icons .rate-hover-box .active-arrow {\n        position: absolute;\n        color: #f0617d;\n        font-size: 50px;\n        left: -15px;\n        top: 46%;\n}\n.video-player .right-video-icons .rate-hover-box span {\n        color: white;\n        display: block;\n        font-size: 16px;\n        letter-spacing: 0.5px;\n        margin-top: 23px;\n}\n.video-player .right-video-icons .share-hover-box {\n      width: 20%;\n      height: 100%;\n      background: #f0617d;\n      position: absolute;\n      top: 0;\n      right: 0;\n      padding: 295px 0 0 60px;\n      text-align: left;\n}\n.video-player .right-video-icons .share-hover-box .active-arrow {\n        position: absolute;\n        color: #f0617d;\n        font-size: 50px;\n        left: -15px;\n        top: 52.7%;\n}\n.video-player .right-video-icons .share-hover-box i {\n        font-size: 26px;\n        color: white;\n        margin-right: 15px;\n}\n.video-player .right-video-icons .share-hover-box i:hover {\n          color: black;\n}\n.video-player .right-video-icons .enjoy-hover-box {\n      width: 20%;\n      height: 100%;\n      background: #f0617d;\n      position: absolute;\n      top: 0;\n      right: 0;\n      padding: 26% 0 0 0;\n      text-align: left;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating {\n        /* RESET STYLES\n                –––––––––––––––––––––––––––––––––––––––––––––––––– */\n        /* CHART-SKILLS STYLES\n                –––––––––––––––––––––––––––––––––––––––––––––––––– */\n        /* ANIMATIONS\n                –––––––––––––––––––––––––––––––––––––––––––––––––– */\n}\n.video-player .right-video-icons .enjoy-hover-box .rating li {\n          cursor: pointer;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills {\n          background: #43C6AC;\n          /* fallback for old browsers */\n          /* Chrome 10-25, Safari 5.1-6 */\n          background: linear-gradient(to left, #F8FFAE, #43C6AC);\n          /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */\n          margin: 0;\n          padding: 0;\n          border-top-left-radius: 300px;\n          border-top-right-radius: 300px;\n          list-style-type: none;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills *,\n        .video-player .right-video-icons .enjoy-hover-box .rating .chart-skills::before {\n          box-sizing: border-box;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills {\n          position: relative;\n          width: 250px;\n          height: 125px;\n          overflow: hidden;\n          float: left;\n          right: -10px;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills::before,\n        .video-player .right-video-icons .enjoy-hover-box .rating .chart-skills::after {\n          position: absolute;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills::before {\n          content: '';\n          width: inherit;\n          height: inherit;\n          border-bottom: none;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills::after {\n          left: 50%;\n          bottom: 10px;\n          transform: translateX(-50%);\n          font-size: 1.1rem;\n          font-weight: bold;\n          color: cadetblue;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills li {\n          position: absolute;\n          top: 100%;\n          left: 0;\n          width: inherit;\n          height: inherit;\n          border-top: none;\n          border-bottom-left-radius: 300px;\n          border-bottom-right-radius: 300px;\n          transform-origin: 50% 0;\n          transform-style: preserve-3d;\n          -webkit-backface-visibility: hidden;\n                  backface-visibility: hidden;\n          animation-fill-mode: forwards;\n          animation-duration: .4s;\n          animation-timing-function: linear;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills li:nth-child(1) {\n          border-top: 5px solid #ffffff;\n          z-index: 4;\n          animation-name: rotate-one;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills li:nth-child(1):hover {\n            font-size: 15px;\n            color: #000000;\n            font-weight: 600;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills li:nth-child(2) {\n          border-top: 5px solid #ffffff;\n          z-index: 3;\n          animation-name: rotate-two;\n          animation-delay: .4s;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills li:nth-child(2):hover {\n            font-size: 15px;\n            color: #000000;\n            font-weight: 600;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills li:nth-child(3) {\n          border-top: 5px solid #ffffff;\n          z-index: 2;\n          animation-name: rotate-three;\n          animation-delay: .8s;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills li:nth-child(3):hover {\n            font-size: 15px;\n            color: #000000;\n            font-weight: 600;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills li:nth-child(4) {\n          border-top: 5px solid #ffffff;\n          z-index: 1;\n          animation-name: rotate-four;\n          animation-delay: 1.2s;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills li:nth-child(4):hover {\n            font-size: 15px;\n            color: #000000;\n            font-weight: 600;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills span {\n          position: absolute;\n          font-size: .85rem;\n          -webkit-backface-visibility: hidden;\n                  backface-visibility: hidden;\n          animation: fade-in .4s linear forwards;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills li:nth-child(1) span {\n          font-size: 1.5em;\n          top: 10px;\n          left: 22px;\n          transform: rotate(-100deg);\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills li:nth-child(2) span {\n          font-size: 1.5em;\n          top: 10px;\n          left: 22px;\n          transform: rotate(-108deg);\n          animation-delay: .4s;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills li:nth-child(3) span {\n          font-size: 1.5em;\n          top: 10px;\n          left: 22px;\n          transform: rotate(-114deg);\n          animation-delay: .8s;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills li:nth-child(4) span {\n          font-size: 1.5em;\n          top: 10px;\n          left: 22px;\n          transform: rotate(-120deg);\n          animation-delay: 1.2s;\n}\n@keyframes rotate-one {\n100% {\n    transform: rotate(45deg);\n    /**\n                         * 12% => 21.6deg\n                         */\n}\n}\n@keyframes rotate-two {\n0% {\n    transform: rotate(45deg);\n}\n100% {\n    transform: rotate(90deg);\n    /**\n                         * 32% => 57.6deg\n                         * 57.6 + 21.6 => 79.2deg\n                         */\n}\n}\n@keyframes rotate-three {\n0% {\n    transform: rotate(90deg);\n}\n100% {\n    transform: rotate(135deg);\n    /**\n                         * 34% => 61.2deg\n                         * 61.2 + 79.2 => 140.4deg\n                         */\n}\n}\n@keyframes rotate-four {\n0% {\n    transform: rotate(135deg);\n}\n100% {\n    transform: rotate(180deg);\n    /**\n                         * 22% => 39.6deg\n                         * 140.4 + 39.6 => 180deg\n                         */\n}\n}\n@keyframes fade-in {\n0%,\n  90% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}\n.video-player .reset-video-width {\n    width: 70%;\n    float: left;\n}\n.right-hover-width {\n  width: 30% !important;\n}\n.right-hover-width .icon-hover-width {\n    width: 33.3% !important;\n}\n.right-hover-enjoy {\n  width: 30% !important;\n}\n.right-hover-enjoy .icon-hover-width {\n    width: 33.3% !important;\n}\n.enjoy-hover {\n  width: 70% !important;\n}\n.enjoy-hover .jwplayer.jw-flag-aspect-mode {\n    width: 100% !important;\n}\n.left-icons-videos {\n  display: none !important;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.video-player .right-video-icons .icons-hover {\n    width: 100%;\n}\n.player-content {\n    padding: 0;\n}\n.player-content h4 {\n    font-size: 28px;\n    line-height: 36px;\n    margin: 30px 0 20px 0;\n}\n.player-content .btn-transparent {\n    margin-bottom: 20px;\n}\n.profile-content {\n    padding: 50px 0 20px 0;\n    text-align: center;\n}\n.profile-content img {\n    float: none;\n}\n.profile-content h4 {\n    width: 100%;\n    margin: 10px 0;\n}\n.charity-slick-slider img {\n    width: 100%;\n}\n.hello-page-wrapper .random .jw-img {\n    height: auto !important;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.content .slick-slider .slick-next {\n    right: -13px !important;\n}\n.video-player .reset-video-width {\n    width: 100%;\n}\n.video-player {\n    height: auto;\n}\n.content .slick-slider .slick-prev {\n    left: -15px !important;\n}\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n.hello-page-wrapper .right-panel .interest-mood h4 {\n    font-size: 15px;\n}\n.hello-page-wrapper .right-panel .interest-mood h4 br {\n    display: none;\n}\n.hello-page-wrapper .right-panel .interest-mood button {\n    padding: 18px 30px;\n}\nheader .nav-container .navbar-nav li {\n    margin: 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating .chart-skills {\n    width: 100%;\n    height: 105px;\n    right: 0;\n}\n.video-player .right-video-icons .share-hover-box {\n    padding: 295px 0 0 35px;\n}\n.content .slick-slider .slick-next {\n    right: -15px !important;\n}\n.content .slick-slider .slick-prev {\n    left: -17px !important;\n}\n.video-player .right-video-icons .icons-hover {\n    padding-top: 15vh;\n}\n.video-player .right-video-icons .rate-hover-box {\n    padding: 100px 0 0 0;\n}\n.video-player .right-video-icons .share-hover-box {\n    padding: 235px 0 0 30px;\n}\n.video-player-wrapper .tooltipBox {\n    height: 28px;\n}\n}\n.join-page-wrapper .white-bg {\n  background: #ffffff !important;\n}\n.join-page-wrapper .join-section h1 {\n  font-weight: bold;\n  color: #020202;\n}\n.join-page-wrapper .join-section p {\n  font-size: 20px;\n}\n.join-page-wrapper .join-section .chat-button .btn {\n  border-radius: 0;\n  padding: 10px 30px;\n}\n.join-page-wrapper .blog-section {\n  padding: 4em 5em 4em 5em;\n}\n.join-page-wrapper .blog-section i {\n    color: #f0617d;\n    font-size: 32px;\n}\n.join-page-wrapper .blog-section .heading {\n    font-family: 'Roboto', sans-serif;\n    color: #f0617d;\n    font-size: 26px;\n}\n.join-page-wrapper .blog-section h3 {\n    color: #020202;\n    font-weight: bold;\n    font-family: 'Roboto', sans-serif;\n}\n.join-page-wrapper .blog-section p {\n    margin: 1em 0;\n    color: #020202;\n    font-size: 20px;\n}\n.join-page-wrapper .blog-section .jumbotron {\n    background: #cccccc;\n    height: 320px;\n    margin: 0;\n    border-radius: 0;\n}\n.join-page-wrapper .blog-section .panel {\n    box-shadow: none;\n    border: none;\n    border-radius: 0;\n}\n.join-page-wrapper .blog-section .panel-body {\n    padding: 0;\n}\n.join-page-wrapper .blog-section .side-border {\n    border-right: 1px solid #cccccc;\n    border-left: 1px solid #cccccc;\n}\n.join-page-wrapper .blog-section .blog-button .btn {\n    border-radius: 0;\n    padding: 10px 30px;\n}\n.join-page-wrapper .blog-section .full-width {\n    width: 100%;\n}\n.join-page-wrapper .blog-section .alternate-content {\n    float: right;\n}\n.join-page-wrapper .goods-section {\n  margin: 8em 0 2em 0;\n}\n.join-page-wrapper .goods-section h1 {\n    font-weight: bold;\n    font-size: 34px;\n    color: #020202;\n}\n.join-page-wrapper .goods-section p {\n    font-size: 20px;\n}\n.join-page-wrapper .goods-section .btn {\n    border-radius: 0;\n    padding: 10px 30px;\n}\n\n/*media query start here mobile version*/\n@media (min-width: 320px) and (max-width: 767px) {\n.blog-section .alternate-content {\n    width: 100%;\n}\n.alternate-content-text {\n    text-align: right;\n}\n.join-page-wrapper .join-section .chat-button .btn {\n    padding: 10px 10px;\n    font-size: 16px;\n}\n.join-page-wrapper .blog-section {\n    padding: 2em 0 2em 0;\n}\n.join-page-wrapper .blog-section .jumbotron {\n    height: 250px;\n}\n.join-page-wrapper .goods-section {\n    margin: 1em 0 2em 0;\n}\n}\n\n/*media query end here mobile version*/\n/*media query start here tab version*/\n@media (min-width: 768px) and (max-width: 991px) {\n.blog-section .alternate-content {\n    width: 100%;\n}\n.blog-section .alternate-content-text {\n    text-align: right;\n}\n}\n\n/*media query end here tab version*/\n.interestlist .btn-group {\n  width: 100%;\n  float: left;\n  margin-bottom: 70px;\n}\n.interestlist .interest-container {\n  margin: 5em 0 0;\n  display: inline-block;\n}\n.interestlist .btn {\n  float: none;\n  margin: 5px 10px;\n}\n.interestlist .active {\n  background: #f0617d;\n  border: 1px solid #f0617d !important;\n  color: #fff !important;\n  box-shadow: none;\n}\n.interestlist .interestButtonList .checkbox-btn {\n  border-radius: 0;\n  border: 1px solid #f0617d;\n  font-weight: 600;\n  color: #5b5b5b;\n  padding: 0.8em 0;\n  font-size: 15px;\n  width: 24.4% !important;\n  float: left;\n}\n.interestlist .interestButtonList .checkbox-btn:nth-of-type(4n - 0) {\n    margin-right: 0;\n}\n.interestlist .checkbox-btn {\n  border-radius: 0;\n  border: 1px solid #f0617d;\n  font-weight: 600;\n  color: #5b5b5b;\n  padding: 0.8em 0;\n  font-size: 15px;\n  width: 23.2%;\n  float: left;\n}\n.interestlist .checkbox-btn-days {\n  border-radius: 0;\n  border: 1px solid #f0617d;\n  font-weight: 600;\n  color: #5b5b5b;\n  padding: 0.8em 0;\n  font-size: 15px;\n  width: 18.2%;\n  float: left;\n}\n.interestlist hr {\n  width: 10%;\n  margin-left: 0;\n  border-top: 1px solid #0d0d0d;\n}\n.interestlist h2 {\n  letter-spacing: 3px;\n  font-family: 'Open Sans', sans-serif;\n}\n.interestlist .submit-btn .btn {\n  width: 20%;\n  padding: 1em 1em;\n  margin: 0 auto;\n  border-radius: 0;\n  border: 1px solid #f0617d;\n  color: #fff;\n  background: #f0617d;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  margin-bottom: 30px;\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n.interestlist .interestButtonList .checkbox-btn {\n    width: 22.4% !important;\n}\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n.interestlist .interestButtonList .checkbox-btn-days {\n    width: 18.4% !important;\n}\n}\n@media (min-width: 768px) and (max-width: 992px) {\n.interestlist .interestButtonList .checkbox-btn {\n    width: 48% !important;\n}\n}\n@media (min-width: 768px) and (max-width: 992px) {\n.interestlist .interestButtonList .checkbox-btn-days {\n    width: 20% !important;\n}\n}\n@media (min-width: 450px) and (max-width: 768px) {\n.interestlist .interestButtonList .checkbox-btn {\n    width: 43% !important;\n    margin: 5px 14px;\n}\n}\n@media (min-width: 450px) and (max-width: 768px) {\n.interestlist .interestButtonList .checkbox-btn-days {\n    width: 30% !important;\n    margin: 5px 12px;\n}\n}\n@media (min-width: 320px) and (max-width: 450px) {\n.interestlist .interestButtonList .checkbox-btn {\n    width: 100% !important;\n}\n}\n@media (min-width: 320px) and (max-width: 450px) {\n.interestlist .interestButtonList .checkbox-btn-days {\n    width: 100% !important;\n}\n}\n.un-auth-wrappers .medium-height {\n  height: auto;\n  position: relative;\n}\n.un-auth-wrappers .medium-height .jwplayer {\n    position: static;\n    background-color: transparent;\n}\n.un-auth-wrappers .medium-height .watch-video a {\n    color: #fff;\n    font-size: 20px;\n    top: 335px;\n    position: absolute;\n    font-weight: lighter;\n    text-decoration: none;\n    font-family: 'Roboto', sans-serif;\n    right: 0;\n}\n.un-auth-wrappers .over-lay {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%;\n  width: 100%;\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  z-index: 1;\n}\n.un-auth-wrappers .over-lay .main-heading {\n    padding: 0;\n    color: #fff;\n    margin-top: 50px;\n    text-align: left;\n}\n.un-auth-wrappers .over-lay .main-heading h1 {\n      font-size: 32px;\n      line-height: 46px;\n      margin-top: 30px;\n      font-family: \"Quicksand\", sans-serif;\n      padding-right: 370px;\n}\n.un-auth-wrappers .over-lay .main-heading .headLine {\n      padding-right: 20px;\n}\n.un-auth-wrappers .over-lay .main-heading p {\n      margin-top: 15px;\n      font-size: 20px;\n      line-height: 31px;\n      font-family: \"Quicksand\", sans-serif;\n}\n.un-auth-wrappers .over-lay .main-heading .main-heading-btn {\n      font-size: 16px;\n      border-color: #f0617d;\n      padding: 15px 35px;\n      line-height: 1.33333;\n      background: #f0617d;\n      border-radius: 2px;\n      margin-top: 20px;\n      font-family: \"Quicksand\", sans-serif;\n}\n.un-auth-wrappers .over-lay.mobile-overlay {\n    background-image: none;\n    position: static;\n}\n.un-auth-wrappers .over-lay.mobile-overlay .main-heading {\n      margin-top: 50px;\n      color: #020202;\n}\n.un-auth-wrappers .slick-prev {\n  left: -28px;\n}\n.un-auth-wrappers .slick-next {\n  right: -17px;\n}\n.un-auth-wrappers .slick-next:before, .un-auth-wrappers .slick-prev:before {\n  font-size: 30px;\n  color: #9e9e9e;\n}\n.un-auth-wrappers .no-padding {\n  padding: 0 !important;\n}\n.un-auth-wrappers .slick-prev, .un-auth-wrappers .slick-next {\n  top: 48%;\n}\n.un-auth-wrappers .white-bg {\n  background: #ffffff !important;\n}\n.un-auth-wrappers .join-section h1 {\n  font-weight: bold;\n  color: #020202;\n}\n.un-auth-wrappers .join-section p {\n  font-size: 20px;\n}\n.un-auth-wrappers .join-section .chat-button .btn {\n  border-radius: 0;\n  padding: 10px 30px;\n}\n.un-auth-wrappers .blog-section {\n  padding: 0;\n}\n.un-auth-wrappers .blog-section .right-box-content {\n    width: 45%;\n    float: right;\n    padding-top: 30px;\n}\n.un-auth-wrappers .blog-section .right-box-content p {\n      padding: 0 180px 0 0;\n}\n.un-auth-wrappers .blog-section .left-box-content {\n    width: 52%;\n    float: left;\n}\n.un-auth-wrappers .blog-section .box-left-content {\n    width: 45%;\n    float: left;\n    padding-left: 40px;\n    padding-top: 30px;\n}\n.un-auth-wrappers .blog-section .box-left-content p {\n      padding-right: 140px;\n}\n.un-auth-wrappers .blog-section .box-right-content {\n    width: 52%;\n    float: right;\n}\n.un-auth-wrappers .blog-section .heading {\n    font-size: 30px;\n    color: #f0617d;\n    font-family: sans-serif;\n    margin: 0;\n}\n.un-auth-wrappers .blog-section .heading i {\n      width: 48px !important;\n      height: 48px !important;\n      margin-bottom: 5px;\n}\n.un-auth-wrappers .blog-section .heading .lastOne {\n      margin: 10px 0 7px 0;\n      display: inline-block;\n}\n.un-auth-wrappers .blog-section p {\n    margin: 10px 0 0 0;\n    line-height: 31px;\n    font-size: 20px;\n    font-family: sans-serif;\n}\n.un-auth-wrappers .blog-section .jumbotron {\n    background: #cccccc;\n    height: 320px;\n    margin: 0;\n    border-radius: 0;\n}\n.un-auth-wrappers .blog-section .panel {\n    box-shadow: none;\n    border: none;\n    border-radius: 0;\n}\n.un-auth-wrappers .blog-section .panel .expert {\n      height: 340px;\n      overflow: hidden;\n}\n.un-auth-wrappers .blog-section .panel-body {\n    padding: 0;\n}\n.un-auth-wrappers .blog-section .panel-body .content {\n      font-size: 22px;\n      margin-top: 10px;\n}\n.un-auth-wrappers .blog-section .side-border {\n    border-right: 1px solid #cccccc;\n    border-left: 1px solid #cccccc;\n}\n.un-auth-wrappers .blog-section .full-width {\n    width: 100%;\n}\n.un-auth-wrappers .blog-section .alternate-content {\n    float: right;\n}\n.un-auth-wrappers .blog-section .padding-min {\n    padding: 4em 2em 4em 2em;\n}\n.un-auth-wrappers .live-chat-text {\n  padding: 0 240px 0 0;\n}\n.un-auth-wrappers .goods-section {\n  margin: 0 0 5em 0;\n}\n.un-auth-wrappers .goods-section h1 {\n    font-family: sans-serif;\n    font-size: 34px;\n    color: #020202;\n}\n.un-auth-wrappers .goods-section .goods-section-header {\n    font-size: 22px;\n    color: black;\n    font-family: sans-serif;\n}\n.un-auth-wrappers .goods-section .charity .thumbnail {\n    border: none !important;\n}\n.un-auth-wrappers .goods-section .charity .text-center img {\n    width: 100%;\n}\n.un-auth-wrappers .goods-section .trail-btn {\n    font-size: 16px;\n    font-weight: bold;\n    color: #f0617d;\n    border-color: #f0617d;\n    padding: 15px 60px;\n    line-height: 1.33333;\n    border-radius: 2px;\n}\n.un-auth-wrappers .goods-section .random h4 {\n    font-size: 20px;\n    text-transform: capitalize;\n    font-weight: bolder;\n    line-height: 1.5;\n    color: black;\n}\n.un-auth-wrappers .goods-section .random .heading {\n    color: #f0617d;\n    font-weight: lighter;\n    font-size: 28px;\n    letter-spacing: 2px;\n    margin-bottom: 45px;\n}\n.un-auth-wrappers .goods-section .random .jumbotron {\n    background: #dbdbdb;\n    height: 200px;\n    margin: 0;\n    border-radius: 0;\n}\n.un-auth-wrappers .goods-section .random .panel {\n    box-shadow: none;\n    border: none;\n    border-radius: 0;\n}\n.un-auth-wrappers .goods-section .random .panel span {\n      font-size: 2em;\n      position: absolute;\n      top: -2px;\n}\n.un-auth-wrappers .goods-section .random .panel p {\n      line-height: 1.6em;\n      margin-top: 1em;\n      font-weight: bold;\n      text-align: left;\n}\n.un-auth-wrappers .goods-section .random .side-border {\n    border-right: 1px solid #dbdbdb;\n    border-left: 1px solid #dbdbdb;\n}\n.content .slick-slider .slick-prev {\n  left: -20px;\n}\n.content .slick-slider .slick-next {\n  right: -20px;\n}\n.watchVideoModal .modal-dialog {\n  width: 915px;\n}\n.watchVideoModal .modal-dialog .modal-body {\n    padding: 18px 90px;\n}\n.watchVideoModal .modal-dialog .modal-body .jwplayer.jw-flag-aspect-mode {\n      height: auto !important;\n}\n.watchVideoModal .modal-dialog .modal-body p {\n      margin: 0;\n      font-family: sans-serif;\n      font-size: 18px;\n      color: #303030;\n      padding: 25px 60px 20px 60px;\n}\n.watchVideoModal .modal-dialog .modal-body button {\n      background: #44bda8;\n      color: white;\n      font-size: 16px;\n      border: none;\n      width: 253px;\n      padding: 14px 15px 12px;\n      letter-spacing: 0.3px;\n      text-transform: capitalize;\n      border-radius: 3px;\n      margin-bottom: 7px;\n}\n.watchVideoModal .modal-dialog .watchVideoModalHeader {\n    background: #44bda8;\n    padding: 17px 0 17px 0;\n    position: relative;\n}\n.watchVideoModal .modal-dialog .watchVideoModalHeader img {\n      width: 94px;\n      height: 40px;\n}\n.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow {\n      width: 24px;\n      height: 24px;\n      position: absolute;\n      right: 0;\n      margin: 8px 24px 0 0;\n}\n.logo-icons {\n  width: 20%;\n  margin: 30px 0 100px 0;\n}\n.logo-icons a img {\n    width: 80%;\n}\n\n/*media query start here mobile version*/\n@media (min-width: 320px) and (max-width: 767px) {\n.alternate-content-text {\n    text-align: left;\n}\n.un-auth-wrappers .medium-height {\n    height: auto;\n}\n.un-auth-wrappers .medium-height .watch-video a {\n      top: 150px;\n      right: 50px;\n}\n.un-auth-wrappers .over-lay.mobile-overlay .main-heading {\n    padding: 0 0.6em;\n    margin-top: 0;\n}\n.un-auth-wrappers .over-lay .main-heading h1 {\n    font-size: 20px;\n    font-weight: bold;\n    margin-top: 15px;\n    margin-bottom: 5px;\n}\n.un-auth-wrappers .over-lay .main-heading p {\n    font-size: 14px;\n    line-height: 26px;\n    margin: 0;\n}\n.un-auth-wrappers .over-lay .main-heading p br {\n      display: none;\n}\n.un-auth-wrappers .over-lay .main-heading .main-heading-btn {\n    padding: 20px 25px;\n    border-radius: 4px;\n}\n.un-auth-wrappers .blog-section {\n    padding: 2em 0.6em;\n}\n.un-auth-wrappers .blog-section .heading {\n      font-size: 24px;\n}\n.un-auth-wrappers .blog-section .heading br {\n        display: none;\n}\n.un-auth-wrappers .blog-section .heading span {\n        padding: 8px 0 0 12px;\n        display: inline-block;\n}\n.un-auth-wrappers .blog-section p {\n      font-size: 14px;\n      color: #000;\n      margin: 15px 0 30px;\n}\n.un-auth-wrappers .blog-section p br {\n        display: none;\n}\n.un-auth-wrappers .blog-section .heading i {\n    width: 35px !important;\n    height: 35px !important;\n    float: left;\n}\n.un-auth-wrappers .blog-section .panel-body .content {\n    font-family: sans-serif;\n    color: #000;\n    text-transform: capitalize;\n    font-size: 19px;\n}\n.un-auth-wrappers .blog-section .panel-body img {\n    width: 100%;\n    height: 190px;\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.un-auth-wrappers .blog-section .panel .expert {\n    height: auto;\n}\n.un-auth-wrappers .goods-section h1 {\n    font-size: 28px;\n    margin: 40px 40px 20px;\n}\n.un-auth-wrappers .goods-section .goods-section-header {\n    margin: 0 40px 50px;\n    font-size: 20px;\n}\n.un-auth-wrappers .goods-section .goods-section-header br {\n      display: none;\n}\n.un-auth-wrappers .goods-section .trail-btn {\n    padding: 18px 20px;\n    font-weight: 500;\n    margin-top: 20px;\n}\n.un-auth-wrappers .goods-section .random .panel p {\n    margin: 1em 3em 1em;\n}\n.un-auth-wrappers .goods-section .random .panel p br {\n      display: none;\n}\n.slick a:focus, .slide-player a:focus, .slick-slide a:focus {\n    outline: none;\n}\n.slick:focus, .slide-player:focus, .slick-slide:focus {\n    outline: none;\n}\n#giving_scroll {\n    margin: 0;\n}\n.logo-icons {\n    width: 50%;\n    margin: 0;\n}\n.logo-icons a img {\n    width: 100%;\n}\n.watchVideoModal .modal-dialog {\n    width: 95%;\n    margin: 30px auto 0;\n}\n.watchVideoModal .modal-dialog .modal-body {\n    padding: 15px 15px;\n}\n.watchVideoModal .modal-dialog .modal-body .jwplayer.jw-flag-aspect-mode {\n    height: auto !important;\n}\n.watchVideoModal .modal-dialog .modal-body p {\n    padding: 25px 0 20px 0;\n}\n.un-auth-wrappers .blog-section .left-box-content {\n    width: 100%;\n    float: left;\n}\n.un-auth-wrappers .blog-section .right-box-content {\n    width: 100%;\n    float: left;\n    padding-top: 0;\n}\n.un-auth-wrappers .blog-section .box-left-content {\n    width: 100%;\n    padding-left: 0;\n    padding-top: 0;\n}\n.un-auth-wrappers .blog-section .box-right-content {\n    width: 100%;\n}\n.un-auth-wrappers .blog-section .box-left-content p {\n    padding-right: 0;\n}\n.un-auth-wrappers .blog-section .right-box-content p {\n    padding: 0;\n}\n.live-chat-text {\n    padding: 0 !important;\n}\n.headLine {\n    padding-right: 0;\n}\n.un-auth-wrappers .over-lay .main-heading h1 {\n    padding: 0;\n    line-height: 36px;\n}\n.content .slick-slider .slick-next {\n    right: -13px !important;\n}\n.content .slick-slider .slick-prev {\n    left: -15px;\n}\n.un-auth-wrappers .goods-section .charity {\n    padding: 0 15px;\n}\n.profile .tabContent .yourFaves img {\n    height: auto !important;\n}\n}\n\n/*media query end here mobile version*/\n@media (min-width: 768px) and (max-width: 991px) {\n.logo-icons {\n    width: 33.3%;\n    margin: 0 0 0 0;\n}\n.un-auth-wrappers .slick-prev {\n    left: -8px;\n    z-index: 999;\n}\n.un-auth-wrappers .slick-next {\n    right: 0;\n}\n#giving_scroll {\n    margin: 0;\n}\n.watchVideoModal .modal-dialog {\n    width: 95%;\n    margin: 20px auto 20px;\n}\n.watchVideoModal .modal-dialog .modal-body {\n    padding: 15px 15px;\n}\n.watchVideoModal .modal-dialog .modal-body .jwplayer.jw-flag-aspect-mode {\n    height: auto !important;\n}\n.watchVideoModal .modal-dialog .modal-body p {\n    padding: 25px 0 20px 0;\n}\n.un-auth-wrappers .blog-section .right-box-content p {\n    padding: 0;\n}\n.un-auth-wrappers .blog-section .box-left-content p {\n    padding-right: 0;\n}\n.un-auth-wrappers .blog-section .right-box-content {\n    padding-top: 0;\n}\n.un-auth-wrappers .blog-section .box-left-content {\n    padding: 0;\n}\n.un-auth-wrappers .blog-section .right-box-content br {\n    display: none;\n}\n.un-auth-wrappers .blog-section .right-box-content span {\n    display: block;\n}\n.un-auth-wrappers .blog-section .box-left-content br {\n    display: none;\n}\n.un-auth-wrappers .blog-section .box-left-content span {\n    display: block;\n}\n#community_scroll .panel-body img {\n    width: 100%;\n}\n.live-chat-text {\n    padding: 0 40px 0 0 !important;\n}\n.headLine {\n    padding-right: 200px !important;\n}\n.un-auth-wrappers .over-lay .main-heading {\n    margin: 0;\n}\n.un-auth-wrappers .medium-height .watch-video a {\n    top: -20px;\n}\n.un-auth-wrappers .over-lay .main-heading h1 {\n    padding-right: 200px;\n}\n.un-auth-wrappers .goods-section .trail-btn {\n    margin-top: 20px;\n}\n}\n\n/*media query end here tab version*/\n.career-page-wrapper .theme-bg-img {\n  padding: 5em 0 3em 0;\n}\n.career-page-wrapper .career-header {\n  background-image: url(" + __webpack_require__(829) + ");\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 100%;\n  height: 677px;\n}\n.career-page-wrapper .career-header .panel {\n    background: #f8f6f5;\n    border-radius: 0;\n    text-align: left;\n    margin: 22em 3em 0 -3em;\n    padding: 1em 3em 5em;\n}\n.career-page-wrapper .career-header .panel h2 {\n      font-weight: bold;\n      color: #3e3c3c;\n      text-transform: capitalize;\n      line-height: 50px;\n}\n.career-page-wrapper .career-header .panel p {\n      font-size: 21px;\n      font-weight: bolder;\n      line-height: 35px;\n}\n.career-page-wrapper .career-header .panel i {\n      cursor: pointer;\n}\n.career-page-wrapper .expert-section h2 {\n  color: #000;\n  font-weight: bold;\n  font-size: 32px;\n}\n.career-page-wrapper .expert-section .expert-tabs ul li.active a {\n  border-bottom: 4px solid #44bda8 !important;\n}\n.career-page-wrapper .expert-section .expert-tabs ul li a {\n  font-weight: bold;\n  font-size: 18px;\n  letter-spacing: 0 !important;\n}\n.career-page-wrapper .expert-section .expert-tabs .experts h2 {\n  color: #5E5E5E;\n}\n.career-page-wrapper .expert-section .expert-tabs .experts p {\n  margin: 3em 0;\n  color: #504848;\n  font-size: 16px;\n  letter-spacing: 0;\n  font-weight: bolder;\n}\n.career-page-wrapper .expert-section .expert-tabs .experts .date {\n  color: #777;\n}\n.career-page-wrapper .expert-section .expert-tabs button {\n  padding: 20px 50px;\n}\n.career-page-wrapper .expert-section .expert-section-btn {\n  color: #44bda8;\n  border: 1.5px solid #44bda8 !important;\n  outline: #44bda8 !important;\n}\n.career-page-wrapper .expert-section .expert-section-btn:hover, .career-page-wrapper .expert-section .expert-section-btn:focus {\n    color: #fff;\n    background-color: #44bda8 !important;\n    border-color: #761c19;\n}\n.career-page-wrapper .featured {\n  margin: 3em 0 6em;\n}\n.career-page-wrapper .featured h2 {\n    font-size: 32px;\n    font-weight: bold;\n    text-transform: uppercase;\n    font-family: \"Quicksand\", sans-serif;\n}\n.career-page-wrapper .featured .experts {\n    text-align: left;\n    padding: 1em;\n}\n.career-page-wrapper .featured .experts h4 {\n      margin: 1em 0;\n      text-transform: capitalize;\n      font-size: 22px;\n      font-weight: bold;\n      line-height: 1.6em;\n}\n.career-page-wrapper .featured .experts p {\n      line-height: 22px;\n      letter-spacing: 1px;\n      font-weight: bolder;\n      color: #5E5E5E;\n}\n.career-page-wrapper .random h2 {\n  font-size: 32px;\n  font-weight: bold;\n  color: #000;\n  text-transform: uppercase;\n}\n.career-page-wrapper .random .panel {\n  text-align: left;\n}\n.career-page-wrapper .random .blog-section h4 {\n  text-transform: capitalize;\n  letter-spacing: 1px;\n  font-family: sans-serif;\n  color: #5E5E5E;\n}\n.career-page-wrapper .random button.btn-load-more {\n  border-radius: 3px;\n  padding: 1em 6em;\n  margin: 2em 0;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.career-page-wrapper .career-header {\n    height: 200px;\n}\n.career-page-wrapper .career-header-sm {\n    margin: 1em;\n}\n.career-page-wrapper .career-header-sm .panel {\n    margin-bottom: 20px;\n    background-color: #fff;\n    border: none;\n    border-radius: 4px;\n    box-shadow: none;\n}\n.career-page-wrapper .career-header-sm .panel h2 {\n      font-size: 22px;\n      line-height: 30px;\n      font-weight: bold;\n      margin: 1em 0;\n}\n.career-page-wrapper .career-header-sm .panel p {\n      font-weight: bold;\n}\n.career-page-wrapper .expert-section .experts {\n    margin: 2em 1em;\n}\n.career-page-wrapper .expert-section .expert-tabs .experts p {\n    margin: 1em 0;\n}\n.career-page-wrapper .featured h2 {\n    font-size: 26px;\n    margin: 1em 0;\n}\n.career-page-wrapper .featured .experts h4 {\n    margin: 0;\n}\n.career-page-wrapper .featured .experts p {\n    margin-top: 3em;\n}\n.career-page-wrapper .random h2 {\n    font-size: 26px;\n    margin: 0 1em 1em 1em;\n}\n.no-xs-padding {\n    padding: 0 !important;\n}\n.career-page-wrapper .random .blog-section h4 {\n    padding: 0.5em;\n    margin: 0;\n    font-size: 20px;\n}\n}\n.expert-page-wrapper .main h2 {\n  text-transform: none;\n  margin-top: 5em;\n  color: #5E5E5E !important;\n}\n.expert-page-wrapper .main p {\n  font-size: 22px;\n  margin: 20px 0;\n  text-transform: capitalize;\n}\n.expert-page-wrapper .main .desc {\n  text-transform: none !important;\n  line-height: 35px !important;\n}\n.expert-page-wrapper .featured h2 {\n  color: #000;\n  font-weight: bold;\n  font-size: 32px;\n}\n.expert-page-wrapper .featured .expert-tabs ul li.active a {\n  border-bottom: 4px solid #44bda8 !important;\n}\n.expert-page-wrapper .featured .expert-tabs ul li a {\n  font-weight: bold;\n  font-size: 18px;\n  letter-spacing: 0 !important;\n}\n.expert-page-wrapper .featured .expert-tabs .experts h2 {\n  color: #5E5E5E;\n}\n.expert-page-wrapper .featured .expert-tabs .experts p {\n  margin: 3em 0;\n  color: #504848;\n  font-size: 16px;\n  letter-spacing: 0;\n  font-weight: bolder;\n}\n.expert-page-wrapper .featured .expert-tabs .experts .date {\n  color: #777;\n}\n.expert-page-wrapper .featured .expert-tabs .experts button {\n  padding: 20px 50px;\n}\n.expert-page-wrapper .featured .expert-section-btn {\n  color: #44bda8;\n  border: 2px solid #44bda8 !important;\n  outline: #44bda8 !important;\n}\n.expert-page-wrapper .featured .expert-section-btn:hover, .expert-page-wrapper .featured .expert-section-btn:focus {\n    color: #fff;\n    background-color: #44bda8 !important;\n    border-color: #761c19;\n}\n.expert-page-wrapper .live-chat {\n  margin-bottom: 5em;\n}\n.expert-page-wrapper .live-chat img {\n    width: 85%;\n    height: auto;\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.expert-page-wrapper .live-chat .live-chat-heading {\n    color: #313131;\n    line-height: 40px;\n    margin-top: 2em;\n    font-weight: bold;\n    font-size: 32px;\n    text-transform: uppercase;\n}\n.expert-page-wrapper .live-chat h2 {\n    color: #000;\n    line-height: 40px;\n    margin-top: 2em;\n    font-weight: bold;\n    font-size: 32px;\n}\n.expert-page-wrapper .live-chat .experts {\n    text-align: left;\n}\n.expert-page-wrapper .live-chat .experts h2 {\n      color: #5E5E5E;\n}\n.expert-page-wrapper .live-chat .experts p {\n      margin: 1em 0;\n      color: #504848;\n      font-size: 16px;\n      letter-spacing: 0;\n      font-weight: bolder;\n}\n.expert-page-wrapper .live-chat .experts .date {\n      color: #777;\n}\n.expert-page-wrapper .live-chat .experts button {\n      padding: 20px 50px;\n}\n.expert-page-wrapper .live-chat .expert-section-btn {\n    color: #44bda8;\n    border-radius: 4px;\n    border: 0.5px solid #44bda8 !important;\n    outline: #44bda8 !important;\n}\n.expert-page-wrapper .live-chat .expert-section-btn:hover, .expert-page-wrapper .live-chat .expert-section-btn:focus {\n      color: #fff;\n      background-color: #44bda8 !important;\n      border-color: #761c19;\n}\n.expert-page-wrapper .random .blog-section h2 {\n  color: #313131;\n}\n.expert-page-wrapper .random .blog-section h4 {\n  letter-spacing: 1px;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.expert-page-wrapper .featured {\n    margin: 0;\n}\n.expert-page-wrapper .main img {\n    height: 260px;\n    width: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.expert-page-wrapper .main h2 {\n    margin-top: 1em;\n    font-weight: bold;\n    font-size: 22px;\n}\n.expert-page-wrapper .main p {\n    font-size: 19px;\n    margin: 25px 0;\n}\n.expert-page-wrapper .main p.title {\n    color: #000;\n    margin: 0;\n}\n.expert-page-wrapper .main .desc {\n    line-height: 24px !important;\n    font-size: 16px;\n}\n.expert-page-wrapper .live-chat .live-chat-heading {\n    font-size: 26px;\n}\n.expert-page-wrapper .live-chat img {\n    width: 95%;\n    -o-object-fit: cover;\n       object-fit: cover;\n    height: auto;\n}\n.expert-page-wrapper .live-chat h2 {\n    color: #3c3a3a !important;\n    line-height: 30px;\n    margin-top: 0.7em;\n    font-weight: bold;\n    font-size: 20px;\n}\n.expert-page-wrapper .live-chat .live-chat-heading {\n    margin: 1em 0;\n}\n.expert-page-wrapper .live-chat .experts {\n    margin: 0 2.2em;\n}\n.expert-page-wrapper .live-chat .experts p {\n    margin: 1.3em 0;\n    font-size: 15px;\n}\n.expert-page-wrapper .live-chat .experts .date {\n    font-size: 18px;\n}\n.expert-page-wrapper .live-chat .experts button {\n    padding: 20px 18px;\n    border-radius: 2px;\n    font-size: 16px;\n}\n.expert-page-wrapper .random .blog-section h2 {\n    font-size: 26px;\n    margin: 1em 0.5em;\n}\n.expert-page-wrapper .random .blog-section h4 {\n    color: #535353;\n    margin: 0 0.6em;\n    font-size: 20px;\n}\n.expert-page-wrapper .random .blog-section h4 br {\n      display: none;\n}\n.career-page-wrapper .random button.btn-load-more {\n    padding: 1em 5em;\n}\n}\n.video-player-wrapper .z-index {\n  z-index: 999;\n}\n.video-player-wrapper .video-text {\n  padding-top: 15px;\n}\n.video-player-wrapper .animated {\n  animation-duration: 0.5s;\n}\n.video-player-wrapper .pink-filled {\n  color: #f0617d;\n}\n.video-player-wrapper .slider .slick-track .slick-slide .slide-player img {\n  height: 206px !important;\n}\n.video-player-wrapper .slider .slick-track .slick-slide .slide-player .text-wrap-title {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.video-player-wrapper .tooltipBox {\n  width: 100%;\n  text-align: center;\n  padding-bottom: 10px;\n  height: 35px;\n}\n.video-player-wrapper .tooltipBox .tooltipText {\n    background: rgba(0, 0, 0, 0.5);\n    color: white;\n    padding: 5px 10px 4px 10px;\n    border-radius: 3px;\n}\n.video-player-wrapper .video-player-background {\n  background: #000;\n}\n.video-player-wrapper .watch-again .current-video-img {\n  display: inline-block;\n  margin: 1em 0;\n}\n.video-player-wrapper .watch-again .current-video-img img {\n    height: 186px;\n    width: 320px;\n    float: left;\n}\n.video-player-wrapper .watch-again .current-video-img a {\n    text-decoration: none;\n    font-size: 20px;\n    color: #f0617d;\n    padding: 10px 0;\n    margin-right: 0;\n    float: left;\n    width: 100%;\n    text-align: left;\n}\n.video-player-wrapper .watch-again .congratz {\n  color: #44bda8;\n  text-align: center;\n  font-size: 24px;\n  margin: 2em 0;\n}\n.video-player-wrapper .watch-again .rating {\n  /* RESET STYLES\n            –––––––––––––––––––––––––––––––––––––––––––––––––– */\n  /* CHART-SKILLS STYLES\n            –––––––––––––––––––––––––––––––––––––––––––––––––– */\n  /* ANIMATIONS\n            –––––––––––––––––––––––––––––––––––––––––––––––––– */\n}\n.video-player-wrapper .watch-again .rating li {\n    cursor: pointer;\n}\n.video-player-wrapper .watch-again .rating .chart-skills {\n    background: #43C6AC;\n    /* fallback for old browsers */\n    /* Chrome 10-25, Safari 5.1-6 */\n    background: linear-gradient(to left, #F8FFAE, #43C6AC);\n    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */\n    margin: 0;\n    padding: 0;\n    border-top-left-radius: 300px;\n    border-top-right-radius: 300px;\n    list-style-type: none;\n}\n.video-player-wrapper .watch-again .rating .chart-skills *,\n  .video-player-wrapper .watch-again .rating .chart-skills::before {\n    box-sizing: border-box;\n}\n.video-player-wrapper .watch-again .rating .chart-skills {\n    position: relative;\n    width: 550px;\n    height: 275px;\n    overflow: hidden;\n    float: left;\n}\n.video-player-wrapper .watch-again .rating .chart-skills::before,\n  .video-player-wrapper .watch-again .rating .chart-skills::after {\n    position: absolute;\n}\n.video-player-wrapper .watch-again .rating .chart-skills::before {\n    content: '';\n    width: inherit;\n    height: inherit;\n    border-bottom: none;\n}\n.video-player-wrapper .watch-again .rating .chart-skills::after {\n    left: 50%;\n    bottom: 10px;\n    transform: translateX(-50%);\n    font-size: 1.1rem;\n    font-weight: bold;\n    color: cadetblue;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: inherit;\n    height: inherit;\n    border-top: none;\n    border-bottom-left-radius: 300px;\n    border-bottom-right-radius: 300px;\n    transform-origin: 50% 0;\n    transform-style: preserve-3d;\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n    animation-fill-mode: forwards;\n    animation-duration: .4s;\n    animation-timing-function: linear;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(1) {\n    border-top: 5px solid #ffffff;\n    z-index: 4;\n    animation-name: rotate-one;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(1):hover {\n      font-size: 15px;\n      color: #000000;\n      font-weight: 600;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(2) {\n    border-top: 5px solid #ffffff;\n    z-index: 3;\n    animation-name: rotate-two;\n    animation-delay: .4s;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(2):hover {\n      font-size: 15px;\n      color: #000000;\n      font-weight: 600;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(3) {\n    border-top: 5px solid #ffffff;\n    z-index: 2;\n    animation-name: rotate-three;\n    animation-delay: .8s;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(3):hover {\n      font-size: 15px;\n      color: #000000;\n      font-weight: 600;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(4) {\n    border-top: 5px solid #ffffff;\n    z-index: 1;\n    animation-name: rotate-four;\n    animation-delay: 1.2s;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(4):hover {\n      font-size: 15px;\n      color: #000000;\n      font-weight: 600;\n}\n.video-player-wrapper .watch-again .rating .chart-skills span {\n    position: absolute;\n    font-size: .85rem;\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n    animation: fade-in .4s linear forwards;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(1) span {\n    font-size: 1.5em;\n    top: 70px;\n    left: 15px;\n    transform: rotate(-110deg);\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(2) span {\n    font-size: 1.5em;\n    top: 70px;\n    left: 45px;\n    transform: rotate(-112deg);\n    animation-delay: .4s;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(3) span {\n    font-size: 1.5em;\n    top: 60px;\n    left: 45px;\n    transform: rotate(-111deg);\n    animation-delay: .8s;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(4) span {\n    font-size: 1.5em;\n    top: 65px;\n    left: 27px;\n    transform: rotate(-117deg);\n    animation-delay: 1.2s;\n}\n@keyframes rotate-one {\n100% {\n    transform: rotate(45deg);\n}\n}\n@keyframes rotate-two {\n0% {\n    transform: rotate(45deg);\n}\n100% {\n    transform: rotate(90deg);\n}\n}\n@keyframes rotate-three {\n0% {\n    transform: rotate(90deg);\n}\n100% {\n    transform: rotate(135deg);\n}\n}\n@keyframes rotate-four {\n0% {\n    transform: rotate(135deg);\n}\n100% {\n    transform: rotate(180deg);\n}\n}\n@keyframes fade-in {\n0%,\n  90% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}\n.video-player-wrapper .watch-again .author p {\n  line-height: 30px;\n  margin: 15px 15em;\n}\n.video-player-wrapper .watch-again h3 {\n  color: #383838;\n  font-weight: 600;\n  font-size: 30px;\n  margin: 2em 0;\n}\n.video-player-wrapper .watch-again p {\n  font-size: 16px;\n  text-align: justify;\n  margin: 0 15em;\n}\n.authorContent {\n  width: 100%;\n  display: inline-block;\n  text-align: left;\n  padding: 50px 0 0 240px;\n}\n.authorContent img {\n    width: 44px;\n    height: 44px;\n    float: left;\n    margin-right: 15px;\n}\n.authorContent h4 {\n    width: 90%;\n    display: inline-block;\n    margin: 2px 0 4px 0;\n    font-size: 20px;\n    color: #303030;\n    font-family: sans-serif;\n}\n.authorContent h5 {\n    width: 90%;\n    display: inline-block;\n    margin: 0;\n    font-size: 14px;\n    color: #303030;\n    font-family: sans-serif;\n}\n.heartIcon {\n  display: none;\n}\n.responsiveSocialIconBox {\n  display: none;\n  width: 100%;\n  position: absolute;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  text-align: center;\n}\n.responsiveSocialIconBox a {\n    float: none !important;\n    display: inline-block;\n    position: relative;\n    top: 40%;\n}\n.responsiveSocialIconBox a i {\n      margin: 0 15px;\n      font-size: 28px;\n      color: white;\n}\n.responsiveSocialIconBox a i:hover {\n        color: #f0617d;\n}\n.responsiveSocialIconBox .active-icon i {\n    color: #f0617d;\n}\n@media (min-width: 320px) and (max-width: 1024px) {\n.video-player .right-video-icons .icons-hover ul li .enjoy {\n    display: none;\n}\n.player-content p {\n    margin: 20px 0 25px 0;\n}\n.video-player-wrapper .watch-again .rating .chart-skills {\n    float: none;\n    margin: auto;\n}\n.video-player-wrapper .watch-again .current-video-img img {\n    height: auto;\n    width: 100%;\n}\n.video-player .jwplayer.jw-flag-aspect-mode {\n    /*height: 250px !important;*/\n}\n.video-player {\n    /*height: 250px;*/\n}\n.video-player .right-video-icons .icons-hover {\n    padding: 46px 0 0 0;\n}\n.video-player .left-video-icons {\n    display: none !important;\n}\n.video-player .jwplayer.jw-flag-aspect-mode {\n    width: 100% !important;\n}\n.video-player .right-video-icons {\n    display: none !important;\n}\n.heartIcon {\n    float: right;\n    margin: 15px 5px 0 0;\n    color: #f0617d;\n    font-size: 22px;\n    display: inline-block;\n}\n.video-player-wrapper .watch-again .current-video-img a {\n    width: auto;\n}\n.responsiveSocialIcon {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n}\n.responsiveSocialIconBox {\n    display: block;\n}\n.video-player-wrapper .watch-again .current-video-img {\n    position: relative;\n}\n.video-player-wrapper .watch-again .author p {\n    margin: 15px 0;\n}\n.video-player-wrapper .watch-again p {\n    margin: 0;\n}\n.authorContent {\n    width: 100%;\n    display: inline-block;\n    text-align: left;\n    padding: 50px 0 0 0;\n}\n.video-player-wrapper .watch-again h3 {\n    font-size: 22px;\n    margin: 1em 0;\n}\n.video-player .reset-video-width {\n    width: 100%;\n}\n.side-content {\n    padding: 20px 0 30px 15px;\n    width: 100%;\n}\n}\n@media (min-width: 320px) and (max-width: 600px) {\n.video-player-wrapper .watch-again .rating .chart-skills {\n    width: 100%;\n    height: 45vw;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li span {\n    font-size: 14px !important;\n}\n}\n@media (min-width: 400px) and (max-width: 500px) {\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(4) span {\n    top: 46px;\n    left: 8px;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(3) span {\n    top: 46px;\n    left: 7px;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(2) span {\n    top: 46px;\n    left: 8px;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(1) span {\n    top: 46px;\n    left: 10px;\n}\n}\n@media (min-width: 320px) and (max-width: 399px) {\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(4) span {\n    top: 37px;\n    left: 17px;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(3) span {\n    top: 39px;\n    left: 16px;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(2) span {\n    top: 43px;\n    left: 15px;\n}\n.video-player-wrapper .watch-again .rating .chart-skills li:nth-child(1) span {\n    top: 38px;\n    left: 5px;\n}\n}\n@media (min-width: 768px) and (max-width: 1024px) {\n.video-player-wrapper .watch-again .rating .chart-skills {\n    float: none;\n    margin: 0 auto;\n}\n.video-player .right-video-icons .icons-hover {\n    width: 100%;\n}\n.player-content {\n    padding: 0;\n}\n.video-player .right-video-icons {\n    display: none;\n}\n.video-player .left-video-icons {\n    display: none;\n}\n.video-player .jwplayer.jw-flag-aspect-mode {\n    height: 100% !important;\n    width: 100% !important;\n    float: left;\n}\n}\n.responsiveSocialIconBox > div {\n  top: 50%;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin-top: -22px;\n}\n.responsiveSocialIconBox i {\n  font-size: 44px;\n  margin: 0 10px;\n  color: #f0617d;\n}\n.search {\n  padding: 90px 0 0 0;\n}\n.search .text-wrap-title {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n.search form {\n    width: 70.2%;\n    margin: 0 auto;\n    display: block;\n}\n.search form input {\n      width: 90%;\n      float: left;\n      line-height: 40px;\n      padding: 6px 25px 2px;\n      outline: none;\n      border-right: 0;\n      border-top: 1px solid darkgrey;\n      border-bottom: 1px solid darkgrey;\n      border-left: 1px solid darkgrey;\n}\n.search form button {\n      width: 10%;\n      float: left;\n      border-radius: 0;\n      line-height: 36px;\n      padding: 10px 0 1.5px 0;\n      background: #f0617d;\n      color: white !important;\n}\n.search form button i {\n        font-size: 22px;\n}\n.search .video-title {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n.search .tabs {\n    width: 100%;\n    float: left;\n    border-bottom: 1px solid darkgrey;\n    padding: 90px 0 0 0;\n    margin-bottom: 90px;\n}\n.search .tabs ul {\n      padding: 0 60px 0 0;\n      margin: 0;\n}\n.search .tabs ul li {\n        list-style: none;\n        display: inline-block;\n        margin: 0 40px 0 40px;\n        padding-bottom: 5px;\n}\n.search .tabs ul li:first-of-type {\n          float: left;\n}\n.search .tabs ul li a {\n          text-decoration: none;\n          padding: 0 20px 5px 20px;\n          font-size: 16px;\n          text-transform: capitalize;\n          font-weight: 400;\n          color: #5D5D5D;\n}\n.search .tabs ul .current {\n        display: inline-block !important;\n        border-bottom: 2px solid #f0617d;\n}\n.search .current {\n    display: inherit !important;\n}\n.search .tabContent {\n    display: none;\n    width: 100%;\n    float: left;\n}\n.search .tabContent img {\n      width: 100%;\n      height: 180px;\n}\n.search .tabContent p {\n      color: black;\n      text-align: left;\n      margin: 10px 15px;\n      letter-spacing: 0.2px;\n      font-size: 20px;\n      padding: 0 30px 0 0;\n}\n.search .tabContent .video-row {\n      margin-bottom: 20px;\n}\n.bottom-margin {\n  margin-bottom: 40px;\n}\n.tabs-content {\n  margin-bottom: 10px;\n  width: 100%;\n  float: left;\n}\n.pagination-box {\n  padding-bottom: 60px;\n  width: 100%;\n  float: left;\n}\n.pagination-box .pagination {\n    margin: 0;\n}\n.pagination-box .pagination li a {\n      padding: 0 2px;\n      color: #5D5D5D;\n      background: none;\n      border: 0;\n      font-weight: 600;\n      margin-right: 8px;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.search {\n    padding: 20px 0 0 0;\n}\n.search form {\n    width: 100%;\n}\n.search form input {\n    width: 80%;\n}\n.search form button {\n    width: 20%;\n}\n.search .tabs {\n    padding: 30px 0 0 0;\n    margin-bottom: 30px;\n    border-bottom: none;\n    overflow: auto;\n}\n.search .tabs ul {\n    padding: 0;\n    float: left;\n    padding-bottom: 15px;\n}\n.search .tabs ul li a {\n    padding: 0 7px 5px 6px;\n    font-size: 13px;\n}\n.search .tabs ul li {\n    display: inline-block;\n    margin: 0;\n    float: left;\n}\n.search .tabs ul li:first-of-type {\n    display: block;\n    float: none;\n    text-align: left;\n    padding-bottom: 15px;\n}\n.tabs-content {\n    margin-bottom: 0;\n}\n.pagination-box {\n    padding-bottom: 20px;\n}\n.jw-img {\n    height: 206px !important;\n}\n}\n@media (min-width: 768px) and (max-width: 992px) {\n.search .tabs ul li {\n    margin: 0 40px 0 0;\n}\n.search form {\n    width: 80%;\n}\n}\n.giving-content {\n  padding: 30px 0 70px 0;\n}\n.giving-content img {\n    display: block;\n    margin: auto;\n}\n.giving-content h2 {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 7px 0 45px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n}\n.giving-content p {\n    width: 71%;\n    margin: auto;\n    display: block;\n    font-size: 16px;\n    color: #303030;\n    padding: 0 60px 55px;\n    line-height: 28px;\n    font-family: sans-serif;\n}\n.giving-content .givingVideos img {\n    width: 97.4%;\n    display: inline-block;\n    float: right;\n}\n.giving-content .givingVideos h3 {\n    color: #000000;\n    font-size: 30px;\n    font-family: sans-serif;\n    margin: 60px 0 15px 0;\n    text-align: left;\n    text-transform: capitalize;\n    letter-spacing: 0.3px;\n}\n.giving-content .givingVideos p {\n    width: 100%;\n    margin: 0;\n    display: block;\n    font-size: 14px;\n    color: #303030;\n    padding: 0 210px 35px 0;\n    line-height: 22px;\n    font-family: sans-serif;\n    text-align: left;\n}\n.giving-content .givingVideos button {\n    font-family: sans-serif;\n    font-size: 16px;\n    background: #f0617d;\n    border: 1px solid #f0617d;\n    color: white;\n    width: 344px;\n    float: left;\n    padding: 22px 15px 16px;\n    letter-spacing: 0.3px;\n    border-radius: 3px;\n    outline: none;\n    position: relative;\n}\n.giving-content .givingVideos button:hover {\n      box-shadow: 0 0 1px 0 #f0617d;\n      color: #f0617d;\n      background: white;\n}\n.giving-content .givingVideos button:hover:before {\n        width: 30px;\n        height: 30px;\n        content: \"\";\n        background: #f0617d;\n        border-radius: 50%;\n        text-align: center;\n        display: inline-block;\n        position: absolute;\n        right: 15px;\n        top: 17px;\n}\n.giving-content .givingVideos button:hover:after {\n        content: \"\\F00C\";\n        font: normal normal normal 14px/1 FontAwesome;\n        position: absolute;\n        color: white;\n        right: 20.5px;\n        top: 24px;\n        font-size: 18px;\n}\n.giving-content .givingVideos button:active {\n      box-shadow: 0 0 0 0 #f0617d;\n      transform: translateY(1px);\n}\n.giving-content .givingVideos .selectedCharity {\n    color: #f0617d !important;\n    background: none !important;\n}\n.giving-content .givingVideos .selectedCharity:before {\n      width: 30px;\n      height: 30px;\n      content: \"\";\n      background: #f0617d;\n      border-radius: 50%;\n      text-align: center;\n      display: inline-block;\n      position: absolute;\n      right: 15px;\n      top: 17px;\n}\n.giving-content .givingVideos .selectedCharity:after {\n      content: \"\\F00C\";\n      font: normal normal normal 14px/1 FontAwesome;\n      position: absolute;\n      color: white;\n      right: 20.5px;\n      top: 24px;\n      font-size: 18px;\n}\n.giving-content .modal-dialog {\n    width: 915px;\n}\n.giving-content .modal-dialog .modal-content {\n      border-radius: 3px;\n}\n.giving-content .modal-dialog .modal-body {\n      padding: 15px 15px 45px;\n}\n.giving-content .modal-dialog .modal-body h4 {\n        color: #303030;\n        font-size: 20px;\n        font-family: sans-serif;\n        letter-spacing: 0.2px;\n        margin: 70px 0 45px 0;\n}\n.giving-content .modal-dialog .modal-body .selectedImage {\n        width: 333px;\n        height: 145px;\n        display: block;\n        margin: 0 auto 55px;\n        border: 3px solid #f0617d;\n        padding: 0 0 0 0;\n        position: relative;\n}\n.giving-content .modal-dialog .modal-body .selectedImage img {\n          width: 253px;\n          height: 95px;\n          padding: 0;\n          margin-top: 25px;\n          -o-object-fit: contain;\n             object-fit: contain;\n}\n.giving-content .modal-dialog .modal-body .selectedImage:before {\n          width: 20px;\n          height: 20px;\n          content: \"\";\n          background: #f0617d;\n          border-radius: 50%;\n          text-align: center;\n          display: inline-block;\n          position: absolute;\n          right: 15px;\n          top: 17px;\n}\n.giving-content .modal-dialog .modal-body .selectedImage:after {\n          content: \"\\F00C\";\n          font: normal normal normal 14px/1 FontAwesome;\n          position: absolute;\n          color: white;\n          right: 17.8px;\n          top: 20px;\n          font-size: 14px;\n}\n.giving-content .modal-dialog .modal-body a {\n        color: #303030;\n        font-size: 16px;\n        font-family: sans-serif;\n        letter-spacing: 0.3px;\n        text-decoration: underline;\n        margin: 0 40px 0 80px;\n}\n.giving-content .modal-dialog .modal-body button {\n        background: #f0617d;\n        color: white;\n        border: none;\n        outline: none;\n        font-family: sans-serif;\n        font-size: 16px;\n        width: 262px;\n        padding: 21px 15px 17px;\n        border-radius: 3px;\n        letter-spacing: 0.2px;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.giving-content {\n    padding: 30px 0 30px 0;\n}\n.giving-content h2 {\n    margin: 7px 0 20px 0;\n}\n.giving-content p {\n    width: 100%;\n    padding: 0 0 30px;\n}\n.giving-content .givingVideos h3 {\n    margin: 30px 0 15px 0;\n}\n.giving-content .givingVideos img {\n    width: 100%;\n}\n.giving-content .givingVideos p {\n    padding: 0 0 20px 0;\n}\n.giving-content .givingVideos button {\n    width: 270px;\n}\n.giving-content .givingVideos {\n    margin-bottom: 40px;\n}\n.giving-content .modal-dialog {\n    width: 95%;\n    margin: 15px auto;\n}\n.giving-content .modal-dialog .modal-body a {\n    margin: 0 0 10px 0;\n    display: block;\n}\n.giving-content .modal-dialog .modal-body h4 {\n    margin: 40px 0 30px 0;\n}\n.giving-content .modal-dialog .modal-body .selectedImage {\n    margin: 0 auto 30px;\n}\n.giving-content .modal-dialog .modal-body .selectedImage {\n    width: 100%;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.giving-content .givingVideos p {\n    padding: 0 30px 35px 0;\n}\n.giving-content .modal-dialog {\n    width: 95%;\n}\n}\n.profile {\n  padding: 80px 0 0 0;\n  width: 100%;\n  display: inline-block;\n}\n.profile .text-wrap-title {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n.profile .heading {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 7px 0 25px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n    font-size: 30px;\n}\n.profile .heading img {\n      margin: 0 0 20px 0;\n}\n.profile .heading .money-img {\n      width: 60px;\n}\n.profile .jw-img {\n    height: 206px !important;\n}\n.profile h2 {\n    text-transform: uppercase;\n    font-family: sans-serif;\n    color: #303030;\n    margin: 0 0 50px 0;\n}\n.profile .tabs-content {\n    margin-bottom: 0;\n}\n.profile .tabs-content .tabs ul {\n      padding: 0;\n      margin: 0 auto 30px;\n      border-bottom: 1px solid #ccc;\n}\n.profile .tabs-content .tabs ul li {\n        list-style: none;\n        display: inline-block;\n        padding: 0 0 4px 0;\n}\n.profile .tabs-content .tabs ul li a {\n          color: #0D0D0D;\n          font-size: 16px;\n          text-transform: capitalize;\n          font-family: sans-serif;\n          padding: 0 43.2px 7px;\n          text-decoration: none;\n}\n.profile .tabs-content hr {\n      margin: 0 1em;\n      border: 0;\n      border-top: 1px solid #eeeeee;\n}\n.profile .tabs-content .right-heart-icon {\n      margin: 0;\n      float: left;\n      width: 100%;\n      padding: 10px 0 0 0;\n}\n.profile .tabs-content .right-heart-icon i {\n        color: #f0617d;\n        float: right;\n        font-size: 28px;\n}\n.profile .tabs ul .current {\n    display: inline-block !important;\n    border-bottom: 3px solid #f0617d;\n}\n.profile .tabContent {\n    display: none;\n    width: 100%;\n    float: left;\n    background: #fafafa;\n}\n.profile .tabContent img {\n      width: 100%;\n      height: 180px;\n}\n.profile .tabContent p {\n      color: black;\n      text-align: left;\n      margin: 10px 15px;\n      letter-spacing: 0.2px;\n      font-size: 20px;\n      padding: 0;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n}\n.profile .tabContent .video-row {\n      margin-bottom: 20px;\n}\n.profile .tabContent .mostRecent {\n      float: right;\n      width: 100%;\n      padding: 70px 0 40px 0;\n}\n.profile .tabContent .mostRecent button {\n        float: right;\n        background: none;\n        color: #f0617d;\n        border: 1px solid #f0617d;\n        text-transform: capitalize;\n        padding: 14px 50px 11px 30px;\n        font-family: sans-serif;\n        letter-spacing: 0.5px;\n        outline: none;\n        position: relative;\n}\n.profile .tabContent .mostRecent button:hover {\n          box-shadow: 0 0 2px 0 #f0617d;\n}\n.profile .tabContent .mostRecent button:active {\n          box-shadow: 0 0 0 0 #f0617d;\n          -webkit-transform: translateY(1px);\n}\n.profile .tabContent .mostRecent button i {\n          font-size: 24px;\n          position: absolute;\n          right: 15px;\n          top: 11px;\n}\n.profile .tabContent .mostRecent span {\n        float: right;\n        font-family: sans-serif;\n        color: #303030;\n        margin: 14px 25px 0 0;\n}\n.profile .tabContent .bottom-margin {\n      margin: 30px 0;\n}\n.profile .tabContent .personalize {\n      background: white;\n      margin: 50px auto 45px;\n      border: 1px solid #e0e0e0;\n}\n.profile .tabContent .personalize .personalizeText {\n        font-size: 24px;\n        margin: 0;\n        padding: 35px 280px 40px;\n        text-align: center;\n        font-family: sans-serif;\n        line-height: 30px;\n        color: #303030;\n        text-overflow: inherit;\n        white-space: inherit;\n}\n.profile .tabContent .personalize .buttonsArea {\n        display: inline-block;\n        width: 100%;\n        margin: 30px 0 60px 0;\n}\n.profile .tabContent .personalize .buttonsArea button {\n          background: none;\n          color: #4A4A4A;\n          font-size: 15px;\n          font-family: sans-serif;\n          border: 1px solid #f0617d;\n          width: 24.2%;\n          margin: 0 8px 10px 0;\n          padding: 14px 10px 11px;\n          outline: none;\n}\n.profile .tabContent .personalize .buttonsArea button:hover {\n            background: #f0617d;\n            color: white;\n}\n.profile .tabContent .personalize .buttonsArea button:nth-of-type(4n+0) {\n            margin-right: 0;\n}\n.profile .tabContent .personalize .updateInterest {\n        background: #f0617d;\n        color: white;\n        border: none;\n        outline: none;\n        font-size: 16px;\n        font-family: sans-serif;\n        letter-spacing: 0.5px;\n        padding: 21px 73px 17px;\n        border-radius: 4px;\n        margin-bottom: 30px;\n}\n.profile .tabContent .personalize .updateInterest:hover {\n          box-shadow: 0 0 2px 0 #f0617d;\n}\n.profile .tabContent .personalize .updateInterest:active {\n          box-shadow: 0 0 0 0 #f0617d;\n          transform: translateY(1px);\n}\n.profile .tabContent .personalize form {\n        width: 50%;\n        margin: 0 auto 60px;\n        display: block;\n}\n.profile .tabContent .personalize form input {\n          width: 100%;\n          padding: 0 15px;\n          height: 60px;\n          outline: none;\n          font-family: sans-serif;\n          margin-bottom: 20px;\n}\n.profile .tabContent .personalize form .sendBtn {\n          font-family: sans-serif;\n          width: 100%;\n          color: #f0617d;\n          background: none;\n          border: 1px solid #f0617d;\n          outline: none;\n          padding: 21px 15px 18px;\n          border-radius: 3px;\n}\n.profile .tabContent .personalize form .sendBtn:hover {\n            box-shadow: 0 0 2px 0 #f0617d;\n}\n.profile .tabContent .personalize form .sendBtn:active {\n            box-shadow: 0 0 0 0 #f0617d;\n            transform: translateY(1px);\n}\n.profile .current {\n    display: inline-block !important;\n}\n.yourFaves {\n  margin: 0;\n}\n.favesText {\n  padding: 2em 0;\n  margin: 0 0 30px 0;\n}\n.selectedCharityBtn {\n  margin-top: 12px;\n}\n.videoInformation {\n  background: white;\n  display: inline-block;\n  padding: 0 0 10px 0;\n}\n.accountContentBox {\n  margin: 70px 0 120px 0;\n}\n.accountContentBox .accountLeft img {\n    width: 241px;\n    height: 241px;\n    margin: 0 auto;\n    display: block;\n    border-radius: 50%;\n    margin-bottom: 20px;\n}\n.accountContentBox .accountLeft a {\n    font-size: 16px;\n    color: #303030;\n    font-family: sans-serif;\n    letter-spacing: 0.3px;\n    text-transform: capitalize;\n    border-bottom: 1px solid #303030;\n    padding-bottom: 1px;\n    text-decoration: none;\n}\n.accountContentBox .accountLeft .shareBox {\n    display: inline-block;\n    background: white;\n    border: 1px solid #e0e0e0;\n    padding: 33px 30px 35px 30px;\n    margin: 60px 0 10px 0;\n}\n.accountContentBox .accountLeft .shareBox p {\n      margin: 0 0 50px 0;\n      padding: 0 90px;\n      text-align: center;\n      font-family: sans-serif;\n      color: #303030;\n}\n.accountContentBox .accountLeft .shareBox input {\n      width: 100%;\n      outline: none;\n      font-family: sans-serif;\n      color: #303030;\n      padding: 0 15px;\n      height: 60px;\n      margin-bottom: 20px;\n}\n.accountContentBox .accountLeft .shareBox ::-webkit-input-placeholder {\n      color: #9B9B9B;\n}\n.accountContentBox .accountLeft .shareBox button {\n      width: 100%;\n      background: none;\n      color: #f0617d;\n      border: 1px solid #f0617d;\n      outline: none;\n      font-size: 16px;\n      font-family: sans-serif;\n      padding: 20px 15px 16px;\n}\n.accountContentBox .accountLeft .shareBox button:hover {\n        box-shadow: 0 0 2px 0 #f0617d;\n}\n.accountContentBox .accountLeft .shareBox button:active {\n        transform: translateY(1px);\n        box-shadow: 0 0 0 0 #f0617d;\n}\n.accountContentBox .accountRight {\n    position: relative;\n}\n.accountContentBox .accountRight .needHelp {\n      position: absolute;\n      right: 0;\n      top: -25px;\n      font-size: 13px;\n      font-family: sans-serif;\n      border-bottom: 1px solid #f0617d;\n      line-height: 12px;\n      text-decoration: none;\n}\n.accountContentBox .accountRight form {\n      background: white;\n      display: inline-block;\n      width: 100%;\n      padding: 0 20px;\n      border: 1px solid #e0e0e0;\n}\n.accountContentBox .accountRight form .formName {\n        width: 100%;\n        float: left;\n        padding: 30px 0 30px 0;\n        border-bottom: 1px solid #D8D8D8;\n}\n.accountContentBox .accountRight form .formName h4 {\n          margin: 0 0 10px 0;\n          float: left;\n          width: 100%;\n          text-align: left;\n          font-size: 16px;\n          color: #303030;\n          font-family: sans-serif;\n}\n.accountContentBox .accountRight form .formName h4 a {\n            float: right;\n            color: #4A4A4A;\n            font-size: 14px;\n            text-transform: capitalize;\n            text-decoration: underline;\n}\n.accountContentBox .accountRight form .formName img {\n          width: 40%;\n          height: auto;\n          float: left;\n}\n.accountContentBox .accountRight form .formName .SelectedCharityName {\n          float: left;\n          margin: 30px 0 0 20px;\n          font-size: 16px;\n}\n.accountContentBox .accountRight form .formName h5 {\n          margin: 0;\n          float: left;\n          width: 100%;\n          text-align: left;\n          font-size: 16px;\n          color: #303030;\n          font-family: sans-serif;\n}\n.accountContentBox .accountRight form .formName h6 {\n          margin: 10px 0 0 0;\n          float: left;\n          width: 100%;\n          text-align: left;\n          font-size: 16px;\n          color: #303030;\n          font-family: sans-serif;\n}\n.accountContentBox .accountRight form .formName h6 a {\n            float: right;\n            color: #4A4A4A;\n            font-size: 14px;\n            text-transform: capitalize;\n            text-decoration: underline;\n            margin: -5px 0 0 0;\n}\n.accountContentBox .accountRight form .formName p {\n          margin: 10px 0 0 0;\n          padding: 0;\n          display: inline-block;\n          width: 100%;\n          line-height: 16px;\n}\n.accountContentBox .accountRight form .formName p a {\n            color: #4A4A4A;\n            font-size: 14px;\n            font-family: sans-serif;\n            text-decoration: underline;\n            width: 47%;\n            display: inline-block;\n}\n.accountContentBox .accountRight form .formName p:first-of-type {\n            margin: 15px 0 0 0;\n}\n.accountContentBox .accountRight form .formName:last-of-type {\n          border: none;\n}\n.accountContentBox .accountRight form .formName:last-of-type h4:last-of-type {\n            margin: 0;\n}\n.accountContentBox .accountRight form .updateName {\n        padding: 0;\n        border: 0;\n}\n.accountContentBox .accountRight form .updateName .form-control-feedback {\n          top: 15px;\n}\n.accountContentBox .accountRight form .updateName input {\n          width: 100%;\n          border: 2px solid #D8D8D8;\n          padding: 0 15px;\n          height: 60px;\n          outline: none;\n          color: #303030;\n          margin: 10px 0 25px 0;\n}\n.accountContentBox .accountRight form .updateName button {\n          float: right;\n          background: #f0617d;\n          border: none;\n          color: white;\n          outline: none;\n          font-size: 16px;\n          width: 310px;\n          padding: 20px 15px 18px;\n          border-radius: 3px;\n}\n.accountContentBox .accountRight form .updateName a {\n          color: #4A4A4A;\n          text-decoration: underline;\n          margin: 20px 0 0 0;\n          display: inline-block;\n}\n.profile {\n  padding: 30px 0 0 0;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.profile {\n    padding: 30px 0 0 0;\n}\n.profile .tabs-content {\n    float: none;\n}\n.profile .tabs-content .tabs ul {\n    width: 100%;\n}\n.profile .tabs-content .tabs ul li a {\n    padding: 0 8.3px 7px;\n    font-size: 14px;\n}\n.profile .tabs-content .tabs ul li {\n    width: 32.3%;\n}\n.profile h2 {\n    margin: 0 0 20px 0;\n}\n.profile .tabContent .mostRecent {\n    padding: 30px 0 30px 0;\n}\n.profile .tabContent p {\n    margin: 10px 10px;\n    font-size: 18px;\n    padding: 0;\n}\n.profile .tabContent .bottom-margin {\n    margin-bottom: 15px;\n}\n.yourFaves {\n    margin: 0 0 20px 0;\n}\n.profile .tabContent .personalize {\n    margin: 20px auto 20px;\n}\n.profile .tabContent .personalize .personalizeText {\n    font-size: 22px;\n    padding: 20px 0 0;\n}\n.profile .tabContent .personalize .buttonsArea button {\n    width: 46.3%;\n}\n.profile .tabContent .personalize .buttonsArea button:nth-of-type(4n+0) {\n    margin-right: 8px;\n}\n.profile .tabContent .personalize .buttonsArea {\n    margin: 30px 0 20px 0;\n}\n.profile .tabContent .personalize form {\n    width: 100%;\n    margin: 20px auto 10px;\n}\n.accountContentBox {\n    margin: 30px 0 30px 0;\n}\n.accountContentBox .col-md-6 {\n    padding: 0;\n}\n.accountContentBox .accountLeft .shareBox {\n    padding: 15px 10px 20px 10px;\n    margin: 30px 0 10px 0;\n    width: 100%;\n}\n.accountContentBox .accountLeft .shareBox p {\n    margin: 0 0 20px 0;\n    padding: 0;\n}\n.accountContentBox .accountRight form {\n    padding: 0 10px;\n    margin-top: 20px;\n}\n.accountContentBox .accountRight .needHelp {\n    top: 0;\n}\n.accountContentBox .accountRight form .formName p a {\n    width: 100%;\n    margin-bottom: 10px;\n}\n.interestlist .interest-container {\n    margin: 2em 0;\n}\n.interestlist .btn-group {\n    margin-bottom: 20px;\n}\n.accountContentBox .accountLeft a {\n    margin-bottom: 20px;\n    display: inline-block;\n}\n.accountContentBox .accountRight form .updateName button {\n    width: 70%;\n}\n.accountContentBox .accountRight form .updateName a {\n    width: 30%;\n}\n.has-error .form-control-feedback {\n    top: 15px;\n}\n}\n@media (min-width: 768px) and (max-width: 992px) {\n.profile .tabs-content {\n    float: none;\n}\n.profile .tabs-content .tabs ul {\n    width: calc(100% - 30px);\n}\n.accountContentBox .accountLeft .shareBox p {\n    padding: 0;\n}\n.accountContentBox .accountRight form .formName p a {\n    width: 100%;\n    margin-bottom: 10px;\n}\n.profile .tabContent .personalize .personalizeText {\n    padding: 35px 140px 40px;\n}\n.profile .tabContent .personalize .buttonsArea button:nth-of-type(4n+0) {\n    margin-right: 8px;\n}\n.interestlist .checkbox-btn {\n    width: 30.5%;\n}\n.interestlist .checkbox-btn-days {\n    width: 19.5%;\n}\n.accountContentBox .accountRight form .updateName a {\n    float: left;\n    width: 30%;\n}\n.accountContentBox .accountRight form .updateName button {\n    width: 70%;\n}\n.has-success .form-control-feedback {\n    top: 15px;\n}\n.has-error .form-control-feedback {\n    top: 15px;\n}\n}\n@media (min-width: 320px) and (max-width: 450px) {\n.interestlist .checkbox-btn {\n    width: 100%;\n    margin: 0 0 10px 0;\n}\n}\n@media (min-width: 451px) and (max-width: 767px) {\n.interestlist .checkbox-btn {\n    width: 45%;\n    margin: 0 5px 10px 5px;\n    float: none;\n}\n}\n@media (min-width: 320px) and (max-width: 450px) {\n.interestlist .checkbox-btn-days {\n    width: 100%;\n    margin: 0 0 10px 0;\n    border-style: solid;\n    border-color: red;\n}\n}\n@media (min-width: 451px) and (max-width: 767px) {\n.interestlist .checkbox-btn-days {\n    width: 45%;\n    margin: 0 5px 10px 5px;\n    float: none;\n    border-style: dashed;\n    border-color: red;\n}\n}\n.community-content {\n  padding: 30px 0 0 0;\n}\n.community-content img {\n    display: block;\n    margin: auto;\n}\n.community-content h2 {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 7px 0 55px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n}\n.community-content .communityBox {\n    width: 85%;\n    margin: 0 auto;\n    display: block;\n}\n.community-content .communityBox img {\n      width: 100%;\n}\n.community-content .communityBox h2 {\n      color: #5E5E5E;\n      margin: 30px 0 34px 0;\n      line-height: 46px;\n      text-align: left;\n      font-family: sans-serif;\n      padding: 0 70px 0 20px;\n}\n.community-content .communityBox p {\n      margin: 0 0 55px 0;\n      color: #303030;\n      font-size: 14px;\n      line-height: 22px;\n      font-family: sans-serif;\n      padding: 0 140px 0 20px;\n      text-align: left;\n      letter-spacing: 0.5px;\n}\n.community-content .communityBox h5 {\n      margin: 0 0 75px 0;\n      color: #5E5E5E;\n      font-size: 16px;\n      font-family: sans-serif;\n      text-align: left;\n      padding: 0 0 0 20px;\n      letter-spacing: 0.6px;\n}\n.community-content .communityBox button {\n      color: #f0617d;\n      border: 1px solid #f0617d;\n      background: none;\n      outline: none;\n      font-size: 16px;\n      font-family: sans-serif;\n      letter-spacing: 0.3px;\n      float: left;\n      margin-left: 20px;\n      width: 278px;\n      padding: 18px 15px 14px;\n      border-radius: 3px;\n}\n.community-content .communityBox button:hover {\n        box-shadow: 0 0 2px 0 #f0617d;\n}\n.community-content .communityBox button:active {\n        box-shadow: 0 0 0 0 #f0617d;\n        transform: translateY(1px);\n}\n.community-content .sliderEventBox {\n    margin: 110px 0 100px 0;\n}\n.community-content .sliderEventBox h2 {\n      margin: 0 0 50px 0;\n      text-transform: uppercase;\n      font-family: sans-serif;\n      color: #303030;\n}\n.community-content .sliderEventBox .slick-slide img {\n      width: 100%;\n      height: 300px;\n}\n.community-content .sliderEventBox .slick-slide h2 {\n      color: #303030;\n      margin: 15px 0 15px 0;\n      line-height: 31px;\n      text-align: left;\n      font-family: sans-serif;\n      padding: 0 20px 0 10px;\n      font-size: 20px;\n      text-transform: inherit;\n}\n.community-content .sliderEventBox .slick-slide p {\n      margin: 0 0 20px 0;\n      color: #303030;\n      font-size: 14px;\n      line-height: 22px;\n      font-family: sans-serif;\n      padding: 0 10px 0 10px;\n      text-align: left;\n      letter-spacing: 0.5px;\n}\n.community-content .sliderEventBox .slick-slide h5 {\n      margin: 0 0 0 0;\n      color: #5E5E5E;\n      font-size: 14px;\n      font-family: sans-serif;\n      text-align: left;\n      padding: 0 0 0 10px;\n      letter-spacing: 0.6px;\n}\n.community-content .sliderTalkBox {\n    padding-bottom: 100px;\n}\n.community-content .sliderTalkBox h2 {\n      margin: 0 0 50px 0;\n      text-transform: uppercase;\n      font-family: sans-serif;\n      color: #303030;\n}\n.community-content .sliderTalkBox .slick-track {\n      height: auto;\n}\n.community-content .sliderTalkBox .slick-slide p {\n      font-size: 14px;\n      color: #303030;\n      font-family: sans-serif;\n      text-align: left;\n      line-height: 22px;\n      margin: 0 0 20px 0;\n      padding: 0 60px 0 0;\n}\n.community-content .sliderTalkBox .slick-slide span {\n      color: #5E5E5E;\n      font-size: 14px;\n      text-align: left;\n      float: left;\n      width: 100%;\n      font-family: sans-serif;\n      margin: 0 0 40px 0;\n}\n.community-content .sliderTalkBox .slick-slide button {\n      float: left;\n      background: none;\n      border: 1px solid #f0617d;\n      color: #f0617d;\n      outline: none;\n      font-size: 16px;\n      font-family: sans-serif;\n      letter-spacing: 0.5px;\n      width: 278px;\n      padding: 18px 15px 14px;\n      border-radius: 3px;\n}\n.community-content .sliderTalkBox .slick-slide button:hover {\n        box-shadow: 0 0 2px 0 #f0617d;\n}\n.community-content .sliderTalkBox .slick-slide button:active {\n        box-shadow: 0 0 0 0 #f0617d;\n        transform: translateY(1px);\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.community-content {\n    padding: 30px 0 0 0;\n}\n.community-content h2 {\n    margin: 7px 0 30px 0;\n}\n.community-content .communityBox h2 {\n    color: #5E5E5E;\n    margin: 20px 0 20px 0;\n    font-size: 20px;\n    line-height: 30px;\n    padding: 0 0 0 10px;\n}\n.community-content .communityBox p {\n    margin: 0 0 20px 0;\n    padding: 0 0 0 10px;\n}\n.community-content .communityBox h5 {\n    margin: 0 0 20px 0;\n    padding: 0 0 0 10px;\n}\n.community-content .communityBox button {\n    font-size: 14px;\n    margin-left: 0px;\n    max-width: 222px;\n    width: 100%;\n}\n.community-content .sliderEventBox {\n    margin: 50px 0 90px 0;\n}\n.community-content .sliderEventBox .slick-dots {\n    bottom: -65px;\n}\n.community-content .sliderEventBox h2 {\n    margin: 0 0 20px 0;\n}\n.community-content .sliderTalkBox h2 {\n    margin: 0 0 20px 0;\n}\n.community-content .sliderTalkBox .slick-slide button {\n    width: 225px;\n}\n.community-content .sliderTalkBox .slick-slide p {\n    font-size: 18px;\n    padding: 0;\n}\n.community-content .sliderTalkBox .slick-slide span {\n    margin: 0 0 20px 0;\n}\n.community-content .sliderTalkBox {\n    padding-bottom: 0;\n}\n.community-content .sliderTalkBox .slick-dots {\n    bottom: -25px;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.community-content .communityBox h2 {\n    margin: 0 0 15px 0;\n    line-height: 36px;\n    padding: 0;\n    font-size: 24px;\n}\n.community-content .communityBox p {\n    margin: 0 0 20px 0;\n    padding: 0;\n}\n.community-content .communityBox h5 {\n    margin: 0 0 30px 0;\n    padding: 0;\n}\n.community-content .communityBox button {\n    margin-left: 0;\n}\n.sliderEventBox .slick-dots {\n    bottom: -65px;\n}\n}\n.liveEventContent .liveEvent {\n  width: 100%;\n  display: block;\n  margin: 0 auto;\n}\n.liveEventContent .liveEvent h3 {\n    color: #303030;\n    font-size: 30px;\n    font-family: sans-serif;\n    line-height: 46px;\n    padding: 0 0;\n    width: 41%;\n    margin: 15px auto 40px;\n}\n.liveEventContent .liveEvent img {\n    width: 93.5%;\n    height: 450px;\n    margin-bottom: 60px;\n}\n.liveEventContent .liveEvent button {\n    border: 1px solid #f0617;\n    color: #f0617;\n    background: none;\n    font-size: 16px;\n    font-family: sans-serif;\n    letter-spacing: 0.3px;\n    width: 316px;\n    padding: 18px 15px 14px;\n    border-radius: 3px;\n    display: block;\n    margin: 25px auto 80px;\n    outline: none;\n}\n.liveEventContent .liveEvent button:hover {\n      box-shadow: 0 0 2px 0 #f0617;\n}\n.liveEventContent .liveEvent button:active {\n      box-shadow: 0 0 0 0 #f0617;\n      transform: translateY(1px);\n}\n.liveEventContent .liveEvent .attendeesContent {\n    width: 100%;\n    display: inline-block;\n    margin-bottom: 50px;\n}\n.liveEventContent .liveEvent .attendeesContent h2 {\n      color: #303030;\n      font-family: sans-serif;\n      margin: 0 0 35px 0;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage {\n      width: 100%;\n      display: block;\n      margin: 0 auto;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage {\n        width: 32%;\n        display: inline-block;\n        text-align: center;\n        margin-bottom: 35px;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage img {\n          width: 86px;\n          height: 86px;\n          display: block;\n          margin: 0 auto;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage span {\n          color: #5E5E5E;\n          font-size: 14px;\n          font-family: sans-serif;\n          text-transform: capitalize;\n          letter-spacing: 0.3px;\n          margin: 12px 0 10px 0;\n          display: inline-block;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage:first-of-type {\n          margin-left: 15px;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage:nth-of-type(2) {\n          margin-right: 15px;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .slick-next, .liveEventContent .liveEvent .attendeesContent .liveEventImage .slick-prev {\n        font-size: 0;\n        border: none;\n        width: auto;\n        padding: 0;\n        margin: 0;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .slick-next {\n        right: -25px;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .slick-prev {\n        left: -25px;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .slick-next:hover, .liveEventContent .liveEvent .attendeesContent .liveEventImage .slick-prev:hover {\n        box-shadow: 0 0 0 0;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .slick-dots li button {\n        font-size: 0;\n        border: none;\n        width: 22px !important;\n        padding: 0;\n        margin: 0;\n        border-radius: 0;\n        height: 4px !important;\n        background: #e0e0e0;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .slick-dots li button:hover {\n          box-shadow: 0 0 0 0;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .slick-dots li button:before {\n          display: none;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .slick-dots .slick-active button {\n        background: #44bda8;\n}\n.liveEventContent .liveEvent .aboutExpert {\n    width: 100%;\n    display: inline-block;\n    margin-bottom: 90px;\n}\n.liveEventContent .liveEvent .aboutExpert h2 {\n      color: #303030;\n      font-family: sans-serif;\n      margin: 0 0 35px 0;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n}\n.liveEventContent .liveEvent .aboutExpert img {\n      width: 160px;\n      height: 160px;\n      display: block;\n      margin: 0 auto 15px;\n}\n.liveEventContent .liveEvent .aboutExpert h4 {\n      color: #303030;\n      font-size: 20px;\n      font-family: sans-serif;\n      text-transform: capitalize;\n      letter-spacing: 0.5px;\n      margin: 0 0 10px 0;\n}\n.liveEventContent .liveEvent .aboutExpert span {\n      color: #303030;\n      font-size: 14px;\n      font-family: sans-serif;\n      letter-spacing: 0.3px;\n      display: block;\n      margin: 0 0 15px 0;\n}\n.liveEventContent .liveEvent .aboutExpert p {\n      margin: 0;\n      font-size: 16px;\n      color: #5E5E5E;\n      font-family: sans-serif;\n      padding: 0 303px;\n      line-height: 27px;\n      letter-spacing: 0.5px;\n}\n.liveEventContent .liveEvent .liveEventQuestion .questionBox {\n    width: 65%;\n    border: 1px solid #e0e0e0;\n    margin: 0 auto 15px;\n    display: block;\n    border-radius: 3px;\n    padding: 25px 0 0 0;\n    position: relative;\n}\n.liveEventContent .liveEvent .liveEventQuestion .questionBox img {\n      width: 52px;\n      height: 40px;\n      margin: 0 0 10px 0;\n}\n.liveEventContent .liveEvent .liveEventQuestion .questionBox p {\n      margin: 0 0 30px 0;\n      color: #303030;\n      font-size: 20px;\n      line-height: 31px;\n      font-family: sans-serif;\n      letter-spacing: 0.5px;\n      padding: 0 70px;\n}\n.liveEventContent .liveEvent .liveEventQuestion .questionBox .arrow {\n      width: 25px;\n      height: 15px;\n      position: absolute;\n      bottom: -25px;\n}\n.liveEventContent .liveEvent .enabled-submission {\n    background: #44bda8;\n    color: #ffffff;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.liveEventContent .liveEvent {\n    width: 100%;\n}\n.liveEventContent .liveEvent h3 {\n    line-height: 36px;\n    width: 100%;\n    padding: 0;\n    margin: 10px 0 20px 0;\n    font-size: 22px;\n}\n.liveEventContent .liveEvent img {\n    width: 100%;\n    height: auto;\n    margin-bottom: 20px;\n}\n.liveEventContent .liveEvent button {\n    width: 270px;\n    margin: 0 auto 30px;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage {\n    width: 100%;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage:last-of-type {\n    width: 100%;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .liveImage {\n    width: 49%;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage:last-of-type .liveImage {\n    width: 49%;\n}\n.liveEventContent .liveEvent .attendeesContent {\n    margin-bottom: 20px;\n}\n.liveEventContent .liveEvent .aboutExpert h2 {\n    font-size: 22px;\n    margin: 0 0 20px 0;\n}\n.liveEventContent .liveEvent .aboutExpert p {\n    padding: 0;\n}\n.liveEventContent .liveEvent .aboutExpert {\n    margin-bottom: 40px;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .liveImage:nth-of-type(4) {\n    margin-right: 0;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .liveImage:first-of-type {\n    margin-left: 0;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage:nth-of-type(2) {\n    margin-right: 0;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage:first-of-type {\n    margin-left: 0;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage {\n    margin-bottom: 10px;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage span {\n    margin: 5px 0 10px 0;\n}\n.liveEventContent .liveEvent .liveEventQuestion .questionBox {\n    width: 100%;\n}\n.liveEventContent .liveEvent .liveEventQuestion .questionBox p {\n    padding: 0 10px;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .slick-next {\n    right: -10px;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .slick-prev {\n    left: -10px;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.liveEventContent .liveEvent h3 {\n    padding: 0 60px;\n    width: 100%;\n}\n.liveEventContent .liveEvent img {\n    width: 100%;\n    height: auto;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage {\n    width: 100%;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage:last-of-type {\n    width: 100%;\n}\n.liveEventContent .liveEvent {\n    width: 90%;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage:last-of-type .liveImage {\n    width: 19.5%;\n}\n.liveEventContent .liveEvent .aboutExpert p {\n    padding: 0 190px;\n}\n.liveEventContent .liveEvent .liveEventQuestion .questionBox p {\n    padding: 0 30px;\n}\n}\n.rules-banner {\n  background: url(" + __webpack_require__(845) + ") no-repeat;\n  width: 100%;\n  height: 582px;\n  display: inline-block;\n  background-size: cover;\n  padding: 105px 0 0 0;\n  position: relative;\n}\n.rules-banner h2 {\n    margin: 0 0 70px 0;\n    color: white;\n    line-height: 46px;\n    font-family: sans-serif;\n    padding: 0 360px;\n    letter-spacing: 0.5px;\n}\n.rules-banner h3 {\n    margin: 0 0 65px 0;\n    color: white;\n    font-family: sans-serif;\n    letter-spacing: 0.5px;\n}\n.rules-banner button {\n    background: none;\n    border: 1px solid white;\n    color: white;\n    font-size: 16px;\n    outline: none;\n    font-family: sans-serif;\n    padding: 18px 70px 14px;\n    letter-spacing: 0.2px;\n    border-radius: 3px;\n    margin-right: 20px;\n}\n.rules-banner button:hover {\n      box-shadow: 0 0 2px 0 white;\n}\n.rules-banner button:active {\n      box-shadow: 0 0 0 0 white;\n      transform: translateY(2px);\n}\n.talkRulesHeading {\n  width: 62.4%;\n  margin: -48px auto 0;\n  display: block;\n  background: white;\n  z-index: 999;\n  position: absolute;\n  left: 0;\n  right: 0;\n  padding: 30px 0 27px 0;\n}\n.talkRulesHeading h2 {\n    margin: 0;\n    color: #44BDA8;\n    font-family: sans-serif;\n}\n.container .marginTop {\n  margin-top: 80px;\n  margin-bottom: 90px;\n}\n.container .marginTop .ruleImages {\n    display: inline-block;\n    width: 100%;\n    position: relative;\n}\n.container .marginTop .ruleImages p {\n      text-align: left;\n      color: #000000;\n      font-size: 18px;\n      font-family: sans-serif;\n      padding: 0 0 0 0;\n      line-height: 24px;\n      margin: 0 0 0 50px;\n      position: absolute;\n}\n.container .marginTop .ruleImages img {\n      position: absolute;\n      left: 0;\n      right: 0;\n      margin: auto;\n      top: -25px;\n}\n.container .rules-expert-content {\n  display: block;\n  margin: 100px 0 100px 0;\n}\n.container .rules-expert-content h2 {\n    margin: 0 0 30px 0;\n    color: #303030;\n    font-family: sans-serif;\n    text-transform: uppercase;\n}\n.container .rules-expert-content img {\n    width: 160px;\n    height: 160px;\n    display: block;\n    margin: 0 auto 25px;\n}\n.container .rules-expert-content h4 {\n    margin: 0 0 8px 0;\n    color: #303030;\n    font-size: 20px;\n    font-family: sans-serif;\n}\n.container .rules-expert-content h5 {\n    margin: 0 0 20px 0;\n    color: #303030;\n    font-family: sans-serif;\n}\n.container .rules-expert-content p {\n    margin: 0;\n    color: #5E5E5E;\n    font-size: 16px;\n    font-family: sans-serif;\n    line-height: 27px;\n    padding: 0 400px;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.rules-banner {\n    width: auto;\n    height: auto;\n    padding: 0;\n}\n.rules-banner h2 {\n    margin: 30px 0 30px 0;\n    line-height: 32px;\n    padding: 0 15px;\n    font-size: 24px;\n}\n.rules-banner h3 {\n    margin: 0 0 35px 0;\n    padding: 0 15px;\n}\n.rules-banner button {\n    padding: 18px 0 14px;\n    width: 200px;\n    margin: 0 0 10px 0;\n}\n.rules-banner button:last-of-type {\n    margin: 0 0 60px 0;\n}\n.talkRulesHeading {\n    width: 75%;\n    margin: -38px auto 0;\n    padding: 20px 0 20px 0;\n}\n.talkRulesHeading h2 {\n    font-size: 26px;\n}\n.container .marginTop .ruleImages {\n    margin-bottom: 150px;\n}\n.container .marginTop .ruleImages p {\n    margin: 0;\n    text-align: center;\n    width: 100%;\n}\n.container .marginTop {\n    margin-bottom: 0;\n}\n.container .rules-expert-content {\n    margin: 0 0 50px 0;\n}\n.container .rules-expert-content h2 {\n    margin: 0 0 20px 0;\n    font-size: 26px;\n}\n.container .rules-expert-content p {\n    padding: 0 15px;\n}\n}\n@media (min-width: 768px) and (max-width: 992px) {\n.rules-banner {\n    width: auto;\n    height: auto;\n    padding: 0 0 0 0;\n    background-position: 45% 0;\n}\n.rules-banner h2 {\n    margin: 50px 0 50px 0;\n    padding: 0 50px;\n}\n.rules-banner button {\n    margin-bottom: 90px;\n}\n.rules-banner button:last-of-type {\n    margin-right: 0;\n}\n.container .marginTop .ruleImages p {\n    font-size: 16px;\n    margin: 0 0 0 0;\n}\n.container .rules-expert-content p {\n    padding: 0 170px;\n}\n}\n.tone-talk {\n  display: inline-block;\n  padding: 35px 0 10px 0;\n  width: 100%;\n}\n.tone-talk h2 {\n    color: #303030;\n    line-height: 46px;\n    margin: 0 0 40px 0;\n    padding: 0 430px;\n    font-family: sans-serif;\n}\n.tone-talk h3 {\n    font-size: 30px;\n    font-family: sans-serif;\n    color: #303030;\n    margin: 0 0 30px 0;\n    text-transform: uppercase;\n}\n.tone-talk .talkContent {\n    background: #f9f9f9;\n    display: inline-block;\n    width: 100%;\n    border: 1px solid #D0D0D0;\n    padding: 17px 17px 25px;\n    border-radius: 3px;\n}\n.tone-talk .talkContent .userContent {\n      display: inline-block;\n      width: 100%;\n      border: 1px solid #D0D0D0;\n      background: white;\n      padding: 0 18px 15px;\n      border-radius: 3px;\n      margin-bottom: 15px;\n}\n.tone-talk .talkContent .userContent .user {\n        width: 100%;\n        display: inline-block;\n        padding: 30px 0 25px 0;\n        border-bottom: 1px solid #D0D0D0;\n}\n.tone-talk .talkContent .userContent .user:last-of-type {\n          border-bottom: 0;\n}\n.tone-talk .talkContent .userContent .user .image {\n          width: 46px;\n          float: left;\n          text-align: left;\n}\n.tone-talk .talkContent .userContent .user .image img {\n            width: 32px;\n            height: 32px;\n            display: inline-block;\n            border-radius: 50%;\n}\n.tone-talk .talkContent .userContent .user .name {\n          width: 92%;\n          float: left;\n}\n.tone-talk .talkContent .userContent .user .name h6 {\n            margin: 0 0 3px 0;\n            float: left;\n            width: 100%;\n            line-height: 14px;\n            text-transform: capitalize;\n            text-align: left;\n            color: #303030;\n            font-family: sans-serif;\n            letter-spacing: 0.3px;\n}\n.tone-talk .talkContent .userContent .user .name h6 span {\n              float: right;\n}\n.tone-talk .talkContent .userContent .user .name p {\n            margin: 0;\n            font-size: 13px;\n            color: #4A4A4A;\n            line-height: 19px;\n            font-family: sans-serif;\n            float: left;\n            text-align: left;\n            padding: 0 130px 0 0;\n}\n.tone-talk .talkContent .questionContent {\n      display: inline-block;\n      width: 100%;\n      border: 1px solid #D0D0D0;\n      background: white;\n      padding: 28px 18px 33px;\n      border-radius: 3px;\n      position: relative;\n      margin-bottom: 30px;\n}\n.tone-talk .talkContent .questionContent .commentIcon {\n        margin-bottom: 15px;\n}\n.tone-talk .talkContent .questionContent .arrow {\n        position: absolute;\n        bottom: -18px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n}\n.tone-talk .talkContent .questionContent h3 {\n        font-size: 20px;\n        font-family: sans-serif;\n        color: #303030;\n        line-height: 31px;\n        margin: 0;\n        padding: 0 80px;\n        text-transform: inherit;\n}\n.tone-talk .talkContent .talkButton button {\n      background: #44BDA8;\n      color: white;\n      font-size: 16px;\n      font-family: sans-serif;\n      letter-spacing: 0.3px;\n      padding: 18px 80px 16px;\n      border-radius: 3px;\n      outline: none;\n      border: 1px solid transparent;\n      transition: all 0.1s ease;\n}\n.tone-talk .talkContent .talkButton button:hover {\n        color: #44BDA8;\n        background: white;\n        border: 1px solid #44BDA8;\n        box-shadow: 0 0 2px 0 #44BDA8;\n        transition: all 0.1s ease;\n}\n.tone-talk .talkContent .talkButton button:active {\n        box-shadow: 0 0 0 0 #44BDA8;\n        transform: translateY(2px);\n}\n.tone-talk .moderatorContent {\n    width: 100%;\n    display: inline-block;\n    padding: 6px 0 0 0;\n}\n.tone-talk .moderatorContent .userImg {\n      width: 160px;\n      height: 160px;\n      display: block;\n      margin: 0 auto 15px;\n      border-radius: 50%;\n}\n.tone-talk .moderatorContent h4 {\n      margin: 0 0 8px 0;\n      color: #303030;\n      font-family: sans-serif;\n      font-size: 20px;\n}\n.tone-talk .moderatorContent h5 {\n      color: #303030;\n      font-family: sans-serif;\n      margin: 0 0 30px 0;\n}\n.tone-talk .moderatorContent p {\n      margin: 0 0 40px 0;\n      font-size: 16px;\n      line-height: 27px;\n      color: #5E5E5E;\n      font-family: sans-serif;\n      padding: 0 90px;\n}\n.tone-talk .moderatorContent h3 {\n      font-size: 30px;\n      font-family: sans-serif;\n      color: #303030;\n      margin: 0 0 35px 0;\n      text-transform: uppercase;\n}\n.tone-talk .moderatorContent .attendeesImg {\n      width: 100%;\n      display: inline-block;\n}\n.tone-talk .moderatorContent .attendeesImg .userImage {\n        width: 24%;\n        display: inline-block;\n        margin: 0 0 25px 0;\n}\n.tone-talk .moderatorContent .attendeesImg .userImage:first-of-type {\n          margin-left: 15px;\n}\n.tone-talk .moderatorContent .attendeesImg .userImage:nth-of-type(3) {\n          margin-right: 15px;\n}\n.tone-talk .moderatorContent .attendeesImg .userImage img {\n          width: 86px;\n          height: 86px;\n          display: block;\n          margin: 0 auto 12px;\n          border-radius: 50%;\n}\n.tone-talk .moderatorContent .attendeesImg .userImage span {\n          color: #5E5E5E;\n          font-family: sans-serif;\n          font-size: 14px;\n          text-transform: capitalize;\n}\n@media (min-width: 320px) and (max-width: 327px) {\n.tone-talk .talkContent .userContent .user .name {\n    width: 78% !important;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.tone-talk {\n    padding: 20px 0 50px 0;\n}\n.tone-talk h2 {\n    margin: 0;\n    padding: 0 130px;\n}\n.tone-talk h3 {\n    margin: 50px 0 20px 0;\n}\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.tone-talk {\n    padding: 20px 0 20px 0;\n}\n.tone-talk h2 {\n    margin: 0;\n    padding: 0 15px;\n    font-size: 22px;\n    line-height: 32px;\n}\n.tone-talk h3 {\n    font-size: 24px;\n    margin: 30px 0 20px 0;\n}\n.tone-talk .moderatorContent h5 {\n    margin: 0 0 15px 0;\n}\n.tone-talk .talkContent {\n    padding: 17px 10px 25px;\n}\n.tone-talk .talkContent .userContent {\n    padding: 0 10px 15px;\n}\n.tone-talk .talkContent .userContent .user .name p {\n    padding: 0;\n}\n.tone-talk .talkContent .questionContent h3 {\n    font-size: 18px;\n    padding: 0;\n}\n.tone-talk .talkContent .talkButton button {\n    padding: 18px 40px 16px;\n}\n.tone-talk .moderatorContent p {\n    padding: 0;\n}\n.tone-talk .moderatorContent .attendeesImg .userImage {\n    width: 49%;\n}\n.tone-talk .moderatorContent .attendeesImg .userImage:first-of-type {\n    margin-left: 0;\n}\n.tone-talk .moderatorContent .attendeesImg .userImage:nth-of-type(3) {\n    margin-right: 0;\n}\n.tone-talk .talkContent .userContent .user .name {\n    width: 79%;\n}\n.tone-talk .talkContent .userContent .user .name h6 span {\n    margin-top: -10px;\n}\n}\n.feed-back-page-wrapper .form label {\n  padding-left: 28px !important;\n  text-align: left;\n  display: block;\n  margin: 0 auto 10px;\n}\n.feed-back-page-wrapper .form label .icon {\n    top: 0 !important;\n    width: 1.8rem !important;\n    height: 1.8rem !important;\n}\n.feed-back-page-wrapper .main-content p {\n  margin: 5px 0 20px;\n  font-size: 16px;\n}\n.feed-back-page-wrapper .star-rating {\n  margin: 20px 0 5px 0;\n}\n.feed-back-page-wrapper .star-rating .star svg {\n    margin: 0 5px 0 0;\n}\n.feed-back-page-wrapper .star-rating .rating-text {\n    margin-top: 0;\n    margin-left: 10px;\n    font-size: 18px;\n    font-weight: 600;\n}\n.feed-back-page-wrapper .formButton {\n  color: #f0617d;\n  border: 1px solid #f0617d;\n  outline: none;\n  font-size: 16px;\n  font-family: sans-serif;\n  margin: 5px 0 20px 0;\n  padding: 12px 40px 8px 40px;\n}\n.feed-back-page-wrapper .formButton:focus {\n    outline: none;\n}\n.feed-back-page-wrapper .formButton:hover {\n    box-shadow: 0 0 2px 0 #f0617d;\n}\n.feed-back-page-wrapper .formButton:active {\n    box-shadow: 0 0 0 0 #f0617d;\n    transform: translateY(2px);\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.feed-back-page-wrapper .star-rating {\n    margin: 12px 0 10px 0;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.feed-back-page-wrapper .star-rating {\n    margin: 20px 0 15px 0;\n}\n.feed-back-page-wrapper .main-content p {\n    margin: 5px 0 30px;\n}\n}\n.validate-content {\n  padding-bottom: 20px;\n}\n.validate-content h1 {\n    font-family: sans-serif;\n    margin: 40px 0 15px 0;\n    letter-spacing: 0.5px;\n    color: #303030;\n}\n.validate-content p {\n    font-size: 18px;\n    font-family: sans-serif;\n    letter-spacing: 0.5px;\n    color: #303030;\n    margin: 0 0 30px 0;\n}\n.validate-content .form form .validateField {\n    width: 45%;\n    margin: 0 auto;\n    display: block;\n}\n.validate-content .form form .validateField .has-feedback {\n      margin-bottom: 20px;\n}\n.validate-content .form form .validateField .has-feedback .form-control {\n        padding: 0 30px 0 15px;\n        height: 60px;\n}\n.validate-content .form form .validateField .form-control-feedback {\n      top: 15px;\n}\n.validate-content .form form .formButton {\n    margin: 0 0 20px 0;\n    padding: 4px 0 0 0;\n    width: 200px;\n    height: 60px;\n    font-size: 18px;\n    color: #f0617d;\n    border-color: #f0617d;\n    outline: none;\n}\n.validate-content .form form .formButton:hover {\n      background: white;\n      transition: inherit;\n      box-shadow: 0 0 2px 0 #f0617d;\n}\n.validate-content .form form .formButton:active {\n      box-shadow: 0 0 0 0 #f0617d;\n      transform: translateY(2px);\n      transition: inherit;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.validate-content h1 {\n    font-size: 25px;\n}\n.validate-content p {\n    font-size: 16px;\n}\n.validate-content .form form .validateField {\n    width: 100%;\n}\n.validate-content {\n    padding: 0 15px 20px 15px;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.validate-content .form form .validateField {\n    width: 70%;\n}\n}\n.contact-us-form h2 {\n  font-family: sans-serif;\n  margin: 40px 0 15px 0;\n  letter-spacing: 0.5px;\n  color: #303030;\n}\n.contact-us-form p {\n  font-size: 18px;\n  font-family: sans-serif;\n  letter-spacing: 0.5px;\n  color: #303030;\n  margin: 0 0 30px 0;\n}\n.contact-us-form .contact-form {\n  width: 52%;\n  display: block;\n  margin: 0 auto;\n}\n.contact-us-form .contact-form .form form .form-group {\n    margin-bottom: 20px;\n    display: -ms-inline-grid;\n    display: inline-grid;\n    width: 100%;\n}\n.contact-us-form .contact-form .form form .form-group .form-control {\n      padding: 0 30px 0 15px;\n      height: 60px;\n}\n.contact-us-form .contact-form .form form .form-group textarea {\n      height: 100px !important;\n      padding-top: 15px !important;\n}\n.contact-us-form .contact-form .form form .form-group .form-control-feedback {\n      top: 15px;\n}\n.contact-us-form .contact-form .form form .form-group .help-block {\n      margin-bottom: 0;\n}\n.contact-us-form .contact-form .form .formButton {\n    margin: 0 0 20px 0;\n    padding: 4px 0 0 0;\n    width: 200px;\n    height: 60px;\n    font-size: 18px;\n    color: #f0617d;\n    border-color: #f0617d;\n    outline: none;\n}\n.contact-us-form .contact-form .form .formButton:hover {\n      background: white;\n      transition: inherit;\n      box-shadow: 0 0 2px 0 #f0617d;\n}\n.contact-us-form .contact-form .form .formButton:active {\n      box-shadow: 0 0 0 0 #f0617d;\n      transform: translateY(2px);\n      transition: inherit;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n.contact-us-form .contact-form {\n    width: 100%;\n    padding: 0 15px;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.contact-us-form .contact-form {\n    width: 70%;\n}\n}\n\n/*for vertical slide*/\n.scroll-fade-enter-active {\n  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);\n}\n.scroll-fade-leave-active {\n  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);\n}\n.scroll-fade-enter, .scroll-fade-leave-to {\n  transform: translateY(10px);\n  opacity: 0;\n}\n\n/*for horizontal slide*/\n.slide-fade-enter-active {\n  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);\n}\n.slide-fade-leave-active {\n  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);\n}\n.slide-fade-enter, .slide-fade-leave-to {\n  transform: translateX(10px);\n  opacity: 0;\n}\n", ""]);

// exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*.modal {*/\n/*    z-index: 999999;*/\n/*}*/\n.min-body-height{min-height: calc(100vh - 557px);\n}\n.unauth-header a.giftslink {\n    display: none;\n}\n.unauth-header .notificationtext {\n    display: none;\n}\n.unauth-header header .logo {\n    height: auto;\n    margin: 0px;\n    padding: 15px;\n    width: auto;\n    float: left;\n}\n.unauth-header header .nav-container {\n    background: transparent;\n    width: 85%;\n}\n.unauth-header li.mid-icons.sign-up-button {\n    display: none;\n}\n.unauth-header div#header-navbar {\n}\n.unauth-header .nav-container {\n    display: inline-block;\n}\n.unauth-header header .nav-container .container {\n    width: 100%;\n}\n.unauth-header header .logo img {\n    height: 62px;\n}\n.unauth-header header .nav-container .navbar .margin-left li a p {\n    color: #fff;\n}\n.unauth-header header .nav-container .navbar .margin-left li a i {\n    color: #fff !important;\n    /*filter: brightness(100);*/\n}\n.unauth-header header .nav-container .navbar .margin-left li a img.aboutimg {\n    display: none;\n}\n.unauth-header header .nav-container .navbar .margin-left li a img.aboutuswhite {\n    display: inline;\n    max-width: 30px;\n    position: relative;\n    top: -2px;\n}\n.unauth-header header .nav-container #header-navbar .navbar-right .login-btn a {\n    color: #fff;\n    font-size: 21px;\n    height: auto;\n    line-height: 1.3;\n}\n.unauth-header header .nav-container #header-navbar .navbar-right li.mid-icons a i {\n    color: #fff;\n    /*filter: brightness(100);*/\n    padding: 10px;\n}\n.unauth-header .nav > li > a:hover, .nav > li > a:focus {\n    background: rgba(0,0,0,0.1);\n}\n@media(min-width:1200px) and (max-width:1280px){\nheader .nav-container a {\n        padding: 23px 4px 12px 4px;\n}\n}\n@media(min-width:981px) and (max-width:1300px){\nbody .unauth-header header .nav-container {\n        width: calc(100% - 185px);\n}\n}\n@media(max-width:1030px) and (min-width:981px) {\nheader .nav-container #header-navbar .navbar-right .login-btn a {\n        padding: 8px 5px !important;\n}\nbody header .nav-container #header-navbar .navbar-right li.mid-icons {\n        margin: 0 3px;\n}\n}\n@media(min-width:768px) and (max-width:980px){\nbody .unauth-header header .nav-container {\n        width: calc(100% - 130px);\n}\n.unauth-header header .logo img{\n        width:100px;\n}\nbody header .nav-container #header-navbar .navbar-right .login-btn a {\n        padding: 8px 2px !important;\n}\n}\n@media(max-width:767px){\n.unauth-header header .nav-container {\n        margin: auto;\n        display: block;\n        width: auto;\n}\n.unauth-header header .nav-container .navbar svg {\n        width: auto;\n        margin: 0;\n        display: block;\n        float: left;\n        position: static;\n}\n.unauth-header header .nav-container .mobile-loginLogoutholder a.btn.btn-link {\n        line-height: 1.3;\n        font-size: 21px;\n        padding: 10px;\n        border: 1px solid #fff;\n        border-radius: 5px;\n        float: right;\n        margin: 2px 10px;\n}\n.unauth-header header .nav-container .mobile-loginLogoutholder {\n        position: static;\n}\n.unauth-header header .nav-container nav.navbar.default-min-height {\n        min-height: 73px !important;\n}\n.unauth-header header .nav-container #header-navbar .navbar-left li {\n        background: #fff;\n}\n.unauth-header header .nav-container #header-navbar .navbar-left li a p {\n        color: #000;\n}\n.unauth-header header .nav-container #header-navbar .navbar-left li a i ,\n    .unauth-header header .nav-container #header-navbar .navbar-left li a i:before{\n        color: #777 !important;\n        filter: brightness(1) !important;\n}\n.unauth-header header .nav-container #header-navbar .navbar-left li a {\n        margin: 0 70px;\n}\n.unauth-header header .nav-container .navbar .margin-left li a img.aboutuswhite {display: none;\n}\n.unauth-header header .nav-container .navbar .margin-left li a img.aboutimg {\n        display: inline-block;\n}\n.unauth-header header .nav-container #header-navbar .navbar-left li a.router-link-active:before{\n        background: transparent !important;\n}\n.unauth-header header .nav-container #header-navbar .margin-minimum{display:none !important\n}\ndiv.tabContent {\n        padding: 0 15px;\n}\n}\n@media (max-width:374px){\n.unauth-header header .nav-container .navbar svg {\n        width: 110px;\n}\n.unauth-header header .nav-container .mobile-loginLogoutholder a.btn.btn-link {\n        padding: 8px 5px;\n        margin: 0;\n}\n}\n.bodyfont-unauth,\n.bodyfont-unauth p,\n.bodyfont-unauth ul,\n.bodyfont-unauth li,\n.bodyfont-unauth a,\n.bodyfont-unauth div,\n.bodyfont-unauth h1,\n.bodyfont-unauth h2,\n.bodyfont-unauth h3,\n.bodyfont-unauth h4,\n.bodyfont-unauth h5,\n.bodyfont-unauth h6 {\n    font-family: 'Zilla Slab', serif !important;\n}\n.bodyfont-unauth a,\n.bodyfont-unauth button,\n.bodyfont-unauth submit {\n    font-family: 'Montserrat', sans-serif !important;\n}\n.bodyfont-unauth h1 a,\n.bodyfont-unauth h2 a,\n.bodyfont-unauth h3 a,\n.bodyfont-unauth h4 a,\n.bodyfont-unauth h5 a,\n.bodyfont-unauth h6 a {\n    font-family: 'Zilla Slab', serif !important;\n}\n\n\n\n", ""]);

// exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\nspan.heading[data-v-593730aa] {\n        position: relative;\n        width: 100%;\n        display: block;\n        font-size: 19px;\n        font-weight: 500;\n        color: #a9a9a9;\n}\n.checkboxholder .radio[data-v-593730aa] {\n        text-align: center;\n        border: 1px solid #ddd;\n        padding: 10px;\n}\n.checkboxholder[data-v-593730aa] {\n}\n.checkboxholder .radio label[data-v-593730aa] {\n        padding: 0;\n        letter-spacing: 0;\n}\n.checkboxholder .radio label span[data-v-593730aa] {\n        display: block;\n}\n.checkboxholder .radio label input[data-v-593730aa] {\n        position: relative;\n        margin: 20px 0;\n}\nspan.footertext[data-v-593730aa] {\n        font-weight: 500;\n        color: #a9a9a9;\n}\nspan.plan-price[data-v-593730aa] {\n        font-size: 34px;\n        font-weight: 900;\n        color: #a9a9a9;\n}\n.radio.popular[data-v-593730aa]:before {\n        content: \"Most Popular Deal\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        line-height: 1.3;\n        background: #f0617d;\n        color: #fff;\n        transform: translatey(-100%);\n        margin-top: -10px;\n        padding: 5px 0;\n}\n.checkboxholder[data-v-593730aa] {\n        padding-top: 30px;\n}\nspan.permonth[data-v-593730aa] {\n        display: block;\n        font-size: 14px;\n}\nspan.plan-price[data-v-593730aa] {\n        line-height: 1.2;\n        padding-top: 20px;\n}\n@media(max-width:767px){\n.radio.popular[data-v-3a43d266][data-v-593730aa]:before {\n            position: absolute;\n            transform: translateY(-20px);\n}\n.radio.popular[data-v-593730aa] {\n            padding-top: 30px !important;\n}\n}\n.StripeElement[data-v-593730aa] {\n        background-color: white;\n        padding: 2em 1em;\n        border: 1px solid #ccc;\n        box-shadow: 0 1px 3px 0 #e6ebf1;\n        transition: box-shadow 150ms ease;\n        height: 34px;\n}\n.float-right.paymentswitch.btn-group[data-v-593730aa] {\n        margin: 0 0 30px;\n}\n.StripeElement--focus[data-v-593730aa] {\n        box-shadow: 0 1px 3px 0 #cfd7df;\n}\n.StripeElement--invalid[data-v-593730aa] {\n        border-color: #fa755a;\n}\n.StripeElement--webkit-autofill[data-v-593730aa] {\n        background-color: #fefde5 !important;\n}\n.radiowrapper[data-v-593730aa] {\n        padding: 0 0px 10px;\n        color: #f0617d;\n}\ndiv#paypal-button[data-v-593730aa] {\n    text-align: center;\n}\n.codediv[data-v-593730aa] {\n    padding: 10px 0 0;\n}\n.codediv + .row.code[data-v-593730aa] {\n    padding-top: 0;\n}\n@media(min-width:768px) {\n.row.code + label.terms-and-condition[data-v-593730aa] {\n        margin: 0;\n}\n}\n.stripeholder[data-v-593730aa] {\n}\n.codediv .stripeholder[data-v-593730aa] {\n    margin-bottom: 20px;\n}\n.codediv .col-md-12[data-v-593730aa] {\n    min-height: 0;\n}\n.showmobile[data-v-593730aa]{\n        display:none;\n}\n.stripeholder[data-v-593730aa] {\n        position: relative;\n}\ni.fa.fa-lock.overlapstripe[data-v-593730aa] {\n        position: absolute;\n        left: 18px;\n        top: 10px;\n        font-size: 18px;\n        color: #b2b8c7;\n}\nbutton.redeem.btn.formButton.btn-block[data-v-593730aa] {\n        margin: 0;\n}\n.row.code[data-v-593730aa] {\n        padding-top: 20px;\n}\n@media (max-width:767px){\n.hidemobile[data-v-593730aa]{\n            display:none;\n}\n.showmobile[data-v-593730aa]{\n            display:inherit;\n}\n.signUp .left-content h4[data-v-593730aa] {\n            font-size: 14px;\n            letter-spacing: 0px;\n}\n.signUp .main-content h2[data-v-593730aa] {\n            margin: 15px 0;\n            line-height: 20px;\n            font-size: 18px;\n}\n.signUp #signup_pwderrormsg[data-v-593730aa] {\n            margin-bottom: 8px;\n            line-height: 1.3;\n            letter-spacing: 1px;\n}\n.signUp .left-content .create-account #signup_button[data-v-593730aa] {\n            margin: 0;\n}\n.signUp .right-content .jumbotron[data-v-593730aa] {\n            padding: 6px;\n            margin-top: 7px;\n}\n.signUp .right-content .jumbotron h2[data-v-593730aa] {\n            margin: 0;\n            font-size: 21px;\n}\n.signUp .right-content .jumbotron p[data-v-593730aa] {\n            display: none;\n}\n.signUp .right-content .card[data-v-593730aa] {\n            padding: 10px 10px;\n}\n.signUp .right-content .card .card-block .list-group li[data-v-593730aa] {\n            font-size: 16px;\n            margin: 0 0 10px;\n}\n.signUp .left-content hr[data-v-593730aa] {\n            display: none;\n}\n.row.margin-top[data-v-593730aa] {\n            margin-top: 0px;\n}\ndiv#paypal-button[data-v-593730aa] {\n\t\t\ttext-align: center!important;\n\t\t\ttop: -3px;\n}\n.codediv .stripeholder[data-v-593730aa] {\n            margin-bottom: 10px;\n}\n}\n\n    /* Media query for mobile viewport */\n@media screen and (max-width: 400px) {\n#paypal-button-container[data-v-593730aa] {\n            width: 100%;\n}\n}\n\n    /* Media query for desktop viewport */\n@media screen and (min-width: 400px) {\n#paypal-button-container[data-v-593730aa] {\n            width: 250px;\n            display: inline-block;\n}\n}\nbutton.redeem.btn.formButton.btn-block[data-v-593730aa] {\n        letter-spacing: 0;\n}\n.checkboxholder[data-v-593730aa] {\n        padding-left: 30px;\n        padding-bottom: 10px;\n}\n.checkboxholder .checkbox[data-v-593730aa] {\n        font-size: 16px;\n        letter-spacing: 3px;\n        margin: 15px 0;\n}\n.redoutlinebox[data-v-593730aa] {\n        border: 2px solid #f0617d;\n        padding: 10px;\n        margin: 0px 0px 20px;\n        text-align: justify;\n}\n.checkboxholder .radio input[type=\"radio\"][data-v-593730aa] {\n        opacity:1;\n        z-index:20;\n        top: 2px;\n}\nbody .margin-top[data-v-593730aa] {\n        margin-top: 89px;\n        margin-bottom: 70px;\n}\nbody .signUp .right-content .card .card-block .list-group[data-v-593730aa]{\n        margin-bottom:0px;\n}\n", ""]);

// exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*.interestlist .interestButtonList .checkbox-btn:hover{*/\n/*    !*background: #fff !important;*!*/\n/*    !*color: #f0617d !important;*!*/\n/*}*/\n/*.interestlist .interestButtonList .checkbox-btn.active:hover {*/\n/*    !*background: #f0617d !important;*!*/\n/*    !*color: #fff !important;*!*/\n/*}*/\n", ""]);

// exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\nform.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn[data-v-5a54a012] {\n    padding: 5px 0 10px;\n    margin: 5px 0;\n    background: #ffffff;\n    color: #f0617d;\n    width: 49.5% !important;\n    line-height: 1.3;\n}\nform.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn-days[data-v-5a54a012] {\n    padding: 5px 0 10px;\n    margin: 5px 0;\n    background: #ffffff;\n    color: #f0617d;\n    width: 38.5% !important;\n    line-height: 1.3;\n}\nbutton.min-padding.checkbox-btn.active[data-v-5a54a012] {\n    background: #f0617d !important;\n}\n@media(max-width:767px){\nform.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn[data-v-5a54a012] {\n        width: 100% !important;\n}\n.interestlist .submit-btn .btn[data-v-5a54a012] {\n        width: 100%;\n}\n}\n@media(max-width:767px){\nform.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn-days[data-v-5a54a012] {\n        width: 100% !important;\n}\n.interestlist .submit-btn .btn[data-v-5a54a012] {\n        width: 100%;\n}\n}\n.interestlist[data-v-5a54a012] {\n    clear: both;\n}\n.interestlist .interest-container[data-v-5a54a012] {\n    width: 100%;\n}\n.headerlevel2 h2[data-v-5a54a012] {\n    color: #0D0D0D;\n    font-weight: 900;\n    margin: 20px 0 20px 0;  /* top right bottom left */\n}\n.headerlevel3 h3[data-v-5a54a012] {\n    color: #0D0D0D;\n    font-weight: 500;\n    margin: 20px 0 20px 0;  /* top right bottom left */\n}\n", ""]);

// exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.btn-group.plusicon[data-v-5ba2bfc2] {\n    position: absolute;\n    right: 50px;\n    bottom: 0px;\n    height: 29px;\n}\nli.divider[data-v-5ba2bfc2] {\n    border-bottom: 1px solid #ddd;\n    margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-5ba2bfc2] {\n    background: transparent;\n    border: 0 none transparent;\n    padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-5ba2bfc2]{\n    font-size: 21px;\n    top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-5ba2bfc2]{\n    padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-5ba2bfc2],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-5ba2bfc2] {\n    padding: 3px 15px;\n    margin-bottom: 5px;\n    display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-5ba2bfc2],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-5ba2bfc2] {\n    height: 30px;\n    padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-5ba2bfc2],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-5ba2bfc2] {\n    position: absolute;\n    top: 6px;\n    font-size:24px;\n    right:20px;\n    cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-5ba2bfc2],\nbutton.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-5ba2bfc2]{\n    position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-5ba2bfc2],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul[data-v-5ba2bfc2]{\n    left: 0;\n    right: auto;\n    width: 230px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    top: 100%;\n    position: absolute;\n    z-index: 5000;\n    list-style: none;\n    text-align: left;\n    padding: 15px;\n}\n.backdropformenu[data-v-5ba2bfc2]{\n    position:fixed;\n    z-index:4900;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-5ba2bfc2]{\n    height: 24px;\n    width: 37px;\n}\n.menuiconbutton[data-v-5ba2bfc2]{\n    height: 24px;\n    width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-5ba2bfc2] {\n    left: auto ;\n    right: 0;\n}\n.fade-enter-active[data-v-5ba2bfc2], .fade-leave-active[data-v-5ba2bfc2] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-5ba2bfc2], .fade-leave-to[data-v-5ba2bfc2] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-5ba2bfc2]{\n    font-size: 10px;\n}\nspan.removed[data-v-5ba2bfc2] {\n    color: red;\n}\nspan.added[data-v-5ba2bfc2] {\n    color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-5ba2bfc2] {\n    position: relative;\n    display:block;\n}\n", ""]);

// exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n@media(max-width:767px){\n.sharesmallpink.watchVideoModal span.multiselect__tag {\n        white-space: normal;\n        width: 100%;\n}\n}\nform.updateName label.open.checkbox.primary {\n    color: #f0617d;\n    padding-left: 24px;\n    text-align: left;\n}\n.interestlist .checkbox-btn.active:hover {\n    /*background: #f0617d !important;*/\n    /*color: #fff !important;*/\n}\n.interestlist .checkbox-btn:hover {\n    /*background: #fff;*/\n    /*color: #f0617d !important;*/\n}\n.hide + .backdropformenu{display:none;\n}\n", ""]);

// exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#playlistshare-form textarea.form-control {\n    max-height: 100px;\n    min-height: 100px;\n    height: 100px !important;\n    width: 100%;\n    max-width: 100%;\n    min-width: 100%;\n}\n#playlistshare-form button.btn.formButton.btn-block {\n    background: #f0617d;\n    border-radius: 7px;\n    min-width: 0;\n    width: auto;\n    padding: 14px;\n}\n.container.boxescontiner .row.nospace.flexrow > div .pimg {\n    transition: all 1s ease;\n    animation-duration: 0.25s;\n    animation-name: fadein;\n    /*animation-name: rotatein;*/\n    animation-count:1;\n    z-index:100;\n    animation-fill-mode: forwards;\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n}\n.container.boxescontiner .row.nospace.flexrow > div.active .pimg {\n    animation-name: fadeout;\n    animation-count:1;\n    animation-fill-mode: forwards;\n}\n\n", ""]);

// exports


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.profile .tabContent .personalize .personalizeText[data-v-6144c6ea] {\n     padding: 35px 101px 40px !important;\n}\n.accountContentBox .accountRight form .formName.highlight[data-v-6144c6ea] {\n     border: 1px solid #f0617d;\n     padding-left: 10px;\n     padding-right: 10px;\n}\n.pinkh3[data-v-6144c6ea] {\n     color:#f0617d;\n}\n.slider.responsive-slick-imagelist img[data-v-6144c6ea] {\n max-height: 80px;\n -o-object-fit: contain;\n    object-fit: contain;\n -o-object-position: 50% 50%;\n    object-position: 50% 50%;\n}\n.slider.responsive-slick-imagelist p.text-wrap-title[data-v-6144c6ea] {\n font-size: 12px;\n}\n.carousalbutton[data-v-6144c6ea]{\n     float: right;\n     background: #f0617d;\n     border: none;\n     color: white;\n     outline: none;\n     font-size: 14px;\n     width: 100%;\n     padding: 5px 0px 5px;\n     border-radius: 3px;\n}\nbutton.carousalbutton.selected[data-v-6144c6ea] {\n     box-shadow: inset 0px 0px 0px 1px #f0617d;\n     box-sizing: border-box;\n     background: #fff;\n     color: #f0617d;\n}\nform.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn[data-v-6144c6ea] {\n      padding: 5px 0 10px;\n      margin: 5px 0;\n      background: #f0617d;\n      color: #fff;\n      width: 49.5% !important;\n      line-height: 1.3;\n}\nform.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn-days[data-v-6144c6ea] {\n      padding: 5px 0 10px;\n      margin: 5px 0;\n      background: #f0617d;\n      color: #fff;\n      width: 38.5% !important;\n      line-height: 1.3;\n}\n#paypal-button[data-v-6144c6ea] {\n     margin-top: 0;\n     text-align: left;\n}\n.interestlist button.min-padding.checkbox-btn[data-v-6144c6ea] {\n     padding: 5px 0 10px;\n     margin: 5px 0;\n     /*background: #ffffff;*/\n     /*color: #f0617d;*/\n     width: 48.2% !important;\n     line-height: 1.3;\n     margin: 5px 10px;\n     transition:all 1s ease;\n}\n.interestlist button.min-padding.checkbox-btn-days[data-v-6144c6ea] {\n     padding: 5px 0 10px;\n     margin: 5px 0;\n     /*background: #ffffff;*/\n     /*color: #f0617d;*/\n     width: 30.2% !important;\n     line-height: 1.3;\n     margin: 5px 5px;\n     transition:all 1s ease;\n}\n.interestlist button.min-padding.checkbox-btn[data-v-6144c6ea]:hover {\n     /*background: #fff;*/\n     /*color: #f0617d; */\n}\n.radiowrapper[data-v-6144c6ea] {\n     padding: 0 0 20px;\n     color: #f0617d;\n     text-align: left;\n}\nbutton.min-padding.checkbox-btn.active[data-v-6144c6ea] {\n     /*background: #f0617d !important;*/\n}\n.row.notstripes .col-md-12[data-v-6144c6ea] {\n     border: 1px solid #ddd;\n     padding-top: 15px;\n     padding-bottom: 15px;\n     margin-left: 15px;\n     margin-right: 15px;\n     width: auto;\n     float: none;\n     display: block;\n     overflow: hidden;\n}\n.row.notstripes[data-v-6144c6ea] {\n     clear: both;\n}\n.row.notstripes div#paypal-button[data-v-6144c6ea] {\n     text-align: center;\n}\n.row.notstripes h5[data-v-6144c6ea] {\n     padding: 0 0 0px;\n}\n /*#paypal-button {\n     border-top: 1px solid #ddd;\n     margin: 20px 0 0 !important;\n     /* border: 1px solid #ddd; */\n     /* clear: both; */\n /*}*/\ndiv#card-element[data-v-6144c6ea] {\n     margin: 20px 0 20px;\n     border: 1px solid #ddd;\n     padding: 20px 10px;\n}\n.accountContentBox .accountRight form .formName h5.paymentmethodh5[data-v-6144c6ea] {\n     border-bottom: 1px solid #ddd;\n     margin: 0 0 20px;\n     padding: 0 0 10px;\n     font-size: 15px;\n}\n@media(max-width:767px){\nform.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn[data-v-6144c6ea] {\n         width: 100% !important;\n}\nform.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn-days[data-v-6144c6ea] {\n         width: 100% !important;\n}\n.interestlist .submit-btn .btn[data-v-6144c6ea] {\n         width: 100%;\n}\n.interestlist .checkbox-btn[data-v-6144c6ea]:hover {\n         /*background: inherit;*/\n         /*color: inherit;*/\n}\n.interestlist .checkbox-btn.active[data-v-6144c6ea]:hover {\n         /*color: #fff;*/\n         /*background: #f0617d;*/\n}\n.interestlist button.min-padding.checkbox-btn[data-v-6144c6ea] {\n         padding: 5px 0 10px;\n         margin: 5px 0;\n         /*background: #ffffff;*/\n         /*color: #f0617d;*/\n         width: 100% !important;\n         line-height: 1.3;\n         margin: 0px 0px;\n}\n.interestlist button.min-padding.checkbox-btn-days[data-v-6144c6ea] {\n         padding: 5px 0 10px;\n         margin: 5px 0;\n         /*background: #ffffff;*/\n         /*color: #f0617d;*/\n         width: 100% !important;\n         line-height: 1.3;\n         margin: 0px 0px;\n}\n}\n.profile-heading[data-v-6144c6ea] {\n     text-transform: none;\n}\n.profile div#tabs-2.tabContent img[data-v-6144c6ea] {\n     height: auto !important;\n}\n.profile div#tabs-2.tabContent .favnumbers[data-v-6144c6ea] {\n     display: -ms-flexbox;\n     display: flex;\n     -ms-flex-align: center;\n         align-items: center;\n     -ms-flex-pack: distribute;\n         justify-content: space-around;\n     -ms-grid-column-align: stretch;\n         justify-items: stretch;\n     -ms-flex-direction: column;\n         flex-direction: column;\n     font-size: 24px;\n}\n.profile div#tabs-2.tabContent .favnumbers > div > span[data-v-6144c6ea] {\n     padding: 0;\n     line-height: 1;\n     display: inline;\n}\n.profile div#tabs-2.tabContent .favnumbers small[data-v-6144c6ea] {\n     font-size: 12px;\n     display: block;\n}\n.profile div#tabs-2.tabContent .favnumbers > div[data-v-6144c6ea] {\n     line-height: 1;\n}\n.profile div#tabs-2.tabContent .favnumbers i.fa[data-v-6144c6ea] {\n     margin: 0;\n}\ndiv#tabs-2 h3[data-v-6144c6ea] {\n     color: #232323;\n     font-weight:700;\n}\n /*First CSS*/\nbutton.downbutton[data-v-6144c6ea] {\n     position: absolute;\n     bottom: 0;\n     width: 100%;\n     left: 0;\n     right: 0;\n     display: block;\n     text-align: center;\n     background-color: #f0617d;\n     z-index: 100;\n     border: 0 none transparent;\n     padding:10px;\n}\n.pinkputlinepannel[data-v-6144c6ea]{\n     background:#fff;\n}\n.takeawaysholder[data-v-6144c6ea], .pinkputlinepannel[data-v-6144c6ea], .progressbarsholder[data-v-6144c6ea] {\n     position: relative;\n     transition: all 1s ease;\n}\nbutton.downbutton > .fa[data-v-6144c6ea] {\n     display: block;\n     font-size: 30px;\n}\n.progressbarsholder.expand[data-v-6144c6ea] {\n     max-height: 3000px;\n}\n.pinkputlinepannel.expand[data-v-6144c6ea] {\n     max-height: 3000px;\n}\n.takeawaysholder.expand[data-v-6144c6ea] {\n     max-height: 3000px;\n}\n /*Second CSS*/\nbutton.downbutton[data-v-6144c6ea] {\n     position: absolute;\n     bottom: 0;\n     width: 100%;\n     left: 0;\n     right: 0;\n     display: block;\n     text-align: center;\n     background-color: inherit;\n     z-index: 100;\n     border: 0 none transparent;\n     padding:10px;\n}\n.pinkputlinepannel[data-v-6144c6ea]{\n     background:#fff;\n}\n.takeawaysholder [data-v-6144c6ea], .pinkputlinepannel [data-v-6144c6ea], .progressbarsholder[data-v-6144c6ea] {\n     position: relative;\n     transition: all 1s ease;\n}\nbutton.downbutton > .fa[data-v-6144c6ea] {\n     display: block;\n     font-size: 30px;\n}\n.progressbarsholder.expand[data-v-6144c6ea] {\n     max-height: 3000px;\n}\n.pinkputlinepannel.expand[data-v-6144c6ea] {\n     max-height: 3000px;\n}\n.takeawaysholder.expand[data-v-6144c6ea] {\n     max-height: 3000px;\n}\n.progress.mb-3[data-v-6144c6ea] {\n  display: -ms-flexbox;\n  display: flex;\n}\n.progessandstar[data-v-6144c6ea] {\n     display: -ms-flexbox;\n     display: flex;\n}\n.progessandstar > .progress[data-v-6144c6ea] {\n     -ms-flex: 100;\n         flex: 100;\n}\n.progessandstar .fa-star[data-v-6144c6ea] {font-size: 20px !important;margin-left:5px;color:#faea63;transform: rotate(45deg);top: -10px;position: relative;\n}\n /*Third CSS*/\nsir kindly add these additional classes\n\n button.downbutton[data-v-6144c6ea]:focus {\n     outline: 0 none transparent;\n}\n.pinkputlinepannel.expand[data-v-6144c6ea] {\n     padding-bottom: 60px;\n}\n.expand i.fa.fa-chevron-down[data-v-6144c6ea] {transform: rotate(180deg);\n}\n.progressbarsholder.expand[data-v-6144c6ea] {\n     padding-bottom: 60px;\n}\n.takeawaysholder.expand[data-v-6144c6ea] {\n     padding-bottom: 80px;\n}\n/*Commented to display arrows on mobile*/\n /*@media(max-width:768px){*/\n /*    button.downbutton {*/\n /*        display: none !important;*/\n /*    }*/\n\n /*    .pinkputlinepannel {*/\n /*        max-height: none !important;*/\n /*    }*/\n\n /*    .takeawaysholder {*/\n /*        max-height: none !important;*/\n /*    }*/\n\n /*    .progressbarsholder {*/\n /*        max-height: none !important;*/\n /*    }*/\n /*}*/\nbuttton.downbutton[data-v-6144c6ea]:focus{border:0 none transparent;outlinie:0 none transparent;\n}\nbutton.downbutton[data-v-6144c6ea]:focus {\n     outline: 0 none transparent !important;\n}\nbutton.downbutton[data-v-6144c6ea]:active {\n     outline: 0 none transparent !important;\n}\n /*Fourth CSS*/\n.takeawaysholder button.downbutton[data-v-6144c6ea] {\n     background: #f0617d;\n     background-clip: padding-box;\n     border: 10px solid transparent;\n}\n.takeawaysholder button.downbutton[data-v-6144c6ea]:after {\n     position: absolute;\n     display: block;\n     height: 10px;\n     width: auto;\n     content: \"\";\n     bottom: -10px;\n     left: -10px;\n     right: -10px;\n     background: #faa51e;\n}\n\n /*.pinkputlinepannel .fa-chevron-down:before {color: #f0617d;}*/\n.takeawaysholder li[data-v-6144c6ea] {\n     font-weight: 600;\n     text-align: left;\n     white-space: pre-line !important;\n}\n.pinkputlinepannel button[data-v-6144c6ea]{background-color:#fff !important;\n}\n.watcedvideotitle[data-v-6144c6ea] {\n     padding-top: 20px;\n     font-size: 18px;\n     font-weight: 700;\n     color: #f0617d;\n     line-height: 1;\n}\n.watcedvideotitle span[data-v-6144c6ea] {\n     font-size: 150%;\n}\n.pinkputlinepannel h3[data-v-6144c6ea] {\n     margin-top: 0;\n}\n /*fifth CSS*/\nli.mobile-event-star i.fa.fa-star.showmobile[data-v-6144c6ea] {\n     display: none;\n}\n@media(max-width:767px){\nli.mobile-event-star i.fa.fa-star.showmobile[data-v-6144c6ea] {\n         display: inline;\n         color: #faa51e;\n         transform: rotate(45deg);\n         font-size: 13px;\n         margin-right: 10px;\n}\nli.mobile-event-star[data-v-6144c6ea] {\n         list-style: none;\n         padding: 0 !important;\n         margin: 0 !important;\n}\n.pinkputlinepannel:first-of-type ul[data-v-6144c6ea] {\n         margin: 0 !important;\n         padding-left: 0 !important;\n}\n}\n /*Changes for Corporate Modal*/\n.sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader[data-v-6144c6ea] {\n     background: #f0617d;\n     color: #fff;\n     font-size: 25px;\n     text-align: left;\n     padding: 15px 25px;\n     font-weight: 700;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body p[data-v-6144c6ea]{\n     padding: 0;\n     margin: 0 0 20px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-6144c6ea] {\n     background: #fff;\n     color: #333;\n     border: 1px solid #cacaca;\n     width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body[data-v-6144c6ea] {\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink[data-v-6144c6ea] {\n     background: #f0617d;\n     width: 100%;\n     margin: 0;\n     border: 1px solid #f0617d;\n}\n@media(max-width:475px){\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-6144c6ea] {\n         padding-left: 0;\n         padding-right: 0;\n}\n}\n.row.sharefb[data-v-6144c6ea] {\n     background: #eee;\n     margin-left: 0;\n     margin-right: 0;\n}\n.row.sharefb > div[data-v-6144c6ea] {\n     padding: 5px;\n     text-align: left;\n}\n.row.sharefb .col-sm-5 img[data-v-6144c6ea] {\n     max-width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-6144c6ea] {\n     font-size: 14px;\n     font-weight: 300;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6[data-v-6144c6ea] {\n     text-transform: uppercase;\n     font-size: 12px;\n     margin: 10px 0 5px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4[data-v-6144c6ea] {\n     margin: 0 0 5px;\n     font-weight:700;\n}\n.showmobile[data-v-6144c6ea]{display:none;\n}\n@media(max-width:767px){\n.usernamenimg.text-left[data-v-6144c6ea] {\n         display: none;\n}\n.showmobile[data-v-6144c6ea]{\n         display: block;\n}\n.alert.alert-default[data-v-6144c6ea] {\n         background: #eee;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-6144c6ea] {\n         display: none;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow[data-v-6144c6ea] {\n         top: 1px;\n         right: -13px;\n}\n.row.sharefb[data-v-6144c6ea] {\n         display: -ms-flexbox;\n         display: flex;\n         -ms-flex-align: center;\n             align-items: center;\n}\n.pinksidebarmin[data-v-6144c6ea]{\n         padding:0 !important;\n         display: -ms-flexbox;\n         display: flex;\n         -ms-flex-direction: column;\n             flex-direction: column;\n         -ms-flex-preferred-size: auto;\n             flex-basis: auto;\n         display: flex ;\n         -ms-flex-align: stretch ;\n             align-items: stretch ;\n         -ms-flex-pack: center;\n             justify-content: center;\n}\n.pinksidebarmin > *[data-v-6144c6ea] {\n         padding: 6px 0 !important;\n         margin: 0 !important;\n         -ms-flex: 100;\n             flex: 100;\n         text-align:center;\n}\n}\n.interestlist[data-v-6144c6ea] {\n     clear: both;\n}\n.interestlist .interest-container[data-v-6144c6ea] {\n     width: 100%;\n}\n.box-size[data-v-6144c6ea] {\n     height: 10px;\n}\n.mb-4[data-v-6144c6ea] {\n     margin-bottom: 40px;\n}\n\n\n", ""]);

// exports


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.profile .tabContent  .yourFaves div.btn-group[data-v-6144c6ea] {\n     position: absolute;\n     right: 50px;\n     bottom: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-6144c6ea] {\n     background: transparent;\n     border: 0 none transparent;\n     padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-6144c6ea] {\n     font-size: 21px;\n     top: 0;\n}\n.yourFaves div.btn-group[data-v-6144c6ea] {\n     bottom: 5px;\n     height: 29px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-6144c6ea] {\n     padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-6144c6ea],\n button.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-6144c6ea] {\n     padding: 3px 15px;\n     margin-bottom: 5px;\n     display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-6144c6ea],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-6144c6ea] {\n     height: 30px;\n     padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-6144c6ea],\n button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-6144c6ea] {\n     position: absolute;\n     top: 6px;\n     font-size:24px;\n     right:20px;\n     cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-6144c6ea],\n button.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-6144c6ea]{\n     position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-6144c6ea],\n button.dropdown-toggle.ellipsis.pull-right+ ul[data-v-6144c6ea] {\n     left: 0;\n     right: auto;\n     width: 230px;\n     background: #fff;\n     border: 1px solid #ddd;\n     border-radius: 5px;\n     top: 100%;\n     position: absolute;\n     z-index: 5000;\n     list-style: none;\n     text-align: left;\n     padding: 15px;\n}\n.backdropformenu[data-v-6144c6ea]{\n     position:fixed;\n     z-index:4900;\n     top:0;\n     left:0;\n     right:0;\n     bottom:0;\n     background: transparent;\n}\nli.divider[data-v-6144c6ea] {\n     border-bottom: 1px solid #ddd;\n     margin: 5px -15px;\n}\n.favnumbers[data-v-6144c6ea] {\n     position: absolute;\n     top: 0;\n     right: 0;\n     bottom: 0;\n     width: 60px;\n     text-align: center;\n     z-index: 500;\n     color: #fff;\n     background: #f0617d;\n}\n.viderowraper[data-v-6144c6ea] {\n     position: relative;\n}\n.favnumbers span[data-v-6144c6ea] {\n     display: block;\n     padding: 14px 0;\n}\n.favnumbers[data-v-6144c6ea] {\n     font-size: 30px;\n     font-weight: 900;\n}\n@media (max-width: 767px) and (min-width: 320px){\n.profile .tabs-content .tabs ul li[data-v-6144c6ea] {\n         width: AUTO;\n         box-sizing: border-box;\n         margin: 0;\n}\n}\n.profile .tabContent img.menuiconbutton[data-v-6144c6ea] {\n     height: 24px;\n     width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-6144c6ea] {\n     left: auto ;\n     right: 0;\n}\n.fade-enter-active[data-v-6144c6ea], .fade-leave-active[data-v-6144c6ea] {\n     transition: opacity .5s;\n}\n.fade-enter[data-v-6144c6ea], .fade-leave-to[data-v-6144c6ea] /* .fade-leave-active below version 2.1.8 */ {\n     opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-6144c6ea]{\n     font-size: 10px;\n}\nspan.removed[data-v-6144c6ea] {\n     color: red;\n}\nspan.added[data-v-6144c6ea] {\n     color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-6144c6ea] {\n     position: relative;\n     display:block;\n}\n.container.boxescontiner .row.nospace.flexrow:nth-of-type(even) > div[data-v-6144c6ea]:nth-of-type(even) {\n     background: #faa51e;\n}\n.container.boxescontiner .row.nospace.flexrow:nth-of-type(odd) > div[data-v-6144c6ea]:nth-of-type(odd) {\n     background: #faa51e;\n}\n.container.boxescontiner .row.nospace.flexrow:nth-of-type(odd) > div[data-v-6144c6ea]:nth-of-type(even) {\n     background: #f0617d;\n}\n.container.boxescontiner .row.nospace.flexrow:nth-of-type(even) > div[data-v-6144c6ea]:nth-of-type(odd) {\n     background: #f0617d;\n}\n.col-sm-4[data-v-6144c6ea] {\n}\n.container.boxescontiner .row.nospace.flexrow > div[data-v-6144c6ea] {\n     padding: 15px;\n     -ms-flex-align: center;\n         align-items: center;\n     display: -ms-flexbox;\n     display: flex;\n     -ms-flex-direction: column;\n         flex-direction: column;\n}\nhtml[data-v-6144c6ea] {\n}\n.container.boxescontiner .row.nospace.flexrow[data-v-6144c6ea] {\n     display: -ms-flexbox;\n     display: flex;\n}\n.container.boxescontiner .row.nospace.flexrow > div img[data-v-6144c6ea] {\n     height: auto;\n     width: auto;\n}\n.container.boxescontiner .row.nospace.flexrow > div p[data-v-6144c6ea] {\n     text-align: center;\n     color: #fff;\n     font-size: 14px;\n     font-weight: 700;\n}\n.container.boxescontiner .row.nospace.flexrow > div p.descriptionservices[data-v-6144c6ea] {\n     text-overflow: unset;\n     white-space: normal;\n     font-size: 19px;\n     text-align: left;\n}\n.container.boxescontiner .row.nospace.flexrow > div p.descriptionservices[data-v-6144c6ea] {\n     /*transform:rotateY(0.25turn);*/\n     animation-duration: 0.25s;\n     animation-name: fadeout;\n     animation-count:1;\n     animation-fill-mode: forwards;\n     position: absolute;\n     -webkit-backface-visibility: hidden;\n             backface-visibility: hidden;\n     top:15px;\n     left:0;\n}\n.container.boxescontiner .row.nospace.flexrow > div.active p.descriptionservices[data-v-6144c6ea] {\n\n     animation-duration: 0.25s;\n     animation-name: fadein;\n     animation-count:1;\n     animation-fill-mode: forwards;\n}\n.container.boxescontiner .row.nospace.flexrow > div p.descriptionservices[data-v-6144c6ea] {\n     margin: 0px 0;\n     padding: 0 20px;\n}\nimg.bagimage[data-v-6144c6ea] {\n     position: absolute;\n     left: 0;\n     right: 0;\n     height: 100%!important;\n     width: 100% !important;\n     top: 0;\n     display: block;\n     bottom: 0;\n     -o-object-fit: cover;\n        object-fit: cover;\n     -o-object-position: center;\n        object-position: center;\n}\n.container.boxescontiner .row.nospace.flexrow > div[data-v-6144c6ea] {\n     position: relative;\n}\n.modal[data-v-6144c6ea] {\n     z-index: 5000;\n}\n /*.swal2-modal.swal2-show {*/\n     /*z-index: 5110;*/\n /*}*/\n@keyframes rotateout {\n0%   {\n         transform:rotateY(0deg) ;\n}\n100% {\n         transform:rotateY(180deg) ;\n}\n}\n@keyframes rotatein {\n0%   {\n         transform:rotateY(-180deg);\n}\n100% {\n         transform:rotateY(0deg) ;\n}\n}\n@keyframes fadeout {\n0%   {\n         opacity:1\n}\n100% {\n         opacity:0\n}\n}\n@keyframes fadein {\n0%   {\n         opacity:0;\n}\n100% {\n         opacity:1 ;\n}\n}\n@media(max-width:767px){\n.container.boxescontiner .row.nospace.flexrow[data-v-6144c6ea] {\n         display: block !important;\n}\n}\n.container.boxescontiner[data-v-6144c6ea] {\n     padding-bottom: 50px;\n}\n@media(max-width:450px){\n.pimg[data-v-6144c6ea] {\n         padding: 25px;\n}\n.container.boxescontiner .row.nospace.flexrow > div.active p.descriptionservices[data-v-6144c6ea] {\n         font-size: 17px;\n}\n}\n@media(max-width:350px){\n.pimg[data-v-6144c6ea] {\n         padding: 40px;\n}\n.container.boxescontiner .row.nospace.flexrow > div.active p.descriptionservices[data-v-6144c6ea] {\n         font-size: 17px;\n}\n}\n@media(min-width:768px) and (max-width:991px) {\n.container.boxescontiner .row.nospace.flexrow > div p.descriptionservices[data-v-6144c6ea] {\n         font-size: 15px !important;\n}\n.container.boxescontiner .row.nospace.flexrow > div .pimg[data-v-6144c6ea] {\n         padding: 10px;\n}\n}\n@media(min-width:992px) and (max-width:1200px) {\n.container.boxescontiner .row.nospace.flexrow > div .pimg[data-v-6144c6ea] {\n         padding: 20px;\n}\n}\n.favnumbers .fa[data-v-6144c6ea] {\n     display: block;\n     margin: 0px 0 15px;\n}\n@media(min-width:1025px){\n.favnumbers .fa[data-v-6144c6ea]{\n         display:none;\n}\n.favnumbers .fa[data-v-6144c6ea]:hover{\n         cursor:pointer;\n}\n.viderowraper:hover .favnumbers .fa[data-v-6144c6ea]{\n         display:block;\n}\n}\n@media(max-width: 1024px){\n.favnumbers .fa[data-v-6144c6ea] {\n         font-size: 22px;\n}\n.favnumbers span[data-v-6144c6ea] {\n         font-size: 20px;\n         padding: 10px 0 !important;\n         margin: 0 !important;\n}\n}\n/* !**!CSS Classes for Progress Tab*/\n.progressbarsholder[data-v-6144c6ea] {\n     background: #f0617d !important;\n     padding: 20px;\n     color: #fff;\n     text-align: left;\n     max-height: 410px;\n     min-height: 410px;\n     overflow: hidden;\n}\n.progressbarsholder .progress-bar[data-v-6144c6ea] {\n     background-color: #adc736;\n}\n.progressbarsholder h3[data-v-6144c6ea] {\n     font-weight: bold;\n     font-size: 23px;\n}\n.takeawaysholder[data-v-6144c6ea] {\n     background: #faa51e;\n     padding: 20px;\n     color: #fff;\n     max-height: 410px;\n     min-height: 410px;\n     text-align: center;\n     overflow: hidden;\n}\n.takeawaysholder h3[data-v-6144c6ea] {\n     font-weight: bold;\n     font-size: 23px;\n}\n.takeawaysholder ul[data-v-6144c6ea] {\n     margin: 0;\n     padding: 0;\n     list-style-position: inside;\n}\n.pinkputlinepannel[data-v-6144c6ea] {\n     border: 5px solid #f0617d;\n     padding: 15px;\n     max-height: 190px;\n     min-height: 190px;\n     overflow: hidden;\n}\n.pinkputlinepannel ul[data-v-6144c6ea] {\n     /*list-style: none;*/\n     /*cursor: pointer;*/\n     text-align: left;\n     padding: 25px;\n     margin: 0;\n}\n.pinkputlinepannel h3[data-v-6144c6ea] {\n     font-size: 21px;\n     font-weight: 900;\n     color: #f0617d;\n}\n.pinkputlinepannel + .pinkputlinepannel[data-v-6144c6ea] {\n     margin-top: 30px;\n}\n.a.btn-group[data-v-6144c6ea] {\n     margin: 0px;\n}\n.headerlevel2 h2[data-v-6144c6ea] {\n     color: #0D0D0D;\n     font-weight: 900;\n     margin: 20px 0 20px 0;  /* top right bottom left */\n}\n.headerlevel3 h3[data-v-6144c6ea] {\n     color: #0D0D0D;\n     font-weight: 500;\n     margin: 0px 0 0px 0;  /* top right bottom left */\n}\n", ""]);

// exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.stripeholder[data-v-6374f53f] {\n    position: relative;\n}\ni.fa.fa-lock.overlapstripe[data-v-6374f53f] {\n    position: absolute;\n    left: 18px;\n    top: 10px;\n    font-size: 18px;\n    color: #b2b8c7;\n}\n.codediv[data-v-6374f53f] {\n    padding: 10px 0 0;\n}\n.codediv + .row.code[data-v-6374f53f] {\n    padding-top: 0;\n}\n.stripeholder[data-v-6374f53f] {\n}\n.codediv .stripeholder[data-v-6374f53f] {\n    margin-bottom: 20px;\n}\n.codediv .col-md-12[data-v-6374f53f] {\n    min-height: 0;\n}\n.StripeElement[data-v-6374f53f] {\n    background-color: white;\n    padding: 2em 1em;\n    border: 1px solid #ccc;\n    box-shadow: 0 1px 3px 0 #e6ebf1;\n    transition: box-shadow 150ms ease;\n    height: 34px;\n}\n.float-right.paymentswitch.btn-group[data-v-6374f53f] {\n    margin: 0 0 30px;\n}\n.StripeElement--focus[data-v-6374f53f] {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n}\n.StripeElement--invalid[data-v-6374f53f] {\n    border-color: #fa755a;\n}\n.StripeElement--webkit-autofill[data-v-6374f53f] {\n    background-color: #fefde5 !important;\n}\n.radiowrapper[data-v-6374f53f] {\n    padding: 0px;\n    color: #f0617d;\n}\n/* Media query for mobile viewport*/\n@media screen and (max-width: 400px) {\n#paypal-button-container[data-v-6374f53f] {\n        width: 100%;\n}\n}\n\n/*Media query for desktop viewport */\n@media screen and (min-width: 400px) {\n#paypal-button-container[data-v-6374f53f] {\n        width: 250px;\n        display: inline-block;\n}\n}\ntable[data-v-6374f53f] {\n    font-size: 12px;\n    letter-spacing: 0;\n    width:100%;\n}\ntable td[data-v-6374f53f] {\n    text-align: left;\n    padding: 12px;\n}\ntable th[data-v-6374f53f] {\n    text-align: left;\n    padding: 12px;\n    background: #f0617d;\n    color:#fff;\n}\nh2[data-v-6374f53f] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 45px 0 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n    text-align:center;\n}\ntr[data-v-6374f53f] {\n    border-bottom: 1px solid #ddd;\n}\nli.list-group-item[data-v-6374f53f] {\n    float: left;\n    width: 48%;\n    padding: 5px;\n    margin: 40px 1% 30px;\n    background-size: 100px !important;\n    border-radius: 0 !important;\n    height: auto;\n    background-color: #f9f9f9;\n    padding-top: 60px;\n}\nli.list-group-item[data-v-6374f53f]:before {\n    background-image: url(" + __webpack_require__(336) + ") !important;\n    float: left;\n    width: 100%;\n    padding: 2%;\n    background-size: contain !important;\n    border-radius: 0 !important;\n    background-color: transparent;\n    background-repeat: no-repeat;\n    background-position: center top;\n    border: 0 none transparent;\n    content: \"\";\n    position: absolute;\n    top: -43px;\n    height: 100px;\n}\nli h5[data-v-6374f53f] {letter-spacing: 1px;text-align: center;\n}\n.row.margin-top[data-v-6374f53f] {\n    margin-bottom: 80px;\n}\n.signUp .right-content .jumbotron[data-v-6374f53f] {\n    padding: 10px;\n}\n.signUp .left-content .panel-body .form-group[data-v-6374f53f] {\n    margin-bottom: 10px;\n}\n\n/*gift section classes*/\n.gift-item[data-v-6374f53f]:before {\n    background: url(" + __webpack_require__(76) + ");\n    content:\"\";\n    height: 150px;\n    display: block;\nposition: absolute;\n    background-position: center !important;\n    background-repeat: no-repeat !important;\n    transform: translateY(-50%);\ntop: 0;\n    right: 0;\n    left: 0;\n}\n.gift-item[data-v-6374f53f] {\n    background: #54d9ec;\n    color: #fff;\n    margin: 120px 0 0;\n    padding: 80px 20px 20px;\n    position: relative;\n    text-align: center;\n}\n.gift-item h5[data-v-6374f53f] {\n    font-size: 22px;\n}\n.gift-item h5 small[data-v-6374f53f] {\n    color: #fff;\n}\n.gift-item button[data-v-6374f53f] {\n    background: #0eb4ce;\n    border: 2px solid #13a8bf;\n    padding: 10px 25px;\n    margin: 10px 0;\n}\n.gifts.row[data-v-6374f53f] {\n    margin-bottom: 50px;\n}\nbutton.active[data-v-6374f53f] {\n    outline: 1px solid blue;\n}\ndiv#paypal-button[data-v-6374f53f] {\n    /*text-align: left;*/\n    margin: 0 12px !important;\n    position: relative;\n    top: -8px;\n}\n@media(min-width:768px){\n.col-md-8 .col-sm-6 .gift-item[data-v-6374f53f] {\n        padding: 40px 10px 10px;\n        margin: 50px 0 10px;\n}\n.col-md-8 .col-sm-6 .gift-item h5[data-v-6374f53f] {\n        font-size: 16px;\n}\n.col-md-8 .col-sm-6 .gift-item[data-v-6374f53f]:before {\n        height: 80px;\n        background-size: contain;\n}\n.col-md-8 .col-sm-6 .gift-item button[data-v-6374f53f] {\n        padding: 5px;\n}\n}\n@media(min-width:320px) and (max-width:375px){\n    /*table  tr  td:nth-child(2) , table  tr  th:nth-child(2) {*/\n        /*display: none;*/\n    /*}*/\n\n    /*table  tr  td:nth-child(3) , table  tr  th:nth-child(3) {*/\n        /*display: none;*/\n    /*}*/\n}\n@media(min-width:376px) and (max-width:425px){\n\n    /*table  tr  td:nth-child(3) , table  tr  th:nth-child(3) {*/\n        /*display: none;*/\n    /*}*/\n}\n@media(min-width: 320px) and (max-width: 767px){\ntable  tr  th[data-v-6374f53f]{\n        white-space: nowrap;\n        font-size: 14px;\n}\ntable  tr  td[data-v-6374f53f]{\n        white-space: nowrap;\n        font-size: 14px;\n}\n}\n\n", ""]);

// exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*for vertical effect*/\n.text-wrap-title-1[data-v-64c573f7] {\n    right: -14px;\n    position: absolute;\n    background-color: rgb(68, 189, 168) !important;\n    color: #fff !important;\n    font-size: 12px !important;\n    padding: 2px 4px !important;\n    border-top-left-radius: 4px !important;\n    line-height: 1.1 !important;\n}\n.align-to-bottom[data-v-64c573f7] {\n    right: -13px !important;\n    top: -9px !important;\n}\n.jw-img-1[data-v-64c573f7] {\n    max-width: 100%; /* Ensure the image does not exceed its container width */\n}\n.image-container[data-v-64c573f7] {\n    position: relative;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n}\n.m-b-45[data-v-64c573f7] {\n    margin-bottom: 40px !important;\n}\n.container__header[data-v-64c573f7] {\n    display: -ms-flexbox;\n    display: flex;\n    max-width: var(--wrap-width);\n    margin: 0 auto;\n    -ms-flex-pack: space-evenly;\n        justify-content: space-evenly;\n    font-size: 30px;\n    font-weight: 700;\n    margin-bottom: 30px;\n}\n.container__header-item[data-v-64c573f7] {\n    padding: 0.3rem;\n    border-radius: 2px;\n    margin-right: 0.3rem;\n    margin-bottom: 0.3rem;\n    cursor: pointer;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    font-size: 16px;\n    font-weight: 400;\n}\n.slide-search-fade-enter-active[data-v-64c573f7] {\n    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);\n}\n.slide-search-fade-leave-active[data-v-64c573f7] {\n    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);\n}\n.slide-search-fade-enter[data-v-64c573f7], .slide-search-fade-leave-to[data-v-64c573f7]\n    /* .slide-search-fade-leave-active for <2.1.8 */ {\n    transform: translateY(10px);\n    opacity: 0;\n}\n.search form input[data-v-64c573f7]{height:50px;\n}\nh3[data-v-64c573f7] {\n    color: #f0617d;\n    font-size:19px;\n}\n@media(min-width:991px){\nh3[data-v-64c573f7] {\n        width: 70.2%;\n        margin: 0 auto 30px;\n        display: block;\n}\n}\n@media (max-width: 992px) and (min-width: 768px){\nh3[data-v-64c573f7] {\n        width: 80%;\n        margin: 0 auto 30px;\n        display: block;\n}\n}\n.right-heart-icon[data-v-64c573f7] {\n    margin: 0;\n    float: left;\n    width: 100%;\n    padding: 10px 0 0 0;\n}\n.right-heart-icon i[data-v-64c573f7] {\n    color: #f0617d;\n    float: right;\n    font-size: 28px;\n}\n.row.video-row hr[data-v-64c573f7] {\n    margin: 0 1em;\n    border: 0;\n    border-top: 1px solid #eeeeee;\n}\n.btn-group.plusicon[data-v-64c573f7] {\n    position: absolute !important;\n    right: 60px !important;\n    bottom: 10px !important;\n    height: 29px !important;\n}\nli.divider[data-v-64c573f7] {\n    border-bottom: 1px solid #ddd;\n    margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-64c573f7] {\n    background: transparent;\n    border: 0 none transparent;\n    padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-64c573f7]{\n    font-size: 21px;\n    top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-64c573f7]{\n    padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-64c573f7],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-64c573f7] {\n    padding: 3px 15px;\n    margin-bottom: 5px;\n    display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-64c573f7],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-64c573f7] {\n    height: 30px;\n    padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-64c573f7],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-64c573f7] {\n    position: absolute;\n    top: 6px;\n    font-size:24px;\n    right:20px;\n    cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-64c573f7],\nbutton.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-64c573f7]{\n    position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-64c573f7],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul[data-v-64c573f7]{\n    left: 0;\n    right: auto;\n    width: 230px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    top: 100%;\n    position: absolute;\n    z-index: 5000;\n    list-style: none;\n    text-align: left;\n    padding: 15px;\n}\n.backdropformenu[data-v-64c573f7]{\n    position:fixed;\n    z-index:4900;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-64c573f7]{\n    height: 24px;\n    width: 37px;\n}\n.menuiconbutton[data-v-64c573f7]{\n    height: 24px !important;\n    width: 37px !important;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-64c573f7] {\n    left: auto ;\n    right: 0;\n}\n.fade-enter-active[data-v-64c573f7], .fade-leave-active[data-v-64c573f7] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-64c573f7], .fade-leave-to[data-v-64c573f7] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-64c573f7]{\n    font-size: 10px;\n}\nspan.removed[data-v-64c573f7] {\n    color: red;\n}\nspan.added[data-v-64c573f7] {\n    color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-64c573f7] {\n    position: relative;\n    display:block;\n}\n.search .tabContent p[data-v-64c573f7] {\n    font-size: 17px;\n}\n", ""]);

// exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\np strong[data-v-65a31e08] {\n    font-weight: 900;\n    color: #000;\n}\n.text-left p[data-v-65a31e08] {\n    font-size: 16px;\n}\na[data-v-65a31e08] {\n    word-wrap:break-word;\n}\n", ""]);

// exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.btn-group.plusicon[data-v-65ebedb2] {\n    position: absolute;\n    right: 50px;\n    bottom: 0px;\n    height: 29px;\n}\nli.divider[data-v-65ebedb2] {\n    border-bottom: 1px solid #ddd;\n    margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-65ebedb2] {\n    background: transparent;\n    border: 0 none transparent;\n    padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-65ebedb2]{\n    font-size: 21px;\n    top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-65ebedb2]{\n    padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-65ebedb2],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-65ebedb2] {\n    padding: 3px 15px;\n    margin-bottom: 5px;\n    display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-65ebedb2],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-65ebedb2] {\n    height: 30px;\n    padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-65ebedb2],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-65ebedb2] {\n    position: absolute;\n    top: 6px;\n    font-size:24px;\n    right:20px;\n    cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-65ebedb2],\nbutton.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-65ebedb2]{\n    position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-65ebedb2],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul[data-v-65ebedb2]{\n    left: 0;\n    right: auto;\n    width: 230px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    top: 100%;\n    position: absolute;\n    z-index: 5000;\n    list-style: none;\n    text-align: left;\n    padding: 15px;\n}\n.backdropformenu[data-v-65ebedb2]{\n    position:fixed;\n    z-index:4900;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-65ebedb2]{\n    height: 24px;\n    width: 37px;\n}\n.menuiconbutton[data-v-65ebedb2]{\n    height: 24px;\n    width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-65ebedb2] {\n    left: auto ;\n    right: 0;\n}\n.fade-enter-active[data-v-65ebedb2], .fade-leave-active[data-v-65ebedb2] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-65ebedb2], .fade-leave-to[data-v-65ebedb2] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-65ebedb2]{\n    font-size: 10px;\n}\nspan.removed[data-v-65ebedb2] {\n    color: red;\n}\nspan.added[data-v-65ebedb2] {\n    color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-65ebedb2] {\n    position: relative;\n    display:block;\n}\n", ""]);

// exports


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.expert_entry_image-and-name-container img.img-responsive[data-v-67ddb66c] {\n        -o-object-position: top;\n           object-position: top;\n}\n.expert_entry_image-and-name-container > a[data-v-67ddb66c] {\n        background: #fff !important;\n}\n.weblink[data-v-67ddb66c] {\n        text-transform: lowercase;\n        font-size: 14px;\n        line-height: 1.3;\n        display:block;\n        text-indent:1.5px;\n}\n.row.expertsrow[data-v-67ddb66c] {\n        margin-bottom: 30px;\n        margin-top: 50px;\n}\n.row.expertsrow h2[data-v-67ddb66c] {\n        color: #000000;\n        font-size: 40px;\n        font-family: sans-serif;\n        margin: 30px 0 15px 0;\n        text-align: left;\n        text-transform: capitalize;\n        letter-spacing: 0.3px;\n}\n.row.expertsrow h2 small[data-v-67ddb66c] {\n        color: #f0617d;\n        letter-spacing: 1px;\n}\n.row.expertsrow p[data-v-67ddb66c]{\n        font-size:20px;\n        color:#000;\n        letter-spacing:1px;\n}\nh2[data-v-67ddb66c]{\n        color: #f0617d;\n        text-transform: capitalize;\n        margin: 35px 0 60px 0;\n        letter-spacing: 0.5px;\n        font-family: sans-serif;\n}\na[data-v-67ddb66c]:hover {\n        text-decoration: none;\n}\n    /*changes in experts layout 1*/\n.expertsrow[data-v-67ddb66c] {\n        margin: 30px -15px;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n}\n.expert-entery[data-v-67ddb66c] {\n        width: 25%;\n        padding: 15px;\n        position: relative;\n}\n.expert_entry_image-and-name-container img.img-responsive[data-v-67ddb66c] {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        height: 100%;\n        -o-object-fit: cover;\n           object-fit: cover;\n        width: 100%;\n}\n.expert_entry_image-and-name-container > a[data-v-67ddb66c] {\n        position: relative;\n        width: 100%;\n        padding-top: 100%;\n        display: block;\n}\n.expert_entry_datacontainer[data-v-67ddb66c] {\n        position: absolute;\n        left: 100%;\n        right: auto;\n        top: 0;\n        z-index: 100;\n        background: #44bda8;\n        width: 200%;\n        min-height: 100%;\n        display: none;\n        -ms-flex-align: center;\n            align-items: center;\n        padding: 20px;\n        text-align: left;\n        color: #fff;\n        font-size: 17px;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        -ms-grid-column-align: stretch;\n            justify-items: stretch;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.expert_entry_datacontainer p[data-v-67ddb66c] {\n        width: 100%;\n        display: block;\n}\n.expert_entry_holder[data-v-67ddb66c] {\n        position: relative;\n}\n.expert_entry_datacontainer[data-v-67ddb66c]:before {\n        display: block;\n        content: \"\";\n        height: 0;\n        width: 0;\n        left: -100px;\n        border: 50px solid #f0617d00;\n        border-right: 50px solid #44bda8;\n        position: absolute;\n        top: 80px;\n}\n.expert_entry_holder:hover .expert_entry_datacontainer[data-v-67ddb66c] {\n        /*display: flex ;*/\n}\n.expert_entry_datacontainer > a[data-v-67ddb66c] {\n        background: white;\n        padding: 5px 30px;\n        border-radius: 20px;\n}\n.expert_entry_image-and-name-container h2[data-v-67ddb66c] {\n        font-size: 22px;\n        margin: 10px 0;\n}\n@media(min-width:768px){\n.expert-entery:nth-of-type(4n+3) .expert_entry_datacontainer[data-v-67ddb66c] {\n            right: 100%;\n            left: auto;\n}\n.expert-entery:nth-of-type(4n+3) .expert_entry_datacontainer[data-v-67ddb66c]:before {\n            left: auto;\n            border: 50px solid #f0617d00;\n            border-left: 50px solid #44bda8;\n            right: -100px;\n}\n.expert-entery:nth-of-type(4n+0) .expert_entry_datacontainer[data-v-67ddb66c] {\n            right: 100%;\n            left: auto;\n}\n.expert-entery:nth-of-type(4n+0) .expert_entry_datacontainer[data-v-67ddb66c]:before {\n            left: auto;\n            border: 50px solid #f0617d00;\n            border-left: 50px solid #44bda8;\n            right: -100px;\n}\n}\n.expert_entry_image-and-name-container[data-v-67ddb66c] {\n        background: #44bda8;\n}\n.expert_entry_image-and-name-container h2 *[data-v-67ddb66c], .expert_entry_image-and-name-container h2 small[data-v-67ddb66c] {\n        color: #fff;\n}\n.expert_entry_image-and-name-container[data-v-67ddb66c]:after {content: \"\";display: table;\n}\n.expert_entry_image-and-name-container h2[data-v-67ddb66c] {\n        min-height: 72px;\n}\n    /*second css*/\n.expert_entry_datacontainer[data-v-67ddb66c] {\n        opacity: 0;\n        /*background-color: red;*/\n        animation-name: popout;\n        animation-duration: 0.5s;\n        animation-delay: 0.1s;\n        animation-fill-mode: forwards;\n}\n@keyframes popout {\nfrom {opacity: 0;\n}\nto {opacity: 1;\n}\n}\n    /*third css*/\n@media(max-width:767px){\n.expert_entry_holder:active .expert_entry_datacontainer[data-v-67ddb66c],\n        .expert_entry_holder:focus .expert_entry_datacontainer[data-v-67ddb66c] {\n            left: 0;\n            right: 0 !important;\n            top: 0;\n            bottom: 0;\n            opacity: 1;\n            animation-name: none;\n            width:100%;\n}\n}\n@media(max-width:767px){\n.expert-entery[data-v-67ddb66c]{\n            width:100% !important;\n}\n.expert_entry_holder.active .expert_entry_datacontainer[data-v-67ddb66c]{left: 0;right: 0 !important;top: 0;bottom: 0;display: -ms-flexbox;display: flex;opacity: 1 !important;animation-name: none;animation-delay: 0s;width:100%;\n}\n.expert_entry_holder.active .expert_entry_datacontainer[data-v-67ddb66c]:before{display:none;\n}\n}\n@media(max-width:767px){\n.expert_entry_holder:hover .expert_entry_datacontainer[data-v-67ddb66c]{\n            left: 0;\n            right: 0 !important;\n            width: 100%;\n}\n}\n@media(max-width:767px){\n.expert_entry_datacontainer > p[data-v-67ddb66c] {\n            max-height: 50vw;\n            display: -webkit-box;\n            -webkit-line-clamp: 6;\n            /* autoprefixer: off */\n            -webkit-box-orient: vertical;\n            /* autoprefixer: on */\n            overflow: hidden;\n            text-overflow: ellipsis;\n}\n}\n.expert-entery:hover .expert_entry_holder .expert_entry_datacontainer[data-v-67ddb66c] {\n        display: -ms-flexbox;\n        display: flex;\n}\n@media(max-width:767px){\n.expert_entry_image-and-name-container > a[data-v-67ddb66c] {\n            pointer-events: none;\n}\n}\n@media(max-width:992px){\n.expert_entry_image-and-name-container[data-v-67ddb66c]:after {\n            content: \"More\" !important;\n            position: relative;\n            bottom: 0%;\n            left: 50%;\n            background: #f0617d;\n            z-index: 50;\n            color: #fff;\n            padding: 10px 30px;\n            border-radius: 50px;\n            font-size: 17px;\n            transform: translate(-50%, 0%);\n            margin-bottom:20px;\n}\n.expert_entry_image-and-name-container[data-v-67ddb66c]{overflow:hidden;\n}\n}\n", ""]);

// exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.text-wrap-title-1[data-v-6a07750b] {\n    right: -14px;\n    position: absolute;\n    background-color: rgb(68, 189, 168) !important;\n    color: #fff !important;\n    font-size: 12px !important;\n    padding: 2px 4px !important;\n    border-top-left-radius: 4px !important;\n    line-height: 1.1 !important;\n}\n.align-to-bottom[data-v-6a07750b] {\n    right: -13px !important;\n    top: -9px !important;\n}\n.jw-img-1[data-v-6a07750b] {\n    max-width: 100%; /* Ensure the image does not exceed its container width */\n}\n.image-container[data-v-6a07750b] {\n    position: relative;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n}\n.btn-group.plusicon[data-v-6a07750b] {\n    position: absolute;\n    right: 50px;\n    bottom: 0px;\n    height: 29px;\n}\nli.divider[data-v-6a07750b] {\n    border-bottom: 1px solid #ddd;\n    margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-6a07750b] {\n    background: transparent;\n    border: 0 none transparent;\n    padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-6a07750b]{\n    font-size: 21px;\n    top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-6a07750b]{\n    padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-6a07750b],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-6a07750b] {\n    padding: 3px 15px;\n    margin-bottom: 5px;\n    display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-6a07750b],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-6a07750b] {\n    height: 30px;\n    padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-6a07750b],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-6a07750b] {\n    position: absolute;\n    top: 6px;\n    font-size:24px;\n    right:20px;\n    cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-6a07750b],\nbutton.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-6a07750b]{\n    position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-6a07750b],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul[data-v-6a07750b]{\n    left: 0;\n    right: auto;\n    width: 230px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    top: 100%;\n    position: absolute;\n    z-index: 5000;\n    list-style: none;\n    text-align: left;\n    padding: 15px;\n}\n.backdropformenu[data-v-6a07750b]{\n    position:fixed;\n    z-index:4900;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-6a07750b]{\n    height: 24px;\n    width: 37px;\n}\n.menuiconbutton[data-v-6a07750b]{\n    height: 24px;\n    width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-6a07750b] {\n    left: auto ;\n    right: 0;\n}\n.fade-enter-active[data-v-6a07750b], .fade-leave-active[data-v-6a07750b] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-6a07750b], .fade-leave-to[data-v-6a07750b] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-6a07750b]{\n    font-size: 10px;\n}\nspan.removed[data-v-6a07750b] {\n    color: red;\n}\nspan.added[data-v-6a07750b] {\n    color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-6a07750b] {\n    position: relative;\n    display:block;\n}\n.bolder[data-v-6a07750b] {\n    font-size: 18px;\n    font-weight: 900;\n}\n@media(max-width:767px){\n.hidemobile[data-v-6a07750b]{display:none;\n}\n}\n\n", ""]);

// exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.plans .pageHeading[data-v-6a24856b]{\n    font-size: 32px;\n    color: #535861;\n    font-weight: lighter;\n    margin: 25px 0 50px 0;\n}\n.plans .cardSection[data-v-6a24856b]{\n    margin-bottom: 50px;\n    display: inline-block;\n    width: 100%;\n    margin: 25px 0 50px;\n}\n.plans .cardSection a[data-v-6a24856b]{\n    display: block;\n    text-decoration: none;\n    transition: 0.5s;\n}\n.plans .cardSection a[data-v-6a24856b]:hover{\n    box-shadow: 0 0 5px -1px black;\n    border-radius: 5px;\n    transform: scale(0.95);\n    position: relative;\n    z-index:1;\n}\n.plans .cardSection .card .cardHeader[data-v-6a24856b]{\n    min-height: 70px;\n    background-color: #2685dc;\n    padding: 22px 15px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    border-radius: 5px 5px 0 0;\n}\n.plans .cardSection .business[data-v-6a24856b]{\n    margin: -25px 5px 0;\n}\n.plans .cardSection .business .cardHeader[data-v-6a24856b]{\n    background-color: #4ec2fc;\n}\n.plans .cardSection .business .cardBody .amountSection h4[data-v-6a24856b]{\n    color: #22b0fc;\n}\n.plans .cardSection .card .cardHeader h1[data-v-6a24856b]{\n    margin:0;\n    font-size: 24px;\n    color: #ffffff;\n}\n.plans .cardSection .card .cardHeader p[data-v-6a24856b]{\n    margin:5px 0 0 0;\n    font-size: 14px;\n    color: #ffffff;\n}\n.plans .cardBody[data-v-6a24856b]{\n    display: inline-block;\n    width: 100%;\n    background-color: #ffffff;\n}\n.plans .cardBody .amountSection[data-v-6a24856b]{\n    padding: 25px  0;\n    background: #ffffff;\n}\n.plans .cardBody .amountSection h4[data-v-6a24856b]{\n    font-size: 32px;\n    margin: 0;\n    font-weight: lighter;\n    color:#2d3139\n}\n.plans .cardBody .amountSection h4 sub[data-v-6a24856b]{\n    bottom:0;\n}\n.plans .cardBody .amountSection p[data-v-6a24856b]{\n    font-size: 16px;\n    margin: 0;\n    color: #8f9baa;\n    font-weight: lighter;\n}\n.plans .cardBody .amountSection .amount[data-v-6a24856b]{\n    padding:  0 10px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.plans .cardBody .amountSection .left[data-v-6a24856b]{\n    width: 55%;\n    float: left;\n}\n.plans .cardBody .amountSection .right[data-v-6a24856b]{\n    width: 45%;\n    display: inline-block;\n}\n.plans .cardBody .amountSection .right h4[data-v-6a24856b]{\n    color: #5285c8;\n}\n.plans .cardBody .cardBodyHeader[data-v-6a24856b]{\n    background-color: #f4f7f9;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.plans .cardBody .cardBodyHeader p[data-v-6a24856b]{\n    margin: 0;\n    text-align: left;\n    font-size: 16px;\n    font-weight: 600;\n    color: #8491a2;\n    padding: 12px 28px;\n    width: 100%;\n}\n.plans .cardBody ul[data-v-6a24856b]{\n    padding: 0;\n    list-style: none;\n}\n.plans .cardBody ul li[data-v-6a24856b]{\n    padding: 15px 25px;\n}\n.plans .cardBody ul li .featureHeadind[data-v-6a24856b]{\n    text-align: left;\n    width: 70%;\n    float: left;\n    border-bottom: 1px solid #f4f7f9;\n    color: #8491a2;\n    padding-bottom: 10px;\n    font-size: 16px;\n}\n.plans .cardBody ul li:last-child .featureHeadind[data-v-6a24856b]{\n    border-bottom: 0 solid transparent;\n}\n.plans .cardBody ul li[data-v-6a24856b]:last-child{\n    padding-bottom: 10px;\n}\n.plans .cardBody ul li .featureDetail[data-v-6a24856b]{\n    text-align: right;\n    width: 30%;\n    display: inline-block;\n    color:#3a3e45;\n    font-weight: 600;\n    font-size: 16px;\n}\n.plans .cardSection .card .cardFooter[data-v-6a24856b]{\n    min-height: 50px;\n    background-color: #2d3139;\n    border-radius: 0 0 5px 5px;\n    position: relative;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.plans .cardSection .card .cardFooter ul[data-v-6a24856b] {\n    padding: 10px 25px;\n    list-style: none;\n    margin: 0;\n    width: 100%;\n}\n.plans .cardSection .card .cardFooter ul li[data-v-6a24856b]{\n    width: 100%;\n}\n.plans .cardSection .card .cardFooter ul li .featureHeadind[data-v-6a24856b]{\n    text-align: left;\n    width: 70%;\n    float: left;\n    color: #ffffff;\n    font-size: 16px;\n}\n.plans .cardSection .card .cardFooter ul li .featureDetail[data-v-6a24856b]{\n    text-align: right;\n    width: 30%;\n    display: inline-block;\n    color:#ffffff;\n    font-weight: 600;\n    font-size: 16px;\n}\n.plans .cardSection .card .cardFooter[data-v-6a24856b]:before{\n    content: '';\n    border-left: 6px solid #2d3139;\n    border-bottom: 6px solid transparent;\n    border-top: 6px solid transparent;\n    position: absolute;\n    top: -5px;\n    left: 0;\n}\n.plans .cardSection .card .cardFooter[data-v-6a24856b]:after{\n    content: '';\n    border-right: 6px solid #2d3139;\n    border-bottom: 6px solid transparent;\n    border-top: 6px solid transparent;\n    position: absolute;\n    top: -5px;\n    right: 0;\n}\n.padding-minus[data-v-6a24856b]{\n    padding:0;\n}\n", ""]);

// exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.set-error[data-v-6cd8833a]{\n    border-color: #a94442 !important;\n    color:#a94442 !important;\n}\n.StripeElement[data-v-6cd8833a] {\n    background-color: white;\n    padding: 2em 1em;\n    border: 1px solid #ccc;\n    box-shadow: 0 1px 3px 0 #e6ebf1;\n    transition: box-shadow 150ms ease;\n    height: 34px;\n}\n.float-right.paymentswitch.btn-group[data-v-6cd8833a] {\n    margin: 0 0 30px;\n}\n.StripeElement--focus[data-v-6cd8833a] {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n}\n.StripeElement--invalid[data-v-6cd8833a] {\n    border-color: #fa755a;\n}\n.StripeElement--webkit-autofill[data-v-6cd8833a] {\n    background-color: #fefde5 !important;\n}\n.radiowrapper[data-v-6cd8833a] {\n    padding: 0 35px 35px;\n    color: #f0617d;\n}\n.showmobile[data-v-6cd8833a]{\n    display:none;\n}\n.stripeholder[data-v-6cd8833a] {\n    position: relative;\n}\ni.fa.fa-lock.overlapstripe[data-v-6cd8833a] {\n    position: absolute;\n    left: 18px;\n    top: 10px;\n    font-size: 18px;\n    color: #b2b8c7;\n}\n@media (max-width:767px){\n.hidemobile[data-v-6cd8833a]{\n        display:none;\n}\n.showmobile[data-v-6cd8833a]{\n        display:inherit;\n}\n.signUp .left-content h4[data-v-6cd8833a] {\n        font-size: 14px;\n        letter-spacing: 0px;\n}\n.signUp .main-content h2[data-v-6cd8833a] {\n        margin: 15px 0;\n        line-height: 20px;\n        font-size: 18px;\n}\n.signUp #redeem_pwderrormsg[data-v-6cd8833a] {\n        margin-bottom: 8px;\n        line-height: 1.3;\n        letter-spacing: 1px;\n}\n.signUp .left-content .create-account #redeem_button[data-v-6cd8833a] {\n        margin: 0;\n}\n.signUp .right-content .jumbotron[data-v-6cd8833a] {\n        padding: 6px;\n        margin-top: 7px;\n}\n.signUp .right-content .jumbotron h2[data-v-6cd8833a] {\n        margin: 0;\n        font-size: 21px;\n}\n.signUp .right-content .jumbotron p[data-v-6cd8833a] {\n        display: none;\n}\n.signUp .right-content .card[data-v-6cd8833a] {\n        padding: 10px 10px;\n}\n.signUp .right-content .card .card-block .list-group li[data-v-6cd8833a] {\n        font-size: 16px;\n        margin: 0 0 10px;\n}\n.signUp .left-content hr[data-v-6cd8833a] {\n        display: none;\n}\n.row.margin-top[data-v-6cd8833a] {\n        margin-top: 0px;\n}\n}\n\n/* Media query for mobile viewport */\n@media screen and (max-width: 400px) {\n#paypal-button-container[data-v-6cd8833a] {\n        width: 100%;\n}\n}\n\n/* Media query for desktop viewport */\n@media screen and (min-width: 400px) {\n#paypal-button-container[data-v-6cd8833a] {\n        width: 250px;\n        display: inline-block;\n}\n}\nbody .margin-top[data-v-6cd8833a] {\n    margin-top: 89px;\n    margin-bottom: 70px;\n}\nbody .signUp .right-content .card .card-block .list-group[data-v-6cd8833a]{\n    margin-bottom:0px;\n}\n", ""]);

// exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.contact-us-form .contact-form .form form .form-group textarea.form-control {\n    max-height: 100px;\n    min-height: 100px;\n    min-width: 100%;\n    max-width: 100%;\n    width: 100% !important;\n    height: 100px !important;\n    resize: none;\n}\n.contact-us-form .contactformtexttone p{font-size:18px\n}\n", ""]);

// exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.hubspotForm[data-v-6d77c942] {\n    margin: 2% 10%;\n    max-width: 80%;\n}\n#contactus_phonenumber[data-v-6d77c942] {\n    padding: 0 30px 0 15px;\n    height: 60px;\n    margin-bottom: 20px;\n}\n.contact-us-form p[data-v-6d77c942] {\n    font-size: 22px;\n    font-family: sans-serif;\n    letter-spacing: 0.5px;\n    margin: 0 0 30px 0;\n    font-weight: normal;\n    line-height: 1;\n    color: #777777;\n}\n.contact-us-form h2[data-v-6d77c942] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 40px 0 15px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n}\n", ""]);

// exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.container .rules-expert-content img[data-v-7020e578] {\n    width: 160px;\n    height: 160px;\n    display: block;\n    margin: 0 auto 25px;\n    border-radius: 50%;\n}\n.container .marginTop .ruleImages p[data-v-7020e578] {\n    text-align: left;\n    color: #000000;\n    font-family: sans-serif;\n    padding: 0 0 0 30px;\n    line-height: 1.2;\n    margin: 0;\n    position: absolute;\n}\n@media(min-width:993px){\n.rules-banner[data-v-7020e578]{\n    height: auto;\n    min-height: 582px;\n    padding-bottom: 80px;\n}\n}\n", ""]);

// exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.row.padding30 {\n    margin: 0 -15px !important;\n}\n.logo {\n    z-index: 5000;\n    position: relative;\n}\n.row.padding30 > div {\n    padding: 0;\n}\n.jw-icon.jw-icon-tooltip.jw-icon-cc.jw-reset.jw-toggle:after {\n    content: \"CC/Subtitles\";\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    background: #000;\n    z-index: 3000;\n    /* border: 1px solid #fff; */\n    white-space: nowrap;\n    top: -6px;\n    font-family: arial;\n    font-size: 12px;\n    display: none;\n    line-height: 1.3;\n    padding: 1px 3px 0;\n    border-radius: 2px;\n}\n/*.jw-icon.jw-icon-tooltip.jw-icon-cc.jw-reset.jw-toggle:hover:after {*/\n/*    display: block;*/\n/*}*/\n/*.jw-icon-rewind {*/\n/*    display: none !important;*/\n/*}*/\na.btn.pink.btn-primary.headerlink {\n    border: 2px solid #44bda8;\n    background-color: #44bda8;\n}\na.btn.pink.btn-primary.headerlink:hover {\n    color: #fff;\n    background-color: #3fa996;\n    border-color: #3fa996;\n}\na.btn.btn-success.btn-lg:hover {\n    color: #fff;\n    background-color: #449d44;\n    border-color: #398439;\n}\n.unauth-header .notificationtext {\n    display: block;\n    width: auto;\n    max-width: none;\n    top: 90px;\n    background: #fff;\n    color: #000;\n    left: 0;\n    right: 0;\n}\n.unauth-header .notificationtext {\n    display: block;\n    width: auto;\n    max-width: none;\n    padding: 10px;\n    top: 90px;\n    background: #fff;\n    color: #000;\n    left: 0;\n    right: 0;\n}\n.notificationtext a.close {\n    text-decoration: none;\n}\n@media(min-width:768px){\n.unauth-header header .nav-container .navbar .margin-left li a i.nav-icon.career-icon{\nbackground:url(" + __webpack_require__(824) + ") no-repeat center center transparent;\n}\n.unauth-header header .nav-container .navbar .margin-left li a i.nav-icon.inspiration-icon{\n    background:url(" + __webpack_require__(816) + ") no-repeat center center transparent;\n}\n.unauth-header header .nav-container .navbar .margin-left li a i.mind-body-icon{\n    background:url(" + __webpack_require__(337) + ") no-repeat center center transparent;\n}\n.unauth-header header .nav-container .navbar .margin-left li a i.money-icon{\n    background:url(" + __webpack_require__(820) + ") no-repeat center center transparent;\n}\n.unauth-header header .nav-container .navbar .margin-left li a i.mind-body-icon{\n    background:url(" + __webpack_require__(337) + ") no-repeat center center transparent;\n}\n.unauth-header header .nav-container #header-navbar .navbar-right li.mid-icons a i.search-icon{\n    background:url(" + __webpack_require__(822) + ") no-repeat center center transparent;\n}\n}\n.unauth-header .unauth-links {\n    display: none;\n}\n@media(max-width:767px) {\n.unauth-header .notificationtext {\n        display: none;\n}\n.unauth-header .unauth-links {\n        display: block;\n        background: #fff;\n}\n.unauth-header .unauth-links a , .unauth-header .unauth-links a i {\n        display: inline-block;\n        width: auto !important;\n        padding: 0;\n}\n.unauth-header .unauth-links a {\n        margin: 0 10px;\n        padding: 15px 0 20px;\n}\n.unauth-header .unauth-links a i {\n        font-size: 18px;\n}\n.unauth-header header .nav-container .navbar .margin-left {\n        margin-bottom: 0;\n}\n}\n@media (max-width: 767px) and (min-width: 320px) {\nbody{\n        zoom: 1 !important;\n}\n}\n.alert.alert-primary.text-center.alertmsg {\n    background: #44bda8;\n    color: #fff;\n}\n.alert.alert-primary.text-center.alertmsg a {\n    text-decoration: none;\n    cursor:pointer;\n    text-decoration: underline;\n}\n.alert.alert-primary.text-center.alertmsg a.close {\n    padding: 0 2px;\n    top: -1px;\n    right: -1px;\n    position: absolute;\n    opacity:1;\n    color:#fff;\n}\n.alert.alert-primary.text-center.alertmsg {\n    position: relative;\n}\n.alert.alert-primary.text-center.alertmsg i.fa.fa-times {\n    width: auto;\n}\n@media(max-width:419px){\nhtml body .unauth-header header .nav-container .mobile-loginLogoutholder a.btn.btn-link {\n    font-size: 14px;\n    padding: 8px 6px 1px;\n}\n}\n@media(min-width:1200px) and (max-width:1310px){\n.unauth-header header .logo {\n        padding-right: 0;\n}\nbody header .nav-container #header-navbar .navbar-right .login-btn a {\n        padding: 5px !important;\n}\n}\n/*.expiryModalImage {*/\n    /*display: block;*/\n    /*margin-left: auto;*/\n    /*margin-right: auto;*/\n    /*z-index: 100000000;*/\n/*}*/\n.cust-corp-banner {\n    position: absolute;\n    top: 45px;\n    left: 20px;\n    font-size: 17px;\n    font-weight: 900;\n    color: #fff;\n    right: calc( 50% + 130px);\n    text-align: center;\n}\n.cust-corp-banner a{color:inherit;text-decoration:underline;\n}\n@media(max-width:767px){\n.cust-corp-banner{display:none;\n}\n}\n", ""]);

// exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\nbody > img {\n    display:none;\n}\n@media(min-width:290px) and (max-width:767px){\nheader .nav-container #header-navbar .navbar-left li a{\n        min-width:200px !important;\n}\n}\n", ""]);

// exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Quicksand:300,400,500,700);", ""]);

// module
exports.push([module.i, "\n.default-min-height[data-v-7063ff53] {\n  min-height: 87px;\n}\n.static-min-height[data-v-7063ff53] {\n  min-height: 50px !important;\n}\n@media (min-width: 768px) {\nheader .nav-container .navbar-nav li[data-v-7063ff53] {\n    /* margin:0 0 0 8px; commented on 08/03/2021 */\n    margin: 0 0 0 1px;\n}\n}\nheader .nav-container .navbar-nav li a i[data-v-7063ff53] {\n  max-width: 25px;\n}\n.pointercursor[data-v-7063ff53] {\n  cursor: pointer;\n}\nheader .nav-container #header-navbar .navbar-right .login-btn a[data-v-7063ff53] {\n  border: 1px solid #f0617d;\n  border-radius: 4px;\n}\n@media (min-width: 768px) {\nheader .nav-container .mobile-loginLogoutholder[data-v-7063ff53] {\n    display: none;\n}\n}\nheader .nav-container .mobile-loginLogoutholder[data-v-7063ff53] {\n  position: absolute;\n  z-index: 1;\n  top: 14px;\n  right: 60px;\n}\nheader .nav-container .mobile-loginLogoutholder a i[data-v-7063ff53] {\n  color: #fff;\n  width: auto;\n  font-size: 25px;\n}\n.unauth-header header .nav-container .navbar-header a.nav-icon.navbar-toggle.search-icon.fa.fa-search[data-v-7063ff53] {\n  background: none;\n  padding: 0;\n  height: 26px;\n  position: relative;\n  left: -8px;\n  top: 3px;\n  text-decoration: none;\n}\n.unauth-header header .nav-container .navbar-header a.nav-icon.navbar-toggle.search-icon.fa.fa-search[data-v-7063ff53]:before {\n  font-size: 25px !important;\n}\nheader .nav-container .mobile-loginLogoutholder a[data-v-7063ff53] {\n  padding: 5px;\n}\nheader .nav-container .mobile-loginLogoutholder a i[data-v-7063ff53] {\n  clear: both;\n  display: block;\n}\nheader .nav-container .mobile-loginLogoutholder a[data-v-7063ff53] {\n  color: #fff;\n  font-size: 10px;\n  line-height: 7px;\n}\n\n/*.search-icon {*/\n/*-webkit-filter: brightness(100);*/\n/*filter: brightness(200);*/\n/*}*/\n.watchVideoModalHeader[data-v-7063ff53] {\n  text-align: center;\n}\n.watchVideoModalHeader[data-v-7063ff53] {\n  text-align: center;\n}\n.watchVideoModal .modal-dialog .modal-body[data-v-7063ff53] {\n  padding: 15px;\n}\n.watchVideoModal .modal-dialog .modal-body h2[data-v-7063ff53] {\n  color: #f0617d;\n  text-transform: capitalize;\n  margin: 40px 0 60px 0;\n  letter-spacing: 0.5px;\n  font-family: sans-serif;\n  text-align: center;\n}\n.watchVideoModal .modal-dialog .modal-body .col-sm-5.text-left h2 small[data-v-7063ff53] {\n  color: #f0617d;\n}\n.watchVideoModal .modal-dialog .modal-body .row.expertsrow[data-v-7063ff53] {\n  margin: 0 -15px 20px;\n}\n.watchVideoModal .modal-dialog .modal-body .col-sm-5.text-left h2[data-v-7063ff53] {\n  color: #000000;\n  font-size: 30px;\n  font-family: sans-serif;\n  margin: 30px 0 15px 0;\n  text-align: left;\n  text-transform: capitalize;\n  letter-spacing: 0.3px;\n}\n.watchVideoModal .modal-dialog .modal-body .col-sm-5.text-left p[data-v-7063ff53] {\n  padding: 0;\n}\n.watchVideoModal .modal-dialog .modal-body button[data-v-7063ff53] {\n  background: #44bda8;\n  color: white;\n  font-size: 16px;\n  border: none;\n  width: 253px;\n  padding: 14px 15px 12px;\n  letter-spacing: 0.3px;\n  text-transform: capitalize;\n  border-radius: 3px;\n  margin-bottom: 7px;\n  margin: 30px auto 10px;\n  display: block;\n}\n.notificationtext a[data-v-7063ff53] {\n  color: inherit;\n  text-decoration: underline;\n}\n.notificationtext[data-v-7063ff53] {\n  left: 50%;\n  color: #fff;\n  position: absolute;\n  font-weight: bold;\n  z-index: 500;\n  top: 43px;\n  text-align: center;\n  font-size: 18px;\n  right: 20px;\n  padding-left: 110px;\n}\nimg.aboutimg[data-v-7063ff53] {\n  height: 27px;\n  width: 27px;\n  opacity: 0.5;\n  margin: 0 0 3px;\n}\nimg.aboutuswhite[data-v-7063ff53] {\n  display: none;\n}\n@media (max-width: 767px) {\nimg.aboutuswhite[data-v-7063ff53] {\n    height: 27px;\n    width: 27px;\n    opacity: 1;\n    margin: 0 0 3px;\n    display: inline-block;\n}\nimg.aboutimg[data-v-7063ff53] {\n    display: none;\n}\n.search-icon[data-v-7063ff53] {\n    filter: brightness(200);\n}\n}\n@media (min-width: 768px) {\n.watchVideoModal .modal-dialog .modal-body .row.expertsrow .col-sm-3.col-sm-offset-2[data-v-7063ff53] {\n    width: 41.66667%;\n    margin-left: 0;\n}\n.watchVideoModal .modal-dialog .modal-body .col-sm-5.text-left[data-v-7063ff53] {\n    width: 58.33333%;\n}\nheader .nav-container #header-navbar .navbar-right .userProfile a span.usernamelimit[data-v-7063ff53] {\n    max-width: 65px;\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    position: absolute;\n    top: 72px;\n    left: 0;\n    right: 0;\n}\n}\n\n/*header style for smaller devices and tabs */\n@media (min-width: 1024px) and (max-width: 1199px) {\nheader .nav-container .navbar .margin-left[data-v-7063ff53] {\n    margin-left: 0 !important;\n}\n.nav > li > a[data-v-7063ff53] {\n    padding: 20px 2px;\n    letter-spacing: 0;\n}\nheader .nav-container .navbar .margin-left li a p[data-v-7063ff53] {\n    letter-spacing: 0;\n    font-size: 14px;\n}\n.unauth-header header .nav-container #header-navbar .navbar-right .login-btn a[data-v-7063ff53] {\n    font-size: 18px;\n}\n}\n@media (min-width: 1200px) {\nheader .nav-container .navbar .margin-left[data-v-7063ff53] {\n    margin-left: 1% !important;\n}\n}\n@media (min-width: 924px) and (max-width: 1023px) {\nheader .nav-container .container[data-v-7063ff53] {\n    width: 100%;\n}\n.nav > li > a[data-v-7063ff53] {\n    padding: 20px 2px;\n    letter-spacing: 0;\n}\n#header-navbar .navbar-left a p[data-v-7063ff53] {\n    font-size: 14px;\n    letter-spacing: 0px !important;\n}\nbody header .nav-container #header-navbar .navbar-right .login-btn a[data-v-7063ff53] {\n    padding: 8px 2px !important;\n    margin-left: 0 !important;\n}\n}\n@media (max-width: 1050px) and (min-width: 980px) {\nbody header .nav-container #header-navbar .navbar-right li.mid-icons[data-v-7063ff53] {\n    top: 30px;\n    margin: 0 0px !important;\n}\n}\n@media (min-width: 876px) and (max-width: 923px) {\nheader .nav-container .container[data-v-7063ff53] {\n    width: 100%;\n}\n.nav > li > a[data-v-7063ff53] {\n    padding: 20px 2px;\n    letter-spacing: 0;\n}\n#header-navbar .navbar-left a p[data-v-7063ff53] {\n    font-size: 14px;\n    letter-spacing: 0px !important;\n}\n.unauth-header header .nav-container #header-navbar .navbar-right .login-btn a[data-v-7063ff53] {\n    font-size: 14px !important;\n}\n}\n@media (min-width: 820px) and (max-width: 875px) {\nheader .nav-container .container[data-v-7063ff53] {\n    width: 100%;\n}\n.nav > li > a[data-v-7063ff53] {\n    padding: 20px 2px;\n    letter-spacing: 0;\n}\n#header-navbar .navbar-left a p[data-v-7063ff53] {\n    font-size: 12px;\n    letter-spacing: 0px !important;\n}\nheader .nav-container #header-navbar .navbar-right .login-btn a[data-v-7063ff53] {\n    border: 0px solid #f0617d;\n    border-radius: 4px;\n    font-size: 14px !important;\n    margin: 0 2px !important;\n}\n}\n@media (min-width: 768px) and (max-width: 819px) {\nheader .nav-container .container[data-v-7063ff53] {\n    width: 100%;\n}\n.nav > li > a[data-v-7063ff53] {\n    padding: 20px 2px;\n    letter-spacing: 0;\n}\n#header-navbar .navbar-left a p[data-v-7063ff53] {\n    font-size: 12px;\n    letter-spacing: 0px !important;\n    text-transform: lowercase;\n}\n}\na.giftslink[data-v-7063ff53] {\n  position: absolute;\n  left: 10px;\n  top: 5px;\n  color: #fff;\n  z-index: 50;\n  font-size: 120px;\n  line-height: 24px;\n}\ni.fa.fa-gift span[data-v-7063ff53] {\n  margin-top: 2px;\n  /*content: \"Give the gift of TONE\";*/\n  display: block;\n  color: #ffffff;\n  font-size: 19px;\n  text-align: center;\n  font-family: \"Quicksand\", sans-serif;\n  font-weight: bold;\n  position: absolute;\n  left: 110px;\n  top: 40px;\n  right: -150px;\n  line-height: 1.3;\n}\ni.fa.fa-gift[data-v-7063ff53] {\n  text-align: center;\n}\na.giftslink i[data-v-7063ff53] {\n  color: #ffffff;\n}\n.alertmsg[data-v-7063ff53] {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-size: 16px;\n  font-weight: bold;\n  letter-spacing: 1px;\n  margin: 10px 0;\n}\n@media (max-width: 767px) {\n.notificationtext[data-v-7063ff53] {\n    display: none;\n}\n.giftslink[data-v-7063ff53] {\n    top: 1px !important;\n    left: 54px !important;\n}\ni.fa.fa-gift[data-v-7063ff53] {\n    font-size: 28px;\n}\ni.fa.fa-gift span[data-v-7063ff53] {\n    display: none;\n}\ni.fa.fa-gift[data-v-7063ff53]:after {\n    margin-top: 2px;\n    content: \"Gifting\";\n    /*content: \"Gift with Purchase\";*/\n    display: block;\n    color: #ffffff;\n    font-size: 10px;\n    line-height: 7px;\n    position: static;\n    text-align: center;\n    font-family: \"Quicksand\", sans-serif;\n    font-weight: bold;\n}\n}\n@media (max-width: 767px) {\nheader .nav-container #header-navbar .navbar-right .userProfile span[data-v-7063ff53] {\n    color: #fff !important;\n}\nheader .nav-container #header-navbar .navbar-left li a i[data-v-7063ff53] {\n    color: #fff !important;\n    text-shadow: 0 0 0 transparent !important;\n    filter: brightness(100);\n    -webkit-filter: brightness(100);\n}\nheader .nav-container .navbar-nav li[data-v-7063ff53] {\n    margin: 0;\n}\nheader .nav-container #header-navbar .navbar-left li[data-v-7063ff53] {\n    position: relative;\n}\nheader .nav-container #header-navbar .navbar-left li a[data-v-7063ff53] {\n    position: static;\n}\n.nav > li > a[data-v-7063ff53]:hover {\n    background: none;\n}\n.nav > li > a[data-v-7063ff53]:focus {\n    background: none;\n}\nheader .nav-container #header-navbar .navbar-left li a.router-link-active[data-v-7063ff53]:before {\n    background: rgba(0, 0, 0, 0.4);\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    display: block;\n}\n}\nheader .nav-container a.about-link[data-v-7063ff53] {\n  position: absolute;\n  top: -27px;\n  color: #f0617d;\n  margin: 0 auto;\n  left: 50%;\n  transform: translateX(-50%);\n  text-transform: uppercase;\n  letter-spacing: 3px;\n  font-size: 12px;\n  font-weight: bold;\n  background: #fff;\n  border-radius: 50px;\n  padding: 2px 20px;\n}\n@media (max-width: 767px) {\nbody header .nav-container a.about-link[data-v-7063ff53] {\n    top: 0px !important;\n    z-index: 500;\n    border-radius: 0px 0px 0px 50px !important;\n    left: auto !important;\n    transform: translateY(0) !important;\n    right: 0;\n    padding: 0px 20px !important;\n}\nheader .nav-container #header-navbar .navbar-left li a i[data-v-7063ff53] {\n    max-width: 10000px;\n    width: 25px !important;\n    margin-right: 5px !important;\n}\n}\n@media (min-width: 768px) and (max-width: 1200px) {\nheader .nav-container .navbar-nav li[data-v-7063ff53] {\n    margin-left: 0px !important;\n}\n}\n.loginModal .modal-dialog .modal-body .bodyContent .form form a[data-v-7063ff53] {\n  float: none;\n}\n@media (min-width: 1920px) {\nheader .nav-container .container[data-v-7063ff53] {\n    width: 1301px;\n}\n}\nheader .nav-container .alertmsg[data-v-7063ff53] {\n  font-weight: 500;\n}\nheader .nav-container .navbar-nav li a i.fa-newspaper-o[data-v-7063ff53] {\n  max-width: none;\n  width: auto;\n  margin: 0 0 2px;\n  height: 28px;\n}\nheader .nav-container .alertmsg a[data-v-7063ff53] {\n  font-size: inherit;\n  padding: 0;\n  color: inherit;\n  text-decoration: underline;\n  font-weight: 900;\n}\n.unauth-header img.businessimg[data-v-7063ff53] {\n  display: none;\n}\n.unauth-header img.playlistsimg[data-v-7063ff53] {\n  display: none;\n}\nimg.businessimgwhite[data-v-7063ff53] {\n  display: none;\n}\nimg.playlistswhite[data-v-7063ff53] {\n  display: none;\n}\n.unauth-header img.businessimgwhite[data-v-7063ff53] {\n  display: inline;\n}\n.unauth-header img.playlistswhite[data-v-7063ff53] {\n  display: inline;\n}\nimg.businessimg[data-v-7063ff53] {\n  height: 30px;\n  width: 30px;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\nimg.playlistsimg[data-v-7063ff53] {\n  height: 30px;\n  width: 30px;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\nimg.businessimgwhite[data-v-7063ff53] {\n  height: 30px;\n  width: 30px;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\nimg.playlistswhite[data-v-7063ff53] {\n  height: 30px;\n  width: 30px;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n@media (max-width: 767px) {\nimg.businessimgwhite[data-v-7063ff53] {\n    display: none;\n}\nimg.playlistswhite[data-v-7063ff53] {\n    display: none;\n}\nimg.businessimgwhite[data-v-7063ff53] {\n    height: 30px;\n    width: 27px;\n    -o-object-fit: contain;\n       object-fit: contain;\n    display: inline;\n}\nimg.playlistswhite[data-v-7063ff53] {\n    height: 30px;\n    width: 27px;\n    -o-object-fit: contain;\n       object-fit: contain;\n    display: inline;\n}\nimg.businessimg[data-v-7063ff53] {\n    display: none;\n}\nimg.playlistsimg[data-v-7063ff53] {\n    display: none;\n}\n.unauth-header img.businessimgwhite[data-v-7063ff53] {\n    display: none;\n}\n.unauth-header img.playlistswhite[data-v-7063ff53] {\n    display: none;\n}\n.unauth-header img.businessimg[data-v-7063ff53] {\n    height: 30px;\n    width: 27px;\n    -o-object-fit: contain;\n       object-fit: contain;\n    display: inline;\n}\n.unauth-header img.playlistsimg[data-v-7063ff53] {\n    height: 30px;\n    width: 27px;\n    -o-object-fit: contain;\n       object-fit: contain;\n    display: inline;\n}\n}\nheader .nav-container .navbar-nav li a i.fa-newspaper-o[data-v-7063ff53] {\n  color: #999999;\n}\n.expiredmodal.modal .modal-header[data-v-7063ff53] {\n  text-align: center;\n  padding: 40px 20px 0px;\n}\n.expiredmodal.modal h2[data-v-7063ff53] {\n  font-weight: 900;\n  color: #000;\n  font-size: 32px;\n  text-align: center;\n}\n.expiredmodal.modal p[data-v-7063ff53] {\n  text-align: center;\n}\n.expiredmodal.modal .modal-header[data-v-7063ff53] {\n  border-bottom: 0;\n}\n.expiredmodal.modal .modal-body[data-v-7063ff53] {\n  padding: 0 60px 30px;\n}\n.expiredmodal.modal\nbutton.btn.formButton.btn-transparent[data-v-7063ff53] {\n  background: #f0617d;\n  padding: 8px 25px;\n  border-radius: 50px;\n  outline: 0 none transparent;\n  margin: 20px 0;\n  color: #ffffff;\n}\n.expiredmodal[data-v-7063ff53] {\n  z-index: 5000;\n}\n.modal-content a.close[data-v-7063ff53] {\n  /* color: #333; */\n  opacity: 1;\n  top: 10px !important;\n  position: absolute;\n  right: 18px;\n}\n.modal-content a.close[data-v-7063ff53]:after {\n  content: \"x\";\n  color: #000;\n  opacity: 1;\n  font-size: 30px;\n}\n@media (min-width: 768px) {\nul.nav.application-icons.navbar-nav.navbar-left.margin-left[data-v-7063ff53] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    -ms-flex-align: end;\n        align-items: flex-end;\n    -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n}\ndiv#header-navbar[data-v-7063ff53] {\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\nul.nav.navbar-nav.navbar-right.margin-minimum[data-v-7063ff53] {\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n}\n}\n.unauth-header i.nav-icon.podcasticon[data-v-7063ff53] {\n  background: url(\"https://s3.amazonaws.com/assets.tonenetworks.com/images/headphones-w.svg\") no-repeat center center transparent !important;\n}\ni.nav-icon.podcasticon[data-v-7063ff53] {\n  background: url(\"https://s3.amazonaws.com/assets.tonenetworks.com/images/headphones.svg\") no-repeat center center transparent !important;\n}\n@media (max-width: 767px) {\ni.nav-icon.podcasticon[data-v-7063ff53] {\n    background: url(\"https://s3.amazonaws.com/assets.tonenetworks.com/images/headphones.svg\") no-repeat center center transparent !important;\n}\n}\n@media (max-width: 767px) {\n.unauth-header i.nav-icon.podcasticon[data-v-7063ff53] {\n    background: url(https://s3.amazonaws.com/assets.tonenetworks.com/images/headphones.svg) no-repeat center center transparent !important;\n}\n}\n", ""]);

// exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.signUp .left-content .panel-body .row.calculations .form-control{\n    height: 40px;\n}\n.signUp .left-content .panel-body .row.calculations .help-block.with-errors {\n    padding-top: 0px;\n    margin: 0;\n    font-size: 12px;\n    letter-spacing: 0;\n}\n.signUp .left-content .panel-body .disabled {\n    opacity: 0.6;\n}\n", ""]);

// exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\nspan.heading[data-v-7113f34d] {\n        position: relative;\n        width: 100%;\n        display: block;\n        font-size: 19px;\n        font-weight: 500;\n        color: #a9a9a9;\n}\n.checkboxholder .radio[data-v-7113f34d] {\n        text-align: center;\n        border: 1px solid #ddd;\n        padding: 10px;\n}\n.checkboxholder[data-v-7113f34d] {\n}\n.checkboxholder .radio label[data-v-7113f34d] {\n        padding: 0;\n        letter-spacing: 0;\n}\n.checkboxholder .radio label span[data-v-7113f34d] {\n        display: block;\n}\n.checkboxholder .radio label input[data-v-7113f34d] {\n        position: relative;\n        margin: 20px 0;\n}\nspan.footertext[data-v-7113f34d] {\n        font-weight: 500;\n        color: #a9a9a9;\n}\nspan.plan-price[data-v-7113f34d] {\n        font-size: 34px;\n        font-weight: 900;\n        color: #a9a9a9;\n}\n.radio.popular[data-v-7113f34d]:before {\n        content: \"Most Popular Deal\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        line-height: 1.3;\n        background: #f0617d;\n        color: #fff;\n        transform: translatey(-100%);\n        margin-top: -10px;\n        padding: 5px 0;\n}\n.checkboxholder[data-v-7113f34d] {\n        padding-top: 30px;\n}\nspan.permonth[data-v-7113f34d] {\n        display: block;\n        font-size: 14px;\n}\nspan.plan-price[data-v-7113f34d] {\n        line-height: 1.2;\n        padding-top: 20px;\n}\n@media(max-width:767px){\n.radio.popular[data-v-3a43d266][data-v-7113f34d]:before {\n            position: absolute;\n            transform: translateY(-20px);\n}\n.radio.popular[data-v-7113f34d] {\n            padding-top: 30px !important;\n}\n}\n.StripeElement[data-v-7113f34d] {\n        background-color: white;\n        padding: 2em 1em;\n        border: 1px solid #ccc;\n        box-shadow: 0 1px 3px 0 #e6ebf1;\n        transition: box-shadow 150ms ease;\n        height: 34px;\n}\n.float-right.paymentswitch.btn-group[data-v-7113f34d] {\n        margin: 0 0 30px;\n}\n.StripeElement--focus[data-v-7113f34d] {\n        box-shadow: 0 1px 3px 0 #cfd7df;\n}\n.StripeElement--invalid[data-v-7113f34d] {\n        border-color: #fa755a;\n}\n.StripeElement--webkit-autofill[data-v-7113f34d] {\n        background-color: #fefde5 !important;\n}\n.radiowrapper[data-v-7113f34d] {\n        padding: 0 0px 10px;\n        color: #f0617d;\n}\ndiv#paypal-button[data-v-7113f34d] {\n    text-align: center;\n}\n.codediv[data-v-7113f34d] {\n    padding: 10px 0 0;\n}\n.codediv + .row.code[data-v-7113f34d] {\n    padding-top: 0;\n}\n@media(min-width:768px) {\n.row.code + label.terms-and-condition[data-v-7113f34d] {\n        margin: 0;\n}\n}\n.stripeholder[data-v-7113f34d] {\n}\n.codediv .stripeholder[data-v-7113f34d] {\n    margin-bottom: 20px;\n}\n.codediv .col-md-12[data-v-7113f34d] {\n    min-height: 0;\n}\n.showmobile[data-v-7113f34d]{\n        display:none;\n}\n.stripeholder[data-v-7113f34d] {\n        position: relative;\n}\ni.fa.fa-lock.overlapstripe[data-v-7113f34d] {\n        position: absolute;\n        left: 18px;\n        top: 10px;\n        font-size: 18px;\n        color: #b2b8c7;\n}\nbutton.redeem.btn.formButton.btn-block[data-v-7113f34d] {\n        margin: 0;\n}\n.row.code[data-v-7113f34d] {\n        padding-top: 20px;\n}\n@media (max-width:767px){\n.hidemobile[data-v-7113f34d]{\n            display:none;\n}\n.showmobile[data-v-7113f34d]{\n            display:inherit;\n}\n.signUp .left-content h4[data-v-7113f34d] {\n            font-size: 14px;\n            letter-spacing: 0px;\n}\n.signUp .main-content h2[data-v-7113f34d] {\n            margin: 15px 0;\n            line-height: 20px;\n            font-size: 18px;\n}\n.signUp #signup_pwderrormsg[data-v-7113f34d] {\n            margin-bottom: 8px;\n            line-height: 1.3;\n            letter-spacing: 1px;\n}\n.signUp .left-content .create-account #signup_button[data-v-7113f34d] {\n            margin: 0;\n}\n.signUp .right-content .jumbotron[data-v-7113f34d] {\n            padding: 6px;\n            margin-top: 7px;\n}\n.signUp .right-content .jumbotron h2[data-v-7113f34d] {\n            margin: 0;\n            font-size: 21px;\n}\n.signUp .right-content .jumbotron p[data-v-7113f34d] {\n            display: none;\n}\n.signUp .right-content .card[data-v-7113f34d] {\n            padding: 10px 10px;\n}\n.signUp .right-content .card .card-block .list-group li[data-v-7113f34d] {\n            font-size: 16px;\n            margin: 0 0 10px;\n}\n.signUp .left-content hr[data-v-7113f34d] {\n            display: none;\n}\n.row.margin-top[data-v-7113f34d] {\n            margin-top: 0px;\n}\ndiv#paypal-button[data-v-7113f34d] {\n\t\t\ttext-align: center!important;\n\t\t\ttop: -3px;\n}\n.codediv .stripeholder[data-v-7113f34d] {\n            margin-bottom: 10px;\n}\n}\n\n    /* Media query for mobile viewport */\n@media screen and (max-width: 400px) {\n#paypal-button-container[data-v-7113f34d] {\n            width: 100%;\n}\n}\n\n    /* Media query for desktop viewport */\n@media screen and (min-width: 400px) {\n#paypal-button-container[data-v-7113f34d] {\n            width: 250px;\n            display: inline-block;\n}\n}\nbutton.redeem.btn.formButton.btn-block[data-v-7113f34d] {\n        letter-spacing: 0;\n}\n.checkboxholder[data-v-7113f34d] {\n        padding-bottom: 10px;\n}\n.checkboxholder .checkbox[data-v-7113f34d] {\n        font-size: 16px;\n        letter-spacing: 3px;\n        margin: 15px 0;\n}\n.redoutlinebox[data-v-7113f34d] {\n        border: 2px solid #f0617d;\n        padding: 10px;\n        margin: 0px 0px 20px;\n        text-align: justify;\n}\n.checkboxholder .radio input[type=\"radio\"][data-v-7113f34d] {\n        opacity:1;\n        z-index:20;\n        top: 2px;\n}\nbody .margin-top[data-v-7113f34d] {\n        margin-top: 89px;\n        margin-bottom: 70px;\n}\nbody .signUp .right-content .card .card-block .list-group[data-v-7113f34d]{\n        margin-bottom:0px;\n}\n@media(min-width:768px){\n.row.calculations[data-v-7113f34d] {\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-align: baseline;\n                align-items: baseline;\n            margin: 10px 0;\n            background: #ededed;\n            padding: 10px;\n            border: 1px solid #ddd;\n}\n}\n@media(max-width: 767px){\n.row.calculations[data-v-7113f34d] {\n            -ms-flex-direction:column;\n                flex-direction:column;\n            background: #ededed;\n            padding: 10px;\n            border: 1px solid #ddd;\n}\n.row.calculations > div[data-v-7113f34d] {\n            margin:0 0 20px;\n}\n}\n.signUp .left-content .panel-body\n    .row.calculations .form-group[data-v-7113f34d] {\n        margin: 0;\n}\n\n\n", ""]);

// exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.validate .form[data-v-716462d9]{\n    text-align: left;\n    width: 40%;\n    margin: 50px auto;\n}\nh2.heading[data-v-716462d9] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 47px 0 35px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n    font-size: 30px;\n}\n.validate h1[data-v-716462d9]{\n    font-size: 32px;\n    color: #009cf6;\n    font-weight: lighter;\n    margin: 0 0 25px 0;\n}\n.validate p[data-v-716462d9]{\n    font-size: 14px;\n    color: #979797;\n    margin: 0;\n}\n.padding-minus[data-v-716462d9]{\n    padding:0;\n}\n.validate .form .form-input[data-v-716462d9]{\n    margin-bottom: 25px ;\n}\n.validate .form .forgotPassword[data-v-716462d9]{\n    float: right;\n    color: black\n}\n.validate .form .forgotPassword[data-v-716462d9]:hover{\n    float: right;\n    color: #337ab7;\n}\n.formButton[data-v-716462d9]{\n    margin: 25px 0 50px;\n    width: 130px;\n    height: 47px;\n    color: #91ab45;\n    border-color: #91ab45;\n    background-color: transparent;\n    transition: 0.5s;\n    padding:0;\n}\n.formButton a[data-v-716462d9]{\n    display: block;\n    padding: 13px 12px;\n    color: #91ab45;\n    text-decoration: none;\n    transition: 0.5s;\n}\n.formButton[data-v-716462d9]:hover{\n    border-color: #91ab45;\n    background-color: #91ab45;\n    transition: 0.5s;\n    color: #ffffff;\n}\n.btn-spinner[data-v-716462d9]{\n    bottom:15px\n}\n", ""]);

// exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.validate .form[data-v-75ef478a]{\n    text-align: left;\n    width: 40%;\n    margin: 50px auto;\n}\nh2.heading[data-v-75ef478a] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 47px 0 35px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n    font-size: 30px;\n}\n.validate h1[data-v-75ef478a]{\n    font-size: 32px;\n    color: #009cf6;\n    font-weight: lighter;\n    margin: 0 0 25px 0;\n}\n.validate p[data-v-75ef478a]{\n    font-size: 14px;\n    color: #979797;\n    margin: 0;\n}\n.padding-minus[data-v-75ef478a]{\n    padding:0;\n}\n.validate .form .form-input[data-v-75ef478a]{\n    margin-bottom: 25px ;\n}\n.validate .form .forgotPassword[data-v-75ef478a]{\n    float: right;\n    color: black\n}\n.validate .form .forgotPassword[data-v-75ef478a]:hover{\n    float: right;\n    color: #337ab7;\n}\n.formButton[data-v-75ef478a]{\n    margin: 25px 0 50px;\n    width: 130px;\n    height: 47px;\n    color: #91ab45;\n    border-color: #91ab45;\n    background-color: transparent;\n    transition: 0.5s;\n    padding:0;\n}\n.formButton a[data-v-75ef478a]{\n    display: block;\n    padding: 13px 12px;\n    color: #91ab45;\n    text-decoration: none;\n    transition: 0.5s;\n}\n.formButton[data-v-75ef478a]:hover{\n    border-color: #91ab45;\n    background-color: #91ab45;\n    transition: 0.5s;\n    color: #ffffff;\n}\n.btn-spinner[data-v-75ef478a]{\n    bottom:15px\n}\n", ""]);

// exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.validate .form[data-v-7d18a2b6]{\n    text-align: left;\n    width: 40%;\n    margin: 50px auto;\n}\nh2.heading[data-v-7d18a2b6] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 47px 0 35px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n    font-size: 30px;\n}\n.validate h1[data-v-7d18a2b6]{\n    font-size: 32px;\n    color: #009cf6;\n    font-weight: lighter;\n    margin: 0 0 25px 0;\n}\n.validate p[data-v-7d18a2b6]{\n    font-size: 14px;\n    color: #979797;\n    margin: 0;\n}\n.padding-minus[data-v-7d18a2b6]{\n    padding:0;\n}\n.validate .form .form-input[data-v-7d18a2b6]{\n    margin-bottom: 25px ;\n}\n.validate .form .forgotPassword[data-v-7d18a2b6]{\n    float: right;\n    color: black\n}\n.validate .form .forgotPassword[data-v-7d18a2b6]:hover{\n    float: right;\n    color: #337ab7;\n}\n.formButton[data-v-7d18a2b6]{\n    margin: 25px 0 50px;\n    width: 130px;\n    height: 47px;\n    color: #91ab45;\n    border-color: #91ab45;\n    background-color: transparent;\n    transition: 0.5s;\n    padding:0;\n}\n.formButton a[data-v-7d18a2b6]{\n    display: block;\n    padding: 13px 12px;\n    color: #91ab45;\n    text-decoration: none;\n    transition: 0.5s;\n}\n.formButton[data-v-7d18a2b6]:hover{\n    border-color: #91ab45;\n    background-color: #91ab45;\n    transition: 0.5s;\n    color: #ffffff;\n}\n.btn-spinner[data-v-7d18a2b6]{\n    bottom:15px\n}\n", ""]);

// exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.mainbanner img[data-v-7ea4666d] {\n    width: 100%;\n    max-height: 60vh;\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center center;\n       object-position: center center;\n}\n.profileimageanddata[data-v-7ea4666d] {\n    clear: both;\n    max-width: 1170px;\n    margin: auto;\n}\n.profileimage[data-v-7ea4666d] {\n    float: left;\n    width: 170px;\n    height: 170px;\n    border: 10px solid #fff;\n    transform: translateY(-50%);\n    box-shadow: 0px 0px 11px rgba(0,0,0,0.25);\n}\n.profileimage img[data-v-7ea4666d] {\n    width: 150px;\n    height: 150px;\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position:center center;\n       object-position:center center;\n}\n.textmatterholder[data-v-7ea4666d] {\n    float: left;\n    width: calc(100% - 170px);\n    text-align: left;\n    padding-left: 30px;\n    padding-top: 20px;\n}\n.tabs ul[data-v-7ea4666d] {\n    margin: 0 0;\n    padding: 0;\n    list-style: none;\n    display:-ms-flexbox;\n    display:flex;\n}\n.tabs ul li[data-v-7ea4666d] {\n    -ms-flex:1;\n        flex:1;\n    text-align: center;\n    float: left;\n    padding: 20px;\n    font-size: 21px;\n    font-weight: 900;\n    border-bottom:1px solid #333;\n}\n.tabs li.current[data-v-7ea4666d]{\n    border-bottom:1px solid #f0617d;\n}\nli.current a[data-v-7ea4666d] {\n    color: #f0617d;\n}\nli a[data-v-7ea4666d] {\n    color: #333;\n}\n.tabs[data-v-7ea4666d]:after {\n    content: \"\";\n    display: table;\n    clear: both;\n    width: 100%;\n}\n.introparacard[data-v-7ea4666d] {\n    padding-top: 30px;\n    text-align: left;\n}\n.introparacard img[data-v-7ea4666d] {\n    max-width: 100%;\n}\n.introparacard blockquote[data-v-7ea4666d] {\n    text-align: center;\n    border: 0 none transparent;\n    padding: 0;\n    margin: 20px 0 0;\n    font-weight: 700;\n    font-style: italic;\n}\nhr.redhr[data-v-7ea4666d] {\n    border-color: #f0617d;\n    max-width: 575px;\n}\n@media(max-width:767px){\nli a[data-v-7ea4666d] {\n        font-size: 14px;\n}\n.textmatterholder[data-v-7ea4666d] {\n        width: 100%;\n        padding: 0 20px;\n}\n.profileimage[data-v-7ea4666d] {\n        float: none;\n        margin: auto;\n        transform: translateY(-20px);\n}\n}\n.imgresponsive img[data-v-7ea4666d] {\n    width: 100%;\n    height: auto;\n}\n.large-text[data-v-7ea4666d] {\n    font-size: 16px;\n}\n\n\n\n/* css for the video popup*/\nbutton#videoplayer_videoredirect[data-v-7ea4666d] {\n    border-radius: 5px;\n    font-weight: 700;\n}\nbutton#videoplayer_videostay[data-v-7ea4666d] {\n    background: white;\n    color: #44bda8;\n    border: 1px solid #44bda8;\n    white-space: normal;\n    line-height: 1;\n    padding: 6px;\n    border-radius: 5px;\n}\n.watchVideoModal .modal-dialog .modal-body p[data-v-7ea4666d] {\n    padding: 16px 60px 19px 60px;\n}\n.watchVideoModal.modal.zoom.in[data-v-7ea4666d] {\n    z-index: 500000;\n}\n.sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader[data-v-7ea4666d] {\n    background: #f0617d;\n    color: #fff;\n    font-size: 25px;\n    text-align: left;\n    padding: 15px 25px;\n    font-weight: 700;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body p[data-v-7ea4666d]{\n    padding: 0;\n    margin: 0 0 20px;\n}\n.row.sharefb[data-v-7ea4666d] {\n    background: #eee;\n    margin-left: 0;\n    margin-right: 0;\n}\n.row.sharefb > div[data-v-7ea4666d] {\n    padding: 5px;\n    text-align: left;\n}\n.row.sharefb .col-sm-5 img[data-v-7ea4666d] {\n    max-width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-7ea4666d] {\n    font-size: 14px;\n    font-weight: 300;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6[data-v-7ea4666d] {\n    text-transform: uppercase;\n    font-size: 12px;\n    margin: 10px 0 5px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4[data-v-7ea4666d] {\n    margin: 0 0 5px;\n    font-weight:700;\n}\n.row.buttonsinpopup[data-v-7ea4666d] {\n    padding-top: 20px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-7ea4666d] {\n    background: #fff;\n    color: #333;\n    border: 1px solid #cacaca;\n    width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body[data-v-7ea4666d] {\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink[data-v-7ea4666d] {\n    background: #f0617d;\n    width: 100%;\n    margin: 0;\n    border: 1px solid #f0617d;\n}\n.usernamenimg.text-left table[data-v-7ea4666d] {\n    max-width: 100%;\n    margin: 0 0 20px;\n    width: 190px;\n}\na.popupsharingoptionlink[data-v-7ea4666d] {\n    display: block;\n    color: #fff;\n    text-decoration: none;\n    max-width: 150px;\n    font-size: 18px;\n    font-weight: 700;\n    padding-top: 15px;\n    text-align: center;\n}\na.popupsharingoptionlink i[data-v-7ea4666d]:before {\n    color: #fff;\n}\na.popupsharingoptionlink i.fa.fa-share-square-o[data-v-7ea4666d] {\n    margin: 0;\n    font-size: 20px;\n    /* display: block; */\n}\n.strongselec[data-v-7ea4666d]{\n    font-weight:700;\n}\n@media(max-width:475px){\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-7ea4666d] {\n        padding-left: 0;\n        padding-right: 0;\n}\n}\n.showmobile[data-v-7ea4666d]{display:none;\n}\n@media(max-width:767px){\n.usernamenimg.text-left[data-v-7ea4666d] {\n        display: none;\n}\n.showmobile[data-v-7ea4666d]{\n        display: block;\n}\n.alert.alert-default[data-v-7ea4666d] {\n        background: #eee;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-7ea4666d] {\n        display: none;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow[data-v-7ea4666d] {\n        top: 1px;\n        right: -13px;\n}\n.row.sharefb[data-v-7ea4666d] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.pinksidebarmin[data-v-7ea4666d]{\n        padding:0 !important;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        -ms-flex-preferred-size: auto;\n            flex-basis: auto;\n        display: flex ;\n        -ms-flex-align: stretch ;\n            align-items: stretch ;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.pinksidebarmin > *[data-v-7ea4666d] {\n        padding: 6px 0 !important;\n        margin: 0 !important;\n        -ms-flex: 100;\n            flex: 100;\n        text-align:center;\n}\n}\n/* css for the video popup ends*/\n@media(min-width:768px) {\n.sliderimage[data-v-7ea4666d] {\n        width: 100%;\n        /* height: 200px;*/\n        -o-object-fit: cover;\n           object-fit: cover;\n        -o-object-position: center;\n           object-position: center;\n}\n}\n.row.video-row.plistisrow img[data-v-7ea4666d] {\n    max-width: 80%;\n}\n.row.video-row.plistisrow .col-sm-6[data-v-7ea4666d] {\n    text-align: left;\n}\n.pinksidebarmin[data-v-7ea4666d] {\n    float: right;\n    width: 20%;\n    background: #f0617d;\n    text-align: center;\n    padding: 20px;\n}\n.pinkbg[data-v-7ea4666d] {background: #f0617d;\n}\n.pinksidebarmin > *[data-v-7ea4666d] {\n    font-size: 25px;\n    color: #fff;\n    cursor: pointer;\n    margin:20px 0;\n}\n@media(min-width:768px){\n.row.video-row.plistisrow .pinkbg img[data-v-7ea4666d] {\n        height: 205px;\n        -o-object-fit: cover;\n           object-fit: cover;\n}\n.pinksidebarmin[data-v-7ea4666d] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        height: 205px;\n        -ms-flex-align: center;\n            align-items: center;\n        -ms-flex-pack: distribute;\n            justify-content: space-around;\n}\n.pinksidebarmin > *[data-v-7ea4666d] {\n        font-size: 25px;\n        color: #fff;\n        cursor: pointer;\n        padding:0;\n        margin:0;\n}\n}\n.col-sm-6.pltext[data-v-7ea4666d] {\n    cursor: pointer;\n    font-size: 16px;\n}\n.pltext h3[data-v-7ea4666d] {\n    text-decoration: underline;\n}\n.clearfix[data-v-7ea4666d] {\n    clear: both;\n}\n.incaseumi[data-v-7ea4666d] {\n    font-size: 18px;\n}\n.incaseumi img[data-v-7ea4666d] {\n    width: 100%;\n}\n.borderedbox[data-v-7ea4666d] {\n    border: 1px solid #ddd;\n    padding: 15px;\n    margin: 10px 0;\n    font-size: 16px;\n}\n.pinnedmsgs[data-v-7ea4666d] {\n    text-align: left;\n}\n.pinnedmsgs h3[data-v-7ea4666d] {\n    color: #f0617d;\n}\n.row.video-row.plistisrow .videoholdersuggestions img[data-v-7ea4666d] {\n    width: 100%;\n    max-width: none;\n    cursor: pointer;\n}\n.videoholdersuggestions[data-v-7ea4666d]{\n    margin:0 0 30px;\n}\n.videoholdersuggestions h3[data-v-7ea4666d] {\n    text-align: center;\n    font-weight: 900;\n    cursor: pointer;\n}\n.videoholdersuggestions p[data-v-7ea4666d] {\n    font-size: 18px;\n}\n.row.video-row.plistisrow.lowerlist .col-sm-6[data-v-7ea4666d]:nth-of-type(odd) {\n    clear: left;\n}\n.smallimgholder[data-v-7ea4666d] {text-align: center;padding: 10px;box-shadow: 0 0 5px rgba(0,0,0,0.5);\n}\n.smallimgholder img[data-v-7ea4666d] {\n    height: auto;\n    width: 100%;\n}\n@media(max-width:991px){\n.hidemobile[data-v-7ea4666d] {\n        display: none;\n}\n.smallimgholder[data-v-7ea4666d] {\n        max-width: 300px;\n        margin: 0 auto;\n}\n}\n@media(max-width:991px){\n.tabs ul[data-v-7ea4666d] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: stretch;\n            align-items: stretch;\n        -ms-grid-column-align: stretch;\n            justify-items: stretch;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.tabs ul li[data-v-7ea4666d]{\n        width: auto;\n        padding: 20px 0;\n        -ms-flex: 1;\n            flex: 1;\n}\nimg.sliderimage[data-v-7ea4666d] {\n        max-width: 100%;\n}\n}\n.row.yourFaves p.text-wrap-title.cursor[data-v-7ea4666d] {\n    font-size: 16px;\n    font-weight: 500;\n    color: #000;\n    text-align: left;\n    line-height: 1.5;\n}\n.row.yourFaves[data-v-7ea4666d] {\n    padding-top: 20px;\n}\n@media(min-width:992px) and (max-width:1200px){\n.tabs ul li[data-v-7ea4666d] {\n        padding-right: 5px !important;\n        padding-left: 5px !important;\n}\n}\n.m-auto[data-v-7ea4666d] {\n    margin: auto;\n    float: none;\n}\n", ""]);

// exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.container-icons.vpage > div > span {\n    display: inline-block;\n    background: #f0617d;\n    height: 50px;\n    width: 50px;\n    color: #fff;\n    text-align: center;\n    line-height: 60px;\n    border-radius: 50%;\n}\n.container-icons.vpage {\n    text-align: right;\n}\n@media(min-width:320px) and (max-width:767px){\n.video-player.autoheight {\n        height: auto;\n}\n.autoheight.video-player .jwplayer.jw-flag-aspect-mode {\n        height: auto !important;\n}\n}\n.autoheight div.jw-error.jw-reset {\n    height: 25vw !important;\n}\n.video-player .left-video-icons{\n    height: 25vw !important;\n}\n.autoheight{\n    height: auto !important;\n    padding-bottom:20px;\n}\n", ""]);

// exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n@media(max-width:768px){\n.row.morevediosrow[data-v-86595488] {\n        margin: 0;\n}\n}\na[data-v-86595488] {\n    cursor: pointer !important;\n}\n.video-player-wrapper .watch-again .current-video-img img[data-v-86595488] {\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.video-player .right-video-icons .enjoy-hover-box[data-v-86595488] {\n    width: 20%;\n    height: 100%;\n    background: #f0617d;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 15% 0px 0;\n    text-align: left;\n}\n.video-player .right-video-icons .enjoy-hover-box button.btn[data-v-86595488] {\n    margin: 0 0 10px;\n    border-color: white;\n    border-radius: 3px;\n    padding: 12px 0 13px;\n    display: block;\n    width: 80%;\n    margin: 0px auto 10px;\n    color: #fff;\n}\n.video-player-wrapper .tooltipBox[data-v-86595488] {\n    width: 100%;\n    text-align: center;\n    padding-bottom: 10px;\n    height: 35px;\n    margin-top: 24px;\n}\n.row.morevediosrow img[data-v-86595488] {\n    max-width: 100%;\n}\n.clearfix[data-v-86595488] {\n    clear: both;\n}\n.gap[data-v-86595488] {\n    height: 30px;\n}\nh3.pinkheading[data-v-86595488] {\n    color: #f0617d;\n    font-size: 28px;\n    letter-spacing: 2px;\n    margin: 10px 0 20px;\n}\nul.pinkheading li  a[data-v-86595488] {\n}\nul.pinkheading li[data-v-86595488] {\n    margin: 5px 0 5px;\n}\nul.pinkheading[data-v-86595488] {\n    margin: 0;\n    padding: 0;\n    font-size: 19px;\n    font-weight: 900;\n    list-style: none;\n}\n/*.row.morevediosrow > div:after {*/\n    /*content: \"\\f04b\";*/\n    /*font-family: fontawesome;*/\n    /*position: absolute;*/\n    /*top: 50%;*/\n    /*left: 50%;*/\n    /*transform: translateX(-50%) translateY(-50%);*/\n    /*color: rgba(255, 255, 255, 0.75);*/\n    /*font-size: 78px;*/\n    /*height: 120px;*/\n    /*width: 120px;*/\n    /*line-height: 107px;*/\n    /*border: 5px solid;*/\n    /*border-radius: 50%;*/\n    /*text-align: center;*/\n    /*padding-left: 22px;*/\n    /*cursor: pointer;*/\n/*}*/\n@media (min-width:768px) {\n.video-player .right-video-icons .enjoy-hover-box[data-v-86595488] {\n        padding: 117px 0px 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating[data-v-86595488] {\n        overflow: hidden;\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating p[data-v-86595488] {\n        color: white;\n        display: block;\n        font-size: 16px;\n        letter-spacing: 0.5px;\n        margin-top: 23px;\n        margin-bottom: 20px;\n        padding: 0 10%;\n        text-align: center;\n}\n}\n.video-player .right-video-icons .rate-hover-box span[data-v-86595488] {\n    margin-bottom: 20px;\n}\n.video-player .right-video-icons .rate-hover-box button[data-v-86595488]:hover {\n    background: #ac2925;\n}\n.video-player .btn-danger[data-v-86595488]:focus {\n    background: inherit;\n    border-color: inherit;\n    outline: none;\n}\n.video-player .right-video-icons div button.btn-danger[data-v-86595488]:hover{\n    background:rgba(0,0,0,0.1);\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-86595488]:hover{\n    background:#ac2925;\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-86595488]:focus{\ncolor: #fff;\nbackground-color: #ac2925;\nborder-color: #fff;\n}\n.profile-content img[data-v-86595488] {\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center center;\n       object-position: center center;\n}\n.video-player .left-video-icons[data-v-86595488] {\n    background: white;\n    color: white;\n    width: 15%;\n    float: left;\n    height: 100%;\n}\nh3.errormessage[data-v-86595488] {\n    color: #f0617d;\n    letter-spacing: 3px;\n    margin: 70px 20px;\n}\n@media(max-width:767px){\n.row.morevediosrow img[data-v-86595488] {\n        margin:0 0 10px;\n}\n}\n.row.morevediosrow p.text-wrap-title.cursor[data-v-86595488] {\n    font-size: 20px;\n    text-align: left;\n    color: #000;\n}\n.container-icons > div > span[data-v-86595488] {\n    display: inline-block;\n    background: #f0617d;\n    height: 50px;\n    width: 50px;\n    color: #fff;\n    text-align: center;\n    line-height: 60px;\n    border-radius: 50%;\n}\np.text-wrap-title.cursor[data-v-86595488] {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\nh2.pink-text-headline[data-v-86595488] {\n    margin: 30px 0 30px;\n}\np.video-description[data-v-86595488] {\n    font-size: 23px;\n}\n.row.morevediosrow p.text-wrap-title.cursor[data-v-86595488] {\n    font-size: 20px;\n}\n.tabContent p.text-wrap-title.cursor[data-v-86595488] {\n    font-size: 17px;\n}\n.show-video-class[data-v-86595488] {\n    max-width: 920px;\n    margin: auto;\n}\np.thumbnail-messaing[data-v-86595488] {\n    background: #44bda8;\n    width: 720px;\n    margin: auto;\n    padding: 10px;\n    color: white;\n    font-size: 16px;\n}\np.thumbnail-messaing a[data-v-86595488] {\n    color: inherit;\n    text-decoration: underline;\n}\n@media(max-width:767px){\n.show-video-thumbnail img[data-v-86595488] {\n        width: 100%;\n}\np.thumbnail-messaing[data-v-86595488] {\n        max-width: 100%;\n}\n}\n.makeitgray[data-v-86595488] {            /* CSS3 filter, WebKit kernel, Firefox outside the most modern browsers*/\n    -moz-filter: grayscale(100%);            /* There is no implementation */\n    -ms-filter: grayscale(100%);\n    -o-filter: grayscale(100%);\n    filter: grayscale(100%);            /* CSS3 filter, standard*/\n    filter: gray;                       /* IE 6-9 */\n    opacity: 0.8;\n}\n.centered-msg[data-v-86595488] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n", ""]);

// exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*.socialicons i{*/\n    /*margin-right:30px;*/\n/*}*/\n/*@media(max-width:767px) {*/\n    /*.socialicons i {*/\n        /*color: #333;*/\n    /*}*/\n/*}*/\n", ""]);

// exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.socialicons  > .holder .fa {\n    color: #fff;\n    line-height: 42px;\n    width: 42px;\n    text-align: center;\n    display: block;\n    letter-spacing: 0;\n}\n.socialicons  > .holder {\n    background: #f0617d;\n    width: 42px;\n    display: inline-block;\n    height: 42px;\n    line-height: 42px;\n    border-radius: 50%;\n}\n.socialicons > a img {\n    max-width: 42px;\n}\n@media(min-width:768px){\n.socialicons  > .holder {\n        margin: 0 0 20px;\n        display:block;\n}\n.over-lay .row {\n        min-height: 450px;\n}\n}\n", ""]);

// exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.socialicons[data-v-8baefe52] {\n        color: #f0617d;\n        letter-spacing: 10px;\n}\n@media(max-width:767px) {\n.socialicons[data-v-8baefe52] {\n            color: #f0617d;\n            margin: 20px 0 0;\n}\n}\nh2.heading[data-v-8baefe52] {\n        color: #f0617d;\n        text-transform: capitalize;\n        margin: 47px 0 35px 0;\n        letter-spacing: 0.5px;\n        font-family: sans-serif;\n        font-size: 30px;\n}\n.aboutlogoholder[data-v-8baefe52] {\n        min-height: 300px;\n        line-height: 300px;\n}\n.mtop30[data-v-8baefe52] {\n        margin-top: 30px;\n}\n.row.aboutrow p[data-v-8baefe52] {\n        font-size: 17px;\n        text-align: left;\n        line-height: 1.3;\n        letter-spacing: 2px;\n}\nh3[data-v-8baefe52] {\n        color: #f0617d;\n        letter-spacing: 4px;\n        font-size: 24px;\n        line-height: 1.5;\n        margin: 30px 0 20px;\n}\nh4[data-v-8baefe52] {\n        color: #454545;\n        letter-spacing: 2px;\n        font-size: 18px;\n        text-align: left;\n        line-height: 1.5;\n\t\tfont-weight:700;\n}\nh4.welcomemessage[data-v-8baefe52] {\n        text-align: center;\n        margin: 50px 0 0;\n        color: inherit;\n        color: #f0617d;\n}\nh2.welcomemessage[data-v-8baefe52] {\n        letter-spacing: 8px;\n        margin: 20px 0 60px;\n        text-transform: uppercase;\n}\n.slide-player img[data-v-8baefe52] {\n        max-width: 100%;\n}\n@media(max-width:480px){\nbody h4[data-v-8baefe52] {\n            font-size: 18px !important;\n}\nh3[data-v-8baefe52] {\n            font-size: 24px !important;\n            line-height: 1.1 !important;\n}\nh2.welcomemessage[data-v-8baefe52] {\n            letter-spacing: 3px !important;\n}\n}\n.over-lay[data-v-8baefe52] {\n    /*background-image: url(https://s3.amazonaws.com/tone-assets/images/TONEGiftingHolidays.jpg);background-repeat: no-repeat;*/\n    // background-image: url(" + __webpack_require__(116) + ");background-repeat: no-repeat;\n    background-size: cover;\n    background-position: 50% 50%;\n    width: 100%;\n    display: inline-block;\n    padding: 50px 0 50px;\n}\n.over-lay .main-heading p[data-v-8baefe52] {\n    margin-top: 15px;\n    font-size: 20px;\n    line-height: 31px;\n    font-family: \"Quicksand\", sans-serif;\n}\n.over-lay ul[data-v-8baefe52] {\n    margin: 30px 0 0;\n    padding: 0;\n}\n.over-lay ul[data-v-8baefe52] {\n    font-size: 27px;\n    font-weight: 500;\n    line-height: 1.2;\n}\n.over-lay ul li[data-v-8baefe52] {\n    list-style: none;\n    margin: 0 0 0px;\n}\n.main-heading .btn[data-v-8baefe52] {\n        margin: 30px 0;\n        font-size: 24px;\n}\n.showMobile[data-v-8baefe52]{display:block;\n}\n@media(min-width:768px){\n.showMobile[data-v-8baefe52]{display:none;\n}\n.over-lay h1[data-v-8baefe52] {\n    color: #fff;\n\tclear:both;\n}\n.over-lay ul li[data-v-8baefe52]:nth-child(1) {\n    clear: left;\n    float: left;\n    margin-right: 10px;\n}\n.over-lay .container[data-v-8baefe52] {\n        max-width: 95%;\n        width: 100%;\n}\n}\n.over-lay[data-v-8baefe52]:before {\n        z-index:5;\n        background-image:url(" + __webpack_require__(341) + ");\n        /*content:\"\";*/\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-size: cover !important;\n        background-position: left top !important;\n}\n.over-lay[data-v-8baefe52] {\n    position: relative;\n}\n.over-lay .container[data-v-8baefe52] {\n    position: relative;\n    z-index: 10;\n\tcolor:#fff;\n}\nul.tonepoints[data-v-8baefe52] {\n    font-size: 18px;\n    letter-spacing: 2px;\n}\nul.tonepoints li[data-v-8baefe52] {\n    margin: 0 0 20px;\n}\n@media (max-width:767px){\n.over-lay.text-left[data-v-8baefe52] {\n        background-image: none;\n        padding: 20px 0;\n        color: #333 !important;\n}\n.main-heading .btn[data-v-8baefe52] {\n        margin: 10px 0 30px;\n        font-size: 24px;\n}\n.over-lay[data-v-8baefe52]:before , .over-lay[data-v-8baefe52]:after {\n        display: none;\n}\n.over-lay h1[data-v-8baefe52] {\n        color: #343434;\n}\n.over-lay .main-heading p[data-v-8baefe52] {\n        color: #343434;\n}\n.over-lay ul li[data-v-8baefe52] {\n        color: #343434;\n}\n}\n.row.aboutrow[data-v-8baefe52] {\n        padding-bottom: 50px;\n}\n/*gift section classes*/\n.gift-item[data-v-8baefe52]:before {\n    background: url(" + __webpack_require__(76) + ");\n\tcontent:\"\";\n    height: 150px;\n    display: block;\n    /* width: 100%; */\n    position: absolute;\n    background-position: center !important;\n    background-repeat: no-repeat !important;\n    transform: translateY(-50%);\n    /* margin: 120px 0 0; */\n    /* top: -30px; */\n    top: 0;\n    right: 0;\n    left: 0;\n}\n.gift-item[data-v-8baefe52] {\n    background: #54d9ec;\n    color: #fff;\n    margin: 120px 0 0;\n    padding: 80px 20px 20px;\n    position: relative;\n    text-align: center;\n}\n@media(min-width:768px){\n}\n@media(max-width:767px){\n.vedioplayerholder[data-v-8baefe52] {\n            margin-top: 20px;\n}\n}\n\n    /*social icons settings*/\n@media(min-width:768px){\n.socialicons[data-v-8baefe52] {\n            position: absolute;\n            right: 30px;\n            width: 20px;\n            top:calc(100% + 70px);\n}\n.over-lay .col-sm-5[data-v-8baefe52] {\n            position: static;\n}\n.socialicons span[data-v-8baefe52] {\n            margin: 0 0 20px;\n            display: block;\n}\n}\n@media(min-width:992px){\n.socialicons[data-v-8baefe52] {\n            top: calc(100% + 70px);\n}\n}\n@media(min-width:1200px){\n.socialicons[data-v-8baefe52] {\n            top: calc(100% + 70px);\n}\n}\n@media(max-width:767px){\n.hideMobile[data-v-8baefe52] {\n            display: none;\n}\n.over-lay ul[data-v-8baefe52]{\n            font-size:22px;\n}\n}\n@media(min-width:768px) {\n.over-lay ul[data-v-8baefe52], .over-lay H1[data-v-8baefe52] {\n            text-shadow: 0 3px 6px rgba(0, 0, 0, 0.5);\n}\n}\n", ""]);

// exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.liveEvent ul.slick-dots {\n    display: none !important;\n}\n.btn-pink{\n    margin: 10px auto;\n    display: block;\n    float: none;\n}\n", ""]);

// exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n@media(min-width:1200px){\n.liveEvent .col-md-offset-3.col-md-6 iframe[data-v-915672dc] {\n    position:static !important;\n}\n.liveEvent .col-md-offset-3.col-md-6[data-v-915672dc] {\n\n        z-index: 20;\n        position:relative;\n        margin-bottom: 50px;\n}\n.attendees[data-v-915672dc] {\n        position: relative;\n        margin-top: 70px;\n        left: 0;\n        right: 0;\n        z-index: 10;\n}\n.liveEvent[data-v-915672dc] {\n        position: relative;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage[data-v-915672dc] {\n        width: 20%;\n}\n.liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage[data-v-915672dc]:nth-of-type(12), .liveEventContent .liveEvent .attendeesContent .liveEventImage .sliderBox .liveImage[data-v-915672dc]:nth-of-type(14) {\n        /*margin-right: 60%;*/\n}\n}\n", ""]);

// exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.set-error[data-v-94815cf4]{\n    border-color: #a94442 !important;\n    color:#a94442 !important;\n}\n.StripeElement[data-v-94815cf4] {\n    background-color: white;\n    padding: 2em 1em;\n    border: 1px solid #ccc;\n    box-shadow: 0 1px 3px 0 #e6ebf1;\n    transition: box-shadow 150ms ease;\n    height: 34px;\n}\n.float-right.paymentswitch.btn-group[data-v-94815cf4] {\n    margin: 0 0 30px;\n}\n.StripeElement--focus[data-v-94815cf4] {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n}\n.StripeElement--invalid[data-v-94815cf4] {\n    border-color: #fa755a;\n}\n.StripeElement--webkit-autofill[data-v-94815cf4] {\n    background-color: #fefde5 !important;\n}\n.radiowrapper[data-v-94815cf4] {\n    padding: 0 0px 10px;\n    color: #f0617d;\n}\ndiv#paypal-button[data-v-94815cf4] {\n    text-align: center;\n}\n.codediv[data-v-94815cf4] {\n    padding: 10px 0 0;\n}\n.codediv + .row.code[data-v-94815cf4] {\n    padding-top: 0;\n}\n@media(min-width:768px) {\n.row.code + label.terms-and-condition[data-v-94815cf4] {\n        margin: 0;\n}\n}\n.stripeholder[data-v-94815cf4] {\n}\n.codediv .stripeholder[data-v-94815cf4] {\n    margin-bottom: 20px;\n}\n.codediv .col-md-12[data-v-94815cf4] {\n    min-height: 0;\n}\n.showmobile[data-v-94815cf4]{\n    display:none;\n}\n.stripeholder[data-v-94815cf4] {\n    position: relative;\n}\ni.fa.fa-lock.overlapstripe[data-v-94815cf4] {\n    position: absolute;\n    left: 18px;\n    top: 10px;\n    font-size: 18px;\n    color: #b2b8c7;\n}\nbutton.redeem.btn.formButton.btn-block[data-v-94815cf4] {\n    margin: 0;\n}\n.row.code[data-v-94815cf4] {\n    padding-top: 20px;\n}\n@media (max-width:767px){\n.hidemobile[data-v-94815cf4]{\n        display:none;\n}\n.showmobile[data-v-94815cf4]{\n        display:inherit;\n}\n.signUp .left-content h4[data-v-94815cf4] {\n        font-size: 14px;\n        letter-spacing: 0px;\n}\n.signUp .main-content h2[data-v-94815cf4] {\n        margin: 15px 0;\n        line-height: 20px;\n        font-size: 18px;\n}\n.signUp #signup_pwderrormsg[data-v-94815cf4] {\n        margin-bottom: 8px;\n        line-height: 1.3;\n        letter-spacing: 1px;\n}\n.signUp .left-content .create-account #signup_button[data-v-94815cf4] {\n        margin: 0;\n}\n.signUp .right-content .jumbotron[data-v-94815cf4] {\n        padding: 6px;\n        margin-top: 7px;\n}\n.signUp .right-content .jumbotron h2[data-v-94815cf4] {\n        margin: 0;\n        font-size: 21px;\n}\n.signUp .right-content .jumbotron p[data-v-94815cf4] {\n        display: none;\n}\n.signUp .right-content .card[data-v-94815cf4] {\n        padding: 10px 10px;\n}\n.signUp .right-content .card .card-block .list-group li[data-v-94815cf4] {\n        font-size: 16px;\n        margin: 0 0 10px;\n}\n.signUp .left-content hr[data-v-94815cf4] {\n        display: none;\n}\n.row.margin-top[data-v-94815cf4] {\n        margin-top: 0px;\n}\ndiv#paypal-button[data-v-94815cf4] {\n        text-align: center!important;\n        top: -3px;\n}\n.codediv .stripeholder[data-v-94815cf4] {\n        margin-bottom: 10px;\n}\n}\n\n/* Media query for mobile viewport */\n@media screen and (max-width: 400px) {\n#paypal-button-container[data-v-94815cf4] {\n        width: 100%;\n}\n}\n\n/* Media query for desktop viewport */\n@media screen and (min-width: 400px) {\n#paypal-button-container[data-v-94815cf4] {\n        width: 250px;\n        display: inline-block;\n}\n}\nbutton.redeem.btn.formButton.btn-block[data-v-94815cf4] {\n    letter-spacing: 0;\n}\n.checkboxholder[data-v-94815cf4] {\n    padding-left: 2px;\n    padding-bottom: 5px;\n}\n.checkboxholder .checkbox[data-v-94815cf4] {\n    font-size: 16px;\n    letter-spacing: 3px;\n    margin: 15px 0;\n}\n.redoutlinebox[data-v-94815cf4] {\n    border: 2px solid #f0617d;\n    padding: 10px;\n    margin: 0px 0px 20px;\n    text-align: justify;\n}\n.checkboxholder .radio input[type=\"radio\"][data-v-94815cf4] {\n    opacity:1;\n    z-index:20;\n    top: 2px;\n}\nbody .margin-top[data-v-94815cf4] {\n    margin-top: 89px;\n    margin-bottom: 70px;\n}\nbody .signUp .right-content .card .card-block .list-group[data-v-94815cf4]{\n    margin-bottom:0px;\n}\n", ""]);

// exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.container-icons.vpage > div > span {\n    display: inline-block;\n    background: #f0617d;\n    height: 50px;\n    width: 50px;\n    color: #fff;\n    text-align: center;\n    line-height: 60px;\n    border-radius: 50%;\n}\n.container-icons.vpage {\n    text-align: right;\n}\n@media(min-width:320px) and (max-width:767px){\n.video-player.autoheight {\n        height: auto;\n}\n.autoheight.video-player .jwplayer.jw-flag-aspect-mode {\n        height: auto !important;\n}\n}\n.autoheight div.jw-error.jw-reset {\n    height: 25vw !important;\n}\n.video-player .left-video-icons{\n    height: 25vw !important;\n}\n.autoheight{\n    height: auto !important;\n    padding-bottom:20px;\n}\n", ""]);

// exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n@media(max-width:768px){\n.row.morevediosrow[data-v-9fb45a86] {\n        margin: 0;\n}\n}\na[data-v-9fb45a86] {\n    cursor: pointer !important;\n}\n.video-player-wrapper .watch-again .current-video-img img[data-v-9fb45a86] {\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.video-player .right-video-icons .enjoy-hover-box[data-v-9fb45a86] {\n    width: 20%;\n    height: 100%;\n    background: #f0617d;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 15% 0px 0;\n    text-align: left;\n}\n.video-player .right-video-icons .enjoy-hover-box button.btn[data-v-9fb45a86] {\n    margin: 0 0 10px;\n    border-color: white;\n    border-radius: 3px;\n    padding: 12px 0 13px;\n    display: block;\n    width: 80%;\n    margin: 0px auto 10px;\n    color: #fff;\n}\n.video-player-wrapper .tooltipBox[data-v-9fb45a86] {\n    width: 100%;\n    text-align: center;\n    padding-bottom: 10px;\n    height: 35px;\n    margin-top: 24px;\n}\n.row.morevediosrow img[data-v-9fb45a86] {\n    max-width: 100%;\n}\n.clearfix[data-v-9fb45a86] {\n    clear: both;\n}\n.gap[data-v-9fb45a86] {\n    height: 30px;\n}\nh3.pinkheading[data-v-9fb45a86] {\n    color: #f0617d;\n    font-size: 28px;\n    letter-spacing: 2px;\n    margin: 10px 0 20px;\n}\nul.pinkheading li  a[data-v-9fb45a86] {\n}\nul.pinkheading li[data-v-9fb45a86] {\n    margin: 5px 0 5px;\n}\nul.pinkheading[data-v-9fb45a86] {\n    margin: 0;\n    padding: 0;\n    font-size: 19px;\n    font-weight: 900;\n    list-style: none;\n}\n/*.row.morevediosrow > div:after {*/\n    /*content: \"\\f04b\";*/\n    /*font-family: fontawesome;*/\n    /*position: absolute;*/\n    /*top: 50%;*/\n    /*left: 50%;*/\n    /*transform: translateX(-50%) translateY(-50%);*/\n    /*color: rgba(255, 255, 255, 0.75);*/\n    /*font-size: 78px;*/\n    /*height: 120px;*/\n    /*width: 120px;*/\n    /*line-height: 107px;*/\n    /*border: 5px solid;*/\n    /*border-radius: 50%;*/\n    /*text-align: center;*/\n    /*padding-left: 22px;*/\n    /*cursor: pointer;*/\n/*}*/\n@media (min-width:768px) {\n.video-player .right-video-icons .enjoy-hover-box[data-v-9fb45a86] {\n        padding: 117px 0px 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating[data-v-9fb45a86] {\n        overflow: hidden;\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating p[data-v-9fb45a86] {\n        color: white;\n        display: block;\n        font-size: 16px;\n        letter-spacing: 0.5px;\n        margin-top: 23px;\n        margin-bottom: 20px;\n        padding: 0 10%;\n        text-align: center;\n}\n}\n.video-player .right-video-icons .rate-hover-box span[data-v-9fb45a86] {\n    margin-bottom: 20px;\n}\n.video-player .right-video-icons .rate-hover-box button[data-v-9fb45a86]:hover {\n    background: #ac2925;\n}\n.video-player .btn-danger[data-v-9fb45a86]:focus {\n    background: inherit;\n    border-color: inherit;\n    outline: none;\n}\n.video-player .right-video-icons div button.btn-danger[data-v-9fb45a86]:hover{\n    background:rgba(0,0,0,0.1);\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-9fb45a86]:hover{\n    background:#ac2925;\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-9fb45a86]:focus{\n    color: #fff;\n    background-color: #ac2925;\n    border-color: #fff;\n}\n.profile-content img[data-v-9fb45a86] {\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center center;\n       object-position: center center;\n}\n.video-player .left-video-icons[data-v-9fb45a86] {\n    background: white;\n    color: white;\n    width: 15%;\n    float: left;\n    height: 100%;\n}\nh3.errormessage[data-v-9fb45a86] {\n    color: #f0617d;\n    letter-spacing: 3px;\n    margin: 70px 20px;\n}\n@media(max-width:767px){\n.row.morevediosrow img[data-v-9fb45a86] {\n        margin: 0 0 10px;\n}\n}\n.row.morevediosrow p.text-wrap-title.cursor[data-v-9fb45a86] {\n    font-size: 20px;\n    text-align: left;\n    color: #000;\n}\n.container-icons > div > span[data-v-9fb45a86] {\n    display: inline-block;\n    background: #f0617d;\n    height: 50px;\n    width: 50px;\n    color: #fff;\n    text-align: center;\n    line-height: 60px;\n    border-radius: 50%;\n}\np.text-wrap-title.cursor[data-v-9fb45a86] {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\nh2.pink-text-headline[data-v-9fb45a86] {\n    margin: 30px 0 30px;\n}\np.video-description[data-v-9fb45a86] {\n    font-size: 23px;\n}\n.row.morevediosrow p.text-wrap-title.cursor[data-v-9fb45a86] {\n    font-size: 20px;\n}\n.tabContent p.text-wrap-title.cursor[data-v-9fb45a86] {\n    font-size: 17px;\n}\n", ""]);

// exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.mainbanner img[data-v-9ff1e25a] {\n    width: 100%;\n    max-height: 60vh;\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center center;\n       object-position: center center;\n}\n.profileimageanddata[data-v-9ff1e25a] {\n    clear: both;\n    max-width: 1170px;\n    margin: auto;\n}\n.profileimage[data-v-9ff1e25a] {\n    float: left;\n    width: 170px;\n    height: 170px;\n    border: 10px solid #fff;\n    transform: translateY(-50%);\n    box-shadow: 0px 0px 11px rgba(0,0,0,0.25);\n}\n.profileimage img[data-v-9ff1e25a] {\n    width: 150px;\n    height: 150px;\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position:center center;\n       object-position:center center;\n}\n.textmatterholder[data-v-9ff1e25a] {\n    float: left;\n    width: calc(100% - 170px);\n    text-align: left;\n    padding-left: 30px;\n    padding-top: 20px;\n}\n.tabs ul[data-v-9ff1e25a] {\n    margin: 0 0;\n    padding: 0;\n    list-style: none;\n    display:-ms-flexbox;\n    display:flex;\n}\n.tabs ul li[data-v-9ff1e25a] {\n    -ms-flex:1;\n        flex:1;\n    text-align: center;\n    float: left;\n    padding: 20px;\n    font-size: 21px;\n    font-weight: 900;\n    border-bottom:1px solid #333;\n}\n.tabs li.current[data-v-9ff1e25a]{\n    border-bottom:1px solid #f0617d;\n}\nli.current a[data-v-9ff1e25a] {\n    color: #f0617d;\n}\nli a[data-v-9ff1e25a] {\n    color: #333;\n}\n.tabs[data-v-9ff1e25a]:after {\n    content: \"\";\n    display: table;\n    clear: both;\n    width: 100%;\n}\n.introparacard[data-v-9ff1e25a] {\n    padding-top: 30px;\n    text-align: left;\n}\n.introparacard img[data-v-9ff1e25a] {\n    max-width: 100%;\n}\n.introparacard blockquote[data-v-9ff1e25a] {\n    text-align: center;\n    border: 0 none transparent;\n    padding: 0;\n    margin: 20px 0 0;\n    font-weight: 700;\n    font-style: italic;\n}\nhr.redhr[data-v-9ff1e25a] {\n    border-color: #f0617d;\n    max-width: 575px;\n}\n@media(max-width:767px){\nli a[data-v-9ff1e25a] {\n        font-size: 14px;\n}\n.textmatterholder[data-v-9ff1e25a] {\n        width: 100%;\n        padding: 0 20px;\n}\n.profileimage[data-v-9ff1e25a] {\n        float: none;\n        margin: auto;\n        transform: translateY(-20px);\n}\n}\n.imgresponsive img[data-v-9ff1e25a] {\n    width: 100%;\n    height: auto;\n}\n.large-text[data-v-9ff1e25a] {\n    font-size: 16px;\n}\n\n\n\n/* css for the video popup*/\nbutton#videoplayer_videoredirect[data-v-9ff1e25a] {\n    border-radius: 5px;\n    font-weight: 700;\n}\nbutton#videoplayer_videostay[data-v-9ff1e25a] {\n    background: white;\n    color: #44bda8;\n    border: 1px solid #44bda8;\n    white-space: normal;\n    line-height: 1;\n    padding: 6px;\n    border-radius: 5px;\n}\n.watchVideoModal .modal-dialog .modal-body p[data-v-9ff1e25a] {\n    padding: 16px 60px 19px 60px;\n}\n.watchVideoModal.modal.zoom.in[data-v-9ff1e25a] {\n    z-index: 500000;\n}\n.sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader[data-v-9ff1e25a] {\n    background: #f0617d;\n    color: #fff;\n    font-size: 25px;\n    text-align: left;\n    padding: 15px 25px;\n    font-weight: 700;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body p[data-v-9ff1e25a]{\n    padding: 0;\n    margin: 0 0 20px;\n}\n.row.sharefb[data-v-9ff1e25a] {\n    background: #eee;\n    margin-left: 0;\n    margin-right: 0;\n}\n.row.sharefb > div[data-v-9ff1e25a] {\n    padding: 5px;\n    text-align: left;\n}\n.row.sharefb .col-sm-5 img[data-v-9ff1e25a] {\n    max-width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-9ff1e25a] {\n    font-size: 14px;\n    font-weight: 300;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6[data-v-9ff1e25a] {\n    text-transform: uppercase;\n    font-size: 12px;\n    margin: 10px 0 5px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4[data-v-9ff1e25a] {\n    margin: 0 0 5px;\n    font-weight:700;\n}\n.row.buttonsinpopup[data-v-9ff1e25a] {\n    padding-top: 20px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-9ff1e25a] {\n    background: #fff;\n    color: #333;\n    border: 1px solid #cacaca;\n    width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body[data-v-9ff1e25a] {\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink[data-v-9ff1e25a] {\n    background: #f0617d;\n    width: 100%;\n    margin: 0;\n    border: 1px solid #f0617d;\n}\n.usernamenimg.text-left table[data-v-9ff1e25a] {\n    max-width: 100%;\n    margin: 0 0 20px;\n    width: 190px;\n}\na.popupsharingoptionlink[data-v-9ff1e25a] {\n    display: block;\n    color: #fff;\n    text-decoration: none;\n    max-width: 150px;\n    font-size: 18px;\n    font-weight: 700;\n    padding-top: 15px;\n    text-align: center;\n}\na.popupsharingoptionlink i[data-v-9ff1e25a]:before {\n    color: #fff;\n}\na.popupsharingoptionlink i.fa.fa-share-square-o[data-v-9ff1e25a] {\n    margin: 0;\n    font-size: 20px;\n    /* display: block; */\n}\n.strongselec[data-v-9ff1e25a]{\n    font-weight:700;\n}\n@media(max-width:475px){\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-9ff1e25a] {\n        padding-left: 0;\n        padding-right: 0;\n}\n}\n.showmobile[data-v-9ff1e25a]{display:none;\n}\n@media(max-width:767px){\n.usernamenimg.text-left[data-v-9ff1e25a] {\n        display: none;\n}\n.showmobile[data-v-9ff1e25a]{\n        display: block;\n}\n.alert.alert-default[data-v-9ff1e25a] {\n        background: #eee;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-9ff1e25a] {\n        display: none;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow[data-v-9ff1e25a] {\n        top: 1px;\n        right: -13px;\n}\n.row.sharefb[data-v-9ff1e25a] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.pinksidebarmin[data-v-9ff1e25a]{\n        padding:0 !important;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        -ms-flex-preferred-size: auto;\n            flex-basis: auto;\n        display: flex ;\n        -ms-flex-align: stretch ;\n            align-items: stretch ;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.pinksidebarmin > *[data-v-9ff1e25a] {\n        padding: 6px 0 !important;\n        margin: 0 !important;\n        -ms-flex: 100;\n            flex: 100;\n        text-align:center;\n}\n}\n/* css for the video popup ends*/\n@media(min-width:768px) {\n.sliderimage[data-v-9ff1e25a] {\n        width: 100%;\n        /* height: 200px;*/\n        -o-object-fit: cover;\n           object-fit: cover;\n        -o-object-position: center;\n           object-position: center;\n}\n}\n.row.video-row.plistisrow img[data-v-9ff1e25a] {\n    max-width: 80%;\n}\n.row.video-row.plistisrow .col-sm-6[data-v-9ff1e25a] {\n    text-align: left;\n}\n.pinksidebarmin[data-v-9ff1e25a] {\n    float: right;\n    width: 20%;\n    background: #f0617d;\n    text-align: center;\n    padding: 20px;\n}\n.pinkbg[data-v-9ff1e25a] {background: #f0617d;\n}\n.pinksidebarmin > *[data-v-9ff1e25a] {\n    font-size: 25px;\n    color: #fff;\n    cursor: pointer;\n    margin:20px 0;\n}\n@media(min-width:768px){\n.row.video-row.plistisrow .pinkbg img[data-v-9ff1e25a] {\n        height: 205px;\n        -o-object-fit: cover;\n           object-fit: cover;\n}\n.pinksidebarmin[data-v-9ff1e25a] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        height: 205px;\n        -ms-flex-align: center;\n            align-items: center;\n        -ms-flex-pack: distribute;\n            justify-content: space-around;\n}\n.pinksidebarmin > *[data-v-9ff1e25a] {\n        font-size: 25px;\n        color: #fff;\n        cursor: pointer;\n        padding:0;\n        margin:0;\n}\n}\n.col-sm-6.pltext[data-v-9ff1e25a] {\n    cursor: pointer;\n    font-size: 16px;\n}\n.pltext h3[data-v-9ff1e25a] {\n    text-decoration: underline;\n}\n.clearfix[data-v-9ff1e25a] {\n    clear: both;\n}\n.incaseumi[data-v-9ff1e25a] {\n    font-size: 18px;\n}\n.incaseumi img[data-v-9ff1e25a] {\n    width: 100%;\n}\n.borderedbox[data-v-9ff1e25a] {\n    border: 1px solid #ddd;\n    padding: 15px;\n    margin: 10px 0;\n    font-size: 16px;\n}\n.pinnedmsgs[data-v-9ff1e25a] {\n    text-align: left;\n}\n.pinnedmsgs h3[data-v-9ff1e25a] {\n    color: #f0617d;\n}\n.row.video-row.plistisrow .videoholdersuggestions img[data-v-9ff1e25a] {\n    width: 100%;\n    max-width: none;\n    cursor: pointer;\n}\n.videoholdersuggestions[data-v-9ff1e25a]{\n    margin:0 0 30px;\n}\n.videoholdersuggestions h3[data-v-9ff1e25a] {\n    text-align: center;\n    font-weight: 900;\n    cursor: pointer;\n}\n.videoholdersuggestions p[data-v-9ff1e25a] {\n    font-size: 18px;\n}\n.row.video-row.plistisrow.lowerlist .col-sm-6[data-v-9ff1e25a]:nth-of-type(odd) {\n    clear: left;\n}\n.smallimgholder[data-v-9ff1e25a] {text-align: center;padding: 10px;box-shadow: 0 0 5px rgba(0,0,0,0.5);\n}\n.smallimgholder img[data-v-9ff1e25a] {\n    height: auto;\n    width: 100%;\n}\n@media(max-width:991px){\n.hidemobile[data-v-9ff1e25a] {\n        display: none;\n}\n.smallimgholder[data-v-9ff1e25a] {\n        max-width: 300px;\n        margin: 0 auto;\n}\n}\n@media(max-width:991px){\n.tabs ul[data-v-9ff1e25a] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: stretch;\n            align-items: stretch;\n        -ms-grid-column-align: stretch;\n            justify-items: stretch;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.tabs ul li[data-v-9ff1e25a]{\n        width: auto;\n        padding: 20px 0;\n        -ms-flex: 1;\n            flex: 1;\n}\nimg.sliderimage[data-v-9ff1e25a] {\n        max-width: 100%;\n}\n}\n.row.yourFaves p.text-wrap-title.cursor[data-v-9ff1e25a] {\n    font-size: 16px;\n    font-weight: 500;\n    color: #000;\n    text-align: left;\n    line-height: 1.5;\n}\n.row.yourFaves[data-v-9ff1e25a] {\n    padding-top: 20px;\n}\n@media(min-width:992px) and (max-width:1200px){\n.tabs ul li[data-v-9ff1e25a] {\n        padding-right: 5px !important;\n        padding-left: 5px !important;\n}\n}\n.m-auto[data-v-9ff1e25a] {\n    margin: auto;\n    float: none;\n}\n.fourinarow .radio[data-v-9ff1e25a] {\n    -ms-flex: 1;\n        flex: 1;\n    max-width: 25%;\n}\n.fourinarow[data-v-9ff1e25a] {\n    display: -ms-flexbox;\n    display: flex;\n}\n.fourinarow .radio img[data-v-9ff1e25a] {\n    width: 100%;\n    margin: 0 0 10px;\n}\n.fourinarow .radio.radio > label > input[type=\"radio\"][data-v-9ff1e25a] {\n/ display: block; /\nz-index: 100 !important;\n    opacity: 1;\n    margin: 0 0 0;\n    padding: 0;\n    z-index: 1;\n    position: relative;\n}\n@media(max-width:767px){\n.fourinarow .radio[data-v-9ff1e25a] {\n        max-width: 50%;\n}\n}\n.fourinarow .radio .active span.heading[data-v-9ff1e25a] {\n    font-weight: 700;\n}\n.fourinarow .radio .active img.thumbnail[data-v-9ff1e25a] {\n    border: 1px solid #f0617d;\n}\n.fourinarow[data-v-9ff1e25a] {\n    -ms-flex-align:baseline;\n        align-items:baseline;\n}\n@media(max-width:767px){\n.fourinarow .radio[data-v-9ff1e25a] {max-width: 50% !important;min-width: 50%;\n}\n}\n.fourinarow[data-v-9ff1e25a] {display: -ms-flexbox;display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;\n}\n.fourinarow .radio > label[data-v-9ff1e25a] {\n    padding: 10px;\n    width: 100%;\n}\n.fourinarow .radio > label img.thumbnail.embed-responsive-item[data-v-9ff1e25a] {\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center;\n       object-position: center;\n}\n.smallimgholder button.btn.formButton.btn-block[data-v-9ff1e25a] {\n    padding: 8px;\n    font-size: 12px;\n    white-space: unset;\n}\nbutton.share-event[data-v-9ff1e25a] {\n    color: rgb(240, 97, 125) !important;\n    border: 1px solid rgb(240, 97, 125) !important;\n    background-image: none !important;\n    font-weight: 600;\n    line-height: 100%;\n    background: #fff !important;\n    font-size: 15px !important;\n    text-decoration: none;\n    border-radius: 3px !important;\n    cursor: pointer;\n    -webkit-font-smoothing: antialiased!important;\n    outline-color: rgba(0,78,255,0.5) !important;\n    text-shadow: 1px 1px 1px rgb(0 0 0 / 0%);\n    display: inline-block;\n    position: relative;\n    /*z-index: 99998;*/\n    font-family: \"Open Sans\",Roboto,\"Helvetica Neue\",Helvetica,Optima,Segoe,\"Segoe UI\",Candara,Calibri,Arial,sans-serif !important;\n    padding: 12px 12px 12px 12px !important;\n    margin-left: 10px !important;\n    width: 173px !important;\n    display: inline-block;\n    float: left !important;\n    box-shadow: 0 0 0 0.5px rgba(50,50,93,.17), 0 2px 5px 0 rgba(50,50,93,.1), 0 1px 1.5px 0 rgba(0,0,0,.07), 0 1px 2px 0 rgba(0,0,0,.08), 0 0 0 0 transparent!important;\n}\n.addeventatc.pinkoutlinebtn[data-v-9ff1e25a] {\n    float: left;\n}\n.slick-slide .addeventatc.pinkoutlinebtn[data-v-9ff1e25a] {\n    padding: 13px 12px 12px 37px !important;\n}\n.slick-slide button.share-event[data-v-9ff1e25a] {\n    width: auto !important;\n    margin: 0 10px;\n}\n@media(max-width:991px){\n.addeventatc.pinkoutlinebtn[data-v-9ff1e25a]{\n        margin-left:0 !important;\n        margin-right:10px;\n        margin-bottom:10px;\n}\nbutton.share-event[data-v-9ff1e25a]{\n        margin-left:0 !important;\n}\n}\n@media(max-width:767px){\n.addeventatc.pinkoutlinebtn[data-v-9ff1e25a]{margin-left:10px !important;\n}\nbutton.share-event[data-v-9ff1e25a]{\n        margin-left:9px !important;\n}\n}\n.imgresponsive.large-text.text-left[data-v-9ff1e25a]:after {\n    content: \"\";\n    display: block;\n    clear: both;\n}\n.row.video-row.plistisrow.flexwrap[data-v-9ff1e25a]{\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.favnumbers[data-v-9ff1e25a] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-pack: distribute;\n    justify-content: space-around;\n    position: absolute;\n    right: 0px;\n    top: 0;\n    bottom: 0;\n    padding: 10px;\n    color: #fff;\n    width: 74px;\n    cursor: pointer;\n}\n.viderowraper-shared[data-v-9ff1e25a] {\n    position: relative;\n}\n.favnumbers div span[data-v-9ff1e25a]{\n    font-size: 170%;\n    font-weight: 700;\n    line-height: 1;\n}\n.favnumbers div span + small[data-v-9ff1e25a] {\n    display: block;\n    line-height: 1;\n}\nspan[data-v-9ff1e25a] {\n}\n.favnumbers div[data-v-9ff1e25a] {\n    text-align: center;\n}\n.favnumbers i.fa[data-v-9ff1e25a] {\n    font-size: 200%;\n}\n@media(min-width:768px){\n.favnumbers i.fa[data-v-9ff1e25a] {\n        display: none;\n}\n.favnumbers:hover i.fa[data-v-9ff1e25a] {\n        display: block;\n}\n}\n.show-share-options[data-v-9ff1e25a] {\n    position: relative;\n}\n.show-share-options img[data-v-9ff1e25a] {\n    width: 100%;\n    height: 200px;\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center;\n       object-position: center;\n}\n.show-share-options .favnumbers-a[data-v-9ff1e25a] {\n    position: absolute;\n    background: #f0617d;\n    top: 0;\n    right: 0;\n    width: 50px;\n    bottom: 0;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n    font-size: 30px;\n    font-weight: bold;\n    color: #fff;\n}\n.show-share-options .favnumbers-a small[data-v-9ff1e25a] {\n    font-size: 11px;\n    display: block;\n    line-height: 1;\n}\n.show-share-options .favnumbers-a > div[data-v-9ff1e25a] {\n    line-height: 1;\n}\n@media(min-width:768px){\n.show-share-options .favnumbers[data-v-9ff1e25a]{\n        display:none;\n}\n.show-share-options:hover .favnumbers[data-v-9ff1e25a]{\n        display:-ms-flexbox;\n        display:flex;\n}\n}\n.show-share-options .favnumbers-a i[data-v-9ff1e25a]:before {\n    color: #fff !important;\n}\n", ""]);

// exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.addressholder[data-v-a416555a] {\n    word-wrap: break-word;\n}\nh2.heading[data-v-a416555a] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 47px 0 35px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n    font-size: 30px;\n}\n.aboutlogoholder[data-v-a416555a] {\n    min-height: 300px;\n    line-height: 300px;\n}\n.mtop30[data-v-a416555a] {\n    margin-top: 30px;\n}\n.row.aboutrow p[data-v-a416555a] {\n    font-size: 17px;\n    text-align: left;\n    line-height: 1.5;\n    letter-spacing: 2px;\n}\nh3[data-v-a416555a] {\n    background: #f0617d;\n    letter-spacing: 2px;\n    font-size: 19px;\n    line-height: 1.5;\n    margin: 30px 0 20px;\n    padding: 5px 10px;\n    color: #Fff;\n    font-weight: 900;\n}\nh4[data-v-a416555a] {\n    color: #f0617d;\n    letter-spacing: 4px;\n    font-size: 22px;\n    text-align: left;\n    line-height: 1.5;\n}\nh4.welcomemessage[data-v-a416555a] {\n    text-align: center;\n    margin: 50px 0 0;\n    color: inherit;\n    color: #f0617d;\n}\nh2.welcomemessage[data-v-a416555a] {\n    letter-spacing: 8px;\n    margin: 20px 0 60px;\n    text-transform: uppercase;\n}\n.slide-player img[data-v-a416555a] {\n    max-width: 100%;\n}\n.addressholder[data-v-a416555a] {\n    text-align: left;\n    background: #ddd;\n    font-size: 12px;\n    padding: 10px;\n    border: 3px solid #f0617d;\n}\n.pressentry h5[data-v-a416555a] {\n    font-size: 17px;\n    font-weight: 700;\n}\n.pressentry h5 small[data-v-a416555a] {\n    display: block;\n    margin: 10px 0 20px;\n}\n.pressentry[data-v-a416555a] {\n    border-bottom: 3px solid #ccc;\n    margin: 20px 0;\n}\n.pressentry[data-v-a416555a]:last-of-type {\n    margin: 0;\n    border-bottom: none transparent;\n}\n.pressentry h5 a[data-v-a416555a] {\n    color: #f0617d;\n}\n.mediasignup h2[data-v-a416555a] {\n    color: #f0617d;\n    font-size: 21px;\n    font-weight: 700;\n    margin: 8px 0;\n}\n.mediasignup[data-v-a416555a] {\n    padding-bottom: 50px;\n}\n.mediasignup span.input-group-addon.cursor.input-group-addon[data-v-a416555a]:last-child {\n    padding: 0;\n    /*background: #f0617d;*/\n    /*border-color: #f0617d;*/\n}\n.mediasignup .input-group.input-md.float-right input[data-v-a416555a] {\n    height: 40px;\n    border: 1px solid #f0617d;\n}\n.mediasignup span.input-group-addon.cursor.input-group-addon:last-child button[data-v-a416555a] {\n    border: 0 none transparent;\n    padding: 6px;\n    font-size: 24px;\n    color: #ffffff;\n    background: transparent;\n}\n@media(max-width:480px){\nbody h4[data-v-a416555a] {\n        font-size: 18px !important;\n}\nh3[data-v-a416555a] {\n        font-size: 24px !important;\n        line-height: 1.1 !important;\n}\nh2.welcomemessage[data-v-a416555a] {\n        letter-spacing: 3px !important;\n}\n}\n", ""]);

// exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.smallcontainer[data-v-a428d674] {\n    max-width: 500px;\n    margin: auto;\n    font-size: 18px;\n}\np[data-v-a428d674] {\n    font-size: 18px;\n    font-weight: 500;\n}\na.lglink[data-v-a428d674] {\n    font-size: 20px;\n    font-weight: 500;\n    color: #000;\n    text-decoration: underline;\n    margin: 30px 0 20px;\n    display: block;\n    cursor: pointer;\n}\n.purpletextcontainer a[data-v-a428d674] {\n    display: block;\n    margin: 20px 0 40px;\n}\n.purpletextcontainer p[data-v-a428d674] {\n    color: #8e628b;\n    font-style: italic;\n    font-size: 22px;\n    font-weight: 900;\n}\n.purpletextcontainer hr[data-v-a428d674] {\n    border-color: #f2617d;\n}\nh3[data-v-a428d674] {\n    color: #f0617d;\n}\n.purpletextcontainer h3[data-v-a428d674] {\n    font-weight: 900;\n    color: #8e628b;\n}\n.entryholder[data-v-a428d674] {\n    text-align: left;\n}\n.entryholder p[data-v-a428d674] {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: normal;\n    color: #000;\n}\n.entryholder > a[data-v-a428d674] {\n    text-align: center;\n}\n.graylastext[data-v-a428d674] {\n    font-size: 16px;\n}\nimg.video[data-v-a428d674] {\n    max-width: 90%;\n    margin: auto;\n    display: block;\n}\nimg[data-v-a428d674] {\n    max-width: 100%;\n}\n.graylastext[data-v-a428d674] {\n    margin: 50px 0 30px;\n}\n.bodyContent[data-v-a428d674] {\n    padding-bottom: 50px;\n}\nimg.blowhorn[data-v-a428d674] {\n    max-width: 100%;\n}\n.entryholder[data-v-a428d674] {\n    margin-top: 20px;\n}\n.entryholder p[data-v-a428d674] {\n    margin: 0 0 40px;\n}\n.entryholder img[data-v-a428d674] {\n    margin: 0 0 20px;\n}\nimg.grad[data-v-a428d674] {\n    max-width: 100%;\n}\nimg.topbtn[data-v-a428d674] {\n    float: right;\n    padding: 10px;\n    border: 1px solid #f0617d;\n    border-radius: 10px;\n}\nimg.logosl[data-v-a428d674] {\n    float: left;\n    margin-top: 10px;\n}\n.smallcontainer[data-v-a428d674] {\n    padding-top: 50px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\nimg.topbtn.lastlogobutton[data-v-a428d674] {\n    float: none !important;\n}\np.firstpara[data-v-a428d674] {\n    text-align: left;\n}\n.listesection[data-v-a428d674] {\n}\n.briefcasesection[data-v-a428d674] {\n    float: left;\n    padding: 0 15px;\n    width: 26%;\n}\n.briefcasetext[data-v-a428d674] {\n    float: left;\n    width: 74%;\n    padding: 0 15px;\n    text-align: left;\n}\n.briefcasetext h4[data-v-a428d674] {\n    margin: 10px 0 0;\n}\na.brieflink[data-v-a428d674] {\n    font-size: 18px;\n    color: #8e628b;\n    text-decoration: underline;\n    cursor: pointer;\n    font-weight: 500;\n}\n.listingimg[data-v-a428d674] {\n    float: left;\n    width: 20%;\n    padding-left: 30px;\n    clear: left;\n    margin: 10px 0;\n}\n.listingtext[data-v-a428d674] {\n    width: 80%;\n    float: left;\n    text-align: left;\n    margin-top: 12px;\n    font-style: italic;\n    color: #000;\n    font-weight: 500;\n}\n.listentryholder[data-v-a428d674] {\n    margin-top: 10px;\n}\n.listesection[data-v-a428d674] {\n    margin: 0 auto 40px;\n    max-width: 90%;\n}\n", ""]);

// exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.aboutpage .slider.responsive-slick-imagelist.slick-initialized.slick-slider .slick-list {\n    z-index: 0;\n}\n.aboutpage .slider.responsive-slick-imagelist.slick-initialized.slick-slider button {\n    z-index: 50;\n}\nhtml .aboutpage .slide-player p{\n    margin:0 0 10px;\n    color: #a7a7a7;\n    font-size: 18px;\n}\n", ""]);

// exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\nh2.heading[data-v-bf8a8d2e] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 47px 0 35px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n    font-size: 30px;\n}\n.aboutlogoholder[data-v-bf8a8d2e] {\n    min-height: 300px;\n    line-height: 300px;\n}\n.mtop30[data-v-bf8a8d2e] {\n    margin-top: 30px;\n}\n.row.aboutrow p[data-v-bf8a8d2e] {\n    font-size: 17px;\n    text-align: left;\n    line-height: 1.5;\n    letter-spacing: 2px;\n}\nh3[data-v-bf8a8d2e] {\n    color: #f0617d;\n    letter-spacing: 2px;\n    font-size: 24px;\n    line-height: 1.5;\n    margin: 30px 0 20px;\n}\nh4[data-v-bf8a8d2e] {\n    color: #f0617d;\n    letter-spacing: 4px;\n    font-size: 22px;\n    text-align: left;\n    line-height: 1.5;\n}\nh4.welcomemessage[data-v-bf8a8d2e] {\n    text-align: center;\n    margin: 50px 0 0;\n    color: inherit;\n    color: #f0617d;\n}\nh2.welcomemessage[data-v-bf8a8d2e] {\n    letter-spacing: 8px;\n    margin: 20px 0 60px;\n    text-transform: uppercase;\n}\n.slide-player img[data-v-bf8a8d2e] {\n    max-width: 100%;\n}\n@media(max-width:480px){\nbody h4[data-v-bf8a8d2e] {\n        font-size: 18px !important;\n}\nh3[data-v-bf8a8d2e] {\n        font-size: 24px !important;\n        line-height: 1.1 !important;\n}\nh2.welcomemessage[data-v-bf8a8d2e] {\n        letter-spacing: 3px !important;\n}\n}\nhtml .slide-player[data-v-bf8a8d2e] {\n    padding: 0 10px;\n    margin: 0;\n}\nh2.heading strong[data-v-bf8a8d2e] {\n    font-weight: 700;\n}\nh3 a[data-v-bf8a8d2e] {\n    text-decoration: underline;\n    word-wrap: break-word;\n}\nimg[data-v-bf8a8d2e] {\n    max-width: 100%;\n}\n\n\n\n", ""]);

// exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.attendeesImg>.userImage span[data-v-c0128b10] {\n    word-wrap: normal;\n    white-space: nowrap;\n}\n.btn-pink[data-v-c0128b10]{\n    color: #f0617d;\n    border: 1px solid #f0617d;\n    background: none;\n    outline: none;\n    font-size: 16px;\n    font-family: sans-serif;\n    letter-spacing: 0.3px;\n    float: left;\n    margin-left: 0px;\n    width: 100%;\n    padding: 13px 15px 9px;\n    border-radius: 3px;\n    margin-top: 10px;\n    max-width: 100%;\n}\n@media(min-width:768px){\n.innerpadding[data-v-c0128b10] {\n        padding-top: 36px;\n}\n}\n", ""]);

// exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.aboutpage .slider.responsive-slick-imagelist.slick-initialized.slick-slider .slick-list {\n    z-index: 0;\n}\n.aboutpage .slider.responsive-slick-imagelist.slick-initialized.slick-slider button {\n    z-index: 50;\n}\nhtml .aboutpage .slide-player p{\n    margin:0 0 10px;\n    color: #a7a7a7;\n    font-size: 18px;\n}\n", ""]);

// exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\nh2.heading[data-v-ce398968] {\n    color: #f0617d;\n    text-transform: capitalize;\n    margin: 47px 0 35px 0;\n    letter-spacing: 0.5px;\n    font-family: sans-serif;\n    font-size: 30px;\n}\n.aboutlogoholder[data-v-ce398968] {\n    min-height: 300px;\n    line-height: 300px;\n}\n.mtop30[data-v-ce398968] {\n    margin-top: 30px;\n}\n.row.aboutrow p[data-v-ce398968] {\n    font-size: 17px;\n    text-align: left;\n    line-height: 1.5;\n    letter-spacing: 2px;\n}\nh3[data-v-ce398968] {\n    color: #f0617d;\n    letter-spacing: 4px;\n    font-size: 24px;\n    line-height: 1.5;\n    margin: 30px 0 20px;\n}\nh4[data-v-ce398968] {\n    color: #f0617d;\n    letter-spacing: 4px;\n    font-size: 22px;\n    text-align: left;\n    line-height: 1.5;\n}\nh4.welcomemessage[data-v-ce398968] {\n    text-align: center;\n    margin: 50px 0 0;\n    color: inherit;\n    color: #f0617d;\n}\nh2.welcomemessage[data-v-ce398968] {\n    letter-spacing: 8px;\n    margin: 20px 0 60px;\n    text-transform: uppercase;\n}\n.slide-player img[data-v-ce398968] {\n    max-width: 100%;\n}\n@media(max-width:480px){\nbody h4[data-v-ce398968] {\n        font-size: 18px !important;\n}\nh3[data-v-ce398968] {\n        font-size: 24px !important;\n        line-height: 1.1 !important;\n}\nh2.welcomemessage[data-v-ce398968] {\n        letter-spacing: 3px !important;\n}\n}\nhtml .slide-player[data-v-ce398968] {\n    padding: 0 10px;\n    margin: 0;\n}\n\n\n", ""]);

// exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.articledetailpage > .container{\n    position:relative;\n}\n.articledetailpage > .container > .shareIcons:before {\n    content:\"SHARE\";\n    font-family:'open sans';\n    font-weight:700;\n    display:block;\n    margin:0 0 20px\n}\n.articledetailpage > .container > .shareIcons {\n    width: 75px;\n    position: absolute;\n    left: 0px;\n    padding: 15px;\n    text-align: center;\n    top: 130px;\n    background:#fff;\n}\n.articledetailpage .shareIcons .fa{\n    color:#999   ;\n    width:42px;\n    height:42px;\n    line-height:42px;\n    margin:10px auto;\n}\n@media(min-width:768px){\n.articledetailpage > .container {\n        padding: 0 75px;\n}\n}\n@media(max-width:767px){\n.shareIcons.bottom {\n        text-align: center;\n}\n.articledetailpage > .container > .shareIcons {\n        position: static;\n        width: auto;\n        height: auto;\n        padding: 0 0 10px;\n}\n.articledetailpage > .container > .shareIcons:before {\n        display: none;\n}\n.articledetailpage .shareIcons .fa {\n        margin: 0 10px 10px;\n}\n.articledetailpage .pinklinksholder {\n        border: 0 none transparent;\n        border-top: 1px solid #f0617d;\n        margin-top: 10px;\n        border-radius: 0;\n}\n}\n", ""]);

// exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.articledetailpage[data-v-deef8e96] {\n    /* color: #f0617d; */\n    text-align: left;\n    /* margin: 30px 0 30px; */\n    /* border-bottom: 2px solid #f0617d; */\n    font-size: 16px;\n}\n.articledetailpage h3[data-v-deef8e96] {\n    color: #f0617d;\n    text-align: left;\n    margin: 40px 0 10px;\n    border-bottom: 2px solid #f0617d;\n    padding: 20px 0 10px;\n    font-weight: 700;\n}\n.articledetailpage h6[data-v-deef8e96] {\n    font-size: 18px;\n    font-weight: 600;\n    margin: 0 0 20px;\n}\n.imageholderbanner img[data-v-deef8e96] {\n    width: 100%;\n    height: auto;\n    margin: 0 0 30px;\n}\n.pinklinksholder[data-v-deef8e96] {\n    border: 2px solid #f0617d;\n    border-radius: 5px;\n    padding: 20px;\n}\n.pinklinksholder h4[data-v-deef8e96] {\n    color: #f0616d;\n    text-align: center;\n    font-size: 22px;\n    font-weight: 900;\n    margin: 0 0 20px;\n}\n.pinklinksholder a[data-v-deef8e96] {\n    display: block;\n    padding: 10px 0;\n    font-weight: 600;\n    text-decoration: underline;\n}\n.pinklinksholder small[data-v-deef8e96] {\n    display:block;\n    text-decoration:none !important;\n    color:#333;\n}\n.pinklinksholder a + small[data-v-deef8e96] {\n    cursor: pointer;\n    margin-top: -10px;\n}\n\n\n", ""]);

// exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.row.yourFaves[data-v-ead0290e] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.expert-page-wrapper .main h2[data-v-ead0290e] {\n    margin-top: 0;\n}\nh2.pinkh2[data-v-ead0290e]{\n    font-size: 29px;\n    /*color: #f0617d !important;*/\n    text-transform: uppercase;\n    font-weight:700;\n}\n.expert-page-wrapper .random .blog-section h2.pinkh2[data-v-ead0290e]{\n    font-size: 29px;\n    /*color: #f0617d !important;*/\n    text-transform: uppercase;\n}\n.blog-section.videossection.clearfix .panel .panel-body > .col-md-12.margin-top-20.margin-bottom-40[data-v-ead0290e] {\n    margin: 10px 0;\n    padding: 0;\n}\n.blog-section.videossection.clearfix .panel .panel-body > .col-md-12.margin-top-20.margin-bottom-40 p[data-v-ead0290e] {\n    font-size: 15px;\n}\n.blog-section.videossection.clearfix .panel .panel-body > .col-md-12.margin-top-20.margin-bottom-40 > p > i.fa.fa-play-circle-o[data-v-ead0290e] {\n    position: relative;\n    font-size: 25px;\n    width: auto !important;\n    color:black;\n    margin-right:10px;\n    top:3px\n}\n.blog-section.videossection.clearfix .panel .panel-body[data-v-ead0290e] {\n    cursor: pointer;\n}\nimg.img-responsive[data-v-ead0290e] {\n    width: 100%;\n}\n.expert-page-wrapper .main img[data-v-ead0290e]{height:auto;\n}\n.expert-page-wrapper .live-chat\nimg.nostyle[data-v-ead0290e] {\n    width: auto;\n    height: auto;\n    max-width: 90%;\n    float: left;\n}\n.experts h2[data-v-ead0290e] {\n    margin-top: 5px;\n}\n.pintlist-holder[data-v-ead0290e] {padding: 0 0 50px;\n}\nul.pink_container[data-v-ead0290e] {\n    padding: 20px;\n    color: #f0617d;\n    font-weight: 700;\n    font-size: 18px;\n    margin: 30px 0;\n    border: 2px solid #f0617d;\n    list-style: none;\n}\nul.pink_container li[data-v-ead0290e] {\n    line-height: 1.3;\n    padding: 0 0 10px;\n}\n.btn-group.plusicon[data-v-ead0290e] {\n    position: absolute;\n    right: 50px;\n    bottom: 0px;\n    height: 29px;\n    z-index:200;\n}\nli.divider[data-v-ead0290e] {\n    border-bottom: 1px solid #ddd;\n    margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-ead0290e] {\n    background: transparent;\n    border: 0 none transparent;\n    padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-ead0290e]{\n    font-size: 21px;\n    top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-ead0290e]{\n    padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-ead0290e],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-ead0290e] {\n    padding: 3px 15px;\n    margin-bottom: 5px;\n    display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-ead0290e],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-ead0290e] {\n    height: 30px;\n    padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-ead0290e],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-ead0290e] {\n    position: absolute;\n    top: 6px;\n    font-size:24px;\n    right:20px;\n    cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-ead0290e],\nbutton.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-ead0290e]{\n    position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-ead0290e],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul[data-v-ead0290e]{\n    left: 0;\n    right: auto;\n    width: 230px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    top: 100%;\n    position: absolute;\n    z-index: 5000;\n    list-style: none;\n    text-align: left;\n    padding: 15px;\n}\n.backdropformenu[data-v-ead0290e]{\n    position:fixed;\n    z-index:4900;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-ead0290e]{\n    height: 24px;\n    width: 37px;\n}\n.menuiconbutton[data-v-ead0290e]{\n    height: 24px;\n    width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-ead0290e] {\n    left: auto ;\n    right: 0;\n}\n.fade-enter-active[data-v-ead0290e], .fade-leave-active[data-v-ead0290e] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-ead0290e], .fade-leave-to[data-v-ead0290e] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-ead0290e]{\n    font-size: 10px;\n}\nspan.removed[data-v-ead0290e] {\n    color: red;\n}\nspan.added[data-v-ead0290e] {\n    color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-ead0290e] {\n    position: relative;\n    display:block;\n}\nlabel.notificationwithcheckboxes[data-v-ead0290e] {\n}\n.career-page-wrapper .featured .experts p[data-v-ead0290e]{\n    font-weight:normal;\n}\n.row.yourFaves p.text-wrap-title.cursor[data-v-ead0290e] {\n    text-align: left;\n    font-size: 15px;\n    white-space: nowrap;\n    font-weight: normal;\n    line-height: 1.8;\n    color: #5e5e5e;\n    margin-top:10px;\n    overflow:hidden;\n    text-overflow:ellipsis;\n}\n.row.yourFaves p.text-wrap-title.cursor i.fa.fa-play-circle-o[data-v-ead0290e] {\n    position: relative;\n    font-size: 25px;\n    width: auto !important;\n    color: black;\n    margin-right: 10px;\n    top: 3px;\n}\n.row.yourFaves hr[data-v-ead0290e] {\n    margin: 0;\n}\n.row.yourFaves p.right-heart-icon[data-v-ead0290e] {\n    text-align: right;\n    top: 10px;\n    position: relative;\n    z-index: 100;\n}\n.row.random-section-head.yourFaves.exceptionalsettings\np.text-wrap-title.cursor i.fa.fa-play-circle-o[data-v-ead0290e]{\n    height:20px !important;\n}\n.row.random-section-head.yourFaves.exceptionalsettings\n.plusicon.btn-group[data-v-ead0290e] {\n    bottom:15px;\n}\n@media(min-width:992px){\n.row.random-section-head.yourFaves.exceptionalsettings .col-xs-12.col-sm-6.col-md-4.bottom-margin[data-v-ead0290e]:nth-of-type(3n + 1) {\n        clear: left;\n}\n}\n@media(max-width:767px){\n.expert-page-wrapper .live-chat img.nostyle[data-v-ead0290e]{\n        max-width:100% ;\n}\n}\n.show-share-options[data-v-ead0290e] {\n    position: relative;\n}\n.show-share-options .favnumbers[data-v-ead0290e] {\n    position: absolute;\n    background: #f0617d;\n    top: 0;\n    right: 0;\n    width: 50px;\n    bottom: 0;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n    font-size: 30px;\n    font-weight: bold;\n    color: #fff;\n}\n.show-share-options .favnumbers small[data-v-ead0290e] {\n    font-size: 11px;\n    display: block;\n    line-height: 1;\n}\n.show-share-options .favnumbers > div[data-v-ead0290e] {\n    line-height: 1;\n}\n@media(min-width:768px){\n.show-share-options .favnumbers[data-v-ead0290e]{\n        display:none;\n}\n}\n.show-share-options:hover .favnumbers[data-v-ead0290e]{\n    display:-ms-flexbox;\n    display:flex;\n}\n/*Changes for Corporate Modal*/\n.sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader[data-v-ead0290e] {\n    background: #f0617d;\n    color: #fff;\n    font-size: 25px;\n    text-align: left;\n    padding: 15px 25px;\n    font-weight: 700;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body p[data-v-ead0290e]{\n    padding: 0;\n    margin: 0 0 20px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-ead0290e] {\n    background: #fff;\n    color: #333;\n    border: 1px solid #cacaca;\n    width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body[data-v-ead0290e] {\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink[data-v-ead0290e] {\n    background: #f0617d;\n    width: 100%;\n    margin: 0;\n    border: 1px solid #f0617d;\n}\n@media(max-width:475px){\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-ead0290e] {\n        padding-left: 0;\n        padding-right: 0;\n}\n}\n.row.sharefb[data-v-ead0290e] {\n    background: #eee;\n    margin-left: 0;\n    margin-right: 0;\n}\n.row.sharefb > div[data-v-ead0290e] {\n    padding: 5px;\n    text-align: left;\n}\n.row.sharefb .col-sm-5 img[data-v-ead0290e] {\n    max-width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-ead0290e] {\n    font-size: 14px;\n    font-weight: 300;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6[data-v-ead0290e] {\n    text-transform: uppercase;\n    font-size: 12px;\n    margin: 10px 0 5px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4[data-v-ead0290e] {\n    margin: 0 0 5px;\n    font-weight:700;\n}\n.showmobile[data-v-ead0290e]{display:none;\n}\n@media(max-width:767px){\n.usernamenimg.text-left[data-v-ead0290e] {\n        display: none;\n}\n.showmobile[data-v-ead0290e]{\n        display: block;\n}\n.alert.alert-default[data-v-ead0290e] {\n        background: #eee;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-ead0290e] {\n        display: none;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow[data-v-ead0290e] {\n        top: 1px;\n        right: -13px;\n}\n.row.sharefb[data-v-ead0290e] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.pinksidebarmin[data-v-ead0290e]{\n        padding:0 !important;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        -ms-flex-preferred-size: auto;\n            flex-basis: auto;\n        display: flex ;\n        -ms-flex-align: stretch ;\n            align-items: stretch ;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.pinksidebarmin > *[data-v-ead0290e] {\n        padding: 6px 0 !important;\n        margin: 0 !important;\n        -ms-flex: 100;\n            flex: 100;\n        text-align:center;\n}\n}\n", ""]);

// exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.container-icons.vpage > div > span {\n    display: inline-block;\n    background: #f0617d;\n    height: 50px;\n    width: 50px;\n    color: #fff;\n    text-align: center;\n    line-height: 60px;\n    border-radius: 50%;\n}\n.container-icons.vpage {\n    text-align: right;\n}\n@media(min-width:320px) and (max-width:767px){\n.video-player.autoheight {\n        height: auto;\n}\n.autoheight.video-player .jwplayer.jw-flag-aspect-mode {\n        height: auto !important;\n}\n}\n.autoheight div.jw-error.jw-reset {\n    height: 25vw !important;\n}\n.video-player .left-video-icons{\n    height: 25vw !important;\n}\n.autoheight{\n    height: auto !important;\n    padding-bottom:20px;\n}\n", ""]);

// exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n@media(max-width:768px){\n.row.morevediosrow[data-v-ebffec0a] {\n        margin: 0;\n}\n}\na[data-v-ebffec0a] {\n    cursor: pointer !important;\n}\n.video-player-wrapper .watch-again .current-video-img img[data-v-ebffec0a] {\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.video-player .right-video-icons .enjoy-hover-box[data-v-ebffec0a] {\n    width: 20%;\n    height: 100%;\n    background: #f0617d;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 15% 0px 0;\n    text-align: left;\n}\n.video-player .right-video-icons .enjoy-hover-box button.btn[data-v-ebffec0a] {\n    margin: 0 0 10px;\n    border-color: white;\n    border-radius: 3px;\n    padding: 12px 0 13px;\n    display: block;\n    width: 80%;\n    margin: 0px auto 10px;\n    color: #fff;\n}\n.video-player-wrapper .tooltipBox[data-v-ebffec0a] {\n    width: 100%;\n    text-align: center;\n    padding-bottom: 10px;\n    height: 35px;\n    margin-top: 24px;\n}\n.row.morevediosrow img[data-v-ebffec0a] {\n    max-width: 100%;\n}\n.clearfix[data-v-ebffec0a] {\n    clear: both;\n}\n.gap[data-v-ebffec0a] {\n    height: 30px;\n}\nh3.pinkheading[data-v-ebffec0a] {\n    color: #f0617d;\n    font-size: 28px;\n    letter-spacing: 2px;\n    margin: 10px 0 20px;\n}\nul.pinkheading li  a[data-v-ebffec0a] {\n}\nul.pinkheading li[data-v-ebffec0a] {\n    margin: 5px 0 5px;\n}\nul.pinkheading[data-v-ebffec0a] {\n    margin: 0;\n    padding: 0;\n    font-size: 19px;\n    font-weight: 900;\n    list-style: none;\n}\n/*.row.morevediosrow > div:after {*/\n    /*content: \"\\f04b\";*/\n    /*font-family: fontawesome;*/\n    /*position: absolute;*/\n    /*top: 50%;*/\n    /*left: 50%;*/\n    /*transform: translateX(-50%) translateY(-50%);*/\n    /*color: rgba(255, 255, 255, 0.75);*/\n    /*font-size: 78px;*/\n    /*height: 120px;*/\n    /*width: 120px;*/\n    /*line-height: 107px;*/\n    /*border: 5px solid;*/\n    /*border-radius: 50%;*/\n    /*text-align: center;*/\n    /*padding-left: 22px;*/\n    /*cursor: pointer;*/\n/*}*/\n@media (min-width:768px) {\n.video-player .right-video-icons .enjoy-hover-box[data-v-ebffec0a] {\n        padding: 117px 0px 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating[data-v-ebffec0a] {\n        overflow: hidden;\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n}\n.video-player .right-video-icons .enjoy-hover-box .rating p[data-v-ebffec0a] {\n        color: white;\n        display: block;\n        font-size: 16px;\n        letter-spacing: 0.5px;\n        margin-top: 23px;\n        margin-bottom: 20px;\n        padding: 0 10%;\n        text-align: center;\n}\n}\n.video-player .right-video-icons .rate-hover-box span[data-v-ebffec0a] {\n    margin-bottom: 20px;\n}\n.video-player .right-video-icons .rate-hover-box button[data-v-ebffec0a]:hover {\n    background: #ac2925;\n}\n.video-player .btn-danger[data-v-ebffec0a]:focus {\n    background: inherit;\n    border-color: inherit;\n    outline: none;\n}\n.video-player .right-video-icons div button.btn-danger[data-v-ebffec0a]:hover{\n    background:rgba(0,0,0,0.1);\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-ebffec0a]:hover{\n    background:#ac2925;\n}\n.video-player .right-video-icons div button.btn-danger.active[data-v-ebffec0a]:focus{\n    color: #fff;\n    background-color: #ac2925;\n    border-color: #fff;\n}\n.profile-content img[data-v-ebffec0a] {\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center center;\n       object-position: center center;\n}\n.video-player .left-video-icons[data-v-ebffec0a] {\n    background: white;\n    color: white;\n    width: 15%;\n    float: left;\n    height: 100%;\n}\nh3.errormessage[data-v-ebffec0a] {\n    color: #f0617d;\n    letter-spacing: 3px;\n    margin: 70px 20px;\n}\n@media(max-width:767px){\n.row.morevediosrow img[data-v-ebffec0a] {\n        margin: 0 0 10px;\n}\n}\n.row.morevediosrow p.text-wrap-title.cursor[data-v-ebffec0a] {\n    font-size: 20px;\n    text-align: left;\n    color: #000;\n}\n.container-icons > div > span[data-v-ebffec0a] {\n    display: inline-block;\n    background: #f0617d;\n    height: 50px;\n    width: 50px;\n    color: #fff;\n    text-align: center;\n    line-height: 60px;\n    border-radius: 50%;\n}\np.text-wrap-title.cursor[data-v-ebffec0a] {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\nh2.pink-text-headline[data-v-ebffec0a] {\n    margin: 30px 0 30px;\n}\np.video-description[data-v-ebffec0a] {\n    font-size: 23px;\n}\n.row.morevediosrow p.text-wrap-title.cursor[data-v-ebffec0a] {\n    font-size: 20px;\n}\n.tabContent p.text-wrap-title.cursor[data-v-ebffec0a] {\n    font-size: 17px;\n}\n", ""]);

// exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.smallcontainer[data-v-f1f1b1be] {\n    max-width: 420px;\n    margin: auto;\n    font-size: 18px;\n}\np[data-v-f1f1b1be] {\n    font-size: 18px;\n    font-weight: 500;\n}\na.lglink[data-v-f1f1b1be] {\n    font-size: 20px;\n    font-weight: 500;\n    color: #000;\n    text-decoration: underline;\n    margin: 30px 0 20px;\n    display: block;\n    cursor: pointer;\n}\n.purpletextcontainer a[data-v-f1f1b1be] {\n    display: block;\n    margin: 20px 0 40px;\n}\n.purpletextcontainer p[data-v-f1f1b1be] {\n    color: #8e628b;\n    font-style: italic;\n    font-size: 22px;\n    font-weight: 900;\n}\n.purpletextcontainer hr[data-v-f1f1b1be] {\n    border-color: #f2617d;\n}\nh3[data-v-f1f1b1be] {\n    color: #f0617d;\n}\n.purpletextcontainer h3[data-v-f1f1b1be] {\n    font-weight: 900;\n    color: #8e628b;\n}\n.entryholder[data-v-f1f1b1be] {\n    text-align: left;\n}\n.entryholder p[data-v-f1f1b1be] {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: normal;\n    color: #000;\n}\n.entryholder > a[data-v-f1f1b1be] {\n    text-align: center;\n}\n.graylastext[data-v-f1f1b1be] {\n    font-size: 16px;\n}\nimg.video[data-v-f1f1b1be] {\n    max-width: 90%;\n    margin: auto;\n    display: block;\n}\nimg[data-v-f1f1b1be] {\n    max-width: 100%;\n}\n.graylastext[data-v-f1f1b1be] {\n    margin: 50px 0 30px;\n}\n.bodyContent[data-v-f1f1b1be] {\n    padding-bottom: 50px;\n}\nimg.blowhorn[data-v-f1f1b1be] {\n    max-width: 100%;\n}\n.entryholder[data-v-f1f1b1be] {\n    margin-top: 20px;\n}\n.entryholder p[data-v-f1f1b1be] {\n    margin: 0 0 40px;\n}\n.entryholder img[data-v-f1f1b1be] {\n    margin: 0 0 20px;\n}\nimg.grad[data-v-f1f1b1be] {\n    max-width: 100%;\n}\nimg.topbtn[data-v-f1f1b1be] {\n    float: right;\n    padding: 10px;\n    border: 1px solid #f0617d;\n    border-radius: 10px;\n}\nimg.logosl[data-v-f1f1b1be] {\n    float: left;\n    margin-top: 10px;\n}\n.smallcontainer[data-v-f1f1b1be] {\n    padding-top: 50px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\nimg.topbtn.lastlogobutton[data-v-f1f1b1be] {\n    float: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.text-wrap-title-1[data-v-f4b69e7e] {\n    right: -14px;\n    position: absolute;\n    background-color: rgb(68, 189, 168) !important;\n    color: #fff !important;\n    font-size: 12px !important;\n    padding: 2px 4px !important;\n    border-top-left-radius: 4px !important;\n    line-height: 1.1 !important;\n}\n.align-to-bottom[data-v-f4b69e7e] {\n    right: -13px !important;\n    top: -9px !important;\n}\n.jw-img-1[data-v-f4b69e7e] {\n    max-width: 100%; /* Ensure the image does not exceed its container width */\n}\n.image-container[data-v-f4b69e7e] {\n    position: relative;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n}\n.btn-group.plusicon[data-v-f4b69e7e] {\n    position: absolute;\n    right: 50px;\n    bottom: 0px;\n    height: 29px;\n}\nli.divider[data-v-f4b69e7e] {\n    border-bottom: 1px solid #ddd;\n    margin: 5px -15px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-f4b69e7e] {\n    background: transparent;\n    border: 0 none transparent;\n    padding: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right[data-v-f4b69e7e]{\n    font-size: 21px;\n    top: 0;\n}\nbutton.dropdown-toggle.ellipsis.pull-right li label[data-v-f4b69e7e]{\n    padding: 30px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-f4b69e7e],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li a[data-v-f4b69e7e] {\n    padding: 3px 15px;\n    margin-bottom: 5px;\n    display: block;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control[data-v-f4b69e7e],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control[data-v-f4b69e7e] {\n    height: 30px;\n    padding: 5px 30px 5px 5px;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle[data-v-f4b69e7e],\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle[data-v-f4b69e7e] {\n    position: absolute;\n    top: 6px;\n    font-size:24px;\n    right:20px;\n    cursor: pointer;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ ul li label[data-v-f4b69e7e],\nbutton.dropdown-toggle.ellipsis.pull-right+div + ul li label[data-v-f4b69e7e]{\n    position:relative;\n}\nbutton.dropdown-toggle.ellipsis.pull-right+ div + ul[data-v-f4b69e7e],\nbutton.dropdown-toggle.ellipsis.pull-right+ ul[data-v-f4b69e7e]{\n    left: 0;\n    right: auto;\n    width: 230px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    top: 100%;\n    position: absolute;\n    z-index: 5000;\n    list-style: none;\n    text-align: left;\n    padding: 15px;\n}\n.backdropformenu[data-v-f4b69e7e]{\n    position:fixed;\n    z-index:4900;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    background: transparent;\n}\n.profile .tabContent .menuiconbutton[data-v-f4b69e7e]{\n    height: 24px;\n    width: 37px;\n}\n.menuiconbutton[data-v-f4b69e7e]{\n    height: 24px;\n    width: 37px;\n}\n.plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul[data-v-f4b69e7e] {\n    left: auto ;\n    right: 0;\n}\n.fade-enter-active[data-v-f4b69e7e], .fade-leave-active[data-v-f4b69e7e] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-f4b69e7e], .fade-leave-to[data-v-f4b69e7e] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\nlabel.notificationwithcheckboxes span[data-v-f4b69e7e]{\n    font-size: 10px;\n}\nspan.removed[data-v-f4b69e7e] {\n    color: red;\n}\nspan.added[data-v-f4b69e7e] {\n    color: #4caa98;\n}\nlabel.notificationwithcheckboxes[data-v-f4b69e7e] {\n    position: relative;\n    display:block;\n}\n.bolder[data-v-f4b69e7e] {\n    font-size: 18px;\n    font-weight: 900;\n}\n@media(max-width:767px){\n.hidemobile[data-v-f4b69e7e]{display:none;\n}\n}\n", ""]);

// exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.community-content .sliderTalkBox .slick-slide .addeventatc.pinkoutlinebtn span {\n    margin: 0;\n    float: none;\n}\n.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow {\n    top: 20px;\n}\n\n", ""]);

// exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.community-content h2[data-v-fc8db22c] {\n    margin: 40px 0 50px;\n}\nh2 + button.button.btn.btn-pink.btn-primary.pull-center[data-v-fc8db22c] {\n    margin: 0 auto 30px;\n}\n.community-content .communityBox h2[data-v-fc8db22c] {\n    margin:  0 0 20px;\n    line-height: 1.3;\n}\n.community-content .communityBox p[data-v-fc8db22c] {\n    margin: 0 0 20px;\n}\n.community-content .sliderEventBox .slick-slide img[data-v-fc8db22c] {\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center;\n       object-position: center;\n    height:auto;\n}\n@media(min-width:768px) {\n.community-content .sliderEventBox .slick-slide img[data-v-fc8db22c] {\n        width: 100%;\n        height: 200px;\n        -o-object-fit: cover;\n           object-fit: cover;\n        -o-object-position: center;\n           object-position: center;\n}\n}\n.community-content .secondheading h2[data-v-fc8db22c] {\n    margin: 7px 0;\n}\n.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent[data-v-fc8db22c] {\n    border-radius: 3px;\n    margin: 20px 0 0;\n}\n.sliderEventBox p[data-v-fc8db22c] {\n    min-height: 155px;\n}\n/*.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent.disabled ,*/\n/*.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent.disabled:hover {*/\n    /*background: transparent;*/\n    /*color: #e08383 !important;*/\n/*}*/\n@media(min-width:768px){\n.sliderTalkBox>h2+p[data-v-fc8db22c] {\n        position: relative;\n        top: -40px;\n        color: #303030;\n        font-size: 15px;\n        font-weight: 500;\n        font-family: sans-serif;\n        letter-spacing: 0.3px;\n}\n.community-content .sliderEventBox[data-v-fc8db22c] {\n        margin: 70px 0 100px 0;\n}\n.sliderTalkBox .slider h2[data-v-fc8db22c] {\n        min-height: 62px;\n}\n}\n.community-content .communityBox button[data-v-fc8db22c]{width:auto;\n}\n.community-content .communityBox h5[data-v-fc8db22c] {\n    margin: 0 0 35px 0;\n}\n.community-content .sliderTalkBox .slick-slide p[data-v-fc8db22c] {\n    margin: 0 0 20px 0;\n    color: #303030;\n    font-size: 14px;\n    line-height: 22px;\n    font-family: sans-serif;\n    padding: 0 10px 0 10px;\n    text-align: left;\n    letter-spacing: 0.5px;\n}\n.selected-event[data-v-fc8db22c] {\n    content: \"\\F00C\";\n    font: normal normal normal 14px/1 FontAwesome;\n    position: absolute;\n    color: white;\n    right: 20.5px;\n    top: 24px;\n    font-size: 18px;\n}\n.slick-slide button.button[data-v-fc8db22c] {\n    color: #f0617d;\n    border: 1px solid #f0617d;\n    background: none;\n    outline: none;\n    font-size: 16px;\n    font-family: sans-serif;\n    letter-spacing: 0.3px;\n    float: left;\n    margin-left: 10px;\n    width: 278px;\n    padding: 18px 15px 14px;\n    border-radius: 3px;\n    margin-top: 10px;\n}\n.sliderTalkBox .slider p[data-v-fc8db22c] {\n    min-height: 160px;\n}\n.community-content .sliderTalkBox .slick-slide h5[data-v-fc8db22c] {\n    text-align: left;\n    padding: 0 10px;\n}\n.sliderTalkBox .slider h2[data-v-fc8db22c]{\n    color: #303030;\n    margin: 15px 0 15px 0;\n    line-height: 31px;\n    text-align: left;\n    font-family: sans-serif;\n    padding: 0 20px 0 10px;\n    font-size: 20px;\n    text-transform: inherit;\n}\n*[data-v-fc8db22c]:before, *[data-v-fc8db22c]:after {\n    box-sizing: border-box;\n    /*color: #f0617d;*/\n}\n.slick-slide .addeventatc.pinkoutlinebtn[data-v-fc8db22c] {\n    display: block;\n    padding: 19px;\n    margin: 10px;\n    font-size: 16px;\n    color: #f1214a !important;\n    opacity: 1;\n}\n.community-content .communityBox .addeventatc.pinkoutlinebtn[data-v-fc8db22c] {\n    margin-left: 20px;\n    float: left;\n}\n.community-content .sliderEventBox h2.archive-less-spacing[data-v-fc8db22c] {\n    margin: 0 0 10px;\n}\n.community-content .sliderEventBox h2.archive-less-spacing + p[data-v-fc8db22c] {\n    min-height: 0;\n    margin: 0 0 30px;\n    color: #303030;\n    font-size: 15px;\n    font-weight: 500;\n    font-family: sans-serif;\n    letter-spacing: 0.3px;\n}\n.sliderEventBox.pointer .col-sm-4.slick-slide[data-v-fc8db22c] {\n    cursor:pointer;\n}\n@media(max-width:767px){\n.community-content .communityBox .addeventatc.pinkoutlinebtn[data-v-fc8db22c] {\n        margin-left: 10px;\n}\n}\nh2 svg[data-v-fc8db22c] {\n    position: relative;\n    top: 15px;\n    width: 100px;\n    height: 69px;\n}\nh2.carosalh2[data-v-fc8db22c] {\n    font-size: 25px !important;\n    font-weight: 700;\n}\n.show-share-options[data-v-fc8db22c] {\n    position: relative;\n}\n.show-share-options .favnumbers[data-v-fc8db22c] {\n    position: absolute;\n    background: #f0617d;\n    top: 0;\n    right: 0;\n    width: 50px;\n    bottom: 0;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n    font-size: 30px;\n    font-weight: bold;\n    color: #fff;\n}\n.show-share-options .favnumbers small[data-v-fc8db22c] {\n    font-size: 11px;\n    display: block;\n    line-height: 1;\n}\n.show-share-options .favnumbers > div[data-v-fc8db22c] {\n    line-height: 1;\n}\n@media(min-width:768px){\n.show-share-options .favnumbers[data-v-fc8db22c]{\n        display:none;\n}\n.show-share-options:hover .favnumbers[data-v-fc8db22c]{\n        display:-ms-flexbox;\n        display:flex;\n}\n}\n.show-share-options .favnumbers i[data-v-fc8db22c]:before {\n    color: #fff !important;\n}\n/*Changes for Corporate Modal*/\n.sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader[data-v-fc8db22c] {\n    background: #f0617d;\n    color: #fff;\n    font-size: 25px;\n    text-align: left;\n    padding: 15px 25px;\n    font-weight: 700;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body p[data-v-fc8db22c]{\n    padding: 0;\n    margin: 0 0 20px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-fc8db22c] {\n    background: #fff;\n    color: #333;\n    border: 1px solid #cacaca;\n    width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body[data-v-fc8db22c] {\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink[data-v-fc8db22c] {\n    background: #f0617d;\n    width: 100%;\n    margin: 0;\n    border: 1px solid #f0617d;\n}\n@media(max-width:475px){\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default[data-v-fc8db22c] {\n        padding-left: 0;\n        padding-right: 0;\n}\n}\n.row.sharefb[data-v-fc8db22c] {\n    background: #eee;\n    margin-left: 0;\n    margin-right: 0;\n}\n.row.sharefb > div[data-v-fc8db22c] {\n    padding: 5px;\n    text-align: left;\n}\n.row.sharefb .col-sm-5 img[data-v-fc8db22c] {\n    max-width: 100%;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-fc8db22c] {\n    font-size: 14px;\n    font-weight: 300;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6[data-v-fc8db22c] {\n    text-transform: uppercase;\n    font-size: 12px;\n    margin: 10px 0 5px;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4[data-v-fc8db22c] {\n    margin: 0 0 5px;\n    font-weight:700;\n}\n.showmobile[data-v-fc8db22c]{display:none;\n}\n@media(max-width:767px){\n.usernamenimg.text-left[data-v-fc8db22c] {\n        display: none;\n}\n.showmobile[data-v-fc8db22c]{\n        display: block;\n}\n.alert.alert-default[data-v-fc8db22c] {\n        background: #eee;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p[data-v-fc8db22c] {\n        display: none;\n}\n.sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow[data-v-fc8db22c] {\n        top: 1px;\n        right: -13px;\n}\n.row.sharefb[data-v-fc8db22c] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.pinksidebarmin[data-v-fc8db22c]{\n        padding:0 !important;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        -ms-flex-preferred-size: auto;\n            flex-basis: auto;\n        display: flex ;\n        -ms-flex-align: stretch ;\n            align-items: stretch ;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.pinksidebarmin > *[data-v-fc8db22c] {\n        padding: 6px 0 !important;\n        margin: 0 !important;\n        -ms-flex: 100;\n            flex: 100;\n        text-align:center;\n}\n}\nbutton.share-event[data-v-fc8db22c] {\n    color: rgb(240, 97, 125) !important;\n    border: 1px solid rgb(240, 97, 125) !important;\n    background-image: none !important;\n    font-weight: 600;\n    line-height: 100%;\n    background: #fff !important;\n    font-size: 15px !important;\n    text-decoration: none;\n    border-radius: 3px !important;\n    cursor: pointer;\n    -webkit-font-smoothing: antialiased!important;\n    outline-color: rgba(0,78,255,0.5) !important;\n    text-shadow: 1px 1px 1px rgb(0 0 0 / 0%);\n    display: inline-block;\n    position: relative;\n    /*z-index: 99998;*/\n    font-family: \"Open Sans\",Roboto,\"Helvetica Neue\",Helvetica,Optima,Segoe,\"Segoe UI\",Candara,Calibri,Arial,sans-serif !important;\n    padding: 12px 12px 12px 12px !important;\n    margin-left: 10px !important;\n    width: 173px !important;\n    display: inline-block;\n    float: left !important;\n    box-shadow: 0 0 0 0.5px rgba(50,50,93,.17), 0 2px 5px 0 rgba(50,50,93,.1), 0 1px 1.5px 0 rgba(0,0,0,.07), 0 1px 2px 0 rgba(0,0,0,.08), 0 0 0 0 transparent!important;\n}\n.addeventatc.pinkoutlinebtn[data-v-fc8db22c] {\n    float: left;\n}\n@media(max-width:991px){\n.community-content .communityBox .addeventatc.pinkoutlinebtn[data-v-fc8db22c]{\n        margin-left:0 !important;\n        margin-right:10px;\n        margin-bottom:10px;\n}\n.community-content .communityBox button.share-event[data-v-fc8db22c]{\n        margin-left:0 !important;\n}\n}\n@media(max-width:767px){\n.community-content .communityBox .addeventatc.pinkoutlinebtn[data-v-fc8db22c]{\n        margin-left:15px !important;\n}\n.community-content .communityBox button.share-event[data-v-fc8db22c]{\n        margin-left:15px !important;\n}\n}\n.slick-slide .addeventatc.pinkoutlinebtn[data-v-fc8db22c] {\n    padding: 13px 12px 12px 37px !important;\n}\n.slick-slide button.share-event[data-v-fc8db22c] {\n    width: auto !important;\n    margin: 10px;\n}\n.community-content .communityBox h2[data-v-fc8db22c] {\n    /*color: #44bda8;*/\n    font-size: 24px;\n}\n.community-content .communityBox[data-v-fc8db22c] {\n    width: 100%;\n}\n", ""]);

// exports


/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.5.4","/opt/atlassian/pipelines/agent/build"]],"_development":true,"_from":"elliptic@6.5.4","_id":"elliptic@6.5.4","_inBundle":false,"_integrity":"sha512-iLhC6ULemrljPZb+QutR5TQGB+pdW6KGD5RSegS+8sorOZT+rdQFbsQFJgvN3eRqNALqJer4oQ16YvJHlU8hzQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.4","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.4","saveSpec":null,"fetchSpec":"6.5.4"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.4.tgz","_spec":"6.5.4","_where":"/opt/atlassian/pipelines/agent/build","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"description":"EC cryptography","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.4"}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = {"version":"2021e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|+10|-a0|0||25e4","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1C00 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|01212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-FSdk.U 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 185,
	"./af.js": 185,
	"./ar": 192,
	"./ar-dz": 186,
	"./ar-dz.js": 186,
	"./ar-kw": 187,
	"./ar-kw.js": 187,
	"./ar-ly": 188,
	"./ar-ly.js": 188,
	"./ar-ma": 189,
	"./ar-ma.js": 189,
	"./ar-sa": 190,
	"./ar-sa.js": 190,
	"./ar-tn": 191,
	"./ar-tn.js": 191,
	"./ar.js": 192,
	"./az": 193,
	"./az.js": 193,
	"./be": 194,
	"./be.js": 194,
	"./bg": 195,
	"./bg.js": 195,
	"./bm": 196,
	"./bm.js": 196,
	"./bn": 198,
	"./bn-bd": 197,
	"./bn-bd.js": 197,
	"./bn.js": 198,
	"./bo": 199,
	"./bo.js": 199,
	"./br": 200,
	"./br.js": 200,
	"./bs": 201,
	"./bs.js": 201,
	"./ca": 202,
	"./ca.js": 202,
	"./cs": 203,
	"./cs.js": 203,
	"./cv": 204,
	"./cv.js": 204,
	"./cy": 205,
	"./cy.js": 205,
	"./da": 206,
	"./da.js": 206,
	"./de": 209,
	"./de-at": 207,
	"./de-at.js": 207,
	"./de-ch": 208,
	"./de-ch.js": 208,
	"./de.js": 209,
	"./dv": 210,
	"./dv.js": 210,
	"./el": 211,
	"./el.js": 211,
	"./en-au": 212,
	"./en-au.js": 212,
	"./en-ca": 213,
	"./en-ca.js": 213,
	"./en-gb": 214,
	"./en-gb.js": 214,
	"./en-ie": 215,
	"./en-ie.js": 215,
	"./en-il": 216,
	"./en-il.js": 216,
	"./en-in": 217,
	"./en-in.js": 217,
	"./en-nz": 218,
	"./en-nz.js": 218,
	"./en-sg": 219,
	"./en-sg.js": 219,
	"./eo": 220,
	"./eo.js": 220,
	"./es": 224,
	"./es-do": 221,
	"./es-do.js": 221,
	"./es-mx": 222,
	"./es-mx.js": 222,
	"./es-us": 223,
	"./es-us.js": 223,
	"./es.js": 224,
	"./et": 225,
	"./et.js": 225,
	"./eu": 226,
	"./eu.js": 226,
	"./fa": 227,
	"./fa.js": 227,
	"./fi": 228,
	"./fi.js": 228,
	"./fil": 229,
	"./fil.js": 229,
	"./fo": 230,
	"./fo.js": 230,
	"./fr": 233,
	"./fr-ca": 231,
	"./fr-ca.js": 231,
	"./fr-ch": 232,
	"./fr-ch.js": 232,
	"./fr.js": 233,
	"./fy": 234,
	"./fy.js": 234,
	"./ga": 235,
	"./ga.js": 235,
	"./gd": 236,
	"./gd.js": 236,
	"./gl": 237,
	"./gl.js": 237,
	"./gom-deva": 238,
	"./gom-deva.js": 238,
	"./gom-latn": 239,
	"./gom-latn.js": 239,
	"./gu": 240,
	"./gu.js": 240,
	"./he": 241,
	"./he.js": 241,
	"./hi": 242,
	"./hi.js": 242,
	"./hr": 243,
	"./hr.js": 243,
	"./hu": 244,
	"./hu.js": 244,
	"./hy-am": 245,
	"./hy-am.js": 245,
	"./id": 246,
	"./id.js": 246,
	"./is": 247,
	"./is.js": 247,
	"./it": 249,
	"./it-ch": 248,
	"./it-ch.js": 248,
	"./it.js": 249,
	"./ja": 250,
	"./ja.js": 250,
	"./jv": 251,
	"./jv.js": 251,
	"./ka": 252,
	"./ka.js": 252,
	"./kk": 253,
	"./kk.js": 253,
	"./km": 254,
	"./km.js": 254,
	"./kn": 255,
	"./kn.js": 255,
	"./ko": 256,
	"./ko.js": 256,
	"./ku": 257,
	"./ku.js": 257,
	"./ky": 258,
	"./ky.js": 258,
	"./lb": 259,
	"./lb.js": 259,
	"./lo": 260,
	"./lo.js": 260,
	"./lt": 261,
	"./lt.js": 261,
	"./lv": 262,
	"./lv.js": 262,
	"./me": 263,
	"./me.js": 263,
	"./mi": 264,
	"./mi.js": 264,
	"./mk": 265,
	"./mk.js": 265,
	"./ml": 266,
	"./ml.js": 266,
	"./mn": 267,
	"./mn.js": 267,
	"./mr": 268,
	"./mr.js": 268,
	"./ms": 270,
	"./ms-my": 269,
	"./ms-my.js": 269,
	"./ms.js": 270,
	"./mt": 271,
	"./mt.js": 271,
	"./my": 272,
	"./my.js": 272,
	"./nb": 273,
	"./nb.js": 273,
	"./ne": 274,
	"./ne.js": 274,
	"./nl": 276,
	"./nl-be": 275,
	"./nl-be.js": 275,
	"./nl.js": 276,
	"./nn": 277,
	"./nn.js": 277,
	"./oc-lnc": 278,
	"./oc-lnc.js": 278,
	"./pa-in": 279,
	"./pa-in.js": 279,
	"./pl": 280,
	"./pl.js": 280,
	"./pt": 282,
	"./pt-br": 281,
	"./pt-br.js": 281,
	"./pt.js": 282,
	"./ro": 283,
	"./ro.js": 283,
	"./ru": 284,
	"./ru.js": 284,
	"./sd": 285,
	"./sd.js": 285,
	"./se": 286,
	"./se.js": 286,
	"./si": 287,
	"./si.js": 287,
	"./sk": 288,
	"./sk.js": 288,
	"./sl": 289,
	"./sl.js": 289,
	"./sq": 290,
	"./sq.js": 290,
	"./sr": 292,
	"./sr-cyrl": 291,
	"./sr-cyrl.js": 291,
	"./sr.js": 292,
	"./ss": 293,
	"./ss.js": 293,
	"./sv": 294,
	"./sv.js": 294,
	"./sw": 295,
	"./sw.js": 295,
	"./ta": 296,
	"./ta.js": 296,
	"./te": 297,
	"./te.js": 297,
	"./tet": 298,
	"./tet.js": 298,
	"./tg": 299,
	"./tg.js": 299,
	"./th": 300,
	"./th.js": 300,
	"./tk": 301,
	"./tk.js": 301,
	"./tl-ph": 302,
	"./tl-ph.js": 302,
	"./tlh": 303,
	"./tlh.js": 303,
	"./tr": 304,
	"./tr.js": 304,
	"./tzl": 305,
	"./tzl.js": 305,
	"./tzm": 307,
	"./tzm-latn": 306,
	"./tzm-latn.js": 306,
	"./tzm.js": 307,
	"./ug-cn": 308,
	"./ug-cn.js": 308,
	"./uk": 309,
	"./uk.js": 309,
	"./ur": 310,
	"./ur.js": 310,
	"./uz": 312,
	"./uz-latn": 311,
	"./uz-latn.js": 311,
	"./uz.js": 312,
	"./vi": 313,
	"./vi.js": 313,
	"./x-pseudo": 314,
	"./x-pseudo.js": 314,
	"./yo": 315,
	"./yo.js": 315,
	"./zh-cn": 316,
	"./zh-cn.js": 316,
	"./zh-hk": 317,
	"./zh-hk.js": 317,
	"./zh-mo": 318,
	"./zh-mo.js": 318,
	"./zh-tw": 319,
	"./zh-tw.js": 319
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 638;

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/WOSB-Logo.18963c0.png";

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/footer-logo.58e0e8c.png";

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyOXB4IiBoZWlnaHQ9IjE2cHgiIHZpZXdCb3g9IjAgMCAyOSAxNiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjkgMTYiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8dGl0bGU+TW9uZXk8L3RpdGxlPgo8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KPGcgaWQ9Ik5hdiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQ2LjAwMDAwMCwgMjQuMDAwMDAwKSI+Cgk8ZyBpZD0iTW9uZXkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQwMy4wMDAwMDAsIDYuMDAwMDAwKSI+CgkJPHBvbHlsaW5lIGlkPSJTdHJva2UtMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjRjA2MTdEIiBwb2ludHM9Ii02NDcuNzUyLC0xNC43MzYgLTY0My4yMzQsLTE5LjI2OCAtNjQxLjEwNCwtMTcuMDk4IAoJCQktNjM2LjE5OSwtMjEuOTUgLTYzMS44NzUsLTE3LjY3MiAtNjIwLjY0NiwtMjguNzE2IAkJIi8+CgkJPHBvbHlsaW5lIGlkPSJTdHJva2UtMyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjRjA2MTdEIiBwb2ludHM9Ii02MjQuOTY5LC0yOC43MTUgLTYyMC42NDUsLTI4LjcxNSAtNjIwLjY0NSwtMjQuNDM4IAkJIi8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyOXB4IiBoZWlnaHQ9IjE2cHgiIHZpZXdCb3g9IjAgMCAyOSAxNiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjkgMTYiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8dGl0bGU+TW9uZXk8L3RpdGxlPgo8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KPGcgaWQ9IlN5bWJvbHMiPgoJPGcgaWQ9Ik1haW4tTmF2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjQ4LjAwMDAwMCwgLTI5LjAwMDAwMCkiPgoJCTxnPgoJCQk8cmVjdCBpZD0iUmVjdCIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1vcGFjaXR5PSIwIiB3aWR0aD0iMTIwMCIgaGVpZ2h0PSI4NiIvPgoJCQk8ZyBpZD0iTmF2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNDYuMDAwMDAwLCAyNC4wMDAwMDApIj4KCQkJCTxnIGlkPSJNb25leSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDAzLjAwMDAwMCwgNi4wMDAwMDApIj4KCQkJCQk8cG9seWxpbmUgaWQ9IlN0cm9rZS0yIiBmaWxsPSJub25lIiBzdHJva2U9IiNGRkZGRkYiIHBvaW50cz0iMC4yNDgsMTQuMjY0IDQuNzY2LDkuNzMyIDYuODk2LDExLjkwMiAxMS44MDEsNy4wNSAKCQkJCQkJMTYuMTI1LDExLjMyOCAyNy4zNTQsMC4yODQgCQkJCQkiLz4KCQkJCQk8cG9seWxpbmUgaWQ9IlN0cm9rZS0zIiBmaWxsPSJub25lIiBzdHJva2U9IiNGRkZGRkYiIHBvaW50cz0iMjMuMDMxLDAuMjg1IDI3LjM1NSwwLjI4NSAyNy4zNTUsNC41NjIgCQkJCQkiLz4KCQkJCTwvZz4KCQkJPC9nPgoJCTwvZz4KCTwvZz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjlweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMjkgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ0LjEgKDQxNDU1KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Nb25leTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTWFpbi1OYXYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02NDguMDAwMDAwLCAtMjkuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3QiIGZpbGwtb3BhY2l0eT0iMCIgZmlsbD0iI0ZGRkZGRiIgeD0iMCIgeT0iMCIgd2lkdGg9IjEyMDAiIGhlaWdodD0iODYiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDxnIGlkPSJOYXYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0Ni4wMDAwMDAsIDI0LjAwMDAwMCkiIHN0cm9rZT0iIzRBNEE0QSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Ik1vbmV5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MDMuMDAwMDAwLCA2LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlN0cm9rZS0yIiBwb2ludHM9IjAuMjQ4MjI2OTUgMTQuMjYzNTAyNSA0Ljc2NTk1NzQ1IDkuNzMxODQyODggNi44OTYyNjA5OSAxMS45MDIzMTEgMTEuODAwOTY3NCA3LjA1MDIyNTg2IDE2LjEyNDU2NDUgMTEuMzI3NTg3NiAyNy4zNTQzNTE4IDAuMjg0Mzk2MDcyIj48L3BvbHlsaW5lPgogICAgICAgICAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlN0cm9rZS0zIiBwb2ludHM9IjIzLjAzMTE0MTggMC4yODQ3NzkwNTEgMjcuMzU0NzM5IDAuMjg0Nzc5MDUxIDI3LjM1NDczOSA0LjU2MjE0MDc1Ij48L3BvbHlsaW5lPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjIgMjIiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8dGl0bGU+U2VhcmNoPC90aXRsZT4KPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CjxnIGlkPSJTeW1ib2xzIj4KCTxnIGlkPSJNYWluLU5hdiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwNTMuMDAwMDAwLCAtMzYuMDAwMDAwKSI+CgkJPGc+CgkJCTxyZWN0IGlkPSJSZWN0IiBmaWxsPSIjRkZGRkZGIiBmaWxsLW9wYWNpdHk9IjAiIHdpZHRoPSIxMjAwIiBoZWlnaHQ9Ijg2Ii8+CgkJCTxwYXRoIGlkPSJTZWFyY2giIGZpbGw9IiNGRkZGRkYiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIwLjUiIGQ9Ik0xMDczLjg2OSw1Ni4yNGwtNS41ODMtNS41ODQKCQkJCWMyLjg4My0zLjIxMiwyLjc4MS04LjE3LTAuMzA2LTExLjI1OGMtMS41NDctMS41NDctMy42MDQtMi4zOTgtNS43OTEtMi4zOThjLTIuMTg4LDAtNC4yNDQsMC44NTItNS43OTEsMi4zOTgKCQkJCVMxMDU0LDQzLjAwMiwxMDU0LDQ1LjE4OXMwLjg1Miw0LjI0NCwyLjM5OCw1Ljc5MXMzLjYwNCwyLjM5OCw1Ljc5MSwyLjM5OGMyLjAzOSwwLDMuOTYzLTAuNzQsNS40NjgtMi4wOTNsNS41ODMsNS41ODMKCQkJCWMwLjA4NywwLjA4OCwwLjIwMSwwLjEzMSwwLjMxNSwwLjEzMXMwLjIyOC0wLjA0MywwLjMxNC0wLjEzMUMxMDc0LjA0Myw1Ni42OTUsMTA3NC4wNDMsNTYuNDE0LDEwNzMuODY5LDU2LjI0TDEwNzMuODY5LDU2LjI0egoJCQkJIE0xMDYyLjE4OSw1Mi40ODhjLTEuOTQ5LDAtMy43ODItMC43Ni01LjE2MS0yLjEzN2MtMS4zNzktMS4zNzktMi4xMzgtMy4yMTItMi4xMzgtNS4xNjJjMC0xLjk0OSwwLjc1OS0zLjc4MiwyLjEzOC01LjE2MQoJCQkJczMuMjEyLTIuMTM5LDUuMTYxLTIuMTM5YzEuOTUsMCwzLjc4MywwLjc2LDUuMTYyLDIuMTM5YzIuODQ1LDIuODQ1LDIuODQ1LDcuNDc2LDAsMTAuMzIxCgkJCQlDMTA2NS45NzMsNTEuNzI5LDEwNjQuMTM5LDUyLjQ4OCwxMDYyLjE4OSw1Mi40ODhMMTA2Mi4xODksNTIuNDg4eiIvPgoJCTwvZz4KCTwvZz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAAB7CAYAAABUx/9/AAAAAXNSR0IArs4c6QAAAfBJREFUeF7t06FxAgEUBuG7KlIBhhZSQQyKGQQtUUAUg4uNYgaHQFACDgUqM3EYDA1Qwe33Otjd94+DyxgYM6RAB7FDTyC22CEDIVTLFjtkIIRq2WKHDIRQLVvskIEQqmWLHTIQQrVssUMGQqiWLXbIQAjVssUOGQihWrbYIQMhVMsWO2QghGrZYocMhFAtW+yQgRCqZYsdMhBCtWyxQwZCqJYtdshACNWyxQ4ZCKFattghAyFUyxY7ZCCEatlihwyEUC1b7JCBEKplix0yEEK1bLFDBkKoli12yEAI1bLFDhkIoVq22CEDIVTLFjtkIIRq2WKHDIRQLVvskIEQqmWLHTIQQrVssUMGQqiWLXbIQAjVssUOGQihWrbYIQMhVMsWO2QghGrZYocMhFAtW+yQgRCqZYsdMhBCtWyxQwZCqJYtdshACNWyxQ4ZCKFattghAyFUyxY7ZCCEatlihwyEUC1b7JCBEKplix0yEEK1bLFDBkKoli12yEAI1bLFDhkIoVq22CEDIVTLFjtkIIRq2WKHDIRQLVvskIEQqmWLHTIQQrVssUMGQqiWLXbIQAjVssUOGQihWrbYIQMhVMsWO2QghGrZYocMhFAtW+zpGvjazHbX0//h8vv3847yczlffyweq/vxuT9vb99TMvECZwARfJMUbKwAAAAASUVORK5CYII="

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/career-bg.82940b3.png";

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAAB7CAYAAABUx/9/AAAAAXNSR0IArs4c6QAAAo9JREFUeF7tk70rBGAAh99zzJYbbnDF5mM43UBRJOVjkpFSypUu+QeMNiWbbjCgTAozbrhsJxHFIEVZdF1HF6WTj2z4D9zzvOPbuzzP8/4iwYMxEMGQChqMDfoExjY2yAAI1WUbG2QAhOqyjQ0yAEJ12cYGGQChumxjgwyAUF22sUEGQKgu29ggAyBUl21skAEQqss2NsgACNVlGxtkAITqso0NMgBCddnGBhkAobpsY4MMgFBdtrFBBkCoLtvYIAMgVJdtbJABEKrLNjbIAAjVZRsbZACE6rKNDTIAQnXZxgYZAKG6bGODDIBQXbaxQQZAqC7b2CADIFSXbWyQARCqyzY2yAAI1WUbG2QAhOqyjQ0yAEJ12cYGGQChumxjgwyAUF22sUEGQKgu29ggAyBUl21skAEQqss2NsgACNVlGxtkAITqso0NMgBCddnGBhkAobpsY4MMgFBdtrFBBkCoLtvYIAMgVJdtbJABEKrLNjbIAAjVZRsbZACE6rKNDTIAQnXZxgYZAKG6bGODDIBQXbaxQQZAqC7b2CADIFSXbWyQARCqyzY2yAAI1WUbG2QAhOqyjQ0yAEJ12cYGGQChumxjgwyAUF22sUEGQKgu29ggAyBUl21skAEQqss2NsgACNVlGxtkAITqso0NMvAbtSEWi8VKpVIphPBWaxYQy+7u6x56fX6OnJ9e7v8NmEwmhyv3N5+35ZeDeDzePJ9O76ytr898RKPVpo623mr56e6kUDishfA1EzuTySxks9mlEML7zzCJ1sTQxNzkZrH6EKkvhuPt7N50pVIpf79JtadGBtsTG2cnR4Xc3ePY993oQP/ixfXVbktnV8/4bHq1sS76sLW8MpXP53P/PfgXTq5JfCq5wrcAAAAASUVORK5CYII="

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAAB7CAYAAABUx/9/AAAAAXNSR0IArs4c6QAAAw5JREFUeF7t0zGKU2EYheF/OldgIaTKTWEghKktJEswbQxkARZ207kFVzCTypQRGwmEgGsQAkFXEJB0YmEzder3Dszhe6c/N+c7z/w3zb8yC9yUudRDm9iF/gnEFrvQAoVO9WWLXWiBQqf6ssUutEChU33ZYhdaoNCpvmyxCy1Q6FRfttiFFih0qi9b7EILFDrVly12oQUKnerLFrvQAoVO9WWLXWiBQqf6ssUutEChU33ZYhdaoNCpvmyxCy1Q6FRfttiFFih0qi9b7EILFDrVl/0E2PP5/N12u/36BJ9GnxQbzXcdHg6H3eeHh/tR13VvJpPXl8vlX2vtf48/gT4lNprvOvzzeDy+GI/Hf1prXWvt42LxfrPZfOnxJ9CnxEbzXYeXq9Xq03q9/t1am7TW7sTucd1n9qnBYPDq2+Hw4+VoNPp7Pp8/LJeL/X5/eC41fdk9S0yn09vZbPb2dDr92u1233v+PPqc2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqit2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqit2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqit2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqit2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqit2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqit2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqit2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqit2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqit2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqit2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqit2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqit2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqit2Gi+rLDYWV6ordhovqyw2FleqK3YaL6ssNhZXqjtI0aYM3zWeJ4tAAAAAElFTkSuQmCC"

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/giving.195d74e.svg";

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/happy.413b21e.jpg";

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyMnB4IiB2aWV3Qm94PSIwIDAgMjQgMjIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ0LjEgKDQxNDU1KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5QYWdlIDE8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iR3JvdXAtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjAxX1RvbmVfSG9tZV8xMjAwX1BJTksiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDg5LjAwMDAwMCwgLTIzMjkuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cC0xNS1Db3B5LTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDgwMS4wMDAwMDAsIDIwNTUuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IkNhcmQtT25lLUNvcHktMiI+PC9nPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yOTQuMDczNzAxLDI3NC41MDA0MjggQzI5MS4wMDk2OTIsMjc0LjUzNjg1MyAyODguNSwyNzYuODgwNTYxIDI4OC41LDI4MC4wNjU3NjcgQzI4OC41LDI4My4wNjE2MDYgMjg5LjYwMTk3NSwyODQuOTIzNDYgMjkyLjMzMDIwOCwyODcuMjk0NDEgQzI5Mi4xMjM3NjQsMjg3LjExNTAwMSAyOTUuNzU1Mjk0LDI5MC4xMjYzODggMjk2LjgzNjEzNywyOTEuMTU1NTQ4IEMyOTguMDM0MzQ3LDI5Mi4yOTY0NjIgMjk5LjA3MDk1OSwyOTMuNDY1NzE5IDMwMCwyOTQuNzY4OTE4IEMzMDAuOTI5MDQsMjkzLjQ2NTcxOCAzMDEuOTY1NjUyLDI5Mi4yOTY0NTEgMzAzLjE2Mzg2LDI5MS4xNTU1MjMgQzMwNC4yNDQ3MTgsMjkwLjEyNjMzNSAzMDcuODc2MTM5LDI4Ny4xMTQ5ODkgMzA3LjY2OTkyMiwyODcuMjk0MjA2IEMzMTAuMzk4MDQ5LDI4NC45MjMyODkgMzExLjUsMjgzLjA2MTQ1MyAzMTEuNSwyODAuMDY1NzY3IEMzMTEuNSwyNzQuMTE5NjE3IDMwMy41NTg4OTEsMjcyLjI1MDM0IDMwMC40MzkwMTMsMjc3Ljk3MzgxNCBMMjk5Ljk5OTg5NywyNzguNzc5Mzc5IEwyOTkuNTYwOTQsMjc3Ljk3MzcyNyBDMjk4LjMyMzk2OSwyNzUuNzAzNDE2IDI5Ni4zNDExOTksMjc0LjUwOTQ2NiAyOTQuMTY5NjA3LDI3NC41MDA4MSBMMjk0LjA3MzcwMSwyNzQuNTAwNDI4IFoiIGlkPSJQYWdlLTEiIHN0cm9rZT0iIzVFNUU1RSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAQCAYAAADj5tSrAAAAAXNSR0IArs4c6QAAANNJREFUOE9j7Orq+s9AAfjw4cOTtrY2WXxGMNLFEgo8QbRWRqJVUqCQPpbExMSsosCRDN++fXu3bt26DHpFPLuurq4fyLIPHz48ePz48WmYxYy6urqhlPjk9+/f32/cuLGFh4dHtK6u7hXIrLNnzy5YuXJlItwSSixA1ju0LbG3ty/19vbuIhQajKSmrm3bthW9e/fuCchgoi0htVjp7+/Xev78+XWQJVpaWn5GRkYxIDYrKyu7pqYmOHW9f/+estR1+fLlnQwMDJ/Qg2hoRzyxSRgAu6qECdk2LS0AAAAASUVORK5CYII="

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAYCAYAAAB9ejRwAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjBCRjM1NTZFOUM2MTFFOThDMkRBQTBCQUNDMzY3RkUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjBCRjM1NTdFOUM2MTFFOThDMkRBQTBCQUNDMzY3RkUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyMEJGMzU1NEU5QzYxMUU5OEMyREFBMEJBQ0MzNjdGRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyMEJGMzU1NUU5QzYxMUU5OEMyREFBMEJBQ0MzNjdGRSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpkgegYAAABQSURBVHja7JRBDgAgCMPA+P8voz9QjBrQ9rzD0ixT68h51BMuEpCQpapX7bemKJV+6PzUrKnb2MgiP0WpbEO3lczz56lsarM9zpNS12kCDACcCwo///EpYAAAAABJRU5ErkJggg=="

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rules-banner.532eb9d.jpg";

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sparkelssmall.857b088.gif";

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/theme_bg.0de4d54.png";

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/womanonstairs-long.d1e0d8e.png";

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/womanonstairs.fb89e49.png";

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/glyphicons-halflings-regular.8988968.svg";

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.fa27723.woff";

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.448c34a.woff2";

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,d09GRk9UVE8AAAVkAAsAAAAAB1wAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAABCAAAAi4AAAKbH/pWDkZGVE0AAAM4AAAAGgAAABxt0civR0RFRgAAA1QAAAAcAAAAIAAyAARPUy8yAAADcAAAAFIAAABgUBj/rmNtYXAAAAPEAAAAUAAAAWIiC0SwaGVhZAAABBQAAAAuAAAANgABMftoaGVhAAAERAAAABwAAAAkA+UCA2htdHgAAARgAAAADgAAAA4ESgBKbWF4cAAABHAAAAAGAAAABgAFUABuYW1lAAAEeAAAANwAAAFuBSeBwnBvc3QAAAVUAAAAEAAAACAAAwABeJw9ks9vEkEUx2cpWyeUoFYgNkHi2Wt7N3rVm3cTs3UVLC4LxIWEQvi1P3i7O1tYLJDAmlgKGEhQrsajf0j7J3jYTXrQWUrMJG+++b55n5e8NwwKBhHDMLv5kxT3ATEBxKBn3qOAl9zxHgb1MAPhHQgHkyF08Gr/L8B/Eb6zWnmCJ7AJVLubQOheArXvJ1A4EXi6j4I+Zg9F0QFKvsnlBCmXeve+sFEnb/nCptdtQ4QYhVFRAT1HrF8UQK/RL/SbmUbclsvGVFXRZKDHUE38cc4qpkbAAsuwiImvro+ufcfaOIQ6szlrmjRJDaKZKnbjN3GWKIbiIzRFUfCffuxxKOL+3LDlDVvx2TdxN84qZEsnhNBa6pgm2dAsnzbLsETdsmRFxUeHV4e+I2/ptN8TyqV8T3Dt29t7EYOuajVIw2y1Wy3M86w0zg/Fz2IvawmQAUHOVrPVfLkoScVynsqsTG0MGUs4z55nh3mnOJa+li+rl9WpPIcFfDubDeaDC+fLBdYN3QADzLauGfj4B6sZmq6CCpqmtSvF0qlUl2qf5AJIUCSlTqlb7lUG+LRfGzZGzZEyBgccMu6MuqPecNDvD4Y9Kjtj4gD+DsvKVMTcMdtqtZtmkzQstQvYje7Syep0PDSAhSOeHYXYWThEF//A/0YvYV1fSQtpKU5STtrhbQ444OtpKSWJIg3pOg8cBs7maTY1EZf07aq+hjWs7IWzdCYTGhb2CtZ47x+Uhx28AAB4nGNgYGBkAIJz765vANHnCyvqYTQAWnkHswAAeJxjYGRgYOADYgkGEGBiYARCFjAG8RgABHYAN3icY2BmYmCcwMDKwMHow5jGwMDgDqW/MkgytDAwMDGwcjKAQQMDAyOQUmCAgoA01xQGB4ZExUmMD/4/YNBjvP3/NgNEDQPjbbBKBQZGADfLDgsAAHicY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQzMCQqKClOUJz0/z9YHRLv/+L7D+8V3cuHmgAHjGwM6ELUByxUMIOZCmbgAAA5LQ8XeJxjYGRgYABiO68w73h+m68M3EwMIHC+sKIeTqsyqDLeZrwN5HIwgKUB/aYJUgAAeJxjYGRgYLzNwMCgx8QAAkA2IwMqYAIAMGIB7QIAAAACAAAlACUAJQAlAAAAAFAAAAUAAHicbY49asNAEIU/2ZJDfkiRIvXapUFCEqpcptABUrg3ZhEiQoKVfY9UqVLlGDlADpAT5e16IUWysMz3hjfzBrjjjQT/EjKpCy+4YhN5yZoxcirPe+SMWz4jr6S+5UzSa3VuwpTnBfc8RF7yxDZyKs9r5IxHPiKv1P9iZqDnyAvMQ39UecbScVb/gJO03Xk4CFom3XYK1clhMdQUlKo7/d9NF13RkIdfy+MV7TSe2sl11tRFaXYmJKpWTd7kdVnJ8veevZKc+n3I93t9Jnvr5n4aTVWU/0z9AI2qMkV4nGNgZkAGjAxoAAAAjgAF"

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1142)
__webpack_require__(1141)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  "data-v-ce398968",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/AboutUs.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AboutUs.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ce398968", Component.options)
  } else {
    hotAPI.reload("data-v-ce398968", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1067)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(969),
  /* scopeId */
  "data-v-36e0590c",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/AccentureCharlot.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AccentureCharlot.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-36e0590c", Component.options)
  } else {
    hotAPI.reload("data-v-36e0590c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1059)
__webpack_require__(1058)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(962),
  /* scopeId */
  "data-v-2dc49f94",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/ArchivePlaylistPlayer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ArchivePlaylistPlayer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2dc49f94", Component.options)
  } else {
    hotAPI.reload("data-v-2dc49f94", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1044)
__webpack_require__(1043)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(952),
  /* scopeId */
  "data-v-14cf791a",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/B2B.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] B2B.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-14cf791a", Component.options)
  } else {
    hotAPI.reload("data-v-14cf791a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1086)
__webpack_require__(1085)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(980),
  /* scopeId */
  "data-v-476d1140",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/BecomeExpert.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] BecomeExpert.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-476d1140", Component.options)
  } else {
    hotAPI.reload("data-v-476d1140", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1122)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(1005),
  /* scopeId */
  "data-v-78b910b7",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Charities.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Charities.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-78b910b7", Component.options)
  } else {
    hotAPI.reload("data-v-78b910b7", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1151)
__webpack_require__(1150)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(1024),
  /* scopeId */
  "data-v-fc8db22c",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Community.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Community.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fc8db22c", Component.options)
  } else {
    hotAPI.reload("data-v-fc8db22c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1124)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(1007),
  /* scopeId */
  "data-v-7ea4666d",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/CommunityDemo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CommunityDemo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ea4666d", Component.options)
  } else {
    hotAPI.reload("data-v-7ea4666d", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1113)
__webpack_require__(1112)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(999),
  /* scopeId */
  "data-v-6d77c942",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/ContactUs.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ContactUs.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6d77c942", Component.options)
  } else {
    hotAPI.reload("data-v-6d77c942", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1077)
__webpack_require__(1076)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(975),
  /* scopeId */
  "data-v-420f1dc1",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/CorpPlaylistVideoPlayer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CorpPlaylistVideoPlayer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-420f1dc1", Component.options)
  } else {
    hotAPI.reload("data-v-420f1dc1", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1135)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(1013),
  /* scopeId */
  "data-v-9ff1e25a",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/CorporateCommunity.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CorporateCommunity.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9ff1e25a", Component.options)
  } else {
    hotAPI.reload("data-v-9ff1e25a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1061)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(964),
  /* scopeId */
  "data-v-304dffb6",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/CorporateGift.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CorporateGift.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-304dffb6", Component.options)
  } else {
    hotAPI.reload("data-v-304dffb6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1041)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(950),
  /* scopeId */
  "data-v-124f4978",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/CorporateLiveEvent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CorporateLiveEvent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-124f4978", Component.options)
  } else {
    hotAPI.reload("data-v-124f4978", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1119)
__webpack_require__(1118)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(1002),
  /* scopeId */
  "data-v-7113f34d",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/CorporateSale.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CorporateSale.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7113f34d", Component.options)
  } else {
    hotAPI.reload("data-v-7113f34d", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1040)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(949),
  /* scopeId */
  "data-v-11799b4e",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/CorporationGifting.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CorporationGifting.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-11799b4e", Component.options)
  } else {
    hotAPI.reload("data-v-11799b4e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1055)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(960),
  /* scopeId */
  "data-v-2791f852",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/CorporationGiftingComcast.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CorporationGiftingComcast.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2791f852", Component.options)
  } else {
    hotAPI.reload("data-v-2791f852", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1132)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(1011),
  /* scopeId */
  "data-v-94815cf4",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/CorporationReferral.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CorporationReferral.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-94815cf4", Component.options)
  } else {
    hotAPI.reload("data-v-94815cf4", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1140)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  "data-v-c0128b10",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/DemoEvent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DemoEvent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c0128b10", Component.options)
  } else {
    hotAPI.reload("data-v-c0128b10", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1082)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(978),
  /* scopeId */
  "data-v-4572d5bb",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/DrRamani.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DrRamani.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4572d5bb", Component.options)
  } else {
    hotAPI.reload("data-v-4572d5bb", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1069)
__webpack_require__(1068)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(970),
  /* scopeId */
  "data-v-3710880a",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/EmailRules.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EmailRules.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3710880a", Component.options)
  } else {
    hotAPI.reload("data-v-3710880a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1052)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(958),
  /* scopeId */
  "data-v-24b2f4ca",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Event.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Event.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24b2f4ca", Component.options)
  } else {
    hotAPI.reload("data-v-24b2f4ca", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1145)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  "data-v-ead0290e",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Expert.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Expert.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ead0290e", Component.options)
  } else {
    hotAPI.reload("data-v-ead0290e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1108)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(995),
  /* scopeId */
  "data-v-67ddb66c",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Experts.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Experts.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-67ddb66c", Component.options)
  } else {
    hotAPI.reload("data-v-67ddb66c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1074)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(973),
  /* scopeId */
  "data-v-38c57b52",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/FAQ.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FAQ.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38c57b52", Component.options)
  } else {
    hotAPI.reload("data-v-38c57b52", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1047)
__webpack_require__(1046)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(954),
  /* scopeId */
  "data-v-1a23b194",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Feedback.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Feedback.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1a23b194", Component.options)
  } else {
    hotAPI.reload("data-v-1a23b194", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1104)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(991),
  /* scopeId */
  "data-v-6374f53f",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Gift.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Gift.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6374f53f", Component.options)
  } else {
    hotAPI.reload("data-v-6374f53f", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1121)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(1004),
  /* scopeId */
  "data-v-75ef478a",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/GiftRedirect.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] GiftRedirect.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-75ef478a", Component.options)
  } else {
    hotAPI.reload("data-v-75ef478a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1035)
__webpack_require__(1037)
__webpack_require__(1036)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(947),
  /* scopeId */
  "data-v-0ed553c4",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Gifts.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Gifts.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0ed553c4", Component.options)
  } else {
    hotAPI.reload("data-v-0ed553c4", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1030)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(942),
  /* scopeId */
  "data-v-03049a46",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Giving.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Giving.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-03049a46", Component.options)
  } else {
    hotAPI.reload("data-v-03049a46", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1066)
__webpack_require__(1065)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(967),
  /* scopeId */
  "data-v-331b4fd3",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Hello.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Hello.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-331b4fd3", Component.options)
  } else {
    hotAPI.reload("data-v-331b4fd3", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(968),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Inspiration.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Inspiration.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-33b9632b", Component.options)
  } else {
    hotAPI.reload("data-v-33b9632b", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1098)
__webpack_require__(1097)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(988),
  /* scopeId */
  "data-v-5a54a012",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/InterestList.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] InterestList.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5a54a012", Component.options)
  } else {
    hotAPI.reload("data-v-5a54a012", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1081)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(977),
  /* scopeId */
  "data-v-4570478e",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Join.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Join.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4570478e", Component.options)
  } else {
    hotAPI.reload("data-v-4570478e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1026)
__webpack_require__(1025)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(939),
  /* scopeId */
  "data-v-00563de2",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/JoinNowMobile.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] JoinNowMobile.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-00563de2", Component.options)
  } else {
    hotAPI.reload("data-v-00563de2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1109)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(996),
  /* scopeId */
  "data-v-6a07750b",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Life.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Life.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6a07750b", Component.options)
  } else {
    hotAPI.reload("data-v-6a07750b", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1057)
__webpack_require__(1056)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(961),
  /* scopeId */
  "data-v-2d26e445",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/LifeContents.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LifeContents.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d26e445", Component.options)
  } else {
    hotAPI.reload("data-v-2d26e445", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1071)
__webpack_require__(1070)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(971),
  /* scopeId */
  "data-v-37fd3ce2",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/LiveEvent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LiveEvent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-37fd3ce2", Component.options)
  } else {
    hotAPI.reload("data-v-37fd3ce2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1131)
__webpack_require__(1130)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(1010),
  /* scopeId */
  "data-v-915672dc",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/LiveEventDemo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LiveEventDemo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-915672dc", Component.options)
  } else {
    hotAPI.reload("data-v-915672dc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1045)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(953),
  /* scopeId */
  "data-v-19786ae6",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/LiveStreamTest.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LiveStreamTest.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-19786ae6", Component.options)
  } else {
    hotAPI.reload("data-v-19786ae6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1120)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(1003),
  /* scopeId */
  "data-v-716462d9",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Logout.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Logout.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-716462d9", Component.options)
  } else {
    hotAPI.reload("data-v-716462d9", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1139)
__webpack_require__(1138)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(1016),
  /* scopeId */
  "data-v-bf8a8d2e",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Maintainance.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Maintainance.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bf8a8d2e", Component.options)
  } else {
    hotAPI.reload("data-v-bf8a8d2e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1111)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(998),
  /* scopeId */
  "data-v-6cd8833a",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/ManagePage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ManagePage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6cd8833a", Component.options)
  } else {
    hotAPI.reload("data-v-6cd8833a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1049)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(956),
  /* scopeId */
  "data-v-21385b83",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Mindbody.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Mindbody.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-21385b83", Component.options)
  } else {
    hotAPI.reload("data-v-21385b83", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1134)
__webpack_require__(1133)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(1012),
  /* scopeId */
  "data-v-9fb45a86",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/MindbodyContents.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MindbodyContents.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9fb45a86", Component.options)
  } else {
    hotAPI.reload("data-v-9fb45a86", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1149)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  "data-v-f4b69e7e",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Money.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Money.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f4b69e7e", Component.options)
  } else {
    hotAPI.reload("data-v-f4b69e7e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1147)
__webpack_require__(1146)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(1021),
  /* scopeId */
  "data-v-ebffec0a",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/MoneyContents.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MoneyContents.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ebffec0a", Component.options)
  } else {
    hotAPI.reload("data-v-ebffec0a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(983),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/NewCareer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NewCareer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4de429bf", Component.options)
  } else {
    hotAPI.reload("data-v-4de429bf", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1039)
__webpack_require__(1038)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(948),
  /* scopeId */
  "data-v-0f63bdda",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/NewEvents.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NewEvents.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0f63bdda", Component.options)
  } else {
    hotAPI.reload("data-v-0f63bdda", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1110)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(997),
  /* scopeId */
  "data-v-6a24856b",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Plans.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Plans.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6a24856b", Component.options)
  } else {
    hotAPI.reload("data-v-6a24856b", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1089)
__webpack_require__(1088)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(982),
  /* scopeId */
  "data-v-4d9ff14b",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/PlaylistVideoPlayer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PlaylistVideoPlayer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4d9ff14b", Component.options)
  } else {
    hotAPI.reload("data-v-4d9ff14b", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1127)
__webpack_require__(1129)
__webpack_require__(1128)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(1009),
  /* scopeId */
  "data-v-8baefe52",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/PodcastTone.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PodcastTone.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8baefe52", Component.options)
  } else {
    hotAPI.reload("data-v-8baefe52", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1136)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1014),
  /* scopeId */
  "data-v-a416555a",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/PressRelease.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PressRelease.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a416555a", Component.options)
  } else {
    hotAPI.reload("data-v-a416555a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1042)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(951),
  /* scopeId */
  "data-v-13ed2e4a",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/PrivacyPolicy.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PrivacyPolicy.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-13ed2e4a", Component.options)
  } else {
    hotAPI.reload("data-v-13ed2e4a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1102)
__webpack_require__(1100)
__webpack_require__(1103)
__webpack_require__(1101)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(990),
  /* scopeId */
  "data-v-6144c6ea",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Profile.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Profile.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6144c6ea", Component.options)
  } else {
    hotAPI.reload("data-v-6144c6ea", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1033)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(945),
  /* scopeId */
  "data-v-0bbfbd6c",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Rating.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Rating.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0bbfbd6c", Component.options)
  } else {
    hotAPI.reload("data-v-0bbfbd6c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1107)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(994),
  /* scopeId */
  "data-v-65ebedb2",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/RecentlyWatched.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RecentlyWatched.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-65ebedb2", Component.options)
  } else {
    hotAPI.reload("data-v-65ebedb2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1031)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(943),
  /* scopeId */
  "data-v-07c2a42a",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Redeem.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Redeem.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07c2a42a", Component.options)
  } else {
    hotAPI.reload("data-v-07c2a42a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1099)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(989),
  /* scopeId */
  "data-v-5ba2bfc2",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/RelatedVideo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RelatedVideo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5ba2bfc2", Component.options)
  } else {
    hotAPI.reload("data-v-5ba2bfc2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1093)
__webpack_require__(1092)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(985),
  /* scopeId */
  "data-v-55855f0b",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/ResetPassword.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ResetPassword.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-55855f0b", Component.options)
  } else {
    hotAPI.reload("data-v-55855f0b", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1084)
__webpack_require__(1083)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(979),
  /* scopeId */
  "data-v-46d191b4",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Resources.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Resources.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-46d191b4", Component.options)
  } else {
    hotAPI.reload("data-v-46d191b4", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1114)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(1000),
  /* scopeId */
  "data-v-7020e578",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Rules.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Rules.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7020e578", Component.options)
  } else {
    hotAPI.reload("data-v-7020e578", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1105)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(992),
  /* scopeId */
  "data-v-64c573f7",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Search.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Search.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-64c573f7", Component.options)
  } else {
    hotAPI.reload("data-v-64c573f7", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1144)
__webpack_require__(1143)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(1019),
  /* scopeId */
  "data-v-deef8e96",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/SetTone.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SetTone.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-deef8e96", Component.options)
  } else {
    hotAPI.reload("data-v-deef8e96", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1073)
__webpack_require__(1072)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(972),
  /* scopeId */
  "data-v-38b18f5a",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/SharePlaylistPlayer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SharePlaylistPlayer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38b18f5a", Component.options)
  } else {
    hotAPI.reload("data-v-38b18f5a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1075)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(974),
  /* scopeId */
  "data-v-3a123387",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/SignUp.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SignUp.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3a123387", Component.options)
  } else {
    hotAPI.reload("data-v-3a123387", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1137)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(1015),
  /* scopeId */
  "data-v-a428d674",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/TakeawayMobile.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TakeawayMobile.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a428d674", Component.options)
  } else {
    hotAPI.reload("data-v-a428d674", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1034)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(946),
  /* scopeId */
  "data-v-0c70a2bb",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Talk.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Talk.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0c70a2bb", Component.options)
  } else {
    hotAPI.reload("data-v-0c70a2bb", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1148)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(1022),
  /* scopeId */
  "data-v-f1f1b1be",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/TeaserMobile.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TeaserMobile.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f1f1b1be", Component.options)
  } else {
    hotAPI.reload("data-v-f1f1b1be", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1106)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(993),
  /* scopeId */
  "data-v-65a31e08",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Terms.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Terms.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-65a31e08", Component.options)
  } else {
    hotAPI.reload("data-v-65a31e08", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1029)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(941),
  /* scopeId */
  "data-v-02ed8db0",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Topic.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Topic.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-02ed8db0", Component.options)
  } else {
    hotAPI.reload("data-v-02ed8db0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1051)
__webpack_require__(1050)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(957),
  /* scopeId */
  "data-v-23798c26",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/TrendingPlaylist.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TrendingPlaylist.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-23798c26", Component.options)
  } else {
    hotAPI.reload("data-v-23798c26", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1096)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(987),
  /* scopeId */
  "data-v-593730aa",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/TrialExpiry.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TrialExpiry.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-593730aa", Component.options)
  } else {
    hotAPI.reload("data-v-593730aa", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1062)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(965),
  /* scopeId */
  "data-v-30ce6f02",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/TrialExpiry_Novo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TrialExpiry_Novo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-30ce6f02", Component.options)
  } else {
    hotAPI.reload("data-v-30ce6f02", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1080)
__webpack_require__(1078)
__webpack_require__(1079)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(976),
  /* scopeId */
  "data-v-434fb5b0",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/UnAuth.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UnAuth.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-434fb5b0", Component.options)
  } else {
    hotAPI.reload("data-v-434fb5b0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1126)
__webpack_require__(1125)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(1008),
  /* scopeId */
  "data-v-86595488",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/UnauthVideoPlayer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UnauthVideoPlayer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-86595488", Component.options)
  } else {
    hotAPI.reload("data-v-86595488", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1123)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(1006),
  /* scopeId */
  "data-v-7d18a2b6",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Validate.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Validate.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d18a2b6", Component.options)
  } else {
    hotAPI.reload("data-v-7d18a2b6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1028)
__webpack_require__(1027)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(940),
  /* scopeId */
  "data-v-02cadb06",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/VideoPlayer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] VideoPlayer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-02cadb06", Component.options)
  } else {
    hotAPI.reload("data-v-02cadb06", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1064)
__webpack_require__(1063)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(966),
  /* scopeId */
  "data-v-32e87aa0",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/Work.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Work.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32e87aa0", Component.options)
  } else {
    hotAPI.reload("data-v-32e87aa0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1054)
__webpack_require__(1053)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(959),
  /* scopeId */
  "data-v-270784da",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/WorkContents.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] WorkContents.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-270784da", Component.options)
  } else {
    hotAPI.reload("data-v-270784da", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1091)
__webpack_require__(1090)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(984),
  /* scopeId */
  "data-v-4f319b61",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/layout/Footer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Footer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4f319b61", Component.options)
  } else {
    hotAPI.reload("data-v-4f319b61", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1117)
__webpack_require__(1115)
__webpack_require__(1116)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1001),
  /* scopeId */
  "data-v-7063ff53",
  /* cssModules */
  null
)
Component.options.__file = "/opt/atlassian/pipelines/agent/build/src/components/layout/Header.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Header.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7063ff53", Component.options)
  } else {
    hotAPI.reload("data-v-7063ff53", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper contact-us-form",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "bodyContent"
  }, [(!_vm.isForget) ? _c('div', {
    staticClass: "login-modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('h3', [_vm._v("Member Sign In")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "login_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "padding-minus"
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "login_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.info.email),
      callback: function($$v) {
        _vm.$set(_vm.info, "email", $$v)
      },
      expression: "info.email"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "login_password",
      "error": "Password",
      "type": "password",
      "placeholder": "Password",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.info.password),
      callback: function($$v) {
        _vm.$set(_vm.info, "password", $$v)
      },
      expression: "info.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(!_vm.spinner) ? _c('button', {
    staticClass: "btn formButton btn-transparent btn-block",
    attrs: {
      "id": "login_button"
    }
  }, [_vm._v("\n                            Sign In\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.spinner) ? _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                        Forget your password ? "), _c('a', {
    staticClass: "forgotPassword",
    attrs: {
      "href": "javascript:",
      "id": "login_lnkforgotpassword"
    },
    on: {
      "click": function($event) {
        _vm.isForget = !_vm.isForget
      }
    }
  }, [_vm._v("Click Here")])])])])]) : _vm._e(), _vm._v(" "), (_vm.isForget) ? _c('div', {
    staticClass: "forget-password-modal"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "id": "forgot_password_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitForgetRequest.apply(null, arguments)
      }
    }
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "forgot_password_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.forgetPassword.email),
      callback: function($$v) {
        _vm.$set(_vm.forgetPassword, "email", $$v)
      },
      expression: "forgetPassword.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn formButton btn-transparent btn-block",
    attrs: {
      "disabled": _vm.spinner,
      "id": "forgot_password_proceed"
    }
  }, [_vm._v("\n                            Submit\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "forgotPassword",
    attrs: {
      "href": "javascript:",
      "id": "login_lnkbacktologin"
    },
    on: {
      "click": function($event) {
        _vm.isForget = !_vm.isForget
      }
    }
  }, [_c('strong', [_vm._v("Back to Sign In")])])])], 1)])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "boxed"
  }, [_vm._v("Not a member")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Welcome to Tone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "forgot-heading"
  }, [_vm._v("\n                    Forgot your password?\n                ")]), _vm._v(" "), _c('p', [_vm._v("Enter your email address to reset your password. your may need\n                to check your spam folder to unblock"), _c('br'), _vm._v("\n                no-reply@tonenetworks.com.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('p', [_vm._v("If you're not yet a Member, please go to "), _c('strong', [_vm._v("www.tonenetworks.com")]), _vm._v(" and select \"Join\" to create your account. ")]), _vm._v(" "), _c('p', [_vm._v("For TONE Corporate Membership recipients who have not yet activated an account, please go to your customized activation link.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boxpink"
  }, [_c('h2', {
    staticClass: "boxed"
  }, [_vm._v("What you get")]), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, [_c('li', [_vm._v("Personalized bite-sized expert videos will inspire you and set a positive TONE to your day")]), _vm._v(" "), _c('li', [_vm._v("Reserve your spot for TONE Live... exclusive live streaming events with our credentialed expert")]), _vm._v(" "), _c('li', [_vm._v("Tune in to TONE Talks... our moderated discussions every Tuesday where we share advice within our community of women helping women!")]), _vm._v(" "), _c('li', [_vm._v("And did we mention you will be helping out a charity every time you use the site?")]), _vm._v(" "), _c('li', [_vm._v("Look out for TONE Teasers... customized emails with videos selected just for you!")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-00563de2", module.exports)
  }
}

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper fixgraybg"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.videoSqueeze),
      expression: "!videoSqueeze"
    }],
    staticClass: "video-player-background",
    class: {
      'animated zoomOutLeft': _vm.videoCompleted
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "video-player",
    on: {
      "mouseleave": function($event) {
        _vm.addRightHoverWidthClass ? _vm.resetClass(true) : _vm.resetClass(false)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideLeftVideoIcons),
      expression: "!hideLeftVideoIcons"
    }],
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.currentVideo && _vm.playTheVideo) ? _c('div', {
    staticClass: "reset-video-width",
    class: {
      'enjoy-hover': _vm.addEnjoyHoverClass
    }
  }, [_c('jwplayer', {
    attrs: {
      "id": "mainVideoPlayer",
      "data": _vm.currentVideo,
      "on-complete": _vm.onVideoComplete
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right-video-icons",
    class: {
      'trailexp': _vm.isTrialExpired, 'right-hover-width': _vm.addRightHoverWidthClass, 'right-hover-enjoy': _vm.addRightHoverEnjoyClass
    },
    on: {
      "mouseleave": function($event) {
        return _vm.resetClass(true)
      }
    }
  }, [_c('div', {
    staticClass: "icons-hover",
    class: {
      'icon-hover-width': _vm.addIconHoverWidthClass
    }
  }, [_c('ul', [(_vm.currentStatus.liked === '1') ? _c('li', [_c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "addToPlayerTop",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('addToPlayerTop')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.currentVideo)
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.currentVideo, playlist, _vm.verifyVideoExists(playlist, _vm.currentVideo))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                    "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('addToPlayerTop')
      }
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart pink-filled",
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]) : _c('li', [_c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "addToPlayerTop",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('addToPlayerTop')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.currentVideo)
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.currentVideo, playlist, _vm.verifyVideoExists(playlist, _vm.currentVideo))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('addToPlayerTop')
      }
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "rate",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "mouseover": _vm.changeHeight
    }
  }, [_vm._v("Suggest a TONE Topic")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "share",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "mouseover": _vm.showSharing
    }
  }, [_vm._v("Share")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "enjoy",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "mouseover": _vm.showEnjoy
    }
  }, [_vm._v("Rating")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRateHoverBox),
      expression: "showRateHoverBox"
    }],
    staticClass: "rate-hover-box",
    class: {
      'z-index': _vm.showRateHoverBox
    },
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_c('span', [_vm._v("Let us know what topics you want to see on TONE")]), _vm._v(" "), (_vm.currentStatus.opinion === '1') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setOpinion('travel')
      }
    }
  }, [_vm._v("\n                                        Travel\n                                    ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setOpinion('travel')
      }
    }
  }, [_vm._v("\n                                        Travel\n                                    ")])]), _vm._v(" "), (_vm.currentStatus.opinion === '2') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setOpinion('dating')
      }
    }
  }, [_vm._v("\n                                        Dating\n                                    ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setOpinion('dating')
      }
    }
  }, [_vm._v("\n                                        Dating\n                                    ")])]), _vm._v(" "), (_vm.currentStatus.opinion === '3') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setOpinion('news')
      }
    }
  }, [_vm._v("\n                                        News\n                                    ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setOpinion('news')
      }
    }
  }, [_vm._v("\n                                        News\n                                    ")])]), _vm._v(" "), (_vm.currentStatus.opinion === '4') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setOpinion('recipes')
      }
    }
  }, [_vm._v("\n                                        Recipes\n                                    ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setOpinion('recipes')
      }
    }
  }, [_vm._v("\n                                        Recipes\n                                    ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showShareHoverBox),
      expression: "showShareHoverBox"
    }],
    staticClass: "share-hover-box",
    class: {
      'z-index': _vm.showShareHoverBox
    },
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_c('div', {
    staticClass: "social-share-manage"
  }, [(_vm.currentVideo) ? _c('social-sharing', {
    class: {
      'control-disabled': _vm.isVideoPrivate
    },
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }) : _vm._e(), _vm._v(" "), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareVideoPermission >= 1))) ? _c('i', {
    staticClass: "fa fa-2x fa-share-square-o cursor",
    attrs: {
      "title": "Share"
    },
    on: {
      "click": function($event) {
        return _vm.showSharingModal()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.corporateInfo && (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareVideoPermission >= 1)) ? _c('span', [_c('a', {
    staticClass: "popupsharingoptionlink",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showSharingModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with " + _vm._s(_vm.user.isSuperUser ? _vm.user.corporationName : _vm.corporateInfo.name))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnjoyHoverBox),
      expression: "showEnjoyHoverBox"
    }],
    staticClass: "enjoy-hover-box",
    class: {
      'z-index': _vm.showEnjoyHoverBox
    },
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_c('div', {
    staticClass: "rating"
  }, [_c('p', [_vm._v("So, what did you think?")]), _vm._v(" "), (_vm.currentStatus.rating === '1') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setRating('1')
      }
    }
  }, [_vm._v("\n                                            1 - Not for me\n                                        ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setRating('1')
      }
    }
  }, [_vm._v("\n                                            1 - Not for me\n                                        ")])]), _vm._v(" "), (_vm.currentStatus.rating === '2') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setRating('2')
      }
    }
  }, [_vm._v("\n                                            2 - Just ok\n                                        ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setRating('2')
      }
    }
  }, [_vm._v("\n                                            2 - Just ok\n                                        ")])]), _vm._v(" "), (_vm.currentStatus.rating === '3') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setRating('3')
      }
    }
  }, [_vm._v("\n                                            3 - Worth it\n                                        ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setRating('3')
      }
    }
  }, [_vm._v("\n                                            3 - Worth it\n                                        ")])]), _vm._v(" "), (_vm.currentStatus.rating === '4') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg active",
    on: {
      "click": function($event) {
        return _vm.setRating('4')
      }
    }
  }, [_vm._v("\n                                            4 - Spot on\n                                        ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.setRating('4')
      }
    }
  }, [_vm._v("\n                                            4 - Spot on\n                                        ")])])])])])])])])]), _vm._v(" "), (_vm.videoSqueeze) ? _c('div', {
    staticClass: "watch-again"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "congratz"
  }, [_c('button', {
    staticClass: "btn btn-danger backtohomebutton btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.redirectToHome()
      }
    }
  }, [_vm._v("Back to Home Page")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.videoMessage) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-6"
  }, [_c('div', {
    staticClass: "current-video-img"
  }, [_c('div', {
    staticClass: "responsiveSocialIcon"
  }, [(_vm.videoGifIndex === 0) ? _c('img', {
    attrs: {
      "src": __webpack_require__(832),
      "alt": _vm.currentVideo.title
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videoGifIndex === 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(826),
      "alt": _vm.currentVideo.title
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videoGifIndex === 2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(831),
      "alt": _vm.currentVideo.title
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videoGifIndex === 3) ? _c('img', {
    attrs: {
      "src": __webpack_require__(846),
      "alt": _vm.currentVideo.title
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentVideo) ? _c('div', {
    staticClass: "responsiveSocialIconBox"
  }, [_c('social-sharing', {
    class: {
      'control-disabled': _vm.isVideoPrivate
    },
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.replayVideo
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-play"
  }), _vm._v("    watch again\n                            ")]), _vm._v(" "), (_vm.currentStatus.liked === '1') ? _c('i', {
    staticClass: "cursor fa fa-heart heartIcon",
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  }) : _c('i', {
    staticClass: "cursor fa fa-heart-o heartIcon",
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-lg-6"
  }, [_c('div', {
    staticClass: "rating"
  }, [_c('ul', {
    staticClass: "chart-skills"
  }, [_c('li', {
    class: {
      'active-icon': _vm.applyRatingClass('1')
    },
    on: {
      "click": function($event) {
        return _vm.setRatingChart('1')
      }
    }
  }, [_c('span', [_vm._v("Not for me")])]), _vm._v(" "), _c('li', {
    class: {
      'active-icon': _vm.applyRatingClass('2')
    },
    on: {
      "click": function($event) {
        return _vm.setRatingChart('2')
      }
    }
  }, [_c('span', [_vm._v("Just ok")])]), _vm._v(" "), _c('li', {
    class: {
      'active-icon': _vm.applyRatingClass('3')
    },
    on: {
      "click": function($event) {
        return _vm.setRatingChart('3')
      }
    }
  }, [_c('span', [_vm._v("Worth it")])]), _vm._v(" "), _c('li', {
    class: {
      'active-icon': _vm.applyRatingClass('4')
    },
    on: {
      "click": function($event) {
        return _vm.setRatingChart('4')
      }
    }
  }, [_c('span', [_vm._v("Spot on")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [(_vm.showRatingMessage) ? _c('h2', {
    staticClass: "pinkh2"
  }, [_vm._v("Thanks for your feedback!")]) : _vm._e()])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "player-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), (_vm.getCorpButtonColor === '#f0617d') ? _c('div', {
    staticClass: "text-right mobileiconholder"
  }, [_c('ul', {
    staticClass: "mobilesocialicons"
  }, [(_vm.currentStatus.liked === '1') ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart pink-filled",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]) : _c('li', [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.currentVideo.mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.currentVideo.mediaid)
      }
    }
  }, [_c('img', {
    staticClass: "menuiconbutton",
    attrs: {
      "src": __webpack_require__(339),
      "title": "Playlist",
      "alt": "PLAYLIST"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.currentVideo)
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.currentVideo, playlist, _vm.verifyVideoExists(playlist, _vm.currentVideo))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.currentVideo.mediaid)
      }
    }
  })])])]), _vm._v(" "), (_vm.currentVideo) ? _c('social-sharing', {
    class: {
      'control-disabled': _vm.isVideoPrivate
    },
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": _vm.currentVideo.title,
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }) : _vm._e(), _vm._v(" "), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareVideoPermission >= 1))) ? _c('i', {
    staticClass: "fa fa-2x fa-share-square-o cursor",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.showSharingModal()
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getCorpButtonColor !== '#f0617d') ? _c('div', {
    staticClass: "text-right mobileiconholder"
  }, [_c('ul', {
    staticClass: "mobilesocialicons"
  }, [(_vm.currentStatus.liked === '1') ? _c('li', {
    style: ({
      backgroundColor: '#A9A9A9 !important'
    })
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart pink-filled",
    style: ({
      backgroundColor: '#A9A9A9 !important'
    }),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]) : _c('li', [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    style: ({
      backgroundColor: '#A9A9A9 !important'
    }),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.setUserLike()
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "plusicon btn-group",
    style: ({
      backgroundColor: '#A9A9A9 !important'
    })
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.currentVideo.mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.currentVideo.mediaid)
      }
    }
  }, [_c('img', {
    staticClass: "menuiconbutton",
    attrs: {
      "src": __webpack_require__(339),
      "title": "Playlist",
      "alt": "PLAYLIST"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.currentVideo)
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.currentVideo, playlist, _vm.verifyVideoExists(playlist, _vm.currentVideo))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                    "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.currentVideo.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.currentVideo.mediaid)
      }
    }
  })])])]), _vm._v(" "), (_vm.currentVideo) ? _c('social-sharing', {
    class: {
      'control-disabled': _vm.isVideoPrivate
    },
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": _vm.currentVideo.title,
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }) : _vm._e(), _vm._v(" "), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareVideoPermission >= 1))) ? _c('i', {
    staticClass: "fa fa-2x fa-share-square-o cursor",
    style: ({
      backgroundColor: '#A9A9A9 !important'
    }),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.showSharingModal()
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.currentVideo.Description) + "\n                        ")]), _vm._v(" "), (_vm.getExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.getExpert[0].expertId + '/' + _vm.getExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": _vm.getExpert[0].name,
      "title": _vm.getExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                            " + _vm._s(_vm.getExpert && _vm.getExpert[0].areasofexpertise) + "\n                        ")]), _vm._v(" "), (!_vm.isTrialExpired) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-3"
  }, [_c('button', {
    staticClass: "btn recently-watched-btn btn-transparent btn-lg",
    style: ([_vm.viewTranscript ? {
      color: '#FFFFFF !important',
      backgroundColor: this.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      outline: 'none !important'
    } : {
      color: _vm.getCorpButtonColor + ' !important',
      backgroundColor: '#FFFFFF !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      outline: 'none !important'
    }]),
    on: {
      "click": _vm.toggleViewTranscript
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.viewTranscript),
      expression: "!viewTranscript"
    }]
  }, [_vm._v("View Transcript")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewTranscript),
      expression: "viewTranscript"
    }]
  }, [_vm._v("Hide Transcript")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8 col-lg-9 vtrnscript"
  }, [(_vm.getCurrentVideoTranscript) ? _c('div', {
    staticClass: "side-content",
    style: ({
      'border-left-color': this.getCorpHeaderColor + ' !important'
    })
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewTranscript),
      expression: "viewTranscript"
    }],
    staticClass: "boxes",
    class: {
      'animated fadeIn': _vm.viewTranscript, 'animated fadeOut': !_vm.viewTranscript
    }
  }, [_c('pre', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentVideoTranscript.vtt_file)
    }
  }, [_vm._v("\n                                        ")])])])]) : _vm._e()])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "recently-watched"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthRecommendedVideos && !_vm.isTrialExpired) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.recommendationList) ? _c('VueSlickCarousel', _vm._b({}, 'VueSlickCarousel', _vm.carouselSettings, false), _vm._l((_vm.recommendationList), function(reccentVideo) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + reccentVideo.mediaid + '/' + reccentVideo.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": reccentVideo.image,
        "title": reccentVideo.title,
        "alt": reccentVideo.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(reccentVideo.title) + "\n                                            ")])])])])
  }), 0) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    style: (_vm.styleObject),
    on: {
      "click": function($event) {
        return _vm.redirectToRelatedVideos()
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_vm._v("View All Your Videos")])])]) : _vm._e()])]), _vm._v(" "), (_vm.showMemberOverlay) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showMemberOverlay
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelMemberModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelMemberModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('p', [_c('b', [_vm._v("We hope you're enjoying your free access to TONE Lite, a limited preview experience!")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("In order to customize your viewing and to be able to produce videos relevant to you, we occasionally need to ask you to update your subscription information")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn formButton btn-transparent",
    attrs: {
      "id": "videoplayer_videoredirect"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/becomemember')
      }
    }
  }, [_vm._v("\n                        Update my Membership\n                    ")]), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-transparent",
    attrs: {
      "id": "videoplayer_videostay"
    },
    on: {
      "click": function($event) {
        return _vm.cancelMemberModal()
      }
    }
  }, [_vm._v("\n                        Not right now, take me to free video\n                    ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showShareCommunity) ? _c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]) : _vm._e(), _vm._v(" "), (_vm.showShareIndividual) ? _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.showShareFriends) ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentVideo.img,
      "title": _vm.currentVideo.title,
      "alt": _vm.currentVideo.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.currentVideo.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.currentVideo.Description.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share this video\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showSharedModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showSharedModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "method": "post",
      "id": "playlistshare-form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSharePlaylist.apply(null, arguments)
      }
    }
  }, [_c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedMessage",
      "id": "playlistshare_sharedMessage",
      "type": "text",
      "error": "Optional Message",
      "placeholder": "Optional Message",
      "autocomplete": "off",
      "icon": ""
    },
    model: {
      value: (_vm.sharePayload.sharedEmailMessage),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedEmailMessage", $$v)
      },
      expression: "sharePayload.sharedEmailMessage"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedEmailMessagePreview",
      "id": "playlistshare_sharedEmailMessagePreview",
      "type": "textarea",
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.sharePayload.sharedPlaylistPreview),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedPlaylistPreview", $$v)
      },
      expression: "sharePayload.sharedPlaylistPreview"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "disabled": _vm.spinner || (_vm.taggedEmails && _vm.taggedEmails.length === 0)
    }
  }, [_vm._v("\n                            Send Email\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("RELATED VIDEOS")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-02cadb06", module.exports)
  }
}

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topic"
  }, [_c('h1', {
    staticClass: "pageHeading"
  }, [_vm._v("\n        What Are Your Interests?\n    ")]), _vm._v(" "), _c('p', [_vm._v("Select as many topics as you'd like")]), _vm._v(" "), _c('div', {
    staticClass: "containerBox"
  }, [_c('bs-input', {
    attrs: {
      "type": "text",
      "id": "topic_search",
      "placeholder": "Search Topics"
    }
  }, [_c('span', {
    staticClass: "input-group-addon inputIcon",
    attrs: {
      "slot": "after"
    },
    slot: "after"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-search"
  })])]), _vm._v(" "), _c('button-group', {
    model: {
      value: (_vm.interestIndexes),
      callback: function($$v) {
        _vm.interestIndexes = $$v
      },
      expression: "interestIndexes"
    }
  }, _vm._l((_vm.interests), function(interest, index) {
    return _c('checkbox', {
      key: index,
      staticClass: "min-padding",
      attrs: {
        "true-value": index
      }
    }, [_vm._v("\n                " + _vm._s(interest.interestName) + "\n            ")])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn formButton",
    on: {
      "click": function($event) {
        return _vm.proceedUserInfo()
      }
    }
  }, [_vm._v("\n                Done\n                "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-02ed8db0", module.exports)
  }
}

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "giving-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(833),
      "alt": "TONE GIVING",
      "title": "TONE Giving"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("giving")]), _vm._v(" "), _c('p', [_vm._v("\n            While we can't give you back time, we can make it easier to give back to others. This is why we created Clicks For Good. The more time you spend on TONE, the more we'll donate to the charity of your choice. Thanks for helping us out!\n        ")]), _vm._v(" "), _vm._l((_vm.getAllCharities), function(charity) {
    return _c('div', {
      key: charity.charityId
    }, [_c('div', {
      staticClass: "row givingVideos"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6"
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('div', [_c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": charity.img_url,
        "title": charity.name,
        "alt": charity.name
      }
    })])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6"
    }, [_c('h3', [_vm._v(_vm._s(charity.name)), _c('br'), _c('small', [_c('a', {
      staticClass: "weblink",
      attrs: {
        "target": "_new",
        "href": charity.website
      }
    }, [_vm._v(_vm._s(charity.website))])])]), _vm._v(" "), _c('p', [_vm._v("\n                       " + _vm._s(charity.description) + "\n                    ")]), _vm._v(" "), (_vm.getSelectedCharity) ? _c('div', [(_vm.checkCharity(charity) === true) ? _c('div', [_c('button', {
      staticClass: "selectedCharity",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Your Charity!")])]) : _c('div', [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.changeCharity(charity)
        }
      }
    }, [_vm._v("\n                                Choose this Charity!\n                                ")])])]) : _vm._e()])])])
  })], 2), _vm._v(" "), (_vm.showModal_player) ? _c('modal', {
    attrs: {
      "effect": "zoom",
      "value": _vm.showModal_player,
      "width": "400"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal_player()
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentPlayerID
    }
  }, [_vm._v("Loading the player...")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-03049a46", module.exports)
  }
}

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "redeem_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "left-content"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true
    }
  }, [_c('panel', {
    staticClass: "text-left",
    attrs: {
      "is-open": true
    }
  }, [_c('h4', [_vm._v("Start your Gift. Set up your Account")]), _vm._v(" "), _c('div', {
    staticClass: "create-account"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onGifteeSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus"
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z '-]+$/,
      "id": "redeem_firstname",
      "type": "text",
      "error": "First Name (no digits allowed)",
      "placeholder": "First Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstName", $$v)
      },
      expression: "user.firstName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z '-]+$/,
      "id": "redeem_lastname",
      "type": "text",
      "error": "Last Name (no digits allowed)",
      "placeholder": "Last Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastName", $$v)
      },
      expression: "user.lastName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[\w\d.+-]+@[\w\d-]+\.[a-z]+$/i,
      "id": "redeem_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), _c('vue-password', {
    staticClass: "form-input",
    attrs: {
      "minlength": 6,
      "classes": "input form-control",
      "placeholder": "Password",
      "error": "Password",
      "id": "signup_password",
      "disableStrength": _vm.hidePasswordMeter,
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-info-circled alert-icon-float-left information"
  }, [_c('p', {
    staticClass: "alert alert-info alert-dismissable",
    class: {
      'set-error': !_vm.verifyPassword()
    },
    attrs: {
      "id": "redeem_pwderrormsg"
    }
  }, [_vm._v("Min 6 Chars, One Upper Case, One Lower Case!")])]), _vm._v(" "), _c('checkbox', {
    staticClass: "terms-and-condition",
    attrs: {
      "value": "isChecked",
      "type": "primary"
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n                                                         I agree to "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "_blank"
    }
  }, [_vm._v("terms and conditions")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "id": "redeem_button",
      "disabled": !_vm.isChecked || _vm.spinner
    }
  }, [_vm._v("\n                                                        Complete Sign Up\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, [(_vm.dynamic_bullet_1) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_2) ? _c('li', {
    staticClass: "hidemobile",
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_3) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_3)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_4) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_4)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_5) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_5)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_6) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_6)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer hidemobile"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.defaultPlan.description))])])])])])])])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), _c('h2', [_vm._v("\n                                Welcome to TONE.\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "hidemobile"
  }, [_c('h2', [_vm._v("Your Plan")]), _c('p', [_vm._v("What You Get")])]), _vm._v(" "), _c('div', {
    staticClass: "showmobile"
  }, [_c('h2', [_vm._v("What You Get")])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07c2a42a", module.exports)
  }
}

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.getSelectedEvent) ? _c('div', [(_vm.user && _vm.isEventToday(_vm.getSelectedEvent[0].start_date, _vm.getSelectedEvent[0].end_date, _vm.getSelectedEvent[0].eventSwitchTime, _vm.getEventSwitchTime)) ? _c('div', [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('h3', [_vm._v("Choose how you want to join the event. You can join as yourself or step into someone else's shoes using our anonymous incognito mode")]) : _c('h3', [_vm._v("Choose how you want to join the event. You can join as yourself or step into someone else's shoes using our anonymous shoe-cognito mode.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    style: (_vm.styleObjectByName),
    attrs: {
      "type": "button",
      "title": "Join event with your first name"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      },
      "click": function($event) {
        return _vm.joinEvent('0')
      }
    }
  }, [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v(" "), _c('button', {
    style: (_vm.styleObjectCognito),
    attrs: {
      "type": "button",
      "title": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'Join event as incognito' : 'Join event as shoe-cognito'
    },
    on: {
      "mouseenter": function($event) {
        return _vm.updateHoverStateCog(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverStateCog(false)
      },
      "click": function($event) {
        return _vm.joinEvent('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.cognitoMsg))])]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.isEventToday(_vm.getSelectedEvent[0].start_date, _vm.getSelectedEvent[0].end_date, _vm.getSelectedEvent[0].eventSwitchTime, _vm.getEventSwitchTime)) ? _c('div', [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('h3', [_vm._v("This event will start " + _vm._s(_vm.getDateReference(_vm.getSelectedEvent[0].start_date, 'live2')) + ". Check back on this page "), (_vm.getSelectedEvent[0].eventSwitchTime && _vm.getSelectedEvent[0].eventSwitchTime > 0) ? _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v(" " + _vm._s(_vm.getSelectedEvent[0].eventSwitchTime) + " ")]) : _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.getEventSwitchTime))]), _vm._v(" minutes before the event start time and choose how you want to join the event. "), _c('br'), _vm._v("You can join as yourself or step into someone else's shoes using our anonymous incognito mode.")]) : _c('h3', [_vm._v("This event will start " + _vm._s(_vm.getDateReference(_vm.getSelectedEvent[0].start_date, 'live2')) + ". Check back on this page "), (_vm.getSelectedEvent[0].eventSwitchTime && _vm.getSelectedEvent[0].eventSwitchTime > 0) ? _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v(" " + _vm._s(_vm.getSelectedEvent[0].eventSwitchTime) + " ")]) : _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.getEventSwitchTime))]), _vm._v(" minutes before the event start time and choose how you want to join the event. "), _c('br'), _vm._v("You can join as yourself or step into someone else's shoes using our anonymous shoe-cognito mode.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "disabled": "",
      "title": "Event hasn't started yet"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent('0')
      }
    }
  }, [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "disabled": "",
      "title": "Event hasn't started yet"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent('1')
      }
    }
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('span', [_vm._v("Incognito")]) : _c('span', [_vm._v("shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (!_vm.user && _vm.isEventToday(_vm.getSelectedEvent[0].start_date, _vm.getSelectedEvent[0].end_date, _vm.getSelectedEvent[0].eventSwitchTime, _vm.getEventSwitchTime)) ? _c('div', [_c('button', {
    style: (_vm.styleObjectByName),
    attrs: {
      "type": "button",
      "title": "Login or Signup to join the event"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      },
      "click": function($event) {
        return _vm.joinEventUnAuth(_vm.getSelectedEvent[0])
      }
    }
  }, [_vm._v("Go to Event")])]) : _vm._e(), _vm._v(" "), (!_vm.user && !_vm.isEventToday(_vm.getSelectedEvent[0].start_date, _vm.getSelectedEvent[0].end_date, _vm.getSelectedEvent[0].eventSwitchTime, _vm.getEventSwitchTime)) ? _c('div', [_c('h3', [_vm._v("This event will start " + _vm._s(_vm.getDateReference(_vm.getSelectedEvent[0].start_date, 'live2')) + ". "), _c('a', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    }),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.UnauthSignInClick(_vm.getSelectedEvent[0])
      }
    }
  }, [_vm._v("Sign In")]), _vm._v(" or "), _c('a', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    }),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.UnauthJoinClick(_vm.getSelectedEvent[0])
      }
    }
  }, [_vm._v("Sign Up")]), _vm._v(" to join us for a discussion that will inspire and empower you to be the best version of yourself.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "sigup-green-join-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.UnauthJoinClick(_vm.getSelectedEvent[0])
      }
    }
  }, [_vm._v(_vm._s(_vm.trialButtonTitle))])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                Please follow the event guidelines:\n                "), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v("1.)")]), _vm._v(" Keep it positive, supportive and respectful;\n                "), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v("2.)")]), _vm._v(" Please be thoughtful and stay on topic;\n                "), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v("3.)")]), _vm._v(" Please do not post copyrighted material, ads, solicitations or anyone's personal info including your own;\n                "), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v("4.)")]), _vm._v(" Please refer to TONE's "), _c('a', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    }),
    attrs: {
      "href": "/terms",
      "target": "new",
      "title": "click to view our terms"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" for more information.\n            ")])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07f96927", module.exports)
  }
}

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper rating-wrapper"
  }, [_c('div', {
    staticClass: "watch-again"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "current-video-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentVideo.img,
      "alt": _vm.currentVideo.title
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "recently-watched"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthRecommendedVideos) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.recommendationList), function(reccentVideo) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": reccentVideo.image
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(reccentVideo.mediaid)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v("\n                                        " + _vm._s(reccentVideo.title) + "\n                                    ")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.redirectToRelatedVideos()
      }
    }
  }, [_vm._v("View All Your Videos")])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "congratz"
  }, [_vm._v("Congrats! You learned a new lorem ipsum dolor sit amet today")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-link"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-play"
  }), _vm._v("    watch again\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "rating"
  }, [_c('ul', {
    staticClass: "chart-skills"
  }, [_c('li', [_c('span', [_vm._v("Rating 1")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Rating 2")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Rating 3")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Rating 4")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Use these 7 Tips to Climb the Corporate Ladder")]), _vm._v(" "), _c('p', [_vm._v("\n                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\n                        been the industry's standard dummy text ever since the 1500s, when an unknown printer took a\n                        galley of type and scrambled it to make a type specimen book. It has survived not only five\n                        centuries, but also the leap into electronic typesetting, remaining essentially unchanged.\n                        It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum\n                        passages, and more recently with desktop publishing software like Aldus PageMaker including\n                        versions of Lorem Ipsum\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "recently-watched"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg"
  }, [_vm._v("View Transcript")])]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_c('div', {
    staticClass: "authorContent"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(837),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Joelle K. Jay")]), _vm._v(" "), _c('h5', [_vm._v("Author, CEO")])]), _vm._v(" "), _c('p', [_vm._v("\n                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\n                            been the industry's standard dummy text ever\n                        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("RELATED VIDEOS")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0bbfbd6c", module.exports)
  }
}

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tone-talk"
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Hey, " + _vm._s(_vm.user.firstName) + ". Great to see you. "), _c('br'), _vm._v("Enjoy the Tone Talk!")]), _vm._v(" "), (!_vm.jwEventRef) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-7"
  }, [_c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("discussion")]), _vm._v(" "), (_vm.getUserSignature) ? _c('div', [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "650",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "allowtransparency": "true",
      "src": _vm.chatRollURL
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-pink",
    on: {
      "click": _vm.leaveEvent
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Leave")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-5"
  }, [_c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("moderator")]), _vm._v(" "), _c('div', {
    staticClass: "moderatorContent"
  }, [_c('p', [_vm._v("\n                            " + _vm._s(_vm.getSelectedEvent[0].longDescription) + "\n                        ")]), _vm._v(" "), _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("attendees")]), _vm._v(" "), (_vm.eventUsersArray) ? _c('div', {
    staticClass: "slider responsive-slick-eventusers"
  }, [_c('div', {
    staticClass: "attendeesImg",
    attrs: {
      "*v-for": "userList in eventUsersArray"
    }
  }, [(_vm.userList[0]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[0].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[0].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[0].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[0].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[0].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (_vm.userList[1]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[1]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[1].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[1].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[1].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[1].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[1].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[2]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[2]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[2].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[2].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[2].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[2].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[2].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[3]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[3]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[3].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[3].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[3].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[3].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[3].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[4]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[4]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[4].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[4].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[4].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[4].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[4].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[5]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[5]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[5].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[5].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[5].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[5].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[5].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[6]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[6]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[6].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[6].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[6].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[6].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[6].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[7]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[7]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[7].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[7].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[7].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[7].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[7].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userList[8]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[8]) ? _c('div', {
    staticClass: "userImage"
  }, [(_vm.userList[8].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[8].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[7].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[8].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[8].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()]) : _vm._e()])]) : _vm._e()])])])]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "rowtight"
  }, [_c('div', {
    staticClass: "col-sm-7 innerpadding align:top"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.jwEventRef,
      "frameborder": "0",
      "scrolling": "auto",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 text-left"
  }, [(_vm.getUserSignature) ? _c('div', [_c('h4', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("TONE Talks Coaching: " + _vm._s(_vm.getSelectedEvent[0].title))]), _vm._v(" "), _c('p', [_vm._v("Welcome! Join us for a discussion that will inspire and empower you to be the best version of yourself.")]), _vm._v(" "), (_vm.getShowCountFlag) ? _c('h6', [_vm._v("Total Participants: " + _vm._s(_vm.participantCount))]) : _vm._e(), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "100%",
      "height": "400px",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "allowtransparency": "true",
      "src": _vm.chatRollURL
    }
  })]) : _vm._e()])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c70a2bb", module.exports)
  }
}

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('img', {
    staticClass: "showMobile",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(116)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "over-lay text-left"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "main-heading"
  }, [_c('button', {
    staticClass: "btn btn-primary main-heading-btn btn-lg showMobile",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirect()
      }
    }
  }, [_vm._v("Give the Gift of TONE")]), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": 'Give the Gift of Knowledge and Empowerment',
      "description": _vm.sharingDescription,
      "title": _vm.sharingTitle
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "socialicons"
          }, [_c('network', {
            staticClass: "holder",
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('ul', [(_vm.dynamic_para_1) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_1)
    }
  }) : _vm._e(), _c('br')]), _vm._v(" "), (_vm.dynamic_para_2) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_2)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', [(_vm.dynamic_para_3) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_3)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.dynamic_button_1 && _vm.dynamic_button_1 !== ' ') ? _c('button', {
    staticClass: "btn btn-primary main-heading-btn btn-lg hideMobile",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirect()
      }
    }
  }, [_vm._v(_vm._s(_vm.dynamic_button_1))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.currentPlayerID) ? _c('div', {
    staticClass: "col-sm-offset-4 col-sm-3 vedioplayerholder showMobile"
  }, [_c('jwplayer', {
    attrs: {
      "id": "showGiftingMobile",
      "data": _vm.currentPlayerID
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container text-left"
  }, [_c('div', {
    staticClass: "row aboutrow"
  }, [_c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "text-align": "left"
    }
  }, [(_vm.giftPlans) ? _c('div', {
    staticClass: "gifts row"
  }, _vm._l((_vm.giftPlans), function(plan) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "gift-item"
    }, [_c('h5', [_c('strong', [_vm._v("Gift of TONE")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(plan.description))])]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          return _vm.setPackage(plan)
        }
      }
    }, [_vm._v("Buy Now: $" + _vm._s(plan.amountFmt))])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.currentPlayerID2) ? _c('div', {
    staticClass: "vedioplayerholder hideMobile"
  }, [_c('jwplayer', {
    attrs: {
      "id": "showGiftingDesktop",
      "data": _vm.currentPlayerID2
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.dynamic_para_4) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_4)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_para_5) ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_5)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "tonepoints"
  }, [(_vm.dynamic_bullet_1) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_2) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_3) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_3)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.dynamic_para_6) ? _c('p', {
    staticStyle: {
      "text-align": "justify"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_6)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_promotion_img && _vm.dynamic_promotion_img.length > 5) ? _c('img', {
    staticStyle: {
      "max-width": "50%",
      "margin": "20px auto",
      "float": "none",
      "clear": "both",
      "display": "block"
    },
    attrs: {
      "src": _vm.dynamic_promotion_img,
      "alt": _vm.dynamic_para_7,
      "title": _vm.dynamic_para_7
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_para_7) ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_7)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0ed553c4", module.exports)
  }
}

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper bodyfont-unauth"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": "refreshing event"
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mainLiveEvent && _vm.showRulesComp && _vm.showJoin(_vm.mainLiveEvent)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.showRulesComp) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.mainLiveEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.mainLiveEvent && _vm.currentVideo) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "video-player autoheight"
  }, [_c('div', {
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.currentVideo) ? _c('div', {
    staticClass: "reset-video-width"
  }, [_c('h2', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.mainLiveEvent.title))]), _vm._v(" "), _c('jwplayer', {
    attrs: {
      "id": "mainVideoPlayer",
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "player-content"
  }, [(_vm.mainLiveEvent) ? _c('p', {
    staticClass: "video-description"
  }, [_vm._v("\n                            " + _vm._s(_vm.mainLiveEvent.longDescription) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.mainLiveEvent && !_vm.showJoin(_vm.mainLiveEvent)) ? _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.mainLiveEvent.title)
      }
    }
  }, [_vm._v("\n                            Add to Calendar\n                            "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.mainLiveEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.mainLiveEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.mainLiveEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.mainLiveEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.mainLiveEvent.eventId))])])]) : _vm._e(), _vm._v(" "), (_vm.getCorpButtonColor === '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getCorpButtonColor !== '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.mainLiveEvent && _vm.showRulesComp && !_vm.showJoin(_vm.mainLiveEvent)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.showRulesComp) ? _c('rulescomp', {
    style: ({
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "data": _vm.mainLiveEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/signup')
      }
    }
  }, [_vm._v("Start Your Free Trial")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redeemCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.toneLiveHeading) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.toneLiveHeading)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.allLiveEvents) ? _c('div', {
    staticClass: "row morevediosrow"
  }, [(_vm.allLiveEvents[0]) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('a', {
    attrs: {
      "href": '/newevents/' + _vm.allLiveEvents[0].eventId,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.allLiveEvents[0].img_url,
      "alt": _vm.allLiveEvents[0].title,
      "title": _vm.allLiveEvents[0].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[0].title))])]), _vm._v(" "), (_vm.allLiveEvents[0]) ? _c('div', {
    staticStyle: {
      "float": "left",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.allLiveEvents[0].title)
      }
    }
  }, [_vm._v("\n                                Add to Calendar\n                                "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[0].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[0].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[0].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[0].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.allLiveEvents[0].eventId))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.allLiveEvents[1]) ? _c('div', {
    staticClass: "col-sm-6",
    on: {
      "click": function($event) {}
    }
  }, [_c('a', {
    attrs: {
      "href": '/newevents/' + _vm.allLiveEvents[1].eventId,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.allLiveEvents[1].img_url,
      "alt": _vm.allLiveEvents[1].title,
      "title": _vm.allLiveEvents[1].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title cursor",
    on: {
      "click": function($event) {}
    }
  }, [_vm._v(_vm._s(_vm.allLiveEvents[1].title))])]), _vm._v(" "), (_vm.allLiveEvents[1]) ? _c('div', {
    staticStyle: {
      "float": "left",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.allLiveEvents[1].title)
      }
    }
  }, [_vm._v("\n                               Add to Calendar\n                               "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[1].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[1].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[1].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[1].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.allLiveEvents[1].eventId))])])]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "sliderTalkBox"
  }, [(_vm.toneTalkHeading) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.toneTalkHeading)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toneTalkDesc) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.toneTalkDesc)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.allTalkEvents) ? _c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.allTalkEvents), function(talkEvent) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('a', {
      attrs: {
        "href": '/event/' + talkEvent.eventId,
        "target": "_blank",
        "rel": "opener"
      }
    }, [_c('h2', {
      staticStyle: {
        "color": "#5E5E5E"
      }
    }, [_vm._v(_vm._s(_vm.getDateReference(talkEvent.start_date, 'live')) + ": " + _vm._s(talkEvent.title))])]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(talkEvent.longDescription) + "\n                            ")]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.getDateReference(talkEvent.start_date, 'live2')))]), _vm._v(" "), _c('div', {
      staticClass: "addeventatc pinkoutlinebtn",
      style: ({
        color: _vm.getCorpButtonColor + ' !important',
        border: '1px solid ' + _vm.getCorpButtonColor
      }),
      attrs: {
        "title": "Add to Calendar"
      },
      on: {
        "click": function($event) {
          return _vm.calendarLogging($event, talkEvent.title)
        }
      }
    }, [_vm._v("\n                                Add to Calendar\n                                "), _c('span', {
      staticClass: "start"
    }, [_vm._v(_vm._s(talkEvent.start_date))]), _vm._v(" "), _c('span', {
      staticClass: "end"
    }, [_vm._v(_vm._s(talkEvent.end_date))]), _vm._v(" "), _c('span', {
      staticClass: "timezone"
    }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(talkEvent.title))]), _vm._v(" "), _c('span', {
      staticClass: "description"
    }, [_vm._v(_vm._s(talkEvent.longDescription))]), _vm._v(" "), _c('span', {
      staticClass: "location"
    }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(talkEvent.eventId))])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/signup')
      }
    }
  }, [_vm._v("Start Your Free Trial")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redeemCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0f63bdda", module.exports)
  }
}

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp bodyfont-unauth"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), (_vm.getCorporateClient) ? _c('h2', [_vm._v("\n                                    " + _vm._s(_vm.getGiftee.welcomeMessage) + "\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "left-content"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true
    }
  }, [_c('panel', {
    staticClass: "text-left",
    attrs: {
      "is-open": true
    }
  }, [_c('h4', [_vm._v("Create your Account")]), _vm._v(" "), _c('div', {
    staticClass: "create-account"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onGifteeSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus"
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z '-]+$/,
      "id": "redeem_firstname",
      "type": "text",
      "error": "First Name (no digits allowed)",
      "placeholder": "First Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstName", $$v)
      },
      expression: "user.firstName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z '-]+$/,
      "id": "redeem_lastname",
      "type": "text",
      "error": "Last Name (no digits allowed)",
      "placeholder": "Last Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastName", $$v)
      },
      expression: "user.lastName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": _vm.emailPattern,
      "id": "redeem_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), (this.corpId == '114') ? _c('div', {
    staticClass: "mandatory-class"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userRegion),
      expression: "user.userRegion"
    }],
    staticClass: "form-control",
    staticStyle: {
      "border-color": "#a94442"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "userRegion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0"
    }
  }, [_vm._v("Select Which Organization You Are From")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Diverse Segments")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("West Division")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Mid West & Mid-Atlantic Division")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("New England Division")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("South East and South West Division")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("New York Division")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Office of Chief Fuduciary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Wealth Management Banking & Lending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("Private Bank Products, Services & Platforms")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("Chief Operating Office")])]), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors",
    staticStyle: {
      "color": "#a94442"
    }
  }, [_vm._v("Organization (required)")])]) : _vm._e(), _vm._v(" "), _c('vue-password', {
    staticClass: "form-input",
    attrs: {
      "minlength": 6,
      "classes": "input form-control",
      "placeholder": "Password",
      "error": "Password",
      "id": "signup_password",
      "disableStrength": _vm.hidePasswordMeter,
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-info-circled alert-icon-float-left information"
  }, [_c('p', {
    staticClass: "alert alert-info alert-dismissable",
    class: {
      'set-error': !_vm.verifyPassword()
    },
    attrs: {
      "id": "redeem_pwderrormsg"
    }
  }, [_vm._v("Min 6 Chars, One Upper Case, One Lower Case!")])]), _vm._v(" "), _c('checkbox', {
    staticClass: "terms-and-condition",
    attrs: {
      "value": "isChecked",
      "type": "primary"
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n                                                             I agree to "), _c('a', {
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "href": "/terms",
      "target": "_blank",
      "rel": "opener"
    }
  }, [_vm._v("terms and conditions")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit",
      "id": "redeem_button",
      "disabled": !_vm.isChecked || _vm.spinner || this.user.packageId === -1 || (this.corpId == '114' ? this.user.userRegion < 1 : false)
    }
  }, [_vm._v("\n                                                            Complete Sign Up\n                                                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "jumbotron",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    })
  }, [_c('div', {
    staticClass: "hidemobile"
  }, [(_vm.getGiftee.panelHeading1) ? _c('h2', [_vm._v(_vm._s(_vm.getGiftee.panelHeading1))]) : _vm._e(), (_vm.getGiftee.panelHeading2) ? _c('p', [_vm._v(_vm._s(_vm.getGiftee.panelHeading2))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "showmobile"
  }, [(_vm.getGiftee.panelHeading2) ? _c('h2', [_vm._v(_vm._s(_vm.getGiftee.panelHeading2))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, [(_vm.getGiftee.panelBullet1) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.getGiftee.panelBullet1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGiftee.panelBullet2) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.getGiftee.panelBullet2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGiftee.panelBullet3) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.getGiftee.panelBullet3)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGiftee.panelBullet4) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.getGiftee.panelBullet4)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGiftee.panelBullet5) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.getGiftee.panelBullet5)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGiftee.panelBullet6) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.getGiftee.panelBullet6)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer hidemobile"
  }, [_c('div', {
    staticClass: "list-group"
  }, [(_vm.giftDescription) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.giftDescription))])]) : _c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.defaultPlan.description))])])])])])])])])])])]), _vm._v(" "), (_vm.showResetModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showResetModal,
      "width": "200"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelResetModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelResetModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h2', {
    staticClass: "forgot-heading"
  }, [_vm._v("\n                        That Account Exists!\n                    ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("You have an account with Tone Networks. Please try logging in or resetting your password.")])]), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-transparent",
    on: {
      "click": _vm.SetupLogin
    }
  }, [_vm._v("\n                        Sign In\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-transparent",
    on: {
      "click": _vm.onSubmitForgetRequest
    }
  }, [_vm._v("\n                        Reset Password\n                    ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-11799b4e", module.exports)
  }
}

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "liveEventContent"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "liveEvent"
  }, [_vm._m(0), _vm._v(" "), (_vm.getCorpStreamingURL) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.getCorpStreamingURL
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v("Welcome to Corporate Live Events")])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-124f4978", module.exports)
  }
}

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper profile",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Privacy Policy")])])]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('p', [_vm._v("Last  Modified: January 1st, 2021 ")]), _vm._v(" "), _c('p', [_vm._v("The website located at "), _c('a', {
    attrs: {
      "href": "https://www.tonenetworks.com/",
      "target": "_blank"
    }
  }, [_vm._v("https://www.tonenetworks.com ")]), _vm._v("(the “"), _c('strong', [_vm._v("Website")]), _vm._v("”) is owned and operated by ChartOne Media LLC, a Delaware limited liability company (“"), _c('strong', [_vm._v("ChartOne")]), _vm._v("”, “"), _c('strong', [_vm._v("we")]), _vm._v("” or “"), _c('strong', [_vm._v("us")]), _vm._v("”).")]), _vm._v(" "), _c('p', [_vm._v("We respect the privacy of our users and are committed to protecting that privacy through our compliance with this Privacy Policy. This Privacy Policy describes the types of information we may collect from you or that you may provide when you access or use the Website, memberships, or any of our other products or services (the Website, and any of our other products or services, collectively, the “"), _c('strong', [_vm._v("Services")]), _vm._v("”) and our practices for collecting, using, maintaining, protecting and disclosing that information.")]), _vm._v(" "), _c('p', [_vm._v("This Privacy Policy applies to information we collect on or through your use of the Services, in email and other electronic messages between you and ChartOne, and through any mobile and desktop applications that you use in connection with the Services. This Privacy Policy does not apply to information that you provide to or is collected by any third party whether through or in connection with your use of the Services or otherwise, including through any third party application or content (including advertising) that may link to or be accessible from or on the Services. You agree and acknowledge that ChartOne has no duty or responsibility to maintain and safeguard any information you may provide to, or is collected by, any third party whether through or in connection with your use of the Services or otherwise.")]), _vm._v(" "), _c('p', [_vm._v("This Privacy Policy is incorporated by reference into our Terms of Service, found at "), _c('a', {
    attrs: {
      "href": "https://www.tonenetworks.com/terms",
      "target": "_blank"
    }
  }, [_vm._v("(Terms of Service)")]), _vm._v(". Please read this Privacy Policy carefully to understand our policies and practices regarding your information and how we will treat it. If you do not agree with our policies and practices, do not access or use the Services. By accessing or using the Services, you agree to this Privacy Policy.")]), _vm._v(" "), _c('p', [_vm._v("This Privacy Policy may change from time to time (see “Changes to Our Privacy Policy” below). Your continued use of the Services after we make changes is deemed to be acceptance of those changes, so please check this Privacy Policy periodically for updates.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Collection of Information")])]), _vm._v(" "), _c('p', [_c('u', [_vm._v("Information We Collect About You")])]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v("We collect several types of information from and about our users, some of which is personally identifiable and some of which is non-identifying or aggregated, including:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("information by which you may be personally identified, such as name, postal address, e-mail address, mobile telephone number, or any other identifier by which you may be contacted online or offline, and credit card or debit card information and related billing information (“"), _c('strong', [_vm._v("personal information")]), _vm._v("”);")]), _vm._v(" "), _c('li', [_vm._v("information that is about you but individually does not identify you; and/or")]), _vm._v(" "), _c('li', [_vm._v("information about your internet connection, the equipment you use to access the Services and usage details.")])]), _vm._v(" "), _c('p', [_vm._v("We collect this information (i) directly from you when you provide it to us, (ii) automatically as you use the Services (which information may include usage details, Internet Protocol (IP) addresses and information collected through cookies, web beacons and other tracking technologies), and (iii) from third parties, such as our business partners.")]), _vm._v(" "), _c('p', [_c('u', [_vm._v("Information You Provide to Us")])]), _vm._v(" "), _c('p', [_vm._v("The information we collect on or through the Website or otherwise through your use of the Services may include (i) information that you provide about yourself or others by using our Services, including information provided at the time of registering to use our Services (such as email address, address, date of birth, and credit card or other payment information), participating in Tone Talks or Tone Live, or requesting further Services; (ii) records and copies of your correspondence, if you contact us; (iii) your responses to surveys that we might ask you to complete for research purposes; and (iv) details of any transactions that you carry out through the Services.")]), _vm._v(" "), _c('p', [_vm._v("You also may provide information to be published or displayed on public areas of the Services, or transmitted to users, experts, or third parties, including but not limited to any videos, photos, graphics, sounds, music, audio transcripts of videos, comments, messages, and other text that are viewable or accessible through the Services (“"), _c('strong', [_vm._v("Content")]), _vm._v("”). Content is transmitted to others at your own risk. Although we limit access to certain information, please be aware that no security measures are perfect or impenetrable. Additionally, we cannot control the actions of third parties, including but not limited to other users and experts. Therefore, we cannot and do not guarantee that Content will not be viewed by unauthorized persons. You should not submit, communicate, transmit, or upload personal information or any other information about yourself or others that you are not comfortable disclosing to the general public. This information may be viewable and searchable by third parties on indexing websites such as Google, and may be disclosed to third parties under certain circumstances as provided herein.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("International Users")])]), _vm._v(" "), _c('p', [_vm._v("If you live outside the United States, by using the Services you consent to the transfer and processing of your personal information in the United States in accordance with this Privacy Policy and U.S. law.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Information Collected Through Data Tracking Technologies")])]), _vm._v(" "), _c('p', [_vm._v("As you use the Services, we may use automatic data collection technologies to collect certain information about your devices, browsing actions and patterns, including details of your use of the Services (such as traffic data, location data, logs and other communication data) and information about your devices and internet connection, including your IP address, operating system and browser type.")]), _vm._v(" "), _c('p', [_vm._v("The technologies we use for this automatic data collection may include:")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Cookies and other similar technologies")]), _vm._v(". We may place cookies on your device to collect anonymous data related to your use of the Services. In general, a cookie is a small file placed on your device that can be used to help recognize your browser across different web pages, websites, and browsing sessions. We may use cookies to provide certain features of the Services. It may be possible to refuse to accept cookies by activating the appropriate setting on your device. However, if you select this setting you may be unable to access certain features of the Services. We may also use other technologies to tailor the Services to you, such as web beacons (also referred to as clear gifs, pixel tags and single-pixel gifs) that permit ChartOne, for example, to track how visitors interact with the Services and for other statistics related to the Services (such as recording the popularity of certain content and verifying system and server integrity).")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Log Information")]), _vm._v(". We may automatically collect and store certain information in our server logs when you use the Services, including details about how you used the Services, IP address, and information specific to your device (such as system activity, hardware settings, browser type, and browser language).")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Device Identifiers")]), _vm._v(". We may collect information about your device, such as your operating system, hardware version, device settings, file and software names and types, mobile network information and device identifiers. This helps us measure how the Services are performing and improve the Services for you on your particular device.")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Location-Based Data")]), _vm._v(". We may collect and process information about your geographic location (for example, through GPS signals) when you use the Services. We will not store or track your device location on an ongoing basis or without your permission. We do not share precise geolocation data with third parties, other than our service providers as necessary to provide the Services.")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Analytics Data")]), _vm._v(". We may also collect analytics data, or use third-party analytics tools, to help us measure traffic and usage trends for the Services. These third-party analytics do not collect direct personal information about any user.")]), _vm._v(" "), _c('p', [_vm._v("We also may use these technologies to collect information about your online activities over time and across third-party websites or other online services (behavioral tracking). Please see “Your Choices About Our Use and Disclosure of Your Information” below for information on how you can opt out of behavioral tracking on the Website and how we respond to web browser signals and other mechanisms that enable consumers to exercise choice about behavioral tracking.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Why We Collect Information")])]), _vm._v(" "), _c('p', [_vm._v("The information we collect helps us to improve the Services and to deliver a better and more personalized experience, including by enabling us to estimate size and usage patterns, store information about your preferences, allowing us to customize our Services according to your individual interests, connect you with other users and experts as applicable, and recognize you when you use the Services.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Legal Bases for Collecting Information")])]), _vm._v(" "), _c('p', [_vm._v("We process personal data for, or based on, one or more of the following legal bases:")]), _vm._v(" "), _c('p', [_c('u', [_vm._v("Performance of a Contract.")])]), _vm._v(" "), _c('p', [_vm._v("We use personal data to enter into and to perform under, an agreement between us and the Customer.")]), _vm._v(" "), _c('p', [_c('u', [_vm._v("Legitimate Interests.")])]), _vm._v(" "), _c('p', [_vm._v("We use personal data for our legitimate interests, including contact information, services offered, and website usage data.")]), _vm._v(" "), _c('p', [_c('u', [_vm._v("Compliance with Legal Obligations and Protection of Individuals.")])]), _vm._v(" "), _c('p', [_vm._v("We may use personal data to comply with the law and our legal obligations, as well as to protect you and other individuals from certain harms.")]), _vm._v(" "), _c('p', [_c('u', [_vm._v("Your Consent.")])]), _vm._v(" "), _c('p', [_vm._v("We process certain personal data because you have given us your consent to process it in that manner.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Third Party Collection of Information")])]), _vm._v(" "), _c('p', [_vm._v("The personal information that you provide to us will be collected, stored, and processed in accordance with this Privacy Policy. Some content or applications, including advertisements, on the Services may be served by third-parties, including advertisers, ad networks and servers, content and application providers, and your mobile device manufacturer and mobile device service provider. These third parties may use tracking technologies to collect information about you when you use the Services. The information they collect may be associated with your personal information or they may collect information, including personal information, about your online activities over time and across different websites and other online services. They may use this information to provide you with interest-based (behavioral) advertising or other targeted content.")]), _vm._v(" "), _c('p', [_vm._v("ChartOne does not control these third parties’ tracking technologies or how they may be used. If you have any questions about an advertisement or other targeted content, you should contact the responsible provider directly.")]), _vm._v(" "), _c('p', [_vm._v("By using the Services, you agree to be bound by the terms, privacy policies, and other policies of these third parties. ChartOne reserves the right to use any third party providers to provide Services in ChartOne’s sole discretion and at any time.")]), _vm._v(" "), _c('p', [_vm._v("ChartOne uses Amazon Web Services to store and process your information in accordance with Amazon’s policies, terms, and agreements, available at "), _c('a', {
    attrs: {
      "href": "https://aws.amazon.com/legal/",
      "target": "_blank"
    }
  }, [_vm._v("https://aws.amazon.com/legal/")]), _vm._v(". Additional information on Amazon Web Services and Amazon’s Privacy Policy is available at "), _c('a', {
    attrs: {
      "href": "https://aws.amazon.com/privacy/",
      "target": "_blank"
    }
  }, [_vm._v("https://aws.amazon.com/privacy/")]), _vm._v(". By using the Services, you agree to be bound by Amazon Web Services’ terms and privacy policy.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("How We Use Your Information")])]), _vm._v(" "), _c('p', [_vm._v("We use information that we collect about you or that you provide to us, including any personal information, to:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Provide you with the Services, and any other information, products or services that you request from us, including but not limited to sending you daily e-mail newsletters.")]), _vm._v(" "), _c('li', [_vm._v("Present our Website and their contents to you.")]), _vm._v(" "), _c('li', [_vm._v("Allow you to participate in Tone Talks and Tone Live.")]), _vm._v(" "), _c('li', [_vm._v("Fulfill any other purpose for which you provide it.")]), _vm._v(" "), _c('li', [_vm._v("Give you notices about your account.")]), _vm._v(" "), _c('li', [_vm._v("Carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including, if applicable, for billing and collection.")]), _vm._v(" "), _c('li', [_vm._v("Notify you when updates to the Services are available, and about changes to any products or services we offer or provide though our Services.")]), _vm._v(" "), _c('li', [_vm._v("Contact you about our own and third­ parties’ goods and services that may be of interest to you.")]), _vm._v(" "), _c('li', [_vm._v("Enable us to display advertisements to our advertisers’ target audiences. Even though we do not disclose your personal information for these purposes without your consent, if you click on or otherwise interact with an advertisement, the advertiser may assume that you meet its target criteria.")])]), _vm._v(" "), _c('p', [_vm._v("Additionally, we may use information that we collect about you or that you provide to us in any other way we may describe when you provide the information or for any other purposes with your consent.")]), _vm._v(" "), _c('p', [_vm._v("Following termination or deactivation of an account, we may retain information and content for backup, archival, audit or other business purposes, or otherwise in accordance with applicable laws. We may maintain anonymized, de-identified or aggregated data, including usage data, for analytics purposes. If you have any questions about data retention or deletion, please e-mail info@tonenetworks.com.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Disclosure of Your Information")])]), _vm._v(" "), _c('p', [_vm._v("We may disclose anonymized, de-identified, and/or aggregated information about our users and information that does not identify any individual, without restriction.")]), _vm._v(" "), _c('p', [_vm._v("We may disclose personal information that we collect or you provide:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("To our subsidiaries and affiliates.")]), _vm._v(" "), _c('li', [_vm._v("To contractors, service providers and other third parties we use to support our business and who are bound by contractual obligations to keep personal information confidential and use it only for the purposes for which we disclose it to them.")]), _vm._v(" "), _c('li', [_vm._v("To a buyer or other successor in the event of a merger, divestiture, restructuring, reorganization, dissolution or other sale or transfer of some or all of our assets, whether as a going concern or as part of bankruptcy, liquidation or similar proceeding, in which personal information held by us is among the assets transferred.")]), _vm._v(" "), _c('li', [_vm._v("To third parties to market their products or services to you if you have consented to or not opted out of these disclosures. We contractually require these third parties to keep personal information confidential and use it only for the purposes for which we disclose it to them.")]), _vm._v(" "), _c('li', [_vm._v("To fulfill the purpose for which you provide it.")]), _vm._v(" "), _c('li', [_vm._v("For any other purpose disclosed by us when you provide the information.")]), _vm._v(" "), _c('li', [_vm._v("With your consent.")]), _vm._v(" "), _c('li', [_vm._v("To comply with any court order, law or legal process, including to respond to any government or regulatory request.")]), _vm._v(" "), _c('li', [_vm._v("To enforce or apply our Terms of Service, found at "), _c('a', {
    attrs: {
      "href": "https://www.tonenetworks.com/terms",
      "target": "_blank"
    }
  }, [_vm._v("Terms")]), _vm._v(" , and other agreements, including for billing and collection purposes.")]), _vm._v(" "), _c('li', [_vm._v("If we believe disclosure is necessary or appropriate to protect the rights, property, or safety of ChartOne, our customers, or others. This includes exchanging information with other companies and organizations for the purposes of fraud protection and credit risk reduction.")])]), _vm._v(" "), _c('p', [_vm._v("We may also share aggregated, non-personally identifiable information publicly, including with partners or the press, in order to, for example, demonstrate how our Services are used, evaluate industry trends, or to create our marketing materials. Any aggregated information shared this way will not contain any personal information.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Your Choices About Our Use and Disclosure of Your Information")])]), _vm._v(" "), _c('p', [_vm._v("We strive to provide you with choices regarding the personal information you provide to us. This section describes mechanisms to control certain uses and disclosures of your information.")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Email Communications")]), _vm._v(". We will send you a confirmation email, a welcome email, and regular emails that directly promote the use of our Services. You may opt-out at any time by following the instructions provided in the email that you receive. Please note that we may continue to send you service-related communications despite opting out of emails.")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Tracking Technologies")]), _vm._v(". You can set your browser to refuse all or some browser cookies, or to alert you when cookies are being sent. If you disable or refuse cookies or block the use of other tracking technologies, some parts of the Services may then be inaccessible or not function properly.")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Location Information")]), _vm._v(". You can choose whether or not to allow the Website to collect and use real-time information about your device’s location through the device’s privacy settings. If you block the use of location information, some parts of the Website may then be inaccessible or not function properly.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Your Rights Regarding Data")])]), _vm._v(" "), _c('p', [_vm._v("Certain laws provide individuals with enhanced rights in respect of their personal data. These rights may include, depending on the facts and circumstances surrounding, and in certain cases the legal basis for, the processing of personal data, the following:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("The right to be informed of whether we hold personal data about you.")]), _vm._v(" "), _c('li', [_vm._v("The right to object to decisions based on profiling or automated decision-making that produce legal or similarly significant effects on you;")]), _vm._v(" "), _c('li', [_vm._v("The right to request restriction of processing of personal data or object to processing of personal data carried out pursuant to (a) a legitimate interest (including, but not limited to, processing for direct marketing purposes) or (b) performance of a task in the public interest;")]), _vm._v(" "), _c('li', [_vm._v("The right to challenge the accuracy and completeness of your personal data and have it amended as appropriate;")]), _vm._v(" "), _c('li', [_vm._v("The right to be provided with information about our policies and practices with respect to the management of personal data, including: (a) the name or title, and address, of the person who is accountable for our privacy policies and practices; (b) the means of gaining access to personal data; (c) a description of the type of personal data held by us, including a general account of its use; (d) a copy of any brochures or other information that explain our policies, standards, or codes; and (e) what personal data is made available to related organizations;")]), _vm._v(" "), _c('li', [_vm._v("The right to data portability, which means that you can request that we provide certain personal data we hold about you in a machine-readable format; and")]), _vm._v(" "), _c('li', [_vm._v("The right to erasure and/or the right to be forgotten, which means that you can request deletion or removal of certain personal data we process about you.")])]), _vm._v(" "), _c('p', [_vm._v("Where required by applicable law, we will respond to a valid request relating to your rights within one month of receipt, or within three months where a request is complex or challenging. Note that we may need to request additional information from you to validate your request.")]), _vm._v(" "), _c('p', [_vm._v("Under certain conditions, you may have the right to require us to, and upon your written request, we will:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Provide you with further details on the use we make of your personal information")]), _vm._v(" "), _c('li', [_vm._v("Provide you with a copy of the personal information we hold about you")]), _vm._v(" "), _c('li', [_vm._v("Update any inaccuracies in the personal information we hold about you")]), _vm._v(" "), _c('li', [_vm._v("Delete any of your personal information that we no longer have a lawful ground to use")]), _vm._v(" "), _c('li', [_vm._v("Where processing is based on consent, stop that particular processing by withdrawing your consent")]), _vm._v(" "), _c('li', [_vm._v("Object to any processing based on our legitimate interests unless our reasons for undertaking that processing outweigh any prejudice to your data protection rights")]), _vm._v(" "), _c('li', [_vm._v("Restrict how we use your personal information whilst a complaint is being investigated")]), _vm._v(" "), _c('li', [_vm._v("Transfer your personal information to a third party in a standardized machine-readable format.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Accessing, Modifying, Rectifying and Correcting Collected Data")])]), _vm._v(" "), _c('p', [_vm._v("We strive to maintain the accuracy of any personal data collected from you, and will use commercially reasonable efforts to respond promptly to update our database when you tell us information in our database is not accurate. However, we must rely upon you to ensure that the information you provide to us is complete, accurate, and up-to-date, and to inform us of any changes. Accordingly, please review all of your information carefully before submitting it to us, and notify, us as soon as possible of any updates or corrections.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Withdrawing Consent")])]), _vm._v(" "), _c('p', [_vm._v("If you have consented to our processing of your Personal Data, you have the right to withdraw your consent at any time, free of charge, and we will discontinue processing of your Personal Data. This includes cases where you wish to opt out from marketing messages that you receive from us.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("European Union Users")])]), _vm._v(" "), _c('p', [_vm._v("Data protection law in Europe requires a “lawful basis” for collecting, processing and transferring personal information from citizens or residents of the European Economic Area (EEA). Our lawful bases, as detailed above, include performance of our contract with our Customers, user consent (which is always easy to withdraw), and our legitimate interests (except where such interests are overridden by the interests or fundamental rights and freedoms of our EU users).")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Your California Privacy Rights")])]), _vm._v(" "), _c('p', [_vm._v("California Civil Code Section 1798.83 permits Hosts and Users who are California residents to request certain information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make such a request, please send an e-mail to info@tonenetworks.com.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Data Security")])]), _vm._v(" "), _c('p', [_vm._v("We have implemented measures designed to secure your personal information from accidental loss and from unauthorized access, use, alteration and disclosure. All information you provide to us is stored on our secure servers behind firewalls. Any information you provide to us through your use of the Services will be encrypted using industry standard technology.")]), _vm._v(" "), _c('p', [_vm._v("The safety and security of your information also depends on you. You are responsible for keeping your account information and password confidential. We ask you not to share your password with anyone.")]), _vm._v(" "), _c('p', [_vm._v("Unfortunately, the transmission of information via the Internet is not completely secure. Although we do our best to protect your personal information and take reasonable steps to ensure that our Website is secure, we cannot guarantee the security of your personal information transmitted through the Services. Any transmission of personal information is at your own risk. We are not responsible for circumvention of any privacy settings or security measures we provide.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Data Protection Officer")])]), _vm._v(" "), _c('p', [_vm._v("To further ensure Data Security, we have appointed a data protection officer (DPO) who is responsible for overseeing questions in relation to this privacy notice. If you have any questions about this privacy notice, including any requests to exercise your legal rights, contact our Data Protection Officer, please email "), _c('a', {
    attrs: {
      "href": "mailto:gtoner@tonenetworks.com"
    }
  }, [_vm._v("gtoner@tonenetworks.com")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Data Retention")])]), _vm._v(" "), _c('p', [_vm._v("We take every reasonable step to ensure that your Personal Data is only processed for the minimum period necessary for the purposes set out in this Policy.")]), _vm._v(" "), _c('p', [_vm._v("The criteria for determining the duration for which we will keep your Personal Data are as follows: we will retain copies of your Personal Data in a form that permits identification only for as long as is necessary in connection with the purposes set out in this Policy, unless applicable law requires a longer retention period. In particular, we may retain your Personal Data for the duration of any period necessary to establish, exercise or defend any legal rights.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Changes to Our Privacy Policy")])]), _vm._v(" "), _c('p', [_vm._v("Any changes we make to our Privacy Policy will be posted on this page. If we make material changes to how we treat your personal information, we will notify you through a notice on the Website and/or by any other reasonable means. The date that the Privacy Policy was last modified is identified at the top of the page. You are responsible for ensuring we have an up-to-date active and deliverable e-mail address for you, and for periodically visiting our Website and this Privacy Policy to check for any changes.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Contact Information")])]), _vm._v(" "), _c('p', [_vm._v("To ask questions or comment about this Privacy Policy and our privacy practices, contact us at:")]), _vm._v(" "), _c('p', [_vm._v("ChartOne Media LLC")]), _vm._v(" "), _c('p', [_vm._v("P.O. Box 356")]), _vm._v(" "), _c('p', [_vm._v("Oyster Bay, NY 11771")]), _vm._v(" "), _c('p', [_vm._v("Phone: "), _c('a', {
    attrs: {
      "href": "tel:(516) 900-1000"
    }
  }, [_vm._v("(516) 900-1000")])]), _vm._v(" "), _c('p', [_vm._v("Email: "), _c('a', {
    attrs: {
      "href": "mailto:info@tonenetworks.com"
    }
  }, [_vm._v("info@tonenetworks.com")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-13ed2e4a", module.exports)
  }
}

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "coverimg",
    class: {
      'hasvideo': _vm.topVideo.length > 2
    }
  }, [(!_vm.topVideoUrl) ? _c('img', {
    staticClass: "responsiveimg",
    attrs: {
      "src": _vm.topImageUrl,
      "alt": "B2B IMAGE",
      "title": "TONE B2B"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.topVideoUrl) ? _c('video', {
    staticClass: "responsiveimg",
    attrs: {
      "autoplay": "",
      "loop": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.topVideoUrl,
      "type": "video/mp4",
      "poster": _vm.topImageUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-play-circle",
    on: {
      "click": function($event) {
        return _vm.openVideoModal('', 'Top')
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "watchvideolink",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.openVideoModal('', 'Top')
      }
    }
  }, [_vm._v("Watch Video")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h1', [_vm._v(_vm._s(_vm.topHeading))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.topParaLine1))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-rounded btn-primary btn-lg",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    }),
    on: {
      "click": function($event) {
        return _vm.scrollToFormSection()
      }
    }
  }, [_vm._v("Get Started")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container showmobile"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.topHeading))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.topParaLine1))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-rounded btn-primary btn-lg",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    }),
    on: {
      "click": function($event) {
        return _vm.scrollToFormSection()
      }
    }
  }, [_vm._v("Get Started")])])])]), _vm._v(" "), _c('div', {
    staticClass: "pannelsection"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.panelsHeading))])])]), _vm._v(" "), _c('div', {
    staticClass: "flexow row centericons"
  }, [_c('div', {
    staticClass: "col-sm"
  }, [_c('div', {
    staticClass: "ceniconholder"
  }, [(_vm.vidSectionImage) ? _c('img', {
    attrs: {
      "src": _vm.vidSectionImage,
      "height": "69",
      "alt": "SECTION IMAGE",
      "title": "TONE B2B"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vidSectionHeading) ? _c('h4', [_vm._v("\n                                EASY ACCESS\n                            ")]) : _vm._e(), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('div', {
    staticClass: "ceniconholder"
  }, [(_vm.evtSectionImage) ? _c('img', {
    attrs: {
      "src": _vm.evtSectionImage,
      "height": "69",
      "alt": "SECTION IMAGE",
      "title": "TONE B2B"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.evtSectionHeading) ? _c('h4', [_vm._v("\n                                RELEVANT CONTENT\n                            ")]) : _vm._e(), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('div', {
    staticClass: "ceniconholder"
  }, [(_vm.collSectionImage) ? _c('img', {
    attrs: {
      "src": _vm.collSectionImage,
      "height": "69",
      "alt": "SECTION IMAGE",
      "title": "TONE B2B"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.collSectionHeading) ? _c('h4', [_vm._v("\n                                DATA & METRICS\n                            ")]) : _vm._e(), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), (_vm.b2bVideos) ? _c('div', {
    staticClass: "Videoscarosal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.videosHeading))]), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-display-videos"
  }, _vm._l((_vm.b2bVideos), function(video) {
    return _c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.description,
        "title": video.title
      },
      on: {
        "click": function($event) {
          return _vm.openVideoModal(video, 'Regular')
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.openVideoModal(video, 'Regular')
        }
      }
    }, [_vm._v("\n                            " + _vm._s(video.title) + "\n                            "), _c('small', [_vm._v(_vm._s(video.description))])]), _vm._v(" "), _c('hr')])
  }), 0)])]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "logoscarosal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.logosHeading))]), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-display-logos"
  }, _vm._l((_vm.corpLogos), function(logo) {
    return _c('div', {
      staticClass: "slide-player"
    }, [_c('a', {
      attrs: {
        "href": logo.linkDestination,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": logo.logoUrl,
        "alt": "CORP LOGO",
        "title": logo.siteNameText
      }
    })])])
  }), 0)])]), _vm._v(" "), (_vm.testimonials) ? _c('div', {
    staticClass: "testimonialscarosal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.testimonialsHeading))]), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-display-testimonials"
  }, _vm._l((_vm.testimonials), function(testimonial) {
    return _c('div', {
      staticClass: "slide-player"
    }, [_vm._v("\n                        “" + _vm._s(testimonial.quote) + "”\n                        "), (testimonial.author) ? _c('div', {
      staticClass: "author"
    }, [_vm._v("--" + _vm._s(testimonial.author) + ", " + _vm._s(testimonial.location) + "--")]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container hubspotHeading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.formHeading))]), _vm._v(" "), (_vm.formLine1) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formLine1)
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.showB2BVideoModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "large": "",
      "effect": "fade",
      "value": _vm.showB2BVideoModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('div', {
    staticClass: "b2bVideoModal",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentVideoPlayer,
      "autoplay": "",
      "controls": ""
    }
  }, [_vm._v("Loading the player...")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-rounded btn-primary btn-lg",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    }),
    on: {
      "click": function($event) {
        _vm.cancelModal();
        _vm.scrollToFormSection();
      }
    }
  }, [_vm._v("Get Started")]), _c('br')])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-style"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v(" 24/7 On-Demand Access ")])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v(" Bite Sized Videos")])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v(" Self-Paced and Personalized ")])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v(" Behavior-Based Push Content ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-style"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v(" 1,800 + Videos ")])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v("Holistic Topics")])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v("70 + Credentialed Experts")])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v("Live Coaching Events")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm"
  }, [_c('div', {
    staticClass: "ceniconholder"
  }, [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/One_to_Many_Icon_unauth_B2B_page.png",
      "height": "69",
      "alt": "SECTION IMAGE",
      "title": "TONE B2B"
    }
  }), _vm._v(" "), _c('h4', [_vm._v(" VIRTUAL COMMUNITIES\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "content-style"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v("Role Modeling")])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v("Content Sharing")])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v("Company-Curated Playlists")])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v("Custom Coaching Sessions")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-style"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v("Monthly Reports")])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v("User Preferences")])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v("Behavioral Data")])]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-check fa-solid"
  }), _vm._v(" "), _c('span', [_vm._v("Employee Sentiment")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "real-results"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', [_vm._v("Real Results")])])]), _vm._v(" "), _c('div', {
    staticClass: "flexow row centericons"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('span', [_vm._v("89%")]), _vm._v(" "), _c('p', [_vm._v("say it positively impacts their personal/professional development")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('span', [_vm._v("54%")]), _vm._v(" "), _c('p', [_vm._v("are more engaged at work")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('span', [_vm._v("70%")]), _vm._v(" "), _c('p', [_vm._v("believe TONE proves their employers commitment to helping them succeed")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('span', [_vm._v("50%")]), _vm._v(" "), _c('p', [_vm._v("are more likely to stay with their current employer")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hubspotForm"
  }, [_c('div', {
    attrs: {
      "id": "hubspotForm"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-14cf791a", module.exports)
  }
}

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper profile"
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v("Live Stream Test")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "padding-bottom": "56.25%",
      "overflow": "hidden"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "src": "https://content.jwplatform.com/players/a074QrQx-c398nk2E.html",
      "width": "80%",
      "height": "80%",
      "frameborder": "0",
      "scrolling": "auto",
      "allowfullscreen": ""
    }
  })])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-19786ae6", module.exports)
  }
}

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper feed-back-page-wrapper",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Feedback")]), _vm._v(" "), _c('p', [_vm._v("We’d love to hear from you.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "id": "fb_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-minus"
  }, [(!_vm.user) ? _c('div', [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "feedback_name",
      "type": "text",
      "error": "Name",
      "placeholder": "Name",
      "required": ""
    },
    model: {
      value: (_vm.feedbackForm.name),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "name", $$v)
      },
      expression: "feedbackForm.name"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "feedback_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": ""
    },
    model: {
      value: (_vm.feedbackForm.email),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "email", $$v)
      },
      expression: "feedbackForm.email"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "feedback_comments",
      "type": "textarea",
      "error": "Comments",
      "placeholder": "Comments",
      "required": ""
    },
    model: {
      value: (_vm.feedbackForm.comments),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "comments", $$v)
      },
      expression: "feedbackForm.comments"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [(!_vm.spinner) ? _c('button', {
    staticClass: "btn formButton btn-transparent",
    style: ({
      color: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "id": "feedback_submit"
    }
  }, [_vm._v("\n                                Send\n                                "), (_vm.spinner) ? _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  }) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "contactus_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])])], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a23b194", module.exports)
  }
}

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "JWvideoHandler"
  }, [_c('div', {
    attrs: {
      "id": "player"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1ad9f1ae", module.exports)
  }
}

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": _vm.spinnerText
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_c('svg', {
    attrs: {
      "width": "59px",
      "height": "49px",
      "viewBox": "0 0 59 49",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Page 1")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_Unauthenticated",
      "transform": "translate(-665.000000, -1737.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-7-Copy-2",
      "transform": "translate(88.000000, 1726.000000)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M720.393793,1779.55672 L720.248873,1779.68175 C715.432452,1783.90429 709.738162,1785.73139 704.609017,1784.72833 C699.982965,1783.81053 696.672699,1780.75588 693.478531,1777.80351 C690.014703,1774.60396 686.749756,1771.58336 681.933407,1771.06622 C677.116986,1770.54906 671.859885,1772.76828 667.705503,1777.21247 C669.319536,1779.4601 677.002852,1788.69794 689.528558,1781.06846 C689.863862,1780.92922 690.250312,1781.05993 690.432178,1781.3725 C690.616881,1781.68791 690.540158,1782.08858 690.256,1782.31308 C686.488104,1784.60333 683.098184,1785.47 680.137377,1785.47 C671.226296,1785.47 666.177169,1777.64134 666.111699,1777.53368 C665.938366,1777.25805 665.969624,1776.90286 666.185578,1776.66134 C670.717863,1771.5693 676.494789,1769.01454 682.035663,1769.61148 C687.332264,1770.17979 690.932195,1773.51009 694.402061,1776.72667 C697.587427,1779.63641 700.599445,1782.45806 704.824752,1783.27358 C709.510453,1784.20557 714.752788,1782.48934 719.214148,1778.55944 L719.387481,1778.41452 L719.390325,1778.41452 C719.95579,1777.95987 720.4985,1777.47395 721.012869,1776.95965 C718.830564,1771.81079 712.885963,1770.61729 711.700971,1770.41273 C709.538525,1771.73688 707.199966,1772.74845 704.753384,1773.41624 C704.688023,1773.42477 704.622671,1773.42477 704.557318,1773.41624 C704.364097,1773.44182 704.168024,1773.39067 704.014586,1773.27132 C703.858304,1773.15481 703.756004,1772.97864 703.730428,1772.78542 C703.676438,1772.38476 703.957751,1772.01535 704.361252,1771.96138 C711.774544,1769.85298 716.363933,1765.82932 718.023212,1760.01544 L718.020368,1760.01544 C718.710864,1757.52906 718.84157,1754.92055 718.406818,1752.37737 C708.347844,1751.34303 704.105442,1757.36146 703.479848,1758.34175 C702.920065,1762.26874 701.13838,1766.18423 698.154804,1770.03746 L698.154804,1770.0403 C697.901904,1770.33014 697.467153,1770.37276 697.163092,1770.13691 C696.859031,1769.90106 696.790849,1769.47199 697.00681,1769.15371 C699.916551,1765.55349 701.610092,1761.82844 702.113041,1758.08869 C702.323314,1756.53155 702.323314,1754.95447 702.113041,1753.39732 C701.152608,1746.12297 695.821891,1741.03092 694.213823,1739.64152 C685.803217,1747.42435 687.308862,1755.83277 689.090497,1760.34505 C689.749735,1761.44472 690.332228,1762.58984 690.838014,1763.76909 C691.036924,1764.1186 690.917581,1764.56476 690.56807,1764.76648 C690.218559,1764.96822 689.772402,1764.84604 689.570684,1764.49653 C688.925652,1763.47361 688.377254,1762.38813 687.933955,1761.26003 C685.314024,1756.82151 681.773452,1754.05958 677.371596,1753.03346 C675.11822,1752.51062 672.779661,1752.47652 670.5121,1752.93969 C668.409376,1759.30475 672.810941,1765.04494 672.853569,1765.10168 C673.10078,1765.41993 673.043953,1765.87741 672.728537,1766.1246 C672.410284,1766.36897 671.9528,1766.31214 671.705618,1765.99673 C671.495345,1765.72678 666.613571,1759.34753 669.267546,1752.0678 L669.267546,1752.06496 C669.34995,1751.84899 669.526127,1751.68703 669.74777,1751.62167 C672.799578,1750.91981 675.984944,1751.05621 678.968738,1752.01665 C681.949549,1752.97708 684.614872,1754.72751 686.683188,1757.07741 C685.680128,1751.88309 686.291057,1744.71102 693.718868,1738.1641 L693.716024,1738.1641 C693.985968,1737.9453 694.372418,1737.9453 694.64234,1738.1641 C694.969118,1738.36016 702.337149,1744.07167 703.573062,1753.22128 C703.689568,1754.11355 703.743558,1755.00859 703.735032,1755.90653 C705.968477,1753.55655 710.776387,1750.08705 719.16466,1751.11288 L719.161823,1751.11288 C719.457344,1751.14982 719.698874,1751.36294 719.772752,1751.64993 C719.772752,1751.78064 722.384099,1762.39415 713.416205,1769.32733 C715.976414,1769.98089 720.690557,1771.8364 722.565885,1776.8061 C722.79889,1777.38009 722.429491,1777.84611 720.392091,1779.55667 L720.393793,1779.55672 Z",
      "id": "Page-1",
      "stroke": _vm.getCorpHeaderColor,
      "fill": _vm.getCorpHeaderColor
    }
  })])])]), _vm._v(" "), _c('br'), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Mindbody")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.getVideoSubcategories) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "interest-container work"
  }, [_c('button-group', {
    model: {
      value: (_vm.interestIndexes),
      callback: function($$v) {
        _vm.interestIndexes = $$v
      },
      expression: "interestIndexes"
    }
  }, _vm._l((_vm.getVideoSubcategories), function(interest, interestSubCategoryId) {
    return _c('checkbox', {
      key: interest.interestSubCategoryName.toString().toUpperCase(),
      staticClass: "min-padding checkbox-btn",
      style: (_vm.styleInterestObject(interest.interestSubCategoryName.toString().toUpperCase())),
      attrs: {
        "true-value": interest.interestSubCategoryName.toString().toUpperCase()
      }
    }, [_vm._v("\n                                    " + _vm._s(interest.interestSubCategoryName) + "\n                                ")])
  }), 1)], 1)]), _vm._v(" "), (_vm.getAuthMindbodyVideos && _vm.getAuthMindbodyVideos.length >= 100 && !_vm.showAllVideosFlag) ? _c('a', {
    staticClass: "bolder hidemobile",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showAllVideos('top')
      }
    }
  }, [_vm._v("choose a category or click to see more")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [(_vm.hideCompleteList() && !_vm.isMobile) ? _c('div', [(_vm.getAuthMindbodyVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthMindbodyVideos), function(video, index) {
    return ((index + 1) <= 99) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      class: {
        'private-contents': video.isPrivate === '1'
      },
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(video.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      attrs: {
        "title": video.title
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), (_vm.getAuthMindbodyVideos && _vm.getAuthMindbodyVideos.length >= 100 && !_vm.showAllVideosFlag) ? _c('a', {
    staticClass: "bolder hidemobile",
    attrs: {
      "id": "btmLink",
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showAllVideos()
      }
    }
  }, [_vm._v("click to browse all videos")]) : _vm._e()], 2) : _vm._e()]) : _c('div', [(_vm.getAuthMindbodyVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthMindbodyVideos), function(video, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      class: {
        'private-contents': video.isPrivate === '1'
      },
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(video.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      attrs: {
        "title": video.title
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(2, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  })], 2) : _vm._e()])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21385b83", module.exports)
  }
}

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper fixgraybgpl"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.videoSqueeze),
      expression: "!videoSqueeze"
    }],
    staticClass: "video-player-background",
    class: {
      'animated zoomOutLeft': _vm.videoCompleted
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "video-player",
    on: {
      "mouseleave": function($event) {
        _vm.addRightHoverWidthClass ? _vm.resetClass(true) : _vm.resetClass(false)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideLeftVideoIcons),
      expression: "!hideLeftVideoIcons"
    }],
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.getTrendingNewPlaylistObject) ? _c('div', {
    staticClass: "reset-video-width",
    class: {
      'enjoy-hover': _vm.addEnjoyHoverClass
    }
  }, [_c('jwplaylist', {
    attrs: {
      "data": _vm.getTrendingNewPlaylistObject,
      "on-playlistitem": _vm.videoChangedInPlaylist()
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.playlistVideos) ? _c('div', {
    staticClass: "playlistholderdiv"
  }, [_c('h4', [_vm._v(_vm._s(_vm.playlistVideos.title))]), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.videoIndex) + " of " + _vm._s(_vm.playlistVideos.userPlaylistVideos.length) + ")")]), _vm._v(" "), _c('div', _vm._l((_vm.getTrendingNewPlaylistObject), function(item) {
    return (_vm.getTrendingNewPlaylistObject && _vm.getItemChangeInPlaylist) ? _c('div', [_c('div', {
      staticClass: "playlistentrydiv",
      class: {
        'playing': item.videoCode === _vm.getItemChangeInPlaylist.item.videoCode
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.image,
        "alt": item.title,
        "title": item.title
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])]) : _vm._e()
  }), 0)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "player-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.currentVideo.Description) + "\n                    ")]), _vm._v(" "), (_vm.getExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.getExpert[0].expertId + '/' + _vm.getExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.getExpert && _vm.getExpert[0].areasofexpertise) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-3"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    style: ([_vm.viewTranscript ? {
      color: '#FFFFFF !important',
      backgroundColor: this.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      outline: 'none !important'
    } : {
      color: _vm.getCorpButtonColor + ' !important',
      backgroundColor: '#FFFFFF !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      outline: 'none !important'
    }]),
    on: {
      "click": _vm.toggleViewTranscript
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.viewTranscript),
      expression: "!viewTranscript"
    }]
  }, [_vm._v("View Transcript")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewTranscript),
      expression: "viewTranscript"
    }]
  }, [_vm._v("Hide Transcript")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8 col-lg-9"
  }, [(_vm.getCurrentVideoTranscript) ? _c('div', {
    staticClass: "side-content",
    style: ({
      'border-left-color': this.getCorpHeaderColor + ' !important'
    })
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewTranscript),
      expression: "viewTranscript"
    }],
    staticClass: "boxes",
    class: {
      'animated fadeIn': _vm.viewTranscript, 'animated fadeOut': !_vm.viewTranscript
    }
  }, [_c('pre', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentVideoTranscript.vtt_file)
    }
  }, [_vm._v("\n                                    ")])])])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "recently-watched"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthRecommendedVideos) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.recommendationList), function(reccentVideo) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": reccentVideo.image
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(reccentVideo.mediaid, reccentVideo.title)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(reccentVideo.title) + "\n                                    ")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    style: (_vm.styleObject),
    on: {
      "click": function($event) {
        return _vm.redirectToRelatedVideos()
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_vm._v("View All Your Videos")])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("RELATED VIDEOS")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-23798c26", module.exports)
  }
}

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community-content"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": "refreshing event"
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('svg', {
    attrs: {
      "width": "61px",
      "height": "50px",
      "viewBox": "0 0 61 50",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Page 1")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_Unauthenticated",
      "transform": "translate(-127.000000, -2206.000000)",
      "stroke": _vm.getCorpHeaderColor,
      "stroke-width": "2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-7-Copy-3",
      "transform": "translate(126.000000, 2175.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M24.5374934,65.012267 C22.5790733,65.012267 19.243945,64.7900847 17.4429019,64.4053966 L9.23192587,72.6163727 L9.23192587,60.9879935 C4.80797411,58.0078696 2,53.639042 2,48.7553018 C2,39.7775843 11.4426225,32.4983366 23.0901862,32.4983366 C34.7383893,32.4983366 44.1803723,39.7775843 44.1803723,48.7553018 C44.1803723,57.7330193 34.7377498,65.012267 23.0901862,65.012267 L24.5374934,65.012267 Z M44.5204304,38.6240915 C47.1558084,41.7216246 48.702081,45.4588977 48.702081,49.4780554 C48.702081,58.8707981 40.2839121,66.7115128 29.1703176,68.4451542 C32.3177945,69.8889815 35.9795445,70.7332924 39.9091744,70.7332924 C41.8675945,70.7332924 43.756055,70.5109693 45.5570981,70.1262812 L53.7680741,78.3372573 L53.7680741,66.7114361 C58.1920252,63.7313122 61,59.3624846 61,54.4761865 C61,46.7198836 53.9484087,40.2476649 44.5204943,38.6240147 L44.5204304,38.6240915 Z",
      "id": "Page-1"
    }
  })])])])]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-transform": "none"
    },
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v("Join the Conversation at "), (_vm.bannerEvent.type === '1') ? _c('span', [_vm._v("TONE Live")]) : _c('span', [_vm._v("TONE Talk")])]), _vm._v(" "), (_vm.bannerEvent && _vm.showRulesComp && _vm.showJoin(_vm.bannerEvent) && _vm.bannerEvent.type !== '3') ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.showRulesComp) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.bannerEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.bannerEvent) ? _c('div', {
    staticClass: "communityBox"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getExpert) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [(_vm.currentVideo) ? _c('jwplayer', {
    attrs: {
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (!_vm.currentVideo) ? _c('img', {
    attrs: {
      "src": _vm.bannerEvent.img_url,
      "alt": _vm.bannerEvent.title,
      "title": _vm.bannerEvent.title
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.bannerEvent && _vm.bannerEvent.csvExpertsNames) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('h2', [_vm._v(_vm._s(_vm.bannerEvent.title) + " with " + _vm._s(_vm.replaceLastExpert(_vm.bannerEvent.csvExpertsNames, ',', ' & ')))]), _vm._v(" "), (_vm.bannerEvent) ? _c('p', [_vm._v("\n                            " + _vm._s(_vm.bannerEvent.longDescription) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.getDateReference(_vm.bannerEvent.start_date, 'str')) + "\n                        ")]), _vm._v(" "), (!_vm.showJoin(_vm.bannerEvent)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    }
  }, [_vm._v("\n                            Add to Calendar\n                            "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.bannerEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.bannerEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.bannerEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.bannerEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.bannerEvent.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.bannerEvent.eventId))]) : _c('span', [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.bannerEvent.eventId))])])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.bannerEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                        ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.bannerEvent && _vm.showRulesComp && !_vm.showJoin(_vm.bannerEvent) && _vm.bannerEvent.type !== '3') ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.showRulesComp) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.bannerEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _c('div')]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showCorporateImageShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateImageShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")])])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.shareEventSelected.img_url,
      "alt": _vm.shareEventSelected.title,
      "title": _vm.shareEventSelected.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.shareEventSelected.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.shareEventSelected.longDescription.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateImage()
      }
    }
  }, [_vm._v("\n                            Share This Event\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-24b2f4ca", module.exports)
  }
}

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper bodyfont-unauth"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "video-player autoheight"
  }, [_c('div', {
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.currentVideo) ? _c('div', {
    staticClass: "reset-video-width"
  }, [_c('h2', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), _c('jwplayer', {
    attrs: {
      "id": "mainVideoPlayer",
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.videoNotFoundFlag) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.videoTag && _vm.videoTag !== 'COMMUNITY') ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "player-content"
  }, [_c('p', {
    staticClass: "video-description"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentVideo.Description) + "\n                    ")]), _vm._v(" "), (_vm.getCorpButtonColor === '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getCorpButtonColor !== '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.videoExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.videoExpert[0].expertId + '/' + _vm.videoExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.videoExpert[0].small_image,
      "alt": _vm.videoExpert[0].name,
      "title": _vm.videoExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.videoExpert && _vm.videoExpert[0].areasofexpertise) + "\n                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoTag && _vm.videoTag !== 'COMMUNITY') ? _c('h2', [_vm._v("MORE " + _vm._s(_vm.videoTag) + " VIDEOS")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoList) ? _c('div', {
    staticClass: "row morevediosrow"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider largeslidesilderplayicon"
  }, _vm._l((_vm.videoList), function(vid) {
    return _c('div', {
      staticClass: "slide-player"
    }, [(_vm.videoList) ? _c('div', {}, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + vid.mediaid + '/' + vid.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": vid.image,
        "alt": vid.title,
        "title": vid.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(vid.title))])])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.showComponent) ? _c('h4', [_vm._v("Want more tips ? Sign up today for your free TONE trial!")]) : _vm._e(), _vm._v(" "), (_vm.showComponent) ? _c('div', {
    staticClass: "text-center"
  }, [(!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/signup')
      }
    }
  }, [_vm._v("Start Your Free Trial")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redeemCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {}, [(_vm.categoryVideoList) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.categoryVideoList), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      },
      on: {
        "click": function($event) {
          return _vm.triggerLogin(video.mediaid)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      staticStyle: {
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          return _vm.triggerLogin(video.mediaid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])])
  })], 2) : _vm._e()])]), _vm._v(" "), (_vm.showComponent) ? _c('h2', {
    staticClass: "pink-text-headline",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(" and many more ...")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "errormessage"
  }, [_vm._v("This video is for Members only. "), _c('br'), _vm._v("\n            Become a member today by starting your Free Trial")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-270784da", module.exports)
  }
}

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp bodyfont-unauth"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), (_vm.getCorporateClient) ? _c('h2', [_vm._v("\n                                    " + _vm._s(_vm.getGiftee.welcomeMessage) + "\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "left-content"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true
    }
  }, [_c('panel', {
    staticClass: "text-left",
    attrs: {
      "is-open": true
    }
  }, [_c('h4', [_vm._v("Create your Account")]), _vm._v(" "), _c('div', {
    staticClass: "create-account"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onGifteeSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus"
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z '-]+$/,
      "id": "redeem_firstname",
      "type": "text",
      "error": "First Name (no digits allowed)",
      "placeholder": "First Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstName", $$v)
      },
      expression: "user.firstName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z '-]+$/,
      "id": "redeem_lastname",
      "type": "text",
      "error": "Last Name (no digits allowed)",
      "placeholder": "Last Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastName", $$v)
      },
      expression: "user.lastName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": _vm.emailPattern,
      "id": "redeem_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), (this.$route.params.corporateId === '112') ? _c('div', {
    staticClass: "mandatory-class"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userRegion),
      expression: "user.userRegion"
    }],
    staticClass: "form-control",
    staticStyle: {
      "border-color": "#a94442"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "userRegion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select Which Comcast Division You Are From")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("HQ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Northeast")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("West")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Central")])]), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors",
    staticStyle: {
      "color": "#a94442"
    }
  }, [_vm._v("Division (required)")])]) : _vm._e(), _vm._v(" "), (_vm.getCorporationRegions && this.$route.params.corporateId !== '112') ? _c('div', {
    staticClass: "mandatory-class"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userRegion),
      expression: "user.userRegion"
    }],
    staticClass: "form-control",
    staticStyle: {
      "border-color": "#a94442"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "userRegion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select Which Adecco Company You Are From")]), _vm._v(" "), _vm._l((_vm.getCorporationRegions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.corpRegionId
      }
    }, [_vm._v("\n                                                                    " + _vm._s(option.regionName) + "\n                                                                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors",
    staticStyle: {
      "color": "#a94442"
    }
  }, [_vm._v("Company (required)")])]) : _vm._e(), _vm._v(" "), _c('vue-password', {
    staticClass: "form-input",
    attrs: {
      "minlength": 6,
      "classes": "input form-control",
      "placeholder": "Password",
      "error": "Password",
      "id": "signup_password",
      "disableStrength": _vm.hidePasswordMeter,
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-info-circled alert-icon-float-left information"
  }, [_c('p', {
    staticClass: "alert alert-info alert-dismissable",
    class: {
      'set-error': !_vm.verifyPassword()
    },
    attrs: {
      "id": "redeem_pwderrormsg"
    }
  }, [_vm._v("Min 6 Chars, One Upper Case, One Lower Case!")])]), _vm._v(" "), _c('checkbox', {
    staticClass: "terms-and-condition",
    attrs: {
      "value": "isChecked",
      "type": "primary"
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n                                                             I agree to "), _c('a', {
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "href": "/terms",
      "target": "_blank",
      "rel": "opener"
    }
  }, [_vm._v("terms and conditions")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit",
      "id": "redeem_button",
      "disabled": !_vm.isChecked || _vm.spinner || this.user.packageId === -1 || this.user.userRegion < 1
    }
  }, [_vm._v("\n                                                            Complete Sign Up\n                                                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "jumbotron",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    })
  }, [_c('div', {
    staticClass: "hidemobile"
  }, [(_vm.getGiftee.panelHeading1) ? _c('h2', [_vm._v(_vm._s(_vm.getGiftee.panelHeading1))]) : _vm._e(), (_vm.getGiftee.panelHeading2) ? _c('p', [_vm._v(_vm._s(_vm.getGiftee.panelHeading2))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "showmobile"
  }, [(_vm.getGiftee.panelHeading2) ? _c('h2', [_vm._v(_vm._s(_vm.getGiftee.panelHeading2))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, [(_vm.getGiftee.panelBullet1) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.getGiftee.panelBullet1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGiftee.panelBullet2) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.getGiftee.panelBullet2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGiftee.panelBullet3) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.getGiftee.panelBullet3)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGiftee.panelBullet4) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.getGiftee.panelBullet4)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGiftee.panelBullet5) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.getGiftee.panelBullet5)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGiftee.panelBullet6) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.getGiftee.panelBullet6)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer hidemobile"
  }, [_c('div', {
    staticClass: "list-group"
  }, [(_vm.giftDescription) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.giftDescription))])]) : _c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.defaultPlan.description))])])])])])])])])])])]), _vm._v(" "), (_vm.showResetModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showResetModal,
      "width": "200"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelResetModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelResetModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h2', {
    staticClass: "forgot-heading"
  }, [_vm._v("\n                        That Account Exists!\n                    ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("You have an account with Tone Networks. Please try logging in or resetting your password.")])]), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-transparent",
    on: {
      "click": _vm.SetupLogin
    }
  }, [_vm._v("\n                        Sign In\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-transparent",
    on: {
      "click": _vm.onSubmitForgetRequest
    }
  }, [_vm._v("\n                        Reset Password\n                    ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2791f852", module.exports)
  }
}

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper bodyfont-unauth"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "video-player autoheight"
  }, [_c('div', {
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.currentVideo) ? _c('div', {
    staticClass: "reset-video-width"
  }, [_c('h2', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), _c('jwplayer', {
    attrs: {
      "id": "mainVideoPlayer",
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.videoNotFoundFlag) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.videoTag && _vm.videoTag !== 'COMMUNITY') ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "player-content"
  }, [_c('p', {
    staticClass: "video-description"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentVideo.Description) + "\n                    ")]), _vm._v(" "), (_vm.getCorpButtonColor === '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getCorpButtonColor !== '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.videoExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.videoExpert[0].expertId + '/' + _vm.videoExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.videoExpert[0].small_image,
      "alt": _vm.videoExpert[0].name,
      "title": _vm.videoExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.videoExpert && _vm.videoExpert[0].areasofexpertise) + "\n                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoTag && _vm.videoTag !== 'COMMUNITY') ? _c('h2', [_vm._v("MORE " + _vm._s(_vm.videoTag) + " VIDEOS")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoList) ? _c('div', {
    staticClass: "row morevediosrow"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider largeslidesilderplayicon"
  }, _vm._l((_vm.videoList), function(vid) {
    return _c('div', {
      staticClass: "slide-player"
    }, [(_vm.videoList) ? _c('div', {}, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + vid.mediaid + '/' + vid.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": vid.image,
        "alt": vid.title,
        "title": vid.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(vid.title))])])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.showComponent) ? _c('h4', [_vm._v("Want more tips ? Sign up today for your free TONE trial!")]) : _vm._e(), _vm._v(" "), (_vm.showComponent) ? _c('div', {
    staticClass: "text-center"
  }, [(!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/signup')
      }
    }
  }, [_vm._v("Start Your Free Trial")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redeemCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {}, [(_vm.categoryVideoList) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.categoryVideoList), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      },
      on: {
        "click": function($event) {
          return _vm.triggerLogin(video.mediaid)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      staticStyle: {
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          return _vm.triggerLogin(video.mediaid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])])
  })], 2) : _vm._e()])]), _vm._v(" "), (_vm.showComponent) ? _c('h2', {
    staticClass: "pink-text-headline",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(" and many more ...")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "errormessage"
  }, [_vm._v("This video is for Members only. "), _c('br'), _vm._v("\n            Become a member today by starting your Free Trial")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2d26e445", module.exports)
  }
}

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper fixgraybgpl"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.videoSqueeze),
      expression: "!videoSqueeze"
    }],
    staticClass: "video-player-background",
    class: {
      'animated zoomOutLeft': _vm.videoCompleted
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "video-player",
    on: {
      "mouseleave": function($event) {
        _vm.addRightHoverWidthClass ? _vm.resetClass(true) : _vm.resetClass(false)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideLeftVideoIcons),
      expression: "!hideLeftVideoIcons"
    }],
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.getArchivePlaylistObject) ? _c('div', {
    staticClass: "reset-video-width",
    class: {
      'enjoy-hover': _vm.addEnjoyHoverClass
    }
  }, [_c('jwplaylist', {
    attrs: {
      "data": _vm.getArchivePlaylistObject,
      "on-playlistitem": _vm.videoChangedInPlaylist()
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.playlistVideos) ? _c('div', {
    staticClass: "playlistholderdiv"
  }, [(((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareArchivePlistPermission >= 1))) ? _c('i', {
    staticClass: "fa fa-2x fa-share-square cursor",
    attrs: {
      "title": "Share Playlist"
    },
    on: {
      "click": function($event) {
        return _vm.showSharingModal(_vm.eventRef)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.eventRef) ? _c('h4', [_vm._v(_vm._s(_vm.eventRef.title))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.videoIndex) + " of " + _vm._s(_vm.playlistVideos.length) + ")")]), _vm._v(" "), _vm._l((_vm.getArchivePlaylistObject), function(item) {
    return (_vm.getArchivePlaylistObject && _vm.getItemChangeInPlaylist) ? _c('div', [_c('div', {
      staticClass: "playlistentrydiv",
      class: {
        'playing': item.videoCode === _vm.getItemChangeInPlaylist.item.videoCode
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.image,
        "alt": item.title,
        "title": item.title
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])]) : _vm._e()
  })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "player-content"
  }, [(_vm.currentVideo) ? _c('h4', [_vm._v(_vm._s(_vm.currentVideo.title) + " (Playing " + _vm._s(_vm.videoIndex) + " of " + _vm._s(_vm.playlistVideos.length) + ")")]) : _vm._e(), _vm._v(" "), (_vm.currentVideo) ? _c('p', [_vm._v("\n                            " + _vm._s(_vm.currentVideo.description) + "\n                        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventExpertColl), function(expert) {
    return (_vm.eventExpertColl) ? _c('div', {
      staticClass: "profile-content"
    }, [_c('a', {
      attrs: {
        "href": '/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
        "target": "_blank",
        "rel": "opener"
      }
    }, [_c('img', {
      attrs: {
        "src": expert.small_image,
        "alt": expert.name,
        "title": expert.name
      }
    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(expert && expert.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(expert && expert.experties))])])]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.showSharedModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showSharedModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "method": "post",
      "id": "playlistshare-form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSharePlaylist.apply(null, arguments)
      }
    }
  }, [_c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedMessage",
      "id": "playlistshare_sharedMessage",
      "type": "text",
      "error": "Optional Message",
      "placeholder": "Optional Message",
      "autocomplete": "off",
      "icon": ""
    },
    model: {
      value: (_vm.sharePayload.sharedEmailMessage),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedEmailMessage", $$v)
      },
      expression: "sharePayload.sharedEmailMessage"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedEmailMessagePreview",
      "id": "playlistshare_sharedEmailMessagePreview",
      "type": "textarea",
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.sharePayload.sharedPlaylistPreview),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedPlaylistPreview", $$v)
      },
      expression: "sharePayload.sharedPlaylistPreview"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "disabled": _vm.spinner || (_vm.taggedEmails && _vm.taggedEmails.length === 0)
    }
  }, [_vm._v("\n                            Send Email\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showShareCommunity) ? _c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]) : _vm._e(), _vm._v(" "), (_vm.showShareIndividual) ? _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.showShareFriends) ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.corpShareModalImage,
      "alt": _vm.corpShareModalTitle,
      "title": _vm.corpShareModalTitle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s((_vm.corpShareModalTitle + " | TONE Networks")))]), _vm._v(" "), (_vm.corpShareModalDesc) ? _c('p', [_vm._v(" " + _vm._s(((_vm.corpShareModalDesc.substring(0,250)) + "...")))]) : _vm._e(), _vm._v(" "), (!_vm.corpShareModalDesc) ? _c('p', [_vm._v(_vm._s(_vm.user.firstName) + "'s Personal Playlist")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share This Playlist\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recently-watched"
  }, [_c('div', {
    staticClass: "container"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2dc49f94", module.exports)
  }
}

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "JWvideoHandler"
  }, [_c('div', {
    attrs: {
      "id": "player"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f3b14a2", module.exports)
  }
}

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("\n                   Corporate Gift Purchase\n                ")]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "signup_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('div', {
    staticClass: "panel panel-default text-left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('br'), _vm._v(" "), (_vm.giftPlans) ? _c('div', {
    staticClass: "gifts row"
  }, _vm._l((this.giftPlans), function(plan) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "gift-item"
    }, [_c('h5', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.packageId),
        expression: "packageId"
      }],
      attrs: {
        "type": "radio",
        "name": "pkg"
      },
      domProps: {
        "value": plan.packageId,
        "checked": plan.packageId == _vm.packageId,
        "checked": _vm._q(_vm.packageId, plan.packageId)
      },
      on: {
        "change": function($event) {
          _vm.packageId = plan.packageId
        }
      }
    }), _c('br'), _c('strong', [_vm._v("Gift of TONE")]), _vm._v(" "), _c('br'), _c('small', [_vm._v(_vm._s(plan.description))])]), _vm._v(" "), (_vm.packageId !== plan.packageId) ? _c('button', {
      on: {
        "click": function($event) {
          _vm.packageId = plan.packageId
        }
      }
    }, [_vm._v("$" + _vm._s(plan.amount))]) : _vm._e(), _vm._v(" "), (_vm.packageId === plan.packageId) ? _c('button', {
      staticClass: "active",
      on: {
        "click": function($event) {
          _vm.packageId = plan.packageId
        }
      }
    }, [_vm._v("$" + _vm._s(plan.amount))]) : _vm._e()])])
  }), 0) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "clearfix gap"
  }), _vm._v(" "), (_vm.getCorporateClients) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientId),
      expression: "clientId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.clientId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getCorporateClients), function(option) {
    return _c('option', {
      domProps: {
        "value": option.corporationId
      }
    }, [_vm._v("\n                                                " + _vm._s(option.name) + "\n                                            ")])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "clearfix gap"
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "file",
      "id": "corporateUpload"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "id": "signup_button",
      "disabled": this.spinner
    },
    on: {
      "click": _vm.onPaymentSubmit
    }
  }, [_vm._v("\n                                        Send Gift\n                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.gifteeCol.length > 0) ? _c('h4', [_vm._v("Recipients "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.gifteeCol = []
      }
    }
  }, [_vm._v("Delete All (" + _vm._s(_vm.gifteeCol.length) + ")")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.gifteeCol.length > 0) ? _c('table', [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.gifteeCol), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry.gifteeFirstName) + " " + _vm._s(entry.gifteeLastName)), _c('br'), _vm._v("\n                                                    " + _vm._s(entry.gifteeEmail) + "\n                                                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getPackageInfo(entry.packageId)[0].description) + " $" + _vm._s(_vm.getPackageInfo(entry.packageId)[0].amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.deliveryMessage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.returnFormatedDate(entry.deliveryDate, 'A')))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn formButton",
      on: {
        "click": function($event) {
          return _vm.removeGiftee(entry)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.gifteeCol.length > 0) ? _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "jumbotron text-center"
  }, [_c('p', [_vm._v("Total Recipients : "), _c('b', [_vm._v(_vm._s(_vm.gifteeCol.length))])])])]) : _vm._e()])])])])])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_c('span', [_vm._v("1.")]), _vm._v(" Gift Selection\n                                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "margin-bot-20"
  }, [_c('span', [_vm._v("2.")]), _vm._v(" Select Corporate Client")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "margin-bot-20"
  }, [_c('span', [_vm._v("3.")]), _vm._v(" Select CSV File")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Recipient")]), _vm._v(" "), _c('th', [_vm._v("Package")]), _vm._v(" "), _c('th', [_vm._v("Message")]), _vm._v(" "), _c('th', [_vm._v("Delivery Date")]), _vm._v(" "), _c('th', [_vm._v(" ")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-304dffb6", module.exports)
  }
}

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "signup_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "left-content"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true
    }
  }, [_c('panel', {
    staticClass: "text-left",
    attrs: {
      "is-open": true
    }
  }, [_c('div', {
    staticClass: "create-account"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "action": "/charge",
      "method": "post",
      "id": "payment-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onPaymentSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "checkboxholder"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "radio popular",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('label', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("One Year Plan")]), _vm._v(" "), _c('span', {
    staticClass: "plan-price"
  }, [_vm._v("$120\n")]), _vm._v(" "), (_vm.annualPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "type": "radio",
      "id": "annualplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.annualPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.annualPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.annualPlan.packageId
      }
    }
  }) : _vm._e()])])]), _c('div', {
    staticClass: "col-sm-4"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "codediv"
  }, [_c('div', {
    staticClass: "radiowrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gateway),
      expression: "gateway"
    }],
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "CC",
      "name": "paymentMethod"
    },
    domProps: {
      "checked": _vm._q(_vm.gateway, "CC")
    },
    on: {
      "change": function($event) {
        _vm.gateway = "CC"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v("Credit Card")])]), _vm._v(" "), (_vm.gateway === 'CC') ? _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "paymentMethod_cardHolder",
      "pattern": /^[A-Za-z ]+$/,
      "type": "text",
      "error": "Card Holder Name (no digits allowed)",
      "placeholder": "Card Holder Name",
      "required": "",
      "name": "cardholdername",
      "icon": ""
    },
    model: {
      value: (_vm.userObject.cardHolderName),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "cardHolderName", $$v)
      },
      expression: "userObject.cardHolderName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.gateway === 'CC') ? _c('div', {
    staticClass: "stripeholder"
  }, [(_vm.gateway === 'CC') ? _c('i', {
    staticClass: "fa fa-lock overlapstripe"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field",
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), (_vm.stripeErrorMessage) ? _c('div', {
    staticStyle: {
      "color": "#a94442",
      "margin": "2px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.stripeErrorMessage))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.gateway === 'paypal') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "text-center margin-top-10 margin-bottom-10",
    attrs: {
      "id": "paypal-button"
    }
  })]), _vm._v(" "), (_vm.userPayments.paymentMethodNonce) ? _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left success"
  }, [_c('p', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Payment successfully authorized")])])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('checkbox', {
    staticClass: "terms-and-condition",
    attrs: {
      "value": "isChecked",
      "type": "primary"
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n                                                             I agree to "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "_blank",
      "rel": "opener"
    }
  }, [_vm._v("terms and conditions")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "id": "signup_button",
      "disabled": !_vm.isChecked || _vm.spinner,
      "name": "completesignupbutton"
    }
  }, [_vm._v("\n                                                            Become a Member\n                                                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])])])])])], 1)], 1)]), _vm._v(" "), _vm._m(1)])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), _c('h2', [_vm._v("Hello Team Novo Nordisk! We are glad you're here. You are just 1 step away from completing your TONE membership!\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "hidemobile"
  }, [_c('h2', [_vm._v("Your Plan")]), _c('p', [_vm._v("What You Get")])]), _vm._v(" "), _c('div', {
    staticClass: "showmobile"
  }, [_c('h2', [_vm._v("What You Get")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('li', [_vm._v("Access to highly credentialed experts for on-demand guidance and coaching to help you grow personally and professionally")]), _vm._v(" "), _c('li', [_vm._v("Over 1000 bite-sized original videos designed for the working woman who is short on \"free time\"")]), _vm._v(" "), _c('li', [_vm._v("An open invitation to all live streaming events with our credentialed experts and career coaching sessions. Learn and ask questions with other Tone members")]), _vm._v(" "), _c('li', [_vm._v("A personalized experience. TONE is self-directed, so you go at your own pace and just watch what you want")]), _vm._v(" "), _c('li', [_vm._v("Custom communications:"), _c('br'), _vm._v(" "), _c('i', [_vm._v("TONE Teasers")]), _vm._v(": customized emails serve up videos selected just for you"), _c('br'), _vm._v(" "), _c('i', [_vm._v("TONE Takeaways")]), _vm._v(": reminder emails reinforce the skills you learn and help make it stick")]), _vm._v(" "), _c('li', [_vm._v("Membership to a vibrant community of like-minded professional women who share your passions, challenges and goals. Learn from each other in live-streaming and interactive coaching sessions")])])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30ce6f02", module.exports)
  }
}

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": _vm.spinnerText
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_c('svg', {
    attrs: {
      "width": "47px",
      "height": "48px",
      "viewBox": "0 0 47 48",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Work")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_Unauthenticated",
      "transform": "translate(-666.000000, -819.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-7",
      "transform": "translate(88.000000, 800.000000)"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Work",
      "transform": "translate(666.000000, 819.000000)",
      "fill": _vm.getCorpHeaderColor
    }
  }, [_c('path', {
    attrs: {
      "d": "M45.6944444,-1.62630326e-19 C34.1361,-1.62630326e-19 23.4467333,5.0007033 15.9565,13.1868132 L1.30555556,13.1868132 C0.777223333,13.1868132 0.301896667,13.5082444 0.0999533333,14.0007033 C-0.102000444,14.4931464 0.0101937778,15.0597626 0.383504333,15.4368527 L8.84924878,23.9877099 C7.97410878,25.934822 7.23772322,27.964378 6.66651656,30.0742154 C6.54208144,30.5316343 6.67059511,31.0199736 7.00310444,31.3537582 L15.9566044,40.3988571 C16.2054747,40.6502295 16.5379944,40.78416 16.8806767,40.78416 C16.9949128,40.78416 17.1111908,40.7697389 17.2254269,40.7367719 C19.3143158,40.1598224 21.3257069,39.4160334 23.2513491,38.5320949 L31.7170936,47.082951 C31.9659638,47.3384482 32.3005202,47.4723735 32.6391291,47.4723735 C32.8064021,47.4723735 32.9777589,47.4394064 33.1389114,47.3714099 C33.6264529,47.1674258 33.9447003,46.6873308 33.9447003,46.1536869 L33.9447003,31.3554462 C42.0495892,23.7893802 47.0002559,12.9930725 47.0002559,1.31852308 C47.0002559,0.589134066 46.4168292,-0.000158241758 45.6947003,-0.000158241758 L45.6944444,-1.62630326e-19 Z M17.2599667,37.9864615 L9.39216667,30.0395604 C12.5765211,19.1398681 20.3483889,10.4882637 30.2074222,6.00474725 L41.0576333,16.9619341 C36.6167078,26.9200879 28.0532556,34.7725714 17.2599667,37.9864615 Z M44.3664333,2.66004396 C44.2256788,6.70881758 43.4484711,10.6275165 42.12657,14.3098022 L32.8325811,4.92448352 C36.4759167,3.58934505 40.3578033,2.80225055 44.3663811,2.66004396 L44.3664333,2.66004396 Z M4.45716667,15.8241758 L13.7407111,15.8241758 C12.3719144,17.5982242 11.1438567,19.4958593 10.0749722,21.4987253 L4.45716667,15.8241758 Z M31.3333333,42.9705495 L25.7152667,37.296 C27.6980922,36.2142593 29.5748022,34.9739077 31.3333333,33.5934066 L31.3333333,42.9705495 Z",
      "id": "Fill-1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.30555556,47.4725275 C1.64010156,47.4725275 1.97462667,47.3447789 2.22962778,47.0872246 L7.45185,41.8124993 C7.96183133,41.2973908 7.96183133,40.4629081 7.45185,39.9477785 C6.94186867,39.4326699 6.11569222,39.4326699 5.60569,39.9477785 L0.383467778,45.2225037 C-0.126513556,45.7376123 -0.126513556,46.5720949 0.383467778,47.0872246 C0.636421778,47.3447789 0.970967778,47.4725275 1.30550333,47.4725275 L1.30555556,47.4725275 Z",
      "id": "Fill-2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.909,47.0874709 C7.16399067,47.3450252 7.49853667,47.4727738 7.83307222,47.4727738 C8.16760778,47.4727738 8.50214333,47.3450252 8.75714444,47.0874709 L12.6738111,43.1314286 C13.1837924,42.61632 13.1837924,41.7818374 12.6738111,41.2667077 C12.1638298,40.7515991 11.3376533,40.7515991 10.8276511,41.2667077 L6.91098444,45.2227501 C6.40100311,45.7358015 6.40100311,46.5723407 6.90894256,47.0874709 L6.909,47.0874709 Z",
      "id": "Fill-3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.30555556,40.8791209 C1.64010156,40.8791209 1.97462667,40.7513723 2.22962778,40.493818 L6.14629444,36.5377741 C6.65627578,36.0226655 6.65627578,35.1881829 6.14629444,34.6730532 C5.63631311,34.1579446 4.81013667,34.1579446 4.30013444,34.6730532 L0.383467778,38.6290971 C-0.126513556,39.1442057 -0.126513556,39.9786884 0.383467778,40.493818 C0.636421778,40.7513723 0.970967778,40.8791209 1.30550333,40.8791209 L1.30555556,40.8791209 Z",
      "id": "Fill-4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.1111111,14.5054945 C22.51065,14.5054945 19.5833333,17.4622418 19.5833333,21.0989011 C19.5833333,24.7355604 22.51065,27.6923077 26.1111111,27.6923077 C29.7115722,27.6923077 32.6388889,24.7355604 32.6388889,21.0989011 C32.6388889,17.4622418 29.7115722,14.5054945 26.1111111,14.5054945 Z M26.1111111,25.0549451 C23.9508344,25.0549451 22.1944444,23.2808967 22.1944444,21.0989011 C22.1944444,18.9169055 23.9508344,17.1428571 26.1111111,17.1428571 C28.2713878,17.1428571 30.0277778,18.9169055 30.0277778,21.0989011 C30.0277778,23.2808967 28.2713878,25.0549451 26.1111111,25.0549451 Z",
      "id": "Fill-5"
    }
  })])])])]), _vm._v(" "), _c('br'), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Work")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.getVideoSubcategories) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "interest-container work"
  }, [_c('button-group', {
    model: {
      value: (_vm.interestIndexes),
      callback: function($$v) {
        _vm.interestIndexes = $$v
      },
      expression: "interestIndexes"
    }
  }, _vm._l((_vm.getVideoSubcategories), function(interest, interestSubCategoryId) {
    return _c('checkbox', {
      key: interest.interestSubCategoryName.toString().toUpperCase(),
      staticClass: "min-padding checkbox-btn",
      style: (_vm.styleInterestObject(interest.interestSubCategoryName.toString().toUpperCase())),
      attrs: {
        "true-value": interest.interestSubCategoryName.toString().toUpperCase()
      }
    }, [_vm._v("\n                                        " + _vm._s(interest.interestSubCategoryName) + "\n                                    ")])
  }), 1)], 1)]), _vm._v(" "), (_vm.getAuthWorkVideos && _vm.getAuthWorkVideos.length >= 100 && !_vm.showAllVideosFlag) ? _c('a', {
    staticClass: "bolder hidemobile",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showAllVideos('top')
      }
    }
  }, [_vm._v("choose a category or click to see more")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [(_vm.hideCompleteList() && !_vm.isMobile) ? _c('div', [_c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthWorkVideos), function(video, index) {
    return ((index + 1) <= 99) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      class: {
        'private-contents': video.isPrivate === '1'
      },
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(video.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      attrs: {
        "title": video.title
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), (_vm.getAuthWorkVideos && _vm.getAuthWorkVideos.length >= 100 && !_vm.showAllVideosFlag) ? _c('a', {
    staticClass: "bolder hidemobile",
    attrs: {
      "id": "btmLink",
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showAllVideos()
      }
    }
  }, [_vm._v("click to browse all videos")]) : _vm._e()], 2)]) : _c('div', [_c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthWorkVideos), function(video, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      class: {
        'private-contents': video.isPrivate === '1'
      },
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(video.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      attrs: {
        "title": video.title
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(2, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  })], 2)])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-32e87aa0", module.exports)
  }
}

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper"
  }, [_c('div', {
    staticClass: "theme-bg-img",
    class: _vm.selectedTheme
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), (_vm.newContentLoaded) ? _c('span', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.firstName) ? _c('span', [_c('h2', [(_vm.getAuthGreeting) ? _c('span', [_vm._v(_vm._s(_vm.getAuthGreeting))]) : _vm._e(), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v(", here are some videos we think you'll love.\n                            ")])]) : _c('span', [_c('h2', [(_vm.getAuthGreeting) ? _c('span', [_vm._v(_vm._s(_vm.getAuthGreeting))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n                               \t     Here are some videos we think you'll love.\n\t\t\t\t                ")])])])]), _vm._v(" "), (_vm.getAuthRecommendedVideos) ? _c('div', {
    staticClass: "left-panel clearfix col-xs-12 col-sm-12 col-md-8"
  }, [_c('div', {
    staticClass: "coloredpannel"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthRecommendedVideos[0].mediaid + '/' + _vm.getAuthRecommendedVideos[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthRecommendedVideos[0].image,
      "alt": _vm.getAuthRecommendedVideos[0].title,
      "title": _vm.getAuthRecommendedVideos[0].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthRecommendedVideos[0].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('h1', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthRecommendedVideos[0].mediaid, _vm.getAuthRecommendedVideos[0].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthRecommendedVideos[0].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getAuthRecommendedVideos[0].description))]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  })]), _vm._v(" "), (_vm.getQuote) ? _c('div', {
    staticClass: "panel panel-default high-lighter responsive-social-icons hidemobile"
  }, [_c('h2', [_vm._v("\n                                    \" " + _vm._s(_vm.getQuote.quote) + " \" "), _c('br')]), _c('h4', [_vm._v("(" + _vm._s(_vm.getQuote.author) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "container-icons"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.quoteReference,
      "description": _vm.quoteReference,
      "title": _vm.quoteReference
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.getAuthRecommendedVideos) ? _c('div', {
    staticClass: "right-panel clearfix col-xs-12 col-sm-12 col-md-4 pull-right"
  }, [(_vm.getAuthRecommendedVideos) ? _c('div', {
    staticClass: "shadowdrop"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthRecommendedVideos[1].mediaid + '/' + _vm.getAuthRecommendedVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthRecommendedVideos[1].image,
      "alt": _vm.getAuthRecommendedVideos[1].title,
      "title": _vm.getAuthRecommendedVideos[1].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthRecommendedVideos[1].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthRecommendedVideos[1].mediaid, _vm.getAuthRecommendedVideos[1].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthRecommendedVideos[1].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getAuthRecommendedVideos[1].description))]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  })])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getAuthRecommendedVideos[2]) ? _c('div', {
    staticClass: "shadowdrop"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthRecommendedVideos[2].mediaid + '/' + _vm.getAuthRecommendedVideos[2].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthRecommendedVideos[2].image,
      "alt": _vm.getAuthRecommendedVideos[2].title,
      "title": _vm.getAuthRecommendedVideos[2].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthRecommendedVideos[2].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthRecommendedVideos[2].mediaid, _vm.getAuthRecommendedVideos[2].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthRecommendedVideos[2].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getAuthRecommendedVideos[2].description))]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  })])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default interest-mood",
    class: {
      hidden: _vm.showQuestionsBox
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 col-md-5"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showQuestions
    }
  }, [_vm._v("Yes\n                                            ")])])])]), _vm._v(" "), (_vm.getAuthQuestions) ? _c('div', {
    staticClass: "col-md-12",
    class: {
      hidden: !_vm.showQuestionsBox
    }
  }, [_c('div', {
    staticClass: "questions-content"
  }, [_vm._l((_vm.getAuthQuestions), function(question) {
    return _c('div', [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.setAnswer(question.questionId)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(question.question))])])])
  }), _vm._v(" "), _c('span', {
    staticClass: "no-thanks"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showQuestions
    }
  }, [_vm._v("no thanks")])])], 2), _vm._v(" "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left-panel clearfix col-xs-12 col-sm-12 col-md-8"
  }, [(_vm.getQuote) ? _c('div', {
    staticClass: "panel panel-default high-lighter responsive-social-icons showMobile"
  }, [_c('h2', [_vm._v("\n                                \" " + _vm._s(_vm.getQuote.quote) + " \" "), _c('br')]), _c('h4', [_vm._v("(" + _vm._s(_vm.getQuote.author) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "container-icons"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.quoteReference,
      "description": _vm.quoteReference,
      "title": _vm.quoteReference
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "charity",
    attrs: {
      "id": "auth_giving_scroll"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAllCharities) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content charity-content"
  }, [_c('div', {
    staticClass: "slider responsive-slick-charity-slider"
  }, [(_vm.firstLiveEvent) ? _c('div', {
    staticClass: "row imgbalnace"
  }, [_c('div', {
    staticClass: "charity-header margin-bottom-20 "
  }, [_c('div', {
    staticClass: "title",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('h2', [_vm._v("TONE Live: " + _vm._s(_vm.getDateReference(_vm.firstLiveEvent.start_date, 'str')))])]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.currentVideo) ? _c('jwplayer', {
    attrs: {
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (!_vm.currentVideo) ? _c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.firstLiveEvent.img_url,
      "alt": "EXPERTS",
      "width": "100%",
      "alt": _vm.firstLiveEvent.title,
      "title": _vm.firstLiveEvent.title
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('h2', [_vm._v(_vm._s(_vm.firstLiveEvent.title) + " ")]), _vm._v(" "), _c('p', [_vm._v("\n                                                " + _vm._s(_vm.firstLiveEvent.longDescription) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("\n                                                " + _vm._s(_vm.getDateReference(_vm.firstLiveEvent.start_date, 'str')) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.firstLiveEvent.eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.firstLiveEvent.title)
      }
    }
  }, [_vm._v("\n                                                Add to Calendar\n                                                "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.firstLiveEvent.eventId))])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.firstLiveEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix>"
  }), _vm._v(" "), (_vm.showJoin(_vm.firstLiveEvent.eventId)) ? _c('button', {
    staticClass: "btn-pink",
    style: (_vm.styleObject),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent(_vm.firstTalkEvent)
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa 2x fa-arrow-circle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Go to Event ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.firstTalkEvent) ? _c('div', {
    staticClass: "row imgbalnace"
  }, [_c('div', {
    staticClass: "charity-header margin-bottom-20"
  }, [_c('div', {
    staticClass: "title",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('h2', [_vm._v("TONE Talk: " + _vm._s(_vm.getDateReference(_vm.firstTalkEvent.start_date, 'str')))])]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.firstTalkEvent.img_url,
      "alt": "EXPERTS",
      "width": "100%",
      "alt": _vm.firstTalkEvent.title,
      "title": _vm.firstTalkEvent.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('h2', [_vm._v(_vm._s(_vm.firstTalkEvent.title) + " ")]), _vm._v(" "), _c('p', [_vm._v("\n                                                " + _vm._s(_vm.firstTalkEvent.longDescription) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("\n                                                " + _vm._s(_vm.getDateReference(_vm.firstTalkEvent.start_date, 'str')) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.firstTalkEvent.eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.firstTalkEvent.title)
      }
    }
  }, [_vm._v("\n                                                Add to Calendar\n                                                "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.firstTalkEvent.eventId))])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.firstTalkEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix>"
  }), _vm._v(" "), (_vm.showJoin(_vm.firstTalkEvent.eventId)) ? _c('button', {
    staticClass: "btn-pink",
    style: (_vm.styleObject),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent(_vm.firstTalkEvent)
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa 2x fa-arrow-circle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Go to Event ")]) : _vm._e(), _vm._v(" "), _c('br')])])]) : _vm._e()])])])]) : _vm._e()])]), _vm._v(" "), (_vm.getAuthRecentlyWatchedVideos) ? _c('div', {
    staticClass: "recently-watched"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.getAuthRecentlyWatchedVideos), function(reccentVideo) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + reccentVideo.mediaid + '/' + reccentVideo.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": reccentVideo.image,
        "alt": reccentVideo.title,
        "title": reccentVideo.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 recent-style cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(reccentVideo.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor postion-title"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(reccentVideo.title) + "\n                                            ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      staticStyle: {
        "outline": "none"
      },
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(reccentVideo)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(reccentVideo)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    style: (_vm.styleObject),
    on: {
      "click": function($event) {
        return _vm.setRecentlyWatchedVideos()
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_vm._v("View All Your Videos")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "expert-section"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row margin-top-40"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('tabs', {
    staticClass: "expert-tabs",
    attrs: {
      "nav-style": "tabs",
      "justified": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [(_vm.firstLiveEvent) ? _c('tab', {
    attrs: {
      "header": "TONE Live"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.firstLiveEvent.img_url,
      "alt": "EXPERTS",
      "width": "100%",
      "alt": _vm.firstLiveEvent.title,
      "title": _vm.firstLiveEvent.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('h2', [_vm._v(_vm._s(_vm.firstLiveEvent.title))]), _vm._v(" "), _c('p', [_vm._v("\n                                                " + _vm._s(_vm.firstLiveEvent.longDescription) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("\n                                                LIVE " + _vm._s(_vm.getDateReference(_vm.firstLiveEvent.start_date, 'str')) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.firstLiveEvent.eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.firstLiveEvent.title)
      }
    }
  }, [_vm._v("\n                                                Add to Calendar\n                                                "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.firstLiveEvent.eventId))])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.firstLiveEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix>"
  }), _vm._v(" "), (_vm.showJoin(_vm.firstLiveEvent.eventId)) ? _c('button', {
    staticClass: "btn-pink",
    style: (_vm.styleObject),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent(_vm.firstLiveEvent)
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa 2x fa-arrow-circle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Go to Event ")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "TONE Talks"
    }
  }, [(_vm.firstTalkEvent) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.firstTalkEvent.img_url,
      "alt": "EXPERTS",
      "width": "100%",
      "alt": _vm.firstTalkEvent.title,
      "title": _vm.firstTalkEvent.title
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('h2', [_vm._v(_vm._s(_vm.firstTalkEvent.title) + " ")]), _vm._v(" "), _c('p', [_vm._v("\n                                                " + _vm._s(_vm.firstTalkEvent.longDescription) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("\n                                                " + _vm._s(_vm.getDateReference(_vm.firstTalkEvent.start_date, 'str')) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.firstTalkEvent.eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.firstTalkEvent.title)
      }
    }
  }, [_vm._v("\n                                                Add to Calendar\n                                                "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.firstTalkEvent.eventId))])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.firstTalkEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix>"
  }), _vm._v(" "), (_vm.showJoin(_vm.firstTalkEvent.eventId)) ? _c('button', {
    staticClass: "btn-pink",
    style: (_vm.styleObject),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent(_vm.firstTalkEvent)
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa 2x fa-arrow-circle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Go to Event ")]) : _vm._e()])])]) : _vm._e()])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "random"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "margin-top-40"
  }, [_c('div', {
    staticClass: "blog-section clearfix"
  }, [_c('div', {
    staticClass: "row random-section-head"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('svg', {
    attrs: {
      "width": "47px",
      "height": "48px",
      "viewBox": "0 0 47 48",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Work")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_Unauthenticated",
      "transform": "translate(-666.000000, -819.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-7",
      "transform": "translate(88.000000, 800.000000)"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Work",
      "transform": "translate(666.000000, 819.000000)",
      "fill": _vm.getCorpHeaderColor
    }
  }, [_c('path', {
    attrs: {
      "d": "M45.6944444,-1.62630326e-19 C34.1361,-1.62630326e-19 23.4467333,5.0007033 15.9565,13.1868132 L1.30555556,13.1868132 C0.777223333,13.1868132 0.301896667,13.5082444 0.0999533333,14.0007033 C-0.102000444,14.4931464 0.0101937778,15.0597626 0.383504333,15.4368527 L8.84924878,23.9877099 C7.97410878,25.934822 7.23772322,27.964378 6.66651656,30.0742154 C6.54208144,30.5316343 6.67059511,31.0199736 7.00310444,31.3537582 L15.9566044,40.3988571 C16.2054747,40.6502295 16.5379944,40.78416 16.8806767,40.78416 C16.9949128,40.78416 17.1111908,40.7697389 17.2254269,40.7367719 C19.3143158,40.1598224 21.3257069,39.4160334 23.2513491,38.5320949 L31.7170936,47.082951 C31.9659638,47.3384482 32.3005202,47.4723735 32.6391291,47.4723735 C32.8064021,47.4723735 32.9777589,47.4394064 33.1389114,47.3714099 C33.6264529,47.1674258 33.9447003,46.6873308 33.9447003,46.1536869 L33.9447003,31.3554462 C42.0495892,23.7893802 47.0002559,12.9930725 47.0002559,1.31852308 C47.0002559,0.589134066 46.4168292,-0.000158241758 45.6947003,-0.000158241758 L45.6944444,-1.62630326e-19 Z M17.2599667,37.9864615 L9.39216667,30.0395604 C12.5765211,19.1398681 20.3483889,10.4882637 30.2074222,6.00474725 L41.0576333,16.9619341 C36.6167078,26.9200879 28.0532556,34.7725714 17.2599667,37.9864615 Z M44.3664333,2.66004396 C44.2256788,6.70881758 43.4484711,10.6275165 42.12657,14.3098022 L32.8325811,4.92448352 C36.4759167,3.58934505 40.3578033,2.80225055 44.3663811,2.66004396 L44.3664333,2.66004396 Z M4.45716667,15.8241758 L13.7407111,15.8241758 C12.3719144,17.5982242 11.1438567,19.4958593 10.0749722,21.4987253 L4.45716667,15.8241758 Z M31.3333333,42.9705495 L25.7152667,37.296 C27.6980922,36.2142593 29.5748022,34.9739077 31.3333333,33.5934066 L31.3333333,42.9705495 Z",
      "id": "Fill-1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.30555556,47.4725275 C1.64010156,47.4725275 1.97462667,47.3447789 2.22962778,47.0872246 L7.45185,41.8124993 C7.96183133,41.2973908 7.96183133,40.4629081 7.45185,39.9477785 C6.94186867,39.4326699 6.11569222,39.4326699 5.60569,39.9477785 L0.383467778,45.2225037 C-0.126513556,45.7376123 -0.126513556,46.5720949 0.383467778,47.0872246 C0.636421778,47.3447789 0.970967778,47.4725275 1.30550333,47.4725275 L1.30555556,47.4725275 Z",
      "id": "Fill-2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.909,47.0874709 C7.16399067,47.3450252 7.49853667,47.4727738 7.83307222,47.4727738 C8.16760778,47.4727738 8.50214333,47.3450252 8.75714444,47.0874709 L12.6738111,43.1314286 C13.1837924,42.61632 13.1837924,41.7818374 12.6738111,41.2667077 C12.1638298,40.7515991 11.3376533,40.7515991 10.8276511,41.2667077 L6.91098444,45.2227501 C6.40100311,45.7358015 6.40100311,46.5723407 6.90894256,47.0874709 L6.909,47.0874709 Z",
      "id": "Fill-3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.30555556,40.8791209 C1.64010156,40.8791209 1.97462667,40.7513723 2.22962778,40.493818 L6.14629444,36.5377741 C6.65627578,36.0226655 6.65627578,35.1881829 6.14629444,34.6730532 C5.63631311,34.1579446 4.81013667,34.1579446 4.30013444,34.6730532 L0.383467778,38.6290971 C-0.126513556,39.1442057 -0.126513556,39.9786884 0.383467778,40.493818 C0.636421778,40.7513723 0.970967778,40.8791209 1.30550333,40.8791209 L1.30555556,40.8791209 Z",
      "id": "Fill-4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.1111111,14.5054945 C22.51065,14.5054945 19.5833333,17.4622418 19.5833333,21.0989011 C19.5833333,24.7355604 22.51065,27.6923077 26.1111111,27.6923077 C29.7115722,27.6923077 32.6388889,24.7355604 32.6388889,21.0989011 C32.6388889,17.4622418 29.7115722,14.5054945 26.1111111,14.5054945 Z M26.1111111,25.0549451 C23.9508344,25.0549451 22.1944444,23.2808967 22.1944444,21.0989011 C22.1944444,18.9169055 23.9508344,17.1428571 26.1111111,17.1428571 C28.2713878,17.1428571 30.0277778,18.9169055 30.0277778,21.0989011 C30.0277778,23.2808967 28.2713878,25.0549451 26.1111111,25.0549451 Z",
      "id": "Fill-5"
    }
  })])])])]), _vm._v(" "), _c('br'), _vm._v("WORK"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.getAuthWorkVideos) ? _c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthWorkVideos[0].mediaid + '/' + _vm.getAuthWorkVideos[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthWorkVideos[0].image,
      "alt": _vm.getAuthWorkVideos[0].title,
      "title": _vm.getAuthWorkVideos[0].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthWorkVideos[0].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthWorkVideos[0].mediaid, _vm.getAuthWorkVideos[0].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthWorkVideos[0].title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "workVideo1",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('workVideo1')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getAuthWorkVideos[0])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getAuthWorkVideos[0], playlist, _vm.verifyVideoExists(playlist, _vm.getAuthWorkVideos[0]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), (_vm.getAuthWorkVideos[0].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "added"
    }, [_vm._v("Added")])]) : _vm._e(), _vm._v(" "), (_vm.getAuthWorkVideos[0].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")])]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('workVideo1')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getAuthWorkVideos[0])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getAuthWorkVideos[0])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.getAuthWorkVideos) ? _c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthWorkVideos[1].mediaid + '/' + _vm.getAuthWorkVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthWorkVideos[1].image,
      "alt": _vm.getAuthWorkVideos[1].title,
      "title": _vm.getAuthWorkVideos[1].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthWorkVideos[1].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthWorkVideos[1].mediaid, _vm.getAuthWorkVideos[1].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthWorkVideos[1].title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "workVideo2",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('workVideo2')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getAuthWorkVideos[1])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getAuthWorkVideos[1], playlist, _vm.verifyVideoExists(playlist, _vm.getAuthWorkVideos[1]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), (_vm.getAuthWorkVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "added"
    }, [_vm._v("Added")])]) : _vm._e(), _vm._v(" "), (_vm.getAuthWorkVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")])]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('workVideo2')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getAuthWorkVideos[1])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getAuthWorkVideos[1])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40 watch-all"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/work'
      }
    }
  }, [_vm._v("\n                                                See  All  Work  "), _c('span', {
    staticClass: "fa fa-angle-double-right fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('svg', {
    attrs: {
      "width": "34px",
      "height": "47px",
      "viewBox": "0 0 34 47",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Page 1")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_Unauthenticated",
      "transform": "translate(-125.000000, -1270.000000)",
      "fill": _vm.getCorpHeaderColor
    }
  }, [_c('path', {
    attrs: {
      "d": "M131.268161,1315.78641 C130.977535,1315.78641 130.686929,1315.70766 130.426289,1315.54453 C129.798161,1315.15078 129.528161,1314.37453 129.775649,1313.67517 L136.398209,1294.97773 L127.583969,1294.97586 C127.028993,1294.97586 126.513329,1294.68524 126.226481,1294.20709 C125.939604,1293.73084 125.924604,1293.1402 126.18523,1292.64896 L137.24011,1271.84 C137.515735,1271.32251 138.051982,1271 138.638878,1271 L153.378238,1271 C153.97075,1271 154.512622,1271.33 154.786366,1271.85498 C155.058242,1272.38187 155.015114,1273.01374 154.671991,1273.49749 L145.384951,1286.60725 L157.062391,1286.60725 C157.701751,1286.60725 158.277367,1286.99162 158.524903,1287.58035 C158.770529,1288.17099 158.637406,1288.85158 158.187406,1289.30538 L132.393166,1315.31898 C132.08754,1315.62648 131.678782,1315.78585 131.268142,1315.78585 L131.268161,1315.78641 Z M130.218161,1291.80897 L138.638801,1291.80897 C139.152545,1291.80897 139.634417,1292.05834 139.932545,1292.47833 C140.228796,1292.89833 140.303796,1293.43646 140.131294,1293.9202 L135.121054,1308.0706 L153.261694,1289.77444 L142.322974,1289.77444 C141.730462,1289.77444 141.18859,1289.44444 140.916718,1288.91755 C140.644841,1288.39252 140.687969,1287.75878 141.031092,1287.27503 L150.316212,1274.16527 L139.591092,1274.16527 L130.218161,1291.80897 Z",
      "id": "Page-1",
      "stroke": "#FFFFFF",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-7-Copy",
      "transform": "translate(126.000000, 1315.000000)",
      "font-size": "30",
      "font-family": "Quicksand-Regular, Quicksand",
      "line-spacing": "60",
      "font-weight": "normal"
    }
  }, [_c('text', {
    attrs: {
      "id": "Inspiration"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "0",
      "y": "28"
    }
  }, [_vm._v("Inspiration")])])])])])]), _vm._v(" "), _c('br'), _vm._v("LIFE"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.getAuthLifeVideos) ? _c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthLifeVideos[0].mediaid + '/' + _vm.getAuthLifeVideos[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthLifeVideos[0].image,
      "alt": _vm.getAuthLifeVideos[0].title,
      "title": _vm.getAuthLifeVideos[0].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthLifeVideos[0].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthLifeVideos[0].mediaid, _vm.getAuthLifeVideos[0].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthLifeVideos[0].title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "lifeVideo1",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('lifeVideo1')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getAuthLifeVideos[0])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getAuthLifeVideos[0], playlist, _vm.verifyVideoExists(playlist, _vm.getAuthLifeVideos[0]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), (_vm.getAuthLifeVideos[0].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "added"
    }, [_vm._v("Added")])]) : _vm._e(), _vm._v(" "), (_vm.getAuthLifeVideos[0].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")])]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('lifeVideo1')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getAuthLifeVideos[0])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getAuthLifeVideos[0])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.getAuthLifeVideos) ? _c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthLifeVideos[1].mediaid + '/' + _vm.getAuthLifeVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthLifeVideos[1].image,
      "alt": _vm.getAuthLifeVideos[1].title,
      "title": _vm.getAuthLifeVideos[1].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthLifeVideos[1].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthLifeVideos[1].mediaid, _vm.getAuthLifeVideos[1].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthLifeVideos[1].title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "lifeVideo2",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('lifeVideo2')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getAuthLifeVideos[1])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getAuthLifeVideos[1], playlist, _vm.verifyVideoExists(playlist, _vm.getAuthLifeVideos[1]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), (_vm.getAuthLifeVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "added"
    }, [_vm._v("Added")])]) : _vm._e(), _vm._v(" "), (_vm.getAuthLifeVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")])]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('lifeVideo2')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getAuthLifeVideos[1])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getAuthLifeVideos[1])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40 watch-all"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/life'
      }
    }
  }, [_vm._v("\n                                                See  All  Life  "), _c('span', {
    staticClass: "fa fa-angle-double-right fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('svg', {
    attrs: {
      "width": "59px",
      "height": "49px",
      "viewBox": "0 0 59 49",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Page 1")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_Unauthenticated",
      "transform": "translate(-665.000000, -1737.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-7-Copy-2",
      "transform": "translate(88.000000, 1726.000000)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M720.393793,1779.55672 L720.248873,1779.68175 C715.432452,1783.90429 709.738162,1785.73139 704.609017,1784.72833 C699.982965,1783.81053 696.672699,1780.75588 693.478531,1777.80351 C690.014703,1774.60396 686.749756,1771.58336 681.933407,1771.06622 C677.116986,1770.54906 671.859885,1772.76828 667.705503,1777.21247 C669.319536,1779.4601 677.002852,1788.69794 689.528558,1781.06846 C689.863862,1780.92922 690.250312,1781.05993 690.432178,1781.3725 C690.616881,1781.68791 690.540158,1782.08858 690.256,1782.31308 C686.488104,1784.60333 683.098184,1785.47 680.137377,1785.47 C671.226296,1785.47 666.177169,1777.64134 666.111699,1777.53368 C665.938366,1777.25805 665.969624,1776.90286 666.185578,1776.66134 C670.717863,1771.5693 676.494789,1769.01454 682.035663,1769.61148 C687.332264,1770.17979 690.932195,1773.51009 694.402061,1776.72667 C697.587427,1779.63641 700.599445,1782.45806 704.824752,1783.27358 C709.510453,1784.20557 714.752788,1782.48934 719.214148,1778.55944 L719.387481,1778.41452 L719.390325,1778.41452 C719.95579,1777.95987 720.4985,1777.47395 721.012869,1776.95965 C718.830564,1771.81079 712.885963,1770.61729 711.700971,1770.41273 C709.538525,1771.73688 707.199966,1772.74845 704.753384,1773.41624 C704.688023,1773.42477 704.622671,1773.42477 704.557318,1773.41624 C704.364097,1773.44182 704.168024,1773.39067 704.014586,1773.27132 C703.858304,1773.15481 703.756004,1772.97864 703.730428,1772.78542 C703.676438,1772.38476 703.957751,1772.01535 704.361252,1771.96138 C711.774544,1769.85298 716.363933,1765.82932 718.023212,1760.01544 L718.020368,1760.01544 C718.710864,1757.52906 718.84157,1754.92055 718.406818,1752.37737 C708.347844,1751.34303 704.105442,1757.36146 703.479848,1758.34175 C702.920065,1762.26874 701.13838,1766.18423 698.154804,1770.03746 L698.154804,1770.0403 C697.901904,1770.33014 697.467153,1770.37276 697.163092,1770.13691 C696.859031,1769.90106 696.790849,1769.47199 697.00681,1769.15371 C699.916551,1765.55349 701.610092,1761.82844 702.113041,1758.08869 C702.323314,1756.53155 702.323314,1754.95447 702.113041,1753.39732 C701.152608,1746.12297 695.821891,1741.03092 694.213823,1739.64152 C685.803217,1747.42435 687.308862,1755.83277 689.090497,1760.34505 C689.749735,1761.44472 690.332228,1762.58984 690.838014,1763.76909 C691.036924,1764.1186 690.917581,1764.56476 690.56807,1764.76648 C690.218559,1764.96822 689.772402,1764.84604 689.570684,1764.49653 C688.925652,1763.47361 688.377254,1762.38813 687.933955,1761.26003 C685.314024,1756.82151 681.773452,1754.05958 677.371596,1753.03346 C675.11822,1752.51062 672.779661,1752.47652 670.5121,1752.93969 C668.409376,1759.30475 672.810941,1765.04494 672.853569,1765.10168 C673.10078,1765.41993 673.043953,1765.87741 672.728537,1766.1246 C672.410284,1766.36897 671.9528,1766.31214 671.705618,1765.99673 C671.495345,1765.72678 666.613571,1759.34753 669.267546,1752.0678 L669.267546,1752.06496 C669.34995,1751.84899 669.526127,1751.68703 669.74777,1751.62167 C672.799578,1750.91981 675.984944,1751.05621 678.968738,1752.01665 C681.949549,1752.97708 684.614872,1754.72751 686.683188,1757.07741 C685.680128,1751.88309 686.291057,1744.71102 693.718868,1738.1641 L693.716024,1738.1641 C693.985968,1737.9453 694.372418,1737.9453 694.64234,1738.1641 C694.969118,1738.36016 702.337149,1744.07167 703.573062,1753.22128 C703.689568,1754.11355 703.743558,1755.00859 703.735032,1755.90653 C705.968477,1753.55655 710.776387,1750.08705 719.16466,1751.11288 L719.161823,1751.11288 C719.457344,1751.14982 719.698874,1751.36294 719.772752,1751.64993 C719.772752,1751.78064 722.384099,1762.39415 713.416205,1769.32733 C715.976414,1769.98089 720.690557,1771.8364 722.565885,1776.8061 C722.79889,1777.38009 722.429491,1777.84611 720.392091,1779.55667 L720.393793,1779.55672 Z",
      "id": "Page-1",
      "stroke": _vm.getCorpHeaderColor,
      "fill": _vm.getCorpHeaderColor
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v("MIND BODY"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.getAuthMindbodyVideos) ? _c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthMindbodyVideos[0].mediaid + '/' + _vm.getAuthMindbodyVideos[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthMindbodyVideos[0].image,
      "alt": _vm.getAuthMindbodyVideos[0].title,
      "title": _vm.getAuthMindbodyVideos[0].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthMindbodyVideos[0].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthMindbodyVideos[0].mediaid, _vm.getAuthMindbodyVideos[0].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthMindbodyVideos[0].title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "mindbodyVideo1",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('mindbodyVideo1')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(13)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getAuthMindbodyVideos[0])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getAuthMindbodyVideos[0], playlist, _vm.verifyVideoExists(playlist, _vm.getAuthMindbodyVideos[0]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), (_vm.getAuthMindbodyVideos[0].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "added"
    }, [_vm._v("Added")])]) : _vm._e(), _vm._v(" "), (_vm.getAuthMindbodyVideos[0].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")])]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('mindbodyVideo1')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getAuthMindbodyVideos[0])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getAuthMindbodyVideos[0])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.getAuthMindbodyVideos) ? _c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthMindbodyVideos[1].mediaid + '/' + _vm.getAuthMindbodyVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthMindbodyVideos[1].image,
      "alt": _vm.getAuthMindbodyVideos[1].title,
      "title": _vm.getAuthMindbodyVideos[1].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthMindbodyVideos[1].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthMindbodyVideos[1].mediaid, _vm.getAuthMindbodyVideos[1].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthMindbodyVideos[1].title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "mindbodyVideo2",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('mindbodyVideo2')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(15)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getAuthMindbodyVideos[1])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getAuthMindbodyVideos[1], playlist, _vm.verifyVideoExists(playlist, _vm.getAuthMindbodyVideos[1]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), (_vm.getAuthMindbodyVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "added"
    }, [_vm._v("Added")])]) : _vm._e(), _vm._v(" "), (_vm.getAuthMindbodyVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")])]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('mindbodyVideo2')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getAuthMindbodyVideos[1])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getAuthMindbodyVideos[1])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40 watch-all"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/mindbody'
      }
    }
  }, [_vm._v("\n                                                See  All  Mind Body  "), _c('span', {
    staticClass: "fa fa-angle-double-right fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])])])])])])]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    attrs: {
      "effect": "zoom",
      "value": _vm.showModal,
      "width": "400"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentPlayerID
    }
  }, [_vm._v("Loading the player...")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(_vm.currentVideoDesc) ? _c('p', [_vm._v("\n                    " + _vm._s(_vm.currentVideoDesc) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('p', [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.quoteReference,
      "description": _vm.quoteReference,
      "title": _vm.quoteReference
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showCorporateImageShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateImageShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")])])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.shareEventSelected.img_url,
      "alt": _vm.shareEventSelected.title,
      "title": _vm.shareEventSelected.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.shareEventSelected.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.shareEventSelected.longDescription.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateImage()
      }
    }
  }, [_vm._v("\n                            Share This Event\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('strong', [_vm._v("Surprise!!")]), _vm._v(" We found new content for you")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-7 col-md-7 extra-small"
  }, [_c('h4', [_vm._v("\n                                                In the mood for "), _c('br'), _vm._v("\n                                                something else\n                                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("RECENTLY WATCHED")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "applicationdownload"
  }, [_c('img', {
    staticClass: "showmobile",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/app-image-resized-new.png",
      "alt": "DOWNLOAD TONE APP",
      "title": "Download TONE App"
    }
  }), _vm._v(" "), _c('h2', [_c('b', [_vm._v("Get TONE on your Phone with the TONE app")])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://apps.apple.com/us/app/tone-networks-advice-on-demand/id1444962883?ls=1"
    }
  }, [_c('img', {
    staticClass: "appbtn",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mobile-app-apple.png",
      "alt": "DOWNLOAD APPLE APP",
      "title": "Download App on IOS"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://play.google.com/store/apps/details?id=com.tonenetworks.toneapp"
    }
  }, [_c('img', {
    staticClass: "appbtn",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mobile-app-android.png",
      "alt": "DOWNLOAD ANDROID APP",
      "title": "Download App on Android"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("EVENTS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-331b4fd3", module.exports)
  }
}

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "tabs-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthInspirationVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.getAuthInspirationVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(video.mediaid)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(video.title))])])
  })], 2) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_c('br'), _vm._v(" "), _c('i', {
    staticClass: "nav-icon inspiration-pink-icon"
  }), _vm._v(" "), _c('br'), _c('span', [_vm._v("INSPIRATION")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "mostRecent"
  }, [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                                            most recent\n                                            "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Sort by")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33b9632b", module.exports)
  }
}

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "redeem_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "left-content"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true
    }
  }, [_c('panel', {
    staticClass: "text-left",
    attrs: {
      "is-open": true
    }
  }, [_c('h4', [_vm._v("Start your Trial. Setup your Account")]), _vm._v(" "), _c('div', {
    staticClass: "create-account"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onGifteeSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus"
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z '-]+$/,
      "id": "redeem_firstname",
      "type": "text",
      "error": "First Name (no digits allowed)",
      "placeholder": "First Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstName", $$v)
      },
      expression: "user.firstName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z '-]+$/,
      "id": "redeem_lastname",
      "type": "text",
      "error": "Last Name (no digits allowed)",
      "placeholder": "Last Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastName", $$v)
      },
      expression: "user.lastName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[\w\d.+-]+@[\w\d-]+\.[a-z]+$/i,
      "id": "redeem_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), _c('vue-password', {
    staticClass: "form-input",
    attrs: {
      "minlength": 6,
      "classes": "input form-control",
      "placeholder": "Password",
      "error": "Password",
      "id": "signup_password",
      "disableStrength": _vm.hidePasswordMeter,
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-info-circled alert-icon-float-left information"
  }, [_c('p', {
    staticClass: "alert alert-info alert-dismissable",
    class: {
      'set-error': !_vm.verifyPassword()
    },
    attrs: {
      "id": "redeem_pwderrormsg"
    }
  }, [_vm._v("Min 6 Chars, One Upper Case, One Lower Case!")])]), _vm._v(" "), _c('checkbox', {
    staticClass: "terms-and-condition",
    attrs: {
      "value": "isChecked",
      "type": "primary"
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n                                                         I agree to "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "_blank"
    }
  }, [_vm._v("terms and conditions")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "id": "redeem_button",
      "disabled": !_vm.isChecked || _vm.spinner || this.user.packageId === -1
    }
  }, [_vm._v("\n                                                        Complete Sign Up\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer hidemobile"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.defaultPlan.description))])])])])])])])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), _c('h2', [_vm._v("\n                                Welcome, Accenture & Partners\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "hidemobile"
  }, [_c('h2', [_vm._v("Your Plan")]), _c('p', [_vm._v("What You Get")])]), _vm._v(" "), _c('div', {
    staticClass: "showmobile"
  }, [_c('h2', [_vm._v("What You Get")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('li', [_vm._v("Personalized bite-sized expert\n                                            videos will inspire you and set a positive\n                                            TONE to your day")]), _vm._v(" "), _c('li', {
    staticClass: "hidemobile"
  }, [_vm._v("A little dose of humor, and a pinch\n                                            of inspiration each time you log on.")]), _vm._v(" "), _c('li', [_vm._v("Reserve your spot for TONE Live...\n                                            Exclusive live streaming events with our\n                                            credentialed experts.")]), _vm._v(" "), _c('li', [_vm._v("Tune in to TONE Talks...our moderated\n                                            discussions every Tuesday and Thursday night\n                                            where we share advice within our community\n                                            of women helping women!")]), _vm._v(" "), _c('li', [_vm._v("Most importantly, make time for you!")]), _vm._v(" "), _c('li', [_vm._v("Enjoy your trial!")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-36e0590c", module.exports)
  }
}

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "validate-content",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "col-md-12 bg-white"
  }, [_c('div', {
    staticClass: "main-content emailrules"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("\n                    Too many Emails? Let's change that!\n                ")]), _vm._v(" "), _c('h2', [_vm._v("Email Preferences")]), _vm._v(" "), _c('checkbox', {
    staticClass: "margin-left",
    attrs: {
      "value": _vm.userObj.isOptOutTeaser
    },
    model: {
      value: (_vm.userObj.isOptOutTeaser),
      callback: function($$v) {
        _vm.$set(_vm.userObj, "isOptOutTeaser", $$v)
      },
      expression: "userObj.isOptOutTeaser"
    }
  }, [_c('span', {
    staticClass: "checkboxcontent"
  }, [_c('span', [_c('strong', [_vm._v("Unsubscribe from TONE Teasers")])]), _c('span', {
    staticClass: "smpreferences"
  }, [_c('small', [_vm._v(" Twice a week email with videos selected specifically for you")])])])]), _vm._v(" "), _c('checkbox', {
    staticClass: "margin-left",
    attrs: {
      "value": _vm.userObj.isOptOutTakeaways
    },
    model: {
      value: (_vm.userObj.isOptOutTakeaways),
      callback: function($$v) {
        _vm.$set(_vm.userObj, "isOptOutTakeaways", $$v)
      },
      expression: "userObj.isOptOutTakeaways"
    }
  }, [_c('span', {
    staticClass: "checkboxcontent"
  }, [_c('span', [_c('strong', [_vm._v("Unsubscribe from TONE Takeaways")])]), _c('span', {
    staticClass: "smpreferences"
  }, [_c('small', [_vm._v(" Follow up email with key lessons once you have watched a video")])])])]), _vm._v(" "), _c('checkbox', {
    staticClass: "margin-left",
    attrs: {
      "value": _vm.userObj.isOptOutContentEmail
    },
    model: {
      value: (_vm.userObj.isOptOutContentEmail),
      callback: function($$v) {
        _vm.$set(_vm.userObj, "isOptOutContentEmail", $$v)
      },
      expression: "userObj.isOptOutContentEmail"
    }
  }, [_c('span', {
    staticClass: "checkboxcontent"
  }, [_c('span', [_c('strong', [_vm._v("Unsubscribe from Content Emails")])]), _c('span', {
    staticClass: "smpreferences"
  }, [_c('small', [_vm._v(" Event reminders, calendar invites, series launches and video blogs")])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "disabled": _vm.spinner
    },
    on: {
      "click": function($event) {
        return _vm.updatePrefrences()
      }
    }
  }, [_vm._v("\n                    Update Preferences\n                    "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3710880a", module.exports)
  }
}

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "liveEventContent"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "liveEvent"
  }, [_c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Hey, " + _vm._s(_vm.user.firstName) + ". Great to see you. Welcome to TONE Live!")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.jwEventRef,
      "frameborder": "0",
      "scrolling": "auto",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "100%",
      "height": "220",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "allowtransparency": "true",
      "src": _vm.chatRollURL
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "attendees"
  }, [_c('div', {
    staticClass: "attendeesContent"
  }, [_c('h2', [_vm._v("attendees")]), _vm._v(" "), _c('div', {
    staticClass: "liveEventImage"
  }, [(_vm.eventUsersArray) ? _c('div', {
    staticClass: "slider responsive-slick-slider-live"
  }, [_c('div', {
    staticClass: "sliderBox",
    attrs: {
      "*v-for": "userList in eventUsersArray"
    }
  }, [(_vm.userList[0]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[0]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[0].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[0].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[0].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[0].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[0].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[0].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[0].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[1]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[1]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[1].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[1].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[1].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[1].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[1].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[1].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[1].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[2]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[2]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[2].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[2].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[2].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[2].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[2].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[2].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[2].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[3]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[3]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[3].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[3].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[3].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[3].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[3].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[3].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[3].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[4]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[4]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[4].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[4].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[4].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[4].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[4].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[4].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[4].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[5]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[5]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[5].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[5].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[5].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[5].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[5].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[5].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[5].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[6]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[6]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[6].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[6].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[6].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[6].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[6].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[6].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[6].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[7]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[7]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[7].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[7].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[7].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[7].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[7].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[7].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[7].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[8]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[8]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[8].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[8].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[8].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[8].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[8].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[8].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[8].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[9]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[9]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[9].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[9].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[9].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[9].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[9].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[9].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[9].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[10]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[10]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[10].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[10].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[10].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[10].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[10].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[10].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[10].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[11]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[11]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[11].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[11].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[11].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[11].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[11].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[11].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[11].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[12]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[12]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[12].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[12].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[12].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[12].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[12].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[12].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[12].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[13]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[13]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[13].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[13].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[13].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[13].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[13].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[13].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[13].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e(), _vm._v(" "), (_vm.userList[14]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('div', [(_vm.userList[14]) ? _c('div', {
    staticClass: "liveImage"
  }, [(_vm.userList[14].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[14].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png",
      "alt": "USER-PROFILE",
      "title": "Incognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Incognito")])])]) : _vm._e()]) : _c('div', [(_vm.userList[14].isAnonymous === '0') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[14].picture,
      "alt": "USER-SHOE",
      "title": _vm.userList[14].firstName
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userList[14].firstName))])]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.userList[14].picture,
      "alt": "USER-SHOE",
      "title": "Shoe-cognito"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])])]) : _vm._e()])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "aboutExpert"
  }, [_c('p', [_vm._v("\n                        " + _vm._s(_vm.getSelectedEvent[0].longDescription) + "\n                    ")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37fd3ce2", module.exports)
  }
}

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper fixgraybgpl"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.videoSqueeze),
      expression: "!videoSqueeze"
    }],
    staticClass: "video-player-background",
    class: {
      'animated zoomOutLeft': _vm.videoCompleted
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "video-player",
    on: {
      "mouseleave": function($event) {
        _vm.addRightHoverWidthClass ? _vm.resetClass(true) : _vm.resetClass(false)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideLeftVideoIcons),
      expression: "!hideLeftVideoIcons"
    }],
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.currentVideo) ? _c('div', {
    staticClass: "reset-video-width",
    class: {
      'enjoy-hover': _vm.addEnjoyHoverClass
    }
  }, [_c('jwplayer', {
    attrs: {
      "id": "mainVideoPlayer",
      "data": _vm.currentVideo,
      "on-complete": _vm.onVideoComplete
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e()]), _vm._v(" "), (_vm.playlistVideos) ? _c('div', {
    staticClass: "playlistholderdiv"
  }, [(_vm.playlistVideos) ? _c('h4', [_vm._v(" " + _vm._s(_vm.playlistVideos.title))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.videoIndex) + " of " + _vm._s(_vm.playlistVideos.length) + ")")]), _vm._v(" "), _vm._l((_vm.playlistVideos), function(item) {
    return (_vm.playlistVideos) ? _c('div', [_c('div', {
      staticClass: "playlistentrydiv",
      class: {
        'playing': item.videoCode === _vm.$route.params.videoCode, 'gray': !_vm.user && _vm.getVideoIndex(_vm.playlistVideos, item.videoCode) > 3
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.thumbnailURL,
        "alt": item.videoTitle,
        "title": item.videoTitle
      },
      on: {
        "click": function($event) {
          return _vm.playVideo(item.userPlaylistId, item.videoCode)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.playVideo(item.userPlaylistId, item.videoCode)
        }
      }
    }, [_vm._v(_vm._s(item.videoTitle))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.user && _vm.getUserSharedPlaylists[0] && _vm.getUserSharedPlaylists[0].userPlaylistType === 1) ? _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.copyPlaylist(_vm.$route.params.playlistId, _vm.user.userId)
      }
    }
  }, [_vm._v("\n                        Add to Playlists\n                    ")]) : _vm._e()], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "player-content"
  }, [(_vm.currentVideo) ? _c('h4', [_vm._v(_vm._s(_vm.currentVideo.title) + " (Playing " + _vm._s(_vm.videoIndex) + " of " + _vm._s(_vm.playlistVideos.length) + ")")]) : _vm._e(), _vm._v(" "), (_vm.currentVideo) ? _c('p', [_vm._v("\n                        " + _vm._s(_vm.currentVideo.Description) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.getExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.getExpert[0].expertId + '/' + _vm.getExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": _vm.getExpert[0].name,
      "title": _vm.getExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.getExpert && _vm.getExpert[0].areasofexpertise) + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "recently-watched"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthRecommendedVideos && _vm.user) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.recommendationList), function(reccentVideo) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": reccentVideo.image,
        "title": reccentVideo.title,
        "alt": reccentVideo.title
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(reccentVideo.mediaid, reccentVideo.title)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(reccentVideo.title) + "\n                                    ")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    on: {
      "click": function($event) {
        return _vm.redirectToRelatedVideos()
      }
    }
  }, [_vm._v("View All Your Videos")])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("RELATED VIDEOS")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38b18f5a", module.exports)
  }
}

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper profile",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container "
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("FAQ")])])]), _vm._v(" "), _vm._l((_vm.allFAQ), function(section) {
    return (_vm.allFAQ) ? _c('div', {
      staticClass: "col-md-12 text-left"
    }, [_c('legend', {
      style: ({
        color: _vm.getCorpHeadingColor
      })
    }, [_vm._v(_vm._s(section.headerName))]), _vm._v(" "), _vm._l((section.lstFaqs), function(faq) {
      return _c('div', [_c('p', [_c('strong', {
        domProps: {
          "innerHTML": _vm._s(faq.question)
        }
      })]), _vm._v(" "), _c('p', {
        domProps: {
          "innerHTML": _vm._s(faq.response)
        }
      }), _vm._v(" "), (faq.faqVideoUrl) ? _c('p', [_c('a', {
        attrs: {
          "target": "new",
          "href": faq.faqVideoUrl
        }
      }, [_vm._v("Learn More")])]) : _vm._e(), _vm._v(" "), (faq.faqImageUrl) ? _c('p', [_c('img', {
        attrs: {
          "src": faq.faqImageUrl
        }
      })]) : _vm._e(), _vm._v(" "), _c('br')])
    })], 2) : _vm._e()
  })], 2)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38c57b52", module.exports)
  }
}

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp bodyfont-unauth"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), _c('h2', [_vm._v("\n                                    Welcome to TONE.\n                                    "), _c('br'), (!_vm.codeRedeemed && !_vm.isFreePreviewEnabled && _vm.showPlanForm && _vm.paidServiceFlag) ? _c('span', [_vm._v("You won't be charged until after your free trial. Easy online cancellation.")]) : _vm._e()])]), _vm._v(" "), (_vm.paidServiceFlag && _vm.freeServiceFlag) ? _c('div', {
    staticClass: "choice-holder"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "innerpart"
  }, [_vm._v("\n                                            Start Your " + _vm._s(_vm.getTotalTrialDays) + " Day Free Trial\n                                            "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    class: {
      'active': _vm.applyActiveClass('trial')
    },
    on: {
      "click": function($event) {
        return _vm.togglePlanView('trial')
      }
    }
  }, [_vm._v("\n                                                Try Now\n                                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "innerpart"
  }, [_vm._v("\n                                            Become a Member Today\n                                            "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    class: {
      'active': _vm.applyActiveClass('buy')
    },
    on: {
      "click": function($event) {
        return _vm.togglePlanView('buy')
      }
    }
  }, [_vm._v("\n                                                Buy Now\n                                            ")])])])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [(_vm.showPlanForm) ? _c('div', {
    staticClass: "left-content"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true
    }
  }, [_c('panel', {
    staticClass: "text-left",
    attrs: {
      "is-open": true
    }
  }, [(!_vm.isFreePreviewEnabled && _vm.showPlanForm && !_vm.freeServiceFlag) ? _c('h4', {
    staticClass: "hidemobile"
  }, [_vm._v("Start your " + _vm._s(_vm.defaultPlan.type) + " "), (!_vm.codeRedeemed) ? _c('span', [_vm._v("trial")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isFreePreviewEnabled && _vm.showPlanForm && !_vm.freeServiceFlag) ? _c('h4', {
    staticClass: "showmobile"
  }, [_vm._v(_vm._s(_vm.defaultPlan.description))]) : _vm._e(), _vm._v(" "), (_vm.showPlanForm && _vm.implementFreePlan && _vm.freeServiceFlag && !_vm.paidServiceFlag) ? _c('h4', [_vm._v("Start Your " + _vm._s(_vm.getTotalTrialDays) + " Day Free Trial")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "create-account"
  }, [(!_vm.isFreePreviewEnabled && _vm.showPlanForm) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "action": "/charge",
      "method": "post",
      "id": "payment-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onPaymentSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus"
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z '-]+$/,
      "name": "firstname",
      "id": "signup_firstname",
      "type": "text",
      "error": "First Name (no digits allowed)",
      "placeholder": "First Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstName", $$v)
      },
      expression: "user.firstName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z '-]+$/,
      "id": "signup_lastname",
      "type": "text",
      "error": "Last Name (no digits allowed)",
      "placeholder": "Last Name",
      "name": "lastname",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastName", $$v)
      },
      expression: "user.lastName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": _vm.emailPattern,
      "id": "signup_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "name": "email",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), _c('vue-password', {
    attrs: {
      "minlength": 6,
      "classes": "input form-control",
      "placeholder": "Password",
      "error": "Password",
      "id": "signup_password",
      "required": "",
      "name": "password",
      "disableStrength": _vm.hidePasswordMeter,
      "icon": ""
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-info-circled alert-icon-float-left information password-error"
  }, [_c('p', {
    staticClass: "alert alert-info alert-dismissable password-error-color",
    class: {
      'set-error': !_vm.verifyPassword()
    },
    attrs: {
      "id": "signup_pwderrormsg"
    }
  }, [_vm._v("Min 6 Chars, One Upper Case, One Lower Case!")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (!_vm.codeRedeemed && !_vm.implementFreePlan) ? _c('h3', [_vm._v("Become a Member now")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (!_vm.codeRedeemed && !_vm.implementFreePlan) ? _c('div', {
    staticClass: "checkboxholder"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Two Year Plan")]), _vm._v(" "), _c('span', {
    staticClass: "plan-price"
  }, [_vm._v("$8.99"), _c('span', {
    staticClass: "permonth"
  }, [_vm._v("per month")])]), _vm._v(" "), (_vm.twoYearPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "type": "radio",
      "id": "2yearplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.twoYearPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.twoYearPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.twoYearPlan.packageId
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "footertext"
  }, [_vm._v("$" + _vm._s(_vm.twoYearPlan.amount) + " billed once")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "radio popular"
  }, [_c('label', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("One Year Plan")]), _vm._v(" "), _c('span', {
    staticClass: "plan-price"
  }, [_vm._v("$9.50 "), _c('span', {
    staticClass: "permonth"
  }, [_vm._v("per month")])]), _vm._v(" "), (_vm.annualPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "type": "radio",
      "id": "annualplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.annualPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.annualPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.annualPlan.packageId
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "footertext"
  }, [_vm._v("$" + _vm._s(_vm.annualPlan.amount) + " billed annually")])])])]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Monthly Plan")]), _vm._v(" "), _c('span', {
    staticClass: "plan-price"
  }, [_vm._v("$" + _vm._s(_vm.defaultPlan.amount) + " "), _c('span', {
    staticClass: "permonth"
  }, [_vm._v("per month")])]), _vm._v(" "), (_vm.defaultPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "type": "radio",
      "id": "monthlyplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.defaultPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.defaultPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.defaultPlan.packageId
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "footertext"
  }, [_vm._v("billed monthly")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (!_vm.codeRedeemed && !_vm.implementFreePlan) ? _c('div', {
    staticClass: "codediv"
  }, [_c('div', {
    staticClass: "radiowrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gateway),
      expression: "gateway"
    }],
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "CC",
      "name": "paymentMethod"
    },
    domProps: {
      "checked": _vm._q(_vm.gateway, "CC")
    },
    on: {
      "change": function($event) {
        _vm.gateway = "CC"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v("Credit Card")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gateway),
      expression: "gateway"
    }],
    attrs: {
      "type": "radio",
      "id": "two",
      "value": "paypal",
      "name": "paymentMethod"
    },
    domProps: {
      "checked": _vm._q(_vm.gateway, "paypal")
    },
    on: {
      "change": function($event) {
        _vm.gateway = "paypal"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "two"
    }
  }, [_vm._v("Paypal")])]), _vm._v(" "), (_vm.gateway === 'CC') ? _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "paymentMethod_cardHolder",
      "pattern": /^[A-Za-z ]+$/,
      "type": "text",
      "error": "Card Holder Name (no digits allowed)",
      "placeholder": "Card Holder Name",
      "required": "",
      "name": "cardholdername",
      "icon": ""
    },
    model: {
      value: (_vm.user.cardHolderName),
      callback: function($$v) {
        _vm.$set(_vm.user, "cardHolderName", $$v)
      },
      expression: "user.cardHolderName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.gateway === 'CC') ? _c('div', {
    staticClass: "stripeholder"
  }, [(_vm.gateway === 'CC') ? _c('i', {
    staticClass: "fa fa-lock overlapstripe"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field",
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), (_vm.stripeErrorMessage) ? _c('div', {
    staticStyle: {
      "color": "#a94442",
      "margin": "2px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.stripeErrorMessage))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.gateway === 'paypal') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "text-center margin-top-10 margin-bottom-10",
    attrs: {
      "id": "paypal-button"
    }
  })]), _vm._v(" "), (_vm.userPayments.paymentMethodNonce) ? _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left success"
  }, [_c('p', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Payment successfully authorized")])])]) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row code"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [(!_vm.codeRedeemed && !_vm.implementFreePlan) ? _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "Gift Code",
      "name": "giftcode",
      "icon": ""
    },
    model: {
      value: (_vm.giftCode),
      callback: function($$v) {
        _vm.giftCode = $$v
      },
      expression: "giftCode"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(!_vm.codeRedeemed && !_vm.implementFreePlan) ? _c('button', {
    staticClass: "redeem btn formButton btn-block",
    attrs: {
      "name": "redeembutton",
      "type": "button",
      "disabled": _vm.giftCode.length === 0 || _vm.spinner
    },
    on: {
      "click": _vm.redeemCode
    }
  }, [_vm._v("\n                                                                        Redeem Your Gift\n                                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('checkbox', {
    staticClass: "terms-and-condition",
    attrs: {
      "value": "isChecked",
      "type": "primary",
      "id": "signuptermsconditionschckbox"
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n                                                                 I agree to "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "_blank",
      "rel": "opener"
    }
  }, [_vm._v("terms and conditions")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "id": "signup_button",
      "disabled": !_vm.isChecked || _vm.spinner,
      "name": "completesignupbutton"
    }
  }, [_vm._v("\n                                                                Complete Sign Up\n                                                                "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])])])])])], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, [(_vm.dynamic_bullet_1) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_2) ? _c('li', {
    staticClass: "hidemobile",
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_3) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_3)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_4) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_4)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_5) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_5)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_6) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_6)
    }
  }) : _vm._e()])])])])])])])])]), _vm._v(" "), (_vm.showResetModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showResetModal,
      "width": "200"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelResetModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelResetModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h2', {
    staticClass: "forgot-heading"
  }, [_vm._v("\n                        That Account Exists!\n                    ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("You have an account with Tone Networks. Please try logging in or resetting your password.")])]), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-transparent",
    on: {
      "click": _vm.SetupLogin
    }
  }, [_vm._v("\n                        Sign In\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-transparent",
    on: {
      "click": _vm.onSubmitForgetRequest
    }
  }, [_vm._v("\n                        Reset Password\n                    ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "hidemobile"
  }, [_c('h2', [_vm._v("Your Plan")]), _c('p', [_vm._v("What You Get")])]), _vm._v(" "), _c('div', {
    staticClass: "showmobile"
  }, [_c('h2', [_vm._v("What You Get")])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a123387", module.exports)
  }
}

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper fixgraybgpl"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.videoSqueeze),
      expression: "!videoSqueeze"
    }],
    staticClass: "video-player-background",
    class: {
      'animated zoomOutLeft': _vm.videoCompleted
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "video-player",
    on: {
      "mouseleave": function($event) {
        _vm.addRightHoverWidthClass ? _vm.resetClass(true) : _vm.resetClass(false)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideLeftVideoIcons),
      expression: "!hideLeftVideoIcons"
    }],
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.getCorpNewPlaylistObject) ? _c('div', {
    staticClass: "reset-video-width",
    class: {
      'enjoy-hover': _vm.addEnjoyHoverClass
    }
  }, [_c('jwplaylist', {
    attrs: {
      "data": _vm.getCorpNewPlaylistObject,
      "on-playlistitem": _vm.videoChangedInPlaylist()
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.playlistVideos) ? _c('div', {
    staticClass: "playlistholderdiv"
  }, [_c('h4', [_vm._v(_vm._s(_vm.playlistVideos.title))]), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.videoIndex) + " of " + _vm._s(_vm.playlistVideos.userPlaylistVideos.length) + ")")]), _vm._v(" "), _c('div', _vm._l((_vm.getCorpNewPlaylistObject), function(item) {
    return (_vm.getCorpNewPlaylistObject && _vm.getItemChangeInPlaylist) ? _c('div', [_c('div', {
      staticClass: "playlistentrydiv",
      class: {
        'playing': item.videoCode === _vm.getItemChangeInPlaylist.item.videoCode
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.image,
        "alt": item.title,
        "title": item.title
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])]) : _vm._e()
  }), 0)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "player-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.currentVideo.Description) + "\n                    ")]), _vm._v(" "), (_vm.getExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.getExpert[0].expertId + '/' + _vm.getExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.getExpert && _vm.getExpert[0].areasofexpertise) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-3"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    style: ([_vm.viewTranscript ? {
      color: '#FFFFFF !important',
      backgroundColor: this.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      outline: 'none !important'
    } : {
      color: _vm.getCorpButtonColor + ' !important',
      backgroundColor: '#FFFFFF !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      outline: 'none !important'
    }]),
    on: {
      "click": _vm.toggleViewTranscript
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.viewTranscript),
      expression: "!viewTranscript"
    }]
  }, [_vm._v("View Transcript")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewTranscript),
      expression: "viewTranscript"
    }]
  }, [_vm._v("Hide Transcript")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8 col-lg-9"
  }, [(_vm.getCurrentVideoTranscript) ? _c('div', {
    staticClass: "side-content",
    style: ({
      'border-left-color': this.getCorpHeaderColor + ' !important'
    })
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewTranscript),
      expression: "viewTranscript"
    }],
    staticClass: "boxes",
    class: {
      'animated fadeIn': _vm.viewTranscript, 'animated fadeOut': !_vm.viewTranscript
    }
  }, [_c('pre', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentVideoTranscript.vtt_file)
    }
  }, [_vm._v("\n                                    ")])])])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "recently-watched"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthRecommendedVideos) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.recommendationList), function(reccentVideo) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": reccentVideo.image
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(reccentVideo.mediaid, reccentVideo.title)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(reccentVideo.title) + "\n                                    ")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    style: (_vm.styleObject),
    on: {
      "click": function($event) {
        return _vm.redirectToRelatedVideos()
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_vm._v("View All Your Videos")])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("RELATED VIDEOS")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-420f1dc1", module.exports)
  }
}

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "un-auth-wrappers"
  }, [_c('div', {
    class: {
      'closed': _vm.menuClosed
    }
  }, [_c('span', {
    staticClass: "openarrow",
    on: {
      "click": _vm.toggleShareMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-chevron-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "closearrow",
    on: {
      "click": _vm.toggleShareMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-chevron-right"
  })]), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.metaTag_fb_title,
      "description": _vm.metaTag_fb_title,
      "title": _vm.metaTag_fb_title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "unauth-share-options"
          }, [_c('network', {
            staticClass: "holder",
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), (_vm.heroImage1 && !_vm.showCorporateLiveStreaming()) ? _c('div', {
    staticClass: "slider responsive-slick-slider-top topcarosal"
  }, [_c('div', {
    staticClass: "slide-player"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.heroImage1,
      "alt": "TOP IMAGE 1"
    }
  }), _vm._v(" "), _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_1)
    }
  }), _vm._v(" "), (!_vm.isNativeApp) ? _c('div', {
    staticClass: "buttonholderbanner"
  }, [(_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e(), _vm._v(" "), (!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "home-pink-button",
    on: {
      "click": function($event) {
        return _vm.openTone4GoodLink()
      }
    }
  }, [_vm._v("Find Out More")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.showGiftingLinks) ? _c('i', {
    staticClass: "fa fa-gift"
  }) : _vm._e(), _vm._v(" "), (_vm.showGiftingLinks) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/gifts')
      }
    }
  }, [_c('strong', [_vm._v("GIVE THE GIFT OF TONE")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "slide-player"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.heroImage2,
      "alt": "TOP IMAGE 2"
    }
  }), _vm._v(" "), _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_2)
    }
  }), _vm._v(" "), (!_vm.isNativeApp) ? _c('div', {
    staticClass: "buttonholderbanner"
  }, [(!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "home-pink-button",
    on: {
      "click": function($event) {
        return _vm.openTone4GoodLink()
      }
    }
  }, [_vm._v("Find Out More")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.showGiftingLinks) ? _c('i', {
    staticClass: "fa fa-gift"
  }) : _vm._e(), _vm._v(" "), (_vm.showGiftingLinks) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/gifts')
      }
    }
  }, [_c('strong', [_vm._v("GIVE THE GIFT OF TONE")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "slide-player"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.heroImage3,
      "alt": "TOP IMAGE 3"
    }
  }), _vm._v(" "), _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_3)
    }
  }), _vm._v(" "), (!_vm.isNativeApp) ? _c('div', {
    staticClass: "buttonholderbanner"
  }, [(!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "home-pink-button",
    on: {
      "click": function($event) {
        return _vm.openTone4GoodLink()
      }
    }
  }, [_vm._v("Find Out More")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.showGiftingLinks) ? _c('i', {
    staticClass: "fa fa-gift"
  }) : _vm._e(), _vm._v(" "), (_vm.showGiftingLinks) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/gifts')
      }
    }
  }, [_c('strong', [_vm._v("GIVE THE GIFT OF TONE")])]) : _vm._e()]) : _vm._e()])]) : _c('div', [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8 livestreaming"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.liveEventURL,
      "width": "100%",
      "height": "350px",
      "frameborder": "0",
      "scrolling": "auto",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_12)
    }
  }), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_13)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('section', {
    staticClass: "videoSections"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "tabs hide-mobile"
  }, [_c('ul', [_c('li', {
    staticClass: "videoList",
    on: {
      "click": function($event) {
        return _vm.$router.push('/content/work')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("WORK")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    on: {
      "click": function($event) {
        return _vm.$router.push('/content/life')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("LIFE")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    on: {
      "click": function($event) {
        return _vm.$router.push('/content/mindbody')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("MINDBODY")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    on: {
      "click": function($event) {
        return _vm.$router.push('/content/money')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("MONEY")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_4)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedRoute),
      expression: "selectedRoute"
    }],
    staticClass: "show-mobile routeselect",
    style: ({
      'background-color': _vm.getCorpHeaderColor + ' !important'
    }),
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedRoute = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "name": "workOption",
      "value": "work",
      "selected": ""
    }
  }, [_vm._v("WORK")]), _vm._v(" "), _c('option', {
    attrs: {
      "name": "lifeOption",
      "value": "life"
    }
  }, [_vm._v("LIFE")]), _vm._v(" "), _c('option', {
    attrs: {
      "name": "mindbodyOption",
      "value": "mindbody"
    }
  }, [_vm._v("MINDBODY")]), _vm._v(" "), _c('option', {
    attrs: {
      "name": "moneyOption",
      "value": "money"
    }
  }, [_vm._v("MONEY")])])]), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-slider  hide-mobile"
  }, [_c('div', {
    staticClass: "tabContent",
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {
    staticClass: "row video-row"
  }, _vm._l((_vm.workVideos), function(work) {
    return _c('div', {
      staticClass: "col-xs-6 col-sm-6 col-md-3 slide-player"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + work.mediaid + '/' + work.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": work.image,
        "alt": "WORK SECTION",
        "title": work.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title"
    }, [_vm._v(_vm._s(work.title))])]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(work.mediaid),
        "media": _vm.returnShareURL(work.mediaid),
        "quote": work.title,
        "description": work.Description,
        "title": work.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    attrs: {
      "id": "tabs-2"
    }
  }, [_c('div', {
    staticClass: "row video-row"
  }, _vm._l((_vm.lifeVideos), function(life) {
    return _c('div', {
      staticClass: "col-xs-6 col-sm-6 col-md-3 slide-player"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + life.mediaid + '/' + life.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": life.image,
        "alt": "LIFE SECTION",
        "title": life.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title"
    }, [_vm._v(_vm._s(life.title))])]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(life.mediaid),
        "media": _vm.returnShareURL(life.mediaid),
        "quote": life.title,
        "description": life.Description,
        "title": life.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    attrs: {
      "id": "tabs-3"
    }
  }, [_c('div', {
    staticClass: "row video-row"
  }, _vm._l((_vm.mindbodyVideos), function(mb) {
    return _c('div', {
      staticClass: "col-xs-6 col-sm-6 col-md-3 slide-player"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + mb.mediaid + '/' + mb.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": mb.image,
        "alt": "MINDBODY SECTION",
        "title": mb.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title"
    }, [_vm._v(_vm._s(mb.title))])]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(mb.mediaid),
        "media": _vm.returnShareURL(mb.mediaid),
        "quote": mb.title,
        "description": mb.Description,
        "title": mb.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    attrs: {
      "id": "tabs-4"
    }
  }, [_c('div', {
    staticClass: "row video-row"
  }, _vm._l((_vm.moneyVideos), function(money) {
    return _c('div', {
      staticClass: "col-xs-6 col-sm-6 col-md-3 slide-player"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + money.mediaid + '/' + money.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": money.image,
        "alt": "MONEY SECTION",
        "title": money.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title"
    }, [_vm._v(_vm._s(money.title))])]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(money.mediaid),
        "media": _vm.returnShareURL(money.mediaid),
        "quote": money.title,
        "description": money.Description,
        "title": money.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row mobilevideotabs show-mobile"
  }, [_vm._l((_vm.workVideos), function(work) {
    return (_vm.selectedRoute === 'work') ? _c('div', {
      staticClass: "col-xs-6 smedia"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": work.image,
        "alt": "WORK SECTION",
        "title": work.title
      },
      on: {
        "click": function($event) {
          return _vm.openModal(work)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title",
      on: {
        "click": function($event) {
          return _vm.openModal(work)
        }
      }
    }, [_vm._v(_vm._s(work.title))]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(work.mediaid),
        "media": _vm.returnShareURL(work.mediaid),
        "quote": work.title,
        "description": work.Description,
        "title": work.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.lifeVideos), function(life) {
    return (_vm.selectedRoute === 'life') ? _c('div', {
      staticClass: "col-xs-6"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": life.image,
        "alt": "LIFE SECTION",
        "title": life.title
      },
      on: {
        "click": function($event) {
          return _vm.openModal(life)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title",
      on: {
        "click": function($event) {
          return _vm.openModal(life)
        }
      }
    }, [_vm._v(_vm._s(life.title))]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(life.mediaid),
        "media": _vm.returnShareURL(life.mediaid),
        "quote": life.title,
        "description": life.Description,
        "title": life.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.mindbodyVideos), function(mb) {
    return (_vm.selectedRoute === 'mindbody') ? _c('div', {
      staticClass: "col-xs-6"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": mb.image,
        "alt": "MINDBODY SECTION",
        "title": mb.title
      },
      on: {
        "click": function($event) {
          return _vm.openModal(mb)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title",
      on: {
        "click": function($event) {
          return _vm.openModal(mb)
        }
      }
    }, [_vm._v(_vm._s(mb.title))]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(mb.mediaid),
        "media": _vm.returnShareURL(mb.mediaid),
        "quote": mb.title,
        "description": mb.Description,
        "title": mb.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.moneyVideos), function(money) {
    return (_vm.selectedRoute === 'money') ? _c('div', {
      staticClass: "col-xs-6"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": money.image,
        "alt": "MONEY SECTION",
        "title": money.title
      },
      on: {
        "click": function($event) {
          return _vm.openModal(money)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title",
      on: {
        "click": function($event) {
          return _vm.openModal(money)
        }
      }
    }, [_vm._v(_vm._s(money.title))]), _vm._v(" "), _c('social-sharing', {
      attrs: {
        "url": _vm.returnShareURL(money.mediaid),
        "media": _vm.returnShareURL(money.mediaid),
        "quote": money.title,
        "description": money.Description,
        "title": money.title
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('network', {
              attrs: {
                "network": "facebook"
              }
            }, [_c('i', {
              staticClass: "fa fa-facebook cursor"
            })]), _vm._v(" "), _c('network', {
              attrs: {
                "network": "twitter"
              }
            }, [_c('i', {
              staticClass: "fa fa-twitter cursor"
            })]), _vm._v(" "), _c('network', {
              staticClass: "holder",
              attrs: {
                "network": "email"
              }
            }, [_c('i', {
              staticClass: "fa fa-envelope cursor"
            })])], 1)
          
        },
        staticRenderFns: []
      }
    })], 1) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()])]), _vm._v(" "), (_vm.getAllExperts) ? _c('section', {
    staticClass: "extertcontainer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.getAllExperts), function(expert) {
    return (expert.unauth_title && expert.small_image_bw) ? _c('div', {
      staticClass: "col-sm-2 col-xs-6"
    }, [_c('a', {
      style: ({
        color: _vm.getCorpHeaderColor + ' !important'
      }),
      attrs: {
        "href": '/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      attrs: {
        "src": expert.small_image_bw,
        "alt": expert.unauth_title,
        "title": expert.unauth_title
      }
    }), _vm._v("\n                            " + _vm._s(expert.unauth_title) + "\n                             ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_5)
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.$router.push('/experts')
      }
    }
  }, [_vm._v("\n                        Meet our Experts\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getServicePodcast) ? _c('div', [_c('section', {
    staticClass: "radiosection",
    style: ({
      backgroundColor: _vm.podcastBgColor
    })
  }, [_c('h2', {
    staticClass: "text-center",
    style: ({
      color: '#ffffff',
      fontWeight: 'bold',
      'font-size': '2em'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.podcastHeadingLine1)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "text-center",
    style: ({
      color: '#ffffff',
      fontWeight: 'bold',
      'font-size': '1.75em'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.podcastHeadingLine2)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.getServicePodcast), function(pod) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('iframe', {
      attrs: {
        "src": pod.podcastUrl,
        "loading": "lazy",
        "width": "95%",
        "height": "200",
        "frameborder": "0",
        "scrolling": "no"
      }
    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(pod.artist) + " : " + _vm._s(pod.title))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(pod.description))]), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": pod.readMoreUrl,
        "target": "_blank"
      }
    }, [_c('h4', {
      style: ({
        color: '#000000'
      })
    }, [_vm._v("Read More")])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.corpLogos) ? _c('div', {
    staticClass: "container logoslider"
  }, [(_vm.dynamic_logosection_header) ? _c('h2', {
    staticClass: "pinkh2",
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_c('strong', [_vm._v(_vm._s(_vm.dynamic_logosection_header))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.corpLogos) ? _c('div', {
    staticClass: "slider responsive-slick-corplogos"
  }, _vm._l((_vm.corpLogos), function(logo) {
    return _c('div', {
      staticClass: "slide-player"
    }, [_c('a', {
      attrs: {
        "href": logo.linkDestination,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": logo.logoUrl,
        "alt": logo.siteNameText,
        "title": logo.siteNameText
      }
    })]), _vm._v(" "), _c('h4', {
      style: ({
        color: _vm.getCorpHeadingColor + ' !important'
      })
    }, [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor + ' !important'
      }),
      attrs: {
        "href": logo.linkDestination,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(logo.siteNameText))])])])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getAllTestimonials) ? _c('section', {
    staticClass: "testimonialsection"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', [_vm._v("\n                                “" + _vm._s(_vm.getAllTestimonials[0].quote) + "”\n                                "), _c('div', {
    staticClass: "author"
  }, [_vm._v("--" + _vm._s(_vm.getAllTestimonials[0].author) + ", " + _vm._s(_vm.getAllTestimonials[0].location))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h3', [_vm._v("\n                                “" + _vm._s(_vm.getAllTestimonials[1].quote) + "”\n                                "), _c('div', {
    staticClass: "author"
  }, [_vm._v("--" + _vm._s(_vm.getAllTestimonials[1].author) + ", " + _vm._s(_vm.getAllTestimonials[1].location))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.dynamic_testimonial_heading) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.dynamic_testimonial_heading))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', [_vm._v("\n                                “" + _vm._s(_vm.getAllTestimonials[2].quote) + "”\n                                "), _c('div', {
    staticClass: "author"
  }, [_vm._v("--" + _vm._s(_vm.getAllTestimonials[2].author) + ", " + _vm._s(_vm.getAllTestimonials[2].location))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h4', [_vm._v("\n                                “" + _vm._s(_vm.getAllTestimonials[3].quote) + "”\n                                "), _c('div', {
    staticClass: "author"
  }, [_vm._v("--" + _vm._s(_vm.getAllTestimonials[3].author) + ", " + _vm._s(_vm.getAllTestimonials[3].location))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "fullscreenimg",
    attrs: {
      "src": __webpack_require__(834),
      "alt": "TONE EVENTS SECTION"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "eventssections text-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_6)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.event1Dest && _vm.event1Dest.indexOf('/') > -1) ? _c('span', [(_vm.event1Dest.indexOf('http') > -1) ? _c('span', [_c('a', {
    attrs: {
      "href": _vm.event1Dest,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.event1Image,
      "alt": "TONE TALK EVENT"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.event1Dest,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_7)
    }
  })])]) : _c('span', [_c('a', {
    attrs: {
      "href": _vm.event1Dest
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.event1Image,
      "alt": "TONE TALK EVENT"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.event1Dest
    }
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_7)
    }
  })])])]) : _c('span', [_c('img', {
    attrs: {
      "src": _vm.event1Image,
      "alt": "TONE TALK EVENT"
    }
  }), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_7)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.event2Dest) ? _c('span', [(_vm.event2Dest.indexOf('http') > -1) ? _c('span', [_c('a', {
    attrs: {
      "href": _vm.event2Dest,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.event2Image,
      "alt": "TONE LIVE EVENT"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.event2Dest,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_8)
    }
  })])]) : _c('span', [_c('a', {
    attrs: {
      "href": _vm.event2Dest
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.event2Image,
      "alt": "TONE LIVE EVENT"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.event2Dest
    }
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_8)
    }
  })])])]) : _c('span', [_c('img', {
    attrs: {
      "src": _vm.event2Image,
      "alt": "TONE LIVE EVENT"
    }
  }), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_8)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.event3Dest) ? _c('span', [(_vm.event3Dest.indexOf('http') > -1) ? _c('span', [_c('a', {
    attrs: {
      "href": _vm.event3Dest,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.event3Image,
      "alt": "ASK QUESTION"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.event3Dest,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_9)
    }
  })])]) : _c('span', [_c('a', {
    attrs: {
      "href": _vm.event3Dest
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.event3Image,
      "alt": "ASK QUESTION"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.event3Dest
    }
  }, [_c('h4', {
    attrs: {
      "alt": "ASK QUESTION"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_9)
    }
  })])])]) : _c('span', [_c('img', {
    attrs: {
      "src": _vm.event3Image,
      "alt": "ASK QUESTION"
    }
  }), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_9)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('section', {
    staticClass: "aboutussection"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("About Us")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-1 col-sm-10",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.mainVideoPlay) ? _c('div', {}, [_c('jwplayer', {
    attrs: {
      "id": "introVideo",
      "data": _vm.mainVideoPlay
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e(), _vm._v(" "), (_vm.getAdvisoryBoard) ? _c('div', [_c('section', {
    staticClass: "text-left advisory"
  }, [_c('h2', {
    style: ({
      fontWeight: 'bold',
      'font-size': '2em'
    })
  }, [_vm._v("ADVISORY BOARD")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.getAdvisoryBoard), function(member) {
    return _c('div', {
      staticClass: "mb-3 col-sm-12"
    }, [_c('span', {
      style: ({
        color: '#f0617d',
        fontWeight: 'bold',
        'font-size': '1.2em'
      })
    }, [_vm._v(_vm._s(member.key))]), _vm._v(" "), _c('span', {
      style: ({
        textAlign: 'left',
        fontWeight: 'bold',
        'font-size': '1.1em'
      })
    }, [_vm._v(_vm._s(member.value))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.dynamic_aboutus_video2_code && this.dynamic_aboutus_video2_code.length > 3 && (_vm.dynamic_aboutus_video2_code !== ' ' || _vm.dynamic_aboutus_video2_code !== '')) ? _c('div', {
    staticClass: "row"
  }, [(_vm.dynamic_aboutus_video2_title && (_vm.dynamic_aboutus_video2_title !== ' ' || _vm.dynamic_aboutus_video2_title !== '')) ? _c('h2', [_vm._v(_vm._s(_vm.dynamic_aboutus_video2_title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-1 col-sm-10",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.unauthPromoVideo) ? _c('div', {}, [_c('jwplayer', {
    attrs: {
      "id": "unauthpromovideo",
      "data": _vm.unauthPromoVideo
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('button', {
    staticClass: "home-pink-button",
    style: ({
      backgroundColor: _vm.getCorpButtonColor
    }),
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()]) : _vm._e()])])], 1), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    attrs: {
      "effect": "zoom",
      "value": _vm.showModal,
      "width": "400"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal('0')
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentPlayerID
    }
  }, [_vm._v("Loading the player...")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showWatchVideoModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showWatchVideoModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal('1')
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelModal('1')
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentPlayerID,
      "id": "unAuthPlayer"
    }
  }, [_vm._v("Loading the player...")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.currentVideoDesc) + "\n                ")]), _vm._v(" "), (!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirectSignupFromPopUp()
      }
    }
  }, [_vm._v("Start Your Free Trial")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redeemGiftcode('popup')
      }
    }
  }, [_vm._v("Redeem Your Gift")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "applicationdownload"
  }, [_c('img', {
    staticClass: "showmobile",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/app-image-resized-new.png",
      "alt": "DOWNLOAD MOBILE APP",
      "title": "Download Mobile App"
    }
  }), _vm._v(" "), _c('h2', [_c('b', [_vm._v("Get TONE on your Phone with the TONE app")])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://apps.apple.com/us/app/tone-networks-advice-on-demand/id1444962883?ls=1"
    }
  }, [_c('img', {
    staticClass: "appbtn",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mobile-app-apple.png",
      "alt": "DOWNLOAD APPLE APP",
      "title": "Download App on IOS"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://play.google.com/store/apps/details?id=com.tonenetworks.toneapp"
    }
  }, [_c('img', {
    staticClass: "appbtn",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mobile-app-android.png",
      "alt": "DOWNLOAD ANDROID APP",
      "title": "Download App on Android"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-434fb5b0", module.exports)
  }
}

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "join-page-wrapper"
  }, [_c('div', {
    staticClass: "col-md-12 margin-bottom-20"
  }, [_c('div', {
    staticClass: "join-section clearfix margin-top-40"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('datepicker', {
    attrs: {
      "format": _vm.dateFormat,
      "clear-button": _vm.isClear
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.dateVal))]), _vm._v(" "), _c('h1', [_vm._v("Join Tone Today")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                    Lorem Ipsum is simply dummy text of the printing "), _c('br'), _vm._v("\n                    and typesetting industry\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 margin-top-30"
  }, [_c('div', {
    staticClass: "chat-button"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Start Your 30-Day's Trial Now")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 margin-top-20"
  }, [_c('div', {
    staticClass: "chat-button"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-transparent btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Watch Video")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 margin-top-40"
  }, [_c('div', {
    staticClass: "blog-section white-bg clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "jumbotron"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('h3', [_vm._v("Career")]), _vm._v(" "), _c('p', [_vm._v("\n                            Lorem ipsum dolor sit amet,\n                            consectetur adipiscing elit,\n                            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "blog-button"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Learn More")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top-30"
  }, [_c('div', {
    staticClass: "col-md-7 alternate-content"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "jumbotron"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "text-left alternate-content-text"
  }, [_c('h3', [_vm._v("Inspiration")]), _vm._v(" "), _c('p', [_vm._v("\n                            Lorem ipsum dolor sit amet,\n                            consectetur adipiscing elit,\n                            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "blog-button"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Learn More")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top-30"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "jumbotron"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('h3', [_vm._v("Mind Body")]), _vm._v(" "), _c('p', [_vm._v("\n                            Lorem ipsum dolor sit amet,\n                            consectetur adipiscing elit,\n                            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "blog-button"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Learn More")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top-30"
  }, [_c('div', {
    staticClass: "col-md-7 alternate-content"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "jumbotron"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "text-left alternate-content-text"
  }, [_c('h3', [_vm._v("Live Chat With Experts")]), _vm._v(" "), _c('p', [_vm._v("\n                            Lorem ipsum dolor sit amet,\n                            consectetur adipiscing elit,\n                            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "blog-button"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Learn More")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 margin-bottom-40"
  }, [_c('div', {
    staticClass: "goods-section clearfix"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', [_vm._v("Clicks For Goods")]), _vm._v(" "), _c('p', [_vm._v("\n                    Lorem Ipsum is simply dummy text of the "), _c('br'), _vm._v("\n                    printing and typesetting industry\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-40"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Learn More")])])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4570478e", module.exports)
  }
}

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper career-page-wrapper expert-page-wrapper",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.showWatchVideoModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showWatchVideoModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentPlayerID
    }
  }, [_vm._v("Loading the player...")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.currentPlayerID.videoDescription) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "featured main"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row margin-top-40"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/experts/Ramani.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('a', {
    attrs: {
      "href": "https://www.tonenetworks.com/#/expert/19"
    }
  }, [_c('h2', [_vm._v(" Dr. Ramani Durvasula ")])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(" (Relationship Realist, Ph.D.) ")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("Dr. Ramani Durvasula is a licensed clinical psychologist in private practice and Professor of Psychology at California State University, Los Angeles, where she was named Outstanding Professor in 2012. She is also a Visiting Professor at the University of Johannesburg. She brings a wealth of expertise in relationships, sexuality, health and wellness, helping people reach their full potential in their relationships, jobs, and family time. "), _c('br'), _vm._v("\n                                Dr. Ramani is a sought-after presenter for audiences ranging from adolescents to mental health professionals. She is involved in national governance in the field of psychology and served as chair of the Committee on Socioeconomic Status at the American Psychological Association and is a member of the Advisory Board of the Minority Fellowship Program of the American Psychological Association."), _c('br'), _vm._v("\n                                Dr. Ramani was co-host of Oxygen’s "), _c('i', [_vm._v("My Shopping Addiction")]), _vm._v(", and has been featured on Bravo, Lifetime Movie Network, National Geographic, History Channel, Discovery, and in documentary films on health. She is a featured commentator on nearly every major television network, radio, print, and internet media. She is the author of numerous peer-reviewed journal articles, book chapters and papers; the modern relationship survival manual "), _c('i', [_vm._v("Should I Stay or Should I Go: Surviving a Relationship With a Narcissist")]), _vm._v("; and "), _c('i', [_vm._v("You Are WHY You Eat: Change Your Food Attitude, Change Your Life")]), _vm._v(". Dr. Ramani is currently at work on a new book about staying sane in our era of entitlement. ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-top-40"
  }, [_c('div', {
    staticClass: "blog-section videossection clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 margin-bottom-40"
  }, [_c('a', {
    attrs: {
      "href": "https://www.tonenetworks.com/#/expert/19"
    }
  }, [_c('h2', {
    staticClass: "text-center pinkh2"
  }, [_vm._v("CLICK HERE FOR MORE ON Dr. Ramani Durvasula")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.tonenetworks.com/#/expert/19"
    }
  }, [_c('div', {
    staticClass: "row random-section-head yourFaves exceptionalsettings"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": "https://cdn.jwplayer.com/thumbs/dWIRniaI-720.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v("Retail Therapy")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": "https://cdn.jwplayer.com/thumbs/tTLW0ntx-720.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v("How to Pick a Partner")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": "https://cdn.jwplayer.com/thumbs/m0jB57uy-720.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v("Channel Your Inner Leader")])])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4572d5bb", module.exports)
  }
}

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resource-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "container-responsive"
  }, [_c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Set the Tone of Your Life")]), _vm._v(" "), _vm._l((_vm.getAllSetToneResources), function(fa) {
    return (_vm.getAllFeaturedArticles) ? _c('div', [(fa.articleHeader) ? _c('h4', {
      style: ({
        'borderBottom': '2px solid ' + _vm.getCorpHeaderColor + ' !important'
      })
    }, [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "href": fa.articleUrl,
        "title": fa.articleHeader,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(fa.articleHeader))])]) : _vm._e(), _vm._v(" "), (fa.articleHeader) ? _c('div', {
      staticClass: "row"
    }, [(fa.imageUrl) ? _c('div', {
      staticClass: "col-sm-6"
    }, [_c('img', {
      attrs: {
        "src": fa.imageUrl,
        "alt": fa.articleHeader,
        "title": fa.articleHeader
      }
    })]) : _vm._e(), _vm._v(" "), (fa.description) ? _c('div', {
      staticClass: "col-sm-6"
    }, [_vm._v(_vm._s(fa.description)), _c('br'), _c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "href": fa.articleUrl,
        "target": "_blank"
      }
    }, [_vm._v("(more)")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()
  }), _vm._v(" "), _c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Featured Articles")]), _vm._v(" "), _vm._l((_vm.getAllFeaturedArticles), function(fa) {
    return (_vm.getAllSetToneResources) ? _c('div', [(fa.articleHeader) ? _c('h4', {
      style: ({
        'borderBottom': '2px solid ' + _vm.getCorpHeaderColor + ' !important'
      })
    }, [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "href": fa.articleUrl,
        "title": fa.articleHeader,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(fa.articleHeader))])]) : _vm._e(), _vm._v(" "), (fa.articleHeader) ? _c('div', {
      staticClass: "row"
    }, [(fa.imageUrl) ? _c('div', {
      staticClass: "col-sm-6"
    }, [_c('img', {
      attrs: {
        "src": fa.imageUrl,
        "alt": fa.articleHeader,
        "title": fa.articleHeader
      }
    })]) : _vm._e(), _vm._v(" "), (fa.description) ? _c('div', {
      staticClass: "col-sm-6"
    }, [_vm._v(_vm._s(fa.description)), _c('br'), _c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "href": fa.articleUrl,
        "target": "_blank"
      }
    }, [_vm._v("(more)")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Resources")]), _vm._v(" "), _c('div', {
    staticClass: "accordionholder"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true,
      "type": "default"
    }
  }, [_c('panel', [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.resourceCategory1_text))])]), _vm._v(" "), _vm._l((_vm.resourceCategory1_links), function(link) {
    return (_vm.resourceCategory1_links) ? _c('div', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "target": "_blank",
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))]), _c('br')]) : _vm._e()
  })], 2), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #2"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.resourceCategory2_text))])]), _vm._v(" "), _vm._l((_vm.resourceCategory2_links), function(link) {
    return (_vm.resourceCategory2_links) ? _c('div', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "target": "_blank",
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))]), _c('br')]) : _vm._e()
  })], 2), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #3"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.resourceCategory3_text))])]), _vm._v(" "), _vm._l((_vm.resourceCategory3_links), function(link) {
    return (_vm.resourceCategory3_links) ? _c('div', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "target": "_blank",
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))]), _c('br')]) : _vm._e()
  })], 2), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #4"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.resourceCategory4_text))])]), _vm._v(" "), _vm._l((_vm.resourceCategory4_links), function(link) {
    return (_vm.resourceCategory4_links) ? _c('div', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "target": "_blank",
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))]), _c('br')]) : _vm._e()
  })], 2), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #5"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.resourceCategory5_text))])]), _vm._v(" "), _vm._l((_vm.resourceCategory5_links), function(link) {
    return (_vm.resourceCategory5_links) ? _c('div', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "target": "_blank",
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))]), _c('br')]) : _vm._e()
  })], 2), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #6"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.resourceCategory6_text))])]), _vm._v(" "), _vm._l((_vm.resourceCategory6_links), function(link) {
    return (_vm.resourceCategory6_links) ? _c('div', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "target": "_blank",
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))]), _c('br')]) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 text-left "
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.video_title))]), _vm._v(" "), _c('div', {
    staticClass: "video-holder"
  }, [(_vm.currentVideo) ? _c('jwplayer', {
    attrs: {
      "id": "resourcesvideoplay",
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (!_vm.currentVideo && _vm.video_code.indexOf('http') >= 0) ? _c('img', {
    attrs: {
      "src": _vm.video_code,
      "alt": _vm.video_title,
      "title": _vm.video_title
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.liveEvent) ? _c('h5', [_vm._v(_vm._s(_vm.getDateReference(_vm.liveEvent.start_date, 'str')))]) : _vm._e(), _vm._v(" "), (_vm.liveEvent) ? _c('small', [_vm._v(_vm._s(_vm.liveEvent.longDescription))]) : _vm._e(), _vm._v(" "), (_vm.liveEvent && !_vm.showJoin(_vm.liveEvent)) ? _c('div', {
    staticClass: "text-center smlbuttonholder"
  }, [_c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.liveEvent.title)
      }
    }
  }, [_vm._v("\n                        Add to Calendar\n                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.liveEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.liveEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.liveEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.liveEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.liveEvent.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.liveEvent.eventId))]) : _c('span', [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.liveEvent.eventId))])])]), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCorporateImageShareModal
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.showJoin(_vm.liveEvent)) ? _c('button', {
    staticClass: "button btn btn-pink btn-primary pull-center",
    style: (_vm.styleObject),
    attrs: {
      "type": "button"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      },
      "click": function($event) {
        return _vm.joinEvent(_vm.liveEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa 2x fa-arrow-circle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Go to Event ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.firstAdvertisementBox) ? _c('div', {
    staticClass: "advertizmentbox"
  }, [(_vm.firstAdvertisementBox && _vm.firstAdvertisementBox.videoCode && _vm.firstAdvertisementBox.videoObject) ? _c('jwplayer', {
    attrs: {
      "id": "resourcesad1",
      "data": _vm.firstAdvertisementBox.videoObject
    }
  }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (_vm.firstAdvertisementBox.imageUrl && !_vm.firstAdvertisementBox.videoCode) ? _c('img', {
    attrs: {
      "src": _vm.firstAdvertisementBox.imageUrl,
      "alt": _vm.firstAdvertisementBox.articleHeader,
      "title": _vm.firstAdvertisementBox.articleHeader
    }
  }) : _vm._e(), _vm._v(" "), (_vm.firstAdvertisementBox.articleHeader) ? _c('p', {
    staticStyle: {
      "padding": "20px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.firstAdvertisementBox.articleHeader)
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    }),
    attrs: {
      "id": "sFeatures"
    }
  }, [_vm._v("Site Features")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "accordionholder"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true,
      "type": "default"
    }
  }, [_c('panel', {
    attrs: {
      "is-open": _vm.openPanel(_vm.siteFeatures1_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures1_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures1_desc) + "\n                            ")]), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #2",
      "is-open": _vm.openPanel(_vm.siteFeatures2_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures2_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures2_desc) + "\n                            ")]), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #3",
      "is-open": _vm.openPanel(_vm.siteFeatures3_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures3_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures3_desc) + "\n                            ")]), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #4",
      "is-open": _vm.openPanel(_vm.siteFeatures4_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures4_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures4_desc) + "\n                            ")]), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #5",
      "is-open": _vm.openPanel(_vm.siteFeatures5_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures5_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures5_desc) + "\n                            ")]), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #6",
      "is-open": _vm.openPanel(_vm.siteFeatures6_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures6_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures6_desc) + "\n                            ")]), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #7",
      "is-open": _vm.openPanel(_vm.siteFeatures7_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures7_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures7_desc) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    staticClass: "adboxheading",
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Sign Up For Our Newsletter")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "footer_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onEmailSignUp.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "formholder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscriptionForm.email),
      expression: "subscriptionForm.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email Address",
      "title": "please enter a valid email address",
      "required": ""
    },
    domProps: {
      "value": (_vm.subscriptionForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscriptionForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._l((_vm.mediaColl), function(ad) {
    return _c('div', [(ad) ? _c('div', {
      staticClass: "advertizmentbox"
    }, [(ad && ad.videoCode && ad.videoObject) ? _c('jwplayer', {
      attrs: {
        "data": ad.videoObject
      }
    }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (ad.imageUrl && !ad.videoCode) ? _c('img', {
      attrs: {
        "src": ad.imageUrl,
        "alt": ad.articleHeader,
        "title": ad.articleHeader
      }
    }) : _vm._e(), _vm._v(" "), (ad.articleHeader) ? _c('p', {
      staticStyle: {
        "padding": "20px"
      },
      domProps: {
        "innerHTML": _vm._s(ad.articleHeader)
      }
    }) : _vm._e()], 1) : _vm._e()])
  }), _vm._v(" "), _c('h3', {
    staticClass: "adboxheading",
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Follow US")]), _vm._v(" "), _c('div', {
    staticClass: "socialblocks"
  }, [_c('a', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    }),
    attrs: {
      "href": "https://www.facebook.com/tonenetworks/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    }),
    attrs: {
      "href": "https://twitter.com/ToneNetworks",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    }),
    attrs: {
      "href": "https://www.instagram.com/tonenetworks/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    }),
    attrs: {
      "href": "https://www.linkedin.com/company/25037986/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    }),
    attrs: {
      "href": "https://www.youtube.com/channel/UCarjWAb1SWrzKtoeNimOVJA/videos",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 2)])]), _vm._v(" "), (_vm.showCorporateImageShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateImageShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")])])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.shareEventSelected.img_url,
      "alt": _vm.shareEventSelected.title,
      "title": _vm.shareEventSelected.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.shareEventSelected.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.shareEventSelected.longDescription.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateImage()
      }
    }
  }, [_vm._v("\n                            Share This Event\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "yellowbtn"
  }, [_c('strong', [_vm._v("Sign Up")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46d191b4", module.exports)
  }
}

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper contact-us-form",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Want to become a TONE Expert?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("TONE is a platform for women helping women in all areas of life. We look for experts in fields that can help\n                        women grow professionally and personally to live life to the fullest potential. Our experts are highly\n                        credentialed, successful in their fields and passionate about helping women. TONE underwrites production and\n                        related expenses, and experts are not paid a fee for their appearances. Please complete this form and tell us\n                        about yourself and why you would be a great addition to TONE")])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-form"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "id": "contactus_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "First Name",
      "placeholder": "First Name",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.firstName),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "firstName", $$v)
      },
      expression: "becomeExpert.firstName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "Last Name",
      "placeholder": "Last Name",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.lastName),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "lastName", $$v)
      },
      expression: "becomeExpert.lastName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "contactus_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.email),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "email", $$v)
      },
      expression: "becomeExpert.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "id": "contactus_phonenumber",
      "error": "Phone Number",
      "placeholder": "Phone Number",
      "mask": "\\(111) 111-1111",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.phone),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "phone", $$v)
      },
      expression: "becomeExpert.phone"
    }
  })], 1), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "Reach Method",
      "placeholder": "Preferred method to Reach to you",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.reachMethod),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "reachMethod", $$v)
      },
      expression: "becomeExpert.reachMethod"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "Website",
      "placeholder": "Website URL",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.websiteUrl),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "websiteUrl", $$v)
      },
      expression: "becomeExpert.websiteUrl"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "Facebook",
      "placeholder": "Facebook"
    },
    model: {
      value: (_vm.becomeExpert.smFacebook),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "smFacebook", $$v)
      },
      expression: "becomeExpert.smFacebook"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "Instagram",
      "placeholder": "Instagram"
    },
    model: {
      value: (_vm.becomeExpert.smInstagram),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "smInstagram", $$v)
      },
      expression: "becomeExpert.smInstagram"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "Twitter",
      "placeholder": "Twitter"
    },
    model: {
      value: (_vm.becomeExpert.smTwitter),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "smTwitter", $$v)
      },
      expression: "becomeExpert.smTwitter"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "LinkedIn",
      "placeholder": "LinkedIn"
    },
    model: {
      value: (_vm.becomeExpert.smLinked_in),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "smLinked_in", $$v)
      },
      expression: "becomeExpert.smLinked_in"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "Pinterest",
      "placeholder": "Pinterest"
    },
    model: {
      value: (_vm.becomeExpert.smPinterest),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "smPinterest", $$v)
      },
      expression: "becomeExpert.smPinterest"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "Other",
      "placeholder": "Other"
    },
    model: {
      value: (_vm.becomeExpert.smOther),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "smOther", $$v)
      },
      expression: "becomeExpert.smOther"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "Other",
      "placeholder": "How did you hear about TONE?"
    },
    model: {
      value: (_vm.becomeExpert.howHearTone),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "howHearTone", $$v)
      },
      expression: "becomeExpert.howHearTone"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox text-left"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.becomeExpert.toneMember),
      expression: "becomeExpert.toneMember"
    }],
    staticClass: "checkbox form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.becomeExpert.toneMember) ? _vm._i(_vm.becomeExpert.toneMember, null) > -1 : (_vm.becomeExpert.toneMember)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.becomeExpert.toneMember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.becomeExpert, "toneMember", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.becomeExpert, "toneMember", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.becomeExpert, "toneMember", $$c)
        }
      }
    }
  }), _vm._v("\n                                Are you currently a TONE Member?\n                            ")])]), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "textarea",
      "error": "Professional Biography",
      "placeholder": "Provide an overview of your professional experience and your bio",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.bioProfExp),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "bioProfExp", $$v)
      },
      expression: "becomeExpert.bioProfExp"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "textarea",
      "error": "Comments",
      "placeholder": "Other info about you (e.g. speaking experiences, links to relevant material, publications, etc.)"
    },
    model: {
      value: (_vm.becomeExpert.otherPersonalInfo),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "otherPersonalInfo", $$v)
      },
      expression: "becomeExpert.otherPersonalInfo"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "textarea",
      "error": "Join Reason",
      "placeholder": "Tell us why you’d like to be a part of TONE",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.joinReason),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "joinReason", $$v)
      },
      expression: "becomeExpert.joinReason"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "textarea",
      "error": "Video Topics",
      "placeholder": "What topics would you propose for your TONE videos?",
      "required": ""
    },
    model: {
      value: (_vm.becomeExpert.videoTopic),
      callback: function($$v) {
        _vm.$set(_vm.becomeExpert, "videoTopic", $$v)
      },
      expression: "becomeExpert.videoTopic"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control",
    staticStyle: {
      "height": "auto",
      "text-align": "left",
      "margin": "0 0 30px"
    }
  }, [_vm._v("\n                                Which content areas would your videos appear in? (check all that apply)\n                            "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.becomeExpert.contentWork),
      expression: "becomeExpert.contentWork"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.becomeExpert.contentWork) ? _vm._i(_vm.becomeExpert.contentWork, null) > -1 : (_vm.becomeExpert.contentWork)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.becomeExpert.contentWork,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.becomeExpert, "contentWork", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.becomeExpert, "contentWork", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.becomeExpert, "contentWork", $$c)
        }
      }
    }
  }), _vm._v(" Work\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.becomeExpert.contentLife),
      expression: "becomeExpert.contentLife"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.becomeExpert.contentLife) ? _vm._i(_vm.becomeExpert.contentLife, null) > -1 : (_vm.becomeExpert.contentLife)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.becomeExpert.contentLife,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.becomeExpert, "contentLife", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.becomeExpert, "contentLife", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.becomeExpert, "contentLife", $$c)
        }
      }
    }
  }), _vm._v(" Life\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.becomeExpert.contentMind),
      expression: "becomeExpert.contentMind"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.becomeExpert.contentMind) ? _vm._i(_vm.becomeExpert.contentMind, null) > -1 : (_vm.becomeExpert.contentMind)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.becomeExpert.contentMind,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.becomeExpert, "contentMind", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.becomeExpert, "contentMind", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.becomeExpert, "contentMind", $$c)
        }
      }
    }
  }), _vm._v(" Mind/Body\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.becomeExpert.contentMoney),
      expression: "becomeExpert.contentMoney"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.becomeExpert.contentMoney) ? _vm._i(_vm.becomeExpert.contentMoney, null) > -1 : (_vm.becomeExpert.contentMoney)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.becomeExpert.contentMoney,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.becomeExpert, "contentMoney", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.becomeExpert, "contentMoney", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.becomeExpert, "contentMoney", $$c)
        }
      }
    }
  }), _vm._v(" Money\n                                ")])])])], 1), _vm._v(" "), _c('div', [(!_vm.spinner) ? _c('button', {
    staticClass: "btn formButton btn-transparent",
    style: ({
      color: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "id": "contact_sendbutton"
    }
  }, [_vm._v("\n                                Send Request\n                                "), (_vm.spinner) ? _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  }) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "contactus_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])])], 1)])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-476d1140", module.exports)
  }
}

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "JWvideoHandler"
  }, [_c('div', {
    ref: _vm.playerID,
    attrs: {
      "id": _vm.playerID
    }
  }, [_vm._v("\n        Loading video...\n    ")]), _vm._v(" "), (_vm.showButtonFlag) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showButtonFlag) ? _c('button', {
    staticClass: "pink-button",
    style: ({
      'border-width': '1px !important',
      'border-style': 'solid !important',
      'border-color': this.getCorpButtonColor + ' !important',
      'color': '#FFFFF !important',
      'background-color': this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "id": "buyflow"
    },
    on: {
      "click": _vm.redirectUserToJoin
    }
  }, [_vm._v("Join Now")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.becomeMemberFlag) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.becomeMemberFlag) ? _c('button', {
    staticClass: "pink-button",
    attrs: {
      "id": "becomeMemberflow"
    },
    on: {
      "click": _vm.redirectUserToCompleteSignup
    }
  }, [_vm._v("Update my Membership")]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ac67fc6", module.exports)
  }
}

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper fixgraybgpl"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.videoSqueeze),
      expression: "!videoSqueeze"
    }],
    staticClass: "video-player-background",
    class: {
      'animated zoomOutLeft': _vm.videoCompleted
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "video-player",
    on: {
      "mouseleave": function($event) {
        _vm.addRightHoverWidthClass ? _vm.resetClass(true) : _vm.resetClass(false)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideLeftVideoIcons),
      expression: "!hideLeftVideoIcons"
    }],
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.getUserNewPlaylistObject) ? _c('div', {
    staticClass: "reset-video-width",
    class: {
      'enjoy-hover': _vm.addEnjoyHoverClass
    }
  }, [_c('jwplaylist', {
    attrs: {
      "data": _vm.getUserNewPlaylistObject,
      "on-playlistitem": _vm.videoChangedInPlaylist()
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.playlistVideos) ? _c('div', {
    staticClass: "playlistholderdiv"
  }, [_c('h4', [_vm._v(_vm._s(_vm.playlistVideos.title))]), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.videoIndex) + " of " + _vm._s(_vm.playlistVideos.userPlaylistVideos.length) + ")")]), _vm._v(" "), _c('div', _vm._l((_vm.getUserNewPlaylistObject), function(item) {
    return (_vm.getUserNewPlaylistObject && _vm.getItemChangeInPlaylist) ? _c('div', [_c('div', {
      staticClass: "playlistentrydiv",
      class: {
        'playing': item.videoCode === _vm.getItemChangeInPlaylist.item.videoCode
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.image,
        "alt": item.title,
        "title": item.title
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])]) : _vm._e()
  }), 0)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "player-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.currentVideo.Description) + "\n                    ")]), _vm._v(" "), (_vm.getExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.getExpert[0].expertId + '/' + _vm.getExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": _vm.getExpert[0].name,
      "title": _vm.getExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.getExpert && _vm.getExpert[0].areasofexpertise) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-3"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    style: ([_vm.viewTranscript ? {
      color: '#FFFFFF !important',
      backgroundColor: this.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      outline: 'none !important'
    } : {
      color: _vm.getCorpButtonColor + ' !important',
      backgroundColor: '#FFFFFF !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      outline: 'none !important'
    }]),
    on: {
      "click": _vm.toggleViewTranscript
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.viewTranscript),
      expression: "!viewTranscript"
    }]
  }, [_vm._v("View Transcript")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewTranscript),
      expression: "viewTranscript"
    }]
  }, [_vm._v("Hide Transcript")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8 col-lg-9"
  }, [(_vm.getCurrentVideoTranscript) ? _c('div', {
    staticClass: "side-content",
    style: ({
      'border-left-color': this.getCorpHeaderColor + ' !important'
    })
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewTranscript),
      expression: "viewTranscript"
    }],
    staticClass: "boxes",
    class: {
      'animated fadeIn': _vm.viewTranscript, 'animated fadeOut': !_vm.viewTranscript
    }
  }, [_c('pre', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentVideoTranscript.vtt_file)
    }
  }, [_vm._v("\n                                    ")])])])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "recently-watched"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthRecommendedVideos) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.recommendationList), function(reccentVideo) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": reccentVideo.image,
        "title": reccentVideo.title,
        "alt": reccentVideo.title
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(reccentVideo.mediaid)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(reccentVideo.title) + "\n                                    ")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    style: (_vm.styleObject),
    on: {
      "click": function($event) {
        return _vm.redirectToRelatedVideos()
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_vm._v("View All Your Videos")])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("RELATED VIDEOS")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d9ff14b", module.exports)
  }
}

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "tabs-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthCareerVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.getAuthCareerVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(video.mediaid)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(video.title))])])
  })], 2) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_c('br'), _vm._v(" "), _c('i', {
    staticClass: "nav-icon career-pink-icon"
  }), _vm._v(" "), _c('br'), _c('span', [_vm._v("Career")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "mostRecent"
  }, [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                                            most recent\n                                            "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Sort by")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4de429bf", module.exports)
  }
}

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row row1"
  }, [_vm._m(0), _vm._v(" "), (_vm.currentRoute.name !== 'SignUp' && _vm.currentRoute.name !== 'Gift' && !_vm.getSiteStatus) ? _c('form', {
    staticClass: "col-xs-12 col-md-5",
    attrs: {
      "id": "footer_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitEmail.apply(null, arguments)
      }
    }
  }, [(!_vm.user) ? _c('div', {
    staticClass: "col-xs-12 col-md-5 input-group input-md sendrefrel  text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscriptionForm.email),
      expression: "subscriptionForm.email"
    }],
    staticClass: "form-control form-control-1",
    attrs: {
      "type": "email",
      "placeholder": "Sign up for our newsletter",
      "title": "please enter a valid email address",
      "required": ""
    },
    domProps: {
      "value": (_vm.subscriptionForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscriptionForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "col-xs-12 col-md-5 input-group input-md sendrefrel  text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscriptionForm.email),
      expression: "subscriptionForm.email"
    }],
    staticClass: " form-control form-control-1",
    attrs: {
      "type": "email",
      "placeholder": "Refer a friend",
      "title": "please enter a valid email address",
      "required": ""
    },
    domProps: {
      "value": (_vm.subscriptionForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscriptionForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "row row1"
  }, [(!_vm.getSiteStatus) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('navbar', {
    staticClass: "footer-nav",
    style: ({
      backgroundColor: _vm.getCorpFooterColor
    })
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/b2b'
      }
    }
  }, [_vm._v("\n                            TONE for Businesses\n                        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/resources'
      }
    }
  }, [_vm._v("\n                            In the News\n                        ")])], 1), _vm._v(" "), (_vm.showGiftingLinks) ? _c('li', [_c('router-link', {
    attrs: {
      "title": "send gifts",
      "to": {
        path: '/gifts'
      }
    }
  }, [_vm._v("\n                            Give the Gift of Tone\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/become-expert'
      }
    }
  }, [_vm._v("\n                           Become an Expert\n                        ")])], 1), _vm._v(" "), (_vm.user) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/Giving'
      }
    }
  }, [_vm._v("\n                            Giving\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/feedback'
      }
    }
  }, [_vm._v("\n                            Feedback\n                        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contactus'
      }
    }
  }, [_vm._v("\n                            Contact Us\n                        ")])], 1)])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "margin-bottom-20"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav nav-pills footer-compnay-name"
  }, [_vm._v("\n                                © " + _vm._s(_vm.bYear) + " TONE Networks\n                            ")]), _vm._v(" "), (!_vm.getSiteStatus) ? _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    style: ({
      backgroundColor: _vm.getCorpFooterColor
    }),
    attrs: {
      "to": {
        path: '/aboutus'
      }
    }
  }, [_vm._v("\n                                About\n                            ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.getSiteStatus) ? _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    style: ({
      backgroundColor: _vm.getCorpFooterColor
    }),
    attrs: {
      "to": {
        path: '/privacypolicy'
      }
    }
  }, [_vm._v("\n                                Privacy Policy\n                            ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.getSiteStatus) ? _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "active",
    style: ({
      backgroundColor: _vm.getCorpFooterColor
    }),
    attrs: {
      "to": {
        path: '/terms'
      }
    }
  }, [_vm._v("\n                                Terms\n                            ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.getSiteStatus) ? _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "active",
    style: ({
      backgroundColor: _vm.getCorpFooterColor
    }),
    attrs: {
      "to": {
        path: '/faq'
      }
    }
  }, [_vm._v("\n                                FAQ\n                            ")])], 1) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-2 text-center",
    staticStyle: {
      "border-width": "2px",
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "input-group input-md float-right"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": __webpack_require__(813),
      "alt": "Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon cursor form-control-2"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sign Up")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon cursor  form-control-2"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send Referral")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-4 footer-links  text-center"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/tonenetworks/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/ToneNetworks",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/tonenetworks/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/25037986/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCarjWAb1SWrzKtoeNimOVJA/videos",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-1 text-center"
  }, [_c('div', {
    staticClass: "input-group input-md float-left"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": __webpack_require__(812),
      "alt": "Logo"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4f319b61", module.exports)
  }
}

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resetpassword"
  }, [_c('h1', [_vm._v("\n        Reset Your Password!\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('vue-password', {
    staticClass: "form-input",
    attrs: {
      "minlength": 6,
      "classes": "input",
      "placeholder": "Password",
      "error": "Password",
      "id": "resetpassword_password",
      "disableStrength": _vm.hidePasswordMeter,
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.forgetpassword.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.forgetpassword, "newPassword", $$v)
      },
      expression: "forgetpassword.newPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-info-circled alert-icon-float-left information"
  }, [_c('p', {
    staticClass: "alert alert-info alert-dismissable",
    class: {
      'set-error': !_vm.verifyPassword()
    },
    attrs: {
      "id": "resetpassword_pwderrormsg"
    }
  }, [_vm._v("Min 6 Chars, One Upper Case, One Lower Case!")])])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "resetpassword_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "id": "resetpassword_reset"
    }
  }, [_vm._v("\n                    Reset Password\n                ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55855f0b", module.exports)
  }
}

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "scroll": _vm.stickyNavigation
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    class: {
      'unauth-header': !_vm.user
    },
    style: ({
      backgroundColor: _vm.getCorpHeaderColor + ' !important'
    })
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ToneHeader', {
    style: ({
      backgroundColor: _vm.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "hide-nav": _vm.hideNav
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center min-body-height"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    style: ({
      backgroundColor: _vm.getCorpFooterColor
    })
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ToneFooter', {
    style: ({
      backgroundColor: _vm.getCorpFooterColor
    })
  })], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5930af97", module.exports)
  }
}

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "signup_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), _c('h2', [_vm._v("\n                                Welcome to TONE.\n                                "), _c('br'), _vm._v(" "), (_vm.getTrialDays > 1) ? _c('span', [_vm._v("Your trial period will expire in " + _vm._s(_vm.getTrialDays) + " days.")]) : _vm._e(), _vm._v(" "), (_vm.getTrialDays === 0) ? _c('span', [_vm._v("Your trial is expiring today.")]) : _vm._e(), _vm._v(" "), (_vm.getTrialDays === 1) ? _c('span', [_vm._v("Your trial is expiring tomorrow.")]) : _vm._e(), _vm._v(" "), (_vm.getTrialDays < 0) ? _c('span', [_vm._v("Your trial period has expired.")]) : _vm._e(), _vm._v("\n                                 But don't worry - you can keep enjoying TONE by becoming a member!\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "left-content"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true
    }
  }, [_c('panel', {
    staticClass: "text-left",
    attrs: {
      "is-open": true
    }
  }, [_c('div', {
    staticClass: "create-account"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "action": "/charge",
      "method": "post",
      "id": "payment-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onPaymentSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Choose your membership plan:")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "checkboxholder"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Two Year Plan")]), _vm._v(" "), _c('span', {
    staticClass: "plan-price"
  }, [_vm._v("$8.99 "), _c('span', {
    staticClass: "permonth"
  }, [_vm._v("per month")])]), _vm._v(" "), (_vm.twoYearPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "type": "radio",
      "id": "2yearplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.twoYearPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.twoYearPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.twoYearPlan.packageId
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "footertext"
  }, [_vm._v("$" + _vm._s(_vm.twoYearPlan.amount) + " billed once")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "radio popular"
  }, [_c('label', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("One Year Plan")]), _vm._v(" "), _c('span', {
    staticClass: "plan-price"
  }, [_vm._v("$9.50 "), _c('span', {
    staticClass: "permonth"
  }, [_vm._v("per month")])]), _vm._v(" "), (_vm.annualPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "type": "radio",
      "id": "annualplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.annualPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.annualPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.annualPlan.packageId
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "footertext"
  }, [_vm._v("$" + _vm._s(_vm.annualPlan.amount) + " billed annually")])])])]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Monthly Plan")]), _vm._v(" "), _c('span', {
    staticClass: "plan-price"
  }, [_vm._v("$" + _vm._s(_vm.defaultPlan.amount) + " "), _c('span', {
    staticClass: "permonth"
  }, [_vm._v("per month")])]), _vm._v(" "), (_vm.defaultPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "type": "radio",
      "id": "monthlyplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.defaultPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.defaultPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.defaultPlan.packageId
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "footertext"
  }, [_vm._v("billed monthly")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "codediv"
  }, [_c('div', {
    staticClass: "radiowrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gateway),
      expression: "gateway"
    }],
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "CC",
      "name": "paymentMethod"
    },
    domProps: {
      "checked": _vm._q(_vm.gateway, "CC")
    },
    on: {
      "change": function($event) {
        _vm.gateway = "CC"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v("Credit Card")])]), _vm._v(" "), (_vm.gateway === 'CC') ? _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "paymentMethod_cardHolder",
      "pattern": /^[A-Za-z ]+$/,
      "type": "text",
      "error": "Card Holder Name (no digits allowed)",
      "placeholder": "Card Holder Name",
      "required": "",
      "name": "cardholdername",
      "icon": ""
    },
    model: {
      value: (_vm.userObject.cardHolderName),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "cardHolderName", $$v)
      },
      expression: "userObject.cardHolderName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.gateway === 'CC') ? _c('div', {
    staticClass: "stripeholder"
  }, [(_vm.gateway === 'CC') ? _c('i', {
    staticClass: "fa fa-lock overlapstripe"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field",
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), (_vm.stripeErrorMessage) ? _c('div', {
    staticStyle: {
      "color": "#a94442",
      "margin": "2px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.stripeErrorMessage))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.gateway === 'paypal') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "text-center margin-top-10 margin-bottom-10",
    attrs: {
      "id": "paypal-button"
    }
  })]), _vm._v(" "), (_vm.userPayments.paymentMethodNonce) ? _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left success"
  }, [_c('p', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Payment successfully authorized")])])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('checkbox', {
    staticClass: "terms-and-condition",
    attrs: {
      "value": "isChecked",
      "type": "primary"
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n                                                         I agree to "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "_blank"
    }
  }, [_vm._v("terms and conditions")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "id": "signup_button",
      "disabled": !_vm.isChecked || _vm.spinner,
      "name": "completesignupbutton"
    }
  }, [_vm._v("\n                                                        Become a Member\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])])])])])], 1)], 1)]), _vm._v(" "), _vm._m(0)])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "hidemobile"
  }, [_c('h2', [_vm._v("Your Plan")]), _c('p', [_vm._v("What You Get")])]), _vm._v(" "), _c('div', {
    staticClass: "showmobile"
  }, [_c('h2', [_vm._v("What You Get")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('li', [_vm._v("Personalized bite-sized expert\n                                            videos will inspire you and set a positive\n                                            TONE to your day")]), _vm._v(" "), _c('li', {
    staticClass: "hidemobile"
  }, [_vm._v("A little dose of humor, and a pinch\n                                            of inspiration each time you log on.")]), _vm._v(" "), _c('li', [_vm._v("Reserve your spot for TONE Live...\n                                            Exclusive live streaming events with our\n                                            credentialed experts.")]), _vm._v(" "), _c('li', [_vm._v("Tune in to TONE Talks...our moderated\n                                            discussions every Tuesday and Thursday night\n                                            where we share advice within our community\n                                            of women helping women!")]), _vm._v(" "), _c('li', [_vm._v("And did we mention you will be helping out a\n                                            charity every time you use the site?")]), _vm._v(" "), _c('li', [_vm._v("Look out for TONE Teasers... customized emails with videos selected just for you!")])])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-593730aa", module.exports)
  }
}

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "interestlist"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    staticClass: "interestButtonList",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "main-content text-left"
  }, [_c('hr'), _vm._v(" "), _c('h2', [_vm._v("\n                                        Topics Of Interests:\n                                        ")]), _vm._v(" "), (_vm.user && _vm.getDefaultPlan) ? _c('img', {
    attrs: {
      "src": _vm.shareSaleSrc,
      "width": "1",
      "height": "1"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "interest-container"
  }, [_c('button-group', {
    model: {
      value: (_vm.interestIndexes),
      callback: function($$v) {
        _vm.interestIndexes = $$v
      },
      expression: "interestIndexes"
    }
  }, [_vm._l((_vm.getAllInterests), function(interest, interestId) {
    return _c('checkbox', {
      key: interestId,
      staticClass: "min-padding checkbox-btn",
      style: (_vm.styleInterestObject(interestId)),
      attrs: {
        "true-value": interestId
      }
    }, [_vm._v("\n                                            " + _vm._s(interest.interestName) + "\n                                        ")])
  }), _vm._v(" "), (_vm.getAllInterests) ? _c('button', {
    staticClass: "min-padding checkbox-btn",
    class: {
      'active': _vm.toggleStatus
    },
    style: ([_vm.toggleStatus ? {
      color: '#FFFFFF !important',
      backgroundColor: this.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    } : {
      color: _vm.getCorpButtonColor + '!important',
      backgroundColor: '#FFFFFF',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    }]),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleStatus = !_vm.toggleStatus
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gift fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" I want it all!")]) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', [_c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "interest-container",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('button-group', {
    staticStyle: {
      "margin": "25px"
    },
    model: {
      value: (_vm.selectedDays),
      callback: function($$v) {
        _vm.selectedDays = $$v
      },
      expression: "selectedDays"
    }
  }, _vm._l((_vm.daysOfWeek), function(day, index) {
    return _c('span', [_c('span', [_c('checkbox', {
      key: index,
      staticClass: "min-padding checkbox-btn-days",
      style: (_vm.styleDays(index)),
      attrs: {
        "true-value": index
      }
    }, [_vm._v("\n                                                                " + _vm._s(day) + "\n                                                            ")])], 1)])
  }), 0)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "submit-btn"
  }, [(_vm.isUserLoggedIn) ? _c('button', {
    staticClass: "btn btn-block",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      border: '1px solid' + _vm.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "id": "interests_submit",
      "type": "submit",
      "disabled": _vm.interestIndexes.length == 0
    }
  }, [_vm._v("\n                                        Done\n                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "interests_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n                                Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)\n                                "), _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "https://dc.ads.linkedin.com/collect/?pid=565489&fmt=gif\nhttps://dc.ads.linkedin.com/collect/?pid=565489&fmt=gif\n"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerlevel3 text-left"
  }, [_c('h3', {
    staticClass: "profile-heading"
  }, [_vm._v("TONE Teaser Delivery Days (choose at least two days):")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a54a012", module.exports)
  }
}

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('br'), _vm._v(" "), _c('br'), _c('span', [_vm._v("All Related Videos")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {}, [(_vm.getAuthRecommendedVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthRecommendedVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image
      }
    }), _vm._v(" "), _c('p', [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  })], 2) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ba2bfc2", module.exports)
  }
}

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("your profile")]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('ul', [_c('li', {
    staticClass: "playlist",
    class: {
      current: _vm.tabs.playlist
    },
    style: ([_vm.tabs.playlist ? {
      'borderBottom': '3px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '0px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.$router.push('/profile/playlist')
      }
    }
  }, [_c('a', {
    style: ([_vm.tabs.playlist ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("playlists")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.coolFeatures
    },
    style: ([_vm.tabs.coolFeatures ? {
      'borderBottom': '3px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '0px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.$router.push('/profile/myprogress')
      }
    }
  }, [_c('a', {
    style: ([_vm.tabs.coolFeatures ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("your Progress")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.chat
    },
    style: ([_vm.tabs.chat ? {
      'borderBottom': '3px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '0px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.$router.push('/profile/personalize')
      }
    }
  }, [_c('a', {
    style: ([_vm.tabs.chat ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("personalize")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.videos
    },
    style: ([_vm.tabs.videos ? {
      'borderBottom': '3px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '0px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.$router.push('/profile/myfav')
      }
    }
  }, [_c('a', {
    style: ([_vm.tabs.videos ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("your faves")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.discussion
    },
    style: ([_vm.tabs.discussion ? {
      'borderBottom': '3px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '0px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.switchTab('discussion')
      }
    }
  }, [_c('a', {
    style: ([_vm.tabs.discussion ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("account")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.coolFeatures
    },
    attrs: {
      "id": "tabs-5"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.userProgressTakeaways) ? _c('h2', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('strong', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Look what You’ve Accomplished!")])]) : _c('h2', {
    staticClass: "heading"
  }, [_c('strong', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.progressHeading1))])]), _vm._v(" "), (!_vm.userProgressTakeaways) ? _c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Now is the BEST time to invest in YOU.")]) : _c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.progressHeading2))]), _vm._v(" "), (_vm.userProgressTakeaways) ? _c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.progressHeading3))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 bottom-margin"
  }, [_c('div', {
    staticClass: "progressbarsholder",
    class: {
      'expand': _vm.expandPlaylistPanel
    },
    style: ({
      backgroundColor: _vm.getCorpHeaderColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    })
  }, [(_vm.isPlaylistWatched) ? _c('h3', [_vm._v("Playlists in Progress")]) : _c('h3', [_vm._v("Playlists for You")]), _vm._v(" "), _vm._l((_vm.userProgressPlaylists), function(playlist) {
    return _c('div', [_c('h4', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.playProgressPlaylist(playlist.playlistId, playlist.playlistTypeDesc, playlist.title, playlist.lastSeenVideoCode, playlist.lastSeenVideoTitle)
        }
      }
    }, [_vm._v(_vm._s(playlist.title))]), _vm._v(" "), _c('div', {
      staticClass: "progessandstar"
    }, [_c('div', {
      staticClass: "progress  mb-3"
    }, [_c('div', {
      staticClass: "progress-bar",
      style: (_vm.returnProgressStyle(Math.round(playlist.percentWatched))),
      attrs: {
        "d": "",
        "role": "progressbar",
        "aria-valuenow": "75",
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }
    })]), _vm._v(" "), (Math.round(playlist.percentWatched) === 100) ? _c('i', {
      staticClass: "fa fa-star"
    }) : _vm._e()])])
  }), _vm._v(" "), _c('button', {
    staticClass: "downbutton",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    on: {
      "click": function($event) {
        _vm.expandPlaylistPanel = !_vm.expandPlaylistPanel
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down"
  })])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 bottom-margin"
  }, [_c('div', {
    staticClass: "pinkputlinepannel",
    class: {
      'expand': _vm.expandEventsAttendedPanel
    },
    style: ({
      borderWidth: '5px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    })
  }, [(_vm.userProgressEventsAttended && _vm.userProgressEventsAttended.length > 0) ? _c('div', [_c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Events Attended")]), _vm._v(" "), _c('ul', _vm._l((_vm.userProgressEventsAttended), function(event) {
    return _c('li', {
      staticClass: "mobile-event-star"
    }, [_c('i', {
      staticClass: "fa fa-star showmobile"
    }), _vm._v(_vm._s(event.event_title)), _c('strong', [_vm._v(" --  " + _vm._s(event.expert_name) + " ")])])
  }), 0)]) : _c('div', [(_vm.upcomingProfileEvent && _vm.upcomingProfileEvent.start_date !== null) ? _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Upcoming Event")]) : _vm._e(), _vm._v(" "), (_vm.upcomingProfileEvent && _vm.upcomingProfileEvent.start_date !== null && _vm.getExpert) ? _c('h4', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/event')
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.upcomingProfileEvent.title) + " with " + _vm._s(_vm.getExpert[0].name) + " on " + _vm._s(_vm.getDateReference(_vm.upcomingProfileEvent.start_date, 'str')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.upcomingProfileEvent) ? _c('h4', {
    staticStyle: {
      "text-align": "justify",
      "text-justify": "inter-word"
    }
  }, [_vm._v(_vm._s(_vm.upcomingProfileEvent.longDescription))]) : _vm._e(), _vm._v(" "), (_vm.upcomingProfileEvent && _vm.upcomingProfileEvent.start_date !== null) ? _c('h5', [_vm._v(_vm._s(_vm.getDateReference(_vm.upcomingProfileEvent.start_date, 'str')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('button', {
    staticClass: "downbutton",
    on: {
      "click": function($event) {
        _vm.expandEventsAttendedPanel = !_vm.expandEventsAttendedPanel
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down",
    style: ({
      color: _vm.getCorpHeaderColor + ' !important'
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pinkputlinepannel",
    class: {
      'expand': _vm.expandVideosWatchedPanel
    },
    style: ({
      borderWidth: '5px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    })
  }, [(_vm.isSectionWatched) ? _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Videos Watched")]) : _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Here are some videos to get your started")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('ul', _vm._l((_vm.userProgressVideosWatched), function(video) {
    return _c('li', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.playWatchedVideo(video.video_code, video.video_title)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(video.video_title))])])
  }), 0)]), _vm._v(" "), (_vm.isSectionWatched) ? _c('div', {
    staticClass: "col-md-4 watcedvideotitle",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("\n                                            TOTAL WATCHED "), _c('br'), _vm._v(" "), (_vm.userProgressVideosWatched) ? _c('span', {
    staticClass: "totalwatched"
  }, [_vm._v("\n                                               " + _vm._s(_vm.userProgressVideosWatched.length) + "\n                                            ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "downbutton",
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    on: {
      "click": function($event) {
        _vm.expandVideosWatchedPanel = !_vm.expandVideosWatchedPanel
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 bottom-margin"
  }, [_c('div', {
    staticClass: "takeawaysholder",
    class: {
      'expand': _vm.expandTakeawayPanel
    }
  }, [_c('h3', [_vm._v("TONE TAKEAWAYS")]), _vm._v(" "), _vm._l((_vm.userProgressTakeaways), function(takeaways) {
    return (_vm.userProgressTakeaways && _vm.userProgressTakeaways.length > 0) ? _c('div', [_c('h4', [_c('strong', [_vm._v(_vm._s(takeaways.video_title))])]), _vm._v(" "), _c('ul', _vm._l((takeaways.tone_takeaways), function(tk) {
      return _c('li', [_c('strong', [_vm._v(_vm._s(tk))])])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()
  }), _vm._v(" "), (!_vm.userProgressTakeaways) ? _c('div', [_vm._m(0), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.progressEmptyTakeawayHdng1))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.progressEmptyTakeawayHdng2))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.progressEmptyTakeawayHdng3))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.progressEmptyTakeawayHdng4))])])]) : _vm._e(), _vm._v(" "), (_vm.userProgressTakeaways && _vm.userProgressTakeaways.length > 0) ? _c('button', {
    staticClass: "downbutton",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    on: {
      "click": function($event) {
        _vm.expandTakeawayPanel = !_vm.expandTakeawayPanel
      }
    }
  }, [(_vm.expandTakeawayPanel) ? _c('span') : _c('span', [_vm._v(_vm._s(_vm.userProgressTakeaways ? 'MORE TAKEAWAYS' : ''))]), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.videos
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthUserFavVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.getAuthUserFavVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v("\n                                        " + _vm._s(video.title) + "\n                                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "btn-group plusicon"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(1, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                    "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Remove Video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o activeIcons",
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.getAuthUserFavVideos && _vm.getAuthUserFavVideos.length == 0) ? _c('div', [_vm._m(3)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.playlist
    },
    attrs: {
      "id": "tabs-2"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.personalPlaylistTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.userPersonalPlaylists) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.userPersonalPlaylists), function(playlist) {
    return (playlist.userPlaylistVideos) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', [_c('div', {
      staticClass: "viderowraper",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', {
      staticClass: "favnumbers",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(playlist.allVidDurInMinutes))]), _c('small', [_vm._v("mins")])]), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "title": "Play"
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "title": "Remove"
      },
      on: {
        "click": function($event) {
          return _vm.removePlaylist(playlist.playlistId)
        }
      }
    }), (playlist.haveCorporationVideo === 0 && ((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.sharePersonalPlaylistPermission >= 1))) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.showSharingModal(playlist, 'personal')
        }
      }
    }) : _vm._e(), (playlist.haveCorporationVideo === 1) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "This playlist contains videos which are private and cannot be shared"
      },
      on: {
        "click": function($event) {
          return _vm.showPrivateVideoShareMsg()
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)
        }
      }
    }, [_vm._v(" " + _vm._s(playlist.title))])])]) : _vm._e()
  }), 0) : _c('div', [_c('h1', {
    staticClass: "favesText",
    attrs: {
      "text-center": "",
      "text-muted": "",
      "margin-bottom-40": ""
    }
  }, [_vm._v("Your personal playlists folder is empty. Start saving your video collection today by clicking the "), _c('span', [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" icon next to any video to create your first playlist")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.userCorpSharedPlaylists) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [(_vm.user.corporation.playlistHeading) ? _c('h3', [_vm._v(_vm._s(_vm.user.corporation.playlistHeading))]) : _c('h3', [_vm._v(_vm._s(_vm.corpPlaylistTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.userCorpSharedPlaylists) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.userCorpSharedPlaylists), function(playlist) {
    return (playlist.userPlaylistVideos) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', [_c('div', {
      staticClass: "viderowraper",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', {
      staticClass: "favnumbers",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(playlist.allVidDurInMinutes))]), _c('small', [_vm._v("mins")])]), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "title": "Play"
      },
      on: {
        "click": function($event) {
          return _vm.playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpPlaylistShareOptnPermission >= 1))) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.showSharingModal(playlist, 'corporate')
        }
      }
    }) : _vm._e(), (playlist.haveCorporationVideo === 1) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "This playlist contains videos which are private and cannot be shared"
      },
      on: {
        "click": function($event) {
          return _vm.showPrivateVideoShareMsg()
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }, [_vm._v(" " + _vm._s(playlist.title))])])]) : _vm._e()
  }), 0) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.userCuratedPlaylists) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.trendingPlaylistTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.userCuratedPlaylists) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.userCuratedPlaylists), function(playlist) {
    return (playlist.userPlaylistVideos) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', [_c('div', {
      staticClass: "viderowraper",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', {
      staticClass: "favnumbers",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(playlist.allVidDurInMinutes)), _c('small', [_vm._v("mins")])])]), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "title": "Play"
      },
      on: {
        "click": function($event) {
          return _vm.playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }), (playlist.haveCorporationVideo === 0 && ((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareTrendingPlaylistPermission >= 1))) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.showSharingModal(playlist, 'trending')
        }
      }
    }) : _vm._e(), (playlist.haveCorporationVideo === 1) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "This playlist contains videos which are private and cannot be shared"
      },
      on: {
        "click": function($event) {
          return _vm.showPrivateVideoShareMsg()
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }, [_vm._v(" " + _vm._s(playlist.title))])])]) : _vm._e()
  }), 0) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.chat
    },
    attrs: {
      "id": "tabs-3"
    }
  }, [_c('div', {
    staticClass: "container personalize"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-12  interestlist"
  }, [_c('div', [_vm._m(5), _vm._v(" "), (_vm.getAllInterests && _vm.getUserInterests) ? _c('div', {
    staticClass: "interest-container"
  }, [_c('button-group', {
    model: {
      value: (_vm.interestIndexes),
      callback: function($$v) {
        _vm.interestIndexes = $$v
      },
      expression: "interestIndexes"
    }
  }, [_vm._l((_vm.getAllInterests), function(interest, interestId) {
    return _c('span', [_c('span', [_c('checkbox', {
      key: interestId,
      staticClass: "min-padding checkbox-btn",
      style: (_vm.styleInterestObject(interestId)),
      attrs: {
        "true-value": interestId
      }
    }, [_vm._v("\n                                                            " + _vm._s(interest.interestName) + "\n                                                        ")])], 1)])
  }), _vm._v(" "), (_vm.getAllInterests) ? _c('button', {
    staticClass: "min-padding checkbox-btn",
    style: ([_vm.toggleStatus ? {
      color: '#FFFFFF !important',
      backgroundColor: this.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    } : {
      color: _vm.getCorpButtonColor + '!important',
      backgroundColor: '#FFFFFF !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    }]),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleStatus = !_vm.toggleStatus
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gift fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" I want it all!")]) : _vm._e()], 2)], 1) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "interest-container",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('button-group', {
    staticStyle: {
      "margin": "25px"
    },
    model: {
      value: (_vm.selectedDays),
      callback: function($$v) {
        _vm.selectedDays = $$v
      },
      expression: "selectedDays"
    }
  }, _vm._l((_vm.daysOfWeek), function(day, index) {
    return _c('span', [_c('span', [_c('checkbox', {
      key: index,
      staticClass: "min-padding checkbox-btn-days",
      style: (_vm.styleDays(index)),
      attrs: {
        "true-value": index
      }
    }, [_vm._v("\n                                                                " + _vm._s(day) + "\n                                                            ")])], 1)])
  }), 0)], 1)])]), _vm._v(" "), _c('button', {
    staticClass: "updateInterest",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    }),
    attrs: {
      "type": "button",
      "disabled": _vm.interestIndexes.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.updateInterests()
      }
    }
  }, [_vm._v("\n                                        UPDATE\n                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.discussion
    },
    attrs: {
      "id": "tabs-4"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [((_vm.getCardExpiryDays < 0 && _vm.user.ccExpAlarmFlag === 2)) ? _c('h3', {
    staticClass: "pinkh3"
  }, [_vm._v("You payment method has expired. Please update your information to access your TONE account.")]) : _vm._e(), _vm._v(" "), ((_vm.user.ccExpAlarmFlag === 2 && (_vm.getCardExpiryDays > 0 && _vm.getCardExpiryDays < 5)) && _vm.user.ccExpiryDate) ? _c('h3', {
    staticClass: "pinkh3"
  }, [_vm._v("You payment method is expiring in " + _vm._s(_vm.getCardExpiryDays) + " "), (_vm.getCardExpiryDays > 1) ? _c('span', [_vm._v("days.")]) : _c('span', [_vm._v("day.")]), _vm._v(" Please update your information to access your TONE account.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row accountContentBox"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "accountLeft"
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('span', [(_vm.user.picture) ? _c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile.png",
      "alt": "USER-PROFILE",
      "title": "Profile Image"
    }
  }) : _vm._e()]) : _c('span', [(_vm.user.picture) ? _c('img', {
    attrs: {
      "src": _vm.getRelatedImage(_vm.user.picture),
      "alt": "USER-SHOE",
      "title": "Profile Image"
    }
  }) : _vm._e()]), _vm._v(" "), _vm._v("\n                                        Profile Image\n                                    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('span') : _c('span', [(_vm.imageText) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.imageText)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getDefaultImages) ? _c('div', {
    staticClass: "slider responsive-slick-imagelist"
  }, _vm._l((_vm.getDefaultImages), function(getDefaultImage) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": getDefaultImage.smallImgUrl,
        "alt": getDefaultImage.title,
        "title": getDefaultImage.title
      },
      on: {
        "click": function($event) {
          return _vm.setDefaultImage(getDefaultImage)
        }
      }
    }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.user.picture !== getDefaultImage.smallImgUrl) ? _c('button', {
      staticClass: "carousalbutton",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      }),
      on: {
        "click": function($event) {
          return _vm.setDefaultImage(getDefaultImage)
        }
      }
    }, [_vm._v("\n                                                    Select\n                                                ")]) : _vm._e(), _vm._v(" "), (_vm.user.picture === getDefaultImage.smallImgUrl) ? _c('button', {
      staticClass: "carousalbutton selected",
      attrs: {
        "diabled": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" Selected\n                                                ")]) : _vm._e()])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [(_vm.user && (_vm.user.corporation && _vm.user.corporation.enableCorporatePage === 1)) ? _c('button', {
    staticClass: "btn formButton btn-block",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('corporation/mycommunity')
      }
    }
  }, [_vm._v("Enter My Community Page\n                                    ")]) : _vm._e(), _vm._v(" "), (_vm.user && (_vm.user.corporation && _vm.user.corporation.pageAdmin === _vm.user.userId)) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/corporation/manage-page')
      }
    }
  }, [_c('h4', [_vm._v("Manage Custom Features")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accountRight"
  }, [_c('form', [_c('div', {
    staticClass: "formName"
  }, [_c('h4', [_vm._v("Name: "), _c('a', {
    class: {
      hidden: _vm.showUpdateNameBox
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdateName
    }
  }, [_vm._v("update")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName) + " ")]), _vm._v(" "), _c('form', {
    staticClass: "updateName",
    class: {
      hidden: !_vm.showUpdateNameBox
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onNameSubmit()
      }
    }
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "profile_updatedfirstname",
      "type": "text",
      "placeholder": "First Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.updatedFirstName),
      callback: function($$v) {
        _vm.updatedFirstName = $$v
      },
      expression: "updatedFirstName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "profile_updatedlastname",
      "type": "text",
      "placeholder": "Last Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.updatedLastName),
      callback: function($$v) {
        _vm.updatedLastName = $$v
      },
      expression: "updatedLastName"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdateName
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit",
      "id": "profile_updatename",
      "disabled": _vm.spinner
    }
  }, [_vm._v("Update\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "formName"
  }, [(_vm.user.status.toLowerCase() === 'register' || _vm.user.status.toLowerCase() === 'registered') ? _c('div', [_vm._m(7)]) : _c('div', [_c('h4', [_vm._v("Email: "), _c('a', {
    class: {
      hidden: _vm.showUpdateEmailBox
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdateEmail
    }
  }, [_vm._v("change")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('form', {
    staticClass: "updateName",
    class: {
      hidden: !_vm.showUpdateEmailBox
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onEmailChangeSubmit.apply(null, arguments)
      }
    }
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "profile_oldEmail",
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    model: {
      value: (_vm.oldPasswordForEmail),
      callback: function($$v) {
        _vm.oldPasswordForEmail = $$v
      },
      expression: "oldPasswordForEmail"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /\S+@\S+\.\S+/,
      "id": "profile_new_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "New Email Address",
      "name": "email",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.newEmail),
      callback: function($$v) {
        _vm.newEmail = $$v
      },
      expression: "newEmail"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdateEmail
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit",
      "id": "profile_updateEmail",
      "disabled": _vm.spinner
    }
  }, [_vm._v("Update\n                                                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "formName"
  }, [_c('h4', [_vm._v("Password: "), _c('a', {
    class: {
      hidden: _vm.showUpdatePasswordBox
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdatePassword
    }
  }, [_vm._v("change")])]), _vm._v(" "), _c('h5', [_vm._v("******************")]), _vm._v(" "), _c('form', {
    staticClass: "updateName",
    class: {
      hidden: !_vm.showUpdatePasswordBox
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onPasswordSubmit.apply(null, arguments)
      }
    }
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "profile_oldpassword",
      "type": "password",
      "placeholder": "Old Password",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.oldPassword),
      callback: function($$v) {
        _vm.oldPassword = $$v
      },
      expression: "oldPassword"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "minlength": 6,
      "id": "profile_newpassword",
      "error": "Password is Required",
      "type": "password",
      "placeholder": "Password",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.updatedPassword),
      callback: function($$v) {
        _vm.updatedPassword = $$v
      },
      expression: "updatedPassword"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "minlength": 6,
      "id": "profile_confirmPassword",
      "error": "Confirm Password is Required",
      "type": "password",
      "placeholder": "Confirm Password",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdatePassword
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit",
      "id": "profile_updatepassword",
      "disabled": _vm.spinner
    }
  }, [_vm._v("Update\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1), _vm._v(" "), _c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.verifyPassword()),
      expression: "!verifyPassword()"
    }],
    attrs: {
      "placement": "top",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "profile_pwderrormsg"
    }
  }, [_vm._v(_vm._s(_vm.passwordError))])])], 1), _vm._v(" "), (_vm.getProfileCharitySection) ? _c('div', {
    staticClass: "formName"
  }, [_c('h4', [_vm._v("Selected Charity: "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCharityUpdate),
      expression: "!isCharityUpdate"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.isCharityUpdate = true
      }
    }
  }, [_vm._v("update")])]), _vm._v(" "), (_vm.getSelectedCharity && _vm.getSelectedCharity !== '{}') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.getSelectedCharity.img_url,
      "alt": "Selected Charity",
      "title": _vm.getSelectedCharity.name
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "SelectedCharityName"
  }, [_vm._v(_vm._s(_vm.getSelectedCharity.name))])]) : _vm._e(), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCharityUpdate),
      expression: "isCharityUpdate"
    }],
    staticClass: "updateName selectedCharityBtn",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateCharity.apply(null, arguments)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.isCharityUpdate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit",
      "id": ""
    }
  }, [_vm._v("Update\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.getAlertMsgStatus) ? _c('div', {
    staticClass: "formName",
    class: {
      highlight: (_vm.getCardExpiryDays < 5 && _vm.user.ccExpAlarmFlag === 2)
    }
  }, [_c('h4', {
    attrs: {
      "id": "updatepaymentmethod"
    }
  }, [_vm._v("Payment Method:"), _c('a', {
    class: {
      hidden: _vm.showPaymentBox
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdatePayment
    }
  }, [_vm._v("change")])]), _vm._v(" "), (!_vm.isStripe) ? _c('div', {
    staticClass: "row notstripes"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.isStripe) ? _c('h5', [_vm._v("PayPal")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center margin-top-10 margin-bottom-10",
    attrs: {
      "id": "paypal-button"
    }
  }), _vm._v(" "), (_vm.userPayments.paymentMethodNonce) ? _c('span', {
    staticClass: "icon-info-circled alert-icon-float-left success"
  }, [_vm._m(8)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isStripe && _vm.getCreditCardInfo) ? _c('h5', {
    staticClass: "paymentmethodh5"
  }, [_vm._v(_vm._s(_vm.getCreditCardInfo))]) : _vm._e(), _vm._v(" "), _c('h6', [_c('a', {
    class: {
      hidden: _vm.showPaymentHistoryBox
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showPaymentHistory
    }
  }, [_vm._v("View Billing History")])]), _vm._v(" "), _c('form', {
    staticClass: "updateName",
    class: {
      hidden: !_vm.showPaymentBox
    },
    attrs: {
      "action": "/charge",
      "method": "post",
      "id": "payment-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onNewCardSubmit.apply(null, arguments)
      }
    }
  }, [(_vm.isStripe) ? _c('div', {
    staticClass: "field",
    attrs: {
      "id": "card-element"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-errors",
      "role": "alert"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showUpdatePayment
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    style: ({
      backgroundColor: _vm.getCorpHeaderColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit",
      "id": "profile_changecc",
      "disabled": _vm.showPaymentHistoryBox
    }
  }, [_vm._v("Update\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)]), _vm._v(" "), (_vm.showPaymentHistoryBox) ? _c('div', [_c('br'), _vm._v(" "), _c('h5', [_vm._v("Billing History")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getBillingHistory) ? _c('div', [(_vm.getBillingHistory) ? _c('table', {
    staticClass: "table table--lg team-roster-table table-hover"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', _vm._l((_vm.getBillingHistory), function(record) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(record.paymentDateFmt))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(record.paymentType))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v("$" + _vm._s(record.paidAmountFmt))])])
  }), 0)]) : _vm._e()]) : _c('div', [_c('h6', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("No record to display!")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showPaymentHistory
    }
  }, [_vm._v("Hide Billing History")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getAlertMsgStatus && _vm.getTrialDays <= 30 && (_vm.user && _vm.user.corporation === null || _vm.user && _vm.user.corporation && _vm.user.corporation.trialExpiryMsgFlag)) ? _c('div', {
    staticClass: "formName"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/becomemember')
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.expiredTrialMessage))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "formName"
  }, [(_vm.user.status === 'CANCELLED') ? _c('div', [_c('h3', {
    staticClass: "alert alert-danger"
  }, [_vm._v("Request for Cancellation has been sent. Check your email for confirmation")])]) : _c('div', [_c('h4', [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelSubscription()
      }
    }
  }, [_vm._v("cancel")])]), _vm._v(" "), _c('h5', [_vm._v("Cancel Your Subscription")])])])])])])])])])])])]), _vm._v(" "), (_vm.showSharedModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showSharedModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "method": "post",
      "id": "playlistshare-form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSharePlaylist.apply(null, arguments)
      }
    }
  }, [_c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedMessage",
      "id": "playlistshare_sharedMessage",
      "type": "text",
      "error": "Optional Message",
      "placeholder": "Optional Message",
      "autocomplete": "off",
      "icon": ""
    },
    model: {
      value: (_vm.sharePayload.sharedEmailMessage),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedEmailMessage", $$v)
      },
      expression: "sharePayload.sharedEmailMessage"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedEmailMessagePreview",
      "id": "playlistshare_sharedEmailMessagePreview",
      "type": "textarea",
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.sharePayload.sharedPlaylistPreview),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedPlaylistPreview", $$v)
      },
      expression: "sharePayload.sharedPlaylistPreview"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "disabled": _vm.spinner || (_vm.taggedEmails && _vm.taggedEmails.length === 0)
    }
  }, [_vm._v("\n                                Send Email\n                                "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showShareCommunity) ? _c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]) : _vm._e(), _vm._v(" "), (_vm.showShareIndividual) ? _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.showShareFriends) ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.corpShareModalImage,
      "alt": _vm.corpShareModalTitle,
      "title": _vm.corpShareModalTitle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s((_vm.corpShareModalTitle + " | TONE Networks")))]), _vm._v(" "), (_vm.corpShareModalDesc) ? _c('p', [_vm._v(" " + _vm._s(((_vm.corpShareModalDesc.substring(0,250)) + "...")))]) : _vm._e(), _vm._v(" "), (!_vm.corpShareModalDesc) ? _c('p', [_vm._v(_vm._s(_vm.user.firstName) + "'s Personal Playlist")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess)) || (_vm.shareInProcess)
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share This Playlist\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('strong', [_vm._v("make it easy!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "favesText",
    attrs: {
      "text-center": "",
      "text-muted": "",
      "margin-bottom-40": ""
    }
  }, [_vm._v("Your faves folder is empty. Start saving your bite-sized collection today by clicking the "), _c('span', [_c('i', {
    staticClass: "fa fa-x fa-heart-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" after watching a clip you love")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "personalizeText"
  }, [_vm._v("\n                                       As part of your membership, TONE delivers two, short videos chosen specifically for you based on your selected preferences.\n                                       Tell us what you like and we’ll send you more of the content you love!\n                                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7 box-size"
  }, [_c('div', {
    staticClass: "main-content text-left pt-3"
  }, [_c('hr'), _vm._v(" "), _c('h2', {
    staticClass: "profile-heading"
  }, [_vm._v("\n                                                Topics Of Interest:\n                                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerlevel3 text-left"
  }, [_c('h3', {
    staticClass: "profile-heading"
  }, [_vm._v("TONE Teaser Delivery Days (choose at least two days):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "alert alert-info"
  }, [_vm._v("Your new email account needs to be validated. "), _c('br'), _vm._v(" Check your email and follow the link")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Payment successfully authorized with Paypal")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6144c6ea", module.exports)
  }
}

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("\n                    Gift Purchase\n                ")]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "signup_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('div', {
    staticClass: "panel panel-default text-left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('br'), _vm._v(" "), (_vm.giftPlans) ? _c('div', {
    staticClass: "gifts row"
  }, _vm._l((this.giftPlans), function(plan) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "gift-item"
    }, [_c('h5', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.packageId),
        expression: "packageId"
      }],
      attrs: {
        "type": "radio",
        "name": "pkg"
      },
      domProps: {
        "value": plan.packageId,
        "checked": plan.packageId == _vm.packageId,
        "checked": _vm._q(_vm.packageId, plan.packageId)
      },
      on: {
        "change": function($event) {
          _vm.packageId = plan.packageId
        }
      }
    }), _c('br'), _c('strong', [_vm._v("Gift of TONE")]), _vm._v(" "), _c('br'), _c('small', [_vm._v(_vm._s(plan.description))])]), _vm._v(" "), (_vm.packageId !== plan.packageId) ? _c('button', {
      on: {
        "click": function($event) {
          _vm.packageId = plan.packageId
        }
      }
    }, [_vm._v("$" + _vm._s(plan.amountFmt))]) : _vm._e(), _vm._v(" "), (_vm.packageId === plan.packageId) ? _c('button', {
      staticClass: "active",
      on: {
        "click": function($event) {
          _vm.packageId = plan.packageId
        }
      }
    }, [_vm._v("$" + _vm._s(plan.amountFmt))]) : _vm._e()])])
  }), 0) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    attrs: {
      "id": "giftee_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addGiftee.apply(null, arguments)
      }
    }
  }, [(_vm.gifteeValidated) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('br'), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z ]+$/,
      "id": "giftee_firstname",
      "type": "text",
      "error": "First Name (no digits allowed)",
      "placeholder": "First Name",
      "name": "gifteeFirstName",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.giftee.gifteeFirstName),
      callback: function($$v) {
        _vm.$set(_vm.giftee, "gifteeFirstName", $$v)
      },
      expression: "giftee.gifteeFirstName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z ]+$/,
      "id": "giftee_lastname",
      "type": "text",
      "error": "Last Name (no digits allowed)",
      "placeholder": "Last Name",
      "name": "gifteeLastName",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.giftee.gifteeLastName),
      callback: function($$v) {
        _vm.$set(_vm.giftee, "gifteeLastName", $$v)
      },
      expression: "giftee.gifteeLastName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /\S+@\S+\.\S+/,
      "id": "giftee_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "name": "gifteeEmail",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.giftee.gifteeEmail),
      callback: function($$v) {
        _vm.$set(_vm.giftee, "gifteeEmail", $$v)
      },
      expression: "giftee.gifteeEmail"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "giftee_comments",
      "type": "textarea",
      "error": "Comments",
      "placeholder": "Message",
      "name": "gifteeDeliveryMessage",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.giftee.deliveryMessage),
      callback: function($$v) {
        _vm.$set(_vm.giftee, "deliveryMessage", $$v)
      },
      expression: "giftee.deliveryMessage"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Delivery Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giftee.deliveryDate),
      expression: "giftee.deliveryDate"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "gifteeDeliveryDate",
      "required": "",
      "id": "delivery",
      "type": "date",
      "data-date-format": "mm/dd/yyyy",
      "min": _vm.returnMinimumDate(),
      "title": _vm.dateErrorMessage,
      "placeholder": "Delivery Date"
    },
    domProps: {
      "value": (_vm.giftee.deliveryDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giftee, "deliveryDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.addMessage) + "\n                                            ")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.gifteeCol.length > 0) ? _c('h4', [_vm._v("Recipients")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.gifteeCol.length > 0) ? _c('table', [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.gifteeCol), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry.gifteeFirstName) + " " + _vm._s(entry.gifteeLastName)), _c('br'), _vm._v("\n                                                    " + _vm._s(entry.gifteeEmail) + "\n                                                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getPackageInfo(entry.packageId)[0].description) + " $" + _vm._s(_vm.getPackageInfo(entry.packageId)[0].amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.deliveryMessage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.returnFormatedDate(entry.deliveryDate, 'A')))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn formButton",
      on: {
        "click": function($event) {
          return _vm.removeGiftee(entry)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.gifteeCol.length > 0) ? _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "jumbotron text-center"
  }, [_c('p', [_vm._v("Total Recipients : "), _c('b', [_vm._v(_vm._s(_vm.gifteeCol.length))])]), _vm._v(" "), _c('p', [_vm._v("Total Amount: "), _c('b', [_vm._v("$" + _vm._s(this.totalAmount))])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true
    }
  }, [_c('panel', {
    staticClass: "text-left",
    attrs: {
      "is-open": true
    }
  }, [_c('h4', [_c('span', [_vm._v("3.")]), _vm._v(" Your Information")]), _vm._v(" "), _c('div', {
    staticClass: "create-account"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "action": "/charge",
      "method": "post",
      "id": "payment-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onPaymentSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus"
  }, [(!_vm.user) ? _c('div', [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z ]+$/,
      "id": "gifter_firstname",
      "type": "text",
      "error": "First Name (no digits allowed)",
      "placeholder": "First Name",
      "name": "gifterFirstName",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.gifter.firstName),
      callback: function($$v) {
        _vm.$set(_vm.gifter, "firstName", $$v)
      },
      expression: "gifter.firstName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z ]+$/,
      "id": "gifter_lastname",
      "type": "text",
      "error": "Last Name (no digits allowed)",
      "placeholder": "Last Name",
      "name": "gifterLastName",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.gifter.lastName),
      callback: function($$v) {
        _vm.$set(_vm.gifter, "lastName", $$v)
      },
      expression: "gifter.lastName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /\S+@\S+\.\S+/,
      "id": "gifter_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "name": "gifterEmail",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.gifter.email),
      callback: function($$v) {
        _vm.$set(_vm.gifter, "email", $$v)
      },
      expression: "gifter.email"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.gateway === 'CC') ? _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "paymentMethod_cardHolder",
      "pattern": /^[A-Za-z ]+$/,
      "type": "text",
      "error": "Card Holder Name (no digits allowed)",
      "placeholder": "Card Holder Name",
      "name": "gifterCardHolderName",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.gifter.cardHolderName),
      callback: function($$v) {
        _vm.$set(_vm.gifter, "cardHolderName", $$v)
      },
      expression: "gifter.cardHolderName"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "radiowrapper"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "CLASS": "codediv"
    }
  }, [(_vm.isStripe) ? _c('div', {
    staticClass: "stripeholder"
  }, [_c('i', {
    staticClass: "fa fa-lock overlapstripe"
  }), _vm._v(" "), _c('div', {
    staticClass: "field",
    attrs: {
      "id": "card-element"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.gateway === 'paypal') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center margin-top-10 margin-bottom-10",
    attrs: {
      "id": "paypal-button"
    }
  })]), _vm._v(" "), (_vm.userPayments.paymentMethodNonce) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left success"
  }, [_c('p', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Payment successfully authorized with Paypal")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.stripeErrorMessage) ? _c('div', {
    staticStyle: {
      "color": "#a94442",
      "margin": "2px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.stripeErrorMessage))]) : _vm._e(), _vm._v(" "), _c('checkbox', {
    staticClass: "terms-and-condition",
    attrs: {
      "value": "isChecked",
      "type": "primary"
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n                                                         I agree to "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "_blank"
    }
  }, [_vm._v("terms and conditions")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "id": "signup_button",
      "disabled": !_vm.isChecked || this.spinner
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Place Order\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])])])])])], 1)], 1)])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_c('span', [_vm._v("1.")]), _vm._v(" Gift Selection\n                                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_c('span', [_vm._v("2.")]), _vm._v("Gift Recipient\n                                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Recipient")]), _vm._v(" "), _c('th', [_vm._v("Package")]), _vm._v(" "), _c('th', [_vm._v("Message")]), _vm._v(" "), _c('th', [_vm._v("Delivery Date")]), _vm._v(" "), _c('th', [_vm._v(" ")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6374f53f", module.exports)
  }
}

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "info",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.isBlankField),
      callback: function($$v) {
        _vm.isBlankField = $$v
      },
      expression: "isBlankField"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign fa-2x pull-left"
  }), _vm._v(" "), _c('p', {
    staticClass: "margin-top-5"
  }, [_vm._v("Please type something, the input field seems to be blank.")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span'), _vm._v(" "), (!_vm.user && (_vm.getSearchResults ? _vm.getSearchResults.length : 0) !== 0 && _vm.currentPlan) ? _c('h3', [_vm._v("Gain access to expert videos in the topics that interest you"), (!_vm.isNativeApp) ? _c('span', [_vm._v(" for just $" + _vm._s(_vm.currentPlan.amount) + " a month! ")]) : _c('span', [_vm._v("!")]), _vm._v(" "), _c('br'), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.redirectToSignUp
    }
  }, [_c('strong', [_vm._v("Start your free trial today")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "id": "search_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.initiateSearch.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contentToSearch),
      expression: "contentToSearch"
    }],
    attrs: {
      "type": "text",
      "placeholder": "What can we help you find?"
    },
    domProps: {
      "value": (_vm.contentToSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contentToSearch = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      border: '1px solid' + _vm.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 margin-top-40"
  }, [_c('transition', {
    attrs: {
      "name": "slide-search-fade"
    }
  }, [(_vm.isEmptyResponse) ? _c('div', {
    staticClass: "text-center text-muted margin-bottom-40"
  }, [_c('h1', [_vm._v("No result found for "), _c('strong', [_vm._v(_vm._s(_vm.enteredValue))]), _vm._v("!")])]) : _vm._e(), _vm._v(" "), ((_vm.getSearchResults ? _vm.getSearchResults.length : 0) !== 0) ? _c('div', {
    staticClass: "text-center text-success"
  }, [_c('h1', [_vm._v("Search results for "), _c('strong', [_vm._v(_vm._s(_vm.enteredValue))])])]) : _vm._e()])], 1)]), _vm._v(" "), (!(this.searchResults === null && this.searchEventResults === null && this.searchPlaylistResult === null)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 margin-bottom-40"
  }, [_c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "tabs m-b-45"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.videos
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('videos')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("videos ("), _c('b', [_vm._v(_vm._s(_vm.getSearchPlaylistResults && _vm.getSearchResults.length ? _vm.getSearchResults.length : 0))]), _vm._v(")")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.events
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('events')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v(" Events ("), _c('b', [_vm._v(_vm._s(_vm.getSearchExpertResults && _vm.getSearchExpertResults.length ? _vm.getSearchExpertResults.length : 0))]), _vm._v(")")])]), _vm._v(" "), _c('li', {
    staticClass: "videoList",
    class: {
      current: _vm.tabs.playlists
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('playlists')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("Playlists ("), _c('b', [_vm._v(_vm._s(_vm.getSearchPlaylistResults && _vm.getSearchPlaylistResults.userPlaylists && _vm.getSearchPlaylistResults.userPlaylists.length ? _vm.getSearchPlaylistResults.userPlaylists.length : 0))]), _vm._v(")")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.videos
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [((_vm.getSearchResults ? _vm.getSearchResults.length : 0) !== 0) ? _c('div', {
    staticClass: "container__header"
  }, [_c('div', {
    staticClass: "container__header-item",
    on: {
      "click": function($event) {
        return _vm.sort('expertname')
      }
    }
  }, [_vm._v("\n                                    Sort By Expert\n                                    "), _c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container__header-item",
    on: {
      "click": function($event) {
        return _vm.sort('_score')
      }
    }
  }, [_vm._v("\n                                    Sort By Rating\n                                    "), _c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row video-row"
  }, _vm._l((_vm.limitTo(_vm.searchResults)), function(result) {
    return (_vm.searchResults && _vm.searchResults) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [(_vm.user) ? _c('div', [_c('router-link', {
      staticClass: "nounderline",
      attrs: {
        "to": {
          path: '/watch/' + result.mediaid + '/' + result.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
        }
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": result.image,
        "alt": result.title,
        "title": result.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(result.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title"
    }, [_vm._v(_vm._s(result.title))])])], 1) : _c('div', [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": result.image,
        "alt": result.title,
        "title": result.title
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(result.videoCode, result.title)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(result.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title",
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(result.videoCode, result.title)
        }
      }
    }, [_vm._v(_vm._s(result.title))])]), _vm._v(" "), (_vm.user) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": result.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(result.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(1, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, result)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(result, playlist, _vm.verifyVideoExists(playlist, result))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                    "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(result.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(result.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(result.mediaid)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.getAuthUserVideos) ? _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(result)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(result)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.events
    },
    attrs: {
      "id": "tabs-2"
    }
  }, [_c('div', {
    staticClass: "row video-row"
  }, _vm._l((_vm.limitTo(_vm.searchEventResults)), function(result) {
    return (_vm.searchEventResults && _vm.searchEventResults.length > 0) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [(_vm.user) ? _c('div', [_c('router-link', {
      staticClass: "nounderline",
      attrs: {
        "to": {
          path: '/tonearchive/' + result.eventId + '/play/1/' + result.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
        }
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": result.img_url,
        "alt": result.title,
        "title": result.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(result.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title"
    }, [_vm._v(_vm._s(result.title))])])], 1) : _c('div', [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": result.img_url,
        "alt": result.title,
        "title": result.title
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(result.videoCode, result.title)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(result.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "cursor video-title",
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(result.videoCode, result.title)
        }
      }
    }, [_vm._v(_vm._s(result.title))])]), _vm._v(" "), (_vm.user) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": result.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(result.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(3, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, result)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(result, playlist, _vm.verifyVideoExists(playlist, result))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(result.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(result.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(result.mediaid)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.getAuthUserVideos) ? _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(result)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(result)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.playlists
    },
    attrs: {
      "id": "tabs-3"
    }
  }, [_c('div', {
    staticClass: "row video-row"
  }, [(_vm.getSearchPlaylistResults && _vm.getSearchPlaylistResults.userPlaylists && _vm.getSearchPlaylistResults.userPlaylists.length > 0) ? _c('span', _vm._l((_vm.limitTo(_vm.searchPlaylistResult)), function(playlist) {
    return (playlist.userPlaylistVideos) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('div', [_c('div', {
      staticClass: "viderowraper image-container",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [(playlist.userPlaylistType === 1) ? _c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)
        }
      }
    }) : _vm._e(), _vm._v(" "), (playlist.userPlaylistType === 2) ? _c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }) : _vm._e(), _vm._v(" "), (playlist.corporationId > 0) ? _c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(playlist.allVidDurInSeconds)))])]), _vm._v(" "), (playlist.userPlaylistType === 1) ? _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)
        }
      }
    }, [_vm._v(" " + _vm._s(playlist.title))]) : _vm._e(), _vm._v(" "), (playlist.userPlaylistType === 2) ? _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }, [_vm._v(" " + _vm._s(playlist.title))]) : _vm._e(), _vm._v(" "), (playlist.corporationId > 0) ? _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }, [_vm._v(" " + _vm._s(playlist.title))]) : _vm._e()])]) : _vm._e()
  }), 0) : _vm._e()])])]), _vm._v(" "), (_vm.tabs.videos) ? _c('span', [((_vm.getSearchResults ? _vm.getSearchResults.length : 0) > 6) ? _c('div', [_c('pagination', {
    ref: "searchResults",
    attrs: {
      "for": "searchResults",
      "per-page": _vm.pageLimit,
      "records": _vm.getSearchResults.length
    },
    on: {
      "paginate": function($event) {
        return _vm.setPage('videos', $event, 1)
      }
    },
    model: {
      value: (_vm.page.videos),
      callback: function($$v) {
        _vm.$set(_vm.page, "videos", $$v)
      },
      expression: "page.videos"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tabs.events) ? _c('span', [((_vm.getSearchExpertResults ? _vm.getSearchExpertResults.length : 0) > 6) ? _c('div', [_c('pagination', {
    ref: "searchEventResults",
    attrs: {
      "for": "searchEventResults",
      "per-page": _vm.pageLimit,
      "records": _vm.getSearchExpertResults.length
    },
    on: {
      "paginate": function($event) {
        return _vm.setPage('events', $event, 2)
      }
    },
    model: {
      value: (_vm.page.events),
      callback: function($$v) {
        _vm.$set(_vm.page, "events", $$v)
      },
      expression: "page.events"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tabs.playlists) ? _c('span', [((_vm.getSearchPlaylistResults && _vm.getSearchPlaylistResults.userPlaylists && _vm.getSearchPlaylistResults.userPlaylists.length ? _vm.getSearchPlaylistResults.userPlaylists.length : 0) > 6) ? _c('div', [_c('pagination', {
    ref: "searchPlaylistResult",
    attrs: {
      "for": "searchPlaylistResult",
      "per-page": _vm.pageLimit,
      "records": _vm.getSearchPlaylistResults.userPlaylists.length
    },
    on: {
      "paginate": function($event) {
        return _vm.setPage('playlists', $event, 3)
      }
    },
    model: {
      value: (_vm.page.playlists),
      callback: function($$v) {
        _vm.$set(_vm.page, "playlists", $$v)
      },
      expression: "page.playlists"
    }
  })], 1) : _vm._e()]) : _vm._e()])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-64c573f7", module.exports)
  }
}

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper profile",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container "
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Terms of Service")])])]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('p', [_vm._v("\n                    Last Modified: October 25, 2017\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    These Terms of Service (\""), _c('strong', [_vm._v("Terms of Service")]), _vm._v("\") govern your\n                    access to and use of the website located at "), _c('a', {
    attrs: {
      "href": "https://tonenetworks.com",
      "target": "_blank"
    }
  }, [_vm._v("https://tonenetworks.com\n                ")]), _vm._v("\n                    (the \""), _c('strong', [_vm._v("Website")]), _vm._v("\"), including any content, functionality and\n                    services offered on or through the Website, memberships, and any of our\n                    other products or services (collectively referred to as the \"    "), _c('strong', [_vm._v("Services")]), _vm._v("\"). The Website is owned and operated by ChartOne\n                    Media LLC, a Delaware limited liability company (\""), _c('strong', [_vm._v("ChartOne")]), _vm._v("\n                    \", \""), _c('strong', [_vm._v("we")]), _vm._v("\" or \""), _c('strong', [_vm._v("us")]), _vm._v("\").\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Please read the Terms of Service carefully before using the Services\n                    because they contain provisions that affect your rights and obligations,\n                    including a mandatory arbitration provision and a waiver of your right to\n                    participate in a class action. By using the Services, you accept and agree\n                    to be bound and abide by these Terms of Service and our Privacy Policy,\n                    found at\n                    "), _c('a', {
    attrs: {
      "href": "https://tonenetworks.com/privacypolicy",
      "target": "_new"
    }
  }, [_vm._v("\n                        https://tonenetworks.com/privacypolicy\n                    ")]), _vm._v("\n                    (\""), _c('strong', [_vm._v("Privacy Policy")]), _vm._v("\"), which are incorporated herein by\n                    reference. If you do not want to agree to these Terms of Service or the\n                    Privacy Policy, you must not access or use the Services.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    The Services are offered and available to individuals who are 18 years of\n                    age or older. By using the Services, you represent and warrant to ChartOne\n                    that you are 18 years of age or older and are otherwise capable of forming\n                    a legally binding contract with ChartOne, and that your use of the Services\n                    is consistent with our Terms of Service, our Privacy Policy, and all\n                    applicable law. If you do not meet these requirements, you must not access\n                    or use the Services.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    You acknowledge and confirm that (i) you have read and understand all of\n                    the terms, conditions, policies, provisions, disclosures and disclaimers\n                    contained herein, (ii) these Terms of Service have the same force and\n                    effect as a signed agreement, and (iii) you expressly accept and agree to\n                    be bound by the terms hereof.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Changes to these Terms of Service")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    We may modify these Terms of Service at any time in our sole discretion. We\n                    will post notice of changes to these Terms of Service on this page. Changes\n                    will not apply retroactively and will only become effective when (i) you\n                    use the Services after you know about the change, or (ii) thirty (30) days\n                    after they are posted, whichever is sooner. However, changes addressing new\n                    functions for a Service or changes made for legal reasons will be effective\n                    immediately. We will also update the Last Modified Date at the top of these\n                    Terms of Service accordingly. Your continued use of the Services after the\n                    Last Modified Date signifies your consent to the modified Terms of Service.\n                    You are expected to check this page frequently so you are aware of any\n                    changes, as they are binding on you. If the modified Terms of Service are\n                    not acceptable to you, you should not access or use the Services after the\n                    Last Modified Date and may cancel your membership (see \"Cancellations\"\n                    below).\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Data Privacy and Personal Information")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    By agreeing to these Terms of Service, you also consent to our Privacy\n                    Policy, which is incorporated by reference into these Terms of Service. If\n                    you live outside the United States, by agreeing to these Terms of Service\n                    you consent to the transfer and processing of your personal information in\n                    the United States in accordance with the Privacy Policy and U.S. law.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    You should not submit or upload personal information or any other\n                    information about yourself or others that you are not comfortable\n                    disclosing to the general public. This information will be viewable by\n                    other users of the Services, may be searchable on indexing websites such as\n                    Google, and may be disclosed to third parties under certain circumstances\n                    as provided in our Privacy Policy.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    By agreeing to these Terms of Service and our Privacy Policy, you\n                    acknowledge and agree that we have the right to display any or all of the\n                    information on your profile in our marketing materials and on our Website\n                    without obtaining your permission.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("International Users")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    ChartOne and the Services are operated from within the United States. If\n                    you access the Services from a location outside the United States, you are\n                    responsible for compliance with the laws of that jurisdiction regarding\n                    online conduct and acceptable content. ChartOne makes no claim that the\n                    content of the Services may be utilized, accessed or appropriate outside\n                    the United States. You must not access or use the Services from a territory\n                    that is embargoed by the United States or from which it is illegal to\n                    receive products, services, or software from the United States.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Third Party Links")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    The Services may link to independent third-party websites or social media\n                    widgets. Such hyperlinks are provided for your reference and convenience\n                    only. ChartOne is not liable for the availability or accuracy of such\n                    third-party sources, and you assume all risk in using them. When you link\n                    to them, these third-party sites or services may place cookies and other\n                    tracking technologies on your computer and may have different rules for\n                    using or sharing any personal information you submit to them. By using such\n                    third-party sources, sites, and/or sources, you agree to be bound by the\n                    terms, privacy policy, and other policies of such third-parties. We\n                    encourage you to read their privacy policies before submitting your\n                    personal information.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    When you access third party websites or interact or communicate with third\n                    parties through the Services, you do so at your own risk. ChartOne is not\n                    responsible for the actions, content, information, data, practices,\n                    policies or opinions of any third parties. You are solely responsible for\n                    your interactions with third parties and you should make whatever\n                    investigation you feel necessary or appropriate before proceeding with any\n                    online or offline interaction with any other person.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    If you have a dispute with one more third party websites or third parties,\n                    you hereby release us (and our officers, directors, agents, subsidiaries,\n                    joint ventures and employees) from claims, demands and damages (actual and\n                    consequential) of every kind and nature, known and unknown, arising out of\n                    or in any way connected with such disputes, including damages for loss of\n                    profits, goodwill, use, privacy or data. We reserve the right, but have no\n                    obligation, to become involved in any way with these disputes. If you are a\n                    California resident, you waive California Civil Code §1542, which\n                    says: \"A general release does not extend to claims which the creditor does\n                    not know or suspect to exist in his or her favor at the time of executing\n                    the release, which if known by him or her must have materially affected his\n                    settlement with the debtor.\" And, if you are not a California resident, you\n                    waive any applicable state statutes of a similar effect.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Registration")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    Using the Services requires you to create an account and accept our Terms\n                    of Service. To create an account, you must provide your email address, address, date of birth, and an accepted form of\n                    payment\n                    (see \"Payment Methods\" below). You may also select one or more areas of\n                    interests.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    By registering, you represent and warrant: (i) that all of the information\n                    that you provide, including any social media profiles and other links that\n                    you choose to add to your profile, is correct, current, and complete; (ii)\n                    that you have created an account for yourself and have not misrepresented\n                    your identity or created a false identity; and (iii) that you have not\n                    registered for any illegal purpose, to facilitate any illegal topic, or\n                    otherwise for the purpose of providing any illegal information. If you\n                    believe that your identity or someone else's identity has been\n                    misrepresented, please contact us immediately. You may also report other\n                    users who you believe to be in breach of this paragraph.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    You agree that all information you provide to register with or use the\n                    Services or otherwise is governed by our Privacy Policy, and you consent to\n                    all actions we take with respect to your information consistent with our\n                    Privacy Policy.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    You agree to keep your account information confidential and to not share\n                    your account with others. You agree to notify us immediately of any\n                    unauthorized access to your account or any other breach of security.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Payment Methods")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    In order to purchase a membership, you must pay by (1) credit card or (2)\n                    PayPal (\""), _c('strong', [_vm._v("Payment Method")]), _vm._v("\"). To pay by credit card, you must\n                    provide the full credit card number, the name on the credit card, the\n                    expiration date, the CVC number, and the billing address. The personal\n                    information that you provide to us will be collected, stored, and processed\n                    in accordance with our Privacy Policy. If you pay using PayPal, you agree\n                    to PayPal's terms and agreements, available at\n                    https://www.paypal.com/us/home.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    All payment transactions made through the Website are processed by Stripe,\n                    a service offered by Stripe, Inc., and your payments are processed by\n                    Stripe in accordance with Stripe's terms and privacy policy, available on\n                    Stripe, Inc.'s website, https://stripe.com/. By using the Services, you\n                    agree to be bound by Stripe Inc.'s terms and privacy policy. By entering\n                    your payment information, you confirm that the Payment Method being used is\n                    yours or that you have been authorized by the owner of the Payment Method\n                    to use it. All Payment Methods are subject to validation checks and\n                    authorization by the issuer. If the credit or debit card issuer refuses to\n                    authorize payment, we will not be responsible for any delay in your ability\n                    to access and use the Services.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    ChartOne does not store credit card or payment information. Payment\n                    information is passed directly to Stripe and PayPal.\n                    Please note that while we take reasonable care to keep the details of your\n                    order and payment secure, in the absence of negligence on our part we are\n                    not liable for any loss you may suffer if a third party gains unauthorized\n                    access to any information that you provide.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Free Trials; Special Offers")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    Your access to the Services may begin with a free trial and/or offer. The\n                    free trial and/or offer period of your membership"), _c('strong'), _vm._v("lasts\n                    for the period specified when you sign up. Free trials are for new members\n                    only. We reserve the right, in our sole discretion, to determine your free\n                    trial eligibility and to provide you with special offers.\n                ")]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                        At the end of any free trial or offer period, we will begin billing you\n                        for the monthly membership fee unless you cancel prior to the end of\n                        the free trial or offer period. You will not receive a notice from us\n                        that your free trial or offer period has ended. We will continue to\n                        bill your Payment Method on a monthly basis for your membership fee\n                        until you cancel. For additional information, see \"Membership\n                        Autorenewals\"\n                    ")]), _vm._v(" "), _c('strong', [_vm._v("above.")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                        By starting a free trial and providing or designating a Payment Method,\n                        you authorize us to charge you a monthly membership fee at the\n                        then-current rate.\n                    ")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Membership Autorenewals; Cancellations")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("A. Membership Autorenewals (Generally)")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                        Your membership will automatically renew monthly, and we will charge\n                        your Payment Method on a monthly basis, until you cancel your\n                        membership (see \"Cancellations\" below for instructions on how to cancel\n                        your membership) or we terminate your membership. If you cancel your\n                        membership, you will continue to have access to the Services through\n                        the end of your membership period. If you started your membership with\n                        a free trial or offer, you will be charged beginning at the expiration\n                        of your free trial or offer period.\n                    ")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                        Unless you notify us before a charge to your Payment Method that you\n                        want to cancel or do not want to automatically renew, you understand\n                        and agree that your membership will automatically renew and you\n                        authorize us, without notice to you (unless required by applicable law)\n                        to collect the then-applicable membership price by charging the Payment\n                        Method that we have on file for you.\n                    ")]), _vm._v(" "), _c('strong', [_vm._v("\n                        If we cannot charge the Payment Method that we have on file for you, we\n                        will contact you via email. We reserve the right to change the calendar\n                        day that we bill you if your Payment Method cannot be charged.\n                    ")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                        B. Timing of Automatic Renewal Charges; When to Cancel to Avoid\n                        Automatic Renewal Charges for the Following Month\n                    ")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                        We automatically bill the membership renewal fee to your Payment Method\n                        each month on the calendar day corresponding to the commencement of\n                        your membership. If you signed up for a free trial, the calendar day\n                        will be based on the date that your paying membership commences\n                        following the expiration of your free trial period.\n                    ")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                        If your membership began on a day that is not contained within a given\n                        month, we may bill your Payment Method on a day in that month that we\n                        deem appropriate in our sole discretion. For example, if you started\n                        your membership on December 31, your Payment Method would next be\n                        charged on January 31 and again on approximately February 28.\n                    ")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                        In order to avoid charges for the following month's membership fees to\n                        your Payment Method, you must cancel your membership at least 48 hours\n                        prior to the date that your membership renews each month. For example,\n                        if you began your membership on April 1, you must cancel on or before\n                        April 28 in order to avoid paying membership fees for the following\n                        month (in this example, May 1 through May 31).\n                    ")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("C. Cancellations")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    You may cancel your membership"), _c('strong'), _vm._v("at any time by logging into\n                    your account and selecting the \"Cancel\" option in your profile.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    When you cancel a membership, you cancel only future charges associated\n                    with your membership. You may cancel at any time, but the cancellation will\n                    not become effective until the end of your current billing period and you\n                    will cancel only future charges associated with your membership. You will\n                    not receive a refund for the current billing cycle. For additional\n                    information, please see \"Membership"), _c('strong'), _vm._v("Autorenewals\n                    (Generally)\" and \"Timing of Automatic Renewal Charges; When to Cancel to\n                    Avoid Automatic Renewal Charges for the Following Month\" above.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Except in the case of certain promotions, you can change or cancel your\n                    membership"), _c('strong'), _vm._v("at any time. Memberships sold as part of a\n                    promotion, subject to an annual commitment, or as an add-on may have\n                    different cancellation or refund policies that will be made clear at the\n                    time of purchase.\n                ")]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Membership Packages and Gifting")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('em')]), _vm._v(" "), _c('p', [_vm._v("\n                    You may choose a membership"), _c('strong'), _vm._v("package for six (6) months or\n                    twelve (12) months and pay in advance for your membership.\n                    "), _c('strong', [_vm._v("\n                        If you elect such a membership package, your membership will be\n                        automatically renewed for the same membership package at the end of\n                        your membership period.\n                    ")]), _vm._v(" "), _c('strong', [_vm._v("For additional information, see \"Membership Autorenewals\" ")]), _vm._v(" "), _c('strong', [_vm._v("above. ")]), _vm._v("\n                    These membership"), _c('strong'), _vm._v("packages are nonrefundable once\n                    purchased."), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    You may gift a twelve (12)-month membership"), _c('strong'), _vm._v("to someone\n                    else (\""), _c('strong', [_vm._v("Gift Membership")]), _vm._v("\"). Gift Memberships"), _c('strong'), _vm._v("will not automatically renew at the end of the membership    "), _c('strong'), _vm._v("period. Please note that Gift Memberships cannot be\n                    cancelled.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Pricing")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    We reserve the right to adjust pricing for the Services in any manner and\n                    at any time in our sole discretion.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Refunds ")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    Payments are nonrefundable. No prorated refunds of any membership    "), _c('strong'), _vm._v("fees paid will be issued upon any termination or\n                    cancellation of a membership.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Clicks for Good ")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    Clicks for Good is a program designed to enable users to give back while\n                    they are giving to themselves. ChartOne is committed to donating money to\n                    charitable organizations. At its sole discretion, ChartOne selects the\n                    charitable organizations that will receive donations from ChartOne and may\n                    revise its selection(s) at any time. ChartOne will in no event be liable\n                    for any failure to give money to a particular charitable organization, nor\n                    for a failure to give any particular amount.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Events: Tone Talks and Tone Live")])]), _vm._v(" "), _c('p', [_vm._v("\n                    As a user, you will participate in the ChartOne Events through (i) Tone\n                    Talks, which are moderated, topic-focused discussions that are not driven\n                    by experts, in which users are encouraged to share their expertise with\n                    each other, and (ii) Tone Live, which is a live streaming interactive event\n                    that gives users access to experts and the ability to ask questions of the\n                    expert.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    By participating in Tone Talks and/or Tone Live, you acknowledge and agree\n                    that ChartOne has sole discretion to determine the topics of discussion and\n                    the questions that the experts will receive and answer. ChartOne reserves\n                    the right in its sole discretion to terminate the participation of any\n                    users that it considers counterproductive, off-topic, or offensive, in its\n                    sole discretion. ChartOne will not be liable for any failure to terminate\n                    any participant in Tone Talks and/or Tone Live. Additionally, ChartOne\n                    reserves the right in its sole discretion to terminate the membership    "), _c('strong'), _vm._v("of any user that it deems to be an offender of ChartOne's\n                    policies and/or Terms of Service.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    By participating in Tone Talks and/or Tone Live, you acknowledge and agree\n                    that ChartOne does not prescreen the topics of discussion and in no event\n                    will be liable for anything that is discussed at Tone Talks and/or Tone\n                    Live.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Information Provided Through the Services")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    The information provided through the Services is for informational purposes\n                    only and is not a substitute for professional, financial, health, legal, or\n                    other advice, nor a replacement for individual relationship between you and\n                    a qualified professional. This information has been prepared to provide\n                    information regarding topics related to lifestyle topics, including but not\n                    limited to legal information, financial, relationship, and general and\n                    specific health issues, including but not limited to mindfulness,\n                    nutrition, and fitness.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    By using the Services, you acknowledge and agree that (i) ChartOne and the\n                    experts featured on ChartOne's website do not intend any of the information\n                    provided through the Services to be used for self-diagnosis or treatment;\n                    (ii) that ChartOne has not independently verified the credentials of\n                    experts and that you have thus made any independent valuations or judgments\n                    of experts on our Website before relying on their advice; (iii) you rely on\n                    any advice at your own risk, and you are solely responsible for verifying\n                    any information and for determining the suitability of any information\n                    obtained through the Services; (iv) you waive any and all rights or claims\n                    that you may have to obtain a refund and (v) ChartOne has no liability to\n                    you for any reason for any advice or Services.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    IF YOU HAVE ANY QUESTIONS OR CONCERNS ABOUT YOUR HEALTH AND BEFORE STARTING\n                    OR STOPPING ANY TREATMENT OR ACTING UPON INFORMATION ACCESSIBLE THROUGH THE\n                    SERVICES, YOU SHOULD CONTACT YOUR OWN PHYSICIAN OR HEALTH CARE PROVIDER.\n                    ADDITIONALLY, IF YOU HAVE ANY QUESTIONS OR CONCERNS ABOUT ANY OF THE OTHER\n                    TOPICS DISCUSSED THROUGH THE SERVICES, YOU SHOULD CONTACT A QUALIFIED\n                    PROFESSIONAL TO DISCUSS YOUR PARTICULAR FACTS AND CIRCUMSTANCES BEFORE\n                    ACTING UPON INFORMATION ACCESSIBLE THROUGH THE SERVICES.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    ChartOne make no representations or warranties and expressly disclaims any\n                    and all liability concerning any treatment or action based on the\n                    information offered or provided through the Services. ChartOne does not\n                    represent or warrant that any such information will meet your expectations\n                    and does not make any representations or warranties with respect to the\n                    quality of advice provided by experts, and is not responsible for the\n                    quality of advice. By using the Services, you acknowledge and agree that\n                    (i) ChartOne does not review or endorse any information or advice provided\n                    through the Services, and does not have any liability to you with respect\n                    to any information or advice provided through the services; (ii) ChartOne\n                    does not verify the accuracy of information nor opinions provided by\n                    experts; and (iii) while ChartOne researches and curates experts in order\n                    to identify their appropriateness, ChartOne does not do background checks\n                    on experts and does not verify their credentials, including but not limited\n                    to educational degrees received, certifications and/or licenses. ChartOne\n                    relies on the experts' representation of themselves on their websites,\n                    social media accounts, and in published materials.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    IF YOU HAVE SPECIFIC CONCERNS OR REQUIRE PROFESSIONAL ADVICE, YOU SHOULD\n                    CONSULT WITH A QUALIFIED PROFESSIONAL. THESE SERVICES ARE NOT DESIGNED AS,\n                    NOR SHOULD YOU USE THESE SERVICES AS, A SUBSTITUTE FOR ADVICE FROM A\n                    QUALIFIED PROFESSIONAL.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    If you have a dispute with another user or expert, you hereby release\n                    ChartOne (and our officers, directors, agents, subsidiaries, joint ventures\n                    and employees) from claims, demands and damages (actual and consequential)\n                    of every kind and nature, known and unknown, arising out of or in any way\n                    connected with such disputes, including damages for loss of profits,\n                    goodwill, use, privacy or data. We reserve the right, but have no\n                    obligation, to become involved in any way with these disputes. If you are a\n                    California resident, you waive California Civil Code §1542, which\n                    says: \"A general release does not extend to claims which the creditor does\n                    not know or suspect to exist in his or her favor at the time of executing\n                    the release, which if known by him or her must have materially affected his\n                    settlement with the debtor.\" And, if you are not a California resident, you\n                    waive any applicable state statutes of a similar effect.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Changes and Termination of Services")])]), _vm._v(" "), _c('p', [_vm._v("\n                    We are constantly changing and improving our Services. We reserve the right\n                    to add or remove functionalities or features of the Services, and we may\n                    suspend, stop, or delete an account or may suspend or stop the Services\n                    altogether, including, for example, if you do not comply with these Terms\n                    of Service or if we are investigating suspected misconduct or breach of any\n                    applicable laws. You can stop using our Services at any time. We may also\n                    stop providing Services to you, add or create new limits to our Services,\n                    or restrict your access to all or a part of the Services at any time and\n                    for any reason without notice or liability. We will not be liable if for\n                    any reason all or any part of the Services are unavailable at any time or\n                    for any period. The right to access and use the Services is revoked in\n                    jurisdictions where it may be prohibited, if any.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Internet Connections; Mobile Access")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    You understand that ChartOne provides the Services over the Internet and\n                    that such connections can be unpredictable, insecure, and unstable, such\n                    that ChartOne cannot guarantee uninterrupted access to the Services.\n                    ChartOne disclaims all liability in connection with any interruptions to\n                    Service access, security incidents, or breaches arising from or\n                    attributable to an Internet and/or data connection. You agree to waive any\n                    and all claims against ChartOne in connection therewith.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    To the extent that you access the Services through a mobile device, you\n                    acknowledge and agree that your wireless service carrier's standard\n                    charges, data rates and other fees may apply, and that all such charges and\n                    fees will be your sole responsibility. You should check with your carrier\n                    to find out what plans are available and how much they cost. In addition,\n                    downloading, installing, or using certain mobile services may be prohibited\n                    or restricted by your carrier, and not all mobile services may work with\n                    all carriers or devices. Therefore, you should check with your carrier to\n                    find out if the mobile services are available for your mobile device, and\n                    what restrictions, if any, may be applicable to your use of such mobile\n                    services.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    By using the Services, you agree that we may communicate with you regarding\n                    the Services by electronic means to your mobile device and that certain\n                    information about your usage of the mobile services may be communicated to\n                    us.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    We may from time to time make updates to the Services. Such updates may\n                    require your acceptance of new Terms of Service before you may continue to\n                    use the Services.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Licenses Granted")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    ChartOne grants to you a revocable, non-transferable, nonexclusive, limited\n                    and non-assignable license to access and use the Services in accordance\n                    with these Terms of Service. ChartOne reserves all other rights in the\n                    Services not expressly granted to you.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    You grant ChartOne a worldwide, unlimited, irrevocable, royalty-free\n                    license to publicly and privately use, publish, reproduce, display, copy,\n                    edit, perform, create derivative works from, or otherwise make use of any\n                    content you submit through the Services, including but not limited to any\n                    videos, photos, graphics, sounds, music, audio transcripts of videos,\n                    comments, messages, and other text that are viewable or accessible through\n                    the Services (\""), _c('strong', [_vm._v("Content")]), _vm._v("\"). You understand and acknowledge\n                    that you are responsible for any Content you submit or contribute, and you,\n                    not ChartOne, are fully responsible for such content, including its\n                    legality, reliability, accuracy and appropriateness. We are not\n                    responsible, or liable to any third party, for the content or accuracy of\n                    any Content. We cannot guarantee the identity of any other users with whom\n                    you may interact in the course of using the Services, nor the authenticity\n                    of any information that experts may provide about themselves. You\n                    acknowledge that all content accessed by you using the Services is at your\n                    own risk and you will be solely responsible for any damage or loss to any\n                    party resulting therefrom.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    You grant ChartOne a worldwide, unlimited, irrevocable, royalty-free\n                    license to publicly and privately use, distribute, modify, offer for sale\n                    or exploit any (i) suggestions, ideas, criticism, or other type of feedback\n                    you make relating to the Services and (ii) any topics of interest that you\n                    select or other polling data that you provide through watching content\n                    through the Services, with no obligation to pay you royalties or any other\n                    compensation.\n                ")]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Conduct and Events Guidelines")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    You may use the Services only for lawful purposes and in accordance with\n                    these Terms of Service. Without limiting the generality of the foregoing,\n                    you agree to use the Services in accordance with the provisions below:\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will only use the Services in accordance with the laws of your\n                    jurisdiction for personal, non-commercial purposes.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will be respectful and considerate of other users and will not\n                    harass or threaten other users or violate the rights of any other party,\n                    and you will do your part to make the Website a safe and supportive\n                    community for all users.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not impersonate someone else or misrepresent your\n                    affiliation with someone else.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will register for the Services using accurate and current\n                    information, and you will not impersonate or attempt to impersonate\n                    ChartOne, a ChartOne employee, another user, an expert, or any other person\n                    or entity (including, without limitation, by using e-mail addresses or\n                    usernames associated with any of the foregoing).\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not post Content that infringes another's intellectual\n                    property rights.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You may not decompile, reverse engineer, or otherwise attempt to\n                    obtain the source code of any content on the Services.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will independently verify the quality, relevance or accuracy of\n                    any information posted on the Services by others.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not use, store, copy, upload, display, post, reproduce,\n                    modify, translate, republish, distribute, broadcast, transmit, create\n                    derivative works from, display, license, sell or otherwise exploit any part\n                    of the Services or content on the Services in any form whatsoever other\n                    than as expressly permitted under these Terms of Service.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not use contact information received through the Services\n                    for phishing, spamming and other unsolicited communications or data\n                    collection.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not collect or store any personally identifiable\n                    information from the Services from other users of the Services without\n                    their express permission.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not submit or post unsolicited promotional content,\n                    advertising, political campaigns, contests, raffles or solicitations.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not use the Services in a manner intended to damage,\n                    disable, overburden or impair the Services or to disrupt or interfere with\n                    another's use of the Services.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not attempt to hack or otherwise gain unauthorized access\n                    to the Services or accounts.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not use high volume, automated, or electronic means to\n                    access the Services (including without limitation robots, spiders, or\n                    scripts).\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not affect the display of the Services through use of\n                    framing, pop-ups or third-party ads.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not transmit malware, software viruses, Trojan horses,\n                    worms or any other malicious application to or through the Services.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not threaten, dox, or otherwise harass other users or\n                    experts.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not submit or post information that is inaccurate, false,\n                    fraudulent, or misleading, including submissions made under false\n                    pretenses.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not submit or post unlawful, harassing, libelous, abusive,\n                    threatening, defamatory, vulgar, obscene, racist, harmful, inappropriate,\n                    sexually explicit, or otherwise objectionable material of any kind,\n                    including but not limited to posting any Content that promotes\n                    discrimination, bigotry, racism, hatred, harassment or harm against any\n                    individual or group; is violent or threatening or promotes violence or\n                    actions that are threatening to any person or entity; and/or promotes\n                    illegal or harmful activities or substances.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not use any meta tags or other hidden text or metadata\n                    utilizing a ChartOne trademark, logo URL or product name without ChartOne's\n                    express written consent.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not forge any TCP/IP packet header or any part of the\n                    header information in any email or newsgroup posting, or in any way use the\n                    Services or Content to send altered, deceptive or false source-identifying\n                    information.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will not act in a manner that violates these Terms of Service.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will comply with applicable local, state, national or\n                    international laws, statutes, ordinances, rules, regulations or ethical\n                    codes governing your jurisdiction.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • You will notify us immediately of any content of the Services that\n                    violates these Terms of Service.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    We have the right to: (i) remove or refuse to post any Content for any or\n                    no reason in our sole discretion; (ii) take any action with respect to any\n                    Content that we deem necessary or appropriate in our sole discretion,\n                    including if we believe that such Content violates these Terms of Service,\n                    infringes any intellectual property right or other right of any person or\n                    entity, threatens the personal safety of other users, experts, or the\n                    public or could create liability for ChartOne; (iii) disclose your identity\n                    or other information about you to any third party who claims that material\n                    posted by you violates their rights, including their intellectual property\n                    rights or their right to privacy; (iv) take appropriate legal action,\n                    including without limitation, referral to law enforcement, for any illegal\n                    or unauthorized use of the Services; and (v) terminate or suspend your\n                    access to all or part of the Services for any or no reason, including\n                    without limitation, any violation of these Terms of Service.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    YOU WAIVE AND HOLD HARMLESS CHARTONE AND ITS AFFILIATES, LICENSEES AND\n                    SERVICE PROVIDERS FROM ANY CLAIMS RESULTING FROM ANY ACTION TAKEN BY SUCH\n                    PARTIES DURING OR AS A RESULT OF ITS INVESTIGATIONS AND FROM ANY ACTIONS\n                    TAKEN AS A CONSEQUENCE OF INVESTIGATIONS BY SUCH PARTIES OR LAW ENFORCEMENT\n                    AUTHORITIES.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    We have no liability or responsibility to anyone for performance or\n                    nonperformance of the activities described in this section.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Proprietary Rights")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    The Services and all past, present and future content of the Services,\n                    including all software, hardware and technology used to provide the\n                    Services (including our proprietary code and third-party software), user\n                    interfaces, materials displayed or performed on the Services, such as text,\n                    graphics, articles, photographs, images, illustrations and the design,\n                    structure, sequence and \"look and feel\" of the Services, and all other\n                    intellectual property, including all trademarks, service marks, logos, or\n                    any other trade name, trademarks, service marks and other distinctive or\n                    proprietary brand features of ChartOne, are (i) owned by ChartOne, its\n                    licensors or other providers of such material, (ii) protected by United\n                    States and international copyright, trademark, patent, trade secret and\n                    other intellectual property or proprietary rights laws, (iii) are intended\n                    solely for the personal, non-commercial use of our users and experts, and\n                    (iv) may only be used in accordance with these Terms of Service.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Using our Services does not give you ownership of any intellectual property\n                    rights in the Services or any content on the Services. You may not use\n                    content from the Services, including Content, unless you obtain permission\n                    from ChartOne and the expert who generated the content, if different from\n                    ChartOne, or are otherwise permitted by law. These Terms of Service do not\n                    grant you the right to use any of ChartOne's technology or intellectual\n                    property. You may not remove, obscure, or alter any copyright or other\n                    legal notices displayed in or along with the Services.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    No right, title or interest in or to the Services or any content on the\n                    Services is transferred to you, and all rights not expressly granted are\n                    reserved by ChartOne. Any use of the Services not expressly permitted by\n                    these Terms of Service is a breach of these Terms and may violate\n                    copyright, trademark and other laws.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Claims of Copyright Infringement")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    If you believe that your copyrighted work has been unlawfully copied and is\n                    accessible on the Services in a way that constitutes copyright\n                    infringement, please send a notice of copyright infringement to:\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    ChartOne Media LLC\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    P.O. Box 356\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Oyster Bay, NY 11771\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Phone: (516) 900-1000\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Email: info@tonenetworks.com\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    The notice should include:\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • Your full name and electronic or physical signature.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • Your mailing address, phone number and email address (at which you\n                    can be contacted by us or the alleged infringer).\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • A statement that you are the owner, or are authorized to act on\n                    behalf of the owner, of the copyright that is allegedly infringed, and that\n                    the information in your notice is accurate.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • A statement that you have a good faith belief that the disputed use\n                    of the copyrighted materials is not authorized by the copyright owner, its\n                    agent or by law, such as fair use.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • A description of the copyrighted work(s) that you claim has been\n                    infringed.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    • A description of the location of the copyrighted materials on the\n                    Services.\n                ")]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Electronic Delivery Statement and Your Consent")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    You agree to receive legal notices and other information concerning\n                    ChartOne or the Services electronically, including notice to any email\n                    address that you may provide.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Term and Termination")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    These Terms of Service will remain in effect until terminated by you or\n                    ChartOne. We reserve the right to terminate or change the Services or your\n                    access to the Services, without notice, at any time and for any reason,\n                    including your violation of these Terms of Service or for business reasons.\n                    The disclaimer of warranties, limitation of liability, jurisdictional,\n                    limitation of time to file claims, indemnification and arbitration\n                    provisions survive any termination.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    You agree that ChartOne may, for any reason and without notice to you,\n                    immediately terminate or otherwise restrict your access to the Services.\n                    ChartOne has no obligation to maintain, store, or transfer your information\n                    or data that you have posted on or uploaded to the Services.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Disclaimer of Representations and Warranties")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    THE SERVICES AND ANY ASSOCIATED CONTENT ARE PROVIDED ON AN \"AS IS\" AND \"AS\n                    AVAILABLE\" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR\n                    IMPLIED. NEITHER CHARTONE NOR ANY PERSON ASSOCIATED WITH CHARTONE MAKES ANY\n                    REPRESENTATION OR WARRANTY WITH RESPECT TO THE COMPLETENESS, SECURITY,\n                    RELIABILITY, QUALITY, ACCURACY OR AVAILABILITY OF THE SERVICES OR ANY\n                    ASSOCIATED CONTENT. WITHOUT LIMITING THE FOREGOING, NEITHER CHARTONE NOR\n                    ANYONE ASSOCIATED WITH CHARTONE REPRESENTS OR WARRANTS THAT THE SERVICES OR\n                    ANY ASSOCIATED CONTENT WILL BE ACCURATE, RELIABLE, ERROR-FREE, UPDATED OR\n                    UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT THE SERVICES ARE FREE\n                    OF VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT THE SERVICES WILL OTHERWISE\n                    MEET YOUR NEEDS OR EXPECTATIONS.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    CHARTONE HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR\n                    IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY\n                    WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR PARTICULAR\n                    PURPOSE.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR\n                    LIMITED UNDER APPLICABLE LAW.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Limitation of Liability")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    YOUR USE OF THE SERVICES AND ANY CONTENT ON THE SERVICES IS AT YOUR SOLE\n                    RISK AND DISCRETION. You may not assert claims for money damages arising\n                    from the Services or any associated content against ChartOne, its\n                    affiliates, licensors or service providers, or our respective employees,\n                    contractors, officers, directors and agents. ChartOne, its affiliates,\n                    licensors and service providers, and its respective employees, contractors,\n                    officers, directors and agents shall not be liable for any direct,\n                    indirect, special, incidental, consequential or punitive damages, including\n                    but not limited to personal injury, pain and suffering, emotional distress,\n                    or loss of revenue, profits, goodwill or data, whether caused by tort\n                    (including negligence), breach of contract or otherwise, even if ChartOne\n                    knew or should have known of the possibility of such damages, arising out\n                    of or in connection with (i) your use, or inability to use, the Services or\n                    any associated content or Content, (ii) any interaction with any third\n                    party through or in connection with the Services, including experts and\n                    other users, (iii) any information offered or provided within or through\n                    the Services, or (iii) any other matter relating to the Services. In no\n                    event shall ChartOne, its affiliates, licensors or service providers, or\n                    its respective employees, contractors, officers, directors and agents be\n                    liable to you in the aggregate (for all potential claims by you) for any\n                    damages incurred in excess of one hundred dollars ($100). Because some\n                    states or jurisdictions do not allow the exclusion or the limitation of\n                    liability for consequential or incidental damages, in such states or\n                    jurisdictions, ChartOne's liability shall be limited to the extent\n                    permitted by law.\n                ")]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Indemnification")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    You are solely legally liable if your use or misuse of the Services or any\n                    associated content causes damage to the Services, to you, or to someone or\n                    something else. You agree to defend, indemnify, and hold harmless ChartOne,\n                    its affiliates, licensors and service providers, and its respective\n                    employees, contractors, officers, directors and agents from and against all\n                    liabilities, claims, damages, judgment, awards, losses, costs, expenses,\n                    fines or fees (including attorney's fees and investigation costs), that\n                    arise from or relate to your use or misuse of the Services, violation of\n                    these Terms of Service or violation of a third party's rights. ChartOne\n                    reserves the right, at ChartOne's own expense, to assume the exclusive\n                    defense and control of any matter otherwise subject to indemnification by\n                    you, in which event you agree to cooperate with ChartOne in asserting any\n                    available defenses.\n                ")]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Limitation on Time to File Claims")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    Any cause of action or claim you may have arising out of or relating to\n                    these Terms of Service or the Services must be commenced within one (1)\n                    year after the cause of action accrues, otherwise, such cause of action is\n                    permanently barred.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Choice of Law and Jurisdiction")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    You agree that the laws of the State of New York and U.S. federal law\n                    govern these Terms of Service, your use of the Services, and any claim or\n                    dispute that you may have against ChartOne, without regard to New York's\n                    conflict of laws rules. You consent to the personal and exclusive\n                    jurisdiction of the federal and state courts of New York, New York. The\n                    United Nations Convention on Contracts for the International Sale of Goods\n                    does not apply to this Agreement.\n                ")]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Binding Arbitration")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    In the rare event you have a dispute with ChartOne, we encourage you to\n                    contact us immediately so we can work together toward a satisfactory\n                    resolution. If we cannot come to a resolution, you agree that any claims,\n                    disputes, demands, counts, controversies, or causes of action between you\n                    and ChartOne arising out of or relating to these Terms of Service, the\n                    Services, including the enforceability of these Terms of Service or our\n                    Privacy Policy or information practices will be finally and exclusively\n                    resolved by binding arbitration on an individual basis only (except as\n                    stated below). The arbitrator may not consolidate more than one person's\n                    claims, and may not otherwise preside over any form of any class or\n                    representative proceeding.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    You understand that you are waiving your right to have your claims heard in\n                    court by a judge or jury. An arbitration award is as enforceable as a court\n                    order and is subject to only limited review by a judge. You also understand\n                    and agree that this arbitration provision prevents you from participating\n                    as a plaintiff or as a class member in any purported class action or\n                    representative proceeding.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Arbitration will be subject to the Federal Arbitration Act, and shall be\n                    commenced and conducted by the American Arbitration Association (\"    "), _c('strong', [_vm._v("AAA")]), _vm._v("\") under the Commercial Arbitration Rules and the\n                    Supplementary Procedures for Consumer Related Disputes, as amended by this\n                    provision, by one arbitrator that is acceptable to both parties. You can\n                    find out more AAA and how to file an arbitration claim at www.adr.org or by\n                    calling 800-778-7879.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Your arbitration fees and your share of arbitrator compensation shall be\n                    governed by the AAA rules and, where appropriate, limited by the AAA\n                    Consumer Rules. In the event you are able to demonstrate that the costs of\n                    arbitration will be prohibitive as compared to the costs of litigation,\n                    ChartOne will pay as much of your filing, administrative, and arbitrator\n                    fees in connection with the arbitration as the arbitrator deems necessary\n                    to prevent arbitration from being cost-prohibitive. In such case, we will\n                    make arrangements to pay all necessary fees directly to the AAA. If the\n                    arbitrator determines the claim(s) you assert in the arbitration are\n                    frivolous, you agree to reimburse ChartOne for all fees associated with the\n                    arbitration paid by ChartOne on your behalf, which you otherwise would be\n                    obligated to pay under the AAA's rules.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    The arbitration will be conducted through written submission, unless the\n                    arbitrator determines that a telephonic hearing is required. Except as\n                    otherwise provided in these Terms of Service, you and ChartOne may litigate\n                    in court to compel arbitration, stay proceedings pending arbitration, or to\n                    confirm, modify, vacate or enter judgment on the award entered by the\n                    arbitrator. In the event this arbitration provision is held unenforceable\n                    by a court, or in the event AAA refuses to arbitrate the dispute, all\n                    controversies, disputes, demands, counts, claims, or causes of action\n                    between you and ChartOne shall be exclusively brought in the state or\n                    federal courts of New York, New York.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Despite this provision, you may file a claim in a small claims court that\n                    has jurisdiction to hear the matter.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Severability and Integration")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    These Terms of Service and any supplemental terms, policies, rules and\n                    guidelines posted on the Services constitute the entire agreement between\n                    you and ChartOne. If any part of the Terms of Service is held invalid or\n                    unenforceable, that portion shall be construed in a manner consistent with\n                    applicable law to reflect, as nearly as possible, the original intentions\n                    of the parties, and the remaining portions shall remain in full force and\n                    effect.\n                ")]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("General Provisions")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    You may not assign these Terms of Service without ChartOne's prior written\n                    approval. ChartOne may assign these Terms without your consent to: (i) a\n                    subsidiary or affiliate; (ii) an acquirer of ChartOne's business or assets;\n                    or (iii) a successor by merger. Any purported assignment in violation of\n                    this section shall be void. No joint venture, partnership, employment, or\n                    agency relationship exists between you and ChartOne as a result of these\n                    Terms of Service or your use of the Services. Our failure to enforce any\n                    right or provision in these Terms of Service shall not constitute a waiver\n                    of such right or provision unless acknowledged and agreed to by ChartOne in\n                    writing.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Contact Information")]), _vm._v(" "), _c('strong')]), _vm._v(" "), _c('p', [_vm._v("\n                    The Services are operated by ChartOne LLC. All feedback, comments, requests\n                    for technical support and other communications relating to the Services\n                    should be directed to us at:\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    ChartOne Media LLC\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    P.O. Box 356\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Oyster Bay, NY 11771\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Phone: (516) 900-1000\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Email: info@tonenetworks.com\n                ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65a31e08", module.exports)
  }
}

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('br'), _vm._v(" "), _c('br'), _c('span', [_vm._v("Recently Watched Videos")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {}, [(_vm.getAuthRecentlyWatchedVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthRecentlyWatchedVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "title": video.title,
        "alt": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  })], 2) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65ebedb2", module.exports)
  }
}

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpHeadingColor,
      textTransform: 'unset !important'
    })
  }, [_vm._v("Meet Our Experts and Hosts")]), _vm._v(" "), _c('div', {
    staticClass: "expertsrow"
  }, _vm._l((_vm.getAllExperts), function(expert) {
    return _c('div', {
      staticClass: "expert-entery",
      attrs: {
        "id": (expert.expertId * 115)
      }
    }, [_c('div', {
      staticClass: "expert_entry_holder",
      attrs: {
        "id": expert.expertId
      }
    }, [_c('div', {
      staticClass: "expert_entry_image-and-name-container"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
        }
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": expert.small_image,
        "alt": expert.name,
        "title": expert.name
      }
    })]), _vm._v(" "), _c('h2', [_c('router-link', {
      attrs: {
        "to": {
          path: '/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(expert.name) + "\n                                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(expert.experties))])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "expert_entry_datacontainer"
    }, [_c('h1', [_vm._v(_vm._s(expert.name))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(expert.experties))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(expert.areasofexpertise))]), _vm._v(" "), _c('router-link', {
      staticClass: "pink-button",
      attrs: {
        "to": {
          path: '/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
        }
      }
    }, [_c('strong', [_vm._v("Find out More")])])], 1)])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "contactformtexttone contact-form"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/become-expert')
      }
    }
  }, [_c('h3', [_vm._v("Want to become a TONE Expert?")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-67ddb66c", module.exports)
  }
}

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": _vm.spinnerText
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_c('svg', {
    attrs: {
      "width": "34px",
      "height": "47px",
      "viewBox": "0 0 34 47",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Page 1")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_Unauthenticated",
      "transform": "translate(-125.000000, -1270.000000)",
      "fill": _vm.getCorpHeaderColor
    }
  }, [_c('path', {
    attrs: {
      "d": "M131.268161,1315.78641 C130.977535,1315.78641 130.686929,1315.70766 130.426289,1315.54453 C129.798161,1315.15078 129.528161,1314.37453 129.775649,1313.67517 L136.398209,1294.97773 L127.583969,1294.97586 C127.028993,1294.97586 126.513329,1294.68524 126.226481,1294.20709 C125.939604,1293.73084 125.924604,1293.1402 126.18523,1292.64896 L137.24011,1271.84 C137.515735,1271.32251 138.051982,1271 138.638878,1271 L153.378238,1271 C153.97075,1271 154.512622,1271.33 154.786366,1271.85498 C155.058242,1272.38187 155.015114,1273.01374 154.671991,1273.49749 L145.384951,1286.60725 L157.062391,1286.60725 C157.701751,1286.60725 158.277367,1286.99162 158.524903,1287.58035 C158.770529,1288.17099 158.637406,1288.85158 158.187406,1289.30538 L132.393166,1315.31898 C132.08754,1315.62648 131.678782,1315.78585 131.268142,1315.78585 L131.268161,1315.78641 Z M130.218161,1291.80897 L138.638801,1291.80897 C139.152545,1291.80897 139.634417,1292.05834 139.932545,1292.47833 C140.228796,1292.89833 140.303796,1293.43646 140.131294,1293.9202 L135.121054,1308.0706 L153.261694,1289.77444 L142.322974,1289.77444 C141.730462,1289.77444 141.18859,1289.44444 140.916718,1288.91755 C140.644841,1288.39252 140.687969,1287.75878 141.031092,1287.27503 L150.316212,1274.16527 L139.591092,1274.16527 L130.218161,1291.80897 Z",
      "id": "Page-1",
      "stroke": "#FFFFFF",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-7-Copy",
      "transform": "translate(126.000000, 1315.000000)",
      "font-size": "30",
      "font-family": "Quicksand-Regular, Quicksand",
      "line-spacing": "60",
      "font-weight": "normal"
    }
  }, [_c('text', {
    attrs: {
      "id": "Inspiration"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "0",
      "y": "28"
    }
  }, [_vm._v("Inspiration")])])])])])]), _vm._v(" "), _c('br'), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Life")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.getVideoSubcategories) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "interest-container work"
  }, [_c('button-group', {
    model: {
      value: (_vm.interestIndexes),
      callback: function($$v) {
        _vm.interestIndexes = $$v
      },
      expression: "interestIndexes"
    }
  }, _vm._l((_vm.getVideoSubcategories), function(interest, interestSubCategoryId) {
    return _c('checkbox', {
      key: interest.interestSubCategoryName.toString().toUpperCase(),
      staticClass: "min-padding checkbox-btn",
      style: (_vm.styleInterestObject(interest.interestSubCategoryName.toString().toUpperCase())),
      attrs: {
        "true-value": interest.interestSubCategoryName.toString().toUpperCase()
      }
    }, [_vm._v("\n                                    " + _vm._s(interest.interestSubCategoryName) + "\n                                ")])
  }), 1)], 1)]), _vm._v(" "), (_vm.getAuthLifeVideos && _vm.getAuthLifeVideos.length >= 100 && !_vm.showAllVideosFlag) ? _c('a', {
    staticClass: "bolder hidemobile",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showAllVideos('top')
      }
    }
  }, [_vm._v("choose a category or click to see more")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [(_vm.hideCompleteList() && !_vm.isMobile) ? _c('div', [(_vm.getAuthLifeVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthLifeVideos), function(video, index) {
    return ((index + 1) <= 99) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      class: {
        'private-contents': video.isPrivate === '1'
      },
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(video.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      attrs: {
        "title": video.title
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), (_vm.getAuthLifeVideos && _vm.getAuthLifeVideos.length >= 100 && !_vm.showAllVideosFlag) ? _c('a', {
    staticClass: "bolder hidemobile",
    attrs: {
      "id": "btmLink",
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showAllVideos()
      }
    }
  }, [_vm._v("click to browse all videos")]) : _vm._e()], 2) : _vm._e()]) : _c('div', [(_vm.getAuthLifeVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthLifeVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      class: {
        'private-contents': video.isPrivate === '1'
      },
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(video.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      attrs: {
        "title": video.title
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(2, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  })], 2) : _vm._e()])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a07750b", module.exports)
  }
}

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plans"
  }, [_c('h1', {
    staticClass: "pageHeading"
  }, [_c('b', [_vm._v("PLANS")]), _vm._v(" & "), _c('b', [_vm._v("PRINCING")])]), _vm._v(" "), _c('div', {
    staticClass: "cardSection"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 padding-minus"
  }, [_c('a', {
    attrs: {
      "href": "#topic"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "cardHeader"
  }, [_c('h1', [_vm._v("Startup")])]), _vm._v(" "), _c('div', {
    staticClass: "cardBody"
  }, [_c('div', {
    staticClass: "amountSection"
  }, [_c('div', {
    staticClass: "left amount"
  }, [_c('h4', [_vm._v("$8."), _c('sub', [_vm._v("99")])]), _vm._v(" "), _c('p', [_vm._v("per month")])]), _vm._v(" "), _c('div', {
    staticClass: "right amount"
  }, [_c('h4', [_vm._v("12")]), _vm._v(" "), _c('p', [_vm._v("targets")])])]), _vm._v(" "), _c('div', {
    staticClass: "cardBodyHeader"
  }, [_c('p', [_vm._v("FEATURES")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("User")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("2 Users")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("Email Alerts")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("Unlimited")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("SMS Alerts")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("Unlimited")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cardFooter"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_c('b', [_vm._v("PPRICE")]), _vm._v(" (Yearly)")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("$99.99")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 padding-minus"
  }, [_c('a', {
    staticClass: "business",
    attrs: {
      "href": "#topic"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "cardHeader"
  }, [_c('h1', [_vm._v("Business")]), _vm._v(" "), _c('p', [_vm._v("MOST POPULAR")])]), _vm._v(" "), _c('div', {
    staticClass: "cardBody"
  }, [_c('div', {
    staticClass: "amountSection"
  }, [_c('div', {
    staticClass: "left amount"
  }, [_c('h4', [_vm._v("$34."), _c('sub', [_vm._v("99")])]), _vm._v(" "), _c('p', [_vm._v("per month")])]), _vm._v(" "), _c('div', {
    staticClass: "right amount"
  }, [_c('h4', [_vm._v("40")]), _vm._v(" "), _c('p', [_vm._v("targets")])])]), _vm._v(" "), _c('div', {
    staticClass: "cardBodyHeader"
  }, [_c('p', [_vm._v("FEATURES")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("User")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("2 Users")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("Email Alerts")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("Unlimited")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("SMS Alerts")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("Unlimited")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cardFooter"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_c('b', [_vm._v("PPRICE")]), _vm._v(" (Yearly)")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("$339.99")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 padding-minus"
  }, [_c('a', {
    attrs: {
      "href": "#topic"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "cardHeader"
  }, [_c('h1', [_vm._v("Enterprise")])]), _vm._v(" "), _c('div', {
    staticClass: "cardBody"
  }, [_c('div', {
    staticClass: "amountSection"
  }, [_c('div', {
    staticClass: "left amount"
  }, [_c('h4', [_vm._v("$79."), _c('sub', [_vm._v("99")])]), _vm._v(" "), _c('p', [_vm._v("per month")])]), _vm._v(" "), _c('div', {
    staticClass: "right amount"
  }, [_c('h4', [_vm._v("100")]), _vm._v(" "), _c('p', [_vm._v("targets")])])]), _vm._v(" "), _c('div', {
    staticClass: "cardBodyHeader"
  }, [_c('p', [_vm._v("FEATURES")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("User")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("2 Users")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("Email Alerts")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("Unlimited")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("SMS Alerts")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("Unlimited")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cardFooter"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_c('b', [_vm._v("PPRICE")]), _vm._v(" (Yearly)")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("$949.99")])])])])])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a24856b", module.exports)
  }
}

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "left-content"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true,
      "type": "danger"
    }
  }, [_c('panel', {
    staticClass: "text-left",
    attrs: {
      "type": "danger"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h4', [_vm._v("Download")])]), _vm._v(" "), _c('div', {
    staticClass: "create-account"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadWithAxios
    }
  }, [_vm._v("\n                                            Download List\n                                        ")])])]), _vm._v(" "), _c('panel', {
    staticClass: "text-left",
    attrs: {
      "header": "Panel #2",
      "type": "danger"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h4', [_vm._v("Upload")])]), _vm._v(" "), _c('div', {
    staticClass: "create-account"
  }, [_c('h5', {
    staticClass: "margin-bot-20"
  }, [_vm._v("Select CSV File")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix gap"
  }), _vm._v(" "), _c('input', {
    ref: "myFileInput",
    staticClass: "btn btn-primary",
    attrs: {
      "type": "file",
      "accept": ".csv",
      "id": "manageCoprPage"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "disabled": _vm.csv_file.length === 0,
      "type": "button"
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_vm._v("\n                                            Upload\n                                        ")])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', [_c('h2', [_vm._v(_vm._s(_vm.user.corporation.name))]), _c('p', [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName) + " (Admin)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v(" Download File => To get list of users in " + _vm._s(_vm.user.corporation.name) + "\n                                                ")]), _vm._v(" "), _c('li', [_vm._v(" Add attribues to users from downloaded file\n                                                ")]), _vm._v(" "), _c('li', [_vm._v(" Upload File => To synchronize changes in users with our records\n")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('br')])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), _c('h2', [_vm._v("\n                                    Welcome to TONE. You are here to Manage your Community Page\n                                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-footer hidemobile"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v("Tips to Upload/Download CSV Files")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('h6', {
    staticClass: "text-uppercase"
  }, [_vm._v("Note: First column of file should always be 'email'")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6cd8833a", module.exports)
  }
}

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hubspotForm"
  }, [_c('div', {
    attrs: {
      "id": "hubspotForm"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6d77c942", module.exports)
  }
}

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.getExpert) ? _c('div', {
    staticClass: "rules-banner"
  }, [(_vm.getSelectedEvent) ? _c('div', [(_vm.isEventToday(_vm.getSelectedEvent[0].start_date, _vm.getSelectedEvent[0].end_date)) ? _c('div', [_c('h2', [_vm._v("Hey, " + _vm._s(_vm.user.firstName) + ". Welcome to our community of women helping women, featuring TONE Talks moderated discussions and TONE Live streaming events with our experts.\n                "), _c('br'), _vm._v("How you would like to join the conversation?\n            ")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent('0')
      }
    }
  }, [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent('1')
      }
    }
  }, [_vm._v("Shoe-cognito")])]) : _c('div', [_c('h2', [_vm._v("Hey, " + _vm._s(_vm.user.firstName) + ". Welcome to our community of women helping women, featuring TONE Talks moderated discussions and TONE Live streaming events with our experts.\n            ")]), _vm._v(" "), _c('h2', [_vm._v("Event will start here at "), _c('br'), _vm._v(" " + _vm._s(_vm.getDateReference(_vm.getSelectedEvent[0].start_date, 'live2')))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getExpert) ? _c('div', {
    staticClass: "rules-expert-content"
  }, [_c('h2', [_vm._v("about the expert")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert[0].name))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.getExpert[0].experties))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getExpert[0].biography)
    }
  })]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "talkRulesHeading"
  }, [_c('h2', [_vm._v("Events Guidelines")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row marginTop rulerow"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "ruleImages"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(842),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                        Keep it positive, supportive and respectful.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "ruleImages"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(844),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                        Please be thoughtful and stay on topic.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "ruleImages"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(843),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                        Please do not post copyrighted material, ads, solicitations or anyone's personal info including your own.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "ruleImages"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(841),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                        Please refer to TONE's "), _c('a', {
    attrs: {
      "href": "/terms"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" for more information.\n                    ")])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7020e578", module.exports)
  }
}

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      showHeaderMobile123: _vm.currentRoute.name === 'SignUp' || _vm.currentRoute.name === 'Gift' || _vm.currentRoute.name === 'Gifts' || _vm.currentRoute.name === 'Redeem,' || _vm.currentRoute.name === 'Event' || _vm.currentRoute.name === 'AccentureCharlotte' || _vm.currentRoute.name === 'CorporationGifting' || _vm.currentRoute.name === 'CorporationGiftingComcast' || _vm.currentRoute.name === 'CorporationReferral'
    },
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    } + ' !important')
  }, [(_vm.currentRoute.name !== 'Feedback' && _vm.currentRoute.name !== 'Maintainance' && _vm.isUserLoggedIn) ? _c('a', {
    staticClass: "fixed-fab-btn logged",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.headerMenusClick('/contactus')
      }
    }
  }, [_vm._v("\n            Tell us what you think\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isNativeApp && (_vm.user && _vm.user.corporation == null) && _vm.showGiftingLinks) ? _c('span', [(_vm.currentRoute.name !== 'Gift' && _vm.currentRoute.name !== 'Gifts' && _vm.currentRoute.name !== 'Redeem,' && _vm.currentRoute.name !== 'SignUp' && _vm.currentRoute.name !== 'AccentureCharlotte' && _vm.currentRoute.name !== 'TrialExpiry' && _vm.currentRoute.name !== 'InterestList' && _vm.currentRoute.name !== 'CorporationGifting' && _vm.currentRoute.name !== 'CorporationGiftingComcast' && _vm.currentRoute.name !== 'CorporationReferral' && _vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    staticClass: "giftslink",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Gifts"
    },
    on: {
      "click": function($event) {
        return _vm.headerMenusClick('/gifts')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gift"
  }, [_c('span', [_vm._v(_vm._s(_vm.getGiftingText))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isNativeApp && (_vm.user && _vm.user.corporation == null) && !_vm.showGiftingLinks && _vm.getAuthLeftTopBannerMessage && _vm.currentRoute.path != _vm.getAuthLeftTopBannerUrl) ? _c('div', {
    staticClass: "cust-corp-banner"
  }, [(!_vm.getAuthLeftTopBannerUrl || _vm.getAuthLeftTopBannerUrl.length < 3) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.getAuthLeftTopBannerMessage) + "\n            ")]) : _c('span', [(_vm.getAuthLeftTopBannerUrl) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": _vm.getAuthLeftTopBannerUrl
    },
    on: {
      "click": function($event) {
        return _vm.corpBannerRedirect(_vm.getAuthLeftTopBannerUrl)
      }
    }
  }, [_vm._v(_vm._s(_vm.getAuthLeftTopBannerMessage))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isNativeApp && (_vm.user && _vm.user.corporation && _vm.user.corporation.giftIconState === 1) && _vm.showGiftingLinks) ? _c('span', [(_vm.currentRoute.name !== 'Gift' && _vm.currentRoute.name !== 'Gifts' && _vm.currentRoute.name !== 'Redeem,' && _vm.currentRoute.name !== 'SignUp' && _vm.currentRoute.name !== 'AccentureCharlotte' && _vm.currentRoute.name !== 'TrialExpiry' && _vm.currentRoute.name !== 'InterestList' && _vm.currentRoute.name !== 'CorporationGifting' && _vm.currentRoute.name !== 'CorporationGiftingComcast' && _vm.currentRoute.name !== 'CorporationReferral' && _vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    staticClass: "giftslink",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Gifts"
    },
    on: {
      "click": function($event) {
        return _vm.headerMenusClick('/gifts')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gift"
  }, [_c('span', [_vm._v(_vm._s(_vm.getGiftingText))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isNativeApp && (_vm.user && _vm.user.corporation && _vm.user.corporation.giftIconState === 2) && _vm.showGiftingLinks) ? _c('span') : _vm._e(), _vm._v(" "), (!_vm.isNativeApp && (_vm.user && _vm.user.corporation && _vm.user.corporation.giftIconState === 3)) ? _c('div', {
    staticClass: "cust-corp-banner"
  }, [(!_vm.user.corporation.giftIconUrl) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.user.corporation.giftIconMessage) + "\n            ")]) : _c('span', [(_vm.user.corporation.giftIconMessage) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": _vm.user.corporation.giftIconMessage
    },
    on: {
      "click": function($event) {
        return _vm.corpBannerRedirect(_vm.user.corporation.giftIconUrl)
      }
    }
  }, [_vm._v(_vm._s(_vm.user.corporation.giftIconMessage))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.logoClickRedirect
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "TONE LOGO"
    }
  })])]), _vm._v(" "), (_vm.getCustomUnauthBannerStatus && (_vm.currentRoute.name === 'UnAuth' && _vm.currentRoute.name !== 'Maintainance') && !_vm.hideBanner) ? _c('div', {
    staticClass: "notificationtext"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.getCustomUnauthBannerLink)
      }
    }
  }, [_vm._v(_vm._s(_vm.getCustomUnauthBannerText))]), _vm._v(" "), _c('a', {
    staticClass: "close",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.hideBanner = true
      }
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), (_vm.getBannerEvent > 0 && !_vm.getCustomUnauthBannerStatus && (_vm.currentRoute.name === 'UnAuth' && _vm.currentRoute.name !== 'Maintainance') && !_vm.hideBanner) ? _c('div', {
    staticClass: "notificationtext"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/event')
      }
    }
  }, [_vm._v(_vm._s(_vm.eventDescription))]), _vm._v(" "), _c('a', {
    staticClass: "close",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.hideBanner = true
      }
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), (_vm.getBannerEvent > 0 && (_vm.currentRoute.name !== 'UnAuth' && _vm.currentRoute.name !== 'Event' && _vm.currentRoute.name !== 'Rules' && _vm.currentRoute.name !== 'Events' && _vm.currentRoute.name !== 'Talk' && _vm.currentRoute.name !== 'LiveEvent') && _vm.user && _vm.user.corporation == null) ? _c('div', {
    staticClass: "notificationtext"
  }, [(_vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.JoinEventOrRedirect
    }
  }, [_vm._v(_vm._s(_vm.authEventDescription))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.corporation && _vm.user.corporation.corporationId > 0 && _vm.user.corporation.enableCorporatePage === 1) ? _c('span', [(_vm.getBannerEvent > 0 && (_vm.currentRoute.name !== 'UnAuth' && _vm.currentRoute.name !== 'Event' && _vm.currentRoute.name !== 'Rules' && _vm.currentRoute.name !== 'Events' && _vm.currentRoute.name !== 'Talk' && _vm.currentRoute.name !== 'LiveEvent') && (_vm.user && _vm.user.corporation && _vm.user.corporation.corporationId > 0 && _vm.user.corporation.enableCorporatePage === 0)) ? _c('div', {
    staticClass: "notificationtext"
  }, [(_vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.JoinEventOrRedirect
    }
  }, [_vm._v(_vm._s(_vm.authEventDescription))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getBannerEvent > 0 && (_vm.currentRoute.name !== 'UnAuth' && _vm.currentRoute.name !== 'Event' && _vm.currentRoute.name !== 'Rules' && _vm.currentRoute.name !== 'Events' && _vm.currentRoute.name !== 'Talk' && _vm.currentRoute.name !== 'LiveEvent') && (_vm.user && _vm.user.corporation && _vm.user.corporation.corporationId > 0 && _vm.user.corporation.enableCorporatePage === 1 && _vm.user.corporation.bnrLinkState === 1)) ? _c('div', {
    staticClass: "notificationtext"
  }, [(_vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.JoinEventOrRedirect
    }
  }, [_vm._v(_vm._s(_vm.authEventDescription))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getBannerEvent > 0 && (_vm.currentRoute.name !== 'UnAuth' && _vm.currentRoute.name !== 'Event' && _vm.currentRoute.name !== 'Rules' && _vm.currentRoute.name !== 'Events' && _vm.currentRoute.name !== 'Talk' && _vm.currentRoute.name !== 'LiveEvent') && (_vm.user && _vm.user.corporation && _vm.user.corporation.corporationId > 0 && _vm.user.corporation.enableCorporatePage === 1 && _vm.user.corporation.bnrLinkState === 2)) ? _c('div', {
    staticClass: "notificationtext"
  }, [(_vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/corporation/mycommunity')
      }
    }
  }, [_vm._v(_vm._s(_vm.user.corporation.corpEvent.authBannerText))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getBannerEvent > 0 && (_vm.currentRoute.name !== 'UnAuth' && _vm.currentRoute.path != _vm.user.corporation.bnrCustomMsgUrl && (_vm.user && _vm.user.corporation && _vm.user.corporation.corporationId > 0 && _vm.user.corporation.enableCorporatePage === 1 && _vm.user.corporation.bnrLinkState === 3))) ? _c('div', {
    staticClass: "notificationtext"
  }, [(_vm.currentRoute.name !== 'Maintainance') ? _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.user.corporation.bnrCustomMsgUrl)
      }
    }
  }, [_vm._v(_vm._s(_vm.user.corporation.bnrCustomMsg))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isNav),
      expression: "!isNav"
    }],
    staticClass: "nav-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('nav', {
    staticClass: "navbar",
    class: [_vm.isUserLoggedIn ? 'static-min-height' : 'default-min-height'],
    style: ([_vm.isMobile ? {
      'backgroundColor': _vm.getCorpHeaderColor
    } : {}])
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [(!_vm.isNativeAppNavigation) ? _c('button', {
    staticClass: "pull-left navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#header-navbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "mobile-version",
    attrs: {
      "width": "172px",
      "height": "69px",
      "viewBox": "0 0 172 69",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Design-Round-5",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_1200_PINK",
      "transform": "translate(-514.000000, -33.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Main-Nav"
    }
  }, [_c('g', {
    attrs: {
      "id": "Mast-Head"
    }
  }, [_c('a', {
    on: {
      "click": _vm.logoClickRedirect
    }
  }, [_c('image', {
    attrs: {
      "id": "Logo",
      "x": "514",
      "y": "33",
      "width": "171.952381",
      "height": "69",
      "xlink:href": "data:image/png;base64,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"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-loginLogoutholder"
  }, [(!_vm.isUserLoggedIn && !_vm.getCorporateGiftingCode) ? _c('a', {
    staticClass: "btn btn-link",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('login')
      }
    }
  }, [_vm._v("Sign In\n                                        ")]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn && !_vm.isNativeApp) ? _c('a', {
    staticClass: "btn btn-link",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.getCorporateClient ? _vm.redeemGiftcodeMobile() : _vm.$router.push('/signup')
      }
    }
  }, [(_vm.getCorporateGiftingCode && _vm.getCorporateClient) ? _c('span', [_vm._v("Redeem")]) : _c('span', [_vm._v("\n                                                Join\n                                                ")])]) : _vm._e()]), _vm._v(" "), (!_vm.isNativeAppNavigation && (_vm.currentRoute.name !== 'B2b')) ? _c('a', {
    staticClass: "collapsed nav-icon navbar-toggle search-icon",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "false",
      "aria-controls": "nav-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchClick()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "id": "header-navbar"
    }
  }, [_c('ul', {
    staticClass: "nav application-icons navbar-nav navbar-left margin-left"
  }, [(!_vm.isNativeAppNavigation) ? _c('li', [(_vm.isUserLoggedIn && _vm.user.minVidReqdWork) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/work'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon career-icon"
  }), _vm._v(" "), _c('p', [_vm._v("WORK")])]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/content/work'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon career-icon"
  }), _vm._v(" "), _c('p', [_vm._v("WORK")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [(_vm.isUserLoggedIn && _vm.user.minVidReqdLife) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/life'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon inspiration-icon"
  }), _vm._v(" "), _c('p', [_vm._v("LIFE")])]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/content/life'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon inspiration-icon"
  }), _vm._v(" "), _c('p', [_vm._v("LIFE")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [(_vm.isUserLoggedIn && _vm.user.minVidReqdMindBody) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/mindbody'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon mind-body-icon"
  }), _vm._v(" "), _c('p', [_vm._v("MIND BODY")])]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/content/mindbody'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon mind-body-icon"
  }), _vm._v(" "), _c('p', [_vm._v("MIND BODY")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [(_vm.isUserLoggedIn && _vm.user.minVidReqdMoney) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/money'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon money-icon"
  }), _vm._v(" "), _c('p', [_vm._v("MONEY")])]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/content/money'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon money-icon"
  }), _vm._v(" "), _c('p', [_vm._v("MONEY")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [(_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/events'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar fa-2x",
    staticStyle: {
      "font-size": "22px",
      "margin": "0 0 8px",
      "color": "#8a8a8a"
    }
  }), _vm._v(" "), _c('p', [_vm._v("EVENTS")])]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/newevents'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar fa-2x",
    staticStyle: {
      "font-size": "22px",
      "margin": "0 0 8px",
      "color": "#8a8a8a"
    }
  }), _vm._v(" "), _c('p', [_vm._v("EVENTS")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [(_vm.isUserLoggedIn) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/profile/playlist'
      }
    }
  }, [_c('img', {
    staticClass: "playlistsimg",
    attrs: {
      "src": __webpack_require__(839),
      "alt": "TONE PLAYLISTS"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "playlistswhite",
    attrs: {
      "src": __webpack_require__(840),
      "alt": "TONE PLAYLISTS"
    }
  }), _vm._v(" "), _c('p', [_vm._v("PLAYLISTS")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [_c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/experts'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o fa-2x",
    staticStyle: {
      "font-size": "22px",
      "margin": "0 0 8px",
      "color": "#8a8a8a"
    }
  }), _vm._v(" "), _c('p', [_vm._v("EXPERTS")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [_c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/resources'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-newspaper-o fa-2x"
  }), _vm._v(" "), _c('p', [_vm._v("IN THE NEWS")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isNativeAppNavigation) ? _c('li', [(!_vm.user || (_vm.user && !_vm.user.corporation) || (_vm.user && _vm.user.corporation && _vm.user.corporation.enableCorporatePage === 0)) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/b2b'
      }
    }
  }, [_c('img', {
    staticClass: "businessimg",
    attrs: {
      "src": __webpack_require__(828),
      "alt": "TONE B2B"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "businessimgwhite",
    attrs: {
      "src": __webpack_require__(827),
      "alt": "TONE B2B"
    }
  }), _vm._v(" "), _c('p', [_vm._v("FOR BUSINESS")])]) : _vm._e(), _vm._v(" "), (_vm.user && (_vm.user.corporation && _vm.user.corporation.enableCorporatePage === 1)) ? _c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/corporation/mycommunity'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-suitcase fa-2x",
    staticStyle: {
      "font-size": "22px",
      "margin": "0 0 8px",
      "color": "#8a8a8a"
    }
  }), _vm._v(" "), _c('p', [_vm._v("MY COMPANY")])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right",
    class: [_vm.isUserLoggedIn ? 'margin-default' : 'margin-minimum']
  }, [(!_vm.isNativeAppNavigation && _vm.currentRoute.name !== 'B2b') ? _c('li', {
    staticClass: "mid-icons mobile-responsive-hide"
  }, [_c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/search'
      }
    }
  }, [_c('i', {
    staticClass: "nav-icon search-icon"
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn) ? _c('li', {
    staticClass: "mid-icons login-btn"
  }, [(!_vm.isNativeApp) ? _c('a', {
    staticClass: "btn btn-link",
    style: ({
      'border-width': '1px !important',
      'border-style': 'solid !important',
      'border-color': this.getCorpButtonColor + ' !important',
      'color': '#FFFFFF'
    }),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.getCorporateGiftInfo ? _vm.redeemGiftcode() : _vm.$router.push('/signup')
      }
    }
  }, [(_vm.getCorporateGiftingCode && _vm.getCorporateClient && _vm.getCorporateGiftInfo) ? _c('span', [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _c('span', [_vm._v("Join")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn && !_vm.getCorporateGiftingCode) ? _c('li', {
    staticClass: "mid-icons login-btn"
  }, [_c('a', {
    staticClass: "btn btn-link",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('login')
      }
    }
  }, [_vm._v("\n                                                Sign In\n                                            ")])]) : _vm._e(), _vm._v(" "), (!_vm.isUserLoggedIn && !_vm.getCorporateGiftingCode) ? _c('li', {
    staticClass: "mid-icons sign-up-button"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg",
    on: {
      "click": _vm.directToSignup
    }
  }, [_vm._v("\n                                                Start Your Free Trial\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.isUserLoggedIn) ? _c('li', {
    staticClass: "mid-icons login-btn"
  }, [_c('a', {
    style: ([!_vm.isMobile ? {
      'border-width': '1px !important',
      'border-style': 'solid !important',
      'border-color': this.getCorpButtonColor + ' !important',
      'color': _vm.getCorpHeadingColor
    } : {
      'border': '1px solid' + _vm.getCorpHeaderColor + ' !important',
      'color': _vm.getCorpHeadingColor,
      'backgroundColor': '#fff'
    }]),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])]) : _vm._e(), _vm._v(" "), (_vm.isUserLoggedIn) ? _c('li', {
    staticClass: "userProfile"
  }, [(_vm.isUserLoggedIn.picture) ? _c('span', [_c('a', {
    staticClass: "logged",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.gotoProfile()
      }
    }
  }, [(_vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2) ? _c('span', [_c('img', {
    staticClass: "img-responsive img-circle",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-brd.png",
      "alt": "USER PROFILE"
    }
  })]) : _c('span', [_c('img', {
    staticClass: "img-responsive img-circle",
    attrs: {
      "src": _vm.isUserLoggedIn.picture,
      "alt": "USER SHOE"
    }
  })]), _vm._v(" "), (_vm.user.firstName) ? _c('span', {
    staticClass: "usernamelimit"
  }, [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))]) : _vm._e()])]) : _c('span', [_c('router-link', {
    staticClass: "logged",
    attrs: {
      "to": {
        path: '/profile'
      }
    }
  }, [_c('img', {
    staticClass: "img-responsive img-circle",
    attrs: {
      "src": "http://placekitten.com/g/200/200",
      "alt": "USER PROFILE"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "usernamelimit"
  }, [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])], 1)]) : _vm._e()]), _vm._v(" "), (!_vm.user) ? _c('div', {
    staticClass: "text-center unauth-links"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.startMsgBoard && _vm.msgDuration > 10 && _vm.msgBoard && _vm.user && (_vm.currentRoute.name !== 'TrialExpiry' || _vm.currentRoute.name !== 'Rules' || _vm.currentRoute.name !== 'LiveEvent' || _vm.currentRoute.name !== 'Talk')) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "alert alert-info text-center alertmsg"
  }, [(_vm.msgBoard[0].destinationURL && (_vm.msgBoard[0].destinationURL.indexOf('http') > -1 || _vm.msgBoard[0].destinationURL.indexOf('/') === 0)) ? _c('span', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.messageBoardRedirect(_vm.msgBoard[0])
      }
    }
  }, [_vm._v(_vm._s(_vm.msgBoard[0].bannerMessage))])]) : _c('span', [_vm._v("\n                        " + _vm._s(_vm.msgBoard[0].bannerMessage) + "\n                    ")]), _vm._v(" "), _c('a', {
    staticClass: "close",
    attrs: {
      "title": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    staticClass: "loginModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showModal,
      "width": "400"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('div', {
    staticClass: "loginHeaderModal",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "bodyContent"
  }, [(!_vm.isForget) ? _c('div', {
    staticClass: "login-modal"
  }, [_c('div', [_c('h2', [_vm._v("Sign In")])]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "id": "login_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "padding-minus"
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "login_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.info.email),
      callback: function($$v) {
        _vm.$set(_vm.info, "email", $$v)
      },
      expression: "info.email"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "login_password",
      "error": "Password",
      "type": "password",
      "placeholder": "Password",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.info.password),
      callback: function($$v) {
        _vm.$set(_vm.info, "password", $$v)
      },
      expression: "info.password"
    }
  })], 1), _vm._v(" "), _c('checkbox', {
    attrs: {
      "value": "isChecked",
      "type": "primary"
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n                                    Remember me\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(!_vm.spinner) ? _c('button', {
    staticClass: "btn formButton btn-transparent",
    attrs: {
      "id": "login_button"
    }
  }, [_vm._v("\n                                        Sign In\n                                    ")]) : _vm._e(), _vm._v(" "), (_vm.spinner) ? _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "forgotPassword",
    attrs: {
      "href": "javascript:",
      "id": "login_lnkforgotpassword"
    },
    on: {
      "click": function($event) {
        _vm.isForget = !_vm.isForget
      }
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Forget your password ?")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "forgotPassword",
    attrs: {
      "href": "javascript:",
      "id": "login_redirectsingup"
    },
    on: {
      "click": function($event) {
        return _vm.redirectSignup()
      }
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Don't have an account? Subscribe here!")])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isForget) ? _c('div', {
    staticClass: "forget-password-modal"
  }, [_c('div', [_c('h2', {
    staticClass: "forgot-heading"
  }, [_vm._v("\n                                Forgot your password?\n                            ")]), _vm._v(" "), _c('p', [_vm._v("Enter your email address to reset your password. your may need")]), _vm._v(" "), _c('p', [_vm._v("to check your spam folder to unblock")]), _vm._v(" "), _c('p', [_vm._v("no-reply@tonenetworks.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "id": "forgot_password_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitForgetRequest.apply(null, arguments)
      }
    }
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "forgot_password_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.forgetPassword.email),
      callback: function($$v) {
        _vm.$set(_vm.forgetPassword, "email", $$v)
      },
      expression: "forgetPassword.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn formButton",
    attrs: {
      "disabled": _vm.spinner,
      "id": "forgot_password_proceed"
    }
  }, [_vm._v("\n                                        Submit\n                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "forgotPassword",
    attrs: {
      "href": "javascript:",
      "id": "login_lnkbacktologin"
    },
    on: {
      "click": function($event) {
        _vm.isForget = !_vm.isForget
      }
    }
  }, [_c('strong', [_vm._v("Back to Sign In")])])])], 1)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showExpiryModal) ? _c('modal', {
    staticClass: "expiredmodal",
    attrs: {
      "value": _vm.showExpiryModal,
      "effect": "zoom"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelExpiryModal()
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(75),
      "alt": "LOGO"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "close",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelExpiryModal()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('h2', [_vm._v("We don't want to lose you!")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Your credit card on file is expiring in " + _vm._s(_vm.getCardExpiryDays) + " "), (_vm.getCardExpiryDays > 1) ? _c('span', [_vm._v("days.")]) : _c('span', [_vm._v("day.")]), _vm._v(" Help us keep your information up to date.")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center small"
  }, [_c('button', {
    staticClass: "btn formButton btn-transparent",
    on: {
      "click": function($event) {
        _vm.cancelExpiryModal();
        _vm.$router.push('/profile')
      }
    }
  }, [_vm._v("\n                        Update Payment Info\n                    ")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelExpiryModal()
      }
    }
  }, [_vm._v("Not now, I'll update later")]), _c('br'), _vm._v("\n                    If you have any questions please contact us at "), _c('a', {
    attrs: {
      "href": "mailto:feedback@tonenetworks.com"
    }
  }, [_vm._v("feedback@tonenetworks.com")]), _c('br'), _vm._v("\n                    For more information on our Terms of Services, "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.cancelExpiryModal();
        _vm.$router.push('/terms')
      }
    }
  }, [_vm._v("click here")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showExpiredModal) ? _c('modal', {
    staticClass: "expiredmodal",
    attrs: {
      "backdrop": false,
      "value": _vm.showExpiredModal,
      "effect": "zoom"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelExpiredModal()
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('img', {
    staticClass: "expiryModalImage",
    attrs: {
      "src": __webpack_require__(75),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('h2', [_vm._v("Whoops, your payment failed! ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("We were unable to verify your payment method on file. Don't worry, we'll try your payment again over the next five days. To keep Tone Networks access, you may need to update your payment details.")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center small"
  }, [_c('button', {
    staticClass: "btn formButton btn-transparent",
    on: {
      "click": function($event) {
        _vm.cancelExpiredModal();
        _vm.$router.push('/profile')
      }
    }
  }, [_vm._v("\n                        Update Payment Info\n                    ")]), _c('br'), _vm._v("\n                    If you have any questions please contact us at "), _c('a', {
    attrs: {
      "href": "mailto:feedback@tonenetworks.com"
    }
  }, [_vm._v("feedback@tonenetworks.com")]), _c('br'), _vm._v("\n                    For more information on our Terms of Services, "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.cancelExpiredModal();
        _vm.$router.push('/terms')
      }
    }
  }, [_vm._v("click here")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logged",
    attrs: {
      "href": "https://blog.tonenetworks.com/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-rss fa-2x"
  }), _vm._v(" "), _c('p', [_vm._v("BLOG")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.facebook.com/tonenetworks/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-square fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://twitter.com/ToneNetworks",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter-square fa-2x",
    attrs: {
      "data-v-5cb853a2": "",
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.instagram.com/tonenetworks/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x",
    attrs: {
      "data-v-5cb853a2": "",
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/25037986/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin-square fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCarjWAb1SWrzKtoeNimOVJA/videos",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-play fa-2x"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7063ff53", module.exports)
  }
}

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "signup_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "left-content"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true
    }
  }, [_c('panel', {
    staticClass: "text-left",
    attrs: {
      "is-open": true
    }
  }, [_c('div', {
    staticClass: "create-account"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "action": "/charge",
      "method": "post",
      "id": "payment-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onPaymentSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "radiowrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corpSel),
      expression: "corpSel"
    }],
    attrs: {
      "type": "radio",
      "value": "E",
      "name": "corpSelection"
    },
    domProps: {
      "checked": _vm._q(_vm.corpSel, "E")
    },
    on: {
      "change": function($event) {
        _vm.corpSel = "E"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v("Existing Corporation")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix showmobile"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corpSel),
      expression: "corpSel"
    }],
    attrs: {
      "type": "radio",
      "value": "N",
      "name": "corpSelection"
    },
    domProps: {
      "checked": _vm._q(_vm.corpSel, "N")
    },
    on: {
      "change": function($event) {
        _vm.corpSel = "N"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "two"
    }
  }, [_vm._v("Create New Corporation")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.corpSel === 'E') ? _c('div', [_c('div', {
    staticClass: "clearfix gap"
  }), _vm._v(" "), (_vm.getCorporateClients) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateClientId),
      expression: "corporateClientId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.corporateClientId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getCorporateClients), function(option) {
    return _c('option', {
      domProps: {
        "value": option.corporationId
      }
    }, [_vm._v("\n                                                                " + _vm._s(option.name) + "\n                                                            ")])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.corpSel === 'N') ? _c('div', [(_vm.corpSel === 'N') ? _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z ]+$/,
      "type": "text",
      "error": "Corporation Name (no digits allowed)",
      "placeholder": "New Corporation Name",
      "required": "",
      "name": "corporationName",
      "icon": ""
    },
    model: {
      value: (_vm.userObject.name),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "name", $$v)
      },
      expression: "userObject.name"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.corpSel === 'N') ? _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /\S+@\S+\.\S+/,
      "id": "corp_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Corporation Email Address",
      "name": "email",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.userObject.email),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "email", $$v)
      },
      expression: "userObject.email"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Choose your membership plan:")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "checkboxholder"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "radio disabled"
  }, [_c('label', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Two Year Plan")]), _vm._v(" "), _c('span', {
    staticClass: "plan-price"
  }, [_vm._v("$" + _vm._s(_vm.twoYearPlan.description) + " "), _c('span', {
    staticClass: "permonth"
  }, [_vm._v("per month")])]), _vm._v(" "), (_vm.twoYearPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "disabled": "",
      "type": "radio",
      "id": "2yearplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.twoYearPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.twoYearPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.twoYearPlan.packageId
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "footertext"
  }, [_vm._v("$" + _vm._s(_vm.twoYearPlan.amount) + " billed annually")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "radio popular"
  }, [_c('label', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("One Year Plan")]), _vm._v(" "), _c('span', {
    staticClass: "plan-price"
  }, [_vm._v("$" + _vm._s(_vm.annualPlan.description) + " "), _c('span', {
    staticClass: "permonth"
  }, [_vm._v("per month")])]), _vm._v(" "), (_vm.annualPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "type": "radio",
      "id": "annualplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.annualPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.annualPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.annualPlan.packageId
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "footertext"
  }, [_vm._v("$" + _vm._s(_vm.annualPlan.amount) + " billed annually")])])])]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "radio disabled"
  }, [_c('label', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Monthly Plan")]), _vm._v(" "), _c('span', {
    staticClass: "plan-price"
  }, [_vm._v("$" + _vm._s(_vm.defaultPlan.amount) + " "), _c('span', {
    staticClass: "permonth"
  }, [_vm._v("per month")])]), _vm._v(" "), (_vm.defaultPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "disabled": "",
      "type": "radio",
      "id": "monthlyplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.defaultPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.defaultPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.defaultPlan.packageId
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "footertext"
  }, [_vm._v("billed monthly")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row calculations"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Total Subscriptions")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "error": "Total SubScriptions",
      "placeholder": "",
      "min": "1",
      "required": "",
      "name": "subscriptionCount"
    },
    model: {
      value: (_vm.userObject.subscriptionCount),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "subscriptionCount", $$v)
      },
      expression: "userObject.subscriptionCount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 thirditem"
  }, [_c('h5', [_vm._v("Package Amount: $" + _vm._s(_vm.planAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 forthitem"
  }, [(_vm.userObject.subscriptionCount > 0) ? _c('h5', [_vm._v("Total Amount: $" + _vm._s(Number((_vm.userObject.subscriptionCount * _vm.planAmount)).toLocaleString()))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "codediv"
  }, [_c('div', {
    staticClass: "radiowrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gateway),
      expression: "gateway"
    }],
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "CC",
      "name": "paymentMethod"
    },
    domProps: {
      "checked": _vm._q(_vm.gateway, "CC")
    },
    on: {
      "change": function($event) {
        _vm.gateway = "CC"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v("Credit Card")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gateway),
      expression: "gateway"
    }],
    attrs: {
      "type": "radio",
      "id": "two",
      "value": "paypal",
      "name": "paymentMethod"
    },
    domProps: {
      "checked": _vm._q(_vm.gateway, "paypal")
    },
    on: {
      "change": function($event) {
        _vm.gateway = "paypal"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "two"
    }
  }, [_vm._v("Paypal")])]), _vm._v(" "), (_vm.gateway === 'CC') ? _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "paymentMethod_cardHolder",
      "pattern": /^[A-Za-z ]+$/,
      "type": "text",
      "error": "Card Holder Name (no digits allowed)",
      "placeholder": "Card Holder Name",
      "required": "",
      "name": "cardholdername",
      "icon": ""
    },
    model: {
      value: (_vm.userObject.cardHolderName),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "cardHolderName", $$v)
      },
      expression: "userObject.cardHolderName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.gateway === 'CC') ? _c('div', {
    staticClass: "stripeholder"
  }, [(_vm.gateway === 'CC') ? _c('i', {
    staticClass: "fa fa-lock overlapstripe"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field",
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), (_vm.stripeErrorMessage) ? _c('div', {
    staticStyle: {
      "color": "#a94442",
      "margin": "2px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.stripeErrorMessage))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.gateway === 'paypal') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "text-center margin-top-10 margin-bottom-10",
    attrs: {
      "id": "paypal-button"
    }
  })]), _vm._v(" "), (_vm.userPayments.paymentMethodNonce) ? _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left success"
  }, [_c('p', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Payment successfully authorized")])])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "Billing Street",
      "placeholder": "Billing Street",
      "required": "",
      "name": "corporationstate",
      "maxlength": 100,
      "icon": ""
    },
    model: {
      value: (_vm.userObject.billingStreet),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "billingStreet", $$v)
      },
      expression: "userObject.billingStreet"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "Billing City",
      "placeholder": "Billing City",
      "required": "",
      "name": "corporationcity",
      "maxlength": 50,
      "icon": ""
    },
    model: {
      value: (_vm.userObject.billingCity),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "billingCity", $$v)
      },
      expression: "userObject.billingCity"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "Billing State",
      "placeholder": "Billing State",
      "required": "",
      "name": "corporationstate",
      "maxlength": 2,
      "icon": ""
    },
    model: {
      value: (_vm.userObject.billingState),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "billingState", $$v)
      },
      expression: "userObject.billingState"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "error": "Billing Zip",
      "placeholder": "Billing Zip",
      "required": "",
      "name": "billingZip",
      "maxlength": 8,
      "icon": ""
    },
    model: {
      value: (_vm.userObject.billingZip),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "billingZip", $$v)
      },
      expression: "userObject.billingZip"
    }
  })], 1)]), _vm._v(" "), _c('checkbox', {
    staticClass: "terms-and-condition",
    attrs: {
      "value": "isChecked",
      "type": "primary",
      "name": "termsconditionschckbox"
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n                                                         I agree to "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "_blank",
      "rel": "opener"
    }
  }, [_vm._v("terms and conditions")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "id": "signup_button",
      "disabled": !_vm.isChecked || _vm.spinner,
      "name": "completesignupbutton"
    }
  }, [_vm._v("\n                                                        Process Payment\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])])])])])], 1)], 1)])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), _c('h2', [_vm._v("\n                                Welcome to TONE. Congrats on your sale!\n                                ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7113f34d", module.exports)
  }
}

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.user && _vm.logoutSuccess) ? _c('h3', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left "
  }), _c('i', {
    staticClass: "fa fa-chevron-left "
  }), _c('i', {
    staticClass: "fa fa-chevron-left "
  }), _vm._v("\n            Logging out ..\n            "), _c('i', {
    staticClass: "fa fa-chevron-left "
  }), _c('i', {
    staticClass: "fa fa-chevron-left "
  }), _c('i', {
    staticClass: "fa fa-chevron-left "
  })]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-716462d9", module.exports)
  }
}

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75ef478a", module.exports)
  }
}

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewcharity"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "blog-section white-bg clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-md-push-7"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_c('br'), _vm._v(" "), _c('i', {
    staticClass: "nav-icon giving-icon"
  }), _vm._v(" "), _c('br'), _c('span', [_vm._v(_vm._s(_vm.selectedCharity.name))])]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.selectedCharity.description) + " "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-md-pull-5"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, [_c('div', {
    staticClass: "slide-player"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.selectedCharity.img_url
    }
  })])])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-78b910b7", module.exports)
  }
}

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "validate-content",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    staticClass: "heading"
  }, [(_vm.validationSuccess) ? _c('i', {
    staticClass: "fa fa-2x fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error.show) ? _c('i', {
    staticClass: "fa fa-2x fa-times"
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n                Account Validation\n            ")])])]), _vm._v(" "), (_vm.validationSuccess) ? _c('div', [_c('strong', [_vm._v("Thank You! Your Account has been validated")]), _vm._v(" "), (!_vm.user) ? _c('h3', {
    staticClass: "redirectMsg"
  }, [_vm._v("Log In to TONE Networks!")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.error.show) ? _c('div', [_c('strong', [_vm._v("Sorry! Your Account could not be validated")]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.error.message))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right "
  }), _c('i', {
    staticClass: "fa fa-chevron-right "
  }), _c('i', {
    staticClass: "fa fa-chevron-right "
  }), _vm._v("\n            Redirecting now\n            "), _c('i', {
    staticClass: "fa fa-chevron-right "
  }), _c('i', {
    staticClass: "fa fa-chevron-right "
  }), _c('i', {
    staticClass: "fa fa-chevron-right "
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d18a2b6", module.exports)
  }
}

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "corporatecommunity"
  }, [(_vm.associatedCorporation) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "smallimgholder"
  }, [(_vm.associatedCorporation.smallImage) ? _c('img', {
    attrs: {
      "src": _vm.associatedCorporation.smallImage,
      "alt": "CORP IMAGE",
      "title": _vm.associatedCorporation.name
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hidemobile"
  }, [_c('br'), _vm._v(" "), _c('b', [_vm._v(" " + _vm._s(_vm.associatedCorporation.pageWelcomeMessage))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(340),
      "alt": "APP QR CODE",
      "text": "APP QR Code"
    }
  }), _c('br'), _vm._v(" " + _vm._s(_vm.associatedCorporation.pageWelcomeMessage) + "Scan the QR code to download our app and enjoy Tone on the go!\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 margin-bottom-40"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [(_vm.associatedCorporation.showSpotlightSection || _vm.associatedCorporation.showPinnedMessages) ? _c('li', {
    staticClass: "community",
    class: {
      current: _vm.selectedTab === 'community'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('community')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("Community")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "events",
    class: {
      current: _vm.selectedTab === 'events'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('events')
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), (_vm.getCorpPrivateVideos) ? _c('li', {
    staticClass: "events",
    class: {
      current: _vm.selectedTab === 'videos'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('videos')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v(" Videos")])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPlaylists) ? _c('li', {
    staticClass: "playlists",
    class: {
      current: _vm.selectedTab === 'playlists'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('playlists')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("Playlists")])]) : _vm._e()])]), _vm._v(" "), (_vm.selectedTab === 'community') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.community
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [(_vm.associatedCorporation.showSpotlightSection) ? _c('div', {
    staticClass: "row video-row introparacard"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.associatedCorporation.spotlightPic) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('img', {
    attrs: {
      "src": _vm.associatedCorporation.spotlightPic,
      "alt": "SPOTLIGHT IMAGE",
      "title": "In Spotlight"
    }
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.associatedCorporation.spotlightPara1) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.associatedCorporation.spotlightPara1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.associatedCorporation.spotlightPara2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.associatedCorporation.spotlightPara2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.associatedCorporation.spotlightPara3) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.associatedCorporation.spotlightPara3)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.associatedCorporation.spotlightQuote) ? _c('blockquote', [_vm._v("\"" + _vm._s(_vm.associatedCorporation.spotlightQuote) + "\"")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr', {
    staticClass: "redhr"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getCorporationPinnedMsgs && (_vm.associatedCorporation.showPinnedMessages || _vm.associatedCorporation.showPinnedMessages === 1)) ? _c('div', {
    staticClass: "pinnedmsgs"
  }, [(_vm.associatedCorporation.pinnedMessageHeading) ? _c('h3', [_vm._v(_vm._s(_vm.associatedCorporation.pinnedMessageHeading) + " "), _c('i', {
    staticClass: "fa fa-map-pin "
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._l((_vm.getCorporationPinnedMsgs), function(msg) {
    return _c('div', {
      staticClass: "borderedbox"
    }, [_c('h4', [_vm._v(_vm._s(msg.msgSenderName) + " "), _c('small', [_vm._v(_vm._s(msg.msgSentDateFmt))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(msg.corpAdminMessage))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'events') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.events
    },
    attrs: {
      "id": "tabs-2"
    }
  }, [(_vm.getCorpMainEvent) ? _c('div', {
    staticClass: "row video-row"
  }, [_c('h3', [_c('b', [_vm._v("Join " + _vm._s(_vm.associatedCorporation.name) + " and TONE Networks for Event this " + _vm._s(_vm.getDateReference(_vm.getCorpMainEvent.start_date, 'str')))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [_c('div', [_c('h3', [_vm._v("Choose how you want to join the event. You can join as yourself or step into someone else's shoes using our anonymous shoe-cognito mode")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "title": "Join event"
    },
    on: {
      "click": function($event) {
        return _vm.generateUnAuthTokenAndRedirect('0')
      }
    }
  }, [_vm._v("Jane")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "title": "Join event"
    },
    on: {
      "click": function($event) {
        return _vm.generateUnAuthTokenAndRedirect('1')
      }
    }
  }, [_vm._v("Shoe-Incognito")]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 imgresponsive"
  }, [_c('img', {
    attrs: {
      "src": _vm.getCorpMainEvent.img_url,
      "alt": "CORP MAIN EVENT BANENR",
      "title": _vm.getCorpMainEvent.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-left large-text"
  }, [_c('h3', [_vm._v(_vm._s(_vm.getCorpMainEvent.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpMainEvent.longDescription))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpMainEvent.start_date, 'str')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), (_vm.getCorpPrivateEvents && _vm.getCorpPrivateEvents.length >= 2) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_c('b', [(_vm.associatedCorporation.privateEventHeading) ? _c('h3', [_c('b', [_vm._v(_vm._s(_vm.associatedCorporation.privateEventHeading))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 imgresponsive large-text text-left"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getCorpPrivateEvents[0].img_url,
      "alt": "PRIVATE EVENT BANNER",
      "title": _vm.getCorpPrivateEvents[0].title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpPrivateEvents[0].start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpPrivateEvents[0].eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    attrs: {
      "title": "Add to Calendar"
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpPrivateEvents[0].type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '3') ? _c('span', [_vm._v(_vm._s(_vm.associatedCorporation.name) + "'s Self-Hosted Event")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 imgresponsive large-text text-left"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getCorpPrivateEvents[1].img_url,
      "alt": "PRIVATE EVENT BANNER",
      "title": _vm.getCorpPrivateEvents[1].title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].longDescription))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpPrivateEvents[1].start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpPrivateEvents[1].eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    attrs: {
      "title": "Add to Calendar"
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpPrivateEvents[0].type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[1].type === '3') ? _c('span', [_vm._v(_vm._s(_vm.associatedCorporation.name) + "'s Self-Hosted Event")]) : _vm._e()])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents && _vm.getCorpPrivateEvents.length === 1) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_c('b', [(_vm.associatedCorporation.privateEventHeading) ? _c('h3', [_c('b', [_vm._v(_vm._s(_vm.associatedCorporation.privateEventHeading))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 m-auto imgresponsive large-text text-left"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getCorpPrivateEvents[0].img_url,
      "alt": "PRIVATE EVENT BANNER",
      "title": _vm.getCorpPrivateEvents[0].title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpPrivateEvents[0].start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpPrivateEvents[0].eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    attrs: {
      "title": "Add to Calendar"
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpPrivateEvents[0].type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '3') ? _c('span', [_vm._v(_vm._s(_vm.associatedCorporation.name) + "'s Self-Hosted Event")]) : _vm._e()])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px",
      "border-bottom": "3px solid #cbcbcb",
      "margin-bottom": "30px"
    }
  }), _vm._v(" "), (_vm.getCorpPublicEvents) ? _c('div', {
    staticClass: "sliderEventBox"
  }, [(_vm.associatedCorporation.toneEventHeading) ? _c('h2', [_vm._v(_vm._s(_vm.associatedCorporation.toneEventHeading))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.getCorpPublicEvents), function(ev) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('h2', {
      staticClass: "carosalh2",
      staticStyle: {
        "color": "#f0617d"
      }
    }, [(ev.type === '1') ? _c('span', [_vm._v(" TONE Live\n")]) : _c('span', [_vm._v(" TONE Talk")])]), _vm._v(" "), _c('img', {
      staticClass: "sliderimage",
      attrs: {
        "src": ev.img_url,
        "alt": "PUBLIC EVENT BANNER",
        "title": ev.title
      }
    }), _vm._v(" "), _c('h2', [_c('a', {
      attrs: {
        "href": '/event/' + ev.eventId,
        "target": "new"
      }
    }, [_vm._v(_vm._s(_vm.getDateReference(ev.start_date, 'live')) + ":  " + _vm._s(_vm.getExpertInfo(ev.expertId, 'name')))])]), _vm._v(" "), _c('p', [_vm._v("\n                                            " + _vm._s(ev.longDescription) + "\n                                        ")]), _vm._v(" "), _c('h5', [_vm._v("LIVE " + _vm._s(_vm.getDateReference(ev.start_date, 'live2')))]), _vm._v(" "), (!_vm.showJoin(ev.eventId)) ? _c('div', {
      staticClass: "addeventatc pinkoutlinebtn",
      attrs: {
        "title": "Add to Calendar"
      }
    }, [_vm._v("\n                                            Add to Calendar\n                                            "), _c('span', {
      staticClass: "start"
    }, [_vm._v(_vm._s(ev.start_date))]), _vm._v(" "), _c('span', {
      staticClass: "end"
    }, [_vm._v(_vm._s(ev.end_date))]), _vm._v(" "), _c('span', {
      staticClass: "timezone"
    }, [_vm._v("ev/New_York")]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(ev.title))]), _vm._v(" "), _c('span', {
      staticClass: "description"
    }, [_vm._v(_vm._s(ev.longDescription))]), _vm._v(" "), _c('span', {
      staticClass: "location"
    }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(ev.eventId))])]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px",
      "border-bottom": "3px solid #cbcbcb",
      "margin-bottom": "30px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.associatedCorporation.archiveEventHeading) ? _c('h3', [_c('strong', [_vm._v(_vm._s(_vm.associatedCorporation.archiveEventHeading))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "clearfix"
  }) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "sliderEventBox pointer"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.getCorpArchiveEvents), function(evn) {
    return _c('div', {
      staticClass: "col-sm-4",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('img', {
      staticClass: "sliderimage",
      attrs: {
        "src": evn.img_url,
        "alt": "PRIVATE EVENT BANNER",
        "title": evn.title
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), _vm._v(" "), _c('h2', {
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v(_vm._s(evn.title))]), _vm._v(" "), _c('p', {
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v("\n                                                " + _vm._s(evn.longDescription) + "\n\n                                            ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px",
      "border-bottom": "1px solid #ddd"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'videos') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.videos
    },
    attrs: {
      "id": "tabs-3"
    }
  }, [(_vm.associatedCorporation.videoTabHeading) ? _c('h3', [_c('b', [_vm._v(_vm._s(_vm.associatedCorporation.videoTabHeading))])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.getCorpPrivateVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v("\n                                                 " + _vm._s(video.title) + "\n                                             ")])])])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'playlists') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.playlists
    },
    attrs: {
      "id": "tabs-4"
    }
  }, [(_vm.getCorpPlaylists) ? _c('div', {
    staticClass: "row video-row plistisrow"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.associatedCorporation.playlistHeading) ? _c('h2', [_vm._v(_vm._s(_vm.associatedCorporation.playlistHeading))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  })]), _vm._v(" "), _vm._l((_vm.getCorpPlaylists), function(playlist) {
    return (playlist.userPlaylistVideos) ? _c('div', [_c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 "
    }, [(playlist.userPlaylistVideos && playlist.userPlaylistVideos.length > 0) ? _c('div', {
      staticClass: "pinkbg"
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pinksidebarmin"
    }, [_c('span', {
      staticClass: "numb"
    }, [_c('strong', [_vm._v(_vm._s(playlist.userPlaylistVideos.length))])]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-envelope-o",
      attrs: {
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.openCorporateShareModal(playlist)
        }
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 pltext"
    }, [_c('h3', {
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }, [_vm._v(_vm._s(playlist.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(playlist.description))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix",
      staticStyle: {
        "height": "10px"
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.getCropUserSharedVideos) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Here are all videos shared with you by your colleagues")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row  video-row plistisrow lowerlist"
  }, _vm._l((_vm.getCropUserSharedVideos), function(video) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "videoholdersuggestions"
    }, [_c('img', {
      attrs: {
        "src": video.thumbnailURL,
        "alt": video.videoTitle,
        "title": video.videoTitle
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(video.videoCode)
        }
      }
    }), _vm._v(" "), _c('h3', {
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(video.videoCode)
        }
      }
    }, [_vm._v(_vm._s(video.videoTitle))]), _vm._v(" "), _c('p', [_vm._v("Shared by " + _vm._s(video.senderName))]), _vm._v(" "), _c('p', [_vm._v("Message: " + _vm._s(video.messageText))])])])
  }), 0)]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share This Playlist\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")])])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg",
      "alt": "user-shoe"
    }
  })]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Jane")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.corpShareModalImage,
      "alt": _vm.corpShareModalTitle,
      "title": _vm.corpShareModalTitle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s((_vm.corpShareModalTitle + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.corpShareModalDesc.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    attrs: {
      "disabled": _vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0)
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share This Playlist\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as Jane\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('span', {
    staticClass: "hidemobile"
  }, [_vm._v("Career")]), _vm._v(" Coaching")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                                            Please follow the event guidelines:\n                                            "), _c('span', [_vm._v("1.)")]), _vm._v(" Keep it positive, supportive and respectful;\n                                            "), _c('span', [_vm._v("2.)")]), _vm._v(" Please be thoughtful and stay on topic;\n                                            "), _c('span', [_vm._v("3.)")]), _vm._v(" Please do not post copyrighted material, ads, solicitations or anyone's personal info including your own;\n                                            "), _c('span', [_vm._v("4.)")]), _vm._v(" Please refer to TONE's "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "new",
      "title": "click to view our terms"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" for more information.\n                                        ")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7ea4666d", module.exports)
  }
}

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper bodyfont-unauth"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "video-player autoheight"
  }, [(_vm.currentVideo && !_vm.showThumbnail) ? _c('div', {
    staticClass: "show-video-class"
  }, [_c('h2', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), _c('jwplayer', {
    attrs: {
      "id": "mainVideoPlayer",
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e(), _vm._v(" "), (_vm.currentVideo && _vm.showThumbnail) ? _c('div', {
    staticClass: "show-video-thumbnail"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), _c('img', {
    staticClass: "makeitgray ",
    attrs: {
      "src": _vm.currentVideo.img,
      "alt": _vm.currentVideo.title,
      "title": _vm.currentVideo.title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "thumbnail-messaing"
  }, [_vm._v("\n                                Want more tips?"), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/signup')
      }
    }
  }, [_vm._v(" Sign up ")]), _vm._v(" today for your free TONE trial! No credit card required!\n                            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.videoNotFoundFlag) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "player-content"
  }, [_c('p', {
    staticClass: "video-description"
  }, [_vm._v("\n                            " + _vm._s(_vm.currentVideo.Description) + "\n                        ")]), _vm._v(" "), (_vm.getCorpButtonColor === '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getCorpButtonColor !== '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.videoExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.videoExpert[0].expertId + '/' + _vm.videoExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.videoExpert[0].small_image,
      "alt": _vm.videoExpert && _vm.videoExpert[0].name,
      "title": _vm.videoExpert && _vm.videoExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                            " + _vm._s(_vm.videoExpert && _vm.videoExpert[0].areasofexpertise) + "\n                        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoTag && _vm.videoTag !== 'COMMUNITY') ? _c('h2', [_vm._v("MORE " + _vm._s(_vm.videoTag) + " VIDEOS")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoList) ? _c('div', {
    staticClass: "row morevediosrow"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider largeslidesilderplayicon"
  }, _vm._l((_vm.videoList), function(vid) {
    return _c('div', {
      staticClass: "slide-player"
    }, [(_vm.videoList) ? _c('div', {}, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + vid.mediaid + '/' + vid.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": vid.image,
        "alt": vid.title,
        "title": vid.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(vid.title))])])]) : _vm._e()])
  }), 0)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "errormessage"
  }, [_vm._v("This video is for Members only. "), _c('br'), _vm._v("\n                Become a member today by starting your Free Trial")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-86595488", module.exports)
  }
}

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100vh"
    },
    attrs: {
      "src": "https://www.podpage.com/have-you-had-this-conversation/"
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8baefe52", module.exports)
  }
}

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "liveEventContent"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "liveEvent"
  }, [_c('h3', [_vm._v("Hey, Jane. Great to see you. Welcome to TONE Live!")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.jwEventRef,
      "frameborder": "0",
      "scrolling": "auto",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "100%",
      "height": "220",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "allowtransparency": "true",
      "src": _vm.chatRollURL
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "attendees"
  }, [_c('div', {
    staticClass: "attendeesContent"
  }, [_c('h2', [_vm._v("attendees")]), _vm._v(" "), _c('div', {
    staticClass: "liveEventImage"
  }, [(_vm.eventUsersArray) ? _c('div', {
    staticClass: "slider responsive-slick-slider-live"
  }, _vm._l((_vm.eventUsersArray), function(userList) {
    return _c('div', {
      staticClass: "sliderBox"
    }, [(userList[0]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[0].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[0].picture,
        "alt": "USER-SHOE",
        "title": userList[0].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[0].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[0].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[1]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[1].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[1].picture,
        "alt": "USER-SHOE",
        "title": userList[1].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[1].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[1].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[2]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[2].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[2].picture,
        "alt": "USER-SHOE",
        "title": userList[2].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[2].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[2].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[3]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[3].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[3].picture,
        "alt": "USER-SHOE",
        "title": userList[3].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[3].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[3].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-congnito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[4]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[4].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[4].picture,
        "alt": "USER-SHOE",
        "title": userList[4].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[4].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[4].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[5]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[5].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[5].picture,
        "alt": "USER-SHOE",
        "title": userList[5].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[5].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[5].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[6]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[6].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[6].picture,
        "alt": "USER-SHOE",
        "title": userList[6].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[6].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[6].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[7]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[7].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[7].picture,
        "alt": "USER-SHOE",
        "title": userList[7].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[7].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[7].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-congnito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[8]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[8].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[8].picture,
        "alt": "USER-SHOE",
        "title": userList[8].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[8].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[8].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-congnito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[9]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[9].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[9].picture,
        "alt": "USER-SHOE",
        "title": userList[9].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[9].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[9].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[10]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[10].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[10].picture,
        "alt": "USER-SHOE",
        "title": userList[10].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[10].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[10].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-congnito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[11]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[11].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[11].picture,
        "alt": "USER-SHOE",
        "title": userList[11].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[11].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[11].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[12]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[12].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[12].picture,
        "alt": "USER-SHOE",
        "title": userList[12].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[12].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[12].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[13]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[13].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[13].picture,
        "alt": "USER-SHOE",
        "title": userList[13].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[13].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[13].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-congnito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[14]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[14].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[14].picture,
        "alt": "USER-SHOE",
        "title": userList[14].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[14].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[14].picture,
        "alt": "USER-SHOE",
        "title": _vm.Shoe - _vm.cognito
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()])
  }), 0) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "aboutExpert"
  }, [_c('h2', [_vm._v("about the expert")]), _vm._v(" "), _c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": _vm.getExpert[0].name,
      "title": _vm.getExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getExpert[0].experties))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.getSelectedEvent[0].longDescription) + "\n                    ")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-915672dc", module.exports)
  }
}

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp bodyfont-unauth"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "signup_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), (_vm.getCorporateClient) ? _c('h2', [_vm._v("\n                                " + _vm._s(_vm.getCorporateClient.welcomeMessage) + "\n                                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "left-content"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true
    }
  }, [_c('panel', {
    staticClass: "text-left",
    attrs: {
      "is-open": true
    }
  }, [_c('h4', [_vm._v("Set Up Your Account")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "create-account"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "action": "/charge",
      "method": "post",
      "id": "payment-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onPaymentSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z ]+$/,
      "id": "referral_firstname",
      "type": "text",
      "error": "First Name (no digits allowed)",
      "placeholder": "First Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.userObject.firstName),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "firstName", $$v)
      },
      expression: "userObject.firstName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /^[A-Za-z ]+$/,
      "id": "referral_lastname",
      "type": "text",
      "error": "Last Name (no digits allowed)",
      "placeholder": "Last Name",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.userObject.lastName),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "lastName", $$v)
      },
      expression: "userObject.lastName"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "pattern": /\S+@\S+\.\S+/,
      "id": "referral_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.userObject.email),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "email", $$v)
      },
      expression: "userObject.email"
    }
  }), _vm._v(" "), _c('vue-password', {
    staticClass: "form-input",
    attrs: {
      "minlength": 6,
      "classes": "input form-control",
      "placeholder": "Password",
      "error": "Password",
      "id": "referral_password",
      "disableStrength": _vm.hidePasswordMeter,
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.userObject.password),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "password", $$v)
      },
      expression: "userObject.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-info-circled alert-icon-float-left information password-error"
  }, [_c('p', {
    staticClass: "alert alert-info alert-dismissable password-error-color",
    class: {
      'set-error': !_vm.verifyPassword()
    },
    attrs: {
      "id": "signup_pwderrormsg"
    }
  }, [_vm._v("Min 6 Chars, One Upper Case, One Lower Case!")])]), _vm._v(" "), _c('div', {
    staticClass: "checkboxholder"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [(_vm.defaultPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "type": "radio",
      "id": "defplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.defaultPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.defaultPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.defaultPlan.packageId
      }
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.defaultPlan.description) + " (" + _vm._s(_vm.defaultPlan.type) + "): $" + _vm._s(_vm.defaultPlan.amount) + "\n                                                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "codediv"
  }, [_c('div', {
    staticClass: "radiowrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gateway),
      expression: "gateway"
    }],
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "CC",
      "name": "paymentMethod"
    },
    domProps: {
      "checked": _vm._q(_vm.gateway, "CC")
    },
    on: {
      "change": function($event) {
        _vm.gateway = "CC"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v("Credit Card")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gateway),
      expression: "gateway"
    }],
    attrs: {
      "type": "radio",
      "id": "two",
      "value": "paypal",
      "name": "paymentMethod"
    },
    domProps: {
      "checked": _vm._q(_vm.gateway, "paypal")
    },
    on: {
      "change": function($event) {
        _vm.gateway = "paypal"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "two"
    }
  }, [_vm._v("Paypal")])]), _vm._v(" "), (_vm.gateway === 'CC') ? _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "paymentMethod_cardHolder",
      "pattern": /^[A-Za-z ]+$/,
      "type": "text",
      "error": "Card Holder Name (no digits allowed)",
      "placeholder": "Card Holder Name",
      "required": "",
      "name": "cardholdername",
      "icon": ""
    },
    model: {
      value: (_vm.userObject.cardHolderName),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "cardHolderName", $$v)
      },
      expression: "userObject.cardHolderName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.gateway === 'CC') ? _c('div', {
    staticClass: "stripeholder"
  }, [(_vm.gateway === 'CC') ? _c('i', {
    staticClass: "fa fa-lock overlapstripe"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field",
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), (_vm.stripeErrorMessage) ? _c('div', {
    staticStyle: {
      "color": "#a94442",
      "margin": "2px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.stripeErrorMessage))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.gateway === 'paypal') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "text-center margin-top-10 margin-bottom-10",
    attrs: {
      "id": "paypal-button"
    }
  })]), _vm._v(" "), (_vm.userPayments.paymentMethodNonce) ? _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left success"
  }, [_c('p', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Payment successfully authorized")])])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('checkbox', {
    staticClass: "terms-and-condition",
    attrs: {
      "value": "isChecked",
      "type": "primary",
      "id": "referraltermsconditionschckbox"
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n                                                         I agree to "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "_blank",
      "rel": "opener"
    }
  }, [_vm._v("terms and conditions")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "id": "referrSignup_button",
      "disabled": !_vm.isChecked || _vm.spinner,
      "name": "completesignupbutton"
    }
  }, [_vm._v("\n                                                        Complete Sign Up\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, [(_vm.dynamic_bullet_1) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_2) ? _c('li', {
    staticClass: "hidemobile",
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_3) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_3)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_4) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_4)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_5) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_5)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_6) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_6)
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer hidemobile"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.defaultPlan.description))])])])])])])])])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "hidemobile"
  }, [_c('h2', [_vm._v("Member Benefits")]), _c('p', [_vm._v("What You Get")])]), _vm._v(" "), _c('div', {
    staticClass: "showmobile"
  }, [_c('h2', [_vm._v("What You Get")])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-94815cf4", module.exports)
  }
}

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper bodyfont-unauth"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "video-player autoheight"
  }, [_c('div', {
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.currentVideo) ? _c('div', {
    staticClass: "reset-video-width"
  }, [_c('h2', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), _c('jwplayer', {
    attrs: {
      "id": "mainVideoPlayer",
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.videoNotFoundFlag) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.videoTag && _vm.videoTag !== 'COMMUNITY') ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "player-content"
  }, [_c('p', {
    staticClass: "video-description"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentVideo.Description) + "\n                    ")]), _vm._v(" "), (_vm.getCorpButtonColor === '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getCorpButtonColor !== '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.videoExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.videoExpert[0].expertId + '/' + _vm.videoExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.videoExpert[0].small_image,
      "alt": _vm.videoExpert[0].name,
      "title": _vm.videoExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.videoExpert && _vm.videoExpert[0].areasofexpertise) + "\n                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoTag && _vm.videoTag !== 'COMMUNITY') ? _c('h2', [_vm._v("MORE " + _vm._s(_vm.videoTag) + " VIDEOS")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoList) ? _c('div', {
    staticClass: "row morevediosrow"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider largeslidesilderplayicon"
  }, _vm._l((_vm.videoList), function(vid) {
    return _c('div', {
      staticClass: "slide-player"
    }, [(_vm.videoList) ? _c('div', {}, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + vid.mediaid + '/' + vid.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": vid.image,
        "alt": vid.title,
        "title": vid.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(vid.title))])])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.showComponent) ? _c('h4', [_vm._v("Want more tips ? Sign up today for your free TONE trial!")]) : _vm._e(), _vm._v(" "), (_vm.showComponent) ? _c('div', {
    staticClass: "text-center"
  }, [(!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/signup')
      }
    }
  }, [_vm._v("Start Your Free Trial")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redeemCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {}, [(_vm.categoryVideoList) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.categoryVideoList), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      },
      on: {
        "click": function($event) {
          return _vm.triggerLogin(video.mediaid)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      staticStyle: {
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          return _vm.triggerLogin(video.mediaid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])])
  })], 2) : _vm._e()])]), _vm._v(" "), (_vm.showComponent) ? _c('h2', {
    staticClass: "pink-text-headline",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(" and many more ...")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "errormessage"
  }, [_vm._v("This video is for Members only. "), _c('br'), _vm._v("\n            Become a member today by starting your Free Trial")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9fb45a86", module.exports)
  }
}

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "corporatecommunity"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "smallimgholder"
  }, [_c('br'), _vm._v(" "), (_vm.siblingCorps && _vm.user.isSuperUser) ? _c('button', {
    staticClass: "btn formButton btn-block smallimgholder",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openSwitchModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.getParentCorporation.name) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.smallImage,
      "alt": "CORP IMAGE",
      "title": _vm.user.corporation.name
    }
  }), _c('div', {
    staticClass: "hidemobile"
  }, [_c('br'), _vm._v(" "), _c('b', [_vm._v(" " + _vm._s(_vm.user.corporation.pageWelcomeMessage))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(340),
      "alt": "APP QR CODE",
      "text": "APP QR Code"
    }
  }), _c('br'), _vm._v(" " + _vm._s(_vm.user.corporation.pageWelcomeMessage) + "Scan the QR code to download our app and enjoy Tone on the go!\n                        "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 margin-bottom-40"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [(_vm.user.corporation.showSpotlightSection || _vm.user.corporation.showPinnedMessages) ? _c('li', {
    staticClass: "community",
    class: {
      current: _vm.selectedTab === 'community'
    },
    style: ([_vm.selectedTab === 'community' ? {
      'borderBottom': '1px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '1px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.switchTab('community')
      }
    }
  }, [_c('a', {
    style: ([_vm.selectedTab === 'community' ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("Community")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "events",
    class: {
      current: _vm.selectedTab === 'events'
    },
    style: ([_vm.selectedTab === 'events' ? {
      'borderBottom': '1px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '1px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.switchTab('events')
      }
    }
  }, [_c('a', {
    style: ([_vm.selectedTab === 'events' ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_c('span', {
    staticClass: "hidemobile"
  }, [_vm._v("Coaching")]), _vm._v(" Events")])]), _vm._v(" "), (_vm.getCorpPrivateVideos) ? _c('li', {
    staticClass: "events",
    class: {
      current: _vm.selectedTab === 'videos'
    },
    style: ([_vm.selectedTab === 'videos' ? {
      'borderBottom': '1px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '1px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.switchTab('videos')
      }
    }
  }, [_c('a', {
    style: ([_vm.selectedTab === 'videos' ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v(" Videos")])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPlaylists) ? _c('li', {
    staticClass: "playlists",
    class: {
      current: _vm.selectedTab === 'playlists'
    },
    style: ([_vm.selectedTab === 'playlists' ? {
      'borderBottom': '1px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '1px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.switchTab('playlists')
      }
    }
  }, [_c('a', {
    style: ([_vm.selectedTab === 'playlists' ? {
      'color': _vm.getCorpHeadingColor
    } : {
      'color': '#333'
    }]),
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("Playlists")])]) : _vm._e()])]), _vm._v(" "), (_vm.selectedTab === 'community') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.community
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [(_vm.user.corporation.showSpotlightSection) ? _c('div', {
    staticClass: "row video-row introparacard"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.user.corporation.spotlightPic) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.corporation.spotlightPic,
      "alt": "SPOTLIGHT IMAGE",
      "title": "In Spotlight"
    }
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.user.corporation.spotlightPara1) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.user.corporation.spotlightPara1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.corporation.spotlightPara2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.user.corporation.spotlightPara2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.corporation.spotlightPara3) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.user.corporation.spotlightPara3)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.user.corporation.spotlightQuote) ? _c('blockquote', [_vm._v("\"" + _vm._s(_vm.user.corporation.spotlightQuote) + "\"")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr', {
    staticClass: "redhr",
    style: ({
      'border-color': this.getCorpHeaderColor + ' !important'
    })
  })])]) : _vm._e(), _vm._v(" "), (_vm.getCorporationPinnedMsgs && (_vm.user.corporation.showPinnedMessages || _vm.user.corporation.showPinnedMessages === 1)) ? _c('div', {
    staticClass: "pinnedmsgs"
  }, [(_vm.user.corporation.pinnedMessageHeading) ? _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.user.corporation.pinnedMessageHeading) + " "), _c('i', {
    staticClass: "fa fa-map-pin "
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._l((_vm.getCorporationPinnedMsgs), function(msg) {
    return _c('div', {
      staticClass: "borderedbox"
    }, [_c('h4', [_vm._v(_vm._s(msg.msgSenderName) + " "), _c('small', [_vm._v(_vm._s(msg.msgSentDateFmt))])]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(msg.corpAdminMessage)
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'events') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.events
    },
    attrs: {
      "id": "tabs-2"
    }
  }, [(_vm.getCorpMainEvent) ? _c('div', {
    staticClass: "row video-row"
  }, [(_vm.getCorpMainEvent.isPrivate === 1) ? _c('h3', [_c('b', [_vm._v("Join " + _vm._s(_vm.user.corporation.name) + " and TONE Networks for this EXCLUSIVE coaching event on " + _vm._s(_vm.getDateReference(_vm.getCorpMainEvent.start_date, 'str')))])]) : _vm._e(), _vm._v(" "), (_vm.getCorpMainEvent.isPrivate !== 1) ? _c('h3', [_c('b', [_vm._v("Join our monthly livestream events for interactive coaching that is designed for your personal and professional needs. Get your questions ready!")])]) : _vm._e(), _vm._v(" "), (_vm.getCorpMainEvent && _vm.getCorpMainEvent.type !== '3' && _vm.showJoin(_vm.getCorpMainEvent.eventId)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.getCorpMainEvent) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.getCorpMainEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 imgresponsive"
  }, [_c('img', {
    attrs: {
      "src": _vm.getCorpMainEvent.img_url,
      "alt": "CORP MAIN EVENT BANENR",
      "title": _vm.getCorpMainEvent.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-left large-text"
  }, [_c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.getCorpMainEvent.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpMainEvent.longDescription))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpMainEvent.start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpMainEvent.eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.getCorpMainEvent.title)
      }
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpMainEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpMainEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpMainEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpMainEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpMainEvent.isPrivate === 1) ? _c('span', [(_vm.getCorpMainEvent.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpMainEvent.type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpMainEvent.type === '3') ? _c('span', [_vm._v(_vm._s(_vm.user.corporation.name) + "'s Self-Hosted Event")]) : _vm._e()]) : _c('span', [(_vm.getCorpMainEvent.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.getCorpMainEvent.eventId))]) : _vm._e(), _vm._v(" "), (_vm.getCorpMainEvent.type === '2') ? _c('span', [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.getCorpMainEvent.eventId))]) : _vm._e(), _vm._v(" "), (_vm.getCorpMainEvent.type === '3') ? _c('span', [_vm._v(_vm._s(_vm.user.corporation.name) + "'s Self-Hosted Event")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.getCorpMainEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getCorpMainEvent && _vm.getCorpMainEvent.type !== '3' && !_vm.showJoin(_vm.getCorpMainEvent.eventId)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.getCorpMainEvent) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.getCorpMainEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents && _vm.getCorpPrivateEvents.length >= 2) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_c('b', [(_vm.user.corporation.privateEventHeading) ? _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_c('b', [_vm._v(_vm._s(_vm.user.corporation.privateEventHeading))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 imgresponsive large-text text-left"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getCorpPrivateEvents[0].img_url,
      "alt": "PRIVATE EVENT BANNER",
      "title": _vm.getCorpPrivateEvents[0].title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpPrivateEvents[0].start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpPrivateEvents[0].eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.getCorpPrivateEvents[0].title)
      }
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpPrivateEvents[0].type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '3') ? _c('span', [_vm._v(_vm._s(_vm.user.corporation.name) + "'s Self-Hosted Event")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.getCorpPrivateEvents[0])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 imgresponsive large-text text-left"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getCorpPrivateEvents[1].img_url,
      "alt": "PRIVATE EVENT BANNER",
      "title": _vm.getCorpPrivateEvents[1].title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].longDescription))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpPrivateEvents[1].start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpPrivateEvents[1].eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.getCorpPrivateEvents[1].title)
      }
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpPrivateEvents[1].type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[1].type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[1].type === '3') ? _c('span', [_vm._v(_vm._s(_vm.user.corporation.name) + "'s Self-Hosted Event")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.getCorpPrivateEvents[1])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                    ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents && _vm.getCorpPrivateEvents.length === 1) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_c('b', [(_vm.user.corporation.privateEventHeading) ? _c('h3', [_c('b', [_vm._v(_vm._s(_vm.user.corporation.privateEventHeading))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 m-auto imgresponsive large-text text-left"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getCorpPrivateEvents[0].img_url,
      "alt": "PRIVATE EVENT BANNER",
      "title": _vm.getCorpPrivateEvents[0].title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpPrivateEvents[0].start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpPrivateEvents[0].eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.getCorpPrivateEvents[0].title)
      }
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpPrivateEvents[0].type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '3') ? _c('span', [_vm._v(_vm._s(_vm.user.corporation.name) + "'s Self-Hosted Event")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.getCorpPrivateEvents[0])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                    ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px",
      "border-bottom": "3px solid #cbcbcb",
      "margin-bottom": "30px"
    }
  }), _vm._v(" "), (_vm.getCorpPublicEvents) ? _c('div', {
    staticClass: "sliderEventBox"
  }, [(_vm.user.corporation.toneEventHeading) ? _c('h2', [_vm._v(_vm._s(_vm.user.corporation.toneEventHeading))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPublicEvents) ? _c('VueSlickCarousel', _vm._b({}, 'VueSlickCarousel', _vm.carouselSettings, false), _vm._l((_vm.getCorpPublicEvents), function(ev) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('h2', {
      staticClass: "carosalh2",
      style: ({
        color: _vm.getCorpHeadingColor + ' !important'
      })
    }, [(ev.type === '1') ? _c('span', [_vm._v(" TONE Live\n")]) : _c('span', [_vm._v(_vm._s(ev.title) + " ")])]), _vm._v(" "), _c('img', {
      staticClass: "sliderimage",
      attrs: {
        "src": ev.img_url,
        "alt": "PUBLIC EVENT BANNER",
        "title": ev.title
      }
    }), _vm._v(" "), _c('h2', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor + ' !important'
      }),
      attrs: {
        "href": '/event/' + ev.eventId,
        "target": "new"
      }
    }, [_vm._v(_vm._s(_vm.getDateReference(ev.start_date, 'live')) + " with " + _vm._s(_vm.replaceLastExpert(ev.csvExpertsNames, ',', ' & ')))])]), _vm._v(" "), _c('p', [_vm._v("\n                                            " + _vm._s(ev.longDescription) + "\n                                        ")]), _vm._v(" "), _c('h5', [_vm._v("LIVE " + _vm._s(_vm.getDateReference(ev.start_date, 'live2')))]), _vm._v(" "), (!_vm.showJoin(ev.eventId)) ? _c('div', {
      staticClass: "addeventatc pinkoutlinebtn",
      style: ({
        color: _vm.getCorpButtonColor + ' !important',
        border: '1px solid ' + _vm.getCorpButtonColor
      }),
      attrs: {
        "title": "Add to Calendar"
      },
      on: {
        "click": function($event) {
          return _vm.calendarLogging($event, ev.title)
        }
      }
    }, [_vm._v("\n                                            Add to Calendar\n                                            "), _c('span', {
      staticClass: "start"
    }, [_vm._v(_vm._s(ev.start_date))]), _vm._v(" "), _c('span', {
      staticClass: "end"
    }, [_vm._v(_vm._s(ev.end_date))]), _vm._v(" "), _c('span', {
      staticClass: "timezone"
    }, [_vm._v("ev/New_York")]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(ev.title))]), _vm._v(" "), _c('span', {
      staticClass: "description"
    }, [_vm._v(_vm._s(ev.longDescription))]), _vm._v(" "), _c('span', {
      staticClass: "location"
    }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(ev.eventId))])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
      staticClass: "share-event",
      style: ({
        color: _vm.getCorpButtonColor + ' !important',
        borderWidth: '1px !important',
        borderStyle: 'solid !important',
        borderColor: _vm.getCorpButtonColor + ' !important'
      }),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openCorporateImageShareModal(ev)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-share-square-o"
    }), _vm._v(" Share\n                                        ")]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px",
      "border-bottom": "3px solid #cbcbcb",
      "margin-bottom": "30px"
    },
    attrs: {
      "id": "missed"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.user.corporation.archiveEventHeading) ? _c('h3', [_c('strong', [_vm._v(_vm._s(_vm.user.corporation.archiveEventHeading))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "clearfix"
  }) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "sliderEventBox pointer"
  }, [(_vm.getCorpArchiveEvents) ? _c('VueSlickCarousel', _vm._b({}, 'VueSlickCarousel', _vm.carouselSettings, false), _vm._l((_vm.getCorpArchiveEvents), function(evn) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('div', {
      staticClass: "show-share-options",
      style: ({
        backgroundColor: _vm.getCorpHeadingColor,
        'cursor': 'pointer'
      })
    }, [_c('img', {
      staticClass: "sliderimage",
      attrs: {
        "src": evn.img_url,
        "alt": "PRIVATE EVENT BANNER",
        "title": evn.title
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), _c('div', {
      staticClass: "favnumbers-a",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(evn.allVidDurInMinutes)), _c('small', [_vm._v("mins")])])]), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "title": "Play"
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpArchiveEventOptnPermission >= 1))) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          _vm.openCorporateShareModal('event', evn)()
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('h2', {
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v(_vm._s(evn.title))]), _vm._v(" "), _c('p', {
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v("\n                                                " + _vm._s(evn.longDescription) + "\n\n                                            ")])])
  }), 0) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px",
      "border-bottom": "1px solid #ddd"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'videos') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.videos
    },
    attrs: {
      "id": "tabs-3"
    }
  }, [(_vm.user.corporation.videoTabHeading) ? _c('h3', [_c('b', [_vm._v(_vm._s(_vm.user.corporation.videoTabHeading))])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.getCorpPrivateVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v("\n                                                 " + _vm._s(video.title) + "\n                                             ")])])])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'playlists') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.playlists
    },
    attrs: {
      "id": "tabs-4"
    }
  }, [(_vm.getCorpPlaylists) ? _c('div', {
    staticClass: "row video-row plistisrow"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.user.corporation.playlistHeading) ? _c('h2', [_vm._v(_vm._s(_vm.user.corporation.playlistHeading))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  })]), _vm._v(" "), _vm._l((_vm.getCorpPlaylists), function(playlist) {
    return (playlist.userPlaylistVideos) ? _c('div', [_c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 "
    }, [(playlist.userPlaylistVideos && playlist.userPlaylistVideos.length > 0) ? _c('div', {
      staticClass: "pinkbg",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pinksidebarmin",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('span', {
      staticClass: "numb"
    }, [_c('strong', [_vm._v(_vm._s(playlist.userPlaylistVideos.length))])]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-play-circle-o",
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareCompanyPlaylistPermission >= 1)) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.openCorporateShareModal('playlist', playlist)
        }
      }
    }) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 pltext"
    }, [_c('h3', {
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }, [_vm._v(_vm._s(playlist.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(playlist.description))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix",
      staticStyle: {
        "height": "10px"
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.getCropUserSharedVideos) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Here are all videos shared with you by your colleagues")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row  video-row plistisrow flexwrap"
  }, _vm._l((_vm.getCropUserSharedVideos), function(video) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [(video.playlistId === 0) ? _c('div', {
      staticClass: "videoholdersuggestions"
    }, [_c('img', {
      attrs: {
        "src": video.thumbnailURL,
        "alt": video.videoTitle,
        "title": video.videoTitle
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(video.videoCode, video.videoTitle)
        }
      }
    }), _vm._v(" "), _c('h3', {
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(video.videoCode, video.videoTitle)
        }
      }
    }, [_vm._v(_vm._s(video.videoTitle))]), _vm._v(" "), _c('p', [_vm._v("Shared by " + _vm._s(video.senderName))]), _vm._v(" "), _c('p', [_vm._v("Message: " + _vm._s(video.messageText))])]) : _vm._e(), _vm._v(" "), (video.playlistId > 0) ? _c('div', {
      staticClass: "videoholdersuggestions "
    }, [_c('div', {
      staticClass: "viderowraper-shared",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylistForShared(video)
        }
      }
    }, [_c('div', {
      staticClass: "favnumbers",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(video.playlistDuration))]), _c('small', [_vm._v("mins")])]), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "title": "Play"
      }
    })]), _vm._v(" "), _c('img', {
      attrs: {
        "src": video.thumbnailURL,
        "alt": video.playlistTitle,
        "title": video.playlistTitle
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylistForShared(video)
        }
      }
    })]), _vm._v(" "), _c('h3', {
      on: {
        "click": function($event) {
          return _vm.playPlaylistForShared(video)
        }
      }
    }, [_vm._v(_vm._s(video.playlistTitle))]), _vm._v(" "), _c('p', [_vm._v("Shared by " + _vm._s(video.senderName))]), _vm._v(" "), _c('p', [_vm._v("Message: " + _vm._s(video.messageText))])]) : _vm._e()])
  }), 0)]) : _vm._e()])])]), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showShareCommunity) ? _c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]) : _vm._e(), _vm._v(" "), (_vm.showShareIndividual) ? _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.showShareFriends) ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.corpShareModalImage,
      "alt": _vm.corpShareModalTitle,
      "title": _vm.corpShareModalTitle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s((_vm.corpShareModalTitle + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.corpShareModalDesc.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor,
      border: '1px solid' + _vm.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess)) || (_vm.shareInProcess)
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share This Playlist\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateSwitch) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateSwitch
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateSwitchModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" Switch to a different corporation\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateSwitchModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.getParentCorporation.name))]), _vm._v(" "), (_vm.getParentCorporation.description) ? _c('h5', [_vm._v(_vm._s(_vm.getParentCorporation.description))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 fourinarow"
  }, _vm._l((_vm.siblingCorps), function(corp) {
    return (_vm.siblingCorps) ? _c('div', {
      staticClass: "radio"
    }, [_c('label', {
      class: {
        active: _vm.selectedCorpId === corp.corporationId
      }
    }, [_c('span', {
      staticClass: "heading"
    }, [_vm._v(_vm._s(corp.name))]), _vm._v(" "), _c('div', {
      staticClass: "embed-responsive embed-responsive-16by9"
    }, [_c('img', {
      staticClass: "thumbnail embed-responsive-item",
      attrs: {
        "src": corp.smallImage ? corp.smallImage : 'https://s3.amazonaws.com/tone-assets/images/corporate/crystal.png',
        "alt": "CORP IMAGE",
        "title": corp.name
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCorpId),
        expression: "selectedCorpId"
      }],
      attrs: {
        "type": "radio",
        "id": corp.corporationId,
        "name": "corpSwitch"
      },
      domProps: {
        "value": corp.corporationId,
        "checked": _vm._q(_vm.selectedCorpId, corp.corporationId)
      },
      on: {
        "change": function($event) {
          _vm.selectedCorpId = corp.corporationId
        }
      }
    })])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateSwitchModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": _vm.shareInProcess || (_vm.selectedCorpId === _vm.user.corporation.corporationId)
    },
    on: {
      "click": function($event) {
        return _vm.switchCorporation()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Switch\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateImageShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateImageShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]), _vm._v(" "), (_vm.shareEventSelected.isPrivate.toString() !== '1') ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.shareEventSelected.img_url,
      "alt": _vm.shareEventSelected.title,
      "title": _vm.shareEventSelected.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.shareEventSelected.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.shareEventSelected.longDescription.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateImage()
      }
    }
  }, [_vm._v("\n                            Share This Event\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showShareCommunity) ? _c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]) : _vm._e(), _vm._v(" "), (_vm.showShareIndividual) ? _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.showShareFriends) ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.corpShareModalImage,
      "alt": _vm.corpShareModalTitle,
      "title": _vm.corpShareModalTitle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s((_vm.corpShareModalTitle + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.corpShareModalDesc.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor,
      border: '1px solid' + _vm.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share This Playlist\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9ff1e25a", module.exports)
  }
}

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row aboutrow"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeaderColor
    })
  }, [_vm._v("TONE Press Room")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-sm-offset-2",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_vm._v("Overview")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "addressholder",
    style: ({
      borderWidth: '2px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    })
  }, [_c('strong', [_vm._v("Kara Brown")]), _vm._v(" "), _c('br'), _vm._v("\n                                kara@smithbrownmarketing.com "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_vm._v("Press Releases")]), _vm._v(" "), (_vm.pressSection) ? _c('div', {
    staticClass: "presscontainer"
  }, _vm._l((_vm.pressSection), function(press) {
    return _c('div', {
      staticClass: "pressentry"
    }, [_c('h5', [_c('a', {
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "href": press.pdfUrl,
        "target": "_blank",
        "rel": "opener"
      }
    }, [_vm._v(_vm._s(press.topicSubHead))]), _vm._v(" "), _c('small', [_vm._v("\n                                    " + _vm._s(press.topicSubHeadDateFmt) + "\n                                ")])]), _vm._v(" "), _c('p', [_vm._v("\n                              " + _vm._s(press.topicSubHeadContents) + "\n                            ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_vm._v("In the News")]), _vm._v(" "), (_vm.newsSection) ? _c('div', {
    staticClass: "presscontainer"
  }, _vm._l((_vm.newsSection), function(news) {
    return _c('div', {
      staticClass: "pressentry"
    }, [_c('h5', [_c('a', {
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "href": news.pdfUrl,
        "target": "_blank",
        "rel": "opener"
      }
    }, [_vm._v(_vm._s(news.topicSubHead))]), _vm._v(" "), _c('small', [_vm._v("\n                                    " + _vm._s(news.topicSubHeadDateFmt) + "\n                                ")])]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(news.topicSubHeadContents) + "\n                            ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_vm._v("Media Access")]), _vm._v(" "), _c('div', {
    staticClass: "row mediasignup"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpHeaderColor
    })
  }, [_vm._v("\n                                Sign Up For Press Release.\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('form', {
    attrs: {
      "id": "footer_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitEmail.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "input-group input-md float-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscriptionForm.email),
      expression: "subscriptionForm.email"
    }],
    staticClass: "form-control",
    style: ({
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "email",
      "placeholder": "email",
      "title": "invalid email address",
      "required": ""
    },
    domProps: {
      "value": (_vm.subscriptionForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscriptionForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon cursor"
  }, [_c('button', {
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                TONE Networks, the first brand of ChartOne Media, is a subscription- based, short form video and social network. The platform features bite-sized videos from highly sought after, credentialed experts covering a range of topics. Designed to effortlessly integrate into the lives of busy women, TONE Networks offers personalized content with actionable tips and access to both expert coaching and peer to peer advice. TONE Networks reinforces the growing women helping women movement by providing a supportive online community complete with live chats and events with its experts, providing a vibrant, supportive community for women.\n                            ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a416555a", module.exports)
  }
}

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "takeawayMobile"
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "bodyContent"
  }, [(_vm.takeawayObject) ? _c('div', {
    staticClass: "smallcontainer"
  }, [_c('div', {
    staticClass: "headsmall"
  }, [_c('img', {
    staticClass: "logosl",
    attrs: {
      "src": __webpack_require__(75)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/mytone')
      }
    }
  }, [_c('img', {
    staticClass: "topbtn",
    attrs: {
      "src": __webpack_require__(74)
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "grad",
    attrs: {
      "src": "https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/0a3d90ee-c79e-472c-9bae-1a89539be47c.jpg"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("Hey there, " + _vm._s(_vm.takeawayObject.firstName))]), _vm._v(" "), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Thanks for watching!The following TONE Takeaways will help you set the tone of your day.")]), _vm._v(" "), _c('a', {
    staticClass: "lglink",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.takeawayObject.video1UrlKey)
      }
    }
  }, [_vm._v(_vm._s(_vm.takeawayObject.video1Key))]), _vm._v(" "), _vm._l((_vm.takeawayObject.tonetakeAways), function(takeaway) {
    return _c('div', {
      staticClass: "listesection"
    }, [_c('div', {
      staticClass: "row"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "briefcasetext"
    }, [_c('h4', [_vm._v("Tone Takeaways:")]), _vm._v(" "), _c('a', {
      staticClass: "brieflink",
      attrs: {
        "href": "javascript:"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(takeaway.videoURL)
        }
      }
    }, [_vm._v(_vm._s(takeaway.vTitle))])])]), _vm._v(" "), (takeaway.tone1) ? _c('div', {
      staticClass: "row listingsection"
    }, [_c('div', {
      staticClass: "listentryholder"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "listingtext"
    }, [_vm._v("\n                            " + _vm._s(takeaway.tone1) + "\n                        ")])]), _vm._v(" "), (takeaway.tone2) ? _c('div', {
      staticClass: "listentryholder"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "listingtext"
    }, [_vm._v("\n                            " + _vm._s(takeaway.tone2) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (takeaway.tone3) ? _c('div', {
      staticClass: "listentryholder"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "listingtext"
    }, [_vm._v("\n                            " + _vm._s(takeaway.tone3) + "\n                        ")])]) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), (_vm.takeawayObject.talkTitle || _vm.takeawayObject.expertName) ? _c('div', {
    staticClass: "purpletextcontainer"
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Upcoming Events")]), _vm._v(" "), (_vm.takeawayObject.talkTitle) ? _c('div', {
    staticClass: "entryholder"
  }, [_c('img', {
    attrs: {
      "src": _vm.takeawayObject.talkImgUrl
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Tone Talk:" + _vm._s(_vm.takeawayObject.talkTitle))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.takeawayObject.talkLongDescription)), _c('br'), _c('br'), _vm._v(_vm._s(_vm.takeawayObject.talkStartDate))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(("/event/" + (_vm.takeawayObject.talkEventId)))
      }
    }
  }, [_vm._v("Add to Calendar")])]) : _vm._e(), _vm._v(" "), (_vm.takeawayObject.expertName) ? _c('div', {
    staticClass: "entryholder"
  }, [_c('img', {
    attrs: {
      "src": _vm.takeawayObject.eventImgUrl
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Tone Live: " + _vm._s(_vm.takeawayObject.expertName))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.takeawayObject.eventLongDescription)), _c('br'), _c('br'), _vm._v(_vm._s(_vm.takeawayObject.eventStartDate))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(("/event/" + (_vm.takeawayObject.eventEventId)))
      }
    }
  }, [_vm._v("Add to Calendar")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/mytone')
      }
    }
  }, [_c('img', {
    staticClass: "topbtn lastlogobutton",
    attrs: {
      "src": __webpack_require__(74)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "pinktext"
  }, [_vm._v("Set the tone of your life")]), _vm._v(" "), _c('p', {
    staticClass: "lastpara"
  }, [_vm._v("- The TONE Team")])], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "briefcasesection"
  }, [_c('img', {
    attrs: {
      "src": "https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/01041c2a-2e73-4ca5-99b9-827c441be3e2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listingimg"
  }, [_c('img', {
    attrs: {
      "src": "https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/24ffbbd6-7718-487e-a23d-7f968c64428f.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listingimg"
  }, [_c('img', {
    attrs: {
      "src": "https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/b0047950-fa37-44f7-9b0c-2ec540e2b6eb.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listingimg"
  }, [_c('img', {
    attrs: {
      "src": "https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/c2bc65aa-8383-4e0f-a6dc-d25fd9828a74.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a428d674", module.exports)
  }
}

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper aboutpage",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row aboutrow"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [(_vm.messageHeader) ? _c('h2', {
    staticClass: "heading"
  }, [_c('strong', [_vm._v(_vm._s(_vm.messageHeader))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.messageText) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.messageText)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.messageImageUrl) ? _c('img', {
    attrs: {
      "src": _vm.messageImageUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bf8a8d2e", module.exports)
  }
}

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.userAuthenticated && _vm.userSignature && _vm.getDemoEvent) ? _c('div', {
    staticClass: "tone-talk"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": "joining event"
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.getDemoEvent.jwRtmpUrl) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-7"
  }, [_c('h3', [_vm._v("discussion")]), _vm._v(" "), (_vm.userSignature) ? _c('div', [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "650",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "allowtransparency": "true",
      "src": _vm.chatRollURL
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-pink",
    on: {
      "click": _vm.leaveEvent
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Leave")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-5"
  }, [_c('h3', [_vm._v("moderator")]), _vm._v(" "), (_vm.getExpert) ? _c('div', {
    staticClass: "moderatorContent"
  }, [_c('img', {
    staticClass: "userImg",
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": _vm.getExpert[0].name,
      "title": _vm.getExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert[0].name))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.getExpert[0].expertise))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.getDemoEvent.longDescription) + "\n                    ")])]) : _vm._e()])])]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "rowtight"
  }, [_c('div', {
    staticClass: "col-sm-8 innerpadding"
  }, [(_vm.getDemoEvent) ? _c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.getDemoEvent.jwRtmpUrl,
      "frameborder": "0",
      "scrolling": "auto",
      "allowfullscreen": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-left"
  }, [(_vm.userSignature) ? _c('div', [_c('h4', [_vm._v("TONE Topic: " + _vm._s(_vm.getDemoEvent.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDemoEvent.jwStreamTitle))]), _vm._v(" "), _c('h6', [_vm._v("Total Participants: 1")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "100%",
      "height": "280px",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "allowtransparency": "true",
      "src": _vm.chatRollURL
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-pink",
    on: {
      "click": _vm.leaveEvent
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Leave")])]) : _vm._e()])]), _vm._v(" "), _vm._m(1)])], 1) : _c('div', [(_vm.getDemoEvent) ? _c('div', {
    staticClass: "community-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(830),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-transform": "none"
    }
  }, [_vm._v("Join the Conversation at "), (_vm.getDemoEvent.type === '1') ? _c('span', [_vm._v("TONE Live")]) : _c('span', [_vm._v("TONE Talk")])]), _vm._v(" "), (_vm.getDemoEvent) ? _c('div', {
    staticClass: "communityBox"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getExpert) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [(_vm.currentVideo) ? _c('jwplayer', {
    attrs: {
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (!_vm.currentVideo) ? _c('img', {
    attrs: {
      "src": _vm.getDemoEvent.imgUrl,
      "alt": ""
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getExpert) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('h2', [_vm._v(_vm._s(_vm.getDemoEvent.title) + " with " + _vm._s(_vm.getExpert[0].name))]), _vm._v(" "), (_vm.getExpert[0]) ? _c('p', [_vm._v("\n                            " + _vm._s(_vm.getDemoEvent.longDescription) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.getDateReference(_vm.getDemoEvent.startDate, 'str')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    attrs: {
      "title": "Add to Calendar"
    }
  }, [_vm._v("\n                            Add to Calendar\n                            "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getDemoEvent.startDate))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getDemoEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getDemoEvent.longDescription))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [_c('div', [_c('h3', [_vm._v("Choose how you want to join the event. You can join as yourself or step into someone else's shoes using our anonymous shoe-cognito mode")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "title": "Join event"
    },
    on: {
      "click": function($event) {
        return _vm.switchEventView()
      }
    }
  }, [_vm._v("Gemma")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "title": "Join event"
    },
    on: {
      "click": function($event) {
        return _vm.switchEventView()
      }
    }
  }, [_vm._v("Shoe-Incognito")]), _vm._v(" "), _vm._m(2)])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Hey, Great to see you. "), _c('br'), _vm._v("Enjoy the Tone Talk!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-7"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                            Please follow the event guidelines:\n                            "), _c('span', [_vm._v("1.)")]), _vm._v(" Keep it positive, supportive and respectful;\n                            "), _c('span', [_vm._v("2.)")]), _vm._v(" Please be thoughtful and stay on topic;\n                            "), _c('span', [_vm._v("3.)")]), _vm._v(" Please do not post copyrighted material, ads, solicitations or anyone's personal info including your own;\n                            "), _c('span', [_vm._v("4.)")]), _vm._v(" Please refer to TONE's "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "new",
      "title": "click to view our terms"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" for more information.\n                        ")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c0128b10", module.exports)
  }
}

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper aboutpage",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row aboutrow"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("About Us")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-sm-offset-2",
    staticStyle: {
      "text-align": "left"
    }
  }, [(_vm.beginSectionHeading) ? _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.beginSectionHeading))]) : _vm._e(), _vm._v(" "), (_vm.beginSectionPara1) ? _c('p', {
    staticStyle: {
      "text-align": "left"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.beginSectionPara1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.beginSectionPara2) ? _c('p', {
    staticStyle: {
      "text-align": "left"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.beginSectionPara2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.beginSectionPara3) ? _c('p', {
    staticStyle: {
      "text-align": "left"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.beginSectionPara3)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.beginSectionImage) ? _c('div', {
    staticClass: "col-sm-4 toneleftlogo"
  }, [_c('div', {
    staticClass: "aboutlogoholder"
  }, [_c('img', {
    staticStyle: {
      "height": "508px",
      "width": "315px"
    },
    attrs: {
      "src": _vm.beginSectionImage,
      "alt": "CEO IMAGE",
      "title": "Gemma Toner"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 mtop30 col-sm-offset-2"
  }, [(_vm.createdSectionHeading) ? _c('h4', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.createdSectionHeading))]) : _vm._e(), _vm._v(" "), (_vm.createdSectionPara1) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.createdSectionPara1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.createdSectionPara2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.createdSectionPara2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.createdSectionPara3) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.createdSectionPara3)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.bottomMessage1) ? _c('h4', {
    staticClass: "welcomemessage",
    style: ({
      color: _vm.getCorpHeadingColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.bottomMessage1)
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "welcomemessage",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('b', [_vm._v(_vm._s(_vm.bottomMessage2))]), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.bottomMessage3))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.staffMembers) ? _c('div', {
    staticClass: "slider responsive-slick-imagelist"
  }, _vm._l((_vm.staffMembers), function(member) {
    return _c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      attrs: {
        "src": member.memberImageUrl,
        "alt": member.memberFirstName,
        "title": member.memberFirstName
      }
    }), _vm._v(" "), _c('h4', {
      staticClass: "text-center",
      style: ({
        color: _vm.getCorpHeadingColor
      })
    }, [_vm._v(_vm._s(member.memberFirstName)), _c('br'), _c('small', [_vm._v(_vm._s(member.position))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(member.biography))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "contactformtexttone contact-form"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/become-expert')
      }
    }
  }, [_c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Want to become a TONE Expert?")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ce398968", module.exports)
  }
}

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "articledetailpage",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": "fetching article"
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('h3', {
    staticClass: "titleofarticle"
  }, [_vm._v(_vm._s(_vm.articleObject.articleHead))]), _vm._v(" "), (!_vm.articleObject.authorUrl) ? _c('h6', [_vm._v(_vm._s(_vm.articleObject.authorName) + " - " + _vm._s(_vm.articleObject.datePublishFmt))]) : _vm._e(), _vm._v(" "), (_vm.articleObject.authorUrl) ? _c('h6', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.articleObject.authorUrl
    }
  }, [_vm._v(_vm._s(_vm.articleObject.authorName))]), _vm._v(" - " + _vm._s(_vm.articleObject.datePublishFmt))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "imageholderbanner"
  }, [_c('img', {
    attrs: {
      "src": _vm.articleObject.imageUrl,
      "title": _vm.articleObject.articleHead,
      "alt": _vm.articleObject.articleHead
    }
  })]), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.articleObject.articleHead,
      "description": _vm.articleObject.articleHead,
      "title": 'TONE Networks, Set the Tone of Your Life'
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "shareIcons"
          }, [_c('network', {
            staticClass: "holder",
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.articleList && _vm.articleList.length > 0) ? _c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.articleObject.paragraph1) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph3) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph3)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph4) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph4)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph5) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph5)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph6) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph6)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph7) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph7)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph8) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph8)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph9) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph9)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph10) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph10)
    }
  }) : _vm._e(), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.articleObject.articleHead,
      "description": _vm.articleObject.articleHead,
      "title": 'TONE Networks, Set the Tone of Your Life'
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "shareIcons bottom"
          }, [_c('network', {
            staticClass: "holder",
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.articleObject.paragraph1) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph3) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph3)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph4) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph4)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph5) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph5)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph6) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph6)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph7) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph7)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph8) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph8)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph9) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph9)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph10) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph10)
    }
  }) : _vm._e(), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.articleObject.articleHead,
      "description": _vm.articleObject.articleHead,
      "title": 'TONE Networks, Set the Tone of Your Life'
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "shareIcons bottom"
          }, [_c('network', {
            staticClass: "holder",
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), (_vm.articleList && _vm.articleList.length > 0) ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pinklinksholder"
  }, [_c('h4', [_vm._v("More Articles")]), _vm._v(" "), _vm._l((_vm.articleList), function(article) {
    return _c('div', [_c('div', {
      staticClass: "listholderlinks"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": article.articleHead
      },
      on: {
        "click": function($event) {
          return _vm.redirectToNextArticle(article)
        }
      }
    }, [_vm._v(_vm._s(article.articleHead))]), _c('small', {
      on: {
        "click": function($event) {
          return _vm.redirectToNextArticle(article)
        }
      }
    }, [_vm._v(_vm._s(article.authorName) + " - " + _vm._s(article.datePublishFmt))])])])
  })], 2)]) : _vm._e()])], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-deef8e96", module.exports)
  }
}

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper career-page-wrapper expert-page-wrapper",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [(_vm.getExpert && _vm.expertInfo) ? _c('div', {
    staticClass: "featured main"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row margin-top-40"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.expertInfo.large_image,
      "alt": _vm.expertInfo.name,
      "title": _vm.expertInfo.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('h2', [_vm._v("\n                                    " + _vm._s(_vm.expertInfo.name) + "\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("\n                                    (" + _vm._s(_vm.expertInfo.experties) + ")\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.expertInfo.biography)
    }
  })])])])])])]) : _vm._e(), _vm._v(" "), (_vm.expertEvent) ? _c('div', {
    staticClass: "live-chat"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "live-chat-heading pinkh2",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Upcoming "), (_vm.expertEvent.type === '1') ? _c('span', [_vm._v("TONE Live")]) : _c('span', [_vm._v("TONE Talk")]), _vm._v(" Event")])]), _vm._v(" "), (_vm.expertEvent && _vm.showJoin(_vm.expertEvent)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.expertEvent) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.expertEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top-40"
  }, [(_vm.getExpert) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-1"
  }, [_c('img', {
    attrs: {
      "src": _vm.expertEvent.img_url,
      "alt": "EVENT BANNER",
      "title": _vm.expertEvent.title
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getExpert && _vm.expertInfo) ? _c('div', {
    staticClass: "experts"
  }, [_c('h2', [_vm._v("\n                                    Join an Exclusive "), (_vm.expertEvent.type === '1') ? _c('span', [_vm._v("TONE Live")]) : _c('span', [_vm._v("TONE Talk")]), _vm._v(" Event with " + _vm._s(_vm.replaceLastExpert(_vm.expertEvent.csvExpertsNames, ',', ' & ')) + "\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    " + _vm._s(_vm.expertEvent.longDescription) + "\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("\n                                    " + _vm._s(_vm.getDateReference(_vm.expertEvent.start_date, 'str')) + "\n                                ")]), _vm._v(" "), (!_vm.showJoin(_vm.expertEvent)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    }
  }, [_vm._v("\n                                    Add to Calendar\n                                    "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.expertEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.expertEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.expertEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.expertEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.expertEvent.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.expertEvent.eventId))]) : _c('span', [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.expertEvent.eventId))])])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.expertEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.expertEvent && !_vm.showJoin(_vm.expertEvent)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.expertEvent) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.expertEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e()])])]) : _c('div', {
    staticClass: "container"
  }, [(_vm.getExpertVideos) ? _c('div', {
    staticClass: "row"
  }, [(_vm.getExpert && _vm.expertMainVideo && _vm.expertInfo) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "pinkh2",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("MEET " + _vm._s(_vm.expertInfo.name))])]) : _vm._e(), _vm._v(" "), (_vm.expertMainVideo) ? _c('div', {
    staticClass: "col-sm-6 col-sm-offset-3"
  }, [_c('jwplayer', {
    attrs: {
      "id": "expertMainVid",
      "data": _vm.expertMainVideo
    }
  }, [_vm._v("Loading the player...")]), _vm._v(" "), _c('h3', [_c('i', {
    staticClass: "fa fa-play"
  }), _vm._v(" " + _vm._s(_vm.expertMainVideo.title))])], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.getExpertVideos) ? _c('div', {
    staticClass: "random"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "margin-top-40"
  }, [_c('div', {
    staticClass: "blog-section videossection clearfix"
  }, [(_vm.getExpert) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 margin-bottom-40"
  }, [_c('h2', {
    staticClass: "text-center pinkh2",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("MOST POPULAR VIDEOS FROM " + _vm._s(_vm.expertInfo.name))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row random-section-head yourFaves exceptionalsettings"
  }, [(_vm.getExpertVideos[1]) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
    class: {
      'innerimggray': _vm.getTrialDays < 0
    }
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getExpertVideos[1].mediaid + '/' + _vm.getExpertVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.getExpertVideos[1].image,
      "alt": _vm.getExpertVideos[1].title,
      "title": _vm.getExpertVideos[1].title
    }
  }), _vm._v(" "), (_vm.getExpertVideos[1].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _c('strong', [_vm._v(_vm._s(_vm.getExpertVideos[1].title))])]) : _vm._e(), _vm._v(" "), (!_vm.getExpertVideos[1].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(_vm._s(_vm.getExpertVideos[1].title))]) : _vm._e()]), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[1].marketing) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[1].marketing) ? _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.getExpertVideos[1].mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.getExpertVideos[1].mediaid)
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getExpertVideos[1])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getExpertVideos[1], playlist, _vm.verifyVideoExists(playlist, _vm.getExpertVideos[1]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.getExpertVideos[1].mediaid)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[1].marketing) ? _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getExpertVideos[1])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getExpertVideos[1])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getExpertVideos[4]) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
    class: {
      'innerimggray': _vm.getTrialDays < 0
    }
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getExpertVideos[4].mediaid + '/' + _vm.getExpertVideos[4].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.getExpertVideos[4].image,
      "alt": _vm.getExpertVideos[4].title,
      "title": _vm.getExpertVideos[4].title
    }
  }), _vm._v(" "), (_vm.getExpertVideos[4].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _c('strong', [_vm._v(_vm._s(_vm.getExpertVideos[4].title))])]) : _vm._e(), _vm._v(" "), (!_vm.getExpertVideos[4].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(_vm._s(_vm.getExpertVideos[4].title))]) : _vm._e()]), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[4].marketing) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[4].marketing) ? _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.getExpertVideos[4].mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.getExpertVideos[4].mediaid)
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getExpertVideos[4])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getExpertVideos[4], playlist, _vm.verifyVideoExists(playlist, _vm.getExpertVideos[4]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[4].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[4].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.getExpertVideos[4].mediaid)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[4].marketing) ? _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getExpertVideos[4])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getExpertVideos[4])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getExpertVideos[2]) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
    class: {
      'innerimggray': _vm.getTrialDays < 0
    }
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getExpertVideos[2].mediaid + '/' + _vm.getExpertVideos[2].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.getExpertVideos[2].image,
      "alt": _vm.getExpertVideos[2].title,
      "title": _vm.getExpertVideos[2].title
    }
  }), _vm._v(" "), (_vm.getExpertVideos[2].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _c('strong', [_vm._v(_vm._s(_vm.getExpertVideos[2].title))])]) : _vm._e(), _vm._v(" "), (!_vm.getExpertVideos[2].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(_vm._s(_vm.getExpertVideos[2].title))]) : _vm._e()]), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[2].marketing) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[2].marketing) ? _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.getExpertVideos[2].mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.getExpertVideos[2].mediaid)
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getExpertVideos[2])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getExpertVideos[2], playlist, _vm.verifyVideoExists(playlist, _vm.getExpertVideos[2]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[2].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[2].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.getExpertVideos[2].mediaid)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[2].marketing) ? _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getExpertVideos[2])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getExpertVideos[2])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getExpertVideos[5]) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
    class: {
      'innerimggray': _vm.getTrialDays < 0
    }
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getExpertVideos[5].mediaid + '/' + _vm.getExpertVideos[5].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.getExpertVideos[5].image,
      "alt": _vm.getExpertVideos[5].title,
      "title": _vm.getExpertVideos[5].title
    }
  }), _vm._v(" "), (_vm.getExpertVideos[5].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _c('strong', [_vm._v(_vm._s(_vm.getExpertVideos[5].title))])]) : _vm._e(), _vm._v(" "), (!_vm.getExpertVideos[5].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(_vm._s(_vm.getExpertVideos[5].title))]) : _vm._e()]), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[5].marketing) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[5].marketing) ? _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.getExpertVideos[5].mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.getExpertVideos[5].mediaid)
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getExpertVideos[5])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getExpertVideos[5], playlist, _vm.verifyVideoExists(playlist, _vm.getExpertVideos[5]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[5].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[5].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.getExpertVideos[5].mediaid)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[5].marketing) ? _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getExpertVideos[5])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getExpertVideos[5])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getExpertVideos[3]) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
    class: {
      'innerimggray': _vm.getTrialDays < 0
    }
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getExpertVideos[3].mediaid + '/' + _vm.getExpertVideos[3].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.getExpertVideos[3].image,
      "alt": _vm.getExpertVideos[3].title,
      "title": _vm.getExpertVideos[3].title
    }
  }), _vm._v(" "), (_vm.getExpertVideos[3].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _c('strong', [_vm._v(_vm._s(_vm.getExpertVideos[3].title))])]) : _vm._e(), _vm._v(" "), (!_vm.getExpertVideos[3].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(_vm._s(_vm.getExpertVideos[3].title))]) : _vm._e()]), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[3].marketing) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[3].marketing) ? _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.getExpertVideos[3].mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.getExpertVideos[3].mediaid)
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getExpertVideos[3])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getExpertVideos[3], playlist, _vm.verifyVideoExists(playlist, _vm.getExpertVideos[3]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[3].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[3].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.getExpertVideos[5].mediaid)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[3].marketing) ? _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getExpertVideos[3])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getExpertVideos[3])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getExpertVideos[6]) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
    class: {
      'innerimggray': _vm.getTrialDays < 0
    }
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getExpertVideos[6].mediaid + '/' + _vm.getExpertVideos[6].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.getExpertVideos[6].image,
      "alt": _vm.getExpertVideos[6].title,
      "title": _vm.getExpertVideos[6].title
    }
  }), _vm._v(" "), (_vm.getExpertVideos[6].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _c('strong', [_vm._v(_vm._s(_vm.getExpertVideos[6].title))])]) : _vm._e(), _vm._v(" "), (!_vm.getExpertVideos[6].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(_vm._s(_vm.getExpertVideos[6].title))]) : _vm._e()]), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[6].marketing) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[6].marketing) ? _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.getExpertVideos[6].mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.getExpertVideos[6].mediaid)
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getExpertVideos[6])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getExpertVideos[6], playlist, _vm.verifyVideoExists(playlist, _vm.getExpertVideos[6]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[6].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[6].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.getExpertVideos[6].mediaid)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[6].marketing) ? _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getExpertVideos[6])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getExpertVideos[6])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (!_vm.getVideosFlag) ? _c('div', {
    staticClass: "pintlist-holder"
  }, [(_vm.expertInfo) ? _c('h2', {
    staticClass: "pinkh2",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("browse all of " + _vm._s(_vm.expertInfo.name) + "'s videos")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {}, [(_vm.getExpertPlaylist) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getExpertPlaylist), function(video) {
    return (!_vm.verifyVideoStatus(video.mediaid)) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), (_vm.user) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(12, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(13, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()]) : _vm._e()
  })], 2) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.expertInfo && _vm.getExpertArchiveClips && _vm.user) ? _c('div', {
    staticClass: "pintlist-holder"
  }, [(_vm.expertInfo) ? _c('h2', {
    staticClass: "pinkh2",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("TONE Coaching Tips")]) : _vm._e(), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-5"
    }
  }, [_c('div', {}, [(_vm.getExpertArchiveClips) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.getExpertArchiveClips), function(evn) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      },
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('div', {
      staticClass: "show-share-options"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": evn.img_url,
        "alt": "ARCHIVE EVENT BANNER",
        "title": evn.title
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), _c('div', {
      staticClass: "favnumbers",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(evn.allVidDurInMinutes)), _c('small', [_vm._v("mins")])])]), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "title": "Play"
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareExpertCoachingTipPermission >= 1))) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.showSharingModal(evn)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('h2', {
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v(_vm._s(evn.title))]), _vm._v(" "), _c('p', {
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(evn.longDescription) + "\n\n                            ")])])
  }), 0) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.showWatchVideoModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showWatchVideoModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentPlayerID
    }
  }, [_vm._v("Loading the player...")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.currentPlayerID.videoDescription) + "\n                ")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showSharedModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showSharedModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "method": "post",
      "id": "playlistshare-form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSharePlaylist.apply(null, arguments)
      }
    }
  }, [_c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedMessage",
      "id": "playlistshare_sharedMessage",
      "type": "text",
      "error": "Optional Message",
      "placeholder": "Optional Message",
      "autocomplete": "off",
      "icon": ""
    },
    model: {
      value: (_vm.sharePayload.sharedEmailMessage),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedEmailMessage", $$v)
      },
      expression: "sharePayload.sharedEmailMessage"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedEmailMessagePreview",
      "id": "playlistshare_sharedEmailMessagePreview",
      "type": "textarea",
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.sharePayload.sharedPlaylistPreview),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedPlaylistPreview", $$v)
      },
      expression: "sharePayload.sharedPlaylistPreview"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "disabled": _vm.spinner || (_vm.taggedEmails && _vm.taggedEmails.length === 0)
    }
  }, [_vm._v("\n                            Send Email\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showShareCommunity) ? _c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]) : _vm._e(), _vm._v(" "), (_vm.showShareIndividual) ? _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.showShareFriends) ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.corpShareModalImage,
      "alt": _vm.corpShareModalTitle,
      "title": _vm.corpShareModalTitle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s((_vm.corpShareModalTitle + " | TONE Networks")))]), _vm._v(" "), (_vm.corpShareModalDesc) ? _c('p', [_vm._v(" " + _vm._s(((_vm.corpShareModalDesc.substring(0,250)) + "...")))]) : _vm._e(), _vm._v(" "), (!_vm.corpShareModalDesc) ? _c('p', [_vm._v(_vm._s(_vm.user.firstName) + "'s Personal Playlist")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share This Playlist\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateImageShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateImageShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")])])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.shareEventSelected.img_url,
      "alt": _vm.shareEventSelected.title,
      "title": _vm.shareEventSelected.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.shareEventSelected.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.shareEventSelected.longDescription.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateImage()
      }
    }
  }, [_vm._v("\n                            Share This Event\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ead0290e", module.exports)
  }
}

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper bodyfont-unauth"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "video-player autoheight"
  }, [_c('div', {
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.currentVideo) ? _c('div', {
    staticClass: "reset-video-width"
  }, [_c('h2', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), _c('jwplayer', {
    attrs: {
      "id": "mainVideoPlayer",
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.videoNotFoundFlag) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.videoTag && _vm.videoTag !== 'COMMUNITY') ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "player-content"
  }, [_c('p', {
    staticClass: "video-description"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentVideo.Description) + "\n                    ")]), _vm._v(" "), (_vm.getCorpButtonColor === '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getCorpButtonColor !== '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.videoExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.videoExpert[0].expertId + '/' + _vm.videoExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.videoExpert[0].small_image,
      "alt": _vm.videoExpert[0].name,
      "title": _vm.videoExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.videoExpert && _vm.videoExpert[0].areasofexpertise) + "\n                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoTag && _vm.videoTag !== 'COMMUNITY') ? _c('h2', [_vm._v("MORE " + _vm._s(_vm.videoTag) + " VIDEOS")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoList) ? _c('div', {
    staticClass: "row morevediosrow"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider largeslidesilderplayicon"
  }, _vm._l((_vm.videoList), function(vid) {
    return _c('div', {
      staticClass: "slide-player"
    }, [(_vm.videoList) ? _c('div', {}, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + vid.mediaid + '/' + vid.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": vid.image,
        "alt": vid.title,
        "title": vid.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(vid.title))])])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.showComponent) ? _c('h4', [_vm._v("Want more tips ? Sign up today for your free TONE trial!")]) : _vm._e(), _vm._v(" "), (_vm.showComponent) ? _c('div', {
    staticClass: "text-center"
  }, [(!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/signup')
      }
    }
  }, [_vm._v("Start Your Free Trial")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redeemCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {}, [(_vm.categoryVideoList) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.categoryVideoList), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      },
      on: {
        "click": function($event) {
          return _vm.triggerLogin(video.mediaid)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      staticStyle: {
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          return _vm.triggerLogin(video.mediaid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])])
  })], 2) : _vm._e()])]), _vm._v(" "), (_vm.showComponent) ? _c('h2', {
    staticClass: "pink-text-headline",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(" and many more ...")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "errormessage"
  }, [_vm._v("This video is for Members only. "), _c('br'), _vm._v("\n            Become a member today by starting your Free Trial")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ebffec0a", module.exports)
  }
}

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "teaserMobile"
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "bodyContent"
  }, [(_vm.teaserObject) ? _c('div', {
    staticClass: "smallcontainer"
  }, [_c('div', {
    staticClass: "headsmall"
  }, [_c('img', {
    staticClass: "logosl",
    attrs: {
      "src": __webpack_require__(75)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/mytone')
      }
    }
  }, [_c('img', {
    staticClass: "topbtn",
    attrs: {
      "src": __webpack_require__(74)
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "grad",
    attrs: {
      "src": "https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/0a3d90ee-c79e-472c-9bae-1a89539be47c.jpg"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("Hey there, " + _vm._s(_vm.teaserObject.firstName))]), _vm._v(" "), _c('p', [_vm._v("Here are your TONE Teasers - videos selected just for you and personalized to your interests.")]), _vm._v(" "), _c('a', {
    staticClass: "lglink",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.teaserObject.video1UrlKey)
      }
    }
  }, [_vm._v(_vm._s(_vm.teaserObject.video1Key))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.teaserObject.video1UrlKey)
      }
    }
  }, [_c('img', {
    staticClass: "video",
    attrs: {
      "src": _vm.teaserObject.video1ImgKey
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "lglink",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.teaserObject.video2UrlKey)
      }
    }
  }, [_vm._v(_vm._s(_vm.teaserObject.video2Key))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.teaserObject.video2UrlKey)
      }
    }
  }, [_c('img', {
    staticClass: "video",
    attrs: {
      "src": _vm.teaserObject.video2ImgKey
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.teaserObject.talkTitle || _vm.teaserObject.expertName) ? _c('div', {
    staticClass: "purpletextcontainer"
  }, [_c('br'), _vm._v(" "), _c('img', {
    staticClass: "blowhorn",
    attrs: {
      "src": "https://s3.amazonaws.com/tone-assets/images/templates/weekly-emails/img_mic.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.teaserObject.quotesValue))]), _vm._v(" "), _c('a', [_vm._v(" - " + _vm._s(_vm.teaserObject.authorNameValue))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.teaserObject.talkTitle || _vm.teaserObject.expertName) ? _c('h3', [_vm._v("Upcoming Events")]) : _vm._e(), _vm._v(" "), (_vm.teaserObject.talkTitle) ? _c('div', {
    staticClass: "entryholder"
  }, [_c('img', {
    attrs: {
      "src": _vm.teaserObject.talkImgUrl
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Tone Talk:" + _vm._s(_vm.teaserObject.talkTitle))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.teaserObject.talkLongDescription)), _c('br'), _c('br'), _vm._v(_vm._s(_vm.teaserObject.talkStartDate))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(("/event/" + (_vm.teaserObject.talkEventId)))
      }
    }
  }, [_vm._v("Add to Calendar")])]) : _vm._e(), _vm._v(" "), (_vm.teaserObject.expertName) ? _c('div', {
    staticClass: "entryholder"
  }, [_c('img', {
    attrs: {
      "src": _vm.teaserObject.eventImgUrl
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Tone Live: " + _vm._s(_vm.teaserObject.expertName))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.teaserObject.eventLongDescription)), _c('br'), _c('br'), _vm._v(_vm._s(_vm.teaserObject.eventStartDate))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(("/event/" + (_vm.teaserObject.eventEventId)))
      }
    }
  }, [_vm._v("Add to Calendar")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "advertimg",
    attrs: {
      "src": _vm.teaserObject.funniesValue
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graylastext"
  }, [_vm._v("\n                In the mood of something else?\n            ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/mytone')
      }
    }
  }, [_c('img', {
    staticClass: "topbtn lastlogobutton",
    attrs: {
      "src": __webpack_require__(74)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "pinktext"
  }, [_vm._v("Set the tone of your life")]), _vm._v(" "), _c('p', {
    staticClass: "lastpara"
  }, [_vm._v("- The TONE Team")])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f1f1b1be", module.exports)
  }
}

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": _vm.spinnerText
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "29px",
      "height": "16px",
      "viewBox": "0 0 29 16",
      "enable-background": "new 0 0 29 16",
      "xml:space": "preserve"
    }
  }, [_c('title', [_vm._v("Money")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Nav",
      "transform": "translate(246.000000, 24.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Money",
      "transform": "translate(403.000000, 6.000000)"
    }
  }, [_c('polyline', {
    attrs: {
      "id": "Stroke-2",
      "fill": "none",
      "stroke": _vm.getCorpHeaderColor,
      "points": "-647.752,-14.736 -643.234,-19.268 -641.104,-17.098\n\t\t\t-636.199,-21.95 -631.875,-17.672 -620.646,-28.716 \t\t"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "id": "Stroke-3",
      "fill": "none",
      "stroke": _vm.getCorpHeaderColor,
      "points": "-624.969,-28.715 -620.645,-28.715 -620.645,-24.438 \t\t"
    }
  })])])]), _vm._v(" "), _c('br'), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Money")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.getVideoSubcategories) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "interest-container work"
  }, [_c('button-group', {
    model: {
      value: (_vm.interestIndexes),
      callback: function($$v) {
        _vm.interestIndexes = $$v
      },
      expression: "interestIndexes"
    }
  }, _vm._l((_vm.getVideoSubcategories), function(interest, interestSubCategoryId) {
    return _c('checkbox', {
      key: interest.interestSubCategoryName.toString().toUpperCase(),
      staticClass: "min-padding checkbox-btn",
      style: (_vm.styleInterestObject(interest.interestSubCategoryName.toString().toUpperCase())),
      attrs: {
        "true-value": interest.interestSubCategoryName.toString().toUpperCase()
      }
    }, [_vm._v("\n                                    " + _vm._s(interest.interestSubCategoryName) + "\n                                ")])
  }), 1)], 1)]), _vm._v(" "), (_vm.getAuthMoneyVideos && _vm.getAuthMoneyVideos.length >= 100 && !_vm.showAllVideosFlag) ? _c('a', {
    staticClass: "bolder hidemobile",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showAllVideos('top')
      }
    }
  }, [_vm._v("choose a category or click to see more")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [(_vm.hideCompleteList() && !_vm.isMobile) ? _c('div', [(_vm.getAuthMoneyVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthMoneyVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      class: {
        'private-contents': video.isPrivate === '1'
      },
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(video.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      attrs: {
        "title": video.title
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), _vm._v(" "), (_vm.getAuthMoneyVideos && _vm.getAuthMoneyVideos.length >= 100 && !_vm.showAllVideosFlag) ? _c('a', {
    staticClass: "bolder hidemobile",
    attrs: {
      "id": "btmLink",
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.showAllVideos()
      }
    }
  }, [_vm._v("click to browse all videos")]) : _vm._e()], 2) : _vm._e()]) : _c('div', [(_vm.getAuthMoneyVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthMoneyVideos), function(video, index) {
    return ((index + 1) <= 99) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      class: {
        'private-contents': video.isPrivate === '1'
      },
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 align-to-bottom cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(video.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      attrs: {
        "title": video.title
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(2, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])]) : _vm._e()
  })], 2) : _vm._e()])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f4b69e7e", module.exports)
  }
}

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community-content"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": "refreshing event"
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('i', {
    staticClass: "fa fa-5x fa-calendar",
    style: ({
      color: _vm.getCorpHeaderColor
    })
  }), _vm._v(" "), _c('h2', {
    style: ({
      color: _vm.getCorpHeadingColor,
      textTransform: 'unset !important'
    })
  }, [_vm._v(_vm._s(_vm.pageTitle) + "\n                "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.pageDesc))])]), _vm._v(" "), (_vm.getMainEvent && _vm.showRulesComp && _vm.showJoin(_vm.getMainEvent.eventId)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.getMainEvent) ? _c('rulescomp', {
    style: ({
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "data": _vm.getMainEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getMainEvent) ? _c('div', {
    staticClass: "communityBox"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getMainEvent) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [(_vm.currentVideo) ? _c('jwplayer', {
    attrs: {
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (!_vm.currentVideo) ? _c('img', {
    attrs: {
      "src": _vm.getMainEvent.img_url,
      "alt": "MAIN EVENT BANNER",
      "title": _vm.getMainEvent.title
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getMainEvent) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpButtonColor + ' !important'
    })
  }, [(_vm.getMainEvent.type === '1') ? _c('span', [_vm._v("TONE Live")]) : _c('span', [_vm._v(_vm._s(_vm.getMainEvent.title))])]), _vm._v(" "), (_vm.getMainEvent) ? _c('p', [_vm._v("\n                            " + _vm._s(_vm.getMainEvent.longDescription) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.getDateReference(_vm.getMainEvent.start_date, 'str')) + "\n                        ")]), _vm._v(" "), (!_vm.showJoin(_vm.getMainEvent.eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.getMainEvent.title)
      }
    }
  }, [_vm._v("\n                            Add to Calendar\n                            "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getMainEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getMainEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getMainEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getMainEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getMainEvent.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.getMainEvent.eventId))]) : _c('span', [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.getMainEvent.eventId))])])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.getMainEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                        ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.getMainEvent && _vm.showRulesComp && !_vm.showJoin(_vm.getMainEvent.eventId)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.getMainEvent) ? _c('rulescomp', {
    style: ({
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "data": _vm.getMainEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sliderEventBox"
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.liveHeading))]), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.getEventList), function(ev) {
    return (ev.eventId !== _vm.getMainEvent.eventId) ? _c('div', {
      staticClass: "col-sm-4"
    }, [_c('h2', {
      staticClass: "carosalh2",
      style: ({
        color: _vm.getCorpButtonColor + ' !important'
      })
    }, [(ev.type === '1') ? _c('span', [_vm._v(" TONE Live\n")]) : _c('span', [_vm._v(" " + _vm._s(ev.title))])]), _vm._v(" "), _c('img', {
      attrs: {
        "src": ev.img_url,
        "alt": "EVENT BANNER",
        "title": ev.title
      }
    }), _vm._v(" "), _c('h2', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor + ' !important'
      }),
      attrs: {
        "href": '/event/' + ev.eventId,
        "target": "new"
      }
    }, [_vm._v(_vm._s(_vm.getDateReference(ev.start_date, 'live')) + " with " + _vm._s(_vm.replaceLastExpert(ev.csvExpertsNames, ',', ' & ')))])]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(ev.longDescription) + "\n                        ")]), _vm._v(" "), _c('h5', [_vm._v("LIVE " + _vm._s(_vm.getDateReference(ev.start_date, 'live2')) + " ")]), _vm._v(" "), (!_vm.showJoin(ev.eventId)) ? _c('div', {
      staticClass: "addeventatc pinkoutlinebtn",
      style: ({
        color: _vm.getCorpButtonColor + ' !important',
        border: '1px solid ' + _vm.getCorpButtonColor
      }),
      attrs: {
        "title": "Add to Calendar"
      },
      on: {
        "click": function($event) {
          return _vm.calendarLogging($event, ev.title)
        }
      }
    }, [_vm._v("\n                            Add to Calendar\n                            "), _c('span', {
      staticClass: "start"
    }, [_vm._v(_vm._s(ev.start_date))]), _vm._v(" "), _c('span', {
      staticClass: "end"
    }, [_vm._v(_vm._s(ev.end_date))]), _vm._v(" "), _c('span', {
      staticClass: "timezone"
    }, [_vm._v("ev/New_York")]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(ev.title))]), _vm._v(" "), _c('span', {
      staticClass: "description"
    }, [_vm._v(_vm._s(ev.longDescription))]), _vm._v(" "), _c('span', {
      staticClass: "location"
    }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(ev.eventId))])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
      staticClass: "share-event",
      style: ({
        color: _vm.getCorpButtonColor + ' !important',
        borderWidth: '1px !important',
        borderStyle: 'solid !important',
        borderColor: _vm.getCorpButtonColor + ' !important'
      }),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openCorporateImageShareModal(ev)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-share-square-o"
    }), _vm._v(" Share\n                        ")]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.getLiveEventsArchive) ? _c('div', {
    staticClass: "sliderEventBox pointer",
    attrs: {
      "id": "missed"
    }
  }, [_c('h2', {
    staticClass: "archive-less-spacing",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.archiveHeading))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.archiveDesc))]), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.getLiveEventsArchive), function(evn) {
    return _c('div', {
      staticClass: "col-sm-4",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('div', {
      staticClass: "show-share-options",
      style: ({
        backgroundColor: _vm.getCorpHeadingColor
      })
    }, [_c('img', {
      attrs: {
        "src": evn.img_url,
        "alt": "ARCHIVE EVENT BANNER",
        "title": evn.title
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), _c('div', {
      staticClass: "favnumbers",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(evn.allVidDurInMinutes)), _c('small', [_vm._v("mins")])])]), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "title": "Play"
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareEventCoachingTipPermission >= 1))) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.showSharingModal(evn)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('h2', {
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v(_vm._s(evn.title))]), _vm._v(" "), _c('p', {
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(evn.longDescription) + "\n\n                        ")])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.showSharedModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showSharedModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "method": "post",
      "id": "playlistshare-form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSharePlaylist.apply(null, arguments)
      }
    }
  }, [_c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedMessage",
      "id": "playlistshare_sharedMessage",
      "type": "text",
      "error": "Optional Message",
      "placeholder": "Optional Message",
      "autocomplete": "off",
      "icon": ""
    },
    model: {
      value: (_vm.sharePayload.sharedEmailMessage),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedEmailMessage", $$v)
      },
      expression: "sharePayload.sharedEmailMessage"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedEmailMessagePreview",
      "id": "playlistshare_sharedEmailMessagePreview",
      "type": "textarea",
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.sharePayload.sharedPlaylistPreview),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedPlaylistPreview", $$v)
      },
      expression: "sharePayload.sharedPlaylistPreview"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "disabled": _vm.spinner || (_vm.taggedEmails && _vm.taggedEmails.length === 0)
    }
  }, [_vm._v("\n                            Send Email\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_vm._v("\n                Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showShareCommunity) ? _c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]) : _vm._e(), _vm._v(" "), (_vm.showShareIndividual) ? _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.showShareFriends) ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.corpShareModalImage,
      "alt": _vm.corpShareModalTitle,
      "title": _vm.corpShareModalTitle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s((_vm.corpShareModalTitle + " | TONE Networks")))]), _vm._v(" "), (_vm.corpShareModalDesc) ? _c('p', [_vm._v(" " + _vm._s(((_vm.corpShareModalDesc.substring(0,250)) + "...")))]) : _vm._e(), _vm._v(" "), (!_vm.corpShareModalDesc) ? _c('p', [_vm._v(_vm._s(_vm.user.firstName) + "'s Personal Playlist")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess)) || (_vm.shareInProcess)
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share This Playlist\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateImageShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateImageShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": __webpack_require__(11),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")])])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.shareEventSelected.img_url,
      "alt": _vm.shareEventSelected.title,
      "title": _vm.shareEventSelected.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.shareEventSelected.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.shareEventSelected.longDescription.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateImage()
      }
    }
  }, [_vm._v("\n                            Share This Event\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fc8db22c", module.exports)
  }
}

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(508);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("9bd0ed5a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-00563de2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./JoinNowMobile.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-00563de2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./JoinNowMobile.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(509);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("05569102", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-00563de2\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./JoinNowMobile.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-00563de2\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./JoinNowMobile.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(510);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("68447dac", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-02cadb06\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./VideoPlayer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-02cadb06\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./VideoPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(511);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("323582a8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-02cadb06\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./VideoPlayer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-02cadb06\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./VideoPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(512);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1c331982", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-02ed8db0\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Topic.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-02ed8db0\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Topic.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(513);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c5ee25ea", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-03049a46\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Giving.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-03049a46\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Giving.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(514);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("27c955f8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-07c2a42a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Redeem.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-07c2a42a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Redeem.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(515);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("174f8f84", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-07f96927\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./RulesComp.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-07f96927\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./RulesComp.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(516);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("973cc120", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0bbfbd6c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Rating.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0bbfbd6c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Rating.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(517);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("656aaf19", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0c70a2bb\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Talk.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0c70a2bb\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Talk.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(518);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("42eecb33", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0ed553c4\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Gifts.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0ed553c4\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Gifts.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(519);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f19a0096", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0ed553c4\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=2!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Gifts.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0ed553c4\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=2!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Gifts.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(520);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("25e3ea96", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0ed553c4\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Gifts.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0ed553c4\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Gifts.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(521);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("18003c7b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0f63bdda\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./NewEvents.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0f63bdda\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./NewEvents.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(522);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b0f595be", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0f63bdda\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./NewEvents.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0f63bdda\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./NewEvents.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(523);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("818b530c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-11799b4e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporationGifting.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-11799b4e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporationGifting.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(524);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("ecba8310", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-124f4978\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporateLiveEvent.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-124f4978\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporateLiveEvent.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(525);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2268e331", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-13ed2e4a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PrivacyPolicy.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-13ed2e4a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PrivacyPolicy.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(526);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("78fad888", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-14cf791a\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./B2B.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-14cf791a\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./B2B.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(527);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2f2e2c62", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-14cf791a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./B2B.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-14cf791a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./B2B.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(528);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("691649ef", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-19786ae6\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LiveStreamTest.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-19786ae6\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LiveStreamTest.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(529);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5f2778dc", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1a23b194\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Feedback.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1a23b194\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Feedback.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(530);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0cdbef9e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1a23b194\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Feedback.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1a23b194\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Feedback.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(531);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("51db5f1d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1ad9f1ae\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./JwPlayList.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1ad9f1ae\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./JwPlayList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(532);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6c19c580", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-21385b83\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Mindbody.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-21385b83\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Mindbody.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(533);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("65bc9e89", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-23798c26\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./TrendingPlaylist.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-23798c26\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./TrendingPlaylist.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(534);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3ca7a2e3", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-23798c26\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./TrendingPlaylist.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-23798c26\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./TrendingPlaylist.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(535);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("065a6d74", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-24b2f4ca\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Event.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-24b2f4ca\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Event.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(536);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2c575342", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-270784da\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./WorkContents.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-270784da\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./WorkContents.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(537);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c1bffbbc", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-270784da\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./WorkContents.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-270784da\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./WorkContents.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(538);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("61a359ea", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2791f852\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporationGiftingComcast.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2791f852\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporationGiftingComcast.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(539);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("110372f6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2d26e445\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LifeContents.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2d26e445\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LifeContents.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(540);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("8df76b10", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2d26e445\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LifeContents.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2d26e445\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LifeContents.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(541);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("aaeae210", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2dc49f94\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ArchivePlaylistPlayer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2dc49f94\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ArchivePlaylistPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(542);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4e06f868", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2dc49f94\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ArchivePlaylistPlayer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2dc49f94\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ArchivePlaylistPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(543);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("fc8c54a8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2f3b14a2\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./JwPlayListTemp.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2f3b14a2\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./JwPlayListTemp.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(544);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d82fec94", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-304dffb6\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporateGift.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-304dffb6\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporateGift.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(545);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("128be589", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-30ce6f02\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./TrialExpiry_Novo.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-30ce6f02\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./TrialExpiry_Novo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(546);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("ae6cd614", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-32e87aa0\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Work.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-32e87aa0\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Work.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(547);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("59bc5b22", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-32e87aa0\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Work.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-32e87aa0\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Work.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(548);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("001e67a2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-331b4fd3\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Hello.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-331b4fd3\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Hello.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(549);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1861fa48", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-331b4fd3\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Hello.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-331b4fd3\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Hello.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(550);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3b36cc90", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-36e0590c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./AccentureCharlot.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-36e0590c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./AccentureCharlot.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(551);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2c7c7efa", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3710880a\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./EmailRules.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3710880a\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./EmailRules.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(552);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a904c53e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3710880a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./EmailRules.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3710880a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./EmailRules.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(553);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7a486bda", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37fd3ce2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LiveEvent.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37fd3ce2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LiveEvent.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(554);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4d2ec3bf", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37fd3ce2\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LiveEvent.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37fd3ce2\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LiveEvent.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(555);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5bad3ade", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-38b18f5a\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./SharePlaylistPlayer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-38b18f5a\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./SharePlaylistPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(556);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("865afce8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-38b18f5a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./SharePlaylistPlayer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-38b18f5a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./SharePlaylistPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(557);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("35845857", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-38c57b52\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./FAQ.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-38c57b52\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./FAQ.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(558);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3ec6cc5e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3a123387\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./SignUp.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3a123387\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./SignUp.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(559);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2369a612", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-420f1dc1\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorpPlaylistVideoPlayer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-420f1dc1\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorpPlaylistVideoPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(560);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d9411592", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-420f1dc1\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorpPlaylistVideoPlayer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-420f1dc1\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorpPlaylistVideoPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(561);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f9212f82", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-434fb5b0\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./UnAuth.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-434fb5b0\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./UnAuth.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(562);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b4ded3c4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-434fb5b0\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=2!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./UnAuth.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-434fb5b0\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=2!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./UnAuth.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("61fa5cce", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-434fb5b0\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./UnAuth.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-434fb5b0\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./UnAuth.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(564);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("26d24ab0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4570478e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Join.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4570478e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Join.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(565);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2a570849", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4572d5bb\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./DrRamani.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4572d5bb\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./DrRamani.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(566);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5d7a2e94", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-46d191b4\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Resources.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-46d191b4\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Resources.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(567);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7776cc6e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-46d191b4\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Resources.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-46d191b4\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Resources.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(568);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("68deaf34", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-476d1140\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./BecomeExpert.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-476d1140\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./BecomeExpert.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(569);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("20decba4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-476d1140\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./BecomeExpert.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-476d1140\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./BecomeExpert.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(570);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("761495dc", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4ac67fc6\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./JwPlayer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4ac67fc6\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./JwPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(571);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6a31c1a4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4d9ff14b\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PlaylistVideoPlayer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4d9ff14b\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PlaylistVideoPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(572);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("12c8804c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4d9ff14b\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PlaylistVideoPlayer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4d9ff14b\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PlaylistVideoPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(573);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5da74f16", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4f319b61\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Footer.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4f319b61\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Footer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(574);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("26b116ce", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4f319b61\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Footer.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4f319b61\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Footer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(575);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("9dd569d0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-55855f0b\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ResetPassword.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-55855f0b\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ResetPassword.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(576);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6b13eca2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-55855f0b\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ResetPassword.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-55855f0b\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ResetPassword.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(577);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("78427ddc", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5930af97\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5930af97\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(578);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("69832ddc", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5930af97\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5930af97\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(579);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("358ed7c4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-593730aa\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./TrialExpiry.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-593730aa\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./TrialExpiry.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(580);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7cb7abcf", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5a54a012\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./InterestList.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5a54a012\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./InterestList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(581);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("57361d4a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5a54a012\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./InterestList.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5a54a012\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./InterestList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(582);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("95fdf02e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5ba2bfc2\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./RelatedVideo.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5ba2bfc2\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./RelatedVideo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(583);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d68d25fa", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6144c6ea\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Profile.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6144c6ea\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Profile.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(584);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4e7aedf6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6144c6ea\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=3!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Profile.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6144c6ea\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=3!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Profile.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(585);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("576ba30e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6144c6ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Profile.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6144c6ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Profile.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(586);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("18534a7b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6144c6ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=2!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Profile.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6144c6ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=2!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Profile.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(587);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2144bf14", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6374f53f\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Gift.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6374f53f\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Gift.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(588);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("732f6a7d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-64c573f7\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Search.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-64c573f7\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Search.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(589);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("17170510", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-65a31e08\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Terms.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-65a31e08\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Terms.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(590);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f7ab638a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-65ebedb2\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./RecentlyWatched.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-65ebedb2\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./RecentlyWatched.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(591);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("53c663be", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-67ddb66c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Experts.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-67ddb66c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Experts.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(592);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("de08e464", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6a07750b\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Life.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6a07750b\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Life.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(593);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5c87c24c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6a24856b\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Plans.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6a24856b\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Plans.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(594);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("9ea5e884", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6cd8833a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ManagePage.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6cd8833a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ManagePage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(595);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c4505434", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6d77c942\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ContactUs.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6d77c942\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ContactUs.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(596);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("518b9028", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6d77c942\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ContactUs.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6d77c942\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./ContactUs.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(597);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6cdbfde6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7020e578\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Rules.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7020e578\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Rules.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(598);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5c3644c4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7063ff53\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Header.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7063ff53\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Header.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(599);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("211e9c23", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7063ff53\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=2!../../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Header.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7063ff53\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=2!../../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Header.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(600);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3a87a21e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7063ff53\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Header.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7063ff53\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Header.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(601);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("8e4bbe22", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7113f34d\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporateSale.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7113f34d\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporateSale.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(602);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5bb6dfa7", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7113f34d\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporateSale.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7113f34d\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporateSale.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(603);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("27051227", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-716462d9\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Logout.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-716462d9\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Logout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(604);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a8e78872", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-75ef478a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./GiftRedirect.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-75ef478a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./GiftRedirect.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(605);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5e0a0a2a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-78b910b7\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Charities.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-78b910b7\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Charities.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(606);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("758b44eb", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7d18a2b6\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Validate.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7d18a2b6\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Validate.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(607);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7c40ca11", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7ea4666d\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CommunityDemo.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7ea4666d\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CommunityDemo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(608);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("51669030", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-86595488\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./UnauthVideoPlayer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-86595488\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./UnauthVideoPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(609);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5bbf3890", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-86595488\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./UnauthVideoPlayer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-86595488\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./UnauthVideoPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(610);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f423abd6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-8baefe52\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PodcastTone.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-8baefe52\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PodcastTone.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(611);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("28257517", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-8baefe52\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=2!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PodcastTone.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-8baefe52\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=2!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PodcastTone.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(612);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4bc546cd", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-8baefe52\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PodcastTone.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-8baefe52\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PodcastTone.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(613);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("24e83224", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-915672dc\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LiveEventDemo.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-915672dc\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LiveEventDemo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(614);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a95fd430", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-915672dc\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LiveEventDemo.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-915672dc\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./LiveEventDemo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(615);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c3cd9412", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-94815cf4\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporationReferral.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-94815cf4\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporationReferral.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(616);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5259cb5b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-9fb45a86\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./MindbodyContents.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-9fb45a86\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./MindbodyContents.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(617);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3c58d983", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-9fb45a86\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./MindbodyContents.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-9fb45a86\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./MindbodyContents.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(618);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6d4ee3d5", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-9ff1e25a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporateCommunity.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-9ff1e25a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./CorporateCommunity.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(619);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("dc8352f0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-a416555a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PressRelease.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-a416555a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./PressRelease.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(620);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("307c4119", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-a428d674\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./TakeawayMobile.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-a428d674\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./TakeawayMobile.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(621);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("05af7828", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-bf8a8d2e\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Maintainance.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-bf8a8d2e\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Maintainance.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(622);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4d797cfa", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-bf8a8d2e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Maintainance.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-bf8a8d2e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Maintainance.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(623);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("61e26f84", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c0128b10\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./DemoEvent.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c0128b10\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./DemoEvent.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(624);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("04b227a2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ce398968\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./AboutUs.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ce398968\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./AboutUs.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(625);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("01a1c776", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ce398968\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./AboutUs.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ce398968\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./AboutUs.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(626);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4ae8ba7a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-deef8e96\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./SetTone.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-deef8e96\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./SetTone.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(627);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0e91a828", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-deef8e96\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./SetTone.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-deef8e96\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./SetTone.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(628);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("65f79dc2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ead0290e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Expert.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ead0290e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Expert.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(629);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("68c50c34", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ebffec0a\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./MoneyContents.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ebffec0a\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./MoneyContents.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(630);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0b0cbfb4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ebffec0a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./MoneyContents.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ebffec0a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./MoneyContents.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(631);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b8d0ecc4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f1f1b1be\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./TeaserMobile.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f1f1b1be\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./TeaserMobile.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(632);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1fec32e0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f4b69e7e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Money.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f4b69e7e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Money.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(633);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("ce70283a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-fc8db22c\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Community.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-fc8db22c\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Community.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(634);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("924f6ece", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-fc8db22c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Community.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-fc8db22c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!../../node_modules/string-replace-loader/index.js?{\"search\":\"pk_test_6pRNASCoBOKtIshFeQd4XMUh\",\"replace\":\"pk_test_SLHUyTkZmNS1OnLNdclgNldo\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://www1.dev-tonenetworks.com\",\"replace\":\"https://www1.dev-tonenetworks.com\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"https://s3.amazonaws.com/tone-assets/app/navigation\",\"replace\":\"https://s3.amazonaws.com/tone-assets/app/navigation\"}!../../node_modules/string-replace-loader/index.js?{\"search\":\"sandbox_2yn8x45w_k2v4j3d55x4gh6xz\",\"replace\":\"production_6r7mxqgh_htw3nq9wp32w8h2x\"}!./Community.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1152 */,
/* 1153 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[351]);


// WEBPACK FOOTER //
// static/js/app.bf6d5d59c409d6ccaaae.js